// Generated by Haxe 4.3.7
(function ($hx_exports, $global) { "use strict";
$hx_exports["nape"] = $hx_exports["nape"] || {};
$hx_exports["nape"]["callbacks"] = $hx_exports["nape"]["callbacks"] || {};
;$hx_exports["nape"]["constraint"] = $hx_exports["nape"]["constraint"] || {};
;$hx_exports["nape"]["dynamics"] = $hx_exports["nape"]["dynamics"] || {};
;$hx_exports["nape"]["geom"] = $hx_exports["nape"]["geom"] || {};
;$hx_exports["nape"]["phys"] = $hx_exports["nape"]["phys"] || {};
;$hx_exports["nape"]["shape"] = $hx_exports["nape"]["shape"] || {};
;$hx_exports["nape"]["space"] = $hx_exports["nape"]["space"] || {};
;$hx_exports["nape"]["util"] = $hx_exports["nape"]["util"] || {};
function $extend(from, fields) {
	var proto = Object.create(from);
	for (var name in fields) proto[name] = fields[name];
	if( fields.toString !== Object.prototype.toString ) proto.toString = fields.toString;
	return proto;
}
Math.__name__ = true;
var NapeMain = function() { };
NapeMain.__name__ = true;
NapeMain.main = function() {
};
var Reflect = function() { };
Reflect.__name__ = true;
Reflect.field = function(o,field) {
	try {
		return o[field];
	} catch( _g ) {
		return null;
	}
};
Reflect.fields = function(o) {
	var a = [];
	if(o != null) {
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		for( var f in o ) {
		if(f != "__id__" && f != "hx__closures__" && hasOwnProperty.call(o,f)) {
			a.push(f);
		}
		}
	}
	return a;
};
Reflect.copy = function(o) {
	if(o == null) {
		return null;
	}
	var o2 = { };
	var _g = 0;
	var _g1 = Reflect.fields(o);
	while(_g < _g1.length) {
		var f = _g1[_g];
		++_g;
		o2[f] = Reflect.field(o,f);
	}
	return o2;
};
var Std = function() { };
Std.__name__ = true;
Std.string = function(s) {
	return js_Boot.__string_rec(s,"");
};
var StringTools = function() { };
StringTools.__name__ = true;
StringTools.hex = function(n,digits) {
	var s = "";
	var hexChars = "0123456789ABCDEF";
	do {
		s = hexChars.charAt(n & 15) + s;
		n >>>= 4;
	} while(n > 0);
	if(digits != null) {
		while(s.length < digits) s = "0" + s;
	}
	return s;
};
var haxe_Exception = function(message,previous,native) {
	Error.call(this,message);
	this.message = message;
	this.__previousException = previous;
	this.__nativeException = native != null ? native : this;
};
haxe_Exception.__name__ = true;
haxe_Exception.thrown = function(value) {
	if(((value) instanceof haxe_Exception)) {
		return value.get_native();
	} else if(((value) instanceof Error)) {
		return value;
	} else {
		var e = new haxe_ValueException(value);
		return e;
	}
};
haxe_Exception.__super__ = Error;
haxe_Exception.prototype = $extend(Error.prototype,{
	get_native: function() {
		return this.__nativeException;
	}
});
var haxe_ValueException = function(value,previous,native) {
	haxe_Exception.call(this,String(value),previous,native);
	this.value = value;
};
haxe_ValueException.__name__ = true;
haxe_ValueException.__super__ = haxe_Exception;
haxe_ValueException.prototype = $extend(haxe_Exception.prototype,{
});
var haxe_iterators_ArrayIterator = function(array) {
	this.current = 0;
	this.array = array;
};
haxe_iterators_ArrayIterator.__name__ = true;
haxe_iterators_ArrayIterator.prototype = {
	hasNext: function() {
		return this.current < this.array.length;
	}
	,next: function() {
		return this.array[this.current++];
	}
};
var js_Boot = function() { };
js_Boot.__name__ = true;
js_Boot.__string_rec = function(o,s) {
	if(o == null) {
		return "null";
	}
	if(s.length >= 5) {
		return "<...>";
	}
	var t = typeof(o);
	if(t == "function" && (o.__name__ || o.__ename__)) {
		t = "object";
	}
	switch(t) {
	case "function":
		return "<function>";
	case "object":
		if(((o) instanceof Array)) {
			var str = "[";
			s += "\t";
			var _g = 0;
			var _g1 = o.length;
			while(_g < _g1) {
				var i = _g++;
				str += (i > 0 ? "," : "") + js_Boot.__string_rec(o[i],s);
			}
			str += "]";
			return str;
		}
		var tostr;
		try {
			tostr = o.toString;
		} catch( _g ) {
			return "???";
		}
		if(tostr != null && tostr != Object.toString && typeof(tostr) == "function") {
			var s2 = o.toString();
			if(s2 != "[object Object]") {
				return s2;
			}
		}
		var str = "{\n";
		s += "\t";
		var hasp = o.hasOwnProperty != null;
		var k = null;
		for( k in o ) {
		if(hasp && !o.hasOwnProperty(k)) {
			continue;
		}
		if(k == "prototype" || k == "__class__" || k == "__super__" || k == "__interfaces__" || k == "__properties__") {
			continue;
		}
		if(str.length != 2) {
			str += ", \n";
		}
		str += s + k + " : " + js_Boot.__string_rec(o[k],s);
		}
		s = s.substring(1);
		str += "\n" + s + "}";
		return str;
	case "string":
		return o;
	default:
		return String(o);
	}
};
var nape_Config = $hx_exports["nape"]["Config"] = function() {
};
nape_Config.__name__ = true;
var nape_callbacks_Callback = $hx_exports["nape"]["callbacks"]["Callback"] = function() {
	this.zpp_inner = null;
};
nape_callbacks_Callback.__name__ = true;
nape_callbacks_Callback.prototype = {
	get_event: function() {
		return zpp_$nape_callbacks_ZPP_$Listener.events[this.zpp_inner.event];
	}
	,get_listener: function() {
		return this.zpp_inner.listener.outer;
	}
	,toString: function() {
		return "";
	}
};
var nape_callbacks_BodyCallback = $hx_exports["nape"]["callbacks"]["BodyCallback"] = function() {
	nape_callbacks_Callback.call(this);
};
nape_callbacks_BodyCallback.__name__ = true;
nape_callbacks_BodyCallback.__super__ = nape_callbacks_Callback;
nape_callbacks_BodyCallback.prototype = $extend(nape_callbacks_Callback.prototype,{
	get_body: function() {
		return this.zpp_inner.body.outer;
	}
	,toString: function() {
		var ret = "Cb:";
		ret += ["WAKE","SLEEP"][this.zpp_inner.event - 2];
		ret += ":" + this.zpp_inner.body.outer.toString();
		ret += " : listener: " + Std.string(this.zpp_inner.listener.outer);
		return ret;
	}
});
var nape_callbacks_Listener = $hx_exports["nape"]["callbacks"]["Listener"] = function() {
	this.zpp_inner = null;
};
nape_callbacks_Listener.__name__ = true;
nape_callbacks_Listener.prototype = {
	get_type: function() {
		return zpp_$nape_callbacks_ZPP_$Listener.types[this.zpp_inner.type];
	}
	,get_event: function() {
		return zpp_$nape_callbacks_ZPP_$Listener.events[this.zpp_inner.event];
	}
	,set_event: function(event) {
		if(zpp_$nape_callbacks_ZPP_$Listener.events[this.zpp_inner.event] != event) {
			var xevent;
			if(zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN = new nape_callbacks_CbEvent();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN) {
				xevent = 0;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING = new nape_callbacks_CbEvent();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING) {
					xevent = 6;
				} else {
					if(zpp_$nape_util_ZPP_$Flags.CbEvent_END == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.CbEvent_END = new nape_callbacks_CbEvent();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_END) {
						xevent = 1;
					} else {
						if(zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP == null) {
							zpp_$nape_util_ZPP_$Flags.internal = true;
							zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP = new nape_callbacks_CbEvent();
							zpp_$nape_util_ZPP_$Flags.internal = false;
						}
						if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP) {
							xevent = 3;
						} else {
							if(zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE == null) {
								zpp_$nape_util_ZPP_$Flags.internal = true;
								zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE = new nape_callbacks_CbEvent();
								zpp_$nape_util_ZPP_$Flags.internal = false;
							}
							if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE) {
								xevent = 2;
							} else {
								if(zpp_$nape_util_ZPP_$Flags.CbEvent_PRE == null) {
									zpp_$nape_util_ZPP_$Flags.internal = true;
									zpp_$nape_util_ZPP_$Flags.CbEvent_PRE = new nape_callbacks_CbEvent();
									zpp_$nape_util_ZPP_$Flags.internal = false;
								}
								xevent = event == zpp_$nape_util_ZPP_$Flags.CbEvent_PRE ? 5 : 4;
							}
						}
					}
				}
			}
			this.zpp_inner.swapEvent(xevent);
		}
		return zpp_$nape_callbacks_ZPP_$Listener.events[this.zpp_inner.event];
	}
	,get_precedence: function() {
		return this.zpp_inner.precedence;
	}
	,set_precedence: function(precedence) {
		if(this.zpp_inner.precedence != precedence) {
			this.zpp_inner.precedence = precedence;
			this.zpp_inner.invalidate_precedence();
		}
		return this.zpp_inner.precedence;
	}
	,get_space: function() {
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,set_space: function(space) {
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != space) {
			if(this.zpp_inner.space != null) {
				this.zpp_inner.space.outer.zpp_inner.wrap_listeners.remove(this);
			}
			if(space != null) {
				var _this = space.zpp_inner.wrap_listeners;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			} else {
				this.zpp_inner.space = null;
			}
		}
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,toString: function() {
		var event = ["BEGIN","END","WAKE","SLEEP","BREAK","PRE","ONGOING"][this.zpp_inner.event];
		if(this.zpp_inner.type == 0) {
			var body = this.zpp_inner.body;
			return "BodyListener{" + event + "::" + Std.string(body.outer_zn.zpp_inner_zn.options.outer) + "}";
		} else if(this.zpp_inner.type == 1) {
			var con = this.zpp_inner.constraint;
			return "ConstraintListener{" + event + "::" + Std.string(con.outer_zn.zpp_inner_zn.options.outer) + "}";
		} else {
			var con = this.zpp_inner.interaction;
			var itype;
			switch(con.itype) {
			case 1:
				itype = "COLLISION";
				break;
			case 2:
				itype = "SENSOR";
				break;
			case 4:
				itype = "FLUID";
				break;
			default:
				itype = "ALL";
			}
			return (this.zpp_inner.type == 2 ? "InteractionListener{" + event + "#" + itype + "::" + Std.string(con.outer_zni.zpp_inner_zn.options1.outer) + ":" + Std.string(con.outer_zni.zpp_inner_zn.options2.outer) + "}" : "PreListener{" + itype + "::" + Std.string(con.outer_znp.zpp_inner_zn.options1.outer) + ":" + Std.string(con.outer_znp.zpp_inner_zn.options2.outer) + "}") + " precedence=" + this.zpp_inner.precedence;
		}
	}
};
var nape_callbacks_BodyListener = $hx_exports["nape"]["callbacks"]["BodyListener"] = function(event,options,handler,precedence) {
	if(precedence == null) {
		precedence = 0;
	}
	this.zpp_inner_zn = null;
	nape_callbacks_Listener.call(this);
	var xevent = -1;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE) {
		xevent = 2;
	} else {
		if(zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP = new nape_callbacks_CbEvent();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP) {
			xevent = 3;
		}
	}
	this.zpp_inner_zn = new zpp_$nape_callbacks_ZPP_$BodyListener(zpp_$nape_callbacks_ZPP_$OptionType.argument(options),xevent,handler);
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	this.zpp_inner.precedence = precedence;
};
nape_callbacks_BodyListener.__name__ = true;
nape_callbacks_BodyListener.__super__ = nape_callbacks_Listener;
nape_callbacks_BodyListener.prototype = $extend(nape_callbacks_Listener.prototype,{
	get_options: function() {
		return this.zpp_inner_zn.options.outer;
	}
	,set_options: function(options) {
		this.zpp_inner_zn.options.set(options.zpp_inner);
		return this.zpp_inner_zn.options.outer;
	}
	,get_handler: function() {
		return this.zpp_inner_zn.handler;
	}
	,set_handler: function(handler) {
		this.zpp_inner_zn.handler = handler;
		return this.zpp_inner_zn.handler;
	}
});
var nape_callbacks_CbEvent = $hx_exports["nape"]["callbacks"]["CbEvent"] = function() {
};
nape_callbacks_CbEvent.__name__ = true;
nape_callbacks_CbEvent.get_BEGIN = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN;
};
nape_callbacks_CbEvent.get_ONGOING = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING;
};
nape_callbacks_CbEvent.get_END = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_END == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_END = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_END;
};
nape_callbacks_CbEvent.get_WAKE = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE;
};
nape_callbacks_CbEvent.get_SLEEP = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP;
};
nape_callbacks_CbEvent.get_BREAK = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK;
};
nape_callbacks_CbEvent.get_PRE = function() {
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_PRE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_PRE = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.CbEvent_PRE;
};
nape_callbacks_CbEvent.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN = new nape_callbacks_CbEvent();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN) {
			return "BEGIN";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING = new nape_callbacks_CbEvent();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING) {
				return "ONGOING";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.CbEvent_END == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.CbEvent_END = new nape_callbacks_CbEvent();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_END) {
					return "END";
				} else {
					if(zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE = new nape_callbacks_CbEvent();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE) {
						return "WAKE";
					} else {
						if(zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP == null) {
							zpp_$nape_util_ZPP_$Flags.internal = true;
							zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP = new nape_callbacks_CbEvent();
							zpp_$nape_util_ZPP_$Flags.internal = false;
						}
						if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP) {
							return "SLEEP";
						} else {
							if(zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK == null) {
								zpp_$nape_util_ZPP_$Flags.internal = true;
								zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK = new nape_callbacks_CbEvent();
								zpp_$nape_util_ZPP_$Flags.internal = false;
							}
							if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK) {
								return "BREAK";
							} else {
								if(zpp_$nape_util_ZPP_$Flags.CbEvent_PRE == null) {
									zpp_$nape_util_ZPP_$Flags.internal = true;
									zpp_$nape_util_ZPP_$Flags.CbEvent_PRE = new nape_callbacks_CbEvent();
									zpp_$nape_util_ZPP_$Flags.internal = false;
								}
								if(this == zpp_$nape_util_ZPP_$Flags.CbEvent_PRE) {
									return "PRE";
								} else {
									return "";
								}
							}
						}
					}
				}
			}
		}
	}
};
var nape_callbacks_CbType = $hx_exports["nape"]["callbacks"]["CbType"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_callbacks_ZPP_$CbType();
	this.zpp_inner.outer = this;
};
nape_callbacks_CbType.__name__ = true;
nape_callbacks_CbType.get_ANY_BODY = function() {
	return zpp_$nape_callbacks_ZPP_$CbType.ANY_BODY;
};
nape_callbacks_CbType.get_ANY_CONSTRAINT = function() {
	return zpp_$nape_callbacks_ZPP_$CbType.ANY_CONSTRAINT;
};
nape_callbacks_CbType.get_ANY_SHAPE = function() {
	return zpp_$nape_callbacks_ZPP_$CbType.ANY_SHAPE;
};
nape_callbacks_CbType.get_ANY_COMPOUND = function() {
	return zpp_$nape_callbacks_ZPP_$CbType.ANY_COMPOUND;
};
nape_callbacks_CbType.prototype = {
	get_id: function() {
		return this.zpp_inner.id;
	}
	,including: function(includes) {
		return new nape_callbacks_OptionType(this).including(includes);
	}
	,excluding: function(excludes) {
		return new nape_callbacks_OptionType(this).excluding(excludes);
	}
	,get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_interactors: function() {
		if(this.zpp_inner.wrap_interactors == null) {
			this.zpp_inner.wrap_interactors = zpp_$nape_util_ZPP_$InteractorList.get(this.zpp_inner.interactors,true);
		}
		return this.zpp_inner.wrap_interactors;
	}
	,get_constraints: function() {
		if(this.zpp_inner.wrap_constraints == null) {
			this.zpp_inner.wrap_constraints = zpp_$nape_util_ZPP_$ConstraintList.get(this.zpp_inner.constraints,true);
		}
		return this.zpp_inner.wrap_constraints;
	}
	,toString: function() {
		if(this == zpp_$nape_callbacks_ZPP_$CbType.ANY_BODY) {
			return "ANY_BODY";
		} else if(this == zpp_$nape_callbacks_ZPP_$CbType.ANY_SHAPE) {
			return "ANY_SHAPE";
		} else if(this == zpp_$nape_callbacks_ZPP_$CbType.ANY_COMPOUND) {
			return "ANY_COMPOUND";
		} else if(this == zpp_$nape_callbacks_ZPP_$CbType.ANY_CONSTRAINT) {
			return "ANY_CONSTRAINT";
		} else {
			return "CbType#" + this.zpp_inner.id;
		}
	}
};
var nape_callbacks_CbTypeIterator = $hx_exports["nape"]["callbacks"]["CbTypeIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_callbacks_CbTypeIterator.__name__ = true;
nape_callbacks_CbTypeIterator.get = function(list) {
	var ret;
	if(nape_callbacks_CbTypeIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$CbTypeList.internal = true;
		var ret1 = new nape_callbacks_CbTypeIterator();
		zpp_$nape_util_ZPP_$CbTypeList.internal = false;
		ret = ret1;
	} else {
		var r = nape_callbacks_CbTypeIterator.zpp_pool;
		nape_callbacks_CbTypeIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_callbacks_CbTypeIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
			nape_callbacks_CbTypeIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_callbacks_CbTypeList = $hx_exports["nape"]["callbacks"]["CbTypeList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$CbTypeList();
	this.zpp_inner.outer = this;
};
nape_callbacks_CbTypeList.__name__ = true;
nape_callbacks_CbTypeList.fromArray = function(array) {
	var ret = new nape_callbacks_CbTypeList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_callbacks_CbTypeList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_callbacks_CbTypeIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_callbacks_CbTypeList();
		this.zpp_inner.valmod();
		var _g = nape_callbacks_CbTypeIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_callbacks_CbTypeIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_callbacks_CbTypeIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_callbacks_CbTypeIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_callbacks_ConstraintCallback = $hx_exports["nape"]["callbacks"]["ConstraintCallback"] = function() {
	nape_callbacks_Callback.call(this);
};
nape_callbacks_ConstraintCallback.__name__ = true;
nape_callbacks_ConstraintCallback.__super__ = nape_callbacks_Callback;
nape_callbacks_ConstraintCallback.prototype = $extend(nape_callbacks_Callback.prototype,{
	get_constraint: function() {
		return this.zpp_inner.constraint.outer;
	}
	,toString: function() {
		var ret = "Cb:";
		ret += ["WAKE","SLEEP","BREAK"][this.zpp_inner.event - 2];
		ret += ":" + this.zpp_inner.constraint.outer.toString();
		ret += " : listener: " + Std.string(this.zpp_inner.listener.outer);
		return ret;
	}
});
var nape_callbacks_ConstraintListener = $hx_exports["nape"]["callbacks"]["ConstraintListener"] = function(event,options,handler,precedence) {
	if(precedence == null) {
		precedence = 0;
	}
	this.zpp_inner_zn = null;
	nape_callbacks_Listener.call(this);
	var xevent = -1;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE) {
		xevent = 2;
	} else {
		if(zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP = new nape_callbacks_CbEvent();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP) {
			xevent = 3;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK = new nape_callbacks_CbEvent();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK) {
				xevent = 4;
			}
		}
	}
	this.zpp_inner_zn = new zpp_$nape_callbacks_ZPP_$ConstraintListener(zpp_$nape_callbacks_ZPP_$OptionType.argument(options),xevent,handler);
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	this.zpp_inner.precedence = precedence;
};
nape_callbacks_ConstraintListener.__name__ = true;
nape_callbacks_ConstraintListener.__super__ = nape_callbacks_Listener;
nape_callbacks_ConstraintListener.prototype = $extend(nape_callbacks_Listener.prototype,{
	get_options: function() {
		return this.zpp_inner_zn.options.outer;
	}
	,set_options: function(options) {
		this.zpp_inner_zn.options.set(options.zpp_inner);
		return this.zpp_inner_zn.options.outer;
	}
	,get_handler: function() {
		return this.zpp_inner_zn.handler;
	}
	,set_handler: function(handler) {
		this.zpp_inner_zn.handler = handler;
		return this.zpp_inner_zn.handler;
	}
});
var nape_callbacks_InteractionCallback = $hx_exports["nape"]["callbacks"]["InteractionCallback"] = function() {
	nape_callbacks_Callback.call(this);
};
nape_callbacks_InteractionCallback.__name__ = true;
nape_callbacks_InteractionCallback.__super__ = nape_callbacks_Callback;
nape_callbacks_InteractionCallback.prototype = $extend(nape_callbacks_Callback.prototype,{
	get_int1: function() {
		return this.zpp_inner.int1.outer_i;
	}
	,get_int2: function() {
		return this.zpp_inner.int2.outer_i;
	}
	,get_arbiters: function() {
		return this.zpp_inner.wrap_arbiters;
	}
	,toString: function() {
		var ret = "Cb:";
		ret += ["BEGIN","END","","","","","ONGOING"][this.zpp_inner.event];
		ret += ":" + this.zpp_inner.int1.outer_i.toString() + "/" + this.zpp_inner.int2.outer_i.toString();
		ret += " : " + this.zpp_inner.wrap_arbiters.toString();
		ret += " : listener: " + Std.string(this.zpp_inner.listener.outer);
		return ret;
	}
});
var nape_callbacks_InteractionListener = $hx_exports["nape"]["callbacks"]["InteractionListener"] = function(event,interactionType,options1,options2,handler,precedence) {
	if(precedence == null) {
		precedence = 0;
	}
	this.zpp_inner_zn = null;
	nape_callbacks_Listener.call(this);
	var xevent = -1;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN) {
		xevent = 0;
	} else {
		if(zpp_$nape_util_ZPP_$Flags.CbEvent_END == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.CbEvent_END = new nape_callbacks_CbEvent();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_END) {
			xevent = 1;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING = new nape_callbacks_CbEvent();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(event == zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING) {
				xevent = 6;
			}
		}
	}
	this.zpp_inner_zn = new zpp_$nape_callbacks_ZPP_$InteractionListener(zpp_$nape_callbacks_ZPP_$OptionType.argument(options1),zpp_$nape_callbacks_ZPP_$OptionType.argument(options2),xevent,2);
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zni = this;
	this.zpp_inner.precedence = precedence;
	this.zpp_inner_zn.handleri = handler;
	var ret = this.zpp_inner_zn.itype;
	var tmp;
	if(ret == 1) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
	} else if(ret == 2) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
	} else if(ret == 4) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
	} else if(ret == 7) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
	} else {
		tmp = null;
	}
	if(tmp != interactionType) {
		var xtype;
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION) {
			xtype = 1;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR) {
				xtype = 2;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				xtype = interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID ? 4 : 7;
			}
		}
		this.zpp_inner_zn.itype = xtype;
	}
	var ret = this.zpp_inner_zn.itype;
	if(ret == 1) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	} else if(ret == 2) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	} else if(ret == 4) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	} else if(ret == 7) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	}
};
nape_callbacks_InteractionListener.__name__ = true;
nape_callbacks_InteractionListener.__super__ = nape_callbacks_Listener;
nape_callbacks_InteractionListener.prototype = $extend(nape_callbacks_Listener.prototype,{
	get_options1: function() {
		return this.zpp_inner_zn.options1.outer;
	}
	,set_options1: function(options1) {
		this.zpp_inner_zn.options1.set(options1.zpp_inner);
		return this.zpp_inner_zn.options1.outer;
	}
	,get_options2: function() {
		return this.zpp_inner_zn.options2.outer;
	}
	,set_options2: function(options2) {
		this.zpp_inner_zn.options2.set(options2.zpp_inner);
		return this.zpp_inner_zn.options2.outer;
	}
	,get_interactionType: function() {
		var ret = this.zpp_inner_zn.itype;
		if(ret == 1) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		} else if(ret == 2) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		} else if(ret == 4) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		} else if(ret == 7) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
		} else {
			return null;
		}
	}
	,set_interactionType: function(interactionType) {
		var ret = this.zpp_inner_zn.itype;
		var tmp;
		if(ret == 1) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		} else if(ret == 2) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		} else if(ret == 4) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		} else if(ret == 7) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
		} else {
			tmp = null;
		}
		if(tmp != interactionType) {
			var xtype;
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION) {
				xtype = 1;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR) {
					xtype = 2;
				} else {
					if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					xtype = interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID ? 4 : 7;
				}
			}
			this.zpp_inner_zn.itype = xtype;
		}
		var ret = this.zpp_inner_zn.itype;
		if(ret == 1) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		} else if(ret == 2) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		} else if(ret == 4) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		} else if(ret == 7) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
		} else {
			return null;
		}
	}
	,get_handler: function() {
		return this.zpp_inner_zn.handleri;
	}
	,set_handler: function(handler) {
		this.zpp_inner_zn.handleri = handler;
		return this.zpp_inner_zn.handleri;
	}
	,get_allowSleepingCallbacks: function() {
		return this.zpp_inner_zn.allowSleepingCallbacks;
	}
	,set_allowSleepingCallbacks: function(allowSleepingCallbacks) {
		this.zpp_inner_zn.allowSleepingCallbacks = allowSleepingCallbacks;
		return this.zpp_inner_zn.allowSleepingCallbacks;
	}
});
var nape_callbacks_InteractionType = $hx_exports["nape"]["callbacks"]["InteractionType"] = function() {
};
nape_callbacks_InteractionType.__name__ = true;
nape_callbacks_InteractionType.get_COLLISION = function() {
	if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
};
nape_callbacks_InteractionType.get_SENSOR = function() {
	if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
};
nape_callbacks_InteractionType.get_FLUID = function() {
	if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
};
nape_callbacks_InteractionType.get_ANY = function() {
	if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
};
nape_callbacks_InteractionType.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION) {
			return "COLLISION";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR) {
				return "SENSOR";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID) {
					return "FLUID";
				} else {
					if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					if(this == zpp_$nape_util_ZPP_$Flags.InteractionType_ANY) {
						return "ANY";
					} else {
						return "";
					}
				}
			}
		}
	}
};
var nape_callbacks_ListenerIterator = $hx_exports["nape"]["callbacks"]["ListenerIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_callbacks_ListenerIterator.__name__ = true;
nape_callbacks_ListenerIterator.get = function(list) {
	var ret;
	if(nape_callbacks_ListenerIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$ListenerList.internal = true;
		var ret1 = new nape_callbacks_ListenerIterator();
		zpp_$nape_util_ZPP_$ListenerList.internal = false;
		ret = ret1;
	} else {
		var r = nape_callbacks_ListenerIterator.zpp_pool;
		nape_callbacks_ListenerIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_callbacks_ListenerIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_callbacks_ListenerIterator.zpp_pool;
			nape_callbacks_ListenerIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_callbacks_ListenerList = $hx_exports["nape"]["callbacks"]["ListenerList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$ListenerList();
	this.zpp_inner.outer = this;
};
nape_callbacks_ListenerList.__name__ = true;
nape_callbacks_ListenerList.fromArray = function(array) {
	var ret = new nape_callbacks_ListenerList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_callbacks_ListenerList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_callbacks_ListenerIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_callbacks_ListenerList();
		this.zpp_inner.valmod();
		var _g = nape_callbacks_ListenerIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_ListenerIterator.zpp_pool;
				nape_callbacks_ListenerIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_callbacks_ListenerIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_ListenerIterator.zpp_pool;
				nape_callbacks_ListenerIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_callbacks_ListenerIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_ListenerIterator.zpp_pool;
				nape_callbacks_ListenerIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_callbacks_ListenerIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_callbacks_ListenerIterator.zpp_pool;
				nape_callbacks_ListenerIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_callbacks_ListenerIterator.zpp_pool;
				nape_callbacks_ListenerIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_callbacks_ListenerType = $hx_exports["nape"]["callbacks"]["ListenerType"] = function() {
};
nape_callbacks_ListenerType.__name__ = true;
nape_callbacks_ListenerType.get_BODY = function() {
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_BODY == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_BODY = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ListenerType_BODY;
};
nape_callbacks_ListenerType.get_CONSTRAINT = function() {
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT;
};
nape_callbacks_ListenerType.get_INTERACTION = function() {
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION;
};
nape_callbacks_ListenerType.get_PRE = function() {
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_PRE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_PRE = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ListenerType_PRE;
};
nape_callbacks_ListenerType.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.ListenerType_PRE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.ListenerType_PRE = new nape_callbacks_ListenerType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.ListenerType_PRE) {
			return "PRE";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.ListenerType_BODY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.ListenerType_BODY = new nape_callbacks_ListenerType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.ListenerType_BODY) {
				return "BODY";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT = new nape_callbacks_ListenerType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT) {
					return "CONSTRAINT";
				} else {
					if(zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION = new nape_callbacks_ListenerType();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					if(this == zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION) {
						return "INTERACTION";
					} else {
						return "";
					}
				}
			}
		}
	}
};
var nape_callbacks_OptionType = $hx_exports["nape"]["callbacks"]["OptionType"] = function(includes,excludes) {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_callbacks_ZPP_$OptionType();
	this.zpp_inner.outer = this;
	if(includes != null) {
		this.including(includes);
	}
	if(excludes != null) {
		this.excluding(excludes);
	}
};
nape_callbacks_OptionType.__name__ = true;
nape_callbacks_OptionType.prototype = {
	get_includes: function() {
		if(this.zpp_inner.wrap_includes == null) {
			this.zpp_inner.setup_includes();
		}
		return this.zpp_inner.wrap_includes;
	}
	,get_excludes: function() {
		if(this.zpp_inner.wrap_excludes == null) {
			this.zpp_inner.setup_excludes();
		}
		return this.zpp_inner.wrap_excludes;
	}
	,including: function(includes) {
		this.zpp_inner.append(this.zpp_inner.includes,includes);
		return this;
	}
	,excluding: function(excludes) {
		this.zpp_inner.append(this.zpp_inner.excludes,excludes);
		return this;
	}
	,toString: function() {
		if(this.zpp_inner.wrap_includes == null) {
			this.zpp_inner.setup_includes();
		}
		var inc = this.zpp_inner.wrap_includes.toString();
		if(this.zpp_inner.wrap_excludes == null) {
			this.zpp_inner.setup_excludes();
		}
		var exc = this.zpp_inner.wrap_excludes.toString();
		return "@{" + inc + " excluding " + exc + "}";
	}
};
var nape_callbacks_PreCallback = $hx_exports["nape"]["callbacks"]["PreCallback"] = function() {
	nape_callbacks_Callback.call(this);
};
nape_callbacks_PreCallback.__name__ = true;
nape_callbacks_PreCallback.__super__ = nape_callbacks_Callback;
nape_callbacks_PreCallback.prototype = $extend(nape_callbacks_Callback.prototype,{
	get_arbiter: function() {
		return this.zpp_inner.pre_arbiter.wrapper();
	}
	,get_int1: function() {
		return this.zpp_inner.int1.outer_i;
	}
	,get_int2: function() {
		return this.zpp_inner.int2.outer_i;
	}
	,get_swapped: function() {
		return this.zpp_inner.pre_swapped;
	}
	,toString: function() {
		var ret = "Cb:PRE:";
		ret += ":" + this.zpp_inner.int1.outer_i.toString() + "/" + this.zpp_inner.int2.outer_i.toString();
		ret += " : " + this.zpp_inner.pre_arbiter.wrapper().toString();
		ret += " : listnener: " + Std.string(this.zpp_inner.listener.outer);
		return ret;
	}
});
var nape_callbacks_PreFlag = $hx_exports["nape"]["callbacks"]["PreFlag"] = function() {
};
nape_callbacks_PreFlag.__name__ = true;
nape_callbacks_PreFlag.get_ACCEPT = function() {
	if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT;
};
nape_callbacks_PreFlag.get_IGNORE = function() {
	if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE;
};
nape_callbacks_PreFlag.get_ACCEPT_ONCE = function() {
	if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE;
};
nape_callbacks_PreFlag.get_IGNORE_ONCE = function() {
	if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE = new nape_callbacks_PreFlag();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE;
};
nape_callbacks_PreFlag.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT) {
			return "ACCEPT";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE) {
				return "IGNORE";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE) {
					return "ACCEPT_ONCE";
				} else {
					if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE = new nape_callbacks_PreFlag();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					if(this == zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE) {
						return "IGNORE_ONCE";
					} else {
						return "";
					}
				}
			}
		}
	}
};
var nape_callbacks_PreListener = $hx_exports["nape"]["callbacks"]["PreListener"] = function(interactionType,options1,options2,handler,precedence,pure) {
	if(pure == null) {
		pure = false;
	}
	if(precedence == null) {
		precedence = 0;
	}
	this.zpp_inner_zn = null;
	nape_callbacks_Listener.call(this);
	this.zpp_inner_zn = new zpp_$nape_callbacks_ZPP_$InteractionListener(zpp_$nape_callbacks_ZPP_$OptionType.argument(options1),zpp_$nape_callbacks_ZPP_$OptionType.argument(options2),5,3);
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_znp = this;
	this.zpp_inner.precedence = precedence;
	this.zpp_inner_zn.pure = pure;
	this.zpp_inner_zn.handlerp = handler;
	var ret = this.zpp_inner_zn.itype;
	var tmp;
	if(ret == 1) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
	} else if(ret == 2) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
	} else if(ret == 4) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
	} else if(ret == 7) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
	} else {
		tmp = null;
	}
	if(tmp != interactionType) {
		var xtype;
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION) {
			xtype = 1;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR) {
				xtype = 2;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				xtype = interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID ? 4 : 7;
			}
		}
		this.zpp_inner_zn.itype = xtype;
	}
	var ret = this.zpp_inner_zn.itype;
	if(ret == 1) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	} else if(ret == 2) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	} else if(ret == 4) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	} else if(ret == 7) {
		if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
	}
};
nape_callbacks_PreListener.__name__ = true;
nape_callbacks_PreListener.__super__ = nape_callbacks_Listener;
nape_callbacks_PreListener.prototype = $extend(nape_callbacks_Listener.prototype,{
	get_options1: function() {
		return this.zpp_inner_zn.options1.outer;
	}
	,set_options1: function(options1) {
		this.zpp_inner_zn.options1.set(options1.zpp_inner);
		return this.zpp_inner_zn.options1.outer;
	}
	,get_options2: function() {
		return this.zpp_inner_zn.options2.outer;
	}
	,set_options2: function(options2) {
		this.zpp_inner_zn.options2.set(options2.zpp_inner);
		return this.zpp_inner_zn.options2.outer;
	}
	,get_handler: function() {
		return this.zpp_inner_zn.handlerp;
	}
	,set_handler: function(handler) {
		this.zpp_inner_zn.handlerp = handler;
		this.zpp_inner_zn.wake();
		return this.zpp_inner_zn.handlerp;
	}
	,get_pure: function() {
		return this.zpp_inner_zn.pure;
	}
	,set_pure: function(pure) {
		if(!pure) {
			this.zpp_inner_zn.wake();
		}
		this.zpp_inner_zn.pure = pure;
		return this.zpp_inner_zn.pure;
	}
	,get_interactionType: function() {
		var ret = this.zpp_inner_zn.itype;
		if(ret == 1) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		} else if(ret == 2) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		} else if(ret == 4) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		} else if(ret == 7) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
		} else {
			return null;
		}
	}
	,set_interactionType: function(interactionType) {
		var ret = this.zpp_inner_zn.itype;
		var tmp;
		if(ret == 1) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		} else if(ret == 2) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		} else if(ret == 4) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		} else if(ret == 7) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
		} else {
			tmp = null;
		}
		if(tmp != interactionType) {
			var xtype;
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION) {
				xtype = 1;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR) {
					xtype = 2;
				} else {
					if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					xtype = interactionType == zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID ? 4 : 7;
				}
			}
			this.zpp_inner_zn.itype = xtype;
		}
		var ret = this.zpp_inner_zn.itype;
		if(ret == 1) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		} else if(ret == 2) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		} else if(ret == 4) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		} else if(ret == 7) {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_ANY == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_ANY = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_ANY;
		} else {
			return null;
		}
	}
});
var nape_constraint_Constraint = $hx_exports["nape"]["constraint"]["Constraint"] = function() {
	this.debugDraw = true;
	this.zpp_inner.insert_cbtype(zpp_$nape_callbacks_ZPP_$CbType.ANY_CONSTRAINT.zpp_inner);
};
nape_constraint_Constraint.__name__ = true;
nape_constraint_Constraint.prototype = {
	get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_compound: function() {
		if(this.zpp_inner.compound == null) {
			return null;
		} else {
			return this.zpp_inner.compound.outer;
		}
	}
	,set_compound: function(compound) {
		if((this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer) != compound) {
			if((this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer) != null) {
				(this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer).zpp_inner.wrap_constraints.remove(this);
			}
			if(compound != null) {
				var _this = compound.zpp_inner.wrap_constraints;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			}
		}
		if(this.zpp_inner.compound == null) {
			return null;
		} else {
			return this.zpp_inner.compound.outer;
		}
	}
	,get_space: function() {
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,set_space: function(space) {
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != space) {
			if(this.zpp_inner.component != null) {
				this.zpp_inner.component.woken = false;
			}
			this.zpp_inner.clearcache();
			if(this.zpp_inner.space != null) {
				this.zpp_inner.space.outer.zpp_inner.wrap_constraints.remove(this);
			}
			if(space != null) {
				var _this = space.zpp_inner.wrap_constraints;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			} else {
				this.zpp_inner.space = null;
			}
		}
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,get_isSleeping: function() {
		return this.zpp_inner.component.sleeping;
	}
	,get_active: function() {
		return this.zpp_inner.active;
	}
	,set_active: function(active) {
		if(this.zpp_inner.active != active) {
			if(this.zpp_inner.component != null) {
				this.zpp_inner.component.woken = false;
			}
			this.zpp_inner.clearcache();
			if(active) {
				this.zpp_inner.active = active;
				this.zpp_inner.activate();
				if(this.zpp_inner.space != null) {
					if(this.zpp_inner.component != null) {
						this.zpp_inner.component.sleeping = true;
					}
					this.zpp_inner.space.wake_constraint(this.zpp_inner,true);
				}
			} else {
				if(this.zpp_inner.space != null) {
					this.zpp_inner.wake();
					this.zpp_inner.space.live_constraints.remove(this.zpp_inner);
				}
				this.zpp_inner.active = active;
				this.zpp_inner.deactivate();
			}
		}
		return this.zpp_inner.active;
	}
	,get_ignore: function() {
		return this.zpp_inner.ignore;
	}
	,set_ignore: function(ignore) {
		if(this.zpp_inner.ignore != ignore) {
			this.zpp_inner.ignore = ignore;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.ignore;
	}
	,get_stiff: function() {
		return this.zpp_inner.stiff;
	}
	,set_stiff: function(stiff) {
		if(this.zpp_inner.stiff != stiff) {
			this.zpp_inner.stiff = stiff;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.stiff;
	}
	,get_frequency: function() {
		return this.zpp_inner.frequency;
	}
	,set_frequency: function(frequency) {
		if(this.zpp_inner.frequency != frequency) {
			this.zpp_inner.frequency = frequency;
			if(!this.zpp_inner.stiff) {
				this.zpp_inner.wake();
			}
		}
		return this.zpp_inner.frequency;
	}
	,get_damping: function() {
		return this.zpp_inner.damping;
	}
	,set_damping: function(damping) {
		if(this.zpp_inner.damping != damping) {
			this.zpp_inner.damping = damping;
			if(!this.zpp_inner.stiff) {
				this.zpp_inner.wake();
			}
		}
		return this.zpp_inner.damping;
	}
	,get_maxForce: function() {
		return this.zpp_inner.maxForce;
	}
	,set_maxForce: function(maxForce) {
		if(this.zpp_inner.maxForce != maxForce) {
			this.zpp_inner.maxForce = maxForce;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.maxForce;
	}
	,get_maxError: function() {
		return this.zpp_inner.maxError;
	}
	,set_maxError: function(maxError) {
		if(this.zpp_inner.maxError != maxError) {
			this.zpp_inner.maxError = maxError;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.maxError;
	}
	,get_breakUnderForce: function() {
		return this.zpp_inner.breakUnderForce;
	}
	,set_breakUnderForce: function(breakUnderForce) {
		if(this.zpp_inner.breakUnderForce != breakUnderForce) {
			this.zpp_inner.breakUnderForce = breakUnderForce;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.breakUnderForce;
	}
	,get_breakUnderError: function() {
		return this.zpp_inner.breakUnderError;
	}
	,set_breakUnderError: function(breakUnderError) {
		if(this.zpp_inner.breakUnderError != breakUnderError) {
			this.zpp_inner.breakUnderError = breakUnderError;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.breakUnderError;
	}
	,get_removeOnBreak: function() {
		return this.zpp_inner.removeOnBreak;
	}
	,set_removeOnBreak: function(removeOnBreak) {
		this.zpp_inner.removeOnBreak = removeOnBreak;
		return this.zpp_inner.removeOnBreak;
	}
	,impulse: function() {
		return null;
	}
	,bodyImpulse: function(body) {
		return null;
	}
	,visitBodies: function(lambda) {
	}
	,get_cbTypes: function() {
		if(this.zpp_inner.wrap_cbTypes == null) {
			this.zpp_inner.setupcbTypes();
		}
		return this.zpp_inner.wrap_cbTypes;
	}
	,toString: function() {
		return "{Constraint}";
	}
	,copy: function() {
		return this.zpp_inner.copy();
	}
};
var nape_constraint_AngleJoint = $hx_exports["nape"]["constraint"]["AngleJoint"] = function(body1,body2,jointMin,jointMax,ratio) {
	if(ratio == null) {
		ratio = 1.0;
	}
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$AngleJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	this.zpp_inner.immutable_midstep("AngleJoint::jointMin");
	if(this.zpp_inner_zn.jointMin != jointMin) {
		this.zpp_inner_zn.jointMin = jointMin;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("AngleJoint::jointMax");
	if(this.zpp_inner_zn.jointMax != jointMax) {
		this.zpp_inner_zn.jointMax = jointMax;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("AngleJoint::ratio");
	if(this.zpp_inner_zn.ratio != ratio) {
		this.zpp_inner_zn.ratio = ratio;
		this.zpp_inner.wake();
	}
};
nape_constraint_AngleJoint.__name__ = true;
nape_constraint_AngleJoint.__super__ = nape_constraint_Constraint;
nape_constraint_AngleJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_jointMin: function() {
		return this.zpp_inner_zn.jointMin;
	}
	,set_jointMin: function(jointMin) {
		this.zpp_inner.immutable_midstep("AngleJoint::jointMin");
		if(this.zpp_inner_zn.jointMin != jointMin) {
			this.zpp_inner_zn.jointMin = jointMin;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMin;
	}
	,get_jointMax: function() {
		return this.zpp_inner_zn.jointMax;
	}
	,set_jointMax: function(jointMax) {
		this.zpp_inner.immutable_midstep("AngleJoint::jointMax");
		if(this.zpp_inner_zn.jointMax != jointMax) {
			this.zpp_inner_zn.jointMax = jointMax;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMax;
	}
	,get_ratio: function() {
		return this.zpp_inner_zn.ratio;
	}
	,set_ratio: function(ratio) {
		this.zpp_inner.immutable_midstep("AngleJoint::ratio");
		if(this.zpp_inner_zn.ratio != ratio) {
			this.zpp_inner_zn.ratio = ratio;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.ratio;
	}
	,isSlack: function() {
		var _this = this.zpp_inner_zn;
		var slack;
		var C = _this.ratio * _this.b2.rot - _this.b1.rot;
		if(_this.equal) {
			C -= _this.jointMax;
			slack = false;
			_this.scale = 1.0;
		} else if(C < _this.jointMin) {
			C = _this.jointMin - C;
			_this.scale = -1.0;
			slack = false;
		} else if(C > _this.jointMax) {
			C -= _this.jointMax;
			_this.scale = 1.0;
			slack = false;
		} else {
			_this.scale = 0.0;
			C = 0;
			slack = true;
		}
		return slack;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(1,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAcc;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get(0,0,0);
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
	}
});
var nape_constraint_ConstraintIterator = $hx_exports["nape"]["constraint"]["ConstraintIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_constraint_ConstraintIterator.__name__ = true;
nape_constraint_ConstraintIterator.get = function(list) {
	var ret;
	if(nape_constraint_ConstraintIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$ConstraintList.internal = true;
		var ret1 = new nape_constraint_ConstraintIterator();
		zpp_$nape_util_ZPP_$ConstraintList.internal = false;
		ret = ret1;
	} else {
		var r = nape_constraint_ConstraintIterator.zpp_pool;
		nape_constraint_ConstraintIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_constraint_ConstraintIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
			nape_constraint_ConstraintIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_constraint_ConstraintList = $hx_exports["nape"]["constraint"]["ConstraintList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$ConstraintList();
	this.zpp_inner.outer = this;
};
nape_constraint_ConstraintList.__name__ = true;
nape_constraint_ConstraintList.fromArray = function(array) {
	var ret = new nape_constraint_ConstraintList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_constraint_ConstraintList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_constraint_ConstraintIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_constraint_ConstraintList();
		this.zpp_inner.valmod();
		var _g = nape_constraint_ConstraintIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_constraint_ConstraintIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_constraint_ConstraintIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_constraint_ConstraintIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_constraint_DistanceJoint = $hx_exports["nape"]["constraint"]["DistanceJoint"] = function(body1,body2,anchor1,anchor2,jointMin,jointMax) {
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$DistanceJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	var _this = this.zpp_inner_zn.wrap_a1;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor1.zpp_inner.x;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor1.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor1.zpp_inner.weak) {
		var inner = anchor1.zpp_inner;
		anchor1.zpp_inner.outer = null;
		anchor1.zpp_inner = null;
		var o = anchor1;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	var _this = this.zpp_inner_zn.wrap_a2;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor2.zpp_inner.x;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor2.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor2.zpp_inner.weak) {
		var inner = anchor2.zpp_inner;
		anchor2.zpp_inner.outer = null;
		anchor2.zpp_inner = null;
		var o = anchor2;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	this.zpp_inner.immutable_midstep("DistanceJoint::jointMin");
	if(this.zpp_inner_zn.jointMin != jointMin) {
		this.zpp_inner_zn.jointMin = jointMin;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("DistanceJoint::jointMax");
	if(this.zpp_inner_zn.jointMax != jointMax) {
		this.zpp_inner_zn.jointMax = jointMax;
		this.zpp_inner.wake();
	}
};
nape_constraint_DistanceJoint.__name__ = true;
nape_constraint_DistanceJoint.__super__ = nape_constraint_Constraint;
nape_constraint_DistanceJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_anchor1: function() {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,set_anchor1: function(anchor1) {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		var _this = this.zpp_inner_zn.wrap_a1;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor1.zpp_inner.x;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor1.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor1.zpp_inner.weak) {
			var inner = anchor1.zpp_inner;
			anchor1.zpp_inner.outer = null;
			anchor1.zpp_inner = null;
			var o = anchor1;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,get_anchor2: function() {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,set_anchor2: function(anchor2) {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		var _this = this.zpp_inner_zn.wrap_a2;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor2.zpp_inner.x;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor2.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor2.zpp_inner.weak) {
			var inner = anchor2.zpp_inner;
			anchor2.zpp_inner.outer = null;
			anchor2.zpp_inner = null;
			var o = anchor2;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,get_jointMin: function() {
		return this.zpp_inner_zn.jointMin;
	}
	,set_jointMin: function(jointMin) {
		this.zpp_inner.immutable_midstep("DistanceJoint::jointMin");
		if(this.zpp_inner_zn.jointMin != jointMin) {
			this.zpp_inner_zn.jointMin = jointMin;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMin;
	}
	,get_jointMax: function() {
		return this.zpp_inner_zn.jointMax;
	}
	,set_jointMax: function(jointMax) {
		this.zpp_inner.immutable_midstep("DistanceJoint::jointMax");
		if(this.zpp_inner_zn.jointMax != jointMax) {
			this.zpp_inner_zn.jointMax = jointMax;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMax;
	}
	,isSlack: function() {
		return this.zpp_inner_zn.slack;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(1,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAcc;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
	}
});
var nape_constraint_LineJoint = $hx_exports["nape"]["constraint"]["LineJoint"] = function(body1,body2,anchor1,anchor2,direction,jointMin,jointMax) {
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$LineJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	var _this = this.zpp_inner_zn.wrap_a1;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor1.zpp_inner.x;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor1.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor1.zpp_inner.weak) {
		var inner = anchor1.zpp_inner;
		anchor1.zpp_inner.outer = null;
		anchor1.zpp_inner = null;
		var o = anchor1;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	var _this = this.zpp_inner_zn.wrap_a2;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor2.zpp_inner.x;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor2.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor2.zpp_inner.weak) {
		var inner = anchor2.zpp_inner;
		anchor2.zpp_inner.outer = null;
		anchor2.zpp_inner = null;
		var o = anchor2;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	if(this.zpp_inner_zn.wrap_n == null) {
		this.zpp_inner_zn.setup_n();
	}
	var _this = this.zpp_inner_zn.wrap_n;
	var _this1 = direction.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = direction.zpp_inner.x;
	var _this1 = direction.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = direction.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(direction.zpp_inner.weak) {
		var inner = direction.zpp_inner;
		direction.zpp_inner.outer = null;
		direction.zpp_inner = null;
		var o = direction;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_n == null) {
		this.zpp_inner_zn.setup_n();
	}
	this.zpp_inner.immutable_midstep("LineJoint::jointMin");
	if(this.zpp_inner_zn.jointMin != jointMin) {
		this.zpp_inner_zn.jointMin = jointMin;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("LineJoint::jointMax");
	if(this.zpp_inner_zn.jointMax != jointMax) {
		this.zpp_inner_zn.jointMax = jointMax;
		this.zpp_inner.wake();
	}
};
nape_constraint_LineJoint.__name__ = true;
nape_constraint_LineJoint.__super__ = nape_constraint_Constraint;
nape_constraint_LineJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_anchor1: function() {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,set_anchor1: function(anchor1) {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		var _this = this.zpp_inner_zn.wrap_a1;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor1.zpp_inner.x;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor1.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor1.zpp_inner.weak) {
			var inner = anchor1.zpp_inner;
			anchor1.zpp_inner.outer = null;
			anchor1.zpp_inner = null;
			var o = anchor1;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,get_anchor2: function() {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,set_anchor2: function(anchor2) {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		var _this = this.zpp_inner_zn.wrap_a2;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor2.zpp_inner.x;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor2.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor2.zpp_inner.weak) {
			var inner = anchor2.zpp_inner;
			anchor2.zpp_inner.outer = null;
			anchor2.zpp_inner = null;
			var o = anchor2;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,get_direction: function() {
		if(this.zpp_inner_zn.wrap_n == null) {
			this.zpp_inner_zn.setup_n();
		}
		return this.zpp_inner_zn.wrap_n;
	}
	,set_direction: function(direction) {
		if(this.zpp_inner_zn.wrap_n == null) {
			this.zpp_inner_zn.setup_n();
		}
		var _this = this.zpp_inner_zn.wrap_n;
		var _this1 = direction.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = direction.zpp_inner.x;
		var _this1 = direction.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = direction.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(direction.zpp_inner.weak) {
			var inner = direction.zpp_inner;
			direction.zpp_inner.outer = null;
			direction.zpp_inner = null;
			var o = direction;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_n == null) {
			this.zpp_inner_zn.setup_n();
		}
		return this.zpp_inner_zn.wrap_n;
	}
	,get_jointMin: function() {
		return this.zpp_inner_zn.jointMin;
	}
	,set_jointMin: function(jointMin) {
		this.zpp_inner.immutable_midstep("LineJoint::jointMin");
		if(this.zpp_inner_zn.jointMin != jointMin) {
			this.zpp_inner_zn.jointMin = jointMin;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMin;
	}
	,get_jointMax: function() {
		return this.zpp_inner_zn.jointMax;
	}
	,set_jointMax: function(jointMax) {
		this.zpp_inner.immutable_midstep("LineJoint::jointMax");
		if(this.zpp_inner_zn.jointMax != jointMax) {
			this.zpp_inner_zn.jointMax = jointMax;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMax;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(2,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAccx;
		ret.zpp_inner.x[ret.zpp_inner.n] = this.zpp_inner_zn.jAccy;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
	}
});
var nape_constraint_MotorJoint = $hx_exports["nape"]["constraint"]["MotorJoint"] = function(body1,body2,rate,ratio) {
	if(ratio == null) {
		ratio = 1.0;
	}
	if(rate == null) {
		rate = 0.0;
	}
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$MotorJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	this.zpp_inner.immutable_midstep("MotorJoint::rate");
	if(this.zpp_inner_zn.rate != rate) {
		this.zpp_inner_zn.rate = rate;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("MotorJoint::ratio");
	if(this.zpp_inner_zn.ratio != ratio) {
		this.zpp_inner_zn.ratio = ratio;
		this.zpp_inner.wake();
	}
};
nape_constraint_MotorJoint.__name__ = true;
nape_constraint_MotorJoint.__super__ = nape_constraint_Constraint;
nape_constraint_MotorJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_ratio: function() {
		return this.zpp_inner_zn.ratio;
	}
	,set_ratio: function(ratio) {
		this.zpp_inner.immutable_midstep("MotorJoint::ratio");
		if(this.zpp_inner_zn.ratio != ratio) {
			this.zpp_inner_zn.ratio = ratio;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.ratio;
	}
	,get_rate: function() {
		return this.zpp_inner_zn.rate;
	}
	,set_rate: function(rate) {
		this.zpp_inner.immutable_midstep("MotorJoint::rate");
		if(this.zpp_inner_zn.rate != rate) {
			this.zpp_inner_zn.rate = rate;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.rate;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(1,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAcc;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
	}
});
var nape_constraint_PivotJoint = $hx_exports["nape"]["constraint"]["PivotJoint"] = function(body1,body2,anchor1,anchor2) {
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$PivotJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	var _this = this.zpp_inner_zn.wrap_a1;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor1.zpp_inner.x;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor1.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor1.zpp_inner.weak) {
		var inner = anchor1.zpp_inner;
		anchor1.zpp_inner.outer = null;
		anchor1.zpp_inner = null;
		var o = anchor1;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	var _this = this.zpp_inner_zn.wrap_a2;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor2.zpp_inner.x;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor2.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor2.zpp_inner.weak) {
		var inner = anchor2.zpp_inner;
		anchor2.zpp_inner.outer = null;
		anchor2.zpp_inner = null;
		var o = anchor2;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
};
nape_constraint_PivotJoint.__name__ = true;
nape_constraint_PivotJoint.__super__ = nape_constraint_Constraint;
nape_constraint_PivotJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_anchor1: function() {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,set_anchor1: function(anchor1) {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		var _this = this.zpp_inner_zn.wrap_a1;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor1.zpp_inner.x;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor1.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor1.zpp_inner.weak) {
			var inner = anchor1.zpp_inner;
			anchor1.zpp_inner.outer = null;
			anchor1.zpp_inner = null;
			var o = anchor1;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,get_anchor2: function() {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,set_anchor2: function(anchor2) {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		var _this = this.zpp_inner_zn.wrap_a2;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor2.zpp_inner.x;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor2.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor2.zpp_inner.weak) {
			var inner = anchor2.zpp_inner;
			anchor2.zpp_inner.outer = null;
			anchor2.zpp_inner = null;
			var o = anchor2;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(2,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAccx;
		ret.zpp_inner.x[ret.zpp_inner.n] = this.zpp_inner_zn.jAccy;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
	}
});
var nape_constraint_PulleyJoint = $hx_exports["nape"]["constraint"]["PulleyJoint"] = function(body1,body2,body3,body4,anchor1,anchor2,anchor3,anchor4,jointMin,jointMax,ratio) {
	if(ratio == null) {
		ratio = 1.0;
	}
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$PulleyJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1 && this.zpp_inner_zn.b3 != this.zpp_inner_zn.b1 && this.zpp_inner_zn.b4 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1 && this.zpp_inner_zn.b3 != inbody1 && this.zpp_inner_zn.b4 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2 && this.zpp_inner_zn.b3 != this.zpp_inner_zn.b2 && this.zpp_inner_zn.b4 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2 && this.zpp_inner_zn.b3 != inbody2 && this.zpp_inner_zn.b4 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body3");
	var inbody3 = body3 == null ? null : body3.zpp_inner;
	if(inbody3 != this.zpp_inner_zn.b3) {
		if(this.zpp_inner_zn.b3 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b3 && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b3 && this.zpp_inner_zn.b4 != this.zpp_inner_zn.b3) {
				if(this.zpp_inner_zn.b3 != null) {
					this.zpp_inner_zn.b3.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b3.wake();
			}
		}
		this.zpp_inner_zn.b3 = inbody3;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody3 != null && this.zpp_inner_zn.b1 != inbody3 && this.zpp_inner_zn.b2 != inbody3 && this.zpp_inner_zn.b4 != inbody3) {
			if(inbody3 != null) {
				inbody3.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody3 != null) {
				inbody3.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b3 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body4");
	var inbody4 = body4 == null ? null : body4.zpp_inner;
	if(inbody4 != this.zpp_inner_zn.b4) {
		if(this.zpp_inner_zn.b4 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b4 && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b4 && this.zpp_inner_zn.b3 != this.zpp_inner_zn.b4) {
				if(this.zpp_inner_zn.b4 != null) {
					this.zpp_inner_zn.b4.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b4.wake();
			}
		}
		this.zpp_inner_zn.b4 = inbody4;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody4 != null && this.zpp_inner_zn.b1 != inbody4 && this.zpp_inner_zn.b2 != inbody4 && this.zpp_inner_zn.b3 != inbody4) {
			if(inbody4 != null) {
				inbody4.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody4 != null) {
				inbody4.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b4 == null;
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	var _this = this.zpp_inner_zn.wrap_a1;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor1.zpp_inner.x;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor1.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor1.zpp_inner.weak) {
		var inner = anchor1.zpp_inner;
		anchor1.zpp_inner.outer = null;
		anchor1.zpp_inner = null;
		var o = anchor1;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	var _this = this.zpp_inner_zn.wrap_a2;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor2.zpp_inner.x;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor2.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor2.zpp_inner.weak) {
		var inner = anchor2.zpp_inner;
		anchor2.zpp_inner.outer = null;
		anchor2.zpp_inner = null;
		var o = anchor2;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	if(this.zpp_inner_zn.wrap_a3 == null) {
		this.zpp_inner_zn.setup_a3();
	}
	var _this = this.zpp_inner_zn.wrap_a3;
	var _this1 = anchor3.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor3.zpp_inner.x;
	var _this1 = anchor3.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor3.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor3.zpp_inner.weak) {
		var inner = anchor3.zpp_inner;
		anchor3.zpp_inner.outer = null;
		anchor3.zpp_inner = null;
		var o = anchor3;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a3 == null) {
		this.zpp_inner_zn.setup_a3();
	}
	if(this.zpp_inner_zn.wrap_a4 == null) {
		this.zpp_inner_zn.setup_a4();
	}
	var _this = this.zpp_inner_zn.wrap_a4;
	var _this1 = anchor4.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor4.zpp_inner.x;
	var _this1 = anchor4.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor4.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor4.zpp_inner.weak) {
		var inner = anchor4.zpp_inner;
		anchor4.zpp_inner.outer = null;
		anchor4.zpp_inner = null;
		var o = anchor4;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a4 == null) {
		this.zpp_inner_zn.setup_a4();
	}
	this.zpp_inner.immutable_midstep("PulleyJoint::ratio");
	if(this.zpp_inner_zn.ratio != ratio) {
		this.zpp_inner_zn.ratio = ratio;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("PulleyJoint::jointMin");
	if(this.zpp_inner_zn.jointMin != jointMin) {
		this.zpp_inner_zn.jointMin = jointMin;
		this.zpp_inner.wake();
	}
	this.zpp_inner.immutable_midstep("PulleyJoint::jointMax");
	if(this.zpp_inner_zn.jointMax != jointMax) {
		this.zpp_inner_zn.jointMax = jointMax;
		this.zpp_inner.wake();
	}
};
nape_constraint_PulleyJoint.__name__ = true;
nape_constraint_PulleyJoint.__super__ = nape_constraint_Constraint;
nape_constraint_PulleyJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1 && this.zpp_inner_zn.b3 != this.zpp_inner_zn.b1 && this.zpp_inner_zn.b4 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1 && this.zpp_inner_zn.b3 != inbody1 && this.zpp_inner_zn.b4 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2 && this.zpp_inner_zn.b3 != this.zpp_inner_zn.b2 && this.zpp_inner_zn.b4 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2 && this.zpp_inner_zn.b3 != inbody2 && this.zpp_inner_zn.b4 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_body3: function() {
		if(this.zpp_inner_zn.b3 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b3.outer;
		}
	}
	,set_body3: function(body3) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body3");
		var inbody3 = body3 == null ? null : body3.zpp_inner;
		if(inbody3 != this.zpp_inner_zn.b3) {
			if(this.zpp_inner_zn.b3 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b3 && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b3 && this.zpp_inner_zn.b4 != this.zpp_inner_zn.b3) {
					if(this.zpp_inner_zn.b3 != null) {
						this.zpp_inner_zn.b3.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b3.wake();
				}
			}
			this.zpp_inner_zn.b3 = inbody3;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody3 != null && this.zpp_inner_zn.b1 != inbody3 && this.zpp_inner_zn.b2 != inbody3 && this.zpp_inner_zn.b4 != inbody3) {
				if(inbody3 != null) {
					inbody3.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody3 != null) {
					inbody3.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b3 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b3.outer;
		}
	}
	,get_body4: function() {
		if(this.zpp_inner_zn.b4 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b4.outer;
		}
	}
	,set_body4: function(body4) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body4");
		var inbody4 = body4 == null ? null : body4.zpp_inner;
		if(inbody4 != this.zpp_inner_zn.b4) {
			if(this.zpp_inner_zn.b4 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b4 && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b4 && this.zpp_inner_zn.b3 != this.zpp_inner_zn.b4) {
					if(this.zpp_inner_zn.b4 != null) {
						this.zpp_inner_zn.b4.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b4.wake();
				}
			}
			this.zpp_inner_zn.b4 = inbody4;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody4 != null && this.zpp_inner_zn.b1 != inbody4 && this.zpp_inner_zn.b2 != inbody4 && this.zpp_inner_zn.b3 != inbody4) {
				if(inbody4 != null) {
					inbody4.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody4 != null) {
					inbody4.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b4 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b4.outer;
		}
	}
	,get_anchor1: function() {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,set_anchor1: function(anchor1) {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		var _this = this.zpp_inner_zn.wrap_a1;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor1.zpp_inner.x;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor1.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor1.zpp_inner.weak) {
			var inner = anchor1.zpp_inner;
			anchor1.zpp_inner.outer = null;
			anchor1.zpp_inner = null;
			var o = anchor1;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,get_anchor2: function() {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,set_anchor2: function(anchor2) {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		var _this = this.zpp_inner_zn.wrap_a2;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor2.zpp_inner.x;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor2.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor2.zpp_inner.weak) {
			var inner = anchor2.zpp_inner;
			anchor2.zpp_inner.outer = null;
			anchor2.zpp_inner = null;
			var o = anchor2;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,get_anchor3: function() {
		if(this.zpp_inner_zn.wrap_a3 == null) {
			this.zpp_inner_zn.setup_a3();
		}
		return this.zpp_inner_zn.wrap_a3;
	}
	,set_anchor3: function(anchor3) {
		if(this.zpp_inner_zn.wrap_a3 == null) {
			this.zpp_inner_zn.setup_a3();
		}
		var _this = this.zpp_inner_zn.wrap_a3;
		var _this1 = anchor3.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor3.zpp_inner.x;
		var _this1 = anchor3.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor3.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor3.zpp_inner.weak) {
			var inner = anchor3.zpp_inner;
			anchor3.zpp_inner.outer = null;
			anchor3.zpp_inner = null;
			var o = anchor3;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a3 == null) {
			this.zpp_inner_zn.setup_a3();
		}
		return this.zpp_inner_zn.wrap_a3;
	}
	,get_anchor4: function() {
		if(this.zpp_inner_zn.wrap_a4 == null) {
			this.zpp_inner_zn.setup_a4();
		}
		return this.zpp_inner_zn.wrap_a4;
	}
	,set_anchor4: function(anchor4) {
		if(this.zpp_inner_zn.wrap_a4 == null) {
			this.zpp_inner_zn.setup_a4();
		}
		var _this = this.zpp_inner_zn.wrap_a4;
		var _this1 = anchor4.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor4.zpp_inner.x;
		var _this1 = anchor4.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor4.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor4.zpp_inner.weak) {
			var inner = anchor4.zpp_inner;
			anchor4.zpp_inner.outer = null;
			anchor4.zpp_inner = null;
			var o = anchor4;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a4 == null) {
			this.zpp_inner_zn.setup_a4();
		}
		return this.zpp_inner_zn.wrap_a4;
	}
	,get_jointMin: function() {
		return this.zpp_inner_zn.jointMin;
	}
	,set_jointMin: function(jointMin) {
		this.zpp_inner.immutable_midstep("PulleyJoint::jointMin");
		if(this.zpp_inner_zn.jointMin != jointMin) {
			this.zpp_inner_zn.jointMin = jointMin;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMin;
	}
	,get_jointMax: function() {
		return this.zpp_inner_zn.jointMax;
	}
	,set_jointMax: function(jointMax) {
		this.zpp_inner.immutable_midstep("PulleyJoint::jointMax");
		if(this.zpp_inner_zn.jointMax != jointMax) {
			this.zpp_inner_zn.jointMax = jointMax;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.jointMax;
	}
	,get_ratio: function() {
		return this.zpp_inner_zn.ratio;
	}
	,set_ratio: function(ratio) {
		this.zpp_inner.immutable_midstep("PulleyJoint::ratio");
		if(this.zpp_inner_zn.ratio != ratio) {
			this.zpp_inner_zn.ratio = ratio;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.ratio;
	}
	,isSlack: function() {
		return this.zpp_inner_zn.slack;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(1,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAcc;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
		if((this.zpp_inner_zn.b3 == null ? null : this.zpp_inner_zn.b3.outer) != null && (this.zpp_inner_zn.b3 == null ? null : this.zpp_inner_zn.b3.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) && (this.zpp_inner_zn.b3 == null ? null : this.zpp_inner_zn.b3.outer) != (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer)) {
			lambda(this.zpp_inner_zn.b3 == null ? null : this.zpp_inner_zn.b3.outer);
		}
		if((this.zpp_inner_zn.b4 == null ? null : this.zpp_inner_zn.b4.outer) != null && (this.zpp_inner_zn.b4 == null ? null : this.zpp_inner_zn.b4.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) && (this.zpp_inner_zn.b4 == null ? null : this.zpp_inner_zn.b4.outer) != (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) && (this.zpp_inner_zn.b4 == null ? null : this.zpp_inner_zn.b4.outer) != (this.zpp_inner_zn.b3 == null ? null : this.zpp_inner_zn.b3.outer)) {
			lambda(this.zpp_inner_zn.b4 == null ? null : this.zpp_inner_zn.b4.outer);
		}
	}
});
var nape_constraint_UserConstraint = $hx_exports["nape"]["constraint"]["UserConstraint"] = function(dimensions,velocityOnly) {
	if(velocityOnly == null) {
		velocityOnly = false;
	}
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$UserConstraint(dimensions,velocityOnly);
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
};
nape_constraint_UserConstraint.__name__ = true;
nape_constraint_UserConstraint.__super__ = nape_constraint_Constraint;
nape_constraint_UserConstraint.prototype = $extend(nape_constraint_Constraint.prototype,{
	__bindVec2: function() {
		var ret = new nape_geom_Vec2();
		ret.zpp_inner._inuse = true;
		ret.zpp_inner._invalidate = ($_=this.zpp_inner_zn,$bind($_,$_.bindVec2_invalidate));
		return ret;
	}
	,__copy: function() {
		return null;
	}
	,__broken: function() {
	}
	,__validate: function() {
	}
	,__draw: function(debug) {
	}
	,__prepare: function() {
	}
	,__position: function(err) {
	}
	,__velocity: function(err) {
	}
	,__eff_mass: function(eff) {
	}
	,__clamp: function(jAcc) {
	}
	,__impulse: function(imp,body,out) {
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(this.zpp_inner_zn.dim,1);
		var _g = 0;
		var _g1 = this.zpp_inner_zn.dim;
		while(_g < _g1) {
			var i = _g++;
			ret.zpp_inner.x[i * ret.zpp_inner.n] = this.zpp_inner_zn.jAcc[i];
		}
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		var i = 0;
		var nbodies = this.zpp_inner_zn.bodies.length;
		while(i < nbodies) {
			var b = this.zpp_inner_zn.bodies[i];
			if(b.body != null) {
				var found = false;
				var _g = i + 1;
				var _g1 = nbodies;
				while(_g < _g1) {
					var j = _g++;
					var c = this.zpp_inner_zn.bodies[j];
					if(c.body == b.body) {
						found = true;
						break;
					}
				}
				if(!found) {
					lambda(b.body.outer);
				}
			}
			++i;
		}
	}
	,__invalidate: function() {
		this.zpp_inner.immutable_midstep("UserConstraint::invalidate()");
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
		}
	}
	,__registerBody: function(oldBody,newBody) {
		this.zpp_inner.immutable_midstep("UserConstraint::registerBody(..)");
		if(oldBody != newBody) {
			if(oldBody != null) {
				var tmp = !this.zpp_inner_zn.remBody(oldBody.zpp_inner);
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					oldBody.zpp_inner.wake();
				}
			}
			if(newBody != null) {
				this.zpp_inner_zn.addBody(newBody.zpp_inner);
			}
			this.zpp_inner.wake();
			if(newBody != null) {
				newBody.zpp_inner.wake();
			}
		}
		return newBody;
	}
});
var nape_constraint_WeldJoint = $hx_exports["nape"]["constraint"]["WeldJoint"] = function(body1,body2,anchor1,anchor2,phase) {
	if(phase == null) {
		phase = 0.0;
	}
	this.zpp_inner_zn = null;
	this.zpp_inner_zn = new zpp_$nape_constraint_ZPP_$WeldJoint();
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	nape_constraint_Constraint.call(this);
	this.zpp_inner.immutable_midstep("Constraint::" + "body1");
	var inbody1 = body1 == null ? null : body1.zpp_inner;
	if(inbody1 != this.zpp_inner_zn.b1) {
		if(this.zpp_inner_zn.b1 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
				if(this.zpp_inner_zn.b1 != null) {
					this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b1.wake();
			}
		}
		this.zpp_inner_zn.b1 = inbody1;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
			if(inbody1 != null) {
				inbody1.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody1 != null) {
				inbody1.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b1 == null;
	this.zpp_inner.immutable_midstep("Constraint::" + "body2");
	var inbody2 = body2 == null ? null : body2.zpp_inner;
	if(inbody2 != this.zpp_inner_zn.b2) {
		if(this.zpp_inner_zn.b2 != null) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
				if(this.zpp_inner_zn.b2 != null) {
					this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner_zn.b2.wake();
			}
		}
		this.zpp_inner_zn.b2 = inbody2;
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
			if(inbody2 != null) {
				inbody2.constraints.add(this.zpp_inner);
			}
		}
		if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
			this.zpp_inner.wake();
			if(inbody2 != null) {
				inbody2.wake();
			}
		}
	}
	var tmp = this.zpp_inner_zn.b2 == null;
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	var _this = this.zpp_inner_zn.wrap_a1;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor1.zpp_inner.x;
	var _this1 = anchor1.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor1.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor1.zpp_inner.weak) {
		var inner = anchor1.zpp_inner;
		anchor1.zpp_inner.outer = null;
		anchor1.zpp_inner = null;
		var o = anchor1;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a1 == null) {
		this.zpp_inner_zn.setup_a1();
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	var _this = this.zpp_inner_zn.wrap_a2;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = anchor2.zpp_inner.x;
	var _this1 = anchor2.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = anchor2.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(anchor2.zpp_inner.weak) {
		var inner = anchor2.zpp_inner;
		anchor2.zpp_inner.outer = null;
		anchor2.zpp_inner = null;
		var o = anchor2;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(this.zpp_inner_zn.wrap_a2 == null) {
		this.zpp_inner_zn.setup_a2();
	}
	this.zpp_inner.immutable_midstep("WeldJoint::phase");
	if(this.zpp_inner_zn.phase != phase) {
		this.zpp_inner_zn.phase = phase;
		this.zpp_inner.wake();
	}
};
nape_constraint_WeldJoint.__name__ = true;
nape_constraint_WeldJoint.__super__ = nape_constraint_Constraint;
nape_constraint_WeldJoint.prototype = $extend(nape_constraint_Constraint.prototype,{
	get_body1: function() {
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,set_body1: function(body1) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body1");
		var inbody1 = body1 == null ? null : body1.zpp_inner;
		if(inbody1 != this.zpp_inner_zn.b1) {
			if(this.zpp_inner_zn.b1 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b2 != this.zpp_inner_zn.b1) {
					if(this.zpp_inner_zn.b1 != null) {
						this.zpp_inner_zn.b1.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b1.wake();
				}
			}
			this.zpp_inner_zn.b1 = inbody1;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody1 != null && this.zpp_inner_zn.b2 != inbody1) {
				if(inbody1 != null) {
					inbody1.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody1 != null) {
					inbody1.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b1 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,set_body2: function(body2) {
		this.zpp_inner.immutable_midstep("Constraint::" + "body2");
		var inbody2 = body2 == null ? null : body2.zpp_inner;
		if(inbody2 != this.zpp_inner_zn.b2) {
			if(this.zpp_inner_zn.b2 != null) {
				if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && this.zpp_inner_zn.b1 != this.zpp_inner_zn.b2) {
					if(this.zpp_inner_zn.b2 != null) {
						this.zpp_inner_zn.b2.constraints.remove(this.zpp_inner);
					}
				}
				if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
					this.zpp_inner_zn.b2.wake();
				}
			}
			this.zpp_inner_zn.b2 = inbody2;
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null && inbody2 != null && this.zpp_inner_zn.b1 != inbody2) {
				if(inbody2 != null) {
					inbody2.constraints.add(this.zpp_inner);
				}
			}
			if(this.zpp_inner.active && (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.wake();
				if(inbody2 != null) {
					inbody2.wake();
				}
			}
		}
		if(this.zpp_inner_zn.b2 == null) {
			return null;
		} else {
			return this.zpp_inner_zn.b2.outer;
		}
	}
	,get_anchor1: function() {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,set_anchor1: function(anchor1) {
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		var _this = this.zpp_inner_zn.wrap_a1;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor1.zpp_inner.x;
		var _this1 = anchor1.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor1.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor1.zpp_inner.weak) {
			var inner = anchor1.zpp_inner;
			anchor1.zpp_inner.outer = null;
			anchor1.zpp_inner = null;
			var o = anchor1;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a1 == null) {
			this.zpp_inner_zn.setup_a1();
		}
		return this.zpp_inner_zn.wrap_a1;
	}
	,get_anchor2: function() {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,set_anchor2: function(anchor2) {
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		var _this = this.zpp_inner_zn.wrap_a2;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = anchor2.zpp_inner.x;
		var _this1 = anchor2.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = anchor2.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(anchor2.zpp_inner.weak) {
			var inner = anchor2.zpp_inner;
			anchor2.zpp_inner.outer = null;
			anchor2.zpp_inner = null;
			var o = anchor2;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner_zn.wrap_a2 == null) {
			this.zpp_inner_zn.setup_a2();
		}
		return this.zpp_inner_zn.wrap_a2;
	}
	,get_phase: function() {
		return this.zpp_inner_zn.phase;
	}
	,set_phase: function(phase) {
		this.zpp_inner.immutable_midstep("WeldJoint::phase");
		if(this.zpp_inner_zn.phase != phase) {
			this.zpp_inner_zn.phase = phase;
			this.zpp_inner.wake();
		}
		return this.zpp_inner_zn.phase;
	}
	,impulse: function() {
		var ret = new nape_geom_MatMN(3,1);
		ret.zpp_inner.x[0 * ret.zpp_inner.n] = this.zpp_inner_zn.jAccx;
		ret.zpp_inner.x[ret.zpp_inner.n] = this.zpp_inner_zn.jAccy;
		ret.zpp_inner.x[ret.zpp_inner.n] = this.zpp_inner_zn.jAccz;
		return ret;
	}
	,bodyImpulse: function(body) {
		if(!this.zpp_inner.active) {
			return nape_geom_Vec3.get();
		} else {
			return this.zpp_inner_zn.bodyImpulse(body.zpp_inner);
		}
	}
	,visitBodies: function(lambda) {
		if((this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer) != null) {
			lambda(this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer);
		}
		if((this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != null && (this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer) != (this.zpp_inner_zn.b1 == null ? null : this.zpp_inner_zn.b1.outer)) {
			lambda(this.zpp_inner_zn.b2 == null ? null : this.zpp_inner_zn.b2.outer);
		}
	}
});
var nape_dynamics_Arbiter = $hx_exports["nape"]["dynamics"]["Arbiter"] = function() {
	this.zpp_inner = null;
	var tmp = !zpp_$nape_dynamics_ZPP_$Arbiter.internal;
};
nape_dynamics_Arbiter.__name__ = true;
nape_dynamics_Arbiter.prototype = {
	get_isSleeping: function() {
		return this.zpp_inner.sleeping;
	}
	,get_type: function() {
		return zpp_$nape_dynamics_ZPP_$Arbiter.types[this.zpp_inner.type];
	}
	,isCollisionArbiter: function() {
		return this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL;
	}
	,isFluidArbiter: function() {
		return this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID;
	}
	,isSensorArbiter: function() {
		return this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR;
	}
	,get_collisionArbiter: function() {
		if(this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
			return this.zpp_inner.colarb.outer_zn;
		} else {
			return null;
		}
	}
	,get_fluidArbiter: function() {
		if(this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
			return this.zpp_inner.fluidarb.outer_zn;
		} else {
			return null;
		}
	}
	,get_shape1: function() {
		if(this.zpp_inner.ws1.id > this.zpp_inner.ws2.id) {
			return this.zpp_inner.ws2.outer;
		} else {
			return this.zpp_inner.ws1.outer;
		}
	}
	,get_shape2: function() {
		if(this.zpp_inner.ws1.id > this.zpp_inner.ws2.id) {
			return this.zpp_inner.ws1.outer;
		} else {
			return this.zpp_inner.ws2.outer;
		}
	}
	,get_body1: function() {
		if(this.zpp_inner.ws1.id > this.zpp_inner.ws2.id) {
			return this.zpp_inner.b2.outer;
		} else {
			return this.zpp_inner.b1.outer;
		}
	}
	,get_body2: function() {
		if(this.zpp_inner.ws1.id > this.zpp_inner.ws2.id) {
			return this.zpp_inner.b1.outer;
		} else {
			return this.zpp_inner.b2.outer;
		}
	}
	,get_state: function() {
		var _g = this.zpp_inner.immState;
		var x = _g;
		if(x == 5) {
			if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT;
		} else if(_g == 1) {
			if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE;
		} else {
			var x = _g;
			if(x == 6) {
				if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				return zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE = new nape_callbacks_PreFlag();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				return zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE;
			}
		}
	}
	,totalImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		return nape_geom_Vec3.get(0,0,0);
	}
	,toString: function() {
		var ret = this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? "CollisionArbiter" : this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID ? "FluidArbiter" : "SensorArbiter";
		if(this.zpp_inner.cleared) {
			return ret + "(object-pooled)";
		} else {
			var tmp = ret + "(" + (this.zpp_inner.ws1.id > this.zpp_inner.ws2.id ? this.zpp_inner.ws2.outer : this.zpp_inner.ws1.outer).toString() + "|" + (this.zpp_inner.ws1.id > this.zpp_inner.ws2.id ? this.zpp_inner.ws1.outer : this.zpp_inner.ws2.outer).toString() + ")";
			var tmp1 = this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? "[" + ["SD","DD"][this.zpp_inner.colarb.stat ? 0 : 1] + "]" : "";
			var _g = this.zpp_inner.immState;
			var x = _g;
			var tmp2;
			if(x == 5) {
				if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				tmp2 = zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT;
			} else if(_g == 1) {
				if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				tmp2 = zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE;
			} else {
				var x = _g;
				if(x == 6) {
					if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					tmp2 = zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE;
				} else {
					if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE = new nape_callbacks_PreFlag();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					tmp2 = zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE_ONCE;
				}
			}
			return tmp + tmp1 + "<-" + tmp2.toString();
		}
	}
};
var nape_dynamics_ArbiterIterator = $hx_exports["nape"]["dynamics"]["ArbiterIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_dynamics_ArbiterIterator.__name__ = true;
nape_dynamics_ArbiterIterator.get = function(list) {
	var ret;
	if(nape_dynamics_ArbiterIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$ArbiterList.internal = true;
		var ret1 = new nape_dynamics_ArbiterIterator();
		zpp_$nape_util_ZPP_$ArbiterList.internal = false;
		ret = ret1;
	} else {
		var r = nape_dynamics_ArbiterIterator.zpp_pool;
		nape_dynamics_ArbiterIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_dynamics_ArbiterIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var length = this.zpp_inner.zpp_gl();
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
			nape_dynamics_ArbiterIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_dynamics_ArbiterList = $hx_exports["nape"]["dynamics"]["ArbiterList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$ArbiterList();
	this.zpp_inner.outer = this;
};
nape_dynamics_ArbiterList.__name__ = true;
nape_dynamics_ArbiterList.fromArray = function(array) {
	var ret = new nape_dynamics_ArbiterList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_dynamics_ArbiterList.prototype = {
	get_length: function() {
		return this.zpp_gl();
	}
	,zpp_gl: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = 0;
			var cx_ite = this.zpp_inner.inner.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.active) {
					this.zpp_inner.user_length++;
				}
				cx_ite = cx_ite.next;
			}
		}
		return this.zpp_inner.user_length;
	}
	,zpp_vm: function() {
		this.zpp_inner.valmod();
	}
	,has: function(obj) {
		this.zpp_vm();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_vm();
		if(this.zpp_inner.reverse_flag) {
			index = this.zpp_gl() - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = 0;
			this.zpp_inner.at_ite = this.zpp_inner.inner.head;
			while(true) {
				var x = this.zpp_inner.at_ite.elt;
				if(x.active) {
					break;
				}
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		while(this.zpp_inner.at_index != index) {
			this.zpp_inner.at_index++;
			this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			while(true) {
				var x = this.zpp_inner.at_ite.elt;
				if(x.active) {
					break;
				}
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.wrapper();
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp = this.empty() ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 1);
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp = this.empty() ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 1);
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite = this.zpp_gl() == 1 ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 2);
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.wrapper();
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite = this.zpp_gl() == 1 ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 2);
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.wrapper();
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(!this.empty()) this.pop();
		} else {
			while(!this.empty()) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_gl() == 0;
	}
	,iterator: function() {
		this.zpp_vm();
		return nape_dynamics_ArbiterIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_dynamics_ArbiterList();
		var _g = this.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		var _g = xs.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				this.add(x);
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		var _g = this.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		var it = this.iterator();
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var length = it.zpp_inner.zpp_gl();
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(i < this.zpp_gl()) {
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_dynamics_ArbiterType = $hx_exports["nape"]["dynamics"]["ArbiterType"] = function() {
};
nape_dynamics_ArbiterType.__name__ = true;
nape_dynamics_ArbiterType.get_COLLISION = function() {
	if(zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION = new nape_dynamics_ArbiterType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION;
};
nape_dynamics_ArbiterType.get_SENSOR = function() {
	if(zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR = new nape_dynamics_ArbiterType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR;
};
nape_dynamics_ArbiterType.get_FLUID = function() {
	if(zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID = new nape_dynamics_ArbiterType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID;
};
nape_dynamics_ArbiterType.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION = new nape_dynamics_ArbiterType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION) {
			return "COLLISION";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR = new nape_dynamics_ArbiterType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR) {
				return "SENSOR";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID = new nape_dynamics_ArbiterType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID) {
					return "FLUID";
				} else {
					return "";
				}
			}
		}
	}
};
var nape_dynamics_CollisionArbiter = $hx_exports["nape"]["dynamics"]["CollisionArbiter"] = function() {
	nape_dynamics_Arbiter.call(this);
};
nape_dynamics_CollisionArbiter.__name__ = true;
nape_dynamics_CollisionArbiter.__super__ = nape_dynamics_Arbiter;
nape_dynamics_CollisionArbiter.prototype = $extend(nape_dynamics_Arbiter.prototype,{
	get_contacts: function() {
		if(this.zpp_inner.colarb.wrap_contacts == null) {
			this.zpp_inner.colarb.setupcontacts();
		}
		return this.zpp_inner.colarb.wrap_contacts;
	}
	,get_normal: function() {
		if(this.zpp_inner.colarb.wrap_normal == null) {
			this.zpp_inner.colarb.getnormal();
		}
		return this.zpp_inner.colarb.wrap_normal;
	}
	,get_radius: function() {
		return this.zpp_inner.colarb.radius;
	}
	,get_referenceEdge1: function() {
		var edge = this.zpp_inner.colarb.__ref_edge1;
		if(edge != null && ((this.zpp_inner.ws1.id > this.zpp_inner.ws2.id ? this.zpp_inner.ws2.outer : this.zpp_inner.ws1.outer).zpp_inner.type != 1 || (this.zpp_inner.ws1.id > this.zpp_inner.ws2.id ? this.zpp_inner.ws2.outer : this.zpp_inner.ws1.outer).zpp_inner != edge.polygon)) {
			edge = this.zpp_inner.colarb.__ref_edge2;
		}
		if(edge == null) {
			return null;
		} else {
			return edge.wrapper();
		}
	}
	,get_referenceEdge2: function() {
		var edge = this.zpp_inner.colarb.__ref_edge1;
		if(edge != null && ((this.zpp_inner.ws1.id > this.zpp_inner.ws2.id ? this.zpp_inner.ws1.outer : this.zpp_inner.ws2.outer).zpp_inner.type != 1 || (this.zpp_inner.ws1.id > this.zpp_inner.ws2.id ? this.zpp_inner.ws1.outer : this.zpp_inner.ws2.outer).zpp_inner != edge.polygon)) {
			edge = this.zpp_inner.colarb.__ref_edge2;
		}
		if(edge == null) {
			return null;
		} else {
			return edge.wrapper();
		}
	}
	,firstVertex: function() {
		var poly2circle = this.zpp_inner.colarb.__ref_edge1 != null != (this.zpp_inner.colarb.__ref_edge2 != null);
		if(poly2circle) {
			return this.zpp_inner.colarb.__ref_vertex == -1;
		} else {
			return false;
		}
	}
	,secondVertex: function() {
		var poly2circle = this.zpp_inner.colarb.__ref_edge1 != null != (this.zpp_inner.colarb.__ref_edge2 != null);
		if(poly2circle) {
			return this.zpp_inner.colarb.__ref_vertex == 1;
		} else {
			return false;
		}
	}
	,normalImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var colarb = this.zpp_inner.colarb;
		if(!freshOnly || colarb.oc1.fresh) {
			var imp = colarb.oc1.wrapper().normalImpulse(body);
			var t = 1;
			var t1 = t;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		if(colarb.hc2) {
			if(!freshOnly || colarb.oc2.fresh) {
				var imp = colarb.oc2.wrapper().normalImpulse(body);
				var t = 1;
				var t1 = t;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retx += imp.zpp_inner.x * t1;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				rety += imp.zpp_inner.y * t1;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retz += imp.zpp_inner.z * t;
				imp.dispose();
			}
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,tangentImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var colarb = this.zpp_inner.colarb;
		if(!freshOnly || colarb.oc1.fresh) {
			var imp = colarb.oc1.wrapper().tangentImpulse(body);
			var t = 1;
			var t1 = t;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		if(colarb.hc2) {
			if(!freshOnly || colarb.oc2.fresh) {
				var imp = colarb.oc2.wrapper().tangentImpulse(body);
				var t = 1;
				var t1 = t;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retx += imp.zpp_inner.x * t1;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				rety += imp.zpp_inner.y * t1;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retz += imp.zpp_inner.z * t;
				imp.dispose();
			}
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,totalImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var colarb = this.zpp_inner.colarb;
		if(!freshOnly || colarb.oc1.fresh) {
			var imp = colarb.oc1.wrapper().totalImpulse(body);
			var t = 1;
			var t1 = t;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		if(colarb.hc2) {
			if(!freshOnly || colarb.oc2.fresh) {
				var imp = colarb.oc2.wrapper().totalImpulse(body);
				var t = 1;
				var t1 = t;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retx += imp.zpp_inner.x * t1;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				rety += imp.zpp_inner.y * t1;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retz += imp.zpp_inner.z * t;
				imp.dispose();
			}
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,rollingImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var colarb = this.zpp_inner.colarb;
		if(!freshOnly || colarb.oc1.fresh) {
			return colarb.oc1.wrapper().rollingImpulse(body);
		} else {
			return 0.0;
		}
	}
	,get_elasticity: function() {
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.restitution;
	}
	,set_elasticity: function(elasticity) {
		var colarb = this.zpp_inner.colarb;
		colarb.restitution = elasticity;
		colarb.userdef_restitution = true;
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.restitution;
	}
	,get_dynamicFriction: function() {
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.dyn_fric;
	}
	,set_dynamicFriction: function(dynamicFriction) {
		var colarb = this.zpp_inner.colarb;
		colarb.dyn_fric = dynamicFriction;
		colarb.userdef_dyn_fric = true;
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.dyn_fric;
	}
	,get_staticFriction: function() {
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.stat_fric;
	}
	,set_staticFriction: function(staticFriction) {
		var colarb = this.zpp_inner.colarb;
		colarb.stat_fric = staticFriction;
		colarb.userdef_stat_fric = true;
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.stat_fric;
	}
	,get_rollingFriction: function() {
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.rfric;
	}
	,set_rollingFriction: function(rollingFriction) {
		var colarb = this.zpp_inner.colarb;
		colarb.rfric = rollingFriction;
		colarb.userdef_rfric = true;
		var colarb = this.zpp_inner.colarb;
		if(colarb.invalidated) {
			colarb.invalidated = false;
			if(!colarb.userdef_restitution) {
				if(colarb.s1.material.elasticity <= -Infinity || colarb.s2.material.elasticity <= -Infinity) {
					colarb.restitution = 0;
				} else if(colarb.s1.material.elasticity >= Infinity || colarb.s2.material.elasticity >= Infinity) {
					colarb.restitution = 1;
				} else {
					colarb.restitution = (colarb.s1.material.elasticity + colarb.s2.material.elasticity) / 2;
				}
				if(colarb.restitution < 0) {
					colarb.restitution = 0;
				}
				if(colarb.restitution > 1) {
					colarb.restitution = 1;
				}
			}
			if(!colarb.userdef_dyn_fric) {
				var x = colarb.s1.material.dynamicFriction * colarb.s2.material.dynamicFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.dyn_fric = tmp;
			}
			if(!colarb.userdef_stat_fric) {
				var x = colarb.s1.material.staticFriction * colarb.s2.material.staticFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.stat_fric = tmp;
			}
			if(!colarb.userdef_rfric) {
				var x = colarb.s1.material.rollingFriction * colarb.s2.material.rollingFriction;
				var tmp;
				if(x == 0.0) {
					tmp = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				colarb.rfric = tmp;
			}
		}
		return colarb.rfric;
	}
});
var nape_dynamics_Contact = $hx_exports["nape"]["dynamics"]["Contact"] = function() {
	this.zpp_inner = null;
};
nape_dynamics_Contact.__name__ = true;
nape_dynamics_Contact.prototype = {
	get_arbiter: function() {
		if(this.zpp_inner.arbiter == null) {
			return null;
		} else {
			var _this = this.zpp_inner.arbiter.outer;
			if(_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				return _this.zpp_inner.colarb.outer_zn;
			} else {
				return null;
			}
		}
	}
	,get_penetration: function() {
		return -this.zpp_inner.dist;
	}
	,get_position: function() {
		if(this.zpp_inner.wrap_position == null) {
			this.zpp_inner.getposition();
		}
		return this.zpp_inner.wrap_position;
	}
	,get_fresh: function() {
		return this.zpp_inner.fresh;
	}
	,normalImpulse: function(body) {
		var colarb = this.zpp_inner.arbiter.colarb;
		var cin = this.zpp_inner.inner;
		var jnAcc = cin.jnAcc;
		if(body == null) {
			return nape_geom_Vec3.get(colarb.nx * jnAcc,colarb.ny * jnAcc);
		} else if(body == colarb.b1.outer) {
			return nape_geom_Vec3.get(colarb.nx * -jnAcc,colarb.ny * -jnAcc,-(colarb.ny * cin.r1x - colarb.nx * cin.r1y) * jnAcc);
		} else {
			return nape_geom_Vec3.get(colarb.nx * jnAcc,colarb.ny * jnAcc,(colarb.ny * cin.r2x - colarb.nx * cin.r2y) * jnAcc);
		}
	}
	,tangentImpulse: function(body) {
		var colarb = this.zpp_inner.arbiter.colarb;
		var cin = this.zpp_inner.inner;
		var jtAcc = cin.jtAcc;
		if(body == null) {
			return nape_geom_Vec3.get(-colarb.ny * jtAcc,colarb.nx * jtAcc);
		} else if(body == colarb.b1.outer) {
			return nape_geom_Vec3.get(colarb.ny * jtAcc,-colarb.nx * jtAcc,-(cin.r1x * colarb.nx + cin.r1y * colarb.ny) * jtAcc);
		} else {
			return nape_geom_Vec3.get(-colarb.ny * jtAcc,colarb.nx * jtAcc,(cin.r2x * colarb.nx + cin.r2y * colarb.ny) * jtAcc);
		}
	}
	,rollingImpulse: function(body) {
		var colarb = this.zpp_inner.arbiter.colarb;
		var jrAcc = this.zpp_inner.arbiter.colarb.jrAcc;
		if(body == null) {
			return jrAcc;
		} else if(body == colarb.b1.outer) {
			return -jrAcc;
		} else {
			return jrAcc;
		}
	}
	,totalImpulse: function(body) {
		var colarb = this.zpp_inner.arbiter.colarb;
		var cin = this.zpp_inner.inner;
		var jnAcc = cin.jnAcc;
		var jtAcc = cin.jtAcc;
		var jrAcc = colarb.jrAcc;
		if(body == null) {
			return nape_geom_Vec3.get(colarb.nx * jnAcc - colarb.ny * jtAcc,colarb.ny * jnAcc + colarb.nx * jtAcc,jrAcc);
		} else {
			var jx = colarb.nx * jnAcc - colarb.ny * jtAcc;
			var jy = colarb.ny * jnAcc + colarb.nx * jtAcc;
			if(body == colarb.b1.outer) {
				return nape_geom_Vec3.get(-jx,-jy,-(jy * cin.r1x - jx * cin.r1y) - jrAcc);
			} else {
				return nape_geom_Vec3.get(jx,jy,jy * cin.r2x - jx * cin.r2y + jrAcc);
			}
		}
	}
	,get_friction: function() {
		return this.zpp_inner.inner.friction;
	}
	,toString: function() {
		if(this.zpp_inner.arbiter == null || this.zpp_inner.arbiter.cleared) {
			return "{object-pooled}";
		} else {
			return "{Contact}";
		}
	}
};
var nape_dynamics_ContactIterator = $hx_exports["nape"]["dynamics"]["ContactIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_dynamics_ContactIterator.__name__ = true;
nape_dynamics_ContactIterator.get = function(list) {
	var ret;
	if(nape_dynamics_ContactIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$ContactList.internal = true;
		var ret1 = new nape_dynamics_ContactIterator();
		zpp_$nape_util_ZPP_$ContactList.internal = false;
		ret = ret1;
	} else {
		var r = nape_dynamics_ContactIterator.zpp_pool;
		nape_dynamics_ContactIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_dynamics_ContactIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = 0;
			var cx_ite = _this.zpp_inner.inner.next;
			while(cx_ite != null) {
				var i = cx_ite;
				if(i.active && i.arbiter.active) {
					_this.zpp_inner.user_length++;
				}
				cx_ite = cx_ite.next;
			}
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_dynamics_ContactIterator.zpp_pool;
			nape_dynamics_ContactIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_dynamics_ContactList = $hx_exports["nape"]["dynamics"]["ContactList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$ContactList();
	this.zpp_inner.outer = this;
};
nape_dynamics_ContactList.__name__ = true;
nape_dynamics_ContactList.fromArray = function(array) {
	var ret = new nape_dynamics_ContactList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_dynamics_ContactList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = 0;
			var cx_ite = this.zpp_inner.inner.next;
			while(cx_ite != null) {
				var i = cx_ite;
				if(i.active && i.arbiter.active) {
					this.zpp_inner.user_length++;
				}
				cx_ite = cx_ite.next;
			}
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = 0;
				var cx_ite = this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = 0;
			this.zpp_inner.at_ite = this.zpp_inner.inner.next;
			while(true) {
				var x = this.zpp_inner.at_ite;
				if(x.active && x.arbiter.active) {
					break;
				}
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		while(this.zpp_inner.at_index != index) {
			this.zpp_inner.at_index++;
			this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			while(true) {
				var x = this.zpp_inner.at_ite;
				if(x.active && x.arbiter.active) {
					break;
				}
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.wrapper();
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					this.zpp_inner.valmod();
					if(this.zpp_inner.zip_length) {
						this.zpp_inner.zip_length = false;
						this.zpp_inner.user_length = 0;
						var cx_ite = this.zpp_inner.inner.next;
						while(cx_ite != null) {
							var i = cx_ite;
							if(i.active && i.arbiter.active) {
								this.zpp_inner.user_length++;
							}
							cx_ite = cx_ite.next;
						}
					}
					if(this.zpp_inner.user_length == 0) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = 0;
							var cx_ite = this.zpp_inner.inner.next;
							while(cx_ite != null) {
								var i = cx_ite;
								if(i.active && i.arbiter.active) {
									this.zpp_inner.user_length++;
								}
								cx_ite = cx_ite.next;
							}
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					this.zpp_inner.valmod();
					if(this.zpp_inner.zip_length) {
						this.zpp_inner.zip_length = false;
						this.zpp_inner.user_length = 0;
						var cx_ite = this.zpp_inner.inner.next;
						while(cx_ite != null) {
							var i = cx_ite;
							if(i.active && i.arbiter.active) {
								this.zpp_inner.user_length++;
							}
							cx_ite = cx_ite.next;
						}
					}
					if(this.zpp_inner.user_length == 0) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = 0;
							var cx_ite = this.zpp_inner.inner.next;
							while(cx_ite != null) {
								var i = cx_ite;
								if(i.active && i.arbiter.active) {
									this.zpp_inner.user_length++;
								}
								cx_ite = cx_ite.next;
							}
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.next;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = 0;
				var cx_ite = this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = 0;
					var cx_ite = this.zpp_inner.inner.next;
					while(cx_ite != null) {
						var i = cx_ite;
						if(i.active && i.arbiter.active) {
							this.zpp_inner.user_length++;
						}
						cx_ite = cx_ite.next;
					}
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.next : ite.next;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.wrapper();
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = 0;
				var cx_ite = this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = 0;
					var cx_ite = this.zpp_inner.inner.next;
					while(cx_ite != null) {
						var i = cx_ite;
						if(i.active && i.arbiter.active) {
							this.zpp_inner.user_length++;
						}
						cx_ite = cx_ite.next;
					}
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.next : ite.next;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.next;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.wrapper();
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.next;
		while(cx_ite != null) {
			var x = cx_ite;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(true) {
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = 0;
					var cx_ite = this.zpp_inner.inner.next;
					while(cx_ite != null) {
						var i = cx_ite;
						if(i.active && i.arbiter.active) {
							this.zpp_inner.user_length++;
						}
						cx_ite = cx_ite.next;
					}
				}
				if(!(this.zpp_inner.user_length != 0)) {
					break;
				}
				this.pop();
			}
		} else {
			while(true) {
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = 0;
					var cx_ite = this.zpp_inner.inner.next;
					while(cx_ite != null) {
						var i = cx_ite;
						if(i.active && i.arbiter.active) {
							this.zpp_inner.user_length++;
						}
						cx_ite = cx_ite.next;
					}
				}
				if(!(this.zpp_inner.user_length != 0)) {
					break;
				}
				this.shift();
			}
		}
	}
	,empty: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = 0;
			var cx_ite = this.zpp_inner.inner.next;
			while(cx_ite != null) {
				var i = cx_ite;
				if(i.active && i.arbiter.active) {
					this.zpp_inner.user_length++;
				}
				cx_ite = cx_ite.next;
			}
		}
		return this.zpp_inner.user_length == 0;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_dynamics_ContactIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_dynamics_ContactList();
		this.zpp_inner.valmod();
		var _g = nape_dynamics_ContactIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = 0;
				var cx_ite = _this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						_this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ContactIterator.zpp_pool;
				nape_dynamics_ContactIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i1 = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i1);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_dynamics_ContactIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = 0;
				var cx_ite = _this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						_this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ContactIterator.zpp_pool;
				nape_dynamics_ContactIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_dynamics_ContactIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = 0;
				var cx_ite = _this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						_this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ContactIterator.zpp_pool;
				nape_dynamics_ContactIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i1 = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i1 == null ? "NULL" : i1.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_dynamics_ContactIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = 0;
				var cx_ite = _this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i = cx_ite;
					if(i.active && i.arbiter.active) {
						_this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_dynamics_ContactIterator.zpp_pool;
				nape_dynamics_ContactIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_dynamics_ContactIterator.zpp_pool;
				nape_dynamics_ContactIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = 0;
				var cx_ite = this.zpp_inner.inner.next;
				while(cx_ite != null) {
					var i1 = cx_ite;
					if(i1.active && i1.arbiter.active) {
						this.zpp_inner.user_length++;
					}
					cx_ite = cx_ite.next;
				}
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_dynamics_FluidArbiter = $hx_exports["nape"]["dynamics"]["FluidArbiter"] = function() {
	nape_dynamics_Arbiter.call(this);
};
nape_dynamics_FluidArbiter.__name__ = true;
nape_dynamics_FluidArbiter.__super__ = nape_dynamics_Arbiter;
nape_dynamics_FluidArbiter.prototype = $extend(nape_dynamics_Arbiter.prototype,{
	get_position: function() {
		if(this.zpp_inner.fluidarb.wrap_position == null) {
			this.zpp_inner.fluidarb.getposition();
		}
		return this.zpp_inner.fluidarb.wrap_position;
	}
	,set_position: function(position) {
		if(this.zpp_inner.fluidarb.wrap_position == null) {
			this.zpp_inner.fluidarb.getposition();
		}
		var _this = this.zpp_inner.fluidarb.wrap_position;
		var _this1 = position.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = position.zpp_inner.x;
		var _this1 = position.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = position.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(position.zpp_inner.weak) {
			var inner = position.zpp_inner;
			position.zpp_inner.outer = null;
			position.zpp_inner = null;
			var o = position;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.fluidarb.wrap_position == null) {
			this.zpp_inner.fluidarb.getposition();
		}
		return this.zpp_inner.fluidarb.wrap_position;
	}
	,get_overlap: function() {
		return this.zpp_inner.fluidarb.overlap;
	}
	,set_overlap: function(overlap) {
		this.zpp_inner.fluidarb.overlap = overlap;
		return this.zpp_inner.fluidarb.overlap;
	}
	,buoyancyImpulse: function(body) {
		var farb = this.zpp_inner.fluidarb;
		if(body == null) {
			return nape_geom_Vec3.get(farb.buoyx,farb.buoyy,0);
		} else if(body.zpp_inner == this.zpp_inner.b2) {
			return nape_geom_Vec3.get(farb.buoyx,farb.buoyy,farb.buoyy * farb.r2x - farb.buoyx * farb.r2y);
		} else {
			return nape_geom_Vec3.get(-farb.buoyx,-farb.buoyy,-(farb.buoyy * farb.r1x - farb.buoyx * farb.r1y));
		}
	}
	,dragImpulse: function(body) {
		var farb = this.zpp_inner.fluidarb;
		var scale = body == null || body.zpp_inner == this.zpp_inner.b2 ? 1 : -1;
		return nape_geom_Vec3.get(farb.dampx * scale,farb.dampy * scale,farb.adamp * scale);
	}
	,totalImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var tmp = this.buoyancyImpulse(body);
		var ret = this.dragImpulse(body);
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = ret.zpp_inner.x;
		var _this = tmp.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		ret.zpp_inner.x = x + tmp.zpp_inner.x;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = ret.zpp_inner.y;
		var _this = tmp.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		ret.zpp_inner.y = y + tmp.zpp_inner.y;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var z = ret.zpp_inner.z;
		var _this = tmp.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		ret.zpp_inner.z = z + tmp.zpp_inner.z;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tmp.dispose();
		return ret;
	}
});
var nape_dynamics_InteractionFilter = $hx_exports["nape"]["dynamics"]["InteractionFilter"] = function(collisionGroup,collisionMask,sensorGroup,sensorMask,fluidGroup,fluidMask) {
	if(fluidMask == null) {
		fluidMask = -1;
	}
	if(fluidGroup == null) {
		fluidGroup = 1;
	}
	if(sensorMask == null) {
		sensorMask = -1;
	}
	if(sensorGroup == null) {
		sensorGroup = 1;
	}
	if(collisionMask == null) {
		collisionMask = -1;
	}
	if(collisionGroup == null) {
		collisionGroup = 1;
	}
	this.zpp_inner = null;
	if(zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool == null) {
		this.zpp_inner = new zpp_$nape_dynamics_ZPP_$InteractionFilter();
	} else {
		this.zpp_inner = zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool;
		zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool = this.zpp_inner.next;
		this.zpp_inner.next = null;
	}
	this.zpp_inner.outer = this;
	if(this.zpp_inner.collisionGroup != collisionGroup) {
		this.zpp_inner.collisionGroup = collisionGroup;
		this.zpp_inner.invalidate();
	}
	if(this.zpp_inner.collisionMask != collisionMask) {
		this.zpp_inner.collisionMask = collisionMask;
		this.zpp_inner.invalidate();
	}
	if(this.zpp_inner.sensorGroup != sensorGroup) {
		this.zpp_inner.sensorGroup = sensorGroup;
		this.zpp_inner.invalidate();
	}
	if(this.zpp_inner.sensorMask != sensorMask) {
		this.zpp_inner.sensorMask = sensorMask;
		this.zpp_inner.invalidate();
	}
	if(this.zpp_inner.fluidGroup != fluidGroup) {
		this.zpp_inner.fluidGroup = fluidGroup;
		this.zpp_inner.invalidate();
	}
	if(this.zpp_inner.fluidMask != fluidMask) {
		this.zpp_inner.fluidMask = fluidMask;
		this.zpp_inner.invalidate();
	}
};
nape_dynamics_InteractionFilter.__name__ = true;
nape_dynamics_InteractionFilter.prototype = {
	get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_shapes: function() {
		if(this.zpp_inner.wrap_shapes == null) {
			this.zpp_inner.wrap_shapes = zpp_$nape_util_ZPP_$ShapeList.get(this.zpp_inner.shapes,true);
		}
		return this.zpp_inner.wrap_shapes;
	}
	,get_collisionGroup: function() {
		return this.zpp_inner.collisionGroup;
	}
	,set_collisionGroup: function(collisionGroup) {
		if(this.zpp_inner.collisionGroup != collisionGroup) {
			this.zpp_inner.collisionGroup = collisionGroup;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.collisionGroup;
	}
	,get_collisionMask: function() {
		return this.zpp_inner.collisionMask;
	}
	,set_collisionMask: function(collisionMask) {
		if(this.zpp_inner.collisionMask != collisionMask) {
			this.zpp_inner.collisionMask = collisionMask;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.collisionMask;
	}
	,get_sensorGroup: function() {
		return this.zpp_inner.sensorGroup;
	}
	,set_sensorGroup: function(sensorGroup) {
		if(this.zpp_inner.sensorGroup != sensorGroup) {
			this.zpp_inner.sensorGroup = sensorGroup;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.sensorGroup;
	}
	,get_sensorMask: function() {
		return this.zpp_inner.sensorMask;
	}
	,set_sensorMask: function(sensorMask) {
		if(this.zpp_inner.sensorMask != sensorMask) {
			this.zpp_inner.sensorMask = sensorMask;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.sensorMask;
	}
	,get_fluidGroup: function() {
		return this.zpp_inner.fluidGroup;
	}
	,set_fluidGroup: function(fluidGroup) {
		if(this.zpp_inner.fluidGroup != fluidGroup) {
			this.zpp_inner.fluidGroup = fluidGroup;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.fluidGroup;
	}
	,get_fluidMask: function() {
		return this.zpp_inner.fluidMask;
	}
	,set_fluidMask: function(fluidMask) {
		if(this.zpp_inner.fluidMask != fluidMask) {
			this.zpp_inner.fluidMask = fluidMask;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.fluidMask;
	}
	,shouldCollide: function(filter) {
		var _this = this.zpp_inner;
		var x = filter.zpp_inner;
		if((_this.collisionMask & x.collisionGroup) != 0) {
			return (x.collisionMask & _this.collisionGroup) != 0;
		} else {
			return false;
		}
	}
	,shouldSense: function(filter) {
		var _this = this.zpp_inner;
		var x = filter.zpp_inner;
		if((_this.sensorMask & x.sensorGroup) != 0) {
			return (x.sensorMask & _this.sensorGroup) != 0;
		} else {
			return false;
		}
	}
	,shouldFlow: function(filter) {
		var _this = this.zpp_inner;
		var x = filter.zpp_inner;
		if((_this.fluidMask & x.fluidGroup) != 0) {
			return (x.fluidMask & _this.fluidGroup) != 0;
		} else {
			return false;
		}
	}
	,copy: function() {
		return new nape_dynamics_InteractionFilter(this.zpp_inner.collisionGroup,this.zpp_inner.collisionMask,this.zpp_inner.sensorGroup,this.zpp_inner.sensorMask,this.zpp_inner.fluidGroup,this.zpp_inner.fluidMask);
	}
	,toString: function() {
		return "{ collision: " + StringTools.hex(this.zpp_inner.collisionGroup,8) + "~" + StringTools.hex(this.zpp_inner.collisionMask,8) + " sensor: " + StringTools.hex(this.zpp_inner.sensorGroup,8) + "~" + StringTools.hex(this.zpp_inner.sensorMask,8) + " fluid: " + StringTools.hex(this.zpp_inner.fluidGroup,8) + "~" + StringTools.hex(this.zpp_inner.fluidMask,8) + " }";
	}
};
var nape_dynamics_InteractionGroup = $hx_exports["nape"]["dynamics"]["InteractionGroup"] = function(ignore) {
	if(ignore == null) {
		ignore = false;
	}
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_dynamics_ZPP_$InteractionGroup();
	this.zpp_inner.outer = this;
	if(this.zpp_inner.ignore != ignore) {
		this.zpp_inner.invalidate(true);
		this.zpp_inner.ignore = ignore;
	}
};
nape_dynamics_InteractionGroup.__name__ = true;
nape_dynamics_InteractionGroup.prototype = {
	get_group: function() {
		if(this.zpp_inner.group == null) {
			return null;
		} else {
			return this.zpp_inner.group.outer;
		}
	}
	,set_group: function(group) {
		this.zpp_inner.setGroup(group == null ? null : group.zpp_inner);
		if(this.zpp_inner.group == null) {
			return null;
		} else {
			return this.zpp_inner.group.outer;
		}
	}
	,get_ignore: function() {
		return this.zpp_inner.ignore;
	}
	,set_ignore: function(ignore) {
		if(this.zpp_inner.ignore != ignore) {
			this.zpp_inner.invalidate(true);
			this.zpp_inner.ignore = ignore;
		}
		return this.zpp_inner.ignore;
	}
	,get_interactors: function() {
		if(this.zpp_inner.wrap_interactors == null) {
			this.zpp_inner.wrap_interactors = zpp_$nape_util_ZPP_$InteractorList.get(this.zpp_inner.interactors,true);
		}
		return this.zpp_inner.wrap_interactors;
	}
	,get_groups: function() {
		if(this.zpp_inner.wrap_groups == null) {
			this.zpp_inner.wrap_groups = zpp_$nape_util_ZPP_$InteractionGroupList.get(this.zpp_inner.groups,true);
		}
		return this.zpp_inner.wrap_groups;
	}
	,toString: function() {
		var ret = "InteractionGroup";
		if(this.zpp_inner.ignore) {
			ret += ":ignore";
		}
		return ret;
	}
};
var nape_dynamics_InteractionGroupIterator = $hx_exports["nape"]["dynamics"]["InteractionGroupIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_dynamics_InteractionGroupIterator.__name__ = true;
nape_dynamics_InteractionGroupIterator.get = function(list) {
	var ret;
	if(nape_dynamics_InteractionGroupIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$InteractionGroupList.internal = true;
		var ret1 = new nape_dynamics_InteractionGroupIterator();
		zpp_$nape_util_ZPP_$InteractionGroupList.internal = false;
		ret = ret1;
	} else {
		var r = nape_dynamics_InteractionGroupIterator.zpp_pool;
		nape_dynamics_InteractionGroupIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_dynamics_InteractionGroupIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_dynamics_InteractionGroupIterator.zpp_pool;
			nape_dynamics_InteractionGroupIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_dynamics_InteractionGroupList = $hx_exports["nape"]["dynamics"]["InteractionGroupList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$InteractionGroupList();
	this.zpp_inner.outer = this;
};
nape_dynamics_InteractionGroupList.__name__ = true;
nape_dynamics_InteractionGroupList.fromArray = function(array) {
	var ret = new nape_dynamics_InteractionGroupList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_dynamics_InteractionGroupList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_dynamics_InteractionGroupIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_dynamics_InteractionGroupList();
		this.zpp_inner.valmod();
		var _g = nape_dynamics_InteractionGroupIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_InteractionGroupIterator.zpp_pool;
				nape_dynamics_InteractionGroupIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_dynamics_InteractionGroupIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_InteractionGroupIterator.zpp_pool;
				nape_dynamics_InteractionGroupIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_dynamics_InteractionGroupIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_InteractionGroupIterator.zpp_pool;
				nape_dynamics_InteractionGroupIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_dynamics_InteractionGroupIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_dynamics_InteractionGroupIterator.zpp_pool;
				nape_dynamics_InteractionGroupIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_dynamics_InteractionGroupIterator.zpp_pool;
				nape_dynamics_InteractionGroupIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_geom_AABB = $hx_exports["nape"]["geom"]["AABB"] = function(x,y,width,height) {
	if(height == null) {
		height = 0;
	}
	if(width == null) {
		width = 0;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	this.zpp_inner = null;
	var ret;
	if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$AABB();
	} else {
		ret = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.minx = x;
	ret.miny = y;
	ret.maxx = x + width;
	ret.maxy = y + height;
	this.zpp_inner = ret;
	this.zpp_inner.outer = this;
};
nape_geom_AABB.__name__ = true;
nape_geom_AABB.prototype = {
	copy: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		var minx = _this.minx;
		var miny = _this.miny;
		var maxx = _this.maxx;
		var maxy = _this.maxy;
		var ret;
		if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$AABB();
		} else {
			ret = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.minx = minx;
		ret.miny = miny;
		ret.maxx = maxx;
		ret.maxy = maxy;
		return ret.wrapper();
	}
	,get_min: function() {
		return this.zpp_inner.getmin();
	}
	,set_min: function(min) {
		var _this = this.zpp_inner.getmin();
		var _this1 = min.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = min.zpp_inner.x;
		var _this1 = min.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = min.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(min.zpp_inner.weak) {
			var inner = min.zpp_inner;
			min.zpp_inner.outer = null;
			min.zpp_inner = null;
			var o = min;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this.zpp_inner.getmin();
	}
	,get_max: function() {
		return this.zpp_inner.getmax();
	}
	,set_max: function(max) {
		var _this = this.zpp_inner.getmax();
		var _this1 = max.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = max.zpp_inner.x;
		var _this1 = max.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = max.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(max.zpp_inner.weak) {
			var inner = max.zpp_inner;
			max.zpp_inner.outer = null;
			max.zpp_inner = null;
			var o = max;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this.zpp_inner.getmax();
	}
	,get_x: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.minx;
	}
	,set_x: function(x) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.minx != x) {
			this.zpp_inner.maxx += x - this.zpp_inner.minx;
			this.zpp_inner.minx = x;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.minx;
	}
	,get_y: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.miny;
	}
	,set_y: function(y) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.miny != y) {
			this.zpp_inner.maxy += y - this.zpp_inner.miny;
			this.zpp_inner.miny = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.miny;
	}
	,get_width: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		return _this.maxx - _this.minx;
	}
	,set_width: function(width) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this.maxx - _this.minx != width) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			this.zpp_inner.maxx = this.zpp_inner.minx + width;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		return _this.maxx - _this.minx;
	}
	,get_height: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		return _this.maxy - _this.miny;
	}
	,set_height: function(height) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this.maxy - _this.miny != height) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			this.zpp_inner.maxy = this.zpp_inner.miny + height;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		return _this.maxy - _this.miny;
	}
	,toString: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.toString();
	}
};
var nape_geom_ConvexResult = $hx_exports["nape"]["geom"]["ConvexResult"] = function() {
	this.zpp_inner = null;
};
nape_geom_ConvexResult.__name__ = true;
nape_geom_ConvexResult.prototype = {
	get_normal: function() {
		return this.zpp_inner.normal;
	}
	,get_position: function() {
		return this.zpp_inner.position;
	}
	,get_toi: function() {
		return this.zpp_inner.toiDistance;
	}
	,get_shape: function() {
		return this.zpp_inner.shape;
	}
	,dispose: function() {
		this.zpp_inner.free();
	}
	,toString: function() {
		return "{ shape: " + Std.string(this.zpp_inner.shape) + " toi: " + this.zpp_inner.toiDistance + " }";
	}
};
var nape_geom_ConvexResultIterator = $hx_exports["nape"]["geom"]["ConvexResultIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_geom_ConvexResultIterator.__name__ = true;
nape_geom_ConvexResultIterator.get = function(list) {
	var ret;
	if(nape_geom_ConvexResultIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$ConvexResultList.internal = true;
		var ret1 = new nape_geom_ConvexResultIterator();
		zpp_$nape_util_ZPP_$ConvexResultList.internal = false;
		ret = ret1;
	} else {
		var r = nape_geom_ConvexResultIterator.zpp_pool;
		nape_geom_ConvexResultIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_geom_ConvexResultIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_geom_ConvexResultIterator.zpp_pool;
			nape_geom_ConvexResultIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_geom_ConvexResultList = $hx_exports["nape"]["geom"]["ConvexResultList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$ConvexResultList();
	this.zpp_inner.outer = this;
};
nape_geom_ConvexResultList.__name__ = true;
nape_geom_ConvexResultList.fromArray = function(array) {
	var ret = new nape_geom_ConvexResultList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_geom_ConvexResultList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj);
			} else {
				this.zpp_inner.inner.add(obj);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_geom_ConvexResultIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_geom_ConvexResultList();
		this.zpp_inner.valmod();
		var _g = nape_geom_ConvexResultIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_ConvexResultIterator.zpp_pool;
				nape_geom_ConvexResultIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_geom_ConvexResultIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_ConvexResultIterator.zpp_pool;
				nape_geom_ConvexResultIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_geom_ConvexResultIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_ConvexResultIterator.zpp_pool;
				nape_geom_ConvexResultIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_geom_ConvexResultIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_geom_ConvexResultIterator.zpp_pool;
				nape_geom_ConvexResultIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_geom_ConvexResultIterator.zpp_pool;
				nape_geom_ConvexResultIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_geom_Geom = $hx_exports["nape"]["geom"]["Geom"] = function() { };
nape_geom_Geom.__name__ = true;
nape_geom_Geom.distanceBody = function(body1,body2,out1,out2) {
	var cx_ite = body1.zpp_inner.shapes.head;
	while(cx_ite != null) {
		var i = cx_ite.elt;
		zpp_$nape_geom_ZPP_$Geom.validateShape(i);
		cx_ite = cx_ite.next;
	}
	var cx_ite = body2.zpp_inner.shapes.head;
	while(cx_ite != null) {
		var i = cx_ite.elt;
		zpp_$nape_geom_ZPP_$Geom.validateShape(i);
		cx_ite = cx_ite.next;
	}
	return zpp_$nape_geom_ZPP_$SweepDistance.distanceBody(body1.zpp_inner,body2.zpp_inner,out1.zpp_inner,out2.zpp_inner);
};
nape_geom_Geom.distance = function(shape1,shape2,out1,out2) {
	zpp_$nape_geom_ZPP_$Geom.validateShape(shape1.zpp_inner);
	zpp_$nape_geom_ZPP_$Geom.validateShape(shape2.zpp_inner);
	var tmp;
	if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
		tmp = new zpp_$nape_geom_ZPP_$Vec2();
	} else {
		tmp = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = tmp.next;
		tmp.next = null;
	}
	tmp.weak = false;
	var s1 = shape1.zpp_inner;
	var s2 = shape2.zpp_inner;
	var w1 = out1.zpp_inner;
	var w2 = out2.zpp_inner;
	var upperBound = 1e100;
	if(upperBound == null) {
		upperBound = 1e100;
	}
	var ret;
	if(s1.type == 0 && s2.type == 0) {
		var c1 = s1.circle;
		var c2 = s2.circle;
		var dist;
		var nx = 0.0;
		var ny = 0.0;
		nx = c2.worldCOMx - c1.worldCOMx;
		ny = c2.worldCOMy - c1.worldCOMy;
		var x = nx * nx + ny * ny;
		var len;
		if(x == 0.0) {
			len = 0.0;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			len = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
		}
		dist = len - (c1.radius + c2.radius);
		if(dist < upperBound) {
			if(len == 0) {
				nx = 1;
				ny = 0;
			} else {
				var t = 1.0 / len;
				nx *= t;
				ny *= t;
			}
			var t = c1.radius;
			w1.x = c1.worldCOMx + nx * t;
			w1.y = c1.worldCOMy + ny * t;
			var t = -c2.radius;
			w2.x = c2.worldCOMx + nx * t;
			w2.y = c2.worldCOMy + ny * t;
			tmp.x = nx;
			tmp.y = ny;
		}
		ret = dist;
	} else {
		var swapped = false;
		if(s1.type == 0 && s2.type == 1) {
			var tmp1 = s1;
			s1 = s2;
			s2 = tmp1;
			var tmp2 = w1;
			w1 = w2;
			w2 = tmp2;
			swapped = true;
		}
		if(s1.type == 1 && s2.type == 0) {
			var poly = s1.polygon;
			var circle = s2.circle;
			var best = -1e+100;
			var a0 = null;
			var cx_ite = poly.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				var dist = a.gnormx * circle.worldCOMx + a.gnormy * circle.worldCOMy - a.gprojection - circle.radius;
				if(dist > upperBound) {
					best = dist;
					break;
				}
				if(dist > 0) {
					if(dist > best) {
						best = dist;
						a0 = a;
					}
				} else if(best < 0 && dist > best) {
					best = dist;
					a0 = a;
				}
				cx_ite = cx_ite.next;
			}
			if(best < upperBound) {
				var v0 = a0.gp0;
				var v1 = a0.gp1;
				var dt = circle.worldCOMy * a0.gnormx - circle.worldCOMx * a0.gnormy;
				if(dt <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
					var nx = 0.0;
					var ny = 0.0;
					nx = circle.worldCOMx - v0.x;
					ny = circle.worldCOMy - v0.y;
					var x = nx * nx + ny * ny;
					var len;
					if(x == 0.0) {
						len = 0.0;
					} else {
						zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
						zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
						var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
						len = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
					}
					best = len - circle.radius;
					if(best < upperBound) {
						if(len == 0) {
							nx = 1;
							ny = 0;
						} else {
							var t = 1.0 / len;
							nx *= t;
							ny *= t;
						}
						var t = 0;
						w1.x = v0.x + nx * t;
						w1.y = v0.y + ny * t;
						var t = -circle.radius;
						w2.x = circle.worldCOMx + nx * t;
						w2.y = circle.worldCOMy + ny * t;
						tmp.x = nx;
						tmp.y = ny;
					}
				} else if(dt >= v1.y * a0.gnormx - v1.x * a0.gnormy) {
					var nx = 0.0;
					var ny = 0.0;
					nx = circle.worldCOMx - v1.x;
					ny = circle.worldCOMy - v1.y;
					var x = nx * nx + ny * ny;
					var len;
					if(x == 0.0) {
						len = 0.0;
					} else {
						zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
						zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
						var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
						len = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
					}
					best = len - circle.radius;
					if(best < upperBound) {
						if(len == 0) {
							nx = 1;
							ny = 0;
						} else {
							var t = 1.0 / len;
							nx *= t;
							ny *= t;
						}
						var t = 0;
						w1.x = v1.x + nx * t;
						w1.y = v1.y + ny * t;
						var t = -circle.radius;
						w2.x = circle.worldCOMx + nx * t;
						w2.y = circle.worldCOMy + ny * t;
						tmp.x = nx;
						tmp.y = ny;
					}
				} else {
					var t = -circle.radius;
					w2.x = circle.worldCOMx + a0.gnormx * t;
					w2.y = circle.worldCOMy + a0.gnormy * t;
					var t = -best;
					w1.x = w2.x + a0.gnormx * t;
					w1.y = w2.y + a0.gnormy * t;
					tmp.x = a0.gnormx;
					tmp.y = a0.gnormy;
				}
			}
			if(swapped) {
				tmp.x = -tmp.x;
				tmp.y = -tmp.y;
			}
			ret = best;
		} else {
			var p1 = s1.polygon;
			var p2 = s2.polygon;
			var best = -1e+100;
			var a1 = null;
			var a2 = null;
			var besti = 0;
			var cx_ite = p1.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				var min = 1e100;
				var cx_ite1 = p2.gverts.next;
				while(cx_ite1 != null) {
					var v = cx_ite1;
					var k = a.gnormx * v.x + a.gnormy * v.y;
					if(k < min) {
						min = k;
					}
					cx_ite1 = cx_ite1.next;
				}
				min -= a.gprojection;
				if(min > upperBound) {
					best = min;
					break;
				}
				if(min > 0) {
					if(min > best) {
						best = min;
						a1 = a;
						besti = 1;
					}
				} else if(best < 0 && min > best) {
					best = min;
					a1 = a;
					besti = 1;
				}
				cx_ite = cx_ite.next;
			}
			if(best < upperBound) {
				var cx_ite = p2.edges.head;
				while(cx_ite != null) {
					var a = cx_ite.elt;
					var min = 1e100;
					var cx_ite1 = p1.gverts.next;
					while(cx_ite1 != null) {
						var v = cx_ite1;
						var k = a.gnormx * v.x + a.gnormy * v.y;
						if(k < min) {
							min = k;
						}
						cx_ite1 = cx_ite1.next;
					}
					min -= a.gprojection;
					if(min > upperBound) {
						best = min;
						break;
					}
					if(min > 0) {
						if(min > best) {
							best = min;
							a2 = a;
							besti = 2;
						}
					} else if(best < 0 && min > best) {
						best = min;
						a2 = a;
						besti = 2;
					}
					cx_ite = cx_ite.next;
				}
				if(best < upperBound) {
					var q1;
					var q2;
					var ax;
					if(besti == 1) {
						q1 = p1;
						q2 = p2;
						ax = a1;
					} else {
						q1 = p2;
						q2 = p1;
						ax = a2;
						var tmp1 = w1;
						w1 = w2;
						w2 = tmp1;
						swapped = !swapped;
					}
					var ay = null;
					var min = 1e100;
					var cx_ite = q2.edges.head;
					while(cx_ite != null) {
						var a = cx_ite.elt;
						var k = ax.gnormx * a.gnormx + ax.gnormy * a.gnormy;
						if(k < min) {
							min = k;
							ay = a;
						}
						cx_ite = cx_ite.next;
					}
					if(swapped) {
						tmp.x = -ax.gnormx;
						tmp.y = -ax.gnormy;
					} else {
						tmp.x = ax.gnormx;
						tmp.y = ax.gnormy;
					}
					if(best >= 0) {
						var v0 = ax.gp0;
						var v1 = ax.gp1;
						var q0 = ay.gp0;
						var q1 = ay.gp1;
						var vx = 0.0;
						var vy = 0.0;
						var qx = 0.0;
						var qy = 0.0;
						vx = v1.x - v0.x;
						vy = v1.y - v0.y;
						qx = q1.x - q0.x;
						qy = q1.y - q0.y;
						var vdot = 1 / (vx * vx + vy * vy);
						var qdot = 1 / (qx * qx + qy * qy);
						var t1 = -(vx * (v0.x - q0.x) + vy * (v0.y - q0.y)) * vdot;
						var t2 = -(vx * (v0.x - q1.x) + vy * (v0.y - q1.y)) * vdot;
						var s1 = -(qx * (q0.x - v0.x) + qy * (q0.y - v0.y)) * qdot;
						var s2 = -(qx * (q0.x - v1.x) + qy * (q0.y - v1.y)) * qdot;
						if(t1 < 0) {
							t1 = 0;
						} else if(t1 > 1) {
							t1 = 1;
						}
						if(t2 < 0) {
							t2 = 0;
						} else if(t2 > 1) {
							t2 = 1;
						}
						if(s1 < 0) {
							s1 = 0;
						} else if(s1 > 1) {
							s1 = 1;
						}
						if(s2 < 0) {
							s2 = 0;
						} else if(s2 > 1) {
							s2 = 1;
						}
						var f1x = 0.0;
						var f1y = 0.0;
						var t = t1;
						f1x = v0.x + vx * t;
						f1y = v0.y + vy * t;
						var f2x = 0.0;
						var f2y = 0.0;
						var t = t2;
						f2x = v0.x + vx * t;
						f2y = v0.y + vy * t;
						var g1x = 0.0;
						var g1y = 0.0;
						var t = s1;
						g1x = q0.x + qx * t;
						g1y = q0.y + qy * t;
						var g2x = 0.0;
						var g2y = 0.0;
						var t = s2;
						g2x = q0.x + qx * t;
						g2y = q0.y + qy * t;
						var dx = 0.0;
						var dy = 0.0;
						dx = f1x - q0.x;
						dy = f1y - q0.y;
						var d1 = dx * dx + dy * dy;
						var dx = 0.0;
						var dy = 0.0;
						dx = f2x - q1.x;
						dy = f2y - q1.y;
						var d2 = dx * dx + dy * dy;
						var dx = 0.0;
						var dy = 0.0;
						dx = g1x - v0.x;
						dy = g1y - v0.y;
						var e1 = dx * dx + dy * dy;
						var dx = 0.0;
						var dy = 0.0;
						dx = g2x - v1.x;
						dy = g2y - v1.y;
						var e2 = dx * dx + dy * dy;
						var minfx = 0.0;
						var minfy = 0.0;
						var minq = null;
						if(d1 < d2) {
							minfx = f1x;
							minfy = f1y;
							minq = q0;
						} else {
							minfx = f2x;
							minfy = f2y;
							minq = q1;
							d1 = d2;
						}
						var mingx = 0.0;
						var mingy = 0.0;
						var minv = null;
						if(e1 < e2) {
							mingx = g1x;
							mingy = g1y;
							minv = v0;
						} else {
							mingx = g2x;
							mingy = g2y;
							minv = v1;
							e1 = e2;
						}
						if(d1 < e1) {
							w1.x = minfx;
							w1.y = minfy;
							w2.x = minq.x;
							w2.y = minq.y;
							best = Math.sqrt(d1);
						} else {
							w2.x = mingx;
							w2.y = mingy;
							w1.x = minv.x;
							w1.y = minv.y;
							best = Math.sqrt(e1);
						}
						if(best != 0) {
							tmp.x = w2.x - w1.x;
							tmp.y = w2.y - w1.y;
							var t = 1.0 / best;
							tmp.x *= t;
							tmp.y *= t;
							if(swapped) {
								tmp.x = -tmp.x;
								tmp.y = -tmp.y;
							}
						}
						ret = best;
					} else {
						var c0x = 0.0;
						var c0y = 0.0;
						c0x = ay.gp0.x;
						c0y = ay.gp0.y;
						var c1x = 0.0;
						var c1y = 0.0;
						c1x = ay.gp1.x;
						c1y = ay.gp1.y;
						var dvx = 0.0;
						var dvy = 0.0;
						dvx = c1x - c0x;
						dvy = c1y - c0y;
						var d0 = ax.gnormy * c0x - ax.gnormx * c0y;
						var d1 = ax.gnormy * c1x - ax.gnormx * c1y;
						var den = 1 / (d1 - d0);
						var t = (-ax.tp1 - d0) * den;
						if(t > nape_Config.epsilon) {
							var t1 = t;
							c0x += dvx * t1;
							c0y += dvy * t1;
						}
						var t = (-ax.tp0 - d1) * den;
						if(t < -nape_Config.epsilon) {
							var t1 = t;
							c1x += dvx * t1;
							c1y += dvy * t1;
						}
						var c0d = c0x * ax.gnormx + c0y * ax.gnormy - ax.gprojection;
						var c1d = c1x * ax.gnormx + c1y * ax.gnormy - ax.gprojection;
						if(c0d < c1d) {
							w2.x = c0x;
							w2.y = c0y;
							var t = -c0d;
							w1.x = w2.x + ax.gnormx * t;
							w1.y = w2.y + ax.gnormy * t;
							ret = c0d;
						} else {
							w2.x = c1x;
							w2.y = c1y;
							var t = -c1d;
							w1.x = w2.x + ax.gnormx * t;
							w1.y = w2.y + ax.gnormy * t;
							ret = c1d;
						}
					}
				} else {
					ret = upperBound;
				}
			} else {
				ret = upperBound;
			}
		}
	}
	var o = tmp;
	if(o.outer != null) {
		o.outer.zpp_inner = null;
		o.outer = null;
	}
	o._isimmutable = null;
	o._validate = null;
	o._invalidate = null;
	o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
	zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	return ret;
};
nape_geom_Geom.intersectsBody = function(body1,body2) {
	var cx_ite = body1.zpp_inner.shapes.head;
	while(cx_ite != null) {
		var i = cx_ite.elt;
		zpp_$nape_geom_ZPP_$Geom.validateShape(i);
		cx_ite = cx_ite.next;
	}
	var cx_ite = body2.zpp_inner.shapes.head;
	while(cx_ite != null) {
		var i = cx_ite.elt;
		zpp_$nape_geom_ZPP_$Geom.validateShape(i);
		cx_ite = cx_ite.next;
	}
	var _this = body1.zpp_inner.aabb;
	var x = body2.zpp_inner.aabb;
	if(!(x.miny <= _this.maxy && _this.miny <= x.maxy && x.minx <= _this.maxx && _this.minx <= x.maxx)) {
		return false;
	} else {
		var cx_ite = body1.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s1 = cx_ite.elt;
			var cx_ite1 = body2.zpp_inner.shapes.head;
			while(cx_ite1 != null) {
				var s2 = cx_ite1.elt;
				if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(s1,s2)) {
					return true;
				}
				cx_ite1 = cx_ite1.next;
			}
			cx_ite = cx_ite.next;
		}
		return false;
	}
};
nape_geom_Geom.intersects = function(shape1,shape2) {
	zpp_$nape_geom_ZPP_$Geom.validateShape(shape1.zpp_inner);
	zpp_$nape_geom_ZPP_$Geom.validateShape(shape2.zpp_inner);
	var _this = shape1.zpp_inner.aabb;
	var x = shape2.zpp_inner.aabb;
	if(x.miny <= _this.maxy && _this.miny <= x.maxy && x.minx <= _this.maxx && _this.minx <= x.maxx) {
		return zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape1.zpp_inner,shape2.zpp_inner);
	} else {
		return false;
	}
};
nape_geom_Geom.contains = function(shape1,shape2) {
	zpp_$nape_geom_ZPP_$Geom.validateShape(shape1.zpp_inner);
	zpp_$nape_geom_ZPP_$Geom.validateShape(shape2.zpp_inner);
	return zpp_$nape_geom_ZPP_$Collide.containTest(shape1.zpp_inner,shape2.zpp_inner);
};
var nape_geom_GeomPoly = $hx_exports["nape"]["geom"]["GeomPoly"] = function(vertices) {
	this.zpp_inner = null;
	this.zpp_pool = null;
	this.zpp_inner = new zpp_$nape_geom_ZPP_$GeomPoly(this);
	if(vertices != null) {
		if(((vertices) instanceof Array)) {
			var lv = vertices;
			var _g = 0;
			while(_g < lv.length) {
				var vite = lv[_g];
				++_g;
				var v = vite;
				var _this = v.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var x = v.zpp_inner.x;
				var _this1 = v.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				var y = v.zpp_inner.y;
				var ret;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.forced = false;
				ret.x = x;
				ret.y = y;
				var obj = ret;
				if(this.zpp_inner.vertices == null) {
					this.zpp_inner.vertices = obj.prev = obj.next = obj;
				} else {
					obj.prev = this.zpp_inner.vertices;
					obj.next = this.zpp_inner.vertices.next;
					this.zpp_inner.vertices.next.prev = obj;
					this.zpp_inner.vertices.next = obj;
				}
				this.zpp_inner.vertices = obj;
			}
		} else if(((vertices) instanceof nape_geom_Vec2List)) {
			var lv = vertices;
			var _g = lv.iterator();
			while(true) {
				_g.zpp_inner.zpp_inner.valmod();
				var length = _g.zpp_inner.zpp_gl();
				_g.zpp_critical = true;
				var tmp;
				if(_g.zpp_i < length) {
					tmp = true;
				} else {
					_g.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
					nape_geom_Vec2Iterator.zpp_pool = _g;
					_g.zpp_inner = null;
					tmp = false;
				}
				if(!tmp) {
					break;
				}
				_g.zpp_critical = false;
				var v = _g.zpp_inner.at(_g.zpp_i++);
				var _this = v.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var x = v.zpp_inner.x;
				var _this1 = v.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				var y = v.zpp_inner.y;
				var ret;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.forced = false;
				ret.x = x;
				ret.y = y;
				var obj = ret;
				if(this.zpp_inner.vertices == null) {
					this.zpp_inner.vertices = obj.prev = obj.next = obj;
				} else {
					obj.prev = this.zpp_inner.vertices;
					obj.next = this.zpp_inner.vertices.next;
					this.zpp_inner.vertices.next.prev = obj;
					this.zpp_inner.vertices.next = obj;
				}
				this.zpp_inner.vertices = obj;
			}
		} else if(((vertices) instanceof nape_geom_GeomPoly)) {
			var lv = vertices;
			var verts = lv.zpp_inner.vertices;
			if(verts != null) {
				var vite = verts;
				do {
					var x = vite.x;
					var y = vite.y;
					if(y == null) {
						y = 0;
					}
					if(x == null) {
						x = 0;
					}
					var ret;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret = new nape_geom_Vec2();
					} else {
						ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
						ret.zpp_pool = null;
					}
					if(ret.zpp_inner == null) {
						var ret1;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret1 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
							ret1.next = null;
						}
						ret1.weak = false;
						ret1._immutable = false;
						ret1.x = x;
						ret1.y = y;
						ret.zpp_inner = ret1;
						ret.zpp_inner.outer = ret;
					} else {
						var tmp;
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						if(ret.zpp_inner.x == x) {
							var _this1 = ret.zpp_inner;
							if(_this1._validate != null) {
								_this1._validate();
							}
							tmp = ret.zpp_inner.y == y;
						} else {
							tmp = false;
						}
						if(!tmp) {
							ret.zpp_inner.x = x;
							ret.zpp_inner.y = y;
							var _this2 = ret.zpp_inner;
							if(_this2._invalidate != null) {
								_this2._invalidate(_this2);
							}
						}
					}
					ret.zpp_inner.weak = false;
					var v = ret;
					vite = vite.next;
					var _this3 = v.zpp_inner;
					if(_this3._validate != null) {
						_this3._validate();
					}
					var x1 = v.zpp_inner.x;
					var _this4 = v.zpp_inner;
					if(_this4._validate != null) {
						_this4._validate();
					}
					var y1 = v.zpp_inner.y;
					var ret2;
					if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
						ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
					} else {
						ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
						ret2.next = null;
					}
					ret2.forced = false;
					ret2.x = x1;
					ret2.y = y1;
					var obj = ret2;
					if(this.zpp_inner.vertices == null) {
						this.zpp_inner.vertices = obj.prev = obj.next = obj;
					} else {
						obj.prev = this.zpp_inner.vertices;
						obj.next = this.zpp_inner.vertices.next;
						this.zpp_inner.vertices.next.prev = obj;
						this.zpp_inner.vertices.next = obj;
					}
					this.zpp_inner.vertices = obj;
					var inner = v.zpp_inner;
					v.zpp_inner.outer = null;
					v.zpp_inner = null;
					var o = v;
					o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
					var o1 = inner;
					if(o1.outer != null) {
						o1.outer.zpp_inner = null;
						o1.outer = null;
					}
					o1._isimmutable = null;
					o1._validate = null;
					o1._invalidate = null;
					o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
				} while(vite != verts);
			}
		}
		this.skipForward(1);
		if(((vertices) instanceof Array)) {
			var lv = vertices;
			var i = 0;
			while(i < lv.length) {
				var cur = lv[i];
				var tmp;
				if(cur.zpp_inner.weak) {
					var inner = cur.zpp_inner;
					cur.zpp_inner.outer = null;
					cur.zpp_inner = null;
					var o = cur;
					o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
					var o1 = inner;
					if(o1.outer != null) {
						o1.outer.zpp_inner = null;
						o1.outer = null;
					}
					o1._isimmutable = null;
					o1._validate = null;
					o1._invalidate = null;
					o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
					tmp = true;
				} else {
					tmp = false;
				}
				if(tmp) {
					lv.splice(i,1);
					continue;
				}
				++i;
			}
		} else if(((vertices) instanceof nape_geom_Vec2List)) {
			var lv = vertices;
			if(lv.zpp_inner._validate != null) {
				lv.zpp_inner._validate();
			}
			var ins = lv.zpp_inner.inner;
			var pre = null;
			var cur = ins.head;
			while(cur != null) {
				var x = cur.elt;
				if(x.outer.zpp_inner.weak) {
					cur = ins.erase(pre);
					if(x.outer.zpp_inner.weak) {
						var _this = x.outer;
						var inner = _this.zpp_inner;
						_this.zpp_inner.outer = null;
						_this.zpp_inner = null;
						var o = _this;
						o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
						var o1 = inner;
						if(o1.outer != null) {
							o1.outer.zpp_inner = null;
							o1.outer = null;
						}
						o1._isimmutable = null;
						o1._validate = null;
						o1._invalidate = null;
						o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
					}
				} else {
					pre = cur;
					cur = cur.next;
				}
			}
		}
	}
};
nape_geom_GeomPoly.__name__ = true;
nape_geom_GeomPoly.get = function(vertices) {
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolGeomPoly == null) {
		ret = new nape_geom_GeomPoly();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolGeomPoly;
		zpp_$nape_util_ZPP_$PubPool.poolGeomPoly = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(vertices != null) {
		if(((vertices) instanceof Array)) {
			var lv = vertices;
			var _g = 0;
			while(_g < lv.length) {
				var vite = lv[_g];
				++_g;
				var v = vite;
				var _this = v.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var x = v.zpp_inner.x;
				var _this1 = v.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				var y = v.zpp_inner.y;
				var ret1;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.forced = false;
				ret1.x = x;
				ret1.y = y;
				var obj = ret1;
				if(ret.zpp_inner.vertices == null) {
					ret.zpp_inner.vertices = obj.prev = obj.next = obj;
				} else {
					obj.prev = ret.zpp_inner.vertices;
					obj.next = ret.zpp_inner.vertices.next;
					ret.zpp_inner.vertices.next.prev = obj;
					ret.zpp_inner.vertices.next = obj;
				}
				ret.zpp_inner.vertices = obj;
			}
		} else if(((vertices) instanceof nape_geom_Vec2List)) {
			var lv = vertices;
			var _g = lv.iterator();
			while(true) {
				_g.zpp_inner.zpp_inner.valmod();
				var length = _g.zpp_inner.zpp_gl();
				_g.zpp_critical = true;
				var tmp;
				if(_g.zpp_i < length) {
					tmp = true;
				} else {
					_g.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
					nape_geom_Vec2Iterator.zpp_pool = _g;
					_g.zpp_inner = null;
					tmp = false;
				}
				if(!tmp) {
					break;
				}
				_g.zpp_critical = false;
				var v = _g.zpp_inner.at(_g.zpp_i++);
				var _this = v.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var x = v.zpp_inner.x;
				var _this1 = v.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				var y = v.zpp_inner.y;
				var ret1;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.forced = false;
				ret1.x = x;
				ret1.y = y;
				var obj = ret1;
				if(ret.zpp_inner.vertices == null) {
					ret.zpp_inner.vertices = obj.prev = obj.next = obj;
				} else {
					obj.prev = ret.zpp_inner.vertices;
					obj.next = ret.zpp_inner.vertices.next;
					ret.zpp_inner.vertices.next.prev = obj;
					ret.zpp_inner.vertices.next = obj;
				}
				ret.zpp_inner.vertices = obj;
			}
		} else if(((vertices) instanceof nape_geom_GeomPoly)) {
			var lv = vertices;
			var verts = lv.zpp_inner.vertices;
			if(verts != null) {
				var vite = verts;
				do {
					var x = vite.x;
					var y = vite.y;
					if(y == null) {
						y = 0;
					}
					if(x == null) {
						x = 0;
					}
					var ret1;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret1 = new nape_geom_Vec2();
					} else {
						ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
						ret1.zpp_pool = null;
					}
					if(ret1.zpp_inner == null) {
						var ret2;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret2 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
							ret2.next = null;
						}
						ret2.weak = false;
						ret2._immutable = false;
						ret2.x = x;
						ret2.y = y;
						ret1.zpp_inner = ret2;
						ret1.zpp_inner.outer = ret1;
					} else {
						var tmp;
						var _this = ret1.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						if(ret1.zpp_inner.x == x) {
							var _this1 = ret1.zpp_inner;
							if(_this1._validate != null) {
								_this1._validate();
							}
							tmp = ret1.zpp_inner.y == y;
						} else {
							tmp = false;
						}
						if(!tmp) {
							ret1.zpp_inner.x = x;
							ret1.zpp_inner.y = y;
							var _this2 = ret1.zpp_inner;
							if(_this2._invalidate != null) {
								_this2._invalidate(_this2);
							}
						}
					}
					ret1.zpp_inner.weak = false;
					var v = ret1;
					vite = vite.next;
					var _this3 = v.zpp_inner;
					if(_this3._validate != null) {
						_this3._validate();
					}
					var x1 = v.zpp_inner.x;
					var _this4 = v.zpp_inner;
					if(_this4._validate != null) {
						_this4._validate();
					}
					var y1 = v.zpp_inner.y;
					var ret3;
					if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
						ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
					} else {
						ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
						ret3.next = null;
					}
					ret3.forced = false;
					ret3.x = x1;
					ret3.y = y1;
					var obj = ret3;
					if(ret.zpp_inner.vertices == null) {
						ret.zpp_inner.vertices = obj.prev = obj.next = obj;
					} else {
						obj.prev = ret.zpp_inner.vertices;
						obj.next = ret.zpp_inner.vertices.next;
						ret.zpp_inner.vertices.next.prev = obj;
						ret.zpp_inner.vertices.next = obj;
					}
					ret.zpp_inner.vertices = obj;
					var inner = v.zpp_inner;
					v.zpp_inner.outer = null;
					v.zpp_inner = null;
					var o = v;
					o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
					var o1 = inner;
					if(o1.outer != null) {
						o1.outer.zpp_inner = null;
						o1.outer = null;
					}
					o1._isimmutable = null;
					o1._validate = null;
					o1._invalidate = null;
					o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
				} while(vite != verts);
			}
		}
		ret.skipForward(1);
		if(((vertices) instanceof Array)) {
			var lv = vertices;
			var i = 0;
			while(i < lv.length) {
				var cur = lv[i];
				var tmp;
				if(cur.zpp_inner.weak) {
					var inner = cur.zpp_inner;
					cur.zpp_inner.outer = null;
					cur.zpp_inner = null;
					var o = cur;
					o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
					var o1 = inner;
					if(o1.outer != null) {
						o1.outer.zpp_inner = null;
						o1.outer = null;
					}
					o1._isimmutable = null;
					o1._validate = null;
					o1._invalidate = null;
					o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
					tmp = true;
				} else {
					tmp = false;
				}
				if(tmp) {
					lv.splice(i,1);
					continue;
				}
				++i;
			}
		} else if(((vertices) instanceof nape_geom_Vec2List)) {
			var lv = vertices;
			if(lv.zpp_inner._validate != null) {
				lv.zpp_inner._validate();
			}
			var ins = lv.zpp_inner.inner;
			var pre = null;
			var cur = ins.head;
			while(cur != null) {
				var x = cur.elt;
				if(x.outer.zpp_inner.weak) {
					cur = ins.erase(pre);
					if(x.outer.zpp_inner.weak) {
						var _this = x.outer;
						var inner = _this.zpp_inner;
						_this.zpp_inner.outer = null;
						_this.zpp_inner = null;
						var o = _this;
						o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
						var o1 = inner;
						if(o1.outer != null) {
							o1.outer.zpp_inner = null;
							o1.outer = null;
						}
						o1._isimmutable = null;
						o1._validate = null;
						o1._invalidate = null;
						o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
					}
				} else {
					pre = cur;
					cur = cur.next;
				}
			}
		}
	}
	return ret;
};
nape_geom_GeomPoly.prototype = {
	empty: function() {
		return this.zpp_inner.vertices == null;
	}
	,size: function() {
		var ret = 0;
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var i = nite;
				++ret;
				nite = nite.next;
			} while(nite != L);
		}
		return ret;
	}
	,iterator: function() {
		return zpp_$nape_geom_ZPP_$GeomVertexIterator.get(this.zpp_inner.vertices,true);
	}
	,forwardIterator: function() {
		return zpp_$nape_geom_ZPP_$GeomVertexIterator.get(this.zpp_inner.vertices,true);
	}
	,backwardsIterator: function() {
		return zpp_$nape_geom_ZPP_$GeomVertexIterator.get(this.zpp_inner.vertices,false);
	}
	,current: function() {
		var _this = this.zpp_inner.vertices;
		if(_this.wrap == null) {
			var x = _this.x;
			var y = _this.y;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this1 = ret.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this1 = ret.zpp_inner;
					if(_this1._validate != null) {
						_this1._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this1 = ret.zpp_inner;
					if(_this1._invalidate != null) {
						_this1._invalidate(_this1);
					}
				}
			}
			ret.zpp_inner.weak = false;
			_this.wrap = ret;
			_this.wrap.zpp_inner._inuse = true;
			_this.wrap.zpp_inner._invalidate = $bind(_this,_this.modwrap);
			_this.wrap.zpp_inner._validate = $bind(_this,_this.getwrap);
		}
		return _this.wrap;
	}
	,push: function(vertex) {
		var _this = vertex.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = vertex.zpp_inner.x;
		var _this = vertex.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = vertex.zpp_inner.y;
		var ret;
		if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$GeomVert();
		} else {
			ret = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.forced = false;
		ret.x = x;
		ret.y = y;
		var obj = ret;
		if(this.zpp_inner.vertices == null) {
			this.zpp_inner.vertices = obj.prev = obj.next = obj;
		} else {
			obj.prev = this.zpp_inner.vertices;
			obj.next = this.zpp_inner.vertices.next;
			this.zpp_inner.vertices.next.prev = obj;
			this.zpp_inner.vertices.next = obj;
		}
		this.zpp_inner.vertices = obj;
		if(vertex.zpp_inner.weak) {
			var inner = vertex.zpp_inner;
			vertex.zpp_inner.outer = null;
			vertex.zpp_inner = null;
			var o = vertex;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,pop: function() {
		var retv = this.zpp_inner.vertices;
		var tmp;
		if(this.zpp_inner.vertices != null && this.zpp_inner.vertices.prev == this.zpp_inner.vertices) {
			this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
			tmp = null;
		} else {
			var retnodes = this.zpp_inner.vertices.prev;
			this.zpp_inner.vertices.prev.next = this.zpp_inner.vertices.next;
			this.zpp_inner.vertices.next.prev = this.zpp_inner.vertices.prev;
			this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
			this.zpp_inner.vertices = null;
			tmp = retnodes;
		}
		this.zpp_inner.vertices = tmp;
		var o = retv;
		if(o.wrap != null) {
			o.wrap.zpp_inner._inuse = false;
			var _this = o.wrap;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o1 = _this;
			o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			o.wrap = null;
		}
		o.prev = o.next = null;
		o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		return this;
	}
	,unshift: function(vertex) {
		var _this = vertex.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = vertex.zpp_inner.x;
		var _this = vertex.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = vertex.zpp_inner.y;
		var ret;
		if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$GeomVert();
		} else {
			ret = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.forced = false;
		ret.x = x;
		ret.y = y;
		var obj = ret;
		if(this.zpp_inner.vertices == null) {
			this.zpp_inner.vertices = obj.prev = obj.next = obj;
		} else {
			obj.next = this.zpp_inner.vertices;
			obj.prev = this.zpp_inner.vertices.prev;
			this.zpp_inner.vertices.prev.next = obj;
			this.zpp_inner.vertices.prev = obj;
		}
		this.zpp_inner.vertices = obj;
		if(vertex.zpp_inner.weak) {
			var inner = vertex.zpp_inner;
			vertex.zpp_inner.outer = null;
			vertex.zpp_inner = null;
			var o = vertex;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,shift: function() {
		var retv = this.zpp_inner.vertices;
		var tmp;
		if(this.zpp_inner.vertices != null && this.zpp_inner.vertices.prev == this.zpp_inner.vertices) {
			this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
			tmp = this.zpp_inner.vertices = null;
		} else {
			var retnodes = this.zpp_inner.vertices.next;
			this.zpp_inner.vertices.prev.next = this.zpp_inner.vertices.next;
			this.zpp_inner.vertices.next.prev = this.zpp_inner.vertices.prev;
			this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
			this.zpp_inner.vertices = null;
			tmp = retnodes;
		}
		this.zpp_inner.vertices = tmp;
		var o = retv;
		if(o.wrap != null) {
			o.wrap.zpp_inner._inuse = false;
			var _this = o.wrap;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o1 = _this;
			o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			o.wrap = null;
		}
		o.prev = o.next = null;
		o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		return this;
	}
	,skipForward: function(times) {
		if(this.zpp_inner.vertices != null) {
			if(times > 0) {
				while(times-- > 0) this.zpp_inner.vertices = this.zpp_inner.vertices.next;
			} else if(times < 0) {
				while(times++ < 0) this.zpp_inner.vertices = this.zpp_inner.vertices.prev;
			}
		}
		return this;
	}
	,skipBackwards: function(times) {
		return this.skipForward(-times);
	}
	,erase: function(count) {
		while(count != 0 && this.zpp_inner.vertices != null) {
			var retv = this.zpp_inner.vertices;
			if(count > 0) {
				var tmp;
				if(this.zpp_inner.vertices != null && this.zpp_inner.vertices.prev == this.zpp_inner.vertices) {
					this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
					tmp = this.zpp_inner.vertices = null;
				} else {
					var retnodes = this.zpp_inner.vertices.next;
					this.zpp_inner.vertices.prev.next = this.zpp_inner.vertices.next;
					this.zpp_inner.vertices.next.prev = this.zpp_inner.vertices.prev;
					this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
					this.zpp_inner.vertices = null;
					tmp = retnodes;
				}
				this.zpp_inner.vertices = tmp;
				--count;
			} else if(count < 0) {
				var tmp1;
				if(this.zpp_inner.vertices != null && this.zpp_inner.vertices.prev == this.zpp_inner.vertices) {
					this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
					tmp1 = null;
				} else {
					var retnodes1 = this.zpp_inner.vertices.prev;
					this.zpp_inner.vertices.prev.next = this.zpp_inner.vertices.next;
					this.zpp_inner.vertices.next.prev = this.zpp_inner.vertices.prev;
					this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
					this.zpp_inner.vertices = null;
					tmp1 = retnodes1;
				}
				this.zpp_inner.vertices = tmp1;
				++count;
			}
			var o = retv;
			if(o.wrap != null) {
				o.wrap.zpp_inner._inuse = false;
				var _this = o.wrap;
				var inner = _this.zpp_inner;
				_this.zpp_inner.outer = null;
				_this.zpp_inner = null;
				var o1 = _this;
				o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
				var o2 = inner;
				if(o2.outer != null) {
					o2.outer.zpp_inner = null;
					o2.outer = null;
				}
				o2._isimmutable = null;
				o2._validate = null;
				o2._invalidate = null;
				o2.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o2;
				o.wrap = null;
			}
			o.prev = o.next = null;
			o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		}
		return this;
	}
	,clear: function() {
		while(this.zpp_inner.vertices != null) {
			var tmp = this.zpp_inner.vertices;
			var tmp1;
			if(this.zpp_inner.vertices != null && this.zpp_inner.vertices.prev == this.zpp_inner.vertices) {
				this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
				tmp1 = this.zpp_inner.vertices = null;
			} else {
				var retnodes = this.zpp_inner.vertices.next;
				this.zpp_inner.vertices.prev.next = this.zpp_inner.vertices.next;
				this.zpp_inner.vertices.next.prev = this.zpp_inner.vertices.prev;
				this.zpp_inner.vertices.next = this.zpp_inner.vertices.prev = null;
				this.zpp_inner.vertices = null;
				tmp1 = retnodes;
			}
			this.zpp_inner.vertices = tmp1;
			var o = tmp;
			if(o.wrap != null) {
				o.wrap.zpp_inner._inuse = false;
				var _this = o.wrap;
				var inner = _this.zpp_inner;
				_this.zpp_inner.outer = null;
				_this.zpp_inner = null;
				var o1 = _this;
				o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
				var o2 = inner;
				if(o2.outer != null) {
					o2.outer.zpp_inner = null;
					o2.outer = null;
				}
				o2._isimmutable = null;
				o2._validate = null;
				o2._invalidate = null;
				o2.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o2;
				o.wrap = null;
			}
			o.prev = o.next = null;
			o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		}
		return this;
	}
	,copy: function() {
		var ret = nape_geom_GeomPoly.get();
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				var x = v.x;
				var y = v.y;
				var ret1;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.forced = false;
				ret1.x = x;
				ret1.y = y;
				var obj = ret1;
				if(ret.zpp_inner.vertices == null) {
					ret.zpp_inner.vertices = obj.prev = obj.next = obj;
				} else {
					obj.prev = ret.zpp_inner.vertices;
					obj.next = ret.zpp_inner.vertices.next;
					ret.zpp_inner.vertices.next.prev = obj;
					ret.zpp_inner.vertices.next = obj;
				}
				ret.zpp_inner.vertices = obj;
				nite = nite.next;
			} while(nite != L);
		}
		return ret.skipForward(1);
	}
	,dispose: function() {
		this.clear();
		var o = this;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolGeomPoly;
		zpp_$nape_util_ZPP_$PubPool.poolGeomPoly = o;
	}
	,toString: function() {
		var ret = "GeomPoly[";
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				if(v != this.zpp_inner.vertices) {
					ret += ",";
				}
				ret += "{" + v.x + "," + v.y + "}";
				nite = nite.next;
			} while(nite != L);
		}
		return ret + "]";
	}
	,area: function() {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			return 0.0;
		} else {
			var area = 0.0;
			var F = this.zpp_inner.vertices;
			var L = this.zpp_inner.vertices;
			if(F != null) {
				var nite = F;
				do {
					var v = nite;
					area += v.x * (v.next.y - v.prev.y);
					nite = nite.next;
				} while(nite != L);
			}
			var ret = area * 0.5;
			if(ret < 0) {
				return -ret;
			} else {
				return ret;
			}
		}
	}
	,winding: function() {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			if(zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED = new nape_geom_Winding();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED;
		} else {
			var area = 0.0;
			var F = this.zpp_inner.vertices;
			var L = this.zpp_inner.vertices;
			if(F != null) {
				var nite = F;
				do {
					var v = nite;
					area += v.x * (v.next.y - v.prev.y);
					nite = nite.next;
				} while(nite != L);
			}
			var area1 = area * 0.5;
			if(area1 > 0) {
				if(zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE = new nape_geom_Winding();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				return zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE;
			} else if(area1 == 0) {
				if(zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED = new nape_geom_Winding();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				return zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE = new nape_geom_Winding();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				return zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE;
			}
		}
	}
	,contains: function(point) {
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = point.zpp_inner.x;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = point.zpp_inner.y;
		var ret = false;
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var p = nite;
				var q = p.prev;
				if((p.y < y && q.y >= y || q.y < y && p.y >= y) && (p.x <= x || q.x <= x)) {
					if(p.x + (y - p.y) / (q.y - p.y) * (q.x - p.x) < x) {
						ret = !ret;
					}
				}
				nite = nite.next;
			} while(nite != L);
		}
		var ret1 = ret;
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret1;
	}
	,isClockwise: function() {
		var tmp = this.winding();
		if(zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE = new nape_geom_Winding();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return tmp == zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE;
	}
	,isConvex: function() {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			return true;
		} else {
			var neg = false;
			var pos = false;
			var ret = true;
			var F = this.zpp_inner.vertices;
			var L = this.zpp_inner.vertices;
			if(F != null) {
				var nite = F;
				do {
					var v = nite;
					var u = v.prev;
					var w = v.next;
					var ax = 0.0;
					var ay = 0.0;
					ax = w.x - v.x;
					ay = w.y - v.y;
					var bx = 0.0;
					var by = 0.0;
					bx = v.x - u.x;
					by = v.y - u.y;
					var dot = by * ax - bx * ay;
					if(dot > 0.0) {
						pos = true;
					} else if(dot < 0.0) {
						neg = true;
					}
					if(pos && neg) {
						ret = false;
						break;
					}
					nite = nite.next;
				} while(nite != L);
			}
			return ret;
		}
	}
	,isSimple: function() {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			return true;
		} else {
			return zpp_$nape_geom_ZPP_$Simple.isSimple(this.zpp_inner.vertices);
		}
	}
	,isMonotone: function() {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			return true;
		} else {
			return zpp_$nape_geom_ZPP_$Monotone.isMonotone(this.zpp_inner.vertices);
		}
	}
	,isDegenerate: function() {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			return true;
		} else {
			return this.area() < nape_Config.epsilon;
		}
	}
	,simplify: function(epsilon) {
		if(this.zpp_inner.vertices == null || this.zpp_inner.vertices.next == null || this.zpp_inner.vertices.prev == this.zpp_inner.vertices.next) {
			return this.copy();
		} else {
			var x = zpp_$nape_geom_ZPP_$Simplify.simplify(this.zpp_inner.vertices,epsilon);
			var ret = nape_geom_GeomPoly.get();
			ret.zpp_inner.vertices = x;
			return ret;
		}
	}
	,simpleDecomposition: function(output) {
		var MPs = this.zpp_inner.vertices;
		if(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList == null) {
			zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList = new zpp_$nape_util_ZNPList_$ZPP_$GeomVert();
		}
		var MPs1 = zpp_$nape_geom_ZPP_$Simple.decompose(MPs,zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList);
		var ret = output == null ? new nape_geom_GeomPolyList() : output;
		while(MPs1.head != null) {
			var MP = MPs1.pop_unsafe();
			var x = nape_geom_GeomPoly.get();
			x.zpp_inner.vertices = MP;
			if(ret.zpp_inner.reverse_flag) {
				ret.push(x);
			} else {
				ret.unshift(x);
			}
		}
		return ret;
	}
	,monotoneDecomposition: function(output) {
		var poly = this.zpp_inner.vertices;
		if(zpp_$nape_geom_ZPP_$Monotone.sharedPPoly == null) {
			zpp_$nape_geom_ZPP_$Monotone.sharedPPoly = new zpp_$nape_geom_ZPP_$PartitionedPoly();
		}
		var poly1 = zpp_$nape_geom_ZPP_$Monotone.decompose(poly,zpp_$nape_geom_ZPP_$Monotone.sharedPPoly);
		if(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList == null) {
			zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList = new zpp_$nape_util_ZNPList_$ZPP_$GeomVert();
		}
		var MPs = poly1.extract(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList);
		var ret = output == null ? new nape_geom_GeomPolyList() : output;
		while(MPs.head != null) {
			var MP = MPs.pop_unsafe();
			var x = nape_geom_GeomPoly.get();
			x.zpp_inner.vertices = MP;
			if(ret.zpp_inner.reverse_flag) {
				ret.push(x);
			} else {
				ret.unshift(x);
			}
		}
		return ret;
	}
	,convexDecomposition: function(delaunay,output) {
		if(delaunay == null) {
			delaunay = false;
		}
		var poly = this.zpp_inner.vertices;
		if(zpp_$nape_geom_ZPP_$Monotone.sharedPPoly == null) {
			zpp_$nape_geom_ZPP_$Monotone.sharedPPoly = new zpp_$nape_geom_ZPP_$PartitionedPoly();
		}
		var poly1 = zpp_$nape_geom_ZPP_$Monotone.decompose(poly,zpp_$nape_geom_ZPP_$Monotone.sharedPPoly);
		if(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedPPList == null) {
			zpp_$nape_geom_ZPP_$PartitionedPoly.sharedPPList = new zpp_$nape_util_ZNPList_$ZPP_$PartitionedPoly();
		}
		var MPs = poly1.extract_partitions(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedPPList);
		var ret = output == null ? new nape_geom_GeomPolyList() : output;
		while(MPs.head != null) {
			var MP = MPs.pop_unsafe();
			zpp_$nape_geom_ZPP_$Triangular.triangulate(MP);
			if(delaunay) {
				zpp_$nape_geom_ZPP_$Triangular.optimise(MP);
			}
			zpp_$nape_geom_ZPP_$Convex.optimise(MP);
			if(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList == null) {
				zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList = new zpp_$nape_util_ZNPList_$ZPP_$GeomVert();
			}
			var MQs = MP.extract(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList);
			var o = MP;
			o.next = zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool;
			zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool = o;
			while(MQs.head != null) {
				var MQ = MQs.pop_unsafe();
				var x = nape_geom_GeomPoly.get();
				x.zpp_inner.vertices = MQ;
				if(ret.zpp_inner.reverse_flag) {
					ret.push(x);
				} else {
					ret.unshift(x);
				}
			}
		}
		return ret;
	}
	,triangularDecomposition: function(delaunay,output) {
		if(delaunay == null) {
			delaunay = false;
		}
		var poly = this.zpp_inner.vertices;
		if(zpp_$nape_geom_ZPP_$Monotone.sharedPPoly == null) {
			zpp_$nape_geom_ZPP_$Monotone.sharedPPoly = new zpp_$nape_geom_ZPP_$PartitionedPoly();
		}
		var poly1 = zpp_$nape_geom_ZPP_$Monotone.decompose(poly,zpp_$nape_geom_ZPP_$Monotone.sharedPPoly);
		if(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedPPList == null) {
			zpp_$nape_geom_ZPP_$PartitionedPoly.sharedPPList = new zpp_$nape_util_ZNPList_$ZPP_$PartitionedPoly();
		}
		var MPs = poly1.extract_partitions(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedPPList);
		var ret = output == null ? new nape_geom_GeomPolyList() : output;
		while(MPs.head != null) {
			var MP = MPs.pop_unsafe();
			zpp_$nape_geom_ZPP_$Triangular.triangulate(MP);
			if(delaunay) {
				zpp_$nape_geom_ZPP_$Triangular.optimise(MP);
			}
			if(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList == null) {
				zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList = new zpp_$nape_util_ZNPList_$ZPP_$GeomVert();
			}
			var MQs = MP.extract(zpp_$nape_geom_ZPP_$PartitionedPoly.sharedGVList);
			var o = MP;
			o.next = zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool;
			zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool = o;
			while(MQs.head != null) {
				var MQ = MQs.pop_unsafe();
				var x = nape_geom_GeomPoly.get();
				x.zpp_inner.vertices = MQ;
				if(ret.zpp_inner.reverse_flag) {
					ret.push(x);
				} else {
					ret.unshift(x);
				}
			}
		}
		return ret;
	}
	,inflate: function(inflation) {
		var ret = nape_geom_GeomPoly.get();
		var tmp = this.winding();
		if(zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE = new nape_geom_Winding();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(tmp == zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE) {
			inflation = -inflation;
		}
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var p = nite;
				var prev = p.prev;
				var next = p.next;
				var ax = 0.0;
				var ay = 0.0;
				var bx = 0.0;
				var by = 0.0;
				ax = p.x - prev.x;
				ay = p.y - prev.y;
				bx = next.x - p.x;
				by = next.y - p.y;
				var apx = 0.0;
				var apy = 0.0;
				var bpx = 0.0;
				var bpy = 0.0;
				apx = ax;
				apy = ay;
				var d = apx * apx + apy * apy;
				zpp_$nape_util_ZPP_$Math.fbuf[0] = d;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var imag = x2 * (1.5 - 0.5 * d * x2 * x2);
				var t = imag;
				apx *= t;
				apy *= t;
				var t1 = apx;
				apx = -apy;
				apy = t1;
				var t2 = inflation;
				apx *= t2;
				apy *= t2;
				bpx = bx;
				bpy = by;
				var d1 = bpx * bpx + bpy * bpy;
				zpp_$nape_util_ZPP_$Math.fbuf[0] = d1;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x21 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var imag1 = x21 * (1.5 - 0.5 * d1 * x21 * x21);
				var t3 = imag1;
				bpx *= t3;
				bpy *= t3;
				var t4 = bpx;
				bpx = -bpy;
				bpy = t4;
				var t5 = inflation;
				bpx *= t5;
				bpy *= t5;
				var bapx = 0.0;
				var bapy = 0.0;
				bapx = bpx - apx;
				bapy = bpy - apy;
				var num = by * bapx - bx * bapy;
				var t6 = num == 0 ? 0 : num / (by * ax - bx * ay);
				var px = 0.0;
				var py = 0.0;
				px = p.x + apx;
				py = p.y + apy;
				var t7 = t6;
				px += ax * t7;
				py += ay * t7;
				var x = px;
				var y = py;
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret1;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret1 = new nape_geom_Vec2();
				} else {
					ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
					ret1.zpp_pool = null;
				}
				if(ret1.zpp_inner == null) {
					var ret2;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret2 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
						ret2.next = null;
					}
					ret2.weak = false;
					ret2._immutable = false;
					ret2.x = x;
					ret2.y = y;
					ret1.zpp_inner = ret2;
					ret1.zpp_inner.outer = ret1;
				} else {
					var tmp;
					var _this = ret1.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					if(ret1.zpp_inner.x == x) {
						var _this1 = ret1.zpp_inner;
						if(_this1._validate != null) {
							_this1._validate();
						}
						tmp = ret1.zpp_inner.y == y;
					} else {
						tmp = false;
					}
					if(!tmp) {
						ret1.zpp_inner.x = x;
						ret1.zpp_inner.y = y;
						var _this2 = ret1.zpp_inner;
						if(_this2._invalidate != null) {
							_this2._invalidate(_this2);
						}
					}
				}
				ret1.zpp_inner.weak = false;
				ret.push(ret1);
				nite = nite.next;
			} while(nite != L);
		}
		return ret.skipForward(1);
	}
	,cut: function(start,end,boundedStart,boundedEnd,output) {
		if(boundedEnd == null) {
			boundedEnd = false;
		}
		if(boundedStart == null) {
			boundedStart = false;
		}
		var ret = zpp_$nape_geom_ZPP_$Cutter.run(this.zpp_inner.vertices,start,end,boundedStart,boundedEnd,output);
		if(start.zpp_inner.weak) {
			var inner = start.zpp_inner;
			start.zpp_inner.outer = null;
			start.zpp_inner = null;
			var o = start;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(end.zpp_inner.weak) {
			var inner = end.zpp_inner;
			end.zpp_inner.outer = null;
			end.zpp_inner = null;
			var o = end;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,transform: function(matrix) {
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				var t = matrix.zpp_inner.a * v.x + matrix.zpp_inner.b * v.y + matrix.zpp_inner.tx;
				v.y = matrix.zpp_inner.c * v.x + matrix.zpp_inner.d * v.y + matrix.zpp_inner.ty;
				v.x = t;
				nite = nite.next;
			} while(nite != L);
		}
		return this;
	}
	,bounds: function() {
		var minx = 1e100;
		var miny = 1e100;
		var maxx = -1e+100;
		var maxy = -1e+100;
		var F = this.zpp_inner.vertices;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				if(v.x < minx) {
					minx = v.x;
				}
				if(v.y < miny) {
					miny = v.y;
				}
				if(v.x > maxx) {
					maxx = v.x;
				}
				if(v.y > maxy) {
					maxy = v.y;
				}
				nite = nite.next;
			} while(nite != L);
		}
		return new nape_geom_AABB(minx,miny,maxx - minx,maxy - miny);
	}
	,top: function() {
		var min = this.zpp_inner.vertices;
		var F = this.zpp_inner.vertices.next;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				if(v.y < min.y) {
					min = v;
				}
				nite = nite.next;
			} while(nite != L);
		}
		if(min.wrap == null) {
			var x = min.x;
			var y = min.y;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			min.wrap = ret;
			min.wrap.zpp_inner._inuse = true;
			min.wrap.zpp_inner._invalidate = $bind(min,min.modwrap);
			min.wrap.zpp_inner._validate = $bind(min,min.getwrap);
		}
		return min.wrap;
	}
	,bottom: function() {
		var max = this.zpp_inner.vertices;
		var F = this.zpp_inner.vertices.next;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				if(v.y > max.y) {
					max = v;
				}
				nite = nite.next;
			} while(nite != L);
		}
		if(max.wrap == null) {
			var x = max.x;
			var y = max.y;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			max.wrap = ret;
			max.wrap.zpp_inner._inuse = true;
			max.wrap.zpp_inner._invalidate = $bind(max,max.modwrap);
			max.wrap.zpp_inner._validate = $bind(max,max.getwrap);
		}
		return max.wrap;
	}
	,left: function() {
		var min = this.zpp_inner.vertices;
		var F = this.zpp_inner.vertices.next;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				if(v.x < min.x) {
					min = v;
				}
				nite = nite.next;
			} while(nite != L);
		}
		if(min.wrap == null) {
			var x = min.x;
			var y = min.y;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			min.wrap = ret;
			min.wrap.zpp_inner._inuse = true;
			min.wrap.zpp_inner._invalidate = $bind(min,min.modwrap);
			min.wrap.zpp_inner._validate = $bind(min,min.getwrap);
		}
		return min.wrap;
	}
	,right: function() {
		var max = this.zpp_inner.vertices;
		var F = this.zpp_inner.vertices.next;
		var L = this.zpp_inner.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				if(v.x > max.x) {
					max = v;
				}
				nite = nite.next;
			} while(nite != L);
		}
		if(max.wrap == null) {
			var x = max.x;
			var y = max.y;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			max.wrap = ret;
			max.wrap.zpp_inner._inuse = true;
			max.wrap.zpp_inner._invalidate = $bind(max,max.modwrap);
			max.wrap.zpp_inner._validate = $bind(max,max.getwrap);
		}
		return max.wrap;
	}
};
var nape_geom_GeomPolyIterator = $hx_exports["nape"]["geom"]["GeomPolyIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_geom_GeomPolyIterator.__name__ = true;
nape_geom_GeomPolyIterator.get = function(list) {
	var ret;
	if(nape_geom_GeomPolyIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$GeomPolyList.internal = true;
		var ret1 = new nape_geom_GeomPolyIterator();
		zpp_$nape_util_ZPP_$GeomPolyList.internal = false;
		ret = ret1;
	} else {
		var r = nape_geom_GeomPolyIterator.zpp_pool;
		nape_geom_GeomPolyIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_geom_GeomPolyIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_geom_GeomPolyIterator.zpp_pool;
			nape_geom_GeomPolyIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_geom_GeomPolyList = $hx_exports["nape"]["geom"]["GeomPolyList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$GeomPolyList();
	this.zpp_inner.outer = this;
};
nape_geom_GeomPolyList.__name__ = true;
nape_geom_GeomPolyList.fromArray = function(array) {
	var ret = new nape_geom_GeomPolyList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_geom_GeomPolyList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_geom_GeomPolyIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_geom_GeomPolyList();
		this.zpp_inner.valmod();
		var _g = nape_geom_GeomPolyIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_GeomPolyIterator.zpp_pool;
				nape_geom_GeomPolyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_geom_GeomPolyIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_GeomPolyIterator.zpp_pool;
				nape_geom_GeomPolyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_geom_GeomPolyIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_GeomPolyIterator.zpp_pool;
				nape_geom_GeomPolyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_geom_GeomPolyIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_geom_GeomPolyIterator.zpp_pool;
				nape_geom_GeomPolyIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_geom_GeomPolyIterator.zpp_pool;
				nape_geom_GeomPolyIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_geom_GeomVertexIterator = $hx_exports["nape"]["geom"]["GeomVertexIterator"] = function() {
};
nape_geom_GeomVertexIterator.__name__ = true;
nape_geom_GeomVertexIterator.prototype = {
	hasNext: function() {
		var ret = this.zpp_inner.ptr != this.zpp_inner.start || this.zpp_inner.first;
		this.zpp_inner.first = false;
		if(!ret) {
			var o = this.zpp_inner;
			o.outer.zpp_inner = null;
			o.ptr = o.start = null;
			o.next = zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool = o;
		}
		return ret;
	}
	,next: function() {
		var _this = this.zpp_inner.ptr;
		if(_this.wrap == null) {
			var x = _this.x;
			var y = _this.y;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this1 = ret.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this1 = ret.zpp_inner;
					if(_this1._validate != null) {
						_this1._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this1 = ret.zpp_inner;
					if(_this1._invalidate != null) {
						_this1._invalidate(_this1);
					}
				}
			}
			ret.zpp_inner.weak = false;
			_this.wrap = ret;
			_this.wrap.zpp_inner._inuse = true;
			_this.wrap.zpp_inner._invalidate = $bind(_this,_this.modwrap);
			_this.wrap.zpp_inner._validate = $bind(_this,_this.getwrap);
		}
		var ret = _this.wrap;
		this.zpp_inner.ptr = this.zpp_inner.forward ? this.zpp_inner.ptr.next : this.zpp_inner.ptr.prev;
		return ret;
	}
};
var nape_geom_MarchingSquares = $hx_exports["nape"]["geom"]["MarchingSquares"] = function() { };
nape_geom_MarchingSquares.__name__ = true;
nape_geom_MarchingSquares.run = function(iso,bounds,cellsize,quality,subgrid,combine,output) {
	if(combine == null) {
		combine = true;
	}
	if(quality == null) {
		quality = 2;
	}
	var ret = output != null ? output : new nape_geom_GeomPolyList();
	if(subgrid == null) {
		var _this = bounds.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = bounds.zpp_inner.minx;
		var _this = bounds.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = bounds.zpp_inner.miny;
		var _this = bounds.zpp_inner.getmax();
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var tmp2 = _this.zpp_inner.x;
		var _this = bounds.zpp_inner.getmax();
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		zpp_$nape_geom_ZPP_$MarchingSquares.run(iso,tmp,tmp1,tmp2,_this.zpp_inner.y,cellsize,quality,combine,ret);
	} else {
		var _this = bounds.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = bounds.zpp_inner;
		var xp = _this.maxx - _this.minx;
		var _this = subgrid.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var xp1 = xp / subgrid.zpp_inner.x;
		var _this = bounds.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = bounds.zpp_inner;
		var yp = _this.maxy - _this.miny;
		var _this = subgrid.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var yp1 = yp / subgrid.zpp_inner.y;
		var xn = xp1 | 0;
		var yn = yp1 | 0;
		if(xn != xp1) {
			++xn;
		}
		if(yn != yp1) {
			++yn;
		}
		var _g = 0;
		var _g1 = xn;
		while(_g < _g1) {
			var x = _g++;
			var _this = bounds.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x0 = bounds.zpp_inner.minx;
			var _this1 = subgrid.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var x01 = x0 + subgrid.zpp_inner.x * x;
			var x1;
			if(x == xn - 1) {
				var _this2 = bounds.zpp_inner.getmax();
				var _this3 = _this2.zpp_inner;
				if(_this3._validate != null) {
					_this3._validate();
				}
				x1 = _this2.zpp_inner.x;
			} else {
				var _this4 = subgrid.zpp_inner;
				if(_this4._validate != null) {
					_this4._validate();
				}
				x1 = x01 + subgrid.zpp_inner.x;
			}
			var _g2 = 0;
			var _g3 = yn;
			while(_g2 < _g3) {
				var y = _g2++;
				var _this5 = bounds.zpp_inner;
				if(_this5._validate != null) {
					_this5._validate();
				}
				var y0 = bounds.zpp_inner.miny;
				var _this6 = subgrid.zpp_inner;
				if(_this6._validate != null) {
					_this6._validate();
				}
				var y01 = y0 + subgrid.zpp_inner.y * y;
				var y1;
				if(y == yn - 1) {
					var _this7 = bounds.zpp_inner.getmax();
					var _this8 = _this7.zpp_inner;
					if(_this8._validate != null) {
						_this8._validate();
					}
					y1 = _this7.zpp_inner.y;
				} else {
					var _this9 = subgrid.zpp_inner;
					if(_this9._validate != null) {
						_this9._validate();
					}
					y1 = y01 + subgrid.zpp_inner.y;
				}
				zpp_$nape_geom_ZPP_$MarchingSquares.run(iso,x01,y01,x1,y1,cellsize,quality,combine,ret);
			}
		}
	}
	if(cellsize.zpp_inner.weak) {
		var inner = cellsize.zpp_inner;
		cellsize.zpp_inner.outer = null;
		cellsize.zpp_inner = null;
		var o = cellsize;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(subgrid != null) {
		if(subgrid.zpp_inner.weak) {
			var inner = subgrid.zpp_inner;
			subgrid.zpp_inner.outer = null;
			subgrid.zpp_inner = null;
			var o = subgrid;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
	}
	return ret;
};
var nape_geom_Mat23 = $hx_exports["nape"]["geom"]["Mat23"] = function(a,b,c,d,tx,ty) {
	if(ty == null) {
		ty = 0.0;
	}
	if(tx == null) {
		tx = 0.0;
	}
	if(d == null) {
		d = 1.0;
	}
	if(c == null) {
		c = 0.0;
	}
	if(b == null) {
		b = 0.0;
	}
	if(a == null) {
		a = 1.0;
	}
	this.zpp_inner = null;
	this.zpp_inner = zpp_$nape_geom_ZPP_$Mat23.get();
	this.zpp_inner.outer = this;
	this.zpp_inner.a = a;
	var _this = this.zpp_inner;
	if(_this._invalidate != null) {
		_this._invalidate();
	}
	this.zpp_inner.b = b;
	var _this = this.zpp_inner;
	if(_this._invalidate != null) {
		_this._invalidate();
	}
	this.zpp_inner.tx = tx;
	var _this = this.zpp_inner;
	if(_this._invalidate != null) {
		_this._invalidate();
	}
	this.zpp_inner.c = c;
	var _this = this.zpp_inner;
	if(_this._invalidate != null) {
		_this._invalidate();
	}
	this.zpp_inner.d = d;
	var _this = this.zpp_inner;
	if(_this._invalidate != null) {
		_this._invalidate();
	}
	this.zpp_inner.ty = ty;
	var _this = this.zpp_inner;
	if(_this._invalidate != null) {
		_this._invalidate();
	}
};
nape_geom_Mat23.__name__ = true;
nape_geom_Mat23.rotation = function(angle) {
	var cos = Math.cos(angle);
	var sin = Math.sin(angle);
	return new nape_geom_Mat23(cos,-sin,sin,cos,0,0);
};
nape_geom_Mat23.translation = function(tx,ty) {
	return new nape_geom_Mat23(1,0,0,1,tx,ty);
};
nape_geom_Mat23.scale = function(sx,sy) {
	return new nape_geom_Mat23(sx,0,0,sy,0,0);
};
nape_geom_Mat23.prototype = {
	get_a: function() {
		return this.zpp_inner.a;
	}
	,set_a: function(a) {
		this.zpp_inner.a = a;
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this.zpp_inner.a;
	}
	,get_b: function() {
		return this.zpp_inner.b;
	}
	,set_b: function(b) {
		this.zpp_inner.b = b;
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this.zpp_inner.b;
	}
	,get_c: function() {
		return this.zpp_inner.c;
	}
	,set_c: function(c) {
		this.zpp_inner.c = c;
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this.zpp_inner.c;
	}
	,get_d: function() {
		return this.zpp_inner.d;
	}
	,set_d: function(d) {
		this.zpp_inner.d = d;
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this.zpp_inner.d;
	}
	,get_tx: function() {
		return this.zpp_inner.tx;
	}
	,set_tx: function(tx) {
		this.zpp_inner.tx = tx;
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this.zpp_inner.tx;
	}
	,get_ty: function() {
		return this.zpp_inner.ty;
	}
	,set_ty: function(ty) {
		this.zpp_inner.ty = ty;
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this.zpp_inner.ty;
	}
	,copy: function() {
		return new nape_geom_Mat23(this.zpp_inner.a,this.zpp_inner.b,this.zpp_inner.c,this.zpp_inner.d,this.zpp_inner.tx,this.zpp_inner.ty);
	}
	,set: function(matrix) {
		var m = matrix.zpp_inner;
		this.zpp_inner.setas(m.a,m.b,m.c,m.d,m.tx,m.ty);
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this;
	}
	,setAs: function(a,b,c,d,tx,ty) {
		if(ty == null) {
			ty = 0.0;
		}
		if(tx == null) {
			tx = 0.0;
		}
		if(d == null) {
			d = 1.0;
		}
		if(c == null) {
			c = 0.0;
		}
		if(b == null) {
			b = 0.0;
		}
		if(a == null) {
			a = 1.0;
		}
		this.zpp_inner.setas(a,b,c,d,tx,ty);
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate();
		}
		return this;
	}
	,reset: function() {
		return this.setAs();
	}
	,get_determinant: function() {
		return this.zpp_inner.a * this.zpp_inner.d - this.zpp_inner.b * this.zpp_inner.c;
	}
	,singular: function() {
		var norm = this.zpp_inner.a * this.zpp_inner.a + this.zpp_inner.b * this.zpp_inner.b + this.zpp_inner.c * this.zpp_inner.c + this.zpp_inner.d * this.zpp_inner.d;
		var limit = this.zpp_inner.a * this.zpp_inner.d - this.zpp_inner.b * this.zpp_inner.c;
		if(limit < 0) {
			limit = -limit;
		}
		return norm > nape_Config.illConditionedThreshold * limit;
	}
	,inverse: function() {
		var idet = 1.0 / (this.zpp_inner.a * this.zpp_inner.d - this.zpp_inner.b * this.zpp_inner.c);
		return new nape_geom_Mat23(this.zpp_inner.d * idet,-this.zpp_inner.b * idet,-this.zpp_inner.c * idet,this.zpp_inner.a * idet,(this.zpp_inner.b * this.zpp_inner.ty - this.zpp_inner.d * this.zpp_inner.tx) * idet,(this.zpp_inner.c * this.zpp_inner.tx - this.zpp_inner.a * this.zpp_inner.ty) * idet);
	}
	,transpose: function() {
		return new nape_geom_Mat23(this.zpp_inner.a,this.zpp_inner.c,this.zpp_inner.b,this.zpp_inner.d,-this.zpp_inner.a * this.zpp_inner.tx - this.zpp_inner.c * this.zpp_inner.ty,-this.zpp_inner.b * this.zpp_inner.tx - this.zpp_inner.d * this.zpp_inner.ty);
	}
	,concat: function(matrix) {
		var m = matrix;
		return new nape_geom_Mat23(m.zpp_inner.a * this.zpp_inner.a + m.zpp_inner.b * this.zpp_inner.c,m.zpp_inner.a * this.zpp_inner.b + m.zpp_inner.b * this.zpp_inner.d,m.zpp_inner.c * this.zpp_inner.a + m.zpp_inner.d * this.zpp_inner.c,m.zpp_inner.c * this.zpp_inner.b + m.zpp_inner.d * this.zpp_inner.d,m.zpp_inner.a * this.zpp_inner.tx + m.zpp_inner.b * this.zpp_inner.ty + m.zpp_inner.tx,m.zpp_inner.c * this.zpp_inner.tx + m.zpp_inner.d * this.zpp_inner.ty + m.zpp_inner.ty);
	}
	,transform: function(point,noTranslation,weak) {
		if(weak == null) {
			weak = false;
		}
		if(noTranslation == null) {
			noTranslation = false;
		}
		var ret;
		if(noTranslation) {
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x = point.zpp_inner.x * this.zpp_inner.a;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x1 = x + point.zpp_inner.y * this.zpp_inner.b;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var y = point.zpp_inner.x * this.zpp_inner.c;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var y1 = y + point.zpp_inner.y * this.zpp_inner.d;
			var weak1 = weak;
			if(weak1 == null) {
				weak1 = false;
			}
			if(y1 == null) {
				y1 = 0;
			}
			if(x1 == null) {
				x1 = 0;
			}
			var ret1;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret1 = new nape_geom_Vec2();
			} else {
				ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
				ret1.zpp_pool = null;
			}
			if(ret1.zpp_inner == null) {
				var ret2;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.weak = false;
				ret2._immutable = false;
				ret2.x = x1;
				ret2.y = y1;
				ret1.zpp_inner = ret2;
				ret1.zpp_inner.outer = ret1;
			} else {
				var ret2;
				var _this = ret1.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret1.zpp_inner.x == x1) {
					var _this = ret1.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					ret2 = ret1.zpp_inner.y == y1;
				} else {
					ret2 = false;
				}
				if(!ret2) {
					ret1.zpp_inner.x = x1;
					ret1.zpp_inner.y = y1;
					var _this = ret1.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret1.zpp_inner.weak = weak1;
			ret = ret1;
		} else {
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x = point.zpp_inner.x * this.zpp_inner.a;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x1 = x + point.zpp_inner.y * this.zpp_inner.b + this.zpp_inner.tx;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var y = point.zpp_inner.x * this.zpp_inner.c;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var y1 = y + point.zpp_inner.y * this.zpp_inner.d + this.zpp_inner.ty;
			var weak1 = weak;
			if(weak1 == null) {
				weak1 = false;
			}
			if(y1 == null) {
				y1 = 0;
			}
			if(x1 == null) {
				x1 = 0;
			}
			var ret1;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret1 = new nape_geom_Vec2();
			} else {
				ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
				ret1.zpp_pool = null;
			}
			if(ret1.zpp_inner == null) {
				var ret2;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.weak = false;
				ret2._immutable = false;
				ret2.x = x1;
				ret2.y = y1;
				ret1.zpp_inner = ret2;
				ret1.zpp_inner.outer = ret1;
			} else {
				var ret2;
				var _this = ret1.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret1.zpp_inner.x == x1) {
					var _this = ret1.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					ret2 = ret1.zpp_inner.y == y1;
				} else {
					ret2 = false;
				}
				if(!ret2) {
					ret1.zpp_inner.x = x1;
					ret1.zpp_inner.y = y1;
					var _this = ret1.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret1.zpp_inner.weak = weak1;
			ret = ret1;
		}
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,inverseTransform: function(point,noTranslation,weak) {
		if(weak == null) {
			weak = false;
		}
		if(noTranslation == null) {
			noTranslation = false;
		}
		var idet = 1.0 / (this.zpp_inner.a * this.zpp_inner.d - this.zpp_inner.b * this.zpp_inner.c);
		var ret;
		if(noTranslation) {
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x = point.zpp_inner.x * this.zpp_inner.d;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x1 = (x - point.zpp_inner.y * this.zpp_inner.b) * idet;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var y = point.zpp_inner.y * this.zpp_inner.a;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var y1 = (y - point.zpp_inner.x * this.zpp_inner.c) * idet;
			var weak1 = weak;
			if(weak1 == null) {
				weak1 = false;
			}
			if(y1 == null) {
				y1 = 0;
			}
			if(x1 == null) {
				x1 = 0;
			}
			var ret1;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret1 = new nape_geom_Vec2();
			} else {
				ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
				ret1.zpp_pool = null;
			}
			if(ret1.zpp_inner == null) {
				var ret2;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.weak = false;
				ret2._immutable = false;
				ret2.x = x1;
				ret2.y = y1;
				ret1.zpp_inner = ret2;
				ret1.zpp_inner.outer = ret1;
			} else {
				var ret2;
				var _this = ret1.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret1.zpp_inner.x == x1) {
					var _this = ret1.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					ret2 = ret1.zpp_inner.y == y1;
				} else {
					ret2 = false;
				}
				if(!ret2) {
					ret1.zpp_inner.x = x1;
					ret1.zpp_inner.y = y1;
					var _this = ret1.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret1.zpp_inner.weak = weak1;
			ret = ret1;
		} else {
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var dx = point.zpp_inner.x - this.zpp_inner.tx;
			var _this = point.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var dy = point.zpp_inner.y - this.zpp_inner.ty;
			var x = (dx * this.zpp_inner.d - dy * this.zpp_inner.b) * idet;
			var y = (dy * this.zpp_inner.a - dx * this.zpp_inner.c) * idet;
			var weak1 = weak;
			if(weak1 == null) {
				weak1 = false;
			}
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret1;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret1 = new nape_geom_Vec2();
			} else {
				ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
				ret1.zpp_pool = null;
			}
			if(ret1.zpp_inner == null) {
				var ret2;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.weak = false;
				ret2._immutable = false;
				ret2.x = x;
				ret2.y = y;
				ret1.zpp_inner = ret2;
				ret1.zpp_inner.outer = ret1;
			} else {
				var ret2;
				var _this = ret1.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret1.zpp_inner.x == x) {
					var _this = ret1.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					ret2 = ret1.zpp_inner.y == y;
				} else {
					ret2 = false;
				}
				if(!ret2) {
					ret1.zpp_inner.x = x;
					ret1.zpp_inner.y = y;
					var _this = ret1.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret1.zpp_inner.weak = weak1;
			ret = ret1;
		}
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,toString: function() {
		return "{ a: " + this.zpp_inner.a + " b: " + this.zpp_inner.b + " c: " + this.zpp_inner.c + " d: " + this.zpp_inner.d + " tx: " + this.zpp_inner.tx + " ty: " + this.zpp_inner.ty + " }";
	}
	,equiorthogonal: function() {
		if(this.singular()) {
			return false;
		} else {
			var x = this.zpp_inner.a * this.zpp_inner.b + this.zpp_inner.c * this.zpp_inner.d;
			if(x * x < nape_Config.epsilon) {
				var y = this.zpp_inner.a * this.zpp_inner.a + this.zpp_inner.b * this.zpp_inner.b - this.zpp_inner.c * this.zpp_inner.c - this.zpp_inner.d * this.zpp_inner.d;
				return y * y < nape_Config.epsilon;
			} else {
				return false;
			}
		}
	}
	,orthogonal: function() {
		var x = this.zpp_inner.a * this.zpp_inner.b + this.zpp_inner.c * this.zpp_inner.d;
		if(x * x < nape_Config.epsilon) {
			var y = this.zpp_inner.a * this.zpp_inner.a + this.zpp_inner.b * this.zpp_inner.b - 1;
			var z = this.zpp_inner.c * this.zpp_inner.c + this.zpp_inner.d * this.zpp_inner.d - 1;
			if(y * y < nape_Config.epsilon) {
				return z * z < nape_Config.epsilon;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
	,equiorthogonalise: function() {
		if(!this.equiorthogonal()) {
			var k1 = Math.sqrt(this.zpp_inner.a * this.zpp_inner.a + this.zpp_inner.c * this.zpp_inner.c);
			var k2 = Math.sqrt(this.zpp_inner.b * this.zpp_inner.b + this.zpp_inner.d * this.zpp_inner.d);
			var k = (k1 + k2) / 2;
			k1 = k / k1;
			k2 = k / k2;
			this.zpp_inner.a = this.zpp_inner.a * k1;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.c = this.zpp_inner.c * k1;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.b = this.zpp_inner.b * k2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.d = this.zpp_inner.d * k2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			var dot = this.zpp_inner.a * this.zpp_inner.b + this.zpp_inner.c * this.zpp_inner.d;
			var ang = 0.25 * Math.PI - 0.5 * Math.acos(dot / (k * k));
			if(this.zpp_inner.a * this.zpp_inner.d - this.zpp_inner.b * this.zpp_inner.c > 0) {
				ang = -ang;
			}
			var sin = Math.sin(ang);
			var cos = Math.cos(ang);
			var a2 = this.zpp_inner.a * cos - this.zpp_inner.c * sin;
			var b2 = this.zpp_inner.b * cos + this.zpp_inner.d * sin;
			this.zpp_inner.c = this.zpp_inner.c * cos + this.zpp_inner.a * sin;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.a = a2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.d = this.zpp_inner.d * cos - this.zpp_inner.b * sin;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.b = b2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
		}
		return this;
	}
	,orthogonalise: function() {
		if(!this.orthogonal()) {
			var k1 = Math.sqrt(this.zpp_inner.a * this.zpp_inner.a + this.zpp_inner.c * this.zpp_inner.c);
			var k2 = Math.sqrt(this.zpp_inner.b * this.zpp_inner.b + this.zpp_inner.d * this.zpp_inner.d);
			var k = 1;
			k1 = k / k1;
			k2 = k / k2;
			this.zpp_inner.a = this.zpp_inner.a * k1;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.c = this.zpp_inner.c * k1;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.b = this.zpp_inner.b * k2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.d = this.zpp_inner.d * k2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			var dot = this.zpp_inner.a * this.zpp_inner.b + this.zpp_inner.c * this.zpp_inner.d;
			var ang = 0.25 * Math.PI - 0.5 * Math.acos(dot / (k * k));
			if(this.zpp_inner.a * this.zpp_inner.d - this.zpp_inner.b * this.zpp_inner.c > 0) {
				ang = -ang;
			}
			var sin = Math.sin(ang);
			var cos = Math.cos(ang);
			var a2 = this.zpp_inner.a * cos - this.zpp_inner.c * sin;
			var b2 = this.zpp_inner.b * cos + this.zpp_inner.d * sin;
			this.zpp_inner.c = this.zpp_inner.c * cos + this.zpp_inner.a * sin;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.a = a2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.d = this.zpp_inner.d * cos - this.zpp_inner.b * sin;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			this.zpp_inner.b = b2;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate();
			}
		}
		return this;
	}
};
var nape_geom_MatMN = $hx_exports["nape"]["geom"]["MatMN"] = function(rows,cols) {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_geom_ZPP_$MatMN(rows,cols);
	this.zpp_inner.outer = this;
};
nape_geom_MatMN.__name__ = true;
nape_geom_MatMN.prototype = {
	get_rows: function() {
		return this.zpp_inner.m;
	}
	,get_cols: function() {
		return this.zpp_inner.n;
	}
	,x: function(row,col) {
		return this.zpp_inner.x[row * this.zpp_inner.n + col];
	}
	,setx: function(row,col,x) {
		return this.zpp_inner.x[row * this.zpp_inner.n + col] = x;
	}
	,toString: function() {
		var ret = "{ ";
		var fst = true;
		var _g = 0;
		var _g1 = this.zpp_inner.m;
		while(_g < _g1) {
			var i = _g++;
			if(!fst) {
				ret += "; ";
			}
			fst = false;
			var _g2 = 0;
			var _g3 = this.zpp_inner.n;
			while(_g2 < _g3) {
				var j = _g2++;
				ret += this.zpp_inner.x[i * this.zpp_inner.n + j] + " ";
			}
		}
		ret += "}";
		return ret;
	}
	,transpose: function() {
		var ret = new nape_geom_MatMN(this.zpp_inner.n,this.zpp_inner.m);
		var _g = 0;
		var _g1 = this.zpp_inner.m;
		while(_g < _g1) {
			var i = _g++;
			var _g2 = 0;
			var _g3 = this.zpp_inner.n;
			while(_g2 < _g3) {
				var j = _g2++;
				ret.zpp_inner.x[j * ret.zpp_inner.n + i] = this.zpp_inner.x[i * this.zpp_inner.n + j];
			}
		}
		return ret;
	}
	,mul: function(matrix) {
		var y = matrix;
		var ret = new nape_geom_MatMN(this.zpp_inner.m,y.zpp_inner.n);
		var _g = 0;
		var _g1 = this.zpp_inner.m;
		while(_g < _g1) {
			var i = _g++;
			var _g2 = 0;
			var _g3 = y.zpp_inner.n;
			while(_g2 < _g3) {
				var j = _g2++;
				var v = 0.0;
				var _g4 = 0;
				var _g5 = this.zpp_inner.n;
				while(_g4 < _g5) {
					var k = _g4++;
					v += this.zpp_inner.x[i * this.zpp_inner.n + k] * y.zpp_inner.x[k * y.zpp_inner.n + j];
				}
				ret.zpp_inner.x[i * ret.zpp_inner.n + j] = v;
			}
		}
		return ret;
	}
};
var nape_geom_Ray = $hx_exports["nape"]["geom"]["Ray"] = function(origin,direction) {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_geom_ZPP_$Ray();
	var _this = this.zpp_inner.origin;
	var _this1 = origin.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = origin.zpp_inner.x;
	var _this1 = origin.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = origin.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(origin.zpp_inner.weak) {
		var inner = origin.zpp_inner;
		origin.zpp_inner.outer = null;
		origin.zpp_inner = null;
		var o = origin;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	var _this = this.zpp_inner.direction;
	var _this1 = direction.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var x = direction.zpp_inner.x;
	var _this1 = direction.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	var y = direction.zpp_inner.y;
	var tmp;
	var _this1 = _this.zpp_inner;
	if(_this1._validate != null) {
		_this1._validate();
	}
	if(_this.zpp_inner.x == x) {
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		tmp = _this.zpp_inner.y == y;
	} else {
		tmp = false;
	}
	if(!tmp) {
		_this.zpp_inner.x = x;
		_this.zpp_inner.y = y;
		var _this1 = _this.zpp_inner;
		if(_this1._invalidate != null) {
			_this1._invalidate(_this1);
		}
	}
	var ret = _this;
	if(direction.zpp_inner.weak) {
		var inner = direction.zpp_inner;
		direction.zpp_inner.outer = null;
		direction.zpp_inner = null;
		var o = direction;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	this.zpp_inner.zip_dir = true;
	this.zpp_inner.maxdist = Infinity;
};
nape_geom_Ray.__name__ = true;
nape_geom_Ray.fromSegment = function(start,end) {
	var dir = end.sub(start,true);
	var ret = new nape_geom_Ray(start,dir);
	var _this = start.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var ax = start.zpp_inner.x;
	var _this = start.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var ay = start.zpp_inner.y;
	var _this = end.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var bx = end.zpp_inner.x;
	var _this = end.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var dx = 0.0;
	var dy = 0.0;
	dx = ax - bx;
	dy = ay - end.zpp_inner.y;
	ret.zpp_inner.maxdist = Math.sqrt(dx * dx + dy * dy);
	if(start.zpp_inner.weak) {
		var inner = start.zpp_inner;
		start.zpp_inner.outer = null;
		start.zpp_inner = null;
		var o = start;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(end.zpp_inner.weak) {
		var inner = end.zpp_inner;
		end.zpp_inner.outer = null;
		end.zpp_inner = null;
		var o = end;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	return ret;
};
nape_geom_Ray.prototype = {
	get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_origin: function() {
		return this.zpp_inner.origin;
	}
	,set_origin: function(origin) {
		var _this = this.zpp_inner.origin;
		var _this1 = origin.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = origin.zpp_inner.x;
		var _this1 = origin.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = origin.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(origin.zpp_inner.weak) {
			var inner = origin.zpp_inner;
			origin.zpp_inner.outer = null;
			origin.zpp_inner = null;
			var o = origin;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this.zpp_inner.origin;
	}
	,get_direction: function() {
		return this.zpp_inner.direction;
	}
	,set_direction: function(direction) {
		var _this = this.zpp_inner.direction;
		var _this1 = direction.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = direction.zpp_inner.x;
		var _this1 = direction.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = direction.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(direction.zpp_inner.weak) {
			var inner = direction.zpp_inner;
			direction.zpp_inner.outer = null;
			direction.zpp_inner = null;
			var o = direction;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		this.zpp_inner.zip_dir = true;
		return this.zpp_inner.direction;
	}
	,get_maxDistance: function() {
		return this.zpp_inner.maxdist;
	}
	,set_maxDistance: function(maxDistance) {
		this.zpp_inner.maxdist = maxDistance;
		return this.zpp_inner.maxdist;
	}
	,aabb: function() {
		return this.zpp_inner.rayAABB().wrapper();
	}
	,at: function(distance,weak) {
		if(weak == null) {
			weak = false;
		}
		this.zpp_inner.validate_dir();
		var _this = this.zpp_inner.origin;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = _this.zpp_inner.x + distance * this.zpp_inner.dirx;
		var _this = this.zpp_inner.origin;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = _this.zpp_inner.y + distance * this.zpp_inner.diry;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,copy: function() {
		var ret = new nape_geom_Ray(this.zpp_inner.origin,this.zpp_inner.direction);
		ret.zpp_inner.maxdist = this.zpp_inner.maxdist;
		return ret;
	}
};
var nape_geom_RayResult = $hx_exports["nape"]["geom"]["RayResult"] = function() {
	this.zpp_inner = null;
};
nape_geom_RayResult.__name__ = true;
nape_geom_RayResult.prototype = {
	get_normal: function() {
		return this.zpp_inner.normal;
	}
	,get_distance: function() {
		return this.zpp_inner.toiDistance;
	}
	,get_inner: function() {
		return this.zpp_inner.inner;
	}
	,get_shape: function() {
		return this.zpp_inner.shape;
	}
	,dispose: function() {
		this.zpp_inner.free();
	}
	,toString: function() {
		return "{ shape: " + Std.string(this.zpp_inner.shape) + " distance: " + this.zpp_inner.toiDistance + " ?inner: " + Std.string(this.zpp_inner.inner) + " }";
	}
};
var nape_geom_RayResultIterator = $hx_exports["nape"]["geom"]["RayResultIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_geom_RayResultIterator.__name__ = true;
nape_geom_RayResultIterator.get = function(list) {
	var ret;
	if(nape_geom_RayResultIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$RayResultList.internal = true;
		var ret1 = new nape_geom_RayResultIterator();
		zpp_$nape_util_ZPP_$RayResultList.internal = false;
		ret = ret1;
	} else {
		var r = nape_geom_RayResultIterator.zpp_pool;
		nape_geom_RayResultIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_geom_RayResultIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_geom_RayResultIterator.zpp_pool;
			nape_geom_RayResultIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_geom_RayResultList = $hx_exports["nape"]["geom"]["RayResultList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$RayResultList();
	this.zpp_inner.outer = this;
};
nape_geom_RayResultList.__name__ = true;
nape_geom_RayResultList.fromArray = function(array) {
	var ret = new nape_geom_RayResultList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_geom_RayResultList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj);
			} else {
				this.zpp_inner.inner.add(obj);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_geom_RayResultIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_geom_RayResultList();
		this.zpp_inner.valmod();
		var _g = nape_geom_RayResultIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_RayResultIterator.zpp_pool;
				nape_geom_RayResultIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_geom_RayResultIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_RayResultIterator.zpp_pool;
				nape_geom_RayResultIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_geom_RayResultIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_RayResultIterator.zpp_pool;
				nape_geom_RayResultIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_geom_RayResultIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_geom_RayResultIterator.zpp_pool;
				nape_geom_RayResultIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_geom_RayResultIterator.zpp_pool;
				nape_geom_RayResultIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_geom_Vec2 = $hx_exports["nape"]["geom"]["Vec2"] = function(x,y) {
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	this.zpp_pool = null;
	this.zpp_inner = null;
	var ret;
	if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$Vec2();
	} else {
		ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.weak = false;
	ret._immutable = false;
	ret.x = x;
	ret.y = y;
	this.zpp_inner = ret;
	this.zpp_inner.outer = this;
};
nape_geom_Vec2.__name__ = true;
nape_geom_Vec2.weak = function(x,y) {
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	var x1 = x;
	var y1 = y;
	var weak = true;
	if(weak == null) {
		weak = false;
	}
	if(y1 == null) {
		y1 = 0;
	}
	if(x1 == null) {
		x1 = 0;
	}
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret = new nape_geom_Vec2();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(ret.zpp_inner == null) {
		var ret1;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.weak = false;
		ret1._immutable = false;
		ret1.x = x1;
		ret1.y = y1;
		ret.zpp_inner = ret1;
		ret.zpp_inner.outer = ret;
	} else {
		var tmp;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret.zpp_inner.x == x1) {
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret.zpp_inner.x = x1;
			ret.zpp_inner.y = y1;
			var _this = ret.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret.zpp_inner.weak = weak;
	return ret;
};
nape_geom_Vec2.get = function(x,y,weak) {
	if(weak == null) {
		weak = false;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret = new nape_geom_Vec2();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(ret.zpp_inner == null) {
		var ret1;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.weak = false;
		ret1._immutable = false;
		ret1.x = x;
		ret1.y = y;
		ret.zpp_inner = ret1;
		ret.zpp_inner.outer = ret;
	} else {
		var tmp;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret.zpp_inner.x == x) {
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret.zpp_inner.x = x;
			ret.zpp_inner.y = y;
			var _this = ret.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret.zpp_inner.weak = weak;
	return ret;
};
nape_geom_Vec2.fromPolar = function(length,angle,weak) {
	if(weak == null) {
		weak = false;
	}
	var x = length * Math.cos(angle);
	var y = length * Math.sin(angle);
	var weak1 = weak;
	if(weak1 == null) {
		weak1 = false;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret = new nape_geom_Vec2();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(ret.zpp_inner == null) {
		var ret1;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.weak = false;
		ret1._immutable = false;
		ret1.x = x;
		ret1.y = y;
		ret.zpp_inner = ret1;
		ret.zpp_inner.outer = ret;
	} else {
		var tmp;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret.zpp_inner.x == x) {
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret.zpp_inner.x = x;
			ret.zpp_inner.y = y;
			var _this = ret.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret.zpp_inner.weak = weak1;
	return ret;
};
nape_geom_Vec2.dsq = function(a,b) {
	var _this = a.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var ax = a.zpp_inner.x;
	var _this = a.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var ay = a.zpp_inner.y;
	var _this = b.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var bx = b.zpp_inner.x;
	var _this = b.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var dx = 0.0;
	var dy = 0.0;
	dx = ax - bx;
	dy = ay - b.zpp_inner.y;
	var ret = dx * dx + dy * dy;
	if(a.zpp_inner.weak) {
		var inner = a.zpp_inner;
		a.zpp_inner.outer = null;
		a.zpp_inner = null;
		var o = a;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(b.zpp_inner.weak) {
		var inner = b.zpp_inner;
		b.zpp_inner.outer = null;
		b.zpp_inner = null;
		var o = b;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	return ret;
};
nape_geom_Vec2.distance = function(a,b) {
	var _this = a.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var ax = a.zpp_inner.x;
	var _this = a.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var ay = a.zpp_inner.y;
	var _this = b.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var bx = b.zpp_inner.x;
	var _this = b.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var dx = 0.0;
	var dy = 0.0;
	dx = ax - bx;
	dy = ay - b.zpp_inner.y;
	var ret = Math.sqrt(dx * dx + dy * dy);
	if(a.zpp_inner.weak) {
		var inner = a.zpp_inner;
		a.zpp_inner.outer = null;
		a.zpp_inner = null;
		var o = a;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	if(b.zpp_inner.weak) {
		var inner = b.zpp_inner;
		b.zpp_inner.outer = null;
		b.zpp_inner = null;
		var o = b;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	return ret;
};
nape_geom_Vec2.prototype = {
	dispose: function() {
		var inner = this.zpp_inner;
		this.zpp_inner.outer = null;
		this.zpp_inner = null;
		var o = this;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	}
	,copy: function(weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,get_x: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.x;
	}
	,set_x: function(x) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x != x) {
			this.zpp_inner.x = x;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.x;
	}
	,get_y: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.y;
	}
	,set_y: function(y) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.y != y) {
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.y;
	}
	,get_length: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return Math.sqrt(tmp1 + tmp * this.zpp_inner.y);
	}
	,set_length: function(length) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t1 = t * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t2 = length / Math.sqrt(t1 + t * this.zpp_inner.y);
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x * t2;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x != x) {
			this.zpp_inner.x = x;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y * t2;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.y != y) {
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate(_this);
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return Math.sqrt(tmp1 + tmp * this.zpp_inner.y);
	}
	,lsq: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return tmp1 + tmp * this.zpp_inner.y;
	}
	,set: function(vector) {
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = vector.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = vector.zpp_inner.y;
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x == x) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			this.zpp_inner.x = x;
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var ret = this;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,setxy: function(x,y) {
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x == x) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			this.zpp_inner.x = x;
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		return this;
	}
	,get_angle: function() {
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(tmp1 == this.zpp_inner.y) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.x == 0;
		} else {
			tmp = false;
		}
		if(tmp) {
			return 0.0;
		} else {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var tmp = this.zpp_inner.y;
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			return Math.atan2(tmp,this.zpp_inner.x);
		}
	}
	,set_angle: function(angle) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var l = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var l1 = l * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var l = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var l2 = Math.sqrt(l1 + l * this.zpp_inner.y);
		var x = l2 * Math.cos(angle);
		var y = l2 * Math.sin(angle);
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x == x) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			this.zpp_inner.x = x;
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(tmp1 == this.zpp_inner.y) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.x == 0;
		} else {
			tmp = false;
		}
		if(tmp) {
			return 0.0;
		} else {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var tmp = this.zpp_inner.y;
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			return Math.atan2(tmp,this.zpp_inner.x);
		}
	}
	,rotate: function(angle) {
		if(angle % (Math.PI * 2) != 0) {
			var ax = Math.sin(angle);
			var ay = Math.cos(angle);
			var t = ay * this.zpp_inner.x - ax * this.zpp_inner.y;
			this.zpp_inner.y = this.zpp_inner.x * ax + this.zpp_inner.y * ay;
			this.zpp_inner.x = t;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		return this;
	}
	,reflect: function(vec,weak) {
		if(weak == null) {
			weak = false;
		}
		var weak1 = true;
		if(weak1 == null) {
			weak1 = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var weak2 = weak1;
		if(weak2 == null) {
			weak2 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var normal;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				normal = ret.zpp_inner.y == y;
			} else {
				normal = false;
			}
			if(!normal) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak2;
		var normal = ret.normalise();
		var ret = vec.sub(normal.muleq(2 * normal.dot(vec)),weak);
		if(vec.zpp_inner.weak) {
			var inner = vec.zpp_inner;
			vec.zpp_inner.outer = null;
			vec.zpp_inner = null;
			var o = vec;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,normalise: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var d = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var d1 = d * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var d = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var d2 = d1 + d * this.zpp_inner.y;
		var imag = 1.0 / Math.sqrt(d2);
		var t = imag;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x * t;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x != x) {
			this.zpp_inner.x = x;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y * t;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.y != y) {
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._invalidate != null) {
			_this._invalidate(_this);
		}
		return this;
	}
	,unit: function(weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x1 = x * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x2 = x1 + x * this.zpp_inner.y;
		var scale;
		if(x2 == 0.0) {
			scale = 0.0;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = x2;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x21 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			scale = 1 / (x21 * (1.5 - 0.5 * x2 * x21 * x21));
		}
		var scale1 = 1 / scale;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x * scale1;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y * scale1;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,add: function(vector,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x1 = x + vector.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y1 = y + vector.zpp_inner.y;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y1 == null) {
			y1 = 0;
		}
		if(x1 == null) {
			x1 = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x1;
			ret1.y = y1;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x1) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y1;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x1;
				ret.zpp_inner.y = y1;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		var ret1 = ret;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret1;
	}
	,addMul: function(vector,scalar,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x1 = x + vector.zpp_inner.x * scalar;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y1 = y + vector.zpp_inner.y * scalar;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y1 == null) {
			y1 = 0;
		}
		if(x1 == null) {
			x1 = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x1;
			ret1.y = y1;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x1) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y1;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x1;
				ret.zpp_inner.y = y1;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		var ret1 = ret;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret1;
	}
	,sub: function(vector,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x1 = x - vector.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y1 = y - vector.zpp_inner.y;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y1 == null) {
			y1 = 0;
		}
		if(x1 == null) {
			x1 = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x1;
			ret1.y = y1;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x1) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y1;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x1;
				ret.zpp_inner.y = y1;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		var ret1 = ret;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret1;
	}
	,mul: function(scalar,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x * scalar;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y * scalar;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,addeq: function(vector) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x1 = x + vector.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y1 = y + vector.zpp_inner.y;
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x == x1) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			this.zpp_inner.x = x1;
			this.zpp_inner.y = y1;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,subeq: function(vector) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x1 = x - vector.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y1 = y - vector.zpp_inner.y;
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x == x1) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			this.zpp_inner.x = x1;
			this.zpp_inner.y = y1;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,muleq: function(scalar) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x * scalar;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y * scalar;
		var tmp;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(this.zpp_inner.x == x) {
			var _this = this.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			this.zpp_inner.x = x;
			this.zpp_inner.y = y;
			var _this = this.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
		return this;
	}
	,dot: function(vector) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret1 = ret * vector.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = this.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret2 = ret1 + ret * vector.zpp_inner.y;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret2;
	}
	,cross: function(vector) {
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = vector.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret1 = ret * this.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = vector.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret2 = ret1 - ret * this.zpp_inner.y;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret2;
	}
	,perp: function(weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = -this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.x;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,toString: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.toString();
	}
};
var nape_geom_Vec2Iterator = $hx_exports["nape"]["geom"]["Vec2Iterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_geom_Vec2Iterator.__name__ = true;
nape_geom_Vec2Iterator.get = function(list) {
	var ret;
	if(nape_geom_Vec2Iterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$Vec2List.internal = true;
		var ret1 = new nape_geom_Vec2Iterator();
		zpp_$nape_util_ZPP_$Vec2List.internal = false;
		ret = ret1;
	} else {
		var r = nape_geom_Vec2Iterator.zpp_pool;
		nape_geom_Vec2Iterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_geom_Vec2Iterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var length = this.zpp_inner.zpp_gl();
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
			nape_geom_Vec2Iterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_geom_Vec2List = $hx_exports["nape"]["geom"]["Vec2List"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$Vec2List();
	this.zpp_inner.outer = this;
};
nape_geom_Vec2List.__name__ = true;
nape_geom_Vec2List.fromArray = function(array) {
	var ret = new nape_geom_Vec2List();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_geom_Vec2List.prototype = {
	get_length: function() {
		return this.zpp_gl();
	}
	,zpp_gl: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,zpp_vm: function() {
		this.zpp_inner.valmod();
	}
	,has: function(obj) {
		this.zpp_vm();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_vm();
		if(this.zpp_inner.reverse_flag) {
			index = this.zpp_gl() - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		var _this = this.zpp_inner.at_ite.elt;
		if(_this.outer == null) {
			_this.outer = new nape_geom_Vec2();
			var o = _this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			_this.outer.zpp_inner = _this;
		}
		return _this.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp = this.empty() ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 1);
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp = this.empty() ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 1);
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite = this.zpp_gl() == 1 ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 2);
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		if(ret.outer == null) {
			ret.outer = new nape_geom_Vec2();
			var o = ret.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			ret.outer.zpp_inner = ret;
		}
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite = this.zpp_gl() == 1 ? null : this.zpp_inner.inner.iterator_at(this.zpp_gl() - 2);
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		if(ret.outer == null) {
			ret.outer = new nape_geom_Vec2();
			var o = ret.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			ret.outer.zpp_inner = ret;
		}
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(!this.empty()) this.pop();
		} else {
			while(!this.empty()) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_gl() == 0;
	}
	,iterator: function() {
		this.zpp_vm();
		return nape_geom_Vec2Iterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_geom_Vec2List();
		var _g = this.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
				nape_geom_Vec2Iterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			var tmp1;
			if(deep) {
				var _this = i.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var x = i.zpp_inner.x;
				var _this1 = i.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				var y = i.zpp_inner.y;
				var weak = false;
				if(weak == null) {
					weak = false;
				}
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret1;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret1 = new nape_geom_Vec2();
				} else {
					ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
					ret1.zpp_pool = null;
				}
				if(ret1.zpp_inner == null) {
					var ret2;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret2 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
						ret2.next = null;
					}
					ret2.weak = false;
					ret2._immutable = false;
					ret2.x = x;
					ret2.y = y;
					ret1.zpp_inner = ret2;
					ret1.zpp_inner.outer = ret1;
				} else {
					var tmp2;
					var _this2 = ret1.zpp_inner;
					if(_this2._validate != null) {
						_this2._validate();
					}
					if(ret1.zpp_inner.x == x) {
						var _this3 = ret1.zpp_inner;
						if(_this3._validate != null) {
							_this3._validate();
						}
						tmp2 = ret1.zpp_inner.y == y;
					} else {
						tmp2 = false;
					}
					if(!tmp2) {
						ret1.zpp_inner.x = x;
						ret1.zpp_inner.y = y;
						var _this4 = ret1.zpp_inner;
						if(_this4._invalidate != null) {
							_this4._invalidate(_this4);
						}
					}
				}
				ret1.zpp_inner.weak = weak;
				tmp1 = ret1;
			} else {
				tmp1 = i;
			}
			ret.push(tmp1);
		}
		return ret;
	}
	,merge: function(xs) {
		var _g = xs.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
				nape_geom_Vec2Iterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				this.add(x);
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		var _g = this.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
				nape_geom_Vec2Iterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		var it = this.iterator();
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var length = it.zpp_inner.zpp_gl();
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
				nape_geom_Vec2Iterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
				nape_geom_Vec2Iterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(i < this.zpp_gl()) {
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_geom_Vec3 = $hx_exports["nape"]["geom"]["Vec3"] = function(x,y,z) {
	if(z == null) {
		z = 0;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	this.zpp_pool = null;
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_geom_ZPP_$Vec3();
	this.zpp_inner.outer = this;
	this.zpp_inner.x = x;
	var _this = this.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	this.zpp_inner.y = y;
	var _this = this.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	this.zpp_inner.z = z;
	var _this = this.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
};
nape_geom_Vec3.__name__ = true;
nape_geom_Vec3.get = function(x,y,z) {
	if(z == null) {
		z = 0;
	}
	if(y == null) {
		y = 0;
	}
	if(x == null) {
		x = 0;
	}
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec3 == null) {
		ret = new nape_geom_Vec3();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec3;
		zpp_$nape_util_ZPP_$PubPool.poolVec3 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	ret.setxyz(x,y,z);
	ret.zpp_inner.immutable = false;
	ret.zpp_inner._validate = null;
	return ret;
};
nape_geom_Vec3.prototype = {
	get_x: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.x;
	}
	,set_x: function(x) {
		this.zpp_inner.x = x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.x;
	}
	,get_y: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.y;
	}
	,set_y: function(y) {
		this.zpp_inner.y = y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.y;
	}
	,get_z: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.z;
	}
	,set_z: function(z) {
		this.zpp_inner.z = z;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.zpp_inner.z;
	}
	,dispose: function() {
		var o = this;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec3;
		zpp_$nape_util_ZPP_$PubPool.poolVec3 = o;
	}
	,get_length: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp2 = tmp1 + tmp * this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.z;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return Math.sqrt(tmp2 + tmp * this.zpp_inner.z);
	}
	,set_length: function(length) {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t1 = t * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t2 = t1 + t * this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t = this.zpp_inner.z;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var t1 = length / Math.sqrt(t2 + t * this.zpp_inner.z);
		var t = t1;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.x *= t;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.y *= t;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.z *= t1;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp2 = tmp1 + tmp * this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.z;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return Math.sqrt(tmp2 + tmp * this.zpp_inner.z);
	}
	,lsq: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp * this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp2 = tmp1 + tmp * this.zpp_inner.y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = this.zpp_inner.z;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return tmp2 + tmp * this.zpp_inner.z;
	}
	,set: function(vector) {
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = vector.zpp_inner.x;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = vector.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this.setxyz(tmp,tmp1,vector.zpp_inner.z);
	}
	,setxyz: function(x,y,z) {
		this.zpp_inner.x = x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.y = y;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.z = z;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return this;
	}
	,xy: function(weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var x = this.zpp_inner.x;
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var y = this.zpp_inner.y;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,toString: function() {
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp = "{ x: " + this.zpp_inner.x + " y: ";
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = tmp + this.zpp_inner.y + " z: ";
		var _this = this.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return tmp1 + this.zpp_inner.z + " }";
	}
};
var nape_geom_Winding = $hx_exports["nape"]["geom"]["Winding"] = function() {
};
nape_geom_Winding.__name__ = true;
nape_geom_Winding.get_UNDEFINED = function() {
	if(zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED = new nape_geom_Winding();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED;
};
nape_geom_Winding.get_CLOCKWISE = function() {
	if(zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE = new nape_geom_Winding();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE;
};
nape_geom_Winding.get_ANTICLOCKWISE = function() {
	if(zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE = new nape_geom_Winding();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE;
};
nape_geom_Winding.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED = new nape_geom_Winding();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.Winding_UNDEFINED) {
			return "UNDEFINED";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE = new nape_geom_Winding();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.Winding_CLOCKWISE) {
				return "CLOCKWISE";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE = new nape_geom_Winding();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.Winding_ANTICLOCKWISE) {
					return "ANTICLOCKWISE";
				} else {
					return "";
				}
			}
		}
	}
};
var nape_phys_Interactor = $hx_exports["nape"]["phys"]["Interactor"] = function() {
	this.zpp_inner_i = null;
};
nape_phys_Interactor.__name__ = true;
nape_phys_Interactor.prototype = {
	get_id: function() {
		return this.zpp_inner_i.id;
	}
	,get_userData: function() {
		if(this.zpp_inner_i.userData == null) {
			this.zpp_inner_i.userData = { };
		}
		return this.zpp_inner_i.userData;
	}
	,isShape: function() {
		return this.zpp_inner_i.ishape != null;
	}
	,isBody: function() {
		return this.zpp_inner_i.ibody != null;
	}
	,isCompound: function() {
		return this.zpp_inner_i.icompound != null;
	}
	,get_castShape: function() {
		if(this.zpp_inner_i.ishape != null) {
			return this.zpp_inner_i.ishape.outer;
		} else {
			return null;
		}
	}
	,get_castBody: function() {
		if(this.zpp_inner_i.ibody != null) {
			return this.zpp_inner_i.ibody.outer;
		} else {
			return null;
		}
	}
	,get_castCompound: function() {
		if(this.zpp_inner_i.icompound != null) {
			return this.zpp_inner_i.icompound.outer;
		} else {
			return null;
		}
	}
	,get_group: function() {
		if(this.zpp_inner_i.group == null) {
			return null;
		} else {
			return this.zpp_inner_i.group.outer;
		}
	}
	,set_group: function(group) {
		this.zpp_inner_i.immutable_midstep("Interactor::group");
		this.zpp_inner_i.setGroup(group == null ? null : group.zpp_inner);
		if(this.zpp_inner_i.group == null) {
			return null;
		} else {
			return this.zpp_inner_i.group.outer;
		}
	}
	,get_cbTypes: function() {
		if(this.zpp_inner_i.wrap_cbTypes == null) {
			this.zpp_inner_i.setupcbTypes();
		}
		return this.zpp_inner_i.wrap_cbTypes;
	}
	,toString: function() {
		return "";
	}
};
var nape_phys_Body = $hx_exports["nape"]["phys"]["Body"] = function(type,position) {
	this.debugDraw = true;
	this.zpp_inner = null;
	nape_phys_Interactor.call(this);
	this.zpp_inner = new zpp_$nape_phys_ZPP_$Body();
	this.zpp_inner.outer = this;
	this.zpp_inner.outer_i = this;
	this.zpp_inner_i = this.zpp_inner;
	if(position != null) {
		var _this = position.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.posx = position.zpp_inner.x;
		var _this = position.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.posy = position.zpp_inner.y;
	} else {
		this.zpp_inner.posx = 0;
		this.zpp_inner.posy = 0;
	}
	var type1;
	if(type == null) {
		if(zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC = new nape_phys_BodyType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		type1 = zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC;
	} else {
		type1 = type;
	}
	this.zpp_inner.immutable_midstep("Body::type");
	if(zpp_$nape_phys_ZPP_$Body.types[this.zpp_inner.type] != type1) {
		var ntype;
		if(zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC = new nape_phys_BodyType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(type1 == zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC) {
			ntype = 2;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC = new nape_phys_BodyType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			ntype = type1 == zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC ? 3 : 1;
		}
		if(ntype == 1 && this.zpp_inner.space != null) {
			this.zpp_inner.velx = 0;
			this.zpp_inner.vely = 0;
			this.zpp_inner.angvel = 0;
		}
		this.zpp_inner.invalidate_type();
		if(this.zpp_inner.space != null) {
			this.zpp_inner.space.transmitType(this.zpp_inner,ntype);
		} else {
			this.zpp_inner.type = ntype;
		}
	}
	if(position != null) {
		if(position.zpp_inner.weak) {
			var inner = position.zpp_inner;
			position.zpp_inner.outer = null;
			position.zpp_inner = null;
			var o = position;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
	}
	this.zpp_inner_i.insert_cbtype(zpp_$nape_callbacks_ZPP_$CbType.ANY_BODY.zpp_inner);
};
nape_phys_Body.__name__ = true;
nape_phys_Body.__super__ = nape_phys_Interactor;
nape_phys_Body.prototype = $extend(nape_phys_Interactor.prototype,{
	get_type: function() {
		return zpp_$nape_phys_ZPP_$Body.types[this.zpp_inner.type];
	}
	,set_type: function(type) {
		this.zpp_inner.immutable_midstep("Body::type");
		if(zpp_$nape_phys_ZPP_$Body.types[this.zpp_inner.type] != type) {
			var ntype;
			if(zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC = new nape_phys_BodyType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(type == zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC) {
				ntype = 2;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC = new nape_phys_BodyType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				ntype = type == zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC ? 3 : 1;
			}
			if(ntype == 1 && this.zpp_inner.space != null) {
				this.zpp_inner.velx = 0;
				this.zpp_inner.vely = 0;
				this.zpp_inner.angvel = 0;
			}
			this.zpp_inner.invalidate_type();
			if(this.zpp_inner.space != null) {
				this.zpp_inner.space.transmitType(this.zpp_inner,ntype);
			} else {
				this.zpp_inner.type = ntype;
			}
		}
		return zpp_$nape_phys_ZPP_$Body.types[this.zpp_inner.type];
	}
	,get_isBullet: function() {
		return this.zpp_inner.bulletEnabled;
	}
	,set_isBullet: function(isBullet) {
		this.zpp_inner.bulletEnabled = isBullet;
		return this.zpp_inner.bulletEnabled;
	}
	,get_disableCCD: function() {
		return this.zpp_inner.disableCCD;
	}
	,set_disableCCD: function(disableCCD) {
		this.zpp_inner.disableCCD = disableCCD;
		return this.zpp_inner.disableCCD;
	}
	,integrate: function(deltaTime) {
		this.zpp_inner.immutable_midstep("Body::space");
		if(deltaTime == 0) {
			return this;
		}
		var cur = this.zpp_inner;
		cur.sweepTime = 0;
		cur.sweep_angvel = cur.angvel;
		var delta = deltaTime - cur.sweepTime;
		if(delta != 0) {
			cur.sweepTime = deltaTime;
			var t = delta;
			cur.posx += cur.velx * t;
			cur.posy += cur.vely * t;
			if(cur.angvel != 0) {
				var dr = cur.sweep_angvel * delta;
				cur.rot += dr;
				if(dr * dr > 0.0001) {
					cur.axisx = Math.sin(cur.rot);
					cur.axisy = Math.cos(cur.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * cur.axisx + dr * cur.axisy) * m;
					cur.axisy = (p * cur.axisy - dr * cur.axisx) * m;
					cur.axisx = nx;
				}
			}
		}
		var cx_ite = cur.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			if(s.type == 1) {
				s.polygon.invalidate_gverts();
				s.polygon.invalidate_gaxi();
			}
			s.invalidate_worldCOM();
			cx_ite = cx_ite.next;
		}
		cur.zip_worldCOM = true;
		cur.zip_axis = true;
		var cx_ite = cur.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			if(s.type == 1) {
				s.polygon.invalidate_gverts();
				s.polygon.invalidate_gaxi();
			}
			s.invalidate_worldCOM();
			cx_ite = cx_ite.next;
		}
		cur.zip_worldCOM = true;
		cur.sweepTime = 0;
		return this;
	}
	,isStatic: function() {
		return this.zpp_inner.type == 1;
	}
	,isDynamic: function() {
		return this.zpp_inner.type == 2;
	}
	,isKinematic: function() {
		return this.zpp_inner.type == 3;
	}
	,get_shapes: function() {
		return this.zpp_inner.wrap_shapes;
	}
	,get_compound: function() {
		if(this.zpp_inner.compound == null) {
			return null;
		} else {
			return this.zpp_inner.compound.outer;
		}
	}
	,set_compound: function(compound) {
		if((this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer) != compound) {
			if((this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer) != null) {
				(this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer).zpp_inner.wrap_bodies.remove(this);
			}
			if(compound != null) {
				var _this = compound.zpp_inner.wrap_bodies;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			}
		}
		if(this.zpp_inner.compound == null) {
			return null;
		} else {
			return this.zpp_inner.compound.outer;
		}
	}
	,get_space: function() {
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,set_space: function(space) {
		this.zpp_inner.immutable_midstep("Body::space");
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != space) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				this.zpp_inner.component.woken = false;
			}
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				(this.zpp_inner.space == null ? null : this.zpp_inner.space.outer).zpp_inner.wrap_bodies.remove(this);
			}
			if(space != null) {
				var _this = space.zpp_inner.wrap_bodies;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			}
		}
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,get_arbiters: function() {
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		return this.zpp_inner.wrap_arbiters;
	}
	,get_isSleeping: function() {
		return this.zpp_inner.component.sleeping;
	}
	,get_constraints: function() {
		if(this.zpp_inner.wrap_constraints == null) {
			this.zpp_inner.wrap_constraints = zpp_$nape_util_ZPP_$ConstraintList.get(this.zpp_inner.constraints,true);
		}
		return this.zpp_inner.wrap_constraints;
	}
	,copy: function() {
		return this.zpp_inner.copy();
	}
	,get_position: function() {
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		return this.zpp_inner.wrap_pos;
	}
	,set_position: function(position) {
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		var _this = this.zpp_inner.wrap_pos;
		var _this1 = position.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = position.zpp_inner.x;
		var _this1 = position.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = position.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(position.zpp_inner.weak) {
			var inner = position.zpp_inner;
			position.zpp_inner.outer = null;
			position.zpp_inner = null;
			var o = position;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		return this.zpp_inner.wrap_pos;
	}
	,get_velocity: function() {
		if(this.zpp_inner.wrap_vel == null) {
			this.zpp_inner.setupVelocity();
		}
		return this.zpp_inner.wrap_vel;
	}
	,set_velocity: function(velocity) {
		if(this.zpp_inner.wrap_vel == null) {
			this.zpp_inner.setupVelocity();
		}
		var _this = this.zpp_inner.wrap_vel;
		var _this1 = velocity.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = velocity.zpp_inner.x;
		var _this1 = velocity.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = velocity.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(velocity.zpp_inner.weak) {
			var inner = velocity.zpp_inner;
			velocity.zpp_inner.outer = null;
			velocity.zpp_inner = null;
			var o = velocity;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_vel == null) {
			this.zpp_inner.setupVelocity();
		}
		return this.zpp_inner.wrap_vel;
	}
	,setVelocityFromTarget: function(targetPosition,targetRotation,deltaTime) {
		var idt = 1 / deltaTime;
		if(this.zpp_inner.wrap_vel == null) {
			this.zpp_inner.setupVelocity();
		}
		var _this = this.zpp_inner.wrap_vel;
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		var vector = targetPosition.sub(this.zpp_inner.wrap_pos,true).muleq(idt);
		var _this1 = vector.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = vector.zpp_inner.x;
		var _this1 = vector.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = vector.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		var angularVel = (targetRotation - this.zpp_inner.rot) * idt;
		if(this.zpp_inner.angvel != angularVel) {
			this.zpp_inner.angvel = angularVel;
			this.zpp_inner.wake();
		}
		if(targetPosition.zpp_inner.weak) {
			var inner = targetPosition.zpp_inner;
			targetPosition.zpp_inner.outer = null;
			targetPosition.zpp_inner = null;
			var o = targetPosition;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,get_kinematicVel: function() {
		if(this.zpp_inner.wrap_kinvel == null) {
			this.zpp_inner.setupkinvel();
		}
		return this.zpp_inner.wrap_kinvel;
	}
	,set_kinematicVel: function(kinematicVel) {
		if(this.zpp_inner.wrap_kinvel == null) {
			this.zpp_inner.setupkinvel();
		}
		var _this = this.zpp_inner.wrap_kinvel;
		var _this1 = kinematicVel.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = kinematicVel.zpp_inner.x;
		var _this1 = kinematicVel.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = kinematicVel.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(kinematicVel.zpp_inner.weak) {
			var inner = kinematicVel.zpp_inner;
			kinematicVel.zpp_inner.outer = null;
			kinematicVel.zpp_inner = null;
			var o = kinematicVel;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_kinvel == null) {
			this.zpp_inner.setupkinvel();
		}
		return this.zpp_inner.wrap_kinvel;
	}
	,get_surfaceVel: function() {
		if(this.zpp_inner.wrap_svel == null) {
			this.zpp_inner.setupsvel();
		}
		return this.zpp_inner.wrap_svel;
	}
	,set_surfaceVel: function(surfaceVel) {
		if(this.zpp_inner.wrap_svel == null) {
			this.zpp_inner.setupsvel();
		}
		var _this = this.zpp_inner.wrap_svel;
		var _this1 = surfaceVel.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = surfaceVel.zpp_inner.x;
		var _this1 = surfaceVel.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = surfaceVel.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(surfaceVel.zpp_inner.weak) {
			var inner = surfaceVel.zpp_inner;
			surfaceVel.zpp_inner.outer = null;
			surfaceVel.zpp_inner = null;
			var o = surfaceVel;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_svel == null) {
			this.zpp_inner.setupsvel();
		}
		return this.zpp_inner.wrap_svel;
	}
	,get_force: function() {
		if(this.zpp_inner.wrap_force == null) {
			this.zpp_inner.setupForce();
		}
		return this.zpp_inner.wrap_force;
	}
	,set_force: function(force) {
		if(this.zpp_inner.wrap_force == null) {
			this.zpp_inner.setupForce();
		}
		var _this = this.zpp_inner.wrap_force;
		var _this1 = force.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = force.zpp_inner.x;
		var _this1 = force.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = force.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(force.zpp_inner.weak) {
			var inner = force.zpp_inner;
			force.zpp_inner.outer = null;
			force.zpp_inner = null;
			var o = force;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_force == null) {
			this.zpp_inner.setupForce();
		}
		return this.zpp_inner.wrap_force;
	}
	,get_constraintVelocity: function() {
		if(this.zpp_inner.wrapcvel == null) {
			this.zpp_inner.setup_cvel();
		}
		return this.zpp_inner.wrapcvel;
	}
	,get_rotation: function() {
		return this.zpp_inner.rot;
	}
	,set_rotation: function(rotation) {
		this.zpp_inner.immutable_midstep("Body::rotation");
		if(this.zpp_inner.rot != rotation) {
			this.zpp_inner.rot = rotation;
			var _this = this.zpp_inner;
			_this.zip_axis = true;
			var cx_ite = _this.shapes.head;
			while(cx_ite != null) {
				var s = cx_ite.elt;
				if(s.type == 1) {
					s.polygon.invalidate_gverts();
					s.polygon.invalidate_gaxi();
				}
				s.invalidate_worldCOM();
				cx_ite = cx_ite.next;
			}
			_this.zip_worldCOM = true;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.rot;
	}
	,get_angularVel: function() {
		return this.zpp_inner.angvel;
	}
	,set_angularVel: function(angularVel) {
		if(this.zpp_inner.angvel != angularVel) {
			this.zpp_inner.angvel = angularVel;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.angvel;
	}
	,get_kinAngVel: function() {
		return this.zpp_inner.kinangvel;
	}
	,set_kinAngVel: function(kinAngVel) {
		if(this.zpp_inner.kinangvel != kinAngVel) {
			this.zpp_inner.kinangvel = kinAngVel;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.kinangvel;
	}
	,get_torque: function() {
		return this.zpp_inner.torque;
	}
	,set_torque: function(torque) {
		if(this.zpp_inner.torque != torque) {
			this.zpp_inner.torque = torque;
			this.zpp_inner.wake();
		}
		return this.zpp_inner.torque;
	}
	,get_bounds: function() {
		return this.zpp_inner.aabb.wrapper();
	}
	,get_allowMovement: function() {
		return !this.zpp_inner.nomove;
	}
	,set_allowMovement: function(allowMovement) {
		this.zpp_inner.immutable_midstep("Body::" + (allowMovement == null ? "null" : "" + allowMovement));
		if(!this.zpp_inner.nomove != allowMovement) {
			this.zpp_inner.nomove = !allowMovement;
			this.zpp_inner.invalidate_mass();
		}
		return !this.zpp_inner.nomove;
	}
	,get_allowRotation: function() {
		return !this.zpp_inner.norotate;
	}
	,set_allowRotation: function(allowRotation) {
		this.zpp_inner.immutable_midstep("Body::" + (allowRotation == null ? "null" : "" + allowRotation));
		if(!this.zpp_inner.norotate != allowRotation) {
			this.zpp_inner.norotate = !allowRotation;
			this.zpp_inner.invalidate_inertia();
		}
		return !this.zpp_inner.norotate;
	}
	,get_massMode: function() {
		if(zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT = new nape_phys_MassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp = zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT;
		if(zpp_$nape_util_ZPP_$Flags.MassMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.MassMode_FIXED = new nape_phys_MassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return [tmp,zpp_$nape_util_ZPP_$Flags.MassMode_FIXED][this.zpp_inner.massMode];
	}
	,set_massMode: function(massMode) {
		this.zpp_inner.immutable_midstep("Body::massMode");
		if(zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT = new nape_phys_MassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		this.zpp_inner.massMode = massMode == zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT ? 0 : 1;
		this.zpp_inner.invalidate_mass();
		if(zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT = new nape_phys_MassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp = zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT;
		if(zpp_$nape_util_ZPP_$Flags.MassMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.MassMode_FIXED = new nape_phys_MassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return [tmp,zpp_$nape_util_ZPP_$Flags.MassMode_FIXED][this.zpp_inner.massMode];
	}
	,get_constraintMass: function() {
		if(!this.zpp_inner.world) {
			this.zpp_inner.validate_mass();
		}
		return this.zpp_inner.smass;
	}
	,get_mass: function() {
		this.zpp_inner.validate_mass();
		return this.zpp_inner.cmass;
	}
	,set_mass: function(mass) {
		this.zpp_inner.immutable_midstep("Body::mass");
		this.zpp_inner.massMode = 1;
		this.zpp_inner.cmass = mass;
		this.zpp_inner.invalidate_mass();
		this.zpp_inner.validate_mass();
		return this.zpp_inner.cmass;
	}
	,get_gravMassMode: function() {
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp = zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT;
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp1 = zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED;
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return [tmp,tmp1,zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED][this.zpp_inner.massMode];
	}
	,set_gravMassMode: function(gravMassMode) {
		this.zpp_inner.immutable_midstep("Body::gravMassMode");
		var tmp;
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(gravMassMode == zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED) {
			tmp = 2;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT = new nape_phys_GravMassMode();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			tmp = gravMassMode == zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT ? 0 : 1;
		}
		this.zpp_inner.gravMassMode = tmp;
		this.zpp_inner.invalidate_gravMass();
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp = zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT;
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp1 = zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED;
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return [tmp,tmp1,zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED][this.zpp_inner.massMode];
	}
	,get_gravMass: function() {
		this.zpp_inner.validate_gravMass();
		return this.zpp_inner.gravMass;
	}
	,set_gravMass: function(gravMass) {
		this.zpp_inner.immutable_midstep("Body::gravMass");
		this.zpp_inner.gravMassMode = 1;
		this.zpp_inner.gravMass = gravMass;
		this.zpp_inner.invalidate_gravMass();
		this.zpp_inner.validate_gravMass();
		return this.zpp_inner.gravMass;
	}
	,get_gravMassScale: function() {
		this.zpp_inner.validate_gravMassScale();
		return this.zpp_inner.gravMassScale;
	}
	,set_gravMassScale: function(gravMassScale) {
		this.zpp_inner.immutable_midstep("Body::gravMassScale");
		this.zpp_inner.gravMassMode = 2;
		this.zpp_inner.gravMassScale = gravMassScale;
		this.zpp_inner.invalidate_gravMassScale();
		this.zpp_inner.validate_gravMassScale();
		return this.zpp_inner.gravMassScale;
	}
	,get_inertiaMode: function() {
		if(zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT = new nape_phys_InertiaMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp = zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT;
		if(zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED = new nape_phys_InertiaMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return [tmp,zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED][this.zpp_inner.inertiaMode];
	}
	,set_inertiaMode: function(inertiaMode) {
		this.zpp_inner.immutable_midstep("Body::inertiaMode");
		if(zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED = new nape_phys_InertiaMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		this.zpp_inner.inertiaMode = inertiaMode == zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED ? 1 : 0;
		this.zpp_inner.invalidate_inertia();
		if(zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT = new nape_phys_InertiaMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		var tmp = zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT;
		if(zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED = new nape_phys_InertiaMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		return [tmp,zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED][this.zpp_inner.inertiaMode];
	}
	,get_constraintInertia: function() {
		if(!this.zpp_inner.world) {
			this.zpp_inner.validate_inertia();
		}
		return this.zpp_inner.sinertia;
	}
	,get_inertia: function() {
		this.zpp_inner.validate_inertia();
		return this.zpp_inner.cinertia;
	}
	,set_inertia: function(inertia) {
		this.zpp_inner.immutable_midstep("Body::inertia");
		this.zpp_inner.inertiaMode = 1;
		this.zpp_inner.cinertia = inertia;
		this.zpp_inner.invalidate_inertia();
		this.zpp_inner.validate_inertia();
		return this.zpp_inner.cinertia;
	}
	,connectedBodies: function(depth,output) {
		if(depth == null) {
			depth = -1;
		}
		return this.zpp_inner.connectedBodies(depth,output);
	}
	,interactingBodies: function(type,depth,output) {
		if(depth == null) {
			depth = -1;
		}
		var arbiter_type;
		if(type == null) {
			arbiter_type = zpp_$nape_dynamics_ZPP_$Arbiter.COL | zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR | zpp_$nape_dynamics_ZPP_$Arbiter.FLUID;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(type == zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION) {
				arbiter_type = zpp_$nape_dynamics_ZPP_$Arbiter.COL;
			} else {
				if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				arbiter_type = type == zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR ? zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR : zpp_$nape_dynamics_ZPP_$Arbiter.FLUID;
			}
		}
		return this.zpp_inner.interactingBodies(arbiter_type,depth,output);
	}
	,crushFactor: function() {
		var msum = 0.0;
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = 0;
			ret1.y = 0;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == 0) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == 0;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = 0;
				ret.zpp_inner.y = 0;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		var jsum = ret;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var arb = _g.zpp_inner.at(_g.zpp_i++);
			var imp3 = arb.totalImpulse(this);
			var imp = imp3.xy();
			jsum.addeq(imp);
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var msum1 = imp.zpp_inner.x;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var msum2 = msum1 * imp.zpp_inner.x;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			var msum3 = imp.zpp_inner.y;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			msum += Math.sqrt(msum2 + msum3 * imp.zpp_inner.y);
			var inner = imp.zpp_inner;
			imp.zpp_inner.outer = null;
			imp.zpp_inner = null;
			var o = imp;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			imp3.dispose();
		}
		if(this.zpp_inner.wrap_constraints == null) {
			this.zpp_inner.wrap_constraints = zpp_$nape_util_ZPP_$ConstraintList.get(this.zpp_inner.constraints,true);
		}
		var _this = this.zpp_inner.wrap_constraints;
		_this.zpp_inner.valmod();
		var _g = nape_constraint_ConstraintIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var con = _g.zpp_inner.at(_g.zpp_i++);
			var imp3 = con.bodyImpulse(this);
			var imp = imp3.xy();
			jsum.addeq(imp);
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var msum1 = imp.zpp_inner.x;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			var msum2 = msum1 * imp.zpp_inner.x;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			var msum3 = imp.zpp_inner.y;
			var _this4 = imp.zpp_inner;
			if(_this4._validate != null) {
				_this4._validate();
			}
			msum += Math.sqrt(msum2 + msum3 * imp.zpp_inner.y);
			var inner = imp.zpp_inner;
			imp.zpp_inner.outer = null;
			imp.zpp_inner = null;
			var o = imp;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			imp3.dispose();
		}
		var _this = jsum.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = jsum.zpp_inner.x;
		var _this = jsum.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret1 = ret * jsum.zpp_inner.x;
		var _this = jsum.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = jsum.zpp_inner.y;
		var _this = jsum.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret2 = msum - Math.sqrt(ret1 + ret * jsum.zpp_inner.y);
		this.zpp_inner.validate_mass();
		var ret = ret2 / (this.zpp_inner.cmass * (this.zpp_inner.space == null ? null : this.zpp_inner.space.outer).zpp_inner.pre_dt);
		var inner = jsum.zpp_inner;
		jsum.zpp_inner.outer = null;
		jsum.zpp_inner = null;
		var o = jsum;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return ret;
	}
	,localPointToWorld: function(point,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this.zip_axis) {
			_this.zip_axis = false;
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		}
		var tempx = 0.0;
		var tempy = 0.0;
		var tempx1 = this.zpp_inner.axisy;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tempx2 = tempx1 * point.zpp_inner.x;
		var tempx1 = this.zpp_inner.axisx;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tempx = tempx2 - tempx1 * point.zpp_inner.y;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tempy1 = point.zpp_inner.x * this.zpp_inner.axisx;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tempy = tempy1 + point.zpp_inner.y * this.zpp_inner.axisy;
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		var x = tempx + this.zpp_inner.posx;
		var y = tempy + this.zpp_inner.posy;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,worldPointToLocal: function(point,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this.zip_axis) {
			_this.zip_axis = false;
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		}
		var tempx = 0.0;
		var tempy = 0.0;
		var pointx = 0.0;
		var pointy = 0.0;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		pointx = point.zpp_inner.x - this.zpp_inner.posx;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		pointy = point.zpp_inner.y - this.zpp_inner.posy;
		tempx = pointx * this.zpp_inner.axisy + pointy * this.zpp_inner.axisx;
		tempy = pointy * this.zpp_inner.axisy - pointx * this.zpp_inner.axisx;
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		var x = tempx;
		var y = tempy;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,localVectorToWorld: function(vector,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this.zip_axis) {
			_this.zip_axis = false;
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		}
		var tempx = 0.0;
		var tempy = 0.0;
		var tempx1 = this.zpp_inner.axisy;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tempx2 = tempx1 * vector.zpp_inner.x;
		var tempx1 = this.zpp_inner.axisx;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tempx = tempx2 - tempx1 * vector.zpp_inner.y;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tempy1 = vector.zpp_inner.x * this.zpp_inner.axisx;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tempy = tempy1 + vector.zpp_inner.y * this.zpp_inner.axisy;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		var x = tempx;
		var y = tempy;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,worldVectorToLocal: function(vector,weak) {
		if(weak == null) {
			weak = false;
		}
		var _this = this.zpp_inner;
		if(_this.zip_axis) {
			_this.zip_axis = false;
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		}
		var tempx = 0.0;
		var tempy = 0.0;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tempx1 = vector.zpp_inner.x * this.zpp_inner.axisy;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tempx = tempx1 + vector.zpp_inner.y * this.zpp_inner.axisx;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tempy1 = vector.zpp_inner.y * this.zpp_inner.axisy;
		var _this = vector.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		tempy = tempy1 - vector.zpp_inner.x * this.zpp_inner.axisx;
		if(vector.zpp_inner.weak) {
			var inner = vector.zpp_inner;
			vector.zpp_inner.outer = null;
			vector.zpp_inner = null;
			var o = vector;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		var x = tempx;
		var y = tempy;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		return ret;
	}
	,applyImpulse: function(impulse,pos,sleepable) {
		if(sleepable == null) {
			sleepable = false;
		}
		if(sleepable && this.zpp_inner.component.sleeping) {
			if(impulse.zpp_inner.weak) {
				var inner = impulse.zpp_inner;
				impulse.zpp_inner.outer = null;
				impulse.zpp_inner = null;
				var o = impulse;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o = inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			}
			if(pos != null) {
				if(pos.zpp_inner.weak) {
					var inner = pos.zpp_inner;
					pos.zpp_inner.outer = null;
					pos.zpp_inner = null;
					var o = pos;
					o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
					var o = inner;
					if(o.outer != null) {
						o.outer.zpp_inner = null;
						o.outer = null;
					}
					o._isimmutable = null;
					o._validate = null;
					o._invalidate = null;
					o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				}
			}
			return this;
		}
		this.zpp_inner.validate_mass();
		var t = this.zpp_inner.imass;
		var fh = this.zpp_inner;
		var fh1 = fh.velx;
		var _this = impulse.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		fh.velx = fh1 + impulse.zpp_inner.x * t;
		var fh = this.zpp_inner;
		var fh1 = fh.vely;
		var _this = impulse.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		fh.vely = fh1 + impulse.zpp_inner.y * t;
		if(pos != null) {
			var rx = 0.0;
			var ry = 0.0;
			var _this = pos.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			rx = pos.zpp_inner.x - this.zpp_inner.posx;
			var _this = pos.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			ry = pos.zpp_inner.y - this.zpp_inner.posy;
			this.zpp_inner.validate_inertia();
			var fh = this.zpp_inner;
			var fh1 = fh.angvel;
			var _this = impulse.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var tmp = impulse.zpp_inner.y * rx;
			var _this = impulse.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			fh.angvel = fh1 + (tmp - impulse.zpp_inner.x * ry) * this.zpp_inner.iinertia;
			if(pos.zpp_inner.weak) {
				var inner = pos.zpp_inner;
				pos.zpp_inner.outer = null;
				pos.zpp_inner = null;
				var o = pos;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o = inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			}
		}
		if(!sleepable) {
			if(this.zpp_inner.type == 2) {
				this.zpp_inner.wake();
			}
		}
		if(impulse.zpp_inner.weak) {
			var inner = impulse.zpp_inner;
			impulse.zpp_inner.outer = null;
			impulse.zpp_inner = null;
			var o = impulse;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,applyAngularImpulse: function(impulse,sleepable) {
		if(sleepable == null) {
			sleepable = false;
		}
		if(sleepable && this.zpp_inner.component.sleeping) {
			return this;
		}
		this.zpp_inner.validate_inertia();
		this.zpp_inner.angvel += impulse * this.zpp_inner.iinertia;
		if(!sleepable) {
			if(this.zpp_inner.type == 2) {
				this.zpp_inner.wake();
			}
		}
		return this;
	}
	,translateShapes: function(translation) {
		this.zpp_inner.immutable_midstep("Body::translateShapes()");
		var weak = translation.zpp_inner.weak;
		translation.zpp_inner.weak = false;
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			s.outer.translate(translation);
			cx_ite = cx_ite.next;
		}
		translation.zpp_inner.weak = weak;
		if(translation.zpp_inner.weak) {
			var inner = translation.zpp_inner;
			translation.zpp_inner.outer = null;
			translation.zpp_inner = null;
			var o = translation;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,rotateShapes: function(angle) {
		this.zpp_inner.immutable_midstep("Body::rotateShapes()");
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			s.outer.rotate(angle);
			cx_ite = cx_ite.next;
		}
		return this;
	}
	,scaleShapes: function(scaleX,scaleY) {
		this.zpp_inner.immutable_midstep("Body::scaleShapes()");
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			s.outer.scale(scaleX,scaleY);
			cx_ite = cx_ite.next;
		}
		return this;
	}
	,transformShapes: function(matrix) {
		this.zpp_inner.immutable_midstep("Body::transformShapes()");
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			s.outer.transform(matrix);
			cx_ite = cx_ite.next;
		}
		return this;
	}
	,align: function() {
		this.zpp_inner.immutable_midstep("Body::align()");
		this.zpp_inner.validate_localCOM();
		var x = -this.zpp_inner.localCOMx;
		var y = -this.zpp_inner.localCOMy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		var dx = ret;
		this.translateShapes(dx);
		var dx2 = this.localVectorToWorld(dx);
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		this.zpp_inner.wrap_pos.subeq(dx2);
		if(this.zpp_inner.pre_posx < Infinity) {
			var t = 1.0;
			var fh = this.zpp_inner;
			var fh1 = fh.pre_posx;
			var _this = dx2.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			fh.pre_posx = fh1 - dx2.zpp_inner.x * t;
			var fh = this.zpp_inner;
			var fh1 = fh.pre_posy;
			var _this = dx2.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			fh.pre_posy = fh1 - dx2.zpp_inner.y * t;
		}
		var inner = dx.zpp_inner;
		dx.zpp_inner.outer = null;
		dx.zpp_inner = null;
		var o = dx;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		var inner = dx2.zpp_inner;
		dx2.zpp_inner.outer = null;
		dx2.zpp_inner = null;
		var o = dx2;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return this;
	}
	,rotate: function(centre,angle) {
		var weak = centre.zpp_inner.weak;
		centre.zpp_inner.weak = false;
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		var del = this.zpp_inner.wrap_pos.sub(centre);
		del.rotate(angle);
		var position = centre.add(del,true);
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		var _this = this.zpp_inner.wrap_pos;
		var _this1 = position.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = position.zpp_inner.x;
		var _this1 = position.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = position.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(position.zpp_inner.weak) {
			var inner = position.zpp_inner;
			position.zpp_inner.outer = null;
			position.zpp_inner = null;
			var o = position;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_pos == null) {
			this.zpp_inner.setupPosition();
		}
		var inner = del.zpp_inner;
		del.zpp_inner.outer = null;
		del.zpp_inner = null;
		var o = del;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		var rotation = this.zpp_inner.rot + angle;
		this.zpp_inner.immutable_midstep("Body::rotation");
		if(this.zpp_inner.rot != rotation) {
			this.zpp_inner.rot = rotation;
			var _this = this.zpp_inner;
			_this.zip_axis = true;
			var cx_ite = _this.shapes.head;
			while(cx_ite != null) {
				var s = cx_ite.elt;
				if(s.type == 1) {
					s.polygon.invalidate_gverts();
					s.polygon.invalidate_gaxi();
				}
				s.invalidate_worldCOM();
				cx_ite = cx_ite.next;
			}
			_this.zip_worldCOM = true;
			this.zpp_inner.wake();
		}
		centre.zpp_inner.weak = weak;
		if(centre.zpp_inner.weak) {
			var inner = centre.zpp_inner;
			centre.zpp_inner.outer = null;
			centre.zpp_inner = null;
			var o = centre;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,setShapeMaterials: function(material) {
		this.zpp_inner.immutable_midstep("Body::setShapeMaterials()");
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			var _this = s.outer;
			_this.zpp_inner.immutable_midstep("Shape::material");
			_this.zpp_inner.setMaterial(material.zpp_inner);
			_this.zpp_inner.material.wrapper();
			cx_ite = cx_ite.next;
		}
		return this;
	}
	,setShapeFilters: function(filter) {
		this.zpp_inner.immutable_midstep("Body::setShapeFilters()");
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			var _this = s.outer;
			_this.zpp_inner.immutable_midstep("Shape::filter");
			_this.zpp_inner.setFilter(filter.zpp_inner);
			_this.zpp_inner.filter.wrapper();
			cx_ite = cx_ite.next;
		}
		return this;
	}
	,setShapeFluidProperties: function(fluidProperties) {
		this.zpp_inner.immutable_midstep("Body::setShapeFluidProperties()");
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			var _this = s.outer;
			_this.zpp_inner.setFluid(fluidProperties.zpp_inner);
			_this.zpp_inner.immutable_midstep("Shape::fluidProperties");
			if(_this.zpp_inner.fluidProperties == null) {
				_this.zpp_inner.setFluid(new nape_phys_FluidProperties().zpp_inner);
			}
			_this.zpp_inner.fluidProperties.wrapper();
			cx_ite = cx_ite.next;
		}
		return this;
	}
	,get_localCOM: function() {
		if(this.zpp_inner.wrap_localCOM == null) {
			var x = this.zpp_inner.localCOMx;
			var y = this.zpp_inner.localCOMy;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			this.zpp_inner.wrap_localCOM = ret;
			this.zpp_inner.wrap_localCOM.zpp_inner._inuse = true;
			this.zpp_inner.wrap_localCOM.zpp_inner._immutable = true;
			this.zpp_inner.wrap_localCOM.zpp_inner._validate = ($_=this.zpp_inner,$bind($_,$_.getlocalCOM));
		}
		return this.zpp_inner.wrap_localCOM;
	}
	,get_worldCOM: function() {
		if(this.zpp_inner.wrap_worldCOM == null) {
			var x = this.zpp_inner.worldCOMx;
			var y = this.zpp_inner.worldCOMy;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			this.zpp_inner.wrap_worldCOM = ret;
			this.zpp_inner.wrap_worldCOM.zpp_inner._inuse = true;
			this.zpp_inner.wrap_worldCOM.zpp_inner._immutable = true;
			this.zpp_inner.wrap_worldCOM.zpp_inner._validate = ($_=this.zpp_inner,$bind($_,$_.getworldCOM));
		}
		return this.zpp_inner.wrap_worldCOM;
	}
	,normalImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			var imp = (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? _this.zpp_inner.colarb.outer_zn : null).normalImpulse(this,freshOnly);
			var t = 1;
			var t1 = t;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,tangentImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			var imp = (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? _this.zpp_inner.colarb.outer_zn : null).tangentImpulse(this,freshOnly);
			var t = 1;
			var t1 = t;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,totalContactsImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			var imp = (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? _this.zpp_inner.colarb.outer_zn : null).totalImpulse(this,freshOnly);
			var t = 1;
			var t1 = t;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,rollingImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var ret = 0.0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			ret += (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? _this.zpp_inner.colarb.outer_zn : null).rollingImpulse(this,freshOnly);
		}
		return ret;
	}
	,buoyancyImpulse: function(body) {
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			var imp = (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID ? _this.zpp_inner.fluidarb.outer_zn : null).buoyancyImpulse(this);
			var t = 1;
			var t1 = t;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,dragImpulse: function(body) {
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			var imp = (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID ? _this.zpp_inner.fluidarb.outer_zn : null).dragImpulse(this);
			var t = 1;
			var t1 = t;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,totalFluidImpulse: function(body) {
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var _this = arb.wrapper();
			var imp = (_this.zpp_inner.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID ? _this.zpp_inner.fluidarb.outer_zn : null).totalImpulse(this);
			var t = 1;
			var t1 = t;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this3 = imp.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,constraintsImpulse: function() {
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var cx_ite = this.zpp_inner.constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			var imp = con.outer.bodyImpulse(this);
			var t = 1;
			var t1 = t;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
			cx_ite = cx_ite.next;
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,totalImpulse: function(body,freshOnly) {
		if(freshOnly == null) {
			freshOnly = false;
		}
		var retx = 0;
		var rety = 0;
		var retz = 0;
		var arbs = this.zpp_inner.arbiters;
		if(this.zpp_inner.wrap_arbiters == null) {
			this.zpp_inner.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.zpp_inner.arbiters,true);
		}
		var _g = this.zpp_inner.wrap_arbiters.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_dynamics_ArbiterIterator.zpp_pool;
				nape_dynamics_ArbiterIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var oarb = _g.zpp_inner.at(_g.zpp_i++);
			var arb = oarb.zpp_inner;
			if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR) {
				continue;
			}
			if(body != null && arb.b2 != body.zpp_inner && arb.b1 != body.zpp_inner) {
				continue;
			}
			var imp = arb.wrapper().totalImpulse(this,freshOnly);
			var t = 1;
			var t1 = t;
			var _this = imp.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			retx += imp.zpp_inner.x * t1;
			var _this1 = imp.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			rety += imp.zpp_inner.y * t1;
			var _this2 = imp.zpp_inner;
			if(_this2._validate != null) {
				_this2._validate();
			}
			retz += imp.zpp_inner.z * t;
			imp.dispose();
		}
		var cx_ite = this.zpp_inner.constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			if(con.active) {
				var imp = con.outer.bodyImpulse(this);
				var t = 1;
				var t1 = t;
				var _this = imp.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				retx += imp.zpp_inner.x * t1;
				var _this1 = imp.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				rety += imp.zpp_inner.y * t1;
				var _this2 = imp.zpp_inner;
				if(_this2._validate != null) {
					_this2._validate();
				}
				retz += imp.zpp_inner.z * t;
				imp.dispose();
			}
			cx_ite = cx_ite.next;
		}
		return nape_geom_Vec3.get(retx,rety,retz);
	}
	,contains: function(point) {
		var wasWeak = point.zpp_inner.weak;
		point.zpp_inner.weak = false;
		var retvar;
		retvar = false;
		var cx_ite = this.zpp_inner.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			if(s.outer.contains(point)) {
				retvar = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		point.zpp_inner.weak = wasWeak;
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return retvar;
	}
	,toString: function() {
		return (this.zpp_inner.world ? "(space::world" : "(" + (this.zpp_inner.type == 2 ? "dynamic" : this.zpp_inner.type == 1 ? "static" : "kinematic")) + ")#" + this.zpp_inner_i.id;
	}
});
var nape_phys_BodyIterator = $hx_exports["nape"]["phys"]["BodyIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_phys_BodyIterator.__name__ = true;
nape_phys_BodyIterator.get = function(list) {
	var ret;
	if(nape_phys_BodyIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$BodyList.internal = true;
		var ret1 = new nape_phys_BodyIterator();
		zpp_$nape_util_ZPP_$BodyList.internal = false;
		ret = ret1;
	} else {
		var r = nape_phys_BodyIterator.zpp_pool;
		nape_phys_BodyIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_phys_BodyIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_phys_BodyIterator.zpp_pool;
			nape_phys_BodyIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_phys_BodyList = $hx_exports["nape"]["phys"]["BodyList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$BodyList();
	this.zpp_inner.outer = this;
};
nape_phys_BodyList.__name__ = true;
nape_phys_BodyList.fromArray = function(array) {
	var ret = new nape_phys_BodyList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_phys_BodyList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_phys_BodyIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_phys_BodyList();
		this.zpp_inner.valmod();
		var _g = nape_phys_BodyIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_phys_BodyIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_phys_BodyIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_phys_BodyIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_phys_BodyType = $hx_exports["nape"]["phys"]["BodyType"] = function() {
};
nape_phys_BodyType.__name__ = true;
nape_phys_BodyType.get_STATIC = function() {
	if(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_STATIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.BodyType_STATIC;
};
nape_phys_BodyType.get_DYNAMIC = function() {
	if(zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC;
};
nape_phys_BodyType.get_KINEMATIC = function() {
	if(zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC;
};
nape_phys_BodyType.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.BodyType_STATIC = new nape_phys_BodyType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.BodyType_STATIC) {
			return "STATIC";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC = new nape_phys_BodyType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC) {
				return "DYNAMIC";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC = new nape_phys_BodyType();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC) {
					return "KINEMATIC";
				} else {
					return "";
				}
			}
		}
	}
};
var nape_phys_Compound = $hx_exports["nape"]["phys"]["Compound"] = function() {
	this.zpp_inner = null;
	nape_phys_Interactor.call(this);
	this.zpp_inner = new zpp_$nape_phys_ZPP_$Compound();
	this.zpp_inner.outer = this;
	this.zpp_inner.outer_i = this;
	this.zpp_inner_i = this.zpp_inner;
	this.zpp_inner.insert_cbtype(zpp_$nape_callbacks_ZPP_$CbType.ANY_COMPOUND.zpp_inner);
};
nape_phys_Compound.__name__ = true;
nape_phys_Compound.__super__ = nape_phys_Interactor;
nape_phys_Compound.prototype = $extend(nape_phys_Interactor.prototype,{
	get_bodies: function() {
		return this.zpp_inner.wrap_bodies;
	}
	,get_constraints: function() {
		return this.zpp_inner.wrap_constraints;
	}
	,get_compounds: function() {
		return this.zpp_inner.wrap_compounds;
	}
	,get_compound: function() {
		if(this.zpp_inner.compound == null) {
			return null;
		} else {
			return this.zpp_inner.compound.outer;
		}
	}
	,set_compound: function(compound) {
		this.zpp_inner.immutable_midstep("Compound::compound");
		if((this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer) != compound) {
			if((this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer) != null) {
				(this.zpp_inner.compound == null ? null : this.zpp_inner.compound.outer).zpp_inner.wrap_compounds.remove(this);
			}
			if(compound != null) {
				var _this = compound.zpp_inner.wrap_compounds;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			}
		}
		if(this.zpp_inner.compound == null) {
			return null;
		} else {
			return this.zpp_inner.compound.outer;
		}
	}
	,get_space: function() {
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,set_space: function(space) {
		this.zpp_inner.immutable_midstep("Compound::space");
		if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != space) {
			if((this.zpp_inner.space == null ? null : this.zpp_inner.space.outer) != null) {
				(this.zpp_inner.space == null ? null : this.zpp_inner.space.outer).zpp_inner.wrap_compounds.remove(this);
			}
			if(space != null) {
				var _this = space.zpp_inner.wrap_compounds;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			}
		}
		if(this.zpp_inner.space == null) {
			return null;
		} else {
			return this.zpp_inner.space.outer;
		}
	}
	,toString: function() {
		return "Compound" + this.zpp_inner_i.id;
	}
	,copy: function() {
		return this.zpp_inner.copy();
	}
	,breakApart: function() {
		this.zpp_inner.breakApart();
	}
	,visitBodies: function(lambda) {
		var _this = this.zpp_inner.wrap_bodies;
		_this.zpp_inner.valmod();
		var _g = nape_phys_BodyIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var b = _g.zpp_inner.at(_g.zpp_i++);
			lambda(b);
		}
		var _this = this.zpp_inner.wrap_compounds;
		_this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			c.visitBodies(lambda);
		}
	}
	,visitConstraints: function(lambda) {
		var _this = this.zpp_inner.wrap_constraints;
		_this.zpp_inner.valmod();
		var _g = nape_constraint_ConstraintIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			lambda(c);
		}
		var _this = this.zpp_inner.wrap_compounds;
		_this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			c.visitConstraints(lambda);
		}
	}
	,visitCompounds: function(lambda) {
		var _this = this.zpp_inner.wrap_compounds;
		_this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			lambda(c);
			c.visitCompounds(lambda);
		}
	}
	,COM: function(weak) {
		if(weak == null) {
			weak = false;
		}
		var x = 0;
		var y = 0;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = weak1;
		var ret1 = ret;
		var total = 0.0;
		this.visitBodies(function(b) {
			var _this = b.zpp_inner.wrap_shapes;
			if(_this.zpp_inner.inner.head != null) {
				var ret = ret1;
				if(b.zpp_inner.wrap_worldCOM == null) {
					var x = b.zpp_inner.worldCOMx;
					var y = b.zpp_inner.worldCOMy;
					if(y == null) {
						y = 0;
					}
					if(x == null) {
						x = 0;
					}
					var ret2;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret2 = new nape_geom_Vec2();
					} else {
						ret2 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret2.zpp_pool;
						ret2.zpp_pool = null;
					}
					if(ret2.zpp_inner == null) {
						var ret3;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret3 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret3 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret3.next;
							ret3.next = null;
						}
						ret3.weak = false;
						ret3._immutable = false;
						ret3.x = x;
						ret3.y = y;
						ret2.zpp_inner = ret3;
						ret2.zpp_inner.outer = ret2;
					} else {
						var tmp;
						var _this = ret2.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						if(ret2.zpp_inner.x == x) {
							var _this = ret2.zpp_inner;
							if(_this._validate != null) {
								_this._validate();
							}
							tmp = ret2.zpp_inner.y == y;
						} else {
							tmp = false;
						}
						if(!tmp) {
							ret2.zpp_inner.x = x;
							ret2.zpp_inner.y = y;
							var _this = ret2.zpp_inner;
							if(_this._invalidate != null) {
								_this._invalidate(_this);
							}
						}
					}
					ret2.zpp_inner.weak = false;
					b.zpp_inner.wrap_worldCOM = ret2;
					b.zpp_inner.wrap_worldCOM.zpp_inner._inuse = true;
					b.zpp_inner.wrap_worldCOM.zpp_inner._immutable = true;
					b.zpp_inner.wrap_worldCOM.zpp_inner._validate = ($_=b.zpp_inner,$bind($_,$_.getworldCOM));
				}
				var tmp = b.zpp_inner.wrap_worldCOM;
				b.zpp_inner.validate_mass();
				ret.addeq(tmp.mul(b.zpp_inner.cmass,true));
				var total1 = total;
				b.zpp_inner.validate_mass();
				total = total1 + b.zpp_inner.cmass;
			}
		});
		ret1.muleq(1 / total);
		return ret1;
	}
	,translate: function(translation) {
		var weak = translation.zpp_inner.weak;
		translation.zpp_inner.weak = false;
		this.visitBodies(function(b) {
			if(b.zpp_inner.wrap_pos == null) {
				b.zpp_inner.setupPosition();
			}
			b.zpp_inner.wrap_pos.addeq(translation);
		});
		translation.zpp_inner.weak = weak;
		if(translation.zpp_inner.weak) {
			var inner = translation.zpp_inner;
			translation.zpp_inner.outer = null;
			translation.zpp_inner = null;
			var o = translation;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,rotate: function(centre,angle) {
		var weak = centre.zpp_inner.weak;
		centre.zpp_inner.weak = false;
		this.visitBodies(function(b) {
			b.rotate(centre,angle);
		});
		centre.zpp_inner.weak = weak;
		if(centre.zpp_inner.weak) {
			var inner = centre.zpp_inner;
			centre.zpp_inner.outer = null;
			centre.zpp_inner = null;
			var o = centre;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
});
var nape_phys_CompoundIterator = $hx_exports["nape"]["phys"]["CompoundIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_phys_CompoundIterator.__name__ = true;
nape_phys_CompoundIterator.get = function(list) {
	var ret;
	if(nape_phys_CompoundIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$CompoundList.internal = true;
		var ret1 = new nape_phys_CompoundIterator();
		zpp_$nape_util_ZPP_$CompoundList.internal = false;
		ret = ret1;
	} else {
		var r = nape_phys_CompoundIterator.zpp_pool;
		nape_phys_CompoundIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_phys_CompoundIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_phys_CompoundIterator.zpp_pool;
			nape_phys_CompoundIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_phys_CompoundList = $hx_exports["nape"]["phys"]["CompoundList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$CompoundList();
	this.zpp_inner.outer = this;
};
nape_phys_CompoundList.__name__ = true;
nape_phys_CompoundList.fromArray = function(array) {
	var ret = new nape_phys_CompoundList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_phys_CompoundList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_phys_CompoundIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_phys_CompoundList();
		this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_phys_CompoundIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_phys_FluidProperties = $hx_exports["nape"]["phys"]["FluidProperties"] = function(density,viscosity) {
	if(viscosity == null) {
		viscosity = 1;
	}
	if(density == null) {
		density = 1;
	}
	this.zpp_inner = null;
	if(zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool == null) {
		this.zpp_inner = new zpp_$nape_phys_ZPP_$FluidProperties();
	} else {
		this.zpp_inner = zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool;
		zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool = this.zpp_inner.next;
		this.zpp_inner.next = null;
	}
	this.zpp_inner.outer = this;
	if(density != this.zpp_inner.density * 1000) {
		this.zpp_inner.density = density / 1000;
		this.zpp_inner.invalidate();
	}
	if(viscosity != this.zpp_inner.viscosity) {
		this.zpp_inner.viscosity = viscosity / 1;
		this.zpp_inner.invalidate();
	}
};
nape_phys_FluidProperties.__name__ = true;
nape_phys_FluidProperties.prototype = {
	get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_shapes: function() {
		if(this.zpp_inner.wrap_shapes == null) {
			this.zpp_inner.wrap_shapes = zpp_$nape_util_ZPP_$ShapeList.get(this.zpp_inner.shapes,true);
		}
		return this.zpp_inner.wrap_shapes;
	}
	,copy: function() {
		var ret = new nape_phys_FluidProperties(this.zpp_inner.density * 1000,this.zpp_inner.viscosity);
		if(this.zpp_inner.userData != null) {
			ret.zpp_inner.userData = Reflect.copy(this.zpp_inner.userData);
		}
		var gravity = this.zpp_inner.wrap_gravity;
		if(gravity == null) {
			if(ret.zpp_inner.wrap_gravity != null) {
				ret.zpp_inner.wrap_gravity.zpp_inner._inuse = false;
				var _this = ret.zpp_inner.wrap_gravity;
				var inner = _this.zpp_inner;
				_this.zpp_inner.outer = null;
				_this.zpp_inner = null;
				var o = _this;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o = inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.zpp_inner.wrap_gravity = null;
			}
		} else {
			if(ret.zpp_inner.wrap_gravity == null) {
				ret.zpp_inner.getgravity();
			}
			var _this = ret.zpp_inner.wrap_gravity;
			var _this1 = gravity.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var x = gravity.zpp_inner.x;
			var _this1 = gravity.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var y = gravity.zpp_inner.y;
			var tmp;
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			if(_this.zpp_inner.x == x) {
				var _this1 = _this.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				tmp = _this.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				_this.zpp_inner.x = x;
				_this.zpp_inner.y = y;
				var _this1 = _this.zpp_inner;
				if(_this1._invalidate != null) {
					_this1._invalidate(_this1);
				}
			}
			var ret1 = _this;
			if(gravity.zpp_inner.weak) {
				var inner = gravity.zpp_inner;
				gravity.zpp_inner.outer = null;
				gravity.zpp_inner = null;
				var o = gravity;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o = inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			}
		}
		return ret;
	}
	,get_density: function() {
		return this.zpp_inner.density * 1000;
	}
	,set_density: function(density) {
		if(density != this.zpp_inner.density * 1000) {
			this.zpp_inner.density = density / 1000;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.density * 1000;
	}
	,get_viscosity: function() {
		return this.zpp_inner.viscosity;
	}
	,set_viscosity: function(viscosity) {
		if(viscosity != this.zpp_inner.viscosity) {
			this.zpp_inner.viscosity = viscosity / 1;
			this.zpp_inner.invalidate();
		}
		return this.zpp_inner.viscosity;
	}
	,get_gravity: function() {
		return this.zpp_inner.wrap_gravity;
	}
	,set_gravity: function(gravity) {
		if(gravity == null) {
			if(this.zpp_inner.wrap_gravity != null) {
				this.zpp_inner.wrap_gravity.zpp_inner._inuse = false;
				var _this = this.zpp_inner.wrap_gravity;
				var inner = _this.zpp_inner;
				_this.zpp_inner.outer = null;
				_this.zpp_inner = null;
				var o = _this;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o = inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				this.zpp_inner.wrap_gravity = null;
			}
		} else {
			if(this.zpp_inner.wrap_gravity == null) {
				this.zpp_inner.getgravity();
			}
			var _this = this.zpp_inner.wrap_gravity;
			var _this1 = gravity.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var x = gravity.zpp_inner.x;
			var _this1 = gravity.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var y = gravity.zpp_inner.y;
			var tmp;
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			if(_this.zpp_inner.x == x) {
				var _this1 = _this.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				tmp = _this.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				_this.zpp_inner.x = x;
				_this.zpp_inner.y = y;
				var _this1 = _this.zpp_inner;
				if(_this1._invalidate != null) {
					_this1._invalidate(_this1);
				}
			}
			var ret = _this;
			if(gravity.zpp_inner.weak) {
				var inner = gravity.zpp_inner;
				gravity.zpp_inner.outer = null;
				gravity.zpp_inner = null;
				var o = gravity;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o = inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			}
		}
		return this.zpp_inner.wrap_gravity;
	}
	,toString: function() {
		return "{ density: " + this.zpp_inner.density * 1000 + " viscosity: " + this.zpp_inner.viscosity + " gravity: " + Std.string(this.zpp_inner.wrap_gravity) + " }";
	}
};
var nape_phys_GravMassMode = $hx_exports["nape"]["phys"]["GravMassMode"] = function() {
};
nape_phys_GravMassMode.__name__ = true;
nape_phys_GravMassMode.get_DEFAULT = function() {
	if(zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT = new nape_phys_GravMassMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT;
};
nape_phys_GravMassMode.get_FIXED = function() {
	if(zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED = new nape_phys_GravMassMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED;
};
nape_phys_GravMassMode.get_SCALED = function() {
	if(zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED = new nape_phys_GravMassMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED;
};
nape_phys_GravMassMode.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT = new nape_phys_GravMassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.GravMassMode_DEFAULT) {
			return "DEFAULT";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED = new nape_phys_GravMassMode();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.GravMassMode_FIXED) {
				return "FIXED";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED = new nape_phys_GravMassMode();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.GravMassMode_SCALED) {
					return "SCALED";
				} else {
					return "";
				}
			}
		}
	}
};
var nape_phys_InertiaMode = $hx_exports["nape"]["phys"]["InertiaMode"] = function() {
};
nape_phys_InertiaMode.__name__ = true;
nape_phys_InertiaMode.get_DEFAULT = function() {
	if(zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT = new nape_phys_InertiaMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT;
};
nape_phys_InertiaMode.get_FIXED = function() {
	if(zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED = new nape_phys_InertiaMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED;
};
nape_phys_InertiaMode.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT = new nape_phys_InertiaMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.InertiaMode_DEFAULT) {
			return "DEFAULT";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED = new nape_phys_InertiaMode();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.InertiaMode_FIXED) {
				return "FIXED";
			} else {
				return "";
			}
		}
	}
};
var nape_phys_InteractorIterator = $hx_exports["nape"]["phys"]["InteractorIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_phys_InteractorIterator.__name__ = true;
nape_phys_InteractorIterator.get = function(list) {
	var ret;
	if(nape_phys_InteractorIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$InteractorList.internal = true;
		var ret1 = new nape_phys_InteractorIterator();
		zpp_$nape_util_ZPP_$InteractorList.internal = false;
		ret = ret1;
	} else {
		var r = nape_phys_InteractorIterator.zpp_pool;
		nape_phys_InteractorIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_phys_InteractorIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_phys_InteractorIterator.zpp_pool;
			nape_phys_InteractorIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_phys_InteractorList = $hx_exports["nape"]["phys"]["InteractorList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$InteractorList();
	this.zpp_inner.outer = this;
};
nape_phys_InteractorList.__name__ = true;
nape_phys_InteractorList.fromArray = function(array) {
	var ret = new nape_phys_InteractorList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_phys_InteractorList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner_i);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer_i;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner_i);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner_i);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner_i);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner_i);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer_i;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer_i;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer_i;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer_i;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer_i;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer_i;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner_i) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner_i);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_phys_InteractorIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_phys_InteractorList();
		this.zpp_inner.valmod();
		var _g = nape_phys_InteractorIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_InteractorIterator.zpp_pool;
				nape_phys_InteractorIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_phys_InteractorIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_InteractorIterator.zpp_pool;
				nape_phys_InteractorIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_phys_InteractorIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_InteractorIterator.zpp_pool;
				nape_phys_InteractorIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_phys_InteractorIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_phys_InteractorIterator.zpp_pool;
				nape_phys_InteractorIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_phys_InteractorIterator.zpp_pool;
				nape_phys_InteractorIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_phys_MassMode = $hx_exports["nape"]["phys"]["MassMode"] = function() {
};
nape_phys_MassMode.__name__ = true;
nape_phys_MassMode.get_DEFAULT = function() {
	if(zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT = new nape_phys_MassMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT;
};
nape_phys_MassMode.get_FIXED = function() {
	if(zpp_$nape_util_ZPP_$Flags.MassMode_FIXED == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.MassMode_FIXED = new nape_phys_MassMode();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.MassMode_FIXED;
};
nape_phys_MassMode.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT = new nape_phys_MassMode();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.MassMode_DEFAULT) {
			return "DEFAULT";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.MassMode_FIXED == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.MassMode_FIXED = new nape_phys_MassMode();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.MassMode_FIXED) {
				return "FIXED";
			} else {
				return "";
			}
		}
	}
};
var nape_phys_Material = $hx_exports["nape"]["phys"]["Material"] = function(elasticity,dynamicFriction,staticFriction,density,rollingFriction) {
	if(rollingFriction == null) {
		rollingFriction = 0.001;
	}
	if(density == null) {
		density = 1;
	}
	if(staticFriction == null) {
		staticFriction = 2.0;
	}
	if(dynamicFriction == null) {
		dynamicFriction = 1.0;
	}
	if(elasticity == null) {
		elasticity = 0.0;
	}
	this.zpp_inner = null;
	if(zpp_$nape_phys_ZPP_$Material.zpp_pool == null) {
		this.zpp_inner = new zpp_$nape_phys_ZPP_$Material();
	} else {
		this.zpp_inner = zpp_$nape_phys_ZPP_$Material.zpp_pool;
		zpp_$nape_phys_ZPP_$Material.zpp_pool = this.zpp_inner.next;
		this.zpp_inner.next = null;
	}
	this.zpp_inner.outer = this;
	if(elasticity != this.zpp_inner.elasticity) {
		this.zpp_inner.elasticity = elasticity / 1;
		this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ARBITERS);
	}
	if(dynamicFriction != this.zpp_inner.dynamicFriction) {
		this.zpp_inner.dynamicFriction = dynamicFriction / 1;
		this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ANGDRAG | zpp_$nape_phys_ZPP_$Material.ARBITERS);
	}
	if(staticFriction != this.zpp_inner.staticFriction) {
		this.zpp_inner.staticFriction = staticFriction / 1;
		this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ARBITERS);
	}
	if(density != this.zpp_inner.density * 1000) {
		this.zpp_inner.density = density / 1000;
		this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.PROPS);
	}
	if(rollingFriction != this.zpp_inner.rollingFriction) {
		this.zpp_inner.rollingFriction = rollingFriction / 1;
		this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ARBITERS);
	}
};
nape_phys_Material.__name__ = true;
nape_phys_Material.wood = function() {
	return new nape_phys_Material(0.4,0.2,0.38,0.7,0.005);
};
nape_phys_Material.steel = function() {
	return new nape_phys_Material(0.2,0.57,0.74,7.8,0.001);
};
nape_phys_Material.ice = function() {
	return new nape_phys_Material(0.3,0.03,0.1,0.9,0.0001);
};
nape_phys_Material.rubber = function() {
	return new nape_phys_Material(0.8,1.0,1.4,1.5,0.01);
};
nape_phys_Material.glass = function() {
	return new nape_phys_Material(0.4,0.4,0.94,2.6,0.002);
};
nape_phys_Material.sand = function() {
	return new nape_phys_Material(-1.0,0.45,0.6,1.6,16.0);
};
nape_phys_Material.prototype = {
	get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_shapes: function() {
		if(this.zpp_inner.wrap_shapes == null) {
			this.zpp_inner.wrap_shapes = zpp_$nape_util_ZPP_$ShapeList.get(this.zpp_inner.shapes,true);
		}
		return this.zpp_inner.wrap_shapes;
	}
	,copy: function() {
		var ret = new nape_phys_Material(this.zpp_inner.elasticity,this.zpp_inner.dynamicFriction,this.zpp_inner.staticFriction,this.zpp_inner.density * 1000,this.zpp_inner.rollingFriction);
		if(this.zpp_inner.userData != null) {
			ret.zpp_inner.userData = Reflect.copy(this.zpp_inner.userData);
		}
		return ret;
	}
	,get_elasticity: function() {
		return this.zpp_inner.elasticity;
	}
	,set_elasticity: function(elasticity) {
		if(elasticity != this.zpp_inner.elasticity) {
			this.zpp_inner.elasticity = elasticity / 1;
			this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ARBITERS);
		}
		return this.zpp_inner.elasticity;
	}
	,get_dynamicFriction: function() {
		return this.zpp_inner.dynamicFriction;
	}
	,set_dynamicFriction: function(dynamicFriction) {
		if(dynamicFriction != this.zpp_inner.dynamicFriction) {
			this.zpp_inner.dynamicFriction = dynamicFriction / 1;
			this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ANGDRAG | zpp_$nape_phys_ZPP_$Material.ARBITERS);
		}
		return this.zpp_inner.dynamicFriction;
	}
	,get_staticFriction: function() {
		return this.zpp_inner.staticFriction;
	}
	,set_staticFriction: function(staticFriction) {
		if(staticFriction != this.zpp_inner.staticFriction) {
			this.zpp_inner.staticFriction = staticFriction / 1;
			this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ARBITERS);
		}
		return this.zpp_inner.staticFriction;
	}
	,get_density: function() {
		return this.zpp_inner.density * 1000;
	}
	,set_density: function(density) {
		if(density != this.zpp_inner.density * 1000) {
			this.zpp_inner.density = density / 1000;
			this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.PROPS);
		}
		return this.zpp_inner.density * 1000;
	}
	,get_rollingFriction: function() {
		return this.zpp_inner.rollingFriction;
	}
	,set_rollingFriction: function(rollingFriction) {
		if(rollingFriction != this.zpp_inner.rollingFriction) {
			this.zpp_inner.rollingFriction = rollingFriction / 1;
			this.zpp_inner.invalidate(zpp_$nape_phys_ZPP_$Material.WAKE | zpp_$nape_phys_ZPP_$Material.ARBITERS);
		}
		return this.zpp_inner.rollingFriction;
	}
	,toString: function() {
		return "{ elasticity: " + this.zpp_inner.elasticity + " dynamicFriction: " + this.zpp_inner.dynamicFriction + " staticFriction: " + this.zpp_inner.staticFriction + " density: " + this.zpp_inner.density * 1000 + " rollingFriction: " + this.zpp_inner.rollingFriction + " }";
	}
};
var nape_shape_Shape = $hx_exports["nape"]["shape"]["Shape"] = function() {
	this.zpp_inner = null;
	nape_phys_Interactor.call(this);
};
nape_shape_Shape.__name__ = true;
nape_shape_Shape.__super__ = nape_phys_Interactor;
nape_shape_Shape.prototype = $extend(nape_phys_Interactor.prototype,{
	get_type: function() {
		return zpp_$nape_shape_ZPP_$Shape.types[this.zpp_inner.type];
	}
	,isCircle: function() {
		return this.zpp_inner.type == 0;
	}
	,isPolygon: function() {
		return this.zpp_inner.type == 1;
	}
	,get_body: function() {
		if(this.zpp_inner.body != null) {
			return this.zpp_inner.body.outer;
		} else {
			return null;
		}
	}
	,set_body: function(body) {
		this.zpp_inner.immutable_midstep("Shape::body");
		if((this.zpp_inner.body != null ? this.zpp_inner.body.outer : null) != body) {
			if(this.zpp_inner.body != null) {
				(this.zpp_inner.body != null ? this.zpp_inner.body.outer : null).zpp_inner.wrap_shapes.remove(this);
			}
			if(body != null) {
				var _this = body.zpp_inner.wrap_shapes;
				if(_this.zpp_inner.reverse_flag) {
					_this.push(this);
				} else {
					_this.unshift(this);
				}
			}
		}
		if(this.zpp_inner.body != null) {
			return this.zpp_inner.body.outer;
		} else {
			return null;
		}
	}
	,get_castCircle: function() {
		if(this.zpp_inner.type == 0) {
			return this.zpp_inner.circle.outer_zn;
		} else {
			return null;
		}
	}
	,get_castPolygon: function() {
		if(this.zpp_inner.type == 1) {
			return this.zpp_inner.polygon.outer_zn;
		} else {
			return null;
		}
	}
	,get_worldCOM: function() {
		if(this.zpp_inner.wrap_worldCOM == null) {
			var x = this.zpp_inner.worldCOMx;
			var y = this.zpp_inner.worldCOMy;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			this.zpp_inner.wrap_worldCOM = ret;
			this.zpp_inner.wrap_worldCOM.zpp_inner._inuse = true;
			this.zpp_inner.wrap_worldCOM.zpp_inner._immutable = true;
			this.zpp_inner.wrap_worldCOM.zpp_inner._validate = ($_=this.zpp_inner,$bind($_,$_.getworldCOM));
		}
		return this.zpp_inner.wrap_worldCOM;
	}
	,get_localCOM: function() {
		if(this.zpp_inner.wrap_localCOM == null) {
			if(this.zpp_inner.type == 0) {
				this.zpp_inner.circle.setupLocalCOM();
			} else {
				this.zpp_inner.polygon.setupLocalCOM();
			}
		}
		return this.zpp_inner.wrap_localCOM;
	}
	,set_localCOM: function(localCOM) {
		this.zpp_inner.immutable_midstep("Body::localCOM");
		if(this.zpp_inner.wrap_localCOM == null) {
			if(this.zpp_inner.type == 0) {
				this.zpp_inner.circle.setupLocalCOM();
			} else {
				this.zpp_inner.polygon.setupLocalCOM();
			}
		}
		var _this = this.zpp_inner.wrap_localCOM;
		var _this1 = localCOM.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = localCOM.zpp_inner.x;
		var _this1 = localCOM.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = localCOM.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(localCOM.zpp_inner.weak) {
			var inner = localCOM.zpp_inner;
			localCOM.zpp_inner.outer = null;
			localCOM.zpp_inner = null;
			var o = localCOM;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_localCOM == null) {
			if(this.zpp_inner.type == 0) {
				this.zpp_inner.circle.setupLocalCOM();
			} else {
				this.zpp_inner.polygon.setupLocalCOM();
			}
		}
		return this.zpp_inner.wrap_localCOM;
	}
	,get_area: function() {
		this.zpp_inner.validate_area_inertia();
		return this.zpp_inner.area;
	}
	,get_inertia: function() {
		this.zpp_inner.validate_area_inertia();
		return this.zpp_inner.inertia;
	}
	,get_angDrag: function() {
		this.zpp_inner.validate_angDrag();
		return this.zpp_inner.angDrag;
	}
	,get_material: function() {
		return this.zpp_inner.material.wrapper();
	}
	,set_material: function(material) {
		this.zpp_inner.immutable_midstep("Shape::material");
		this.zpp_inner.setMaterial(material.zpp_inner);
		return this.zpp_inner.material.wrapper();
	}
	,get_filter: function() {
		return this.zpp_inner.filter.wrapper();
	}
	,set_filter: function(filter) {
		this.zpp_inner.immutable_midstep("Shape::filter");
		this.zpp_inner.setFilter(filter.zpp_inner);
		return this.zpp_inner.filter.wrapper();
	}
	,get_fluidProperties: function() {
		this.zpp_inner.immutable_midstep("Shape::fluidProperties");
		if(this.zpp_inner.fluidProperties == null) {
			this.zpp_inner.setFluid(new nape_phys_FluidProperties().zpp_inner);
		}
		return this.zpp_inner.fluidProperties.wrapper();
	}
	,set_fluidProperties: function(fluidProperties) {
		this.zpp_inner.setFluid(fluidProperties.zpp_inner);
		this.zpp_inner.immutable_midstep("Shape::fluidProperties");
		if(this.zpp_inner.fluidProperties == null) {
			this.zpp_inner.setFluid(new nape_phys_FluidProperties().zpp_inner);
		}
		return this.zpp_inner.fluidProperties.wrapper();
	}
	,get_fluidEnabled: function() {
		return this.zpp_inner.fluidEnabled;
	}
	,set_fluidEnabled: function(fluidEnabled) {
		this.zpp_inner.immutable_midstep("Shape::fluidEnabled");
		this.zpp_inner.fluidEnabled = fluidEnabled;
		if(fluidEnabled && this.zpp_inner.fluidProperties == null) {
			var fluidProperties = new nape_phys_FluidProperties();
			this.zpp_inner.setFluid(fluidProperties.zpp_inner);
			this.zpp_inner.immutable_midstep("Shape::fluidProperties");
			if(this.zpp_inner.fluidProperties == null) {
				this.zpp_inner.setFluid(new nape_phys_FluidProperties().zpp_inner);
			}
			this.zpp_inner.fluidProperties.wrapper();
		}
		this.zpp_inner.wake();
		return this.zpp_inner.fluidEnabled;
	}
	,get_sensorEnabled: function() {
		return this.zpp_inner.sensorEnabled;
	}
	,set_sensorEnabled: function(sensorEnabled) {
		this.zpp_inner.immutable_midstep("Shape::sensorEnabled");
		this.zpp_inner.sensorEnabled = sensorEnabled;
		this.zpp_inner.wake();
		return this.zpp_inner.sensorEnabled;
	}
	,get_bounds: function() {
		return this.zpp_inner.aabb.wrapper();
	}
	,translate: function(translation) {
		this.zpp_inner.immutable_midstep("Shape::translate()");
		if(translation.lsq() > 0) {
			if(this.zpp_inner.type == 0) {
				var tmp = this.zpp_inner.circle;
				var _this = translation.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var tmp1 = translation.zpp_inner.x;
				var _this = translation.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp.__translate(tmp1,translation.zpp_inner.y);
			} else {
				var tmp = this.zpp_inner.polygon;
				var _this = translation.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var tmp1 = translation.zpp_inner.x;
				var _this = translation.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp.__translate(tmp1,translation.zpp_inner.y);
			}
		}
		if(translation.zpp_inner.weak) {
			var inner = translation.zpp_inner;
			translation.zpp_inner.outer = null;
			translation.zpp_inner = null;
			var o = translation;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return this;
	}
	,scale: function(scalex,scaley) {
		this.zpp_inner.immutable_midstep("Shape::scale()");
		if(this.zpp_inner.type == 0) {
			var d = scalex * scalex - scaley * scaley;
			if(d * d < nape_Config.epsilon * nape_Config.epsilon) {
				this.zpp_inner.circle.__scale(scalex,scaley);
			}
		} else {
			this.zpp_inner.polygon.__scale(scalex,scaley);
		}
		return this;
	}
	,rotate: function(angle) {
		this.zpp_inner.immutable_midstep("Shape::rotate()");
		var dr = angle % (2 * Math.PI);
		if(dr != 0.0) {
			var cos = Math.cos(angle);
			var sin = Math.sin(angle);
			if(this.zpp_inner.type == 0) {
				this.zpp_inner.circle.__rotate(sin,cos);
			} else {
				this.zpp_inner.polygon.__rotate(sin,cos);
			}
		}
		return this;
	}
	,transform: function(matrix) {
		this.zpp_inner.immutable_midstep("Shape::transform()");
		if(this.zpp_inner.type == 0) {
			if(matrix.equiorthogonal()) {
				this.zpp_inner.circle.__transform(matrix);
			}
		} else {
			this.zpp_inner.polygon.__transform(matrix);
		}
		return this;
	}
	,contains: function(point) {
		zpp_$nape_geom_ZPP_$Geom.validateShape(this.zpp_inner);
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret = zpp_$nape_geom_ZPP_$Collide.shapeContains(this.zpp_inner,point.zpp_inner);
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,copy: function() {
		return this.zpp_inner.copy();
	}
	,toString: function() {
		var ret = this.zpp_inner.type == 0 ? "Circle" : "Polygon";
		return ret + "#" + this.zpp_inner_i.id;
	}
});
var nape_shape_Circle = $hx_exports["nape"]["shape"]["Circle"] = function(radius,localCOM,material,filter) {
	this.zpp_inner_zn = null;
	nape_shape_Shape.call(this);
	this.zpp_inner_zn = new zpp_$nape_shape_ZPP_$Circle();
	this.zpp_inner_zn.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner_i = this.zpp_inner;
	this.zpp_inner_i.outer_i = this;
	this.zpp_inner.immutable_midstep("Circle::radius");
	if(radius != this.zpp_inner_zn.radius) {
		this.zpp_inner_zn.radius = radius;
		this.zpp_inner_zn.invalidate_radius();
	}
	if(localCOM == null) {
		this.zpp_inner.localCOMx = 0;
		this.zpp_inner.localCOMy = 0;
	} else {
		var _this = localCOM.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.localCOMx = localCOM.zpp_inner.x;
		var _this = localCOM.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		this.zpp_inner.localCOMy = localCOM.zpp_inner.y;
		if(localCOM.zpp_inner.weak) {
			var inner = localCOM.zpp_inner;
			localCOM.zpp_inner.outer = null;
			localCOM.zpp_inner = null;
			var o = localCOM;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
	}
	if(material == null) {
		if(zpp_$nape_phys_ZPP_$Material.zpp_pool == null) {
			this.zpp_inner.material = new zpp_$nape_phys_ZPP_$Material();
		} else {
			this.zpp_inner.material = zpp_$nape_phys_ZPP_$Material.zpp_pool;
			zpp_$nape_phys_ZPP_$Material.zpp_pool = this.zpp_inner.material.next;
			this.zpp_inner.material.next = null;
		}
	} else {
		this.zpp_inner.immutable_midstep("Shape::material");
		this.zpp_inner.setMaterial(material.zpp_inner);
		this.zpp_inner.material.wrapper();
	}
	if(filter == null) {
		if(zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool == null) {
			this.zpp_inner.filter = new zpp_$nape_dynamics_ZPP_$InteractionFilter();
		} else {
			this.zpp_inner.filter = zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool = this.zpp_inner.filter.next;
			this.zpp_inner.filter.next = null;
		}
	} else {
		this.zpp_inner.immutable_midstep("Shape::filter");
		this.zpp_inner.setFilter(filter.zpp_inner);
		this.zpp_inner.filter.wrapper();
	}
	this.zpp_inner_i.insert_cbtype(zpp_$nape_callbacks_ZPP_$CbType.ANY_SHAPE.zpp_inner);
};
nape_shape_Circle.__name__ = true;
nape_shape_Circle.__super__ = nape_shape_Shape;
nape_shape_Circle.prototype = $extend(nape_shape_Shape.prototype,{
	get_radius: function() {
		return this.zpp_inner_zn.radius;
	}
	,set_radius: function(radius) {
		this.zpp_inner.immutable_midstep("Circle::radius");
		if(radius != this.zpp_inner_zn.radius) {
			this.zpp_inner_zn.radius = radius;
			this.zpp_inner_zn.invalidate_radius();
		}
		return this.zpp_inner_zn.radius;
	}
});
var nape_shape_Edge = $hx_exports["nape"]["shape"]["Edge"] = function() {
	this.zpp_inner = null;
};
nape_shape_Edge.__name__ = true;
nape_shape_Edge.prototype = {
	get_polygon: function() {
		return this.zpp_inner.polygon.outer_zn;
	}
	,get_localNormal: function() {
		if(this.zpp_inner.wrap_lnorm == null) {
			this.zpp_inner.getlnorm();
		}
		return this.zpp_inner.wrap_lnorm;
	}
	,get_worldNormal: function() {
		if(this.zpp_inner.wrap_gnorm == null) {
			this.zpp_inner.getgnorm();
		}
		return this.zpp_inner.wrap_gnorm;
	}
	,get_length: function() {
		this.zpp_inner.polygon.validate_laxi();
		return this.zpp_inner.length;
	}
	,get_localProjection: function() {
		this.zpp_inner.polygon.validate_laxi();
		return this.zpp_inner.lprojection;
	}
	,get_worldProjection: function() {
		var _this = this.zpp_inner.polygon;
		if(_this.zip_gaxi) {
			if(_this.body != null) {
				_this.zip_gaxi = false;
				_this.validate_laxi();
				var _this1 = _this.body;
				if(_this1.zip_axis) {
					_this1.zip_axis = false;
					_this1.axisx = Math.sin(_this1.rot);
					_this1.axisy = Math.cos(_this1.rot);
				}
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var ite = _this.edges.head;
				var cx_ite = _this.gverts.next;
				var u = cx_ite;
				cx_ite = cx_ite.next;
				while(cx_ite != null) {
					var v = cx_ite;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
					u = v;
					cx_ite = cx_ite.next;
				}
				var v = _this.gverts.next;
				var e = ite.elt;
				ite = ite.next;
				e.gp0 = u;
				e.gp1 = v;
				e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
				e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
				e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
				if(e.wrap_gnorm != null) {
					e.wrap_gnorm.zpp_inner.x = e.gnormx;
					e.wrap_gnorm.zpp_inner.y = e.gnormy;
				}
				e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
				e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
			}
		}
		return this.zpp_inner.gprojection;
	}
	,get_localVertex1: function() {
		this.zpp_inner.polygon.validate_laxi();
		var _this = this.zpp_inner.lp0;
		if(_this.outer == null) {
			_this.outer = new nape_geom_Vec2();
			var o = _this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			_this.outer.zpp_inner = _this;
		}
		return _this.outer;
	}
	,get_localVertex2: function() {
		this.zpp_inner.polygon.validate_laxi();
		var _this = this.zpp_inner.lp1;
		if(_this.outer == null) {
			_this.outer = new nape_geom_Vec2();
			var o = _this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			_this.outer.zpp_inner = _this;
		}
		return _this.outer;
	}
	,get_worldVertex1: function() {
		var _this = this.zpp_inner.polygon;
		if(_this.zip_gaxi) {
			if(_this.body != null) {
				_this.zip_gaxi = false;
				_this.validate_laxi();
				var _this1 = _this.body;
				if(_this1.zip_axis) {
					_this1.zip_axis = false;
					_this1.axisx = Math.sin(_this1.rot);
					_this1.axisy = Math.cos(_this1.rot);
				}
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var ite = _this.edges.head;
				var cx_ite = _this.gverts.next;
				var u = cx_ite;
				cx_ite = cx_ite.next;
				while(cx_ite != null) {
					var v = cx_ite;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
					u = v;
					cx_ite = cx_ite.next;
				}
				var v = _this.gverts.next;
				var e = ite.elt;
				ite = ite.next;
				e.gp0 = u;
				e.gp1 = v;
				e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
				e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
				e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
				if(e.wrap_gnorm != null) {
					e.wrap_gnorm.zpp_inner.x = e.gnormx;
					e.wrap_gnorm.zpp_inner.y = e.gnormy;
				}
				e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
				e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
			}
		}
		var _this = this.zpp_inner.gp0;
		if(_this.outer == null) {
			_this.outer = new nape_geom_Vec2();
			var o = _this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			_this.outer.zpp_inner = _this;
		}
		return _this.outer;
	}
	,get_worldVertex2: function() {
		var _this = this.zpp_inner.polygon;
		if(_this.zip_gaxi) {
			if(_this.body != null) {
				_this.zip_gaxi = false;
				_this.validate_laxi();
				var _this1 = _this.body;
				if(_this1.zip_axis) {
					_this1.zip_axis = false;
					_this1.axisx = Math.sin(_this1.rot);
					_this1.axisy = Math.cos(_this1.rot);
				}
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var ite = _this.edges.head;
				var cx_ite = _this.gverts.next;
				var u = cx_ite;
				cx_ite = cx_ite.next;
				while(cx_ite != null) {
					var v = cx_ite;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
					u = v;
					cx_ite = cx_ite.next;
				}
				var v = _this.gverts.next;
				var e = ite.elt;
				ite = ite.next;
				e.gp0 = u;
				e.gp1 = v;
				e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
				e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
				e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
				if(e.wrap_gnorm != null) {
					e.wrap_gnorm.zpp_inner.x = e.gnormx;
					e.wrap_gnorm.zpp_inner.y = e.gnormy;
				}
				e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
				e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
			}
		}
		var _this = this.zpp_inner.gp1;
		if(_this.outer == null) {
			_this.outer = new nape_geom_Vec2();
			var o = _this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			_this.outer.zpp_inner = _this;
		}
		return _this.outer;
	}
	,toString: function() {
		if(this.zpp_inner.polygon == null) {
			return "Edge(object-pooled)";
		} else if(this.zpp_inner.polygon.body == null) {
			this.zpp_inner.polygon.validate_laxi();
			return "{ localNormal : " + ("{ x: " + this.zpp_inner.lnormx + " y: " + this.zpp_inner.lnormy + " }") + " }";
		} else {
			var _this = this.zpp_inner.polygon;
			if(_this.zip_gaxi) {
				if(_this.body != null) {
					_this.zip_gaxi = false;
					_this.validate_laxi();
					var _this1 = _this.body;
					if(_this1.zip_axis) {
						_this1.zip_axis = false;
						_this1.axisx = Math.sin(_this1.rot);
						_this1.axisy = Math.cos(_this1.rot);
					}
					if(_this.zip_gverts) {
						if(_this.body != null) {
							_this.zip_gverts = false;
							_this.validate_lverts();
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							var li = _this.lverts.next;
							var cx_ite = _this.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
								g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var ite = _this.edges.head;
					var cx_ite = _this.gverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var v = cx_ite;
						var e = ite.elt;
						ite = ite.next;
						e.gp0 = u;
						e.gp1 = v;
						e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
						e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
						e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
						if(e.wrap_gnorm != null) {
							e.wrap_gnorm.zpp_inner.x = e.gnormx;
							e.wrap_gnorm.zpp_inner.y = e.gnormy;
						}
						e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
						e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
						u = v;
						cx_ite = cx_ite.next;
					}
					var v = _this.gverts.next;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
				}
			}
			return "{ localNormal : " + ("{ x: " + this.zpp_inner.lnormx + " y: " + this.zpp_inner.lnormy + " }") + " worldNormal : " + ("{ x: " + this.zpp_inner.gnormx + " y: " + this.zpp_inner.gnormy + " }") + " }";
		}
	}
};
var nape_shape_EdgeIterator = $hx_exports["nape"]["shape"]["EdgeIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_shape_EdgeIterator.__name__ = true;
nape_shape_EdgeIterator.get = function(list) {
	var ret;
	if(nape_shape_EdgeIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$EdgeList.internal = true;
		var ret1 = new nape_shape_EdgeIterator();
		zpp_$nape_util_ZPP_$EdgeList.internal = false;
		ret = ret1;
	} else {
		var r = nape_shape_EdgeIterator.zpp_pool;
		nape_shape_EdgeIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_shape_EdgeIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_shape_EdgeIterator.zpp_pool;
			nape_shape_EdgeIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_shape_EdgeList = $hx_exports["nape"]["shape"]["EdgeList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$EdgeList();
	this.zpp_inner.outer = this;
};
nape_shape_EdgeList.__name__ = true;
nape_shape_EdgeList.fromArray = function(array) {
	var ret = new nape_shape_EdgeList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_shape_EdgeList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(index != this.zpp_inner.user_length - 1) {
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				index = this.zpp_inner.user_length - 2 - index;
			}
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.wrapper();
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.wrapper();
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.wrapper();
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.wrapper();
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_shape_EdgeIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_shape_EdgeList();
		this.zpp_inner.valmod();
		var _g = nape_shape_EdgeIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_EdgeIterator.zpp_pool;
				nape_shape_EdgeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_shape_EdgeIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_EdgeIterator.zpp_pool;
				nape_shape_EdgeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_shape_EdgeIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_EdgeIterator.zpp_pool;
				nape_shape_EdgeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_shape_EdgeIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_shape_EdgeIterator.zpp_pool;
				nape_shape_EdgeIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_shape_EdgeIterator.zpp_pool;
				nape_shape_EdgeIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_shape_Polygon = $hx_exports["nape"]["shape"]["Polygon"] = function(localVerts,material,filter) {
	this.zpp_inner_zn = null;
	nape_shape_Shape.call(this);
	this.zpp_inner_zn = new zpp_$nape_shape_ZPP_$Polygon();
	this.zpp_inner_zn.outer = this;
	this.zpp_inner_zn.outer_zn = this;
	this.zpp_inner = this.zpp_inner_zn;
	this.zpp_inner_i = this.zpp_inner;
	this.zpp_inner_i.outer_i = this;
	if(((localVerts) instanceof Array)) {
		var lv = localVerts;
		var _g = 0;
		while(_g < lv.length) {
			var vite = lv[_g];
			++_g;
			var x = vite;
			if(this.zpp_inner_zn.wrap_lverts == null) {
				this.zpp_inner_zn.getlverts();
			}
			var tmp = this.zpp_inner_zn.wrap_lverts;
			var _this = x.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x1 = x.zpp_inner.x;
			var _this1 = x.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var y = x.zpp_inner.y;
			var weak = false;
			if(weak == null) {
				weak = false;
			}
			if(y == null) {
				y = 0;
			}
			if(x1 == null) {
				x1 = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x1;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp1;
				var _this2 = ret.zpp_inner;
				if(_this2._validate != null) {
					_this2._validate();
				}
				if(ret.zpp_inner.x == x1) {
					var _this3 = ret.zpp_inner;
					if(_this3._validate != null) {
						_this3._validate();
					}
					tmp1 = ret.zpp_inner.y == y;
				} else {
					tmp1 = false;
				}
				if(!tmp1) {
					ret.zpp_inner.x = x1;
					ret.zpp_inner.y = y;
					var _this4 = ret.zpp_inner;
					if(_this4._invalidate != null) {
						_this4._invalidate(_this4);
					}
				}
			}
			ret.zpp_inner.weak = weak;
			tmp.push(ret);
		}
	} else if(((localVerts) instanceof nape_geom_Vec2List)) {
		var lv = localVerts;
		var _g = lv.iterator();
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var length = _g.zpp_inner.zpp_gl();
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_geom_Vec2Iterator.zpp_pool;
				nape_geom_Vec2Iterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(this.zpp_inner_zn.wrap_lverts == null) {
				this.zpp_inner_zn.getlverts();
			}
			var tmp1 = this.zpp_inner_zn.wrap_lverts;
			var _this = x.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			var x1 = x.zpp_inner.x;
			var _this1 = x.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			var y = x.zpp_inner.y;
			var weak = false;
			if(weak == null) {
				weak = false;
			}
			if(y == null) {
				y = 0;
			}
			if(x1 == null) {
				x1 = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x1;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp2;
				var _this2 = ret.zpp_inner;
				if(_this2._validate != null) {
					_this2._validate();
				}
				if(ret.zpp_inner.x == x1) {
					var _this3 = ret.zpp_inner;
					if(_this3._validate != null) {
						_this3._validate();
					}
					tmp2 = ret.zpp_inner.y == y;
				} else {
					tmp2 = false;
				}
				if(!tmp2) {
					ret.zpp_inner.x = x1;
					ret.zpp_inner.y = y;
					var _this4 = ret.zpp_inner;
					if(_this4._invalidate != null) {
						_this4._invalidate(_this4);
					}
				}
			}
			ret.zpp_inner.weak = weak;
			tmp1.push(ret);
		}
	} else if(((localVerts) instanceof nape_geom_GeomPoly)) {
		var lv = localVerts;
		var verts = lv.zpp_inner.vertices;
		if(verts != null) {
			var vite = verts;
			do {
				var x = vite.x;
				var y = vite.y;
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret = new nape_geom_Vec2();
				} else {
					ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
					ret.zpp_pool = null;
				}
				if(ret.zpp_inner == null) {
					var ret1;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret1 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.weak = false;
					ret1._immutable = false;
					ret1.x = x;
					ret1.y = y;
					ret.zpp_inner = ret1;
					ret.zpp_inner.outer = ret;
				} else {
					var tmp;
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					if(ret.zpp_inner.x == x) {
						var _this1 = ret.zpp_inner;
						if(_this1._validate != null) {
							_this1._validate();
						}
						tmp = ret.zpp_inner.y == y;
					} else {
						tmp = false;
					}
					if(!tmp) {
						ret.zpp_inner.x = x;
						ret.zpp_inner.y = y;
						var _this2 = ret.zpp_inner;
						if(_this2._invalidate != null) {
							_this2._invalidate(_this2);
						}
					}
				}
				ret.zpp_inner.weak = false;
				var x1 = ret;
				vite = vite.next;
				if(this.zpp_inner_zn.wrap_lverts == null) {
					this.zpp_inner_zn.getlverts();
				}
				var tmp1 = this.zpp_inner_zn.wrap_lverts;
				var _this3 = x1.zpp_inner;
				if(_this3._validate != null) {
					_this3._validate();
				}
				var x2 = x1.zpp_inner.x;
				var _this4 = x1.zpp_inner;
				if(_this4._validate != null) {
					_this4._validate();
				}
				var y1 = x1.zpp_inner.y;
				var weak = false;
				if(weak == null) {
					weak = false;
				}
				if(y1 == null) {
					y1 = 0;
				}
				if(x2 == null) {
					x2 = 0;
				}
				var ret2;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret2 = new nape_geom_Vec2();
				} else {
					ret2 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret2.zpp_pool;
					ret2.zpp_pool = null;
				}
				if(ret2.zpp_inner == null) {
					var ret3;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret3 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret3 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret3.next;
						ret3.next = null;
					}
					ret3.weak = false;
					ret3._immutable = false;
					ret3.x = x2;
					ret3.y = y1;
					ret2.zpp_inner = ret3;
					ret2.zpp_inner.outer = ret2;
				} else {
					var tmp2;
					var _this5 = ret2.zpp_inner;
					if(_this5._validate != null) {
						_this5._validate();
					}
					if(ret2.zpp_inner.x == x2) {
						var _this6 = ret2.zpp_inner;
						if(_this6._validate != null) {
							_this6._validate();
						}
						tmp2 = ret2.zpp_inner.y == y1;
					} else {
						tmp2 = false;
					}
					if(!tmp2) {
						ret2.zpp_inner.x = x2;
						ret2.zpp_inner.y = y1;
						var _this7 = ret2.zpp_inner;
						if(_this7._invalidate != null) {
							_this7._invalidate(_this7);
						}
					}
				}
				ret2.zpp_inner.weak = weak;
				tmp1.push(ret2);
				var inner = x1.zpp_inner;
				x1.zpp_inner.outer = null;
				x1.zpp_inner = null;
				var o = x1;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o1 = inner;
				if(o1.outer != null) {
					o1.outer.zpp_inner = null;
					o1.outer = null;
				}
				o1._isimmutable = null;
				o1._validate = null;
				o1._invalidate = null;
				o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			} while(vite != verts);
		}
	}
	if(((localVerts) instanceof Array)) {
		var lv = localVerts;
		var i = 0;
		while(i < lv.length) {
			var cur = lv[i];
			var tmp;
			if(cur.zpp_inner.weak) {
				var inner = cur.zpp_inner;
				cur.zpp_inner.outer = null;
				cur.zpp_inner = null;
				var o = cur;
				o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
				var o1 = inner;
				if(o1.outer != null) {
					o1.outer.zpp_inner = null;
					o1.outer = null;
				}
				o1._isimmutable = null;
				o1._validate = null;
				o1._invalidate = null;
				o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
				tmp = true;
			} else {
				tmp = false;
			}
			if(tmp) {
				lv.splice(i,1);
				continue;
			}
			++i;
		}
	} else if(((localVerts) instanceof nape_geom_Vec2List)) {
		var lv = localVerts;
		if(lv.zpp_inner._validate != null) {
			lv.zpp_inner._validate();
		}
		var ins = lv.zpp_inner.inner;
		var pre = null;
		var cur = ins.head;
		while(cur != null) {
			var x = cur.elt;
			if(x.outer.zpp_inner.weak) {
				cur = ins.erase(pre);
				if(x.outer.zpp_inner.weak) {
					var _this = x.outer;
					var inner = _this.zpp_inner;
					_this.zpp_inner.outer = null;
					_this.zpp_inner = null;
					var o = _this;
					o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
					var o1 = inner;
					if(o1.outer != null) {
						o1.outer.zpp_inner = null;
						o1.outer = null;
					}
					o1._isimmutable = null;
					o1._validate = null;
					o1._invalidate = null;
					o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
				}
			} else {
				pre = cur;
				cur = cur.next;
			}
		}
	}
	if(material == null) {
		if(zpp_$nape_phys_ZPP_$Material.zpp_pool == null) {
			this.zpp_inner.material = new zpp_$nape_phys_ZPP_$Material();
		} else {
			this.zpp_inner.material = zpp_$nape_phys_ZPP_$Material.zpp_pool;
			zpp_$nape_phys_ZPP_$Material.zpp_pool = this.zpp_inner.material.next;
			this.zpp_inner.material.next = null;
		}
	} else {
		this.zpp_inner.immutable_midstep("Shape::material");
		this.zpp_inner.setMaterial(material.zpp_inner);
		this.zpp_inner.material.wrapper();
	}
	if(filter == null) {
		if(zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool == null) {
			this.zpp_inner.filter = new zpp_$nape_dynamics_ZPP_$InteractionFilter();
		} else {
			this.zpp_inner.filter = zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool = this.zpp_inner.filter.next;
			this.zpp_inner.filter.next = null;
		}
	} else {
		this.zpp_inner.immutable_midstep("Shape::filter");
		this.zpp_inner.setFilter(filter.zpp_inner);
		this.zpp_inner.filter.wrapper();
	}
	this.zpp_inner_i.insert_cbtype(zpp_$nape_callbacks_ZPP_$CbType.ANY_SHAPE.zpp_inner);
};
nape_shape_Polygon.__name__ = true;
nape_shape_Polygon.rect = function(x,y,width,height,weak) {
	if(weak == null) {
		weak = false;
	}
	var x1 = x;
	var y1 = y;
	var weak1 = weak;
	if(weak1 == null) {
		weak1 = false;
	}
	if(y1 == null) {
		y1 = 0;
	}
	if(x1 == null) {
		x1 = 0;
	}
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret = new nape_geom_Vec2();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(ret.zpp_inner == null) {
		var ret1;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.weak = false;
		ret1._immutable = false;
		ret1.x = x1;
		ret1.y = y1;
		ret.zpp_inner = ret1;
		ret.zpp_inner.outer = ret;
	} else {
		var tmp;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret.zpp_inner.x == x1) {
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret.zpp_inner.x = x1;
			ret.zpp_inner.y = y1;
			var _this = ret.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret.zpp_inner.weak = weak1;
	var x1 = x + width;
	var y1 = y;
	var weak1 = weak;
	if(weak1 == null) {
		weak1 = false;
	}
	if(y1 == null) {
		y1 = 0;
	}
	if(x1 == null) {
		x1 = 0;
	}
	var ret1;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret1 = new nape_geom_Vec2();
	} else {
		ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
		ret1.zpp_pool = null;
	}
	if(ret1.zpp_inner == null) {
		var ret2;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret2 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
			ret2.next = null;
		}
		ret2.weak = false;
		ret2._immutable = false;
		ret2.x = x1;
		ret2.y = y1;
		ret1.zpp_inner = ret2;
		ret1.zpp_inner.outer = ret1;
	} else {
		var tmp;
		var _this = ret1.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret1.zpp_inner.x == x1) {
			var _this = ret1.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret1.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret1.zpp_inner.x = x1;
			ret1.zpp_inner.y = y1;
			var _this = ret1.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret1.zpp_inner.weak = weak1;
	var x1 = x + width;
	var y1 = y + height;
	var weak1 = weak;
	if(weak1 == null) {
		weak1 = false;
	}
	if(y1 == null) {
		y1 = 0;
	}
	if(x1 == null) {
		x1 = 0;
	}
	var ret2;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret2 = new nape_geom_Vec2();
	} else {
		ret2 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret2.zpp_pool;
		ret2.zpp_pool = null;
	}
	if(ret2.zpp_inner == null) {
		var ret3;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret3 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret3 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret3.next;
			ret3.next = null;
		}
		ret3.weak = false;
		ret3._immutable = false;
		ret3.x = x1;
		ret3.y = y1;
		ret2.zpp_inner = ret3;
		ret2.zpp_inner.outer = ret2;
	} else {
		var tmp;
		var _this = ret2.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret2.zpp_inner.x == x1) {
			var _this = ret2.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret2.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret2.zpp_inner.x = x1;
			ret2.zpp_inner.y = y1;
			var _this = ret2.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret2.zpp_inner.weak = weak1;
	var x1 = x;
	var y1 = y + height;
	var weak1 = weak;
	if(weak1 == null) {
		weak1 = false;
	}
	if(y1 == null) {
		y1 = 0;
	}
	if(x1 == null) {
		x1 = 0;
	}
	var ret3;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret3 = new nape_geom_Vec2();
	} else {
		ret3 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret3.zpp_pool;
		ret3.zpp_pool = null;
	}
	if(ret3.zpp_inner == null) {
		var ret4;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret4 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret4 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret4.next;
			ret4.next = null;
		}
		ret4.weak = false;
		ret4._immutable = false;
		ret4.x = x1;
		ret4.y = y1;
		ret3.zpp_inner = ret4;
		ret3.zpp_inner.outer = ret3;
	} else {
		var tmp;
		var _this = ret3.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret3.zpp_inner.x == x1) {
			var _this = ret3.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret3.zpp_inner.y == y1;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret3.zpp_inner.x = x1;
			ret3.zpp_inner.y = y1;
			var _this = ret3.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret3.zpp_inner.weak = weak1;
	return [ret,ret1,ret2,ret3];
};
nape_shape_Polygon.box = function(width,height,weak) {
	if(weak == null) {
		weak = false;
	}
	return nape_shape_Polygon.rect(-width / 2,-height / 2,width,height,weak);
};
nape_shape_Polygon.regular = function(xRadius,yRadius,edgeCount,angleOffset,weak) {
	if(weak == null) {
		weak = false;
	}
	if(angleOffset == null) {
		angleOffset = 0.0;
	}
	var ret = [];
	var dangle = Math.PI * 2 / edgeCount;
	var _g = 0;
	var _g1 = edgeCount;
	while(_g < _g1) {
		var i = _g++;
		var ang = i * dangle + angleOffset;
		var x = Math.cos(ang) * xRadius;
		var y = Math.sin(ang) * yRadius;
		var weak1 = weak;
		if(weak1 == null) {
			weak1 = false;
		}
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret1;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret1 = new nape_geom_Vec2();
		} else {
			ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
			ret1.zpp_pool = null;
		}
		if(ret1.zpp_inner == null) {
			var ret2;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret2 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
				ret2.next = null;
			}
			ret2.weak = false;
			ret2._immutable = false;
			ret2.x = x;
			ret2.y = y;
			ret1.zpp_inner = ret2;
			ret1.zpp_inner.outer = ret1;
		} else {
			var tmp;
			var _this = ret1.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret1.zpp_inner.x == x) {
				var _this1 = ret1.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				tmp = ret1.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret1.zpp_inner.x = x;
				ret1.zpp_inner.y = y;
				var _this2 = ret1.zpp_inner;
				if(_this2._invalidate != null) {
					_this2._invalidate(_this2);
				}
			}
		}
		ret1.zpp_inner.weak = weak1;
		var x1 = ret1;
		ret.push(x1);
	}
	return ret;
};
nape_shape_Polygon.__super__ = nape_shape_Shape;
nape_shape_Polygon.prototype = $extend(nape_shape_Shape.prototype,{
	get_localVerts: function() {
		if(this.zpp_inner_zn.wrap_lverts == null) {
			this.zpp_inner_zn.getlverts();
		}
		return this.zpp_inner_zn.wrap_lverts;
	}
	,get_worldVerts: function() {
		if(this.zpp_inner_zn.wrap_gverts == null) {
			this.zpp_inner_zn.getgverts();
		}
		return this.zpp_inner_zn.wrap_gverts;
	}
	,get_edges: function() {
		if(this.zpp_inner_zn.wrap_edges == null) {
			this.zpp_inner_zn.getedges();
		}
		return this.zpp_inner_zn.wrap_edges;
	}
	,validity: function() {
		return this.zpp_inner_zn.valid();
	}
});
var nape_shape_ShapeIterator = $hx_exports["nape"]["shape"]["ShapeIterator"] = function() {
	this.zpp_next = null;
	this.zpp_critical = false;
	this.zpp_i = 0;
	this.zpp_inner = null;
};
nape_shape_ShapeIterator.__name__ = true;
nape_shape_ShapeIterator.get = function(list) {
	var ret;
	if(nape_shape_ShapeIterator.zpp_pool == null) {
		zpp_$nape_util_ZPP_$ShapeList.internal = true;
		var ret1 = new nape_shape_ShapeIterator();
		zpp_$nape_util_ZPP_$ShapeList.internal = false;
		ret = ret1;
	} else {
		var r = nape_shape_ShapeIterator.zpp_pool;
		nape_shape_ShapeIterator.zpp_pool = r.zpp_next;
		ret = r;
	}
	ret.zpp_i = 0;
	ret.zpp_inner = list;
	ret.zpp_critical = false;
	return ret;
};
nape_shape_ShapeIterator.prototype = {
	hasNext: function() {
		this.zpp_inner.zpp_inner.valmod();
		var _this = this.zpp_inner;
		_this.zpp_inner.valmod();
		if(_this.zpp_inner.zip_length) {
			_this.zpp_inner.zip_length = false;
			_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
		}
		var length = _this.zpp_inner.user_length;
		this.zpp_critical = true;
		if(this.zpp_i < length) {
			return true;
		} else {
			this.zpp_next = nape_shape_ShapeIterator.zpp_pool;
			nape_shape_ShapeIterator.zpp_pool = this;
			this.zpp_inner = null;
			return false;
		}
	}
	,next: function() {
		this.zpp_critical = false;
		return this.zpp_inner.at(this.zpp_i++);
	}
};
var nape_shape_ShapeList = $hx_exports["nape"]["shape"]["ShapeList"] = function() {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_util_ZPP_$ShapeList();
	this.zpp_inner.outer = this;
};
nape_shape_ShapeList.__name__ = true;
nape_shape_ShapeList.fromArray = function(array) {
	var ret = new nape_shape_ShapeList();
	var _g = 0;
	while(_g < array.length) {
		var i = array[_g];
		++_g;
		ret.push(i);
	}
	return ret;
};
nape_shape_ShapeList.prototype = {
	get_length: function() {
		this.zpp_inner.valmod();
		if(this.zpp_inner.zip_length) {
			this.zpp_inner.zip_length = false;
			this.zpp_inner.user_length = this.zpp_inner.inner.length;
		}
		return this.zpp_inner.user_length;
	}
	,has: function(obj) {
		this.zpp_inner.valmod();
		return this.zpp_inner.inner.has(obj.zpp_inner);
	}
	,at: function(index) {
		this.zpp_inner.valmod();
		if(this.zpp_inner.reverse_flag) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			index = this.zpp_inner.user_length - 1 - index;
		}
		if(index < this.zpp_inner.at_index || this.zpp_inner.at_ite == null) {
			this.zpp_inner.at_index = index;
			this.zpp_inner.at_ite = this.zpp_inner.inner.iterator_at(index);
		} else {
			while(this.zpp_inner.at_index != index) {
				this.zpp_inner.at_index++;
				this.zpp_inner.at_ite = this.zpp_inner.at_ite.next;
			}
		}
		return this.zpp_inner.at_ite.elt.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.zpp_inner.inner.add(obj.zpp_inner);
			} else {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				if(this.zpp_inner.push_ite == null) {
					var tmp;
					if(this.zpp_inner.inner.head == null) {
						tmp = null;
					} else {
						var tmp1 = this.zpp_inner.inner;
						this.zpp_inner.valmod();
						if(this.zpp_inner.zip_length) {
							this.zpp_inner.zip_length = false;
							this.zpp_inner.user_length = this.zpp_inner.inner.length;
						}
						tmp = tmp1.iterator_at(this.zpp_inner.user_length - 1);
					}
					this.zpp_inner.push_ite = tmp;
				}
				this.zpp_inner.push_ite = this.zpp_inner.inner.insert(this.zpp_inner.push_ite,obj.zpp_inner);
			} else {
				this.zpp_inner.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		} else {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.zpp_inner.at_ite != null && this.zpp_inner.at_ite.next == null) {
				this.zpp_inner.at_ite = null;
			}
			var ite;
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(this.zpp_inner.user_length == 1) {
				ite = null;
			} else {
				var ite1 = this.zpp_inner.inner;
				this.zpp_inner.valmod();
				if(this.zpp_inner.zip_length) {
					this.zpp_inner.zip_length = false;
					this.zpp_inner.user_length = this.zpp_inner.inner.length;
				}
				ite = ite1.iterator_at(this.zpp_inner.user_length - 2);
			}
			ret = ite == null ? this.zpp_inner.inner.head.elt : ite.next.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.erase(ite);
			}
		} else {
			ret = this.zpp_inner.inner.head.elt;
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		var retx = ret.outer;
		return retx;
	}
	,add: function(obj) {
		if(this.zpp_inner.reverse_flag) {
			return this.push(obj);
		} else {
			return this.unshift(obj);
		}
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_inner.valmod();
		var ret;
		ret = false;
		var cx_ite = this.zpp_inner.inner.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if(x == obj.zpp_inner) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.zpp_inner.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(this.zpp_inner.inner.head != null) this.pop();
		} else {
			while(this.zpp_inner.inner.head != null) this.shift();
		}
	}
	,empty: function() {
		return this.zpp_inner.inner.head == null;
	}
	,iterator: function() {
		this.zpp_inner.valmod();
		return nape_shape_ShapeIterator.get(this);
	}
	,copy: function(deep) {
		if(deep == null) {
			deep = false;
		}
		var ret = new nape_shape_ShapeList();
		this.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			ret.push(deep ? null : i);
		}
		return ret;
	}
	,merge: function(xs) {
		xs.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(xs);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var x = _g.zpp_inner.at(_g.zpp_i++);
			if(!this.has(x)) {
				if(this.zpp_inner.reverse_flag) {
					this.push(x);
				} else {
					this.unshift(x);
				}
			}
		}
	}
	,toString: function() {
		var ret = "[";
		var fst = true;
		this.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var i = _g.zpp_inner.at(_g.zpp_i++);
			if(!fst) {
				ret += ",";
			}
			ret += i == null ? "NULL" : i.toString();
			fst = false;
		}
		return ret + "]";
	}
	,foreach: function(lambda) {
		this.zpp_inner.valmod();
		var it = nape_shape_ShapeIterator.get(this);
		while(true) {
			it.zpp_inner.zpp_inner.valmod();
			var _this = it.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			it.zpp_critical = true;
			var tmp;
			if(it.zpp_i < length) {
				tmp = true;
			} else {
				it.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = it;
				it.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			try {
				it.zpp_critical = false;
				lambda(it.zpp_inner.at(it.zpp_i++));
			} catch( _g ) {
				it.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = it;
				it.zpp_inner = null;
				break;
			}
		}
		return this;
	}
	,filter: function(lambda) {
		var i = 0;
		while(true) {
			this.zpp_inner.valmod();
			if(this.zpp_inner.zip_length) {
				this.zpp_inner.zip_length = false;
				this.zpp_inner.user_length = this.zpp_inner.inner.length;
			}
			if(!(i < this.zpp_inner.user_length)) {
				break;
			}
			var x = this.at(i);
			try {
				if(lambda(x)) {
					++i;
				} else {
					this.remove(x);
				}
			} catch( _g ) {
				break;
			}
		}
		return this;
	}
};
var nape_shape_ShapeType = $hx_exports["nape"]["shape"]["ShapeType"] = function() {
};
nape_shape_ShapeType.__name__ = true;
nape_shape_ShapeType.get_CIRCLE = function() {
	if(zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE = new nape_shape_ShapeType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE;
};
nape_shape_ShapeType.get_POLYGON = function() {
	if(zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON = new nape_shape_ShapeType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON;
};
nape_shape_ShapeType.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE = new nape_shape_ShapeType();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE) {
			return "CIRCLE";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON = new nape_shape_ShapeType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON) {
				return "POLYGON";
			} else {
				return "";
			}
		}
	}
};
var nape_shape_ValidationResult = $hx_exports["nape"]["shape"]["ValidationResult"] = function() {
};
nape_shape_ValidationResult.__name__ = true;
nape_shape_ValidationResult.get_VALID = function() {
	if(zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID = new nape_shape_ValidationResult();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID;
};
nape_shape_ValidationResult.get_DEGENERATE = function() {
	if(zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE = new nape_shape_ValidationResult();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE;
};
nape_shape_ValidationResult.get_CONCAVE = function() {
	if(zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE = new nape_shape_ValidationResult();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE;
};
nape_shape_ValidationResult.get_SELF_INTERSECTING = function() {
	if(zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING = new nape_shape_ValidationResult();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING;
};
nape_shape_ValidationResult.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID = new nape_shape_ValidationResult();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID) {
			return "VALID";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE = new nape_shape_ValidationResult();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE) {
				return "DEGENERATE";
			} else {
				if(zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE = new nape_shape_ValidationResult();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				if(this == zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE) {
					return "CONCAVE";
				} else {
					if(zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING = new nape_shape_ValidationResult();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					if(this == zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING) {
						return "SELF_INTERSECTING";
					} else {
						return "";
					}
				}
			}
		}
	}
};
var nape_space_Broadphase = $hx_exports["nape"]["space"]["Broadphase"] = function() {
};
nape_space_Broadphase.__name__ = true;
nape_space_Broadphase.get_DYNAMIC_AABB_TREE = function() {
	if(zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE = new nape_space_Broadphase();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE;
};
nape_space_Broadphase.get_SWEEP_AND_PRUNE = function() {
	if(zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE = new nape_space_Broadphase();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	return zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE;
};
nape_space_Broadphase.prototype = {
	toString: function() {
		if(zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE = new nape_space_Broadphase();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(this == zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE) {
			return "DYNAMIC_AABB_TREE";
		} else {
			if(zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE = new nape_space_Broadphase();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			if(this == zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE) {
				return "SWEEP_AND_PRUNE";
			} else {
				return "";
			}
		}
	}
};
var nape_space_Space = $hx_exports["nape"]["space"]["Space"] = function(gravity,broadphase) {
	this.zpp_inner = null;
	this.zpp_inner = new zpp_$nape_space_ZPP_$Space(gravity == null ? null : gravity.zpp_inner,broadphase);
	this.zpp_inner.outer = this;
	if(gravity != null) {
		if(gravity.zpp_inner.weak) {
			var inner = gravity.zpp_inner;
			gravity.zpp_inner.outer = null;
			gravity.zpp_inner = null;
			var o = gravity;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
	}
};
nape_space_Space.__name__ = true;
nape_space_Space.prototype = {
	get_userData: function() {
		if(this.zpp_inner.userData == null) {
			this.zpp_inner.userData = { };
		}
		return this.zpp_inner.userData;
	}
	,get_gravity: function() {
		if(this.zpp_inner.wrap_gravity == null) {
			this.zpp_inner.getgravity();
		}
		return this.zpp_inner.wrap_gravity;
	}
	,set_gravity: function(gravity) {
		if(this.zpp_inner.wrap_gravity == null) {
			this.zpp_inner.getgravity();
		}
		var _this = this.zpp_inner.wrap_gravity;
		var _this1 = gravity.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var x = gravity.zpp_inner.x;
		var _this1 = gravity.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		var y = gravity.zpp_inner.y;
		var tmp;
		var _this1 = _this.zpp_inner;
		if(_this1._validate != null) {
			_this1._validate();
		}
		if(_this.zpp_inner.x == x) {
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			tmp = _this.zpp_inner.y == y;
		} else {
			tmp = false;
		}
		if(!tmp) {
			_this.zpp_inner.x = x;
			_this.zpp_inner.y = y;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate(_this1);
			}
		}
		var ret = _this;
		if(gravity.zpp_inner.weak) {
			var inner = gravity.zpp_inner;
			gravity.zpp_inner.outer = null;
			gravity.zpp_inner = null;
			var o = gravity;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		if(this.zpp_inner.wrap_gravity == null) {
			this.zpp_inner.getgravity();
		}
		return this.zpp_inner.wrap_gravity;
	}
	,get_broadphase: function() {
		if(this.zpp_inner.bphase.is_sweep) {
			if(zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE = new nape_space_Broadphase();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE;
		} else {
			if(zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE = new nape_space_Broadphase();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE;
		}
	}
	,get_sortContacts: function() {
		return this.zpp_inner.sortcontacts;
	}
	,set_sortContacts: function(sortContacts) {
		this.zpp_inner.sortcontacts = sortContacts;
		return this.zpp_inner.sortcontacts;
	}
	,get_worldAngularDrag: function() {
		return this.zpp_inner.global_ang_drag;
	}
	,set_worldAngularDrag: function(worldAngularDrag) {
		var d = worldAngularDrag;
		this.zpp_inner.global_ang_drag = d;
		return this.zpp_inner.global_ang_drag;
	}
	,get_worldLinearDrag: function() {
		return this.zpp_inner.global_lin_drag;
	}
	,set_worldLinearDrag: function(worldLinearDrag) {
		var d = worldLinearDrag;
		this.zpp_inner.global_lin_drag = d;
		return this.zpp_inner.global_lin_drag;
	}
	,get_compounds: function() {
		return this.zpp_inner.wrap_compounds;
	}
	,get_bodies: function() {
		return this.zpp_inner.wrap_bodies;
	}
	,get_liveBodies: function() {
		return this.zpp_inner.wrap_live;
	}
	,get_constraints: function() {
		return this.zpp_inner.wrap_constraints;
	}
	,get_liveConstraints: function() {
		return this.zpp_inner.wrap_livecon;
	}
	,visitBodies: function(lambda) {
		var _this = this.zpp_inner.wrap_bodies;
		_this.zpp_inner.valmod();
		var _g = nape_phys_BodyIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_BodyIterator.zpp_pool;
				nape_phys_BodyIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var b = _g.zpp_inner.at(_g.zpp_i++);
			lambda(b);
		}
		var _this = this.zpp_inner.wrap_compounds;
		_this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			c.visitBodies(lambda);
		}
	}
	,visitConstraints: function(lambda) {
		var _this = this.zpp_inner.wrap_constraints;
		_this.zpp_inner.valmod();
		var _g = nape_constraint_ConstraintIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_constraint_ConstraintIterator.zpp_pool;
				nape_constraint_ConstraintIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			lambda(c);
		}
		var _this = this.zpp_inner.wrap_compounds;
		_this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			c.visitConstraints(lambda);
		}
	}
	,visitCompounds: function(lambda) {
		var _this = this.zpp_inner.wrap_compounds;
		_this.zpp_inner.valmod();
		var _g = nape_phys_CompoundIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_phys_CompoundIterator.zpp_pool;
				nape_phys_CompoundIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var c = _g.zpp_inner.at(_g.zpp_i++);
			lambda(c);
			c.visitCompounds(lambda);
		}
	}
	,get_world: function() {
		return this.zpp_inner.__static;
	}
	,get_arbiters: function() {
		if(this.zpp_inner.wrap_arbiters == null) {
			var ret = new zpp_$nape_dynamics_ZPP_$SpaceArbiterList();
			ret.space = this.zpp_inner;
			this.zpp_inner.wrap_arbiters = ret;
		}
		return this.zpp_inner.wrap_arbiters;
	}
	,get_listeners: function() {
		return this.zpp_inner.wrap_listeners;
	}
	,clear: function() {
		this.zpp_inner.clear();
	}
	,step: function(deltaTime,velocityIterations,positionIterations) {
		if(positionIterations == null) {
			positionIterations = 10;
		}
		if(velocityIterations == null) {
			velocityIterations = 10;
		}
		this.zpp_inner.step(deltaTime,velocityIterations,positionIterations);
	}
	,get_timeStamp: function() {
		return this.zpp_inner.stamp;
	}
	,get_elapsedTime: function() {
		return this.zpp_inner.time;
	}
	,interactionType: function(shape1,shape2) {
		if((shape1.zpp_inner.body != null ? shape1.zpp_inner.body.outer : null).zpp_inner.type == 1 && (shape2.zpp_inner.body != null ? shape2.zpp_inner.body.outer : null).zpp_inner.type == 1) {
			return null;
		}
		if((shape1.zpp_inner.body != null ? shape1.zpp_inner.body.outer : null) == (shape2.zpp_inner.body != null ? shape2.zpp_inner.body.outer : null)) {
			return null;
		}
		var s1 = shape1.zpp_inner;
		var s2 = shape2.zpp_inner;
		var _this = this.zpp_inner;
		var b1 = s1.body;
		var b2 = s2.body;
		var con_ignore;
		con_ignore = false;
		var cx_ite = b1.constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			if(con.ignore && con.pair_exists(b1.id,b2.id)) {
				con_ignore = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		var _g;
		var _g1;
		if(!con_ignore) {
			var cur = s1;
			while(cur != null && cur.group == null) if(cur.ishape != null) {
				cur = cur.ishape.body;
			} else if(cur.icompound != null) {
				cur = cur.icompound.compound;
			} else {
				cur = cur.ibody.compound;
			}
			var g1 = cur == null ? null : cur.group;
			var _g2;
			if(g1 == null) {
				_g2 = false;
			} else {
				var cur = s2;
				while(cur != null && cur.group == null) if(cur.ishape != null) {
					cur = cur.ishape.body;
				} else if(cur.icompound != null) {
					cur = cur.icompound.compound;
				} else {
					cur = cur.ibody.compound;
				}
				var g2 = cur == null ? null : cur.group;
				if(g2 == null) {
					_g2 = false;
				} else {
					var ret = false;
					while(g1 != null && g2 != null) {
						if(g1 == g2) {
							ret = g1.ignore;
							break;
						}
						if(g1.depth < g2.depth) {
							g2 = g2.group;
						} else {
							g1 = g1.group;
						}
					}
					_g2 = ret;
				}
			}
			_g1 = !_g2;
		} else {
			_g1 = false;
		}
		if(_g1) {
			var _g1;
			if(s1.sensorEnabled || s2.sensorEnabled) {
				var _this = s1.filter;
				var x = s2.filter;
				_g1 = (_this.sensorMask & x.sensorGroup) != 0 && (x.sensorMask & _this.sensorGroup) != 0;
			} else {
				_g1 = false;
			}
			if(_g1) {
				_g = 2;
			} else {
				var _g1;
				if(s1.fluidEnabled || s2.fluidEnabled) {
					var _this = s1.filter;
					var x = s2.filter;
					_g1 = (_this.fluidMask & x.fluidGroup) != 0 && (x.fluidMask & _this.fluidGroup) != 0;
				} else {
					_g1 = false;
				}
				if(_g1 && !(b1.imass == 0 && b2.imass == 0 && b1.iinertia == 0 && b2.iinertia == 0)) {
					_g = 0;
				} else {
					var _this = s1.filter;
					var x = s2.filter;
					_g = (_this.collisionMask & x.collisionGroup) != 0 && (x.collisionMask & _this.collisionGroup) != 0 && !(b1.imass == 0 && b2.imass == 0 && b1.iinertia == 0 && b2.iinertia == 0) ? 1 : -1;
				}
			}
		} else {
			_g = -1;
		}
		switch(_g) {
		case 0:
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_FLUID;
		case 1:
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_COLLISION;
		case 2:
			if(zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR = new nape_callbacks_InteractionType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			return zpp_$nape_util_ZPP_$Flags.InteractionType_SENSOR;
		default:
			return null;
		}
	}
	,shapesUnderPoint: function(point,filter,output) {
		var ret = this.zpp_inner;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret1 = point.zpp_inner.x;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret2 = ret.shapesUnderPoint(ret1,point.zpp_inner.y,filter == null ? null : filter.zpp_inner,output);
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret2;
	}
	,bodiesUnderPoint: function(point,filter,output) {
		var ret = this.zpp_inner;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret1 = point.zpp_inner.x;
		var _this = point.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var ret2 = ret.bodiesUnderPoint(ret1,point.zpp_inner.y,filter == null ? null : filter.zpp_inner,output);
		if(point.zpp_inner.weak) {
			var inner = point.zpp_inner;
			point.zpp_inner.outer = null;
			point.zpp_inner = null;
			var o = point;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret2;
	}
	,shapesInAABB: function(aabb,containment,strict,filter,output) {
		if(strict == null) {
			strict = true;
		}
		if(containment == null) {
			containment = false;
		}
		return this.zpp_inner.shapesInAABB(aabb,strict,containment,filter == null ? null : filter.zpp_inner,output);
	}
	,bodiesInAABB: function(aabb,containment,strict,filter,output) {
		if(strict == null) {
			strict = true;
		}
		if(containment == null) {
			containment = false;
		}
		return this.zpp_inner.bodiesInAABB(aabb,strict,containment,filter == null ? null : filter.zpp_inner,output);
	}
	,shapesInCircle: function(position,radius,containment,filter,output) {
		if(containment == null) {
			containment = false;
		}
		var ret = this.zpp_inner.shapesInCircle(position,radius,containment,filter == null ? null : filter.zpp_inner,output);
		if(position.zpp_inner.weak) {
			var inner = position.zpp_inner;
			position.zpp_inner.outer = null;
			position.zpp_inner = null;
			var o = position;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,bodiesInCircle: function(position,radius,containment,filter,output) {
		if(containment == null) {
			containment = false;
		}
		var ret = this.zpp_inner.bodiesInCircle(position,radius,containment,filter == null ? null : filter.zpp_inner,output);
		if(position.zpp_inner.weak) {
			var inner = position.zpp_inner;
			position.zpp_inner.outer = null;
			position.zpp_inner = null;
			var o = position;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		return ret;
	}
	,shapesInShape: function(shape,containment,filter,output) {
		if(containment == null) {
			containment = false;
		}
		return this.zpp_inner.shapesInShape(shape.zpp_inner,containment,filter == null ? null : filter.zpp_inner,output);
	}
	,bodiesInShape: function(shape,containment,filter,output) {
		if(containment == null) {
			containment = false;
		}
		return this.zpp_inner.bodiesInShape(shape.zpp_inner,containment,filter == null ? null : filter.zpp_inner,output);
	}
	,shapesInBody: function(body,filter,output) {
		var ret = output == null ? new nape_shape_ShapeList() : output;
		var _this = body.zpp_inner.wrap_shapes;
		_this.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var shape = _g.zpp_inner.at(_g.zpp_i++);
			var cur = this.shapesInShape(shape,false,filter,ret);
		}
		return ret;
	}
	,bodiesInBody: function(body,filter,output) {
		var ret = output == null ? new nape_phys_BodyList() : output;
		var _this = body.zpp_inner.wrap_shapes;
		_this.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var shape = _g.zpp_inner.at(_g.zpp_i++);
			var cur = this.bodiesInShape(shape,false,filter,ret);
		}
		return ret;
	}
	,convexCast: function(shape,deltaTime,liveSweep,filter) {
		if(liveSweep == null) {
			liveSweep = false;
		}
		return this.zpp_inner.convexCast(shape.zpp_inner,deltaTime,filter,liveSweep);
	}
	,convexMultiCast: function(shape,deltaTime,liveSweep,filter,output) {
		if(liveSweep == null) {
			liveSweep = false;
		}
		return this.zpp_inner.convexMultiCast(shape.zpp_inner,deltaTime,filter,liveSweep,output);
	}
	,rayCast: function(ray,inner,filter) {
		if(inner == null) {
			inner = false;
		}
		return this.zpp_inner.rayCast(ray,inner,filter);
	}
	,rayMultiCast: function(ray,inner,filter,output) {
		if(inner == null) {
			inner = false;
		}
		return this.zpp_inner.rayMultiCast(ray,inner,filter,output);
	}
};
var nape_util_Debug = $hx_exports["nape"]["util"]["Debug"] = function() { };
nape_util_Debug.__name__ = true;
nape_util_Debug.version = function() {
	return "Nape 2.0.19";
};
nape_util_Debug.clearObjectPools = function() {
	while(nape_shape_EdgeIterator.zpp_pool != null) {
		var nxt = nape_shape_EdgeIterator.zpp_pool.zpp_next;
		nape_shape_EdgeIterator.zpp_pool.zpp_next = null;
		nape_shape_EdgeIterator.zpp_pool = nxt;
	}
	while(nape_shape_ShapeIterator.zpp_pool != null) {
		var nxt = nape_shape_ShapeIterator.zpp_pool.zpp_next;
		nape_shape_ShapeIterator.zpp_pool.zpp_next = null;
		nape_shape_ShapeIterator.zpp_pool = nxt;
	}
	while(nape_phys_BodyIterator.zpp_pool != null) {
		var nxt = nape_phys_BodyIterator.zpp_pool.zpp_next;
		nape_phys_BodyIterator.zpp_pool.zpp_next = null;
		nape_phys_BodyIterator.zpp_pool = nxt;
	}
	while(nape_phys_CompoundIterator.zpp_pool != null) {
		var nxt = nape_phys_CompoundIterator.zpp_pool.zpp_next;
		nape_phys_CompoundIterator.zpp_pool.zpp_next = null;
		nape_phys_CompoundIterator.zpp_pool = nxt;
	}
	while(nape_phys_InteractorIterator.zpp_pool != null) {
		var nxt = nape_phys_InteractorIterator.zpp_pool.zpp_next;
		nape_phys_InteractorIterator.zpp_pool.zpp_next = null;
		nape_phys_InteractorIterator.zpp_pool = nxt;
	}
	while(nape_geom_ConvexResultIterator.zpp_pool != null) {
		var nxt = nape_geom_ConvexResultIterator.zpp_pool.zpp_next;
		nape_geom_ConvexResultIterator.zpp_pool.zpp_next = null;
		nape_geom_ConvexResultIterator.zpp_pool = nxt;
	}
	while(nape_geom_GeomPolyIterator.zpp_pool != null) {
		var nxt = nape_geom_GeomPolyIterator.zpp_pool.zpp_next;
		nape_geom_GeomPolyIterator.zpp_pool.zpp_next = null;
		nape_geom_GeomPolyIterator.zpp_pool = nxt;
	}
	while(nape_geom_RayResultIterator.zpp_pool != null) {
		var nxt = nape_geom_RayResultIterator.zpp_pool.zpp_next;
		nape_geom_RayResultIterator.zpp_pool.zpp_next = null;
		nape_geom_RayResultIterator.zpp_pool = nxt;
	}
	while(nape_geom_Vec2Iterator.zpp_pool != null) {
		var nxt = nape_geom_Vec2Iterator.zpp_pool.zpp_next;
		nape_geom_Vec2Iterator.zpp_pool.zpp_next = null;
		nape_geom_Vec2Iterator.zpp_pool = nxt;
	}
	while(nape_dynamics_ArbiterIterator.zpp_pool != null) {
		var nxt = nape_dynamics_ArbiterIterator.zpp_pool.zpp_next;
		nape_dynamics_ArbiterIterator.zpp_pool.zpp_next = null;
		nape_dynamics_ArbiterIterator.zpp_pool = nxt;
	}
	while(nape_dynamics_ContactIterator.zpp_pool != null) {
		var nxt = nape_dynamics_ContactIterator.zpp_pool.zpp_next;
		nape_dynamics_ContactIterator.zpp_pool.zpp_next = null;
		nape_dynamics_ContactIterator.zpp_pool = nxt;
	}
	while(nape_dynamics_InteractionGroupIterator.zpp_pool != null) {
		var nxt = nape_dynamics_InteractionGroupIterator.zpp_pool.zpp_next;
		nape_dynamics_InteractionGroupIterator.zpp_pool.zpp_next = null;
		nape_dynamics_InteractionGroupIterator.zpp_pool = nxt;
	}
	while(nape_constraint_ConstraintIterator.zpp_pool != null) {
		var nxt = nape_constraint_ConstraintIterator.zpp_pool.zpp_next;
		nape_constraint_ConstraintIterator.zpp_pool.zpp_next = null;
		nape_constraint_ConstraintIterator.zpp_pool = nxt;
	}
	while(nape_callbacks_CbTypeIterator.zpp_pool != null) {
		var nxt = nape_callbacks_CbTypeIterator.zpp_pool.zpp_next;
		nape_callbacks_CbTypeIterator.zpp_pool.zpp_next = null;
		nape_callbacks_CbTypeIterator.zpp_pool = nxt;
	}
	while(nape_callbacks_ListenerIterator.zpp_pool != null) {
		var nxt = nape_callbacks_ListenerIterator.zpp_pool.zpp_next;
		nape_callbacks_ListenerIterator.zpp_pool.zpp_next = null;
		nape_callbacks_ListenerIterator.zpp_pool = nxt;
	}
	while(zpp_$nape_space_ZPP_$AABBNode.zpp_pool != null) {
		var nxt = zpp_$nape_space_ZPP_$AABBNode.zpp_pool.next;
		zpp_$nape_space_ZPP_$AABBNode.zpp_pool.next = null;
		zpp_$nape_space_ZPP_$AABBNode.zpp_pool = nxt;
	}
	while(zpp_$nape_space_ZPP_$AABBPair.zpp_pool != null) {
		var nxt = zpp_$nape_space_ZPP_$AABBPair.zpp_pool.next;
		zpp_$nape_space_ZPP_$AABBPair.zpp_pool.next = null;
		zpp_$nape_space_ZPP_$AABBPair.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = nxt;
	}
	while(zpp_$nape_space_ZPP_$SweepData.zpp_pool != null) {
		var nxt = zpp_$nape_space_ZPP_$SweepData.zpp_pool.next;
		zpp_$nape_space_ZPP_$SweepData.zpp_pool.next = null;
		zpp_$nape_space_ZPP_$SweepData.zpp_pool = nxt;
	}
	while(zpp_$nape_shape_ZPP_$Edge.zpp_pool != null) {
		var nxt = zpp_$nape_shape_ZPP_$Edge.zpp_pool.next;
		zpp_$nape_shape_ZPP_$Edge.zpp_pool.next = null;
		zpp_$nape_shape_ZPP_$Edge.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = nxt;
	}
	while(zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool != null) {
		var nxt = zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool.next;
		zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool.next = null;
		zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = nxt;
	}
	while(zpp_$nape_phys_ZPP_$Material.zpp_pool != null) {
		var nxt = zpp_$nape_phys_ZPP_$Material.zpp_pool.next;
		zpp_$nape_phys_ZPP_$Material.zpp_pool.next = null;
		zpp_$nape_phys_ZPP_$Material.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$AABB.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$AABB.zpp_pool.next;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool = nxt;
	}
	while(zpp_$nape_space_ZPP_$Island.zpp_pool != null) {
		var nxt = zpp_$nape_space_ZPP_$Island.zpp_pool.next;
		zpp_$nape_space_ZPP_$Island.zpp_pool.next = null;
		zpp_$nape_space_ZPP_$Island.zpp_pool = nxt;
	}
	while(zpp_$nape_space_ZPP_$Component.zpp_pool != null) {
		var nxt = zpp_$nape_space_ZPP_$Component.zpp_pool.next;
		zpp_$nape_space_ZPP_$Component.zpp_pool.next = null;
		zpp_$nape_space_ZPP_$Component.zpp_pool = nxt;
	}
	while(zpp_$nape_space_ZPP_$CallbackSet.zpp_pool != null) {
		var nxt = zpp_$nape_space_ZPP_$CallbackSet.zpp_pool.next;
		zpp_$nape_space_ZPP_$CallbackSet.zpp_pool.next = null;
		zpp_$nape_space_ZPP_$CallbackSet.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$CutVert.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$CutVert.zpp_pool.next;
		zpp_$nape_geom_ZPP_$CutVert.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$CutVert.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$CutInt.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$CutInt.zpp_pool.next;
		zpp_$nape_geom_ZPP_$CutInt.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$CutInt.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool.next;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool.next;
		zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$Mat23.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$Mat23.zpp_pool.next;
		zpp_$nape_geom_ZPP_$Mat23.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$Mat23.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool.next;
		zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$MarchPair.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$MarchPair.zpp_pool.next;
		zpp_$nape_geom_ZPP_$MarchPair.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$MarchPair.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool.next;
		zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool.next;
		zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool.next;
		zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool.next;
		zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool.next;
		zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool.next;
		zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool.next;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = nxt;
	}
	while(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool != null) {
		var nxt = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool.next;
		zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool.next = null;
		zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool.next;
		zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$Vec2.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$Vec2.zpp_pool.next;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = nxt;
	}
	while(zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool != null) {
		var nxt = zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool.next;
		zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool.next = null;
		zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool = nxt;
	}
	while(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool != null) {
		var nxt = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool.next;
		zpp_$nape_dynamics_ZPP_$Contact.zpp_pool.next = null;
		zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool = nxt;
	}
	while(zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool != null) {
		var nxt = zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool.next;
		zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool.next = null;
		zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool = nxt;
	}
	while(zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool != null) {
		var nxt = zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool.next;
		zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool.next = null;
		zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool != null) {
		var nxt = zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool.next;
		zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool.next = null;
		zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool != null) {
		var nxt = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool.next;
		zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool.next = null;
		zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = nxt;
	}
	while(zpp_$nape_callbacks_ZPP_$Callback.zpp_pool != null) {
		var nxt = zpp_$nape_callbacks_ZPP_$Callback.zpp_pool.next;
		zpp_$nape_callbacks_ZPP_$Callback.zpp_pool.next = null;
		zpp_$nape_callbacks_ZPP_$Callback.zpp_pool = nxt;
	}
	while(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool != null) {
		var nxt = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool.next;
		zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool.next = null;
		zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool = nxt;
	}
	while(zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool != null) {
		var nxt = zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool.next;
		zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool.next = null;
		zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool.next;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool.next = null;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool != null) {
		var nxt = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool.next;
		zpp_$nape_util_ZNPNode_$RayResult.zpp_pool.next = null;
		zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = nxt;
	}
	while(zpp_$nape_util_ZPP_$PubPool.poolGeomPoly != null) {
		var nxt = zpp_$nape_util_ZPP_$PubPool.poolGeomPoly.zpp_pool;
		zpp_$nape_util_ZPP_$PubPool.poolGeomPoly.zpp_pool = null;
		zpp_$nape_util_ZPP_$PubPool.poolGeomPoly = nxt;
	}
	while(zpp_$nape_util_ZPP_$PubPool.poolVec3 != null) {
		var nxt = zpp_$nape_util_ZPP_$PubPool.poolVec3.zpp_pool;
		zpp_$nape_util_ZPP_$PubPool.poolVec3.zpp_pool = null;
		zpp_$nape_util_ZPP_$PubPool.poolVec3 = nxt;
	}
	while(zpp_$nape_util_ZPP_$PubPool.poolVec2 != null) {
		var nxt = zpp_$nape_util_ZPP_$PubPool.poolVec2.zpp_pool;
		zpp_$nape_util_ZPP_$PubPool.poolVec2.zpp_pool = null;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = nxt;
	}
};
var zpp_$nape_ZPP_$ID = function() { };
zpp_$nape_ZPP_$ID.__name__ = true;
zpp_$nape_ZPP_$ID.Interactor = function() {
	return zpp_$nape_ZPP_$ID._Interactor++;
};
zpp_$nape_ZPP_$ID.ZPP_SimpleVert = function() {
	return zpp_$nape_ZPP_$ID._ZPP_SimpleVert++;
};
zpp_$nape_ZPP_$ID.ZPP_SimpleSeg = function() {
	return zpp_$nape_ZPP_$ID._ZPP_SimpleSeg++;
};
zpp_$nape_ZPP_$ID.Constraint = function() {
	return zpp_$nape_ZPP_$ID._Constraint++;
};
zpp_$nape_ZPP_$ID.CbType = function() {
	return zpp_$nape_ZPP_$ID._CbType++;
};
zpp_$nape_ZPP_$ID.CbSet = function() {
	return zpp_$nape_ZPP_$ID._CbSet++;
};
zpp_$nape_ZPP_$ID.Listener = function() {
	return zpp_$nape_ZPP_$ID._Listener++;
};
var zpp_$nape_callbacks_ZPP_$Callback = function() {
	this.constraint = null;
	this.body = null;
	this.pre_swapped = false;
	this.pre_arbiter = null;
	this.wrap_arbiters = null;
	this.set = null;
	this.int2 = null;
	this.int1 = null;
	this.length = 0;
	this.prev = null;
	this.next = null;
	this.listener = null;
	this.event = 0;
	this.outer_int = null;
	this.outer_con = null;
	this.outer_body = null;
	this.length = 0;
};
zpp_$nape_callbacks_ZPP_$Callback.__name__ = true;
zpp_$nape_callbacks_ZPP_$Callback.prototype = {
	wrapper_body: function() {
		if(this.outer_body == null) {
			this.outer_body = new nape_callbacks_BodyCallback();
			this.outer_body.zpp_inner = this;
		}
		return this.outer_body;
	}
	,wrapper_con: function() {
		if(this.outer_con == null) {
			this.outer_con = new nape_callbacks_ConstraintCallback();
			this.outer_con.zpp_inner = this;
		}
		return this.outer_con;
	}
	,wrapper_int: function() {
		if(this.outer_int == null) {
			this.outer_int = new nape_callbacks_InteractionCallback();
			this.outer_int.zpp_inner = this;
		}
		if(this.wrap_arbiters == null) {
			this.wrap_arbiters = zpp_$nape_util_ZPP_$ArbiterList.get(this.set.arbiters,true);
		} else {
			this.wrap_arbiters.zpp_inner.inner = this.set.arbiters;
		}
		this.wrap_arbiters.zpp_inner.zip_length = true;
		this.wrap_arbiters.zpp_inner.at_ite = null;
		return this.outer_int;
	}
	,push: function(obj) {
		if(this.prev != null) {
			this.prev.next = obj;
		} else {
			this.next = obj;
		}
		obj.prev = this.prev;
		obj.next = null;
		this.prev = obj;
		this.length++;
	}
	,pop: function() {
		var ret = this.next;
		this.next = ret.next;
		if(this.next == null) {
			this.prev = null;
		} else {
			this.next.prev = null;
		}
		this.length--;
		return ret;
	}
	,empty: function() {
		return this.next == null;
	}
};
var zpp_$nape_callbacks_ZPP_$CbSet = function() {
	this.constraints = null;
	this.interactors = null;
	this.zip_conlisteners = false;
	this.conlisteners = null;
	this.zip_bodylisteners = false;
	this.bodylisteners = null;
	this.zip_listeners = false;
	this.listeners = null;
	this.cbpairs = null;
	this.manager = null;
	this.id = 0;
	this.next = null;
	this.count = 0;
	this.cbTypes = null;
	this.cbTypes = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
	this.listeners = new zpp_$nape_util_ZNPList_$ZPP_$InteractionListener();
	this.zip_listeners = true;
	this.bodylisteners = new zpp_$nape_util_ZNPList_$ZPP_$BodyListener();
	this.zip_bodylisteners = true;
	this.conlisteners = new zpp_$nape_util_ZNPList_$ZPP_$ConstraintListener();
	this.zip_conlisteners = true;
	this.constraints = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this.interactors = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
	this.id = zpp_$nape_ZPP_$ID.CbSet();
	this.cbpairs = new zpp_$nape_util_ZNPList_$ZPP_$CbSetPair();
};
zpp_$nape_callbacks_ZPP_$CbSet.__name__ = true;
zpp_$nape_callbacks_ZPP_$CbSet.setlt = function(a,b) {
	var i = a.cbTypes.head;
	var j = b.cbTypes.head;
	while(i != null && j != null) {
		var ca = i.elt;
		var cb = j.elt;
		if(ca.id < cb.id) {
			return true;
		}
		if(cb.id < ca.id) {
			return false;
		} else {
			i = i.next;
			j = j.next;
		}
	}
	if(j != null) {
		return i == null;
	} else {
		return false;
	}
};
zpp_$nape_callbacks_ZPP_$CbSet.get = function(cbTypes) {
	var ret;
	if(zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool == null) {
		ret = new zpp_$nape_callbacks_ZPP_$CbSet();
	} else {
		ret = zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool;
		zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool = ret.next;
		ret.next = null;
	}
	var ite = null;
	var cx_ite = cbTypes.head;
	while(cx_ite != null) {
		var cb = cx_ite.elt;
		ite = ret.cbTypes.insert(ite,cb);
		cb.cbsets.add(ret);
		cx_ite = cx_ite.next;
	}
	return ret;
};
zpp_$nape_callbacks_ZPP_$CbSet.single_intersection = function(a,b,i) {
	var _this = a.manager;
	var ret = null;
	var pairs = a.cbpairs.length < b.cbpairs.length ? a.cbpairs : b.cbpairs;
	var cx_ite = pairs.head;
	while(cx_ite != null) {
		var p = cx_ite.elt;
		if(p.a == a && p.b == b || p.a == b && p.b == a) {
			ret = p;
			break;
		}
		cx_ite = cx_ite.next;
	}
	if(ret == null) {
		var ret1;
		if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
			ret1 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
		} else {
			ret1 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
			zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.zip_listeners = true;
		if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(a,b)) {
			ret1.a = a;
			ret1.b = b;
		} else {
			ret1.a = b;
			ret1.b = a;
		}
		ret = ret1;
		a.cbpairs.add(ret);
		if(b != a) {
			b.cbpairs.add(ret);
		}
	}
	if(ret.zip_listeners) {
		ret.zip_listeners = false;
		ret.__validate();
	}
	var ite = ret.listeners.head;
	if(ite != null && ite.elt == i) {
		return ite.next == null;
	} else {
		return false;
	}
};
zpp_$nape_callbacks_ZPP_$CbSet.prototype = {
	invalidate_pairs: function() {
		var cx_ite = this.cbpairs.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.zip_listeners = true;
			cx_ite = cx_ite.next;
		}
	}
	,realvalidate_listeners: function() {
		this.listeners.clear();
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			var npre = null;
			var nite = this.listeners.head;
			var cite = cb.listeners.head;
			while(cite != null) {
				var cx = cite.elt;
				if(nite != null && nite.elt == cx) {
					cite = cite.next;
					npre = nite;
					nite = nite.next;
				} else {
					var tmp;
					if(nite != null) {
						var b = nite.elt;
						tmp = cx.precedence > b.precedence || cx.precedence == b.precedence && cx.id > b.id;
					} else {
						tmp = true;
					}
					if(tmp) {
						if(cx.space == this.manager.space) {
							var _this = this.listeners;
							var ret;
							if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
								ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
							} else {
								ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.elt = cx;
							var temp = ret;
							if(npre == null) {
								temp.next = _this.head;
								_this.head = temp;
							} else {
								temp.next = npre.next;
								npre.next = temp;
							}
							_this.pushmod = _this.modified = true;
							_this.length++;
							npre = temp;
						}
						cite = cite.next;
					} else {
						npre = nite;
						nite = nite.next;
					}
				}
			}
			cx_ite = cx_ite.next;
		}
	}
	,realvalidate_bodylisteners: function() {
		this.bodylisteners.clear();
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			var npre = null;
			var nite = this.bodylisteners.head;
			var cite = cb.bodylisteners.head;
			while(cite != null) {
				var cx = cite.elt;
				if(nite != null && nite.elt == cx) {
					cite = cite.next;
					npre = nite;
					nite = nite.next;
				} else {
					var tmp;
					if(nite != null) {
						var b = nite.elt;
						tmp = cx.precedence > b.precedence || cx.precedence == b.precedence && cx.id > b.id;
					} else {
						tmp = true;
					}
					if(tmp) {
						var _this = cx.options;
						if(!_this.nonemptyintersection(this.cbTypes,_this.excludes) && cx.space == this.manager.space) {
							var _this1 = this.bodylisteners;
							var ret;
							if(zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool == null) {
								ret = new zpp_$nape_util_ZNPNode_$ZPP_$BodyListener();
							} else {
								ret = zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.elt = cx;
							var temp = ret;
							if(npre == null) {
								temp.next = _this1.head;
								_this1.head = temp;
							} else {
								temp.next = npre.next;
								npre.next = temp;
							}
							_this1.pushmod = _this1.modified = true;
							_this1.length++;
							npre = temp;
						}
						cite = cite.next;
					} else {
						npre = nite;
						nite = nite.next;
					}
				}
			}
			cx_ite = cx_ite.next;
		}
	}
	,realvalidate_conlisteners: function() {
		this.conlisteners.clear();
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			var npre = null;
			var nite = this.conlisteners.head;
			var cite = cb.conlisteners.head;
			while(cite != null) {
				var cx = cite.elt;
				if(nite != null && nite.elt == cx) {
					cite = cite.next;
					npre = nite;
					nite = nite.next;
				} else {
					var tmp;
					if(nite != null) {
						var b = nite.elt;
						tmp = cx.precedence > b.precedence || cx.precedence == b.precedence && cx.id > b.id;
					} else {
						tmp = true;
					}
					if(tmp) {
						var _this = cx.options;
						if(!_this.nonemptyintersection(this.cbTypes,_this.excludes) && cx.space == this.manager.space) {
							var _this1 = this.conlisteners;
							var ret;
							if(zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool == null) {
								ret = new zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener();
							} else {
								ret = zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.elt = cx;
							var temp = ret;
							if(npre == null) {
								temp.next = _this1.head;
								_this1.head = temp;
							} else {
								temp.next = npre.next;
								npre.next = temp;
							}
							_this1.pushmod = _this1.modified = true;
							_this1.length++;
							npre = temp;
						}
						cite = cite.next;
					} else {
						npre = nite;
						nite = nite.next;
					}
				}
			}
			cx_ite = cx_ite.next;
		}
	}
	,validate: function() {
		if(this.zip_listeners) {
			this.zip_listeners = false;
			this.realvalidate_listeners();
		}
		if(this.zip_bodylisteners) {
			this.zip_bodylisteners = false;
			this.realvalidate_bodylisteners();
		}
		if(this.zip_conlisteners) {
			this.zip_conlisteners = false;
			this.realvalidate_conlisteners();
		}
	}
};
var zpp_$nape_callbacks_ZPP_$CbSetPair = function() {
	this.listeners = null;
	this.zip_listeners = false;
	this.next = null;
	this.b = null;
	this.a = null;
	this.listeners = new zpp_$nape_util_ZNPList_$ZPP_$InteractionListener();
};
zpp_$nape_callbacks_ZPP_$CbSetPair.__name__ = true;
zpp_$nape_callbacks_ZPP_$CbSetPair.setlt = function(x,y) {
	if(!zpp_$nape_callbacks_ZPP_$CbSet.setlt(x.a,y.a)) {
		if(x.a == y.a) {
			return zpp_$nape_callbacks_ZPP_$CbSet.setlt(x.b,y.b);
		} else {
			return false;
		}
	} else {
		return true;
	}
};
zpp_$nape_callbacks_ZPP_$CbSetPair.prototype = {
	__validate: function() {
		this.listeners.clear();
		var aite = this.a.listeners.head;
		var bite = this.b.listeners.head;
		while(aite != null && bite != null) {
			var ax = aite.elt;
			var bx = bite.elt;
			if(ax == bx) {
				var tmp;
				var tmp1;
				var _this = ax.options1;
				var xs = this.a.cbTypes;
				if(_this.nonemptyintersection(xs,_this.includes) && !_this.nonemptyintersection(xs,_this.excludes)) {
					var _this1 = ax.options2;
					var xs1 = this.b.cbTypes;
					tmp1 = _this1.nonemptyintersection(xs1,_this1.includes) && !_this1.nonemptyintersection(xs1,_this1.excludes);
				} else {
					tmp1 = false;
				}
				if(!tmp1) {
					var _this2 = ax.options2;
					var xs2 = this.a.cbTypes;
					if(_this2.nonemptyintersection(xs2,_this2.includes) && !_this2.nonemptyintersection(xs2,_this2.excludes)) {
						var _this3 = ax.options1;
						var xs3 = this.b.cbTypes;
						tmp = _this3.nonemptyintersection(xs3,_this3.includes) && !_this3.nonemptyintersection(xs3,_this3.excludes);
					} else {
						tmp = false;
					}
				} else {
					tmp = true;
				}
				if(tmp) {
					this.listeners.add(ax);
				}
				aite = aite.next;
				bite = bite.next;
			} else if(ax.precedence > bx.precedence || ax.precedence == bx.precedence && ax.id > bx.id) {
				aite = aite.next;
			} else {
				bite = bite.next;
			}
		}
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$InteractionListener = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$InteractionListener.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$InteractionListener.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$BodyListener = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$BodyListener.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$BodyListener.prototype = {
	remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$ConstraintListener = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$ConstraintListener.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$ConstraintListener.prototype = {
	remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Constraint = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Constraint.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Constraint.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Constraint();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Constraint();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Interactor = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Interactor.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Interactor.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$CbSet = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$CbSet.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$CbSet.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
};
var zpp_$nape_callbacks_ZPP_$CbType = function() {
	this.conlisteners = null;
	this.bodylisteners = null;
	this.listeners = null;
	this.cbsets = null;
	this.id = 0;
	this.userData = null;
	this.outer = null;
	this.id = zpp_$nape_ZPP_$ID.CbType();
	this.listeners = new zpp_$nape_util_ZNPList_$ZPP_$InteractionListener();
	this.bodylisteners = new zpp_$nape_util_ZNPList_$ZPP_$BodyListener();
	this.conlisteners = new zpp_$nape_util_ZNPList_$ZPP_$ConstraintListener();
	this.constraints = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this.interactors = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
	this.cbsets = new zpp_$nape_util_ZNPList_$ZPP_$CbSet();
};
zpp_$nape_callbacks_ZPP_$CbType.__name__ = true;
var zpp_$nape_util_ZPP_$Flags = function() { };
zpp_$nape_util_ZPP_$Flags.__name__ = true;
var zpp_$nape_callbacks_ZPP_$Listener = function() {
	this.space = null;
	this.interaction = null;
	this.constraint = null;
	this.body = null;
	this.precedence = 0;
	this.event = 0;
	this.type = 0;
	this.id = 0;
	this.outer = null;
	this.id = zpp_$nape_ZPP_$ID.Listener();
};
zpp_$nape_callbacks_ZPP_$Listener.__name__ = true;
zpp_$nape_callbacks_ZPP_$Listener.prototype = {
	swapEvent: function(event) {
	}
	,invalidate_precedence: function() {
	}
	,addedToSpace: function() {
	}
	,removedFromSpace: function() {
	}
};
var zpp_$nape_callbacks_ZPP_$BodyListener = function(options,event,handler) {
	this.handler = null;
	this.options = null;
	this.outer_zn = null;
	zpp_$nape_callbacks_ZPP_$Listener.call(this);
	this.event = event;
	this.handler = handler;
	this.body = this;
	this.type = 0;
	this.options = options.zpp_inner;
};
zpp_$nape_callbacks_ZPP_$BodyListener.__name__ = true;
zpp_$nape_callbacks_ZPP_$BodyListener.__super__ = zpp_$nape_callbacks_ZPP_$Listener;
zpp_$nape_callbacks_ZPP_$BodyListener.prototype = $extend(zpp_$nape_callbacks_ZPP_$Listener.prototype,{
	addedToSpace: function() {
		this.options.handler = $bind(this,this.cbtype_change);
		var cx_ite = this.options.includes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			var pre = null;
			var cx_ite1 = cb.bodylisteners.head;
			while(cx_ite1 != null) {
				var j = cx_ite1.elt;
				if(this.precedence > j.precedence || this.precedence == j.precedence && this.id > j.id) {
					break;
				}
				pre = cx_ite1;
				cx_ite1 = cx_ite1.next;
			}
			var _this = cb.bodylisteners;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$BodyListener();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = this;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
			var cx_ite2 = cb.cbsets.head;
			while(cx_ite2 != null) {
				var cb1 = cx_ite2.elt;
				cb1.zip_bodylisteners = true;
				cx_ite2 = cx_ite2.next;
			}
			cx_ite = cx_ite.next;
		}
	}
	,removedFromSpace: function() {
		var cx_ite = this.options.includes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.bodylisteners.remove(this);
			var cx_ite1 = cb.cbsets.head;
			while(cx_ite1 != null) {
				var cb1 = cx_ite1.elt;
				cb1.zip_bodylisteners = true;
				cx_ite1 = cx_ite1.next;
			}
			cx_ite = cx_ite.next;
		}
		this.options.handler = null;
	}
	,cbtype_change: function(cb,included,added) {
		this.removedFromSpace();
		var _this = this.options;
		if(included) {
			if(added) {
				var pre = null;
				var cx_ite = _this.includes.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(cb.id < j.id) {
						break;
					}
					pre = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this1 = _this.includes;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = cb;
				var temp = ret;
				if(pre == null) {
					temp.next = _this1.head;
					_this1.head = temp;
				} else {
					temp.next = pre.next;
					pre.next = temp;
				}
				_this1.pushmod = _this1.modified = true;
				_this1.length++;
			} else {
				_this.includes.remove(cb);
			}
		} else if(added) {
			var pre = null;
			var cx_ite = _this.excludes.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(cb.id < j.id) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this1 = _this.excludes;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = cb;
			var temp = ret;
			if(pre == null) {
				temp.next = _this1.head;
				_this1.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this1.pushmod = _this1.modified = true;
			_this1.length++;
		} else {
			_this.excludes.remove(cb);
		}
		this.addedToSpace();
	}
	,invalidate_precedence: function() {
		if(this.space != null) {
			this.removedFromSpace();
			this.addedToSpace();
		}
	}
	,swapEvent: function(newev) {
		this.removedFromSpace();
		this.event = newev;
		this.addedToSpace();
	}
});
var zpp_$nape_callbacks_ZPP_$ConstraintListener = function(options,event,handler) {
	this.handler = null;
	this.options = null;
	this.outer_zn = null;
	zpp_$nape_callbacks_ZPP_$Listener.call(this);
	this.event = event;
	this.handler = handler;
	this.constraint = this;
	this.type = 1;
	this.options = options.zpp_inner;
};
zpp_$nape_callbacks_ZPP_$ConstraintListener.__name__ = true;
zpp_$nape_callbacks_ZPP_$ConstraintListener.__super__ = zpp_$nape_callbacks_ZPP_$Listener;
zpp_$nape_callbacks_ZPP_$ConstraintListener.prototype = $extend(zpp_$nape_callbacks_ZPP_$Listener.prototype,{
	addedToSpace: function() {
		this.options.handler = $bind(this,this.cbtype_change);
		var cx_ite = this.options.includes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			var pre = null;
			var cx_ite1 = cb.conlisteners.head;
			while(cx_ite1 != null) {
				var j = cx_ite1.elt;
				if(this.precedence > j.precedence || this.precedence == j.precedence && this.id > j.id) {
					break;
				}
				pre = cx_ite1;
				cx_ite1 = cx_ite1.next;
			}
			var _this = cb.conlisteners;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = this;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
			var cx_ite2 = cb.cbsets.head;
			while(cx_ite2 != null) {
				var cb1 = cx_ite2.elt;
				cb1.zip_conlisteners = true;
				cx_ite2 = cx_ite2.next;
			}
			cx_ite = cx_ite.next;
		}
	}
	,removedFromSpace: function() {
		var cx_ite = this.options.includes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.conlisteners.remove(this);
			var cx_ite1 = cb.cbsets.head;
			while(cx_ite1 != null) {
				var cb1 = cx_ite1.elt;
				cb1.zip_conlisteners = true;
				cx_ite1 = cx_ite1.next;
			}
			cx_ite = cx_ite.next;
		}
		this.options.handler = null;
	}
	,cbtype_change: function(cb,included,added) {
		this.removedFromSpace();
		var _this = this.options;
		if(included) {
			if(added) {
				var pre = null;
				var cx_ite = _this.includes.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(cb.id < j.id) {
						break;
					}
					pre = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this1 = _this.includes;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = cb;
				var temp = ret;
				if(pre == null) {
					temp.next = _this1.head;
					_this1.head = temp;
				} else {
					temp.next = pre.next;
					pre.next = temp;
				}
				_this1.pushmod = _this1.modified = true;
				_this1.length++;
			} else {
				_this.includes.remove(cb);
			}
		} else if(added) {
			var pre = null;
			var cx_ite = _this.excludes.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(cb.id < j.id) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this1 = _this.excludes;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = cb;
			var temp = ret;
			if(pre == null) {
				temp.next = _this1.head;
				_this1.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this1.pushmod = _this1.modified = true;
			_this1.length++;
		} else {
			_this.excludes.remove(cb);
		}
		this.addedToSpace();
	}
	,invalidate_precedence: function() {
		if(this.space != null) {
			this.removedFromSpace();
			this.addedToSpace();
		}
	}
	,swapEvent: function(newev) {
		this.removedFromSpace();
		this.event = newev;
		this.addedToSpace();
	}
});
var zpp_$nape_util_ZNPList_$ZPP_$CbType = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$CbType.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$CbType.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_callbacks_ZPP_$InteractionListener = function(options1,options2,event,type) {
	this.handlerp = null;
	this.pure = false;
	this.allowSleepingCallbacks = false;
	this.handleri = null;
	this.options2 = null;
	this.options1 = null;
	this.itype = 0;
	this.outer_znp = null;
	this.outer_zni = null;
	zpp_$nape_callbacks_ZPP_$Listener.call(this);
	this.type = type;
	this.interaction = this;
	this.event = event;
	this.options1 = options1.zpp_inner;
	this.options2 = options2.zpp_inner;
	this.allowSleepingCallbacks = false;
};
zpp_$nape_callbacks_ZPP_$InteractionListener.__name__ = true;
zpp_$nape_callbacks_ZPP_$InteractionListener.__super__ = zpp_$nape_callbacks_ZPP_$Listener;
zpp_$nape_callbacks_ZPP_$InteractionListener.prototype = $extend(zpp_$nape_callbacks_ZPP_$Listener.prototype,{
	wake: function() {
		var ite1 = this.options1.includes.head;
		var ite2 = this.options2.includes.head;
		while(ite1 != null && ite2 != null) {
			var cb1 = ite1.elt;
			var cb2 = ite2.elt;
			if(cb1 == cb2) {
				var cx_ite = cb1.interactors.head;
				while(cx_ite != null) {
					var i = cx_ite.elt;
					i.wake();
					cx_ite = cx_ite.next;
				}
				ite1 = ite1.next;
				ite2 = ite2.next;
			} else if(cb1.id < cb2.id) {
				var cx_ite1 = cb1.interactors.head;
				while(cx_ite1 != null) {
					var i1 = cx_ite1.elt;
					i1.wake();
					cx_ite1 = cx_ite1.next;
				}
				ite1 = ite1.next;
			} else {
				var cx_ite2 = cb2.interactors.head;
				while(cx_ite2 != null) {
					var i2 = cx_ite2.elt;
					i2.wake();
					cx_ite2 = cx_ite2.next;
				}
				ite2 = ite2.next;
			}
		}
		while(ite1 != null) {
			var cx_ite = ite1.elt.interactors.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				i.wake();
				cx_ite = cx_ite.next;
			}
			ite1 = ite1.next;
		}
		while(ite2 != null) {
			var cx_ite = ite2.elt.interactors.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				i.wake();
				cx_ite = cx_ite.next;
			}
			ite2 = ite2.next;
		}
	}
	,with_uniquesets: function(fresh) {
		var _gthis = this;
		var set;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool == null) {
			set = new zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair();
		} else {
			set = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = set.next;
			set.next = null;
		}
		set.lt = zpp_$nape_callbacks_ZPP_$CbSetPair.setlt;
		var B = this.options2.includes;
		var U = zpp_$nape_callbacks_ZPP_$InteractionListener.UCbType;
		var V = zpp_$nape_callbacks_ZPP_$InteractionListener.VCbType;
		var W = zpp_$nape_callbacks_ZPP_$InteractionListener.WCbType;
		var aite = this.options1.includes.head;
		var bite = B.head;
		while(aite != null && bite != null) {
			var a = aite.elt;
			var b = bite.elt;
			if(a == b) {
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = a;
				var temp = ret;
				temp.next = W.head;
				W.head = temp;
				W.modified = true;
				W.length++;
				aite = aite.next;
				bite = bite.next;
			} else if(a.id < b.id) {
				var ret1;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
					ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
				} else {
					ret1 = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.elt = a;
				var temp1 = ret1;
				temp1.next = U.head;
				U.head = temp1;
				U.modified = true;
				U.length++;
				aite = aite.next;
			} else {
				var ret2;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
					ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
				} else {
					ret2 = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.elt = b;
				var temp2 = ret2;
				temp2.next = V.head;
				V.head = temp2;
				V.modified = true;
				V.length++;
				bite = bite.next;
			}
		}
		while(aite != null) {
			var o = aite.elt;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = o;
			var temp = ret;
			temp.next = U.head;
			U.head = temp;
			U.modified = true;
			U.length++;
			aite = aite.next;
		}
		while(bite != null) {
			var o = bite.elt;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = o;
			var temp = ret;
			temp.next = V.head;
			V.head = temp;
			V.modified = true;
			V.length++;
			bite = bite.next;
		}
		while(U.head != null) {
			var x = U.pop_unsafe();
			var cx_ite = B.head;
			while(cx_ite != null) {
				var y = cx_ite.elt;
				var B1 = y.cbsets;
				var U1 = zpp_$nape_callbacks_ZPP_$InteractionListener.UCbSet;
				var V1 = zpp_$nape_callbacks_ZPP_$InteractionListener.VCbSet;
				var W1 = zpp_$nape_callbacks_ZPP_$InteractionListener.WCbSet;
				var aite = x.cbsets.head;
				var bite = B1.head;
				while(aite != null && bite != null) {
					var a = aite.elt;
					var b = bite.elt;
					if(a == b) {
						var ret;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret.next;
							ret.next = null;
						}
						ret.elt = a;
						var temp = ret;
						temp.next = W1.head;
						W1.head = temp;
						W1.modified = true;
						W1.length++;
						aite = aite.next;
						bite = bite.next;
					} else if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(a,b)) {
						var ret1;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret1 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret1.next;
							ret1.next = null;
						}
						ret1.elt = a;
						var temp1 = ret1;
						temp1.next = U1.head;
						U1.head = temp1;
						U1.modified = true;
						U1.length++;
						aite = aite.next;
					} else {
						var ret2;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret2 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret2.next;
							ret2.next = null;
						}
						ret2.elt = b;
						var temp2 = ret2;
						temp2.next = V1.head;
						V1.head = temp2;
						V1.modified = true;
						V1.length++;
						bite = bite.next;
					}
				}
				while(aite != null) {
					var o = aite.elt;
					var ret3;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret3 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret3.next;
						ret3.next = null;
					}
					ret3.elt = o;
					var temp3 = ret3;
					temp3.next = U1.head;
					U1.head = temp3;
					U1.modified = true;
					U1.length++;
					aite = aite.next;
				}
				while(bite != null) {
					var o1 = bite.elt;
					var ret4;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret4 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret4 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret4.next;
						ret4.next = null;
					}
					ret4.elt = o1;
					var temp4 = ret4;
					temp4.next = V1.head;
					V1.head = temp4;
					V1.modified = true;
					V1.length++;
					bite = bite.next;
				}
				while(U1.head != null) {
					var x1 = U1.pop_unsafe();
					var cx_ite1 = B1.head;
					while(cx_ite1 != null) {
						var y1 = cx_ite1.elt;
						x1.validate();
						y1.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x1,y1,_gthis)) {
							var ret5;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret5 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret5 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret5.next;
								ret5.next = null;
							}
							ret5.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x1,y1)) {
								ret5.a = x1;
								ret5.b = y1;
							} else {
								ret5.a = y1;
								ret5.b = x1;
							}
							set.try_insert(ret5);
						}
						cx_ite1 = cx_ite1.next;
					}
				}
				while(V1.head != null) {
					var x2 = V1.pop_unsafe();
					var cx_ite2 = W1.head;
					while(cx_ite2 != null) {
						var y2 = cx_ite2.elt;
						x2.validate();
						y2.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x2,y2,_gthis)) {
							var ret6;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret6 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret6 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret6.next;
								ret6.next = null;
							}
							ret6.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x2,y2)) {
								ret6.a = x2;
								ret6.b = y2;
							} else {
								ret6.a = y2;
								ret6.b = x2;
							}
							set.try_insert(ret6);
						}
						cx_ite2 = cx_ite2.next;
					}
				}
				while(W1.head != null) {
					var x3 = W1.pop_unsafe();
					x3.validate();
					x3.validate();
					if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x3,x3,_gthis)) {
						var ret7;
						if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
							ret7 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
						} else {
							ret7 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
							zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret7.next;
							ret7.next = null;
						}
						ret7.zip_listeners = true;
						if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x3,x3)) {
							ret7.a = x3;
							ret7.b = x3;
						} else {
							ret7.a = x3;
							ret7.b = x3;
						}
						set.try_insert(ret7);
					}
					var cx_ite3 = W1.head;
					while(cx_ite3 != null) {
						var y3 = cx_ite3.elt;
						x3.validate();
						y3.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x3,y3,_gthis)) {
							var ret8;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret8 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret8 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret8.next;
								ret8.next = null;
							}
							ret8.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x3,y3)) {
								ret8.a = x3;
								ret8.b = y3;
							} else {
								ret8.a = y3;
								ret8.b = x3;
							}
							set.try_insert(ret8);
						}
						cx_ite3 = cx_ite3.next;
					}
				}
				cx_ite = cx_ite.next;
			}
		}
		while(V.head != null) {
			var x = V.pop_unsafe();
			var cx_ite = W.head;
			while(cx_ite != null) {
				var y = cx_ite.elt;
				var B = y.cbsets;
				var U = zpp_$nape_callbacks_ZPP_$InteractionListener.UCbSet;
				var V1 = zpp_$nape_callbacks_ZPP_$InteractionListener.VCbSet;
				var W1 = zpp_$nape_callbacks_ZPP_$InteractionListener.WCbSet;
				var aite = x.cbsets.head;
				var bite = B.head;
				while(aite != null && bite != null) {
					var a = aite.elt;
					var b = bite.elt;
					if(a == b) {
						var ret;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret.next;
							ret.next = null;
						}
						ret.elt = a;
						var temp = ret;
						temp.next = W1.head;
						W1.head = temp;
						W1.modified = true;
						W1.length++;
						aite = aite.next;
						bite = bite.next;
					} else if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(a,b)) {
						var ret1;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret1 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret1.next;
							ret1.next = null;
						}
						ret1.elt = a;
						var temp1 = ret1;
						temp1.next = U.head;
						U.head = temp1;
						U.modified = true;
						U.length++;
						aite = aite.next;
					} else {
						var ret2;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret2 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret2.next;
							ret2.next = null;
						}
						ret2.elt = b;
						var temp2 = ret2;
						temp2.next = V1.head;
						V1.head = temp2;
						V1.modified = true;
						V1.length++;
						bite = bite.next;
					}
				}
				while(aite != null) {
					var o = aite.elt;
					var ret3;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret3 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret3.next;
						ret3.next = null;
					}
					ret3.elt = o;
					var temp3 = ret3;
					temp3.next = U.head;
					U.head = temp3;
					U.modified = true;
					U.length++;
					aite = aite.next;
				}
				while(bite != null) {
					var o1 = bite.elt;
					var ret4;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret4 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret4 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret4.next;
						ret4.next = null;
					}
					ret4.elt = o1;
					var temp4 = ret4;
					temp4.next = V1.head;
					V1.head = temp4;
					V1.modified = true;
					V1.length++;
					bite = bite.next;
				}
				while(U.head != null) {
					var x1 = U.pop_unsafe();
					var cx_ite1 = B.head;
					while(cx_ite1 != null) {
						var y1 = cx_ite1.elt;
						x1.validate();
						y1.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x1,y1,_gthis)) {
							var ret5;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret5 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret5 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret5.next;
								ret5.next = null;
							}
							ret5.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x1,y1)) {
								ret5.a = x1;
								ret5.b = y1;
							} else {
								ret5.a = y1;
								ret5.b = x1;
							}
							set.try_insert(ret5);
						}
						cx_ite1 = cx_ite1.next;
					}
				}
				while(V1.head != null) {
					var x2 = V1.pop_unsafe();
					var cx_ite2 = W1.head;
					while(cx_ite2 != null) {
						var y2 = cx_ite2.elt;
						x2.validate();
						y2.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x2,y2,_gthis)) {
							var ret6;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret6 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret6 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret6.next;
								ret6.next = null;
							}
							ret6.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x2,y2)) {
								ret6.a = x2;
								ret6.b = y2;
							} else {
								ret6.a = y2;
								ret6.b = x2;
							}
							set.try_insert(ret6);
						}
						cx_ite2 = cx_ite2.next;
					}
				}
				while(W1.head != null) {
					var x3 = W1.pop_unsafe();
					x3.validate();
					x3.validate();
					if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x3,x3,_gthis)) {
						var ret7;
						if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
							ret7 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
						} else {
							ret7 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
							zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret7.next;
							ret7.next = null;
						}
						ret7.zip_listeners = true;
						if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x3,x3)) {
							ret7.a = x3;
							ret7.b = x3;
						} else {
							ret7.a = x3;
							ret7.b = x3;
						}
						set.try_insert(ret7);
					}
					var cx_ite3 = W1.head;
					while(cx_ite3 != null) {
						var y3 = cx_ite3.elt;
						x3.validate();
						y3.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x3,y3,_gthis)) {
							var ret8;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret8 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret8 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret8.next;
								ret8.next = null;
							}
							ret8.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x3,y3)) {
								ret8.a = x3;
								ret8.b = y3;
							} else {
								ret8.a = y3;
								ret8.b = x3;
							}
							set.try_insert(ret8);
						}
						cx_ite3 = cx_ite3.next;
					}
				}
				cx_ite = cx_ite.next;
			}
		}
		while(W.head != null) {
			var x = W.pop_unsafe();
			var B = x.cbsets;
			var U = zpp_$nape_callbacks_ZPP_$InteractionListener.UCbSet;
			var V = zpp_$nape_callbacks_ZPP_$InteractionListener.VCbSet;
			var W1 = zpp_$nape_callbacks_ZPP_$InteractionListener.WCbSet;
			var aite = x.cbsets.head;
			var bite = B.head;
			while(aite != null && bite != null) {
				var a = aite.elt;
				var b = bite.elt;
				if(a == b) {
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = a;
					var temp = ret;
					temp.next = W1.head;
					W1.head = temp;
					W1.modified = true;
					W1.length++;
					aite = aite.next;
					bite = bite.next;
				} else if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(a,b)) {
					var ret1;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret1 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.elt = a;
					var temp1 = ret1;
					temp1.next = U.head;
					U.head = temp1;
					U.modified = true;
					U.length++;
					aite = aite.next;
				} else {
					var ret2;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret2 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret2.next;
						ret2.next = null;
					}
					ret2.elt = b;
					var temp2 = ret2;
					temp2.next = V.head;
					V.head = temp2;
					V.modified = true;
					V.length++;
					bite = bite.next;
				}
			}
			while(aite != null) {
				var o = aite.elt;
				var ret3;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
					ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
				} else {
					ret3 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret3.next;
					ret3.next = null;
				}
				ret3.elt = o;
				var temp3 = ret3;
				temp3.next = U.head;
				U.head = temp3;
				U.modified = true;
				U.length++;
				aite = aite.next;
			}
			while(bite != null) {
				var o1 = bite.elt;
				var ret4;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
					ret4 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
				} else {
					ret4 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret4.next;
					ret4.next = null;
				}
				ret4.elt = o1;
				var temp4 = ret4;
				temp4.next = V.head;
				V.head = temp4;
				V.modified = true;
				V.length++;
				bite = bite.next;
			}
			while(U.head != null) {
				var x1 = U.pop_unsafe();
				var cx_ite = B.head;
				while(cx_ite != null) {
					var y = cx_ite.elt;
					x1.validate();
					y.validate();
					if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x1,y,_gthis)) {
						var ret5;
						if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
							ret5 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
						} else {
							ret5 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
							zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret5.next;
							ret5.next = null;
						}
						ret5.zip_listeners = true;
						if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x1,y)) {
							ret5.a = x1;
							ret5.b = y;
						} else {
							ret5.a = y;
							ret5.b = x1;
						}
						set.try_insert(ret5);
					}
					cx_ite = cx_ite.next;
				}
			}
			while(V.head != null) {
				var x2 = V.pop_unsafe();
				var cx_ite1 = W1.head;
				while(cx_ite1 != null) {
					var y1 = cx_ite1.elt;
					x2.validate();
					y1.validate();
					if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x2,y1,_gthis)) {
						var ret6;
						if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
							ret6 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
						} else {
							ret6 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
							zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret6.next;
							ret6.next = null;
						}
						ret6.zip_listeners = true;
						if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x2,y1)) {
							ret6.a = x2;
							ret6.b = y1;
						} else {
							ret6.a = y1;
							ret6.b = x2;
						}
						set.try_insert(ret6);
					}
					cx_ite1 = cx_ite1.next;
				}
			}
			while(W1.head != null) {
				var x3 = W1.pop_unsafe();
				x3.validate();
				x3.validate();
				if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x3,x3,_gthis)) {
					var ret7;
					if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
						ret7 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
					} else {
						ret7 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
						zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret7.next;
						ret7.next = null;
					}
					ret7.zip_listeners = true;
					if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x3,x3)) {
						ret7.a = x3;
						ret7.b = x3;
					} else {
						ret7.a = x3;
						ret7.b = x3;
					}
					set.try_insert(ret7);
				}
				var cx_ite2 = W1.head;
				while(cx_ite2 != null) {
					var y2 = cx_ite2.elt;
					x3.validate();
					y2.validate();
					if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x3,y2,_gthis)) {
						var ret8;
						if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
							ret8 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
						} else {
							ret8 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
							zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret8.next;
							ret8.next = null;
						}
						ret8.zip_listeners = true;
						if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x3,y2)) {
							ret8.a = x3;
							ret8.b = y2;
						} else {
							ret8.a = y2;
							ret8.b = x3;
						}
						set.try_insert(ret8);
					}
					cx_ite2 = cx_ite2.next;
				}
			}
			var cx_ite3 = W.head;
			while(cx_ite3 != null) {
				var y3 = cx_ite3.elt;
				var B1 = y3.cbsets;
				var U1 = zpp_$nape_callbacks_ZPP_$InteractionListener.UCbSet;
				var V1 = zpp_$nape_callbacks_ZPP_$InteractionListener.VCbSet;
				var W2 = zpp_$nape_callbacks_ZPP_$InteractionListener.WCbSet;
				var aite1 = x.cbsets.head;
				var bite1 = B1.head;
				while(aite1 != null && bite1 != null) {
					var a1 = aite1.elt;
					var b1 = bite1.elt;
					if(a1 == b1) {
						var ret9;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret9 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret9 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret9.next;
							ret9.next = null;
						}
						ret9.elt = a1;
						var temp5 = ret9;
						temp5.next = W2.head;
						W2.head = temp5;
						W2.modified = true;
						W2.length++;
						aite1 = aite1.next;
						bite1 = bite1.next;
					} else if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(a1,b1)) {
						var ret10;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret10 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret10 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret10.next;
							ret10.next = null;
						}
						ret10.elt = a1;
						var temp6 = ret10;
						temp6.next = U1.head;
						U1.head = temp6;
						U1.modified = true;
						U1.length++;
						aite1 = aite1.next;
					} else {
						var ret11;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
							ret11 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
						} else {
							ret11 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret11.next;
							ret11.next = null;
						}
						ret11.elt = b1;
						var temp7 = ret11;
						temp7.next = V1.head;
						V1.head = temp7;
						V1.modified = true;
						V1.length++;
						bite1 = bite1.next;
					}
				}
				while(aite1 != null) {
					var o2 = aite1.elt;
					var ret12;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret12 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret12 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret12.next;
						ret12.next = null;
					}
					ret12.elt = o2;
					var temp8 = ret12;
					temp8.next = U1.head;
					U1.head = temp8;
					U1.modified = true;
					U1.length++;
					aite1 = aite1.next;
				}
				while(bite1 != null) {
					var o3 = bite1.elt;
					var ret13;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool == null) {
						ret13 = new zpp_$nape_util_ZNPNode_$ZPP_$CbSet();
					} else {
						ret13 = zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbSet.zpp_pool = ret13.next;
						ret13.next = null;
					}
					ret13.elt = o3;
					var temp9 = ret13;
					temp9.next = V1.head;
					V1.head = temp9;
					V1.modified = true;
					V1.length++;
					bite1 = bite1.next;
				}
				while(U1.head != null) {
					var x4 = U1.pop_unsafe();
					var cx_ite4 = B1.head;
					while(cx_ite4 != null) {
						var y4 = cx_ite4.elt;
						x4.validate();
						y4.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x4,y4,_gthis)) {
							var ret14;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret14 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret14 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret14.next;
								ret14.next = null;
							}
							ret14.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x4,y4)) {
								ret14.a = x4;
								ret14.b = y4;
							} else {
								ret14.a = y4;
								ret14.b = x4;
							}
							set.try_insert(ret14);
						}
						cx_ite4 = cx_ite4.next;
					}
				}
				while(V1.head != null) {
					var x5 = V1.pop_unsafe();
					var cx_ite5 = W2.head;
					while(cx_ite5 != null) {
						var y5 = cx_ite5.elt;
						x5.validate();
						y5.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x5,y5,_gthis)) {
							var ret15;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret15 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret15 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret15.next;
								ret15.next = null;
							}
							ret15.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x5,y5)) {
								ret15.a = x5;
								ret15.b = y5;
							} else {
								ret15.a = y5;
								ret15.b = x5;
							}
							set.try_insert(ret15);
						}
						cx_ite5 = cx_ite5.next;
					}
				}
				while(W2.head != null) {
					var x6 = W2.pop_unsafe();
					x6.validate();
					x6.validate();
					if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x6,x6,_gthis)) {
						var ret16;
						if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
							ret16 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
						} else {
							ret16 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
							zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret16.next;
							ret16.next = null;
						}
						ret16.zip_listeners = true;
						if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x6,x6)) {
							ret16.a = x6;
							ret16.b = x6;
						} else {
							ret16.a = x6;
							ret16.b = x6;
						}
						set.try_insert(ret16);
					}
					var cx_ite6 = W2.head;
					while(cx_ite6 != null) {
						var y6 = cx_ite6.elt;
						x6.validate();
						y6.validate();
						if(zpp_$nape_callbacks_ZPP_$CbSet.single_intersection(x6,y6,_gthis)) {
							var ret17;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret17 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret17 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret17.next;
								ret17.next = null;
							}
							ret17.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(x6,y6)) {
								ret17.a = x6;
								ret17.b = y6;
							} else {
								ret17.a = y6;
								ret17.b = x6;
							}
							set.try_insert(ret17);
						}
						cx_ite6 = cx_ite6.next;
					}
				}
				cx_ite3 = cx_ite3.next;
			}
		}
		if(set.parent != null) {
			var cur = set.parent;
			while(cur != null) if(cur.prev != null) {
				cur = cur.prev;
			} else if(cur.next != null) {
				cur = cur.next;
			} else {
				var pair = cur.data;
				if(fresh) {
					_gthis.space.freshListenerType(pair.a,pair.b);
				} else {
					_gthis.space.nullListenerType(pair.a,pair.b);
				}
				var o = pair;
				o.a = o.b = null;
				o.listeners.clear();
				o.next = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
				zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = o;
				var ret = cur.parent;
				if(ret != null) {
					if(cur == ret.prev) {
						ret.prev = null;
					} else {
						ret.next = null;
					}
					cur.parent = null;
				}
				var o1 = cur;
				o1.data = null;
				o1.lt = null;
				o1.swapped = null;
				o1.next = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = o1;
				cur = ret;
			}
			set.parent = null;
		}
		var o = set;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = o;
	}
	,addedToSpace: function() {
		var _gthis = this;
		var pre = this.type == 3;
		var ite1 = this.options1.includes.head;
		var ite2 = this.options2.includes.head;
		while(ite1 != null && ite2 != null) {
			var cb1 = ite1.elt;
			var cb2 = ite2.elt;
			if(cb1 == cb2) {
				var pre1 = null;
				var cx_ite = cb1.listeners.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(_gthis.precedence > j.precedence || _gthis.precedence == j.precedence && _gthis.id > j.id) {
						break;
					}
					pre1 = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this = cb1.listeners;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = _gthis;
				var temp = ret;
				if(pre1 == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre1.next;
					pre1.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
				var cx_ite1 = cb1.cbsets.head;
				while(cx_ite1 != null) {
					var cb = cx_ite1.elt;
					cb.zip_listeners = true;
					cb.invalidate_pairs();
					cx_ite1 = cx_ite1.next;
				}
				if(pre) {
					var cx_ite2 = cb1.interactors.head;
					while(cx_ite2 != null) {
						var i = cx_ite2.elt;
						i.wake();
						cx_ite2 = cx_ite2.next;
					}
				}
				ite1 = ite1.next;
				ite2 = ite2.next;
			} else if(cb1.id < cb2.id) {
				var pre2 = null;
				var cx_ite3 = cb1.listeners.head;
				while(cx_ite3 != null) {
					var j1 = cx_ite3.elt;
					if(_gthis.precedence > j1.precedence || _gthis.precedence == j1.precedence && _gthis.id > j1.id) {
						break;
					}
					pre2 = cx_ite3;
					cx_ite3 = cx_ite3.next;
				}
				var _this1 = cb1.listeners;
				var ret1;
				if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
					ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
				} else {
					ret1 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.elt = _gthis;
				var temp1 = ret1;
				if(pre2 == null) {
					temp1.next = _this1.head;
					_this1.head = temp1;
				} else {
					temp1.next = pre2.next;
					pre2.next = temp1;
				}
				_this1.pushmod = _this1.modified = true;
				_this1.length++;
				var cx_ite4 = cb1.cbsets.head;
				while(cx_ite4 != null) {
					var cb3 = cx_ite4.elt;
					cb3.zip_listeners = true;
					cb3.invalidate_pairs();
					cx_ite4 = cx_ite4.next;
				}
				if(pre) {
					var cx_ite5 = cb1.interactors.head;
					while(cx_ite5 != null) {
						var i1 = cx_ite5.elt;
						i1.wake();
						cx_ite5 = cx_ite5.next;
					}
				}
				ite1 = ite1.next;
			} else {
				var pre3 = null;
				var cx_ite6 = cb2.listeners.head;
				while(cx_ite6 != null) {
					var j2 = cx_ite6.elt;
					if(_gthis.precedence > j2.precedence || _gthis.precedence == j2.precedence && _gthis.id > j2.id) {
						break;
					}
					pre3 = cx_ite6;
					cx_ite6 = cx_ite6.next;
				}
				var _this2 = cb2.listeners;
				var ret2;
				if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
					ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
				} else {
					ret2 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.elt = _gthis;
				var temp2 = ret2;
				if(pre3 == null) {
					temp2.next = _this2.head;
					_this2.head = temp2;
				} else {
					temp2.next = pre3.next;
					pre3.next = temp2;
				}
				_this2.pushmod = _this2.modified = true;
				_this2.length++;
				var cx_ite7 = cb2.cbsets.head;
				while(cx_ite7 != null) {
					var cb4 = cx_ite7.elt;
					cb4.zip_listeners = true;
					cb4.invalidate_pairs();
					cx_ite7 = cx_ite7.next;
				}
				if(pre) {
					var cx_ite8 = cb2.interactors.head;
					while(cx_ite8 != null) {
						var i2 = cx_ite8.elt;
						i2.wake();
						cx_ite8 = cx_ite8.next;
					}
				}
				ite2 = ite2.next;
			}
		}
		while(ite1 != null) {
			var cb = ite1.elt;
			var pre1 = null;
			var cx_ite = cb.listeners.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(_gthis.precedence > j.precedence || _gthis.precedence == j.precedence && _gthis.id > j.id) {
					break;
				}
				pre1 = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = cb.listeners;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = _gthis;
			var temp = ret;
			if(pre1 == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre1.next;
				pre1.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
			var cx_ite1 = cb.cbsets.head;
			while(cx_ite1 != null) {
				var cb1 = cx_ite1.elt;
				cb1.zip_listeners = true;
				cb1.invalidate_pairs();
				cx_ite1 = cx_ite1.next;
			}
			if(pre) {
				var cx_ite2 = cb.interactors.head;
				while(cx_ite2 != null) {
					var i = cx_ite2.elt;
					i.wake();
					cx_ite2 = cx_ite2.next;
				}
			}
			ite1 = ite1.next;
		}
		while(ite2 != null) {
			var cb = ite2.elt;
			var pre1 = null;
			var cx_ite = cb.listeners.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(_gthis.precedence > j.precedence || _gthis.precedence == j.precedence && _gthis.id > j.id) {
					break;
				}
				pre1 = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = cb.listeners;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = _gthis;
			var temp = ret;
			if(pre1 == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre1.next;
				pre1.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
			var cx_ite1 = cb.cbsets.head;
			while(cx_ite1 != null) {
				var cb1 = cx_ite1.elt;
				cb1.zip_listeners = true;
				cb1.invalidate_pairs();
				cx_ite1 = cx_ite1.next;
			}
			if(pre) {
				var cx_ite2 = cb.interactors.head;
				while(cx_ite2 != null) {
					var i = cx_ite2.elt;
					i.wake();
					cx_ite2 = cx_ite2.next;
				}
			}
			ite2 = ite2.next;
		}
		this.options1.handler = $bind(this,this.cbtype_change1);
		this.options2.handler = $bind(this,this.cbtype_change2);
		this.with_uniquesets(true);
	}
	,removedFromSpace: function() {
		var _gthis = this;
		this.with_uniquesets(false);
		var pre = this.type == 3;
		var ite1 = this.options1.includes.head;
		var ite2 = this.options2.includes.head;
		while(ite1 != null && ite2 != null) {
			var cb1 = ite1.elt;
			var cb2 = ite2.elt;
			if(cb1 == cb2) {
				cb1.listeners.remove(_gthis);
				var cx_ite = cb1.cbsets.head;
				while(cx_ite != null) {
					var cb = cx_ite.elt;
					cb.zip_listeners = true;
					cb.invalidate_pairs();
					cx_ite = cx_ite.next;
				}
				if(pre) {
					var cx_ite1 = cb1.interactors.head;
					while(cx_ite1 != null) {
						var i = cx_ite1.elt;
						i.wake();
						cx_ite1 = cx_ite1.next;
					}
				}
				ite1 = ite1.next;
				ite2 = ite2.next;
			} else if(cb1.id < cb2.id) {
				cb1.listeners.remove(_gthis);
				var cx_ite2 = cb1.cbsets.head;
				while(cx_ite2 != null) {
					var cb3 = cx_ite2.elt;
					cb3.zip_listeners = true;
					cb3.invalidate_pairs();
					cx_ite2 = cx_ite2.next;
				}
				if(pre) {
					var cx_ite3 = cb1.interactors.head;
					while(cx_ite3 != null) {
						var i1 = cx_ite3.elt;
						i1.wake();
						cx_ite3 = cx_ite3.next;
					}
				}
				ite1 = ite1.next;
			} else {
				cb2.listeners.remove(_gthis);
				var cx_ite4 = cb2.cbsets.head;
				while(cx_ite4 != null) {
					var cb4 = cx_ite4.elt;
					cb4.zip_listeners = true;
					cb4.invalidate_pairs();
					cx_ite4 = cx_ite4.next;
				}
				if(pre) {
					var cx_ite5 = cb2.interactors.head;
					while(cx_ite5 != null) {
						var i2 = cx_ite5.elt;
						i2.wake();
						cx_ite5 = cx_ite5.next;
					}
				}
				ite2 = ite2.next;
			}
		}
		while(ite1 != null) {
			var cb = ite1.elt;
			cb.listeners.remove(_gthis);
			var cx_ite = cb.cbsets.head;
			while(cx_ite != null) {
				var cb1 = cx_ite.elt;
				cb1.zip_listeners = true;
				cb1.invalidate_pairs();
				cx_ite = cx_ite.next;
			}
			if(pre) {
				var cx_ite1 = cb.interactors.head;
				while(cx_ite1 != null) {
					var i = cx_ite1.elt;
					i.wake();
					cx_ite1 = cx_ite1.next;
				}
			}
			ite1 = ite1.next;
		}
		while(ite2 != null) {
			var cb = ite2.elt;
			cb.listeners.remove(_gthis);
			var cx_ite = cb.cbsets.head;
			while(cx_ite != null) {
				var cb1 = cx_ite.elt;
				cb1.zip_listeners = true;
				cb1.invalidate_pairs();
				cx_ite = cx_ite.next;
			}
			if(pre) {
				var cx_ite1 = cb.interactors.head;
				while(cx_ite1 != null) {
					var i = cx_ite1.elt;
					i.wake();
					cx_ite1 = cx_ite1.next;
				}
			}
			ite2 = ite2.next;
		}
		this.options1.handler = null;
		this.options2.handler = null;
	}
	,invalidate_precedence: function() {
		var _gthis = this;
		if(this.space != null) {
			var pre = this.type == 3;
			var ite1 = this.options1.includes.head;
			var ite2 = this.options2.includes.head;
			while(ite1 != null && ite2 != null) {
				var cb1 = ite1.elt;
				var cb2 = ite2.elt;
				if(cb1 == cb2) {
					cb1.listeners.remove(_gthis);
					var cx_ite = cb1.cbsets.head;
					while(cx_ite != null) {
						var cb = cx_ite.elt;
						cb.zip_listeners = true;
						cb.invalidate_pairs();
						cx_ite = cx_ite.next;
					}
					var pre1 = null;
					var cx_ite1 = cb1.listeners.head;
					while(cx_ite1 != null) {
						var j = cx_ite1.elt;
						if(_gthis.precedence > j.precedence || _gthis.precedence == j.precedence && _gthis.id > j.id) {
							break;
						}
						pre1 = cx_ite1;
						cx_ite1 = cx_ite1.next;
					}
					var _this = cb1.listeners;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = _gthis;
					var temp = ret;
					if(pre1 == null) {
						temp.next = _this.head;
						_this.head = temp;
					} else {
						temp.next = pre1.next;
						pre1.next = temp;
					}
					_this.pushmod = _this.modified = true;
					_this.length++;
					var cx_ite2 = cb1.cbsets.head;
					while(cx_ite2 != null) {
						var cb3 = cx_ite2.elt;
						cb3.zip_listeners = true;
						cb3.invalidate_pairs();
						cx_ite2 = cx_ite2.next;
					}
					if(pre) {
						var cx_ite3 = cb1.interactors.head;
						while(cx_ite3 != null) {
							var i = cx_ite3.elt;
							i.wake();
							cx_ite3 = cx_ite3.next;
						}
					}
					ite1 = ite1.next;
					ite2 = ite2.next;
				} else if(cb1.id < cb2.id) {
					cb1.listeners.remove(_gthis);
					var cx_ite4 = cb1.cbsets.head;
					while(cx_ite4 != null) {
						var cb4 = cx_ite4.elt;
						cb4.zip_listeners = true;
						cb4.invalidate_pairs();
						cx_ite4 = cx_ite4.next;
					}
					var pre2 = null;
					var cx_ite5 = cb1.listeners.head;
					while(cx_ite5 != null) {
						var j1 = cx_ite5.elt;
						if(_gthis.precedence > j1.precedence || _gthis.precedence == j1.precedence && _gthis.id > j1.id) {
							break;
						}
						pre2 = cx_ite5;
						cx_ite5 = cx_ite5.next;
					}
					var _this1 = cb1.listeners;
					var ret1;
					if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
						ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
					} else {
						ret1 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.elt = _gthis;
					var temp1 = ret1;
					if(pre2 == null) {
						temp1.next = _this1.head;
						_this1.head = temp1;
					} else {
						temp1.next = pre2.next;
						pre2.next = temp1;
					}
					_this1.pushmod = _this1.modified = true;
					_this1.length++;
					var cx_ite6 = cb1.cbsets.head;
					while(cx_ite6 != null) {
						var cb5 = cx_ite6.elt;
						cb5.zip_listeners = true;
						cb5.invalidate_pairs();
						cx_ite6 = cx_ite6.next;
					}
					if(pre) {
						var cx_ite7 = cb1.interactors.head;
						while(cx_ite7 != null) {
							var i1 = cx_ite7.elt;
							i1.wake();
							cx_ite7 = cx_ite7.next;
						}
					}
					ite1 = ite1.next;
				} else {
					cb2.listeners.remove(_gthis);
					var cx_ite8 = cb2.cbsets.head;
					while(cx_ite8 != null) {
						var cb6 = cx_ite8.elt;
						cb6.zip_listeners = true;
						cb6.invalidate_pairs();
						cx_ite8 = cx_ite8.next;
					}
					var pre3 = null;
					var cx_ite9 = cb2.listeners.head;
					while(cx_ite9 != null) {
						var j2 = cx_ite9.elt;
						if(_gthis.precedence > j2.precedence || _gthis.precedence == j2.precedence && _gthis.id > j2.id) {
							break;
						}
						pre3 = cx_ite9;
						cx_ite9 = cx_ite9.next;
					}
					var _this2 = cb2.listeners;
					var ret2;
					if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
						ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
					} else {
						ret2 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret2.next;
						ret2.next = null;
					}
					ret2.elt = _gthis;
					var temp2 = ret2;
					if(pre3 == null) {
						temp2.next = _this2.head;
						_this2.head = temp2;
					} else {
						temp2.next = pre3.next;
						pre3.next = temp2;
					}
					_this2.pushmod = _this2.modified = true;
					_this2.length++;
					var cx_ite10 = cb2.cbsets.head;
					while(cx_ite10 != null) {
						var cb7 = cx_ite10.elt;
						cb7.zip_listeners = true;
						cb7.invalidate_pairs();
						cx_ite10 = cx_ite10.next;
					}
					if(pre) {
						var cx_ite11 = cb2.interactors.head;
						while(cx_ite11 != null) {
							var i2 = cx_ite11.elt;
							i2.wake();
							cx_ite11 = cx_ite11.next;
						}
					}
					ite2 = ite2.next;
				}
			}
			while(ite1 != null) {
				var cb = ite1.elt;
				cb.listeners.remove(_gthis);
				var cx_ite = cb.cbsets.head;
				while(cx_ite != null) {
					var cb1 = cx_ite.elt;
					cb1.zip_listeners = true;
					cb1.invalidate_pairs();
					cx_ite = cx_ite.next;
				}
				var pre1 = null;
				var cx_ite1 = cb.listeners.head;
				while(cx_ite1 != null) {
					var j = cx_ite1.elt;
					if(_gthis.precedence > j.precedence || _gthis.precedence == j.precedence && _gthis.id > j.id) {
						break;
					}
					pre1 = cx_ite1;
					cx_ite1 = cx_ite1.next;
				}
				var _this = cb.listeners;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = _gthis;
				var temp = ret;
				if(pre1 == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre1.next;
					pre1.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
				var cx_ite2 = cb.cbsets.head;
				while(cx_ite2 != null) {
					var cb2 = cx_ite2.elt;
					cb2.zip_listeners = true;
					cb2.invalidate_pairs();
					cx_ite2 = cx_ite2.next;
				}
				if(pre) {
					var cx_ite3 = cb.interactors.head;
					while(cx_ite3 != null) {
						var i = cx_ite3.elt;
						i.wake();
						cx_ite3 = cx_ite3.next;
					}
				}
				ite1 = ite1.next;
			}
			while(ite2 != null) {
				var cb = ite2.elt;
				cb.listeners.remove(_gthis);
				var cx_ite = cb.cbsets.head;
				while(cx_ite != null) {
					var cb1 = cx_ite.elt;
					cb1.zip_listeners = true;
					cb1.invalidate_pairs();
					cx_ite = cx_ite.next;
				}
				var pre1 = null;
				var cx_ite1 = cb.listeners.head;
				while(cx_ite1 != null) {
					var j = cx_ite1.elt;
					if(_gthis.precedence > j.precedence || _gthis.precedence == j.precedence && _gthis.id > j.id) {
						break;
					}
					pre1 = cx_ite1;
					cx_ite1 = cx_ite1.next;
				}
				var _this = cb.listeners;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = _gthis;
				var temp = ret;
				if(pre1 == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre1.next;
					pre1.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
				var cx_ite2 = cb.cbsets.head;
				while(cx_ite2 != null) {
					var cb2 = cx_ite2.elt;
					cb2.zip_listeners = true;
					cb2.invalidate_pairs();
					cx_ite2 = cx_ite2.next;
				}
				if(pre) {
					var cx_ite3 = cb.interactors.head;
					while(cx_ite3 != null) {
						var i = cx_ite3.elt;
						i.wake();
						cx_ite3 = cx_ite3.next;
					}
				}
				ite2 = ite2.next;
			}
		}
	}
	,cbtype_change1: function(cb,included,added) {
		this.cbtype_change(this.options1,cb,included,added);
	}
	,cbtype_change2: function(cb,included,added) {
		this.cbtype_change(this.options2,cb,included,added);
	}
	,cbtype_change: function(options,cb,included,added) {
		this.removedFromSpace();
		if(included) {
			if(added) {
				var pre = null;
				var cx_ite = options.includes.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(cb.id < j.id) {
						break;
					}
					pre = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this = options.includes;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = cb;
				var temp = ret;
				if(pre == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre.next;
					pre.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
			} else {
				options.includes.remove(cb);
			}
		} else if(added) {
			var pre = null;
			var cx_ite = options.excludes.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(cb.id < j.id) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = options.excludes;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = cb;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
		} else {
			options.excludes.remove(cb);
		}
		this.addedToSpace();
	}
	,swapEvent: function(newev) {
		this.removedFromSpace();
		this.event = newev;
		this.addedToSpace();
	}
});
var zpp_$nape_callbacks_ZPP_$OptionType = function() {
	this.wrap_excludes = null;
	this.wrap_includes = null;
	this.excludes = null;
	this.includes = null;
	this.handler = null;
	this.outer = null;
	this.includes = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
	this.excludes = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
};
zpp_$nape_callbacks_ZPP_$OptionType.__name__ = true;
zpp_$nape_callbacks_ZPP_$OptionType.argument = function(val) {
	if(val == null) {
		return new nape_callbacks_OptionType();
	} else if(((val) instanceof nape_callbacks_OptionType)) {
		return val;
	} else {
		return new nape_callbacks_OptionType().including(val);
	}
};
zpp_$nape_callbacks_ZPP_$OptionType.prototype = {
	setup_includes: function() {
		this.wrap_includes = zpp_$nape_util_ZPP_$CbTypeList.get(this.includes,true);
	}
	,setup_excludes: function() {
		this.wrap_excludes = zpp_$nape_util_ZPP_$CbTypeList.get(this.excludes,true);
	}
	,nonemptyintersection: function(xs,ys) {
		var ret = false;
		var xite = xs.head;
		var eite = ys.head;
		while(eite != null && xite != null) {
			var ex = eite.elt;
			var xi = xite.elt;
			if(ex == xi) {
				ret = true;
				break;
			} else if(ex.id < xi.id) {
				eite = eite.next;
			} else {
				xite = xite.next;
			}
		}
		return ret;
	}
	,append_type: function(list,val) {
		if(list == this.includes) {
			if(!this.includes.has(val)) {
				if(!this.excludes.has(val)) {
					if(this.handler != null) {
						this.handler(val,true,true);
					} else {
						var pre = null;
						var cx_ite = this.includes.head;
						while(cx_ite != null) {
							var j = cx_ite.elt;
							if(val.id < j.id) {
								break;
							}
							pre = cx_ite;
							cx_ite = cx_ite.next;
						}
						var _this = this.includes;
						var ret;
						if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
							ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
						} else {
							ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
							ret.next = null;
						}
						ret.elt = val;
						var temp = ret;
						if(pre == null) {
							temp.next = _this.head;
							_this.head = temp;
						} else {
							temp.next = pre.next;
							pre.next = temp;
						}
						_this.pushmod = _this.modified = true;
						_this.length++;
					}
				} else if(this.handler != null) {
					this.handler(val,false,false);
				} else {
					this.excludes.remove(val);
				}
			}
		} else if(!this.excludes.has(val)) {
			if(!this.includes.has(val)) {
				if(this.handler != null) {
					this.handler(val,false,true);
				} else {
					var pre = null;
					var cx_ite = this.excludes.head;
					while(cx_ite != null) {
						var j = cx_ite.elt;
						if(val.id < j.id) {
							break;
						}
						pre = cx_ite;
						cx_ite = cx_ite.next;
					}
					var _this = this.excludes;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = val;
					var temp = ret;
					if(pre == null) {
						temp.next = _this.head;
						_this.head = temp;
					} else {
						temp.next = pre.next;
						pre.next = temp;
					}
					_this.pushmod = _this.modified = true;
					_this.length++;
				}
			} else if(this.handler != null) {
				this.handler(val,true,false);
			} else {
				this.includes.remove(val);
			}
		}
	}
	,set: function(options) {
		if(options != this) {
			while(this.includes.head != null) this.append_type(this.excludes,this.includes.head.elt);
			while(this.excludes.head != null) this.append_type(this.includes,this.excludes.head.elt);
			var cx_ite = options.excludes.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				this.append_type(this.excludes,i);
				cx_ite = cx_ite.next;
			}
			var cx_ite = options.includes.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				this.append_type(this.includes,i);
				cx_ite = cx_ite.next;
			}
		}
		return this;
	}
	,append: function(list,val) {
		if(((val) instanceof nape_callbacks_CbType)) {
			var cb = val;
			this.append_type(list,cb.zpp_inner);
		} else if(((val) instanceof nape_callbacks_CbTypeList)) {
			var cbs = val;
			cbs.zpp_inner.valmod();
			var _g = nape_callbacks_CbTypeIterator.get(cbs);
			while(true) {
				_g.zpp_inner.zpp_inner.valmod();
				var _this = _g.zpp_inner;
				_this.zpp_inner.valmod();
				if(_this.zpp_inner.zip_length) {
					_this.zpp_inner.zip_length = false;
					_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
				}
				var length = _this.zpp_inner.user_length;
				_g.zpp_critical = true;
				var tmp;
				if(_g.zpp_i < length) {
					tmp = true;
				} else {
					_g.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
					nape_callbacks_CbTypeIterator.zpp_pool = _g;
					_g.zpp_inner = null;
					tmp = false;
				}
				if(!tmp) {
					break;
				}
				_g.zpp_critical = false;
				var cb = _g.zpp_inner.at(_g.zpp_i++);
				this.append_type(list,cb.zpp_inner);
			}
		} else if(((val) instanceof Array)) {
			var cbs = val;
			var _g = 0;
			while(_g < cbs.length) {
				var cb = cbs[_g];
				++_g;
				var cbx = cb;
				this.append_type(list,cbx.zpp_inner);
			}
		}
	}
};
var zpp_$nape_constraint_ZPP_$Constraint = function() {
	this.pre_dt = 0.0;
	this.wrap_cbTypes = null;
	this.cbSet = null;
	this.cbTypes = null;
	this.__velocity = false;
	this.ignore = false;
	this.component = null;
	this.removeOnBreak = false;
	this.breakUnderError = false;
	this.breakUnderForce = false;
	this.maxError = 0.0;
	this.maxForce = 0.0;
	this.damping = 0.0;
	this.frequency = 0.0;
	this.stiff = false;
	this.active = false;
	this.space = null;
	this.compound = null;
	this.userData = null;
	this.id = 0;
	this.outer = null;
	this.__velocity = false;
	this.id = zpp_$nape_ZPP_$ID.Constraint();
	this.stiff = true;
	this.active = true;
	this.ignore = false;
	this.frequency = 10;
	this.damping = 1;
	this.maxForce = Infinity;
	this.maxError = Infinity;
	this.breakUnderForce = false;
	this.removeOnBreak = true;
	this.pre_dt = -1.0;
	this.cbTypes = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
};
zpp_$nape_constraint_ZPP_$Constraint.__name__ = true;
zpp_$nape_constraint_ZPP_$Constraint.prototype = {
	immutable_midstep: function(name) {
	}
	,setupcbTypes: function() {
		this.wrap_cbTypes = zpp_$nape_util_ZPP_$CbTypeList.get(this.cbTypes);
		this.wrap_cbTypes.zpp_inner.adder = $bind(this,this.wrap_cbTypes_adder);
		this.wrap_cbTypes.zpp_inner.subber = $bind(this,this.wrap_cbTypes_subber);
		this.wrap_cbTypes.zpp_inner.dontremove = true;
	}
	,wrap_cbTypes_subber: function(pcb) {
		var cb = pcb.zpp_inner;
		if(this.cbTypes.has(cb)) {
			if(this.space != null) {
				this.dealloc_cbSet();
				cb.constraints.remove(this);
			}
			this.cbTypes.remove(cb);
			if(this.space != null) {
				this.alloc_cbSet();
				this.wake();
			}
		}
	}
	,wrap_cbTypes_adder: function(cb) {
		this.insert_cbtype(cb.zpp_inner);
		return false;
	}
	,insert_cbtype: function(cb) {
		if(!this.cbTypes.has(cb)) {
			if(this.space != null) {
				this.dealloc_cbSet();
				cb.constraints.add(this);
			}
			var pre = null;
			var cx_ite = this.cbTypes.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(cb.id < j.id) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = this.cbTypes;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = cb;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
			if(this.space != null) {
				this.alloc_cbSet();
				this.wake();
			}
		}
	}
	,alloc_cbSet: function() {
		if((this.cbSet = this.space.cbsets.get(this.cbTypes)) != null) {
			this.cbSet.count++;
			this.cbSet.constraints.add(this);
		}
	}
	,dealloc_cbSet: function() {
		if(this.cbSet != null) {
			this.cbSet.constraints.remove(this);
			if(--this.cbSet.count == 0) {
				this.space.cbsets.remove(this.cbSet);
				var o = this.cbSet;
				o.listeners.clear();
				o.zip_listeners = true;
				o.bodylisteners.clear();
				o.zip_bodylisteners = true;
				o.conlisteners.clear();
				o.zip_conlisteners = true;
				while(o.cbTypes.head != null) {
					var cb = o.cbTypes.pop_unsafe();
					cb.cbsets.remove(o);
				}
				o.next = zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool;
				zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool = o;
			}
			this.cbSet = null;
		}
	}
	,activate: function() {
		if(this.space != null) {
			this.activeInSpace();
		}
	}
	,deactivate: function() {
		if(this.space != null) {
			this.inactiveOrOutSpace();
		}
	}
	,addedToSpace: function() {
		if(this.active) {
			this.activeInSpace();
		}
		this.activeBodies();
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.constraints.add(this);
			cx_ite = cx_ite.next;
		}
	}
	,removedFromSpace: function() {
		if(this.active) {
			this.inactiveOrOutSpace();
		}
		this.inactiveBodies();
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.constraints.remove(this);
			cx_ite = cx_ite.next;
		}
	}
	,activeInSpace: function() {
		this.alloc_cbSet();
		if(zpp_$nape_space_ZPP_$Component.zpp_pool == null) {
			this.component = new zpp_$nape_space_ZPP_$Component();
		} else {
			this.component = zpp_$nape_space_ZPP_$Component.zpp_pool;
			zpp_$nape_space_ZPP_$Component.zpp_pool = this.component.next;
			this.component.next = null;
		}
		this.component.isBody = false;
		this.component.constraint = this;
	}
	,inactiveOrOutSpace: function() {
		this.dealloc_cbSet();
		var o = this.component;
		o.body = null;
		o.constraint = null;
		o.next = zpp_$nape_space_ZPP_$Component.zpp_pool;
		zpp_$nape_space_ZPP_$Component.zpp_pool = o;
		this.component = null;
	}
	,activeBodies: function() {
	}
	,inactiveBodies: function() {
	}
	,clearcache: function() {
	}
	,wake_connected: function() {
	}
	,forest: function() {
	}
	,pair_exists: function(id,di) {
		return false;
	}
	,broken: function() {
	}
	,warmStart: function() {
	}
	,preStep: function(dt) {
		return false;
	}
	,applyImpulseVel: function() {
		return false;
	}
	,applyImpulsePos: function() {
		return false;
	}
	,wake: function() {
		if(this.space != null) {
			this.space.wake_constraint(this);
		}
	}
	,copy: function(dict,todo) {
		return null;
	}
	,copyto: function(ret) {
		var me = this.outer;
		if(me.zpp_inner.wrap_cbTypes == null) {
			me.zpp_inner.setupcbTypes();
		}
		var _this = me.zpp_inner.wrap_cbTypes;
		_this.zpp_inner.valmod();
		var _g = nape_callbacks_CbTypeIterator.get(_this);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var cb = _g.zpp_inner.at(_g.zpp_i++);
			if(ret.zpp_inner.wrap_cbTypes == null) {
				ret.zpp_inner.setupcbTypes();
			}
			var _this1 = ret.zpp_inner.wrap_cbTypes;
			if(_this1.zpp_inner.reverse_flag) {
				_this1.push(cb);
			} else {
				_this1.unshift(cb);
			}
		}
		ret.zpp_inner.removeOnBreak = me.zpp_inner.removeOnBreak;
		var breakUnderError = me.zpp_inner.breakUnderError;
		if(ret.zpp_inner.breakUnderError != breakUnderError) {
			ret.zpp_inner.breakUnderError = breakUnderError;
			ret.zpp_inner.wake();
		}
		var breakUnderForce = me.zpp_inner.breakUnderForce;
		if(ret.zpp_inner.breakUnderForce != breakUnderForce) {
			ret.zpp_inner.breakUnderForce = breakUnderForce;
			ret.zpp_inner.wake();
		}
		var maxError = me.zpp_inner.maxError;
		if(ret.zpp_inner.maxError != maxError) {
			ret.zpp_inner.maxError = maxError;
			ret.zpp_inner.wake();
		}
		var maxForce = me.zpp_inner.maxForce;
		if(ret.zpp_inner.maxForce != maxForce) {
			ret.zpp_inner.maxForce = maxForce;
			ret.zpp_inner.wake();
		}
		var damping = me.zpp_inner.damping;
		if(ret.zpp_inner.damping != damping) {
			ret.zpp_inner.damping = damping;
			if(!ret.zpp_inner.stiff) {
				ret.zpp_inner.wake();
			}
		}
		var frequency = me.zpp_inner.frequency;
		if(ret.zpp_inner.frequency != frequency) {
			ret.zpp_inner.frequency = frequency;
			if(!ret.zpp_inner.stiff) {
				ret.zpp_inner.wake();
			}
		}
		var stiff = me.zpp_inner.stiff;
		if(ret.zpp_inner.stiff != stiff) {
			ret.zpp_inner.stiff = stiff;
			ret.zpp_inner.wake();
		}
		var ignore = me.zpp_inner.ignore;
		if(ret.zpp_inner.ignore != ignore) {
			ret.zpp_inner.ignore = ignore;
			ret.zpp_inner.wake();
		}
		var active = me.zpp_inner.active;
		if(ret.zpp_inner.active != active) {
			if(ret.zpp_inner.component != null) {
				ret.zpp_inner.component.woken = false;
			}
			ret.zpp_inner.clearcache();
			if(active) {
				ret.zpp_inner.active = active;
				ret.zpp_inner.activate();
				if(ret.zpp_inner.space != null) {
					if(ret.zpp_inner.component != null) {
						ret.zpp_inner.component.sleeping = true;
					}
					ret.zpp_inner.space.wake_constraint(ret.zpp_inner,true);
				}
			} else {
				if(ret.zpp_inner.space != null) {
					ret.zpp_inner.wake();
					ret.zpp_inner.space.live_constraints.remove(ret.zpp_inner);
				}
				ret.zpp_inner.active = active;
				ret.zpp_inner.deactivate();
			}
		}
	}
};
var zpp_$nape_constraint_ZPP_$AngleJoint = function() {
	this.stepped = false;
	this.bias = 0.0;
	this.gamma = 0.0;
	this.jMax = 0.0;
	this.jAcc = 0.0;
	this.kMass = 0.0;
	this.b2 = null;
	this.b1 = null;
	this.scale = 0.0;
	this.equal = false;
	this.slack = false;
	this.jointMax = 0.0;
	this.jointMin = 0.0;
	this.ratio = 0.0;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.ratio = 1;
	this.jAcc = 0;
	this.slack = false;
	this.jMax = Infinity;
	this.stepped = false;
};
zpp_$nape_constraint_ZPP_$AngleJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$AngleJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$AngleJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			if(b == this.b1) {
				return nape_geom_Vec3.get(0,0,-this.scale * this.jAcc);
			} else {
				return nape_geom_Vec3.get(0,0,this.ratio * this.scale * this.jAcc);
			}
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
	}
	,copy: function(dict,todo) {
		var ret = new nape_constraint_AngleJoint(null,null,this.jointMin,this.jointMax,this.ratio);
		this.copyto(ret);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		return ret;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && this.b2.id == di)) {
			if(this.b1.id == di) {
				return this.b2.id == id;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAcc = 0;
		this.pre_dt = -1.0;
		this.slack = false;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.equal = this.jointMin == this.jointMax;
		var C = this.ratio * this.b2.rot - this.b1.rot;
		if(this.equal) {
			C -= this.jointMax;
			this.slack = false;
			this.scale = 1.0;
		} else if(C < this.jointMin) {
			C = this.jointMin - C;
			this.scale = -1.0;
			this.slack = false;
		} else if(C > this.jointMax) {
			C -= this.jointMax;
			this.scale = 1.0;
			this.slack = false;
		} else {
			this.scale = 0.0;
			C = 0;
			this.slack = true;
		}
		var C1 = C;
		if(!this.slack) {
			this.kMass = this.b1.sinertia + this.ratio * this.ratio * this.b2.sinertia;
			if(this.kMass != 0) {
				this.kMass = 1 / this.kMass;
			} else {
				this.jAcc = 0;
			}
			if(!this.stiff) {
				if(this.breakUnderError && C1 * C1 > this.maxError * this.maxError) {
					return true;
				}
				var omega = 2 * Math.PI * this.frequency;
				this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
				var ig = 1 / (1 + this.gamma);
				var biasCoef = dt * omega * omega * this.gamma;
				this.gamma *= ig;
				this.kMass *= ig;
				this.bias = -C1 * biasCoef;
				if(this.bias < -this.maxError) {
					this.bias = -this.maxError;
				} else if(this.bias > this.maxError) {
					this.bias = this.maxError;
				}
			} else {
				this.bias = 0;
				this.gamma = 0;
			}
			this.jAcc *= dtratio;
			this.jMax = this.maxForce * dt;
		}
		return false;
	}
	,warmStart: function() {
		if(!this.slack) {
			this.b1.angvel -= this.scale * this.b1.iinertia * this.jAcc;
			this.b2.angvel += this.ratio * this.scale * this.b2.iinertia * this.jAcc;
		}
	}
	,applyImpulseVel: function() {
		if(this.slack) {
			return false;
		}
		var E = this.scale * (this.ratio * (this.b2.angvel + this.b2.kinangvel) - this.b1.angvel - this.b1.kinangvel);
		var j = this.kMass * (this.bias - E) - this.jAcc * this.gamma;
		var jOld = this.jAcc;
		this.jAcc += j;
		if(!this.equal && this.jAcc > 0) {
			this.jAcc = 0;
		}
		if(this.breakUnderForce && (this.jAcc > this.jMax || this.jAcc < -this.jMax)) {
			return true;
		}
		if(!this.stiff) {
			if(this.jAcc > this.jMax) {
				this.jAcc = this.jMax;
			} else if(this.jAcc < -this.jMax) {
				this.jAcc = -this.jMax;
			}
		}
		j = this.jAcc - jOld;
		this.b1.angvel -= this.scale * this.b1.iinertia * j;
		this.b2.angvel += this.ratio * this.scale * this.b2.iinertia * j;
		return false;
	}
	,applyImpulsePos: function() {
		var j;
		var slack;
		var C = this.ratio * this.b2.rot - this.b1.rot;
		if(this.equal) {
			C -= this.jointMax;
			slack = false;
			this.scale = 1.0;
		} else if(C < this.jointMin) {
			C = this.jointMin - C;
			this.scale = -1.0;
			slack = false;
		} else if(C > this.jointMax) {
			C -= this.jointMax;
			this.scale = 1.0;
			slack = false;
		} else {
			this.scale = 0.0;
			C = 0;
			slack = true;
		}
		var E = C;
		if(!slack) {
			if(this.breakUnderError && E * E > this.maxError * this.maxError) {
				return true;
			}
			E *= 0.5;
			j = -E * this.kMass;
			if(this.equal || j < 0) {
				var _this = this.b1;
				var dr = -this.scale * j * this.b1.iinertia;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
				var _this = this.b2;
				var dr = this.ratio * this.scale * j * this.b2.iinertia;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
			}
		}
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$CopyHelper = function() {
	this.cb = null;
	this.bc = null;
	this.id = 0;
};
zpp_$nape_constraint_ZPP_$CopyHelper.__name__ = true;
zpp_$nape_constraint_ZPP_$CopyHelper.dict = function(id,bc) {
	var ret = new zpp_$nape_constraint_ZPP_$CopyHelper();
	ret.id = id;
	ret.bc = bc;
	return ret;
};
zpp_$nape_constraint_ZPP_$CopyHelper.todo = function(id,cb) {
	var ret = new zpp_$nape_constraint_ZPP_$CopyHelper();
	ret.id = id;
	ret.cb = cb;
	return ret;
};
var zpp_$nape_constraint_ZPP_$DistanceJoint = function() {
	this.stepped = false;
	this.bias = 0.0;
	this.gamma = 0.0;
	this.jMax = 0.0;
	this.jAcc = 0.0;
	this.kMass = 0.0;
	this.wrap_a2 = null;
	this.a2rely = 0.0;
	this.a2relx = 0.0;
	this.a2localy = 0.0;
	this.a2localx = 0.0;
	this.b2 = null;
	this.wrap_a1 = null;
	this.a1rely = 0.0;
	this.a1relx = 0.0;
	this.a1localy = 0.0;
	this.a1localx = 0.0;
	this.b1 = null;
	this.cx2 = 0.0;
	this.cx1 = 0.0;
	this.ny = 0.0;
	this.nx = 0.0;
	this.equal = false;
	this.slack = false;
	this.jointMax = 0.0;
	this.jointMin = 0.0;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.a1localx = 0;
	this.a1localy = 0;
	this.a1relx = 0;
	this.a1rely = 0;
	this.a2localx = 0;
	this.a2localy = 0;
	this.a2relx = 0;
	this.a2rely = 0;
	this.jAcc = 0;
	this.jMax = Infinity;
	this.stepped = false;
	this.cx1 = this.cx2 = 0;
};
zpp_$nape_constraint_ZPP_$DistanceJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$DistanceJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$DistanceJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			if(b == this.b1) {
				return nape_geom_Vec3.get(-this.jAcc * this.nx,-this.jAcc * this.ny,-this.cx1 * this.jAcc);
			} else {
				return nape_geom_Vec3.get(this.jAcc * this.nx,this.jAcc * this.ny,this.cx2 * this.jAcc);
			}
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
	}
	,validate_a1: function() {
		this.wrap_a1.zpp_inner.x = this.a1localx;
		this.wrap_a1.zpp_inner.y = this.a1localy;
	}
	,invalidate_a1: function(x) {
		this.immutable_midstep("Constraint::" + "a1");
		this.a1localx = x.x;
		this.a1localy = x.y;
		this.wake();
	}
	,setup_a1: function() {
		var x = this.a1localx;
		var y = this.a1localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a1 = ret;
		this.wrap_a1.zpp_inner._inuse = true;
		this.wrap_a1.zpp_inner._validate = $bind(this,this.validate_a1);
		this.wrap_a1.zpp_inner._invalidate = $bind(this,this.invalidate_a1);
	}
	,validate_a2: function() {
		this.wrap_a2.zpp_inner.x = this.a2localx;
		this.wrap_a2.zpp_inner.y = this.a2localy;
	}
	,invalidate_a2: function(x) {
		this.immutable_midstep("Constraint::" + "a2");
		this.a2localx = x.x;
		this.a2localy = x.y;
		this.wake();
	}
	,setup_a2: function() {
		var x = this.a2localx;
		var y = this.a2localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a2 = ret;
		this.wrap_a2.zpp_inner._inuse = true;
		this.wrap_a2.zpp_inner._validate = $bind(this,this.validate_a2);
		this.wrap_a2.zpp_inner._invalidate = $bind(this,this.invalidate_a2);
	}
	,copy: function(dict,todo) {
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a1 == null) {
			_this.zpp_inner_zn.setup_a1();
		}
		var ret = _this.zpp_inner_zn.wrap_a1;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a2 == null) {
			_this.zpp_inner_zn.setup_a2();
		}
		var ret1 = new nape_constraint_DistanceJoint(null,null,ret,_this.zpp_inner_zn.wrap_a2,this.jointMin,this.jointMax);
		this.copyto(ret1);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret1.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret1.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret1.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret1.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		return ret1;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && this.b2.id == di)) {
			if(this.b1.id == di) {
				return this.b2.id == id;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAcc = 0;
		this.pre_dt = -1.0;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.equal = this.jointMin == this.jointMax;
		this.a1relx = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		this.a1rely = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		this.a2relx = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		this.a2rely = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		this.nx = this.b2.posx + this.a2relx - (this.b1.posx + this.a1relx);
		this.ny = this.b2.posy + this.a2rely - (this.b1.posy + this.a1rely);
		var C = this.nx * this.nx + this.ny * this.ny;
		if(C < nape_Config.epsilon) {
			this.nx = 0;
			this.ny = 0;
			C = 0;
			this.slack = true;
		} else {
			if(C == 0.0) {
				C = 0.0;
			} else {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = C;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				C = 1 / (x2 * (1.5 - 0.5 * C * x2 * x2));
			}
			var t = 1.0 / C;
			this.nx *= t;
			this.ny *= t;
			if(this.equal) {
				C -= this.jointMax;
				this.slack = false;
			} else if(C < this.jointMin) {
				C = this.jointMin - C;
				this.nx = -this.nx;
				this.ny = -this.ny;
				this.slack = false;
			} else if(C > this.jointMax) {
				C -= this.jointMax;
				this.slack = false;
			} else {
				this.nx = 0;
				this.ny = 0;
				C = 0;
				this.slack = true;
			}
		}
		var C1 = C;
		if(!this.slack) {
			this.cx1 = this.ny * this.a1relx - this.nx * this.a1rely;
			this.cx2 = this.ny * this.a2relx - this.nx * this.a2rely;
			this.kMass = this.b1.smass + this.b2.smass + this.cx1 * this.cx1 * this.b1.sinertia + this.cx2 * this.cx2 * this.b2.sinertia;
			if(this.kMass != 0) {
				this.kMass = 1 / this.kMass;
			} else {
				this.jAcc = 0;
			}
			if(!this.stiff) {
				if(this.breakUnderError && C1 * C1 > this.maxError * this.maxError) {
					return true;
				}
				var omega = 2 * Math.PI * this.frequency;
				this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
				var ig = 1 / (1 + this.gamma);
				var biasCoef = dt * omega * omega * this.gamma;
				this.gamma *= ig;
				this.kMass *= ig;
				this.bias = -C1 * biasCoef;
				if(this.bias < -this.maxError) {
					this.bias = -this.maxError;
				} else if(this.bias > this.maxError) {
					this.bias = this.maxError;
				}
			} else {
				this.bias = 0;
				this.gamma = 0;
			}
			this.jAcc *= dtratio;
			this.jMax = this.maxForce * dt;
		}
		return false;
	}
	,warmStart: function() {
		if(!this.slack) {
			var t = this.b1.imass * this.jAcc;
			this.b1.velx -= this.nx * t;
			this.b1.vely -= this.ny * t;
			var t = this.b2.imass * this.jAcc;
			this.b2.velx += this.nx * t;
			this.b2.vely += this.ny * t;
			this.b1.angvel -= this.cx1 * this.b1.iinertia * this.jAcc;
			this.b2.angvel += this.cx2 * this.b2.iinertia * this.jAcc;
		}
	}
	,applyImpulseVel: function() {
		if(this.slack) {
			return false;
		}
		var E = this.nx * (this.b2.velx + this.b2.kinvelx - this.b1.velx - this.b1.kinvelx) + this.ny * (this.b2.vely + this.b2.kinvely - this.b1.vely - this.b1.kinvely) + (this.b2.angvel + this.b2.kinangvel) * this.cx2 - (this.b1.angvel + this.b1.kinangvel) * this.cx1;
		var j = this.kMass * (this.bias - E) - this.jAcc * this.gamma;
		var jOld = this.jAcc;
		this.jAcc += j;
		if(!this.equal && this.jAcc > 0) {
			this.jAcc = 0;
		}
		if(this.breakUnderForce && this.jAcc < -this.jMax) {
			return true;
		}
		if(!this.stiff) {
			if(this.jAcc < -this.jMax) {
				this.jAcc = -this.jMax;
			}
		}
		j = this.jAcc - jOld;
		var t = this.b1.imass * j;
		this.b1.velx -= this.nx * t;
		this.b1.vely -= this.ny * t;
		var t = this.b2.imass * j;
		this.b2.velx += this.nx * t;
		this.b2.vely += this.ny * t;
		this.b1.angvel -= this.cx1 * this.b1.iinertia * j;
		this.b2.angvel += this.cx2 * this.b2.iinertia * j;
		return false;
	}
	,applyImpulsePos: function() {
		var j;
		var r1x = 0.0;
		var r1y = 0.0;
		r1x = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		r1y = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		var r2x = 0.0;
		var r2y = 0.0;
		r2x = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		r2y = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var slack;
		var nx = 0.0;
		var ny = 0.0;
		nx = this.b2.posx + r2x - (this.b1.posx + r1x);
		ny = this.b2.posy + r2y - (this.b1.posy + r1y);
		var C = nx * nx + ny * ny;
		if(C < nape_Config.epsilon) {
			nx = 0;
			ny = 0;
			C = 0;
			slack = true;
		} else {
			if(C == 0.0) {
				C = 0.0;
			} else {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = C;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				C = 1 / (x2 * (1.5 - 0.5 * C * x2 * x2));
			}
			var t = 1.0 / C;
			nx *= t;
			ny *= t;
			if(this.equal) {
				C -= this.jointMax;
				slack = false;
			} else if(C < this.jointMin) {
				C = this.jointMin - C;
				nx = -nx;
				ny = -ny;
				slack = false;
			} else if(C > this.jointMax) {
				C -= this.jointMax;
				slack = false;
			} else {
				nx = 0;
				ny = 0;
				C = 0;
				slack = true;
			}
		}
		var E = C;
		if(!slack) {
			if(this.breakUnderError && E * E > this.maxError * this.maxError) {
				return true;
			}
			if(E * E < nape_Config.constraintLinearSlop * nape_Config.constraintLinearSlop) {
				return false;
			}
			E *= 0.5;
			if(E * E > 6) {
				var k = this.b1.smass + this.b2.smass;
				if(k > nape_Config.epsilon) {
					k = 0.75 / k;
					j = -E * k;
					if(this.equal || j < 0) {
						var t = j * this.b1.imass;
						this.b1.posx -= nx * t;
						this.b1.posy -= ny * t;
						var t = j * this.b2.imass;
						this.b2.posx += nx * t;
						this.b2.posy += ny * t;
						nx = this.b2.posx + r2x - (this.b1.posx + r1x);
						ny = this.b2.posy + r2y - (this.b1.posy + r1y);
						var C = nx * nx + ny * ny;
						if(C < nape_Config.epsilon) {
							nx = 0;
							ny = 0;
							C = 0;
							slack = true;
						} else {
							if(C == 0.0) {
								C = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = C;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								C = 1 / (x2 * (1.5 - 0.5 * C * x2 * x2));
							}
							var t = 1.0 / C;
							nx *= t;
							ny *= t;
							if(this.equal) {
								C -= this.jointMax;
								slack = false;
							} else if(C < this.jointMin) {
								C = this.jointMin - C;
								nx = -nx;
								ny = -ny;
								slack = false;
							} else if(C > this.jointMax) {
								C -= this.jointMax;
								slack = false;
							} else {
								nx = 0;
								ny = 0;
								C = 0;
								slack = true;
							}
						}
						E = C;
						E *= 0.5;
					}
				}
			}
			var cx1 = ny * r1x - nx * r1y;
			var cx2 = ny * r2x - nx * r2y;
			var k = this.b1.smass + this.b2.smass + cx1 * cx1 * this.b1.sinertia + cx2 * cx2 * this.b2.sinertia;
			if(k != 0) {
				k = 1 / k;
			}
			j = -E * k;
			if(this.equal || j < 0) {
				var t = this.b1.imass * j;
				this.b1.posx -= nx * t;
				this.b1.posy -= ny * t;
				var t = this.b2.imass * j;
				this.b2.posx += nx * t;
				this.b2.posy += ny * t;
				var _this = this.b1;
				var dr = -cx1 * this.b1.iinertia * j;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
				var _this = this.b2;
				var dr = cx2 * this.b2.iinertia * j;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
			}
		}
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$LineJoint = function() {
	this.biasy = 0.0;
	this.biasx = 0.0;
	this.jAccy = 0.0;
	this.jAccx = 0.0;
	this.kMassc = 0.0;
	this.kMassb = 0.0;
	this.kMassa = 0.0;
	this.wrap_n = null;
	this.nrely = 0.0;
	this.nrelx = 0.0;
	this.nlocaly = 0.0;
	this.nlocalx = 0.0;
	this.wrap_a2 = null;
	this.a2rely = 0.0;
	this.a2relx = 0.0;
	this.a2localy = 0.0;
	this.a2localx = 0.0;
	this.wrap_a1 = null;
	this.a1rely = 0.0;
	this.a1relx = 0.0;
	this.a1localy = 0.0;
	this.a1localx = 0.0;
	this.cx2 = 0.0;
	this.cx1 = 0.0;
	this.dot2 = 0.0;
	this.dot1 = 0.0;
	this.equal = false;
	this.jointMax = 0.0;
	this.jointMin = 0.0;
	this.scale = 0.0;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.a1localx = 0;
	this.a1localy = 0;
	this.a1relx = 0;
	this.a1rely = 0;
	this.a2localx = 0;
	this.a2localy = 0;
	this.a2relx = 0;
	this.a2rely = 0;
	this.nlocalx = 0;
	this.nlocaly = 0;
	this.nrelx = 0;
	this.nrely = 0;
	this.jAccx = 0;
	this.jAccy = 0;
	this.jMax = Infinity;
	this.jointMin = -Infinity;
	this.jointMax = Infinity;
	this.stepped = false;
};
zpp_$nape_constraint_ZPP_$LineJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$LineJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$LineJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			var jx = this.scale * this.nrelx * this.jAccy - this.nrely * this.jAccx;
			var jy = this.nrelx * this.jAccx + this.scale * this.nrely * this.jAccy;
			if(b == this.b1) {
				return nape_geom_Vec3.get(-jx,-jy,this.scale * this.cx1 * jy - this.dot1 * jx);
			} else {
				return nape_geom_Vec3.get(jx,jy,this.scale * this.cx1 * jy - this.dot1 * jx);
			}
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
	}
	,validate_a1: function() {
		this.wrap_a1.zpp_inner.x = this.a1localx;
		this.wrap_a1.zpp_inner.y = this.a1localy;
	}
	,invalidate_a1: function(x) {
		this.immutable_midstep("Constraint::" + "a1");
		this.a1localx = x.x;
		this.a1localy = x.y;
		this.wake();
	}
	,setup_a1: function() {
		var x = this.a1localx;
		var y = this.a1localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a1 = ret;
		this.wrap_a1.zpp_inner._inuse = true;
		this.wrap_a1.zpp_inner._validate = $bind(this,this.validate_a1);
		this.wrap_a1.zpp_inner._invalidate = $bind(this,this.invalidate_a1);
	}
	,validate_a2: function() {
		this.wrap_a2.zpp_inner.x = this.a2localx;
		this.wrap_a2.zpp_inner.y = this.a2localy;
	}
	,invalidate_a2: function(x) {
		this.immutable_midstep("Constraint::" + "a2");
		this.a2localx = x.x;
		this.a2localy = x.y;
		this.wake();
	}
	,setup_a2: function() {
		var x = this.a2localx;
		var y = this.a2localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a2 = ret;
		this.wrap_a2.zpp_inner._inuse = true;
		this.wrap_a2.zpp_inner._validate = $bind(this,this.validate_a2);
		this.wrap_a2.zpp_inner._invalidate = $bind(this,this.invalidate_a2);
	}
	,validate_n: function() {
		this.wrap_n.zpp_inner.x = this.nlocalx;
		this.wrap_n.zpp_inner.y = this.nlocaly;
	}
	,invalidate_n: function(x) {
		this.immutable_midstep("Constraint::" + "n");
		this.nlocalx = x.x;
		this.nlocaly = x.y;
		this.zip_n = true;
		this.wake();
	}
	,setup_n: function() {
		var x = this.nlocalx;
		var y = this.nlocaly;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_n = ret;
		this.wrap_n.zpp_inner._inuse = true;
		this.wrap_n.zpp_inner._validate = $bind(this,this.validate_n);
		this.wrap_n.zpp_inner._invalidate = $bind(this,this.invalidate_n);
	}
	,validate_norm: function() {
		if(this.zip_n) {
			this.zip_n = false;
			var d = this.nlocalx * this.nlocalx + this.nlocaly * this.nlocaly;
			var imag = 1.0 / Math.sqrt(d);
			var t = imag;
			this.nlocalx *= t;
			this.nlocaly *= t;
		}
	}
	,copy: function(dict,todo) {
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a1 == null) {
			_this.zpp_inner_zn.setup_a1();
		}
		var ret = _this.zpp_inner_zn.wrap_a1;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a2 == null) {
			_this.zpp_inner_zn.setup_a2();
		}
		var ret1 = _this.zpp_inner_zn.wrap_a2;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_n == null) {
			_this.zpp_inner_zn.setup_n();
		}
		var ret2 = new nape_constraint_LineJoint(null,null,ret,ret1,_this.zpp_inner_zn.wrap_n,this.jointMin,this.jointMax);
		this.copyto(ret2);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret2.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret2.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret2.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret2.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		return ret2;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && this.b2.id == di)) {
			if(this.b1.id == di) {
				return this.b2.id == id;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAccx = 0;
		this.jAccy = 0;
		this.pre_dt = -1.0;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.equal = this.jointMin == this.jointMax;
		this.stepped = true;
		this.validate_norm();
		this.a1relx = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		this.a1rely = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		this.nrelx = this.b1.axisy * this.nlocalx - this.b1.axisx * this.nlocaly;
		this.nrely = this.nlocalx * this.b1.axisx + this.nlocaly * this.b1.axisy;
		this.a2relx = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		this.a2rely = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var dx = 0.0;
		var dy = 0.0;
		var Cx = 0.0;
		var Cy = 0.0;
		dx = this.b2.posx + this.a2relx - this.b1.posx - this.a1relx;
		dy = this.b2.posy + this.a2rely - this.b1.posy - this.a1rely;
		Cx = dy * this.nrelx - dx * this.nrely;
		Cy = this.nrelx * dx + this.nrely * dy;
		if(this.equal) {
			Cy -= this.jointMin;
			this.scale = 1.0;
		} else if(Cy > this.jointMax) {
			Cy -= this.jointMax;
			this.scale = 1.0;
		} else if(Cy < this.jointMin) {
			Cy = this.jointMin - Cy;
			this.scale = -1.0;
		} else {
			Cy = 0;
			this.scale = 0;
		}
		var drx = 0.0;
		var dry = 0.0;
		drx = dx + this.a1relx;
		dry = dy + this.a1rely;
		this.dot1 = this.nrelx * drx + this.nrely * dry;
		this.cx1 = dry * this.nrelx - drx * this.nrely;
		this.dot2 = this.nrelx * this.a2relx + this.nrely * this.a2rely;
		this.cx2 = this.a2rely * this.nrelx - this.a2relx * this.nrely;
		this.kMassa = this.b1.smass + this.b2.smass + this.dot1 * this.dot1 * this.b1.sinertia + this.dot2 * this.dot2 * this.b2.sinertia;
		this.kMassb = -this.scale * (this.dot1 * this.cx1 * this.b1.sinertia + this.dot2 * this.cx2 * this.b2.sinertia);
		this.kMassc = this.scale * this.scale * (this.b1.smass + this.b2.smass + this.cx1 * this.cx1 * this.b1.sinertia + this.cx2 * this.cx2 * this.b2.sinertia);
		var det = this.kMassa * this.kMassc - this.kMassb * this.kMassb;
		var flag;
		if(det != det) {
			this.kMassa = this.kMassb = this.kMassc = 0;
			flag = 3;
		} else if(det == 0) {
			var flag1 = 0;
			if(this.kMassa != 0) {
				this.kMassa = 1 / this.kMassa;
			} else {
				this.kMassa = 0;
				flag1 |= 1;
			}
			if(this.kMassc != 0) {
				this.kMassc = 1 / this.kMassc;
			} else {
				this.kMassc = 0;
				flag1 |= 2;
			}
			this.kMassb = 0;
			flag = flag1;
		} else {
			det = 1 / det;
			var t = this.kMassc * det;
			this.kMassc = this.kMassa * det;
			this.kMassa = t;
			this.kMassb *= -det;
			flag = 0;
		}
		if((flag & 1) != 0) {
			this.jAccx = 0;
		}
		if((flag & 2) != 0) {
			this.jAccy = 0;
		}
		if(!this.stiff) {
			if(this.breakUnderError && Cx * Cx + Cy * Cy > this.maxError * this.maxError) {
				return true;
			}
			var biasCoef;
			var omega = 2 * Math.PI * this.frequency;
			this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
			var ig = 1 / (1 + this.gamma);
			biasCoef = dt * omega * omega * this.gamma;
			this.gamma *= ig;
			var X = ig;
			this.kMassa *= X;
			this.kMassb *= X;
			this.kMassc *= X;
			this.biasx = Cx;
			this.biasy = Cy;
			var t = -biasCoef;
			this.biasx *= t;
			this.biasy *= t;
			var t = this.maxError;
			var ls = this.biasx * this.biasx + this.biasy * this.biasy;
			if(ls > t * t) {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
				this.biasx *= t1;
				this.biasy *= t1;
			}
		} else {
			this.gamma = 0;
			this.biasx = 0;
			this.biasy = 0;
		}
		var t = dtratio;
		this.jAccx *= t;
		this.jAccy *= t;
		this.jMax = this.maxForce * dt;
		return false;
	}
	,warmStart: function() {
		var J2x = this.scale * this.nrelx * this.jAccy - this.nrely * this.jAccx;
		var J2y = this.nrelx * this.jAccx + this.scale * this.nrely * this.jAccy;
		var t = this.b1.imass;
		this.b1.velx -= J2x * t;
		this.b1.vely -= J2y * t;
		var t = this.b2.imass;
		this.b2.velx += J2x * t;
		this.b2.vely += J2y * t;
		this.b1.angvel += (this.scale * this.cx1 * this.jAccy - this.dot1 * this.jAccx) * this.b1.iinertia;
		this.b2.angvel += (this.dot2 * this.jAccx - this.scale * this.cx2 * this.jAccy) * this.b2.iinertia;
	}
	,applyImpulseVel: function() {
		var Ex = 0.0;
		var Ey = 0.0;
		var dvx = 0.0;
		var dvy = 0.0;
		dvx = this.b2.velx - this.b1.velx;
		dvy = this.b2.vely - this.b1.vely;
		dvx += this.b2.kinvelx - this.b1.kinvelx;
		dvy += this.b2.kinvely - this.b1.kinvely;
		Ex = dvy * this.nrelx - dvx * this.nrely + (this.b2.angvel + this.b2.kinangvel) * this.dot2 - (this.b1.angvel + this.b1.kinangvel) * this.dot1;
		Ey = this.scale * (this.nrelx * dvx + this.nrely * dvy - (this.b2.angvel + this.b2.kinangvel) * this.cx2 + (this.b1.angvel + this.b1.kinangvel) * this.cx1);
		var Jx = 0.0;
		var Jy = 0.0;
		Jx = this.biasx - Ex;
		Jy = this.biasy - Ey;
		var t = this.kMassa * Jx + this.kMassb * Jy;
		Jy = this.kMassb * Jx + this.kMassc * Jy;
		Jx = t;
		var t = this.gamma;
		Jx -= this.jAccx * t;
		Jy -= this.jAccy * t;
		var jOldx = 0.0;
		var jOldy = 0.0;
		jOldx = this.jAccx;
		jOldy = this.jAccy;
		var t = 1.0;
		this.jAccx += Jx * t;
		this.jAccy += Jy * t;
		if(this.jAccy > 0) {
			this.jAccy = 0;
		}
		if(this.breakUnderForce) {
			if(this.jAccx * this.jAccx + this.jAccy * this.jAccy > this.jMax * this.jMax) {
				return true;
			}
		} else if(!this.stiff) {
			var t = this.jMax;
			var ls = this.jAccx * this.jAccx + this.jAccy * this.jAccy;
			if(ls > t * t) {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
				this.jAccx *= t1;
				this.jAccy *= t1;
			}
		}
		Jx = this.jAccx - jOldx;
		Jy = this.jAccy - jOldy;
		var J2x = this.scale * this.nrelx * Jy - this.nrely * Jx;
		var J2y = this.nrelx * Jx + this.scale * this.nrely * Jy;
		var t = this.b1.imass;
		this.b1.velx -= J2x * t;
		this.b1.vely -= J2y * t;
		var t = this.b2.imass;
		this.b2.velx += J2x * t;
		this.b2.vely += J2y * t;
		this.b1.angvel += (this.scale * this.cx1 * Jy - this.dot1 * Jx) * this.b1.iinertia;
		this.b2.angvel += (this.dot2 * Jx - this.scale * this.cx2 * Jy) * this.b2.iinertia;
		return false;
	}
	,applyImpulsePos: function() {
		var nx = 0.0;
		var ny = 0.0;
		nx = this.b1.axisy * this.nlocalx - this.b1.axisx * this.nlocaly;
		ny = this.nlocalx * this.b1.axisx + this.nlocaly * this.b1.axisy;
		var r1x = 0.0;
		var r1y = 0.0;
		r1x = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		r1y = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		var r2x = 0.0;
		var r2y = 0.0;
		r2x = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		r2y = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var dx = 0.0;
		var dy = 0.0;
		var scale;
		var Ex = 0.0;
		var Ey = 0.0;
		dx = this.b2.posx + r2x - this.b1.posx - r1x;
		dy = this.b2.posy + r2y - this.b1.posy - r1y;
		Ex = dy * nx - dx * ny;
		Ey = nx * dx + ny * dy;
		if(this.equal) {
			Ey -= this.jointMin;
			scale = 1.0;
		} else if(Ey > this.jointMax) {
			Ey -= this.jointMax;
			scale = 1.0;
		} else if(Ey < this.jointMin) {
			Ey = this.jointMin - Ey;
			scale = -1.0;
		} else {
			Ey = 0;
			scale = 0;
		}
		if(this.breakUnderError && Ex * Ex + Ey * Ey > this.maxError * this.maxError) {
			return true;
		}
		if(Ex * Ex + Ey * Ey < nape_Config.constraintLinearSlop * nape_Config.constraintLinearSlop) {
			return false;
		}
		var Jx = 0.0;
		var Jy = 0.0;
		var t = 0.5;
		Ex *= t;
		Ey *= t;
		if(Ex * Ex + Ey * Ey > 6) {
			var k = this.b1.smass + this.b2.smass;
			if(k > nape_Config.epsilon) {
				k = 0.8 / k;
				var Jx1 = k * (ny * Ex - scale * nx * Ey);
				var Jy1 = k * (nx * Ex * scale - ny * Ex);
				var t = this.b1.imass;
				this.b1.posx -= Jx1 * t;
				this.b1.posy -= Jy1 * t;
				var t = this.b2.imass;
				this.b2.posx += Jx1 * t;
				this.b2.posy += Jy1 * t;
				dx = this.b2.posx + r2x - this.b1.posx - r1x;
				dy = this.b2.posy + r2y - this.b1.posy - r1y;
				Ex = dy * nx - dx * ny;
				Ey = nx * dx + ny * dy;
				if(this.equal) {
					Ey -= this.jointMin;
					scale = 1.0;
				} else if(Ey > this.jointMax) {
					Ey -= this.jointMax;
					scale = 1.0;
				} else if(Ey < this.jointMin) {
					Ey = this.jointMin - Ey;
					scale = -1.0;
				} else {
					Ey = 0;
					scale = 0;
				}
				var t = 0.5;
				Ex *= t;
				Ey *= t;
			}
		}
		var dot1;
		var dot2;
		var cx1;
		var cx2;
		var Ka = 0.0;
		var Kb = 0.0;
		var Kc = 0.0;
		var drx = 0.0;
		var dry = 0.0;
		drx = dx + r1x;
		dry = dy + r1y;
		dot1 = nx * drx + ny * dry;
		cx1 = dry * nx - drx * ny;
		dot2 = nx * r2x + ny * r2y;
		cx2 = r2y * nx - r2x * ny;
		Ka = this.b1.smass + this.b2.smass + dot1 * dot1 * this.b1.sinertia + dot2 * dot2 * this.b2.sinertia;
		Kb = -scale * (dot1 * cx1 * this.b1.sinertia + dot2 * cx2 * this.b2.sinertia);
		Kc = scale * scale * (this.b1.smass + this.b2.smass + cx1 * cx1 * this.b1.sinertia + cx2 * cx2 * this.b2.sinertia);
		Jx = -Ex;
		Jy = -Ey;
		var det = Ka * Kc - Kb * Kb;
		if(det != det) {
			Jy = 0;
			Jx = Jy;
		} else if(det == 0) {
			if(Ka != 0) {
				Jx /= Ka;
			} else {
				Jx = 0;
			}
			if(Kc != 0) {
				Jy /= Kc;
			} else {
				Jy = 0;
			}
		} else {
			det = 1 / det;
			var t = det * (Kc * Jx - Kb * Jy);
			Jy = det * (Ka * Jy - Kb * Jx);
			Jx = t;
		}
		if(Jy > 0) {
			Jy = 0;
		}
		var J2x = scale * nx * Jy - ny * Jx;
		var J2y = nx * Jx + scale * ny * Jy;
		var t = this.b1.imass;
		this.b1.posx -= J2x * t;
		this.b1.posy -= J2y * t;
		var t = this.b2.imass;
		this.b2.posx += J2x * t;
		this.b2.posy += J2y * t;
		var _this = this.b1;
		var dr = (scale * cx1 * Jy - dot1 * Jx) * this.b1.iinertia;
		_this.rot += dr;
		if(dr * dr > 0.0001) {
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		} else {
			var d2 = dr * dr;
			var p = 1 - 0.5 * d2;
			var m = 1 - d2 * d2 / 8;
			var nx = (p * _this.axisx + dr * _this.axisy) * m;
			_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
			_this.axisx = nx;
		}
		var _this = this.b2;
		var dr = (dot2 * Jx - scale * cx2 * Jy) * this.b2.iinertia;
		_this.rot += dr;
		if(dr * dr > 0.0001) {
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		} else {
			var d2 = dr * dr;
			var p = 1 - 0.5 * d2;
			var m = 1 - d2 * d2 / 8;
			var nx = (p * _this.axisx + dr * _this.axisy) * m;
			_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
			_this.axisx = nx;
		}
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$MotorJoint = function() {
	this.stepped = false;
	this.jMax = 0.0;
	this.jAcc = 0.0;
	this.kMass = 0.0;
	this.b2 = null;
	this.b1 = null;
	this.rate = 0.0;
	this.ratio = 0.0;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.jAcc = 0;
	this.stepped = false;
	this.__velocity = true;
};
zpp_$nape_constraint_ZPP_$MotorJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$MotorJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$MotorJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			if(b == this.b1) {
				return nape_geom_Vec3.get(0,0,-this.jAcc);
			} else {
				return nape_geom_Vec3.get(0,0,this.ratio * this.jAcc);
			}
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
	}
	,copy: function(dict,todo) {
		var ret = new nape_constraint_MotorJoint(null,null,this.rate,this.ratio);
		this.copyto(ret);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		return ret;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && this.b2.id == di)) {
			if(this.b1.id == di) {
				return this.b2.id == id;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAcc = 0;
		this.pre_dt = -1.0;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.kMass = this.b1.sinertia + this.ratio * this.ratio * this.b2.sinertia;
		this.kMass = 1.0 / this.kMass;
		this.jAcc *= dtratio;
		this.jMax = this.maxForce * dt;
		return false;
	}
	,warmStart: function() {
		this.b1.angvel -= this.b1.iinertia * this.jAcc;
		this.b2.angvel += this.ratio * this.b2.iinertia * this.jAcc;
	}
	,applyImpulseVel: function() {
		var E = this.ratio * (this.b2.angvel + this.b2.kinangvel) - this.b1.angvel - this.b1.kinangvel - this.rate;
		var j = -this.kMass * E;
		var jOld = this.jAcc;
		this.jAcc += j;
		if(this.breakUnderForce) {
			if(this.jAcc > this.jMax || this.jAcc < -this.jMax) {
				return true;
			}
		} else if(this.jAcc < -this.jMax) {
			this.jAcc = -this.jMax;
		} else if(this.jAcc > this.jMax) {
			this.jAcc = this.jMax;
		}
		j = this.jAcc - jOld;
		this.b1.angvel -= this.b1.iinertia * j;
		this.b2.angvel += this.ratio * this.b2.iinertia * j;
		return false;
	}
	,applyImpulsePos: function() {
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$PivotJoint = function() {
	this.stepped = false;
	this.biasy = 0.0;
	this.biasx = 0.0;
	this.gamma = 0.0;
	this.jMax = 0.0;
	this.jAccy = 0.0;
	this.jAccx = 0.0;
	this.kMassc = 0.0;
	this.kMassb = 0.0;
	this.kMassa = 0.0;
	this.wrap_a2 = null;
	this.a2rely = 0.0;
	this.a2relx = 0.0;
	this.a2localy = 0.0;
	this.a2localx = 0.0;
	this.b2 = null;
	this.wrap_a1 = null;
	this.a1rely = 0.0;
	this.a1relx = 0.0;
	this.a1localy = 0.0;
	this.a1localx = 0.0;
	this.b1 = null;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.stepped = false;
	this.jAccx = 0;
	this.jAccy = 0;
	this.jMax = Infinity;
	this.a1localx = 0;
	this.a1localy = 0;
	this.a1relx = 0;
	this.a1rely = 0;
	this.a2localx = 0;
	this.a2localy = 0;
	this.a2relx = 0;
	this.a2rely = 0;
};
zpp_$nape_constraint_ZPP_$PivotJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$PivotJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$PivotJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			if(b == this.b1) {
				return nape_geom_Vec3.get(-this.jAccx,-this.jAccy,-(this.jAccy * this.a1relx - this.jAccx * this.a1rely));
			} else {
				return nape_geom_Vec3.get(this.jAccx,this.jAccy,this.jAccy * this.a2relx - this.jAccx * this.a2rely);
			}
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
	}
	,validate_a1: function() {
		this.wrap_a1.zpp_inner.x = this.a1localx;
		this.wrap_a1.zpp_inner.y = this.a1localy;
	}
	,invalidate_a1: function(x) {
		this.immutable_midstep("Constraint::" + "a1");
		this.a1localx = x.x;
		this.a1localy = x.y;
		this.wake();
	}
	,setup_a1: function() {
		var x = this.a1localx;
		var y = this.a1localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a1 = ret;
		this.wrap_a1.zpp_inner._inuse = true;
		this.wrap_a1.zpp_inner._validate = $bind(this,this.validate_a1);
		this.wrap_a1.zpp_inner._invalidate = $bind(this,this.invalidate_a1);
	}
	,validate_a2: function() {
		this.wrap_a2.zpp_inner.x = this.a2localx;
		this.wrap_a2.zpp_inner.y = this.a2localy;
	}
	,invalidate_a2: function(x) {
		this.immutable_midstep("Constraint::" + "a2");
		this.a2localx = x.x;
		this.a2localy = x.y;
		this.wake();
	}
	,setup_a2: function() {
		var x = this.a2localx;
		var y = this.a2localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a2 = ret;
		this.wrap_a2.zpp_inner._inuse = true;
		this.wrap_a2.zpp_inner._validate = $bind(this,this.validate_a2);
		this.wrap_a2.zpp_inner._invalidate = $bind(this,this.invalidate_a2);
	}
	,copy: function(dict,todo) {
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a1 == null) {
			_this.zpp_inner_zn.setup_a1();
		}
		var ret = _this.zpp_inner_zn.wrap_a1;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a2 == null) {
			_this.zpp_inner_zn.setup_a2();
		}
		var ret1 = new nape_constraint_PivotJoint(null,null,ret,_this.zpp_inner_zn.wrap_a2);
		this.copyto(ret1);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret1.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret1.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret1.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret1.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		return ret1;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && this.b2.id == di)) {
			if(this.b1.id == di) {
				return this.b2.id == id;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAccx = 0;
		this.jAccy = 0;
		this.pre_dt = -1.0;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.a1relx = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		this.a1rely = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		this.a2relx = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		this.a2rely = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var m = this.b1.smass + this.b2.smass;
		this.kMassa = m;
		this.kMassb = 0;
		this.kMassc = m;
		if(this.b1.sinertia != 0) {
			var X = this.a1relx * this.b1.sinertia;
			var Y = this.a1rely * this.b1.sinertia;
			this.kMassa += Y * this.a1rely;
			this.kMassb += -Y * this.a1relx;
			this.kMassc += X * this.a1relx;
		}
		if(this.b2.sinertia != 0) {
			var X = this.a2relx * this.b2.sinertia;
			var Y = this.a2rely * this.b2.sinertia;
			this.kMassa += Y * this.a2rely;
			this.kMassb += -Y * this.a2relx;
			this.kMassc += X * this.a2relx;
		}
		var det = this.kMassa * this.kMassc - this.kMassb * this.kMassb;
		var flag;
		if(det != det) {
			this.kMassa = this.kMassb = this.kMassc = 0;
			flag = 3;
		} else if(det == 0) {
			var flag1 = 0;
			if(this.kMassa != 0) {
				this.kMassa = 1 / this.kMassa;
			} else {
				this.kMassa = 0;
				flag1 |= 1;
			}
			if(this.kMassc != 0) {
				this.kMassc = 1 / this.kMassc;
			} else {
				this.kMassc = 0;
				flag1 |= 2;
			}
			this.kMassb = 0;
			flag = flag1;
		} else {
			det = 1 / det;
			var t = this.kMassc * det;
			this.kMassc = this.kMassa * det;
			this.kMassa = t;
			this.kMassb *= -det;
			flag = 0;
		}
		if((flag & 1) != 0) {
			this.jAccx = 0;
		}
		if((flag & 2) != 0) {
			this.jAccy = 0;
		}
		if(!this.stiff) {
			var biasCoef;
			var omega = 2 * Math.PI * this.frequency;
			this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
			var ig = 1 / (1 + this.gamma);
			biasCoef = dt * omega * omega * this.gamma;
			this.gamma *= ig;
			var X = ig;
			this.kMassa *= X;
			this.kMassb *= X;
			this.kMassc *= X;
			this.biasx = this.b2.posx + this.a2relx - (this.b1.posx + this.a1relx);
			this.biasy = this.b2.posy + this.a2rely - (this.b1.posy + this.a1rely);
			if(this.breakUnderError && this.biasx * this.biasx + this.biasy * this.biasy > this.maxError * this.maxError) {
				return true;
			}
			var t = -biasCoef;
			this.biasx *= t;
			this.biasy *= t;
			var t = this.maxError;
			var ls = this.biasx * this.biasx + this.biasy * this.biasy;
			if(ls > t * t) {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
				this.biasx *= t1;
				this.biasy *= t1;
			}
		} else {
			this.biasx = 0;
			this.biasy = 0;
			this.gamma = 0;
		}
		var t = dtratio;
		this.jAccx *= t;
		this.jAccy *= t;
		this.jMax = this.maxForce * dt;
		return false;
	}
	,warmStart: function() {
		var t = this.b1.imass;
		this.b1.velx -= this.jAccx * t;
		this.b1.vely -= this.jAccy * t;
		var t = this.b2.imass;
		this.b2.velx += this.jAccx * t;
		this.b2.vely += this.jAccy * t;
		this.b1.angvel -= (this.jAccy * this.a1relx - this.jAccx * this.a1rely) * this.b1.iinertia;
		this.b2.angvel += (this.jAccy * this.a2relx - this.jAccx * this.a2rely) * this.b2.iinertia;
	}
	,applyImpulseVel: function() {
		var Ex = 0.0;
		var Ey = 0.0;
		Ex = this.b2.velx + this.b2.kinvelx - this.a2rely * (this.b2.angvel + this.b2.kinangvel) - (this.b1.velx + this.b1.kinvelx - this.a1rely * (this.b1.angvel + this.b1.kinangvel));
		Ey = this.b2.vely + this.b2.kinvely + this.a2relx * (this.b2.angvel + this.b2.kinangvel) - (this.b1.vely + this.b1.kinvely + this.a1relx * (this.b1.angvel + this.b1.kinangvel));
		var Jx = 0.0;
		var Jy = 0.0;
		Jx = this.biasx - Ex;
		Jy = this.biasy - Ey;
		var t = this.kMassa * Jx + this.kMassb * Jy;
		Jy = this.kMassb * Jx + this.kMassc * Jy;
		Jx = t;
		var t = this.gamma;
		Jx -= this.jAccx * t;
		Jy -= this.jAccy * t;
		var jOldx = 0.0;
		var jOldy = 0.0;
		jOldx = this.jAccx;
		jOldy = this.jAccy;
		var t = 1.0;
		this.jAccx += Jx * t;
		this.jAccy += Jy * t;
		if(this.breakUnderForce) {
			if(this.jAccx * this.jAccx + this.jAccy * this.jAccy > this.jMax * this.jMax) {
				return true;
			}
		} else if(!this.stiff) {
			var t = this.jMax;
			var ls = this.jAccx * this.jAccx + this.jAccy * this.jAccy;
			if(ls > t * t) {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
				this.jAccx *= t1;
				this.jAccy *= t1;
			}
		}
		Jx = this.jAccx - jOldx;
		Jy = this.jAccy - jOldy;
		var t = this.b1.imass;
		this.b1.velx -= Jx * t;
		this.b1.vely -= Jy * t;
		var t = this.b2.imass;
		this.b2.velx += Jx * t;
		this.b2.vely += Jy * t;
		this.b1.angvel -= (Jy * this.a1relx - Jx * this.a1rely) * this.b1.iinertia;
		this.b2.angvel += (Jy * this.a2relx - Jx * this.a2rely) * this.b2.iinertia;
		return false;
	}
	,applyImpulsePos: function() {
		var r1x = 0.0;
		var r1y = 0.0;
		r1x = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		r1y = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		var r2x = 0.0;
		var r2y = 0.0;
		r2x = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		r2y = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var Ex = 0.0;
		var Ey = 0.0;
		Ex = this.b2.posx + r2x - (this.b1.posx + r1x);
		Ey = this.b2.posy + r2y - (this.b1.posy + r1y);
		if(this.breakUnderError && Ex * Ex + Ey * Ey > this.maxError * this.maxError) {
			return true;
		}
		if(Ex * Ex + Ey * Ey < nape_Config.constraintLinearSlop * nape_Config.constraintLinearSlop) {
			return false;
		}
		var t = 0.5;
		Ex *= t;
		Ey *= t;
		var Jx = 0.0;
		var Jy = 0.0;
		if(Ex * Ex + Ey * Ey > 6) {
			var k = this.b1.smass + this.b2.smass;
			if(k > nape_Config.epsilon) {
				k = 0.75 / k;
				Jx = -Ex * k;
				Jy = -Ey * k;
				var t = 20;
				var ls = Jx * Jx + Jy * Jy;
				if(ls > t * t) {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
					Jx *= t1;
					Jy *= t1;
				}
				var t = this.b1.imass;
				this.b1.posx -= Jx * t;
				this.b1.posy -= Jy * t;
				var t = this.b2.imass;
				this.b2.posx += Jx * t;
				this.b2.posy += Jy * t;
				Ex = this.b2.posx + r2x - (this.b1.posx + r1x);
				Ey = this.b2.posy + r2y - (this.b1.posy + r1y);
				var t = 0.5;
				Ex *= t;
				Ey *= t;
			}
		}
		var Ka = 0.0;
		var Kb = 0.0;
		var Kc = 0.0;
		var m = this.b1.smass + this.b2.smass;
		Ka = m;
		Kb = 0;
		Kc = m;
		if(this.b1.sinertia != 0) {
			var X = r1x * this.b1.sinertia;
			var Y = r1y * this.b1.sinertia;
			Ka += Y * r1y;
			Kb += -Y * r1x;
			Kc += X * r1x;
		}
		if(this.b2.sinertia != 0) {
			var X = r2x * this.b2.sinertia;
			var Y = r2y * this.b2.sinertia;
			Ka += Y * r2y;
			Kb += -Y * r2x;
			Kc += X * r2x;
		}
		Jx = -Ex;
		Jy = -Ey;
		var t = 6;
		var ls = Jx * Jx + Jy * Jy;
		if(ls > t * t) {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
			Jx *= t1;
			Jy *= t1;
		}
		var det = Ka * Kc - Kb * Kb;
		if(det != det) {
			Jy = 0;
			Jx = Jy;
		} else if(det == 0) {
			if(Ka != 0) {
				Jx /= Ka;
			} else {
				Jx = 0;
			}
			if(Kc != 0) {
				Jy /= Kc;
			} else {
				Jy = 0;
			}
		} else {
			det = 1 / det;
			var t = det * (Kc * Jx - Kb * Jy);
			Jy = det * (Ka * Jy - Kb * Jx);
			Jx = t;
		}
		var t = this.b1.imass;
		this.b1.posx -= Jx * t;
		this.b1.posy -= Jy * t;
		var t = this.b2.imass;
		this.b2.posx += Jx * t;
		this.b2.posy += Jy * t;
		var _this = this.b1;
		var dr = -(Jy * r1x - Jx * r1y) * this.b1.iinertia;
		_this.rot += dr;
		if(dr * dr > 0.0001) {
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		} else {
			var d2 = dr * dr;
			var p = 1 - 0.5 * d2;
			var m = 1 - d2 * d2 / 8;
			var nx = (p * _this.axisx + dr * _this.axisy) * m;
			_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
			_this.axisx = nx;
		}
		var _this = this.b2;
		var dr = (Jy * r2x - Jx * r2y) * this.b2.iinertia;
		_this.rot += dr;
		if(dr * dr > 0.0001) {
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		} else {
			var d2 = dr * dr;
			var p = 1 - 0.5 * d2;
			var m = 1 - d2 * d2 / 8;
			var nx = (p * _this.axisx + dr * _this.axisy) * m;
			_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
			_this.axisx = nx;
		}
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$PulleyJoint = function() {
	this.stepped = false;
	this.bias = 0.0;
	this.gamma = 0.0;
	this.jMax = 0.0;
	this.jAcc = 0.0;
	this.kMass = 0.0;
	this.wrap_a4 = null;
	this.a4rely = 0.0;
	this.a4relx = 0.0;
	this.a4localy = 0.0;
	this.a4localx = 0.0;
	this.b4 = null;
	this.wrap_a3 = null;
	this.a3rely = 0.0;
	this.a3relx = 0.0;
	this.a3localy = 0.0;
	this.a3localx = 0.0;
	this.b3 = null;
	this.wrap_a2 = null;
	this.a2rely = 0.0;
	this.a2relx = 0.0;
	this.a2localy = 0.0;
	this.a2localx = 0.0;
	this.b2 = null;
	this.wrap_a1 = null;
	this.a1rely = 0.0;
	this.a1relx = 0.0;
	this.a1localy = 0.0;
	this.a1localx = 0.0;
	this.b1 = null;
	this.cx4 = 0.0;
	this.cx3 = 0.0;
	this.cx2 = 0.0;
	this.cx1 = 0.0;
	this.n34y = 0.0;
	this.n34x = 0.0;
	this.n12y = 0.0;
	this.n12x = 0.0;
	this.equal = false;
	this.slack = false;
	this.jointMax = 0.0;
	this.jointMin = 0.0;
	this.ratio = 1.0;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.a1localx = 0;
	this.a1localy = 0;
	this.a1relx = 0;
	this.a1rely = 0;
	this.a2localx = 0;
	this.a2localy = 0;
	this.a2relx = 0;
	this.a2rely = 0;
	this.a3localx = 0;
	this.a3localy = 0;
	this.a3relx = 0;
	this.a3rely = 0;
	this.a4localx = 0;
	this.a4localy = 0;
	this.a4relx = 0;
	this.a4rely = 0;
	this.n12x = 1;
	this.n12y = 0;
	this.n34x = 1;
	this.n34y = 0;
	this.jAcc = 0;
	this.jMax = Infinity;
	this.stepped = false;
	this.cx1 = this.cx2 = this.cx3 = this.cx4 = 0;
};
zpp_$nape_constraint_ZPP_$PulleyJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$PulleyJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$PulleyJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			var ret = nape_geom_Vec3.get();
			if(b == this.b1) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.x -= this.jAcc * this.n12x;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.y -= this.jAcc * this.n12y;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.z -= this.cx1 * this.jAcc;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
			}
			if(b == this.b2) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.x += this.jAcc * this.n12x;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.y += this.jAcc * this.n12y;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.z += this.cx2 * this.jAcc;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
			}
			if(b == this.b3) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.x -= this.jAcc * this.n34x;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.y -= this.jAcc * this.n34y;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.z -= this.cx3 * this.jAcc;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
			}
			if(b == this.b4) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.x += this.jAcc * this.n34x;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.y += this.jAcc * this.n34y;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				ret.zpp_inner.z += this.cx4 * this.jAcc;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
			}
			return ret;
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
		if(this.b3 != this.b1 && this.b3 != this.b2) {
			if(this.b3 != null) {
				this.b3.constraints.add(this);
			}
		}
		if(this.b4 != this.b1 && this.b4 != this.b2 && this.b4 != this.b3) {
			if(this.b4 != null) {
				this.b4.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
		if(this.b3 != this.b1 && this.b3 != this.b2) {
			if(this.b3 != null) {
				this.b3.constraints.remove(this);
			}
		}
		if(this.b4 != this.b1 && this.b4 != this.b2 && this.b4 != this.b3) {
			if(this.b4 != null) {
				this.b4.constraints.remove(this);
			}
		}
	}
	,validate_a1: function() {
		this.wrap_a1.zpp_inner.x = this.a1localx;
		this.wrap_a1.zpp_inner.y = this.a1localy;
	}
	,invalidate_a1: function(x) {
		this.immutable_midstep("Constraint::" + "a1");
		this.a1localx = x.x;
		this.a1localy = x.y;
		this.wake();
	}
	,setup_a1: function() {
		var x = this.a1localx;
		var y = this.a1localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a1 = ret;
		this.wrap_a1.zpp_inner._inuse = true;
		this.wrap_a1.zpp_inner._validate = $bind(this,this.validate_a1);
		this.wrap_a1.zpp_inner._invalidate = $bind(this,this.invalidate_a1);
	}
	,validate_a2: function() {
		this.wrap_a2.zpp_inner.x = this.a2localx;
		this.wrap_a2.zpp_inner.y = this.a2localy;
	}
	,invalidate_a2: function(x) {
		this.immutable_midstep("Constraint::" + "a2");
		this.a2localx = x.x;
		this.a2localy = x.y;
		this.wake();
	}
	,setup_a2: function() {
		var x = this.a2localx;
		var y = this.a2localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a2 = ret;
		this.wrap_a2.zpp_inner._inuse = true;
		this.wrap_a2.zpp_inner._validate = $bind(this,this.validate_a2);
		this.wrap_a2.zpp_inner._invalidate = $bind(this,this.invalidate_a2);
	}
	,validate_a3: function() {
		this.wrap_a3.zpp_inner.x = this.a3localx;
		this.wrap_a3.zpp_inner.y = this.a3localy;
	}
	,invalidate_a3: function(x) {
		this.immutable_midstep("Constraint::" + "a3");
		this.a3localx = x.x;
		this.a3localy = x.y;
		this.wake();
	}
	,setup_a3: function() {
		var x = this.a3localx;
		var y = this.a3localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a3 = ret;
		this.wrap_a3.zpp_inner._inuse = true;
		this.wrap_a3.zpp_inner._validate = $bind(this,this.validate_a3);
		this.wrap_a3.zpp_inner._invalidate = $bind(this,this.invalidate_a3);
	}
	,validate_a4: function() {
		this.wrap_a4.zpp_inner.x = this.a4localx;
		this.wrap_a4.zpp_inner.y = this.a4localy;
	}
	,invalidate_a4: function(x) {
		this.immutable_midstep("Constraint::" + "a4");
		this.a4localx = x.x;
		this.a4localy = x.y;
		this.wake();
	}
	,setup_a4: function() {
		var x = this.a4localx;
		var y = this.a4localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a4 = ret;
		this.wrap_a4.zpp_inner._inuse = true;
		this.wrap_a4.zpp_inner._validate = $bind(this,this.validate_a4);
		this.wrap_a4.zpp_inner._invalidate = $bind(this,this.invalidate_a4);
	}
	,copy: function(dict,todo) {
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a1 == null) {
			_this.zpp_inner_zn.setup_a1();
		}
		var ret = _this.zpp_inner_zn.wrap_a1;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a2 == null) {
			_this.zpp_inner_zn.setup_a2();
		}
		var ret1 = _this.zpp_inner_zn.wrap_a2;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a3 == null) {
			_this.zpp_inner_zn.setup_a3();
		}
		var ret2 = _this.zpp_inner_zn.wrap_a3;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a4 == null) {
			_this.zpp_inner_zn.setup_a4();
		}
		var ret3 = new nape_constraint_PulleyJoint(null,null,null,null,ret,ret1,ret2,_this.zpp_inner_zn.wrap_a4,this.jointMin,this.jointMax,this.ratio);
		this.copyto(ret3);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret3.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret3.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret3.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret3.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b3 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b3.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret3.zpp_inner_zn.b3 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b3.id,function(b) {
					ret3.zpp_inner_zn.b3 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b4 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b4.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret3.zpp_inner_zn.b4 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b4.id,function(b) {
					ret3.zpp_inner_zn.b4 = b.zpp_inner;
				}));
			}
		}
		return ret3;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
		if(this.b3 != null && this.b3.type == 2) {
			this.b3.wake();
		}
		if(this.b4 != null && this.b4.type == 2) {
			this.b4.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b3.type == 2) {
			var xr;
			if(this.b3.component == this.b3.component.parent) {
				xr = this.b3.component;
			} else {
				var obj = this.b3.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b4.type == 2) {
			var xr;
			if(this.b4.component == this.b4.component.parent) {
				xr = this.b4.component;
			} else {
				var obj = this.b4.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && (this.b2.id == di || this.b3.id == di || this.b4.id == di) || this.b2.id == id && (this.b3.id == di || this.b4.id == di || this.b1.id == di) || this.b3.id == id && (this.b4.id == di || this.b1.id == di || this.b2.id == di))) {
			if(this.b4.id == id) {
				if(!(this.b1.id == di || this.b2.id == di)) {
					return this.b3.id == di;
				} else {
					return true;
				}
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAcc = 0;
		this.pre_dt = -1.0;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.equal = this.jointMin == this.jointMax;
		this.a1relx = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		this.a1rely = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		this.a2relx = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		this.a2rely = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		this.a3relx = this.b3.axisy * this.a3localx - this.b3.axisx * this.a3localy;
		this.a3rely = this.a3localx * this.b3.axisx + this.a3localy * this.b3.axisy;
		this.a4relx = this.b4.axisy * this.a4localx - this.b4.axisx * this.a4localy;
		this.a4rely = this.a4localx * this.b4.axisx + this.a4localy * this.b4.axisy;
		var t12x = 0.0;
		var t12y = 0.0;
		var t34x = 0.0;
		var t34y = 0.0;
		t12x = this.b2.posx + this.a2relx - (this.b1.posx + this.a1relx);
		t12y = this.b2.posy + this.a2rely - (this.b1.posy + this.a1rely);
		t34x = this.b4.posx + this.a4relx - (this.b3.posx + this.a3relx);
		t34y = this.b4.posy + this.a4rely - (this.b3.posy + this.a3rely);
		var x = t12x * t12x + t12y * t12y;
		var C12;
		if(x == 0.0) {
			C12 = 0.0;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			C12 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
		}
		var x = t34x * t34x + t34y * t34y;
		var C34;
		if(x == 0.0) {
			C34 = 0.0;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			C34 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
		}
		if(C12 != 0) {
			var t = 1.0 / C12;
			this.n12x = t12x * t;
			this.n12y = t12y * t;
		}
		if(C34 != 0) {
			var t = 1.0 / C34;
			this.n34x = t34x * t;
			this.n34y = t34y * t;
			var t = this.ratio;
			this.n34x *= t;
			this.n34y *= t;
		} else {
			var x = this.n34x * this.n34x + this.n34y * this.n34y;
			var t;
			if(x == 0.0) {
				t = 0.0;
			} else {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				t = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
			}
			var t1 = this.ratio / t;
			this.n34x *= t1;
			this.n34y *= t1;
		}
		var C = C12 + this.ratio * C34;
		if(this.equal) {
			C -= this.jointMax;
			this.slack = false;
		} else if(C < this.jointMin) {
			C = this.jointMin - C;
			this.n12x = -this.n12x;
			this.n12y = -this.n12y;
			this.n34x = -this.n34x;
			this.n34y = -this.n34y;
			this.slack = false;
		} else if(C > this.jointMax) {
			C -= this.jointMax;
			this.slack = false;
		} else {
			this.n12x = 0;
			this.n12y = 0;
			this.n34x = 0;
			this.n34y = 0;
			C = 0;
			this.slack = true;
		}
		var C1 = C;
		if(!this.slack) {
			this.cx1 = this.n12y * this.a1relx - this.n12x * this.a1rely;
			this.cx2 = this.n12y * this.a2relx - this.n12x * this.a2rely;
			this.cx3 = this.n34y * this.a3relx - this.n34x * this.a3rely;
			this.cx4 = this.n34y * this.a4relx - this.n34x * this.a4rely;
			var ratioSq = this.ratio * this.ratio;
			var K = this.b1.smass + this.b2.smass + ratioSq * (this.b3.smass + this.b4.smass) + this.b1.sinertia * this.cx1 * this.cx1 + this.b2.sinertia * this.cx2 * this.cx2 + this.b3.sinertia * this.cx3 * this.cx3 + this.b4.sinertia * this.cx4 * this.cx4;
			if(this.b1 == this.b4) {
				K -= 2 * ((this.n12x * this.n34x + this.n12y * this.n34y) * this.b1.smass + this.cx1 * this.cx4 * this.b1.sinertia);
			}
			if(this.b1 == this.b3) {
				K += 2 * ((this.n12x * this.n34x + this.n12y * this.n34y) * this.b1.smass + this.cx1 * this.cx3 * this.b1.sinertia);
			}
			if(this.b2 == this.b3) {
				K -= 2 * ((this.n12x * this.n34x + this.n12y * this.n34y) * this.b2.smass + this.cx2 * this.cx3 * this.b2.sinertia);
			}
			if(this.b2 == this.b4) {
				K += 2 * ((this.n12x * this.n34x + this.n12y * this.n34y) * this.b2.smass + this.cx2 * this.cx4 * this.b2.sinertia);
			}
			this.kMass = K;
			if(this.kMass != 0) {
				this.kMass = 1 / this.kMass;
			} else {
				this.jAcc = 0;
			}
			if(!this.stiff) {
				if(this.breakUnderError && C1 * C1 > this.maxError * this.maxError) {
					return true;
				}
				var omega = 2 * Math.PI * this.frequency;
				this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
				var ig = 1 / (1 + this.gamma);
				var biasCoef = dt * omega * omega * this.gamma;
				this.gamma *= ig;
				this.kMass *= ig;
				this.bias = -C1 * biasCoef;
				if(this.bias < -this.maxError) {
					this.bias = -this.maxError;
				} else if(this.bias > this.maxError) {
					this.bias = this.maxError;
				}
			} else {
				this.bias = 0;
				this.gamma = 0;
			}
			this.jAcc *= dtratio;
			this.jMax = this.maxForce * dt;
		}
		return false;
	}
	,warmStart: function() {
		if(!this.slack) {
			var t = this.b1.imass * this.jAcc;
			this.b1.velx -= this.n12x * t;
			this.b1.vely -= this.n12y * t;
			var t = this.b2.imass * this.jAcc;
			this.b2.velx += this.n12x * t;
			this.b2.vely += this.n12y * t;
			var t = this.b3.imass * this.jAcc;
			this.b3.velx -= this.n34x * t;
			this.b3.vely -= this.n34y * t;
			var t = this.b4.imass * this.jAcc;
			this.b4.velx += this.n34x * t;
			this.b4.vely += this.n34y * t;
			this.b1.angvel -= this.cx1 * this.b1.iinertia * this.jAcc;
			this.b2.angvel += this.cx2 * this.b2.iinertia * this.jAcc;
			this.b3.angvel -= this.cx3 * this.b3.iinertia * this.jAcc;
			this.b4.angvel += this.cx4 * this.b4.iinertia * this.jAcc;
		}
	}
	,applyImpulseVel: function() {
		if(this.slack) {
			return false;
		}
		var E = this.n12x * (this.b2.velx + this.b2.kinvelx - this.b1.velx - this.b1.kinvelx) + this.n12y * (this.b2.vely + this.b2.kinvely - this.b1.vely - this.b1.kinvely) + this.n34x * (this.b4.velx + this.b4.kinvelx - this.b3.velx - this.b3.kinvelx) + this.n34y * (this.b4.vely + this.b4.kinvely - this.b3.vely - this.b3.kinvely) + (this.b2.angvel + this.b2.kinangvel) * this.cx2 - (this.b1.angvel + this.b1.kinangvel) * this.cx1 + (this.b4.angvel + this.b4.kinangvel) * this.cx4 - (this.b3.angvel + this.b3.kinangvel) * this.cx3;
		var j = this.kMass * (this.bias - E) - this.jAcc * this.gamma;
		var jOld = this.jAcc;
		this.jAcc += j;
		if(!this.equal && this.jAcc > 0) {
			this.jAcc = 0;
		}
		if(this.breakUnderForce && this.jAcc < -this.jMax) {
			return true;
		}
		if(!this.stiff) {
			if(this.jAcc < -this.jMax) {
				this.jAcc = -this.jMax;
			}
		}
		j = this.jAcc - jOld;
		var t = this.b1.imass * j;
		this.b1.velx -= this.n12x * t;
		this.b1.vely -= this.n12y * t;
		var t = this.b2.imass * j;
		this.b2.velx += this.n12x * t;
		this.b2.vely += this.n12y * t;
		var t = this.b3.imass * j;
		this.b3.velx -= this.n34x * t;
		this.b3.vely -= this.n34y * t;
		var t = this.b4.imass * j;
		this.b4.velx += this.n34x * t;
		this.b4.vely += this.n34y * t;
		this.b1.angvel -= this.cx1 * this.b1.iinertia * j;
		this.b2.angvel += this.cx2 * this.b2.iinertia * j;
		this.b3.angvel -= this.cx3 * this.b3.iinertia * j;
		this.b4.angvel += this.cx4 * this.b4.iinertia * j;
		return false;
	}
	,applyImpulsePos: function() {
		var j;
		var r1x = 0.0;
		var r1y = 0.0;
		r1x = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		r1y = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		var r2x = 0.0;
		var r2y = 0.0;
		r2x = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		r2y = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var r3x = 0.0;
		var r3y = 0.0;
		r3x = this.b3.axisy * this.a3localx - this.b3.axisx * this.a3localy;
		r3y = this.a3localx * this.b3.axisx + this.a3localy * this.b3.axisy;
		var r4x = 0.0;
		var r4y = 0.0;
		r4x = this.b4.axisy * this.a4localx - this.b4.axisx * this.a4localy;
		r4y = this.a4localx * this.b4.axisx + this.a4localy * this.b4.axisy;
		var slack;
		var n12x = 0.0;
		var n12y = 0.0;
		var n34x = 0.0;
		var n34y = 0.0;
		n12x = this.n12x;
		n12y = this.n12y;
		n34x = this.n34x;
		n34y = this.n34y;
		var t12x = 0.0;
		var t12y = 0.0;
		var t34x = 0.0;
		var t34y = 0.0;
		t12x = this.b2.posx + r2x - (this.b1.posx + r1x);
		t12y = this.b2.posy + r2y - (this.b1.posy + r1y);
		t34x = this.b4.posx + r4x - (this.b3.posx + r3x);
		t34y = this.b4.posy + r4y - (this.b3.posy + r3y);
		var x = t12x * t12x + t12y * t12y;
		var C12;
		if(x == 0.0) {
			C12 = 0.0;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			C12 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
		}
		var x = t34x * t34x + t34y * t34y;
		var C34;
		if(x == 0.0) {
			C34 = 0.0;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			C34 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
		}
		if(C12 != 0) {
			var t = 1.0 / C12;
			n12x = t12x * t;
			n12y = t12y * t;
		}
		if(C34 != 0) {
			var t = 1.0 / C34;
			n34x = t34x * t;
			n34y = t34y * t;
			var t = this.ratio;
			n34x *= t;
			n34y *= t;
		} else {
			var x = n34x * n34x + n34y * n34y;
			var t;
			if(x == 0.0) {
				t = 0.0;
			} else {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				t = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
			}
			var t1 = this.ratio / t;
			n34x *= t1;
			n34y *= t1;
		}
		var C = C12 + this.ratio * C34;
		if(this.equal) {
			C -= this.jointMax;
			slack = false;
		} else if(C < this.jointMin) {
			C = this.jointMin - C;
			n12x = -n12x;
			n12y = -n12y;
			n34x = -n34x;
			n34y = -n34y;
			slack = false;
		} else if(C > this.jointMax) {
			C -= this.jointMax;
			slack = false;
		} else {
			n12x = 0;
			n12y = 0;
			n34x = 0;
			n34y = 0;
			C = 0;
			slack = true;
		}
		var E = C;
		if(!slack) {
			if(this.breakUnderError && E * E > this.maxError * this.maxError) {
				return true;
			}
			if(E * E < nape_Config.constraintLinearSlop * nape_Config.constraintLinearSlop) {
				return false;
			}
			E *= 0.5;
			if(E * E > 6) {
				var k = this.b1.smass + this.b2.smass;
				if(k > nape_Config.epsilon) {
					k = 0.75 / k;
					j = -E * k;
					if(this.equal || j < 0) {
						var t = j * this.b1.imass;
						this.b1.posx -= n12x * t;
						this.b1.posy -= n12y * t;
						var t = j * this.b2.imass;
						this.b2.posx += n12x * t;
						this.b2.posy += n12y * t;
						var t = j * this.b3.imass;
						this.b3.posx -= n34x * t;
						this.b3.posy -= n34y * t;
						var t = j * this.b4.imass;
						this.b4.posx += n34x * t;
						this.b4.posy += n34y * t;
						var t12x = 0.0;
						var t12y = 0.0;
						var t34x = 0.0;
						var t34y = 0.0;
						t12x = this.b2.posx + r2x - (this.b1.posx + r1x);
						t12y = this.b2.posy + r2y - (this.b1.posy + r1y);
						t34x = this.b4.posx + r4x - (this.b3.posx + r3x);
						t34y = this.b4.posy + r4y - (this.b3.posy + r3y);
						var x = t12x * t12x + t12y * t12y;
						var C12;
						if(x == 0.0) {
							C12 = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							C12 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
						}
						var x = t34x * t34x + t34y * t34y;
						var C34;
						if(x == 0.0) {
							C34 = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							C34 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
						}
						if(C12 != 0) {
							var t = 1.0 / C12;
							n12x = t12x * t;
							n12y = t12y * t;
						}
						if(C34 != 0) {
							var t = 1.0 / C34;
							n34x = t34x * t;
							n34y = t34y * t;
							var t = this.ratio;
							n34x *= t;
							n34y *= t;
						} else {
							var x = n34x * n34x + n34y * n34y;
							var t;
							if(x == 0.0) {
								t = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								t = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
							}
							var t1 = this.ratio / t;
							n34x *= t1;
							n34y *= t1;
						}
						var C = C12 + this.ratio * C34;
						if(this.equal) {
							C -= this.jointMax;
							slack = false;
						} else if(C < this.jointMin) {
							C = this.jointMin - C;
							n12x = -n12x;
							n12y = -n12y;
							n34x = -n34x;
							n34y = -n34y;
							slack = false;
						} else if(C > this.jointMax) {
							C -= this.jointMax;
							slack = false;
						} else {
							n12x = 0;
							n12y = 0;
							n34x = 0;
							n34y = 0;
							C = 0;
							slack = true;
						}
						E = C;
						E *= 0.5;
					}
				}
			}
			var cx1 = n12y * r1x - n12x * r1y;
			var cx2 = n12y * r2x - n12x * r2y;
			var cx3 = n34y * r3x - n34x * r3y;
			var cx4 = n34y * r4x - n34x * r4y;
			var ratioSq = this.ratio * this.ratio;
			var K = this.b1.smass + this.b2.smass + ratioSq * (this.b3.smass + this.b4.smass) + this.b1.sinertia * cx1 * cx1 + this.b2.sinertia * cx2 * cx2 + this.b3.sinertia * cx3 * cx3 + this.b4.sinertia * cx4 * cx4;
			if(this.b1 == this.b4) {
				K -= 2 * ((n12x * n34x + n12y * n34y) * this.b1.smass + cx1 * cx4 * this.b1.sinertia);
			}
			if(this.b1 == this.b3) {
				K += 2 * ((n12x * n34x + n12y * n34y) * this.b1.smass + cx1 * cx3 * this.b1.sinertia);
			}
			if(this.b2 == this.b3) {
				K -= 2 * ((n12x * n34x + n12y * n34y) * this.b2.smass + cx2 * cx3 * this.b2.sinertia);
			}
			if(this.b2 == this.b4) {
				K += 2 * ((n12x * n34x + n12y * n34y) * this.b2.smass + cx2 * cx4 * this.b2.sinertia);
			}
			var k = K;
			if(k != 0) {
				k = 1 / k;
			}
			j = -E * k;
			if(this.equal || j < 0) {
				var t = this.b1.imass * j;
				this.b1.posx -= n12x * t;
				this.b1.posy -= n12y * t;
				var t = this.b2.imass * j;
				this.b2.posx += n12x * t;
				this.b2.posy += n12y * t;
				var t = this.b3.imass * j;
				this.b3.posx -= n34x * t;
				this.b3.posy -= n34y * t;
				var t = this.b4.imass * j;
				this.b4.posx += n34x * t;
				this.b4.posy += n34y * t;
				var _this = this.b1;
				var dr = -cx1 * this.b1.iinertia * j;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
				var _this = this.b2;
				var dr = cx2 * this.b2.iinertia * j;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
				var _this = this.b3;
				var dr = -cx3 * this.b3.iinertia * j;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
				var _this = this.b4;
				var dr = cx4 * this.b4.iinertia * j;
				_this.rot += dr;
				if(dr * dr > 0.0001) {
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * _this.axisx + dr * _this.axisy) * m;
					_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
					_this.axisx = nx;
				}
			}
		}
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$UserConstraint = function(dim,velonly) {
	this.jOld = null;
	this.J = null;
	this.vec3 = null;
	this.Keff = null;
	this.jMax = 0.0;
	this.velonly = false;
	this.gamma = 0.0;
	this.soft = 0.0;
	this.y = null;
	this.L = null;
	this.stepped = false;
	this.bias = null;
	this.jAcc = null;
	this.dim = 0;
	this.bodies = null;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.bodies = [];
	this.dim = dim;
	this.velonly = velonly;
	this.jAcc = [];
	this.bias = [];
	this.L = [];
	this.J = [];
	this.jOld = [];
	this.y = [];
	this.Keff = [];
	this.vec3 = nape_geom_Vec3.get(0,0,0);
	var _g = 0;
	var _g1 = dim;
	while(_g < _g1) {
		var i = _g++;
		var tmp = this.bias[i] = this.J[i] = this.jOld[i] = this.y[i] = 0.0;
		this.jAcc[i] = tmp;
		var _g2 = 0;
		var _g3 = dim;
		while(_g2 < _g3) {
			var j = _g2++;
			this.L[i * dim + j] = 0.0;
		}
	}
	this.stepped = false;
};
zpp_$nape_constraint_ZPP_$UserConstraint.__name__ = true;
zpp_$nape_constraint_ZPP_$UserConstraint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$UserConstraint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bindVec2_invalidate: function(_) {
		this.outer_zn.__invalidate();
	}
	,addBody: function(b) {
		var match = null;
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var x = _g1[_g];
			++_g;
			if(x.body == b) {
				match = x;
				break;
			}
		}
		if(match == null) {
			this.bodies.push(new zpp_$nape_constraint_ZPP_$UserBody(1,b));
			if(this.active && this.space != null) {
				if(b != null) {
					b.constraints.add(this);
				}
			}
		} else {
			match.cnt++;
		}
	}
	,remBody: function(b) {
		var match = null;
		var bl = this.bodies.length | 0;
		var i = 0;
		while(i < bl) {
			var x = this.bodies[i];
			if(x.body == b) {
				x.cnt--;
				if(x.cnt == 0) {
					if(bl > 0) {
						this.bodies[i] = this.bodies[bl - 1];
					}
					this.bodies.pop();
					if(this.active && this.space != null) {
						if(b != null) {
							b.constraints.remove(this);
						}
					}
				}
				match = x;
				break;
			}
			++i;
		}
		return match != null;
	}
	,bodyImpulse: function(b) {
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.J[i] = this.jAcc[i];
		}
		var ret = nape_geom_Vec3.get(0,0,0);
		if(this.stepped) {
			this.outer_zn.__impulse(this.J,b.outer,ret);
		}
		return ret;
	}
	,activeBodies: function() {
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			if(b.body != null) {
				b.body.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			if(b.body != null) {
				b.body.constraints.remove(this);
			}
		}
	}
	,copy: function(dict,todo) {
		var ret = this.outer_zn.__copy();
		this.copyto(ret);
		throw haxe_Exception.thrown("not done yet");
	}
	,wake_connected: function() {
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			if(b.body.type == 2) {
				b.body.wake();
			}
		}
	}
	,forest: function() {
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var b = _g1[_g];
			++_g;
			if(b.body.type == 2) {
				var xr;
				if(b.body.component == b.body.component.parent) {
					xr = b.body.component;
				} else {
					var obj = b.body.component;
					var stack = null;
					while(obj != obj.parent) {
						var nxt = obj.parent;
						obj.parent = stack;
						stack = obj;
						obj = nxt;
					}
					while(stack != null) {
						var nxt1 = stack.parent;
						stack.parent = obj;
						stack = nxt1;
					}
					xr = obj;
				}
				var yr;
				if(this.component == this.component.parent) {
					yr = this.component;
				} else {
					var obj1 = this.component;
					var stack1 = null;
					while(obj1 != obj1.parent) {
						var nxt2 = obj1.parent;
						obj1.parent = stack1;
						stack1 = obj1;
						obj1 = nxt2;
					}
					while(stack1 != null) {
						var nxt3 = stack1.parent;
						stack1.parent = obj1;
						stack1 = nxt3;
					}
					yr = obj1;
				}
				if(xr != yr) {
					if(xr.rank < yr.rank) {
						xr.parent = yr;
					} else if(xr.rank > yr.rank) {
						yr.parent = xr;
					} else {
						yr.parent = xr;
						xr.rank++;
					}
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		var ret = false;
		var bl = this.bodies.length | 0;
		var _g = 0;
		var _g1 = bl;
		while(_g < _g1) {
			var bi = _g++;
			var b = this.bodies[bi].body;
			var _g2 = bi + 1;
			var _g3 = bl;
			while(_g2 < _g3) {
				var ci = _g2++;
				var c = this.bodies[ci].body;
				if(b.id == id && c.id == di || b.id == di && c.id == id) {
					ret = true;
					break;
				}
			}
			if(ret) {
				break;
			}
		}
		return ret;
	}
	,broken: function() {
		this.outer_zn.__broken();
	}
	,clearcache: function() {
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.jAcc[i] = 0.0;
		}
		this.pre_dt = -1.0;
	}
	,lsq: function(v) {
		var sum = 0.0;
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			sum += v[i] * v[i];
		}
		return sum;
	}
	,_clamp: function(v,max) {
		var x = this.lsq(v);
		if(x > max * max) {
			var scale = max / Math.sqrt(x);
			var _g = 0;
			var _g1 = this.dim;
			while(_g < _g1) {
				var i = _g++;
				v[i] *= scale;
			}
		}
	}
	,solve: function(m) {
		var ind = 0;
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var j = _g++;
			var sum = 0.0;
			var _g2 = 0;
			var _g3 = j - 1;
			while(_g2 < _g3) {
				var k = _g2++;
				sum += this.L[j * this.dim + k] * this.L[j * this.dim + k];
			}
			var rec = Math.sqrt(m[ind++] - sum);
			this.L[j * this.dim + j] = rec;
			if(rec != 0) {
				rec = 1.0 / rec;
				var _g4 = j + 1;
				var _g5 = this.dim;
				while(_g4 < _g5) {
					var i = _g4++;
					var sum1 = 0.0;
					var _g6 = 0;
					var _g7 = j - 1;
					while(_g6 < _g7) {
						var k1 = _g6++;
						sum1 += this.L[i * this.dim + k1] * this.L[j * this.dim + k1];
					}
					this.L[i * this.dim + j] = rec * (m[ind++] - sum1);
				}
			} else {
				var _g8 = j + 1;
				var _g9 = this.dim;
				while(_g8 < _g9) {
					var i1 = _g8++;
					this.L[i1 * this.dim + j] = 0.0;
				}
				ind += this.dim - j - 1;
			}
		}
		return this.L;
	}
	,transform: function(L,x) {
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			var sum = x[i];
			var lii = L[i * this.dim + i];
			if(lii != 0) {
				var _g2 = 0;
				var _g3 = i;
				while(_g2 < _g3) {
					var k = _g2++;
					sum -= L[i * this.dim + k] * this.y[k];
				}
				this.y[i] = sum / lii;
			} else {
				this.y[i] = 0.0;
			}
		}
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var ix = _g++;
			var i = this.dim - 1 - ix;
			var lii = L[i * this.dim + i];
			if(lii != 0) {
				var sum = this.y[i];
				var _g2 = i + 1;
				var _g3 = this.dim;
				while(_g2 < _g3) {
					var k = _g2++;
					sum -= L[k * this.dim + i] * x[k];
				}
				x[i] = sum / lii;
			} else {
				x[i] = 0.0;
			}
		}
	}
	,preStep: function(dt) {
		this.outer_zn.__validate();
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.outer_zn.__prepare();
		this.outer_zn.__eff_mass(this.Keff);
		this.L = this.solve(this.Keff);
		if(!this.stiff && !this.velonly) {
			var omega = 2 * Math.PI * this.frequency;
			this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
			var ig = 1 / (1 + this.gamma);
			var biasCoef = dt * omega * omega * this.gamma;
			this.gamma *= ig;
			this.soft = ig;
			this.outer_zn.__position(this.bias);
			if(this.breakUnderError && this.lsq(this.bias) > this.maxError * this.maxError) {
				return true;
			}
			var _g = 0;
			var _g1 = this.dim;
			while(_g < _g1) {
				var i = _g++;
				this.bias[i] *= -biasCoef;
			}
			this._clamp(this.bias,this.maxError);
		} else {
			var _g = 0;
			var _g1 = this.dim;
			while(_g < _g1) {
				var i = _g++;
				this.bias[i] = 0.0;
			}
			this.gamma = 0.0;
			this.soft = 1.0;
		}
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.jAcc[i] *= dtratio;
		}
		this.jMax = this.maxForce * dt;
		return false;
	}
	,warmStart: function() {
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var bs = _g1[_g];
			++_g;
			var b = bs.body;
			this.outer_zn.__impulse(this.jAcc,b.outer,this.vec3);
			var t = b.imass;
			var b1 = b;
			var b2 = b1.velx;
			var _this = this.vec3;
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			b1.velx = b2 + _this.zpp_inner.x * t;
			var b3 = b;
			var b4 = b3.vely;
			var _this2 = this.vec3;
			var _this3 = _this2.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			b3.vely = b4 + _this2.zpp_inner.y * t;
			var b5 = b;
			var b6 = b5.angvel;
			var _this4 = this.vec3;
			var _this5 = _this4.zpp_inner;
			if(_this5._validate != null) {
				_this5._validate();
			}
			b5.angvel = b6 + _this4.zpp_inner.z * b.iinertia;
		}
	}
	,applyImpulseVel: function() {
		this.outer_zn.__velocity(this.J);
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.J[i] = this.bias[i] - this.J[i];
		}
		this.transform(this.L,this.J);
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.jOld[i] = this.jAcc[i];
			this.jAcc[i] += this.J[i] = this.J[i] * this.soft - this.jAcc[i] * this.gamma;
		}
		this.outer_zn.__clamp(this.jAcc);
		if((this.breakUnderForce || !this.stiff) && this.lsq(this.jAcc) > this.jMax * this.jMax) {
			if(this.breakUnderForce) {
				return true;
			} else if(!this.stiff) {
				this._clamp(this.jAcc,this.jMax);
			}
		}
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.J[i] = this.jAcc[i] - this.jOld[i];
		}
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var bs = _g1[_g];
			++_g;
			var b = bs.body;
			this.outer_zn.__impulse(this.J,b.outer,this.vec3);
			var t = b.imass;
			var b1 = b;
			var b2 = b1.velx;
			var _this = this.vec3;
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			b1.velx = b2 + _this.zpp_inner.x * t;
			var b3 = b;
			var b4 = b3.vely;
			var _this2 = this.vec3;
			var _this3 = _this2.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			b3.vely = b4 + _this2.zpp_inner.y * t;
			var b5 = b;
			var b6 = b5.angvel;
			var _this4 = this.vec3;
			var _this5 = _this4.zpp_inner;
			if(_this5._validate != null) {
				_this5._validate();
			}
			b5.angvel = b6 + _this4.zpp_inner.z * b.iinertia;
		}
		return false;
	}
	,applyImpulsePos: function() {
		if(this.velonly) {
			return false;
		}
		this.outer_zn.__prepare();
		this.outer_zn.__position(this.J);
		var lj = this.lsq(this.J);
		if(this.breakUnderError && lj > this.maxError * this.maxError) {
			return true;
		} else if(lj < nape_Config.constraintLinearSlop * nape_Config.constraintLinearSlop) {
			return false;
		}
		var _g = 0;
		var _g1 = this.dim;
		while(_g < _g1) {
			var i = _g++;
			this.J[i] *= -1;
		}
		this.outer_zn.__eff_mass(this.Keff);
		this.transform(this.solve(this.Keff),this.J);
		this.outer_zn.__clamp(this.J);
		var _g = 0;
		var _g1 = this.bodies;
		while(_g < _g1.length) {
			var bs = _g1[_g];
			++_g;
			var b = bs.body;
			this.outer_zn.__impulse(this.J,b.outer,this.vec3);
			var t = b.imass;
			var b1 = b;
			var b2 = b1.posx;
			var _this = this.vec3;
			var _this1 = _this.zpp_inner;
			if(_this1._validate != null) {
				_this1._validate();
			}
			b1.posx = b2 + _this.zpp_inner.x * t;
			var b3 = b;
			var b4 = b3.posy;
			var _this2 = this.vec3;
			var _this3 = _this2.zpp_inner;
			if(_this3._validate != null) {
				_this3._validate();
			}
			b3.posy = b4 + _this2.zpp_inner.y * t;
			var _this4 = this.vec3;
			var _this5 = _this4.zpp_inner;
			if(_this5._validate != null) {
				_this5._validate();
			}
			var dr = _this4.zpp_inner.z * b.iinertia;
			b.rot += dr;
			if(dr * dr > 0.0001) {
				b.axisx = Math.sin(b.rot);
				b.axisy = Math.cos(b.rot);
			} else {
				var d2 = dr * dr;
				var p = 1 - 0.5 * d2;
				var m = 1 - d2 * d2 / 8;
				var nx = (p * b.axisx + dr * b.axisy) * m;
				b.axisy = (p * b.axisy - dr * b.axisx) * m;
				b.axisx = nx;
			}
		}
		return false;
	}
});
var zpp_$nape_constraint_ZPP_$UserBody = function(cnt,body) {
	this.body = null;
	this.cnt = 0;
	this.cnt = cnt;
	this.body = body;
};
zpp_$nape_constraint_ZPP_$UserBody.__name__ = true;
var zpp_$nape_constraint_ZPP_$WeldJoint = function() {
	this.stepped = false;
	this.biasz = 0.0;
	this.biasy = 0.0;
	this.biasx = 0.0;
	this.gamma = 0.0;
	this.jMax = 0.0;
	this.jAccz = 0.0;
	this.jAccy = 0.0;
	this.jAccx = 0.0;
	this.kMassf = 0.0;
	this.kMasse = 0.0;
	this.kMassc = 0.0;
	this.kMassd = 0.0;
	this.kMassb = 0.0;
	this.kMassa = 0.0;
	this.phase = 0.0;
	this.wrap_a2 = null;
	this.a2rely = 0.0;
	this.a2relx = 0.0;
	this.a2localy = 0.0;
	this.a2localx = 0.0;
	this.b2 = null;
	this.wrap_a1 = null;
	this.a1rely = 0.0;
	this.a1relx = 0.0;
	this.a1localy = 0.0;
	this.a1localx = 0.0;
	this.b1 = null;
	this.outer_zn = null;
	zpp_$nape_constraint_ZPP_$Constraint.call(this);
	this.phase = 0;
	this.jAccx = 0;
	this.jAccy = 0;
	this.jAccz = 0;
	this.jMax = Infinity;
	this.stepped = false;
	this.a1localx = 0;
	this.a1localy = 0;
	this.a1relx = 0;
	this.a1rely = 0;
	this.a2localx = 0;
	this.a2localy = 0;
	this.a2relx = 0;
	this.a2rely = 0;
};
zpp_$nape_constraint_ZPP_$WeldJoint.__name__ = true;
zpp_$nape_constraint_ZPP_$WeldJoint.__super__ = zpp_$nape_constraint_ZPP_$Constraint;
zpp_$nape_constraint_ZPP_$WeldJoint.prototype = $extend(zpp_$nape_constraint_ZPP_$Constraint.prototype,{
	bodyImpulse: function(b) {
		if(this.stepped) {
			if(b == this.b1) {
				return nape_geom_Vec3.get(-this.jAccx,-this.jAccy,-(this.jAccy * this.a1relx - this.jAccx * this.a1rely + this.jAccz));
			} else {
				return nape_geom_Vec3.get(this.jAccx,this.jAccy,this.jAccy * this.a2relx - this.jAccx * this.a2rely + this.jAccz);
			}
		} else {
			return nape_geom_Vec3.get(0,0,0);
		}
	}
	,activeBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.add(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.add(this);
			}
		}
	}
	,inactiveBodies: function() {
		if(this.b1 != null) {
			this.b1.constraints.remove(this);
		}
		if(this.b2 != this.b1) {
			if(this.b2 != null) {
				this.b2.constraints.remove(this);
			}
		}
	}
	,validate_a1: function() {
		this.wrap_a1.zpp_inner.x = this.a1localx;
		this.wrap_a1.zpp_inner.y = this.a1localy;
	}
	,invalidate_a1: function(x) {
		this.immutable_midstep("Constraint::" + "a1");
		this.a1localx = x.x;
		this.a1localy = x.y;
		this.wake();
	}
	,setup_a1: function() {
		var x = this.a1localx;
		var y = this.a1localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a1 = ret;
		this.wrap_a1.zpp_inner._inuse = true;
		this.wrap_a1.zpp_inner._validate = $bind(this,this.validate_a1);
		this.wrap_a1.zpp_inner._invalidate = $bind(this,this.invalidate_a1);
	}
	,validate_a2: function() {
		this.wrap_a2.zpp_inner.x = this.a2localx;
		this.wrap_a2.zpp_inner.y = this.a2localy;
	}
	,invalidate_a2: function(x) {
		this.immutable_midstep("Constraint::" + "a2");
		this.a2localx = x.x;
		this.a2localy = x.y;
		this.wake();
	}
	,setup_a2: function() {
		var x = this.a2localx;
		var y = this.a2localy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_a2 = ret;
		this.wrap_a2.zpp_inner._inuse = true;
		this.wrap_a2.zpp_inner._validate = $bind(this,this.validate_a2);
		this.wrap_a2.zpp_inner._invalidate = $bind(this,this.invalidate_a2);
	}
	,copy: function(dict,todo) {
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a1 == null) {
			_this.zpp_inner_zn.setup_a1();
		}
		var ret = _this.zpp_inner_zn.wrap_a1;
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_a2 == null) {
			_this.zpp_inner_zn.setup_a2();
		}
		var ret1 = new nape_constraint_WeldJoint(null,null,ret,_this.zpp_inner_zn.wrap_a2);
		this.copyto(ret1);
		if(dict != null && this.b1 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b1.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret1.zpp_inner_zn.b1 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b1.id,function(b) {
					ret1.zpp_inner_zn.b1 = b.zpp_inner;
				}));
			}
		}
		if(dict != null && this.b2 != null) {
			var b = null;
			var _g = 0;
			while(_g < dict.length) {
				var idc = dict[_g];
				++_g;
				if(idc.id == this.b2.id) {
					b = idc.bc;
					break;
				}
			}
			if(b != null) {
				ret1.zpp_inner_zn.b2 = b.zpp_inner;
			} else {
				todo.push(zpp_$nape_constraint_ZPP_$CopyHelper.todo(this.b2.id,function(b) {
					ret1.zpp_inner_zn.b2 = b.zpp_inner;
				}));
			}
		}
		return ret1;
	}
	,wake_connected: function() {
		if(this.b1 != null && this.b1.type == 2) {
			this.b1.wake();
		}
		if(this.b2 != null && this.b2.type == 2) {
			this.b2.wake();
		}
	}
	,forest: function() {
		if(this.b1.type == 2) {
			var xr;
			if(this.b1.component == this.b1.component.parent) {
				xr = this.b1.component;
			} else {
				var obj = this.b1.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
		if(this.b2.type == 2) {
			var xr;
			if(this.b2.component == this.b2.component.parent) {
				xr = this.b2.component;
			} else {
				var obj = this.b2.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				xr = obj;
			}
			var yr;
			if(this.component == this.component.parent) {
				yr = this.component;
			} else {
				var obj = this.component;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt = stack.parent;
					stack.parent = obj;
					stack = nxt;
				}
				yr = obj;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
		}
	}
	,pair_exists: function(id,di) {
		if(!(this.b1.id == id && this.b2.id == di)) {
			if(this.b1.id == di) {
				return this.b2.id == id;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
	,clearcache: function() {
		this.jAccx = 0;
		this.jAccy = 0;
		this.jAccz = 0;
		this.pre_dt = -1.0;
	}
	,preStep: function(dt) {
		if(this.pre_dt == -1.0) {
			this.pre_dt = dt;
		}
		var dtratio = dt / this.pre_dt;
		this.pre_dt = dt;
		this.stepped = true;
		this.a1relx = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		this.a1rely = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		this.a2relx = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		this.a2rely = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var m = this.b1.smass + this.b2.smass;
		this.kMassa = m;
		this.kMassb = 0;
		this.kMassd = m;
		this.kMassc = 0;
		this.kMasse = 0;
		this.kMassf = 0;
		if(this.b1.sinertia != 0) {
			var X = this.a1relx * this.b1.sinertia;
			var Y = this.a1rely * this.b1.sinertia;
			this.kMassa += Y * this.a1rely;
			this.kMassb += -Y * this.a1relx;
			this.kMassd += X * this.a1relx;
			this.kMassc += -Y;
			this.kMasse += X;
			this.kMassf += this.b1.sinertia;
		}
		if(this.b2.sinertia != 0) {
			var X = this.a2relx * this.b2.sinertia;
			var Y = this.a2rely * this.b2.sinertia;
			this.kMassa += Y * this.a2rely;
			this.kMassb += -Y * this.a2relx;
			this.kMassd += X * this.a2relx;
			this.kMassc += -Y;
			this.kMasse += X;
			this.kMassf += this.b2.sinertia;
		}
		var det = this.kMassa * (this.kMassd * this.kMassf - this.kMasse * this.kMasse) + this.kMassb * (this.kMassc * this.kMasse - this.kMassb * this.kMassf) + this.kMassc * (this.kMassb * this.kMasse - this.kMassc * this.kMassd);
		var flag;
		if(det != det) {
			this.kMassa = 0;
			this.kMassb = 0;
			this.kMassd = 0;
			this.kMassc = 0;
			this.kMasse = 0;
			this.kMassf = 0;
			flag = 7;
		} else if(det == 0) {
			var flag1 = 0;
			if(this.kMassa != 0) {
				this.kMassa = 1 / this.kMassa;
			} else {
				this.kMassa = 0;
				flag1 |= 1;
			}
			if(this.kMassd != 0) {
				this.kMassd = 1 / this.kMassd;
			} else {
				this.kMassd = 0;
				flag1 |= 2;
			}
			if(this.kMassf != 0) {
				this.kMassf = 1 / this.kMassf;
			} else {
				this.kMassf = 0;
				flag1 |= 4;
			}
			this.kMassb = this.kMassc = this.kMasse = 0.0;
			flag = flag1;
		} else {
			det = 1 / det;
			var A = det * (this.kMassd * this.kMassf - this.kMasse * this.kMasse);
			var B = det * (this.kMasse * this.kMassc - this.kMassb * this.kMassf);
			var D = det * (this.kMassa * this.kMassf - this.kMassc * this.kMassc);
			var C = det * (this.kMassb * this.kMasse - this.kMassc * this.kMassd);
			var E = det * (this.kMassb * this.kMassc - this.kMassa * this.kMasse);
			var F = det * (this.kMassa * this.kMassd - this.kMassb * this.kMassb);
			this.kMassa = A;
			this.kMassb = B;
			this.kMassd = D;
			this.kMassc = C;
			this.kMasse = E;
			this.kMassf = F;
			flag = 0;
		}
		if((flag & 1) != 0) {
			this.jAccx = 0;
		}
		if((flag & 2) != 0) {
			this.jAccy = 0;
		}
		if((flag & 4) != 0) {
			this.jAccz = 0;
		}
		if(!this.stiff) {
			var biasCoef;
			var omega = 2 * Math.PI * this.frequency;
			this.gamma = 1 / (dt * omega * (2 * this.damping + omega * dt));
			var ig = 1 / (1 + this.gamma);
			biasCoef = dt * omega * omega * this.gamma;
			this.gamma *= ig;
			var X = ig;
			this.kMassa *= X;
			this.kMassb *= X;
			this.kMassd *= X;
			this.kMassc *= X;
			this.kMasse *= X;
			this.kMassf *= X;
			this.biasx = this.b2.posx + this.a2relx - (this.b1.posx + this.a1relx);
			this.biasy = this.b2.posy + this.a2rely - (this.b1.posy + this.a1rely);
			this.biasz = this.b2.rot - this.b1.rot - this.phase;
			if(this.breakUnderError && this.biasx * this.biasx + this.biasy * this.biasy + this.biasz * this.biasz > this.maxError * this.maxError) {
				return true;
			}
			var t = -biasCoef;
			var t1 = t;
			this.biasx *= t1;
			this.biasy *= t1;
			this.biasz *= t;
			var t = this.maxError;
			var ls = this.biasx * this.biasx + this.biasy * this.biasy + this.biasz * this.biasz;
			if(ls > t * t) {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
				var t = t1;
				this.biasx *= t;
				this.biasy *= t;
				this.biasz *= t1;
			}
		} else {
			this.biasx = 0;
			this.biasy = 0;
			this.biasz = 0;
			this.gamma = 0;
		}
		var t = dtratio;
		var t1 = t;
		this.jAccx *= t1;
		this.jAccy *= t1;
		this.jAccz *= t;
		this.jMax = this.maxForce * dt;
		return false;
	}
	,warmStart: function() {
		var t = this.b1.imass;
		this.b1.velx -= this.jAccx * t;
		this.b1.vely -= this.jAccy * t;
		var t = this.b2.imass;
		this.b2.velx += this.jAccx * t;
		this.b2.vely += this.jAccy * t;
		this.b1.angvel -= (this.jAccy * this.a1relx - this.jAccx * this.a1rely + this.jAccz) * this.b1.iinertia;
		this.b2.angvel += (this.jAccy * this.a2relx - this.jAccx * this.a2rely + this.jAccz) * this.b2.iinertia;
	}
	,applyImpulseVel: function() {
		var Ex = 0.0;
		var Ey = 0.0;
		var Ez = 0.0;
		Ex = this.b2.velx + this.b2.kinvelx - this.a2rely * (this.b2.angvel + this.b2.kinangvel) - (this.b1.velx + this.b1.kinvelx - this.a1rely * (this.b1.angvel + this.b1.kinangvel));
		Ey = this.b2.vely + this.b2.kinvely + this.a2relx * (this.b2.angvel + this.b2.kinangvel) - (this.b1.vely + this.b1.kinvely + this.a1relx * (this.b1.angvel + this.b1.kinangvel));
		Ez = this.b2.angvel + this.b2.kinangvel - this.b1.angvel - this.b1.kinangvel;
		var Jx = 0.0;
		var Jy = 0.0;
		var Jz = 0.0;
		Jx = this.biasx - Ex;
		Jy = this.biasy - Ey;
		Jz = this.biasz - Ez;
		var X = this.kMassa * Jx + this.kMassb * Jy + this.kMassc * Jz;
		var Y = this.kMassb * Jx + this.kMassd * Jy + this.kMasse * Jz;
		Jz = this.kMassc * Jx + this.kMasse * Jy + this.kMassf * Jz;
		Jx = X;
		Jy = Y;
		var t = this.gamma;
		var t1 = t;
		Jx -= this.jAccx * t1;
		Jy -= this.jAccy * t1;
		Jz -= this.jAccz * t;
		var jOldx = 0.0;
		var jOldy = 0.0;
		var jOldz = 0.0;
		jOldx = this.jAccx;
		jOldy = this.jAccy;
		jOldz = this.jAccz;
		var t = 1;
		var t1 = t;
		this.jAccx += Jx * t1;
		this.jAccy += Jy * t1;
		this.jAccz += Jz * t;
		if(this.breakUnderForce) {
			if(this.jAccx * this.jAccx + this.jAccy * this.jAccy + this.jAccz * this.jAccz > this.jMax * this.jMax) {
				return true;
			}
		} else if(!this.stiff) {
			var t = this.jMax;
			var ls = this.jAccx * this.jAccx + this.jAccy * this.jAccy + this.jAccz * this.jAccz;
			if(ls > t * t) {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
				var t = t1;
				this.jAccx *= t;
				this.jAccy *= t;
				this.jAccz *= t1;
			}
		}
		Jx = this.jAccx - jOldx;
		Jy = this.jAccy - jOldy;
		Jz = this.jAccz - jOldz;
		var t = this.b1.imass;
		this.b1.velx -= Jx * t;
		this.b1.vely -= Jy * t;
		var t = this.b2.imass;
		this.b2.velx += Jx * t;
		this.b2.vely += Jy * t;
		this.b1.angvel -= (Jy * this.a1relx - Jx * this.a1rely + Jz) * this.b1.iinertia;
		this.b2.angvel += (Jy * this.a2relx - Jx * this.a2rely + Jz) * this.b2.iinertia;
		return false;
	}
	,applyImpulsePos: function() {
		var r1x = 0.0;
		var r1y = 0.0;
		r1x = this.b1.axisy * this.a1localx - this.b1.axisx * this.a1localy;
		r1y = this.a1localx * this.b1.axisx + this.a1localy * this.b1.axisy;
		var r2x = 0.0;
		var r2y = 0.0;
		r2x = this.b2.axisy * this.a2localx - this.b2.axisx * this.a2localy;
		r2y = this.a2localx * this.b2.axisx + this.a2localy * this.b2.axisy;
		var Ex = 0.0;
		var Ey = 0.0;
		var Ez = 0.0;
		Ex = this.b2.posx + r2x - (this.b1.posx + r1x);
		Ey = this.b2.posy + r2y - (this.b1.posy + r1y);
		Ez = this.b2.rot - this.b1.rot - this.phase;
		var Jx = 0.0;
		var Jy = 0.0;
		var Jz = 0.0;
		if(this.breakUnderError && Ex * Ex + Ey * Ey + Ez * Ez > this.maxError * this.maxError) {
			return true;
		}
		var cont = true;
		if(Ex * Ex + Ey * Ey < nape_Config.constraintLinearSlop * nape_Config.constraintLinearSlop) {
			cont = false;
			Ex = 0;
			Ey = 0;
		}
		var x = nape_Config.constraintAngularSlop;
		if(Ez * Ez < x * x) {
			if(!cont) {
				return false;
			} else {
				Ez = 0;
			}
		}
		var t = 0.5;
		var t1 = t;
		Ex *= t1;
		Ey *= t1;
		Ez *= t;
		if(Ex * Ex + Ey * Ey > 6) {
			var k = this.b1.smass + this.b2.smass;
			if(k > nape_Config.epsilon) {
				k = 0.75 / k;
				Jx = -Ex * k;
				Jy = -Ey * k;
				var t = 20;
				var ls = Jx * Jx + Jy * Jy;
				if(ls > t * t) {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
					Jx *= t1;
					Jy *= t1;
				}
				var t = this.b1.imass;
				this.b1.posx -= Jx * t;
				this.b1.posy -= Jy * t;
				var t = this.b2.imass;
				this.b2.posx += Jx * t;
				this.b2.posy += Jy * t;
				Ex = this.b2.posx + r2x - (this.b1.posx + r1x);
				Ey = this.b2.posy + r2y - (this.b1.posy + r1y);
				Ez = this.b2.rot - this.b1.rot - this.phase;
				var t = 0.5;
				var t1 = t;
				Ex *= t1;
				Ey *= t1;
				Ez *= t;
			}
		}
		var Ka = 0.0;
		var Kb = 0.0;
		var Kd = 0.0;
		var Kc = 0.0;
		var Ke = 0.0;
		var Kf = 0.0;
		var m = this.b1.smass + this.b2.smass;
		Ka = m;
		Kb = 0;
		Kd = m;
		Kc = 0;
		Ke = 0;
		Kf = 0;
		if(this.b1.sinertia != 0) {
			var X = r1x * this.b1.sinertia;
			var Y = r1y * this.b1.sinertia;
			Ka += Y * r1y;
			Kb += -Y * r1x;
			Kd += X * r1x;
			Kc += -Y;
			Ke += X;
			Kf += this.b1.sinertia;
		}
		if(this.b2.sinertia != 0) {
			var X = r2x * this.b2.sinertia;
			var Y = r2y * this.b2.sinertia;
			Ka += Y * r2y;
			Kb += -Y * r2x;
			Kd += X * r2x;
			Kc += -Y;
			Ke += X;
			Kf += this.b2.sinertia;
		}
		Jx = -Ex;
		Jy = -Ey;
		Jz = -Ez;
		var t = 6;
		var ls = Jx * Jx + Jy * Jy;
		if(ls > t * t) {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = ls;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			var t1 = t * (x2 * (1.5 - 0.5 * ls * x2 * x2));
			Jx *= t1;
			Jy *= t1;
		}
		var a = -0.25;
		var tmp = Jz < a;
		var det = Ka * (Kd * Kf - Ke * Ke) + Kb * (Kc * Ke - Kb * Kf) + Kc * (Kb * Ke - Kc * Kd);
		if(det != det) {
			Jz = 0;
			Jy = Jz;
			Jx = Jy;
		} else if(det == 0) {
			if(Ka != 0) {
				Jx /= Ka;
			} else {
				Jx = 0;
			}
			if(Kd != 0) {
				Jy /= Kd;
			} else {
				Jy = 0;
			}
			if(Kf != 0) {
				Jz /= Kf;
			} else {
				Jz = 0;
			}
		} else {
			det = 1 / det;
			var B = Ke * Kc - Kb * Kf;
			var C = Kb * Ke - Kc * Kd;
			var E = Kb * Kc - Ka * Ke;
			var X = det * (Jx * (Kd * Kf - Ke * Ke) + Jy * B + Jz * C);
			var Y = det * (Jx * B + Jy * (Ka * Kf - Kc * Kc) + Jz * E);
			Jz = det * (Jx * C + Jy * E + Jz * (Ka * Kd - Kb * Kb));
			Jx = X;
			Jy = Y;
		}
		var t = this.b1.imass;
		this.b1.posx -= Jx * t;
		this.b1.posy -= Jy * t;
		var t = this.b2.imass;
		this.b2.posx += Jx * t;
		this.b2.posy += Jy * t;
		var _this = this.b1;
		var dr = -(Jy * r1x - Jx * r1y + Jz) * this.b1.iinertia;
		_this.rot += dr;
		if(dr * dr > 0.0001) {
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		} else {
			var d2 = dr * dr;
			var p = 1 - 0.5 * d2;
			var m = 1 - d2 * d2 / 8;
			var nx = (p * _this.axisx + dr * _this.axisy) * m;
			_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
			_this.axisx = nx;
		}
		var _this = this.b2;
		var dr = (Jy * r2x - Jx * r2y + Jz) * this.b2.iinertia;
		_this.rot += dr;
		if(dr * dr > 0.0001) {
			_this.axisx = Math.sin(_this.rot);
			_this.axisy = Math.cos(_this.rot);
		} else {
			var d2 = dr * dr;
			var p = 1 - 0.5 * d2;
			var m = 1 - d2 * d2 / 8;
			var nx = (p * _this.axisx + dr * _this.axisy) * m;
			_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
			_this.axisx = nx;
		}
		return false;
	}
});
var zpp_$nape_dynamics_ZPP_$Arbiter = function() {
	this.sensorarb = null;
	this.fluidarb = null;
	this.colarb = null;
	this.type = 0;
	this.pair = null;
	this.ws2 = null;
	this.ws1 = null;
	this.b2 = null;
	this.b1 = null;
	this.invalidated = false;
	this.immState = 0;
	this.fresh = false;
	this.continuous = false;
	this.presentable = false;
	this.intchange = false;
	this.present = 0;
	this.sleeping = false;
	this.cleared = false;
	this.active = false;
	this.endGenerated = 0;
	this.sleep_stamp = 0;
	this.up_stamp = 0;
	this.stamp = 0;
	this.di = 0;
	this.id = 0;
	this.outer = null;
};
zpp_$nape_dynamics_ZPP_$Arbiter.__name__ = true;
zpp_$nape_dynamics_ZPP_$Arbiter.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			zpp_$nape_dynamics_ZPP_$Arbiter.internal = true;
			if(this.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				this.colarb.outer_zn = new nape_dynamics_CollisionArbiter();
				this.outer = this.colarb.outer_zn;
			} else if(this.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
				this.fluidarb.outer_zn = new nape_dynamics_FluidArbiter();
				this.outer = this.fluidarb.outer_zn;
			} else {
				this.outer = new nape_dynamics_Arbiter();
			}
			this.outer.zpp_inner = this;
			zpp_$nape_dynamics_ZPP_$Arbiter.internal = false;
		}
		return this.outer;
	}
};
var zpp_$nape_dynamics_ZPP_$SensorArbiter = function() {
	this.next = null;
	zpp_$nape_dynamics_ZPP_$Arbiter.call(this);
	this.type = zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR;
	this.sensorarb = this;
};
zpp_$nape_dynamics_ZPP_$SensorArbiter.__name__ = true;
zpp_$nape_dynamics_ZPP_$SensorArbiter.__super__ = zpp_$nape_dynamics_ZPP_$Arbiter;
zpp_$nape_dynamics_ZPP_$SensorArbiter.prototype = $extend(zpp_$nape_dynamics_ZPP_$Arbiter.prototype,{
});
var zpp_$nape_dynamics_ZPP_$FluidArbiter = function() {
	this.pre_dt = 0.0;
	this.mutable = false;
	this.wrap_position = null;
	this.buoyy = 0.0;
	this.buoyx = 0.0;
	this.ny = 0.0;
	this.nx = 0.0;
	this.lgamma = 0.0;
	this.dampy = 0.0;
	this.dampx = 0.0;
	this.vMassc = 0.0;
	this.vMassb = 0.0;
	this.vMassa = 0.0;
	this.agamma = 0.0;
	this.adamp = 0.0;
	this.wMass = 0.0;
	this.nodrag = false;
	this.r2y = 0.0;
	this.r2x = 0.0;
	this.r1y = 0.0;
	this.r1x = 0.0;
	this.overlap = 0.0;
	this.centroidy = 0.0;
	this.centroidx = 0.0;
	this.next = null;
	this.outer_zn = null;
	zpp_$nape_dynamics_ZPP_$Arbiter.call(this);
	this.type = zpp_$nape_dynamics_ZPP_$Arbiter.FLUID;
	this.fluidarb = this;
	this.buoyx = 0;
	this.buoyy = 0;
	this.pre_dt = -1.0;
};
zpp_$nape_dynamics_ZPP_$FluidArbiter.__name__ = true;
zpp_$nape_dynamics_ZPP_$FluidArbiter.__super__ = zpp_$nape_dynamics_ZPP_$Arbiter;
zpp_$nape_dynamics_ZPP_$FluidArbiter.prototype = $extend(zpp_$nape_dynamics_ZPP_$Arbiter.prototype,{
	position_validate: function() {
		this.wrap_position.zpp_inner.x = this.centroidx;
		this.wrap_position.zpp_inner.y = this.centroidy;
	}
	,position_invalidate: function(x) {
		this.centroidx = x.x;
		this.centroidy = x.y;
	}
	,getposition: function() {
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = 0;
			ret1.y = 0;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == 0) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == 0;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = 0;
				ret.zpp_inner.y = 0;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_position = ret;
		this.wrap_position.zpp_inner._inuse = true;
		this.wrap_position.zpp_inner._immutable = !this.mutable;
		this.wrap_position.zpp_inner._validate = $bind(this,this.position_validate);
		this.wrap_position.zpp_inner._invalidate = $bind(this,this.position_invalidate);
	}
});
var zpp_$nape_dynamics_ZPP_$ColArbiter = function() {
	this.pre_dt = 0.0;
	this.mutable = false;
	this.stat = false;
	this.next = null;
	this.hpc2 = false;
	this.hc2 = false;
	this.oc2 = null;
	this.c2 = null;
	this.oc1 = null;
	this.c1 = null;
	this.__ref_vertex = 0;
	this.__ref_edge2 = null;
	this.__ref_edge1 = null;
	this.biasCoef = 0.0;
	this.rev = false;
	this.radius = 0.0;
	this.lproj = 0.0;
	this.lnormy = 0.0;
	this.lnormx = 0.0;
	this.surfacey = 0.0;
	this.surfacex = 0.0;
	this.k2y = 0.0;
	this.k2x = 0.0;
	this.k1y = 0.0;
	this.k1x = 0.0;
	this.rt2b = 0.0;
	this.rn2b = 0.0;
	this.rt2a = 0.0;
	this.rn2a = 0.0;
	this.rt1b = 0.0;
	this.rn1b = 0.0;
	this.rt1a = 0.0;
	this.rn1a = 0.0;
	this.jrAcc = 0.0;
	this.rMass = 0.0;
	this.Kc = 0.0;
	this.Kb = 0.0;
	this.Ka = 0.0;
	this.kMassc = 0.0;
	this.kMassb = 0.0;
	this.kMassa = 0.0;
	this.wrap_normal = null;
	this.ny = 0.0;
	this.nx = 0.0;
	this.innards = null;
	this.wrap_contacts = null;
	this.contacts = null;
	this.s2 = null;
	this.s1 = null;
	this.userdef_rfric = false;
	this.userdef_restitution = false;
	this.userdef_stat_fric = false;
	this.userdef_dyn_fric = false;
	this.rfric = 0.0;
	this.restitution = 0.0;
	this.stat_fric = 0.0;
	this.dyn_fric = 0.0;
	this.outer_zn = null;
	zpp_$nape_dynamics_ZPP_$Arbiter.call(this);
	this.pre_dt = -1.0;
	this.contacts = new zpp_$nape_dynamics_ZPP_$Contact();
	this.innards = new zpp_$nape_dynamics_ZPP_$IContact();
	this.type = zpp_$nape_dynamics_ZPP_$Arbiter.COL;
	this.colarb = this;
};
zpp_$nape_dynamics_ZPP_$ColArbiter.__name__ = true;
zpp_$nape_dynamics_ZPP_$ColArbiter.__super__ = zpp_$nape_dynamics_ZPP_$Arbiter;
zpp_$nape_dynamics_ZPP_$ColArbiter.prototype = $extend(zpp_$nape_dynamics_ZPP_$Arbiter.prototype,{
	normal_validate: function() {
		if(this.cleared) {
			throw haxe_Exception.thrown("Error: Arbiter not currently in use");
		}
		this.wrap_normal.zpp_inner.x = this.nx;
		this.wrap_normal.zpp_inner.y = this.ny;
		if(this.ws1.id > this.ws2.id) {
			this.wrap_normal.zpp_inner.x = -this.wrap_normal.zpp_inner.x;
			this.wrap_normal.zpp_inner.y = -this.wrap_normal.zpp_inner.y;
		}
	}
	,getnormal: function() {
		var x = 0;
		var y = 0;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_normal = ret;
		this.wrap_normal.zpp_inner._immutable = true;
		this.wrap_normal.zpp_inner._inuse = true;
		this.wrap_normal.zpp_inner._validate = $bind(this,this.normal_validate);
	}
	,contacts_adder: function(x) {
		return false;
	}
	,contacts_subber: function(x) {
		var pre = null;
		var prei = null;
		var cx_itei = this.innards.next;
		var cx_ite = this.contacts.next;
		while(cx_ite != null) {
			var c = cx_ite;
			if(c == x.zpp_inner) {
				this.contacts.erase(pre);
				this.innards.erase(prei);
				var o = c;
				o.sBias = -1.0;
				o.arbiter = null;
				o.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
				zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o;
				break;
			}
			pre = cx_ite;
			prei = cx_itei;
			cx_itei = cx_itei.next;
			cx_ite = cx_ite.next;
		}
	}
	,setupcontacts: function() {
		this.wrap_contacts = zpp_$nape_util_ZPP_$ContactList.get(this.contacts,true);
		this.wrap_contacts.zpp_inner.immutable = !this.mutable;
		this.wrap_contacts.zpp_inner.adder = $bind(this,this.contacts_adder);
		this.wrap_contacts.zpp_inner.dontremove = true;
		this.wrap_contacts.zpp_inner.subber = $bind(this,this.contacts_subber);
	}
});
var zpp_$nape_dynamics_ZPP_$Contact = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this._inuse = false;
	this.next = null;
	this.elasticity = 0.0;
	this.sBias = -1.0;
	this.dist = 0.0;
	this.fresh = false;
	this.hash = 0;
	this.stamp = 0;
	this.posOnly = false;
	this.active = false;
	this.inner = null;
	this.arbiter = null;
	this.wrap_position = null;
	this.py = 0.0;
	this.px = 0.0;
	this.outer = null;
	this.inner = new zpp_$nape_dynamics_ZPP_$IContact();
};
zpp_$nape_dynamics_ZPP_$Contact.__name__ = true;
zpp_$nape_dynamics_ZPP_$Contact.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			zpp_$nape_dynamics_ZPP_$Contact.internal = true;
			this.outer = new nape_dynamics_Contact();
			zpp_$nape_dynamics_ZPP_$Contact.internal = false;
			this.outer.zpp_inner = this;
		}
		return this.outer;
	}
	,position_validate: function() {
		this.wrap_position.zpp_inner.x = this.px;
		this.wrap_position.zpp_inner.y = this.py;
	}
	,getposition: function() {
		var me = this;
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = 0;
			ret1.y = 0;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == 0) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == 0;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = 0;
				ret.zpp_inner.y = 0;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_position = ret;
		this.wrap_position.zpp_inner._inuse = true;
		this.wrap_position.zpp_inner._immutable = true;
		this.wrap_position.zpp_inner._validate = $bind(this,this.position_validate);
	}
	,add: function(o) {
		o._inuse = true;
		var temp = o;
		temp.next = this.next;
		this.next = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		o._inuse = true;
		var temp = o;
		if(cur == null) {
			temp.next = this.next;
			this.next = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.next;
		this.next = ret.next;
		ret._inuse = false;
		if(this.next == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.next;
		var ret = false;
		while(cur != null) {
			if(cur == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.next;
					ret1 = old.next;
					this.next = ret1;
					if(this.next == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				old._inuse = false;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.next;
			ret = old.next;
			this.next = ret;
			if(this.next == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		old._inuse = false;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.next;
		while(cx_ite != null) {
			var npite = cx_ite;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.next;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_dynamics_ZPP_$IContact = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this._inuse = false;
	this.next = null;
	this.lr2y = 0.0;
	this.lr2x = 0.0;
	this.lr1y = 0.0;
	this.lr1x = 0.0;
	this.jtAcc = 0.0;
	this.jnAcc = 0.0;
	this.friction = 0.0;
	this.biasCoef = 0.0;
	this.bounce = 0.0;
	this.tMass = 0.0;
	this.nMass = 0.0;
	this.r2y = 0.0;
	this.r2x = 0.0;
	this.r1y = 0.0;
	this.r1x = 0.0;
};
zpp_$nape_dynamics_ZPP_$IContact.__name__ = true;
zpp_$nape_dynamics_ZPP_$IContact.prototype = {
	add: function(o) {
		o._inuse = true;
		var temp = o;
		temp.next = this.next;
		this.next = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.next;
			ret = old.next;
			this.next = ret;
			if(this.next == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		old._inuse = false;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
};
var zpp_$nape_dynamics_ZPP_$InteractionFilter = function() {
	this.fluidMask = 0;
	this.fluidGroup = 0;
	this.sensorMask = 0;
	this.sensorGroup = 0;
	this.collisionMask = 0;
	this.collisionGroup = 0;
	this.wrap_shapes = null;
	this.shapes = null;
	this.outer = null;
	this.userData = null;
	this.next = null;
	this.shapes = new zpp_$nape_util_ZNPList_$ZPP_$Shape();
	this.collisionGroup = this.sensorGroup = this.fluidGroup = 1;
	this.collisionMask = this.sensorMask = this.fluidMask = -1;
};
zpp_$nape_dynamics_ZPP_$InteractionFilter.__name__ = true;
zpp_$nape_dynamics_ZPP_$InteractionFilter.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			this.outer = new nape_dynamics_InteractionFilter();
			var o = this.outer.zpp_inner;
			o.outer = null;
			o.next = zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool = o;
			this.outer.zpp_inner = this;
		}
		return this.outer;
	}
	,invalidate: function() {
		var cx_ite = this.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			s.invalidate_filter();
			cx_ite = cx_ite.next;
		}
	}
};
var zpp_$nape_dynamics_ZPP_$InteractionGroup = function() {
	this.depth = 0;
	this.wrap_interactors = null;
	this.interactors = null;
	this.wrap_groups = null;
	this.groups = null;
	this.group = null;
	this.ignore = false;
	this.outer = null;
	this.depth = 0;
	this.groups = new zpp_$nape_util_ZNPList_$ZPP_$InteractionGroup();
	this.interactors = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
};
zpp_$nape_dynamics_ZPP_$InteractionGroup.__name__ = true;
zpp_$nape_dynamics_ZPP_$InteractionGroup.prototype = {
	setGroup: function(group) {
		if(this.group != group) {
			if(this.group != null) {
				this.group.groups.remove(this);
				this.depth = 0;
				this.group.invalidate(true);
			}
			this.group = group;
			if(group != null) {
				group.groups.add(this);
				this.depth = group.depth + 1;
				group.invalidate(true);
			} else {
				this.invalidate(true);
			}
		}
	}
	,invalidate: function(force) {
		if(force == null) {
			force = false;
		}
		if(!(force || this.ignore)) {
			return;
		}
		var cx_ite = this.interactors.head;
		while(cx_ite != null) {
			var b = cx_ite.elt;
			if(b.ibody != null) {
				b.ibody.wake();
			} else if(b.ishape != null) {
				b.ishape.body.wake();
			} else {
				b.icompound.wake();
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.groups.head;
		while(cx_ite != null) {
			var g = cx_ite.elt;
			g.invalidate(force);
			cx_ite = cx_ite.next;
		}
	}
};
var zpp_$nape_dynamics_ZPP_$SpaceArbiterList = function() {
	this.at_index_3 = 0;
	this.at_index_2 = 0;
	this.at_index_1 = 0;
	this.at_index_0 = 0;
	this.ite_3 = null;
	this.ite_2 = null;
	this.ite_1 = null;
	this.ite_0 = null;
	this.lengths = null;
	this.zip_length = false;
	this._length = 0;
	this.space = null;
	nape_dynamics_ArbiterList.call(this);
	this.at_index_0 = 0;
	this.at_index_1 = 0;
	this.at_index_2 = 0;
	this.at_index_3 = 0;
	this.zip_length = true;
	this._length = 0;
	this.lengths = [];
	this.lengths.push(0);
	this.lengths.push(0);
	this.lengths.push(0);
	this.lengths.push(0);
};
zpp_$nape_dynamics_ZPP_$SpaceArbiterList.__name__ = true;
zpp_$nape_dynamics_ZPP_$SpaceArbiterList.__super__ = nape_dynamics_ArbiterList;
zpp_$nape_dynamics_ZPP_$SpaceArbiterList.prototype = $extend(nape_dynamics_ArbiterList.prototype,{
	zpp_gl: function() {
		this.zpp_vm();
		if(this.zip_length) {
			this._length = 0;
			var ind = 0;
			var len = 0;
			var cx_ite = this.space.c_arbiters_true.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.active) {
					++len;
				}
				cx_ite = cx_ite.next;
			}
			this.lengths[ind++] = len;
			this._length += len;
			var len = 0;
			var cx_ite = this.space.c_arbiters_false.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.active) {
					++len;
				}
				cx_ite = cx_ite.next;
			}
			this.lengths[ind++] = len;
			this._length += len;
			var len = 0;
			var cx_ite = this.space.f_arbiters.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.active) {
					++len;
				}
				cx_ite = cx_ite.next;
			}
			this.lengths[ind++] = len;
			this._length += len;
			var len = 0;
			var cx_ite = this.space.s_arbiters.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.active) {
					++len;
				}
				cx_ite = cx_ite.next;
			}
			this.lengths[ind++] = len;
			this._length += len;
			this.zip_length = false;
		}
		return this._length;
	}
	,zpp_vm: function() {
		var modified = false;
		if(this.space.c_arbiters_true.modified) {
			modified = true;
			this.space.c_arbiters_true.modified = false;
		}
		if(this.space.c_arbiters_false.modified) {
			modified = true;
			this.space.c_arbiters_false.modified = false;
		}
		if(this.space.f_arbiters.modified) {
			modified = true;
			this.space.f_arbiters.modified = false;
		}
		if(this.space.s_arbiters.modified) {
			modified = true;
			this.space.s_arbiters.modified = false;
		}
		if(modified) {
			this.zip_length = true;
			this._length = 0;
			this.ite_0 = null;
			this.ite_1 = null;
			this.ite_2 = null;
			this.ite_3 = null;
		}
	}
	,push: function(obj) {
		return false;
	}
	,pop: function() {
		return null;
	}
	,unshift: function(obj) {
		return false;
	}
	,shift: function() {
		return null;
	}
	,remove: function(obj) {
		return false;
	}
	,clear: function() {
	}
	,at: function(index) {
		this.zpp_vm();
		var ret = null;
		var accum_length = 0;
		if(ret == null) {
			if(index < accum_length + this.lengths[0]) {
				var offset = index - accum_length;
				if(offset < this.at_index_0 || this.ite_0 == null) {
					this.at_index_0 = 0;
					this.ite_0 = this.space.c_arbiters_true.head;
					while(true) {
						var x = this.ite_0.elt;
						if(x.active) {
							break;
						}
						this.ite_0 = this.ite_0.next;
					}
				}
				while(this.at_index_0 != offset) {
					this.at_index_0++;
					this.ite_0 = this.ite_0.next;
					while(true) {
						var x = this.ite_0.elt;
						if(x.active) {
							break;
						}
						this.ite_0 = this.ite_0.next;
					}
				}
				ret = this.ite_0.elt.wrapper();
			} else {
				accum_length += this.lengths[0];
			}
		}
		if(ret == null) {
			if(index < accum_length + this.lengths[1]) {
				var offset = index - accum_length;
				if(offset < this.at_index_1 || this.ite_1 == null) {
					this.at_index_1 = 0;
					this.ite_1 = this.space.c_arbiters_false.head;
					while(true) {
						var x = this.ite_1.elt;
						if(x.active) {
							break;
						}
						this.ite_1 = this.ite_1.next;
					}
				}
				while(this.at_index_1 != offset) {
					this.at_index_1++;
					this.ite_1 = this.ite_1.next;
					while(true) {
						var x = this.ite_1.elt;
						if(x.active) {
							break;
						}
						this.ite_1 = this.ite_1.next;
					}
				}
				ret = this.ite_1.elt.wrapper();
			} else {
				accum_length += this.lengths[1];
			}
		}
		if(ret == null) {
			if(index < accum_length + this.lengths[2]) {
				var offset = index - accum_length;
				if(offset < this.at_index_2 || this.ite_2 == null) {
					this.at_index_2 = 0;
					this.ite_2 = this.space.f_arbiters.head;
					while(true) {
						var x = this.ite_2.elt;
						if(x.active) {
							break;
						}
						this.ite_2 = this.ite_2.next;
					}
				}
				while(this.at_index_2 != offset) {
					this.at_index_2++;
					this.ite_2 = this.ite_2.next;
					while(true) {
						var x = this.ite_2.elt;
						if(x.active) {
							break;
						}
						this.ite_2 = this.ite_2.next;
					}
				}
				ret = this.ite_2.elt.wrapper();
			} else {
				accum_length += this.lengths[2];
			}
		}
		if(ret == null) {
			if(index < accum_length + this.lengths[3]) {
				var offset = index - accum_length;
				if(offset < this.at_index_3 || this.ite_3 == null) {
					this.at_index_3 = 0;
					this.ite_3 = this.space.s_arbiters.head;
					while(true) {
						var x = this.ite_3.elt;
						if(x.active) {
							break;
						}
						this.ite_3 = this.ite_3.next;
					}
				}
				while(this.at_index_3 != offset) {
					this.at_index_3++;
					this.ite_3 = this.ite_3.next;
					while(true) {
						var x = this.ite_3.elt;
						if(x.active) {
							break;
						}
						this.ite_3 = this.ite_3.next;
					}
				}
				ret = this.ite_3.elt.wrapper();
			} else {
				accum_length += this.lengths[3];
			}
		}
		return ret;
	}
});
var zpp_$nape_geom_ZPP_$AABB = function() {
	this.wrap_max = null;
	this.maxy = 0.0;
	this.maxx = 0.0;
	this.wrap_min = null;
	this.miny = 0.0;
	this.minx = 0.0;
	this.next = null;
	this.outer = null;
	this._immutable = false;
	this._validate = null;
	this._invalidate = null;
};
zpp_$nape_geom_ZPP_$AABB.__name__ = true;
zpp_$nape_geom_ZPP_$AABB.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			this.outer = new nape_geom_AABB();
			var o = this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o.wrap_min = o.wrap_max = null;
			o._invalidate = null;
			o._validate = null;
			o.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = o;
			this.outer.zpp_inner = this;
		}
		return this.outer;
	}
	,getmin: function() {
		if(this.wrap_min == null) {
			var x = this.minx;
			var y = this.miny;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			this.wrap_min = ret;
			this.wrap_min.zpp_inner._inuse = true;
			if(this._immutable) {
				this.wrap_min.zpp_inner._immutable = true;
			} else {
				this.wrap_min.zpp_inner._invalidate = $bind(this,this.mod_min);
			}
			this.wrap_min.zpp_inner._validate = $bind(this,this.dom_min);
		}
		return this.wrap_min;
	}
	,dom_min: function() {
		if(this._validate != null) {
			this._validate();
		}
		this.wrap_min.zpp_inner.x = this.minx;
		this.wrap_min.zpp_inner.y = this.miny;
	}
	,mod_min: function(min) {
		if(min.x != this.minx || min.y != this.miny) {
			this.minx = min.x;
			this.miny = min.y;
			if(this._invalidate != null) {
				this._invalidate(this);
			}
		}
	}
	,getmax: function() {
		if(this.wrap_max == null) {
			var x = this.maxx;
			var y = this.maxy;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			this.wrap_max = ret;
			this.wrap_max.zpp_inner._inuse = true;
			if(this._immutable) {
				this.wrap_max.zpp_inner._immutable = true;
			} else {
				this.wrap_max.zpp_inner._invalidate = $bind(this,this.mod_max);
			}
			this.wrap_max.zpp_inner._validate = $bind(this,this.dom_max);
		}
		return this.wrap_max;
	}
	,dom_max: function() {
		if(this._validate != null) {
			this._validate();
		}
		this.wrap_max.zpp_inner.x = this.maxx;
		this.wrap_max.zpp_inner.y = this.maxy;
	}
	,mod_max: function(max) {
		if(max.x != this.maxx || max.y != this.maxy) {
			this.maxx = max.x;
			this.maxy = max.y;
			if(this._invalidate != null) {
				this._invalidate(this);
			}
		}
	}
	,toString: function() {
		return "{ x: " + this.minx + " y: " + this.miny + " w: " + (this.maxx - this.minx) + " h: " + (this.maxy - this.miny) + " }";
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Vec2 = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Vec2.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Vec2.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Vec2();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Vec2();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Vec2.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_geom_ZPP_$Collide = function() { };
zpp_$nape_geom_ZPP_$Collide.__name__ = true;
zpp_$nape_geom_ZPP_$Collide.circleContains = function(c,p) {
	var dx = 0.0;
	var dy = 0.0;
	dx = p.x - c.worldCOMx;
	dy = p.y - c.worldCOMy;
	return dx * dx + dy * dy < c.radius * c.radius;
};
zpp_$nape_geom_ZPP_$Collide.polyContains = function(s,p) {
	var retvar;
	retvar = true;
	var cx_ite = s.edges.head;
	while(cx_ite != null) {
		var a = cx_ite.elt;
		if(a.gnormx * p.x + a.gnormy * p.y <= a.gprojection) {
			cx_ite = cx_ite.next;
			continue;
		} else {
			retvar = false;
			break;
		}
	}
	return retvar;
};
zpp_$nape_geom_ZPP_$Collide.shapeContains = function(s,p) {
	if(s.type == 0) {
		return zpp_$nape_geom_ZPP_$Collide.circleContains(s.circle,p);
	} else {
		return zpp_$nape_geom_ZPP_$Collide.polyContains(s.polygon,p);
	}
};
zpp_$nape_geom_ZPP_$Collide.containTest = function(s1,s2) {
	var _this = s1.aabb;
	var x = s2.aabb;
	if(x.minx >= _this.minx && x.miny >= _this.miny && x.maxx <= _this.maxx && x.maxy <= _this.maxy) {
		if(s1.type == 0) {
			if(s2.type == 0) {
				var minDist = s1.circle.radius + -s2.circle.radius;
				var px = 0.0;
				var py = 0.0;
				px = s2.circle.worldCOMx - s1.circle.worldCOMx;
				py = s2.circle.worldCOMy - s1.circle.worldCOMy;
				var distSqr = px * px + py * py;
				return distSqr <= minDist * minDist;
			} else {
				var retvar;
				retvar = true;
				var cx_ite = s2.polygon.gverts.next;
				while(cx_ite != null) {
					var p = cx_ite;
					var minDist = s1.circle.radius;
					var px = 0.0;
					var py = 0.0;
					px = p.x - s1.circle.worldCOMx;
					py = p.y - s1.circle.worldCOMy;
					var distSqr = px * px + py * py;
					if(distSqr <= minDist * minDist) {
						cx_ite = cx_ite.next;
						continue;
					} else {
						retvar = false;
						break;
					}
				}
				return retvar;
			}
		} else if(s2.type == 0) {
			var retvar;
			retvar = true;
			var cx_ite = s1.polygon.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				if(a.gnormx * s2.circle.worldCOMx + a.gnormy * s2.circle.worldCOMy + s2.circle.radius <= a.gprojection) {
					cx_ite = cx_ite.next;
					continue;
				} else {
					retvar = false;
					break;
				}
			}
			return retvar;
		} else {
			var retvar;
			retvar = true;
			var cx_ite = s1.polygon.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				var max = -1e+100;
				var cx_ite1 = s2.polygon.gverts.next;
				while(cx_ite1 != null) {
					var v = cx_ite1;
					var k = a.gnormx * v.x + a.gnormy * v.y;
					if(k > max) {
						max = k;
					}
					cx_ite1 = cx_ite1.next;
				}
				if(max <= a.gprojection) {
					cx_ite = cx_ite.next;
					continue;
				} else {
					retvar = false;
					break;
				}
			}
			return retvar;
		}
	} else {
		return false;
	}
};
zpp_$nape_geom_ZPP_$Collide.contactCollide = function(s1,s2,arb,rev) {
	if(s2.type == 1) {
		if(s1.type == 1) {
			var cont = true;
			var max = -1e+100;
			var maxmin = -1e+100;
			var maxi = -1;
			var axis1 = null;
			var axis2 = null;
			var cx_ite = s1.polygon.edges.head;
			while(cx_ite != null) {
				var ax = cx_ite.elt;
				var min = 1e100;
				var cx_ite1 = s2.polygon.gverts.next;
				while(cx_ite1 != null) {
					var v = cx_ite1;
					var k = ax.gnormx * v.x + ax.gnormy * v.y;
					if(k < min) {
						min = k;
					}
					if(min - ax.gprojection <= max) {
						break;
					}
					cx_ite1 = cx_ite1.next;
				}
				min -= ax.gprojection;
				if(min >= 0) {
					cont = false;
					break;
				}
				if(min > max) {
					max = min;
					axis1 = ax;
					maxi = 1;
				}
				cx_ite = cx_ite.next;
			}
			if(cont) {
				var cx_ite = s2.polygon.edges.head;
				while(cx_ite != null) {
					var ax = cx_ite.elt;
					var min = 1e100;
					var cx_ite1 = s1.polygon.gverts.next;
					while(cx_ite1 != null) {
						var v = cx_ite1;
						var k = ax.gnormx * v.x + ax.gnormy * v.y;
						if(k < min) {
							min = k;
						}
						if(min - ax.gprojection <= max) {
							break;
						}
						cx_ite1 = cx_ite1.next;
					}
					min -= ax.gprojection;
					if(min >= 0) {
						cont = false;
						break;
					}
					if(min > max) {
						max = min;
						axis2 = ax;
						maxi = 2;
					}
					cx_ite = cx_ite.next;
				}
				if(!cont) {
					return false;
				} else {
					var q1;
					var q2;
					var ax;
					var scale;
					if(maxi == 1) {
						q1 = s1.polygon;
						q2 = s2.polygon;
						ax = axis1;
						scale = 1.0;
					} else {
						q1 = s2.polygon;
						q2 = s1.polygon;
						ax = axis2;
						scale = -1.0;
					}
					var ay = null;
					var min = 1e100;
					var cx_ite = q2.edges.head;
					while(cx_ite != null) {
						var axis = cx_ite.elt;
						var k = ax.gnormx * axis.gnormx + ax.gnormy * axis.gnormy;
						if(k < min) {
							min = k;
							ay = axis;
						}
						cx_ite = cx_ite.next;
					}
					var c0x = 0.0;
					var c0y = 0.0;
					c0x = ay.gp0.x;
					c0y = ay.gp0.y;
					var c1x = 0.0;
					var c1y = 0.0;
					c1x = ay.gp1.x;
					c1y = ay.gp1.y;
					var dvx = 0.0;
					var dvy = 0.0;
					dvx = c1x - c0x;
					dvy = c1y - c0y;
					var d0 = ax.gnormy * c0x - ax.gnormx * c0y;
					var d1 = ax.gnormy * c1x - ax.gnormx * c1y;
					var den = 1 / (d1 - d0);
					var t = (-ax.tp1 - d0) * den;
					if(t > nape_Config.epsilon) {
						var t1 = t;
						c0x += dvx * t1;
						c0y += dvy * t1;
					}
					var t = (-ax.tp0 - d1) * den;
					if(t < -nape_Config.epsilon) {
						var t1 = t;
						c1x += dvx * t1;
						c1y += dvy * t1;
					}
					var nx = 0.0;
					var ny = 0.0;
					var t = scale;
					nx = ax.gnormx * t;
					ny = ax.gnormy * t;
					arb.lnormx = ax.lnormx;
					arb.lnormy = ax.lnormy;
					arb.lproj = ax.lprojection;
					arb.radius = 0;
					arb.rev = rev != (scale == -1);
					arb.ptype = arb.rev ? 1 : 0;
					var c0d = c0x * ax.gnormx + c0y * ax.gnormy - ax.gprojection;
					var c1d = c1x * ax.gnormx + c1y * ax.gnormy - ax.gprojection;
					if(c0d > 0 && c1d > 0) {
						return false;
					} else {
						if(rev) {
							nx = -nx;
							ny = -ny;
						}
						var px = c0x - ax.gnormx * c0d * 0.5;
						var py = c0y - ax.gnormy * c0d * 0.5;
						var hash = arb.rev ? 1 : 0;
						var posOnly = c0d > 0;
						if(posOnly == null) {
							posOnly = false;
						}
						var c = null;
						var cx_ite = arb.contacts.next;
						while(cx_ite != null) {
							var cur = cx_ite;
							if(hash == cur.hash) {
								c = cur;
								break;
							}
							cx_ite = cx_ite.next;
						}
						if(c == null) {
							if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
								c = new zpp_$nape_dynamics_ZPP_$Contact();
							} else {
								c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
								zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
								c.next = null;
							}
							var ci = c.inner;
							ci.jnAcc = ci.jtAcc = 0;
							c.hash = hash;
							c.fresh = true;
							c.arbiter = arb;
							arb.jrAcc = 0;
							var _this = arb.contacts;
							c._inuse = true;
							var temp = c;
							temp.next = _this.next;
							_this.next = temp;
							_this.modified = true;
							_this.length++;
							arb.innards.add(ci);
						} else {
							c.fresh = false;
						}
						c.px = px;
						c.py = py;
						arb.nx = nx;
						arb.ny = ny;
						c.dist = c0d;
						c.stamp = arb.stamp;
						c.posOnly = posOnly;
						var con = c;
						var t = 1.0;
						c0x -= q2.body.posx * t;
						c0y -= q2.body.posy * t;
						con.inner.lr1x = c0x * q2.body.axisy + c0y * q2.body.axisx;
						con.inner.lr1y = c0y * q2.body.axisy - c0x * q2.body.axisx;
						var px = c1x - ax.gnormx * c1d * 0.5;
						var py = c1y - ax.gnormy * c1d * 0.5;
						var hash = arb.rev ? 0 : 1;
						var posOnly = c1d > 0;
						if(posOnly == null) {
							posOnly = false;
						}
						var c = null;
						var cx_ite = arb.contacts.next;
						while(cx_ite != null) {
							var cur = cx_ite;
							if(hash == cur.hash) {
								c = cur;
								break;
							}
							cx_ite = cx_ite.next;
						}
						if(c == null) {
							if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
								c = new zpp_$nape_dynamics_ZPP_$Contact();
							} else {
								c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
								zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
								c.next = null;
							}
							var ci = c.inner;
							ci.jnAcc = ci.jtAcc = 0;
							c.hash = hash;
							c.fresh = true;
							c.arbiter = arb;
							arb.jrAcc = 0;
							var _this = arb.contacts;
							c._inuse = true;
							var temp = c;
							temp.next = _this.next;
							_this.next = temp;
							_this.modified = true;
							_this.length++;
							arb.innards.add(ci);
						} else {
							c.fresh = false;
						}
						c.px = px;
						c.py = py;
						arb.nx = nx;
						arb.ny = ny;
						c.dist = c1d;
						c.stamp = arb.stamp;
						c.posOnly = posOnly;
						con = c;
						var t = 1.0;
						c1x -= q2.body.posx * t;
						c1y -= q2.body.posy * t;
						con.inner.lr1x = c1x * q2.body.axisy + c1y * q2.body.axisx;
						con.inner.lr1y = c1y * q2.body.axisy - c1x * q2.body.axisx;
						if(maxi == 1) {
							arb.__ref_edge1 = ax;
							arb.__ref_edge2 = ay;
						} else {
							arb.__ref_edge2 = ax;
							arb.__ref_edge1 = ay;
						}
						return true;
					}
				}
			} else {
				return false;
			}
		} else {
			var max = -1e+100;
			var minmax = -1e+100;
			var cont = true;
			var a0 = null;
			var vi = null;
			var vite = s2.polygon.gverts.next;
			var cx_ite = s2.polygon.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				var dist = a.gnormx * s1.circle.worldCOMx + a.gnormy * s1.circle.worldCOMy - a.gprojection - s1.circle.radius;
				if(dist > 0) {
					cont = false;
					break;
				}
				if(dist > max) {
					max = dist;
					a0 = a;
					vi = vite;
				}
				vite = vite.next;
				cx_ite = cx_ite.next;
			}
			if(cont) {
				var v0 = vi;
				var v1 = vi.next == null ? s2.polygon.gverts.next : vi.next;
				var dt = s1.circle.worldCOMy * a0.gnormx - s1.circle.worldCOMx * a0.gnormy;
				if(dt <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
					var minDist = s1.circle.radius;
					var px = 0.0;
					var py = 0.0;
					px = v0.x - s1.circle.worldCOMx;
					py = v0.y - s1.circle.worldCOMy;
					var distSqr = px * px + py * py;
					var co;
					if(distSqr > minDist * minDist) {
						co = null;
					} else if(distSqr < nape_Config.epsilon * nape_Config.epsilon) {
						var px1 = s1.circle.worldCOMx;
						var py1 = s1.circle.worldCOMy;
						var c = null;
						var cx_ite = arb.contacts.next;
						while(cx_ite != null) {
							var cur = cx_ite;
							if(0 == cur.hash) {
								c = cur;
								break;
							}
							cx_ite = cx_ite.next;
						}
						if(c == null) {
							if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
								c = new zpp_$nape_dynamics_ZPP_$Contact();
							} else {
								c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
								zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
								c.next = null;
							}
							var ci = c.inner;
							ci.jnAcc = ci.jtAcc = 0;
							c.hash = 0;
							c.fresh = true;
							c.arbiter = arb;
							arb.jrAcc = 0;
							var _this = arb.contacts;
							c._inuse = true;
							var temp = c;
							temp.next = _this.next;
							_this.next = temp;
							_this.modified = true;
							_this.length++;
							arb.innards.add(ci);
						} else {
							c.fresh = false;
						}
						c.px = px1;
						c.py = py1;
						arb.nx = 1;
						arb.ny = 0;
						c.dist = -minDist;
						c.stamp = arb.stamp;
						c.posOnly = false;
						co = c;
					} else {
						zpp_$nape_util_ZPP_$Math.fbuf[0] = distSqr;
						zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
						var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
						var invDist = x2 * (1.5 - 0.5 * distSqr * x2 * x2);
						var dist = invDist < nape_Config.epsilon ? 1e100 : 1.0 / invDist;
						var df = 0.5 + (s1.circle.radius - 0.5 * minDist) * invDist;
						if(rev) {
							var px1 = s1.circle.worldCOMx + px * df;
							var py1 = s1.circle.worldCOMy + py * df;
							var c = null;
							var cx_ite = arb.contacts.next;
							while(cx_ite != null) {
								var cur = cx_ite;
								if(0 == cur.hash) {
									c = cur;
									break;
								}
								cx_ite = cx_ite.next;
							}
							if(c == null) {
								if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
									c = new zpp_$nape_dynamics_ZPP_$Contact();
								} else {
									c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
									zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
									c.next = null;
								}
								var ci = c.inner;
								ci.jnAcc = ci.jtAcc = 0;
								c.hash = 0;
								c.fresh = true;
								c.arbiter = arb;
								arb.jrAcc = 0;
								var _this = arb.contacts;
								c._inuse = true;
								var temp = c;
								temp.next = _this.next;
								_this.next = temp;
								_this.modified = true;
								_this.length++;
								arb.innards.add(ci);
							} else {
								c.fresh = false;
							}
							c.px = px1;
							c.py = py1;
							arb.nx = -px * invDist;
							arb.ny = -py * invDist;
							c.dist = dist - minDist;
							c.stamp = arb.stamp;
							c.posOnly = false;
							co = c;
						} else {
							var px1 = s1.circle.worldCOMx + px * df;
							var py1 = s1.circle.worldCOMy + py * df;
							var c = null;
							var cx_ite = arb.contacts.next;
							while(cx_ite != null) {
								var cur = cx_ite;
								if(0 == cur.hash) {
									c = cur;
									break;
								}
								cx_ite = cx_ite.next;
							}
							if(c == null) {
								if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
									c = new zpp_$nape_dynamics_ZPP_$Contact();
								} else {
									c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
									zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
									c.next = null;
								}
								var ci = c.inner;
								ci.jnAcc = ci.jtAcc = 0;
								c.hash = 0;
								c.fresh = true;
								c.arbiter = arb;
								arb.jrAcc = 0;
								var _this = arb.contacts;
								c._inuse = true;
								var temp = c;
								temp.next = _this.next;
								_this.next = temp;
								_this.modified = true;
								_this.length++;
								arb.innards.add(ci);
							} else {
								c.fresh = false;
							}
							c.px = px1;
							c.py = py1;
							arb.nx = px * invDist;
							arb.ny = py * invDist;
							c.dist = dist - minDist;
							c.stamp = arb.stamp;
							c.posOnly = false;
							co = c;
						}
					}
					if(co != null) {
						var con = co.inner;
						arb.ptype = 2;
						var vx = 0.0;
						var vy = 0.0;
						vx = v0.x - s2.polygon.body.posx;
						vy = v0.y - s2.polygon.body.posy;
						arb.__ref_edge1 = a0;
						arb.__ref_vertex = -1;
						if(rev) {
							con.lr1x = vx * s2.polygon.body.axisy + vy * s2.polygon.body.axisx;
							con.lr1y = vy * s2.polygon.body.axisy - vx * s2.polygon.body.axisx;
							con.lr2x = s1.circle.localCOMx;
							con.lr2y = s1.circle.localCOMy;
						} else {
							con.lr2x = vx * s2.polygon.body.axisy + vy * s2.polygon.body.axisx;
							con.lr2y = vy * s2.polygon.body.axisy - vx * s2.polygon.body.axisx;
							con.lr1x = s1.circle.localCOMx;
							con.lr1y = s1.circle.localCOMy;
						}
						arb.radius = s1.circle.radius;
					}
					return co != null;
				} else if(dt >= v1.y * a0.gnormx - v1.x * a0.gnormy) {
					var minDist = s1.circle.radius;
					var px = 0.0;
					var py = 0.0;
					px = v1.x - s1.circle.worldCOMx;
					py = v1.y - s1.circle.worldCOMy;
					var distSqr = px * px + py * py;
					var co;
					if(distSqr > minDist * minDist) {
						co = null;
					} else if(distSqr < nape_Config.epsilon * nape_Config.epsilon) {
						var px1 = s1.circle.worldCOMx;
						var py1 = s1.circle.worldCOMy;
						var c = null;
						var cx_ite = arb.contacts.next;
						while(cx_ite != null) {
							var cur = cx_ite;
							if(0 == cur.hash) {
								c = cur;
								break;
							}
							cx_ite = cx_ite.next;
						}
						if(c == null) {
							if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
								c = new zpp_$nape_dynamics_ZPP_$Contact();
							} else {
								c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
								zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
								c.next = null;
							}
							var ci = c.inner;
							ci.jnAcc = ci.jtAcc = 0;
							c.hash = 0;
							c.fresh = true;
							c.arbiter = arb;
							arb.jrAcc = 0;
							var _this = arb.contacts;
							c._inuse = true;
							var temp = c;
							temp.next = _this.next;
							_this.next = temp;
							_this.modified = true;
							_this.length++;
							arb.innards.add(ci);
						} else {
							c.fresh = false;
						}
						c.px = px1;
						c.py = py1;
						arb.nx = 1;
						arb.ny = 0;
						c.dist = -minDist;
						c.stamp = arb.stamp;
						c.posOnly = false;
						co = c;
					} else {
						zpp_$nape_util_ZPP_$Math.fbuf[0] = distSqr;
						zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
						var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
						var invDist = x2 * (1.5 - 0.5 * distSqr * x2 * x2);
						var dist = invDist < nape_Config.epsilon ? 1e100 : 1.0 / invDist;
						var df = 0.5 + (s1.circle.radius - 0.5 * minDist) * invDist;
						if(rev) {
							var px1 = s1.circle.worldCOMx + px * df;
							var py1 = s1.circle.worldCOMy + py * df;
							var c = null;
							var cx_ite = arb.contacts.next;
							while(cx_ite != null) {
								var cur = cx_ite;
								if(0 == cur.hash) {
									c = cur;
									break;
								}
								cx_ite = cx_ite.next;
							}
							if(c == null) {
								if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
									c = new zpp_$nape_dynamics_ZPP_$Contact();
								} else {
									c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
									zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
									c.next = null;
								}
								var ci = c.inner;
								ci.jnAcc = ci.jtAcc = 0;
								c.hash = 0;
								c.fresh = true;
								c.arbiter = arb;
								arb.jrAcc = 0;
								var _this = arb.contacts;
								c._inuse = true;
								var temp = c;
								temp.next = _this.next;
								_this.next = temp;
								_this.modified = true;
								_this.length++;
								arb.innards.add(ci);
							} else {
								c.fresh = false;
							}
							c.px = px1;
							c.py = py1;
							arb.nx = -px * invDist;
							arb.ny = -py * invDist;
							c.dist = dist - minDist;
							c.stamp = arb.stamp;
							c.posOnly = false;
							co = c;
						} else {
							var px1 = s1.circle.worldCOMx + px * df;
							var py1 = s1.circle.worldCOMy + py * df;
							var c = null;
							var cx_ite = arb.contacts.next;
							while(cx_ite != null) {
								var cur = cx_ite;
								if(0 == cur.hash) {
									c = cur;
									break;
								}
								cx_ite = cx_ite.next;
							}
							if(c == null) {
								if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
									c = new zpp_$nape_dynamics_ZPP_$Contact();
								} else {
									c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
									zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
									c.next = null;
								}
								var ci = c.inner;
								ci.jnAcc = ci.jtAcc = 0;
								c.hash = 0;
								c.fresh = true;
								c.arbiter = arb;
								arb.jrAcc = 0;
								var _this = arb.contacts;
								c._inuse = true;
								var temp = c;
								temp.next = _this.next;
								_this.next = temp;
								_this.modified = true;
								_this.length++;
								arb.innards.add(ci);
							} else {
								c.fresh = false;
							}
							c.px = px1;
							c.py = py1;
							arb.nx = px * invDist;
							arb.ny = py * invDist;
							c.dist = dist - minDist;
							c.stamp = arb.stamp;
							c.posOnly = false;
							co = c;
						}
					}
					if(co != null) {
						var con = co.inner;
						arb.ptype = 2;
						var vx = 0.0;
						var vy = 0.0;
						vx = v1.x - s2.polygon.body.posx;
						vy = v1.y - s2.polygon.body.posy;
						arb.__ref_edge1 = a0;
						arb.__ref_vertex = 1;
						if(rev) {
							con.lr1x = vx * s2.polygon.body.axisy + vy * s2.polygon.body.axisx;
							con.lr1y = vy * s2.polygon.body.axisy - vx * s2.polygon.body.axisx;
							con.lr2x = s1.circle.localCOMx;
							con.lr2y = s1.circle.localCOMy;
						} else {
							con.lr2x = vx * s2.polygon.body.axisy + vy * s2.polygon.body.axisx;
							con.lr2y = vy * s2.polygon.body.axisy - vx * s2.polygon.body.axisx;
							con.lr1x = s1.circle.localCOMx;
							con.lr1y = s1.circle.localCOMy;
						}
						arb.radius = s1.circle.radius;
					}
					return co != null;
				} else {
					var nx = 0.0;
					var ny = 0.0;
					var t = s1.circle.radius + max * 0.5;
					nx = a0.gnormx * t;
					ny = a0.gnormy * t;
					var px = 0.0;
					var py = 0.0;
					px = s1.circle.worldCOMx - nx;
					py = s1.circle.worldCOMy - ny;
					var con;
					if(rev) {
						var nx = a0.gnormx;
						var ny = a0.gnormy;
						var c = null;
						var cx_ite = arb.contacts.next;
						while(cx_ite != null) {
							var cur = cx_ite;
							if(0 == cur.hash) {
								c = cur;
								break;
							}
							cx_ite = cx_ite.next;
						}
						if(c == null) {
							if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
								c = new zpp_$nape_dynamics_ZPP_$Contact();
							} else {
								c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
								zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
								c.next = null;
							}
							var ci = c.inner;
							ci.jnAcc = ci.jtAcc = 0;
							c.hash = 0;
							c.fresh = true;
							c.arbiter = arb;
							arb.jrAcc = 0;
							var _this = arb.contacts;
							c._inuse = true;
							var temp = c;
							temp.next = _this.next;
							_this.next = temp;
							_this.modified = true;
							_this.length++;
							arb.innards.add(ci);
						} else {
							c.fresh = false;
						}
						c.px = px;
						c.py = py;
						arb.nx = nx;
						arb.ny = ny;
						c.dist = max;
						c.stamp = arb.stamp;
						c.posOnly = false;
						con = c;
					} else {
						var nx = -a0.gnormx;
						var ny = -a0.gnormy;
						var c = null;
						var cx_ite = arb.contacts.next;
						while(cx_ite != null) {
							var cur = cx_ite;
							if(0 == cur.hash) {
								c = cur;
								break;
							}
							cx_ite = cx_ite.next;
						}
						if(c == null) {
							if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
								c = new zpp_$nape_dynamics_ZPP_$Contact();
							} else {
								c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
								zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
								c.next = null;
							}
							var ci = c.inner;
							ci.jnAcc = ci.jtAcc = 0;
							c.hash = 0;
							c.fresh = true;
							c.arbiter = arb;
							arb.jrAcc = 0;
							var _this = arb.contacts;
							c._inuse = true;
							var temp = c;
							temp.next = _this.next;
							_this.next = temp;
							_this.modified = true;
							_this.length++;
							arb.innards.add(ci);
						} else {
							c.fresh = false;
						}
						c.px = px;
						c.py = py;
						arb.nx = nx;
						arb.ny = ny;
						c.dist = max;
						c.stamp = arb.stamp;
						c.posOnly = false;
						con = c;
					}
					arb.ptype = rev ? 0 : 1;
					arb.lnormx = a0.lnormx;
					arb.lnormy = a0.lnormy;
					arb.rev = !rev;
					arb.lproj = a0.lprojection;
					arb.radius = s1.circle.radius;
					con.inner.lr1x = s1.circle.localCOMx;
					con.inner.lr1y = s1.circle.localCOMy;
					arb.__ref_edge1 = a0;
					arb.__ref_vertex = 0;
					return true;
				}
			} else {
				return false;
			}
		}
	} else {
		var minDist = s1.circle.radius + s2.circle.radius;
		var px = 0.0;
		var py = 0.0;
		px = s2.circle.worldCOMx - s1.circle.worldCOMx;
		py = s2.circle.worldCOMy - s1.circle.worldCOMy;
		var distSqr = px * px + py * py;
		var co;
		if(distSqr > minDist * minDist) {
			co = null;
		} else if(distSqr < nape_Config.epsilon * nape_Config.epsilon) {
			var px1 = s1.circle.worldCOMx;
			var py1 = s1.circle.worldCOMy;
			var c = null;
			var cx_ite = arb.contacts.next;
			while(cx_ite != null) {
				var cur = cx_ite;
				if(0 == cur.hash) {
					c = cur;
					break;
				}
				cx_ite = cx_ite.next;
			}
			if(c == null) {
				if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
					c = new zpp_$nape_dynamics_ZPP_$Contact();
				} else {
					c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
					zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
					c.next = null;
				}
				var ci = c.inner;
				ci.jnAcc = ci.jtAcc = 0;
				c.hash = 0;
				c.fresh = true;
				c.arbiter = arb;
				arb.jrAcc = 0;
				var _this = arb.contacts;
				c._inuse = true;
				var temp = c;
				temp.next = _this.next;
				_this.next = temp;
				_this.modified = true;
				_this.length++;
				arb.innards.add(ci);
			} else {
				c.fresh = false;
			}
			c.px = px1;
			c.py = py1;
			arb.nx = 1;
			arb.ny = 0;
			c.dist = -minDist;
			c.stamp = arb.stamp;
			c.posOnly = false;
			co = c;
		} else {
			zpp_$nape_util_ZPP_$Math.fbuf[0] = distSqr;
			zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
			var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
			var invDist = x2 * (1.5 - 0.5 * distSqr * x2 * x2);
			var dist = invDist < nape_Config.epsilon ? 1e100 : 1.0 / invDist;
			var df = 0.5 + (s1.circle.radius - 0.5 * minDist) * invDist;
			if(rev) {
				var px1 = s1.circle.worldCOMx + px * df;
				var py1 = s1.circle.worldCOMy + py * df;
				var c = null;
				var cx_ite = arb.contacts.next;
				while(cx_ite != null) {
					var cur = cx_ite;
					if(0 == cur.hash) {
						c = cur;
						break;
					}
					cx_ite = cx_ite.next;
				}
				if(c == null) {
					if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
						c = new zpp_$nape_dynamics_ZPP_$Contact();
					} else {
						c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
						zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
						c.next = null;
					}
					var ci = c.inner;
					ci.jnAcc = ci.jtAcc = 0;
					c.hash = 0;
					c.fresh = true;
					c.arbiter = arb;
					arb.jrAcc = 0;
					var _this = arb.contacts;
					c._inuse = true;
					var temp = c;
					temp.next = _this.next;
					_this.next = temp;
					_this.modified = true;
					_this.length++;
					arb.innards.add(ci);
				} else {
					c.fresh = false;
				}
				c.px = px1;
				c.py = py1;
				arb.nx = -px * invDist;
				arb.ny = -py * invDist;
				c.dist = dist - minDist;
				c.stamp = arb.stamp;
				c.posOnly = false;
				co = c;
			} else {
				var px1 = s1.circle.worldCOMx + px * df;
				var py1 = s1.circle.worldCOMy + py * df;
				var c = null;
				var cx_ite = arb.contacts.next;
				while(cx_ite != null) {
					var cur = cx_ite;
					if(0 == cur.hash) {
						c = cur;
						break;
					}
					cx_ite = cx_ite.next;
				}
				if(c == null) {
					if(zpp_$nape_dynamics_ZPP_$Contact.zpp_pool == null) {
						c = new zpp_$nape_dynamics_ZPP_$Contact();
					} else {
						c = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
						zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = c.next;
						c.next = null;
					}
					var ci = c.inner;
					ci.jnAcc = ci.jtAcc = 0;
					c.hash = 0;
					c.fresh = true;
					c.arbiter = arb;
					arb.jrAcc = 0;
					var _this = arb.contacts;
					c._inuse = true;
					var temp = c;
					temp.next = _this.next;
					_this.next = temp;
					_this.modified = true;
					_this.length++;
					arb.innards.add(ci);
				} else {
					c.fresh = false;
				}
				c.px = px1;
				c.py = py1;
				arb.nx = px * invDist;
				arb.ny = py * invDist;
				c.dist = dist - minDist;
				c.stamp = arb.stamp;
				c.posOnly = false;
				co = c;
			}
		}
		if(co != null) {
			var con = co.inner;
			if(rev) {
				con.lr1x = s2.circle.localCOMx;
				con.lr1y = s2.circle.localCOMy;
				con.lr2x = s1.circle.localCOMx;
				con.lr2y = s1.circle.localCOMy;
			} else {
				con.lr1x = s1.circle.localCOMx;
				con.lr1y = s1.circle.localCOMy;
				con.lr2x = s2.circle.localCOMx;
				con.lr2y = s2.circle.localCOMy;
			}
			arb.radius = s1.circle.radius + s2.circle.radius;
			arb.ptype = 2;
			return true;
		} else {
			return false;
		}
	}
};
zpp_$nape_geom_ZPP_$Collide.testCollide_safe = function(s1,s2) {
	if(s2.type == 0) {
		var t = s1;
		s1 = s2;
		s2 = t;
	}
	return zpp_$nape_geom_ZPP_$Collide.testCollide(s1,s2);
};
zpp_$nape_geom_ZPP_$Collide.testCollide = function(s1,s2) {
	if(s2.type == 1) {
		if(s1.type == 1) {
			var cont = true;
			var cx_ite = s1.polygon.edges.head;
			while(cx_ite != null) {
				var ax = cx_ite.elt;
				var min = 1e100;
				var cx_ite1 = s2.polygon.gverts.next;
				while(cx_ite1 != null) {
					var v = cx_ite1;
					var k = ax.gnormx * v.x + ax.gnormy * v.y;
					if(k < min) {
						min = k;
					}
					cx_ite1 = cx_ite1.next;
				}
				min -= ax.gprojection;
				if(min > 0) {
					cont = false;
					break;
				}
				cx_ite = cx_ite.next;
			}
			if(cont) {
				var cx_ite = s2.polygon.edges.head;
				while(cx_ite != null) {
					var ax = cx_ite.elt;
					var min = 1e100;
					var cx_ite1 = s1.polygon.gverts.next;
					while(cx_ite1 != null) {
						var v = cx_ite1;
						var k = ax.gnormx * v.x + ax.gnormy * v.y;
						if(k < min) {
							min = k;
						}
						cx_ite1 = cx_ite1.next;
					}
					min -= ax.gprojection;
					if(min > 0) {
						cont = false;
						break;
					}
					cx_ite = cx_ite.next;
				}
				return cont;
			} else {
				return false;
			}
		} else {
			var a0 = null;
			var vi = null;
			var cont = true;
			var max = -1e+100;
			var vite = s2.polygon.gverts.next;
			var cx_ite = s2.polygon.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				var dist = a.gnormx * s1.circle.worldCOMx + a.gnormy * s1.circle.worldCOMy - a.gprojection - s1.circle.radius;
				if(dist > 0) {
					cont = false;
					break;
				}
				if(dist > max) {
					max = dist;
					a0 = a;
					vi = vite;
				}
				vite = vite.next;
				cx_ite = cx_ite.next;
			}
			if(cont) {
				var v0 = vi;
				var v1 = vi.next == null ? s2.polygon.gverts.next : vi.next;
				var dt = s1.circle.worldCOMy * a0.gnormx - s1.circle.worldCOMx * a0.gnormy;
				if(dt <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
					var minDist = s1.circle.radius;
					var px = 0.0;
					var py = 0.0;
					px = v0.x - s1.circle.worldCOMx;
					py = v0.y - s1.circle.worldCOMy;
					var distSqr = px * px + py * py;
					return distSqr <= minDist * minDist;
				} else if(dt >= v1.y * a0.gnormx - v1.x * a0.gnormy) {
					var minDist = s1.circle.radius;
					var px = 0.0;
					var py = 0.0;
					px = v1.x - s1.circle.worldCOMx;
					py = v1.y - s1.circle.worldCOMy;
					var distSqr = px * px + py * py;
					return distSqr <= minDist * minDist;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}
	} else {
		var minDist = s1.circle.radius + s2.circle.radius;
		var px = 0.0;
		var py = 0.0;
		px = s2.circle.worldCOMx - s1.circle.worldCOMx;
		py = s2.circle.worldCOMy - s1.circle.worldCOMy;
		var distSqr = px * px + py * py;
		return distSqr <= minDist * minDist;
	}
};
zpp_$nape_geom_ZPP_$Collide.flowCollide = function(s1,s2,arb) {
	if(s2.type == 1) {
		if(s1.type == 1) {
			var out1 = [];
			var out2 = [];
			var cont = true;
			var total = true;
			var cx_ite = s1.polygon.edges.head;
			while(cx_ite != null) {
				var ax = cx_ite.elt;
				var min = 1e100;
				var ind = 0;
				var cx_ite1 = s2.polygon.gverts.next;
				while(cx_ite1 != null) {
					var v = cx_ite1;
					var k = ax.gnormx * v.x + ax.gnormy * v.y;
					if(k < min) {
						min = k;
					}
					if(k >= ax.gprojection + nape_Config.epsilon) {
						out2[ind] = true;
						total = false;
					}
					++ind;
					cx_ite1 = cx_ite1.next;
				}
				min -= ax.gprojection;
				if(min > 0) {
					cont = false;
					break;
				}
				cx_ite = cx_ite.next;
			}
			if(total) {
				var _this = s2.polygon;
				if(_this.zip_worldCOM) {
					if(_this.body != null) {
						_this.zip_worldCOM = false;
						if(_this.zip_localCOM) {
							_this.zip_localCOM = false;
							if(_this.type == 1) {
								var _this1 = _this.polygon;
								if(_this1.lverts.next.next == null) {
									_this1.localCOMx = _this1.lverts.next.x;
									_this1.localCOMy = _this1.lverts.next.y;
								} else if(_this1.lverts.next.next.next == null) {
									_this1.localCOMx = _this1.lverts.next.x;
									_this1.localCOMy = _this1.lverts.next.y;
									var t = 1.0;
									_this1.localCOMx += _this1.lverts.next.next.x * t;
									_this1.localCOMy += _this1.lverts.next.next.y * t;
									var t = 0.5;
									_this1.localCOMx *= t;
									_this1.localCOMy *= t;
								} else {
									_this1.localCOMx = 0;
									_this1.localCOMy = 0;
									var area = 0.0;
									var cx_ite = _this1.lverts.next;
									var u = cx_ite;
									cx_ite = cx_ite.next;
									var v = cx_ite;
									cx_ite = cx_ite.next;
									while(cx_ite != null) {
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
									}
									cx_ite = _this1.lverts.next;
									var w = cx_ite;
									area += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									_this1.localCOMx += (v.x + w.x) * cf;
									_this1.localCOMy += (v.y + w.y) * cf;
									u = v;
									v = w;
									cx_ite = cx_ite.next;
									var w = cx_ite;
									area += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									_this1.localCOMx += (v.x + w.x) * cf;
									_this1.localCOMy += (v.y + w.y) * cf;
									area = 1 / (3 * area);
									var t = area;
									_this1.localCOMx *= t;
									_this1.localCOMy *= t;
								}
							}
							if(_this.wrap_localCOM != null) {
								_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
								_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
							}
						}
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
						_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
					}
				}
				arb.overlap = s2.polygon.area;
				arb.centroidx = s2.polygon.worldCOMx;
				arb.centroidy = s2.polygon.worldCOMy;
				return true;
			} else if(cont) {
				total = true;
				var cx_ite = s2.polygon.edges.head;
				while(cx_ite != null) {
					var ax = cx_ite.elt;
					var min = 1e100;
					var ind = 0;
					var cx_ite1 = s1.polygon.gverts.next;
					while(cx_ite1 != null) {
						var v = cx_ite1;
						var k = ax.gnormx * v.x + ax.gnormy * v.y;
						if(k < min) {
							min = k;
						}
						if(k >= ax.gprojection + nape_Config.epsilon) {
							out1[ind] = true;
							total = false;
						}
						++ind;
						cx_ite1 = cx_ite1.next;
					}
					min -= ax.gprojection;
					if(min > 0) {
						cont = false;
						break;
					}
					cx_ite = cx_ite.next;
				}
				if(total) {
					var _this = s1.polygon;
					if(_this.zip_worldCOM) {
						if(_this.body != null) {
							_this.zip_worldCOM = false;
							if(_this.zip_localCOM) {
								_this.zip_localCOM = false;
								if(_this.type == 1) {
									var _this1 = _this.polygon;
									if(_this1.lverts.next.next == null) {
										_this1.localCOMx = _this1.lverts.next.x;
										_this1.localCOMy = _this1.lverts.next.y;
									} else if(_this1.lverts.next.next.next == null) {
										_this1.localCOMx = _this1.lverts.next.x;
										_this1.localCOMy = _this1.lverts.next.y;
										var t = 1.0;
										_this1.localCOMx += _this1.lverts.next.next.x * t;
										_this1.localCOMy += _this1.lverts.next.next.y * t;
										var t = 0.5;
										_this1.localCOMx *= t;
										_this1.localCOMy *= t;
									} else {
										_this1.localCOMx = 0;
										_this1.localCOMy = 0;
										var area = 0.0;
										var cx_ite = _this1.lverts.next;
										var u = cx_ite;
										cx_ite = cx_ite.next;
										var v = cx_ite;
										cx_ite = cx_ite.next;
										while(cx_ite != null) {
											var w = cx_ite;
											area += v.x * (w.y - u.y);
											var cf = w.y * v.x - w.x * v.y;
											_this1.localCOMx += (v.x + w.x) * cf;
											_this1.localCOMy += (v.y + w.y) * cf;
											u = v;
											v = w;
											cx_ite = cx_ite.next;
										}
										cx_ite = _this1.lverts.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										area = 1 / (3 * area);
										var t = area;
										_this1.localCOMx *= t;
										_this1.localCOMy *= t;
									}
								}
								if(_this.wrap_localCOM != null) {
									_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
									_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
								}
							}
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
							_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
						}
					}
					arb.overlap = s1.polygon.area;
					arb.centroidx = s1.polygon.worldCOMx;
					arb.centroidy = s1.polygon.worldCOMy;
					return true;
				} else if(cont) {
					while(zpp_$nape_geom_ZPP_$Collide.flowpoly.head != null) {
						var p = zpp_$nape_geom_ZPP_$Collide.flowpoly.pop_unsafe();
						if(!p._inuse) {
							var o = p;
							if(o.outer != null) {
								o.outer.zpp_inner = null;
								o.outer = null;
							}
							o._isimmutable = null;
							o._validate = null;
							o._invalidate = null;
							o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
						}
					}
					var fst_vert = null;
					var poly1 = false;
					var ite1 = s1.polygon.gverts.next;
					var ind1 = 0;
					var ite2 = s2.polygon.gverts.next;
					var ind2 = 0;
					var _g = 0;
					var _g1 = s2.polygon.edgeCnt;
					while(_g < _g1) {
						var i = _g++;
						if(!out2[i]) {
							ind2 = i;
							break;
						} else {
							ite2 = ite2.next;
						}
					}
					if(ite2 == null) {
						ite2 = s2.polygon.gverts.next;
						poly1 = true;
						var _g = 0;
						var _g1 = s1.polygon.edgeCnt;
						while(_g < _g1) {
							var i = _g++;
							if(!out1[i]) {
								ind1 = i;
								break;
							} else {
								ite1 = ite1.next;
							}
						}
						if(ite1 == null) {
							ite1 = s1.polygon.gverts.next;
						} else {
							zpp_$nape_geom_ZPP_$Collide.flowpoly.add(ite1);
							fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
						}
					} else {
						zpp_$nape_geom_ZPP_$Collide.flowpoly.add(ite2);
						fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
					}
					var cnt = 1;
					if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head == null) {
						var cx_cont = true;
						var cx_itei = s1.polygon.gverts.next;
						var u = cx_itei;
						var cx_itej = cx_itei.next;
						while(cx_itej != null) {
							var v = cx_itej;
							var min = 2.0;
							var cx_cont1 = true;
							var cx_itei1 = s2.polygon.gverts.next;
							var a = cx_itei1;
							var cx_itej1 = cx_itei1.next;
							while(cx_itej1 != null) {
								var b = cx_itej1;
								var t = 0.0;
								var _sx = 0.0;
								var _sy = 0.0;
								_sx = u.x - a.x;
								_sy = u.y - a.y;
								var _vx = 0.0;
								var _vy = 0.0;
								_vx = v.x - u.x;
								_vy = v.y - u.y;
								var _qx = 0.0;
								var _qy = 0.0;
								_qx = b.x - a.x;
								_qy = b.y - a.y;
								var den = _vy * _qx - _vx * _qy;
								var tmp;
								if(den * den > nape_Config.epsilon * nape_Config.epsilon) {
									den = 1 / den;
									var txx = (_qy * _sx - _qx * _sy) * den;
									if(txx > nape_Config.epsilon && txx < 1 - nape_Config.epsilon) {
										var sxx = (_vy * _sx - _vx * _sy) * den;
										if(sxx > nape_Config.epsilon && sxx < 1 - nape_Config.epsilon) {
											t = txx;
											tmp = true;
										} else {
											tmp = false;
										}
									} else {
										tmp = false;
									}
								} else {
									tmp = false;
								}
								if(tmp) {
									if(t < min) {
										min = t;
										ite2 = cx_itei1;
									}
								}
								cx_itei1 = cx_itej1;
								a = b;
								cx_itej1 = cx_itej1.next;
							}
							if(cx_cont1) {
								do {
									cx_itej1 = s2.polygon.gverts.next;
									var b1 = cx_itej1;
									var t1 = 0.0;
									var _sx1 = 0.0;
									var _sy1 = 0.0;
									_sx1 = u.x - a.x;
									_sy1 = u.y - a.y;
									var _vx1 = 0.0;
									var _vy1 = 0.0;
									_vx1 = v.x - u.x;
									_vy1 = v.y - u.y;
									var _qx1 = 0.0;
									var _qy1 = 0.0;
									_qx1 = b1.x - a.x;
									_qy1 = b1.y - a.y;
									var den1 = _vy1 * _qx1 - _vx1 * _qy1;
									var tmp1;
									if(den1 * den1 > nape_Config.epsilon * nape_Config.epsilon) {
										den1 = 1 / den1;
										var txx1 = (_qy1 * _sx1 - _qx1 * _sy1) * den1;
										if(txx1 > nape_Config.epsilon && txx1 < 1 - nape_Config.epsilon) {
											var sxx1 = (_vy1 * _sx1 - _vx1 * _sy1) * den1;
											if(sxx1 > nape_Config.epsilon && sxx1 < 1 - nape_Config.epsilon) {
												t1 = txx1;
												tmp1 = true;
											} else {
												tmp1 = false;
											}
										} else {
											tmp1 = false;
										}
									} else {
										tmp1 = false;
									}
									if(tmp1) {
										if(t1 < min) {
											min = t1;
											ite2 = cx_itei1;
										}
									}
								} while(false);
							}
							if(min != 2.0) {
								var cx = 0.0;
								var cy = 0.0;
								var T = min;
								cx = u.x + (v.x - u.x) * T;
								cy = u.y + (v.y - u.y) * T;
								var ret;
								if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
									ret = new zpp_$nape_geom_ZPP_$Vec2();
								} else {
									ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
									zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
									ret.next = null;
								}
								ret.weak = false;
								ret._immutable = false;
								ret.x = cx;
								ret.y = cy;
								fst_vert = ret;
								zpp_$nape_geom_ZPP_$Collide.flowpoly.add(fst_vert);
								poly1 = true;
								ite1 = cx_itei;
								cx_cont = false;
								break;
							}
							cx_itei = cx_itej;
							u = v;
							cx_itej = cx_itej.next;
						}
						if(cx_cont) {
							do {
								cx_itej = s1.polygon.gverts.next;
								var v = cx_itej;
								var min = 2.0;
								var cx_cont = true;
								var cx_itei1 = s2.polygon.gverts.next;
								var a = cx_itei1;
								var cx_itej1 = cx_itei1.next;
								while(cx_itej1 != null) {
									var b = cx_itej1;
									var t = 0.0;
									var _sx = 0.0;
									var _sy = 0.0;
									_sx = u.x - a.x;
									_sy = u.y - a.y;
									var _vx = 0.0;
									var _vy = 0.0;
									_vx = v.x - u.x;
									_vy = v.y - u.y;
									var _qx = 0.0;
									var _qy = 0.0;
									_qx = b.x - a.x;
									_qy = b.y - a.y;
									var den = _vy * _qx - _vx * _qy;
									var tmp;
									if(den * den > nape_Config.epsilon * nape_Config.epsilon) {
										den = 1 / den;
										var txx = (_qy * _sx - _qx * _sy) * den;
										if(txx > nape_Config.epsilon && txx < 1 - nape_Config.epsilon) {
											var sxx = (_vy * _sx - _vx * _sy) * den;
											if(sxx > nape_Config.epsilon && sxx < 1 - nape_Config.epsilon) {
												t = txx;
												tmp = true;
											} else {
												tmp = false;
											}
										} else {
											tmp = false;
										}
									} else {
										tmp = false;
									}
									if(tmp) {
										if(t < min) {
											min = t;
											ite2 = cx_itei1;
										}
									}
									cx_itei1 = cx_itej1;
									a = b;
									cx_itej1 = cx_itej1.next;
								}
								if(cx_cont) {
									do {
										cx_itej1 = s2.polygon.gverts.next;
										var b1 = cx_itej1;
										var t1 = 0.0;
										var _sx1 = 0.0;
										var _sy1 = 0.0;
										_sx1 = u.x - a.x;
										_sy1 = u.y - a.y;
										var _vx1 = 0.0;
										var _vy1 = 0.0;
										_vx1 = v.x - u.x;
										_vy1 = v.y - u.y;
										var _qx1 = 0.0;
										var _qy1 = 0.0;
										_qx1 = b1.x - a.x;
										_qy1 = b1.y - a.y;
										var den1 = _vy1 * _qx1 - _vx1 * _qy1;
										var tmp1;
										if(den1 * den1 > nape_Config.epsilon * nape_Config.epsilon) {
											den1 = 1 / den1;
											var txx1 = (_qy1 * _sx1 - _qx1 * _sy1) * den1;
											if(txx1 > nape_Config.epsilon && txx1 < 1 - nape_Config.epsilon) {
												var sxx1 = (_vy1 * _sx1 - _vx1 * _sy1) * den1;
												if(sxx1 > nape_Config.epsilon && sxx1 < 1 - nape_Config.epsilon) {
													t1 = txx1;
													tmp1 = true;
												} else {
													tmp1 = false;
												}
											} else {
												tmp1 = false;
											}
										} else {
											tmp1 = false;
										}
										if(tmp1) {
											if(t1 < min) {
												min = t1;
												ite2 = cx_itei1;
											}
										}
									} while(false);
								}
								if(min != 2.0) {
									var cx = 0.0;
									var cy = 0.0;
									var T = min;
									cx = u.x + (v.x - u.x) * T;
									cy = u.y + (v.y - u.y) * T;
									var ret;
									if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
										ret = new zpp_$nape_geom_ZPP_$Vec2();
									} else {
										ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
										zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
										ret.next = null;
									}
									ret.weak = false;
									ret._immutable = false;
									ret.x = cx;
									ret.y = cy;
									fst_vert = ret;
									zpp_$nape_geom_ZPP_$Collide.flowpoly.add(fst_vert);
									poly1 = true;
									ite1 = cx_itei;
									break;
								}
							} while(false);
						}
						cnt = 2;
					}
					while(true) if(poly1) {
						ite1 = ite1.next;
						++ind1;
						if(ite1 == null) {
							ite1 = s1.polygon.gverts.next;
							ind1 = 0;
						}
						if(!out1[ind1]) {
							var ex = ite1;
							var tmp;
							if(fst_vert != null) {
								var dx = 0.0;
								var dy = 0.0;
								dx = ex.x - fst_vert.x;
								dy = ex.y - fst_vert.y;
								tmp = dx * dx + dy * dy < nape_Config.epsilon;
							} else {
								tmp = false;
							}
							if(tmp) {
								break;
							}
							zpp_$nape_geom_ZPP_$Collide.flowpoly.add(ex);
							if(fst_vert == null) {
								fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
							}
							cnt = 1;
						} else {
							var a = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
							var b = ite1;
							var u = ite2;
							var itm = ite2.next;
							if(itm == null) {
								itm = s2.polygon.gverts.next;
							}
							var max = -1.0;
							var itmo = null;
							var indo = 0;
							var icnt = 0;
							var beg_ite = itm;
							var cx_ite = itm;
							do {
								var v = cx_ite;
								var t = 0.0;
								var _sx = 0.0;
								var _sy = 0.0;
								_sx = u.x - a.x;
								_sy = u.y - a.y;
								var _vx = 0.0;
								var _vy = 0.0;
								_vx = v.x - u.x;
								_vy = v.y - u.y;
								var _qx = 0.0;
								var _qy = 0.0;
								_qx = b.x - a.x;
								_qy = b.y - a.y;
								var den = _vy * _qx - _vx * _qy;
								var tmp1;
								if(den * den > nape_Config.epsilon * nape_Config.epsilon) {
									den = 1 / den;
									var txx = (_qy * _sx - _qx * _sy) * den;
									if(txx > nape_Config.epsilon && txx < 1 - nape_Config.epsilon) {
										var sxx = (_vy * _sx - _vx * _sy) * den;
										if(sxx > nape_Config.epsilon && sxx < 1 - nape_Config.epsilon) {
											t = txx;
											tmp1 = true;
										} else {
											tmp1 = false;
										}
									} else {
										tmp1 = false;
									}
								} else {
									tmp1 = false;
								}
								if(tmp1) {
									if(t >= max) {
										itmo = ite2;
										indo = ind2;
										if(++icnt == cnt) {
											max = t;
											cx_ite = beg_ite;
											break;
										} else {
											max = t;
										}
									}
								}
								u = v;
								ite2 = cx_ite;
								++ind2;
								if(ind2 >= s2.polygon.edgeCnt) {
									ind2 = 0;
								}
								cx_ite = cx_ite.next;
								if(cx_ite == null) {
									cx_ite = s2.polygon.gverts.next;
								}
							} while(false);
							while(cx_ite != beg_ite) {
								var v1 = cx_ite;
								var t1 = 0.0;
								var _sx1 = 0.0;
								var _sy1 = 0.0;
								_sx1 = u.x - a.x;
								_sy1 = u.y - a.y;
								var _vx1 = 0.0;
								var _vy1 = 0.0;
								_vx1 = v1.x - u.x;
								_vy1 = v1.y - u.y;
								var _qx1 = 0.0;
								var _qy1 = 0.0;
								_qx1 = b.x - a.x;
								_qy1 = b.y - a.y;
								var den1 = _vy1 * _qx1 - _vx1 * _qy1;
								var tmp2;
								if(den1 * den1 > nape_Config.epsilon * nape_Config.epsilon) {
									den1 = 1 / den1;
									var txx1 = (_qy1 * _sx1 - _qx1 * _sy1) * den1;
									if(txx1 > nape_Config.epsilon && txx1 < 1 - nape_Config.epsilon) {
										var sxx1 = (_vy1 * _sx1 - _vx1 * _sy1) * den1;
										if(sxx1 > nape_Config.epsilon && sxx1 < 1 - nape_Config.epsilon) {
											t1 = txx1;
											tmp2 = true;
										} else {
											tmp2 = false;
										}
									} else {
										tmp2 = false;
									}
								} else {
									tmp2 = false;
								}
								if(tmp2) {
									if(t1 >= max) {
										itmo = ite2;
										indo = ind2;
										if(++icnt == cnt) {
											max = t1;
											cx_ite = beg_ite;
											break;
										} else {
											max = t1;
										}
									}
								}
								u = v1;
								ite2 = cx_ite;
								++ind2;
								if(ind2 >= s2.polygon.edgeCnt) {
									ind2 = 0;
								}
								cx_ite = cx_ite.next;
								if(cx_ite == null) {
									cx_ite = s2.polygon.gverts.next;
								}
							}
							if(itmo == null) {
								break;
							}
							var u1 = itmo;
							var itm2 = itmo.next;
							if(itm2 == null) {
								itm2 = s2.polygon.gverts.next;
							}
							var v2 = itm2;
							var cx = 0.0;
							var cy = 0.0;
							var T = max;
							cx = u1.x + (v2.x - u1.x) * T;
							cy = u1.y + (v2.y - u1.y) * T;
							var tmp3;
							if(fst_vert != null) {
								var dx1 = 0.0;
								var dy1 = 0.0;
								dx1 = cx - fst_vert.x;
								dy1 = cy - fst_vert.y;
								tmp3 = dx1 * dx1 + dy1 * dy1 < nape_Config.epsilon;
							} else {
								tmp3 = false;
							}
							if(tmp3) {
								break;
							}
							var tmp4 = zpp_$nape_geom_ZPP_$Collide.flowpoly;
							var ret;
							if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
								ret = new zpp_$nape_geom_ZPP_$Vec2();
							} else {
								ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
								zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.weak = false;
							ret._immutable = false;
							ret.x = cx;
							ret.y = cy;
							tmp4.add(ret);
							if(fst_vert == null) {
								fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
							}
							ite2 = itmo;
							ind2 = indo;
							poly1 = !poly1;
							cnt = 2;
						}
					} else {
						ite2 = ite2.next;
						++ind2;
						if(ite2 == null) {
							ite2 = s2.polygon.gverts.next;
							ind2 = 0;
						}
						if(!out2[ind2]) {
							var ex1 = ite2;
							var tmp5;
							if(fst_vert != null) {
								var dx2 = 0.0;
								var dy2 = 0.0;
								dx2 = ex1.x - fst_vert.x;
								dy2 = ex1.y - fst_vert.y;
								tmp5 = dx2 * dx2 + dy2 * dy2 < nape_Config.epsilon;
							} else {
								tmp5 = false;
							}
							if(tmp5) {
								break;
							}
							zpp_$nape_geom_ZPP_$Collide.flowpoly.add(ex1);
							if(fst_vert == null) {
								fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
							}
							cnt = 1;
						} else {
							var a1 = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
							var b1 = ite2;
							var u2 = ite1;
							var itm1 = ite1.next;
							if(itm1 == null) {
								itm1 = s1.polygon.gverts.next;
							}
							var max1 = -1.0;
							var itmo1 = null;
							var indo1 = 0;
							var icnt1 = 0;
							var beg_ite1 = itm1;
							var cx_ite1 = itm1;
							do {
								var v3 = cx_ite1;
								var t2 = 0.0;
								var _sx2 = 0.0;
								var _sy2 = 0.0;
								_sx2 = u2.x - a1.x;
								_sy2 = u2.y - a1.y;
								var _vx2 = 0.0;
								var _vy2 = 0.0;
								_vx2 = v3.x - u2.x;
								_vy2 = v3.y - u2.y;
								var _qx2 = 0.0;
								var _qy2 = 0.0;
								_qx2 = b1.x - a1.x;
								_qy2 = b1.y - a1.y;
								var den2 = _vy2 * _qx2 - _vx2 * _qy2;
								var tmp6;
								if(den2 * den2 > nape_Config.epsilon * nape_Config.epsilon) {
									den2 = 1 / den2;
									var txx2 = (_qy2 * _sx2 - _qx2 * _sy2) * den2;
									if(txx2 > nape_Config.epsilon && txx2 < 1 - nape_Config.epsilon) {
										var sxx2 = (_vy2 * _sx2 - _vx2 * _sy2) * den2;
										if(sxx2 > nape_Config.epsilon && sxx2 < 1 - nape_Config.epsilon) {
											t2 = txx2;
											tmp6 = true;
										} else {
											tmp6 = false;
										}
									} else {
										tmp6 = false;
									}
								} else {
									tmp6 = false;
								}
								if(tmp6) {
									if(t2 >= max1) {
										itmo1 = ite1;
										indo1 = ind1;
										if(++icnt1 == cnt) {
											max1 = t2;
											cx_ite1 = beg_ite1;
											break;
										} else {
											max1 = t2;
										}
									}
								}
								u2 = v3;
								ite1 = cx_ite1;
								++ind1;
								if(ind1 >= s1.polygon.edgeCnt) {
									ind1 = 0;
								}
								cx_ite1 = cx_ite1.next;
								if(cx_ite1 == null) {
									cx_ite1 = s1.polygon.gverts.next;
								}
							} while(false);
							while(cx_ite1 != beg_ite1) {
								var v4 = cx_ite1;
								var t3 = 0.0;
								var _sx3 = 0.0;
								var _sy3 = 0.0;
								_sx3 = u2.x - a1.x;
								_sy3 = u2.y - a1.y;
								var _vx3 = 0.0;
								var _vy3 = 0.0;
								_vx3 = v4.x - u2.x;
								_vy3 = v4.y - u2.y;
								var _qx3 = 0.0;
								var _qy3 = 0.0;
								_qx3 = b1.x - a1.x;
								_qy3 = b1.y - a1.y;
								var den3 = _vy3 * _qx3 - _vx3 * _qy3;
								var tmp7;
								if(den3 * den3 > nape_Config.epsilon * nape_Config.epsilon) {
									den3 = 1 / den3;
									var txx3 = (_qy3 * _sx3 - _qx3 * _sy3) * den3;
									if(txx3 > nape_Config.epsilon && txx3 < 1 - nape_Config.epsilon) {
										var sxx3 = (_vy3 * _sx3 - _vx3 * _sy3) * den3;
										if(sxx3 > nape_Config.epsilon && sxx3 < 1 - nape_Config.epsilon) {
											t3 = txx3;
											tmp7 = true;
										} else {
											tmp7 = false;
										}
									} else {
										tmp7 = false;
									}
								} else {
									tmp7 = false;
								}
								if(tmp7) {
									if(t3 >= max1) {
										itmo1 = ite1;
										indo1 = ind1;
										if(++icnt1 == cnt) {
											max1 = t3;
											cx_ite1 = beg_ite1;
											break;
										} else {
											max1 = t3;
										}
									}
								}
								u2 = v4;
								ite1 = cx_ite1;
								++ind1;
								if(ind1 >= s1.polygon.edgeCnt) {
									ind1 = 0;
								}
								cx_ite1 = cx_ite1.next;
								if(cx_ite1 == null) {
									cx_ite1 = s1.polygon.gverts.next;
								}
							}
							if(itmo1 == null) {
								break;
							}
							var u3 = itmo1;
							var itm21 = itmo1.next;
							if(itm21 == null) {
								itm21 = s1.polygon.gverts.next;
							}
							var v5 = itm21;
							var cx1 = 0.0;
							var cy1 = 0.0;
							var T1 = max1;
							cx1 = u3.x + (v5.x - u3.x) * T1;
							cy1 = u3.y + (v5.y - u3.y) * T1;
							var tmp8;
							if(fst_vert != null) {
								var dx3 = 0.0;
								var dy3 = 0.0;
								dx3 = cx1 - fst_vert.x;
								dy3 = cy1 - fst_vert.y;
								tmp8 = dx3 * dx3 + dy3 * dy3 < nape_Config.epsilon;
							} else {
								tmp8 = false;
							}
							if(tmp8) {
								break;
							}
							var tmp9 = zpp_$nape_geom_ZPP_$Collide.flowpoly;
							var ret1;
							if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
								ret1 = new zpp_$nape_geom_ZPP_$Vec2();
							} else {
								ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
								zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.weak = false;
							ret1._immutable = false;
							ret1.x = cx1;
							ret1.y = cy1;
							tmp9.add(ret1);
							if(fst_vert == null) {
								fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
							}
							ite1 = itmo1;
							ind1 = indo1;
							poly1 = !poly1;
							cnt = 2;
						}
					}
					if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head != null && zpp_$nape_geom_ZPP_$Collide.flowpoly.head.next != null && zpp_$nape_geom_ZPP_$Collide.flowpoly.head.next.next != null) {
						var area = 0.0;
						var COMx = 0.0;
						var COMy = 0.0;
						COMx = 0;
						COMy = 0;
						area = 0.0;
						var cx_ite = zpp_$nape_geom_ZPP_$Collide.flowpoly.head;
						var u = cx_ite.elt;
						cx_ite = cx_ite.next;
						var v = cx_ite.elt;
						cx_ite = cx_ite.next;
						while(cx_ite != null) {
							var w = cx_ite.elt;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							COMx += (v.x + w.x) * cf;
							COMy += (v.y + w.y) * cf;
							u = v;
							v = w;
							cx_ite = cx_ite.next;
						}
						cx_ite = zpp_$nape_geom_ZPP_$Collide.flowpoly.head;
						var w = cx_ite.elt;
						area += v.x * (w.y - u.y);
						var cf = w.y * v.x - w.x * v.y;
						COMx += (v.x + w.x) * cf;
						COMy += (v.y + w.y) * cf;
						u = v;
						v = w;
						cx_ite = cx_ite.next;
						var w = cx_ite.elt;
						area += v.x * (w.y - u.y);
						var cf = w.y * v.x - w.x * v.y;
						COMx += (v.x + w.x) * cf;
						COMy += (v.y + w.y) * cf;
						area *= 0.5;
						var ia = 1 / (6 * area);
						var t = ia;
						COMx *= t;
						COMy *= t;
						arb.overlap = -area;
						arb.centroidx = COMx;
						arb.centroidy = COMy;
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			var inte = [];
			var total = true;
			var a0 = null;
			var vi = null;
			var max = -1e+100;
			var cont = true;
			var vite = s2.polygon.gverts.next;
			var ind = 0;
			var cx_ite = s2.polygon.edges.head;
			while(cx_ite != null) {
				var a = cx_ite.elt;
				var dist = a.gnormx * s1.circle.worldCOMx + a.gnormy * s1.circle.worldCOMy;
				if(dist > a.gprojection + s1.circle.radius) {
					cont = false;
					break;
				} else if(dist + s1.circle.radius > a.gprojection + nape_Config.epsilon) {
					total = false;
					inte[ind] = true;
				}
				dist -= a.gprojection + s1.circle.radius;
				if(dist > max) {
					max = dist;
					a0 = a;
					vi = vite;
				}
				vite = vite.next;
				++ind;
				cx_ite = cx_ite.next;
			}
			if(cont) {
				if(total) {
					arb.overlap = s1.circle.area;
					arb.centroidx = s1.circle.worldCOMx;
					arb.centroidy = s1.circle.worldCOMy;
					return true;
				} else {
					var v0 = vi;
					var v1 = vi.next == null ? s2.polygon.gverts.next : vi.next;
					var dt = s1.circle.worldCOMy * a0.gnormx - s1.circle.worldCOMx * a0.gnormy;
					var tmp;
					if(dt <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
						var minDist = s1.circle.radius;
						var px = 0.0;
						var py = 0.0;
						px = v0.x - s1.circle.worldCOMx;
						py = v0.y - s1.circle.worldCOMy;
						var distSqr = px * px + py * py;
						tmp = distSqr <= minDist * minDist;
					} else if(dt >= v1.y * a0.gnormx - v1.x * a0.gnormy) {
						var minDist = s1.circle.radius;
						var px = 0.0;
						var py = 0.0;
						px = v1.x - s1.circle.worldCOMx;
						py = v1.y - s1.circle.worldCOMy;
						var distSqr = px * px + py * py;
						tmp = distSqr <= minDist * minDist;
					} else {
						tmp = true;
					}
					if(tmp) {
						var ins = [];
						var ind = 0;
						var total = true;
						var vi = null;
						var vind = 0;
						var cx_ite = s2.polygon.gverts.next;
						while(cx_ite != null) {
							var v = cx_ite;
							var dx = 0.0;
							var dy = 0.0;
							dx = v.x - s1.circle.worldCOMx;
							dy = v.y - s1.circle.worldCOMy;
							var dist = dx * dx + dy * dy;
							if(!(ins[ind] = dist <= s1.circle.radius * s1.circle.radius)) {
								total = false;
							} else {
								vind = ind;
								vi = cx_ite;
							}
							++ind;
							cx_ite = cx_ite.next;
						}
						if(total) {
							var _this = s2.polygon;
							if(_this.zip_worldCOM) {
								if(_this.body != null) {
									_this.zip_worldCOM = false;
									if(_this.zip_localCOM) {
										_this.zip_localCOM = false;
										if(_this.type == 1) {
											var _this1 = _this.polygon;
											if(_this1.lverts.next.next == null) {
												_this1.localCOMx = _this1.lverts.next.x;
												_this1.localCOMy = _this1.lverts.next.y;
											} else if(_this1.lverts.next.next.next == null) {
												_this1.localCOMx = _this1.lverts.next.x;
												_this1.localCOMy = _this1.lverts.next.y;
												var t = 1.0;
												_this1.localCOMx += _this1.lverts.next.next.x * t;
												_this1.localCOMy += _this1.lverts.next.next.y * t;
												var t = 0.5;
												_this1.localCOMx *= t;
												_this1.localCOMy *= t;
											} else {
												_this1.localCOMx = 0;
												_this1.localCOMy = 0;
												var area = 0.0;
												var cx_ite = _this1.lverts.next;
												var u = cx_ite;
												cx_ite = cx_ite.next;
												var v = cx_ite;
												cx_ite = cx_ite.next;
												while(cx_ite != null) {
													var w = cx_ite;
													area += v.x * (w.y - u.y);
													var cf = w.y * v.x - w.x * v.y;
													_this1.localCOMx += (v.x + w.x) * cf;
													_this1.localCOMy += (v.y + w.y) * cf;
													u = v;
													v = w;
													cx_ite = cx_ite.next;
												}
												cx_ite = _this1.lverts.next;
												var w = cx_ite;
												area += v.x * (w.y - u.y);
												var cf = w.y * v.x - w.x * v.y;
												_this1.localCOMx += (v.x + w.x) * cf;
												_this1.localCOMy += (v.y + w.y) * cf;
												u = v;
												v = w;
												cx_ite = cx_ite.next;
												var w = cx_ite;
												area += v.x * (w.y - u.y);
												var cf = w.y * v.x - w.x * v.y;
												_this1.localCOMx += (v.x + w.x) * cf;
												_this1.localCOMy += (v.y + w.y) * cf;
												area = 1 / (3 * area);
												var t = area;
												_this1.localCOMx *= t;
												_this1.localCOMy *= t;
											}
										}
										if(_this.wrap_localCOM != null) {
											_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
											_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
										}
									}
									var _this1 = _this.body;
									if(_this1.zip_axis) {
										_this1.zip_axis = false;
										_this1.axisx = Math.sin(_this1.rot);
										_this1.axisy = Math.cos(_this1.rot);
									}
									_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
									_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
								}
							}
							arb.overlap = s2.polygon.area;
							arb.centroidx = s2.polygon.worldCOMx;
							arb.centroidy = s2.polygon.worldCOMy;
							return true;
						} else {
							while(zpp_$nape_geom_ZPP_$Collide.flowpoly.head != null) {
								var p = zpp_$nape_geom_ZPP_$Collide.flowpoly.pop_unsafe();
								if(!p._inuse) {
									var o = p;
									if(o.outer != null) {
										o.outer.zpp_inner = null;
										o.outer = null;
									}
									o._isimmutable = null;
									o._validate = null;
									o._invalidate = null;
									o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
									zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
								}
							}
							zpp_$nape_geom_ZPP_$Collide.flowsegs.clear();
							var fst_vert = null;
							var state = 1;
							if(vi == null) {
								vi = s2.polygon.gverts.next;
								state = 2;
							} else {
								fst_vert = vi;
								zpp_$nape_geom_ZPP_$Collide.flowpoly.add(fst_vert);
							}
							while(state != 0) if(state == 1) {
								vi = vi.next;
								if(vi == null) {
									vi = s2.polygon.gverts.next;
								}
								++vind;
								if(vind >= s2.polygon.edgeCnt) {
									vind = 0;
								}
								if(ins[vind]) {
									var dx = 0.0;
									var dy = 0.0;
									dx = fst_vert.x - vi.x;
									dy = fst_vert.y - vi.y;
									if(dx * dx + dy * dy < nape_Config.epsilon) {
										break;
									}
									zpp_$nape_geom_ZPP_$Collide.flowpoly.add(vi);
								} else {
									var u = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
									var v = vi;
									var vx = 0.0;
									var vy = 0.0;
									vx = v.x - u.x;
									vy = v.y - u.y;
									var qx = 0.0;
									var qy = 0.0;
									qx = u.x - s1.circle.worldCOMx;
									qy = u.y - s1.circle.worldCOMy;
									var A = vx * vx + vy * vy;
									var B = 2 * (qx * vx + qy * vy);
									var C = qx * qx + qy * qy - s1.circle.radius * s1.circle.radius;
									var D = Math.sqrt(B * B - 4 * A * C);
									A = 1 / (2 * A);
									var t = (-B - D) * A;
									var tval = t < nape_Config.epsilon ? (-B + D) * A : t;
									var cx = 0.0;
									var cy = 0.0;
									var T = tval;
									cx = u.x + (v.x - u.x) * T;
									cy = u.y + (v.y - u.y) * T;
									var dx1 = 0.0;
									var dy1 = 0.0;
									dx1 = fst_vert.x - cx;
									dy1 = fst_vert.y - cy;
									if(dx1 * dx1 + dy1 * dy1 < nape_Config.epsilon) {
										break;
									}
									var tmp = zpp_$nape_geom_ZPP_$Collide.flowpoly;
									var ret;
									if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
										ret = new zpp_$nape_geom_ZPP_$Vec2();
									} else {
										ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
										zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
										ret.next = null;
									}
									ret.weak = false;
									ret._immutable = false;
									ret.x = cx;
									ret.y = cy;
									tmp.add(ret);
									state = 2;
								}
							} else if(state == 2) {
								var vi2 = vi.next;
								if(vi2 == null) {
									vi2 = s2.polygon.gverts.next;
								}
								var u1 = vi;
								state = 0;
								var beg_ite = vi2;
								var cx_ite = vi2;
								do {
									var v1 = cx_ite;
									var vind2 = vind + 1;
									if(vind2 == s2.polygon.edgeCnt) {
										vind2 = 0;
									}
									if(inte[vind]) {
										if(ins[vind2]) {
											var vx1 = 0.0;
											var vy1 = 0.0;
											vx1 = v1.x - u1.x;
											vy1 = v1.y - u1.y;
											var qx1 = 0.0;
											var qy1 = 0.0;
											qx1 = u1.x - s1.circle.worldCOMx;
											qy1 = u1.y - s1.circle.worldCOMy;
											var A1 = vx1 * vx1 + vy1 * vy1;
											var B1 = 2 * (qx1 * vx1 + qy1 * vy1);
											var C1 = qx1 * qx1 + qy1 * qy1 - s1.circle.radius * s1.circle.radius;
											var D1 = Math.sqrt(B1 * B1 - 4 * A1 * C1);
											A1 = 1 / (2 * A1);
											var t1 = (-B1 - D1) * A1;
											var tval1 = t1 < nape_Config.epsilon ? (-B1 + D1) * A1 : t1;
											var cx1 = 0.0;
											var cy1 = 0.0;
											var T1 = tval1;
											cx1 = u1.x + (v1.x - u1.x) * T1;
											cy1 = u1.y + (v1.y - u1.y) * T1;
											var dx2 = 0.0;
											var dy2 = 0.0;
											dx2 = fst_vert.x - cx1;
											dy2 = fst_vert.y - cy1;
											if(dx2 * dx2 + dy2 * dy2 < nape_Config.epsilon) {
												state = 0;
												cx_ite = beg_ite;
												break;
											}
											var ret1;
											if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
												ret1 = new zpp_$nape_geom_ZPP_$Vec2();
											} else {
												ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
												zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
												ret1.next = null;
											}
											ret1.weak = false;
											ret1._immutable = false;
											ret1.x = cx1;
											ret1.y = cy1;
											var cp = ret1;
											zpp_$nape_geom_ZPP_$Collide.flowsegs.add(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt);
											zpp_$nape_geom_ZPP_$Collide.flowsegs.add(cp);
											zpp_$nape_geom_ZPP_$Collide.flowpoly.add(cp);
											state = 1;
											cx_ite = beg_ite;
											break;
										} else {
											var t0 = 0.0;
											var t11 = 0.0;
											var vx2 = 0.0;
											var vy2 = 0.0;
											vx2 = v1.x - u1.x;
											vy2 = v1.y - u1.y;
											var qx2 = 0.0;
											var qy2 = 0.0;
											qx2 = u1.x - s1.circle.worldCOMx;
											qy2 = u1.y - s1.circle.worldCOMy;
											var A2 = vx2 * vx2 + vy2 * vy2;
											var B2 = 2 * (qx2 * vx2 + qy2 * vy2);
											var C2 = qx2 * qx2 + qy2 * qy2 - s1.circle.radius * s1.circle.radius;
											var D2 = B2 * B2 - 4 * A2 * C2;
											var two;
											if(D2 * D2 < nape_Config.epsilon) {
												if(D2 < 0) {
													t0 = 10.0;
												} else {
													t11 = -B2 / (2 * A2);
													t0 = t11;
												}
												two = false;
											} else {
												D2 = Math.sqrt(D2);
												A2 = 1 / (2 * A2);
												t0 = (-B2 - D2) * A2;
												t11 = (-B2 + D2) * A2;
												two = true;
											}
											if(t0 < 1 - nape_Config.epsilon && t11 > nape_Config.epsilon) {
												var cx2 = 0.0;
												var cy2 = 0.0;
												var T2 = t0;
												cx2 = u1.x + (v1.x - u1.x) * T2;
												cy2 = u1.y + (v1.y - u1.y) * T2;
												var tmp1;
												if(fst_vert != null) {
													var dx3 = 0.0;
													var dy3 = 0.0;
													dx3 = fst_vert.x - cx2;
													dy3 = fst_vert.y - cy2;
													tmp1 = dx3 * dx3 + dy3 * dy3 < nape_Config.epsilon;
												} else {
													tmp1 = false;
												}
												if(tmp1) {
													state = 0;
													cx_ite = beg_ite;
													break;
												}
												var ret2;
												if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
													ret2 = new zpp_$nape_geom_ZPP_$Vec2();
												} else {
													ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
													zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
													ret2.next = null;
												}
												ret2.weak = false;
												ret2._immutable = false;
												ret2.x = cx2;
												ret2.y = cy2;
												var cp1 = ret2;
												if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head != null) {
													zpp_$nape_geom_ZPP_$Collide.flowsegs.add(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt);
													zpp_$nape_geom_ZPP_$Collide.flowsegs.add(cp1);
												}
												zpp_$nape_geom_ZPP_$Collide.flowpoly.add(cp1);
												if(fst_vert == null) {
													fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
												}
												if(two) {
													var cx3 = 0.0;
													var cy3 = 0.0;
													var T3 = t11;
													cx3 = u1.x + (v1.x - u1.x) * T3;
													cy3 = u1.y + (v1.y - u1.y) * T3;
													var tmp2 = zpp_$nape_geom_ZPP_$Collide.flowpoly;
													var ret3;
													if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
														ret3 = new zpp_$nape_geom_ZPP_$Vec2();
													} else {
														ret3 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
														zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret3.next;
														ret3.next = null;
													}
													ret3.weak = false;
													ret3._immutable = false;
													ret3.x = cx3;
													ret3.y = cy3;
													tmp2.add(ret3);
												}
											}
										}
									}
									u1 = v1;
									vi = cx_ite;
									vind = vind2;
									cx_ite = cx_ite.next;
									if(cx_ite == null) {
										cx_ite = s2.polygon.gverts.next;
									}
								} while(false);
								while(cx_ite != beg_ite) {
									var v2 = cx_ite;
									var vind21 = vind + 1;
									if(vind21 == s2.polygon.edgeCnt) {
										vind21 = 0;
									}
									if(inte[vind]) {
										if(ins[vind21]) {
											var vx3 = 0.0;
											var vy3 = 0.0;
											vx3 = v2.x - u1.x;
											vy3 = v2.y - u1.y;
											var qx3 = 0.0;
											var qy3 = 0.0;
											qx3 = u1.x - s1.circle.worldCOMx;
											qy3 = u1.y - s1.circle.worldCOMy;
											var A3 = vx3 * vx3 + vy3 * vy3;
											var B3 = 2 * (qx3 * vx3 + qy3 * vy3);
											var C3 = qx3 * qx3 + qy3 * qy3 - s1.circle.radius * s1.circle.radius;
											var D3 = Math.sqrt(B3 * B3 - 4 * A3 * C3);
											A3 = 1 / (2 * A3);
											var t2 = (-B3 - D3) * A3;
											var tval2 = t2 < nape_Config.epsilon ? (-B3 + D3) * A3 : t2;
											var cx4 = 0.0;
											var cy4 = 0.0;
											var T4 = tval2;
											cx4 = u1.x + (v2.x - u1.x) * T4;
											cy4 = u1.y + (v2.y - u1.y) * T4;
											var dx4 = 0.0;
											var dy4 = 0.0;
											dx4 = fst_vert.x - cx4;
											dy4 = fst_vert.y - cy4;
											if(dx4 * dx4 + dy4 * dy4 < nape_Config.epsilon) {
												state = 0;
												cx_ite = beg_ite;
												break;
											}
											var ret4;
											if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
												ret4 = new zpp_$nape_geom_ZPP_$Vec2();
											} else {
												ret4 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
												zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret4.next;
												ret4.next = null;
											}
											ret4.weak = false;
											ret4._immutable = false;
											ret4.x = cx4;
											ret4.y = cy4;
											var cp2 = ret4;
											zpp_$nape_geom_ZPP_$Collide.flowsegs.add(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt);
											zpp_$nape_geom_ZPP_$Collide.flowsegs.add(cp2);
											zpp_$nape_geom_ZPP_$Collide.flowpoly.add(cp2);
											state = 1;
											cx_ite = beg_ite;
											break;
										} else {
											var t01 = 0.0;
											var t12 = 0.0;
											var vx4 = 0.0;
											var vy4 = 0.0;
											vx4 = v2.x - u1.x;
											vy4 = v2.y - u1.y;
											var qx4 = 0.0;
											var qy4 = 0.0;
											qx4 = u1.x - s1.circle.worldCOMx;
											qy4 = u1.y - s1.circle.worldCOMy;
											var A4 = vx4 * vx4 + vy4 * vy4;
											var B4 = 2 * (qx4 * vx4 + qy4 * vy4);
											var C4 = qx4 * qx4 + qy4 * qy4 - s1.circle.radius * s1.circle.radius;
											var D4 = B4 * B4 - 4 * A4 * C4;
											var two1;
											if(D4 * D4 < nape_Config.epsilon) {
												if(D4 < 0) {
													t01 = 10.0;
												} else {
													t12 = -B4 / (2 * A4);
													t01 = t12;
												}
												two1 = false;
											} else {
												D4 = Math.sqrt(D4);
												A4 = 1 / (2 * A4);
												t01 = (-B4 - D4) * A4;
												t12 = (-B4 + D4) * A4;
												two1 = true;
											}
											if(t01 < 1 - nape_Config.epsilon && t12 > nape_Config.epsilon) {
												var cx5 = 0.0;
												var cy5 = 0.0;
												var T5 = t01;
												cx5 = u1.x + (v2.x - u1.x) * T5;
												cy5 = u1.y + (v2.y - u1.y) * T5;
												var tmp3;
												if(fst_vert != null) {
													var dx5 = 0.0;
													var dy5 = 0.0;
													dx5 = fst_vert.x - cx5;
													dy5 = fst_vert.y - cy5;
													tmp3 = dx5 * dx5 + dy5 * dy5 < nape_Config.epsilon;
												} else {
													tmp3 = false;
												}
												if(tmp3) {
													state = 0;
													cx_ite = beg_ite;
													break;
												}
												var ret5;
												if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
													ret5 = new zpp_$nape_geom_ZPP_$Vec2();
												} else {
													ret5 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
													zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret5.next;
													ret5.next = null;
												}
												ret5.weak = false;
												ret5._immutable = false;
												ret5.x = cx5;
												ret5.y = cy5;
												var cp3 = ret5;
												if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head != null) {
													zpp_$nape_geom_ZPP_$Collide.flowsegs.add(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt);
													zpp_$nape_geom_ZPP_$Collide.flowsegs.add(cp3);
												}
												zpp_$nape_geom_ZPP_$Collide.flowpoly.add(cp3);
												if(fst_vert == null) {
													fst_vert = zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt;
												}
												if(two1) {
													var cx6 = 0.0;
													var cy6 = 0.0;
													var T6 = t12;
													cx6 = u1.x + (v2.x - u1.x) * T6;
													cy6 = u1.y + (v2.y - u1.y) * T6;
													var tmp4 = zpp_$nape_geom_ZPP_$Collide.flowpoly;
													var ret6;
													if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
														ret6 = new zpp_$nape_geom_ZPP_$Vec2();
													} else {
														ret6 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
														zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret6.next;
														ret6.next = null;
													}
													ret6.weak = false;
													ret6._immutable = false;
													ret6.x = cx6;
													ret6.y = cy6;
													tmp4.add(ret6);
												}
											}
										}
									}
									u1 = v2;
									vi = cx_ite;
									vind = vind21;
									cx_ite = cx_ite.next;
									if(cx_ite == null) {
										cx_ite = s2.polygon.gverts.next;
									}
								}
							}
							if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head == null) {
								return false;
							} else if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.next == null) {
								var all = true;
								var cx_ite = s2.polygon.edges.head;
								while(cx_ite != null) {
									var e = cx_ite.elt;
									var dist = e.gnormx * s1.circle.worldCOMx + e.gnormy * s1.circle.worldCOMy;
									if(dist > e.gprojection) {
										all = false;
										break;
									}
									cx_ite = cx_ite.next;
								}
								if(all) {
									arb.overlap = s1.circle.area;
									arb.centroidx = s1.circle.worldCOMx;
									arb.centroidy = s1.circle.worldCOMy;
									return true;
								} else {
									return false;
								}
							} else {
								var COMx = 0;
								var COMy = 0;
								var area = 0.0;
								if(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.next.next != null) {
									var parea = 0.0;
									var pCOMx = 0.0;
									var pCOMy = 0.0;
									pCOMx = 0;
									pCOMy = 0;
									parea = 0.0;
									var cx_ite = zpp_$nape_geom_ZPP_$Collide.flowpoly.head;
									var u = cx_ite.elt;
									cx_ite = cx_ite.next;
									var v = cx_ite.elt;
									cx_ite = cx_ite.next;
									while(cx_ite != null) {
										var w = cx_ite.elt;
										parea += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										pCOMx += (v.x + w.x) * cf;
										pCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
									}
									cx_ite = zpp_$nape_geom_ZPP_$Collide.flowpoly.head;
									var w = cx_ite.elt;
									parea += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									pCOMx += (v.x + w.x) * cf;
									pCOMy += (v.y + w.y) * cf;
									u = v;
									v = w;
									cx_ite = cx_ite.next;
									var w = cx_ite.elt;
									parea += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									pCOMx += (v.x + w.x) * cf;
									pCOMy += (v.y + w.y) * cf;
									parea *= 0.5;
									var ia = 1 / (6 * parea);
									var t = ia;
									pCOMx *= t;
									pCOMy *= t;
									var t = -parea;
									COMx += pCOMx * t;
									COMy += pCOMy * t;
									area -= parea;
								} else {
									zpp_$nape_geom_ZPP_$Collide.flowsegs.add(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.elt);
									zpp_$nape_geom_ZPP_$Collide.flowsegs.add(zpp_$nape_geom_ZPP_$Collide.flowpoly.head.next.elt);
								}
								while(zpp_$nape_geom_ZPP_$Collide.flowsegs.head != null) {
									var u = zpp_$nape_geom_ZPP_$Collide.flowsegs.pop_unsafe();
									var v = zpp_$nape_geom_ZPP_$Collide.flowsegs.pop_unsafe();
									var dx = 0.0;
									var dy = 0.0;
									dx = v.x - u.x;
									dy = v.y - u.y;
									var nx = 0.0;
									var ny = 0.0;
									nx = dx;
									ny = dy;
									var d = nx * nx + ny * ny;
									zpp_$nape_util_ZPP_$Math.fbuf[0] = d;
									zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
									var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
									var imag = x2 * (1.5 - 0.5 * d * x2 * x2);
									var t = imag;
									nx *= t;
									ny *= t;
									var t1 = nx;
									nx = -ny;
									ny = t1;
									var cx = 0.0;
									var cy = 0.0;
									cx = u.x + v.x;
									cy = u.y + v.y;
									var t2 = 0.5;
									cx *= t2;
									cy *= t2;
									var t3 = 1.0;
									cx -= s1.circle.worldCOMx * t3;
									cy -= s1.circle.worldCOMy * t3;
									var xd = nx * cx + ny * cy;
									var carea = 0.0;
									var ccom = 0.0;
									var X = xd;
									var cos = X / s1.circle.radius;
									var sin = Math.sqrt(1 - cos * cos);
									var theta = Math.acos(cos);
									carea = s1.circle.radius * (s1.circle.radius * theta - X * sin);
									ccom = 0.66666666666666663 * s1.circle.radius * sin * sin * sin / (theta - cos * sin);
									cx = s1.circle.worldCOMx;
									cy = s1.circle.worldCOMy;
									var t4 = ccom;
									cx += nx * t4;
									cy += ny * t4;
									var t5 = carea;
									COMx += cx * t5;
									COMy += cy * t5;
									area += carea;
								}
								var t = 1.0 / area;
								COMx *= t;
								COMy *= t;
								arb.overlap = area;
								arb.centroidx = COMx;
								arb.centroidy = COMy;
								return true;
							}
						}
					} else {
						return false;
					}
				}
			} else {
				return false;
			}
		}
	} else {
		var c1 = s1.circle;
		var c2 = s2.circle;
		var deltax = 0.0;
		var deltay = 0.0;
		deltax = c2.worldCOMx - c1.worldCOMx;
		deltay = c2.worldCOMy - c1.worldCOMy;
		var cr = c1.radius + c2.radius;
		var ds = deltax * deltax + deltay * deltay;
		if(ds > cr * cr) {
			return false;
		} else if(ds < nape_Config.epsilon * nape_Config.epsilon) {
			if(c1.radius < c2.radius) {
				arb.overlap = c1.area;
				arb.centroidx = c1.worldCOMx;
				arb.centroidy = c1.worldCOMy;
			} else {
				arb.overlap = c2.area;
				arb.centroidx = c2.worldCOMx;
				arb.centroidy = c2.worldCOMy;
			}
			return true;
		} else {
			var d = Math.sqrt(ds);
			var id = 1 / d;
			var x1 = 0.5 * (d - (c2.radius * c2.radius - c1.radius * c1.radius) * id);
			if(x1 <= -c1.radius) {
				arb.overlap = c1.area;
				arb.centroidx = c1.worldCOMx;
				arb.centroidy = c1.worldCOMy;
			} else {
				var x2 = d - x1;
				if(x2 <= -c2.radius) {
					arb.overlap = c2.area;
					arb.centroidx = c2.worldCOMx;
					arb.centroidy = c2.worldCOMy;
				} else {
					var area1 = 0.0;
					var y1 = 0.0;
					var area2 = 0.0;
					var y2 = 0.0;
					var X = x1;
					var cos = X / c1.radius;
					var sin = Math.sqrt(1 - cos * cos);
					var theta = Math.acos(cos);
					area1 = c1.radius * (c1.radius * theta - X * sin);
					y1 = 0.66666666666666663 * c1.radius * sin * sin * sin / (theta - cos * sin);
					var X = x2;
					var cos = X / c2.radius;
					var sin = Math.sqrt(1 - cos * cos);
					var theta = Math.acos(cos);
					area2 = c2.radius * (c2.radius * theta - X * sin);
					y2 = 0.66666666666666663 * c2.radius * sin * sin * sin / (theta - cos * sin);
					var tarea = area1 + area2;
					var ya = (y1 * area1 + (d - y2) * area2) / tarea * id;
					arb.overlap = tarea;
					arb.centroidx = c1.worldCOMx + deltax * ya;
					arb.centroidy = c1.worldCOMy + deltay * ya;
				}
			}
			return true;
		}
	}
};
var zpp_$nape_geom_ZPP_$Convex = function() { };
zpp_$nape_geom_ZPP_$Convex.__name__ = true;
zpp_$nape_geom_ZPP_$Convex.isinner = function(a,b,c) {
	var ux = 0.0;
	var uy = 0.0;
	ux = a.x - b.x;
	uy = a.y - b.y;
	var vx = 0.0;
	var vy = 0.0;
	vx = c.x - b.x;
	vy = c.y - b.y;
	return vy * ux - vx * uy >= 0;
};
zpp_$nape_geom_ZPP_$Convex.optimise = function(P) {
	var F = P.vertices;
	var L = P.vertices;
	if(F != null) {
		var nite = F;
		do {
			var p = nite;
			p.sort();
			nite = nite.next;
		} while(nite != L);
	}
	var F = P.vertices;
	var L = P.vertices;
	if(F != null) {
		var nite = F;
		while(true) {
			var p = nite;
			var pright = p.prev;
			var ppre = null;
			var cx_ite = p.diagonals.head;
			while(cx_ite != null) {
				var pdiag = cx_ite.elt;
				var pleft = cx_ite.next == null ? p.next : cx_ite.next.elt;
				if(!zpp_$nape_geom_ZPP_$Convex.isinner(pleft,p,pright)) {
					ppre = cx_ite;
					pright = pdiag;
					cx_ite = cx_ite.next;
					continue;
				}
				var removable = true;
				var q = pdiag;
				var qright = q.prev;
				var qpre = null;
				var cx_ite1 = q.diagonals.head;
				while(cx_ite1 != null) {
					var qdiag = cx_ite1.elt;
					if(qdiag == p) {
						var qleft = cx_ite1.next == null ? q.next : cx_ite1.next.elt;
						removable = zpp_$nape_geom_ZPP_$Convex.isinner(qleft,q,qright);
						break;
					}
					qright = qdiag;
					qpre = cx_ite1;
					cx_ite1 = cx_ite1.next;
				}
				if(removable) {
					cx_ite = p.diagonals.erase(ppre);
					q.diagonals.erase(qpre);
					continue;
				}
				pright = pdiag;
				ppre = cx_ite;
				cx_ite = cx_ite.next;
			}
			nite = nite.next;
			if(!(nite != L)) {
				break;
			}
		}
	}
};
var zpp_$nape_geom_ZPP_$ConvexRayResult = function() {
	this.toiDistance = 0.0;
	this.next = null;
	this.inner = false;
	this.ray = null;
	this.position = null;
	this.convex = null;
	this.shape = null;
	this.normal = null;
};
zpp_$nape_geom_ZPP_$ConvexRayResult.__name__ = true;
zpp_$nape_geom_ZPP_$ConvexRayResult.getRay = function(normal,time,inner,shape) {
	var ret;
	if(zpp_$nape_geom_ZPP_$ConvexRayResult.rayPool == null) {
		zpp_$nape_geom_ZPP_$ConvexRayResult.internal = true;
		ret = new nape_geom_RayResult();
		ret.zpp_inner = new zpp_$nape_geom_ZPP_$ConvexRayResult();
		ret.zpp_inner.ray = ret;
		zpp_$nape_geom_ZPP_$ConvexRayResult.internal = false;
	} else {
		ret = zpp_$nape_geom_ZPP_$ConvexRayResult.rayPool.ray;
		zpp_$nape_geom_ZPP_$ConvexRayResult.rayPool = zpp_$nape_geom_ZPP_$ConvexRayResult.rayPool.next;
		ret.zpp_inner.next = null;
	}
	var zinner = ret.zpp_inner;
	zinner.normal = normal;
	normal.zpp_inner._immutable = true;
	zinner.toiDistance = time;
	zinner.inner = inner;
	zinner.shape = shape;
	return ret;
};
zpp_$nape_geom_ZPP_$ConvexRayResult.getConvex = function(normal,position,toiDistance,shape) {
	var ret;
	if(zpp_$nape_geom_ZPP_$ConvexRayResult.convexPool == null) {
		zpp_$nape_geom_ZPP_$ConvexRayResult.internal = true;
		ret = new nape_geom_ConvexResult();
		ret.zpp_inner = new zpp_$nape_geom_ZPP_$ConvexRayResult();
		ret.zpp_inner.convex = ret;
		zpp_$nape_geom_ZPP_$ConvexRayResult.internal = false;
	} else {
		ret = zpp_$nape_geom_ZPP_$ConvexRayResult.convexPool.convex;
		zpp_$nape_geom_ZPP_$ConvexRayResult.convexPool = zpp_$nape_geom_ZPP_$ConvexRayResult.convexPool.next;
		ret.zpp_inner.next = null;
	}
	var inner = ret.zpp_inner;
	inner.normal = normal;
	inner.position = position;
	normal.zpp_inner._immutable = true;
	position.zpp_inner._immutable = true;
	inner.toiDistance = toiDistance;
	inner.shape = shape;
	return ret;
};
zpp_$nape_geom_ZPP_$ConvexRayResult.prototype = {
	free: function() {
		this.normal.zpp_inner._immutable = false;
		var _this = this.normal;
		var inner = _this.zpp_inner;
		_this.zpp_inner.outer = null;
		_this.zpp_inner = null;
		var o = _this;
		o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
		var o = inner;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		if(this.position != null) {
			this.position.zpp_inner._immutable = false;
			var _this = this.position;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o = _this;
			o.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o;
			var o = inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		}
		this.shape = null;
		this.toiDistance = 0.0;
		if(this.convex != null) {
			this.next = zpp_$nape_geom_ZPP_$ConvexRayResult.convexPool;
			zpp_$nape_geom_ZPP_$ConvexRayResult.convexPool = this;
		} else {
			this.next = zpp_$nape_geom_ZPP_$ConvexRayResult.rayPool;
			zpp_$nape_geom_ZPP_$ConvexRayResult.rayPool = this;
		}
	}
};
var zpp_$nape_geom_ZPP_$CutVert = function() {
	this.used = false;
	this.rank = 0;
	this.parent = null;
	this.positive = false;
	this.value = 0.0;
	this.vert = null;
	this.posy = 0.0;
	this.posx = 0.0;
	this.next = null;
	this.prev = null;
};
zpp_$nape_geom_ZPP_$CutVert.__name__ = true;
var zpp_$nape_geom_ZPP_$CutInt = function() {
	this.path1 = null;
	this.start = null;
	this.end = null;
	this.path0 = null;
	this.vertex = false;
	this.virtualint = false;
	this.time = 0.0;
	this.next = null;
};
zpp_$nape_geom_ZPP_$CutInt.__name__ = true;
var zpp_$nape_geom_ZPP_$Cutter = function() { };
zpp_$nape_geom_ZPP_$Cutter.__name__ = true;
zpp_$nape_geom_ZPP_$Cutter.run = function(P,_start,_end,bstart,bend,output) {
	var px = 0.0;
	var py = 0.0;
	var _this = _start.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	px = _start.zpp_inner.x;
	var _this = _start.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	py = _start.zpp_inner.y;
	var dx = 0.0;
	var dy = 0.0;
	var _this = _end.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	dx = _end.zpp_inner.x - px;
	var _this = _end.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	dy = _end.zpp_inner.y - py;
	var min = bstart ? 0 : -Infinity;
	var max = bend ? 1 : Infinity;
	var crx = -(py * dx - px * dy);
	var verts = null;
	var clashes = false;
	var p = P;
	do {
		var c;
		if(zpp_$nape_geom_ZPP_$CutVert.zpp_pool == null) {
			c = new zpp_$nape_geom_ZPP_$CutVert();
		} else {
			c = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
			zpp_$nape_geom_ZPP_$CutVert.zpp_pool = c.next;
			c.next = null;
		}
		c.vert = p;
		c.posx = c.vert.x;
		c.posy = c.vert.y;
		c.value = c.posy * dx - c.posx * dy + crx;
		c.positive = c.value > 0;
		if(c.value == 0) {
			clashes = true;
		}
		var obj = c;
		if(verts == null) {
			verts = obj.prev = obj.next = obj;
		} else {
			obj.prev = verts;
			obj.next = verts.next;
			verts.next.prev = obj;
			verts.next = obj;
		}
		verts = obj;
		p = p.next;
	} while(p != P);
	if(clashes) {
		var start = null;
		var F = verts;
		var L = verts;
		if(F != null) {
			var nite = F;
			do {
				var p = nite;
				if(p.value != 0.0) {
					start = p;
					break;
				}
				nite = nite.next;
			} while(nite != L);
		}
		var nx = 0.0;
		var ny = 0.0;
		nx = dx;
		ny = dy;
		var d = nx * nx + ny * ny;
		zpp_$nape_util_ZPP_$Math.fbuf[0] = d;
		zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
		var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
		var imag = x2 * (1.5 - 0.5 * d * x2 * x2);
		var t = imag;
		nx *= t;
		ny *= t;
		var t = nx;
		nx = -ny;
		ny = t;
		var pre = null;
		var p = start;
		while(true) {
			if(p.value != 0.0 && (pre == null || p == pre.next)) {
				pre = p;
				p = p.next;
				if(!(p != start)) {
					break;
				} else {
					continue;
				}
			}
			var prod = pre.value * p.value;
			if(prod == 0) {
				p = p.next;
				if(!(p != start)) {
					break;
				} else {
					continue;
				}
			}
			var a = pre.next;
			var positive;
			if(prod > 0) {
				positive = pre.positive;
			} else {
				var b = a.next;
				var midx = 0.0;
				var midy = 0.0;
				midx = a.posx + b.posx;
				midy = a.posy + b.posy;
				var t = 0.5;
				midx *= t;
				midy *= t;
				var x = midx + nx * 1e-8;
				var y = midy + ny * 1e-8;
				var ret = false;
				var F = P;
				var L = P;
				if(F != null) {
					var nite = F;
					do {
						var p1 = nite;
						var q = p1.prev;
						if((p1.y < y && q.y >= y || q.y < y && p1.y >= y) && (p1.x <= x || q.x <= x)) {
							if(p1.x + (y - p1.y) / (q.y - p1.y) * (q.x - p1.x) < x) {
								ret = !ret;
							}
						}
						nite = nite.next;
					} while(nite != L);
				}
				positive = ret;
			}
			var F1 = a;
			var L1 = p;
			if(F1 != null) {
				var nite1 = F1;
				do {
					var q1 = nite1;
					q1.positive = positive;
					nite1 = nite1.next;
				} while(nite1 != L1);
			}
			pre = p;
			p = p.next;
			if(!(p != start)) {
				break;
			}
		}
		while(true) {
			if(p.value != 0.0 && (pre == null || p == pre.next)) {
				pre = p;
				p = p.next;
				if(!false) {
					break;
				} else {
					continue;
				}
			}
			var prod = pre.value * p.value;
			if(prod == 0) {
				p = p.next;
				if(!false) {
					break;
				} else {
					continue;
				}
			}
			var a = pre.next;
			var positive;
			if(prod > 0) {
				positive = pre.positive;
			} else {
				var b = a.next;
				var midx = 0.0;
				var midy = 0.0;
				midx = a.posx + b.posx;
				midy = a.posy + b.posy;
				var t = 0.5;
				midx *= t;
				midy *= t;
				var x = midx + nx * 1e-8;
				var y = midy + ny * 1e-8;
				var ret = false;
				var F = P;
				var L = P;
				if(F != null) {
					var nite = F;
					do {
						var p1 = nite;
						var q = p1.prev;
						if((p1.y < y && q.y >= y || q.y < y && p1.y >= y) && (p1.x <= x || q.x <= x)) {
							if(p1.x + (y - p1.y) / (q.y - p1.y) * (q.x - p1.x) < x) {
								ret = !ret;
							}
						}
						nite = nite.next;
					} while(nite != L);
				}
				positive = ret;
			}
			var F1 = a;
			var L1 = p;
			if(F1 != null) {
				var nite1 = F1;
				do {
					var q1 = nite1;
					q1.positive = positive;
					nite1 = nite1.next;
				} while(nite1 != L1);
			}
			pre = p;
			p = p.next;
			if(!false) {
				break;
			}
		}
	}
	if(zpp_$nape_geom_ZPP_$Cutter.ints == null) {
		zpp_$nape_geom_ZPP_$Cutter.ints = new zpp_$nape_util_ZNPList_$ZPP_$CutInt();
	}
	if(zpp_$nape_geom_ZPP_$Cutter.paths == null) {
		zpp_$nape_geom_ZPP_$Cutter.paths = new zpp_$nape_util_ZNPList_$ZPP_$CutVert();
	}
	var start = null;
	var x = verts.posx;
	var y = verts.posy;
	var ret;
	if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$GeomVert();
	} else {
		ret = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.forced = false;
	ret.x = x;
	ret.y = y;
	var obj = ret;
	if(start == null) {
		start = obj.prev = obj.next = obj;
	} else {
		obj.next = start;
		obj.prev = start.prev;
		start.prev.next = obj;
		start.prev = obj;
	}
	var origin = start;
	var ret;
	if(zpp_$nape_geom_ZPP_$CutVert.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$CutVert();
	} else {
		ret = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
		zpp_$nape_geom_ZPP_$CutVert.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.vert = start;
	ret.parent = ret;
	ret.rank = 0;
	ret.used = false;
	var firstpath = ret;
	zpp_$nape_geom_ZPP_$Cutter.paths.add(firstpath);
	var i = verts;
	do {
		var j = i.next;
		var x = j.posx;
		var y = j.posy;
		var ret;
		if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$GeomVert();
		} else {
			ret = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.forced = false;
		ret.x = x;
		ret.y = y;
		var pj = ret;
		if(i.positive == j.positive) {
			var obj = pj;
			if(start == null) {
				start = obj.prev = obj.next = obj;
			} else {
				obj.next = start;
				obj.prev = start.prev;
				start.prev.next = obj;
				start.prev = obj;
			}
		} else {
			var ux = 0.0;
			var uy = 0.0;
			ux = j.posx - i.posx;
			uy = j.posy - i.posy;
			var denom = dy * ux - dx * uy;
			denom = 1 / denom;
			var pax = 0.0;
			var pay = 0.0;
			pax = px - i.posx;
			pay = py - i.posy;
			var s = (uy * pax - ux * pay) * denom;
			if(s < min || s > max) {
				var tmp = zpp_$nape_geom_ZPP_$Cutter.ints;
				var virtualint = true;
				if(virtualint == null) {
					virtualint = false;
				}
				var ret1;
				if(zpp_$nape_geom_ZPP_$CutInt.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$CutInt();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$CutInt.zpp_pool;
					zpp_$nape_geom_ZPP_$CutInt.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.virtualint = virtualint;
				ret1.end = null;
				ret1.start = null;
				ret1.path0 = null;
				ret1.path1 = null;
				ret1.time = s;
				ret1.vertex = false;
				tmp.add(ret1);
				var obj1 = pj;
				if(start == null) {
					start = obj1.prev = obj1.next = obj1;
				} else {
					obj1.next = start;
					obj1.prev = start.prev;
					start.prev.next = obj1;
					start.prev = obj1;
				}
			} else if(i.value == 0) {
				var endof = start.prev;
				start = null;
				var x1 = endof.x;
				var y1 = endof.y;
				var ret2;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.forced = false;
				ret2.x = x1;
				ret2.y = y1;
				var obj2 = ret2;
				if(start == null) {
					start = obj2.prev = obj2.next = obj2;
				} else {
					obj2.next = start;
					obj2.prev = start.prev;
					start.prev.next = obj2;
					start.prev = obj2;
				}
				var obj3 = pj;
				if(start == null) {
					start = obj3.prev = obj3.next = obj3;
				} else {
					obj3.next = start;
					obj3.prev = start.prev;
					start.prev.next = obj3;
					start.prev = obj3;
				}
				var prepath = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
				var tmp1 = zpp_$nape_geom_ZPP_$Cutter.paths;
				var ret3;
				if(zpp_$nape_geom_ZPP_$CutVert.zpp_pool == null) {
					ret3 = new zpp_$nape_geom_ZPP_$CutVert();
				} else {
					ret3 = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
					zpp_$nape_geom_ZPP_$CutVert.zpp_pool = ret3.next;
					ret3.next = null;
				}
				ret3.vert = start;
				ret3.parent = ret3;
				ret3.rank = 0;
				ret3.used = false;
				tmp1.add(ret3);
				var postpath = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
				var tmp2 = zpp_$nape_geom_ZPP_$Cutter.ints;
				var virtualint1 = true;
				if(virtualint1 == null) {
					virtualint1 = false;
				}
				var ret4;
				if(zpp_$nape_geom_ZPP_$CutInt.zpp_pool == null) {
					ret4 = new zpp_$nape_geom_ZPP_$CutInt();
				} else {
					ret4 = zpp_$nape_geom_ZPP_$CutInt.zpp_pool;
					zpp_$nape_geom_ZPP_$CutInt.zpp_pool = ret4.next;
					ret4.next = null;
				}
				ret4.virtualint = virtualint1;
				ret4.end = endof;
				ret4.start = start;
				ret4.path0 = prepath;
				ret4.path1 = postpath;
				ret4.time = s;
				ret4.vertex = false;
				tmp2.add(ret4);
			} else if(j.value == 0) {
				var obj4 = pj;
				if(start == null) {
					start = obj4.prev = obj4.next = obj4;
				} else {
					obj4.next = start;
					obj4.prev = start.prev;
					start.prev.next = obj4;
					start.prev = obj4;
				}
				var endof1 = start.prev;
				start = null;
				var x2 = j.posx;
				var y2 = j.posy;
				var ret5;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
					ret5.next = null;
				}
				ret5.forced = false;
				ret5.x = x2;
				ret5.y = y2;
				var obj5 = ret5;
				if(start == null) {
					start = obj5.prev = obj5.next = obj5;
				} else {
					obj5.next = start;
					obj5.prev = start.prev;
					start.prev.next = obj5;
					start.prev = obj5;
				}
				var prepath1 = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
				var tmp3 = zpp_$nape_geom_ZPP_$Cutter.paths;
				var ret6;
				if(zpp_$nape_geom_ZPP_$CutVert.zpp_pool == null) {
					ret6 = new zpp_$nape_geom_ZPP_$CutVert();
				} else {
					ret6 = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
					zpp_$nape_geom_ZPP_$CutVert.zpp_pool = ret6.next;
					ret6.next = null;
				}
				ret6.vert = start;
				ret6.parent = ret6;
				ret6.rank = 0;
				ret6.used = false;
				tmp3.add(ret6);
				var postpath1 = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
				var tmp4 = zpp_$nape_geom_ZPP_$Cutter.ints;
				var virtualint2 = true;
				if(virtualint2 == null) {
					virtualint2 = false;
				}
				var ret7;
				if(zpp_$nape_geom_ZPP_$CutInt.zpp_pool == null) {
					ret7 = new zpp_$nape_geom_ZPP_$CutInt();
				} else {
					ret7 = zpp_$nape_geom_ZPP_$CutInt.zpp_pool;
					zpp_$nape_geom_ZPP_$CutInt.zpp_pool = ret7.next;
					ret7.next = null;
				}
				ret7.virtualint = virtualint2;
				ret7.end = endof1;
				ret7.start = start;
				ret7.path0 = prepath1;
				ret7.path1 = postpath1;
				ret7.time = s;
				ret7.vertex = false;
				tmp4.add(ret7);
			} else {
				var t = (dy * pax - dx * pay) * denom;
				var qx = 0.0;
				var qy = 0.0;
				qx = i.posx;
				qy = i.posy;
				var t1 = t;
				qx += ux * t1;
				qy += uy * t1;
				var ret8;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
					ret8.next = null;
				}
				ret8.forced = false;
				ret8.x = qx;
				ret8.y = qy;
				var obj6 = ret8;
				if(start == null) {
					start = obj6.prev = obj6.next = obj6;
				} else {
					obj6.next = start;
					obj6.prev = start.prev;
					start.prev.next = obj6;
					start.prev = obj6;
				}
				var endof2 = start.prev;
				start = null;
				var ret9;
				if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
					ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
				} else {
					ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
					zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
					ret9.next = null;
				}
				ret9.forced = false;
				ret9.x = qx;
				ret9.y = qy;
				var obj7 = ret9;
				if(start == null) {
					start = obj7.prev = obj7.next = obj7;
				} else {
					obj7.next = start;
					obj7.prev = start.prev;
					start.prev.next = obj7;
					start.prev = obj7;
				}
				var obj8 = pj;
				if(start == null) {
					start = obj8.prev = obj8.next = obj8;
				} else {
					obj8.next = start;
					obj8.prev = start.prev;
					start.prev.next = obj8;
					start.prev = obj8;
				}
				var prepath2 = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
				var tmp5 = zpp_$nape_geom_ZPP_$Cutter.paths;
				var ret10;
				if(zpp_$nape_geom_ZPP_$CutVert.zpp_pool == null) {
					ret10 = new zpp_$nape_geom_ZPP_$CutVert();
				} else {
					ret10 = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
					zpp_$nape_geom_ZPP_$CutVert.zpp_pool = ret10.next;
					ret10.next = null;
				}
				ret10.vert = start;
				ret10.parent = ret10;
				ret10.rank = 0;
				ret10.used = false;
				tmp5.add(ret10);
				var postpath2 = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
				var tmp6 = zpp_$nape_geom_ZPP_$Cutter.ints;
				var virtualint3 = false;
				if(virtualint3 == null) {
					virtualint3 = false;
				}
				var ret11;
				if(zpp_$nape_geom_ZPP_$CutInt.zpp_pool == null) {
					ret11 = new zpp_$nape_geom_ZPP_$CutInt();
				} else {
					ret11 = zpp_$nape_geom_ZPP_$CutInt.zpp_pool;
					zpp_$nape_geom_ZPP_$CutInt.zpp_pool = ret11.next;
					ret11.next = null;
				}
				ret11.virtualint = virtualint3;
				ret11.end = endof2;
				ret11.start = start;
				ret11.path0 = prepath2;
				ret11.path1 = postpath2;
				ret11.time = s;
				ret11.vertex = false;
				tmp6.add(ret11);
			}
		}
		i = i.next;
	} while(i != verts);
	var endof = start.prev;
	endof.next.prev = origin.prev;
	origin.prev.next = endof.next;
	endof.next = origin;
	origin.prev = endof;
	var lastpath = zpp_$nape_geom_ZPP_$Cutter.paths.head.elt;
	var xr;
	if(firstpath == firstpath.parent) {
		xr = firstpath;
	} else {
		var obj = firstpath;
		var stack = null;
		while(obj != obj.parent) {
			var nxt = obj.parent;
			obj.parent = stack;
			stack = obj;
			obj = nxt;
		}
		while(stack != null) {
			var nxt = stack.parent;
			stack.parent = obj;
			stack = nxt;
		}
		xr = obj;
	}
	var yr;
	if(lastpath == lastpath.parent) {
		yr = lastpath;
	} else {
		var obj = lastpath;
		var stack = null;
		while(obj != obj.parent) {
			var nxt = obj.parent;
			obj.parent = stack;
			stack = obj;
			obj = nxt;
		}
		while(stack != null) {
			var nxt = stack.parent;
			stack.parent = obj;
			stack = nxt;
		}
		yr = obj;
	}
	if(xr != yr) {
		if(xr.rank < yr.rank) {
			xr.parent = yr;
		} else if(xr.rank > yr.rank) {
			yr.parent = xr;
		} else {
			yr.parent = xr;
			xr.rank++;
		}
	}
	var xxlist = zpp_$nape_geom_ZPP_$Cutter.ints;
	if(xxlist.head != null && xxlist.head.next != null) {
		var head = xxlist.head;
		var tail = null;
		var left = null;
		var right = null;
		var nxt = null;
		var listSize = 1;
		var numMerges;
		var leftSize;
		var rightSize;
		do {
			numMerges = 0;
			left = head;
			head = null;
			tail = head;
			while(left != null) {
				++numMerges;
				right = left;
				leftSize = 0;
				rightSize = listSize;
				while(right != null && leftSize < listSize) {
					++leftSize;
					right = right.next;
				}
				while(leftSize > 0 || rightSize > 0 && right != null) {
					if(leftSize == 0) {
						nxt = right;
						right = right.next;
						--rightSize;
					} else if(rightSize == 0 || right == null) {
						nxt = left;
						left = left.next;
						--leftSize;
					} else if(left.elt.time < right.elt.time) {
						nxt = left;
						left = left.next;
						--leftSize;
					} else {
						nxt = right;
						right = right.next;
						--rightSize;
					}
					if(tail != null) {
						tail.next = nxt;
					} else {
						head = nxt;
					}
					tail = nxt;
				}
				left = right;
			}
			tail.next = null;
			listSize <<= 1;
		} while(numMerges > 1);
		xxlist.head = head;
		xxlist.modified = true;
		xxlist.pushmod = true;
	}
	while(zpp_$nape_geom_ZPP_$Cutter.ints.head != null) {
		var i = zpp_$nape_geom_ZPP_$Cutter.ints.pop_unsafe();
		var j = zpp_$nape_geom_ZPP_$Cutter.ints.pop_unsafe();
		if(!i.virtualint && !j.virtualint) {
			i.end.next.prev = j.start.prev;
			j.start.prev.next = i.end.next;
			i.end.next = j.start;
			j.start.prev = i.end;
			j.end.next.prev = i.start.prev;
			i.start.prev.next = j.end.next;
			j.end.next = i.start;
			i.start.prev = j.end;
			var xr;
			if(i.path0 == i.path0.parent) {
				xr = i.path0;
			} else {
				var obj = i.path0;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt1 = stack.parent;
					stack.parent = obj;
					stack = nxt1;
				}
				xr = obj;
			}
			var yr;
			if(j.path1 == j.path1.parent) {
				yr = j.path1;
			} else {
				var obj1 = j.path1;
				var stack1 = null;
				while(obj1 != obj1.parent) {
					var nxt2 = obj1.parent;
					obj1.parent = stack1;
					stack1 = obj1;
					obj1 = nxt2;
				}
				while(stack1 != null) {
					var nxt3 = stack1.parent;
					stack1.parent = obj1;
					stack1 = nxt3;
				}
				yr = obj1;
			}
			if(xr != yr) {
				if(xr.rank < yr.rank) {
					xr.parent = yr;
				} else if(xr.rank > yr.rank) {
					yr.parent = xr;
				} else {
					yr.parent = xr;
					xr.rank++;
				}
			}
			var xr1;
			if(i.path1 == i.path1.parent) {
				xr1 = i.path1;
			} else {
				var obj2 = i.path1;
				var stack2 = null;
				while(obj2 != obj2.parent) {
					var nxt4 = obj2.parent;
					obj2.parent = stack2;
					stack2 = obj2;
					obj2 = nxt4;
				}
				while(stack2 != null) {
					var nxt5 = stack2.parent;
					stack2.parent = obj2;
					stack2 = nxt5;
				}
				xr1 = obj2;
			}
			var yr1;
			if(j.path0 == j.path0.parent) {
				yr1 = j.path0;
			} else {
				var obj3 = j.path0;
				var stack3 = null;
				while(obj3 != obj3.parent) {
					var nxt6 = obj3.parent;
					obj3.parent = stack3;
					stack3 = obj3;
					obj3 = nxt6;
				}
				while(stack3 != null) {
					var nxt7 = stack3.parent;
					stack3.parent = obj3;
					stack3 = nxt7;
				}
				yr1 = obj3;
			}
			if(xr1 != yr1) {
				if(xr1.rank < yr1.rank) {
					xr1.parent = yr1;
				} else if(xr1.rank > yr1.rank) {
					yr1.parent = xr1;
				} else {
					yr1.parent = xr1;
					xr1.rank++;
				}
			}
		} else if(i.virtualint && !j.virtualint) {
			var tmp;
			if(j.end != null && j.end.prev == j.end) {
				j.end.next = j.end.prev = null;
				var o = j.end;
				if(o.wrap != null) {
					o.wrap.zpp_inner._inuse = false;
					var _this = o.wrap;
					var inner = _this.zpp_inner;
					_this.zpp_inner.outer = null;
					_this.zpp_inner = null;
					var o1 = _this;
					o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
					var o2 = inner;
					if(o2.outer != null) {
						o2.outer.zpp_inner = null;
						o2.outer = null;
					}
					o2._isimmutable = null;
					o2._validate = null;
					o2._invalidate = null;
					o2.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o2;
					o.wrap = null;
				}
				o.prev = o.next = null;
				o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
				zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
				tmp = null;
			} else {
				var retnodes = j.end.prev;
				j.end.prev.next = j.end.next;
				j.end.next.prev = j.end.prev;
				j.end.next = j.end.prev = null;
				var o3 = j.end;
				if(o3.wrap != null) {
					o3.wrap.zpp_inner._inuse = false;
					var _this1 = o3.wrap;
					var inner1 = _this1.zpp_inner;
					_this1.zpp_inner.outer = null;
					_this1.zpp_inner = null;
					var o4 = _this1;
					o4.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o4;
					var o5 = inner1;
					if(o5.outer != null) {
						o5.outer.zpp_inner = null;
						o5.outer = null;
					}
					o5._isimmutable = null;
					o5._validate = null;
					o5._invalidate = null;
					o5.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o5;
					o3.wrap = null;
				}
				o3.prev = o3.next = null;
				o3.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
				zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o3;
				j.end = null;
				tmp = retnodes;
			}
			j.end = tmp;
			if(!j.vertex) {
				if(j.end != j.path0.vert) {
					j.start.x = j.end.x;
					j.start.y = j.end.y;
					var tmp1;
					if(j.end != null && j.end.prev == j.end) {
						j.end.next = j.end.prev = null;
						var o6 = j.end;
						if(o6.wrap != null) {
							o6.wrap.zpp_inner._inuse = false;
							var _this2 = o6.wrap;
							var inner2 = _this2.zpp_inner;
							_this2.zpp_inner.outer = null;
							_this2.zpp_inner = null;
							var o7 = _this2;
							o7.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o7;
							var o8 = inner2;
							if(o8.outer != null) {
								o8.outer.zpp_inner = null;
								o8.outer = null;
							}
							o8._isimmutable = null;
							o8._validate = null;
							o8._invalidate = null;
							o8.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o8;
							o6.wrap = null;
						}
						o6.prev = o6.next = null;
						o6.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o6;
						tmp1 = null;
					} else {
						var retnodes1 = j.end.prev;
						j.end.prev.next = j.end.next;
						j.end.next.prev = j.end.prev;
						j.end.next = j.end.prev = null;
						var o9 = j.end;
						if(o9.wrap != null) {
							o9.wrap.zpp_inner._inuse = false;
							var _this3 = o9.wrap;
							var inner3 = _this3.zpp_inner;
							_this3.zpp_inner.outer = null;
							_this3.zpp_inner = null;
							var o10 = _this3;
							o10.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o10;
							var o11 = inner3;
							if(o11.outer != null) {
								o11.outer.zpp_inner = null;
								o11.outer = null;
							}
							o11._isimmutable = null;
							o11._validate = null;
							o11._invalidate = null;
							o11.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o11;
							o9.wrap = null;
						}
						o9.prev = o9.next = null;
						o9.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o9;
						j.end = null;
						tmp1 = retnodes1;
					}
					j.end = tmp1;
				} else {
					var n = j.start.next;
					j.start.x = n.x;
					j.start.y = n.y;
					if(n != null && n.prev == n) {
						n.next = n.prev = null;
						var o12 = n;
						if(o12.wrap != null) {
							o12.wrap.zpp_inner._inuse = false;
							var _this4 = o12.wrap;
							var inner4 = _this4.zpp_inner;
							_this4.zpp_inner.outer = null;
							_this4.zpp_inner = null;
							var o13 = _this4;
							o13.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o13;
							var o14 = inner4;
							if(o14.outer != null) {
								o14.outer.zpp_inner = null;
								o14.outer = null;
							}
							o14._isimmutable = null;
							o14._validate = null;
							o14._invalidate = null;
							o14.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o14;
							o12.wrap = null;
						}
						o12.prev = o12.next = null;
						o12.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o12;
						n = null;
					} else {
						n.prev.next = n.next;
						n.next.prev = n.prev;
						n.next = n.prev = null;
						var o15 = n;
						if(o15.wrap != null) {
							o15.wrap.zpp_inner._inuse = false;
							var _this5 = o15.wrap;
							var inner5 = _this5.zpp_inner;
							_this5.zpp_inner.outer = null;
							_this5.zpp_inner = null;
							var o16 = _this5;
							o16.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o16;
							var o17 = inner5;
							if(o17.outer != null) {
								o17.outer.zpp_inner = null;
								o17.outer = null;
							}
							o17._isimmutable = null;
							o17._validate = null;
							o17._invalidate = null;
							o17.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o17;
							o15.wrap = null;
						}
						o15.prev = o15.next = null;
						o15.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o15;
					}
				}
			}
			j.end.next.prev = j.start.prev;
			j.start.prev.next = j.end.next;
			j.end.next = j.start;
			j.start.prev = j.end;
			var xr2;
			if(j.path0 == j.path0.parent) {
				xr2 = j.path0;
			} else {
				var obj4 = j.path0;
				var stack4 = null;
				while(obj4 != obj4.parent) {
					var nxt8 = obj4.parent;
					obj4.parent = stack4;
					stack4 = obj4;
					obj4 = nxt8;
				}
				while(stack4 != null) {
					var nxt9 = stack4.parent;
					stack4.parent = obj4;
					stack4 = nxt9;
				}
				xr2 = obj4;
			}
			var yr2;
			if(j.path1 == j.path1.parent) {
				yr2 = j.path1;
			} else {
				var obj5 = j.path1;
				var stack5 = null;
				while(obj5 != obj5.parent) {
					var nxt10 = obj5.parent;
					obj5.parent = stack5;
					stack5 = obj5;
					obj5 = nxt10;
				}
				while(stack5 != null) {
					var nxt11 = stack5.parent;
					stack5.parent = obj5;
					stack5 = nxt11;
				}
				yr2 = obj5;
			}
			if(xr2 != yr2) {
				if(xr2.rank < yr2.rank) {
					xr2.parent = yr2;
				} else if(xr2.rank > yr2.rank) {
					yr2.parent = xr2;
				} else {
					yr2.parent = xr2;
					xr2.rank++;
				}
			}
		} else if(j.virtualint && !i.virtualint) {
			var tmp2;
			if(i.end != null && i.end.prev == i.end) {
				i.end.next = i.end.prev = null;
				var o18 = i.end;
				if(o18.wrap != null) {
					o18.wrap.zpp_inner._inuse = false;
					var _this6 = o18.wrap;
					var inner6 = _this6.zpp_inner;
					_this6.zpp_inner.outer = null;
					_this6.zpp_inner = null;
					var o19 = _this6;
					o19.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o19;
					var o20 = inner6;
					if(o20.outer != null) {
						o20.outer.zpp_inner = null;
						o20.outer = null;
					}
					o20._isimmutable = null;
					o20._validate = null;
					o20._invalidate = null;
					o20.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o20;
					o18.wrap = null;
				}
				o18.prev = o18.next = null;
				o18.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
				zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o18;
				tmp2 = null;
			} else {
				var retnodes2 = i.end.prev;
				i.end.prev.next = i.end.next;
				i.end.next.prev = i.end.prev;
				i.end.next = i.end.prev = null;
				var o21 = i.end;
				if(o21.wrap != null) {
					o21.wrap.zpp_inner._inuse = false;
					var _this7 = o21.wrap;
					var inner7 = _this7.zpp_inner;
					_this7.zpp_inner.outer = null;
					_this7.zpp_inner = null;
					var o22 = _this7;
					o22.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = o22;
					var o23 = inner7;
					if(o23.outer != null) {
						o23.outer.zpp_inner = null;
						o23.outer = null;
					}
					o23._isimmutable = null;
					o23._validate = null;
					o23._invalidate = null;
					o23.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o23;
					o21.wrap = null;
				}
				o21.prev = o21.next = null;
				o21.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
				zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o21;
				i.end = null;
				tmp2 = retnodes2;
			}
			i.end = tmp2;
			if(!i.vertex) {
				if(i.end != i.path0.vert) {
					i.start.x = i.end.x;
					i.start.y = i.end.y;
					var tmp3;
					if(i.end != null && i.end.prev == i.end) {
						i.end.next = i.end.prev = null;
						var o24 = i.end;
						if(o24.wrap != null) {
							o24.wrap.zpp_inner._inuse = false;
							var _this8 = o24.wrap;
							var inner8 = _this8.zpp_inner;
							_this8.zpp_inner.outer = null;
							_this8.zpp_inner = null;
							var o25 = _this8;
							o25.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o25;
							var o26 = inner8;
							if(o26.outer != null) {
								o26.outer.zpp_inner = null;
								o26.outer = null;
							}
							o26._isimmutable = null;
							o26._validate = null;
							o26._invalidate = null;
							o26.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o26;
							o24.wrap = null;
						}
						o24.prev = o24.next = null;
						o24.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o24;
						tmp3 = null;
					} else {
						var retnodes3 = i.end.prev;
						i.end.prev.next = i.end.next;
						i.end.next.prev = i.end.prev;
						i.end.next = i.end.prev = null;
						var o27 = i.end;
						if(o27.wrap != null) {
							o27.wrap.zpp_inner._inuse = false;
							var _this9 = o27.wrap;
							var inner9 = _this9.zpp_inner;
							_this9.zpp_inner.outer = null;
							_this9.zpp_inner = null;
							var o28 = _this9;
							o28.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o28;
							var o29 = inner9;
							if(o29.outer != null) {
								o29.outer.zpp_inner = null;
								o29.outer = null;
							}
							o29._isimmutable = null;
							o29._validate = null;
							o29._invalidate = null;
							o29.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o29;
							o27.wrap = null;
						}
						o27.prev = o27.next = null;
						o27.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o27;
						i.end = null;
						tmp3 = retnodes3;
					}
					i.end = tmp3;
				} else {
					var n1 = i.start.next;
					i.start.x = n1.x;
					i.start.y = n1.y;
					if(n1 != null && n1.prev == n1) {
						n1.next = n1.prev = null;
						var o30 = n1;
						if(o30.wrap != null) {
							o30.wrap.zpp_inner._inuse = false;
							var _this10 = o30.wrap;
							var inner10 = _this10.zpp_inner;
							_this10.zpp_inner.outer = null;
							_this10.zpp_inner = null;
							var o31 = _this10;
							o31.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o31;
							var o32 = inner10;
							if(o32.outer != null) {
								o32.outer.zpp_inner = null;
								o32.outer = null;
							}
							o32._isimmutable = null;
							o32._validate = null;
							o32._invalidate = null;
							o32.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o32;
							o30.wrap = null;
						}
						o30.prev = o30.next = null;
						o30.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o30;
						n1 = null;
					} else {
						n1.prev.next = n1.next;
						n1.next.prev = n1.prev;
						n1.next = n1.prev = null;
						var o33 = n1;
						if(o33.wrap != null) {
							o33.wrap.zpp_inner._inuse = false;
							var _this11 = o33.wrap;
							var inner11 = _this11.zpp_inner;
							_this11.zpp_inner.outer = null;
							_this11.zpp_inner = null;
							var o34 = _this11;
							o34.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
							zpp_$nape_util_ZPP_$PubPool.poolVec2 = o34;
							var o35 = inner11;
							if(o35.outer != null) {
								o35.outer.zpp_inner = null;
								o35.outer = null;
							}
							o35._isimmutable = null;
							o35._validate = null;
							o35._invalidate = null;
							o35.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o35;
							o33.wrap = null;
						}
						o33.prev = o33.next = null;
						o33.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
						zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o33;
					}
				}
			}
			i.end.next.prev = i.start.prev;
			i.start.prev.next = i.end.next;
			i.end.next = i.start;
			i.start.prev = i.end;
			var xr3;
			if(i.path0 == i.path0.parent) {
				xr3 = i.path0;
			} else {
				var obj6 = i.path0;
				var stack6 = null;
				while(obj6 != obj6.parent) {
					var nxt12 = obj6.parent;
					obj6.parent = stack6;
					stack6 = obj6;
					obj6 = nxt12;
				}
				while(stack6 != null) {
					var nxt13 = stack6.parent;
					stack6.parent = obj6;
					stack6 = nxt13;
				}
				xr3 = obj6;
			}
			var yr3;
			if(i.path1 == i.path1.parent) {
				yr3 = i.path1;
			} else {
				var obj7 = i.path1;
				var stack7 = null;
				while(obj7 != obj7.parent) {
					var nxt14 = obj7.parent;
					obj7.parent = stack7;
					stack7 = obj7;
					obj7 = nxt14;
				}
				while(stack7 != null) {
					var nxt15 = stack7.parent;
					stack7.parent = obj7;
					stack7 = nxt15;
				}
				yr3 = obj7;
			}
			if(xr3 != yr3) {
				if(xr3.rank < yr3.rank) {
					xr3.parent = yr3;
				} else if(xr3.rank > yr3.rank) {
					yr3.parent = xr3;
				} else {
					yr3.parent = xr3;
					xr3.rank++;
				}
			}
		}
		var o36 = i;
		o36.end = o36.start = null;
		o36.path0 = o36.path1 = null;
		o36.next = zpp_$nape_geom_ZPP_$CutInt.zpp_pool;
		zpp_$nape_geom_ZPP_$CutInt.zpp_pool = o36;
		var o37 = j;
		o37.end = o37.start = null;
		o37.path0 = o37.path1 = null;
		o37.next = zpp_$nape_geom_ZPP_$CutInt.zpp_pool;
		zpp_$nape_geom_ZPP_$CutInt.zpp_pool = o37;
	}
	var ret = output == null ? new nape_geom_GeomPolyList() : output;
	var cx_ite = zpp_$nape_geom_ZPP_$Cutter.paths.head;
	while(cx_ite != null) {
		var p = cx_ite.elt;
		var poly;
		if(p == p.parent) {
			poly = p;
		} else {
			var obj = p;
			var stack = null;
			while(obj != obj.parent) {
				var nxt = obj.parent;
				obj.parent = stack;
				stack = obj;
				obj = nxt;
			}
			while(stack != null) {
				var nxt1 = stack.parent;
				stack.parent = obj;
				stack = nxt1;
			}
			poly = obj;
		}
		if(poly.used) {
			cx_ite = cx_ite.next;
			continue;
		}
		poly.used = true;
		var p1 = poly.vert;
		var skip = true;
		while(poly.vert != null && (skip || p1 != poly.vert)) {
			skip = false;
			if(p1.x == p1.next.x && p1.y == p1.next.y) {
				if(p1 == poly.vert) {
					poly.vert = p1.next == p1 ? null : p1.next;
					skip = true;
				}
				if(p1 != null && p1.prev == p1) {
					p1.next = p1.prev = null;
					p1 = null;
				} else {
					var retnodes = p1.next;
					p1.prev.next = p1.next;
					p1.next.prev = p1.prev;
					p1.next = p1.prev = null;
					p1 = null;
					p1 = retnodes;
				}
			} else {
				p1 = p1.next;
			}
		}
		if(poly.vert != null) {
			var gp = nape_geom_GeomPoly.get();
			gp.zpp_inner.vertices = poly.vert;
			if(ret.zpp_inner.reverse_flag) {
				ret.push(gp);
			} else {
				ret.unshift(gp);
			}
		}
		cx_ite = cx_ite.next;
	}
	while(zpp_$nape_geom_ZPP_$Cutter.paths.head != null) {
		var p = zpp_$nape_geom_ZPP_$Cutter.paths.pop_unsafe();
		var o = p;
		o.vert = null;
		o.parent = null;
		o.next = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
		zpp_$nape_geom_ZPP_$CutVert.zpp_pool = o;
	}
	while(verts != null) if(verts != null && verts.prev == verts) {
		verts.next = verts.prev = null;
		var o = verts;
		o.vert = null;
		o.parent = null;
		o.next = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
		zpp_$nape_geom_ZPP_$CutVert.zpp_pool = o;
		verts = null;
	} else {
		var retnodes = verts.next;
		verts.prev.next = verts.next;
		verts.next.prev = verts.prev;
		verts.next = verts.prev = null;
		var o1 = verts;
		o1.vert = null;
		o1.parent = null;
		o1.next = zpp_$nape_geom_ZPP_$CutVert.zpp_pool;
		zpp_$nape_geom_ZPP_$CutVert.zpp_pool = o1;
		verts = null;
		verts = retnodes;
	}
	return ret;
};
var zpp_$nape_geom_ZPP_$Geom = function() { };
zpp_$nape_geom_ZPP_$Geom.__name__ = true;
zpp_$nape_geom_ZPP_$Geom.validateShape = function(s) {
	if(s.type == 1) {
		var _this = s.polygon;
		if(_this.zip_gaxi) {
			if(_this.body != null) {
				_this.zip_gaxi = false;
				_this.validate_laxi();
				var _this1 = _this.body;
				if(_this1.zip_axis) {
					_this1.zip_axis = false;
					_this1.axisx = Math.sin(_this1.rot);
					_this1.axisy = Math.cos(_this1.rot);
				}
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var ite = _this.edges.head;
				var cx_ite = _this.gverts.next;
				var u = cx_ite;
				cx_ite = cx_ite.next;
				while(cx_ite != null) {
					var v = cx_ite;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
					u = v;
					cx_ite = cx_ite.next;
				}
				var v = _this.gverts.next;
				var e = ite.elt;
				ite = ite.next;
				e.gp0 = u;
				e.gp1 = v;
				e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
				e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
				e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
				if(e.wrap_gnorm != null) {
					e.wrap_gnorm.zpp_inner.x = e.gnormx;
					e.wrap_gnorm.zpp_inner.y = e.gnormy;
				}
				e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
				e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
			}
		}
	}
	if(s.zip_aabb) {
		if(s.body != null) {
			s.zip_aabb = false;
			if(s.type == 0) {
				var _this = s.circle;
				if(_this.zip_worldCOM) {
					if(_this.body != null) {
						_this.zip_worldCOM = false;
						if(_this.zip_localCOM) {
							_this.zip_localCOM = false;
							if(_this.type == 1) {
								var _this1 = _this.polygon;
								if(_this1.lverts.next.next == null) {
									_this1.localCOMx = _this1.lverts.next.x;
									_this1.localCOMy = _this1.lverts.next.y;
								} else if(_this1.lverts.next.next.next == null) {
									_this1.localCOMx = _this1.lverts.next.x;
									_this1.localCOMy = _this1.lverts.next.y;
									var t = 1.0;
									_this1.localCOMx += _this1.lverts.next.next.x * t;
									_this1.localCOMy += _this1.lverts.next.next.y * t;
									var t = 0.5;
									_this1.localCOMx *= t;
									_this1.localCOMy *= t;
								} else {
									_this1.localCOMx = 0;
									_this1.localCOMy = 0;
									var area = 0.0;
									var cx_ite = _this1.lverts.next;
									var u = cx_ite;
									cx_ite = cx_ite.next;
									var v = cx_ite;
									cx_ite = cx_ite.next;
									while(cx_ite != null) {
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
									}
									cx_ite = _this1.lverts.next;
									var w = cx_ite;
									area += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									_this1.localCOMx += (v.x + w.x) * cf;
									_this1.localCOMy += (v.y + w.y) * cf;
									u = v;
									v = w;
									cx_ite = cx_ite.next;
									var w = cx_ite;
									area += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									_this1.localCOMx += (v.x + w.x) * cf;
									_this1.localCOMy += (v.y + w.y) * cf;
									area = 1 / (3 * area);
									var t = area;
									_this1.localCOMx *= t;
									_this1.localCOMy *= t;
								}
							}
							if(_this.wrap_localCOM != null) {
								_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
								_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
							}
						}
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
						_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
					}
				}
				var rx = _this.radius;
				var ry = _this.radius;
				_this.aabb.minx = _this.worldCOMx - rx;
				_this.aabb.miny = _this.worldCOMy - ry;
				_this.aabb.maxx = _this.worldCOMx + rx;
				_this.aabb.maxy = _this.worldCOMy + ry;
			} else {
				var _this = s.polygon;
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var p0 = _this.gverts.next;
				_this.aabb.minx = p0.x;
				_this.aabb.miny = p0.y;
				_this.aabb.maxx = p0.x;
				_this.aabb.maxy = p0.y;
				var cx_ite = _this.gverts.next.next;
				while(cx_ite != null) {
					var p = cx_ite;
					if(p.x < _this.aabb.minx) {
						_this.aabb.minx = p.x;
					}
					if(p.x > _this.aabb.maxx) {
						_this.aabb.maxx = p.x;
					}
					if(p.y < _this.aabb.miny) {
						_this.aabb.miny = p.y;
					}
					if(p.y > _this.aabb.maxy) {
						_this.aabb.maxy = p.y;
					}
					cx_ite = cx_ite.next;
				}
			}
		}
	}
	if(s.zip_worldCOM) {
		if(s.body != null) {
			s.zip_worldCOM = false;
			if(s.zip_localCOM) {
				s.zip_localCOM = false;
				if(s.type == 1) {
					var _this = s.polygon;
					if(_this.lverts.next.next == null) {
						_this.localCOMx = _this.lverts.next.x;
						_this.localCOMy = _this.lverts.next.y;
					} else if(_this.lverts.next.next.next == null) {
						_this.localCOMx = _this.lverts.next.x;
						_this.localCOMy = _this.lverts.next.y;
						var t = 1.0;
						_this.localCOMx += _this.lverts.next.next.x * t;
						_this.localCOMy += _this.lverts.next.next.y * t;
						var t = 0.5;
						_this.localCOMx *= t;
						_this.localCOMy *= t;
					} else {
						_this.localCOMx = 0;
						_this.localCOMy = 0;
						var area = 0.0;
						var cx_ite = _this.lverts.next;
						var u = cx_ite;
						cx_ite = cx_ite.next;
						var v = cx_ite;
						cx_ite = cx_ite.next;
						while(cx_ite != null) {
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							u = v;
							v = w;
							cx_ite = cx_ite.next;
						}
						cx_ite = _this.lverts.next;
						var w = cx_ite;
						area += v.x * (w.y - u.y);
						var cf = w.y * v.x - w.x * v.y;
						_this.localCOMx += (v.x + w.x) * cf;
						_this.localCOMy += (v.y + w.y) * cf;
						u = v;
						v = w;
						cx_ite = cx_ite.next;
						var w = cx_ite;
						area += v.x * (w.y - u.y);
						var cf = w.y * v.x - w.x * v.y;
						_this.localCOMx += (v.x + w.x) * cf;
						_this.localCOMy += (v.y + w.y) * cf;
						area = 1 / (3 * area);
						var t = area;
						_this.localCOMx *= t;
						_this.localCOMy *= t;
					}
				}
				if(s.wrap_localCOM != null) {
					s.wrap_localCOM.zpp_inner.x = s.localCOMx;
					s.wrap_localCOM.zpp_inner.y = s.localCOMy;
				}
			}
			var _this = s.body;
			if(_this.zip_axis) {
				_this.zip_axis = false;
				_this.axisx = Math.sin(_this.rot);
				_this.axisy = Math.cos(_this.rot);
			}
			s.worldCOMx = s.body.posx + (s.body.axisy * s.localCOMx - s.body.axisx * s.localCOMy);
			s.worldCOMy = s.body.posy + (s.localCOMx * s.body.axisx + s.localCOMy * s.body.axisy);
		}
	}
};
var zpp_$nape_geom_ZPP_$GeomVert = function() {
	this.forced = false;
	this.wrap = null;
	this.next = null;
	this.prev = null;
	this.y = 0.0;
	this.x = 0.0;
};
zpp_$nape_geom_ZPP_$GeomVert.__name__ = true;
zpp_$nape_geom_ZPP_$GeomVert.prototype = {
	modwrap: function(n) {
		this.x = n.x;
		this.y = n.y;
	}
	,getwrap: function() {
		this.wrap.zpp_inner.x = this.x;
		this.wrap.zpp_inner.y = this.y;
	}
};
var zpp_$nape_geom_ZPP_$GeomPoly = function(outer) {
	this.vertices = null;
	this.outer = null;
	this.outer = outer;
};
zpp_$nape_geom_ZPP_$GeomPoly.__name__ = true;
var zpp_$nape_geom_ZPP_$GeomVertexIterator = function() {
	this.next = null;
	this.outer = null;
	this.forward = false;
	this.first = false;
	this.start = null;
	this.ptr = null;
	this.outer = new nape_geom_GeomVertexIterator();
};
zpp_$nape_geom_ZPP_$GeomVertexIterator.__name__ = true;
zpp_$nape_geom_ZPP_$GeomVertexIterator.get = function(poly,forward) {
	var ret;
	if(zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$GeomVertexIterator();
	} else {
		ret = zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVertexIterator.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.outer.zpp_inner = ret;
	ret.ptr = poly;
	ret.forward = forward;
	ret.start = poly;
	ret.first = poly != null;
	return ret.outer;
};
var zpp_$nape_geom_ZPP_$MarchSpan = function() {
	this.next = null;
	this.out = false;
	this.rank = 0;
	this.parent = null;
	this.parent = this;
};
zpp_$nape_geom_ZPP_$MarchSpan.__name__ = true;
var zpp_$nape_geom_ZPP_$MarchPair = function() {
	this.next = null;
	this.spanr = null;
	this.span2 = null;
	this.span1 = null;
	this.pd = null;
	this.okeyr = 0;
	this.keyr = 0;
	this.pr = null;
	this.okey2 = 0;
	this.key2 = 0;
	this.p2 = null;
	this.okey1 = 0;
	this.key1 = 0;
	this.p1 = null;
};
zpp_$nape_geom_ZPP_$MarchPair.__name__ = true;
var zpp_$nape_geom_ZPP_$MarchingSquares = function() {
};
zpp_$nape_geom_ZPP_$MarchingSquares.__name__ = true;
zpp_$nape_geom_ZPP_$MarchingSquares.run = function(iso,bx0,by0,bx1,by1,cell,quality,combine,ret) {
	var _this = cell.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var xp = (bx1 - bx0) / cell.zpp_inner.x;
	var xn = xp | 0;
	var _this = cell.zpp_inner;
	if(_this._validate != null) {
		_this._validate();
	}
	var yp = (by1 - by0) / cell.zpp_inner.y;
	var yn = yp | 0;
	if(xp != xn) {
		++xn;
	}
	if(yp != yn) {
		++yn;
	}
	if(combine) {
		if(zpp_$nape_geom_ZPP_$MarchingSquares.map == null) {
			zpp_$nape_geom_ZPP_$MarchingSquares.map = new zpp_$nape_util_ZNPArray2_$ZPP_$MarchPair(xn,yn);
		} else {
			zpp_$nape_geom_ZPP_$MarchingSquares.map.resize(xn,yn,null);
		}
	}
	if(zpp_$nape_geom_ZPP_$MarchingSquares.isos == null) {
		zpp_$nape_geom_ZPP_$MarchingSquares.isos = new zpp_$nape_util_ZNPArray2_$Float(xn + 1,yn + 1);
	} else {
		zpp_$nape_geom_ZPP_$MarchingSquares.isos.resize(xn + 1,yn + 1,0);
	}
	var _g = 0;
	var _g1 = yn + 1;
	while(_g < _g1) {
		var y = _g++;
		var yc;
		if(y == 0) {
			yc = by0;
		} else if(y <= yn) {
			var _this = cell.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			yc = by0 + cell.zpp_inner.y * y;
		} else {
			yc = by1;
		}
		var _g2 = 0;
		var _g3 = xn + 1;
		while(_g2 < _g3) {
			var x = _g2++;
			var xc;
			if(x == 0) {
				xc = bx0;
			} else if(x <= xn) {
				var _this1 = cell.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				xc = bx0 + cell.zpp_inner.x * x;
			} else {
				xc = bx1;
			}
			var _this2 = zpp_$nape_geom_ZPP_$MarchingSquares.isos;
			var obj = iso(xc,yc);
			_this2.list[y * _this2.width + x] = obj;
		}
	}
	if(zpp_$nape_geom_ZPP_$MarchingSquares.ints == null) {
		zpp_$nape_geom_ZPP_$MarchingSquares.ints = new zpp_$nape_util_ZNPArray2_$ZPP_$GeomVert(xn + 1,(yn << 1) + 1);
	} else {
		zpp_$nape_geom_ZPP_$MarchingSquares.ints.resize(xn + 1,(yn << 1) + 1,null);
	}
	var spans = null;
	if(combine) {
		if(zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool == null) {
			spans = new zpp_$nape_geom_ZPP_$MarchSpan();
		} else {
			spans = zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool;
			zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool = spans.next;
			spans.next = null;
		}
		spans.out = false;
		spans.rank = 0;
	}
	var py = by0;
	var _g = 0;
	var _g1 = yn;
	while(_g < _g1) {
		var y = _g++;
		var y0 = py;
		var y1;
		if(y == yn - 1) {
			y1 = by1;
		} else {
			var _this = cell.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			y1 = by0 + cell.zpp_inner.y * (y + 1);
		}
		py = y1;
		var px = bx0;
		var pre = null;
		var _g2 = 0;
		var _g3 = xn;
		while(_g2 < _g3) {
			var x = _g2++;
			var x0 = px;
			var x1;
			if(x == xn - 1) {
				x1 = bx1;
			} else {
				var _this1 = cell.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				x1 = bx0 + cell.zpp_inner.x * (x + 1);
			}
			px = x1;
			var fstx = x == 0 || !combine;
			var fsty = y == 0 || !combine;
			var sndx = x == xn - 1 || !combine;
			var sndy = y == yn - 1 || !combine;
			var pp = zpp_$nape_geom_ZPP_$MarchingSquares.me.marchSquare(iso,zpp_$nape_geom_ZPP_$MarchingSquares.isos,zpp_$nape_geom_ZPP_$MarchingSquares.ints,x0,y0,x1,y1,x,y,fstx,fsty,sndx,sndy,quality);
			if(pp == null) {
				pre = null;
				continue;
			}
			if(combine) {
				var pd = pp.p2 != null && pp.okey2 != 14 ? pp.p2 : pp.p1;
				pp.pd = ((pd == pp.p2 ? pp.okey2 : pp.okey1) & 128) == 0 ? pd.prev : pd.prev.prev;
				var _this2 = zpp_$nape_geom_ZPP_$MarchingSquares.map;
				_this2.list[y * _this2.width + x] = pp;
				var tmp;
				if(pre != null) {
					var _this3 = zpp_$nape_geom_ZPP_$MarchingSquares.me;
					var key = pp.key1;
					var flag = key & 1 | (key & 192) >> 5;
					var cnt = 0;
					if((flag & 1) != 0) {
						++cnt;
					}
					if((flag & 2) != 0) {
						++cnt;
					}
					if((flag & 4) != 0) {
						++cnt;
					}
					tmp = cnt >= 2;
				} else {
					tmp = false;
				}
				if(tmp) {
					zpp_$nape_geom_ZPP_$MarchingSquares.me.combLR(pre,pp);
					pp.span1 = pre.spanr;
				} else {
					if(zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool == null) {
						pp.span1 = new zpp_$nape_geom_ZPP_$MarchSpan();
					} else {
						pp.span1 = zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool;
						zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool = pp.span1.next;
						pp.span1.next = null;
					}
					var _this4 = pp.span1;
					_this4.out = false;
					_this4.rank = 0;
					pp.span1.next = spans;
					spans = pp.span1;
				}
				if(pp.p2 != null) {
					if(zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool == null) {
						pp.span2 = new zpp_$nape_geom_ZPP_$MarchSpan();
					} else {
						pp.span2 = zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool;
						zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool = pp.span2.next;
						pp.span2.next = null;
					}
					var _this5 = pp.span2;
					_this5.out = false;
					_this5.rank = 0;
					pp.span2.next = spans;
					spans = pp.span2;
					pp.spanr = pp.span2;
				} else {
					pp.spanr = pp.span1;
				}
				var _this6 = zpp_$nape_geom_ZPP_$MarchingSquares.me;
				var flag1 = (pp.keyr & 28) >> 2;
				var cnt1 = 0;
				if((flag1 & 1) != 0) {
					++cnt1;
				}
				if((flag1 & 2) != 0) {
					++cnt1;
				}
				if((flag1 & 4) != 0) {
					++cnt1;
				}
				if(cnt1 >= 2) {
					pre = pp;
				} else {
					pre = null;
				}
			} else {
				zpp_$nape_geom_ZPP_$MarchingSquares.me.output(ret,pp.p1);
				if(pp.p2 != null) {
					zpp_$nape_geom_ZPP_$MarchingSquares.me.output(ret,pp.p2);
				}
				var o = pp;
				o.p1 = o.p2 = o.pr = o.pd = null;
				o.span1 = o.span2 = o.spanr = null;
				o.next = zpp_$nape_geom_ZPP_$MarchPair.zpp_pool;
				zpp_$nape_geom_ZPP_$MarchPair.zpp_pool = o;
			}
		}
	}
	if(!combine) {
		return;
	}
	var _g = 1;
	var _g1 = yn;
	while(_g < _g1) {
		var y = _g++;
		var pre = null;
		var _g2 = 0;
		var _g3 = xn;
		while(_g2 < _g3) {
			var x = _g2++;
			var _this = zpp_$nape_geom_ZPP_$MarchingSquares.map;
			var b = _this.list[y * _this.width + x];
			if(b == null) {
				pre = null;
				continue;
			}
			var bkey = b.p2 != null && b.okey2 == 14 ? b.okey2 : b.okey1;
			var _this1 = zpp_$nape_geom_ZPP_$MarchingSquares.me;
			var flag = bkey & 7;
			var cnt = 0;
			if((flag & 1) != 0) {
				++cnt;
			}
			if((flag & 2) != 0) {
				++cnt;
			}
			if((flag & 4) != 0) {
				++cnt;
			}
			if(cnt < 2) {
				pre = null;
				continue;
			}
			var _this2 = zpp_$nape_geom_ZPP_$MarchingSquares.map;
			var a = _this2.list[(y - 1) * _this2.width + x];
			if(a == null) {
				pre = null;
				continue;
			}
			var akey = a.p2 != null && a.okey2 == 56 ? a.okey2 : a.okey1;
			var _this3 = zpp_$nape_geom_ZPP_$MarchingSquares.me;
			var flag1 = (akey & 112) >> 4;
			var cnt1 = 0;
			if((flag1 & 1) != 0) {
				++cnt1;
			}
			if((flag1 & 2) != 0) {
				++cnt1;
			}
			if((flag1 & 4) != 0) {
				++cnt1;
			}
			if(cnt1 < 2) {
				pre = null;
				continue;
			}
			var ad = a.p2 != null && a.okey2 == 56 ? a.span2 : a.span1;
			var bu = b.p2 != null && b.okey2 == 14 ? b.span2 : b.span1;
			var tmp;
			if(ad == ad.parent) {
				tmp = ad;
			} else {
				var obj = ad;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt1 = stack.parent;
					stack.parent = obj;
					stack = nxt1;
				}
				tmp = obj;
			}
			var tmp1;
			if(bu == bu.parent) {
				tmp1 = bu;
			} else {
				var obj1 = bu;
				var stack1 = null;
				while(obj1 != obj1.parent) {
					var nxt2 = obj1.parent;
					obj1.parent = stack1;
					stack1 = obj1;
					obj1 = nxt2;
				}
				while(stack1 != null) {
					var nxt3 = stack1.parent;
					stack1.parent = obj1;
					stack1 = nxt3;
				}
				tmp1 = obj1;
			}
			if(tmp == tmp1) {
				if(pre != bu) {
					zpp_$nape_geom_ZPP_$MarchingSquares.me.combUD_virtual(a,b);
				}
			} else {
				var xr;
				if(ad == ad.parent) {
					xr = ad;
				} else {
					var obj2 = ad;
					var stack2 = null;
					while(obj2 != obj2.parent) {
						var nxt4 = obj2.parent;
						obj2.parent = stack2;
						stack2 = obj2;
						obj2 = nxt4;
					}
					while(stack2 != null) {
						var nxt5 = stack2.parent;
						stack2.parent = obj2;
						stack2 = nxt5;
					}
					xr = obj2;
				}
				var yr;
				if(bu == bu.parent) {
					yr = bu;
				} else {
					var obj3 = bu;
					var stack3 = null;
					while(obj3 != obj3.parent) {
						var nxt6 = obj3.parent;
						obj3.parent = stack3;
						stack3 = obj3;
						obj3 = nxt6;
					}
					while(stack3 != null) {
						var nxt7 = stack3.parent;
						stack3.parent = obj3;
						stack3 = nxt7;
					}
					yr = obj3;
				}
				if(xr != yr) {
					if(xr.rank < yr.rank) {
						xr.parent = yr;
					} else if(xr.rank > yr.rank) {
						yr.parent = xr;
					} else {
						yr.parent = xr;
						xr.rank++;
					}
				}
				zpp_$nape_geom_ZPP_$MarchingSquares.me.combUD(a,b);
			}
			var key = bu == b.span2 ? b.okey2 : b.okey1;
			pre = (key & 4) != 0 ? bu : null;
		}
	}
	var _g = 0;
	var _g1 = yn;
	while(_g < _g1) {
		var y = _g++;
		var _g2 = 0;
		var _g3 = xn;
		while(_g2 < _g3) {
			var x = _g2++;
			var _this = zpp_$nape_geom_ZPP_$MarchingSquares.map;
			var p = _this.list[y * _this.width + x];
			if(p == null) {
				continue;
			}
			var root;
			if(p.span1 == p.span1.parent) {
				root = p.span1;
			} else {
				var obj = p.span1;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt1 = stack.parent;
					stack.parent = obj;
					stack = nxt1;
				}
				root = obj;
			}
			if(!root.out) {
				root.out = true;
				zpp_$nape_geom_ZPP_$MarchingSquares.me.output(ret,p.p1);
			}
			if(p.p2 != null) {
				if(p.span2 == p.span2.parent) {
					root = p.span2;
				} else {
					var obj1 = p.span2;
					var stack1 = null;
					while(obj1 != obj1.parent) {
						var nxt2 = obj1.parent;
						obj1.parent = stack1;
						stack1 = obj1;
						obj1 = nxt2;
					}
					while(stack1 != null) {
						var nxt3 = stack1.parent;
						stack1.parent = obj1;
						stack1 = nxt3;
					}
					root = obj1;
				}
				if(!root.out) {
					root.out = true;
					zpp_$nape_geom_ZPP_$MarchingSquares.me.output(ret,p.p2);
				}
			}
			var o = p;
			o.p1 = o.p2 = o.pr = o.pd = null;
			o.span1 = o.span2 = o.spanr = null;
			o.next = zpp_$nape_geom_ZPP_$MarchPair.zpp_pool;
			zpp_$nape_geom_ZPP_$MarchPair.zpp_pool = o;
			var _this1 = zpp_$nape_geom_ZPP_$MarchingSquares.map;
			_this1.list[y * _this1.width + x] = null;
		}
	}
	while(spans != null) {
		var t = spans;
		spans = t.next;
		var o = t;
		o.parent = o;
		o.next = zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool;
		zpp_$nape_geom_ZPP_$MarchSpan.zpp_pool = o;
	}
};
zpp_$nape_geom_ZPP_$MarchingSquares.prototype = {
	output: function(ret,poly) {
		var tmp;
		if(poly == null || poly.next == poly || poly.next == poly.prev) {
			tmp = true;
		} else {
			var area = 0.0;
			var F = poly;
			var L = poly;
			if(F != null) {
				var nite = F;
				do {
					var v = nite;
					area += v.x * (v.next.y - v.prev.y);
					nite = nite.next;
				} while(nite != L);
			}
			var a = area * 0.5;
			tmp = a * a < nape_Config.epsilon * nape_Config.epsilon;
		}
		if(tmp) {
			while(poly != null) if(poly != null && poly.prev == poly) {
				poly.next = poly.prev = null;
				poly = null;
			} else {
				var retnodes = poly.next;
				poly.prev.next = poly.next;
				poly.next.prev = poly.prev;
				poly.next = poly.prev = null;
				poly = null;
				poly = retnodes;
			}
			return;
		}
		var gp = nape_geom_GeomPoly.get();
		gp.zpp_inner.vertices = poly;
		if(ret.zpp_inner.reverse_flag) {
			ret.push(gp);
		} else {
			ret.unshift(gp);
		}
	}
	,combLR: function(a,b) {
		var poly = a.pr;
		var kind = a.okeyr & 7;
		var ap = kind == 0 ? poly : kind == 3 ? poly.next.next : poly.next;
		var poly = b.p1;
		var bp = (b.okey1 & 1) == 0 ? poly.prev : poly;
		var ap2 = ap.next;
		var bp2 = bp.prev;
		if((a.keyr & 4) != 0) {
			if(b.pr == b.p1) {
				b.pr = ap.prev;
			}
			b.p1 = ap.prev;
			ap.prev.next = bp.next;
			bp.next.prev = ap.prev;
			var o = ap;
			if(o.wrap != null) {
				o.wrap.zpp_inner._inuse = false;
				var _this = o.wrap;
				var inner = _this.zpp_inner;
				_this.zpp_inner.outer = null;
				_this.zpp_inner = null;
				var o1 = _this;
				o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
				var o1 = inner;
				if(o1.outer != null) {
					o1.outer.zpp_inner = null;
					o1.outer = null;
				}
				o1._isimmutable = null;
				o1._validate = null;
				o1._invalidate = null;
				o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
				o.wrap = null;
			}
			o.prev = o.next = null;
			o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		} else {
			ap.next = bp.next;
			bp.next.prev = ap;
		}
		var o = bp;
		if(o.wrap != null) {
			o.wrap.zpp_inner._inuse = false;
			var _this = o.wrap;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o1 = _this;
			o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			o.wrap = null;
		}
		o.prev = o.next = null;
		o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		if((a.keyr & 16) != 0) {
			b.pd = ap2.next;
			ap2.next.prev = bp2.prev;
			bp2.prev.next = ap2.next;
			var o = ap2;
			if(o.wrap != null) {
				o.wrap.zpp_inner._inuse = false;
				var _this = o.wrap;
				var inner = _this.zpp_inner;
				_this.zpp_inner.outer = null;
				_this.zpp_inner = null;
				var o1 = _this;
				o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
				var o1 = inner;
				if(o1.outer != null) {
					o1.outer.zpp_inner = null;
					o1.outer = null;
				}
				o1._isimmutable = null;
				o1._validate = null;
				o1._invalidate = null;
				o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
				o.wrap = null;
			}
			o.prev = o.next = null;
			o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		} else {
			ap2.prev = bp2.prev;
			bp2.prev.next = ap2;
		}
		var o = bp2;
		if(o.wrap != null) {
			o.wrap.zpp_inner._inuse = false;
			var _this = o.wrap;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o1 = _this;
			o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			o.wrap = null;
		}
		o.prev = o.next = null;
		o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
	}
	,combUD: function(a,b) {
		var ad = a.p2 != null && a.key2 == 56 ? a.p2 : a.p1;
		var bu = b.p2 != null && b.key2 == 14 ? b.p2 : b.p1;
		var ap = a.pd;
		var bp = bu;
		var ap2 = ap.prev;
		var bp2 = bp.next;
		bp.next = ap.next;
		ap.next.prev = bp;
		var o = ap;
		if(o.wrap != null) {
			o.wrap.zpp_inner._inuse = false;
			var _this = o.wrap;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o1 = _this;
			o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			o.wrap = null;
		}
		o.prev = o.next = null;
		o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
		bp2.prev = ap2.prev;
		ap2.prev.next = bp2;
		if(ap2 == a.p1) {
			a.p1 = bp2;
		}
		var o = ap2;
		if(o.wrap != null) {
			o.wrap.zpp_inner._inuse = false;
			var _this = o.wrap;
			var inner = _this.zpp_inner;
			_this.zpp_inner.outer = null;
			_this.zpp_inner = null;
			var o1 = _this;
			o1.zpp_pool = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = o1;
			var o1 = inner;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1._isimmutable = null;
			o1._validate = null;
			o1._invalidate = null;
			o1.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o1;
			o.wrap = null;
		}
		o.prev = o.next = null;
		o.next = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = o;
	}
	,combUD_virtual: function(a,b) {
		var ad = a.p2 != null && a.key2 == 56 ? a.p2 : a.p1;
		var bu = b.p2 != null && b.key2 == 14 ? b.p2 : b.p1;
		var ap = a.pd;
		var bp = bu;
		var ap2 = ap.prev;
		var bp2 = bp.next;
		ap.forced = bp.forced = ap2.forced = bp2.forced = true;
	}
	,marchSquare: function(iso,isos,ints,x0,y0,x1,y1,xn,yn,fstx,fsty,sndx,sndy,quality) {
		var key = 0;
		var v0 = isos.list[yn * isos.width + xn];
		if(v0 < 0) {
			key |= 8;
		}
		var v1 = isos.list[yn * isos.width + (xn + 1)];
		if(v1 < 0) {
			key |= 4;
		}
		var v2 = isos.list[(yn + 1) * isos.width + (xn + 1)];
		if(v2 < 0) {
			key |= 2;
		}
		var v3 = isos.list[(yn + 1) * isos.width + xn];
		if(v3 < 0) {
			key |= 1;
		}
		if(key == 0) {
			return null;
		} else {
			var ret;
			if(zpp_$nape_geom_ZPP_$MarchPair.zpp_pool == null) {
				ret = new zpp_$nape_geom_ZPP_$MarchPair();
			} else {
				ret = zpp_$nape_geom_ZPP_$MarchPair.zpp_pool;
				zpp_$nape_geom_ZPP_$MarchPair.zpp_pool = ret.next;
				ret.next = null;
			}
			if(key != 10 && key != 5) {
				var val = zpp_$nape_geom_ZPP_$MarchingSquares.look_march[key];
				ret.okey1 = val;
				var _g = 0;
				while(_g < 8) {
					var i = _g++;
					if((val & 1 << i) != 0) {
						var p = null;
						if(i == 0) {
							var ret1;
							if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
								ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
							} else {
								ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
								zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.forced = false;
							ret1.x = x0;
							ret1.y = y0;
							p = ret1;
							if(fstx || fsty) {
								p.forced = true;
							}
						} else if(i == 2) {
							var ret2;
							if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
								ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
							} else {
								ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
								zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
								ret2.next = null;
							}
							ret2.forced = false;
							ret2.x = x1;
							ret2.y = y0;
							p = ret2;
							if(sndx || fsty) {
								p.forced = true;
							}
						} else if(i == 4) {
							var ret3;
							if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
								ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
							} else {
								ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
								zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
								ret3.next = null;
							}
							ret3.forced = false;
							ret3.x = x1;
							ret3.y = y1;
							p = ret3;
							if(sndx || sndy) {
								p.forced = true;
							}
						} else if(i == 6) {
							var ret4;
							if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
								ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
							} else {
								ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
								zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
								ret4.next = null;
							}
							ret4.forced = false;
							ret4.x = x0;
							ret4.y = y1;
							p = ret4;
							if(fstx || sndy) {
								p.forced = true;
							}
						} else if(i == 1) {
							p = ints.list[(yn << 1) * ints.width + xn];
							if(p == null) {
								var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
								var ret5;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
									ret5.next = null;
								}
								ret5.forced = false;
								ret5.x = x;
								ret5.y = y0;
								p = ret5;
								ints.list[(yn << 1) * ints.width + xn] = p;
							} else {
								var x2 = p.x;
								var y = p.y;
								var ret6;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
									ret6.next = null;
								}
								ret6.forced = false;
								ret6.x = x2;
								ret6.y = y;
								p = ret6;
							}
							if(fsty) {
								p.forced = true;
							}
							if(p.x == x0 || p.x == x1) {
								if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
									val ^= 2;
								}
							}
						} else if(i == 5) {
							p = ints.list[((yn << 1) + 2) * ints.width + xn];
							if(p == null) {
								var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
								var ret7;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
									ret7.next = null;
								}
								ret7.forced = false;
								ret7.x = x3;
								ret7.y = y1;
								p = ret7;
								ints.list[((yn << 1) + 2) * ints.width + xn] = p;
							} else {
								var x4 = p.x;
								var y2 = p.y;
								var ret8;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
									ret8.next = null;
								}
								ret8.forced = false;
								ret8.x = x4;
								ret8.y = y2;
								p = ret8;
							}
							if(sndy) {
								p.forced = true;
							}
							if(p.x == x0 || p.x == x1) {
								if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
									val ^= 32;
								}
							}
						} else if(i == 3) {
							p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
							if(p == null) {
								var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
								var ret9;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
									ret9.next = null;
								}
								ret9.forced = false;
								ret9.x = x1;
								ret9.y = y3;
								p = ret9;
								ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
							} else {
								var x5 = p.x;
								var y4 = p.y;
								var ret10;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
									ret10.next = null;
								}
								ret10.forced = false;
								ret10.x = x5;
								ret10.y = y4;
								p = ret10;
							}
							if(sndx) {
								p.forced = true;
							}
							if(p.y == y0 || p.y == y1) {
								if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
									val ^= 8;
								}
							}
						} else {
							p = ints.list[((yn << 1) + 1) * ints.width + xn];
							if(p == null) {
								var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
								var ret11;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
									ret11.next = null;
								}
								ret11.forced = false;
								ret11.x = x0;
								ret11.y = y5;
								p = ret11;
								ints.list[((yn << 1) + 1) * ints.width + xn] = p;
							} else {
								var x6 = p.x;
								var y6 = p.y;
								var ret12;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
									ret12.next = null;
								}
								ret12.forced = false;
								ret12.x = x6;
								ret12.y = y6;
								p = ret12;
							}
							if(fstx) {
								p.forced = true;
							}
							if(p.y == y0 || p.y == y1) {
								if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
									val ^= 128;
								}
							}
						}
						var obj = p;
						if(ret.p1 == null) {
							ret.p1 = obj.prev = obj.next = obj;
						} else {
							obj.prev = ret.p1;
							obj.next = ret.p1.next;
							ret.p1.next.prev = obj;
							ret.p1.next = obj;
						}
						ret.p1 = obj;
					}
				}
				ret.p1 = ret.p1.next;
				ret.key1 = val;
				if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
					val = 0;
					ret.key1 = 0;
					ret.p1 = null;
				}
				if(val == 0) {
					ret = null;
				} else {
					ret.pr = ret.p1;
					ret.okeyr = ret.okey1;
					ret.keyr = ret.key1;
				}
			} else {
				var mid = iso(0.5 * (x0 + x1),0.5 * (y0 + y1)) < 0;
				if(key == 10) {
					if(mid) {
						var val = 187;
						ret.okey1 = val;
						var _g = 0;
						while(_g < 8) {
							var i = _g++;
							if((val & 1 << i) != 0) {
								var p = null;
								if(i == 0) {
									var ret1;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
										ret1.next = null;
									}
									ret1.forced = false;
									ret1.x = x0;
									ret1.y = y0;
									p = ret1;
									if(fstx || fsty) {
										p.forced = true;
									}
								} else if(i == 2) {
									var ret2;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
										ret2.next = null;
									}
									ret2.forced = false;
									ret2.x = x1;
									ret2.y = y0;
									p = ret2;
									if(sndx || fsty) {
										p.forced = true;
									}
								} else if(i == 4) {
									var ret3;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
										ret3.next = null;
									}
									ret3.forced = false;
									ret3.x = x1;
									ret3.y = y1;
									p = ret3;
									if(sndx || sndy) {
										p.forced = true;
									}
								} else if(i == 6) {
									var ret4;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
										ret4.next = null;
									}
									ret4.forced = false;
									ret4.x = x0;
									ret4.y = y1;
									p = ret4;
									if(fstx || sndy) {
										p.forced = true;
									}
								} else if(i == 1) {
									p = ints.list[(yn << 1) * ints.width + xn];
									if(p == null) {
										var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
										var ret5;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.forced = false;
										ret5.x = x;
										ret5.y = y0;
										p = ret5;
										ints.list[(yn << 1) * ints.width + xn] = p;
									} else {
										var x2 = p.x;
										var y = p.y;
										var ret6;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
											ret6.next = null;
										}
										ret6.forced = false;
										ret6.x = x2;
										ret6.y = y;
										p = ret6;
									}
									if(fsty) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
											val ^= 2;
										}
									}
								} else if(i == 5) {
									p = ints.list[((yn << 1) + 2) * ints.width + xn];
									if(p == null) {
										var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
										var ret7;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
											ret7.next = null;
										}
										ret7.forced = false;
										ret7.x = x3;
										ret7.y = y1;
										p = ret7;
										ints.list[((yn << 1) + 2) * ints.width + xn] = p;
									} else {
										var x4 = p.x;
										var y2 = p.y;
										var ret8;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
											ret8.next = null;
										}
										ret8.forced = false;
										ret8.x = x4;
										ret8.y = y2;
										p = ret8;
									}
									if(sndy) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
											val ^= 32;
										}
									}
								} else if(i == 3) {
									p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
									if(p == null) {
										var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
										var ret9;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
											ret9.next = null;
										}
										ret9.forced = false;
										ret9.x = x1;
										ret9.y = y3;
										p = ret9;
										ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
									} else {
										var x5 = p.x;
										var y4 = p.y;
										var ret10;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
											ret10.next = null;
										}
										ret10.forced = false;
										ret10.x = x5;
										ret10.y = y4;
										p = ret10;
									}
									if(sndx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
											val ^= 8;
										}
									}
								} else {
									p = ints.list[((yn << 1) + 1) * ints.width + xn];
									if(p == null) {
										var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
										var ret11;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
											ret11.next = null;
										}
										ret11.forced = false;
										ret11.x = x0;
										ret11.y = y5;
										p = ret11;
										ints.list[((yn << 1) + 1) * ints.width + xn] = p;
									} else {
										var x6 = p.x;
										var y6 = p.y;
										var ret12;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
											ret12.next = null;
										}
										ret12.forced = false;
										ret12.x = x6;
										ret12.y = y6;
										p = ret12;
									}
									if(fstx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
											val ^= 128;
										}
									}
								}
								var obj = p;
								if(ret.p1 == null) {
									ret.p1 = obj.prev = obj.next = obj;
								} else {
									obj.prev = ret.p1;
									obj.next = ret.p1.next;
									ret.p1.next.prev = obj;
									ret.p1.next = obj;
								}
								ret.p1 = obj;
							}
						}
						ret.p1 = ret.p1.next;
						ret.key1 = val;
						if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
							val = 0;
							ret.key1 = 0;
							ret.p1 = null;
						}
						if(val == 0) {
							ret = null;
						} else {
							ret.pr = ret.p1;
							ret.okeyr = ret.okey1;
							ret.keyr = ret.key1;
						}
					} else {
						var val = 131;
						ret.okey1 = val;
						var _g = 0;
						while(_g < 8) {
							var i = _g++;
							if((val & 1 << i) != 0) {
								var p = null;
								if(i == 0) {
									var ret1;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
										ret1.next = null;
									}
									ret1.forced = false;
									ret1.x = x0;
									ret1.y = y0;
									p = ret1;
									if(fstx || fsty) {
										p.forced = true;
									}
								} else if(i == 2) {
									var ret2;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
										ret2.next = null;
									}
									ret2.forced = false;
									ret2.x = x1;
									ret2.y = y0;
									p = ret2;
									if(sndx || fsty) {
										p.forced = true;
									}
								} else if(i == 4) {
									var ret3;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
										ret3.next = null;
									}
									ret3.forced = false;
									ret3.x = x1;
									ret3.y = y1;
									p = ret3;
									if(sndx || sndy) {
										p.forced = true;
									}
								} else if(i == 6) {
									var ret4;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
										ret4.next = null;
									}
									ret4.forced = false;
									ret4.x = x0;
									ret4.y = y1;
									p = ret4;
									if(fstx || sndy) {
										p.forced = true;
									}
								} else if(i == 1) {
									p = ints.list[(yn << 1) * ints.width + xn];
									if(p == null) {
										var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
										var ret5;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.forced = false;
										ret5.x = x;
										ret5.y = y0;
										p = ret5;
										ints.list[(yn << 1) * ints.width + xn] = p;
									} else {
										var x2 = p.x;
										var y = p.y;
										var ret6;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
											ret6.next = null;
										}
										ret6.forced = false;
										ret6.x = x2;
										ret6.y = y;
										p = ret6;
									}
									if(fsty) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
											val ^= 2;
										}
									}
								} else if(i == 5) {
									p = ints.list[((yn << 1) + 2) * ints.width + xn];
									if(p == null) {
										var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
										var ret7;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
											ret7.next = null;
										}
										ret7.forced = false;
										ret7.x = x3;
										ret7.y = y1;
										p = ret7;
										ints.list[((yn << 1) + 2) * ints.width + xn] = p;
									} else {
										var x4 = p.x;
										var y2 = p.y;
										var ret8;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
											ret8.next = null;
										}
										ret8.forced = false;
										ret8.x = x4;
										ret8.y = y2;
										p = ret8;
									}
									if(sndy) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
											val ^= 32;
										}
									}
								} else if(i == 3) {
									p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
									if(p == null) {
										var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
										var ret9;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
											ret9.next = null;
										}
										ret9.forced = false;
										ret9.x = x1;
										ret9.y = y3;
										p = ret9;
										ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
									} else {
										var x5 = p.x;
										var y4 = p.y;
										var ret10;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
											ret10.next = null;
										}
										ret10.forced = false;
										ret10.x = x5;
										ret10.y = y4;
										p = ret10;
									}
									if(sndx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
											val ^= 8;
										}
									}
								} else {
									p = ints.list[((yn << 1) + 1) * ints.width + xn];
									if(p == null) {
										var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
										var ret11;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
											ret11.next = null;
										}
										ret11.forced = false;
										ret11.x = x0;
										ret11.y = y5;
										p = ret11;
										ints.list[((yn << 1) + 1) * ints.width + xn] = p;
									} else {
										var x6 = p.x;
										var y6 = p.y;
										var ret12;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
											ret12.next = null;
										}
										ret12.forced = false;
										ret12.x = x6;
										ret12.y = y6;
										p = ret12;
									}
									if(fstx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
											val ^= 128;
										}
									}
								}
								var obj = p;
								if(ret.p1 == null) {
									ret.p1 = obj.prev = obj.next = obj;
								} else {
									obj.prev = ret.p1;
									obj.next = ret.p1.next;
									ret.p1.next.prev = obj;
									ret.p1.next = obj;
								}
								ret.p1 = obj;
							}
						}
						ret.p1 = ret.p1.next;
						ret.key1 = val;
						if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
							val = 0;
							ret.key1 = 0;
							ret.p1 = null;
						}
						if(val != 0) {
							var val = 56;
							ret.okey2 = val;
							var _g = 0;
							while(_g < 8) {
								var i = _g++;
								if((val & 1 << i) != 0) {
									var p = null;
									if(i == 0) {
										var ret1;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
											ret1.next = null;
										}
										ret1.forced = false;
										ret1.x = x0;
										ret1.y = y0;
										p = ret1;
										if(fstx || fsty) {
											p.forced = true;
										}
									} else if(i == 2) {
										var ret2;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.forced = false;
										ret2.x = x1;
										ret2.y = y0;
										p = ret2;
										if(sndx || fsty) {
											p.forced = true;
										}
									} else if(i == 4) {
										var ret3;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
											ret3.next = null;
										}
										ret3.forced = false;
										ret3.x = x1;
										ret3.y = y1;
										p = ret3;
										if(sndx || sndy) {
											p.forced = true;
										}
									} else if(i == 6) {
										var ret4;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
											ret4.next = null;
										}
										ret4.forced = false;
										ret4.x = x0;
										ret4.y = y1;
										p = ret4;
										if(fstx || sndy) {
											p.forced = true;
										}
									} else if(i == 1) {
										p = ints.list[(yn << 1) * ints.width + xn];
										if(p == null) {
											var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
											var ret5;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
												ret5.next = null;
											}
											ret5.forced = false;
											ret5.x = x;
											ret5.y = y0;
											p = ret5;
											ints.list[(yn << 1) * ints.width + xn] = p;
										} else {
											var x2 = p.x;
											var y = p.y;
											var ret6;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
												ret6.next = null;
											}
											ret6.forced = false;
											ret6.x = x2;
											ret6.y = y;
											p = ret6;
										}
										if(fsty) {
											p.forced = true;
										}
										if(p.x == x0 || p.x == x1) {
											if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
												val ^= 2;
											}
										}
									} else if(i == 5) {
										p = ints.list[((yn << 1) + 2) * ints.width + xn];
										if(p == null) {
											var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
											var ret7;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
												ret7.next = null;
											}
											ret7.forced = false;
											ret7.x = x3;
											ret7.y = y1;
											p = ret7;
											ints.list[((yn << 1) + 2) * ints.width + xn] = p;
										} else {
											var x4 = p.x;
											var y2 = p.y;
											var ret8;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
												ret8.next = null;
											}
											ret8.forced = false;
											ret8.x = x4;
											ret8.y = y2;
											p = ret8;
										}
										if(sndy) {
											p.forced = true;
										}
										if(p.x == x0 || p.x == x1) {
											if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
												val ^= 32;
											}
										}
									} else if(i == 3) {
										p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
										if(p == null) {
											var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
											var ret9;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
												ret9.next = null;
											}
											ret9.forced = false;
											ret9.x = x1;
											ret9.y = y3;
											p = ret9;
											ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
										} else {
											var x5 = p.x;
											var y4 = p.y;
											var ret10;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
												ret10.next = null;
											}
											ret10.forced = false;
											ret10.x = x5;
											ret10.y = y4;
											p = ret10;
										}
										if(sndx) {
											p.forced = true;
										}
										if(p.y == y0 || p.y == y1) {
											if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
												val ^= 8;
											}
										}
									} else {
										p = ints.list[((yn << 1) + 1) * ints.width + xn];
										if(p == null) {
											var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
											var ret11;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
												ret11.next = null;
											}
											ret11.forced = false;
											ret11.x = x0;
											ret11.y = y5;
											p = ret11;
											ints.list[((yn << 1) + 1) * ints.width + xn] = p;
										} else {
											var x6 = p.x;
											var y6 = p.y;
											var ret12;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
												ret12.next = null;
											}
											ret12.forced = false;
											ret12.x = x6;
											ret12.y = y6;
											p = ret12;
										}
										if(fstx) {
											p.forced = true;
										}
										if(p.y == y0 || p.y == y1) {
											if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
												val ^= 128;
											}
										}
									}
									var obj = p;
									if(ret.p2 == null) {
										ret.p2 = obj.prev = obj.next = obj;
									} else {
										obj.prev = ret.p2;
										obj.next = ret.p2.next;
										ret.p2.next.prev = obj;
										ret.p2.next = obj;
									}
									ret.p2 = obj;
								}
							}
							ret.p2 = ret.p2.next;
							ret.key2 = val;
							if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
								val = 0;
								ret.key2 = 0;
								ret.p2 = null;
							}
							if(val == 0) {
								ret.pr = ret.p1;
								ret.okeyr = ret.okey1;
								ret.keyr = ret.key1;
							} else {
								ret.pr = ret.p2;
								ret.okeyr = ret.okey2;
								ret.keyr = ret.key2;
							}
						} else {
							var val = 56;
							ret.okey1 = val;
							var _g = 0;
							while(_g < 8) {
								var i = _g++;
								if((val & 1 << i) != 0) {
									var p = null;
									if(i == 0) {
										var ret1;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
											ret1.next = null;
										}
										ret1.forced = false;
										ret1.x = x0;
										ret1.y = y0;
										p = ret1;
										if(fstx || fsty) {
											p.forced = true;
										}
									} else if(i == 2) {
										var ret2;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.forced = false;
										ret2.x = x1;
										ret2.y = y0;
										p = ret2;
										if(sndx || fsty) {
											p.forced = true;
										}
									} else if(i == 4) {
										var ret3;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
											ret3.next = null;
										}
										ret3.forced = false;
										ret3.x = x1;
										ret3.y = y1;
										p = ret3;
										if(sndx || sndy) {
											p.forced = true;
										}
									} else if(i == 6) {
										var ret4;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
											ret4.next = null;
										}
										ret4.forced = false;
										ret4.x = x0;
										ret4.y = y1;
										p = ret4;
										if(fstx || sndy) {
											p.forced = true;
										}
									} else if(i == 1) {
										p = ints.list[(yn << 1) * ints.width + xn];
										if(p == null) {
											var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
											var ret5;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
												ret5.next = null;
											}
											ret5.forced = false;
											ret5.x = x;
											ret5.y = y0;
											p = ret5;
											ints.list[(yn << 1) * ints.width + xn] = p;
										} else {
											var x2 = p.x;
											var y = p.y;
											var ret6;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
												ret6.next = null;
											}
											ret6.forced = false;
											ret6.x = x2;
											ret6.y = y;
											p = ret6;
										}
										if(fsty) {
											p.forced = true;
										}
										if(p.x == x0 || p.x == x1) {
											if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
												val ^= 2;
											}
										}
									} else if(i == 5) {
										p = ints.list[((yn << 1) + 2) * ints.width + xn];
										if(p == null) {
											var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
											var ret7;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
												ret7.next = null;
											}
											ret7.forced = false;
											ret7.x = x3;
											ret7.y = y1;
											p = ret7;
											ints.list[((yn << 1) + 2) * ints.width + xn] = p;
										} else {
											var x4 = p.x;
											var y2 = p.y;
											var ret8;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
												ret8.next = null;
											}
											ret8.forced = false;
											ret8.x = x4;
											ret8.y = y2;
											p = ret8;
										}
										if(sndy) {
											p.forced = true;
										}
										if(p.x == x0 || p.x == x1) {
											if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
												val ^= 32;
											}
										}
									} else if(i == 3) {
										p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
										if(p == null) {
											var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
											var ret9;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
												ret9.next = null;
											}
											ret9.forced = false;
											ret9.x = x1;
											ret9.y = y3;
											p = ret9;
											ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
										} else {
											var x5 = p.x;
											var y4 = p.y;
											var ret10;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
												ret10.next = null;
											}
											ret10.forced = false;
											ret10.x = x5;
											ret10.y = y4;
											p = ret10;
										}
										if(sndx) {
											p.forced = true;
										}
										if(p.y == y0 || p.y == y1) {
											if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
												val ^= 8;
											}
										}
									} else {
										p = ints.list[((yn << 1) + 1) * ints.width + xn];
										if(p == null) {
											var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
											var ret11;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
												ret11.next = null;
											}
											ret11.forced = false;
											ret11.x = x0;
											ret11.y = y5;
											p = ret11;
											ints.list[((yn << 1) + 1) * ints.width + xn] = p;
										} else {
											var x6 = p.x;
											var y6 = p.y;
											var ret12;
											if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
												ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
											} else {
												ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
												zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
												ret12.next = null;
											}
											ret12.forced = false;
											ret12.x = x6;
											ret12.y = y6;
											p = ret12;
										}
										if(fstx) {
											p.forced = true;
										}
										if(p.y == y0 || p.y == y1) {
											if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
												val ^= 128;
											}
										}
									}
									var obj = p;
									if(ret.p1 == null) {
										ret.p1 = obj.prev = obj.next = obj;
									} else {
										obj.prev = ret.p1;
										obj.next = ret.p1.next;
										ret.p1.next.prev = obj;
										ret.p1.next = obj;
									}
									ret.p1 = obj;
								}
							}
							ret.p1 = ret.p1.next;
							ret.key1 = val;
							if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
								val = 0;
								ret.key1 = 0;
								ret.p1 = null;
							}
							if(val == 0) {
								ret = null;
							} else {
								ret.pr = ret.p1;
								ret.okeyr = ret.okey1;
								ret.keyr = ret.key1;
							}
						}
					}
				} else if(mid) {
					var val = 238;
					ret.okey1 = val;
					var _g = 0;
					while(_g < 8) {
						var i = _g++;
						if((val & 1 << i) != 0) {
							var p = null;
							if(i == 0) {
								var ret1;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.forced = false;
								ret1.x = x0;
								ret1.y = y0;
								p = ret1;
								if(fstx || fsty) {
									p.forced = true;
								}
							} else if(i == 2) {
								var ret2;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
									ret2.next = null;
								}
								ret2.forced = false;
								ret2.x = x1;
								ret2.y = y0;
								p = ret2;
								if(sndx || fsty) {
									p.forced = true;
								}
							} else if(i == 4) {
								var ret3;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
									ret3.next = null;
								}
								ret3.forced = false;
								ret3.x = x1;
								ret3.y = y1;
								p = ret3;
								if(sndx || sndy) {
									p.forced = true;
								}
							} else if(i == 6) {
								var ret4;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
									ret4.next = null;
								}
								ret4.forced = false;
								ret4.x = x0;
								ret4.y = y1;
								p = ret4;
								if(fstx || sndy) {
									p.forced = true;
								}
							} else if(i == 1) {
								p = ints.list[(yn << 1) * ints.width + xn];
								if(p == null) {
									var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
									var ret5;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
										ret5.next = null;
									}
									ret5.forced = false;
									ret5.x = x;
									ret5.y = y0;
									p = ret5;
									ints.list[(yn << 1) * ints.width + xn] = p;
								} else {
									var x2 = p.x;
									var y = p.y;
									var ret6;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
										ret6.next = null;
									}
									ret6.forced = false;
									ret6.x = x2;
									ret6.y = y;
									p = ret6;
								}
								if(fsty) {
									p.forced = true;
								}
								if(p.x == x0 || p.x == x1) {
									if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
										val ^= 2;
									}
								}
							} else if(i == 5) {
								p = ints.list[((yn << 1) + 2) * ints.width + xn];
								if(p == null) {
									var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
									var ret7;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
										ret7.next = null;
									}
									ret7.forced = false;
									ret7.x = x3;
									ret7.y = y1;
									p = ret7;
									ints.list[((yn << 1) + 2) * ints.width + xn] = p;
								} else {
									var x4 = p.x;
									var y2 = p.y;
									var ret8;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
										ret8.next = null;
									}
									ret8.forced = false;
									ret8.x = x4;
									ret8.y = y2;
									p = ret8;
								}
								if(sndy) {
									p.forced = true;
								}
								if(p.x == x0 || p.x == x1) {
									if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
										val ^= 32;
									}
								}
							} else if(i == 3) {
								p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
								if(p == null) {
									var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
									var ret9;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
										ret9.next = null;
									}
									ret9.forced = false;
									ret9.x = x1;
									ret9.y = y3;
									p = ret9;
									ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
								} else {
									var x5 = p.x;
									var y4 = p.y;
									var ret10;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
										ret10.next = null;
									}
									ret10.forced = false;
									ret10.x = x5;
									ret10.y = y4;
									p = ret10;
								}
								if(sndx) {
									p.forced = true;
								}
								if(p.y == y0 || p.y == y1) {
									if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
										val ^= 8;
									}
								}
							} else {
								p = ints.list[((yn << 1) + 1) * ints.width + xn];
								if(p == null) {
									var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
									var ret11;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
										ret11.next = null;
									}
									ret11.forced = false;
									ret11.x = x0;
									ret11.y = y5;
									p = ret11;
									ints.list[((yn << 1) + 1) * ints.width + xn] = p;
								} else {
									var x6 = p.x;
									var y6 = p.y;
									var ret12;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
										ret12.next = null;
									}
									ret12.forced = false;
									ret12.x = x6;
									ret12.y = y6;
									p = ret12;
								}
								if(fstx) {
									p.forced = true;
								}
								if(p.y == y0 || p.y == y1) {
									if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
										val ^= 128;
									}
								}
							}
							var obj = p;
							if(ret.p1 == null) {
								ret.p1 = obj.prev = obj.next = obj;
							} else {
								obj.prev = ret.p1;
								obj.next = ret.p1.next;
								ret.p1.next.prev = obj;
								ret.p1.next = obj;
							}
							ret.p1 = obj;
						}
					}
					ret.p1 = ret.p1.next;
					ret.key1 = val;
					if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
						val = 0;
						ret.key1 = 0;
						ret.p1 = null;
					}
					if(val == 0) {
						ret = null;
					} else {
						ret.pr = ret.p1;
						ret.okeyr = ret.okey1;
						ret.keyr = ret.key1;
					}
				} else {
					var val = 224;
					ret.okey1 = val;
					var _g = 0;
					while(_g < 8) {
						var i = _g++;
						if((val & 1 << i) != 0) {
							var p = null;
							if(i == 0) {
								var ret1;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.forced = false;
								ret1.x = x0;
								ret1.y = y0;
								p = ret1;
								if(fstx || fsty) {
									p.forced = true;
								}
							} else if(i == 2) {
								var ret2;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
									ret2.next = null;
								}
								ret2.forced = false;
								ret2.x = x1;
								ret2.y = y0;
								p = ret2;
								if(sndx || fsty) {
									p.forced = true;
								}
							} else if(i == 4) {
								var ret3;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
									ret3.next = null;
								}
								ret3.forced = false;
								ret3.x = x1;
								ret3.y = y1;
								p = ret3;
								if(sndx || sndy) {
									p.forced = true;
								}
							} else if(i == 6) {
								var ret4;
								if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
									ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
								} else {
									ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
									zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
									ret4.next = null;
								}
								ret4.forced = false;
								ret4.x = x0;
								ret4.y = y1;
								p = ret4;
								if(fstx || sndy) {
									p.forced = true;
								}
							} else if(i == 1) {
								p = ints.list[(yn << 1) * ints.width + xn];
								if(p == null) {
									var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
									var ret5;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
										ret5.next = null;
									}
									ret5.forced = false;
									ret5.x = x;
									ret5.y = y0;
									p = ret5;
									ints.list[(yn << 1) * ints.width + xn] = p;
								} else {
									var x2 = p.x;
									var y = p.y;
									var ret6;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
										ret6.next = null;
									}
									ret6.forced = false;
									ret6.x = x2;
									ret6.y = y;
									p = ret6;
								}
								if(fsty) {
									p.forced = true;
								}
								if(p.x == x0 || p.x == x1) {
									if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
										val ^= 2;
									}
								}
							} else if(i == 5) {
								p = ints.list[((yn << 1) + 2) * ints.width + xn];
								if(p == null) {
									var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
									var ret7;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
										ret7.next = null;
									}
									ret7.forced = false;
									ret7.x = x3;
									ret7.y = y1;
									p = ret7;
									ints.list[((yn << 1) + 2) * ints.width + xn] = p;
								} else {
									var x4 = p.x;
									var y2 = p.y;
									var ret8;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
										ret8.next = null;
									}
									ret8.forced = false;
									ret8.x = x4;
									ret8.y = y2;
									p = ret8;
								}
								if(sndy) {
									p.forced = true;
								}
								if(p.x == x0 || p.x == x1) {
									if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
										val ^= 32;
									}
								}
							} else if(i == 3) {
								p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
								if(p == null) {
									var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
									var ret9;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
										ret9.next = null;
									}
									ret9.forced = false;
									ret9.x = x1;
									ret9.y = y3;
									p = ret9;
									ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
								} else {
									var x5 = p.x;
									var y4 = p.y;
									var ret10;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
										ret10.next = null;
									}
									ret10.forced = false;
									ret10.x = x5;
									ret10.y = y4;
									p = ret10;
								}
								if(sndx) {
									p.forced = true;
								}
								if(p.y == y0 || p.y == y1) {
									if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
										val ^= 8;
									}
								}
							} else {
								p = ints.list[((yn << 1) + 1) * ints.width + xn];
								if(p == null) {
									var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
									var ret11;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
										ret11.next = null;
									}
									ret11.forced = false;
									ret11.x = x0;
									ret11.y = y5;
									p = ret11;
									ints.list[((yn << 1) + 1) * ints.width + xn] = p;
								} else {
									var x6 = p.x;
									var y6 = p.y;
									var ret12;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
										ret12.next = null;
									}
									ret12.forced = false;
									ret12.x = x6;
									ret12.y = y6;
									p = ret12;
								}
								if(fstx) {
									p.forced = true;
								}
								if(p.y == y0 || p.y == y1) {
									if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
										val ^= 128;
									}
								}
							}
							var obj = p;
							if(ret.p1 == null) {
								ret.p1 = obj.prev = obj.next = obj;
							} else {
								obj.prev = ret.p1;
								obj.next = ret.p1.next;
								ret.p1.next.prev = obj;
								ret.p1.next = obj;
							}
							ret.p1 = obj;
						}
					}
					ret.p1 = ret.p1.next;
					ret.key1 = val;
					if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
						val = 0;
						ret.key1 = 0;
						ret.p1 = null;
					}
					if(val != 0) {
						var val = 14;
						ret.okey2 = val;
						var _g = 0;
						while(_g < 8) {
							var i = _g++;
							if((val & 1 << i) != 0) {
								var p = null;
								if(i == 0) {
									var ret1;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
										ret1.next = null;
									}
									ret1.forced = false;
									ret1.x = x0;
									ret1.y = y0;
									p = ret1;
									if(fstx || fsty) {
										p.forced = true;
									}
								} else if(i == 2) {
									var ret2;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
										ret2.next = null;
									}
									ret2.forced = false;
									ret2.x = x1;
									ret2.y = y0;
									p = ret2;
									if(sndx || fsty) {
										p.forced = true;
									}
								} else if(i == 4) {
									var ret3;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
										ret3.next = null;
									}
									ret3.forced = false;
									ret3.x = x1;
									ret3.y = y1;
									p = ret3;
									if(sndx || sndy) {
										p.forced = true;
									}
								} else if(i == 6) {
									var ret4;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
										ret4.next = null;
									}
									ret4.forced = false;
									ret4.x = x0;
									ret4.y = y1;
									p = ret4;
									if(fstx || sndy) {
										p.forced = true;
									}
								} else if(i == 1) {
									p = ints.list[(yn << 1) * ints.width + xn];
									if(p == null) {
										var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
										var ret5;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.forced = false;
										ret5.x = x;
										ret5.y = y0;
										p = ret5;
										ints.list[(yn << 1) * ints.width + xn] = p;
									} else {
										var x2 = p.x;
										var y = p.y;
										var ret6;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
											ret6.next = null;
										}
										ret6.forced = false;
										ret6.x = x2;
										ret6.y = y;
										p = ret6;
									}
									if(fsty) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
											val ^= 2;
										}
									}
								} else if(i == 5) {
									p = ints.list[((yn << 1) + 2) * ints.width + xn];
									if(p == null) {
										var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
										var ret7;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
											ret7.next = null;
										}
										ret7.forced = false;
										ret7.x = x3;
										ret7.y = y1;
										p = ret7;
										ints.list[((yn << 1) + 2) * ints.width + xn] = p;
									} else {
										var x4 = p.x;
										var y2 = p.y;
										var ret8;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
											ret8.next = null;
										}
										ret8.forced = false;
										ret8.x = x4;
										ret8.y = y2;
										p = ret8;
									}
									if(sndy) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
											val ^= 32;
										}
									}
								} else if(i == 3) {
									p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
									if(p == null) {
										var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
										var ret9;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
											ret9.next = null;
										}
										ret9.forced = false;
										ret9.x = x1;
										ret9.y = y3;
										p = ret9;
										ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
									} else {
										var x5 = p.x;
										var y4 = p.y;
										var ret10;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
											ret10.next = null;
										}
										ret10.forced = false;
										ret10.x = x5;
										ret10.y = y4;
										p = ret10;
									}
									if(sndx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
											val ^= 8;
										}
									}
								} else {
									p = ints.list[((yn << 1) + 1) * ints.width + xn];
									if(p == null) {
										var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
										var ret11;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
											ret11.next = null;
										}
										ret11.forced = false;
										ret11.x = x0;
										ret11.y = y5;
										p = ret11;
										ints.list[((yn << 1) + 1) * ints.width + xn] = p;
									} else {
										var x6 = p.x;
										var y6 = p.y;
										var ret12;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
											ret12.next = null;
										}
										ret12.forced = false;
										ret12.x = x6;
										ret12.y = y6;
										p = ret12;
									}
									if(fstx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
											val ^= 128;
										}
									}
								}
								var obj = p;
								if(ret.p2 == null) {
									ret.p2 = obj.prev = obj.next = obj;
								} else {
									obj.prev = ret.p2;
									obj.next = ret.p2.next;
									ret.p2.next.prev = obj;
									ret.p2.next = obj;
								}
								ret.p2 = obj;
							}
						}
						ret.p2 = ret.p2.next;
						ret.key2 = val;
						if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
							val = 0;
							ret.key2 = 0;
							ret.p2 = null;
						}
						if(val == 0) {
							ret.pr = ret.p1;
							ret.okeyr = ret.okey1;
							ret.keyr = ret.key1;
						} else {
							ret.pr = ret.p2;
							ret.okeyr = ret.okey2;
							ret.keyr = ret.key2;
						}
					} else {
						var val = 14;
						ret.okey1 = val;
						var _g = 0;
						while(_g < 8) {
							var i = _g++;
							if((val & 1 << i) != 0) {
								var p = null;
								if(i == 0) {
									var ret1;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
										ret1.next = null;
									}
									ret1.forced = false;
									ret1.x = x0;
									ret1.y = y0;
									p = ret1;
									if(fstx || fsty) {
										p.forced = true;
									}
								} else if(i == 2) {
									var ret2;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret2 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret2 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret2.next;
										ret2.next = null;
									}
									ret2.forced = false;
									ret2.x = x1;
									ret2.y = y0;
									p = ret2;
									if(sndx || fsty) {
										p.forced = true;
									}
								} else if(i == 4) {
									var ret3;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret3 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret3 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret3.next;
										ret3.next = null;
									}
									ret3.forced = false;
									ret3.x = x1;
									ret3.y = y1;
									p = ret3;
									if(sndx || sndy) {
										p.forced = true;
									}
								} else if(i == 6) {
									var ret4;
									if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
										ret4 = new zpp_$nape_geom_ZPP_$GeomVert();
									} else {
										ret4 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
										zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret4.next;
										ret4.next = null;
									}
									ret4.forced = false;
									ret4.x = x0;
									ret4.y = y1;
									p = ret4;
									if(fstx || sndy) {
										p.forced = true;
									}
								} else if(i == 1) {
									p = ints.list[(yn << 1) * ints.width + xn];
									if(p == null) {
										var x = this.xlerp(x0,x1,y0,v0,v1,iso,quality);
										var ret5;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret5 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret5 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.forced = false;
										ret5.x = x;
										ret5.y = y0;
										p = ret5;
										ints.list[(yn << 1) * ints.width + xn] = p;
									} else {
										var x2 = p.x;
										var y = p.y;
										var ret6;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret6 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret6 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret6.next;
											ret6.next = null;
										}
										ret6.forced = false;
										ret6.x = x2;
										ret6.y = y;
										p = ret6;
									}
									if(fsty) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 1) != 0 || p.x == x1 && (val & 4) != 0) {
											val ^= 2;
										}
									}
								} else if(i == 5) {
									p = ints.list[((yn << 1) + 2) * ints.width + xn];
									if(p == null) {
										var x3 = this.xlerp(x0,x1,y1,v3,v2,iso,quality);
										var ret7;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret7 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret7 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret7.next;
											ret7.next = null;
										}
										ret7.forced = false;
										ret7.x = x3;
										ret7.y = y1;
										p = ret7;
										ints.list[((yn << 1) + 2) * ints.width + xn] = p;
									} else {
										var x4 = p.x;
										var y2 = p.y;
										var ret8;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret8 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret8 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret8.next;
											ret8.next = null;
										}
										ret8.forced = false;
										ret8.x = x4;
										ret8.y = y2;
										p = ret8;
									}
									if(sndy) {
										p.forced = true;
									}
									if(p.x == x0 || p.x == x1) {
										if(p.x == x0 && (val & 64) != 0 || p.x == x1 && (val & 16) != 0) {
											val ^= 32;
										}
									}
								} else if(i == 3) {
									p = ints.list[((yn << 1) + 1) * ints.width + (xn + 1)];
									if(p == null) {
										var y3 = this.ylerp(y0,y1,x1,v1,v2,iso,quality);
										var ret9;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret9 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret9 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret9.next;
											ret9.next = null;
										}
										ret9.forced = false;
										ret9.x = x1;
										ret9.y = y3;
										p = ret9;
										ints.list[((yn << 1) + 1) * ints.width + (xn + 1)] = p;
									} else {
										var x5 = p.x;
										var y4 = p.y;
										var ret10;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret10 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret10 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret10.next;
											ret10.next = null;
										}
										ret10.forced = false;
										ret10.x = x5;
										ret10.y = y4;
										p = ret10;
									}
									if(sndx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 4) != 0 || p.y == y1 && (val & 16) != 0) {
											val ^= 8;
										}
									}
								} else {
									p = ints.list[((yn << 1) + 1) * ints.width + xn];
									if(p == null) {
										var y5 = this.ylerp(y0,y1,x0,v0,v3,iso,quality);
										var ret11;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret11 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret11 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret11.next;
											ret11.next = null;
										}
										ret11.forced = false;
										ret11.x = x0;
										ret11.y = y5;
										p = ret11;
										ints.list[((yn << 1) + 1) * ints.width + xn] = p;
									} else {
										var x6 = p.x;
										var y6 = p.y;
										var ret12;
										if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
											ret12 = new zpp_$nape_geom_ZPP_$GeomVert();
										} else {
											ret12 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
											zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret12.next;
											ret12.next = null;
										}
										ret12.forced = false;
										ret12.x = x6;
										ret12.y = y6;
										p = ret12;
									}
									if(fstx) {
										p.forced = true;
									}
									if(p.y == y0 || p.y == y1) {
										if(p.y == y0 && (val & 1) != 0 || p.y == y1 && (val & 64) != 0) {
											val ^= 128;
										}
									}
								}
								var obj = p;
								if(ret.p1 == null) {
									ret.p1 = obj.prev = obj.next = obj;
								} else {
									obj.prev = ret.p1;
									obj.next = ret.p1.next;
									ret.p1.next.prev = obj;
									ret.p1.next = obj;
								}
								ret.p1 = obj;
							}
						}
						ret.p1 = ret.p1.next;
						ret.key1 = val;
						if(val == 1 || val == 4 || val == 16 || val == 64 || val == 3 || val == 12 || val == 48 || val == 192 || val == 129 || val == 6 || val == 24 || val == 96 || val == 5 || val == 20 || val == 80 || val == 65 || val == 17 || val == 68) {
							val = 0;
							ret.key1 = 0;
							ret.p1 = null;
						}
						if(val == 0) {
							ret = null;
						} else {
							ret.pr = ret.p1;
							ret.okeyr = ret.okey1;
							ret.keyr = ret.key1;
						}
					}
				}
			}
			return ret;
		}
	}
	,xlerp: function(x0,x1,y,v0,v1,iso,quality) {
		var xm;
		if(v0 == 0) {
			xm = x0;
		} else if(v1 == 0) {
			xm = x1;
		} else {
			var dv = v0 - v1;
			var t = dv * dv < nape_Config.epsilon * nape_Config.epsilon ? 0.5 : v0 / dv;
			if(t < 0) {
				t = 0;
			} else if(t > 1) {
				t = 1;
			}
			xm = x0 + t * (x1 - x0);
		}
		while(quality-- != 0 && x0 < xm && xm < x1) {
			var vm = iso(xm,y);
			if(vm == 0) {
				break;
			}
			if(v0 * vm < 0) {
				x1 = xm;
				v1 = vm;
			} else {
				x0 = xm;
				v0 = vm;
			}
			if(v0 == 0) {
				xm = x0;
			} else if(v1 == 0) {
				xm = x1;
			} else {
				var dv = v0 - v1;
				var t = dv * dv < nape_Config.epsilon * nape_Config.epsilon ? 0.5 : v0 / dv;
				if(t < 0) {
					t = 0;
				} else if(t > 1) {
					t = 1;
				}
				xm = x0 + t * (x1 - x0);
			}
		}
		return xm;
	}
	,ylerp: function(y0,y1,x,v0,v1,iso,quality) {
		var ym;
		if(v0 == 0) {
			ym = y0;
		} else if(v1 == 0) {
			ym = y1;
		} else {
			var dv = v0 - v1;
			var t = dv * dv < nape_Config.epsilon * nape_Config.epsilon ? 0.5 : v0 / dv;
			if(t < 0) {
				t = 0;
			} else if(t > 1) {
				t = 1;
			}
			ym = y0 + t * (y1 - y0);
		}
		while(quality-- != 0 && y0 < ym && ym < y1) {
			var vm = iso(x,ym);
			if(vm == 0) {
				break;
			}
			if(v0 * vm < 0) {
				y1 = ym;
				v1 = vm;
			} else {
				y0 = ym;
				v0 = vm;
			}
			if(v0 == 0) {
				ym = y0;
			} else if(v1 == 0) {
				ym = y1;
			} else {
				var dv = v0 - v1;
				var t = dv * dv < nape_Config.epsilon * nape_Config.epsilon ? 0.5 : v0 / dv;
				if(t < 0) {
					t = 0;
				} else if(t > 1) {
					t = 1;
				}
				ym = y0 + t * (y1 - y0);
			}
		}
		return ym;
	}
};
var zpp_$nape_geom_ZPP_$Mat23 = function() {
	this.next = null;
	this._invalidate = null;
	this.ty = 0.0;
	this.tx = 0.0;
	this.d = 0.0;
	this.c = 0.0;
	this.b = 0.0;
	this.a = 0.0;
	this.outer = null;
};
zpp_$nape_geom_ZPP_$Mat23.__name__ = true;
zpp_$nape_geom_ZPP_$Mat23.get = function() {
	var ret;
	if(zpp_$nape_geom_ZPP_$Mat23.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$Mat23();
	} else {
		ret = zpp_$nape_geom_ZPP_$Mat23.zpp_pool;
		zpp_$nape_geom_ZPP_$Mat23.zpp_pool = ret.next;
		ret.next = null;
	}
	return ret;
};
zpp_$nape_geom_ZPP_$Mat23.prototype = {
	setas: function(a,b,c,d,tx,ty) {
		this.tx = tx;
		this.ty = ty;
		this.a = a;
		this.b = b;
		this.c = c;
		this.d = d;
	}
};
var zpp_$nape_geom_ZPP_$MatMN = function(m,n) {
	this.x = null;
	this.n = 0;
	this.m = 0;
	this.outer = null;
	this.m = m;
	this.n = n;
	this.x = [];
	var _g = 0;
	var _g1 = m * n;
	while(_g < _g1) {
		var i = _g++;
		this.x.push(0.0);
	}
};
zpp_$nape_geom_ZPP_$MatMN.__name__ = true;
var zpp_$nape_geom_ZPP_$Monotone = function() { };
zpp_$nape_geom_ZPP_$Monotone.__name__ = true;
zpp_$nape_geom_ZPP_$Monotone.bisector = function(b) {
	var a = b.prev;
	var c = b.next;
	var ux = 0.0;
	var uy = 0.0;
	ux = b.x - a.x;
	uy = b.y - a.y;
	var vx = 0.0;
	var vy = 0.0;
	vx = c.x - b.x;
	vy = c.y - b.y;
	var ret;
	if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$Vec2();
	} else {
		ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.weak = false;
	ret._immutable = false;
	ret.x = -uy - vy;
	ret.y = ux + vx;
	var ret1 = ret;
	var d = ret1.x * ret1.x + ret1.y * ret1.y;
	zpp_$nape_util_ZPP_$Math.fbuf[0] = d;
	zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
	var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
	var imag = x2 * (1.5 - 0.5 * d * x2 * x2);
	var t = imag;
	ret1.x *= t;
	ret1.y *= t;
	if(vy * ux - vx * uy < 0) {
		ret1.x = -ret1.x;
		ret1.y = -ret1.y;
	}
	return ret1;
};
zpp_$nape_geom_ZPP_$Monotone.below = function(p,q) {
	if(p.y < q.y) {
		return true;
	} else if(p.y > q.y) {
		return false;
	} else if(p.x < q.x) {
		return true;
	} else if(p.x > q.x) {
		return false;
	} else {
		var po = zpp_$nape_geom_ZPP_$Monotone.bisector(p);
		var qo = zpp_$nape_geom_ZPP_$Monotone.bisector(q);
		var t = 1.0;
		po.x += p.x * t;
		po.y += p.y * t;
		var t = 1.0;
		qo.x += q.x * t;
		qo.y += q.y * t;
		var ret = po.x < qo.x || po.x == qo.x && po.y < qo.y;
		var o = po;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		var o = qo;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return ret;
	}
};
zpp_$nape_geom_ZPP_$Monotone.above = function(p,q) {
	return zpp_$nape_geom_ZPP_$Monotone.below(q,p);
};
zpp_$nape_geom_ZPP_$Monotone.left_vertex = function(p) {
	var pre = p.prev;
	if(!(pre.y > p.y)) {
		if(pre.y == p.y) {
			return p.next.y < p.y;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
zpp_$nape_geom_ZPP_$Monotone.isMonotone = function(P) {
	var min = P;
	var max = P;
	var F = P.next;
	var L = P;
	if(F != null) {
		var nite = F;
		do {
			var p = nite;
			if(p.y < min.y) {
				min = p;
			}
			if(p.y > max.y) {
				max = p;
			}
			nite = nite.next;
		} while(nite != L);
	}
	var ret = true;
	var pre = min;
	if(max != min.next) {
		var F = min.next;
		var L = max;
		if(F != null) {
			var nite = F;
			do {
				var p = nite;
				if(p.y < pre.y) {
					ret = false;
					break;
				}
				pre = p;
				nite = nite.next;
			} while(nite != L);
		}
	}
	if(!ret) {
		return false;
	}
	pre = min;
	if(max != min.prev) {
		var F = min.prev;
		var L = max;
		if(F != null) {
			var nite = F;
			do {
				var p = nite;
				if(p.y < pre.y) {
					ret = false;
					break;
				}
				pre = p;
				nite = nite.prev;
			} while(nite != L);
		}
	}
	return ret;
};
zpp_$nape_geom_ZPP_$Monotone.decompose = function(P,poly) {
	if(poly == null) {
		poly = new zpp_$nape_geom_ZPP_$PartitionedPoly(P);
	} else {
		poly.init(P);
	}
	if(poly.vertices == null) {
		return poly;
	}
	if(zpp_$nape_geom_ZPP_$Monotone.queue == null) {
		zpp_$nape_geom_ZPP_$Monotone.queue = new zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex();
	}
	var F = poly.vertices;
	var L = poly.vertices;
	if(F != null) {
		var nite = F;
		do {
			var p = nite;
			zpp_$nape_geom_ZPP_$Monotone.queue.add(p);
			var ux = 0.0;
			var uy = 0.0;
			ux = p.next.x - p.x;
			uy = p.next.y - p.y;
			var vx = 0.0;
			var vy = 0.0;
			vx = p.prev.x - p.x;
			vy = p.prev.y - p.y;
			var cx = vy * ux - vx * uy > 0.0;
			p.type = zpp_$nape_geom_ZPP_$Monotone.below(p.prev,p) ? zpp_$nape_geom_ZPP_$Monotone.below(p.next,p) ? cx ? 0 : 3 : 4 : zpp_$nape_geom_ZPP_$Monotone.below(p,p.next) ? cx ? 1 : 2 : 4;
			nite = nite.next;
		} while(nite != L);
	}
	var xxlist = zpp_$nape_geom_ZPP_$Monotone.queue;
	if(xxlist.head != null && xxlist.head.next != null) {
		var head = xxlist.head;
		var tail = null;
		var left = null;
		var right = null;
		var nxt = null;
		var listSize = 1;
		var numMerges;
		var leftSize;
		var rightSize;
		do {
			numMerges = 0;
			left = head;
			head = null;
			tail = head;
			while(left != null) {
				++numMerges;
				right = left;
				leftSize = 0;
				rightSize = listSize;
				while(right != null && leftSize < listSize) {
					++leftSize;
					right = right.next;
				}
				while(leftSize > 0 || rightSize > 0 && right != null) {
					if(leftSize == 0) {
						nxt = right;
						right = right.next;
						--rightSize;
					} else if(rightSize == 0 || right == null) {
						nxt = left;
						left = left.next;
						--leftSize;
					} else if(zpp_$nape_geom_ZPP_$Monotone.above(left.elt,right.elt)) {
						nxt = left;
						left = left.next;
						--leftSize;
					} else {
						nxt = right;
						right = right.next;
						--rightSize;
					}
					if(tail != null) {
						tail.next = nxt;
					} else {
						head = nxt;
					}
					tail = nxt;
				}
				left = right;
			}
			tail.next = null;
			listSize <<= 1;
		} while(numMerges > 1);
		xxlist.head = head;
		xxlist.modified = true;
		xxlist.pushmod = true;
	}
	if(zpp_$nape_geom_ZPP_$Monotone.edges == null) {
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool == null) {
			zpp_$nape_geom_ZPP_$Monotone.edges = new zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex();
		} else {
			zpp_$nape_geom_ZPP_$Monotone.edges = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool = zpp_$nape_geom_ZPP_$Monotone.edges.next;
			zpp_$nape_geom_ZPP_$Monotone.edges.next = null;
		}
		zpp_$nape_geom_ZPP_$Monotone.edges.lt = zpp_$nape_geom_ZPP_$PartitionVertex.edge_lt;
		zpp_$nape_geom_ZPP_$Monotone.edges.swapped = zpp_$nape_geom_ZPP_$PartitionVertex.edge_swap;
	}
	while(zpp_$nape_geom_ZPP_$Monotone.queue.head != null) {
		var v = zpp_$nape_geom_ZPP_$Monotone.queue.pop_unsafe();
		switch(v.type) {
		case 0:
			v.helper = v;
			v.node = zpp_$nape_geom_ZPP_$Monotone.edges.insert(v);
			break;
		case 1:
			var e = v.prev;
			if(e.helper.type == 2) {
				poly.add_diagonal(v,e.helper);
			}
			zpp_$nape_geom_ZPP_$Monotone.edges.remove_node(e.node);
			break;
		case 2:
			var e1 = v.prev;
			if(e1.helper.type == 2) {
				poly.add_diagonal(v,e1.helper);
			}
			zpp_$nape_geom_ZPP_$Monotone.edges.remove_node(e1.node);
			var ret = null;
			if(!zpp_$nape_geom_ZPP_$Monotone.edges.empty()) {
				var set_ite = zpp_$nape_geom_ZPP_$Monotone.edges.parent;
				while(set_ite.prev != null) set_ite = set_ite.prev;
				while(set_ite != null) {
					var elt = set_ite.data;
					if(!zpp_$nape_geom_ZPP_$PartitionVertex.vert_lt(elt,v)) {
						ret = elt;
						break;
					}
					if(set_ite.next != null) {
						set_ite = set_ite.next;
						while(set_ite.prev != null) set_ite = set_ite.prev;
					} else {
						while(set_ite.parent != null && set_ite == set_ite.parent.next) set_ite = set_ite.parent;
						set_ite = set_ite.parent;
					}
				}
			}
			var e2 = ret;
			if(e2 != null) {
				if(e2.helper.type == 2) {
					poly.add_diagonal(v,e2.helper);
				}
				e2.helper = v;
			}
			break;
		case 3:
			var ret1 = null;
			if(!zpp_$nape_geom_ZPP_$Monotone.edges.empty()) {
				var set_ite1 = zpp_$nape_geom_ZPP_$Monotone.edges.parent;
				while(set_ite1.prev != null) set_ite1 = set_ite1.prev;
				while(set_ite1 != null) {
					var elt1 = set_ite1.data;
					if(!zpp_$nape_geom_ZPP_$PartitionVertex.vert_lt(elt1,v)) {
						ret1 = elt1;
						break;
					}
					if(set_ite1.next != null) {
						set_ite1 = set_ite1.next;
						while(set_ite1.prev != null) set_ite1 = set_ite1.prev;
					} else {
						while(set_ite1.parent != null && set_ite1 == set_ite1.parent.next) set_ite1 = set_ite1.parent;
						set_ite1 = set_ite1.parent;
					}
				}
			}
			var e3 = ret1;
			if(e3 != null) {
				poly.add_diagonal(v,e3.helper);
				e3.helper = v;
			}
			v.node = zpp_$nape_geom_ZPP_$Monotone.edges.insert(v);
			v.helper = v;
			break;
		case 4:
			var pre = v.prev;
			if(zpp_$nape_geom_ZPP_$Monotone.left_vertex(v)) {
				if(pre.helper.type == 2) {
					poly.add_diagonal(v,pre.helper);
				}
				zpp_$nape_geom_ZPP_$Monotone.edges.remove_node(pre.node);
				v.node = zpp_$nape_geom_ZPP_$Monotone.edges.insert(v);
				v.helper = v;
			} else {
				var ret2 = null;
				if(!zpp_$nape_geom_ZPP_$Monotone.edges.empty()) {
					var set_ite2 = zpp_$nape_geom_ZPP_$Monotone.edges.parent;
					while(set_ite2.prev != null) set_ite2 = set_ite2.prev;
					while(set_ite2 != null) {
						var elt2 = set_ite2.data;
						if(!zpp_$nape_geom_ZPP_$PartitionVertex.vert_lt(elt2,v)) {
							ret2 = elt2;
							break;
						}
						if(set_ite2.next != null) {
							set_ite2 = set_ite2.next;
							while(set_ite2.prev != null) set_ite2 = set_ite2.prev;
						} else {
							while(set_ite2.parent != null && set_ite2 == set_ite2.parent.next) set_ite2 = set_ite2.parent;
							set_ite2 = set_ite2.parent;
						}
					}
				}
				var e4 = ret2;
				if(e4.helper.type == 2) {
					poly.add_diagonal(v,e4.helper);
				}
				e4.helper = v;
			}
			break;
		}
	}
	return poly;
};
var zpp_$nape_geom_ZPP_$PartitionVertex = function() {
	this.node = null;
	this.prev = null;
	this.next = null;
	this.rightchain = false;
	this.helper = null;
	this.type = 0;
	this.diagonals = null;
	this.forced = false;
	this.y = 0.0;
	this.x = 0.0;
	this.mag = 0;
	this.id = 0;
	this.id = zpp_$nape_geom_ZPP_$PartitionVertex.nextId++;
	this.diagonals = new zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex();
};
zpp_$nape_geom_ZPP_$PartitionVertex.__name__ = true;
zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance = function(edge,vert) {
	var flip = edge.next.y > edge.y;
	var ux = 0.0;
	var uy = 0.0;
	ux = edge.next.x - edge.x;
	uy = edge.next.y - edge.y;
	var vx = 0.0;
	var vy = 0.0;
	vx = vert.x - edge.x;
	vy = vert.y - edge.y;
	return (flip ? -1.0 : 1.0) * (vy * ux - vx * uy);
};
zpp_$nape_geom_ZPP_$PartitionVertex.vert_lt = function(edge,vert) {
	if(vert == edge || vert == edge.next) {
		return true;
	} else if(edge.y == edge.next.y) {
		var x = edge.x;
		var y = edge.next.x;
		return (x < y ? x : y) <= vert.x;
	} else {
		return zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(edge,vert) <= 0.0;
	}
};
zpp_$nape_geom_ZPP_$PartitionVertex.edge_swap = function(p,q) {
	var t = p.node;
	p.node = q.node;
	q.node = t;
};
zpp_$nape_geom_ZPP_$PartitionVertex.edge_lt = function(p,q) {
	if(p == q && p.next == q.next) {
		return false;
	}
	if(p == q.next) {
		return !zpp_$nape_geom_ZPP_$PartitionVertex.vert_lt(p,q);
	} else if(q == p.next) {
		return zpp_$nape_geom_ZPP_$PartitionVertex.vert_lt(q,p);
	} else if(p.y == p.next.y) {
		if(q.y == q.next.y) {
			var x = p.x;
			var y = p.next.x;
			var x1 = q.x;
			var y1 = q.next.x;
			return (x > y ? x : y) > (x1 > y1 ? x1 : y1);
		} else if(!(zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(q,p) > 0.0)) {
			return zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(q,p.next) > 0.0;
		} else {
			return true;
		}
	} else {
		var qRight = zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(p,q);
		var qNextRight = zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(p,q.next);
		if(qRight == 0 && qNextRight == 0) {
			var x = p.x;
			var y = p.next.x;
			var x1 = q.x;
			var y1 = q.next.x;
			return (x > y ? x : y) > (x1 > y1 ? x1 : y1);
		}
		if(qRight * qNextRight >= 0) {
			if(!(qRight < 0)) {
				return qNextRight < 0;
			} else {
				return true;
			}
		}
		var pRight = zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(q,p);
		var pNextRight = zpp_$nape_geom_ZPP_$PartitionVertex.rightdistance(q,p.next);
		if(pRight * pNextRight >= 0) {
			if(!(pRight > 0)) {
				return pNextRight > 0;
			} else {
				return true;
			}
		}
		return false;
	}
};
zpp_$nape_geom_ZPP_$PartitionVertex.prototype = {
	sort: function() {
		var ux = 0.0;
		var uy = 0.0;
		var vx = 0.0;
		var vy = 0.0;
		ux = this.prev.x - this.x;
		uy = this.prev.y - this.y;
		vx = this.next.x - this.x;
		vy = this.next.y - this.y;
		var ret = vy * ux - vx * uy;
		var vorient = ret > 0 ? -1 : ret == 0 ? 0 : 1;
		var xxlist = this.diagonals;
		if(xxlist.head != null && xxlist.head.next != null) {
			var head = xxlist.head;
			var tail = null;
			var left = null;
			var right = null;
			var nxt = null;
			var listSize = 1;
			var numMerges;
			var leftSize;
			var rightSize;
			do {
				numMerges = 0;
				left = head;
				head = null;
				tail = head;
				while(left != null) {
					++numMerges;
					right = left;
					leftSize = 0;
					rightSize = listSize;
					while(right != null && leftSize < listSize) {
						++leftSize;
						right = right.next;
					}
					while(leftSize > 0 || rightSize > 0 && right != null) {
						if(leftSize == 0) {
							nxt = right;
							right = right.next;
							--rightSize;
						} else if(rightSize == 0 || right == null) {
							nxt = left;
							left = left.next;
							--leftSize;
						} else {
							var tmp;
							if(vorient == 1) {
								ux = left.elt.x - this.x;
								uy = left.elt.y - this.y;
								vx = right.elt.x - this.x;
								vy = right.elt.y - this.y;
								var ret = vy * ux - vx * uy;
								tmp = (ret > 0 ? -1 : ret == 0 ? 0 : 1) == 1;
							} else {
								ux = this.prev.x - this.x;
								uy = this.prev.y - this.y;
								vx = left.elt.x - this.x;
								vy = left.elt.y - this.y;
								var ret1 = vy * ux - vx * uy;
								var d1 = ret1 > 0 ? -1 : ret1 == 0 ? 0 : 1;
								ux = this.prev.x - this.x;
								uy = this.prev.y - this.y;
								vx = right.elt.x - this.x;
								vy = right.elt.y - this.y;
								var ret2 = vy * ux - vx * uy;
								var d2 = ret2 > 0 ? -1 : ret2 == 0 ? 0 : 1;
								if(d1 * d2 == 1 || d1 * d2 == 0 && (d1 == 1 || d2 == 1)) {
									ux = left.elt.x - this.x;
									uy = left.elt.y - this.y;
									vx = right.elt.x - this.x;
									vy = right.elt.y - this.y;
									var ret3 = vy * ux - vx * uy;
									tmp = (ret3 > 0 ? -1 : ret3 == 0 ? 0 : 1) == 1;
								} else if(d1 == -1 || d2 == -1) {
									tmp = d2 == -1;
								} else if(d1 == 0 && d2 == 0) {
									ux = this.x - this.prev.x;
									uy = this.y - this.prev.y;
									vx = left.elt.x - this.x;
									vy = left.elt.y - this.y;
									var d11 = ux * vx + uy * vy;
									vx = right.elt.x - this.x;
									vy = right.elt.y - this.y;
									var d21 = ux * vx + uy * vy;
									tmp = d11 < 0 && d21 > 0 ? true : d21 < 0 && d11 > 0 ? false : true;
								} else {
									tmp = true;
								}
							}
							if(tmp) {
								nxt = left;
								left = left.next;
								--leftSize;
							} else {
								nxt = right;
								right = right.next;
								--rightSize;
							}
						}
						if(tail != null) {
							tail.next = nxt;
						} else {
							head = nxt;
						}
						tail = nxt;
					}
					left = right;
				}
				tail.next = null;
				listSize <<= 1;
			} while(numMerges > 1);
			xxlist.head = head;
			xxlist.modified = true;
			xxlist.pushmod = true;
		}
	}
};
var zpp_$nape_geom_ZPP_$PartitionedPoly = function(P) {
	this.next = null;
	this.vertices = null;
	this.init(P);
};
zpp_$nape_geom_ZPP_$PartitionedPoly.__name__ = true;
zpp_$nape_geom_ZPP_$PartitionedPoly.prototype = {
	eq: function(a,b) {
		var dx = 0.0;
		var dy = 0.0;
		dx = a.x - b.x;
		dy = a.y - b.y;
		return dx * dx + dy * dy < nape_Config.epsilon * nape_Config.epsilon;
	}
	,init: function(P) {
		if(P == null) {
			return;
		}
		var area = 0.0;
		var F = P;
		var L = P;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				area += v.x * (v.next.y - v.prev.y);
				nite = nite.next;
			} while(nite != L);
		}
		var cw = area * 0.5 > 0.0;
		var p = P;
		do {
			var tmp;
			if(cw) {
				var ret;
				if(zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool == null) {
					ret = new zpp_$nape_geom_ZPP_$PartitionVertex();
				} else {
					ret = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.x = p.x;
				ret.y = p.y;
				var obj = ret;
				if(this.vertices == null) {
					this.vertices = obj.prev = obj.next = obj;
				} else {
					obj.prev = this.vertices;
					obj.next = this.vertices.next;
					this.vertices.next.prev = obj;
					this.vertices.next = obj;
				}
				tmp = obj;
			} else {
				var ret1;
				if(zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$PartitionVertex();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.x = p.x;
				ret1.y = p.y;
				var obj1 = ret1;
				if(this.vertices == null) {
					this.vertices = obj1.prev = obj1.next = obj1;
				} else {
					obj1.next = this.vertices;
					obj1.prev = this.vertices.prev;
					this.vertices.prev.next = obj1;
					this.vertices.prev = obj1;
				}
				tmp = obj1;
			}
			this.vertices = tmp;
			this.vertices.forced = p.forced;
			p = p.next;
		} while(p != P);
		this.remove_collinear_vertices();
	}
	,remove_collinear_vertices: function() {
		var p = this.vertices;
		var skip = true;
		while(skip || p != this.vertices) {
			skip = false;
			if(this.eq(p,p.next)) {
				if(p == this.vertices) {
					this.vertices = p.next;
					skip = true;
				}
				if(p.forced) {
					p.next.forced = true;
				}
				if(p != null && p.prev == p) {
					p.next = p.prev = null;
					var o = p;
					o.helper = null;
					o.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o;
					p = null;
				} else {
					var retnodes = p.next;
					p.prev.next = p.next;
					p.next.prev = p.prev;
					p.next = p.prev = null;
					var o1 = p;
					o1.helper = null;
					o1.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o1;
					p = null;
					p = retnodes;
				}
				if(p == null) {
					this.vertices = null;
					break;
				}
			} else {
				p = p.next;
			}
		}
		if(this.vertices == null) {
			return true;
		}
		var removed;
		do {
			removed = false;
			p = this.vertices;
			skip = true;
			while(skip || p != this.vertices) {
				skip = false;
				var pre = p.prev;
				var ux = 0.0;
				var uy = 0.0;
				ux = p.x - pre.x;
				uy = p.y - pre.y;
				var vx = 0.0;
				var vy = 0.0;
				vx = p.next.x - p.x;
				vy = p.next.y - p.y;
				var crs = vy * ux - vx * uy;
				if(crs * crs >= nape_Config.epsilon * nape_Config.epsilon) {
					p = p.next;
				} else {
					if(p == this.vertices) {
						this.vertices = p.next;
						skip = true;
					}
					if(p != null && p.prev == p) {
						p.next = p.prev = null;
						var o = p;
						o.helper = null;
						o.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
						zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o;
						p = null;
					} else {
						var retnodes = p.next;
						p.prev.next = p.next;
						p.next.prev = p.prev;
						p.next = p.prev = null;
						var o1 = p;
						o1.helper = null;
						o1.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
						zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o1;
						p = null;
						p = retnodes;
					}
					removed = true;
					if(p == null) {
						removed = false;
						this.vertices = null;
						break;
					}
				}
			}
		} while(removed);
		return this.vertices == null;
	}
	,add_diagonal: function(p,q) {
		p.diagonals.add(q);
		q.diagonals.add(p);
		p.forced = q.forced = true;
	}
	,extract_partitions: function(ret) {
		if(ret == null) {
			ret = new zpp_$nape_util_ZNPList_$ZPP_$PartitionedPoly();
		}
		if(this.vertices != null) {
			var F = this.vertices;
			var L = this.vertices;
			if(F != null) {
				var nite = F;
				do {
					var c = nite;
					c.sort();
					nite = nite.next;
				} while(nite != L);
			}
			this.pull_partitions(this.vertices,ret);
			while(this.vertices != null) {
				var tmp;
				if(this.vertices != null && this.vertices.prev == this.vertices) {
					this.vertices.next = this.vertices.prev = null;
					var o = this.vertices;
					o.helper = null;
					o.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o;
					tmp = this.vertices = null;
				} else {
					var retnodes = this.vertices.next;
					this.vertices.prev.next = this.vertices.next;
					this.vertices.next.prev = this.vertices.prev;
					this.vertices.next = this.vertices.prev = null;
					var o1 = this.vertices;
					o1.helper = null;
					o1.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o1;
					this.vertices = null;
					tmp = retnodes;
				}
				this.vertices = tmp;
			}
			var pre = null;
			var cx_ite = ret.head;
			while(cx_ite != null) {
				var p = cx_ite.elt;
				if(p.remove_collinear_vertices()) {
					ret.erase(pre);
					continue;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
		}
		return ret;
	}
	,pull_partitions: function(start,ret) {
		var poly;
		if(zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool == null) {
			poly = new zpp_$nape_geom_ZPP_$PartitionedPoly();
		} else {
			poly = zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool;
			zpp_$nape_geom_ZPP_$PartitionedPoly.zpp_pool = poly.next;
			poly.next = null;
		}
		var next = start;
		do {
			var ret1;
			if(zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$PartitionVertex();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
				zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.x = next.x;
			ret1.y = next.y;
			ret1.forced = next.forced;
			var obj = ret1;
			if(poly.vertices == null) {
				poly.vertices = obj.prev = obj.next = obj;
			} else {
				obj.prev = poly.vertices;
				obj.next = poly.vertices.next;
				poly.vertices.next.prev = obj;
				poly.vertices.next = obj;
			}
			poly.vertices = obj;
			poly.vertices.forced = next.forced;
			if(next.diagonals.head != null) {
				var _this = next.diagonals;
				var ret2 = _this.head.elt;
				_this.pop();
				var diag = ret2;
				if(diag == start) {
					break;
				} else {
					next = this.pull_partitions(next,ret);
				}
			} else {
				next = next.next;
			}
		} while(next != start);
		var area = 0.0;
		var F = poly.vertices;
		var L = poly.vertices;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				area += v.x * (v.next.y - v.prev.y);
				nite = nite.next;
			} while(nite != L);
		}
		if(area * 0.5 != 0) {
			ret.add(poly);
		}
		return next;
	}
	,extract: function(ret) {
		if(ret == null) {
			ret = new zpp_$nape_util_ZNPList_$ZPP_$GeomVert();
		}
		if(this.vertices != null) {
			var F = this.vertices;
			var L = this.vertices;
			if(F != null) {
				var nite = F;
				do {
					var c = nite;
					c.sort();
					nite = nite.next;
				} while(nite != L);
			}
			this.pull(this.vertices,ret);
			while(this.vertices != null) {
				var tmp;
				if(this.vertices != null && this.vertices.prev == this.vertices) {
					this.vertices.next = this.vertices.prev = null;
					var o = this.vertices;
					o.helper = null;
					o.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o;
					tmp = this.vertices = null;
				} else {
					var retnodes = this.vertices.next;
					this.vertices.prev.next = this.vertices.next;
					this.vertices.next.prev = this.vertices.prev;
					this.vertices.next = this.vertices.prev = null;
					var o1 = this.vertices;
					o1.helper = null;
					o1.next = zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool;
					zpp_$nape_geom_ZPP_$PartitionVertex.zpp_pool = o1;
					this.vertices = null;
					tmp = retnodes;
				}
				this.vertices = tmp;
			}
		}
		return ret;
	}
	,pull: function(start,ret) {
		var poly = null;
		var next = start;
		do {
			var x = next.x;
			var y = next.y;
			var ret1;
			if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
				zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.forced = false;
			ret1.x = x;
			ret1.y = y;
			var obj = ret1;
			if(poly == null) {
				poly = obj.prev = obj.next = obj;
			} else {
				obj.prev = poly;
				obj.next = poly.next;
				poly.next.prev = obj;
				poly.next = obj;
			}
			poly = obj;
			poly.forced = next.forced;
			if(next.diagonals.head != null) {
				var _this = next.diagonals;
				var ret2 = _this.head.elt;
				_this.pop();
				var diag = ret2;
				if(diag == start) {
					break;
				} else {
					next = this.pull(next,ret);
				}
			} else {
				next = next.next;
			}
		} while(next != start);
		var area = 0.0;
		var F = poly;
		var L = poly;
		if(F != null) {
			var nite = F;
			do {
				var v = nite;
				area += v.x * (v.next.y - v.prev.y);
				nite = nite.next;
			} while(nite != L);
		}
		var area1 = area * 0.5;
		if(area1 * area1 >= nape_Config.epsilon * nape_Config.epsilon) {
			var p = poly;
			var skip = true;
			while(skip || p != poly) {
				skip = false;
				var dx = 0.0;
				var dy = 0.0;
				dx = p.x - p.next.x;
				dy = p.y - p.next.y;
				if(dx * dx + dy * dy < nape_Config.epsilon * nape_Config.epsilon) {
					if(p == poly) {
						poly = p.next;
						skip = true;
					}
					if(p.forced) {
						p.next.forced = true;
					}
					if(p != null && p.prev == p) {
						p.next = p.prev = null;
						p = null;
					} else {
						var retnodes = p.next;
						p.prev.next = p.next;
						p.next.prev = p.prev;
						p.next = p.prev = null;
						p = null;
						p = retnodes;
					}
					if(p == null) {
						poly = null;
						break;
					}
				} else {
					p = p.next;
				}
			}
			if(poly != null) {
				var removed;
				do {
					removed = false;
					p = poly;
					skip = true;
					while(skip || p != poly) {
						skip = false;
						var pre = p.prev;
						var ux = 0.0;
						var uy = 0.0;
						ux = p.x - pre.x;
						uy = p.y - pre.y;
						var vx = 0.0;
						var vy = 0.0;
						vx = p.next.x - p.x;
						vy = p.next.y - p.y;
						var crs = vy * ux - vx * uy;
						if(crs * crs >= nape_Config.epsilon * nape_Config.epsilon) {
							p = p.next;
						} else {
							if(p == poly) {
								poly = p.next;
								skip = true;
							}
							if(p != null && p.prev == p) {
								p.next = p.prev = null;
								p = null;
							} else {
								var retnodes = p.next;
								p.prev.next = p.next;
								p.next.prev = p.prev;
								p.next = p.prev = null;
								p = null;
								p = retnodes;
							}
							removed = true;
							if(p == null) {
								removed = false;
								poly = null;
								break;
							}
						}
					}
				} while(removed);
			}
			if(poly != null) {
				ret.add(poly);
			}
		}
		return next;
	}
};
var zpp_$nape_geom_ZPP_$Ray = function() {
	this.zip_dir = false;
	this.absnormaly = 0.0;
	this.absnormalx = 0.0;
	this.normaly = 0.0;
	this.normalx = 0.0;
	this.idiry = 0.0;
	this.idirx = 0.0;
	this.diry = 0.0;
	this.dirx = 0.0;
	this.originy = 0.0;
	this.originx = 0.0;
	this.userData = null;
	this.maxdist = 0.0;
	this.direction = null;
	this.origin = null;
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret = new nape_geom_Vec2();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(ret.zpp_inner == null) {
		var ret1;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.weak = false;
		ret1._immutable = false;
		ret1.x = 0;
		ret1.y = 0;
		ret.zpp_inner = ret1;
		ret.zpp_inner.outer = ret;
	} else {
		var tmp;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret.zpp_inner.x == 0) {
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret.zpp_inner.y == 0;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret.zpp_inner.x = 0;
			ret.zpp_inner.y = 0;
			var _this = ret.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret.zpp_inner.weak = false;
	this.origin = ret;
	this.origin.zpp_inner._invalidate = $bind(this,this.origin_invalidate);
	var ret;
	if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
		ret = new nape_geom_Vec2();
	} else {
		ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
		zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
		ret.zpp_pool = null;
	}
	if(ret.zpp_inner == null) {
		var ret1;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.weak = false;
		ret1._immutable = false;
		ret1.x = 0;
		ret1.y = 0;
		ret.zpp_inner = ret1;
		ret.zpp_inner.outer = ret;
	} else {
		var tmp;
		var _this = ret.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		if(ret.zpp_inner.x == 0) {
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			tmp = ret.zpp_inner.y == 0;
		} else {
			tmp = false;
		}
		if(!tmp) {
			ret.zpp_inner.x = 0;
			ret.zpp_inner.y = 0;
			var _this = ret.zpp_inner;
			if(_this._invalidate != null) {
				_this._invalidate(_this);
			}
		}
	}
	ret.zpp_inner.weak = false;
	this.direction = ret;
	this.direction.zpp_inner._invalidate = $bind(this,this.direction_invalidate);
	this.originx = 0;
	this.originy = 0;
	this.dirx = 0;
	this.diry = 0;
	this.zip_dir = false;
};
zpp_$nape_geom_ZPP_$Ray.__name__ = true;
zpp_$nape_geom_ZPP_$Ray.prototype = {
	origin_invalidate: function(x) {
		this.originx = x.x;
		this.originy = x.y;
	}
	,direction_invalidate: function(x) {
		this.dirx = x.x;
		this.diry = x.y;
		this.zip_dir = true;
	}
	,validate_dir: function() {
		if(this.zip_dir) {
			this.zip_dir = false;
			var d = this.dirx * this.dirx + this.diry * this.diry;
			var imag = 1.0 / Math.sqrt(d);
			var t = imag;
			this.dirx *= t;
			this.diry *= t;
			this.idirx = 1 / this.dirx;
			this.idiry = 1 / this.diry;
			this.normalx = -this.diry;
			this.normaly = this.dirx;
			var x = this.normalx;
			this.absnormalx = x < 0 ? -x : x;
			var x = this.normaly;
			this.absnormaly = x < 0 ? -x : x;
		}
	}
	,rayAABB: function() {
		var x0 = this.originx;
		var x1 = x0;
		var y0 = this.originy;
		var y1 = y0;
		if(this.maxdist >= Infinity) {
			if(this.dirx > 0) {
				x1 = Infinity;
			} else if(this.dirx < 0) {
				x1 = -Infinity;
			}
			if(this.diry > 0) {
				y1 = Infinity;
			} else if(this.diry < 0) {
				y1 = -Infinity;
			}
		} else {
			x1 += this.maxdist * this.dirx;
			y1 += this.maxdist * this.diry;
		}
		if(x1 < x0) {
			var t = x0;
			x0 = x1;
			x1 = t;
		}
		if(y1 < y0) {
			var t = y0;
			y0 = y1;
			y1 = t;
		}
		var ret;
		if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$AABB();
		} else {
			ret = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.minx = x0;
		ret.miny = y0;
		ret.maxx = x1;
		ret.maxy = y1;
		var rayab = ret;
		return rayab;
	}
	,aabbtest: function(a) {
		var dot1 = this.normalx * (this.originx - 0.5 * (a.minx + a.maxx)) + this.normaly * (this.originy - 0.5 * (a.miny + a.maxy));
		var dot2 = this.absnormalx * 0.5 * (a.maxx - a.minx) + this.absnormaly * 0.5 * (a.maxy - a.miny);
		var x = dot1;
		return (x < 0 ? -x : x) < dot2;
	}
	,aabbsect: function(a) {
		var cx = this.originx >= a.minx && this.originx <= a.maxx;
		var cy = this.originy >= a.miny && this.originy <= a.maxy;
		if(cx && cy) {
			return 0.0;
		} else {
			var ret = -1.0;
			while(!(this.dirx >= 0 && this.originx >= a.maxx)) {
				if(this.dirx <= 0 && this.originx <= a.minx) {
					break;
				}
				if(this.diry >= 0 && this.originy >= a.maxy) {
					break;
				}
				if(this.diry <= 0 && this.originy <= a.miny) {
					break;
				}
				if(this.dirx > 0) {
					var t = (a.minx - this.originx) * this.idirx;
					if(t >= 0 && t <= this.maxdist) {
						var y = this.originy + t * this.diry;
						if(y >= a.miny && y <= a.maxy) {
							ret = t;
							break;
						}
					}
				} else if(this.dirx < 0) {
					var t1 = (a.maxx - this.originx) * this.idirx;
					if(t1 >= 0 && t1 <= this.maxdist) {
						var y1 = this.originy + t1 * this.diry;
						if(y1 >= a.miny && y1 <= a.maxy) {
							ret = t1;
							break;
						}
					}
				}
				if(this.diry > 0) {
					var t2 = (a.miny - this.originy) * this.idiry;
					if(t2 >= 0 && t2 <= this.maxdist) {
						var x = this.originx + t2 * this.dirx;
						if(x >= a.minx && x <= a.maxx) {
							ret = t2;
							break;
						}
					}
				} else if(this.diry < 0) {
					var t3 = (a.maxy - this.originy) * this.idiry;
					if(t3 >= 0 && t3 <= this.maxdist) {
						var x1 = this.originx + t3 * this.dirx;
						if(x1 >= a.minx && x1 <= a.maxx) {
							ret = t3;
							break;
						}
					}
				}
				if(!false) {
					break;
				}
			}
			return ret;
		}
	}
	,circlesect: function(c,inner,mint) {
		if(c.zip_worldCOM) {
			if(c.body != null) {
				c.zip_worldCOM = false;
				if(c.zip_localCOM) {
					c.zip_localCOM = false;
					if(c.type == 1) {
						var _this = c.polygon;
						if(_this.lverts.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
						} else if(_this.lverts.next.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
							var t = 1.0;
							_this.localCOMx += _this.lverts.next.next.x * t;
							_this.localCOMy += _this.lverts.next.next.y * t;
							var t = 0.5;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						} else {
							_this.localCOMx = 0;
							_this.localCOMy = 0;
							var area = 0.0;
							var cx_ite = _this.lverts.next;
							var u = cx_ite;
							cx_ite = cx_ite.next;
							var v = cx_ite;
							cx_ite = cx_ite.next;
							while(cx_ite != null) {
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this.localCOMx += (v.x + w.x) * cf;
								_this.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite = cx_ite.next;
							}
							cx_ite = _this.lverts.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							u = v;
							v = w;
							cx_ite = cx_ite.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							area = 1 / (3 * area);
							var t = area;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						}
					}
					if(c.wrap_localCOM != null) {
						c.wrap_localCOM.zpp_inner.x = c.localCOMx;
						c.wrap_localCOM.zpp_inner.y = c.localCOMy;
					}
				}
				var _this = c.body;
				if(_this.zip_axis) {
					_this.zip_axis = false;
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				}
				c.worldCOMx = c.body.posx + (c.body.axisy * c.localCOMx - c.body.axisx * c.localCOMy);
				c.worldCOMy = c.body.posy + (c.localCOMx * c.body.axisx + c.localCOMy * c.body.axisy);
			}
		}
		var acx = 0.0;
		var acy = 0.0;
		acx = this.originx - c.worldCOMx;
		acy = this.originy - c.worldCOMy;
		var A = this.dirx * this.dirx + this.diry * this.diry;
		var B = 2 * (acx * this.dirx + acy * this.diry);
		var C = acx * acx + acy * acy - c.radius * c.radius;
		var det = B * B - 4 * A * C;
		if(det == 0) {
			var t = -B / 2 * A;
			if((!inner || C > 0) && t > 0 && t < mint && t <= this.maxdist) {
				var nx = 0.0;
				var ny = 0.0;
				nx = this.originx;
				ny = this.originy;
				var t1 = t;
				nx += this.dirx * t1;
				ny += this.diry * t1;
				var t1 = 1.0;
				nx -= c.worldCOMx * t1;
				ny -= c.worldCOMy * t1;
				var d = nx * nx + ny * ny;
				var imag = 1.0 / Math.sqrt(d);
				var t1 = imag;
				nx *= t1;
				ny *= t1;
				if(C <= 0) {
					nx = -nx;
					ny = -ny;
				}
				var x = nx;
				var y = ny;
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret = new nape_geom_Vec2();
				} else {
					ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
					ret.zpp_pool = null;
				}
				if(ret.zpp_inner == null) {
					var ret1;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret1 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.weak = false;
					ret1._immutable = false;
					ret1.x = x;
					ret1.y = y;
					ret.zpp_inner = ret1;
					ret.zpp_inner.outer = ret;
				} else {
					var tmp;
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					if(ret.zpp_inner.x == x) {
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						tmp = ret.zpp_inner.y == y;
					} else {
						tmp = false;
					}
					if(!tmp) {
						ret.zpp_inner.x = x;
						ret.zpp_inner.y = y;
						var _this = ret.zpp_inner;
						if(_this._invalidate != null) {
							_this._invalidate(_this);
						}
					}
				}
				ret.zpp_inner.weak = false;
				return zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,t,C <= 0,c.outer);
			} else {
				return null;
			}
		} else {
			det = Math.sqrt(det);
			A = 1 / (2 * A);
			var t0 = (-B - det) * A;
			var t1 = (-B + det) * A;
			if(t0 > 0) {
				if(t0 < mint && t0 <= this.maxdist) {
					var nx = 0.0;
					var ny = 0.0;
					nx = this.originx;
					ny = this.originy;
					var t = t0;
					nx += this.dirx * t;
					ny += this.diry * t;
					var t = 1.0;
					nx -= c.worldCOMx * t;
					ny -= c.worldCOMy * t;
					var d = nx * nx + ny * ny;
					var imag = 1.0 / Math.sqrt(d);
					var t = imag;
					nx *= t;
					ny *= t;
					var x = nx;
					var y = ny;
					if(y == null) {
						y = 0;
					}
					if(x == null) {
						x = 0;
					}
					var ret;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret = new nape_geom_Vec2();
					} else {
						ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
						ret.zpp_pool = null;
					}
					if(ret.zpp_inner == null) {
						var ret1;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret1 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
							ret1.next = null;
						}
						ret1.weak = false;
						ret1._immutable = false;
						ret1.x = x;
						ret1.y = y;
						ret.zpp_inner = ret1;
						ret.zpp_inner.outer = ret;
					} else {
						var tmp;
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						if(ret.zpp_inner.x == x) {
							var _this = ret.zpp_inner;
							if(_this._validate != null) {
								_this._validate();
							}
							tmp = ret.zpp_inner.y == y;
						} else {
							tmp = false;
						}
						if(!tmp) {
							ret.zpp_inner.x = x;
							ret.zpp_inner.y = y;
							var _this = ret.zpp_inner;
							if(_this._invalidate != null) {
								_this._invalidate(_this);
							}
						}
					}
					ret.zpp_inner.weak = false;
					return zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,t0,false,c.outer);
				} else {
					return null;
				}
			} else if(t1 > 0 && inner) {
				if(t1 < mint && t1 <= this.maxdist) {
					var nx = 0.0;
					var ny = 0.0;
					nx = this.originx;
					ny = this.originy;
					var t = t1;
					nx += this.dirx * t;
					ny += this.diry * t;
					var t = 1.0;
					nx -= c.worldCOMx * t;
					ny -= c.worldCOMy * t;
					var d = nx * nx + ny * ny;
					var imag = 1.0 / Math.sqrt(d);
					var t = imag;
					nx *= t;
					ny *= t;
					nx = -nx;
					ny = -ny;
					var x = nx;
					var y = ny;
					if(y == null) {
						y = 0;
					}
					if(x == null) {
						x = 0;
					}
					var ret;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret = new nape_geom_Vec2();
					} else {
						ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
						ret.zpp_pool = null;
					}
					if(ret.zpp_inner == null) {
						var ret1;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret1 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
							ret1.next = null;
						}
						ret1.weak = false;
						ret1._immutable = false;
						ret1.x = x;
						ret1.y = y;
						ret.zpp_inner = ret1;
						ret.zpp_inner.outer = ret;
					} else {
						var tmp;
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						if(ret.zpp_inner.x == x) {
							var _this = ret.zpp_inner;
							if(_this._validate != null) {
								_this._validate();
							}
							tmp = ret.zpp_inner.y == y;
						} else {
							tmp = false;
						}
						if(!tmp) {
							ret.zpp_inner.x = x;
							ret.zpp_inner.y = y;
							var _this = ret.zpp_inner;
							if(_this._invalidate != null) {
								_this._invalidate(_this);
							}
						}
					}
					ret.zpp_inner.weak = false;
					return zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,t1,true,c.outer);
				} else {
					return null;
				}
			} else {
				return null;
			}
		}
	}
	,circlesect2: function(c,inner,list) {
		if(c.zip_worldCOM) {
			if(c.body != null) {
				c.zip_worldCOM = false;
				if(c.zip_localCOM) {
					c.zip_localCOM = false;
					if(c.type == 1) {
						var _this = c.polygon;
						if(_this.lverts.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
						} else if(_this.lverts.next.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
							var t = 1.0;
							_this.localCOMx += _this.lverts.next.next.x * t;
							_this.localCOMy += _this.lverts.next.next.y * t;
							var t = 0.5;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						} else {
							_this.localCOMx = 0;
							_this.localCOMy = 0;
							var area = 0.0;
							var cx_ite = _this.lverts.next;
							var u = cx_ite;
							cx_ite = cx_ite.next;
							var v = cx_ite;
							cx_ite = cx_ite.next;
							while(cx_ite != null) {
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this.localCOMx += (v.x + w.x) * cf;
								_this.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite = cx_ite.next;
							}
							cx_ite = _this.lverts.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							u = v;
							v = w;
							cx_ite = cx_ite.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							area = 1 / (3 * area);
							var t = area;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						}
					}
					if(c.wrap_localCOM != null) {
						c.wrap_localCOM.zpp_inner.x = c.localCOMx;
						c.wrap_localCOM.zpp_inner.y = c.localCOMy;
					}
				}
				var _this = c.body;
				if(_this.zip_axis) {
					_this.zip_axis = false;
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				}
				c.worldCOMx = c.body.posx + (c.body.axisy * c.localCOMx - c.body.axisx * c.localCOMy);
				c.worldCOMy = c.body.posy + (c.localCOMx * c.body.axisx + c.localCOMy * c.body.axisy);
			}
		}
		var acx = 0.0;
		var acy = 0.0;
		acx = this.originx - c.worldCOMx;
		acy = this.originy - c.worldCOMy;
		var A = this.dirx * this.dirx + this.diry * this.diry;
		var B = 2 * (acx * this.dirx + acy * this.diry);
		var C = acx * acx + acy * acy - c.radius * c.radius;
		var det = B * B - 4 * A * C;
		if(det == 0) {
			var t = -B / 2 * A;
			if((!inner || C > 0) && t > 0 && t <= this.maxdist) {
				var nx = 0.0;
				var ny = 0.0;
				nx = this.originx;
				ny = this.originy;
				var t1 = t;
				nx += this.dirx * t1;
				ny += this.diry * t1;
				var t1 = 1.0;
				nx -= c.worldCOMx * t1;
				ny -= c.worldCOMy * t1;
				var d = nx * nx + ny * ny;
				var imag = 1.0 / Math.sqrt(d);
				var t1 = imag;
				nx *= t1;
				ny *= t1;
				if(C <= 0) {
					nx = -nx;
					ny = -ny;
				}
				var x = nx;
				var y = ny;
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret = new nape_geom_Vec2();
				} else {
					ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
					ret.zpp_pool = null;
				}
				if(ret.zpp_inner == null) {
					var ret1;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret1 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.weak = false;
					ret1._immutable = false;
					ret1.x = x;
					ret1.y = y;
					ret.zpp_inner = ret1;
					ret.zpp_inner.outer = ret;
				} else {
					var res;
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					if(ret.zpp_inner.x == x) {
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						res = ret.zpp_inner.y == y;
					} else {
						res = false;
					}
					if(!res) {
						ret.zpp_inner.x = x;
						ret.zpp_inner.y = y;
						var _this = ret.zpp_inner;
						if(_this._invalidate != null) {
							_this._invalidate(_this);
						}
					}
				}
				ret.zpp_inner.weak = false;
				var res = zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,t,C <= 0,c.outer);
				var pre = null;
				var cx_ite = list.zpp_inner.inner.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(res.zpp_inner.toiDistance < j.zpp_inner.toiDistance) {
						break;
					}
					pre = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this = list.zpp_inner.inner;
				var ret;
				if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$RayResult();
				} else {
					ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
					zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = res;
				var temp = ret;
				if(pre == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre.next;
					pre.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
			}
		} else {
			det = Math.sqrt(det);
			A = 1 / (2 * A);
			var t0 = (-B - det) * A;
			var t1 = (-B + det) * A;
			if(t0 > 0 && t0 <= this.maxdist) {
				var nx = 0.0;
				var ny = 0.0;
				nx = this.originx;
				ny = this.originy;
				var t = t0;
				nx += this.dirx * t;
				ny += this.diry * t;
				var t = 1.0;
				nx -= c.worldCOMx * t;
				ny -= c.worldCOMy * t;
				var d = nx * nx + ny * ny;
				var imag = 1.0 / Math.sqrt(d);
				var t = imag;
				nx *= t;
				ny *= t;
				var x = nx;
				var y = ny;
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret = new nape_geom_Vec2();
				} else {
					ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
					ret.zpp_pool = null;
				}
				if(ret.zpp_inner == null) {
					var ret1;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret1 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.weak = false;
					ret1._immutable = false;
					ret1.x = x;
					ret1.y = y;
					ret.zpp_inner = ret1;
					ret.zpp_inner.outer = ret;
				} else {
					var res;
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					if(ret.zpp_inner.x == x) {
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						res = ret.zpp_inner.y == y;
					} else {
						res = false;
					}
					if(!res) {
						ret.zpp_inner.x = x;
						ret.zpp_inner.y = y;
						var _this = ret.zpp_inner;
						if(_this._invalidate != null) {
							_this._invalidate(_this);
						}
					}
				}
				ret.zpp_inner.weak = false;
				var res = zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,t0,false,c.outer);
				var pre = null;
				var cx_ite = list.zpp_inner.inner.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(res.zpp_inner.toiDistance < j.zpp_inner.toiDistance) {
						break;
					}
					pre = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this = list.zpp_inner.inner;
				var ret;
				if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$RayResult();
				} else {
					ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
					zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = res;
				var temp = ret;
				if(pre == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre.next;
					pre.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
			}
			if(t1 > 0 && t1 <= this.maxdist && inner) {
				var nx = 0.0;
				var ny = 0.0;
				nx = this.originx;
				ny = this.originy;
				var t = t1;
				nx += this.dirx * t;
				ny += this.diry * t;
				var t = 1.0;
				nx -= c.worldCOMx * t;
				ny -= c.worldCOMy * t;
				var d = nx * nx + ny * ny;
				var imag = 1.0 / Math.sqrt(d);
				var t = imag;
				nx *= t;
				ny *= t;
				nx = -nx;
				ny = -ny;
				var x = nx;
				var y = ny;
				if(y == null) {
					y = 0;
				}
				if(x == null) {
					x = 0;
				}
				var ret;
				if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
					ret = new nape_geom_Vec2();
				} else {
					ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
					zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
					ret.zpp_pool = null;
				}
				if(ret.zpp_inner == null) {
					var ret1;
					if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
						ret1 = new zpp_$nape_geom_ZPP_$Vec2();
					} else {
						ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
						zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.weak = false;
					ret1._immutable = false;
					ret1.x = x;
					ret1.y = y;
					ret.zpp_inner = ret1;
					ret.zpp_inner.outer = ret;
				} else {
					var res;
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					if(ret.zpp_inner.x == x) {
						var _this = ret.zpp_inner;
						if(_this._validate != null) {
							_this._validate();
						}
						res = ret.zpp_inner.y == y;
					} else {
						res = false;
					}
					if(!res) {
						ret.zpp_inner.x = x;
						ret.zpp_inner.y = y;
						var _this = ret.zpp_inner;
						if(_this._invalidate != null) {
							_this._invalidate(_this);
						}
					}
				}
				ret.zpp_inner.weak = false;
				var res = zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,t1,true,c.outer);
				var pre = null;
				var cx_ite = list.zpp_inner.inner.head;
				while(cx_ite != null) {
					var j = cx_ite.elt;
					if(res.zpp_inner.toiDistance < j.zpp_inner.toiDistance) {
						break;
					}
					pre = cx_ite;
					cx_ite = cx_ite.next;
				}
				var _this = list.zpp_inner.inner;
				var ret;
				if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$RayResult();
				} else {
					ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
					zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = res;
				var temp = ret;
				if(pre == null) {
					temp.next = _this.head;
					_this.head = temp;
				} else {
					temp.next = pre.next;
					pre.next = temp;
				}
				_this.pushmod = _this.modified = true;
				_this.length++;
			}
		}
	}
	,polysect: function(p,inner,mint) {
		var min = mint;
		var edge = null;
		var ei = p.edges.head;
		var cx_cont = true;
		var cx_itei = p.gverts.next;
		var u = cx_itei;
		var cx_itej = cx_itei.next;
		while(cx_itej != null) {
			var v = cx_itej;
			var e = ei.elt;
			if(inner || e.gnormx * this.dirx + e.gnormy * this.diry < 0) {
				var _vx = 0.0;
				var _vy = 0.0;
				_vx = v.x - u.x;
				_vy = v.y - u.y;
				var _sx = 0.0;
				var _sy = 0.0;
				_sx = u.x - this.originx;
				_sy = u.y - this.originy;
				var den = _vy * this.dirx - _vx * this.diry;
				if(den * den > nape_Config.epsilon) {
					den = 1 / den;
					var sxx = (_vy * _sx - _vx * _sy) * den;
					if(sxx > 0 && sxx < min && sxx <= this.maxdist) {
						var txx = (this.diry * _sx - this.dirx * _sy) * den;
						if(txx > -nape_Config.epsilon && txx < 1 + nape_Config.epsilon) {
							min = sxx;
							edge = ei.elt;
						}
					}
				}
			}
			ei = ei.next;
			cx_itei = cx_itej;
			u = v;
			cx_itej = cx_itej.next;
		}
		if(cx_cont) {
			do {
				cx_itej = p.gverts.next;
				var v = cx_itej;
				var e = ei.elt;
				if(inner || e.gnormx * this.dirx + e.gnormy * this.diry < 0) {
					var _vx = 0.0;
					var _vy = 0.0;
					_vx = v.x - u.x;
					_vy = v.y - u.y;
					var _sx = 0.0;
					var _sy = 0.0;
					_sx = u.x - this.originx;
					_sy = u.y - this.originy;
					var den = _vy * this.dirx - _vx * this.diry;
					if(den * den > nape_Config.epsilon) {
						den = 1 / den;
						var sxx = (_vy * _sx - _vx * _sy) * den;
						if(sxx > 0 && sxx < min && sxx <= this.maxdist) {
							var txx = (this.diry * _sx - this.dirx * _sy) * den;
							if(txx > -nape_Config.epsilon && txx < 1 + nape_Config.epsilon) {
								min = sxx;
								edge = ei.elt;
							}
						}
					}
				}
				ei = ei.next;
			} while(false);
		}
		if(edge != null) {
			var nx = 0.0;
			var ny = 0.0;
			nx = edge.gnormx;
			ny = edge.gnormy;
			var inner = nx * this.dirx + ny * this.diry > 0;
			if(inner) {
				nx = -nx;
				ny = -ny;
			}
			var x = nx;
			var y = ny;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			return zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,min,inner,p.outer);
		} else {
			return null;
		}
	}
	,polysect2: function(p,inner,list) {
		var min = Infinity;
		var max = -1.0;
		var edge = null;
		var edgemax = null;
		var ei = p.edges.head;
		var cx_cont = true;
		var cx_itei = p.gverts.next;
		var u = cx_itei;
		var cx_itej = cx_itei.next;
		while(cx_itej != null) {
			var v = cx_itej;
			var e = ei.elt;
			if(inner || e.gnormx * this.dirx + e.gnormy * this.diry < 0) {
				var _vx = 0.0;
				var _vy = 0.0;
				_vx = v.x - u.x;
				_vy = v.y - u.y;
				var _sx = 0.0;
				var _sy = 0.0;
				_sx = u.x - this.originx;
				_sy = u.y - this.originy;
				var den = _vy * this.dirx - _vx * this.diry;
				if(den * den > nape_Config.epsilon) {
					den = 1 / den;
					var sxx = (_vy * _sx - _vx * _sy) * den;
					if(sxx > 0 && sxx <= this.maxdist && (sxx < min || sxx > max)) {
						var txx = (this.diry * _sx - this.dirx * _sy) * den;
						if(txx > -nape_Config.epsilon && txx < 1 + nape_Config.epsilon) {
							if(sxx < min) {
								min = sxx;
								edge = ei.elt;
							}
							if(sxx > max) {
								max = sxx;
								edgemax = ei.elt;
							}
						}
					}
				}
			}
			ei = ei.next;
			cx_itei = cx_itej;
			u = v;
			cx_itej = cx_itej.next;
		}
		if(cx_cont) {
			do {
				cx_itej = p.gverts.next;
				var v = cx_itej;
				var e = ei.elt;
				if(inner || e.gnormx * this.dirx + e.gnormy * this.diry < 0) {
					var _vx = 0.0;
					var _vy = 0.0;
					_vx = v.x - u.x;
					_vy = v.y - u.y;
					var _sx = 0.0;
					var _sy = 0.0;
					_sx = u.x - this.originx;
					_sy = u.y - this.originy;
					var den = _vy * this.dirx - _vx * this.diry;
					if(den * den > nape_Config.epsilon) {
						den = 1 / den;
						var sxx = (_vy * _sx - _vx * _sy) * den;
						if(sxx > 0 && sxx <= this.maxdist && (sxx < min || sxx > max)) {
							var txx = (this.diry * _sx - this.dirx * _sy) * den;
							if(txx > -nape_Config.epsilon && txx < 1 + nape_Config.epsilon) {
								if(sxx < min) {
									min = sxx;
									edge = ei.elt;
								}
								if(sxx > max) {
									max = sxx;
									edgemax = ei.elt;
								}
							}
						}
					}
				}
				ei = ei.next;
			} while(false);
		}
		if(edge != null) {
			var nx = 0.0;
			var ny = 0.0;
			nx = edge.gnormx;
			ny = edge.gnormy;
			var inner = nx * this.dirx + ny * this.diry > 0;
			if(inner) {
				nx = -nx;
				ny = -ny;
			}
			var x = nx;
			var y = ny;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var ret1;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					ret1 = ret.zpp_inner.y == y;
				} else {
					ret1 = false;
				}
				if(!ret1) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			var ret1 = zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,min,inner,p.outer);
			var pre = null;
			var cx_ite = list.zpp_inner.inner.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(ret1.zpp_inner.toiDistance < j.zpp_inner.toiDistance) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = list.zpp_inner.inner;
			var ret;
			if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$RayResult();
			} else {
				ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
				zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = ret1;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
		}
		if(edgemax != null && edge != edgemax) {
			var nx = 0.0;
			var ny = 0.0;
			nx = edgemax.gnormx;
			ny = edgemax.gnormy;
			var inner = nx * this.dirx + ny * this.diry > 0;
			if(inner) {
				nx = -nx;
				ny = -ny;
			}
			var x = nx;
			var y = ny;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var ret1;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					ret1 = ret.zpp_inner.y == y;
				} else {
					ret1 = false;
				}
				if(!ret1) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			var ret1 = zpp_$nape_geom_ZPP_$ConvexRayResult.getRay(ret,max,inner,p.outer);
			var pre = null;
			var cx_ite = list.zpp_inner.inner.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(ret1.zpp_inner.toiDistance < j.zpp_inner.toiDistance) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = list.zpp_inner.inner;
			var ret;
			if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$RayResult();
			} else {
				ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
				zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = ret1;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
		}
	}
};
var zpp_$nape_geom_ZPP_$SimpleVert = function() {
	this.node = null;
	this.next = null;
	this.id = 0;
	this.links = null;
	this.y = 0.0;
	this.x = 0.0;
	this.forced = false;
	this.id = zpp_$nape_ZPP_$ID.ZPP_SimpleVert();
	if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool == null) {
		this.links = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert();
	} else {
		this.links = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = this.links.next;
		this.links.next = null;
	}
	this.links.lt = zpp_$nape_geom_ZPP_$SimpleVert.less_xy;
};
zpp_$nape_geom_ZPP_$SimpleVert.__name__ = true;
zpp_$nape_geom_ZPP_$SimpleVert.less_xy = function(p,q) {
	if(!(p.y < q.y)) {
		if(p.y == q.y) {
			return p.x < q.x;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
zpp_$nape_geom_ZPP_$SimpleVert.swap_nodes = function(p,q) {
	var t = p.node;
	p.node = q.node;
	q.node = t;
};
var zpp_$nape_geom_ZPP_$SimpleSeg = function() {
	this.node = null;
	this.prev = null;
	this.next = null;
	this.id = 0;
	this.vertices = null;
	this.right = null;
	this.left = null;
	this.id = zpp_$nape_ZPP_$ID.ZPP_SimpleSeg();
	if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool == null) {
		this.vertices = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert();
	} else {
		this.vertices = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = this.vertices.next;
		this.vertices.next = null;
	}
	this.vertices.lt = $bind(this,this.less_xy);
};
zpp_$nape_geom_ZPP_$SimpleSeg.__name__ = true;
zpp_$nape_geom_ZPP_$SimpleSeg.get = function(left,right) {
	var ret;
	if(zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$SimpleSeg();
	} else {
		ret = zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.left = left;
	ret.right = right;
	ret.vertices.insert(left);
	ret.vertices.insert(right);
	return ret;
};
zpp_$nape_geom_ZPP_$SimpleSeg.prototype = {
	less_xy: function(a,b) {
		if(!(a.x < b.x)) {
			if(a.x == b.x) {
				return a.y < b.y;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var zpp_$nape_geom_ZPP_$SimpleEvent = function() {
	this.next = null;
	this.node = null;
	this.segment2 = null;
	this.segment = null;
	this.vertex = null;
	this.type = 0;
};
zpp_$nape_geom_ZPP_$SimpleEvent.__name__ = true;
zpp_$nape_geom_ZPP_$SimpleEvent.swap_nodes = function(a,b) {
	var t = a.node;
	a.node = b.node;
	b.node = t;
};
zpp_$nape_geom_ZPP_$SimpleEvent.less_xy = function(a,b) {
	if(a.vertex.x < b.vertex.x) {
		return true;
	} else if(a.vertex.x > b.vertex.x) {
		return false;
	} else if(a.vertex.y < b.vertex.y) {
		return true;
	} else if(a.vertex.y > b.vertex.y) {
		return false;
	} else {
		return a.type < b.type;
	}
};
var zpp_$nape_geom_ZPP_$SimpleSweep = function() {
	this.tree = null;
	this.sweepx = 0.0;
	if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool == null) {
		this.tree = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg();
	} else {
		this.tree = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool = this.tree.next;
		this.tree.next = null;
	}
	this.tree.lt = $bind(this,this.edge_lt);
	this.tree.swapped = $bind(this,this.swap_nodes);
};
zpp_$nape_geom_ZPP_$SimpleSweep.__name__ = true;
zpp_$nape_geom_ZPP_$SimpleSweep.prototype = {
	swap_nodes: function(p,q) {
		var t = p.node;
		p.node = q.node;
		q.node = t;
	}
	,edge_lt: function(p,q) {
		var ux = 0.0;
		var uy = 0.0;
		var vx = 0.0;
		var vy = 0.0;
		var flip;
		if(p.left == q.left && p.right == q.right) {
			return false;
		} else if(p.left == q.right) {
			if(p.left.x == p.right.x) {
				if(p.left.y < p.right.y) {
					return p.left.y > q.left.y;
				} else {
					return p.right.y > q.left.y;
				}
			} else {
				flip = p.right.x < p.left.x;
				ux = p.right.x - p.left.x;
				uy = p.right.y - p.left.y;
				vx = q.left.x - p.left.x;
				vy = q.left.y - p.left.y;
				return (flip ? uy * vx - ux * vy : vy * ux - vx * uy) < 0;
			}
		} else if(p.right == q.left) {
			var tmp;
			if(q.left.x == q.right.x) {
				tmp = q.left.y < q.right.y ? q.left.y > p.left.y : q.right.y > p.left.y;
			} else {
				flip = q.right.x < q.left.x;
				ux = q.right.x - q.left.x;
				uy = q.right.y - q.left.y;
				vx = p.left.x - q.left.x;
				vy = p.left.y - q.left.y;
				tmp = (flip ? uy * vx - ux * vy : vy * ux - vx * uy) < 0;
			}
			return !tmp;
		} else if(p.left == q.left) {
			if(p.left.x == p.right.x) {
				if(p.left.y < p.right.y) {
					return p.left.y > q.right.y;
				} else {
					return p.right.y > q.right.y;
				}
			} else {
				flip = p.right.x < p.left.x;
				ux = p.right.x - p.left.x;
				uy = p.right.y - p.left.y;
				vx = q.right.x - p.left.x;
				vy = q.right.y - p.left.y;
				return (flip ? uy * vx - ux * vy : vy * ux - vx * uy) < 0;
			}
		} else if(p.right == q.right) {
			if(p.left.x == p.right.x) {
				if(p.left.y < p.right.y) {
					return p.left.y > q.left.y;
				} else {
					return p.right.y > q.left.y;
				}
			} else {
				flip = p.right.x < p.left.x;
				ux = p.right.x - p.left.x;
				uy = p.right.y - p.left.y;
				vx = q.left.x - p.left.x;
				vy = q.left.y - p.left.y;
				return (flip ? uy * vx - ux * vy : vy * ux - vx * uy) < 0;
			}
		}
		if(p.left.x == p.right.x) {
			if(q.left.x == q.right.x) {
				var pmax = p.left.y < p.right.y ? p.right : p.left;
				var qmax = q.left.y < q.right.y ? q.right : q.left;
				return pmax.y > qmax.y;
			} else {
				flip = q.right.x < q.left.x;
				ux = q.right.x - q.left.x;
				uy = q.right.y - q.left.y;
				vx = p.left.x - q.left.x;
				vy = p.left.y - q.left.y;
				var plrg = flip ? uy * vx - ux * vy : vy * ux - vx * uy;
				flip = q.right.x < q.left.x;
				ux = q.right.x - q.left.x;
				uy = q.right.y - q.left.y;
				vx = p.right.x - q.left.x;
				vy = p.right.y - q.left.y;
				var aplrg = flip ? uy * vx - ux * vy : vy * ux - vx * uy;
				if(plrg * aplrg >= 0) {
					return plrg >= 0.0;
				} else {
					return this.sweepx >= p.left.x;
				}
			}
		} else if(q.left.x == q.right.x) {
			flip = p.right.x < p.left.x;
			ux = p.right.x - p.left.x;
			uy = p.right.y - p.left.y;
			vx = q.left.x - p.left.x;
			vy = q.left.y - p.left.y;
			var qlrg = flip ? uy * vx - ux * vy : vy * ux - vx * uy;
			flip = p.right.x < p.left.x;
			ux = p.right.x - p.left.x;
			uy = p.right.y - p.left.y;
			vx = q.right.x - p.left.x;
			vy = q.right.y - p.left.y;
			var aqlrg = flip ? uy * vx - ux * vy : vy * ux - vx * uy;
			if(qlrg * aqlrg >= 0) {
				return qlrg < 0.0;
			} else {
				return this.sweepx < q.left.x;
			}
		} else {
			flip = p.right.x < p.left.x;
			ux = p.right.x - p.left.x;
			uy = p.right.y - p.left.y;
			vx = q.left.x - p.left.x;
			vy = q.left.y - p.left.y;
			var qlrg = (flip ? uy * vx - ux * vy : vy * ux - vx * uy) < 0.0;
			flip = p.right.x < p.left.x;
			ux = p.right.x - p.left.x;
			uy = p.right.y - p.left.y;
			vx = q.right.x - p.left.x;
			vy = q.right.y - p.left.y;
			var aqlrg = (flip ? uy * vx - ux * vy : vy * ux - vx * uy) < 0.0;
			if(qlrg == aqlrg) {
				return qlrg;
			} else {
				flip = q.right.x < q.left.x;
				ux = q.right.x - q.left.x;
				uy = q.right.y - q.left.y;
				vx = p.left.x - q.left.x;
				vy = p.left.y - q.left.y;
				var plrg = (flip ? uy * vx - ux * vy : vy * ux - vx * uy) >= 0.0;
				flip = q.right.x < q.left.x;
				ux = q.right.x - q.left.x;
				uy = q.right.y - q.left.y;
				vx = p.right.x - q.left.x;
				vy = p.right.y - q.left.y;
				var aplrg = (flip ? uy * vx - ux * vy : vy * ux - vx * uy) >= 0.0;
				if(plrg == aplrg) {
					return plrg;
				}
				var py = (this.sweepx - p.left.x) / (p.right.x - p.left.x) * (p.right.y - p.left.y) + p.left.y;
				var qy = (this.sweepx - q.left.x) / (q.right.x - q.left.x) * (q.right.y - q.left.y) + q.left.y;
				return py > qy;
			}
		}
	}
	,clear: function() {
		this.tree.clear();
	}
	,add: function(e) {
		e.node = this.tree.insert(e);
		var nxt = this.tree.successor_node(e.node);
		var pre = this.tree.predecessor_node(e.node);
		if(nxt != null) {
			e.next = nxt.data;
			nxt.data.prev = e;
		}
		if(pre != null) {
			e.prev = pre.data;
			pre.data.next = e;
		}
		return e;
	}
	,remove: function(e) {
		var nxt = this.tree.successor_node(e.node);
		var pre = this.tree.predecessor_node(e.node);
		if(nxt != null) {
			nxt.data.prev = e.prev;
		}
		if(pre != null) {
			pre.data.next = e.next;
		}
		this.tree.remove_node(e.node);
		e.node = null;
	}
	,intersect: function(p,q) {
		if(p == null || q == null) {
			return false;
		} else if(p.left == q.left || p.left == q.right || p.right == q.left || p.right == q.right) {
			return false;
		} else {
			var lsign = (q.left.x - p.left.x) * (p.right.y - p.left.y) - (p.right.x - p.left.x) * (q.left.y - p.left.y);
			var rsign = (q.right.x - p.left.x) * (p.right.y - p.left.y) - (p.right.x - p.left.x) * (q.right.y - p.left.y);
			if(lsign * rsign > 0) {
				return false;
			} else {
				var lsign2 = (p.left.x - q.left.x) * (q.right.y - q.left.y) - (q.right.x - q.left.x) * (p.left.y - q.left.y);
				var rsign2 = (p.right.x - q.left.x) * (q.right.y - q.left.y) - (q.right.x - q.left.x) * (p.right.y - q.left.y);
				if(lsign2 * rsign2 > 0) {
					return false;
				} else if(lsign * rsign >= 0 && lsign2 * rsign2 >= 0) {
					return true;
				} else {
					return true;
				}
			}
		}
	}
	,intersection: function(p,q) {
		if(p == null || q == null) {
			return null;
		} else if(p.left == q.left || p.left == q.right || p.right == q.left || p.right == q.right) {
			return null;
		} else {
			var ux = 0.0;
			var uy = 0.0;
			ux = p.right.x - p.left.x;
			uy = p.right.y - p.left.y;
			var vx = 0.0;
			var vy = 0.0;
			vx = q.right.x - q.left.x;
			vy = q.right.y - q.left.y;
			var denom = vy * ux - vx * uy;
			if(denom == 0.0) {
				return null;
			}
			denom = 1 / denom;
			var cx = 0.0;
			var cy = 0.0;
			cx = q.left.x - p.left.x;
			cy = q.left.y - p.left.y;
			var t = (vy * cx - vx * cy) * denom;
			if(t < 0 || t > 1) {
				return null;
			}
			var s = (uy * cx - ux * cy) * denom;
			if(s < 0 || s > 1) {
				return null;
			}
			var vet;
			if(s == 0 || s == 1 || t == 0 || t == 1) {
				vet = s == 0 ? q.left : s == 1 ? q.right : t == 0 ? p.left : p.right;
			} else {
				var x = 0.5 * (p.left.x + ux * t + q.left.x + vx * s);
				var y = 0.5 * (p.left.y + uy * t + q.left.y + vy * s);
				var ret;
				if(zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool == null) {
					ret = new zpp_$nape_geom_ZPP_$SimpleVert();
				} else {
					ret = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
					zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.x = x;
				ret.y = y;
				vet = ret;
			}
			var ret;
			if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
				ret = new zpp_$nape_geom_ZPP_$SimpleEvent();
			} else {
				ret = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.vertex = vet;
			var ret1 = ret;
			ret1.type = 0;
			ret1.segment = p;
			ret1.segment2 = q;
			return ret1;
		}
	}
};
var zpp_$nape_geom_ZPP_$Simple = function() { };
zpp_$nape_geom_ZPP_$Simple.__name__ = true;
zpp_$nape_geom_ZPP_$Simple.decompose = function(poly,rets) {
	if(zpp_$nape_geom_ZPP_$Simple.sweep == null) {
		zpp_$nape_geom_ZPP_$Simple.sweep = new zpp_$nape_geom_ZPP_$SimpleSweep();
		zpp_$nape_geom_ZPP_$Simple.inthash = new zpp_$nape_util_FastHash2_$Hashable2_$Boolfalse();
	}
	if(zpp_$nape_geom_ZPP_$Simple.vertices == null) {
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool == null) {
			zpp_$nape_geom_ZPP_$Simple.vertices = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert();
		} else {
			zpp_$nape_geom_ZPP_$Simple.vertices = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = zpp_$nape_geom_ZPP_$Simple.vertices.next;
			zpp_$nape_geom_ZPP_$Simple.vertices.next = null;
		}
		zpp_$nape_geom_ZPP_$Simple.vertices.lt = zpp_$nape_geom_ZPP_$SimpleVert.less_xy;
		zpp_$nape_geom_ZPP_$Simple.vertices.swapped = zpp_$nape_geom_ZPP_$SimpleVert.swap_nodes;
	}
	if(zpp_$nape_geom_ZPP_$Simple.queue == null) {
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool == null) {
			zpp_$nape_geom_ZPP_$Simple.queue = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent();
		} else {
			zpp_$nape_geom_ZPP_$Simple.queue = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool = zpp_$nape_geom_ZPP_$Simple.queue.next;
			zpp_$nape_geom_ZPP_$Simple.queue.next = null;
		}
		zpp_$nape_geom_ZPP_$Simple.queue.lt = zpp_$nape_geom_ZPP_$SimpleEvent.less_xy;
		zpp_$nape_geom_ZPP_$Simple.queue.swapped = zpp_$nape_geom_ZPP_$SimpleEvent.swap_nodes;
	}
	var fst = null;
	var pre = null;
	var F = poly;
	var L = poly;
	if(F != null) {
		var nite = F;
		do {
			var v = nite;
			var x = v.x;
			var y = v.y;
			var ret;
			if(zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool == null) {
				ret = new zpp_$nape_geom_ZPP_$SimpleVert();
			} else {
				ret = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.x = x;
			ret.y = y;
			var vert = ret;
			var cur = zpp_$nape_geom_ZPP_$Simple.vertices.parent;
			while(cur != null) if(zpp_$nape_geom_ZPP_$Simple.vertices.lt(vert,cur.data)) {
				cur = cur.prev;
			} else if(zpp_$nape_geom_ZPP_$Simple.vertices.lt(cur.data,vert)) {
				cur = cur.next;
			} else {
				break;
			}
			var vx = cur;
			if(vx != null) {
				var o = vert;
				o.links.clear();
				o.node = null;
				o.forced = false;
				o.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o;
				vert = vx.data;
			} else {
				vert.node = zpp_$nape_geom_ZPP_$Simple.vertices.insert(vert);
			}
			if(pre != null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$SimpleEvent();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
					zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.vertex = pre;
				var e1 = ret1;
				var ret2;
				if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$SimpleEvent();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
					zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.vertex = vert;
				var e2 = ret2;
				var seg;
				if(zpp_$nape_geom_ZPP_$SimpleEvent.less_xy(e1,e2)) {
					e1.type = 1;
					e2.type = 2;
					seg = zpp_$nape_geom_ZPP_$SimpleSeg.get(pre,vert);
				} else {
					e1.type = 2;
					e2.type = 1;
					seg = zpp_$nape_geom_ZPP_$SimpleSeg.get(vert,pre);
				}
				e1.segment = e2.segment = seg;
				zpp_$nape_geom_ZPP_$Simple.queue.insert(e1);
				zpp_$nape_geom_ZPP_$Simple.queue.insert(e2);
				pre.links.insert(vert);
				vert.links.insert(pre);
			}
			pre = vert;
			if(fst == null) {
				fst = vert;
			}
			nite = nite.next;
		} while(nite != L);
	}
	var ret;
	if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$SimpleEvent();
	} else {
		ret = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.vertex = pre;
	var e1 = ret;
	var ret;
	if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$SimpleEvent();
	} else {
		ret = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.vertex = fst;
	var e2 = ret;
	var seg;
	if(zpp_$nape_geom_ZPP_$SimpleEvent.less_xy(e1,e2)) {
		e1.type = 1;
		e2.type = 2;
		seg = zpp_$nape_geom_ZPP_$SimpleSeg.get(pre,fst);
	} else {
		e1.type = 2;
		e2.type = 1;
		seg = zpp_$nape_geom_ZPP_$SimpleSeg.get(fst,pre);
	}
	e1.segment = e2.segment = seg;
	zpp_$nape_geom_ZPP_$Simple.queue.insert(e1);
	zpp_$nape_geom_ZPP_$Simple.queue.insert(e2);
	pre.links.insert(fst);
	fst.links.insert(pre);
	if(zpp_$nape_geom_ZPP_$Simple.ints == null) {
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool == null) {
			zpp_$nape_geom_ZPP_$Simple.ints = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent();
		} else {
			zpp_$nape_geom_ZPP_$Simple.ints = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool = zpp_$nape_geom_ZPP_$Simple.ints.next;
			zpp_$nape_geom_ZPP_$Simple.ints.next = null;
		}
		zpp_$nape_geom_ZPP_$Simple.ints.lt = zpp_$nape_geom_ZPP_$SimpleEvent.less_xy;
	}
	while(!zpp_$nape_geom_ZPP_$Simple.queue.empty()) {
		var e = zpp_$nape_geom_ZPP_$Simple.queue.pop_front();
		zpp_$nape_geom_ZPP_$Simple.sweep.sweepx = e.vertex.x;
		if(e.type == 1) {
			var s = e.segment;
			zpp_$nape_geom_ZPP_$Simple.sweep.add(s);
			if(s.next != null && s != null && !(s.next.id < s.id ? zpp_$nape_geom_ZPP_$Simple.inthash.has(s.next.id,s.id) : zpp_$nape_geom_ZPP_$Simple.inthash.has(s.id,s.next.id))) {
				var intx = zpp_$nape_geom_ZPP_$Simple.sweep.intersection(s.next,s);
				if(intx != null) {
					if(intx.vertex.x >= zpp_$nape_geom_ZPP_$Simple.sweep.sweepx) {
						var cur = zpp_$nape_geom_ZPP_$Simple.queue.parent;
						while(cur != null) if(zpp_$nape_geom_ZPP_$Simple.queue.lt(intx,cur.data)) {
							cur = cur.prev;
						} else if(zpp_$nape_geom_ZPP_$Simple.queue.lt(cur.data,intx)) {
							cur = cur.next;
						} else {
							break;
						}
						var ex = cur;
						if(ex == null) {
							var cur1 = zpp_$nape_geom_ZPP_$Simple.ints.parent;
							while(cur1 != null) if(zpp_$nape_geom_ZPP_$Simple.ints.lt(intx,cur1.data)) {
								cur1 = cur1.prev;
							} else if(zpp_$nape_geom_ZPP_$Simple.ints.lt(cur1.data,intx)) {
								cur1 = cur1.next;
							} else {
								break;
							}
							var vx = cur1;
							if(vx != null) {
								var o = intx.vertex;
								o.links.clear();
								o.node = null;
								o.forced = false;
								o.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
								zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o;
								intx.vertex = vx.data.vertex;
								vx.data = intx;
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx);
							} else {
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx);
								zpp_$nape_geom_ZPP_$Simple.ints.insert(intx);
							}
							if(s.next.id < s.id) {
								var tmp = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id = s.next.id;
								var di = s.id;
								var ret;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret.next;
									ret.next = null;
								}
								ret.id = id;
								ret.di = di;
								var ret1 = ret;
								ret1.value = true;
								tmp.add(ret1);
							} else {
								var tmp1 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id1 = s.id;
								var di1 = s.next.id;
								var ret2;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret2 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret2 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret2.next;
									ret2.next = null;
								}
								ret2.id = id1;
								ret2.di = di1;
								var ret3 = ret2;
								ret3.value = true;
								tmp1.add(ret3);
							}
						} else {
							var x = ex.data;
							var o1 = intx.vertex;
							o1.links.clear();
							o1.node = null;
							o1.forced = false;
							o1.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o1;
							var o2 = intx;
							o2.vertex = null;
							o2.segment = o2.segment2 = null;
							o2.node = null;
							o2.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o2;
						}
					} else {
						var o3 = intx.vertex;
						o3.links.clear();
						o3.node = null;
						o3.forced = false;
						o3.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o3;
						var o4 = intx;
						o4.vertex = null;
						o4.segment = o4.segment2 = null;
						o4.node = null;
						o4.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o4;
					}
				}
			}
			if(s != null && s.prev != null && !(s.id < s.prev.id ? zpp_$nape_geom_ZPP_$Simple.inthash.has(s.id,s.prev.id) : zpp_$nape_geom_ZPP_$Simple.inthash.has(s.prev.id,s.id))) {
				var intx1 = zpp_$nape_geom_ZPP_$Simple.sweep.intersection(s,s.prev);
				if(intx1 != null) {
					if(intx1.vertex.x >= zpp_$nape_geom_ZPP_$Simple.sweep.sweepx) {
						var cur2 = zpp_$nape_geom_ZPP_$Simple.queue.parent;
						while(cur2 != null) if(zpp_$nape_geom_ZPP_$Simple.queue.lt(intx1,cur2.data)) {
							cur2 = cur2.prev;
						} else if(zpp_$nape_geom_ZPP_$Simple.queue.lt(cur2.data,intx1)) {
							cur2 = cur2.next;
						} else {
							break;
						}
						var ex1 = cur2;
						if(ex1 == null) {
							var cur3 = zpp_$nape_geom_ZPP_$Simple.ints.parent;
							while(cur3 != null) if(zpp_$nape_geom_ZPP_$Simple.ints.lt(intx1,cur3.data)) {
								cur3 = cur3.prev;
							} else if(zpp_$nape_geom_ZPP_$Simple.ints.lt(cur3.data,intx1)) {
								cur3 = cur3.next;
							} else {
								break;
							}
							var vx1 = cur3;
							if(vx1 != null) {
								var o5 = intx1.vertex;
								o5.links.clear();
								o5.node = null;
								o5.forced = false;
								o5.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
								zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o5;
								intx1.vertex = vx1.data.vertex;
								vx1.data = intx1;
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx1);
							} else {
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx1);
								zpp_$nape_geom_ZPP_$Simple.ints.insert(intx1);
							}
							if(s.id < s.prev.id) {
								var tmp2 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id2 = s.id;
								var di2 = s.prev.id;
								var ret4;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret4 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret4 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret4.next;
									ret4.next = null;
								}
								ret4.id = id2;
								ret4.di = di2;
								var ret5 = ret4;
								ret5.value = true;
								tmp2.add(ret5);
							} else {
								var tmp3 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id3 = s.prev.id;
								var di3 = s.id;
								var ret6;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret6 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret6 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret6.next;
									ret6.next = null;
								}
								ret6.id = id3;
								ret6.di = di3;
								var ret7 = ret6;
								ret7.value = true;
								tmp3.add(ret7);
							}
						} else {
							var x1 = ex1.data;
							var o6 = intx1.vertex;
							o6.links.clear();
							o6.node = null;
							o6.forced = false;
							o6.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o6;
							var o7 = intx1;
							o7.vertex = null;
							o7.segment = o7.segment2 = null;
							o7.node = null;
							o7.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o7;
						}
					} else {
						var o8 = intx1.vertex;
						o8.links.clear();
						o8.node = null;
						o8.forced = false;
						o8.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o8;
						var o9 = intx1;
						o9.vertex = null;
						o9.segment = o9.segment2 = null;
						o9.node = null;
						o9.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o9;
					}
				}
			}
		} else if(e.type == 2) {
			var s1 = e.segment;
			if(s1.node != null) {
				var nxt = s1.next;
				var pre = s1.prev;
				zpp_$nape_geom_ZPP_$Simple.sweep.remove(s1);
				var o10 = s1;
				o10.left = o10.right = null;
				o10.prev = null;
				o10.node = null;
				o10.vertices.clear();
				o10.next = zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool = o10;
				if(nxt != null && pre != null && !(nxt.id < pre.id ? zpp_$nape_geom_ZPP_$Simple.inthash.has(nxt.id,pre.id) : zpp_$nape_geom_ZPP_$Simple.inthash.has(pre.id,nxt.id))) {
					var intx2 = zpp_$nape_geom_ZPP_$Simple.sweep.intersection(nxt,pre);
					if(intx2 != null) {
						if(intx2.vertex.x >= zpp_$nape_geom_ZPP_$Simple.sweep.sweepx) {
							var cur4 = zpp_$nape_geom_ZPP_$Simple.queue.parent;
							while(cur4 != null) if(zpp_$nape_geom_ZPP_$Simple.queue.lt(intx2,cur4.data)) {
								cur4 = cur4.prev;
							} else if(zpp_$nape_geom_ZPP_$Simple.queue.lt(cur4.data,intx2)) {
								cur4 = cur4.next;
							} else {
								break;
							}
							var ex2 = cur4;
							if(ex2 == null) {
								var cur5 = zpp_$nape_geom_ZPP_$Simple.ints.parent;
								while(cur5 != null) if(zpp_$nape_geom_ZPP_$Simple.ints.lt(intx2,cur5.data)) {
									cur5 = cur5.prev;
								} else if(zpp_$nape_geom_ZPP_$Simple.ints.lt(cur5.data,intx2)) {
									cur5 = cur5.next;
								} else {
									break;
								}
								var vx2 = cur5;
								if(vx2 != null) {
									var o11 = intx2.vertex;
									o11.links.clear();
									o11.node = null;
									o11.forced = false;
									o11.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
									zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o11;
									intx2.vertex = vx2.data.vertex;
									vx2.data = intx2;
									zpp_$nape_geom_ZPP_$Simple.queue.insert(intx2);
								} else {
									zpp_$nape_geom_ZPP_$Simple.queue.insert(intx2);
									zpp_$nape_geom_ZPP_$Simple.ints.insert(intx2);
								}
								if(nxt.id < pre.id) {
									var tmp4 = zpp_$nape_geom_ZPP_$Simple.inthash;
									var id4 = nxt.id;
									var di4 = pre.id;
									var ret8;
									if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
										ret8 = new zpp_$nape_util_Hashable2_$Boolfalse();
									} else {
										ret8 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
										zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret8.next;
										ret8.next = null;
									}
									ret8.id = id4;
									ret8.di = di4;
									var ret9 = ret8;
									ret9.value = true;
									tmp4.add(ret9);
								} else {
									var tmp5 = zpp_$nape_geom_ZPP_$Simple.inthash;
									var id5 = pre.id;
									var di5 = nxt.id;
									var ret10;
									if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
										ret10 = new zpp_$nape_util_Hashable2_$Boolfalse();
									} else {
										ret10 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
										zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret10.next;
										ret10.next = null;
									}
									ret10.id = id5;
									ret10.di = di5;
									var ret11 = ret10;
									ret11.value = true;
									tmp5.add(ret11);
								}
							} else {
								var x2 = ex2.data;
								var o12 = intx2.vertex;
								o12.links.clear();
								o12.node = null;
								o12.forced = false;
								o12.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
								zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o12;
								var o13 = intx2;
								o13.vertex = null;
								o13.segment = o13.segment2 = null;
								o13.node = null;
								o13.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
								zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o13;
							}
						} else {
							var o14 = intx2.vertex;
							o14.links.clear();
							o14.node = null;
							o14.forced = false;
							o14.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o14;
							var o15 = intx2;
							o15.vertex = null;
							o15.segment = o15.segment2 = null;
							o15.node = null;
							o15.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o15;
						}
					}
				}
			}
		} else {
			var intx3 = e.vertex;
			var pnull = intx3.node == null;
			var a = e.segment;
			var b = e.segment2;
			if(b.next != a) {
				var t = a;
				a = b;
				b = t;
			}
			var cur6 = a.vertices.parent;
			while(cur6 != null) if(a.vertices.lt(intx3,cur6.data)) {
				cur6 = cur6.prev;
			} else if(a.vertices.lt(cur6.data,intx3)) {
				cur6 = cur6.next;
			} else {
				break;
			}
			var anew = cur6 == null;
			var cur7 = b.vertices.parent;
			while(cur7 != null) if(b.vertices.lt(intx3,cur7.data)) {
				cur7 = cur7.prev;
			} else if(b.vertices.lt(cur7.data,intx3)) {
				cur7 = cur7.next;
			} else {
				break;
			}
			var bnew = cur7 == null;
			if(anew) {
				var aint = a.vertices.insert(intx3);
				var naleft = intx3 == a.left ? intx3 : a.vertices.predecessor_node(aint).data;
				var naright = intx3 == a.right ? intx3 : a.vertices.successor_node(aint).data;
				naleft.links.remove(naright);
				if(intx3 != naleft) {
					naleft.links.insert(intx3);
				}
				naright.links.remove(naleft);
				if(intx3 != naright) {
					naright.links.insert(intx3);
				}
				if(intx3 != naleft) {
					intx3.links.insert(naleft);
				}
				if(intx3 != naright) {
					intx3.links.insert(naright);
				}
			}
			if(bnew) {
				var bint = b.vertices.insert(intx3);
				var nbleft = intx3 == b.left ? intx3 : b.vertices.predecessor_node(bint).data;
				var nbright = intx3 == b.right ? intx3 : b.vertices.successor_node(bint).data;
				nbleft.links.remove(nbright);
				if(intx3 != nbleft) {
					nbleft.links.insert(intx3);
				}
				nbright.links.remove(nbleft);
				if(intx3 != nbright) {
					nbright.links.insert(intx3);
				}
				if(intx3 != nbleft) {
					intx3.links.insert(nbleft);
				}
				if(intx3 != nbright) {
					intx3.links.insert(nbright);
				}
			}
			if(pnull) {
				intx3.node = zpp_$nape_geom_ZPP_$Simple.vertices.insert(intx3);
			}
			intx3.forced = true;
			if(pnull) {
				var an = a.node;
				var bn = b.node;
				an.data = b;
				bn.data = a;
				a.node = bn;
				b.node = an;
				b.next = a.next;
				a.next = b;
				a.prev = b.prev;
				b.prev = a;
				if(a.prev != null) {
					a.prev.next = a;
				}
				if(b.next != null) {
					b.next.prev = b;
				}
			}
			if(b.next != null && b != null && !(b.next.id < b.id ? zpp_$nape_geom_ZPP_$Simple.inthash.has(b.next.id,b.id) : zpp_$nape_geom_ZPP_$Simple.inthash.has(b.id,b.next.id))) {
				var intx4 = zpp_$nape_geom_ZPP_$Simple.sweep.intersection(b.next,b);
				if(intx4 != null) {
					if(intx4.vertex.x >= zpp_$nape_geom_ZPP_$Simple.sweep.sweepx) {
						var cur8 = zpp_$nape_geom_ZPP_$Simple.queue.parent;
						while(cur8 != null) if(zpp_$nape_geom_ZPP_$Simple.queue.lt(intx4,cur8.data)) {
							cur8 = cur8.prev;
						} else if(zpp_$nape_geom_ZPP_$Simple.queue.lt(cur8.data,intx4)) {
							cur8 = cur8.next;
						} else {
							break;
						}
						var ex3 = cur8;
						if(ex3 == null) {
							var cur9 = zpp_$nape_geom_ZPP_$Simple.ints.parent;
							while(cur9 != null) if(zpp_$nape_geom_ZPP_$Simple.ints.lt(intx4,cur9.data)) {
								cur9 = cur9.prev;
							} else if(zpp_$nape_geom_ZPP_$Simple.ints.lt(cur9.data,intx4)) {
								cur9 = cur9.next;
							} else {
								break;
							}
							var vx3 = cur9;
							if(vx3 != null) {
								var o16 = intx4.vertex;
								o16.links.clear();
								o16.node = null;
								o16.forced = false;
								o16.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
								zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o16;
								intx4.vertex = vx3.data.vertex;
								vx3.data = intx4;
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx4);
							} else {
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx4);
								zpp_$nape_geom_ZPP_$Simple.ints.insert(intx4);
							}
							if(b.next.id < b.id) {
								var tmp6 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id6 = b.next.id;
								var di6 = b.id;
								var ret12;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret12 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret12 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret12.next;
									ret12.next = null;
								}
								ret12.id = id6;
								ret12.di = di6;
								var ret13 = ret12;
								ret13.value = true;
								tmp6.add(ret13);
							} else {
								var tmp7 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id7 = b.id;
								var di7 = b.next.id;
								var ret14;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret14 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret14 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret14.next;
									ret14.next = null;
								}
								ret14.id = id7;
								ret14.di = di7;
								var ret15 = ret14;
								ret15.value = true;
								tmp7.add(ret15);
							}
						} else {
							var x3 = ex3.data;
							var o17 = intx4.vertex;
							o17.links.clear();
							o17.node = null;
							o17.forced = false;
							o17.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o17;
							var o18 = intx4;
							o18.vertex = null;
							o18.segment = o18.segment2 = null;
							o18.node = null;
							o18.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o18;
						}
					} else {
						var o19 = intx4.vertex;
						o19.links.clear();
						o19.node = null;
						o19.forced = false;
						o19.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o19;
						var o20 = intx4;
						o20.vertex = null;
						o20.segment = o20.segment2 = null;
						o20.node = null;
						o20.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o20;
					}
				}
			}
			if(a != null && a.prev != null && !(a.id < a.prev.id ? zpp_$nape_geom_ZPP_$Simple.inthash.has(a.id,a.prev.id) : zpp_$nape_geom_ZPP_$Simple.inthash.has(a.prev.id,a.id))) {
				var intx5 = zpp_$nape_geom_ZPP_$Simple.sweep.intersection(a,a.prev);
				if(intx5 != null) {
					if(intx5.vertex.x >= zpp_$nape_geom_ZPP_$Simple.sweep.sweepx) {
						var cur10 = zpp_$nape_geom_ZPP_$Simple.queue.parent;
						while(cur10 != null) if(zpp_$nape_geom_ZPP_$Simple.queue.lt(intx5,cur10.data)) {
							cur10 = cur10.prev;
						} else if(zpp_$nape_geom_ZPP_$Simple.queue.lt(cur10.data,intx5)) {
							cur10 = cur10.next;
						} else {
							break;
						}
						var ex4 = cur10;
						if(ex4 == null) {
							var cur11 = zpp_$nape_geom_ZPP_$Simple.ints.parent;
							while(cur11 != null) if(zpp_$nape_geom_ZPP_$Simple.ints.lt(intx5,cur11.data)) {
								cur11 = cur11.prev;
							} else if(zpp_$nape_geom_ZPP_$Simple.ints.lt(cur11.data,intx5)) {
								cur11 = cur11.next;
							} else {
								break;
							}
							var vx4 = cur11;
							if(vx4 != null) {
								var o21 = intx5.vertex;
								o21.links.clear();
								o21.node = null;
								o21.forced = false;
								o21.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
								zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o21;
								intx5.vertex = vx4.data.vertex;
								vx4.data = intx5;
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx5);
							} else {
								zpp_$nape_geom_ZPP_$Simple.queue.insert(intx5);
								zpp_$nape_geom_ZPP_$Simple.ints.insert(intx5);
							}
							if(a.id < a.prev.id) {
								var tmp8 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id8 = a.id;
								var di8 = a.prev.id;
								var ret16;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret16 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret16 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret16.next;
									ret16.next = null;
								}
								ret16.id = id8;
								ret16.di = di8;
								var ret17 = ret16;
								ret17.value = true;
								tmp8.add(ret17);
							} else {
								var tmp9 = zpp_$nape_geom_ZPP_$Simple.inthash;
								var id9 = a.prev.id;
								var di9 = a.id;
								var ret18;
								if(zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool == null) {
									ret18 = new zpp_$nape_util_Hashable2_$Boolfalse();
								} else {
									ret18 = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
									zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = ret18.next;
									ret18.next = null;
								}
								ret18.id = id9;
								ret18.di = di9;
								var ret19 = ret18;
								ret19.value = true;
								tmp9.add(ret19);
							}
						} else {
							var x4 = ex4.data;
							var o22 = intx5.vertex;
							o22.links.clear();
							o22.node = null;
							o22.forced = false;
							o22.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o22;
							var o23 = intx5;
							o23.vertex = null;
							o23.segment = o23.segment2 = null;
							o23.node = null;
							o23.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
							zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o23;
						}
					} else {
						var o24 = intx5.vertex;
						o24.links.clear();
						o24.node = null;
						o24.forced = false;
						o24.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o24;
						var o25 = intx5;
						o25.vertex = null;
						o25.segment = o25.segment2 = null;
						o25.node = null;
						o25.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
						zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o25;
					}
				}
			}
			zpp_$nape_geom_ZPP_$Simple.ints.remove(e);
		}
		var o26 = e;
		o26.vertex = null;
		o26.segment = o26.segment2 = null;
		o26.node = null;
		o26.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o26;
	}
	var _g = 0;
	var _g1 = zpp_$nape_geom_ZPP_$Simple.inthash.table.length;
	while(_g < _g1) {
		var i = _g++;
		var n = zpp_$nape_geom_ZPP_$Simple.inthash.table[i];
		if(n == null) {
			continue;
		}
		while(n != null) {
			var t = n.hnext;
			n.hnext = null;
			var o = n;
			o.next = zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool;
			zpp_$nape_util_Hashable2_$Boolfalse.zpp_pool = o;
			n = t;
		}
		zpp_$nape_geom_ZPP_$Simple.inthash.table[i] = null;
	}
	if(rets == null) {
		rets = new zpp_$nape_util_ZNPList_$ZPP_$GeomVert();
	}
	while(!zpp_$nape_geom_ZPP_$Simple.vertices.empty()) zpp_$nape_geom_ZPP_$Simple.clip_polygon(zpp_$nape_geom_ZPP_$Simple.vertices,rets);
	return rets;
};
zpp_$nape_geom_ZPP_$Simple.clip_polygon = function(vertices,rets) {
	var ret = null;
	var cur = vertices.first();
	var fst = cur;
	var pren = cur.links.parent;
	var nxtn = pren.prev == null ? pren.next : pren.prev;
	var pre = pren.data;
	var nxt = nxtn.data;
	var ux = 0.0;
	var uy = 0.0;
	ux = cur.x - pre.x;
	uy = cur.y - pre.y;
	var vx = 0.0;
	var vy = 0.0;
	vx = nxt.x - cur.x;
	vy = nxt.y - cur.y;
	if(vy * ux - vx * uy < 0) {
		nxt = pre;
	}
	var x = cur.x;
	var y = cur.y;
	var ret1;
	if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
		ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
	} else {
		ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
		zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
		ret1.next = null;
	}
	ret1.forced = false;
	ret1.x = x;
	ret1.y = y;
	var obj = ret1;
	if(ret == null) {
		ret = obj.prev = obj.next = obj;
	} else {
		obj.prev = ret;
		obj.next = ret.next;
		ret.next.prev = obj;
		ret.next = obj;
	}
	ret = obj;
	ret.forced = cur.forced;
	while(true) {
		cur.links.remove(nxt);
		nxt.links.remove(cur);
		if(nxt == fst) {
			if(cur.links.empty()) {
				vertices.remove(cur);
				var o = cur;
				o.links.clear();
				o.node = null;
				o.forced = false;
				o.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o;
			}
			break;
		}
		var x = nxt.x;
		var y = nxt.y;
		var ret1;
		if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
			zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.forced = false;
		ret1.x = x;
		ret1.y = y;
		var obj = ret1;
		if(ret == null) {
			ret = obj.prev = obj.next = obj;
		} else {
			obj.prev = ret;
			obj.next = ret.next;
			ret.next.prev = obj;
			ret.next = obj;
		}
		ret = obj;
		ret.forced = nxt.forced;
		if(nxt.links.singular()) {
			if(cur.links.empty()) {
				vertices.remove(cur);
				var o1 = cur;
				o1.links.clear();
				o1.node = null;
				o1.forced = false;
				o1.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o1;
			}
			cur = nxt;
			nxt = nxt.links.parent.data;
		} else {
			var min = null;
			var minl = 0.0;
			if(!nxt.links.empty()) {
				var set_ite = nxt.links.parent;
				while(set_ite.prev != null) set_ite = set_ite.prev;
				while(set_ite != null) {
					var p = set_ite.data;
					if(min == null) {
						min = p;
						var ux = 0.0;
						var uy = 0.0;
						ux = nxt.x - cur.x;
						uy = nxt.y - cur.y;
						var vx = 0.0;
						var vy = 0.0;
						vx = p.x - nxt.x;
						vy = p.y - nxt.y;
						minl = vy * ux - vx * uy;
					} else {
						var ux1 = 0.0;
						var uy1 = 0.0;
						ux1 = nxt.x - cur.x;
						uy1 = nxt.y - cur.y;
						var vx1 = 0.0;
						var vy1 = 0.0;
						vx1 = p.x - nxt.x;
						vy1 = p.y - nxt.y;
						var nleft = vy1 * ux1 - vx1 * uy1;
						if(nleft > 0 && minl <= 0) {
							min = p;
							minl = nleft;
						} else if(minl * nleft >= 0) {
							var ux2 = 0.0;
							var uy2 = 0.0;
							ux2 = nxt.x - p.x;
							uy2 = nxt.y - p.y;
							var vx2 = 0.0;
							var vy2 = 0.0;
							vx2 = min.x - nxt.x;
							vy2 = min.y - nxt.y;
							var pleft = vy2 * ux2 - vx2 * uy2;
							if(pleft > 0) {
								min = p;
								minl = nleft;
							}
						}
					}
					if(set_ite.next != null) {
						set_ite = set_ite.next;
						while(set_ite.prev != null) set_ite = set_ite.prev;
					} else {
						while(set_ite.parent != null && set_ite == set_ite.parent.next) set_ite = set_ite.parent;
						set_ite = set_ite.parent;
					}
				}
			}
			if(cur.links.empty()) {
				vertices.remove(cur);
				var o2 = cur;
				o2.links.clear();
				o2.node = null;
				o2.forced = false;
				o2.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o2;
			}
			cur = nxt;
			nxt = min;
		}
	}
	vertices.remove(fst);
	var o = fst;
	o.links.clear();
	o.node = null;
	o.forced = false;
	o.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
	zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o;
	rets.add(ret);
};
zpp_$nape_geom_ZPP_$Simple.isSimple = function(poly) {
	if(zpp_$nape_geom_ZPP_$Simple.sweep == null) {
		zpp_$nape_geom_ZPP_$Simple.sweep = new zpp_$nape_geom_ZPP_$SimpleSweep();
		zpp_$nape_geom_ZPP_$Simple.inthash = new zpp_$nape_util_FastHash2_$Hashable2_$Boolfalse();
	}
	var vertices = zpp_$nape_geom_ZPP_$Simple.list_vertices;
	if(vertices == null) {
		vertices = zpp_$nape_geom_ZPP_$Simple.list_vertices = new zpp_$nape_util_ZNPList_$ZPP_$SimpleVert();
	}
	var F = poly;
	var L = poly;
	if(F != null) {
		var nite = F;
		do {
			var v = nite;
			var x = v.x;
			var y = v.y;
			var ret;
			if(zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool == null) {
				ret = new zpp_$nape_geom_ZPP_$SimpleVert();
			} else {
				ret = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.x = x;
			ret.y = y;
			vertices.add(ret);
			nite = nite.next;
		} while(nite != L);
	}
	var queue = zpp_$nape_geom_ZPP_$Simple.list_queue;
	if(queue == null) {
		queue = zpp_$nape_geom_ZPP_$Simple.list_queue = new zpp_$nape_util_ZNPList_$ZPP_$SimpleEvent();
	}
	var cx_ite = vertices.head;
	var u = cx_ite.elt;
	cx_ite = cx_ite.next;
	while(cx_ite != null) {
		var v = cx_ite.elt;
		var ret;
		if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$SimpleEvent();
		} else {
			ret = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
			zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.vertex = u;
		var e1 = queue.add(ret);
		var ret1;
		if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$SimpleEvent();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
			zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.vertex = v;
		var e2 = queue.add(ret1);
		var tmp;
		if(zpp_$nape_geom_ZPP_$SimpleEvent.less_xy(e1,e2)) {
			e1.type = 1;
			e2.type = 2;
			tmp = zpp_$nape_geom_ZPP_$SimpleSeg.get(u,v);
		} else {
			e1.type = 2;
			e2.type = 1;
			tmp = zpp_$nape_geom_ZPP_$SimpleSeg.get(v,u);
		}
		e1.segment = e2.segment = tmp;
		u = v;
		cx_ite = cx_ite.next;
	}
	var v = vertices.head.elt;
	var ret;
	if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$SimpleEvent();
	} else {
		ret = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.vertex = u;
	var e1 = queue.add(ret);
	var ret;
	if(zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$SimpleEvent();
	} else {
		ret = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.vertex = v;
	var e2 = queue.add(ret);
	var tmp;
	if(zpp_$nape_geom_ZPP_$SimpleEvent.less_xy(e1,e2)) {
		e1.type = 1;
		e2.type = 2;
		tmp = zpp_$nape_geom_ZPP_$SimpleSeg.get(u,v);
	} else {
		e1.type = 2;
		e2.type = 1;
		tmp = zpp_$nape_geom_ZPP_$SimpleSeg.get(v,u);
	}
	e1.segment = e2.segment = tmp;
	var xxlist = queue;
	if(xxlist.head != null && xxlist.head.next != null) {
		var head = xxlist.head;
		var tail = null;
		var left = null;
		var right = null;
		var nxt = null;
		var listSize = 1;
		var numMerges;
		var leftSize;
		var rightSize;
		do {
			numMerges = 0;
			left = head;
			head = null;
			tail = head;
			while(left != null) {
				++numMerges;
				right = left;
				leftSize = 0;
				rightSize = listSize;
				while(right != null && leftSize < listSize) {
					++leftSize;
					right = right.next;
				}
				while(leftSize > 0 || rightSize > 0 && right != null) {
					if(leftSize == 0) {
						nxt = right;
						right = right.next;
						--rightSize;
					} else if(rightSize == 0 || right == null) {
						nxt = left;
						left = left.next;
						--leftSize;
					} else if(zpp_$nape_geom_ZPP_$SimpleEvent.less_xy(left.elt,right.elt)) {
						nxt = left;
						left = left.next;
						--leftSize;
					} else {
						nxt = right;
						right = right.next;
						--rightSize;
					}
					if(tail != null) {
						tail.next = nxt;
					} else {
						head = nxt;
					}
					tail = nxt;
				}
				left = right;
			}
			tail.next = null;
			listSize <<= 1;
		} while(numMerges > 1);
		xxlist.head = head;
		xxlist.modified = true;
		xxlist.pushmod = true;
	}
	var ret = true;
	while(queue.head != null) {
		var e = queue.pop_unsafe();
		var seg = e.segment;
		if(e.type == 1) {
			zpp_$nape_geom_ZPP_$Simple.sweep.add(seg);
			if(zpp_$nape_geom_ZPP_$Simple.sweep.intersect(seg,seg.next) || zpp_$nape_geom_ZPP_$Simple.sweep.intersect(seg,seg.prev)) {
				ret = false;
				break;
			}
		} else if(e.type == 2) {
			if(zpp_$nape_geom_ZPP_$Simple.sweep.intersect(seg.prev,seg.next)) {
				ret = false;
				break;
			}
			zpp_$nape_geom_ZPP_$Simple.sweep.remove(seg);
			var o = seg;
			o.left = o.right = null;
			o.prev = null;
			o.node = null;
			o.vertices.clear();
			o.next = zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool;
			zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool = o;
		}
		var o1 = e;
		o1.vertex = null;
		o1.segment = o1.segment2 = null;
		o1.node = null;
		o1.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o1;
	}
	while(queue.head != null) {
		var e = queue.pop_unsafe();
		if(e.type == 2) {
			var o = e.segment;
			o.left = o.right = null;
			o.prev = null;
			o.node = null;
			o.vertices.clear();
			o.next = zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool;
			zpp_$nape_geom_ZPP_$SimpleSeg.zpp_pool = o;
		}
		var o1 = e;
		o1.vertex = null;
		o1.segment = o1.segment2 = null;
		o1.node = null;
		o1.next = zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleEvent.zpp_pool = o1;
	}
	zpp_$nape_geom_ZPP_$Simple.sweep.clear();
	while(vertices.head != null) {
		var o = vertices.pop_unsafe();
		o.links.clear();
		o.node = null;
		o.forced = false;
		o.next = zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool;
		zpp_$nape_geom_ZPP_$SimpleVert.zpp_pool = o;
	}
	return ret;
};
var zpp_$nape_geom_ZPP_$SimplifyV = function() {
	this.forced = false;
	this.flag = false;
	this.prev = null;
	this.next = null;
	this.y = 0.0;
	this.x = 0.0;
};
zpp_$nape_geom_ZPP_$SimplifyV.__name__ = true;
var zpp_$nape_geom_ZPP_$SimplifyP = function() {
	this.max = null;
	this.min = null;
	this.next = null;
};
zpp_$nape_geom_ZPP_$SimplifyP.__name__ = true;
var zpp_$nape_geom_ZPP_$Simplify = function() { };
zpp_$nape_geom_ZPP_$Simplify.__name__ = true;
zpp_$nape_geom_ZPP_$Simplify.distance = function(v,a,b) {
	var nx = 0.0;
	var ny = 0.0;
	nx = b.x - a.x;
	ny = b.y - a.y;
	var cx = 0.0;
	var cy = 0.0;
	cx = v.x - a.x;
	cy = v.y - a.y;
	var den = nx * nx + ny * ny;
	if(den == 0.0) {
		return cx * cx + cy * cy;
	} else {
		var t = (cx * nx + cy * ny) / (nx * nx + ny * ny);
		if(t <= 0) {
			return cx * cx + cy * cy;
		} else if(t >= 1) {
			var dx = 0.0;
			var dy = 0.0;
			dx = v.x - b.x;
			dy = v.y - b.y;
			return dx * dx + dy * dy;
		} else {
			var t1 = t;
			cx -= nx * t1;
			cy -= ny * t1;
			return cx * cx + cy * cy;
		}
	}
};
zpp_$nape_geom_ZPP_$Simplify.simplify = function(P,epsilon) {
	var ret = null;
	var min = null;
	var max = null;
	epsilon *= epsilon;
	if(zpp_$nape_geom_ZPP_$Simplify.stack == null) {
		zpp_$nape_geom_ZPP_$Simplify.stack = new zpp_$nape_util_ZNPList_$ZPP_$SimplifyP();
	}
	var pre = null;
	var fst = null;
	var cur = P;
	do {
		var ret1;
		if(zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$SimplifyV();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool;
			zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.x = cur.x;
		ret1.y = cur.y;
		ret1.flag = false;
		var v = ret1;
		v.forced = cur.forced;
		if(v.forced) {
			v.flag = true;
			if(pre != null) {
				var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
				var ret2;
				if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$SimplifyP();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
					zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.min = pre;
				ret2.max = v;
				tmp.add(ret2);
			} else {
				fst = v;
			}
			pre = v;
		}
		var obj = v;
		if(ret == null) {
			ret = obj.prev = obj.next = obj;
		} else {
			obj.prev = ret;
			obj.next = ret.next;
			ret.next.prev = obj;
			ret.next = obj;
		}
		ret = obj;
		if(min == null) {
			min = ret;
			max = ret;
		} else {
			if(ret.x - min.x + (ret.y - min.y) < 0.0) {
				min = ret;
			}
			if(max.x - ret.x + (max.y - ret.y) < 0.0) {
				max = ret;
			}
		}
		cur = cur.next;
	} while(cur != P);
	if(zpp_$nape_geom_ZPP_$Simplify.stack.head == null) {
		if(fst == null) {
			min.flag = max.flag = true;
			var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
			var ret1;
			if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
				zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.min = min;
			ret1.max = max;
			tmp.add(ret1);
			var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
			var ret1;
			if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
				zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.min = max;
			ret1.max = min;
			tmp.add(ret1);
		} else {
			var d1 = min.x - fst.x + (min.y - fst.y);
			if(d1 < 0) {
				d1 = -d1;
			}
			var d2 = max.x - fst.x + (max.y - fst.y);
			if(d2 < 0) {
				d2 = -d2;
			}
			if(d1 > d2) {
				min.flag = fst.flag = true;
				var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
				var ret1;
				if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
					zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.min = min;
				ret1.max = fst;
				tmp.add(ret1);
				var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
				var ret1;
				if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
					zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.min = fst;
				ret1.max = min;
				tmp.add(ret1);
			} else {
				max.flag = fst.flag = true;
				var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
				var ret1;
				if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
					zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.min = max;
				ret1.max = fst;
				tmp.add(ret1);
				var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
				var ret1;
				if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
					zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.min = fst;
				ret1.max = max;
				tmp.add(ret1);
			}
		}
	} else {
		var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
		var ret1;
		if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
			ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
		} else {
			ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
			zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
			ret1.next = null;
		}
		ret1.min = pre;
		ret1.max = fst;
		tmp.add(ret1);
	}
	while(zpp_$nape_geom_ZPP_$Simplify.stack.head != null) {
		var cur = zpp_$nape_geom_ZPP_$Simplify.stack.pop_unsafe();
		var min = cur.min;
		var max = cur.max;
		var o = cur;
		o.min = o.max = null;
		o.next = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
		zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = o;
		var dmax = epsilon;
		var dv = null;
		var ite = min.next;
		while(ite != max) {
			var dist = zpp_$nape_geom_ZPP_$Simplify.distance(ite,min,max);
			if(dist > dmax) {
				dmax = dist;
				dv = ite;
			}
			ite = ite.next;
		}
		if(dv != null) {
			dv.flag = true;
			var tmp = zpp_$nape_geom_ZPP_$Simplify.stack;
			var ret1;
			if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$SimplifyP();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
				zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.min = min;
			ret1.max = dv;
			tmp.add(ret1);
			var tmp1 = zpp_$nape_geom_ZPP_$Simplify.stack;
			var ret2;
			if(zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool == null) {
				ret2 = new zpp_$nape_geom_ZPP_$SimplifyP();
			} else {
				ret2 = zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool;
				zpp_$nape_geom_ZPP_$SimplifyP.zpp_pool = ret2.next;
				ret2.next = null;
			}
			ret2.min = dv;
			ret2.max = max;
			tmp1.add(ret2);
		}
	}
	var retp = null;
	while(ret != null) {
		if(ret.flag) {
			var x = ret.x;
			var y = ret.y;
			var ret1;
			if(zpp_$nape_geom_ZPP_$GeomVert.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$GeomVert();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$GeomVert.zpp_pool;
				zpp_$nape_geom_ZPP_$GeomVert.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.forced = false;
			ret1.x = x;
			ret1.y = y;
			var obj = ret1;
			if(retp == null) {
				retp = obj.prev = obj.next = obj;
			} else {
				obj.prev = retp;
				obj.next = retp.next;
				retp.next.prev = obj;
				retp.next = obj;
			}
			retp = obj;
			retp.forced = ret.forced;
		}
		if(ret != null && ret.prev == ret) {
			ret.next = ret.prev = null;
			var o = ret;
			o.next = zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool;
			zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool = o;
			ret = null;
		} else {
			var retnodes = ret.next;
			ret.prev.next = ret.next;
			ret.next.prev = ret.prev;
			ret.next = ret.prev = null;
			var o1 = ret;
			o1.next = zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool;
			zpp_$nape_geom_ZPP_$SimplifyV.zpp_pool = o1;
			ret = null;
			ret = retnodes;
		}
	}
	return retp;
};
var zpp_$nape_geom_ZPP_$ToiEvent = function() {
	this.kinematic = false;
	this.failed = false;
	this.slipped = false;
	this.axis = null;
	this.c2 = null;
	this.c1 = null;
	this.frozen2 = false;
	this.frozen1 = false;
	this.arbiter = null;
	this.s2 = null;
	this.s1 = null;
	this.toi = 0.0;
	this.next = null;
	this.c1 = new zpp_$nape_geom_ZPP_$Vec2();
	this.c2 = new zpp_$nape_geom_ZPP_$Vec2();
	this.axis = new zpp_$nape_geom_ZPP_$Vec2();
};
zpp_$nape_geom_ZPP_$ToiEvent.__name__ = true;
var zpp_$nape_geom_ZPP_$SweepDistance = function() { };
zpp_$nape_geom_ZPP_$SweepDistance.__name__ = true;
zpp_$nape_geom_ZPP_$SweepDistance.dynamicSweep = function(toi,timeStep,lowerBound,negRadius,userAPI) {
	if(userAPI == null) {
		userAPI = false;
	}
	var s1 = toi.s1;
	var s2 = toi.s2;
	var b1 = s1.body;
	var b2 = s2.body;
	var deltax = 0.0;
	var deltay = 0.0;
	deltax = b2.velx - b1.velx;
	deltay = b2.vely - b1.vely;
	var ang1 = b1.angvel;
	if(ang1 < 0) {
		ang1 = -ang1;
	}
	var ang2 = b2.angvel;
	if(ang2 < 0) {
		ang2 = -ang2;
	}
	var angBias = s1.sweepCoef * ang1 + s2.sweepCoef * ang2;
	if(!userAPI && !toi.kinematic && deltax * deltax + deltay * deltay < nape_Config.dynamicSweepLinearThreshold * nape_Config.dynamicSweepLinearThreshold && angBias < nape_Config.dynamicSweepAngularThreshold) {
		toi.toi = -1;
		toi.failed = true;
		return;
	}
	var c1 = toi.c1;
	var c2 = toi.c2;
	var axis = toi.axis;
	var curTOI = lowerBound;
	var curIter = 0;
	while(true) {
		var dt = curTOI * timeStep;
		var delta = dt - b1.sweepTime;
		if(delta != 0) {
			b1.sweepTime = dt;
			var t = delta;
			b1.posx += b1.velx * t;
			b1.posy += b1.vely * t;
			if(b1.angvel != 0) {
				var dr = b1.sweep_angvel * delta;
				b1.rot += dr;
				if(dr * dr > 0.0001) {
					b1.axisx = Math.sin(b1.rot);
					b1.axisy = Math.cos(b1.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * b1.axisx + dr * b1.axisy) * m;
					b1.axisy = (p * b1.axisy - dr * b1.axisx) * m;
					b1.axisx = nx;
				}
			}
		}
		if(s1.type == 0) {
			s1.worldCOMx = b1.posx + (b1.axisy * s1.localCOMx - b1.axisx * s1.localCOMy);
			s1.worldCOMy = b1.posy + (s1.localCOMx * b1.axisx + s1.localCOMy * b1.axisy);
		} else {
			var p1 = s1.polygon;
			var li = p1.lverts.next;
			var cx_ite = p1.gverts.next;
			while(cx_ite != null) {
				var g = cx_ite;
				var l = li;
				li = li.next;
				g.x = b1.posx + (b1.axisy * l.x - b1.axisx * l.y);
				g.y = b1.posy + (l.x * b1.axisx + l.y * b1.axisy);
				cx_ite = cx_ite.next;
			}
			var ite = p1.edges.head;
			var cx_ite1 = p1.gverts.next;
			var u = cx_ite1;
			cx_ite1 = cx_ite1.next;
			while(cx_ite1 != null) {
				var v = cx_ite1;
				var e = ite.elt;
				ite = ite.next;
				e.gnormx = b1.axisy * e.lnormx - b1.axisx * e.lnormy;
				e.gnormy = e.lnormx * b1.axisx + e.lnormy * b1.axisy;
				e.gprojection = b1.posx * e.gnormx + b1.posy * e.gnormy + e.lprojection;
				e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
				e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
				u = v;
				cx_ite1 = cx_ite1.next;
			}
			var v1 = p1.gverts.next;
			var e1 = ite.elt;
			ite = ite.next;
			e1.gnormx = b1.axisy * e1.lnormx - b1.axisx * e1.lnormy;
			e1.gnormy = e1.lnormx * b1.axisx + e1.lnormy * b1.axisy;
			e1.gprojection = b1.posx * e1.gnormx + b1.posy * e1.gnormy + e1.lprojection;
			e1.tp0 = u.y * e1.gnormx - u.x * e1.gnormy;
			e1.tp1 = v1.y * e1.gnormx - v1.x * e1.gnormy;
		}
		var dt1 = curTOI * timeStep;
		var delta1 = dt1 - b2.sweepTime;
		if(delta1 != 0) {
			b2.sweepTime = dt1;
			var t1 = delta1;
			b2.posx += b2.velx * t1;
			b2.posy += b2.vely * t1;
			if(b2.angvel != 0) {
				var dr1 = b2.sweep_angvel * delta1;
				b2.rot += dr1;
				if(dr1 * dr1 > 0.0001) {
					b2.axisx = Math.sin(b2.rot);
					b2.axisy = Math.cos(b2.rot);
				} else {
					var d21 = dr1 * dr1;
					var p2 = 1 - 0.5 * d21;
					var m1 = 1 - d21 * d21 / 8;
					var nx1 = (p2 * b2.axisx + dr1 * b2.axisy) * m1;
					b2.axisy = (p2 * b2.axisy - dr1 * b2.axisx) * m1;
					b2.axisx = nx1;
				}
			}
		}
		if(s2.type == 0) {
			s2.worldCOMx = b2.posx + (b2.axisy * s2.localCOMx - b2.axisx * s2.localCOMy);
			s2.worldCOMy = b2.posy + (s2.localCOMx * b2.axisx + s2.localCOMy * b2.axisy);
		} else {
			var p3 = s2.polygon;
			var li1 = p3.lverts.next;
			var cx_ite2 = p3.gverts.next;
			while(cx_ite2 != null) {
				var g1 = cx_ite2;
				var l1 = li1;
				li1 = li1.next;
				g1.x = b2.posx + (b2.axisy * l1.x - b2.axisx * l1.y);
				g1.y = b2.posy + (l1.x * b2.axisx + l1.y * b2.axisy);
				cx_ite2 = cx_ite2.next;
			}
			var ite1 = p3.edges.head;
			var cx_ite3 = p3.gverts.next;
			var u1 = cx_ite3;
			cx_ite3 = cx_ite3.next;
			while(cx_ite3 != null) {
				var v2 = cx_ite3;
				var e2 = ite1.elt;
				ite1 = ite1.next;
				e2.gnormx = b2.axisy * e2.lnormx - b2.axisx * e2.lnormy;
				e2.gnormy = e2.lnormx * b2.axisx + e2.lnormy * b2.axisy;
				e2.gprojection = b2.posx * e2.gnormx + b2.posy * e2.gnormy + e2.lprojection;
				e2.tp0 = u1.y * e2.gnormx - u1.x * e2.gnormy;
				e2.tp1 = v2.y * e2.gnormx - v2.x * e2.gnormy;
				u1 = v2;
				cx_ite3 = cx_ite3.next;
			}
			var v3 = p3.gverts.next;
			var e3 = ite1.elt;
			ite1 = ite1.next;
			e3.gnormx = b2.axisy * e3.lnormx - b2.axisx * e3.lnormy;
			e3.gnormy = e3.lnormx * b2.axisx + e3.lnormy * b2.axisy;
			e3.gprojection = b2.posx * e3.gnormx + b2.posy * e3.gnormy + e3.lprojection;
			e3.tp0 = u1.y * e3.gnormx - u1.x * e3.gnormy;
			e3.tp1 = v3.y * e3.gnormx - v3.x * e3.gnormy;
		}
		var s11 = s1;
		var s21 = s2;
		var w1 = c1;
		var w2 = c2;
		var sep;
		if(s11.type == 0 && s21.type == 0) {
			var c11 = s11.circle;
			var c21 = s21.circle;
			var dist;
			var nx2 = 0.0;
			var ny = 0.0;
			nx2 = c21.worldCOMx - c11.worldCOMx;
			ny = c21.worldCOMy - c11.worldCOMy;
			var x = nx2 * nx2 + ny * ny;
			var len;
			if(x == 0.0) {
				len = 0.0;
			} else {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				len = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
			}
			dist = len - (c11.radius + c21.radius);
			if(dist < 1e100) {
				if(len == 0) {
					nx2 = 1;
					ny = 0;
				} else {
					var t2 = 1.0 / len;
					nx2 *= t2;
					ny *= t2;
				}
				var t3 = c11.radius;
				w1.x = c11.worldCOMx + nx2 * t3;
				w1.y = c11.worldCOMy + ny * t3;
				var t4 = -c21.radius;
				w2.x = c21.worldCOMx + nx2 * t4;
				w2.y = c21.worldCOMy + ny * t4;
				axis.x = nx2;
				axis.y = ny;
			}
			sep = dist;
		} else {
			var swapped = false;
			if(s11.type == 0 && s21.type == 1) {
				var tmp = s11;
				s11 = s21;
				s21 = tmp;
				var tmp2 = w1;
				w1 = w2;
				w2 = tmp2;
				swapped = true;
			}
			if(s11.type == 1 && s21.type == 0) {
				var poly = s11.polygon;
				var circle = s21.circle;
				var best = -1e+100;
				var a0 = null;
				var cx_ite4 = poly.edges.head;
				while(cx_ite4 != null) {
					var a = cx_ite4.elt;
					var dist1 = a.gnormx * circle.worldCOMx + a.gnormy * circle.worldCOMy - a.gprojection - circle.radius;
					if(dist1 > 1e100) {
						best = dist1;
						break;
					}
					if(dist1 > 0) {
						if(dist1 > best) {
							best = dist1;
							a0 = a;
						}
					} else if(best < 0 && dist1 > best) {
						best = dist1;
						a0 = a;
					}
					cx_ite4 = cx_ite4.next;
				}
				if(best < 1e100) {
					var v0 = a0.gp0;
					var v11 = a0.gp1;
					var dt2 = circle.worldCOMy * a0.gnormx - circle.worldCOMx * a0.gnormy;
					if(dt2 <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
						var nx3 = 0.0;
						var ny1 = 0.0;
						nx3 = circle.worldCOMx - v0.x;
						ny1 = circle.worldCOMy - v0.y;
						var x1 = nx3 * nx3 + ny1 * ny1;
						var len1;
						if(x1 == 0.0) {
							len1 = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x1;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x21 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							len1 = 1 / (x21 * (1.5 - 0.5 * x1 * x21 * x21));
						}
						best = len1 - circle.radius;
						if(best < 1e100) {
							if(len1 == 0) {
								nx3 = 1;
								ny1 = 0;
							} else {
								var t5 = 1.0 / len1;
								nx3 *= t5;
								ny1 *= t5;
							}
							var t6 = 0;
							w1.x = v0.x + nx3 * t6;
							w1.y = v0.y + ny1 * t6;
							var t7 = -circle.radius;
							w2.x = circle.worldCOMx + nx3 * t7;
							w2.y = circle.worldCOMy + ny1 * t7;
							axis.x = nx3;
							axis.y = ny1;
						}
					} else if(dt2 >= v11.y * a0.gnormx - v11.x * a0.gnormy) {
						var nx4 = 0.0;
						var ny2 = 0.0;
						nx4 = circle.worldCOMx - v11.x;
						ny2 = circle.worldCOMy - v11.y;
						var x3 = nx4 * nx4 + ny2 * ny2;
						var len2;
						if(x3 == 0.0) {
							len2 = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x3;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x22 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							len2 = 1 / (x22 * (1.5 - 0.5 * x3 * x22 * x22));
						}
						best = len2 - circle.radius;
						if(best < 1e100) {
							if(len2 == 0) {
								nx4 = 1;
								ny2 = 0;
							} else {
								var t8 = 1.0 / len2;
								nx4 *= t8;
								ny2 *= t8;
							}
							var t9 = 0;
							w1.x = v11.x + nx4 * t9;
							w1.y = v11.y + ny2 * t9;
							var t10 = -circle.radius;
							w2.x = circle.worldCOMx + nx4 * t10;
							w2.y = circle.worldCOMy + ny2 * t10;
							axis.x = nx4;
							axis.y = ny2;
						}
					} else {
						var t11 = -circle.radius;
						w2.x = circle.worldCOMx + a0.gnormx * t11;
						w2.y = circle.worldCOMy + a0.gnormy * t11;
						var t12 = -best;
						w1.x = w2.x + a0.gnormx * t12;
						w1.y = w2.y + a0.gnormy * t12;
						axis.x = a0.gnormx;
						axis.y = a0.gnormy;
					}
				}
				if(swapped) {
					axis.x = -axis.x;
					axis.y = -axis.y;
				}
				sep = best;
			} else {
				var p11 = s11.polygon;
				var p21 = s21.polygon;
				var best1 = -1e+100;
				var a1 = null;
				var a2 = null;
				var besti = 0;
				var cx_ite5 = p11.edges.head;
				while(cx_ite5 != null) {
					var a3 = cx_ite5.elt;
					var min = 1e100;
					var cx_ite6 = p21.gverts.next;
					while(cx_ite6 != null) {
						var v4 = cx_ite6;
						var k = a3.gnormx * v4.x + a3.gnormy * v4.y;
						if(k < min) {
							min = k;
						}
						cx_ite6 = cx_ite6.next;
					}
					min -= a3.gprojection;
					if(min > 1e100) {
						best1 = min;
						break;
					}
					if(min > 0) {
						if(min > best1) {
							best1 = min;
							a1 = a3;
							besti = 1;
						}
					} else if(best1 < 0 && min > best1) {
						best1 = min;
						a1 = a3;
						besti = 1;
					}
					cx_ite5 = cx_ite5.next;
				}
				if(best1 < 1e100) {
					var cx_ite7 = p21.edges.head;
					while(cx_ite7 != null) {
						var a4 = cx_ite7.elt;
						var min1 = 1e100;
						var cx_ite8 = p11.gverts.next;
						while(cx_ite8 != null) {
							var v5 = cx_ite8;
							var k1 = a4.gnormx * v5.x + a4.gnormy * v5.y;
							if(k1 < min1) {
								min1 = k1;
							}
							cx_ite8 = cx_ite8.next;
						}
						min1 -= a4.gprojection;
						if(min1 > 1e100) {
							best1 = min1;
							break;
						}
						if(min1 > 0) {
							if(min1 > best1) {
								best1 = min1;
								a2 = a4;
								besti = 2;
							}
						} else if(best1 < 0 && min1 > best1) {
							best1 = min1;
							a2 = a4;
							besti = 2;
						}
						cx_ite7 = cx_ite7.next;
					}
					if(best1 < 1e100) {
						var q1;
						var q2;
						var ax;
						if(besti == 1) {
							q1 = p11;
							q2 = p21;
							ax = a1;
						} else {
							q1 = p21;
							q2 = p11;
							ax = a2;
							var tmp1 = w1;
							w1 = w2;
							w2 = tmp1;
							swapped = !swapped;
						}
						var ay = null;
						var min2 = 1e100;
						var cx_ite9 = q2.edges.head;
						while(cx_ite9 != null) {
							var a5 = cx_ite9.elt;
							var k2 = ax.gnormx * a5.gnormx + ax.gnormy * a5.gnormy;
							if(k2 < min2) {
								min2 = k2;
								ay = a5;
							}
							cx_ite9 = cx_ite9.next;
						}
						if(swapped) {
							axis.x = -ax.gnormx;
							axis.y = -ax.gnormy;
						} else {
							axis.x = ax.gnormx;
							axis.y = ax.gnormy;
						}
						if(best1 >= 0) {
							var v01 = ax.gp0;
							var v12 = ax.gp1;
							var q0 = ay.gp0;
							var q11 = ay.gp1;
							var vx = 0.0;
							var vy = 0.0;
							var qx = 0.0;
							var qy = 0.0;
							vx = v12.x - v01.x;
							vy = v12.y - v01.y;
							qx = q11.x - q0.x;
							qy = q11.y - q0.y;
							var vdot = 1 / (vx * vx + vy * vy);
							var qdot = 1 / (qx * qx + qy * qy);
							var t13 = -(vx * (v01.x - q0.x) + vy * (v01.y - q0.y)) * vdot;
							var t21 = -(vx * (v01.x - q11.x) + vy * (v01.y - q11.y)) * vdot;
							var s12 = -(qx * (q0.x - v01.x) + qy * (q0.y - v01.y)) * qdot;
							var s22 = -(qx * (q0.x - v12.x) + qy * (q0.y - v12.y)) * qdot;
							if(t13 < 0) {
								t13 = 0;
							} else if(t13 > 1) {
								t13 = 1;
							}
							if(t21 < 0) {
								t21 = 0;
							} else if(t21 > 1) {
								t21 = 1;
							}
							if(s12 < 0) {
								s12 = 0;
							} else if(s12 > 1) {
								s12 = 1;
							}
							if(s22 < 0) {
								s22 = 0;
							} else if(s22 > 1) {
								s22 = 1;
							}
							var f1x = 0.0;
							var f1y = 0.0;
							var t14 = t13;
							f1x = v01.x + vx * t14;
							f1y = v01.y + vy * t14;
							var f2x = 0.0;
							var f2y = 0.0;
							var t15 = t21;
							f2x = v01.x + vx * t15;
							f2y = v01.y + vy * t15;
							var g1x = 0.0;
							var g1y = 0.0;
							var t16 = s12;
							g1x = q0.x + qx * t16;
							g1y = q0.y + qy * t16;
							var g2x = 0.0;
							var g2y = 0.0;
							var t17 = s22;
							g2x = q0.x + qx * t17;
							g2y = q0.y + qy * t17;
							var dx = 0.0;
							var dy = 0.0;
							dx = f1x - q0.x;
							dy = f1y - q0.y;
							var d1 = dx * dx + dy * dy;
							var dx1 = 0.0;
							var dy1 = 0.0;
							dx1 = f2x - q11.x;
							dy1 = f2y - q11.y;
							var d22 = dx1 * dx1 + dy1 * dy1;
							var dx2 = 0.0;
							var dy2 = 0.0;
							dx2 = g1x - v01.x;
							dy2 = g1y - v01.y;
							var e11 = dx2 * dx2 + dy2 * dy2;
							var dx3 = 0.0;
							var dy3 = 0.0;
							dx3 = g2x - v12.x;
							dy3 = g2y - v12.y;
							var e21 = dx3 * dx3 + dy3 * dy3;
							var minfx = 0.0;
							var minfy = 0.0;
							var minq = null;
							if(d1 < d22) {
								minfx = f1x;
								minfy = f1y;
								minq = q0;
							} else {
								minfx = f2x;
								minfy = f2y;
								minq = q11;
								d1 = d22;
							}
							var mingx = 0.0;
							var mingy = 0.0;
							var minv = null;
							if(e11 < e21) {
								mingx = g1x;
								mingy = g1y;
								minv = v01;
							} else {
								mingx = g2x;
								mingy = g2y;
								minv = v12;
								e11 = e21;
							}
							if(d1 < e11) {
								w1.x = minfx;
								w1.y = minfy;
								w2.x = minq.x;
								w2.y = minq.y;
								best1 = Math.sqrt(d1);
							} else {
								w2.x = mingx;
								w2.y = mingy;
								w1.x = minv.x;
								w1.y = minv.y;
								best1 = Math.sqrt(e11);
							}
							if(best1 != 0) {
								axis.x = w2.x - w1.x;
								axis.y = w2.y - w1.y;
								var t18 = 1.0 / best1;
								axis.x *= t18;
								axis.y *= t18;
								if(swapped) {
									axis.x = -axis.x;
									axis.y = -axis.y;
								}
							}
							sep = best1;
						} else {
							var c0x = 0.0;
							var c0y = 0.0;
							c0x = ay.gp0.x;
							c0y = ay.gp0.y;
							var c1x = 0.0;
							var c1y = 0.0;
							c1x = ay.gp1.x;
							c1y = ay.gp1.y;
							var dvx = 0.0;
							var dvy = 0.0;
							dvx = c1x - c0x;
							dvy = c1y - c0y;
							var d0 = ax.gnormy * c0x - ax.gnormx * c0y;
							var d11 = ax.gnormy * c1x - ax.gnormx * c1y;
							var den = 1 / (d11 - d0);
							var t19 = (-ax.tp1 - d0) * den;
							if(t19 > nape_Config.epsilon) {
								var t20 = t19;
								c0x += dvx * t20;
								c0y += dvy * t20;
							}
							var t22 = (-ax.tp0 - d11) * den;
							if(t22 < -nape_Config.epsilon) {
								var t23 = t22;
								c1x += dvx * t23;
								c1y += dvy * t23;
							}
							var c0d = c0x * ax.gnormx + c0y * ax.gnormy - ax.gprojection;
							var c1d = c1x * ax.gnormx + c1y * ax.gnormy - ax.gprojection;
							if(c0d < c1d) {
								w2.x = c0x;
								w2.y = c0y;
								var t24 = -c0d;
								w1.x = w2.x + ax.gnormx * t24;
								w1.y = w2.y + ax.gnormy * t24;
								sep = c0d;
							} else {
								w2.x = c1x;
								w2.y = c1y;
								var t25 = -c1d;
								w1.x = w2.x + ax.gnormx * t25;
								w1.y = w2.y + ax.gnormy * t25;
								sep = c1d;
							}
						}
					} else {
						sep = 1e100;
					}
				} else {
					sep = 1e100;
				}
			}
		}
		var sep1 = sep + negRadius;
		var dot = deltax * axis.x + deltay * axis.y;
		if(sep1 < nape_Config.distanceThresholdCCD) {
			if(userAPI) {
				break;
			}
			var d1x = 0.0;
			var d1y = 0.0;
			d1x = c1.x - b1.posx;
			d1y = c1.y - b1.posy;
			var d2x = 0.0;
			var d2y = 0.0;
			d2x = c2.x - b2.posx;
			d2y = c2.y - b2.posy;
			var proj = dot - b1.sweep_angvel * (axis.y * d1x - axis.x * d1y) + b2.sweep_angvel * (axis.y * d2x - axis.x * d2y);
			if(proj > 0) {
				toi.slipped = true;
			}
			if(proj <= 0 || sep1 < nape_Config.distanceThresholdCCD * 0.5) {
				break;
			}
		}
		var denom = (angBias - dot) * timeStep;
		if(denom <= 0) {
			curTOI = -1;
			break;
		}
		var delta2 = sep1 / denom;
		if(delta2 < 1e-6) {
			delta2 = 1e-6;
		}
		curTOI += delta2;
		if(curTOI >= 1) {
			curTOI = 1;
			var dt3 = curTOI * timeStep;
			var delta3 = dt3 - b1.sweepTime;
			if(delta3 != 0) {
				b1.sweepTime = dt3;
				var t26 = delta3;
				b1.posx += b1.velx * t26;
				b1.posy += b1.vely * t26;
				if(b1.angvel != 0) {
					var dr2 = b1.sweep_angvel * delta3;
					b1.rot += dr2;
					if(dr2 * dr2 > 0.0001) {
						b1.axisx = Math.sin(b1.rot);
						b1.axisy = Math.cos(b1.rot);
					} else {
						var d23 = dr2 * dr2;
						var p4 = 1 - 0.5 * d23;
						var m2 = 1 - d23 * d23 / 8;
						var nx5 = (p4 * b1.axisx + dr2 * b1.axisy) * m2;
						b1.axisy = (p4 * b1.axisy - dr2 * b1.axisx) * m2;
						b1.axisx = nx5;
					}
				}
			}
			if(s1.type == 0) {
				s1.worldCOMx = b1.posx + (b1.axisy * s1.localCOMx - b1.axisx * s1.localCOMy);
				s1.worldCOMy = b1.posy + (s1.localCOMx * b1.axisx + s1.localCOMy * b1.axisy);
			} else {
				var p5 = s1.polygon;
				var li2 = p5.lverts.next;
				var cx_ite10 = p5.gverts.next;
				while(cx_ite10 != null) {
					var g2 = cx_ite10;
					var l2 = li2;
					li2 = li2.next;
					g2.x = b1.posx + (b1.axisy * l2.x - b1.axisx * l2.y);
					g2.y = b1.posy + (l2.x * b1.axisx + l2.y * b1.axisy);
					cx_ite10 = cx_ite10.next;
				}
				var ite2 = p5.edges.head;
				var cx_ite11 = p5.gverts.next;
				var u2 = cx_ite11;
				cx_ite11 = cx_ite11.next;
				while(cx_ite11 != null) {
					var v6 = cx_ite11;
					var e4 = ite2.elt;
					ite2 = ite2.next;
					e4.gnormx = b1.axisy * e4.lnormx - b1.axisx * e4.lnormy;
					e4.gnormy = e4.lnormx * b1.axisx + e4.lnormy * b1.axisy;
					e4.gprojection = b1.posx * e4.gnormx + b1.posy * e4.gnormy + e4.lprojection;
					e4.tp0 = u2.y * e4.gnormx - u2.x * e4.gnormy;
					e4.tp1 = v6.y * e4.gnormx - v6.x * e4.gnormy;
					u2 = v6;
					cx_ite11 = cx_ite11.next;
				}
				var v7 = p5.gverts.next;
				var e5 = ite2.elt;
				ite2 = ite2.next;
				e5.gnormx = b1.axisy * e5.lnormx - b1.axisx * e5.lnormy;
				e5.gnormy = e5.lnormx * b1.axisx + e5.lnormy * b1.axisy;
				e5.gprojection = b1.posx * e5.gnormx + b1.posy * e5.gnormy + e5.lprojection;
				e5.tp0 = u2.y * e5.gnormx - u2.x * e5.gnormy;
				e5.tp1 = v7.y * e5.gnormx - v7.x * e5.gnormy;
			}
			var dt4 = curTOI * timeStep;
			var delta4 = dt4 - b2.sweepTime;
			if(delta4 != 0) {
				b2.sweepTime = dt4;
				var t27 = delta4;
				b2.posx += b2.velx * t27;
				b2.posy += b2.vely * t27;
				if(b2.angvel != 0) {
					var dr3 = b2.sweep_angvel * delta4;
					b2.rot += dr3;
					if(dr3 * dr3 > 0.0001) {
						b2.axisx = Math.sin(b2.rot);
						b2.axisy = Math.cos(b2.rot);
					} else {
						var d24 = dr3 * dr3;
						var p6 = 1 - 0.5 * d24;
						var m3 = 1 - d24 * d24 / 8;
						var nx6 = (p6 * b2.axisx + dr3 * b2.axisy) * m3;
						b2.axisy = (p6 * b2.axisy - dr3 * b2.axisx) * m3;
						b2.axisx = nx6;
					}
				}
			}
			if(s2.type == 0) {
				s2.worldCOMx = b2.posx + (b2.axisy * s2.localCOMx - b2.axisx * s2.localCOMy);
				s2.worldCOMy = b2.posy + (s2.localCOMx * b2.axisx + s2.localCOMy * b2.axisy);
			} else {
				var p7 = s2.polygon;
				var li3 = p7.lverts.next;
				var cx_ite12 = p7.gverts.next;
				while(cx_ite12 != null) {
					var g3 = cx_ite12;
					var l3 = li3;
					li3 = li3.next;
					g3.x = b2.posx + (b2.axisy * l3.x - b2.axisx * l3.y);
					g3.y = b2.posy + (l3.x * b2.axisx + l3.y * b2.axisy);
					cx_ite12 = cx_ite12.next;
				}
				var ite3 = p7.edges.head;
				var cx_ite13 = p7.gverts.next;
				var u3 = cx_ite13;
				cx_ite13 = cx_ite13.next;
				while(cx_ite13 != null) {
					var v8 = cx_ite13;
					var e6 = ite3.elt;
					ite3 = ite3.next;
					e6.gnormx = b2.axisy * e6.lnormx - b2.axisx * e6.lnormy;
					e6.gnormy = e6.lnormx * b2.axisx + e6.lnormy * b2.axisy;
					e6.gprojection = b2.posx * e6.gnormx + b2.posy * e6.gnormy + e6.lprojection;
					e6.tp0 = u3.y * e6.gnormx - u3.x * e6.gnormy;
					e6.tp1 = v8.y * e6.gnormx - v8.x * e6.gnormy;
					u3 = v8;
					cx_ite13 = cx_ite13.next;
				}
				var v9 = p7.gverts.next;
				var e7 = ite3.elt;
				ite3 = ite3.next;
				e7.gnormx = b2.axisy * e7.lnormx - b2.axisx * e7.lnormy;
				e7.gnormy = e7.lnormx * b2.axisx + e7.lnormy * b2.axisy;
				e7.gprojection = b2.posx * e7.gnormx + b2.posy * e7.gnormy + e7.lprojection;
				e7.tp0 = u3.y * e7.gnormx - u3.x * e7.gnormy;
				e7.tp1 = v9.y * e7.gnormx - v9.x * e7.gnormy;
			}
			var s13 = s1;
			var s23 = s2;
			var w11 = c1;
			var w21 = c2;
			var sep2;
			if(s13.type == 0 && s23.type == 0) {
				var c12 = s13.circle;
				var c22 = s23.circle;
				var dist2;
				var nx7 = 0.0;
				var ny3 = 0.0;
				nx7 = c22.worldCOMx - c12.worldCOMx;
				ny3 = c22.worldCOMy - c12.worldCOMy;
				var x4 = nx7 * nx7 + ny3 * ny3;
				var len3;
				if(x4 == 0.0) {
					len3 = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x4;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x23 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					len3 = 1 / (x23 * (1.5 - 0.5 * x4 * x23 * x23));
				}
				dist2 = len3 - (c12.radius + c22.radius);
				if(dist2 < 1e100) {
					if(len3 == 0) {
						nx7 = 1;
						ny3 = 0;
					} else {
						var t28 = 1.0 / len3;
						nx7 *= t28;
						ny3 *= t28;
					}
					var t29 = c12.radius;
					w11.x = c12.worldCOMx + nx7 * t29;
					w11.y = c12.worldCOMy + ny3 * t29;
					var t30 = -c22.radius;
					w21.x = c22.worldCOMx + nx7 * t30;
					w21.y = c22.worldCOMy + ny3 * t30;
					axis.x = nx7;
					axis.y = ny3;
				}
				sep2 = dist2;
			} else {
				var swapped1 = false;
				if(s13.type == 0 && s23.type == 1) {
					var tmp3 = s13;
					s13 = s23;
					s23 = tmp3;
					var tmp21 = w11;
					w11 = w21;
					w21 = tmp21;
					swapped1 = true;
				}
				if(s13.type == 1 && s23.type == 0) {
					var poly1 = s13.polygon;
					var circle1 = s23.circle;
					var best2 = -1e+100;
					var a01 = null;
					var cx_ite14 = poly1.edges.head;
					while(cx_ite14 != null) {
						var a6 = cx_ite14.elt;
						var dist3 = a6.gnormx * circle1.worldCOMx + a6.gnormy * circle1.worldCOMy - a6.gprojection - circle1.radius;
						if(dist3 > 1e100) {
							best2 = dist3;
							break;
						}
						if(dist3 > 0) {
							if(dist3 > best2) {
								best2 = dist3;
								a01 = a6;
							}
						} else if(best2 < 0 && dist3 > best2) {
							best2 = dist3;
							a01 = a6;
						}
						cx_ite14 = cx_ite14.next;
					}
					if(best2 < 1e100) {
						var v02 = a01.gp0;
						var v13 = a01.gp1;
						var dt5 = circle1.worldCOMy * a01.gnormx - circle1.worldCOMx * a01.gnormy;
						if(dt5 <= v02.y * a01.gnormx - v02.x * a01.gnormy) {
							var nx8 = 0.0;
							var ny4 = 0.0;
							nx8 = circle1.worldCOMx - v02.x;
							ny4 = circle1.worldCOMy - v02.y;
							var x5 = nx8 * nx8 + ny4 * ny4;
							var len4;
							if(x5 == 0.0) {
								len4 = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x5;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x24 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								len4 = 1 / (x24 * (1.5 - 0.5 * x5 * x24 * x24));
							}
							best2 = len4 - circle1.radius;
							if(best2 < 1e100) {
								if(len4 == 0) {
									nx8 = 1;
									ny4 = 0;
								} else {
									var t31 = 1.0 / len4;
									nx8 *= t31;
									ny4 *= t31;
								}
								var t32 = 0;
								w11.x = v02.x + nx8 * t32;
								w11.y = v02.y + ny4 * t32;
								var t33 = -circle1.radius;
								w21.x = circle1.worldCOMx + nx8 * t33;
								w21.y = circle1.worldCOMy + ny4 * t33;
								axis.x = nx8;
								axis.y = ny4;
							}
						} else if(dt5 >= v13.y * a01.gnormx - v13.x * a01.gnormy) {
							var nx9 = 0.0;
							var ny5 = 0.0;
							nx9 = circle1.worldCOMx - v13.x;
							ny5 = circle1.worldCOMy - v13.y;
							var x6 = nx9 * nx9 + ny5 * ny5;
							var len5;
							if(x6 == 0.0) {
								len5 = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x6;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x25 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								len5 = 1 / (x25 * (1.5 - 0.5 * x6 * x25 * x25));
							}
							best2 = len5 - circle1.radius;
							if(best2 < 1e100) {
								if(len5 == 0) {
									nx9 = 1;
									ny5 = 0;
								} else {
									var t34 = 1.0 / len5;
									nx9 *= t34;
									ny5 *= t34;
								}
								var t35 = 0;
								w11.x = v13.x + nx9 * t35;
								w11.y = v13.y + ny5 * t35;
								var t36 = -circle1.radius;
								w21.x = circle1.worldCOMx + nx9 * t36;
								w21.y = circle1.worldCOMy + ny5 * t36;
								axis.x = nx9;
								axis.y = ny5;
							}
						} else {
							var t37 = -circle1.radius;
							w21.x = circle1.worldCOMx + a01.gnormx * t37;
							w21.y = circle1.worldCOMy + a01.gnormy * t37;
							var t38 = -best2;
							w11.x = w21.x + a01.gnormx * t38;
							w11.y = w21.y + a01.gnormy * t38;
							axis.x = a01.gnormx;
							axis.y = a01.gnormy;
						}
					}
					if(swapped1) {
						axis.x = -axis.x;
						axis.y = -axis.y;
					}
					sep2 = best2;
				} else {
					var p12 = s13.polygon;
					var p22 = s23.polygon;
					var best3 = -1e+100;
					var a11 = null;
					var a21 = null;
					var besti1 = 0;
					var cx_ite15 = p12.edges.head;
					while(cx_ite15 != null) {
						var a7 = cx_ite15.elt;
						var min3 = 1e100;
						var cx_ite16 = p22.gverts.next;
						while(cx_ite16 != null) {
							var v10 = cx_ite16;
							var k3 = a7.gnormx * v10.x + a7.gnormy * v10.y;
							if(k3 < min3) {
								min3 = k3;
							}
							cx_ite16 = cx_ite16.next;
						}
						min3 -= a7.gprojection;
						if(min3 > 1e100) {
							best3 = min3;
							break;
						}
						if(min3 > 0) {
							if(min3 > best3) {
								best3 = min3;
								a11 = a7;
								besti1 = 1;
							}
						} else if(best3 < 0 && min3 > best3) {
							best3 = min3;
							a11 = a7;
							besti1 = 1;
						}
						cx_ite15 = cx_ite15.next;
					}
					if(best3 < 1e100) {
						var cx_ite17 = p22.edges.head;
						while(cx_ite17 != null) {
							var a8 = cx_ite17.elt;
							var min4 = 1e100;
							var cx_ite18 = p12.gverts.next;
							while(cx_ite18 != null) {
								var v14 = cx_ite18;
								var k4 = a8.gnormx * v14.x + a8.gnormy * v14.y;
								if(k4 < min4) {
									min4 = k4;
								}
								cx_ite18 = cx_ite18.next;
							}
							min4 -= a8.gprojection;
							if(min4 > 1e100) {
								best3 = min4;
								break;
							}
							if(min4 > 0) {
								if(min4 > best3) {
									best3 = min4;
									a21 = a8;
									besti1 = 2;
								}
							} else if(best3 < 0 && min4 > best3) {
								best3 = min4;
								a21 = a8;
								besti1 = 2;
							}
							cx_ite17 = cx_ite17.next;
						}
						if(best3 < 1e100) {
							var q12;
							var q21;
							var ax1;
							if(besti1 == 1) {
								q12 = p12;
								q21 = p22;
								ax1 = a11;
							} else {
								q12 = p22;
								q21 = p12;
								ax1 = a21;
								var tmp4 = w11;
								w11 = w21;
								w21 = tmp4;
								swapped1 = !swapped1;
							}
							var ay1 = null;
							var min5 = 1e100;
							var cx_ite19 = q21.edges.head;
							while(cx_ite19 != null) {
								var a9 = cx_ite19.elt;
								var k5 = ax1.gnormx * a9.gnormx + ax1.gnormy * a9.gnormy;
								if(k5 < min5) {
									min5 = k5;
									ay1 = a9;
								}
								cx_ite19 = cx_ite19.next;
							}
							if(swapped1) {
								axis.x = -ax1.gnormx;
								axis.y = -ax1.gnormy;
							} else {
								axis.x = ax1.gnormx;
								axis.y = ax1.gnormy;
							}
							if(best3 >= 0) {
								var v03 = ax1.gp0;
								var v15 = ax1.gp1;
								var q01 = ay1.gp0;
								var q13 = ay1.gp1;
								var vx1 = 0.0;
								var vy1 = 0.0;
								var qx1 = 0.0;
								var qy1 = 0.0;
								vx1 = v15.x - v03.x;
								vy1 = v15.y - v03.y;
								qx1 = q13.x - q01.x;
								qy1 = q13.y - q01.y;
								var vdot1 = 1 / (vx1 * vx1 + vy1 * vy1);
								var qdot1 = 1 / (qx1 * qx1 + qy1 * qy1);
								var t110 = -(vx1 * (v03.x - q01.x) + vy1 * (v03.y - q01.y)) * vdot1;
								var t210 = -(vx1 * (v03.x - q13.x) + vy1 * (v03.y - q13.y)) * vdot1;
								var s14 = -(qx1 * (q01.x - v03.x) + qy1 * (q01.y - v03.y)) * qdot1;
								var s24 = -(qx1 * (q01.x - v15.x) + qy1 * (q01.y - v15.y)) * qdot1;
								if(t110 < 0) {
									t110 = 0;
								} else if(t110 > 1) {
									t110 = 1;
								}
								if(t210 < 0) {
									t210 = 0;
								} else if(t210 > 1) {
									t210 = 1;
								}
								if(s14 < 0) {
									s14 = 0;
								} else if(s14 > 1) {
									s14 = 1;
								}
								if(s24 < 0) {
									s24 = 0;
								} else if(s24 > 1) {
									s24 = 1;
								}
								var f1x1 = 0.0;
								var f1y1 = 0.0;
								var t39 = t110;
								f1x1 = v03.x + vx1 * t39;
								f1y1 = v03.y + vy1 * t39;
								var f2x1 = 0.0;
								var f2y1 = 0.0;
								var t40 = t210;
								f2x1 = v03.x + vx1 * t40;
								f2y1 = v03.y + vy1 * t40;
								var g1x1 = 0.0;
								var g1y1 = 0.0;
								var t41 = s14;
								g1x1 = q01.x + qx1 * t41;
								g1y1 = q01.y + qy1 * t41;
								var g2x1 = 0.0;
								var g2y1 = 0.0;
								var t42 = s24;
								g2x1 = q01.x + qx1 * t42;
								g2y1 = q01.y + qy1 * t42;
								var dx4 = 0.0;
								var dy4 = 0.0;
								dx4 = f1x1 - q01.x;
								dy4 = f1y1 - q01.y;
								var d12 = dx4 * dx4 + dy4 * dy4;
								var dx5 = 0.0;
								var dy5 = 0.0;
								dx5 = f2x1 - q13.x;
								dy5 = f2y1 - q13.y;
								var d25 = dx5 * dx5 + dy5 * dy5;
								var dx6 = 0.0;
								var dy6 = 0.0;
								dx6 = g1x1 - v03.x;
								dy6 = g1y1 - v03.y;
								var e12 = dx6 * dx6 + dy6 * dy6;
								var dx7 = 0.0;
								var dy7 = 0.0;
								dx7 = g2x1 - v15.x;
								dy7 = g2y1 - v15.y;
								var e22 = dx7 * dx7 + dy7 * dy7;
								var minfx1 = 0.0;
								var minfy1 = 0.0;
								var minq1 = null;
								if(d12 < d25) {
									minfx1 = f1x1;
									minfy1 = f1y1;
									minq1 = q01;
								} else {
									minfx1 = f2x1;
									minfy1 = f2y1;
									minq1 = q13;
									d12 = d25;
								}
								var mingx1 = 0.0;
								var mingy1 = 0.0;
								var minv1 = null;
								if(e12 < e22) {
									mingx1 = g1x1;
									mingy1 = g1y1;
									minv1 = v03;
								} else {
									mingx1 = g2x1;
									mingy1 = g2y1;
									minv1 = v15;
									e12 = e22;
								}
								if(d12 < e12) {
									w11.x = minfx1;
									w11.y = minfy1;
									w21.x = minq1.x;
									w21.y = minq1.y;
									best3 = Math.sqrt(d12);
								} else {
									w21.x = mingx1;
									w21.y = mingy1;
									w11.x = minv1.x;
									w11.y = minv1.y;
									best3 = Math.sqrt(e12);
								}
								if(best3 != 0) {
									axis.x = w21.x - w11.x;
									axis.y = w21.y - w11.y;
									var t43 = 1.0 / best3;
									axis.x *= t43;
									axis.y *= t43;
									if(swapped1) {
										axis.x = -axis.x;
										axis.y = -axis.y;
									}
								}
								sep2 = best3;
							} else {
								var c0x1 = 0.0;
								var c0y1 = 0.0;
								c0x1 = ay1.gp0.x;
								c0y1 = ay1.gp0.y;
								var c1x1 = 0.0;
								var c1y1 = 0.0;
								c1x1 = ay1.gp1.x;
								c1y1 = ay1.gp1.y;
								var dvx1 = 0.0;
								var dvy1 = 0.0;
								dvx1 = c1x1 - c0x1;
								dvy1 = c1y1 - c0y1;
								var d01 = ax1.gnormy * c0x1 - ax1.gnormx * c0y1;
								var d13 = ax1.gnormy * c1x1 - ax1.gnormx * c1y1;
								var den1 = 1 / (d13 - d01);
								var t44 = (-ax1.tp1 - d01) * den1;
								if(t44 > nape_Config.epsilon) {
									var t45 = t44;
									c0x1 += dvx1 * t45;
									c0y1 += dvy1 * t45;
								}
								var t46 = (-ax1.tp0 - d13) * den1;
								if(t46 < -nape_Config.epsilon) {
									var t47 = t46;
									c1x1 += dvx1 * t47;
									c1y1 += dvy1 * t47;
								}
								var c0d1 = c0x1 * ax1.gnormx + c0y1 * ax1.gnormy - ax1.gprojection;
								var c1d1 = c1x1 * ax1.gnormx + c1y1 * ax1.gnormy - ax1.gprojection;
								if(c0d1 < c1d1) {
									w21.x = c0x1;
									w21.y = c0y1;
									var t48 = -c0d1;
									w11.x = w21.x + ax1.gnormx * t48;
									w11.y = w21.y + ax1.gnormy * t48;
									sep2 = c0d1;
								} else {
									w21.x = c1x1;
									w21.y = c1y1;
									var t49 = -c1d1;
									w11.x = w21.x + ax1.gnormx * t49;
									w11.y = w21.y + ax1.gnormy * t49;
									sep2 = c1d1;
								}
							}
						} else {
							sep2 = 1e100;
						}
					} else {
						sep2 = 1e100;
					}
				}
			}
			var sep3 = sep2 + negRadius;
			var dot1 = deltax * axis.x + deltay * axis.y;
			if(sep3 < nape_Config.distanceThresholdCCD) {
				if(userAPI) {
					break;
				}
				var d1x1 = 0.0;
				var d1y1 = 0.0;
				d1x1 = c1.x - b1.posx;
				d1y1 = c1.y - b1.posy;
				var d2x1 = 0.0;
				var d2y1 = 0.0;
				d2x1 = c2.x - b2.posx;
				d2y1 = c2.y - b2.posy;
				var proj1 = dot1 - b1.sweep_angvel * (axis.y * d1x1 - axis.x * d1y1) + b2.sweep_angvel * (axis.y * d2x1 - axis.x * d2y1);
				if(proj1 > 0) {
					toi.slipped = true;
				}
				if(proj1 <= 0 || sep3 < nape_Config.distanceThresholdCCD * 0.5) {
					break;
				}
			}
			curTOI = -1;
			break;
		}
		if(++curIter >= 40) {
			if(sep1 > negRadius) {
				toi.failed = true;
			}
			break;
		}
	}
	toi.toi = curTOI;
};
zpp_$nape_geom_ZPP_$SweepDistance.staticSweep = function(toi,timeStep,lowerBound,negRadius) {
	var s1 = toi.s1;
	var s2 = toi.s2;
	var b1 = s1.body;
	var b2 = s2.body;
	var deltax = 0.0;
	var deltay = 0.0;
	deltax = -b1.velx;
	deltay = -b1.vely;
	var ang1 = b1.sweep_angvel;
	if(ang1 < 0) {
		ang1 = -ang1;
	}
	var angBias = s1.sweepCoef * ang1;
	var c1 = toi.c1;
	var c2 = toi.c2;
	var axis = toi.axis;
	var curTOI = lowerBound;
	var curIter = 0;
	while(true) {
		var dt = curTOI * timeStep;
		var delta = dt - b1.sweepTime;
		if(delta != 0) {
			b1.sweepTime = dt;
			var t = delta;
			b1.posx += b1.velx * t;
			b1.posy += b1.vely * t;
			if(b1.angvel != 0) {
				var dr = b1.sweep_angvel * delta;
				b1.rot += dr;
				if(dr * dr > 0.0001) {
					b1.axisx = Math.sin(b1.rot);
					b1.axisy = Math.cos(b1.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * b1.axisx + dr * b1.axisy) * m;
					b1.axisy = (p * b1.axisy - dr * b1.axisx) * m;
					b1.axisx = nx;
				}
			}
		}
		if(s1.type == 0) {
			s1.worldCOMx = b1.posx + (b1.axisy * s1.localCOMx - b1.axisx * s1.localCOMy);
			s1.worldCOMy = b1.posy + (s1.localCOMx * b1.axisx + s1.localCOMy * b1.axisy);
		} else {
			var p1 = s1.polygon;
			var li = p1.lverts.next;
			var cx_ite = p1.gverts.next;
			while(cx_ite != null) {
				var g = cx_ite;
				var l = li;
				li = li.next;
				g.x = b1.posx + (b1.axisy * l.x - b1.axisx * l.y);
				g.y = b1.posy + (l.x * b1.axisx + l.y * b1.axisy);
				cx_ite = cx_ite.next;
			}
			var ite = p1.edges.head;
			var cx_ite1 = p1.gverts.next;
			var u = cx_ite1;
			cx_ite1 = cx_ite1.next;
			while(cx_ite1 != null) {
				var v = cx_ite1;
				var e = ite.elt;
				ite = ite.next;
				e.gnormx = b1.axisy * e.lnormx - b1.axisx * e.lnormy;
				e.gnormy = e.lnormx * b1.axisx + e.lnormy * b1.axisy;
				e.gprojection = b1.posx * e.gnormx + b1.posy * e.gnormy + e.lprojection;
				e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
				e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
				u = v;
				cx_ite1 = cx_ite1.next;
			}
			var v1 = p1.gverts.next;
			var e1 = ite.elt;
			ite = ite.next;
			e1.gnormx = b1.axisy * e1.lnormx - b1.axisx * e1.lnormy;
			e1.gnormy = e1.lnormx * b1.axisx + e1.lnormy * b1.axisy;
			e1.gprojection = b1.posx * e1.gnormx + b1.posy * e1.gnormy + e1.lprojection;
			e1.tp0 = u.y * e1.gnormx - u.x * e1.gnormy;
			e1.tp1 = v1.y * e1.gnormx - v1.x * e1.gnormy;
		}
		var s11 = s1;
		var s21 = s2;
		var w1 = c1;
		var w2 = c2;
		var sep;
		if(s11.type == 0 && s21.type == 0) {
			var c11 = s11.circle;
			var c21 = s21.circle;
			var dist;
			var nx1 = 0.0;
			var ny = 0.0;
			nx1 = c21.worldCOMx - c11.worldCOMx;
			ny = c21.worldCOMy - c11.worldCOMy;
			var x = nx1 * nx1 + ny * ny;
			var len;
			if(x == 0.0) {
				len = 0.0;
			} else {
				zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
				zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
				var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
				len = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
			}
			dist = len - (c11.radius + c21.radius);
			if(dist < 1e100) {
				if(len == 0) {
					nx1 = 1;
					ny = 0;
				} else {
					var t1 = 1.0 / len;
					nx1 *= t1;
					ny *= t1;
				}
				var t2 = c11.radius;
				w1.x = c11.worldCOMx + nx1 * t2;
				w1.y = c11.worldCOMy + ny * t2;
				var t3 = -c21.radius;
				w2.x = c21.worldCOMx + nx1 * t3;
				w2.y = c21.worldCOMy + ny * t3;
				axis.x = nx1;
				axis.y = ny;
			}
			sep = dist;
		} else {
			var swapped = false;
			if(s11.type == 0 && s21.type == 1) {
				var tmp = s11;
				s11 = s21;
				s21 = tmp;
				var tmp2 = w1;
				w1 = w2;
				w2 = tmp2;
				swapped = true;
			}
			if(s11.type == 1 && s21.type == 0) {
				var poly = s11.polygon;
				var circle = s21.circle;
				var best = -1e+100;
				var a0 = null;
				var cx_ite2 = poly.edges.head;
				while(cx_ite2 != null) {
					var a = cx_ite2.elt;
					var dist1 = a.gnormx * circle.worldCOMx + a.gnormy * circle.worldCOMy - a.gprojection - circle.radius;
					if(dist1 > 1e100) {
						best = dist1;
						break;
					}
					if(dist1 > 0) {
						if(dist1 > best) {
							best = dist1;
							a0 = a;
						}
					} else if(best < 0 && dist1 > best) {
						best = dist1;
						a0 = a;
					}
					cx_ite2 = cx_ite2.next;
				}
				if(best < 1e100) {
					var v0 = a0.gp0;
					var v11 = a0.gp1;
					var dt1 = circle.worldCOMy * a0.gnormx - circle.worldCOMx * a0.gnormy;
					if(dt1 <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
						var nx2 = 0.0;
						var ny1 = 0.0;
						nx2 = circle.worldCOMx - v0.x;
						ny1 = circle.worldCOMy - v0.y;
						var x1 = nx2 * nx2 + ny1 * ny1;
						var len1;
						if(x1 == 0.0) {
							len1 = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x1;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x21 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							len1 = 1 / (x21 * (1.5 - 0.5 * x1 * x21 * x21));
						}
						best = len1 - circle.radius;
						if(best < 1e100) {
							if(len1 == 0) {
								nx2 = 1;
								ny1 = 0;
							} else {
								var t4 = 1.0 / len1;
								nx2 *= t4;
								ny1 *= t4;
							}
							var t5 = 0;
							w1.x = v0.x + nx2 * t5;
							w1.y = v0.y + ny1 * t5;
							var t6 = -circle.radius;
							w2.x = circle.worldCOMx + nx2 * t6;
							w2.y = circle.worldCOMy + ny1 * t6;
							axis.x = nx2;
							axis.y = ny1;
						}
					} else if(dt1 >= v11.y * a0.gnormx - v11.x * a0.gnormy) {
						var nx3 = 0.0;
						var ny2 = 0.0;
						nx3 = circle.worldCOMx - v11.x;
						ny2 = circle.worldCOMy - v11.y;
						var x3 = nx3 * nx3 + ny2 * ny2;
						var len2;
						if(x3 == 0.0) {
							len2 = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x3;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x22 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							len2 = 1 / (x22 * (1.5 - 0.5 * x3 * x22 * x22));
						}
						best = len2 - circle.radius;
						if(best < 1e100) {
							if(len2 == 0) {
								nx3 = 1;
								ny2 = 0;
							} else {
								var t7 = 1.0 / len2;
								nx3 *= t7;
								ny2 *= t7;
							}
							var t8 = 0;
							w1.x = v11.x + nx3 * t8;
							w1.y = v11.y + ny2 * t8;
							var t9 = -circle.radius;
							w2.x = circle.worldCOMx + nx3 * t9;
							w2.y = circle.worldCOMy + ny2 * t9;
							axis.x = nx3;
							axis.y = ny2;
						}
					} else {
						var t10 = -circle.radius;
						w2.x = circle.worldCOMx + a0.gnormx * t10;
						w2.y = circle.worldCOMy + a0.gnormy * t10;
						var t11 = -best;
						w1.x = w2.x + a0.gnormx * t11;
						w1.y = w2.y + a0.gnormy * t11;
						axis.x = a0.gnormx;
						axis.y = a0.gnormy;
					}
				}
				if(swapped) {
					axis.x = -axis.x;
					axis.y = -axis.y;
				}
				sep = best;
			} else {
				var p11 = s11.polygon;
				var p2 = s21.polygon;
				var best1 = -1e+100;
				var a1 = null;
				var a2 = null;
				var besti = 0;
				var cx_ite3 = p11.edges.head;
				while(cx_ite3 != null) {
					var a3 = cx_ite3.elt;
					var min = 1e100;
					var cx_ite4 = p2.gverts.next;
					while(cx_ite4 != null) {
						var v2 = cx_ite4;
						var k = a3.gnormx * v2.x + a3.gnormy * v2.y;
						if(k < min) {
							min = k;
						}
						cx_ite4 = cx_ite4.next;
					}
					min -= a3.gprojection;
					if(min > 1e100) {
						best1 = min;
						break;
					}
					if(min > 0) {
						if(min > best1) {
							best1 = min;
							a1 = a3;
							besti = 1;
						}
					} else if(best1 < 0 && min > best1) {
						best1 = min;
						a1 = a3;
						besti = 1;
					}
					cx_ite3 = cx_ite3.next;
				}
				if(best1 < 1e100) {
					var cx_ite5 = p2.edges.head;
					while(cx_ite5 != null) {
						var a4 = cx_ite5.elt;
						var min1 = 1e100;
						var cx_ite6 = p11.gverts.next;
						while(cx_ite6 != null) {
							var v3 = cx_ite6;
							var k1 = a4.gnormx * v3.x + a4.gnormy * v3.y;
							if(k1 < min1) {
								min1 = k1;
							}
							cx_ite6 = cx_ite6.next;
						}
						min1 -= a4.gprojection;
						if(min1 > 1e100) {
							best1 = min1;
							break;
						}
						if(min1 > 0) {
							if(min1 > best1) {
								best1 = min1;
								a2 = a4;
								besti = 2;
							}
						} else if(best1 < 0 && min1 > best1) {
							best1 = min1;
							a2 = a4;
							besti = 2;
						}
						cx_ite5 = cx_ite5.next;
					}
					if(best1 < 1e100) {
						var q1;
						var q2;
						var ax;
						if(besti == 1) {
							q1 = p11;
							q2 = p2;
							ax = a1;
						} else {
							q1 = p2;
							q2 = p11;
							ax = a2;
							var tmp1 = w1;
							w1 = w2;
							w2 = tmp1;
							swapped = !swapped;
						}
						var ay = null;
						var min2 = 1e100;
						var cx_ite7 = q2.edges.head;
						while(cx_ite7 != null) {
							var a5 = cx_ite7.elt;
							var k2 = ax.gnormx * a5.gnormx + ax.gnormy * a5.gnormy;
							if(k2 < min2) {
								min2 = k2;
								ay = a5;
							}
							cx_ite7 = cx_ite7.next;
						}
						if(swapped) {
							axis.x = -ax.gnormx;
							axis.y = -ax.gnormy;
						} else {
							axis.x = ax.gnormx;
							axis.y = ax.gnormy;
						}
						if(best1 >= 0) {
							var v01 = ax.gp0;
							var v12 = ax.gp1;
							var q0 = ay.gp0;
							var q11 = ay.gp1;
							var vx = 0.0;
							var vy = 0.0;
							var qx = 0.0;
							var qy = 0.0;
							vx = v12.x - v01.x;
							vy = v12.y - v01.y;
							qx = q11.x - q0.x;
							qy = q11.y - q0.y;
							var vdot = 1 / (vx * vx + vy * vy);
							var qdot = 1 / (qx * qx + qy * qy);
							var t12 = -(vx * (v01.x - q0.x) + vy * (v01.y - q0.y)) * vdot;
							var t21 = -(vx * (v01.x - q11.x) + vy * (v01.y - q11.y)) * vdot;
							var s12 = -(qx * (q0.x - v01.x) + qy * (q0.y - v01.y)) * qdot;
							var s22 = -(qx * (q0.x - v12.x) + qy * (q0.y - v12.y)) * qdot;
							if(t12 < 0) {
								t12 = 0;
							} else if(t12 > 1) {
								t12 = 1;
							}
							if(t21 < 0) {
								t21 = 0;
							} else if(t21 > 1) {
								t21 = 1;
							}
							if(s12 < 0) {
								s12 = 0;
							} else if(s12 > 1) {
								s12 = 1;
							}
							if(s22 < 0) {
								s22 = 0;
							} else if(s22 > 1) {
								s22 = 1;
							}
							var f1x = 0.0;
							var f1y = 0.0;
							var t13 = t12;
							f1x = v01.x + vx * t13;
							f1y = v01.y + vy * t13;
							var f2x = 0.0;
							var f2y = 0.0;
							var t14 = t21;
							f2x = v01.x + vx * t14;
							f2y = v01.y + vy * t14;
							var g1x = 0.0;
							var g1y = 0.0;
							var t15 = s12;
							g1x = q0.x + qx * t15;
							g1y = q0.y + qy * t15;
							var g2x = 0.0;
							var g2y = 0.0;
							var t16 = s22;
							g2x = q0.x + qx * t16;
							g2y = q0.y + qy * t16;
							var dx = 0.0;
							var dy = 0.0;
							dx = f1x - q0.x;
							dy = f1y - q0.y;
							var d1 = dx * dx + dy * dy;
							var dx1 = 0.0;
							var dy1 = 0.0;
							dx1 = f2x - q11.x;
							dy1 = f2y - q11.y;
							var d21 = dx1 * dx1 + dy1 * dy1;
							var dx2 = 0.0;
							var dy2 = 0.0;
							dx2 = g1x - v01.x;
							dy2 = g1y - v01.y;
							var e11 = dx2 * dx2 + dy2 * dy2;
							var dx3 = 0.0;
							var dy3 = 0.0;
							dx3 = g2x - v12.x;
							dy3 = g2y - v12.y;
							var e2 = dx3 * dx3 + dy3 * dy3;
							var minfx = 0.0;
							var minfy = 0.0;
							var minq = null;
							if(d1 < d21) {
								minfx = f1x;
								minfy = f1y;
								minq = q0;
							} else {
								minfx = f2x;
								minfy = f2y;
								minq = q11;
								d1 = d21;
							}
							var mingx = 0.0;
							var mingy = 0.0;
							var minv = null;
							if(e11 < e2) {
								mingx = g1x;
								mingy = g1y;
								minv = v01;
							} else {
								mingx = g2x;
								mingy = g2y;
								minv = v12;
								e11 = e2;
							}
							if(d1 < e11) {
								w1.x = minfx;
								w1.y = minfy;
								w2.x = minq.x;
								w2.y = minq.y;
								best1 = Math.sqrt(d1);
							} else {
								w2.x = mingx;
								w2.y = mingy;
								w1.x = minv.x;
								w1.y = minv.y;
								best1 = Math.sqrt(e11);
							}
							if(best1 != 0) {
								axis.x = w2.x - w1.x;
								axis.y = w2.y - w1.y;
								var t17 = 1.0 / best1;
								axis.x *= t17;
								axis.y *= t17;
								if(swapped) {
									axis.x = -axis.x;
									axis.y = -axis.y;
								}
							}
							sep = best1;
						} else {
							var c0x = 0.0;
							var c0y = 0.0;
							c0x = ay.gp0.x;
							c0y = ay.gp0.y;
							var c1x = 0.0;
							var c1y = 0.0;
							c1x = ay.gp1.x;
							c1y = ay.gp1.y;
							var dvx = 0.0;
							var dvy = 0.0;
							dvx = c1x - c0x;
							dvy = c1y - c0y;
							var d0 = ax.gnormy * c0x - ax.gnormx * c0y;
							var d11 = ax.gnormy * c1x - ax.gnormx * c1y;
							var den = 1 / (d11 - d0);
							var t18 = (-ax.tp1 - d0) * den;
							if(t18 > nape_Config.epsilon) {
								var t19 = t18;
								c0x += dvx * t19;
								c0y += dvy * t19;
							}
							var t20 = (-ax.tp0 - d11) * den;
							if(t20 < -nape_Config.epsilon) {
								var t22 = t20;
								c1x += dvx * t22;
								c1y += dvy * t22;
							}
							var c0d = c0x * ax.gnormx + c0y * ax.gnormy - ax.gprojection;
							var c1d = c1x * ax.gnormx + c1y * ax.gnormy - ax.gprojection;
							if(c0d < c1d) {
								w2.x = c0x;
								w2.y = c0y;
								var t23 = -c0d;
								w1.x = w2.x + ax.gnormx * t23;
								w1.y = w2.y + ax.gnormy * t23;
								sep = c0d;
							} else {
								w2.x = c1x;
								w2.y = c1y;
								var t24 = -c1d;
								w1.x = w2.x + ax.gnormx * t24;
								w1.y = w2.y + ax.gnormy * t24;
								sep = c1d;
							}
						}
					} else {
						sep = 1e100;
					}
				} else {
					sep = 1e100;
				}
			}
		}
		var sep1 = sep + negRadius;
		var dot = deltax * axis.x + deltay * axis.y;
		if(sep1 < nape_Config.distanceThresholdCCD) {
			var d1x = 0.0;
			var d1y = 0.0;
			d1x = c1.x - b1.posx;
			d1y = c1.y - b1.posy;
			var proj = dot - b1.sweep_angvel * (axis.y * d1x - axis.x * d1y);
			if(proj > 0) {
				toi.slipped = true;
			}
			if(proj <= 0 || sep1 < nape_Config.distanceThresholdCCD * 0.5) {
				break;
			}
		}
		var denom = (angBias - dot) * timeStep;
		if(denom <= 0) {
			curTOI = -1;
			break;
		}
		var delta1 = sep1 / denom;
		if(delta1 < 1e-6) {
			delta1 = 1e-6;
		}
		curTOI += delta1;
		if(curTOI >= 1) {
			curTOI = 1;
			var dt2 = curTOI * timeStep;
			var delta2 = dt2 - b1.sweepTime;
			if(delta2 != 0) {
				b1.sweepTime = dt2;
				var t25 = delta2;
				b1.posx += b1.velx * t25;
				b1.posy += b1.vely * t25;
				if(b1.angvel != 0) {
					var dr1 = b1.sweep_angvel * delta2;
					b1.rot += dr1;
					if(dr1 * dr1 > 0.0001) {
						b1.axisx = Math.sin(b1.rot);
						b1.axisy = Math.cos(b1.rot);
					} else {
						var d22 = dr1 * dr1;
						var p3 = 1 - 0.5 * d22;
						var m1 = 1 - d22 * d22 / 8;
						var nx4 = (p3 * b1.axisx + dr1 * b1.axisy) * m1;
						b1.axisy = (p3 * b1.axisy - dr1 * b1.axisx) * m1;
						b1.axisx = nx4;
					}
				}
			}
			if(s1.type == 0) {
				s1.worldCOMx = b1.posx + (b1.axisy * s1.localCOMx - b1.axisx * s1.localCOMy);
				s1.worldCOMy = b1.posy + (s1.localCOMx * b1.axisx + s1.localCOMy * b1.axisy);
			} else {
				var p4 = s1.polygon;
				var li1 = p4.lverts.next;
				var cx_ite8 = p4.gverts.next;
				while(cx_ite8 != null) {
					var g1 = cx_ite8;
					var l1 = li1;
					li1 = li1.next;
					g1.x = b1.posx + (b1.axisy * l1.x - b1.axisx * l1.y);
					g1.y = b1.posy + (l1.x * b1.axisx + l1.y * b1.axisy);
					cx_ite8 = cx_ite8.next;
				}
				var ite1 = p4.edges.head;
				var cx_ite9 = p4.gverts.next;
				var u1 = cx_ite9;
				cx_ite9 = cx_ite9.next;
				while(cx_ite9 != null) {
					var v4 = cx_ite9;
					var e3 = ite1.elt;
					ite1 = ite1.next;
					e3.gnormx = b1.axisy * e3.lnormx - b1.axisx * e3.lnormy;
					e3.gnormy = e3.lnormx * b1.axisx + e3.lnormy * b1.axisy;
					e3.gprojection = b1.posx * e3.gnormx + b1.posy * e3.gnormy + e3.lprojection;
					e3.tp0 = u1.y * e3.gnormx - u1.x * e3.gnormy;
					e3.tp1 = v4.y * e3.gnormx - v4.x * e3.gnormy;
					u1 = v4;
					cx_ite9 = cx_ite9.next;
				}
				var v5 = p4.gverts.next;
				var e4 = ite1.elt;
				ite1 = ite1.next;
				e4.gnormx = b1.axisy * e4.lnormx - b1.axisx * e4.lnormy;
				e4.gnormy = e4.lnormx * b1.axisx + e4.lnormy * b1.axisy;
				e4.gprojection = b1.posx * e4.gnormx + b1.posy * e4.gnormy + e4.lprojection;
				e4.tp0 = u1.y * e4.gnormx - u1.x * e4.gnormy;
				e4.tp1 = v5.y * e4.gnormx - v5.x * e4.gnormy;
			}
			var s13 = s1;
			var s23 = s2;
			var w11 = c1;
			var w21 = c2;
			var sep2;
			if(s13.type == 0 && s23.type == 0) {
				var c12 = s13.circle;
				var c22 = s23.circle;
				var dist2;
				var nx5 = 0.0;
				var ny3 = 0.0;
				nx5 = c22.worldCOMx - c12.worldCOMx;
				ny3 = c22.worldCOMy - c12.worldCOMy;
				var x4 = nx5 * nx5 + ny3 * ny3;
				var len3;
				if(x4 == 0.0) {
					len3 = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x4;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x23 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					len3 = 1 / (x23 * (1.5 - 0.5 * x4 * x23 * x23));
				}
				dist2 = len3 - (c12.radius + c22.radius);
				if(dist2 < 1e100) {
					if(len3 == 0) {
						nx5 = 1;
						ny3 = 0;
					} else {
						var t26 = 1.0 / len3;
						nx5 *= t26;
						ny3 *= t26;
					}
					var t27 = c12.radius;
					w11.x = c12.worldCOMx + nx5 * t27;
					w11.y = c12.worldCOMy + ny3 * t27;
					var t28 = -c22.radius;
					w21.x = c22.worldCOMx + nx5 * t28;
					w21.y = c22.worldCOMy + ny3 * t28;
					axis.x = nx5;
					axis.y = ny3;
				}
				sep2 = dist2;
			} else {
				var swapped1 = false;
				if(s13.type == 0 && s23.type == 1) {
					var tmp3 = s13;
					s13 = s23;
					s23 = tmp3;
					var tmp21 = w11;
					w11 = w21;
					w21 = tmp21;
					swapped1 = true;
				}
				if(s13.type == 1 && s23.type == 0) {
					var poly1 = s13.polygon;
					var circle1 = s23.circle;
					var best2 = -1e+100;
					var a01 = null;
					var cx_ite10 = poly1.edges.head;
					while(cx_ite10 != null) {
						var a6 = cx_ite10.elt;
						var dist3 = a6.gnormx * circle1.worldCOMx + a6.gnormy * circle1.worldCOMy - a6.gprojection - circle1.radius;
						if(dist3 > 1e100) {
							best2 = dist3;
							break;
						}
						if(dist3 > 0) {
							if(dist3 > best2) {
								best2 = dist3;
								a01 = a6;
							}
						} else if(best2 < 0 && dist3 > best2) {
							best2 = dist3;
							a01 = a6;
						}
						cx_ite10 = cx_ite10.next;
					}
					if(best2 < 1e100) {
						var v02 = a01.gp0;
						var v13 = a01.gp1;
						var dt3 = circle1.worldCOMy * a01.gnormx - circle1.worldCOMx * a01.gnormy;
						if(dt3 <= v02.y * a01.gnormx - v02.x * a01.gnormy) {
							var nx6 = 0.0;
							var ny4 = 0.0;
							nx6 = circle1.worldCOMx - v02.x;
							ny4 = circle1.worldCOMy - v02.y;
							var x5 = nx6 * nx6 + ny4 * ny4;
							var len4;
							if(x5 == 0.0) {
								len4 = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x5;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x24 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								len4 = 1 / (x24 * (1.5 - 0.5 * x5 * x24 * x24));
							}
							best2 = len4 - circle1.radius;
							if(best2 < 1e100) {
								if(len4 == 0) {
									nx6 = 1;
									ny4 = 0;
								} else {
									var t29 = 1.0 / len4;
									nx6 *= t29;
									ny4 *= t29;
								}
								var t30 = 0;
								w11.x = v02.x + nx6 * t30;
								w11.y = v02.y + ny4 * t30;
								var t31 = -circle1.radius;
								w21.x = circle1.worldCOMx + nx6 * t31;
								w21.y = circle1.worldCOMy + ny4 * t31;
								axis.x = nx6;
								axis.y = ny4;
							}
						} else if(dt3 >= v13.y * a01.gnormx - v13.x * a01.gnormy) {
							var nx7 = 0.0;
							var ny5 = 0.0;
							nx7 = circle1.worldCOMx - v13.x;
							ny5 = circle1.worldCOMy - v13.y;
							var x6 = nx7 * nx7 + ny5 * ny5;
							var len5;
							if(x6 == 0.0) {
								len5 = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x6;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x25 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								len5 = 1 / (x25 * (1.5 - 0.5 * x6 * x25 * x25));
							}
							best2 = len5 - circle1.radius;
							if(best2 < 1e100) {
								if(len5 == 0) {
									nx7 = 1;
									ny5 = 0;
								} else {
									var t32 = 1.0 / len5;
									nx7 *= t32;
									ny5 *= t32;
								}
								var t33 = 0;
								w11.x = v13.x + nx7 * t33;
								w11.y = v13.y + ny5 * t33;
								var t34 = -circle1.radius;
								w21.x = circle1.worldCOMx + nx7 * t34;
								w21.y = circle1.worldCOMy + ny5 * t34;
								axis.x = nx7;
								axis.y = ny5;
							}
						} else {
							var t35 = -circle1.radius;
							w21.x = circle1.worldCOMx + a01.gnormx * t35;
							w21.y = circle1.worldCOMy + a01.gnormy * t35;
							var t36 = -best2;
							w11.x = w21.x + a01.gnormx * t36;
							w11.y = w21.y + a01.gnormy * t36;
							axis.x = a01.gnormx;
							axis.y = a01.gnormy;
						}
					}
					if(swapped1) {
						axis.x = -axis.x;
						axis.y = -axis.y;
					}
					sep2 = best2;
				} else {
					var p12 = s13.polygon;
					var p21 = s23.polygon;
					var best3 = -1e+100;
					var a11 = null;
					var a21 = null;
					var besti1 = 0;
					var cx_ite11 = p12.edges.head;
					while(cx_ite11 != null) {
						var a7 = cx_ite11.elt;
						var min3 = 1e100;
						var cx_ite12 = p21.gverts.next;
						while(cx_ite12 != null) {
							var v6 = cx_ite12;
							var k3 = a7.gnormx * v6.x + a7.gnormy * v6.y;
							if(k3 < min3) {
								min3 = k3;
							}
							cx_ite12 = cx_ite12.next;
						}
						min3 -= a7.gprojection;
						if(min3 > 1e100) {
							best3 = min3;
							break;
						}
						if(min3 > 0) {
							if(min3 > best3) {
								best3 = min3;
								a11 = a7;
								besti1 = 1;
							}
						} else if(best3 < 0 && min3 > best3) {
							best3 = min3;
							a11 = a7;
							besti1 = 1;
						}
						cx_ite11 = cx_ite11.next;
					}
					if(best3 < 1e100) {
						var cx_ite13 = p21.edges.head;
						while(cx_ite13 != null) {
							var a8 = cx_ite13.elt;
							var min4 = 1e100;
							var cx_ite14 = p12.gverts.next;
							while(cx_ite14 != null) {
								var v7 = cx_ite14;
								var k4 = a8.gnormx * v7.x + a8.gnormy * v7.y;
								if(k4 < min4) {
									min4 = k4;
								}
								cx_ite14 = cx_ite14.next;
							}
							min4 -= a8.gprojection;
							if(min4 > 1e100) {
								best3 = min4;
								break;
							}
							if(min4 > 0) {
								if(min4 > best3) {
									best3 = min4;
									a21 = a8;
									besti1 = 2;
								}
							} else if(best3 < 0 && min4 > best3) {
								best3 = min4;
								a21 = a8;
								besti1 = 2;
							}
							cx_ite13 = cx_ite13.next;
						}
						if(best3 < 1e100) {
							var q12;
							var q21;
							var ax1;
							if(besti1 == 1) {
								q12 = p12;
								q21 = p21;
								ax1 = a11;
							} else {
								q12 = p21;
								q21 = p12;
								ax1 = a21;
								var tmp4 = w11;
								w11 = w21;
								w21 = tmp4;
								swapped1 = !swapped1;
							}
							var ay1 = null;
							var min5 = 1e100;
							var cx_ite15 = q21.edges.head;
							while(cx_ite15 != null) {
								var a9 = cx_ite15.elt;
								var k5 = ax1.gnormx * a9.gnormx + ax1.gnormy * a9.gnormy;
								if(k5 < min5) {
									min5 = k5;
									ay1 = a9;
								}
								cx_ite15 = cx_ite15.next;
							}
							if(swapped1) {
								axis.x = -ax1.gnormx;
								axis.y = -ax1.gnormy;
							} else {
								axis.x = ax1.gnormx;
								axis.y = ax1.gnormy;
							}
							if(best3 >= 0) {
								var v03 = ax1.gp0;
								var v14 = ax1.gp1;
								var q01 = ay1.gp0;
								var q13 = ay1.gp1;
								var vx1 = 0.0;
								var vy1 = 0.0;
								var qx1 = 0.0;
								var qy1 = 0.0;
								vx1 = v14.x - v03.x;
								vy1 = v14.y - v03.y;
								qx1 = q13.x - q01.x;
								qy1 = q13.y - q01.y;
								var vdot1 = 1 / (vx1 * vx1 + vy1 * vy1);
								var qdot1 = 1 / (qx1 * qx1 + qy1 * qy1);
								var t110 = -(vx1 * (v03.x - q01.x) + vy1 * (v03.y - q01.y)) * vdot1;
								var t210 = -(vx1 * (v03.x - q13.x) + vy1 * (v03.y - q13.y)) * vdot1;
								var s14 = -(qx1 * (q01.x - v03.x) + qy1 * (q01.y - v03.y)) * qdot1;
								var s24 = -(qx1 * (q01.x - v14.x) + qy1 * (q01.y - v14.y)) * qdot1;
								if(t110 < 0) {
									t110 = 0;
								} else if(t110 > 1) {
									t110 = 1;
								}
								if(t210 < 0) {
									t210 = 0;
								} else if(t210 > 1) {
									t210 = 1;
								}
								if(s14 < 0) {
									s14 = 0;
								} else if(s14 > 1) {
									s14 = 1;
								}
								if(s24 < 0) {
									s24 = 0;
								} else if(s24 > 1) {
									s24 = 1;
								}
								var f1x1 = 0.0;
								var f1y1 = 0.0;
								var t37 = t110;
								f1x1 = v03.x + vx1 * t37;
								f1y1 = v03.y + vy1 * t37;
								var f2x1 = 0.0;
								var f2y1 = 0.0;
								var t38 = t210;
								f2x1 = v03.x + vx1 * t38;
								f2y1 = v03.y + vy1 * t38;
								var g1x1 = 0.0;
								var g1y1 = 0.0;
								var t39 = s14;
								g1x1 = q01.x + qx1 * t39;
								g1y1 = q01.y + qy1 * t39;
								var g2x1 = 0.0;
								var g2y1 = 0.0;
								var t40 = s24;
								g2x1 = q01.x + qx1 * t40;
								g2y1 = q01.y + qy1 * t40;
								var dx4 = 0.0;
								var dy4 = 0.0;
								dx4 = f1x1 - q01.x;
								dy4 = f1y1 - q01.y;
								var d12 = dx4 * dx4 + dy4 * dy4;
								var dx5 = 0.0;
								var dy5 = 0.0;
								dx5 = f2x1 - q13.x;
								dy5 = f2y1 - q13.y;
								var d23 = dx5 * dx5 + dy5 * dy5;
								var dx6 = 0.0;
								var dy6 = 0.0;
								dx6 = g1x1 - v03.x;
								dy6 = g1y1 - v03.y;
								var e12 = dx6 * dx6 + dy6 * dy6;
								var dx7 = 0.0;
								var dy7 = 0.0;
								dx7 = g2x1 - v14.x;
								dy7 = g2y1 - v14.y;
								var e21 = dx7 * dx7 + dy7 * dy7;
								var minfx1 = 0.0;
								var minfy1 = 0.0;
								var minq1 = null;
								if(d12 < d23) {
									minfx1 = f1x1;
									minfy1 = f1y1;
									minq1 = q01;
								} else {
									minfx1 = f2x1;
									minfy1 = f2y1;
									minq1 = q13;
									d12 = d23;
								}
								var mingx1 = 0.0;
								var mingy1 = 0.0;
								var minv1 = null;
								if(e12 < e21) {
									mingx1 = g1x1;
									mingy1 = g1y1;
									minv1 = v03;
								} else {
									mingx1 = g2x1;
									mingy1 = g2y1;
									minv1 = v14;
									e12 = e21;
								}
								if(d12 < e12) {
									w11.x = minfx1;
									w11.y = minfy1;
									w21.x = minq1.x;
									w21.y = minq1.y;
									best3 = Math.sqrt(d12);
								} else {
									w21.x = mingx1;
									w21.y = mingy1;
									w11.x = minv1.x;
									w11.y = minv1.y;
									best3 = Math.sqrt(e12);
								}
								if(best3 != 0) {
									axis.x = w21.x - w11.x;
									axis.y = w21.y - w11.y;
									var t41 = 1.0 / best3;
									axis.x *= t41;
									axis.y *= t41;
									if(swapped1) {
										axis.x = -axis.x;
										axis.y = -axis.y;
									}
								}
								sep2 = best3;
							} else {
								var c0x1 = 0.0;
								var c0y1 = 0.0;
								c0x1 = ay1.gp0.x;
								c0y1 = ay1.gp0.y;
								var c1x1 = 0.0;
								var c1y1 = 0.0;
								c1x1 = ay1.gp1.x;
								c1y1 = ay1.gp1.y;
								var dvx1 = 0.0;
								var dvy1 = 0.0;
								dvx1 = c1x1 - c0x1;
								dvy1 = c1y1 - c0y1;
								var d01 = ax1.gnormy * c0x1 - ax1.gnormx * c0y1;
								var d13 = ax1.gnormy * c1x1 - ax1.gnormx * c1y1;
								var den1 = 1 / (d13 - d01);
								var t42 = (-ax1.tp1 - d01) * den1;
								if(t42 > nape_Config.epsilon) {
									var t43 = t42;
									c0x1 += dvx1 * t43;
									c0y1 += dvy1 * t43;
								}
								var t44 = (-ax1.tp0 - d13) * den1;
								if(t44 < -nape_Config.epsilon) {
									var t45 = t44;
									c1x1 += dvx1 * t45;
									c1y1 += dvy1 * t45;
								}
								var c0d1 = c0x1 * ax1.gnormx + c0y1 * ax1.gnormy - ax1.gprojection;
								var c1d1 = c1x1 * ax1.gnormx + c1y1 * ax1.gnormy - ax1.gprojection;
								if(c0d1 < c1d1) {
									w21.x = c0x1;
									w21.y = c0y1;
									var t46 = -c0d1;
									w11.x = w21.x + ax1.gnormx * t46;
									w11.y = w21.y + ax1.gnormy * t46;
									sep2 = c0d1;
								} else {
									w21.x = c1x1;
									w21.y = c1y1;
									var t47 = -c1d1;
									w11.x = w21.x + ax1.gnormx * t47;
									w11.y = w21.y + ax1.gnormy * t47;
									sep2 = c1d1;
								}
							}
						} else {
							sep2 = 1e100;
						}
					} else {
						sep2 = 1e100;
					}
				}
			}
			var sep3 = sep2 + negRadius;
			var dot1 = deltax * axis.x + deltay * axis.y;
			if(sep3 < nape_Config.distanceThresholdCCD) {
				var d1x1 = 0.0;
				var d1y1 = 0.0;
				d1x1 = c1.x - b1.posx;
				d1y1 = c1.y - b1.posy;
				var proj1 = dot1 - b1.sweep_angvel * (axis.y * d1x1 - axis.x * d1y1);
				if(proj1 > 0) {
					toi.slipped = true;
				}
				if(proj1 <= 0 || sep3 < nape_Config.distanceThresholdCCD * 0.5) {
					break;
				}
			}
			curTOI = -1;
			break;
		}
		if(++curIter >= 40) {
			if(sep1 > negRadius) {
				toi.failed = true;
			}
			break;
		}
	}
	toi.toi = curTOI;
};
zpp_$nape_geom_ZPP_$SweepDistance.distanceBody = function(b1,b2,w1,w2) {
	var t1;
	if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
		t1 = new zpp_$nape_geom_ZPP_$Vec2();
	} else {
		t1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = t1.next;
		t1.next = null;
	}
	t1.weak = false;
	var t2;
	if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
		t2 = new zpp_$nape_geom_ZPP_$Vec2();
	} else {
		t2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = t2.next;
		t2.next = null;
	}
	t2.weak = false;
	var ax;
	if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
		ax = new zpp_$nape_geom_ZPP_$Vec2();
	} else {
		ax = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ax.next;
		ax.next = null;
	}
	ax.weak = false;
	var min = 1e100;
	var cx_ite = b1.shapes.head;
	while(cx_ite != null) {
		var s1 = cx_ite.elt;
		var cx_ite1 = b2.shapes.head;
		while(cx_ite1 != null) {
			var s2 = cx_ite1.elt;
			var s11 = s1;
			var s21 = s2;
			var w11 = t1;
			var w21 = t2;
			var upperBound = min;
			if(upperBound == null) {
				upperBound = 1e100;
			}
			var dist;
			if(s11.type == 0 && s21.type == 0) {
				var c1 = s11.circle;
				var c2 = s21.circle;
				var dist1;
				var nx = 0.0;
				var ny = 0.0;
				nx = c2.worldCOMx - c1.worldCOMx;
				ny = c2.worldCOMy - c1.worldCOMy;
				var x = nx * nx + ny * ny;
				var len;
				if(x == 0.0) {
					len = 0.0;
				} else {
					zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
					zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
					var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
					len = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
				}
				dist1 = len - (c1.radius + c2.radius);
				if(dist1 < upperBound) {
					if(len == 0) {
						nx = 1;
						ny = 0;
					} else {
						var t = 1.0 / len;
						nx *= t;
						ny *= t;
					}
					var t3 = c1.radius;
					w11.x = c1.worldCOMx + nx * t3;
					w11.y = c1.worldCOMy + ny * t3;
					var t4 = -c2.radius;
					w21.x = c2.worldCOMx + nx * t4;
					w21.y = c2.worldCOMy + ny * t4;
					ax.x = nx;
					ax.y = ny;
				}
				dist = dist1;
			} else {
				var swapped = false;
				if(s11.type == 0 && s21.type == 1) {
					var tmp = s11;
					s11 = s21;
					s21 = tmp;
					var tmp2 = w11;
					w11 = w21;
					w21 = tmp2;
					swapped = true;
				}
				if(s11.type == 1 && s21.type == 0) {
					var poly = s11.polygon;
					var circle = s21.circle;
					var best = -1e+100;
					var a0 = null;
					var cx_ite2 = poly.edges.head;
					while(cx_ite2 != null) {
						var a = cx_ite2.elt;
						var dist2 = a.gnormx * circle.worldCOMx + a.gnormy * circle.worldCOMy - a.gprojection - circle.radius;
						if(dist2 > upperBound) {
							best = dist2;
							break;
						}
						if(dist2 > 0) {
							if(dist2 > best) {
								best = dist2;
								a0 = a;
							}
						} else if(best < 0 && dist2 > best) {
							best = dist2;
							a0 = a;
						}
						cx_ite2 = cx_ite2.next;
					}
					if(best < upperBound) {
						var v0 = a0.gp0;
						var v1 = a0.gp1;
						var dt = circle.worldCOMy * a0.gnormx - circle.worldCOMx * a0.gnormy;
						if(dt <= v0.y * a0.gnormx - v0.x * a0.gnormy) {
							var nx1 = 0.0;
							var ny1 = 0.0;
							nx1 = circle.worldCOMx - v0.x;
							ny1 = circle.worldCOMy - v0.y;
							var x1 = nx1 * nx1 + ny1 * ny1;
							var len1;
							if(x1 == 0.0) {
								len1 = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x1;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x21 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								len1 = 1 / (x21 * (1.5 - 0.5 * x1 * x21 * x21));
							}
							best = len1 - circle.radius;
							if(best < upperBound) {
								if(len1 == 0) {
									nx1 = 1;
									ny1 = 0;
								} else {
									var t5 = 1.0 / len1;
									nx1 *= t5;
									ny1 *= t5;
								}
								var t6 = 0;
								w11.x = v0.x + nx1 * t6;
								w11.y = v0.y + ny1 * t6;
								var t7 = -circle.radius;
								w21.x = circle.worldCOMx + nx1 * t7;
								w21.y = circle.worldCOMy + ny1 * t7;
								ax.x = nx1;
								ax.y = ny1;
							}
						} else if(dt >= v1.y * a0.gnormx - v1.x * a0.gnormy) {
							var nx2 = 0.0;
							var ny2 = 0.0;
							nx2 = circle.worldCOMx - v1.x;
							ny2 = circle.worldCOMy - v1.y;
							var x3 = nx2 * nx2 + ny2 * ny2;
							var len2;
							if(x3 == 0.0) {
								len2 = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x3;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x22 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								len2 = 1 / (x22 * (1.5 - 0.5 * x3 * x22 * x22));
							}
							best = len2 - circle.radius;
							if(best < upperBound) {
								if(len2 == 0) {
									nx2 = 1;
									ny2 = 0;
								} else {
									var t8 = 1.0 / len2;
									nx2 *= t8;
									ny2 *= t8;
								}
								var t9 = 0;
								w11.x = v1.x + nx2 * t9;
								w11.y = v1.y + ny2 * t9;
								var t10 = -circle.radius;
								w21.x = circle.worldCOMx + nx2 * t10;
								w21.y = circle.worldCOMy + ny2 * t10;
								ax.x = nx2;
								ax.y = ny2;
							}
						} else {
							var t11 = -circle.radius;
							w21.x = circle.worldCOMx + a0.gnormx * t11;
							w21.y = circle.worldCOMy + a0.gnormy * t11;
							var t12 = -best;
							w11.x = w21.x + a0.gnormx * t12;
							w11.y = w21.y + a0.gnormy * t12;
							ax.x = a0.gnormx;
							ax.y = a0.gnormy;
						}
					}
					if(swapped) {
						ax.x = -ax.x;
						ax.y = -ax.y;
					}
					dist = best;
				} else {
					var p1 = s11.polygon;
					var p2 = s21.polygon;
					var best1 = -1e+100;
					var a1 = null;
					var a2 = null;
					var besti = 0;
					var cx_ite3 = p1.edges.head;
					while(cx_ite3 != null) {
						var a3 = cx_ite3.elt;
						var min1 = 1e100;
						var cx_ite4 = p2.gverts.next;
						while(cx_ite4 != null) {
							var v = cx_ite4;
							var k = a3.gnormx * v.x + a3.gnormy * v.y;
							if(k < min1) {
								min1 = k;
							}
							cx_ite4 = cx_ite4.next;
						}
						min1 -= a3.gprojection;
						if(min1 > upperBound) {
							best1 = min1;
							break;
						}
						if(min1 > 0) {
							if(min1 > best1) {
								best1 = min1;
								a1 = a3;
								besti = 1;
							}
						} else if(best1 < 0 && min1 > best1) {
							best1 = min1;
							a1 = a3;
							besti = 1;
						}
						cx_ite3 = cx_ite3.next;
					}
					if(best1 < upperBound) {
						var cx_ite5 = p2.edges.head;
						while(cx_ite5 != null) {
							var a4 = cx_ite5.elt;
							var min2 = 1e100;
							var cx_ite6 = p1.gverts.next;
							while(cx_ite6 != null) {
								var v2 = cx_ite6;
								var k1 = a4.gnormx * v2.x + a4.gnormy * v2.y;
								if(k1 < min2) {
									min2 = k1;
								}
								cx_ite6 = cx_ite6.next;
							}
							min2 -= a4.gprojection;
							if(min2 > upperBound) {
								best1 = min2;
								break;
							}
							if(min2 > 0) {
								if(min2 > best1) {
									best1 = min2;
									a2 = a4;
									besti = 2;
								}
							} else if(best1 < 0 && min2 > best1) {
								best1 = min2;
								a2 = a4;
								besti = 2;
							}
							cx_ite5 = cx_ite5.next;
						}
						if(best1 < upperBound) {
							var q1;
							var q2;
							var ax1;
							if(besti == 1) {
								q1 = p1;
								q2 = p2;
								ax1 = a1;
							} else {
								q1 = p2;
								q2 = p1;
								ax1 = a2;
								var tmp1 = w11;
								w11 = w21;
								w21 = tmp1;
								swapped = !swapped;
							}
							var ay = null;
							var min3 = 1e100;
							var cx_ite7 = q2.edges.head;
							while(cx_ite7 != null) {
								var a5 = cx_ite7.elt;
								var k2 = ax1.gnormx * a5.gnormx + ax1.gnormy * a5.gnormy;
								if(k2 < min3) {
									min3 = k2;
									ay = a5;
								}
								cx_ite7 = cx_ite7.next;
							}
							if(swapped) {
								ax.x = -ax1.gnormx;
								ax.y = -ax1.gnormy;
							} else {
								ax.x = ax1.gnormx;
								ax.y = ax1.gnormy;
							}
							if(best1 >= 0) {
								var v01 = ax1.gp0;
								var v11 = ax1.gp1;
								var q0 = ay.gp0;
								var q11 = ay.gp1;
								var vx = 0.0;
								var vy = 0.0;
								var qx = 0.0;
								var qy = 0.0;
								vx = v11.x - v01.x;
								vy = v11.y - v01.y;
								qx = q11.x - q0.x;
								qy = q11.y - q0.y;
								var vdot = 1 / (vx * vx + vy * vy);
								var qdot = 1 / (qx * qx + qy * qy);
								var t13 = -(vx * (v01.x - q0.x) + vy * (v01.y - q0.y)) * vdot;
								var t21 = -(vx * (v01.x - q11.x) + vy * (v01.y - q11.y)) * vdot;
								var s12 = -(qx * (q0.x - v01.x) + qy * (q0.y - v01.y)) * qdot;
								var s22 = -(qx * (q0.x - v11.x) + qy * (q0.y - v11.y)) * qdot;
								if(t13 < 0) {
									t13 = 0;
								} else if(t13 > 1) {
									t13 = 1;
								}
								if(t21 < 0) {
									t21 = 0;
								} else if(t21 > 1) {
									t21 = 1;
								}
								if(s12 < 0) {
									s12 = 0;
								} else if(s12 > 1) {
									s12 = 1;
								}
								if(s22 < 0) {
									s22 = 0;
								} else if(s22 > 1) {
									s22 = 1;
								}
								var f1x = 0.0;
								var f1y = 0.0;
								var t14 = t13;
								f1x = v01.x + vx * t14;
								f1y = v01.y + vy * t14;
								var f2x = 0.0;
								var f2y = 0.0;
								var t15 = t21;
								f2x = v01.x + vx * t15;
								f2y = v01.y + vy * t15;
								var g1x = 0.0;
								var g1y = 0.0;
								var t16 = s12;
								g1x = q0.x + qx * t16;
								g1y = q0.y + qy * t16;
								var g2x = 0.0;
								var g2y = 0.0;
								var t17 = s22;
								g2x = q0.x + qx * t17;
								g2y = q0.y + qy * t17;
								var dx = 0.0;
								var dy = 0.0;
								dx = f1x - q0.x;
								dy = f1y - q0.y;
								var d1 = dx * dx + dy * dy;
								var dx1 = 0.0;
								var dy1 = 0.0;
								dx1 = f2x - q11.x;
								dy1 = f2y - q11.y;
								var d2 = dx1 * dx1 + dy1 * dy1;
								var dx2 = 0.0;
								var dy2 = 0.0;
								dx2 = g1x - v01.x;
								dy2 = g1y - v01.y;
								var e1 = dx2 * dx2 + dy2 * dy2;
								var dx3 = 0.0;
								var dy3 = 0.0;
								dx3 = g2x - v11.x;
								dy3 = g2y - v11.y;
								var e2 = dx3 * dx3 + dy3 * dy3;
								var minfx = 0.0;
								var minfy = 0.0;
								var minq = null;
								if(d1 < d2) {
									minfx = f1x;
									minfy = f1y;
									minq = q0;
								} else {
									minfx = f2x;
									minfy = f2y;
									minq = q11;
									d1 = d2;
								}
								var mingx = 0.0;
								var mingy = 0.0;
								var minv = null;
								if(e1 < e2) {
									mingx = g1x;
									mingy = g1y;
									minv = v01;
								} else {
									mingx = g2x;
									mingy = g2y;
									minv = v11;
									e1 = e2;
								}
								if(d1 < e1) {
									w11.x = minfx;
									w11.y = minfy;
									w21.x = minq.x;
									w21.y = minq.y;
									best1 = Math.sqrt(d1);
								} else {
									w21.x = mingx;
									w21.y = mingy;
									w11.x = minv.x;
									w11.y = minv.y;
									best1 = Math.sqrt(e1);
								}
								if(best1 != 0) {
									ax.x = w21.x - w11.x;
									ax.y = w21.y - w11.y;
									var t18 = 1.0 / best1;
									ax.x *= t18;
									ax.y *= t18;
									if(swapped) {
										ax.x = -ax.x;
										ax.y = -ax.y;
									}
								}
								dist = best1;
							} else {
								var c0x = 0.0;
								var c0y = 0.0;
								c0x = ay.gp0.x;
								c0y = ay.gp0.y;
								var c1x = 0.0;
								var c1y = 0.0;
								c1x = ay.gp1.x;
								c1y = ay.gp1.y;
								var dvx = 0.0;
								var dvy = 0.0;
								dvx = c1x - c0x;
								dvy = c1y - c0y;
								var d0 = ax1.gnormy * c0x - ax1.gnormx * c0y;
								var d11 = ax1.gnormy * c1x - ax1.gnormx * c1y;
								var den = 1 / (d11 - d0);
								var t19 = (-ax1.tp1 - d0) * den;
								if(t19 > nape_Config.epsilon) {
									var t20 = t19;
									c0x += dvx * t20;
									c0y += dvy * t20;
								}
								var t22 = (-ax1.tp0 - d11) * den;
								if(t22 < -nape_Config.epsilon) {
									var t23 = t22;
									c1x += dvx * t23;
									c1y += dvy * t23;
								}
								var c0d = c0x * ax1.gnormx + c0y * ax1.gnormy - ax1.gprojection;
								var c1d = c1x * ax1.gnormx + c1y * ax1.gnormy - ax1.gprojection;
								if(c0d < c1d) {
									w21.x = c0x;
									w21.y = c0y;
									var t24 = -c0d;
									w11.x = w21.x + ax1.gnormx * t24;
									w11.y = w21.y + ax1.gnormy * t24;
									dist = c0d;
								} else {
									w21.x = c1x;
									w21.y = c1y;
									var t25 = -c1d;
									w11.x = w21.x + ax1.gnormx * t25;
									w11.y = w21.y + ax1.gnormy * t25;
									dist = c1d;
								}
							}
						} else {
							dist = upperBound;
						}
					} else {
						dist = upperBound;
					}
				}
			}
			if(dist < min) {
				min = dist;
				w1.x = t1.x;
				w1.y = t1.y;
				w2.x = t2.x;
				w2.y = t2.y;
			}
			cx_ite1 = cx_ite1.next;
		}
		cx_ite = cx_ite.next;
	}
	var o = t1;
	if(o.outer != null) {
		o.outer.zpp_inner = null;
		o.outer = null;
	}
	o._isimmutable = null;
	o._validate = null;
	o._invalidate = null;
	o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
	zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	var o = t2;
	if(o.outer != null) {
		o.outer.zpp_inner = null;
		o.outer = null;
	}
	o._isimmutable = null;
	o._validate = null;
	o._invalidate = null;
	o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
	zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	var o = ax;
	if(o.outer != null) {
		o.outer.zpp_inner = null;
		o.outer = null;
	}
	o._isimmutable = null;
	o._validate = null;
	o._invalidate = null;
	o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
	zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
	return min;
};
var zpp_$nape_geom_ZPP_$PartitionPair = function() {
	this.node = null;
	this.di = 0;
	this.id = 0;
	this.b = null;
	this.a = null;
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this._inuse = false;
	this.next = null;
};
zpp_$nape_geom_ZPP_$PartitionPair.__name__ = true;
zpp_$nape_geom_ZPP_$PartitionPair.edge_swap = function(a,b) {
	var t = a.node;
	a.node = b.node;
	b.node = t;
};
zpp_$nape_geom_ZPP_$PartitionPair.edge_lt = function(a,b) {
	if(a.id >= b.id) {
		if(a.id == b.id) {
			return a.di < b.di;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
zpp_$nape_geom_ZPP_$PartitionPair.prototype = {
	add: function(o) {
		o._inuse = true;
		var temp = o;
		temp.next = this.next;
		this.next = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.next;
		this.next = ret.next;
		ret._inuse = false;
		if(this.next == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.next;
		this.pop();
		return ret;
	}
};
var zpp_$nape_geom_ZPP_$Triangular = function() { };
zpp_$nape_geom_ZPP_$Triangular.__name__ = true;
zpp_$nape_geom_ZPP_$Triangular.delaunay = function(A,B,C,D) {
	var ux = 0.0;
	var uy = 0.0;
	var vx = 0.0;
	var vy = 0.0;
	var tmp;
	var tmp1;
	var tmp2;
	ux = C.x - B.x;
	uy = C.y - B.y;
	vx = B.x - A.x;
	vy = B.y - A.y;
	if(!(vy * ux - vx * uy >= 0)) {
		ux = D.x - C.x;
		uy = D.y - C.y;
		vx = C.x - B.x;
		vy = C.y - B.y;
		tmp2 = vy * ux - vx * uy >= 0;
	} else {
		tmp2 = true;
	}
	if(!tmp2) {
		ux = A.x - D.x;
		uy = A.y - D.y;
		vx = D.x - C.x;
		vy = D.y - C.y;
		tmp1 = vy * ux - vx * uy >= 0;
	} else {
		tmp1 = true;
	}
	if(!tmp1) {
		ux = B.x - A.x;
		uy = B.y - A.y;
		vx = A.x - D.x;
		vy = A.y - D.y;
		tmp = vy * ux - vx * uy >= 0;
	} else {
		tmp = true;
	}
	if(tmp) {
		return true;
	}
	return B.x * (C.y * D.mag - C.mag * D.y) - C.x * (B.y * D.mag - B.mag * D.y) + D.x * (B.y * C.mag - B.mag * C.y) - (A.x * (C.y * D.mag - C.mag * D.y) - C.x * (A.y * D.mag - A.mag * D.y) + D.x * (A.y * C.mag - A.mag * C.y)) + (A.x * (B.y * D.mag - B.mag * D.y) - B.x * (A.y * D.mag - A.mag * D.y) + D.x * (A.y * B.mag - A.mag * B.y)) - (A.x * (B.y * C.mag - B.mag * C.y) - B.x * (A.y * C.mag - A.mag * C.y) + C.x * (A.y * B.mag - A.mag * B.y)) > 0;
};
zpp_$nape_geom_ZPP_$Triangular.optimise = function(P) {
	var F = P.vertices;
	var L = P.vertices;
	if(F != null) {
		var nite = F;
		do {
			var p = nite;
			p.sort();
			p.mag = p.x * p.x + p.y * p.y;
			nite = nite.next;
		} while(nite != L);
	}
	if(zpp_$nape_geom_ZPP_$Triangular.edgeSet == null) {
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool == null) {
			zpp_$nape_geom_ZPP_$Triangular.edgeSet = new zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair();
		} else {
			zpp_$nape_geom_ZPP_$Triangular.edgeSet = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool = zpp_$nape_geom_ZPP_$Triangular.edgeSet.next;
			zpp_$nape_geom_ZPP_$Triangular.edgeSet.next = null;
		}
		zpp_$nape_geom_ZPP_$Triangular.edgeSet.lt = zpp_$nape_geom_ZPP_$PartitionPair.edge_lt;
		zpp_$nape_geom_ZPP_$Triangular.edgeSet.swapped = zpp_$nape_geom_ZPP_$PartitionPair.edge_swap;
	}
	var edgeStack;
	if(zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool == null) {
		edgeStack = new zpp_$nape_geom_ZPP_$PartitionPair();
	} else {
		edgeStack = zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool;
		zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool = edgeStack.next;
		edgeStack.next = null;
	}
	var F = P.vertices;
	var L = P.vertices;
	if(F != null) {
		var nite = F;
		while(true) {
			var p = nite;
			var q0 = p.next;
			p.diagonals.reverse();
			var cx_ite = p.diagonals.head;
			while(cx_ite != null) {
				var q = cx_ite.elt;
				if(q.id < p.id) {
					q0 = q;
					cx_ite = cx_ite.next;
					continue;
				}
				var q1 = cx_ite.next == null ? p.prev : cx_ite.next.elt;
				if(!zpp_$nape_geom_ZPP_$Triangular.delaunay(p,q0,q,q1)) {
					var ret;
					if(zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool == null) {
						ret = new zpp_$nape_geom_ZPP_$PartitionPair();
					} else {
						ret = zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool;
						zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.a = p;
					ret.b = q;
					if(p.id < q.id) {
						ret.id = p.id;
						ret.di = q.id;
					} else {
						ret.id = q.id;
						ret.di = p.id;
					}
					var edge = ret;
					edgeStack.add(edge);
					edge.node = zpp_$nape_geom_ZPP_$Triangular.edgeSet.insert(edge);
				}
				q0 = q;
				cx_ite = cx_ite.next;
			}
			nite = nite.next;
			if(!(nite != L)) {
				break;
			}
		}
	}
	while(edgeStack.next != null) {
		var edge = edgeStack.pop_unsafe();
		var A = edge.a;
		var C = edge.b;
		var B = A.next;
		var D = null;
		var cx_ite = A.diagonals.head;
		while(cx_ite != null) {
			var p = cx_ite.elt;
			if(p == C) {
				cx_ite = cx_ite.next;
				D = cx_ite == null ? A.prev : cx_ite.elt;
				break;
			}
			B = p;
			cx_ite = cx_ite.next;
		}
		A.diagonals.remove(C);
		C.diagonals.remove(A);
		if(C == B.next) {
			B.diagonals.add(D);
		} else {
			var cx_ite1 = B.diagonals.head;
			while(cx_ite1 != null) {
				var p1 = cx_ite1.elt;
				if(p1 == C) {
					B.diagonals.insert(cx_ite1,D);
					break;
				}
				cx_ite1 = cx_ite1.next;
			}
		}
		if(A == D.next) {
			D.diagonals.add(B);
		} else {
			var cx_ite2 = D.diagonals.head;
			while(cx_ite2 != null) {
				var p2 = cx_ite2.elt;
				if(p2 == A) {
					D.diagonals.insert(cx_ite2,B);
					break;
				}
				cx_ite2 = cx_ite2.next;
			}
		}
		zpp_$nape_geom_ZPP_$Triangular.edgeSet.remove_node(edge.node);
		var o = edge;
		o.a = o.b = null;
		o.node = null;
		o.next = zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool;
		zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool = o;
	}
	var o = edgeStack;
	o.a = o.b = null;
	o.node = null;
	o.next = zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool;
	zpp_$nape_geom_ZPP_$PartitionPair.zpp_pool = o;
};
zpp_$nape_geom_ZPP_$Triangular.triangulate = function(P) {
	var min = P.vertices;
	var max = P.vertices;
	var F = P.vertices.next;
	var L = P.vertices;
	if(F != null) {
		var nite = F;
		do {
			var p = nite;
			if(p.y < min.y || p.y == min.y && p.x < min.x) {
				min = p;
			}
			if(max.y < p.y || max.y == p.y && max.x < p.x) {
				max = p;
			}
			nite = nite.next;
		} while(nite != L);
	}
	if(zpp_$nape_geom_ZPP_$Triangular.queue == null) {
		zpp_$nape_geom_ZPP_$Triangular.queue = new zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex();
	}
	var rp = max.prev;
	var lp = max.next;
	zpp_$nape_geom_ZPP_$Triangular.queue.add(max);
	while(rp != min || lp != min) if(rp == min || lp != min && (rp.y < lp.y || rp.y == lp.y && rp.x < lp.x)) {
		zpp_$nape_geom_ZPP_$Triangular.queue.add(lp);
		lp.rightchain = false;
		lp = lp.next;
	} else {
		zpp_$nape_geom_ZPP_$Triangular.queue.add(rp);
		rp.rightchain = true;
		rp = rp.prev;
	}
	zpp_$nape_geom_ZPP_$Triangular.queue.add(min);
	if(zpp_$nape_geom_ZPP_$Triangular.stack == null) {
		zpp_$nape_geom_ZPP_$Triangular.stack = new zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex();
	}
	zpp_$nape_geom_ZPP_$Triangular.stack.add(zpp_$nape_geom_ZPP_$Triangular.queue.pop_unsafe());
	var pre = zpp_$nape_geom_ZPP_$Triangular.queue.pop_unsafe();
	zpp_$nape_geom_ZPP_$Triangular.stack.add(pre);
	while(true) {
		var p = zpp_$nape_geom_ZPP_$Triangular.queue.pop_unsafe();
		if(zpp_$nape_geom_ZPP_$Triangular.queue.head == null) {
			break;
		}
		if(p.rightchain != zpp_$nape_geom_ZPP_$Triangular.stack.head.elt.rightchain) {
			while(true) {
				var s = zpp_$nape_geom_ZPP_$Triangular.stack.pop_unsafe();
				if(zpp_$nape_geom_ZPP_$Triangular.stack.head == null) {
					break;
				}
				P.add_diagonal(s,p);
			}
			zpp_$nape_geom_ZPP_$Triangular.stack.add(pre);
		} else {
			var q = zpp_$nape_geom_ZPP_$Triangular.stack.pop_unsafe();
			while(zpp_$nape_geom_ZPP_$Triangular.stack.head != null) {
				var s1 = zpp_$nape_geom_ZPP_$Triangular.stack.head.elt;
				var ux = 0.0;
				var uy = 0.0;
				ux = p.x - q.x;
				uy = p.y - q.y;
				var vx = 0.0;
				var vy = 0.0;
				vx = q.x - s1.x;
				vy = q.y - s1.y;
				var right = vy * ux - vx * uy;
				if(p.rightchain && right >= 0 || !p.rightchain && right <= 0) {
					break;
				}
				P.add_diagonal(s1,p);
				q = s1;
				zpp_$nape_geom_ZPP_$Triangular.stack.pop();
			}
			zpp_$nape_geom_ZPP_$Triangular.stack.add(q);
		}
		zpp_$nape_geom_ZPP_$Triangular.stack.add(p);
		pre = p;
	}
	if(zpp_$nape_geom_ZPP_$Triangular.stack.head != null) {
		zpp_$nape_geom_ZPP_$Triangular.stack.pop();
		while(zpp_$nape_geom_ZPP_$Triangular.stack.head != null) {
			var s = zpp_$nape_geom_ZPP_$Triangular.stack.pop_unsafe();
			if(zpp_$nape_geom_ZPP_$Triangular.stack.head == null) {
				break;
			}
			P.add_diagonal(max,s);
		}
	}
	return P;
};
var zpp_$nape_geom_ZPP_$Vec2 = function() {
	this.y = 0.0;
	this.x = 0.0;
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this._inuse = false;
	this.next = null;
	this.weak = false;
	this.outer = null;
	this._isimmutable = null;
	this._immutable = false;
	this._validate = null;
	this._invalidate = null;
};
zpp_$nape_geom_ZPP_$Vec2.__name__ = true;
zpp_$nape_geom_ZPP_$Vec2.prototype = {
	add: function(o) {
		o._inuse = true;
		var temp = o;
		temp.next = this.next;
		this.next = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		o._inuse = true;
		var temp = o;
		if(cur == null) {
			temp.next = this.next;
			this.next = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.next;
		this.next = ret.next;
		ret._inuse = false;
		if(this.next == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.next;
		var ret = false;
		while(cur != null) {
			if(cur == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.next;
					ret1 = old.next;
					this.next = ret1;
					if(this.next == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				old._inuse = false;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.next;
			ret = old.next;
			this.next = ret;
			if(this.next == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		old._inuse = false;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,reverse: function() {
		var cur = this.next;
		var pre = null;
		while(cur != null) {
			var nx = cur.next;
			cur.next = pre;
			this.next = cur;
			pre = cur;
			cur = nx;
		}
		this.modified = true;
		this.pushmod = true;
	}
	,iterator_at: function(ind) {
		var ret = this.next;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
	,toString: function() {
		return "{ x: " + this.x + " y: " + this.y + " }";
	}
};
var zpp_$nape_geom_ZPP_$Vec3 = function() {
	this._validate = null;
	this.immutable = false;
	this.z = 0.0;
	this.y = 0.0;
	this.x = 0.0;
	this.outer = null;
	this.immutable = false;
	this._validate = null;
};
zpp_$nape_geom_ZPP_$Vec3.__name__ = true;
var zpp_$nape_phys_ZPP_$Interactor = function() {
	this.wrap_cbTypes = null;
	this.cbSet = null;
	this.cbTypes = null;
	this.group = null;
	this.cbsets = null;
	this.icompound = null;
	this.ibody = null;
	this.ishape = null;
	this.userData = null;
	this.id = 0;
	this.outer_i = null;
	this.id = zpp_$nape_ZPP_$ID.Interactor();
	this.cbsets = new zpp_$nape_util_ZNPList_$ZPP_$CallbackSet();
	this.cbTypes = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
};
zpp_$nape_phys_ZPP_$Interactor.__name__ = true;
zpp_$nape_phys_ZPP_$Interactor.get = function(i1,i2) {
	var id = i1.id < i2.id ? i1.id : i2.id;
	var di = i1.id < i2.id ? i2.id : i1.id;
	var xs = i1.cbsets.length < i2.cbsets.length ? i1.cbsets : i2.cbsets;
	var ret = null;
	var cx_ite = xs.head;
	while(cx_ite != null) {
		var x = cx_ite.elt;
		if(x.id == id && x.di == di) {
			ret = x;
			break;
		}
		cx_ite = cx_ite.next;
	}
	return ret;
};
zpp_$nape_phys_ZPP_$Interactor.prototype = {
	__iaddedToSpace: function() {
		if(this.group != null) {
			this.group.interactors.add(this);
		}
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.interactors.add(this);
			cx_ite = cx_ite.next;
		}
		this.alloc_cbSet();
	}
	,__iremovedFromSpace: function() {
		if(this.group != null) {
			this.group.interactors.remove(this);
		}
		var cx_ite = this.cbTypes.head;
		while(cx_ite != null) {
			var cb = cx_ite.elt;
			cb.interactors.remove(this);
			cx_ite = cx_ite.next;
		}
		this.dealloc_cbSet();
	}
	,wake: function() {
		if(this.ishape != null) {
			var body = this.ishape.body;
			if(body != null && body.space != null) {
				body.space.non_inlined_wake(body);
			}
		} else if(this.ibody != null) {
			if(this.ibody.space != null) {
				this.ibody.space.non_inlined_wake(this.ibody);
			}
		} else if(this.icompound.space != null) {
			this.icompound.space.wakeCompound(this.icompound);
		}
	}
	,setupcbTypes: function() {
		this.wrap_cbTypes = zpp_$nape_util_ZPP_$CbTypeList.get(this.cbTypes);
		this.wrap_cbTypes.zpp_inner.adder = $bind(this,this.wrap_cbTypes_adder);
		this.wrap_cbTypes.zpp_inner.subber = $bind(this,this.wrap_cbTypes_subber);
		this.wrap_cbTypes.zpp_inner.dontremove = true;
	}
	,wrap_cbTypes_subber: function(pcb) {
		var cb = pcb.zpp_inner;
		if(this.cbTypes.has(cb)) {
			var space = this.ishape != null ? this.ishape.body == null ? null : this.ishape.body.space : this.ibody != null ? this.ibody.space : this.icompound.space;
			if(space != null) {
				this.dealloc_cbSet();
				cb.interactors.remove(this);
			}
			this.cbTypes.remove(cb);
			if(space != null) {
				this.alloc_cbSet();
				this.wake();
			}
		}
	}
	,wrap_cbTypes_adder: function(cb) {
		this.insert_cbtype(cb.zpp_inner);
		return false;
	}
	,insert_cbtype: function(cb) {
		if(!this.cbTypes.has(cb)) {
			var space = this.ishape != null ? this.ishape.body == null ? null : this.ishape.body.space : this.ibody != null ? this.ibody.space : this.icompound.space;
			if(space != null) {
				this.dealloc_cbSet();
				cb.interactors.add(this);
			}
			var pre = null;
			var cx_ite = this.cbTypes.head;
			while(cx_ite != null) {
				var j = cx_ite.elt;
				if(cb.id < j.id) {
					break;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var _this = this.cbTypes;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbType();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbType.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = cb;
			var temp = ret;
			if(pre == null) {
				temp.next = _this.head;
				_this.head = temp;
			} else {
				temp.next = pre.next;
				pre.next = temp;
			}
			_this.pushmod = _this.modified = true;
			_this.length++;
			if(space != null) {
				this.alloc_cbSet();
				this.wake();
			}
		}
	}
	,alloc_cbSet: function() {
		var space = this.ishape != null ? this.ishape.body == null ? null : this.ishape.body.space : this.ibody != null ? this.ibody.space : this.icompound.space;
		if((this.cbSet = space.cbsets.get(this.cbTypes)) != null) {
			this.cbSet.count++;
			this.cbSet.interactors.add(this);
			this.cbSet.validate();
			space.freshInteractorType(this);
		}
	}
	,dealloc_cbSet: function() {
		var space = this.ishape != null ? this.ishape.body == null ? null : this.ishape.body.space : this.ibody != null ? this.ibody.space : this.icompound.space;
		if(this.cbSet != null) {
			this.cbSet.interactors.remove(this);
			space.nullInteractorType(this);
			if(--this.cbSet.count == 0) {
				space.cbsets.remove(this.cbSet);
				var o = this.cbSet;
				o.listeners.clear();
				o.zip_listeners = true;
				o.bodylisteners.clear();
				o.zip_bodylisteners = true;
				o.conlisteners.clear();
				o.zip_conlisteners = true;
				while(o.cbTypes.head != null) {
					var cb = o.cbTypes.pop_unsafe();
					cb.cbsets.remove(o);
				}
				o.next = zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool;
				zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool = o;
			}
			this.cbSet = null;
		}
	}
	,setGroup: function(group) {
		if(this.group != group) {
			var inspace = (this.ishape != null ? this.ishape.body == null ? null : this.ishape.body.space : this.ibody != null ? this.ibody.space : this.icompound.space) != null;
			if(inspace && this.group != null) {
				this.group.interactors.remove(this);
			}
			this.group = group;
			if(inspace && group != null) {
				group.interactors.add(this);
			}
			if(inspace) {
				if(this.ishape != null) {
					this.ishape.body.wake();
				} else if(this.ibody != null) {
					this.ibody.wake();
				} else {
					this.icompound.wake();
				}
			}
		}
	}
	,immutable_midstep: function(n) {
		if(this.ibody == null) {
			if(this.ishape != null) {
				this.ishape.__immutable_midstep(n);
			} else {
				this.icompound.__imutable_midstep(n);
			}
		}
	}
	,copyto: function(ret) {
		ret.zpp_inner_i.group = this.group;
		var _this = this.outer_i;
		if(_this.zpp_inner_i.wrap_cbTypes == null) {
			_this.zpp_inner_i.setupcbTypes();
		}
		var _this1 = _this.zpp_inner_i.wrap_cbTypes;
		_this1.zpp_inner.valmod();
		var _g = nape_callbacks_CbTypeIterator.get(_this1);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_callbacks_CbTypeIterator.zpp_pool;
				nape_callbacks_CbTypeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var cb = _g.zpp_inner.at(_g.zpp_i++);
			if(ret.zpp_inner_i.wrap_cbTypes == null) {
				ret.zpp_inner_i.setupcbTypes();
			}
			var _this1 = ret.zpp_inner_i.wrap_cbTypes;
			if(_this1.zpp_inner.reverse_flag) {
				_this1.push(cb);
			} else {
				_this1.unshift(cb);
			}
		}
		if(this.userData != null) {
			ret.zpp_inner_i.userData = Reflect.copy(this.userData);
		}
	}
};
var zpp_$nape_phys_ZPP_$Body = function() {
	this.wrap_worldCOM = null;
	this.wrap_localCOM = null;
	this.zip_worldCOM = false;
	this.worldCOMy = 0.0;
	this.worldCOMx = 0.0;
	this.zip_localCOM = false;
	this.localCOMy = 0.0;
	this.localCOMx = 0.0;
	this.zip_aabb = false;
	this.aabb = null;
	this.norotate = false;
	this.sinertia = 0.0;
	this.iinertia = 0.0;
	this.cinertia = 0.0;
	this.zip_inertia = false;
	this.inertia = 0.0;
	this.inertiaMode = 0;
	this.zip_gravMassScale = false;
	this.gravMassScale = 0.0;
	this.gravMassMode = 0;
	this.zip_gravMass = false;
	this.gravMass = 0.0;
	this.nomove = false;
	this.cmass = 0.0;
	this.smass = 0.0;
	this.imass = 0.0;
	this.massMode = 0;
	this.zip_mass = false;
	this.mass = 0.0;
	this.zip_axis = false;
	this.axisy = 0.0;
	this.axisx = 0.0;
	this.rot = 0.0;
	this.pre_rot = 0.0;
	this.kinangvel = 0.0;
	this.torque = 0.0;
	this.angvel = 0.0;
	this.wrapcvel = null;
	this.wrap_svel = null;
	this.svely = 0.0;
	this.svelx = 0.0;
	this.wrap_kinvel = null;
	this.kinvely = 0.0;
	this.kinvelx = 0.0;
	this.wrap_force = null;
	this.forcey = 0.0;
	this.forcex = 0.0;
	this.wrap_vel = null;
	this.vely = 0.0;
	this.velx = 0.0;
	this.wrap_pos = null;
	this.posy = 0.0;
	this.posx = 0.0;
	this.pre_posy = 0.0;
	this.pre_posx = 0.0;
	this.disableCCD = false;
	this.bulletEnabled = false;
	this.bullet = false;
	this.sweepRadius = 0.0;
	this.sweepFrozen = false;
	this.sweep_angvel = 0.0;
	this.sweepTime = 0.0;
	this.graph_depth = 0;
	this.component = null;
	this.wrap_constraints = null;
	this.constraints = null;
	this.wrap_arbiters = null;
	this.arbiters = null;
	this.space = null;
	this.wrap_shapes = null;
	this.shapes = null;
	this.compound = null;
	this.type = 0;
	this.world = false;
	this.outer = null;
	zpp_$nape_phys_ZPP_$Interactor.call(this);
	this.ibody = this;
	this.world = false;
	this.bulletEnabled = false;
	this.sweepTime = 0;
	this.sweep_angvel = 0;
	this.norotate = this.nomove = false;
	this.disableCCD = false;
	this.posx = 0;
	this.posy = 0;
	this.rot = 0;
	this.axisx = 0;
	this.axisy = 1;
	this.svelx = 0;
	this.svely = 0;
	this.velx = 0;
	this.vely = 0;
	this.kinvelx = 0;
	this.kinvely = 0;
	this.forcex = 0;
	this.forcey = 0;
	this.torque = this.angvel = this.kinangvel = 0;
	this.pre_posx = Infinity;
	this.pre_posy = Infinity;
	this.pre_rot = Infinity;
	this.localCOMx = 0;
	this.localCOMy = 0;
	this.worldCOMx = 0;
	this.worldCOMy = 0;
	this.zip_aabb = true;
	var ret;
	if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$AABB();
	} else {
		ret = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.minx = 0;
	ret.miny = 0;
	ret.maxx = 0;
	ret.maxy = 0;
	this.aabb = ret;
	this.aabb._immutable = true;
	var me = this;
	this.aabb._validate = $bind(this,this.aabb_validate);
	this.massMode = 0;
	this.gravMassMode = 0;
	this.gravMassScale = 1.0;
	this.inertiaMode = 0;
	this.arbiters = new zpp_$nape_util_ZNPList_$ZPP_$Arbiter();
	this.constraints = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this.shapes = new zpp_$nape_util_ZNPList_$ZPP_$Shape();
	this.wrap_shapes = zpp_$nape_util_ZPP_$ShapeList.get(this.shapes);
	this.wrap_shapes.zpp_inner.adder = $bind(this,this.shapes_adder);
	this.wrap_shapes.zpp_inner.subber = $bind(this,this.shapes_subber);
	this.wrap_shapes.zpp_inner._invalidate = $bind(this,this.shapes_invalidate);
	this.kinematicDelaySleep = false;
};
zpp_$nape_phys_ZPP_$Body.__name__ = true;
zpp_$nape_phys_ZPP_$Body.bodysetlt = function(a,b) {
	return a.id < b.id;
};
zpp_$nape_phys_ZPP_$Body.__static = function() {
	if(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_STATIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var ret = new nape_phys_Body(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC);
	var si = ret.zpp_inner;
	si.world = true;
	si.wrap_shapes.zpp_inner.immutable = true;
	si.smass = si.imass = si.cmass = si.mass = si.gravMass = 0.0;
	si.sinertia = si.iinertia = si.cinertia = si.inertia = 0.0;
	si.cbTypes.clear();
	return ret;
};
zpp_$nape_phys_ZPP_$Body.__super__ = zpp_$nape_phys_ZPP_$Interactor;
zpp_$nape_phys_ZPP_$Body.prototype = $extend(zpp_$nape_phys_ZPP_$Interactor.prototype,{
	invalidate_type: function() {
		this.invalidate_mass();
		this.invalidate_inertia();
	}
	,invalidate_shapes: function() {
		this.zip_aabb = true;
		this.zip_localCOM = true;
		this.zip_worldCOM = true;
		this.invalidate_mass();
		this.invalidate_inertia();
	}
	,connectedBodies_cont: function(b) {
		if(zpp_$nape_phys_ZPP_$Body.bodyset.try_insert_bool(b.zpp_inner)) {
			zpp_$nape_phys_ZPP_$Body.bodystack.add(b.zpp_inner);
			b.zpp_inner.graph_depth = zpp_$nape_phys_ZPP_$Body.cur_graph_depth + 1;
		}
	}
	,connectedBodies: function(depth,output) {
		var _gthis = this;
		if(zpp_$nape_phys_ZPP_$Body.bodyset == null) {
			zpp_$nape_phys_ZPP_$Body.bodyset = new zpp_$nape_util_ZPP_$Set_$ZPP_$Body();
			zpp_$nape_phys_ZPP_$Body.bodyset.lt = zpp_$nape_phys_ZPP_$Body.bodysetlt;
			zpp_$nape_phys_ZPP_$Body.bodystack = new zpp_$nape_util_ZNPList_$ZPP_$Body();
		}
		var ret = output == null ? new nape_phys_BodyList() : output;
		zpp_$nape_phys_ZPP_$Body.bodystack.add(this);
		zpp_$nape_phys_ZPP_$Body.bodyset.insert(this);
		this.graph_depth = 0;
		while(zpp_$nape_phys_ZPP_$Body.bodystack.head != null) {
			var cur = zpp_$nape_phys_ZPP_$Body.bodystack.pop_unsafe();
			if(cur.graph_depth == depth) {
				continue;
			}
			zpp_$nape_phys_ZPP_$Body.cur_graph_depth = cur.graph_depth;
			var cx_ite = cur.constraints.head;
			while(cx_ite != null) {
				var c = cx_ite.elt;
				c.outer.visitBodies($bind(this,this.connectedBodies_cont));
				cx_ite = cx_ite.next;
			}
		}
		var _this = zpp_$nape_phys_ZPP_$Body.bodyset;
		if(_this.parent != null) {
			var cur = _this.parent;
			while(cur != null) if(cur.prev != null) {
				cur = cur.prev;
			} else if(cur.next != null) {
				cur = cur.next;
			} else {
				var b = cur.data;
				if(b != _gthis) {
					var obj = b.outer;
					if(ret.zpp_inner.reverse_flag) {
						ret.push(obj);
					} else {
						ret.unshift(obj);
					}
				}
				var ret1 = cur.parent;
				if(ret1 != null) {
					if(cur == ret1.prev) {
						ret1.prev = null;
					} else {
						ret1.next = null;
					}
					cur.parent = null;
				}
				var o = cur;
				o.data = null;
				o.lt = null;
				o.swapped = null;
				o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = o;
				cur = ret1;
			}
			_this.parent = null;
		}
		return ret;
	}
	,interactingBodies: function(arbiter_type,depth,output) {
		var _gthis = this;
		if(zpp_$nape_phys_ZPP_$Body.bodyset == null) {
			zpp_$nape_phys_ZPP_$Body.bodyset = new zpp_$nape_util_ZPP_$Set_$ZPP_$Body();
			zpp_$nape_phys_ZPP_$Body.bodyset.lt = zpp_$nape_phys_ZPP_$Body.bodysetlt;
			zpp_$nape_phys_ZPP_$Body.bodystack = new zpp_$nape_util_ZNPList_$ZPP_$Body();
		}
		var ret = output == null ? new nape_phys_BodyList() : output;
		zpp_$nape_phys_ZPP_$Body.bodyset.insert(this);
		zpp_$nape_phys_ZPP_$Body.bodystack.add(this);
		this.graph_depth = 0;
		while(zpp_$nape_phys_ZPP_$Body.bodystack.head != null) {
			var cur = zpp_$nape_phys_ZPP_$Body.bodystack.pop_unsafe();
			if(cur.graph_depth == depth) {
				continue;
			}
			var cx_ite = cur.arbiters.head;
			while(cx_ite != null) {
				var arb = cx_ite.elt;
				if((arb.type & arbiter_type) != 0) {
					var other = arb.b1 == cur ? arb.b2 : arb.b1;
					if(zpp_$nape_phys_ZPP_$Body.bodyset.try_insert_bool(other)) {
						zpp_$nape_phys_ZPP_$Body.bodystack.add(other);
						other.graph_depth = cur.graph_depth + 1;
					}
				}
				cx_ite = cx_ite.next;
			}
		}
		var _this = zpp_$nape_phys_ZPP_$Body.bodyset;
		if(_this.parent != null) {
			var cur = _this.parent;
			while(cur != null) if(cur.prev != null) {
				cur = cur.prev;
			} else if(cur.next != null) {
				cur = cur.next;
			} else {
				var b = cur.data;
				if(b != _gthis) {
					var obj = b.outer;
					if(ret.zpp_inner.reverse_flag) {
						ret.push(obj);
					} else {
						ret.unshift(obj);
					}
				}
				var ret1 = cur.parent;
				if(ret1 != null) {
					if(cur == ret1.prev) {
						ret1.prev = null;
					} else {
						ret1.next = null;
					}
					cur.parent = null;
				}
				var o = cur;
				o.data = null;
				o.lt = null;
				o.swapped = null;
				o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = o;
				cur = ret1;
			}
			_this.parent = null;
		}
		return ret;
	}
	,atRest: function(dt) {
		if(this.type != 2) {
			return this.component.sleeping;
		} else {
			var linSq = nape_Config.linearSleepThreshold;
			linSq *= linSq;
			var cansleep;
			if(this.velx * this.velx + this.vely * this.vely > linSq) {
				cansleep = false;
			} else {
				var dx = 0.0;
				var dy = 0.0;
				dx = this.posx - this.pre_posx;
				dy = this.posy - this.pre_posy;
				if(dx * dx + dy * dy > 0.25 * linSq * dt * dt) {
					cansleep = false;
				} else {
					var dx = 0.0;
					var dy = 0.0;
					dx = this.aabb.maxx - this.aabb.minx;
					dy = this.aabb.maxy - this.aabb.miny;
					var idl = dx * dx + dy * dy;
					var angSq = nape_Config.angularSleepThreshold;
					angSq *= angSq;
					if(4 * this.angvel * this.angvel * idl > angSq) {
						cansleep = false;
					} else {
						var dr = this.rot - this.pre_rot;
						cansleep = dr * dr * idl > angSq * dt * dt ? false : true;
					}
				}
			}
			if(!cansleep) {
				this.component.waket = this.space.stamp;
			}
			return this.component.waket + nape_Config.sleepDelay < this.space.stamp;
		}
	}
	,refreshArbiters: function() {
		var cx_ite = this.arbiters.head;
		while(cx_ite != null) {
			var arb = cx_ite.elt;
			arb.invalidated = true;
			cx_ite = cx_ite.next;
		}
	}
	,pos_invalidate: function(pos) {
		this.immutable_midstep("Body::position");
		if(!(this.posx == pos.x && this.posy == pos.y)) {
			this.posx = pos.x;
			this.posy = pos.y;
			var cx_ite = this.shapes.head;
			while(cx_ite != null) {
				var s = cx_ite.elt;
				if(s.type == 1) {
					s.polygon.invalidate_gverts();
					s.polygon.invalidate_gaxi();
				}
				s.invalidate_worldCOM();
				cx_ite = cx_ite.next;
			}
			this.zip_worldCOM = true;
			this.wake();
		}
	}
	,pos_validate: function() {
		this.wrap_pos.zpp_inner.x = this.posx;
		this.wrap_pos.zpp_inner.y = this.posy;
	}
	,vel_invalidate: function(vel) {
		this.velx = vel.x;
		this.vely = vel.y;
		this.wake();
	}
	,vel_validate: function() {
		this.wrap_vel.zpp_inner.x = this.velx;
		this.wrap_vel.zpp_inner.y = this.vely;
	}
	,kinvel_invalidate: function(vel) {
		this.kinvelx = vel.x;
		this.kinvely = vel.y;
		this.wake();
	}
	,kinvel_validate: function() {
		this.wrap_kinvel.zpp_inner.x = this.kinvelx;
		this.wrap_kinvel.zpp_inner.y = this.kinvely;
	}
	,svel_invalidate: function(vel) {
		this.svelx = vel.x;
		this.svely = vel.y;
		this.wake();
	}
	,svel_validate: function() {
		this.wrap_svel.zpp_inner.x = this.svelx;
		this.wrap_svel.zpp_inner.y = this.svely;
	}
	,force_invalidate: function(force) {
		this.forcex = force.x;
		this.forcey = force.y;
		this.wake();
	}
	,force_validate: function() {
		this.wrap_force.zpp_inner.x = this.forcex;
		this.wrap_force.zpp_inner.y = this.forcey;
	}
	,setupPosition: function() {
		var x = this.posx;
		var y = this.posy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_pos = ret;
		this.wrap_pos.zpp_inner._inuse = true;
		if(this.world) {
			this.wrap_pos.zpp_inner._immutable = true;
		} else {
			this.wrap_pos.zpp_inner._invalidate = $bind(this,this.pos_invalidate);
			this.wrap_pos.zpp_inner._validate = $bind(this,this.pos_validate);
		}
	}
	,setupVelocity: function() {
		var x = this.velx;
		var y = this.vely;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_vel = ret;
		this.wrap_vel.zpp_inner._inuse = true;
		if(this.world) {
			this.wrap_vel.zpp_inner._immutable = true;
		} else {
			this.wrap_vel.zpp_inner._invalidate = $bind(this,this.vel_invalidate);
			this.wrap_vel.zpp_inner._validate = $bind(this,this.vel_validate);
		}
	}
	,setupkinvel: function() {
		var x = this.kinvelx;
		var y = this.kinvely;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_kinvel = ret;
		this.wrap_kinvel.zpp_inner._inuse = true;
		if(this.world) {
			this.wrap_kinvel.zpp_inner._immutable = true;
		} else {
			this.wrap_kinvel.zpp_inner._invalidate = $bind(this,this.kinvel_invalidate);
			this.wrap_kinvel.zpp_inner._validate = $bind(this,this.kinvel_validate);
		}
	}
	,setupsvel: function() {
		var x = this.svelx;
		var y = this.svely;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_svel = ret;
		this.wrap_svel.zpp_inner._inuse = true;
		if(this.world) {
			this.wrap_svel.zpp_inner._immutable = true;
		} else {
			this.wrap_svel.zpp_inner._invalidate = $bind(this,this.svel_invalidate);
			this.wrap_svel.zpp_inner._validate = $bind(this,this.svel_validate);
		}
	}
	,setupForce: function() {
		var x = this.forcex;
		var y = this.forcey;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_force = ret;
		this.wrap_force.zpp_inner._inuse = true;
		if(this.world) {
			this.wrap_force.zpp_inner._immutable = true;
		} else {
			this.wrap_force.zpp_inner._invalidate = $bind(this,this.force_invalidate);
			this.wrap_force.zpp_inner._validate = $bind(this,this.force_validate);
		}
	}
	,cvel_validate: function() {
		this.wrapcvel.zpp_inner.x = this.velx + this.kinvelx;
		this.wrapcvel.zpp_inner.y = this.vely + this.kinvely;
		this.wrapcvel.zpp_inner.z = this.angvel + this.kinangvel;
	}
	,setup_cvel: function() {
		var me = this;
		this.wrapcvel = nape_geom_Vec3.get();
		this.wrapcvel.zpp_inner.immutable = true;
		this.wrapcvel.zpp_inner._validate = $bind(this,this.cvel_validate);
	}
	,invalidate_mass: function() {
		this.zip_mass = true;
		this.invalidate_gravMass();
	}
	,validate_mass: function() {
		var exist = false;
		if(this.zip_mass || this.massMode == 0 && exist) {
			this.zip_mass = false;
			if(this.massMode == 0) {
				this.cmass = 0;
				var cx_ite = this.shapes.head;
				while(cx_ite != null) {
					var s = cx_ite.elt;
					s.refmaterial.density = s.material.density;
					s.validate_area_inertia();
					this.cmass += s.area * s.material.density;
					cx_ite = cx_ite.next;
				}
			}
			if(this.type == 2 && !this.nomove) {
				this.mass = this.cmass;
				this.imass = this.smass = 1.0 / this.mass;
			} else {
				this.mass = Infinity;
				this.imass = this.smass = 0.0;
			}
			if(exist) {
				this.invalidate_inertia();
			}
		}
	}
	,invalidate_gravMass: function() {
		if(this.gravMassMode != 1) {
			this.zip_gravMass = true;
		}
		if(this.gravMassMode != 2) {
			this.zip_gravMassScale = true;
		}
		this.wake();
	}
	,validate_gravMass: function() {
		if(this.zip_gravMass) {
			this.zip_gravMass = false;
			this.validate_mass();
			if(this.gravMassMode == 0) {
				this.validate_mass();
				this.gravMass = this.cmass;
			} else if(this.gravMassMode == 2) {
				this.validate_mass();
				this.gravMass = this.cmass * this.gravMassScale;
			}
		}
	}
	,invalidate_gravMassScale: function() {
		if(this.gravMassMode != 2) {
			this.zip_gravMassScale = true;
		} else {
			this.invalidate_gravMass();
		}
	}
	,validate_gravMassScale: function() {
		if(this.zip_gravMassScale) {
			this.zip_gravMassScale = false;
			if(this.gravMassMode == 0) {
				this.gravMassScale = 1.0;
			} else if(this.gravMassMode == 1) {
				this.validate_mass();
				this.gravMassScale = this.gravMass / this.cmass;
			}
		}
	}
	,invalidate_inertia: function() {
		this.zip_inertia = true;
		this.wake();
	}
	,validate_inertia: function() {
		var exist = false;
		if(this.zip_inertia || this.inertiaMode == 0 && exist) {
			this.zip_inertia = false;
			if(this.inertiaMode == 0) {
				this.cinertia = 0;
				var cx_ite = this.shapes.head;
				while(cx_ite != null) {
					var s = cx_ite.elt;
					s.refmaterial.density = s.material.density;
					s.validate_area_inertia();
					this.cinertia += s.inertia * s.area * s.material.density;
					cx_ite = cx_ite.next;
				}
			}
			if(this.type == 2 && !this.norotate) {
				this.inertia = this.cinertia;
				this.sinertia = this.iinertia = 1.0 / this.inertia;
			} else {
				this.inertia = Infinity;
				this.sinertia = this.iinertia = 0;
			}
			if(exist) {
				this.invalidate_inertia();
			}
		}
	}
	,validate_localCOM: function() {
		if(this.zip_localCOM) {
			this.zip_localCOM = false;
			var tempx = 0;
			var tempy = 0;
			var msum = 0.0;
			var cx_ite = this.shapes.head;
			while(cx_ite != null) {
				var s = cx_ite.elt;
				if(s.zip_localCOM) {
					s.zip_localCOM = false;
					if(s.type == 1) {
						var _this = s.polygon;
						if(_this.lverts.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
						} else if(_this.lverts.next.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
							var t = 1.0;
							_this.localCOMx += _this.lverts.next.next.x * t;
							_this.localCOMy += _this.lverts.next.next.y * t;
							var t1 = 0.5;
							_this.localCOMx *= t1;
							_this.localCOMy *= t1;
						} else {
							_this.localCOMx = 0;
							_this.localCOMy = 0;
							var area = 0.0;
							var cx_ite1 = _this.lverts.next;
							var u = cx_ite1;
							cx_ite1 = cx_ite1.next;
							var v = cx_ite1;
							cx_ite1 = cx_ite1.next;
							while(cx_ite1 != null) {
								var w = cx_ite1;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this.localCOMx += (v.x + w.x) * cf;
								_this.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite1 = cx_ite1.next;
							}
							cx_ite1 = _this.lverts.next;
							var w1 = cx_ite1;
							area += v.x * (w1.y - u.y);
							var cf1 = w1.y * v.x - w1.x * v.y;
							_this.localCOMx += (v.x + w1.x) * cf1;
							_this.localCOMy += (v.y + w1.y) * cf1;
							u = v;
							v = w1;
							cx_ite1 = cx_ite1.next;
							var w2 = cx_ite1;
							area += v.x * (w2.y - u.y);
							var cf2 = w2.y * v.x - w2.x * v.y;
							_this.localCOMx += (v.x + w2.x) * cf2;
							_this.localCOMy += (v.y + w2.y) * cf2;
							area = 1 / (3 * area);
							var t2 = area;
							_this.localCOMx *= t2;
							_this.localCOMy *= t2;
						}
					}
					if(s.wrap_localCOM != null) {
						s.wrap_localCOM.zpp_inner.x = s.localCOMx;
						s.wrap_localCOM.zpp_inner.y = s.localCOMy;
					}
				}
				s.validate_area_inertia();
				var t3 = s.area * s.material.density;
				tempx += s.localCOMx * t3;
				tempy += s.localCOMy * t3;
				msum += s.area * s.material.density;
				cx_ite = cx_ite.next;
			}
			if(msum != 0) {
				var t = 1.0 / msum;
				this.localCOMx = tempx * t;
				this.localCOMy = tempy * t;
			}
			if(this.wrap_localCOM != null) {
				this.wrap_localCOM.zpp_inner.x = this.localCOMx;
				this.wrap_localCOM.zpp_inner.y = this.localCOMy;
			}
			if(this.zip_mass && this.massMode == 0) {
				this.zip_mass = false;
				this.cmass = msum;
				if(this.type == 2) {
					this.mass = this.cmass;
					this.imass = this.smass = 1.0 / this.mass;
				} else {
					this.mass = Infinity;
					this.imass = this.smass = 0.0;
				}
			}
		}
	}
	,validate_worldCOM: function() {
		if(this.zip_worldCOM) {
			this.zip_worldCOM = false;
			this.validate_localCOM();
			if(this.zip_axis) {
				this.zip_axis = false;
				this.axisx = Math.sin(this.rot);
				this.axisy = Math.cos(this.rot);
			}
			this.worldCOMx = this.posx + (this.axisy * this.localCOMx - this.axisx * this.localCOMy);
			this.worldCOMy = this.posy + (this.localCOMx * this.axisx + this.localCOMy * this.axisy);
			if(this.wrap_worldCOM != null) {
				this.wrap_worldCOM.zpp_inner.x = this.worldCOMx;
				this.wrap_worldCOM.zpp_inner.y = this.worldCOMy;
			}
		}
	}
	,getlocalCOM: function() {
		this.validate_localCOM();
	}
	,getworldCOM: function() {
		this.validate_worldCOM();
	}
	,aabb_validate: function() {
		if(this.zip_aabb) {
			this.zip_aabb = false;
			this.aabb.minx = Infinity;
			this.aabb.miny = Infinity;
			this.aabb.maxx = -Infinity;
			this.aabb.maxy = -Infinity;
			var cx_ite = this.shapes.head;
			while(cx_ite != null) {
				var s = cx_ite.elt;
				if(s.zip_aabb) {
					if(s.body != null) {
						s.zip_aabb = false;
						if(s.type == 0) {
							var _this = s.circle;
							if(_this.zip_worldCOM) {
								if(_this.body != null) {
									_this.zip_worldCOM = false;
									if(_this.zip_localCOM) {
										_this.zip_localCOM = false;
										if(_this.type == 1) {
											var _this1 = _this.polygon;
											if(_this1.lverts.next.next == null) {
												_this1.localCOMx = _this1.lverts.next.x;
												_this1.localCOMy = _this1.lverts.next.y;
											} else if(_this1.lverts.next.next.next == null) {
												_this1.localCOMx = _this1.lverts.next.x;
												_this1.localCOMy = _this1.lverts.next.y;
												var t = 1.0;
												_this1.localCOMx += _this1.lverts.next.next.x * t;
												_this1.localCOMy += _this1.lverts.next.next.y * t;
												var t1 = 0.5;
												_this1.localCOMx *= t1;
												_this1.localCOMy *= t1;
											} else {
												_this1.localCOMx = 0;
												_this1.localCOMy = 0;
												var area = 0.0;
												var cx_ite1 = _this1.lverts.next;
												var u = cx_ite1;
												cx_ite1 = cx_ite1.next;
												var v = cx_ite1;
												cx_ite1 = cx_ite1.next;
												while(cx_ite1 != null) {
													var w = cx_ite1;
													area += v.x * (w.y - u.y);
													var cf = w.y * v.x - w.x * v.y;
													_this1.localCOMx += (v.x + w.x) * cf;
													_this1.localCOMy += (v.y + w.y) * cf;
													u = v;
													v = w;
													cx_ite1 = cx_ite1.next;
												}
												cx_ite1 = _this1.lverts.next;
												var w1 = cx_ite1;
												area += v.x * (w1.y - u.y);
												var cf1 = w1.y * v.x - w1.x * v.y;
												_this1.localCOMx += (v.x + w1.x) * cf1;
												_this1.localCOMy += (v.y + w1.y) * cf1;
												u = v;
												v = w1;
												cx_ite1 = cx_ite1.next;
												var w2 = cx_ite1;
												area += v.x * (w2.y - u.y);
												var cf2 = w2.y * v.x - w2.x * v.y;
												_this1.localCOMx += (v.x + w2.x) * cf2;
												_this1.localCOMy += (v.y + w2.y) * cf2;
												area = 1 / (3 * area);
												var t2 = area;
												_this1.localCOMx *= t2;
												_this1.localCOMy *= t2;
											}
										}
										if(_this.wrap_localCOM != null) {
											_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
											_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
										}
									}
									var _this2 = _this.body;
									if(_this2.zip_axis) {
										_this2.zip_axis = false;
										_this2.axisx = Math.sin(_this2.rot);
										_this2.axisy = Math.cos(_this2.rot);
									}
									_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
									_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
								}
							}
							var rx = _this.radius;
							var ry = _this.radius;
							_this.aabb.minx = _this.worldCOMx - rx;
							_this.aabb.miny = _this.worldCOMy - ry;
							_this.aabb.maxx = _this.worldCOMx + rx;
							_this.aabb.maxy = _this.worldCOMy + ry;
						} else {
							var _this3 = s.polygon;
							if(_this3.zip_gverts) {
								if(_this3.body != null) {
									_this3.zip_gverts = false;
									_this3.validate_lverts();
									var _this4 = _this3.body;
									if(_this4.zip_axis) {
										_this4.zip_axis = false;
										_this4.axisx = Math.sin(_this4.rot);
										_this4.axisy = Math.cos(_this4.rot);
									}
									var li = _this3.lverts.next;
									var cx_ite2 = _this3.gverts.next;
									while(cx_ite2 != null) {
										var g = cx_ite2;
										var l = li;
										li = li.next;
										g.x = _this3.body.posx + (_this3.body.axisy * l.x - _this3.body.axisx * l.y);
										g.y = _this3.body.posy + (l.x * _this3.body.axisx + l.y * _this3.body.axisy);
										cx_ite2 = cx_ite2.next;
									}
								}
							}
							var p0 = _this3.gverts.next;
							_this3.aabb.minx = p0.x;
							_this3.aabb.miny = p0.y;
							_this3.aabb.maxx = p0.x;
							_this3.aabb.maxy = p0.y;
							var cx_ite3 = _this3.gverts.next.next;
							while(cx_ite3 != null) {
								var p = cx_ite3;
								if(p.x < _this3.aabb.minx) {
									_this3.aabb.minx = p.x;
								}
								if(p.x > _this3.aabb.maxx) {
									_this3.aabb.maxx = p.x;
								}
								if(p.y < _this3.aabb.miny) {
									_this3.aabb.miny = p.y;
								}
								if(p.y > _this3.aabb.maxy) {
									_this3.aabb.maxy = p.y;
								}
								cx_ite3 = cx_ite3.next;
							}
						}
					}
				}
				var _this5 = this.aabb;
				var x = s.aabb;
				if(x.minx < _this5.minx) {
					_this5.minx = x.minx;
				}
				if(x.maxx > _this5.maxx) {
					_this5.maxx = x.maxx;
				}
				if(x.miny < _this5.miny) {
					_this5.miny = x.miny;
				}
				if(x.maxy > _this5.maxy) {
					_this5.maxy = x.maxy;
				}
				cx_ite = cx_ite.next;
			}
		}
	}
	,shapes_adder: function(s) {
		if(s.zpp_inner.body != this) {
			if(s.zpp_inner.body != null) {
				s.zpp_inner.body.wrap_shapes.remove(s);
			}
			s.zpp_inner.body = this;
			s.zpp_inner.addedToBody();
			if(this.space != null) {
				var _this = this.space;
				var s1 = s.zpp_inner;
				var o = s1.body;
				if(!o.world) {
					o.component.waket = _this.stamp + (_this.midstep ? 0 : 1);
					if(o.type == 3) {
						o.kinematicDelaySleep = true;
					}
					if(o.component.sleeping) {
						_this.really_wake(o,false);
					}
				}
				_this.bphase.insert(s1);
				s1.addedToSpace();
			}
			if(s.zpp_inner.type == 1) {
				s.zpp_inner.polygon.invalidate_gaxi();
				s.zpp_inner.polygon.invalidate_gverts();
			}
			return true;
		} else {
			return false;
		}
	}
	,shapes_subber: function(s) {
		if(this.space != null) {
			this.space.removed_shape(s.zpp_inner);
		}
		s.zpp_inner.body = null;
		s.zpp_inner.removedFromBody();
	}
	,shapes_invalidate: function(_) {
		this.invalidate_shapes();
	}
	,addedToSpace: function() {
		if(zpp_$nape_space_ZPP_$Component.zpp_pool == null) {
			this.component = new zpp_$nape_space_ZPP_$Component();
		} else {
			this.component = zpp_$nape_space_ZPP_$Component.zpp_pool;
			zpp_$nape_space_ZPP_$Component.zpp_pool = this.component.next;
			this.component.next = null;
		}
		this.component.isBody = true;
		this.component.body = this;
		this.__iaddedToSpace();
	}
	,removedFromSpace: function() {
		while(this.arbiters.head != null) {
			var arb = this.arbiters.pop_unsafe();
			var s = this.space;
			arb.cleared = true;
			if(arb.b2 == this) {
				var _this = arb.b1.arbiters;
				var pre = null;
				var cur = _this.head;
				var ret = false;
				while(cur != null) {
					if(cur.elt == arb) {
						var old;
						var ret1;
						if(pre == null) {
							old = _this.head;
							ret1 = old.next;
							_this.head = ret1;
							if(_this.head == null) {
								_this.pushmod = true;
							}
						} else {
							old = pre.next;
							ret1 = old.next;
							pre.next = ret1;
							if(ret1 == null) {
								_this.pushmod = true;
							}
						}
						var o = old;
						o.elt = null;
						o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
						_this.modified = true;
						_this.length--;
						_this.pushmod = true;
						ret = true;
						break;
					}
					pre = cur;
					cur = cur.next;
				}
			}
			if(arb.b1 == this) {
				var _this1 = arb.b2.arbiters;
				var pre1 = null;
				var cur1 = _this1.head;
				var ret2 = false;
				while(cur1 != null) {
					if(cur1.elt == arb) {
						var old1;
						var ret3;
						if(pre1 == null) {
							old1 = _this1.head;
							ret3 = old1.next;
							_this1.head = ret3;
							if(_this1.head == null) {
								_this1.pushmod = true;
							}
						} else {
							old1 = pre1.next;
							ret3 = old1.next;
							pre1.next = ret3;
							if(ret3 == null) {
								_this1.pushmod = true;
							}
						}
						var o1 = old1;
						o1.elt = null;
						o1.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o1;
						_this1.modified = true;
						_this1.length--;
						_this1.pushmod = true;
						ret2 = true;
						break;
					}
					pre1 = cur1;
					cur1 = cur1.next;
				}
			}
			if(arb.pair != null) {
				arb.pair.arb = null;
				arb.pair = null;
			}
			arb.active = false;
			s.f_arbiters.modified = true;
		}
		var o = this.component;
		o.body = null;
		o.constraint = null;
		o.next = zpp_$nape_space_ZPP_$Component.zpp_pool;
		zpp_$nape_space_ZPP_$Component.zpp_pool = o;
		this.component = null;
		this.__iremovedFromSpace();
	}
	,copy: function() {
		var ret = new nape_phys_Body().zpp_inner;
		ret.type = this.type;
		ret.bulletEnabled = this.bulletEnabled;
		ret.disableCCD = this.disableCCD;
		var cx_ite = this.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			var _this = ret.outer.zpp_inner.wrap_shapes;
			var obj = s.outer.copy();
			if(_this.zpp_inner.reverse_flag) {
				_this.push(obj);
			} else {
				_this.unshift(obj);
			}
			cx_ite = cx_ite.next;
		}
		ret.posx = this.posx;
		ret.posy = this.posy;
		ret.velx = this.velx;
		ret.vely = this.vely;
		ret.forcex = this.forcex;
		ret.forcey = this.forcey;
		ret.rot = this.rot;
		ret.angvel = this.angvel;
		ret.torque = this.torque;
		ret.kinvelx = this.kinvelx;
		ret.kinvely = this.kinvely;
		ret.kinangvel = this.kinangvel;
		ret.svelx = this.svelx;
		ret.svely = this.svely;
		if(!this.zip_axis) {
			ret.axisx = this.axisx;
			ret.axisy = this.axisy;
		} else {
			ret.zip_axis = true;
			var cx_ite = ret.shapes.head;
			while(cx_ite != null) {
				var s = cx_ite.elt;
				if(s.type == 1) {
					s.polygon.invalidate_gverts();
					s.polygon.invalidate_gaxi();
				}
				s.invalidate_worldCOM();
				cx_ite = cx_ite.next;
			}
			ret.zip_worldCOM = true;
		}
		ret.rot = this.rot;
		ret.massMode = this.massMode;
		ret.gravMassMode = this.gravMassMode;
		ret.inertiaMode = this.inertiaMode;
		ret.norotate = this.norotate;
		ret.nomove = this.nomove;
		ret.cmass = this.cmass;
		ret.cinertia = this.cinertia;
		if(!this.zip_mass) {
			ret.mass = this.mass;
		} else {
			ret.invalidate_mass();
		}
		if(!this.zip_gravMass) {
			ret.gravMass = this.gravMass;
		} else {
			ret.invalidate_gravMass();
		}
		if(!this.zip_gravMassScale) {
			ret.gravMassScale = this.gravMassScale;
		} else {
			ret.invalidate_gravMassScale();
		}
		if(!this.zip_inertia) {
			ret.inertia = this.inertia;
		} else {
			ret.invalidate_inertia();
		}
		if(!this.zip_aabb) {
			ret.aabb.minx = this.aabb.minx;
			ret.aabb.miny = this.aabb.miny;
			ret.aabb.maxx = this.aabb.maxx;
			ret.aabb.maxy = this.aabb.maxy;
		} else {
			ret.zip_aabb = true;
		}
		if(!this.zip_localCOM) {
			ret.localCOMx = this.localCOMx;
			ret.localCOMy = this.localCOMy;
		} else {
			ret.zip_localCOM = true;
			ret.zip_worldCOM = true;
		}
		if(!this.zip_worldCOM) {
			ret.worldCOMx = this.worldCOMx;
			ret.worldCOMy = this.worldCOMy;
		} else {
			ret.zip_worldCOM = true;
		}
		this.copyto(ret.outer);
		return ret.outer;
	}
});
var zpp_$nape_phys_ZPP_$Compound = function() {
	this.space = null;
	this.compound = null;
	this.depth = 0;
	this.wrap_compounds = null;
	this.wrap_constraints = null;
	this.wrap_bodies = null;
	this.compounds = null;
	this.constraints = null;
	this.bodies = null;
	this.outer = null;
	zpp_$nape_phys_ZPP_$Interactor.call(this);
	this.icompound = this;
	this.depth = 1;
	var me = this;
	this.bodies = new zpp_$nape_util_ZNPList_$ZPP_$Body();
	this.wrap_bodies = zpp_$nape_util_ZPP_$BodyList.get(this.bodies);
	this.wrap_bodies.zpp_inner.adder = $bind(this,this.bodies_adder);
	this.wrap_bodies.zpp_inner.subber = $bind(this,this.bodies_subber);
	this.constraints = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this.wrap_constraints = zpp_$nape_util_ZPP_$ConstraintList.get(this.constraints);
	this.wrap_constraints.zpp_inner.adder = $bind(this,this.constraints_adder);
	this.wrap_constraints.zpp_inner.subber = $bind(this,this.constraints_subber);
	this.compounds = new zpp_$nape_util_ZNPList_$ZPP_$Compound();
	this.wrap_compounds = zpp_$nape_util_ZPP_$CompoundList.get(this.compounds);
	this.wrap_compounds.zpp_inner.adder = $bind(this,this.compounds_adder);
	this.wrap_compounds.zpp_inner.subber = $bind(this,this.compounds_subber);
};
zpp_$nape_phys_ZPP_$Compound.__name__ = true;
zpp_$nape_phys_ZPP_$Compound.__super__ = zpp_$nape_phys_ZPP_$Interactor;
zpp_$nape_phys_ZPP_$Compound.prototype = $extend(zpp_$nape_phys_ZPP_$Interactor.prototype,{
	__imutable_midstep: function(name) {
	}
	,addedToSpace: function() {
		this.__iaddedToSpace();
	}
	,removedFromSpace: function() {
		this.__iremovedFromSpace();
	}
	,breakApart: function() {
		if(this.space != null) {
			this.__iremovedFromSpace();
			this.space.nullInteractorType(this);
		}
		if(this.compound != null) {
			this.compound.compounds.remove(this);
		} else if(this.space != null) {
			this.space.compounds.remove(this);
		}
		while(this.bodies.head != null) {
			var b = this.bodies.pop_unsafe();
			if((b.compound = this.compound) != null) {
				this.compound.bodies.add(b);
			} else if(this.space != null) {
				this.space.bodies.add(b);
			}
			if(this.space != null) {
				this.space.freshInteractorType(b);
			}
		}
		while(this.constraints.head != null) {
			var c = this.constraints.pop_unsafe();
			if((c.compound = this.compound) != null) {
				this.compound.constraints.add(c);
			} else if(this.space != null) {
				this.space.constraints.add(c);
			}
		}
		while(this.compounds.head != null) {
			var c = this.compounds.pop_unsafe();
			if((c.compound = this.compound) != null) {
				this.compound.compounds.add(c);
			} else if(this.space != null) {
				this.space.compounds.add(c);
			}
			if(this.space != null) {
				this.space.freshInteractorType(c);
			}
		}
		this.compound = null;
		this.space = null;
	}
	,bodies_adder: function(x) {
		if(x.zpp_inner.compound != this) {
			if(x.zpp_inner.compound != null) {
				x.zpp_inner.compound.wrap_bodies.remove(x);
			} else if(x.zpp_inner.space != null) {
				x.zpp_inner.space.wrap_bodies.remove(x);
			}
			x.zpp_inner.compound = this;
			if(this.space != null) {
				this.space.addBody(x.zpp_inner);
			}
			return true;
		} else {
			return false;
		}
	}
	,bodies_subber: function(x) {
		x.zpp_inner.compound = null;
		if(this.space != null) {
			this.space.remBody(x.zpp_inner);
		}
	}
	,constraints_adder: function(x) {
		if(x.zpp_inner.compound != this) {
			if(x.zpp_inner.compound != null) {
				x.zpp_inner.compound.wrap_constraints.remove(x);
			} else if(x.zpp_inner.space != null) {
				x.zpp_inner.space.wrap_constraints.remove(x);
			}
			x.zpp_inner.compound = this;
			if(this.space != null) {
				this.space.addConstraint(x.zpp_inner);
			}
			return true;
		} else {
			return false;
		}
	}
	,constraints_subber: function(x) {
		x.zpp_inner.compound = null;
		if(this.space != null) {
			this.space.remConstraint(x.zpp_inner);
		}
	}
	,compounds_adder: function(x) {
		if(x.zpp_inner.compound != this) {
			if(x.zpp_inner.compound != null) {
				x.zpp_inner.compound.wrap_compounds.remove(x);
			} else if(x.zpp_inner.space != null) {
				x.zpp_inner.space.wrap_compounds.remove(x);
			}
			x.zpp_inner.compound = this;
			x.zpp_inner.depth = this.depth + 1;
			if(this.space != null) {
				this.space.addCompound(x.zpp_inner);
			}
			return true;
		} else {
			return false;
		}
	}
	,compounds_subber: function(x) {
		x.zpp_inner.compound = null;
		x.zpp_inner.depth = 1;
		if(this.space != null) {
			this.space.remCompound(x.zpp_inner);
		}
	}
	,copy: function(dict,todo) {
		var root = dict == null;
		if(dict == null) {
			dict = [];
		}
		if(todo == null) {
			todo = [];
		}
		var ret = new nape_phys_Compound();
		var cx_ite = this.compounds.head;
		while(cx_ite != null) {
			var c = cx_ite.elt;
			var cc = c.copy(dict,todo);
			cc.zpp_inner.immutable_midstep("Compound::compound");
			if((cc.zpp_inner.compound == null ? null : cc.zpp_inner.compound.outer) != ret) {
				if((cc.zpp_inner.compound == null ? null : cc.zpp_inner.compound.outer) != null) {
					(cc.zpp_inner.compound == null ? null : cc.zpp_inner.compound.outer).zpp_inner.wrap_compounds.remove(cc);
				}
				if(ret != null) {
					var _this = ret.zpp_inner.wrap_compounds;
					if(_this.zpp_inner.reverse_flag) {
						_this.push(cc);
					} else {
						_this.unshift(cc);
					}
				}
			}
			var tmp = cc.zpp_inner.compound == null;
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.bodies.head;
		while(cx_ite != null) {
			var b = cx_ite.elt;
			var bc = b.outer.copy();
			dict.push(zpp_$nape_constraint_ZPP_$CopyHelper.dict(b.id,bc));
			if((bc.zpp_inner.compound == null ? null : bc.zpp_inner.compound.outer) != ret) {
				if((bc.zpp_inner.compound == null ? null : bc.zpp_inner.compound.outer) != null) {
					(bc.zpp_inner.compound == null ? null : bc.zpp_inner.compound.outer).zpp_inner.wrap_bodies.remove(bc);
				}
				if(ret != null) {
					var _this = ret.zpp_inner.wrap_bodies;
					if(_this.zpp_inner.reverse_flag) {
						_this.push(bc);
					} else {
						_this.unshift(bc);
					}
				}
			}
			var tmp = bc.zpp_inner.compound == null;
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.constraints.head;
		while(cx_ite != null) {
			var c = cx_ite.elt;
			var cc = c.copy(dict,todo);
			if((cc.zpp_inner.compound == null ? null : cc.zpp_inner.compound.outer) != ret) {
				if((cc.zpp_inner.compound == null ? null : cc.zpp_inner.compound.outer) != null) {
					(cc.zpp_inner.compound == null ? null : cc.zpp_inner.compound.outer).zpp_inner.wrap_constraints.remove(cc);
				}
				if(ret != null) {
					var _this = ret.zpp_inner.wrap_constraints;
					if(_this.zpp_inner.reverse_flag) {
						_this.push(cc);
					} else {
						_this.unshift(cc);
					}
				}
			}
			var tmp = cc.zpp_inner.compound == null;
			cx_ite = cx_ite.next;
		}
		if(root) {
			while(todo.length > 0) {
				var xcb = todo.pop();
				var _g = 0;
				while(_g < dict.length) {
					var idc = dict[_g];
					++_g;
					if(idc.id == xcb.id) {
						xcb.cb(idc.bc);
						break;
					}
				}
			}
		}
		this.copyto(ret);
		return ret;
	}
});
var zpp_$nape_phys_ZPP_$FluidProperties = function() {
	this.wrap_gravity = null;
	this.gravityy = 0.0;
	this.gravityx = 0.0;
	this.density = 0.0;
	this.viscosity = 0.0;
	this.wrap_shapes = null;
	this.shapes = null;
	this.outer = null;
	this.userData = null;
	this.next = null;
	this.shapes = new zpp_$nape_util_ZNPList_$ZPP_$Shape();
	this.density = this.viscosity = 1;
	this.wrap_gravity = null;
	this.gravityx = 0;
	this.gravityy = 0;
};
zpp_$nape_phys_ZPP_$FluidProperties.__name__ = true;
zpp_$nape_phys_ZPP_$FluidProperties.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			this.outer = new nape_phys_FluidProperties();
			var o = this.outer.zpp_inner;
			o.outer = null;
			o.next = zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool;
			zpp_$nape_phys_ZPP_$FluidProperties.zpp_pool = o;
			this.outer.zpp_inner = this;
		}
		return this.outer;
	}
	,gravity_invalidate: function(x) {
		this.gravityx = x.x;
		this.gravityy = x.y;
		this.invalidate();
	}
	,gravity_validate: function() {
		this.wrap_gravity.zpp_inner.x = this.gravityx;
		this.wrap_gravity.zpp_inner.y = this.gravityy;
	}
	,getgravity: function() {
		var x = this.gravityx;
		var y = this.gravityy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_gravity = ret;
		this.wrap_gravity.zpp_inner._inuse = true;
		this.wrap_gravity.zpp_inner._invalidate = $bind(this,this.gravity_invalidate);
		this.wrap_gravity.zpp_inner._validate = $bind(this,this.gravity_validate);
	}
	,invalidate: function() {
		var cx_ite = this.shapes.head;
		while(cx_ite != null) {
			var shape = cx_ite.elt;
			shape.invalidate_fluidprops();
			cx_ite = cx_ite.next;
		}
	}
};
var zpp_$nape_phys_ZPP_$Material = function() {
	this.rollingFriction = 0.0;
	this.elasticity = 0.0;
	this.density = 0.0;
	this.staticFriction = 0.0;
	this.dynamicFriction = 0.0;
	this.wrap_shapes = null;
	this.shapes = null;
	this.outer = null;
	this.userData = null;
	this.next = null;
	this.shapes = new zpp_$nape_util_ZNPList_$ZPP_$Shape();
	this.elasticity = 0;
	this.dynamicFriction = 1;
	this.staticFriction = 2;
	this.density = 0.001;
	this.rollingFriction = 0.01;
};
zpp_$nape_phys_ZPP_$Material.__name__ = true;
zpp_$nape_phys_ZPP_$Material.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			this.outer = new nape_phys_Material();
			var o = this.outer.zpp_inner;
			o.outer = null;
			o.next = zpp_$nape_phys_ZPP_$Material.zpp_pool;
			zpp_$nape_phys_ZPP_$Material.zpp_pool = o;
			this.outer.zpp_inner = this;
		}
		return this.outer;
	}
	,set: function(x) {
		this.dynamicFriction = x.dynamicFriction;
		this.staticFriction = x.staticFriction;
		this.density = x.density;
		this.elasticity = x.elasticity;
		this.rollingFriction = x.rollingFriction;
	}
	,invalidate: function(x) {
		var cx_ite = this.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			s.invalidate_material(x);
			cx_ite = cx_ite.next;
		}
	}
};
var zpp_$nape_shape_ZPP_$Shape = function(type) {
	this.zip_aabb = false;
	this.aabb = null;
	this.pairs = null;
	this.node = null;
	this.sweep = null;
	this.sensorEnabled = false;
	this.fluidEnabled = false;
	this.fluidProperties = null;
	this.filter = null;
	this.material = null;
	this.refmaterial = null;
	this.polygon = null;
	this.circle = null;
	this.sweepCoef = 0.0;
	this.zip_sweepRadius = false;
	this.sweepRadius = 0.0;
	this.wrap_worldCOM = null;
	this.wrap_localCOM = null;
	this.zip_worldCOM = false;
	this.worldCOMy = 0.0;
	this.worldCOMx = 0.0;
	this.zip_localCOM = false;
	this.localCOMy = 0.0;
	this.localCOMx = 0.0;
	this.zip_angDrag = false;
	this.angDrag = 0.0;
	this.inertia = 0.0;
	this.zip_area_inertia = false;
	this.area = 0.0;
	this.type = 0;
	this.body = null;
	this.outer = null;
	zpp_$nape_phys_ZPP_$Interactor.call(this);
	this.pairs = new zpp_$nape_util_ZNPList_$ZPP_$AABBPair();
	this.ishape = this;
	this.type = type;
	var ret;
	if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
		ret = new zpp_$nape_geom_ZPP_$AABB();
	} else {
		ret = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.minx = 0;
	ret.miny = 0;
	ret.maxx = 0;
	ret.maxy = 0;
	this.aabb = ret;
	this.aabb._immutable = true;
	var me = this;
	this.aabb._validate = $bind(this,this.aabb_validate);
	this.zip_area_inertia = this.zip_angDrag = this.zip_localCOM = this.zip_sweepRadius = true;
	this.localCOMx = 0;
	this.localCOMy = 0;
	this.worldCOMx = 0;
	this.worldCOMy = 0;
	this.fluidEnabled = false;
	this.sensorEnabled = false;
	this.fluidProperties = null;
	this.body = null;
	this.refmaterial = new zpp_$nape_phys_ZPP_$Material();
	this.sweepRadius = this.sweepCoef = 0;
};
zpp_$nape_shape_ZPP_$Shape.__name__ = true;
zpp_$nape_shape_ZPP_$Shape.__super__ = zpp_$nape_phys_ZPP_$Interactor;
zpp_$nape_shape_ZPP_$Shape.prototype = $extend(zpp_$nape_phys_ZPP_$Interactor.prototype,{
	validate_sweepRadius: function() {
		if(this.zip_sweepRadius) {
			this.zip_sweepRadius = false;
			if(this.type == 0) {
				this.circle.__validate_sweepRadius();
			} else {
				this.polygon.__validate_sweepRadius();
			}
		}
	}
	,validate_area_inertia: function() {
		if(this.zip_area_inertia) {
			this.zip_area_inertia = false;
			if(this.type == 0) {
				this.circle.__validate_area_inertia();
			} else {
				this.polygon.__validate_area_inertia();
			}
		}
	}
	,validate_angDrag: function() {
		if(this.zip_angDrag || this.refmaterial.dynamicFriction != this.material.dynamicFriction) {
			this.zip_angDrag = false;
			this.refmaterial.dynamicFriction = this.material.dynamicFriction;
			if(this.type == 0) {
				this.circle.__validate_angDrag();
			} else {
				this.polygon.__validate_angDrag();
			}
		}
	}
	,getworldCOM: function() {
		if(this.zip_worldCOM) {
			if(this.body != null) {
				this.zip_worldCOM = false;
				if(this.zip_localCOM) {
					this.zip_localCOM = false;
					if(this.type == 1) {
						var _this = this.polygon;
						if(_this.lverts.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
						} else if(_this.lverts.next.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
							var t = 1.0;
							_this.localCOMx += _this.lverts.next.next.x * t;
							_this.localCOMy += _this.lverts.next.next.y * t;
							var t = 0.5;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						} else {
							_this.localCOMx = 0;
							_this.localCOMy = 0;
							var area = 0.0;
							var cx_ite = _this.lverts.next;
							var u = cx_ite;
							cx_ite = cx_ite.next;
							var v = cx_ite;
							cx_ite = cx_ite.next;
							while(cx_ite != null) {
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this.localCOMx += (v.x + w.x) * cf;
								_this.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite = cx_ite.next;
							}
							cx_ite = _this.lverts.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							u = v;
							v = w;
							cx_ite = cx_ite.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							area = 1 / (3 * area);
							var t = area;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						}
					}
					if(this.wrap_localCOM != null) {
						this.wrap_localCOM.zpp_inner.x = this.localCOMx;
						this.wrap_localCOM.zpp_inner.y = this.localCOMy;
					}
				}
				var _this = this.body;
				if(_this.zip_axis) {
					_this.zip_axis = false;
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				}
				this.worldCOMx = this.body.posx + (this.body.axisy * this.localCOMx - this.body.axisx * this.localCOMy);
				this.worldCOMy = this.body.posy + (this.localCOMx * this.body.axisx + this.localCOMy * this.body.axisy);
			}
		}
		this.wrap_worldCOM.zpp_inner.x = this.worldCOMx;
		this.wrap_worldCOM.zpp_inner.y = this.worldCOMy;
	}
	,invalidate_area_inertia: function() {
		this.zip_area_inertia = true;
		if(this.body != null) {
			var _this = this.body;
			_this.zip_localCOM = true;
			_this.zip_worldCOM = true;
			this.body.invalidate_mass();
			this.body.invalidate_inertia();
		}
	}
	,invalidate_angDrag: function() {
		this.zip_angDrag = true;
	}
	,invalidate_localCOM: function() {
		this.zip_localCOM = true;
		this.invalidate_area_inertia();
		if(this.type == 0) {
			this.zip_sweepRadius = true;
		}
		this.invalidate_angDrag();
		this.invalidate_worldCOM();
		if(this.body != null) {
			var _this = this.body;
			_this.zip_localCOM = true;
			_this.zip_worldCOM = true;
		}
	}
	,invalidate_worldCOM: function() {
		this.zip_worldCOM = true;
		this.zip_aabb = true;
		if(this.body != null) {
			this.body.zip_aabb = true;
		}
	}
	,invalidate_material: function(flags) {
		if((flags & zpp_$nape_phys_ZPP_$Material.WAKE) != 0) {
			this.wake();
		}
		if((flags & zpp_$nape_phys_ZPP_$Material.ARBITERS) != 0) {
			if(this.body != null) {
				this.body.refreshArbiters();
			}
		}
		if((flags & zpp_$nape_phys_ZPP_$Material.PROPS) != 0) {
			if(this.body != null) {
				var _this = this.body;
				_this.zip_localCOM = true;
				_this.zip_worldCOM = true;
				this.body.invalidate_mass();
				this.body.invalidate_inertia();
			}
		}
		if((flags & zpp_$nape_phys_ZPP_$Material.ANGDRAG) != 0) {
			this.invalidate_angDrag();
		}
		this.refmaterial.set(this.material);
	}
	,invalidate_filter: function() {
		this.wake();
	}
	,invalidate_fluidprops: function() {
		if(this.fluidEnabled) {
			this.wake();
		}
	}
	,aabb_validate: function() {
		if(this.zip_aabb) {
			if(this.body != null) {
				this.zip_aabb = false;
				if(this.type == 0) {
					var _this = this.circle;
					if(_this.zip_worldCOM) {
						if(_this.body != null) {
							_this.zip_worldCOM = false;
							if(_this.zip_localCOM) {
								_this.zip_localCOM = false;
								if(_this.type == 1) {
									var _this1 = _this.polygon;
									if(_this1.lverts.next.next == null) {
										_this1.localCOMx = _this1.lverts.next.x;
										_this1.localCOMy = _this1.lverts.next.y;
									} else if(_this1.lverts.next.next.next == null) {
										_this1.localCOMx = _this1.lverts.next.x;
										_this1.localCOMy = _this1.lverts.next.y;
										var t = 1.0;
										_this1.localCOMx += _this1.lverts.next.next.x * t;
										_this1.localCOMy += _this1.lverts.next.next.y * t;
										var t = 0.5;
										_this1.localCOMx *= t;
										_this1.localCOMy *= t;
									} else {
										_this1.localCOMx = 0;
										_this1.localCOMy = 0;
										var area = 0.0;
										var cx_ite = _this1.lverts.next;
										var u = cx_ite;
										cx_ite = cx_ite.next;
										var v = cx_ite;
										cx_ite = cx_ite.next;
										while(cx_ite != null) {
											var w = cx_ite;
											area += v.x * (w.y - u.y);
											var cf = w.y * v.x - w.x * v.y;
											_this1.localCOMx += (v.x + w.x) * cf;
											_this1.localCOMy += (v.y + w.y) * cf;
											u = v;
											v = w;
											cx_ite = cx_ite.next;
										}
										cx_ite = _this1.lverts.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										area = 1 / (3 * area);
										var t = area;
										_this1.localCOMx *= t;
										_this1.localCOMy *= t;
									}
								}
								if(_this.wrap_localCOM != null) {
									_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
									_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
								}
							}
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
							_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
						}
					}
					var rx = _this.radius;
					var ry = _this.radius;
					_this.aabb.minx = _this.worldCOMx - rx;
					_this.aabb.miny = _this.worldCOMy - ry;
					_this.aabb.maxx = _this.worldCOMx + rx;
					_this.aabb.maxy = _this.worldCOMy + ry;
				} else {
					var _this = this.polygon;
					if(_this.zip_gverts) {
						if(_this.body != null) {
							_this.zip_gverts = false;
							_this.validate_lverts();
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							var li = _this.lverts.next;
							var cx_ite = _this.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
								g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var p0 = _this.gverts.next;
					_this.aabb.minx = p0.x;
					_this.aabb.miny = p0.y;
					_this.aabb.maxx = p0.x;
					_this.aabb.maxy = p0.y;
					var cx_ite = _this.gverts.next.next;
					while(cx_ite != null) {
						var p = cx_ite;
						if(p.x < _this.aabb.minx) {
							_this.aabb.minx = p.x;
						}
						if(p.x > _this.aabb.maxx) {
							_this.aabb.maxx = p.x;
						}
						if(p.y < _this.aabb.miny) {
							_this.aabb.miny = p.y;
						}
						if(p.y > _this.aabb.maxy) {
							_this.aabb.maxy = p.y;
						}
						cx_ite = cx_ite.next;
					}
				}
			}
		}
	}
	,setMaterial: function(material) {
		if(this.material != material) {
			if(this.body != null && this.body.space != null) {
				if(this.material != null) {
					this.material.shapes.remove(this);
				}
			}
			this.material = material;
			if(this.body != null && this.body.space != null) {
				material.shapes.add(this);
			}
			this.wake();
			if(this.body != null) {
				this.body.refreshArbiters();
			}
		}
	}
	,setFilter: function(filter) {
		if(this.filter != filter) {
			if(this.body != null && this.body.space != null) {
				if(this.filter != null) {
					this.filter.shapes.remove(this);
				}
			}
			this.filter = filter;
			if(this.body != null && this.body.space != null) {
				filter.shapes.add(this);
			}
			this.wake();
		}
	}
	,setFluid: function(fluid) {
		if(this.fluidProperties != fluid) {
			if(this.body != null && this.body.space != null) {
				if(this.fluidProperties != null) {
					this.fluidProperties.shapes.remove(this);
				}
			}
			this.fluidProperties = fluid;
			if(this.body != null && this.body.space != null) {
				fluid.shapes.add(this);
			}
			if(this.fluidEnabled) {
				this.wake();
			}
		}
	}
	,__immutable_midstep: function(name) {
	}
	,addedToBody: function() {
		this.invalidate_worldCOM();
		this.zip_aabb = true;
		if(this.body != null) {
			this.body.zip_aabb = true;
		}
	}
	,removedFromBody: function() {
	}
	,addedToSpace: function() {
		this.__iaddedToSpace();
		this.material.shapes.add(this);
		this.filter.shapes.add(this);
		if(this.fluidProperties != null) {
			this.fluidProperties.shapes.add(this);
		}
	}
	,removedFromSpace: function() {
		this.__iremovedFromSpace();
		this.material.shapes.remove(this);
		this.filter.shapes.remove(this);
		if(this.fluidProperties != null) {
			this.fluidProperties.shapes.remove(this);
		}
	}
	,copy: function() {
		var ret = null;
		if(this.type == 0) {
			ret = this.circle.__copy();
		} else {
			ret = this.polygon.__copy();
		}
		if(!this.zip_area_inertia) {
			ret.area = this.area;
			ret.inertia = this.inertia;
		} else {
			ret.invalidate_area_inertia();
		}
		if(!this.zip_sweepRadius) {
			ret.sweepRadius = this.sweepRadius;
			ret.sweepCoef = this.sweepCoef;
		} else {
			ret.zip_sweepRadius = true;
		}
		if(!this.zip_angDrag) {
			ret.angDrag = this.angDrag;
		} else {
			ret.invalidate_angDrag();
		}
		if(!this.zip_aabb) {
			ret.aabb.minx = this.aabb.minx;
			ret.aabb.miny = this.aabb.miny;
			ret.aabb.maxx = this.aabb.maxx;
			ret.aabb.maxy = this.aabb.maxy;
		} else {
			ret.zip_aabb = true;
			if(ret.body != null) {
				ret.body.zip_aabb = true;
			}
		}
		var o = ret.material;
		o.outer = null;
		o.next = zpp_$nape_phys_ZPP_$Material.zpp_pool;
		zpp_$nape_phys_ZPP_$Material.zpp_pool = o;
		var o = ret.filter;
		o.outer = null;
		o.next = zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool;
		zpp_$nape_dynamics_ZPP_$InteractionFilter.zpp_pool = o;
		ret.material = this.material;
		ret.filter = this.filter;
		if(this.fluidProperties != null) {
			ret.fluidProperties = this.fluidProperties;
		}
		ret.fluidEnabled = this.fluidEnabled;
		ret.sensorEnabled = this.sensorEnabled;
		if(this.userData != null) {
			ret.userData = Reflect.copy(this.userData);
		}
		this.copyto(ret.outer);
		return ret.outer;
	}
});
var zpp_$nape_shape_ZPP_$Circle = function() {
	this.radius = 0.0;
	this.outer_zn = null;
	zpp_$nape_shape_ZPP_$Shape.call(this,0);
	this.circle = this;
	this.zip_localCOM = false;
};
zpp_$nape_shape_ZPP_$Circle.__name__ = true;
zpp_$nape_shape_ZPP_$Circle.__super__ = zpp_$nape_shape_ZPP_$Shape;
zpp_$nape_shape_ZPP_$Circle.prototype = $extend(zpp_$nape_shape_ZPP_$Shape.prototype,{
	invalidate_radius: function() {
		this.invalidate_area_inertia();
		this.invalidate_angDrag();
		this.zip_aabb = true;
		if(this.body != null) {
			this.body.zip_aabb = true;
		}
		if(this.body != null) {
			this.body.wake();
		}
	}
	,localCOM_validate: function() {
		this.wrap_localCOM.zpp_inner.x = this.localCOMx;
		this.wrap_localCOM.zpp_inner.y = this.localCOMy;
	}
	,localCOM_invalidate: function(x) {
		this.localCOMx = x.x;
		this.localCOMy = x.y;
		this.invalidate_localCOM();
		if(this.body != null) {
			this.body.wake();
		}
	}
	,setupLocalCOM: function() {
		var me = this;
		var x = this.localCOMx;
		var y = this.localCOMy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_localCOM = ret;
		this.wrap_localCOM.zpp_inner._inuse = true;
		this.wrap_localCOM.zpp_inner._validate = $bind(this,this.localCOM_validate);
		this.wrap_localCOM.zpp_inner._invalidate = $bind(this,this.localCOM_invalidate);
	}
	,__validate_sweepRadius: function() {
		this.sweepCoef = Math.sqrt(this.localCOMx * this.localCOMx + this.localCOMy * this.localCOMy);
		this.sweepRadius = this.sweepCoef + this.radius;
	}
	,__validate_area_inertia: function() {
		var r2 = this.radius * this.radius;
		this.area = r2 * Math.PI;
		this.inertia = r2 * 0.5 + (this.localCOMx * this.localCOMx + this.localCOMy * this.localCOMy);
	}
	,__validate_angDrag: function() {
		var lc = this.localCOMx * this.localCOMx + this.localCOMy * this.localCOMy;
		var r2 = this.radius * this.radius;
		var skin = this.material.dynamicFriction * nape_Config.fluidAngularDragFriction;
		this.angDrag = (lc + 2 * r2) * skin + 0.5 * nape_Config.fluidAngularDrag * (1 + nape_Config.fluidVacuumDrag) * lc;
		this.angDrag /= 2 * (lc + 0.5 * r2);
	}
	,__scale: function(sx,sy) {
		var factor = ((sx < 0 ? -sx : sx) + (sy < 0 ? -sy : sy)) / 2;
		this.radius *= factor < 0 ? -factor : factor;
		this.invalidate_radius();
		if(this.localCOMx * this.localCOMx + this.localCOMy * this.localCOMy > 0) {
			this.localCOMx *= sx;
			this.localCOMy *= sy;
			this.invalidate_localCOM();
		}
	}
	,__translate: function(x,y) {
		var t = 1.0;
		this.localCOMx += x * t;
		this.localCOMy += y * t;
		this.invalidate_localCOM();
	}
	,__rotate: function(x,y) {
		if(this.localCOMx * this.localCOMx + this.localCOMy * this.localCOMy > 0) {
			var tx = 0.0;
			var ty = 0.0;
			tx = y * this.localCOMx - x * this.localCOMy;
			ty = this.localCOMx * x + this.localCOMy * y;
			this.localCOMx = tx;
			this.localCOMy = ty;
			this.invalidate_localCOM();
		}
	}
	,__transform: function(m) {
		var det = m.zpp_inner.a * m.zpp_inner.d - m.zpp_inner.b * m.zpp_inner.c;
		if(det < 0) {
			det = -det;
		}
		this.radius *= Math.sqrt(det);
		var t = m.zpp_inner.a * this.localCOMx + m.zpp_inner.b * this.localCOMy + m.zpp_inner.tx;
		this.localCOMy = m.zpp_inner.c * this.localCOMx + m.zpp_inner.d * this.localCOMy + m.zpp_inner.ty;
		this.localCOMx = t;
		this.invalidate_radius();
		this.invalidate_localCOM();
	}
	,__copy: function() {
		var ret = new nape_shape_Circle(this.radius).zpp_inner_zn;
		ret.localCOMx = this.localCOMx;
		ret.localCOMy = this.localCOMy;
		ret.zip_localCOM = false;
		return ret;
	}
});
var zpp_$nape_shape_ZPP_$Edge = function() {
	this.tp1 = 0.0;
	this.tp0 = 0.0;
	this.gp1 = null;
	this.lp1 = null;
	this.gp0 = null;
	this.lp0 = null;
	this.gprojection = 0.0;
	this.lprojection = 0.0;
	this.length = 0.0;
	this.wrap_gnorm = null;
	this.gnormy = 0.0;
	this.gnormx = 0.0;
	this.wrap_lnorm = null;
	this.lnormy = 0.0;
	this.lnormx = 0.0;
	this.outer = null;
	this.polygon = null;
	this.next = null;
	this.lnormx = 0;
	this.lnormy = 0;
	this.gnormx = 0;
	this.gnormy = 0;
	this.length = 0;
	this.lprojection = 0;
	this.gprojection = 0;
};
zpp_$nape_shape_ZPP_$Edge.__name__ = true;
zpp_$nape_shape_ZPP_$Edge.prototype = {
	wrapper: function() {
		if(this.outer == null) {
			zpp_$nape_shape_ZPP_$Edge.internal = true;
			this.outer = new nape_shape_Edge();
			zpp_$nape_shape_ZPP_$Edge.internal = false;
			this.outer.zpp_inner = this;
		}
		return this.outer;
	}
	,lnorm_validate: function() {
		this.polygon.validate_laxi();
		this.wrap_lnorm.zpp_inner.x = this.lnormx;
		this.wrap_lnorm.zpp_inner.y = this.lnormy;
	}
	,gnorm_validate: function() {
		var _this = this.polygon;
		if(_this.zip_gaxi) {
			if(_this.body != null) {
				_this.zip_gaxi = false;
				_this.validate_laxi();
				var _this1 = _this.body;
				if(_this1.zip_axis) {
					_this1.zip_axis = false;
					_this1.axisx = Math.sin(_this1.rot);
					_this1.axisy = Math.cos(_this1.rot);
				}
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var ite = _this.edges.head;
				var cx_ite = _this.gverts.next;
				var u = cx_ite;
				cx_ite = cx_ite.next;
				while(cx_ite != null) {
					var v = cx_ite;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
					u = v;
					cx_ite = cx_ite.next;
				}
				var v = _this.gverts.next;
				var e = ite.elt;
				ite = ite.next;
				e.gp0 = u;
				e.gp1 = v;
				e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
				e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
				e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
				if(e.wrap_gnorm != null) {
					e.wrap_gnorm.zpp_inner.x = e.gnormx;
					e.wrap_gnorm.zpp_inner.y = e.gnormy;
				}
				e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
				e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
			}
		}
		this.wrap_gnorm.zpp_inner.x = this.gnormx;
		this.wrap_gnorm.zpp_inner.y = this.gnormy;
	}
	,getlnorm: function() {
		var x = this.lnormx;
		var y = this.lnormy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_lnorm = ret;
		this.wrap_lnorm.zpp_inner._immutable = true;
		this.wrap_lnorm.zpp_inner._validate = $bind(this,this.lnorm_validate);
	}
	,getgnorm: function() {
		var x = this.gnormx;
		var y = this.gnormy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_gnorm = ret;
		this.wrap_gnorm.zpp_inner._immutable = true;
		this.wrap_gnorm.zpp_inner._validate = $bind(this,this.gnorm_validate);
	}
};
var zpp_$nape_shape_ZPP_$Polygon = function() {
	this.zip_sanitation = false;
	this.zip_valid = false;
	this.zip_gaxi = false;
	this.zip_gverts = false;
	this.zip_laxi = false;
	this.zip_lverts = false;
	this.reverse_flag = false;
	this.edgeCnt = 0;
	this.wrap_edges = null;
	this.edges = null;
	this.wrap_gverts = null;
	this.gverts = null;
	this.wrap_lverts = null;
	this.lverts = null;
	this.outer_zn = null;
	zpp_$nape_shape_ZPP_$Shape.call(this,1);
	this.polygon = this;
	this.lverts = new zpp_$nape_geom_ZPP_$Vec2();
	this.gverts = new zpp_$nape_geom_ZPP_$Vec2();
	this.edges = new zpp_$nape_util_ZNPList_$ZPP_$Edge();
	this.edgeCnt = 0;
};
zpp_$nape_shape_ZPP_$Polygon.__name__ = true;
zpp_$nape_shape_ZPP_$Polygon.__super__ = zpp_$nape_shape_ZPP_$Shape;
zpp_$nape_shape_ZPP_$Polygon.prototype = $extend(zpp_$nape_shape_ZPP_$Shape.prototype,{
	lverts_pa_invalidate: function(x) {
		this.invalidate_lverts();
	}
	,gverts_pa_validate: function() {
		if(this.zip_gverts) {
			if(this.body != null) {
				this.zip_gverts = false;
				this.validate_lverts();
				var _this = this.body;
				if(_this.zip_axis) {
					_this.zip_axis = false;
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				}
				var li = this.lverts.next;
				var cx_ite = this.gverts.next;
				while(cx_ite != null) {
					var g = cx_ite;
					var l = li;
					li = li.next;
					g.x = this.body.posx + (this.body.axisy * l.x - this.body.axisx * l.y);
					g.y = this.body.posy + (l.x * this.body.axisx + l.y * this.body.axisy);
					cx_ite = cx_ite.next;
				}
			}
		}
	}
	,lverts_post_adder: function(x) {
		x.zpp_inner._invalidate = $bind(this,this.lverts_pa_invalidate);
		var ite = null;
		var ite2 = null;
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var i = cx_ite;
			if(i == x.zpp_inner) {
				break;
			} else {
				ite = ite == null ? this.gverts.next : ite.next;
				ite2 = ite2 == null ? this.edges.head : ite2.next;
			}
			cx_ite = cx_ite.next;
		}
		var immutable = true;
		if(immutable == null) {
			immutable = false;
		}
		var ret;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.weak = false;
		ret._immutable = immutable;
		ret.x = 0;
		ret.y = 0;
		var vec = ret;
		this.gverts.insert(ite,vec);
		if(this.lverts.next.next != null) {
			if(this.lverts.next.next.next == null) {
				var ed;
				if(zpp_$nape_shape_ZPP_$Edge.zpp_pool == null) {
					ed = new zpp_$nape_shape_ZPP_$Edge();
				} else {
					ed = zpp_$nape_shape_ZPP_$Edge.zpp_pool;
					zpp_$nape_shape_ZPP_$Edge.zpp_pool = ed.next;
					ed.next = null;
				}
				ed.polygon = this;
				this.edges.add(ed);
				var ed;
				if(zpp_$nape_shape_ZPP_$Edge.zpp_pool == null) {
					ed = new zpp_$nape_shape_ZPP_$Edge();
				} else {
					ed = zpp_$nape_shape_ZPP_$Edge.zpp_pool;
					zpp_$nape_shape_ZPP_$Edge.zpp_pool = ed.next;
					ed.next = null;
				}
				ed.polygon = this;
				this.edges.add(ed);
				this.edgeCnt += 2;
			} else {
				var ed;
				if(zpp_$nape_shape_ZPP_$Edge.zpp_pool == null) {
					ed = new zpp_$nape_shape_ZPP_$Edge();
				} else {
					ed = zpp_$nape_shape_ZPP_$Edge.zpp_pool;
					zpp_$nape_shape_ZPP_$Edge.zpp_pool = ed.next;
					ed.next = null;
				}
				ed.polygon = this;
				this.edges.insert(ite2,ed);
				this.edgeCnt++;
			}
		}
		vec._validate = $bind(this,this.gverts_pa_validate);
	}
	,lverts_subber: function(x) {
		this.cleanup_lvert(x.zpp_inner);
	}
	,lverts_invalidate: function(_) {
		this.invalidate_lverts();
	}
	,lverts_validate: function() {
		this.validate_lverts();
	}
	,gverts_validate: function() {
		if(this.zip_gverts) {
			if(this.body != null) {
				this.zip_gverts = false;
				this.validate_lverts();
				var _this = this.body;
				if(_this.zip_axis) {
					_this.zip_axis = false;
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				}
				var li = this.lverts.next;
				var cx_ite = this.gverts.next;
				while(cx_ite != null) {
					var g = cx_ite;
					var l = li;
					li = li.next;
					g.x = this.body.posx + (this.body.axisy * l.x - this.body.axisx * l.y);
					g.y = this.body.posy + (l.x * this.body.axisx + l.y * this.body.axisy);
					cx_ite = cx_ite.next;
				}
			}
		}
	}
	,edges_validate: function() {
		this.validate_lverts();
	}
	,getlverts: function() {
		var me = this;
		this.wrap_lverts = zpp_$nape_util_ZPP_$MixVec2List.get(this.lverts);
		this.wrap_lverts.zpp_inner.post_adder = $bind(this,this.lverts_post_adder);
		this.wrap_lverts.zpp_inner.subber = $bind(this,this.lverts_subber);
		this.wrap_lverts.zpp_inner._invalidate = $bind(this,this.lverts_invalidate);
		this.wrap_lverts.zpp_inner._validate = $bind(this,this.lverts_validate);
		this.wrap_lverts.zpp_inner.reverse_flag = this.reverse_flag;
	}
	,getgverts: function() {
		var me = this;
		this.wrap_gverts = zpp_$nape_util_ZPP_$MixVec2List.get(this.gverts,true);
		this.wrap_gverts.zpp_inner.reverse_flag = this.reverse_flag;
		this.wrap_gverts.zpp_inner._validate = $bind(this,this.gverts_validate);
	}
	,getedges: function() {
		var me = this;
		this.wrap_edges = zpp_$nape_util_ZPP_$EdgeList.get(this.edges,true);
		this.wrap_edges.zpp_inner.reverse_flag = this.reverse_flag;
		this.wrap_edges.zpp_inner._validate = $bind(this,this.edges_validate);
	}
	,invalidate_lverts: function() {
		this.invalidate_laxi();
		this.invalidate_area_inertia();
		this.invalidate_angDrag();
		this.invalidate_localCOM();
		this.invalidate_gverts();
		this.zip_lverts = true;
		this.zip_valid = true;
		this.zip_sanitation = true;
		if(this.body != null) {
			this.body.wake();
		}
	}
	,invalidate_laxi: function() {
		this.invalidate_gaxi();
		this.zip_sweepRadius = true;
		this.zip_laxi = true;
	}
	,invalidate_gverts: function() {
		this.zip_aabb = true;
		if(this.body != null) {
			this.body.zip_aabb = true;
		}
		this.zip_gverts = true;
	}
	,invalidate_gaxi: function() {
		this.zip_gaxi = true;
	}
	,valid: function() {
		if(this.zip_valid) {
			this.zip_valid = false;
			if(this.zip_sanitation) {
				this.zip_sanitation = false;
				this.splice_collinear_real();
			}
			if(this.lverts.length < 3) {
				if(zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE == null) {
					zpp_$nape_util_ZPP_$Flags.internal = true;
					zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE = new nape_shape_ValidationResult();
					zpp_$nape_util_ZPP_$Flags.internal = false;
				}
				return this.validation = zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE;
			} else {
				this.validate_lverts();
				this.validate_area_inertia();
				if(this.area < nape_Config.epsilon) {
					if(zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE == null) {
						zpp_$nape_util_ZPP_$Flags.internal = true;
						zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE = new nape_shape_ValidationResult();
						zpp_$nape_util_ZPP_$Flags.internal = false;
					}
					return this.validation = zpp_$nape_util_ZPP_$Flags.ValidationResult_DEGENERATE;
				} else {
					var neg = false;
					var pos = false;
					var cx_cont = true;
					var cx_ite = this.lverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					var v = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var w = cx_ite;
						var ax = 0.0;
						var ay = 0.0;
						ax = w.x - v.x;
						ay = w.y - v.y;
						var bx = 0.0;
						var by = 0.0;
						bx = v.x - u.x;
						by = v.y - u.y;
						var dot = by * ax - bx * ay;
						if(dot > nape_Config.epsilon) {
							pos = true;
						} else if(dot < -nape_Config.epsilon) {
							neg = true;
						}
						if(pos && neg) {
							cx_cont = false;
							break;
						}
						u = v;
						v = w;
						cx_ite = cx_ite.next;
					}
					if(cx_cont) {
						cx_ite = this.lverts.next;
						var w = cx_ite;
						do {
							var ax = 0.0;
							var ay = 0.0;
							ax = w.x - v.x;
							ay = w.y - v.y;
							var bx = 0.0;
							var by = 0.0;
							bx = v.x - u.x;
							by = v.y - u.y;
							var dot = by * ax - bx * ay;
							if(dot > nape_Config.epsilon) {
								pos = true;
							} else if(dot < -nape_Config.epsilon) {
								neg = true;
							}
							if(pos && neg) {
								cx_cont = false;
								break;
							}
						} while(false);
						if(cx_cont) {
							u = v;
							v = w;
							cx_ite = cx_ite.next;
							var w = cx_ite;
							do {
								var ax = 0.0;
								var ay = 0.0;
								ax = w.x - v.x;
								ay = w.y - v.y;
								var bx = 0.0;
								var by = 0.0;
								bx = v.x - u.x;
								by = v.y - u.y;
								var dot = by * ax - bx * ay;
								if(dot > nape_Config.epsilon) {
									pos = true;
								} else if(dot < -nape_Config.epsilon) {
									neg = true;
								}
								if(pos && neg) {
									break;
								}
							} while(false);
						}
					}
					if(pos && neg) {
						if(zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE == null) {
							zpp_$nape_util_ZPP_$Flags.internal = true;
							zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE = new nape_shape_ValidationResult();
							zpp_$nape_util_ZPP_$Flags.internal = false;
						}
						return this.validation = zpp_$nape_util_ZPP_$Flags.ValidationResult_CONCAVE;
					} else {
						var cont = true;
						var cx_cont = true;
						var cx_ite = this.lverts.next;
						var u = cx_ite;
						cx_ite = cx_ite.next;
						while(cx_ite != null) {
							var v = cx_ite;
							if(!cont) {
								cx_cont = false;
								break;
							}
							var cx_cont1 = true;
							var cx_ite1 = this.lverts.next;
							var a = cx_ite1;
							cx_ite1 = cx_ite1.next;
							while(cx_ite1 != null) {
								var b = cx_ite1;
								if(u == a || u == b || v == a || v == b) {
									a = b;
									cx_ite1 = cx_ite1.next;
									continue;
								}
								var sx = 0.0;
								var sy = 0.0;
								sx = u.x - a.x;
								sy = u.y - a.y;
								var vx = 0.0;
								var vy = 0.0;
								vx = v.x - u.x;
								vy = v.y - u.y;
								var qx = 0.0;
								var qy = 0.0;
								qx = b.x - a.x;
								qy = b.y - a.y;
								var den = vy * qx - vx * qy;
								if(den * den > nape_Config.epsilon) {
									den = 1 / den;
									var t = (qy * sx - qx * sy) * den;
									if(t > nape_Config.epsilon && t < 1 - nape_Config.epsilon) {
										var s = (vy * sx - vx * sy) * den;
										if(s > nape_Config.epsilon && s < 1 - nape_Config.epsilon) {
											cont = false;
											cx_cont1 = false;
											break;
										}
									}
								}
								a = b;
								cx_ite1 = cx_ite1.next;
							}
							if(cx_cont1) {
								do {
									var b1 = this.lverts.next;
									if(u == a || u == b1 || v == a || v == b1) {
										break;
									}
									var sx1 = 0.0;
									var sy1 = 0.0;
									sx1 = u.x - a.x;
									sy1 = u.y - a.y;
									var vx1 = 0.0;
									var vy1 = 0.0;
									vx1 = v.x - u.x;
									vy1 = v.y - u.y;
									var qx1 = 0.0;
									var qy1 = 0.0;
									qx1 = b1.x - a.x;
									qy1 = b1.y - a.y;
									var den1 = vy1 * qx1 - vx1 * qy1;
									if(den1 * den1 > nape_Config.epsilon) {
										den1 = 1 / den1;
										var t1 = (qy1 * sx1 - qx1 * sy1) * den1;
										if(t1 > nape_Config.epsilon && t1 < 1 - nape_Config.epsilon) {
											var s1 = (vy1 * sx1 - vx1 * sy1) * den1;
											if(s1 > nape_Config.epsilon && s1 < 1 - nape_Config.epsilon) {
												cont = false;
												break;
											}
										}
									}
								} while(false);
							}
							u = v;
							cx_ite = cx_ite.next;
						}
						if(cx_cont) {
							while(true) {
								var v = this.lverts.next;
								if(!cont) {
									break;
								}
								var cx_cont = true;
								var cx_ite = this.lverts.next;
								var a = cx_ite;
								cx_ite = cx_ite.next;
								while(cx_ite != null) {
									var b = cx_ite;
									if(u == a || u == b || v == a || v == b) {
										a = b;
										cx_ite = cx_ite.next;
										continue;
									}
									var sx = 0.0;
									var sy = 0.0;
									sx = u.x - a.x;
									sy = u.y - a.y;
									var vx = 0.0;
									var vy = 0.0;
									vx = v.x - u.x;
									vy = v.y - u.y;
									var qx = 0.0;
									var qy = 0.0;
									qx = b.x - a.x;
									qy = b.y - a.y;
									var den = vy * qx - vx * qy;
									if(den * den > nape_Config.epsilon) {
										den = 1 / den;
										var t = (qy * sx - qx * sy) * den;
										if(t > nape_Config.epsilon && t < 1 - nape_Config.epsilon) {
											var s = (vy * sx - vx * sy) * den;
											if(s > nape_Config.epsilon && s < 1 - nape_Config.epsilon) {
												cont = false;
												cx_cont = false;
												break;
											}
										}
									}
									a = b;
									cx_ite = cx_ite.next;
								}
								if(cx_cont) {
									do {
										var b1 = this.lverts.next;
										if(u == a || u == b1 || v == a || v == b1) {
											break;
										}
										var sx1 = 0.0;
										var sy1 = 0.0;
										sx1 = u.x - a.x;
										sy1 = u.y - a.y;
										var vx1 = 0.0;
										var vy1 = 0.0;
										vx1 = v.x - u.x;
										vy1 = v.y - u.y;
										var qx1 = 0.0;
										var qy1 = 0.0;
										qx1 = b1.x - a.x;
										qy1 = b1.y - a.y;
										var den1 = vy1 * qx1 - vx1 * qy1;
										if(den1 * den1 > nape_Config.epsilon) {
											den1 = 1 / den1;
											var t1 = (qy1 * sx1 - qx1 * sy1) * den1;
											if(t1 > nape_Config.epsilon && t1 < 1 - nape_Config.epsilon) {
												var s1 = (vy1 * sx1 - vx1 * sy1) * den1;
												if(s1 > nape_Config.epsilon && s1 < 1 - nape_Config.epsilon) {
													cont = false;
													break;
												}
											}
										}
									} while(false);
								}
								if(!false) {
									break;
								}
							}
						}
						if(!cont) {
							if(zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING == null) {
								zpp_$nape_util_ZPP_$Flags.internal = true;
								zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING = new nape_shape_ValidationResult();
								zpp_$nape_util_ZPP_$Flags.internal = false;
							}
							return this.validation = zpp_$nape_util_ZPP_$Flags.ValidationResult_SELF_INTERSECTING;
						} else {
							if(zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID == null) {
								zpp_$nape_util_ZPP_$Flags.internal = true;
								zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID = new nape_shape_ValidationResult();
								zpp_$nape_util_ZPP_$Flags.internal = false;
							}
							return this.validation = zpp_$nape_util_ZPP_$Flags.ValidationResult_VALID;
						}
					}
				}
			}
		} else {
			return this.validation;
		}
	}
	,validate_lverts: function() {
		if(this.zip_lverts) {
			this.zip_lverts = false;
			if(this.lverts.length > 2) {
				this.validate_area_inertia();
				if(this.area < 0) {
					this.reverse_vertices();
					this.area = -this.area;
				}
			}
		}
	}
	,cleanup_lvert: function(x) {
		var ite = null;
		var ite2 = null;
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var i = cx_ite;
			if(i == x) {
				break;
			} else {
				ite = ite == null ? this.gverts.next : ite.next;
				ite2 = ite2 == null ? this.edges.head : ite2.next;
			}
			cx_ite = cx_ite.next;
		}
		var rem = ite == null ? this.gverts.next : ite.next;
		this.gverts.erase(ite);
		var o = rem;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		if(this.edgeCnt == 2) {
			var rem = this.edges.pop_unsafe();
			var o = rem;
			o.polygon = null;
			o.next = zpp_$nape_shape_ZPP_$Edge.zpp_pool;
			zpp_$nape_shape_ZPP_$Edge.zpp_pool = o;
			rem = this.edges.pop_unsafe();
			var o = rem;
			o.polygon = null;
			o.next = zpp_$nape_shape_ZPP_$Edge.zpp_pool;
			zpp_$nape_shape_ZPP_$Edge.zpp_pool = o;
			this.edgeCnt = 0;
		} else if(this.edgeCnt != 0) {
			var rem = ite2 == null ? this.edges.head.elt : ite2.next.elt;
			this.edges.erase(ite2);
			var o = rem;
			o.polygon = null;
			o.next = zpp_$nape_shape_ZPP_$Edge.zpp_pool;
			zpp_$nape_shape_ZPP_$Edge.zpp_pool = o;
			this.edgeCnt--;
		}
	}
	,splice_collinear_real: function() {
		if(this.lverts.next == null) {
			return;
		}
		if(this.lverts.next.next == null) {
			return;
		}
		if(this.lverts.next.next.next == null) {
			return;
		}
		var pre = null;
		var cur = this.lverts.next;
		while(cur != null) {
			var nxt = cur.next == null ? this.lverts.next : cur.next;
			var u = cur;
			var v = nxt;
			var dx = 0.0;
			var dy = 0.0;
			dx = u.x - v.x;
			dy = u.y - v.y;
			if(dx * dx + dy * dy < nape_Config.epsilon * nape_Config.epsilon) {
				this.cleanup_lvert(cur);
				cur = this.lverts.erase(pre);
			} else {
				pre = cur;
				cur = cur.next;
			}
		}
		if(this.lverts.next == null) {
			return;
		}
		var removed;
		do {
			removed = false;
			var pre = this.lverts.next;
			while(pre != null) {
				var cur = pre.next == null ? this.lverts.next : pre.next;
				var nxt = cur.next == null ? this.lverts.next : cur.next;
				var u = pre;
				var v = cur;
				var w = nxt;
				var ax = 0.0;
				var ay = 0.0;
				ax = v.x - u.x;
				ay = v.y - u.y;
				var bx = 0.0;
				var by = 0.0;
				bx = w.x - v.x;
				by = w.y - v.y;
				var crs = by * ax - bx * ay;
				if(crs * crs >= nape_Config.epsilon * nape_Config.epsilon) {
					pre = pre.next;
				} else {
					this.cleanup_lvert(cur);
					this.lverts.erase(pre.next == null ? null : pre);
					removed = true;
					pre = pre.next;
				}
			}
		} while(removed);
	}
	,reverse_vertices: function() {
		this.lverts.reverse();
		this.gverts.reverse();
		this.edges.reverse();
		var ite = this.edges.iterator_at(this.edgeCnt - 1);
		var elem = this.edges.pop_unsafe();
		this.edges.insert(ite,elem);
		this.reverse_flag = !this.reverse_flag;
		if(this.wrap_lverts != null) {
			this.wrap_lverts.zpp_inner.reverse_flag = this.reverse_flag;
		}
		if(this.wrap_gverts != null) {
			this.wrap_gverts.zpp_inner.reverse_flag = this.reverse_flag;
		}
		if(this.wrap_edges != null) {
			this.wrap_edges.zpp_inner.reverse_flag = this.reverse_flag;
		}
	}
	,validate_laxi: function() {
		if(this.zip_laxi) {
			this.zip_laxi = false;
			this.validate_lverts();
			var ite = this.edges.head;
			var cx_ite = this.lverts.next;
			var u = cx_ite;
			cx_ite = cx_ite.next;
			while(cx_ite != null) {
				var v = cx_ite;
				var edge = ite.elt;
				ite = ite.next;
				edge.lp0 = u;
				edge.lp1 = v;
				var dx = 0.0;
				var dy = 0.0;
				dx = u.x - v.x;
				dy = u.y - v.y;
				var l = Math.sqrt(dx * dx + dy * dy);
				edge.length = l;
				var t = 1.0 / l;
				dx *= t;
				dy *= t;
				var t1 = dx;
				dx = -dy;
				dy = t1;
				edge.lprojection = dx * u.x + dy * u.y;
				edge.lnormx = dx;
				edge.lnormy = dy;
				if(edge.wrap_lnorm != null) {
					edge.wrap_lnorm.zpp_inner.x = dx;
					edge.wrap_lnorm.zpp_inner.y = dy;
				}
				u = v;
				cx_ite = cx_ite.next;
			}
			var v = this.lverts.next;
			var edge = ite.elt;
			ite = ite.next;
			edge.lp0 = u;
			edge.lp1 = v;
			var dx = 0.0;
			var dy = 0.0;
			dx = u.x - v.x;
			dy = u.y - v.y;
			var l = Math.sqrt(dx * dx + dy * dy);
			edge.length = l;
			var t = 1.0 / l;
			dx *= t;
			dy *= t;
			var t = dx;
			dx = -dy;
			dy = t;
			edge.lprojection = dx * u.x + dy * u.y;
			edge.lnormx = dx;
			edge.lnormy = dy;
			if(edge.wrap_lnorm != null) {
				edge.wrap_lnorm.zpp_inner.x = dx;
				edge.wrap_lnorm.zpp_inner.y = dy;
			}
		}
	}
	,__validate_sweepRadius: function() {
		var maxRadius = 0.0;
		var minRadius = 0.0;
		this.validate_laxi();
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var x = cx_ite;
			var r = x.x * x.x + x.y * x.y;
			if(r > maxRadius) {
				maxRadius = r;
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.edges.head;
		while(cx_ite != null) {
			var e = cx_ite.elt;
			if(e.lprojection < minRadius) {
				minRadius = e.lprojection;
				if(minRadius < 0) {
					break;
				}
			}
			cx_ite = cx_ite.next;
		}
		if(minRadius < 0) {
			minRadius = 0;
		}
		this.sweepRadius = Math.sqrt(maxRadius);
		this.sweepCoef = this.sweepRadius - minRadius;
	}
	,__validate_area_inertia: function() {
		if(this.lverts.next == null || this.lverts.next.next == null || this.lverts.next.next.next == null) {
			this.area = 0;
			this.inertia = 0;
		} else {
			this.area = 0.0;
			var s1 = 0.0;
			var s2 = 0.0;
			var cx_ite = this.lverts.next;
			var u = cx_ite;
			cx_ite = cx_ite.next;
			var v = cx_ite;
			cx_ite = cx_ite.next;
			while(cx_ite != null) {
				var w = cx_ite;
				var a = v.y * u.x - v.x * u.y;
				var b = v.x * v.x + v.y * v.y + (v.x * u.x + v.y * u.y) + (u.x * u.x + u.y * u.y);
				s1 += a * b;
				s2 += a;
				this.area += v.x * (w.y - u.y);
				u = v;
				v = w;
				cx_ite = cx_ite.next;
			}
			cx_ite = this.lverts.next;
			var w = cx_ite;
			var a = v.y * u.x - v.x * u.y;
			var b = v.x * v.x + v.y * v.y + (v.x * u.x + v.y * u.y) + (u.x * u.x + u.y * u.y);
			s1 += a * b;
			s2 += a;
			this.area += v.x * (w.y - u.y);
			u = v;
			v = w;
			cx_ite = cx_ite.next;
			var w = cx_ite;
			var a = v.y * u.x - v.x * u.y;
			var b = v.x * v.x + v.y * v.y + (v.x * u.x + v.y * u.y) + (u.x * u.x + u.y * u.y);
			s1 += a * b;
			s2 += a;
			this.area += v.x * (w.y - u.y);
			this.inertia = s1 / (6 * s2);
			this.area *= 0.5;
			if(this.area < 0) {
				this.area = -this.area;
				this.reverse_vertices();
			}
		}
	}
	,__validate_angDrag: function() {
		this.validate_area_inertia();
		this.validate_laxi();
		var accum = 0.0;
		var ei = this.edges.head;
		var perim = 0.0;
		var cx_cont = true;
		var cx_itei = this.lverts.next;
		var u = cx_itei;
		var cx_itej = cx_itei.next;
		while(cx_itej != null) {
			var v = cx_itej;
			var edge = ei.elt;
			ei = ei.next;
			perim += edge.length;
			var dx = 0.0;
			var dy = 0.0;
			dx = v.x - u.x;
			dy = v.y - u.y;
			accum += edge.length * nape_Config.fluidAngularDragFriction * this.material.dynamicFriction * edge.lprojection * edge.lprojection;
			var t = -(u.y * edge.lnormx - u.x * edge.lnormy) / (dy * edge.lnormx - dx * edge.lnormy);
			if(t > 0) {
				var ta = t > 1 ? 1 : t;
				var cx = 0.0;
				var cy = 0.0;
				cx = u.x;
				cy = u.y;
				var t1 = ta;
				cx += dx * t1;
				cy += dy * t1;
				var dota = edge.lnormy * u.x - edge.lnormx * u.y;
				var dotb = edge.lnormy * cx - edge.lnormx * cy;
				var dots = (dotb * dotb * dotb - dota * dota * dota) / (3 * (dotb - dota));
				accum += dots * ta * edge.length * nape_Config.fluidAngularDrag;
			}
			if(t < 1) {
				var tb = t < 0 ? 0 : t;
				var cx1 = 0.0;
				var cy1 = 0.0;
				cx1 = u.x;
				cy1 = u.y;
				var t2 = tb;
				cx1 += dx * t2;
				cy1 += dy * t2;
				var dota1 = edge.lnormy * cx1 - edge.lnormx * cy1;
				var dotb1 = edge.lnormy * v.x - edge.lnormx * v.y;
				var dots1 = (dotb1 * dotb1 * dotb1 - dota1 * dota1 * dota1) / (3 * (dotb1 - dota1));
				accum += dots1 * nape_Config.fluidVacuumDrag * (1 - tb) * edge.length * nape_Config.fluidAngularDrag;
			}
			cx_itei = cx_itej;
			u = v;
			cx_itej = cx_itej.next;
		}
		if(cx_cont) {
			do {
				cx_itej = this.lverts.next;
				var v = cx_itej;
				var edge = ei.elt;
				ei = ei.next;
				perim += edge.length;
				var dx = 0.0;
				var dy = 0.0;
				dx = v.x - u.x;
				dy = v.y - u.y;
				accum += edge.length * nape_Config.fluidAngularDragFriction * this.material.dynamicFriction * edge.lprojection * edge.lprojection;
				var t = -(u.y * edge.lnormx - u.x * edge.lnormy) / (dy * edge.lnormx - dx * edge.lnormy);
				if(t > 0) {
					var ta = t > 1 ? 1 : t;
					var cx = 0.0;
					var cy = 0.0;
					cx = u.x;
					cy = u.y;
					var t1 = ta;
					cx += dx * t1;
					cy += dy * t1;
					var dota = edge.lnormy * u.x - edge.lnormx * u.y;
					var dotb = edge.lnormy * cx - edge.lnormx * cy;
					var dots = (dotb * dotb * dotb - dota * dota * dota) / (3 * (dotb - dota));
					accum += dots * ta * edge.length * nape_Config.fluidAngularDrag;
				}
				if(t < 1) {
					var tb = t < 0 ? 0 : t;
					var cx1 = 0.0;
					var cy1 = 0.0;
					cx1 = u.x;
					cy1 = u.y;
					var t2 = tb;
					cx1 += dx * t2;
					cy1 += dy * t2;
					var dota1 = edge.lnormy * cx1 - edge.lnormx * cy1;
					var dotb1 = edge.lnormy * v.x - edge.lnormx * v.y;
					var dots1 = (dotb1 * dotb1 * dotb1 - dota1 * dota1 * dota1) / (3 * (dotb1 - dota1));
					accum += dots1 * nape_Config.fluidVacuumDrag * (1 - tb) * edge.length * nape_Config.fluidAngularDrag;
				}
			} while(false);
		}
		this.angDrag = accum / (this.inertia * perim);
	}
	,localCOM_validate: function() {
		if(this.zip_localCOM) {
			this.zip_localCOM = false;
			if(this.type == 1) {
				var _this = this.polygon;
				if(_this.lverts.next.next == null) {
					_this.localCOMx = _this.lverts.next.x;
					_this.localCOMy = _this.lverts.next.y;
				} else if(_this.lverts.next.next.next == null) {
					_this.localCOMx = _this.lverts.next.x;
					_this.localCOMy = _this.lverts.next.y;
					var t = 1.0;
					_this.localCOMx += _this.lverts.next.next.x * t;
					_this.localCOMy += _this.lverts.next.next.y * t;
					var t = 0.5;
					_this.localCOMx *= t;
					_this.localCOMy *= t;
				} else {
					_this.localCOMx = 0;
					_this.localCOMy = 0;
					var area = 0.0;
					var cx_ite = _this.lverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					var v = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var w = cx_ite;
						area += v.x * (w.y - u.y);
						var cf = w.y * v.x - w.x * v.y;
						_this.localCOMx += (v.x + w.x) * cf;
						_this.localCOMy += (v.y + w.y) * cf;
						u = v;
						v = w;
						cx_ite = cx_ite.next;
					}
					cx_ite = _this.lverts.next;
					var w = cx_ite;
					area += v.x * (w.y - u.y);
					var cf = w.y * v.x - w.x * v.y;
					_this.localCOMx += (v.x + w.x) * cf;
					_this.localCOMy += (v.y + w.y) * cf;
					u = v;
					v = w;
					cx_ite = cx_ite.next;
					var w = cx_ite;
					area += v.x * (w.y - u.y);
					var cf = w.y * v.x - w.x * v.y;
					_this.localCOMx += (v.x + w.x) * cf;
					_this.localCOMy += (v.y + w.y) * cf;
					area = 1 / (3 * area);
					var t = area;
					_this.localCOMx *= t;
					_this.localCOMy *= t;
				}
			}
			if(this.wrap_localCOM != null) {
				this.wrap_localCOM.zpp_inner.x = this.localCOMx;
				this.wrap_localCOM.zpp_inner.y = this.localCOMy;
			}
		}
	}
	,localCOM_invalidate: function(x) {
		if(this.zip_localCOM) {
			this.zip_localCOM = false;
			if(this.type == 1) {
				var _this = this.polygon;
				if(_this.lverts.next.next == null) {
					_this.localCOMx = _this.lverts.next.x;
					_this.localCOMy = _this.lverts.next.y;
				} else if(_this.lverts.next.next.next == null) {
					_this.localCOMx = _this.lverts.next.x;
					_this.localCOMy = _this.lverts.next.y;
					var t = 1.0;
					_this.localCOMx += _this.lverts.next.next.x * t;
					_this.localCOMy += _this.lverts.next.next.y * t;
					var t = 0.5;
					_this.localCOMx *= t;
					_this.localCOMy *= t;
				} else {
					_this.localCOMx = 0;
					_this.localCOMy = 0;
					var area = 0.0;
					var cx_ite = _this.lverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					var v = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var w = cx_ite;
						area += v.x * (w.y - u.y);
						var cf = w.y * v.x - w.x * v.y;
						_this.localCOMx += (v.x + w.x) * cf;
						_this.localCOMy += (v.y + w.y) * cf;
						u = v;
						v = w;
						cx_ite = cx_ite.next;
					}
					cx_ite = _this.lverts.next;
					var w = cx_ite;
					area += v.x * (w.y - u.y);
					var cf = w.y * v.x - w.x * v.y;
					_this.localCOMx += (v.x + w.x) * cf;
					_this.localCOMy += (v.y + w.y) * cf;
					u = v;
					v = w;
					cx_ite = cx_ite.next;
					var w = cx_ite;
					area += v.x * (w.y - u.y);
					var cf = w.y * v.x - w.x * v.y;
					_this.localCOMx += (v.x + w.x) * cf;
					_this.localCOMy += (v.y + w.y) * cf;
					area = 1 / (3 * area);
					var t = area;
					_this.localCOMx *= t;
					_this.localCOMy *= t;
				}
			}
			if(this.wrap_localCOM != null) {
				this.wrap_localCOM.zpp_inner.x = this.localCOMx;
				this.wrap_localCOM.zpp_inner.y = this.localCOMy;
			}
		}
		var delx = 0;
		var dely = 0;
		delx = x.x - this.localCOMx;
		dely = x.y - this.localCOMy;
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var p = cx_ite;
			var t = 1.0;
			p.x += delx * t;
			p.y += dely * t;
			cx_ite = cx_ite.next;
		}
		this.invalidate_lverts();
	}
	,setupLocalCOM: function() {
		var x = this.localCOMx;
		var y = this.localCOMy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_localCOM = ret;
		this.wrap_localCOM.zpp_inner._inuse = true;
		this.wrap_localCOM.zpp_inner._validate = $bind(this,this.localCOM_validate);
		this.wrap_localCOM.zpp_inner._invalidate = $bind(this,this.localCOM_invalidate);
	}
	,__translate: function(dx,dy) {
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var p = cx_ite;
			var t = 1.0;
			p.x += dx * t;
			p.y += dy * t;
			cx_ite = cx_ite.next;
		}
		this.invalidate_lverts();
	}
	,__scale: function(sx,sy) {
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var p = cx_ite;
			p.x *= sx;
			p.y *= sy;
			cx_ite = cx_ite.next;
		}
		this.invalidate_lverts();
	}
	,__rotate: function(ax,ay) {
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var p = cx_ite;
			var tempx = 0.0;
			var tempy = 0.0;
			tempx = ay * p.x - ax * p.y;
			tempy = p.x * ax + p.y * ay;
			p.x = tempx;
			p.y = tempy;
			cx_ite = cx_ite.next;
		}
		this.invalidate_lverts();
	}
	,__transform: function(mat) {
		var cx_ite = this.lverts.next;
		while(cx_ite != null) {
			var p = cx_ite;
			var t = mat.zpp_inner.a * p.x + mat.zpp_inner.b * p.y + mat.zpp_inner.tx;
			p.y = mat.zpp_inner.c * p.x + mat.zpp_inner.d * p.y + mat.zpp_inner.ty;
			p.x = t;
			cx_ite = cx_ite.next;
		}
		this.invalidate_lverts();
	}
	,__copy: function() {
		var _this = this.outer_zn;
		if(_this.zpp_inner_zn.wrap_lverts == null) {
			_this.zpp_inner_zn.getlverts();
		}
		var ret = new nape_shape_Polygon(_this.zpp_inner_zn.wrap_lverts).zpp_inner_zn;
		return ret;
	}
});
var zpp_$nape_space_ZPP_$Broadphase = function() {
	this.circShape = null;
	this.matrix = null;
	this.aabbShape = null;
	this.dynab = null;
	this.sweep = null;
	this.is_sweep = false;
	this.space = null;
};
zpp_$nape_space_ZPP_$Broadphase.__name__ = true;
zpp_$nape_space_ZPP_$Broadphase.prototype = {
	insert: function(shape) {
		if(this.is_sweep) {
			this.sweep.__insert(shape);
		} else {
			this.dynab.__insert(shape);
		}
	}
	,remove: function(shape) {
		if(this.is_sweep) {
			this.sweep.__remove(shape);
		} else {
			this.dynab.__remove(shape);
		}
	}
	,sync: function(shape) {
		if(this.is_sweep) {
			if(!this.sweep.space.continuous) {
				if(shape.zip_aabb) {
					if(shape.body != null) {
						shape.zip_aabb = false;
						if(shape.type == 0) {
							var _this = shape.circle;
							if(_this.zip_worldCOM) {
								if(_this.body != null) {
									_this.zip_worldCOM = false;
									if(_this.zip_localCOM) {
										_this.zip_localCOM = false;
										if(_this.type == 1) {
											var _this1 = _this.polygon;
											if(_this1.lverts.next.next == null) {
												_this1.localCOMx = _this1.lverts.next.x;
												_this1.localCOMy = _this1.lverts.next.y;
											} else if(_this1.lverts.next.next.next == null) {
												_this1.localCOMx = _this1.lverts.next.x;
												_this1.localCOMy = _this1.lverts.next.y;
												var t = 1.0;
												_this1.localCOMx += _this1.lverts.next.next.x * t;
												_this1.localCOMy += _this1.lverts.next.next.y * t;
												var t = 0.5;
												_this1.localCOMx *= t;
												_this1.localCOMy *= t;
											} else {
												_this1.localCOMx = 0;
												_this1.localCOMy = 0;
												var area = 0.0;
												var cx_ite = _this1.lverts.next;
												var u = cx_ite;
												cx_ite = cx_ite.next;
												var v = cx_ite;
												cx_ite = cx_ite.next;
												while(cx_ite != null) {
													var w = cx_ite;
													area += v.x * (w.y - u.y);
													var cf = w.y * v.x - w.x * v.y;
													_this1.localCOMx += (v.x + w.x) * cf;
													_this1.localCOMy += (v.y + w.y) * cf;
													u = v;
													v = w;
													cx_ite = cx_ite.next;
												}
												cx_ite = _this1.lverts.next;
												var w = cx_ite;
												area += v.x * (w.y - u.y);
												var cf = w.y * v.x - w.x * v.y;
												_this1.localCOMx += (v.x + w.x) * cf;
												_this1.localCOMy += (v.y + w.y) * cf;
												u = v;
												v = w;
												cx_ite = cx_ite.next;
												var w = cx_ite;
												area += v.x * (w.y - u.y);
												var cf = w.y * v.x - w.x * v.y;
												_this1.localCOMx += (v.x + w.x) * cf;
												_this1.localCOMy += (v.y + w.y) * cf;
												area = 1 / (3 * area);
												var t = area;
												_this1.localCOMx *= t;
												_this1.localCOMy *= t;
											}
										}
										if(_this.wrap_localCOM != null) {
											_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
											_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
										}
									}
									var _this1 = _this.body;
									if(_this1.zip_axis) {
										_this1.zip_axis = false;
										_this1.axisx = Math.sin(_this1.rot);
										_this1.axisy = Math.cos(_this1.rot);
									}
									_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
									_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
								}
							}
							var rx = _this.radius;
							var ry = _this.radius;
							_this.aabb.minx = _this.worldCOMx - rx;
							_this.aabb.miny = _this.worldCOMy - ry;
							_this.aabb.maxx = _this.worldCOMx + rx;
							_this.aabb.maxy = _this.worldCOMy + ry;
						} else {
							var _this = shape.polygon;
							if(_this.zip_gverts) {
								if(_this.body != null) {
									_this.zip_gverts = false;
									_this.validate_lverts();
									var _this1 = _this.body;
									if(_this1.zip_axis) {
										_this1.zip_axis = false;
										_this1.axisx = Math.sin(_this1.rot);
										_this1.axisy = Math.cos(_this1.rot);
									}
									var li = _this.lverts.next;
									var cx_ite = _this.gverts.next;
									while(cx_ite != null) {
										var g = cx_ite;
										var l = li;
										li = li.next;
										g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
										g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
										cx_ite = cx_ite.next;
									}
								}
							}
							var p0 = _this.gverts.next;
							_this.aabb.minx = p0.x;
							_this.aabb.miny = p0.y;
							_this.aabb.maxx = p0.x;
							_this.aabb.maxy = p0.y;
							var cx_ite = _this.gverts.next.next;
							while(cx_ite != null) {
								var p = cx_ite;
								if(p.x < _this.aabb.minx) {
									_this.aabb.minx = p.x;
								}
								if(p.x > _this.aabb.maxx) {
									_this.aabb.maxx = p.x;
								}
								if(p.y < _this.aabb.miny) {
									_this.aabb.miny = p.y;
								}
								if(p.y > _this.aabb.maxy) {
									_this.aabb.maxy = p.y;
								}
								cx_ite = cx_ite.next;
							}
						}
					}
				}
			}
		} else {
			var _this = this.dynab;
			var node = shape.node;
			if(!node.synced) {
				if(!_this.space.continuous) {
					if(shape.zip_aabb) {
						if(shape.body != null) {
							shape.zip_aabb = false;
							if(shape.type == 0) {
								var _this1 = shape.circle;
								if(_this1.zip_worldCOM) {
									if(_this1.body != null) {
										_this1.zip_worldCOM = false;
										if(_this1.zip_localCOM) {
											_this1.zip_localCOM = false;
											if(_this1.type == 1) {
												var _this2 = _this1.polygon;
												if(_this2.lverts.next.next == null) {
													_this2.localCOMx = _this2.lverts.next.x;
													_this2.localCOMy = _this2.lverts.next.y;
												} else if(_this2.lverts.next.next.next == null) {
													_this2.localCOMx = _this2.lverts.next.x;
													_this2.localCOMy = _this2.lverts.next.y;
													var t = 1.0;
													_this2.localCOMx += _this2.lverts.next.next.x * t;
													_this2.localCOMy += _this2.lverts.next.next.y * t;
													var t = 0.5;
													_this2.localCOMx *= t;
													_this2.localCOMy *= t;
												} else {
													_this2.localCOMx = 0;
													_this2.localCOMy = 0;
													var area = 0.0;
													var cx_ite = _this2.lverts.next;
													var u = cx_ite;
													cx_ite = cx_ite.next;
													var v = cx_ite;
													cx_ite = cx_ite.next;
													while(cx_ite != null) {
														var w = cx_ite;
														area += v.x * (w.y - u.y);
														var cf = w.y * v.x - w.x * v.y;
														_this2.localCOMx += (v.x + w.x) * cf;
														_this2.localCOMy += (v.y + w.y) * cf;
														u = v;
														v = w;
														cx_ite = cx_ite.next;
													}
													cx_ite = _this2.lverts.next;
													var w = cx_ite;
													area += v.x * (w.y - u.y);
													var cf = w.y * v.x - w.x * v.y;
													_this2.localCOMx += (v.x + w.x) * cf;
													_this2.localCOMy += (v.y + w.y) * cf;
													u = v;
													v = w;
													cx_ite = cx_ite.next;
													var w = cx_ite;
													area += v.x * (w.y - u.y);
													var cf = w.y * v.x - w.x * v.y;
													_this2.localCOMx += (v.x + w.x) * cf;
													_this2.localCOMy += (v.y + w.y) * cf;
													area = 1 / (3 * area);
													var t = area;
													_this2.localCOMx *= t;
													_this2.localCOMy *= t;
												}
											}
											if(_this1.wrap_localCOM != null) {
												_this1.wrap_localCOM.zpp_inner.x = _this1.localCOMx;
												_this1.wrap_localCOM.zpp_inner.y = _this1.localCOMy;
											}
										}
										var _this2 = _this1.body;
										if(_this2.zip_axis) {
											_this2.zip_axis = false;
											_this2.axisx = Math.sin(_this2.rot);
											_this2.axisy = Math.cos(_this2.rot);
										}
										_this1.worldCOMx = _this1.body.posx + (_this1.body.axisy * _this1.localCOMx - _this1.body.axisx * _this1.localCOMy);
										_this1.worldCOMy = _this1.body.posy + (_this1.localCOMx * _this1.body.axisx + _this1.localCOMy * _this1.body.axisy);
									}
								}
								var rx = _this1.radius;
								var ry = _this1.radius;
								_this1.aabb.minx = _this1.worldCOMx - rx;
								_this1.aabb.miny = _this1.worldCOMy - ry;
								_this1.aabb.maxx = _this1.worldCOMx + rx;
								_this1.aabb.maxy = _this1.worldCOMy + ry;
							} else {
								var _this1 = shape.polygon;
								if(_this1.zip_gverts) {
									if(_this1.body != null) {
										_this1.zip_gverts = false;
										_this1.validate_lverts();
										var _this2 = _this1.body;
										if(_this2.zip_axis) {
											_this2.zip_axis = false;
											_this2.axisx = Math.sin(_this2.rot);
											_this2.axisy = Math.cos(_this2.rot);
										}
										var li = _this1.lverts.next;
										var cx_ite = _this1.gverts.next;
										while(cx_ite != null) {
											var g = cx_ite;
											var l = li;
											li = li.next;
											g.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
											g.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
											cx_ite = cx_ite.next;
										}
									}
								}
								var p0 = _this1.gverts.next;
								_this1.aabb.minx = p0.x;
								_this1.aabb.miny = p0.y;
								_this1.aabb.maxx = p0.x;
								_this1.aabb.maxy = p0.y;
								var cx_ite = _this1.gverts.next.next;
								while(cx_ite != null) {
									var p = cx_ite;
									if(p.x < _this1.aabb.minx) {
										_this1.aabb.minx = p.x;
									}
									if(p.x > _this1.aabb.maxx) {
										_this1.aabb.maxx = p.x;
									}
									if(p.y < _this1.aabb.miny) {
										_this1.aabb.miny = p.y;
									}
									if(p.y > _this1.aabb.maxy) {
										_this1.aabb.maxy = p.y;
									}
									cx_ite = cx_ite.next;
								}
							}
						}
					}
				}
				var sync;
				if(node.dyn == (shape.body.type == 1 ? false : !shape.body.component.sleeping)) {
					var _this1 = node.aabb;
					var x = shape.aabb;
					sync = !(x.minx >= _this1.minx && x.miny >= _this1.miny && x.maxx <= _this1.maxx && x.maxy <= _this1.maxy);
				} else {
					sync = true;
				}
				if(sync) {
					node.synced = true;
					node.snext = _this.syncs;
					_this.syncs = node;
				}
			}
		}
	}
	,broadphase: function(space,discrete) {
	}
	,clear: function() {
	}
	,shapesUnderPoint: function(x,y,filter,output) {
		return null;
	}
	,bodiesUnderPoint: function(x,y,filter,output) {
		return null;
	}
	,updateAABBShape: function(aabb) {
		if(this.aabbShape == null) {
			if(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.BodyType_STATIC = new nape_phys_BodyType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			var body = new nape_phys_Body(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC);
			var _this = body.zpp_inner.wrap_shapes;
			var obj = this.aabbShape = new nape_shape_Polygon(nape_shape_Polygon.rect(aabb.minx,aabb.miny,aabb.maxx - aabb.minx,aabb.maxy - aabb.miny));
			if(_this.zpp_inner.reverse_flag) {
				_this.push(obj);
			} else {
				_this.unshift(obj);
			}
		} else {
			var ab = this.aabbShape.zpp_inner.aabb;
			var sx = (aabb.maxx - aabb.minx) / (ab.maxx - ab.minx);
			var sy = (aabb.maxy - aabb.miny) / (ab.maxy - ab.miny);
			if(this.matrix == null) {
				this.matrix = new nape_geom_Mat23();
			}
			var _this = this.matrix;
			_this.zpp_inner.a = sx;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			var _this1 = this.matrix;
			_this1.zpp_inner.c = 0;
			var _this2 = _this1.zpp_inner;
			if(_this2._invalidate != null) {
				_this2._invalidate();
			}
			_this.zpp_inner.b = _this1.zpp_inner.c;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			_this.zpp_inner.d = sy;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			_this.zpp_inner.tx = aabb.minx - sx * ab.minx;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			_this.zpp_inner.ty = aabb.miny - sy * ab.miny;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			this.aabbShape.transform(this.matrix);
		}
		var _this = this.aabbShape.zpp_inner;
		if(_this.zip_aabb) {
			if(_this.body != null) {
				_this.zip_aabb = false;
				if(_this.type == 0) {
					var _this1 = _this.circle;
					if(_this1.zip_worldCOM) {
						if(_this1.body != null) {
							_this1.zip_worldCOM = false;
							if(_this1.zip_localCOM) {
								_this1.zip_localCOM = false;
								if(_this1.type == 1) {
									var _this2 = _this1.polygon;
									if(_this2.lverts.next.next == null) {
										_this2.localCOMx = _this2.lverts.next.x;
										_this2.localCOMy = _this2.lverts.next.y;
									} else if(_this2.lverts.next.next.next == null) {
										_this2.localCOMx = _this2.lverts.next.x;
										_this2.localCOMy = _this2.lverts.next.y;
										var t = 1.0;
										_this2.localCOMx += _this2.lverts.next.next.x * t;
										_this2.localCOMy += _this2.lverts.next.next.y * t;
										var t = 0.5;
										_this2.localCOMx *= t;
										_this2.localCOMy *= t;
									} else {
										_this2.localCOMx = 0;
										_this2.localCOMy = 0;
										var area = 0.0;
										var cx_ite = _this2.lverts.next;
										var u = cx_ite;
										cx_ite = cx_ite.next;
										var v = cx_ite;
										cx_ite = cx_ite.next;
										while(cx_ite != null) {
											var w = cx_ite;
											area += v.x * (w.y - u.y);
											var cf = w.y * v.x - w.x * v.y;
											_this2.localCOMx += (v.x + w.x) * cf;
											_this2.localCOMy += (v.y + w.y) * cf;
											u = v;
											v = w;
											cx_ite = cx_ite.next;
										}
										cx_ite = _this2.lverts.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this2.localCOMx += (v.x + w.x) * cf;
										_this2.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this2.localCOMx += (v.x + w.x) * cf;
										_this2.localCOMy += (v.y + w.y) * cf;
										area = 1 / (3 * area);
										var t = area;
										_this2.localCOMx *= t;
										_this2.localCOMy *= t;
									}
								}
								if(_this1.wrap_localCOM != null) {
									_this1.wrap_localCOM.zpp_inner.x = _this1.localCOMx;
									_this1.wrap_localCOM.zpp_inner.y = _this1.localCOMy;
								}
							}
							var _this2 = _this1.body;
							if(_this2.zip_axis) {
								_this2.zip_axis = false;
								_this2.axisx = Math.sin(_this2.rot);
								_this2.axisy = Math.cos(_this2.rot);
							}
							_this1.worldCOMx = _this1.body.posx + (_this1.body.axisy * _this1.localCOMx - _this1.body.axisx * _this1.localCOMy);
							_this1.worldCOMy = _this1.body.posy + (_this1.localCOMx * _this1.body.axisx + _this1.localCOMy * _this1.body.axisy);
						}
					}
					var rx = _this1.radius;
					var ry = _this1.radius;
					_this1.aabb.minx = _this1.worldCOMx - rx;
					_this1.aabb.miny = _this1.worldCOMy - ry;
					_this1.aabb.maxx = _this1.worldCOMx + rx;
					_this1.aabb.maxy = _this1.worldCOMy + ry;
				} else {
					var _this1 = _this.polygon;
					if(_this1.zip_gverts) {
						if(_this1.body != null) {
							_this1.zip_gverts = false;
							_this1.validate_lverts();
							var _this = _this1.body;
							if(_this.zip_axis) {
								_this.zip_axis = false;
								_this.axisx = Math.sin(_this.rot);
								_this.axisy = Math.cos(_this.rot);
							}
							var li = _this1.lverts.next;
							var cx_ite = _this1.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
								g.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var p0 = _this1.gverts.next;
					_this1.aabb.minx = p0.x;
					_this1.aabb.miny = p0.y;
					_this1.aabb.maxx = p0.x;
					_this1.aabb.maxy = p0.y;
					var cx_ite = _this1.gverts.next.next;
					while(cx_ite != null) {
						var p = cx_ite;
						if(p.x < _this1.aabb.minx) {
							_this1.aabb.minx = p.x;
						}
						if(p.x > _this1.aabb.maxx) {
							_this1.aabb.maxx = p.x;
						}
						if(p.y < _this1.aabb.miny) {
							_this1.aabb.miny = p.y;
						}
						if(p.y > _this1.aabb.maxy) {
							_this1.aabb.maxy = p.y;
						}
						cx_ite = cx_ite.next;
					}
				}
			}
		}
		var _this = this.aabbShape.zpp_inner.polygon;
		if(_this.zip_gaxi) {
			if(_this.body != null) {
				_this.zip_gaxi = false;
				_this.validate_laxi();
				var _this1 = _this.body;
				if(_this1.zip_axis) {
					_this1.zip_axis = false;
					_this1.axisx = Math.sin(_this1.rot);
					_this1.axisy = Math.cos(_this1.rot);
				}
				if(_this.zip_gverts) {
					if(_this.body != null) {
						_this.zip_gverts = false;
						_this.validate_lverts();
						var _this1 = _this.body;
						if(_this1.zip_axis) {
							_this1.zip_axis = false;
							_this1.axisx = Math.sin(_this1.rot);
							_this1.axisy = Math.cos(_this1.rot);
						}
						var li = _this.lverts.next;
						var cx_ite = _this.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
							g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
							cx_ite = cx_ite.next;
						}
					}
				}
				var ite = _this.edges.head;
				var cx_ite = _this.gverts.next;
				var u = cx_ite;
				cx_ite = cx_ite.next;
				while(cx_ite != null) {
					var v = cx_ite;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
					u = v;
					cx_ite = cx_ite.next;
				}
				var v = _this.gverts.next;
				var e = ite.elt;
				ite = ite.next;
				e.gp0 = u;
				e.gp1 = v;
				e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
				e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
				e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
				if(e.wrap_gnorm != null) {
					e.wrap_gnorm.zpp_inner.x = e.gnormx;
					e.wrap_gnorm.zpp_inner.y = e.gnormy;
				}
				e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
				e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
			}
		}
	}
	,shapesInAABB: function(aabb,strict,containment,filter,output) {
		return null;
	}
	,bodiesInAABB: function(aabb,strict,containment,filter,output) {
		return null;
	}
	,updateCircShape: function(x,y,r) {
		if(this.circShape == null) {
			if(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC == null) {
				zpp_$nape_util_ZPP_$Flags.internal = true;
				zpp_$nape_util_ZPP_$Flags.BodyType_STATIC = new nape_phys_BodyType();
				zpp_$nape_util_ZPP_$Flags.internal = false;
			}
			var body = new nape_phys_Body(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC);
			var _this = body.zpp_inner.wrap_shapes;
			var x1 = x;
			var y1 = y;
			if(y1 == null) {
				y1 = 0;
			}
			if(x1 == null) {
				x1 = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x1;
				ret1.y = y1;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var obj;
				var _this1 = ret.zpp_inner;
				if(_this1._validate != null) {
					_this1._validate();
				}
				if(ret.zpp_inner.x == x1) {
					var _this1 = ret.zpp_inner;
					if(_this1._validate != null) {
						_this1._validate();
					}
					obj = ret.zpp_inner.y == y1;
				} else {
					obj = false;
				}
				if(!obj) {
					ret.zpp_inner.x = x1;
					ret.zpp_inner.y = y1;
					var _this1 = ret.zpp_inner;
					if(_this1._invalidate != null) {
						_this1._invalidate(_this1);
					}
				}
			}
			ret.zpp_inner.weak = false;
			var obj = this.circShape = new nape_shape_Circle(r,ret);
			if(_this.zpp_inner.reverse_flag) {
				_this.push(obj);
			} else {
				_this.unshift(obj);
			}
		} else {
			var ci = this.circShape.zpp_inner.circle;
			var ss = r / ci.radius;
			if(this.matrix == null) {
				this.matrix = new nape_geom_Mat23();
			}
			var _this = this.matrix;
			var _this1 = this.matrix;
			_this1.zpp_inner.d = ss;
			var _this2 = _this1.zpp_inner;
			if(_this2._invalidate != null) {
				_this2._invalidate();
			}
			_this.zpp_inner.a = _this1.zpp_inner.d;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			var _this1 = this.matrix;
			_this1.zpp_inner.c = 0;
			var _this2 = _this1.zpp_inner;
			if(_this2._invalidate != null) {
				_this2._invalidate();
			}
			_this.zpp_inner.b = _this1.zpp_inner.c;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			_this.zpp_inner.tx = x - ss * ci.localCOMx;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			var _this = this.matrix;
			_this.zpp_inner.ty = y - ss * ci.localCOMy;
			var _this1 = _this.zpp_inner;
			if(_this1._invalidate != null) {
				_this1._invalidate();
			}
			this.circShape.transform(this.matrix);
		}
		var _this = this.circShape.zpp_inner;
		if(_this.zip_aabb) {
			if(_this.body != null) {
				_this.zip_aabb = false;
				if(_this.type == 0) {
					var _this1 = _this.circle;
					if(_this1.zip_worldCOM) {
						if(_this1.body != null) {
							_this1.zip_worldCOM = false;
							if(_this1.zip_localCOM) {
								_this1.zip_localCOM = false;
								if(_this1.type == 1) {
									var _this2 = _this1.polygon;
									if(_this2.lverts.next.next == null) {
										_this2.localCOMx = _this2.lverts.next.x;
										_this2.localCOMy = _this2.lverts.next.y;
									} else if(_this2.lverts.next.next.next == null) {
										_this2.localCOMx = _this2.lverts.next.x;
										_this2.localCOMy = _this2.lverts.next.y;
										var t = 1.0;
										_this2.localCOMx += _this2.lverts.next.next.x * t;
										_this2.localCOMy += _this2.lverts.next.next.y * t;
										var t = 0.5;
										_this2.localCOMx *= t;
										_this2.localCOMy *= t;
									} else {
										_this2.localCOMx = 0;
										_this2.localCOMy = 0;
										var area = 0.0;
										var cx_ite = _this2.lverts.next;
										var u = cx_ite;
										cx_ite = cx_ite.next;
										var v = cx_ite;
										cx_ite = cx_ite.next;
										while(cx_ite != null) {
											var w = cx_ite;
											area += v.x * (w.y - u.y);
											var cf = w.y * v.x - w.x * v.y;
											_this2.localCOMx += (v.x + w.x) * cf;
											_this2.localCOMy += (v.y + w.y) * cf;
											u = v;
											v = w;
											cx_ite = cx_ite.next;
										}
										cx_ite = _this2.lverts.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this2.localCOMx += (v.x + w.x) * cf;
										_this2.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this2.localCOMx += (v.x + w.x) * cf;
										_this2.localCOMy += (v.y + w.y) * cf;
										area = 1 / (3 * area);
										var t = area;
										_this2.localCOMx *= t;
										_this2.localCOMy *= t;
									}
								}
								if(_this1.wrap_localCOM != null) {
									_this1.wrap_localCOM.zpp_inner.x = _this1.localCOMx;
									_this1.wrap_localCOM.zpp_inner.y = _this1.localCOMy;
								}
							}
							var _this2 = _this1.body;
							if(_this2.zip_axis) {
								_this2.zip_axis = false;
								_this2.axisx = Math.sin(_this2.rot);
								_this2.axisy = Math.cos(_this2.rot);
							}
							_this1.worldCOMx = _this1.body.posx + (_this1.body.axisy * _this1.localCOMx - _this1.body.axisx * _this1.localCOMy);
							_this1.worldCOMy = _this1.body.posy + (_this1.localCOMx * _this1.body.axisx + _this1.localCOMy * _this1.body.axisy);
						}
					}
					var rx = _this1.radius;
					var ry = _this1.radius;
					_this1.aabb.minx = _this1.worldCOMx - rx;
					_this1.aabb.miny = _this1.worldCOMy - ry;
					_this1.aabb.maxx = _this1.worldCOMx + rx;
					_this1.aabb.maxy = _this1.worldCOMy + ry;
				} else {
					var _this1 = _this.polygon;
					if(_this1.zip_gverts) {
						if(_this1.body != null) {
							_this1.zip_gverts = false;
							_this1.validate_lverts();
							var _this = _this1.body;
							if(_this.zip_axis) {
								_this.zip_axis = false;
								_this.axisx = Math.sin(_this.rot);
								_this.axisy = Math.cos(_this.rot);
							}
							var li = _this1.lverts.next;
							var cx_ite = _this1.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
								g.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var p0 = _this1.gverts.next;
					_this1.aabb.minx = p0.x;
					_this1.aabb.miny = p0.y;
					_this1.aabb.maxx = p0.x;
					_this1.aabb.maxy = p0.y;
					var cx_ite = _this1.gverts.next.next;
					while(cx_ite != null) {
						var p = cx_ite;
						if(p.x < _this1.aabb.minx) {
							_this1.aabb.minx = p.x;
						}
						if(p.x > _this1.aabb.maxx) {
							_this1.aabb.maxx = p.x;
						}
						if(p.y < _this1.aabb.miny) {
							_this1.aabb.miny = p.y;
						}
						if(p.y > _this1.aabb.maxy) {
							_this1.aabb.maxy = p.y;
						}
						cx_ite = cx_ite.next;
					}
				}
			}
		}
	}
	,shapesInCircle: function(x,y,r,containment,filter,output) {
		return null;
	}
	,bodiesInCircle: function(x,y,r,containment,filter,output) {
		return null;
	}
	,validateShape: function(s) {
		if(s.type == 1) {
			var _this = s.polygon;
			if(_this.zip_gaxi) {
				if(_this.body != null) {
					_this.zip_gaxi = false;
					_this.validate_laxi();
					var _this1 = _this.body;
					if(_this1.zip_axis) {
						_this1.zip_axis = false;
						_this1.axisx = Math.sin(_this1.rot);
						_this1.axisy = Math.cos(_this1.rot);
					}
					if(_this.zip_gverts) {
						if(_this.body != null) {
							_this.zip_gverts = false;
							_this.validate_lverts();
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							var li = _this.lverts.next;
							var cx_ite = _this.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
								g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var ite = _this.edges.head;
					var cx_ite = _this.gverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var v = cx_ite;
						var e = ite.elt;
						ite = ite.next;
						e.gp0 = u;
						e.gp1 = v;
						e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
						e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
						e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
						if(e.wrap_gnorm != null) {
							e.wrap_gnorm.zpp_inner.x = e.gnormx;
							e.wrap_gnorm.zpp_inner.y = e.gnormy;
						}
						e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
						e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
						u = v;
						cx_ite = cx_ite.next;
					}
					var v = _this.gverts.next;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
				}
			}
		}
		if(s.zip_aabb) {
			if(s.body != null) {
				s.zip_aabb = false;
				if(s.type == 0) {
					var _this = s.circle;
					if(_this.zip_worldCOM) {
						if(_this.body != null) {
							_this.zip_worldCOM = false;
							if(_this.zip_localCOM) {
								_this.zip_localCOM = false;
								if(_this.type == 1) {
									var _this1 = _this.polygon;
									if(_this1.lverts.next.next == null) {
										_this1.localCOMx = _this1.lverts.next.x;
										_this1.localCOMy = _this1.lverts.next.y;
									} else if(_this1.lverts.next.next.next == null) {
										_this1.localCOMx = _this1.lverts.next.x;
										_this1.localCOMy = _this1.lverts.next.y;
										var t = 1.0;
										_this1.localCOMx += _this1.lverts.next.next.x * t;
										_this1.localCOMy += _this1.lverts.next.next.y * t;
										var t = 0.5;
										_this1.localCOMx *= t;
										_this1.localCOMy *= t;
									} else {
										_this1.localCOMx = 0;
										_this1.localCOMy = 0;
										var area = 0.0;
										var cx_ite = _this1.lverts.next;
										var u = cx_ite;
										cx_ite = cx_ite.next;
										var v = cx_ite;
										cx_ite = cx_ite.next;
										while(cx_ite != null) {
											var w = cx_ite;
											area += v.x * (w.y - u.y);
											var cf = w.y * v.x - w.x * v.y;
											_this1.localCOMx += (v.x + w.x) * cf;
											_this1.localCOMy += (v.y + w.y) * cf;
											u = v;
											v = w;
											cx_ite = cx_ite.next;
										}
										cx_ite = _this1.lverts.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										u = v;
										v = w;
										cx_ite = cx_ite.next;
										var w = cx_ite;
										area += v.x * (w.y - u.y);
										var cf = w.y * v.x - w.x * v.y;
										_this1.localCOMx += (v.x + w.x) * cf;
										_this1.localCOMy += (v.y + w.y) * cf;
										area = 1 / (3 * area);
										var t = area;
										_this1.localCOMx *= t;
										_this1.localCOMy *= t;
									}
								}
								if(_this.wrap_localCOM != null) {
									_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
									_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
								}
							}
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
							_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
						}
					}
					var rx = _this.radius;
					var ry = _this.radius;
					_this.aabb.minx = _this.worldCOMx - rx;
					_this.aabb.miny = _this.worldCOMy - ry;
					_this.aabb.maxx = _this.worldCOMx + rx;
					_this.aabb.maxy = _this.worldCOMy + ry;
				} else {
					var _this = s.polygon;
					if(_this.zip_gverts) {
						if(_this.body != null) {
							_this.zip_gverts = false;
							_this.validate_lverts();
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							var li = _this.lverts.next;
							var cx_ite = _this.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
								g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var p0 = _this.gverts.next;
					_this.aabb.minx = p0.x;
					_this.aabb.miny = p0.y;
					_this.aabb.maxx = p0.x;
					_this.aabb.maxy = p0.y;
					var cx_ite = _this.gverts.next.next;
					while(cx_ite != null) {
						var p = cx_ite;
						if(p.x < _this.aabb.minx) {
							_this.aabb.minx = p.x;
						}
						if(p.x > _this.aabb.maxx) {
							_this.aabb.maxx = p.x;
						}
						if(p.y < _this.aabb.miny) {
							_this.aabb.miny = p.y;
						}
						if(p.y > _this.aabb.maxy) {
							_this.aabb.maxy = p.y;
						}
						cx_ite = cx_ite.next;
					}
				}
			}
		}
		if(s.zip_worldCOM) {
			if(s.body != null) {
				s.zip_worldCOM = false;
				if(s.zip_localCOM) {
					s.zip_localCOM = false;
					if(s.type == 1) {
						var _this = s.polygon;
						if(_this.lverts.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
						} else if(_this.lverts.next.next.next == null) {
							_this.localCOMx = _this.lverts.next.x;
							_this.localCOMy = _this.lverts.next.y;
							var t = 1.0;
							_this.localCOMx += _this.lverts.next.next.x * t;
							_this.localCOMy += _this.lverts.next.next.y * t;
							var t = 0.5;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						} else {
							_this.localCOMx = 0;
							_this.localCOMy = 0;
							var area = 0.0;
							var cx_ite = _this.lverts.next;
							var u = cx_ite;
							cx_ite = cx_ite.next;
							var v = cx_ite;
							cx_ite = cx_ite.next;
							while(cx_ite != null) {
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this.localCOMx += (v.x + w.x) * cf;
								_this.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite = cx_ite.next;
							}
							cx_ite = _this.lverts.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							u = v;
							v = w;
							cx_ite = cx_ite.next;
							var w = cx_ite;
							area += v.x * (w.y - u.y);
							var cf = w.y * v.x - w.x * v.y;
							_this.localCOMx += (v.x + w.x) * cf;
							_this.localCOMy += (v.y + w.y) * cf;
							area = 1 / (3 * area);
							var t = area;
							_this.localCOMx *= t;
							_this.localCOMy *= t;
						}
					}
					if(s.wrap_localCOM != null) {
						s.wrap_localCOM.zpp_inner.x = s.localCOMx;
						s.wrap_localCOM.zpp_inner.y = s.localCOMy;
					}
				}
				var _this = s.body;
				if(_this.zip_axis) {
					_this.zip_axis = false;
					_this.axisx = Math.sin(_this.rot);
					_this.axisy = Math.cos(_this.rot);
				}
				s.worldCOMx = s.body.posx + (s.body.axisy * s.localCOMx - s.body.axisx * s.localCOMy);
				s.worldCOMy = s.body.posy + (s.localCOMx * s.body.axisx + s.localCOMy * s.body.axisy);
			}
		}
	}
	,shapesInShape: function(shape,containment,filter,output) {
		return null;
	}
	,bodiesInShape: function(shape,containment,filter,output) {
		return null;
	}
	,rayCast: function(ray,inner,filter) {
		return null;
	}
	,rayMultiCast: function(ray,inner,filter,output) {
		return null;
	}
};
var zpp_$nape_space_ZPP_$AABBNode = function() {
	this.first_sync = false;
	this.synced = false;
	this.snext = null;
	this.moved = false;
	this.mnext = null;
	this.next = null;
	this.rayt = 0.0;
	this.height = 0;
	this.child2 = null;
	this.child1 = null;
	this.parent = null;
	this.dyn = false;
	this.shape = null;
	this.aabb = null;
	this.height = -1;
};
zpp_$nape_space_ZPP_$AABBNode.__name__ = true;
var zpp_$nape_space_ZPP_$AABBPair = function() {
	this.next = null;
	this.arb = null;
	this.di = 0;
	this.id = 0;
	this.sleeping = false;
	this.first = false;
	this.n2 = null;
	this.n1 = null;
};
zpp_$nape_space_ZPP_$AABBPair.__name__ = true;
var zpp_$nape_space_ZPP_$AABBTree = function() {
	this.root = null;
};
zpp_$nape_space_ZPP_$AABBTree.__name__ = true;
zpp_$nape_space_ZPP_$AABBTree.prototype = {
	clear: function() {
		if(this.root == null) {
			return;
		}
		var stack = null;
		this.root.next = stack;
		stack = this.root;
		while(stack != null) {
			var ret = stack;
			stack = ret.next;
			ret.next = null;
			var node = ret;
			if(node.child1 == null) {
				node.shape.node = null;
				node.shape.removedFromSpace();
				node.shape = null;
			} else {
				if(node.child1 != null) {
					node.child1.next = stack;
					stack = node.child1;
				}
				if(node.child2 != null) {
					node.child2.next = stack;
					stack = node.child2;
				}
			}
			var o = node;
			o.height = -1;
			var o1 = o.aabb;
			if(o1.outer != null) {
				o1.outer.zpp_inner = null;
				o1.outer = null;
			}
			o1.wrap_min = o1.wrap_max = null;
			o1._invalidate = null;
			o1._validate = null;
			o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
			o.child1 = o.child2 = o.parent = null;
			o.next = null;
			o.snext = null;
			o.mnext = null;
			o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
			zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
		}
		this.root = null;
	}
	,removeLeaf: function(leaf) {
		if(leaf == this.root) {
			this.root = null;
		} else {
			var parent = leaf.parent;
			var gparent = parent.parent;
			var sibling = parent.child1 == leaf ? parent.child2 : parent.child1;
			if(gparent != null) {
				if(gparent.child1 == parent) {
					gparent.child1 = sibling;
				} else {
					gparent.child2 = sibling;
				}
				sibling.parent = gparent;
				var o = parent;
				o.height = -1;
				var o1 = o.aabb;
				if(o1.outer != null) {
					o1.outer.zpp_inner = null;
					o1.outer = null;
				}
				o1.wrap_min = o1.wrap_max = null;
				o1._invalidate = null;
				o1._validate = null;
				o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
				zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
				o.child1 = o.child2 = o.parent = null;
				o.next = null;
				o.snext = null;
				o.mnext = null;
				o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
				zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
				var node = gparent;
				while(node != null) {
					if(!(node.child1 == null || node.height < 2)) {
						var b = node.child1;
						var c = node.child2;
						var balance = c.height - b.height;
						if(balance > 1) {
							var f = c.child1;
							var g = c.child2;
							c.child1 = node;
							c.parent = node.parent;
							node.parent = c;
							if(c.parent != null) {
								if(c.parent.child1 == node) {
									c.parent.child1 = c;
								} else {
									c.parent.child2 = c;
								}
							} else {
								this.root = c;
							}
							if(f.height > g.height) {
								c.child2 = f;
								node.child2 = g;
								g.parent = node;
								var _this = node.aabb;
								var a = b.aabb;
								var b1 = g.aabb;
								_this.minx = a.minx < b1.minx ? a.minx : b1.minx;
								_this.miny = a.miny < b1.miny ? a.miny : b1.miny;
								_this.maxx = a.maxx > b1.maxx ? a.maxx : b1.maxx;
								_this.maxy = a.maxy > b1.maxy ? a.maxy : b1.maxy;
								var _this1 = c.aabb;
								var a1 = node.aabb;
								var b2 = f.aabb;
								_this1.minx = a1.minx < b2.minx ? a1.minx : b2.minx;
								_this1.miny = a1.miny < b2.miny ? a1.miny : b2.miny;
								_this1.maxx = a1.maxx > b2.maxx ? a1.maxx : b2.maxx;
								_this1.maxy = a1.maxy > b2.maxy ? a1.maxy : b2.maxy;
								var x = b.height;
								var y = g.height;
								node.height = 1 + (x > y ? x : y);
								var x1 = node.height;
								var y1 = f.height;
								c.height = 1 + (x1 > y1 ? x1 : y1);
							} else {
								c.child2 = g;
								node.child2 = f;
								f.parent = node;
								var _this2 = node.aabb;
								var a2 = b.aabb;
								var b3 = f.aabb;
								_this2.minx = a2.minx < b3.minx ? a2.minx : b3.minx;
								_this2.miny = a2.miny < b3.miny ? a2.miny : b3.miny;
								_this2.maxx = a2.maxx > b3.maxx ? a2.maxx : b3.maxx;
								_this2.maxy = a2.maxy > b3.maxy ? a2.maxy : b3.maxy;
								var _this3 = c.aabb;
								var a3 = node.aabb;
								var b4 = g.aabb;
								_this3.minx = a3.minx < b4.minx ? a3.minx : b4.minx;
								_this3.miny = a3.miny < b4.miny ? a3.miny : b4.miny;
								_this3.maxx = a3.maxx > b4.maxx ? a3.maxx : b4.maxx;
								_this3.maxy = a3.maxy > b4.maxy ? a3.maxy : b4.maxy;
								var x2 = b.height;
								var y2 = f.height;
								node.height = 1 + (x2 > y2 ? x2 : y2);
								var x3 = node.height;
								var y3 = g.height;
								c.height = 1 + (x3 > y3 ? x3 : y3);
							}
							node = c;
						} else if(balance < -1) {
							var f1 = b.child1;
							var g1 = b.child2;
							b.child1 = node;
							b.parent = node.parent;
							node.parent = b;
							if(b.parent != null) {
								if(b.parent.child1 == node) {
									b.parent.child1 = b;
								} else {
									b.parent.child2 = b;
								}
							} else {
								this.root = b;
							}
							if(f1.height > g1.height) {
								b.child2 = f1;
								node.child1 = g1;
								g1.parent = node;
								var _this4 = node.aabb;
								var a4 = c.aabb;
								var b5 = g1.aabb;
								_this4.minx = a4.minx < b5.minx ? a4.minx : b5.minx;
								_this4.miny = a4.miny < b5.miny ? a4.miny : b5.miny;
								_this4.maxx = a4.maxx > b5.maxx ? a4.maxx : b5.maxx;
								_this4.maxy = a4.maxy > b5.maxy ? a4.maxy : b5.maxy;
								var _this5 = b.aabb;
								var a5 = node.aabb;
								var b6 = f1.aabb;
								_this5.minx = a5.minx < b6.minx ? a5.minx : b6.minx;
								_this5.miny = a5.miny < b6.miny ? a5.miny : b6.miny;
								_this5.maxx = a5.maxx > b6.maxx ? a5.maxx : b6.maxx;
								_this5.maxy = a5.maxy > b6.maxy ? a5.maxy : b6.maxy;
								var x4 = c.height;
								var y4 = g1.height;
								node.height = 1 + (x4 > y4 ? x4 : y4);
								var x5 = node.height;
								var y5 = f1.height;
								b.height = 1 + (x5 > y5 ? x5 : y5);
							} else {
								b.child2 = g1;
								node.child1 = f1;
								f1.parent = node;
								var _this6 = node.aabb;
								var a6 = c.aabb;
								var b7 = f1.aabb;
								_this6.minx = a6.minx < b7.minx ? a6.minx : b7.minx;
								_this6.miny = a6.miny < b7.miny ? a6.miny : b7.miny;
								_this6.maxx = a6.maxx > b7.maxx ? a6.maxx : b7.maxx;
								_this6.maxy = a6.maxy > b7.maxy ? a6.maxy : b7.maxy;
								var _this7 = b.aabb;
								var a7 = node.aabb;
								var b8 = g1.aabb;
								_this7.minx = a7.minx < b8.minx ? a7.minx : b8.minx;
								_this7.miny = a7.miny < b8.miny ? a7.miny : b8.miny;
								_this7.maxx = a7.maxx > b8.maxx ? a7.maxx : b8.maxx;
								_this7.maxy = a7.maxy > b8.maxy ? a7.maxy : b8.maxy;
								var x6 = c.height;
								var y6 = f1.height;
								node.height = 1 + (x6 > y6 ? x6 : y6);
								var x7 = node.height;
								var y7 = g1.height;
								b.height = 1 + (x7 > y7 ? x7 : y7);
							}
							node = b;
						}
					}
					var child1 = node.child1;
					var child2 = node.child2;
					var _this8 = node.aabb;
					var a8 = child1.aabb;
					var b9 = child2.aabb;
					_this8.minx = a8.minx < b9.minx ? a8.minx : b9.minx;
					_this8.miny = a8.miny < b9.miny ? a8.miny : b9.miny;
					_this8.maxx = a8.maxx > b9.maxx ? a8.maxx : b9.maxx;
					_this8.maxy = a8.maxy > b9.maxy ? a8.maxy : b9.maxy;
					var x8 = child1.height;
					var y8 = child2.height;
					node.height = 1 + (x8 > y8 ? x8 : y8);
					node = node.parent;
				}
			} else {
				this.root = sibling;
				sibling.parent = null;
				var o = parent;
				o.height = -1;
				var o1 = o.aabb;
				if(o1.outer != null) {
					o1.outer.zpp_inner = null;
					o1.outer = null;
				}
				o1.wrap_min = o1.wrap_max = null;
				o1._invalidate = null;
				o1._validate = null;
				o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
				zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
				o.child1 = o.child2 = o.parent = null;
				o.next = null;
				o.snext = null;
				o.mnext = null;
				o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
				zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
			}
		}
	}
};
var zpp_$nape_space_ZPP_$DynAABBPhase = function(space) {
	this.openlist = null;
	this.failed = null;
	this.treeStack2 = null;
	this.treeStack = null;
	this.moves = null;
	this.syncs = null;
	this.pairs = null;
	this.dtree = null;
	this.stree = null;
	zpp_$nape_space_ZPP_$Broadphase.call(this);
	this.space = space;
	this.is_sweep = false;
	this.dynab = this;
	this.stree = new zpp_$nape_space_ZPP_$AABBTree();
	this.dtree = new zpp_$nape_space_ZPP_$AABBTree();
};
zpp_$nape_space_ZPP_$DynAABBPhase.__name__ = true;
zpp_$nape_space_ZPP_$DynAABBPhase.__super__ = zpp_$nape_space_ZPP_$Broadphase;
zpp_$nape_space_ZPP_$DynAABBPhase.prototype = $extend(zpp_$nape_space_ZPP_$Broadphase.prototype,{
	__insert: function(shape) {
		var node;
		if(zpp_$nape_space_ZPP_$AABBNode.zpp_pool == null) {
			node = new zpp_$nape_space_ZPP_$AABBNode();
		} else {
			node = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
			zpp_$nape_space_ZPP_$AABBNode.zpp_pool = node.next;
			node.next = null;
		}
		if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
			node.aabb = new zpp_$nape_geom_ZPP_$AABB();
		} else {
			node.aabb = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = node.aabb.next;
			node.aabb.next = null;
		}
		node.moved = false;
		node.synced = false;
		node.first_sync = false;
		node.shape = shape;
		shape.node = node;
		node.synced = true;
		node.first_sync = true;
		node.snext = this.syncs;
		this.syncs = node;
	}
	,__remove: function(shape) {
		var node = shape.node;
		if(!node.first_sync) {
			if(node.dyn) {
				this.dtree.removeLeaf(node);
			} else {
				this.stree.removeLeaf(node);
			}
		}
		shape.node = null;
		if(node.synced) {
			var pre = null;
			var cur = this.syncs;
			while(cur != null) {
				if(cur == node) {
					break;
				}
				pre = cur;
				cur = cur.snext;
			}
			if(pre == null) {
				this.syncs = cur.snext;
			} else {
				pre.snext = cur.snext;
			}
			cur.snext = null;
			node.synced = false;
		}
		if(node.moved) {
			var pre = null;
			var cur = this.moves;
			while(cur != null) {
				if(cur == node) {
					break;
				}
				pre = cur;
				cur = cur.mnext;
			}
			if(pre == null) {
				this.moves = cur.mnext;
			} else {
				pre.mnext = cur.mnext;
			}
			cur.mnext = null;
			node.moved = false;
		}
		var pre = null;
		var cur = this.pairs;
		while(cur != null) {
			var nxt = cur.next;
			if(cur.n1 == node || cur.n2 == node) {
				if(pre == null) {
					this.pairs = nxt;
				} else {
					pre.next = nxt;
				}
				if(cur.arb != null) {
					cur.arb.pair = null;
				}
				cur.arb = null;
				cur.n1.shape.pairs.remove(cur);
				cur.n2.shape.pairs.remove(cur);
				var o = cur;
				o.n1 = o.n2 = null;
				o.sleeping = false;
				o.next = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
				zpp_$nape_space_ZPP_$AABBPair.zpp_pool = o;
				cur = nxt;
				continue;
			}
			pre = cur;
			cur = nxt;
		}
		while(shape.pairs.head != null) {
			var cur = shape.pairs.pop_unsafe();
			if(cur.n1 == node) {
				cur.n2.shape.pairs.remove(cur);
			} else {
				cur.n1.shape.pairs.remove(cur);
			}
			if(cur.arb != null) {
				cur.arb.pair = null;
			}
			cur.arb = null;
			var o = cur;
			o.n1 = o.n2 = null;
			o.sleeping = false;
			o.next = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
			zpp_$nape_space_ZPP_$AABBPair.zpp_pool = o;
		}
		var o = node;
		o.height = -1;
		var o1 = o.aabb;
		if(o1.outer != null) {
			o1.outer.zpp_inner = null;
			o1.outer = null;
		}
		o1.wrap_min = o1.wrap_max = null;
		o1._invalidate = null;
		o1._validate = null;
		o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
		o.child1 = o.child2 = o.parent = null;
		o.next = null;
		o.snext = null;
		o.mnext = null;
		o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
		zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
	}
	,sync_broadphase: function() {
		this.space.validation();
		if(this.syncs != null) {
			if(this.moves == null) {
				var node = this.syncs;
				while(node != null) {
					var shape = node.shape;
					if(!node.first_sync) {
						var tree = node.dyn ? this.dtree : this.stree;
						if(node == tree.root) {
							tree.root = null;
						} else {
							var parent = node.parent;
							var gparent = parent.parent;
							var sibling = parent.child1 == node ? parent.child2 : parent.child1;
							if(gparent != null) {
								if(gparent.child1 == parent) {
									gparent.child1 = sibling;
								} else {
									gparent.child2 = sibling;
								}
								sibling.parent = gparent;
								var o = parent;
								o.height = -1;
								var o1 = o.aabb;
								if(o1.outer != null) {
									o1.outer.zpp_inner = null;
									o1.outer = null;
								}
								o1.wrap_min = o1.wrap_max = null;
								o1._invalidate = null;
								o1._validate = null;
								o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
								zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
								o.child1 = o.child2 = o.parent = null;
								o.next = null;
								o.snext = null;
								o.mnext = null;
								o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
								zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
								var node1 = gparent;
								while(node1 != null) {
									if(!(node1.child1 == null || node1.height < 2)) {
										var b = node1.child1;
										var c = node1.child2;
										var balance = c.height - b.height;
										if(balance > 1) {
											var f = c.child1;
											var g = c.child2;
											c.child1 = node1;
											c.parent = node1.parent;
											node1.parent = c;
											if(c.parent != null) {
												if(c.parent.child1 == node1) {
													c.parent.child1 = c;
												} else {
													c.parent.child2 = c;
												}
											} else {
												tree.root = c;
											}
											if(f.height > g.height) {
												c.child2 = f;
												node1.child2 = g;
												g.parent = node1;
												var _this = node1.aabb;
												var a = b.aabb;
												var b1 = g.aabb;
												_this.minx = a.minx < b1.minx ? a.minx : b1.minx;
												_this.miny = a.miny < b1.miny ? a.miny : b1.miny;
												_this.maxx = a.maxx > b1.maxx ? a.maxx : b1.maxx;
												_this.maxy = a.maxy > b1.maxy ? a.maxy : b1.maxy;
												var _this1 = c.aabb;
												var a1 = node1.aabb;
												var b2 = f.aabb;
												_this1.minx = a1.minx < b2.minx ? a1.minx : b2.minx;
												_this1.miny = a1.miny < b2.miny ? a1.miny : b2.miny;
												_this1.maxx = a1.maxx > b2.maxx ? a1.maxx : b2.maxx;
												_this1.maxy = a1.maxy > b2.maxy ? a1.maxy : b2.maxy;
												var x = b.height;
												var y = g.height;
												node1.height = 1 + (x > y ? x : y);
												var x1 = node1.height;
												var y1 = f.height;
												c.height = 1 + (x1 > y1 ? x1 : y1);
											} else {
												c.child2 = g;
												node1.child2 = f;
												f.parent = node1;
												var _this2 = node1.aabb;
												var a2 = b.aabb;
												var b3 = f.aabb;
												_this2.minx = a2.minx < b3.minx ? a2.minx : b3.minx;
												_this2.miny = a2.miny < b3.miny ? a2.miny : b3.miny;
												_this2.maxx = a2.maxx > b3.maxx ? a2.maxx : b3.maxx;
												_this2.maxy = a2.maxy > b3.maxy ? a2.maxy : b3.maxy;
												var _this3 = c.aabb;
												var a3 = node1.aabb;
												var b4 = g.aabb;
												_this3.minx = a3.minx < b4.minx ? a3.minx : b4.minx;
												_this3.miny = a3.miny < b4.miny ? a3.miny : b4.miny;
												_this3.maxx = a3.maxx > b4.maxx ? a3.maxx : b4.maxx;
												_this3.maxy = a3.maxy > b4.maxy ? a3.maxy : b4.maxy;
												var x2 = b.height;
												var y2 = f.height;
												node1.height = 1 + (x2 > y2 ? x2 : y2);
												var x3 = node1.height;
												var y3 = g.height;
												c.height = 1 + (x3 > y3 ? x3 : y3);
											}
											node1 = c;
										} else if(balance < -1) {
											var f1 = b.child1;
											var g1 = b.child2;
											b.child1 = node1;
											b.parent = node1.parent;
											node1.parent = b;
											if(b.parent != null) {
												if(b.parent.child1 == node1) {
													b.parent.child1 = b;
												} else {
													b.parent.child2 = b;
												}
											} else {
												tree.root = b;
											}
											if(f1.height > g1.height) {
												b.child2 = f1;
												node1.child1 = g1;
												g1.parent = node1;
												var _this4 = node1.aabb;
												var a4 = c.aabb;
												var b5 = g1.aabb;
												_this4.minx = a4.minx < b5.minx ? a4.minx : b5.minx;
												_this4.miny = a4.miny < b5.miny ? a4.miny : b5.miny;
												_this4.maxx = a4.maxx > b5.maxx ? a4.maxx : b5.maxx;
												_this4.maxy = a4.maxy > b5.maxy ? a4.maxy : b5.maxy;
												var _this5 = b.aabb;
												var a5 = node1.aabb;
												var b6 = f1.aabb;
												_this5.minx = a5.minx < b6.minx ? a5.minx : b6.minx;
												_this5.miny = a5.miny < b6.miny ? a5.miny : b6.miny;
												_this5.maxx = a5.maxx > b6.maxx ? a5.maxx : b6.maxx;
												_this5.maxy = a5.maxy > b6.maxy ? a5.maxy : b6.maxy;
												var x4 = c.height;
												var y4 = g1.height;
												node1.height = 1 + (x4 > y4 ? x4 : y4);
												var x5 = node1.height;
												var y5 = f1.height;
												b.height = 1 + (x5 > y5 ? x5 : y5);
											} else {
												b.child2 = g1;
												node1.child1 = f1;
												f1.parent = node1;
												var _this6 = node1.aabb;
												var a6 = c.aabb;
												var b7 = f1.aabb;
												_this6.minx = a6.minx < b7.minx ? a6.minx : b7.minx;
												_this6.miny = a6.miny < b7.miny ? a6.miny : b7.miny;
												_this6.maxx = a6.maxx > b7.maxx ? a6.maxx : b7.maxx;
												_this6.maxy = a6.maxy > b7.maxy ? a6.maxy : b7.maxy;
												var _this7 = b.aabb;
												var a7 = node1.aabb;
												var b8 = g1.aabb;
												_this7.minx = a7.minx < b8.minx ? a7.minx : b8.minx;
												_this7.miny = a7.miny < b8.miny ? a7.miny : b8.miny;
												_this7.maxx = a7.maxx > b8.maxx ? a7.maxx : b8.maxx;
												_this7.maxy = a7.maxy > b8.maxy ? a7.maxy : b8.maxy;
												var x6 = c.height;
												var y6 = f1.height;
												node1.height = 1 + (x6 > y6 ? x6 : y6);
												var x7 = node1.height;
												var y7 = g1.height;
												b.height = 1 + (x7 > y7 ? x7 : y7);
											}
											node1 = b;
										}
									}
									var child1 = node1.child1;
									var child2 = node1.child2;
									var _this8 = node1.aabb;
									var a8 = child1.aabb;
									var b9 = child2.aabb;
									_this8.minx = a8.minx < b9.minx ? a8.minx : b9.minx;
									_this8.miny = a8.miny < b9.miny ? a8.miny : b9.miny;
									_this8.maxx = a8.maxx > b9.maxx ? a8.maxx : b9.maxx;
									_this8.maxy = a8.maxy > b9.maxy ? a8.maxy : b9.maxy;
									var x8 = child1.height;
									var y8 = child2.height;
									node1.height = 1 + (x8 > y8 ? x8 : y8);
									node1 = node1.parent;
								}
							} else {
								tree.root = sibling;
								sibling.parent = null;
								var o2 = parent;
								o2.height = -1;
								var o3 = o2.aabb;
								if(o3.outer != null) {
									o3.outer.zpp_inner = null;
									o3.outer = null;
								}
								o3.wrap_min = o3.wrap_max = null;
								o3._invalidate = null;
								o3._validate = null;
								o3.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
								zpp_$nape_geom_ZPP_$AABB.zpp_pool = o3;
								o2.child1 = o2.child2 = o2.parent = null;
								o2.next = null;
								o2.snext = null;
								o2.mnext = null;
								o2.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
								zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o2;
							}
						}
					} else {
						node.first_sync = false;
					}
					var aabb = node.aabb;
					if(!this.space.continuous) {
						if(shape.zip_aabb) {
							if(shape.body != null) {
								shape.zip_aabb = false;
								if(shape.type == 0) {
									var _this9 = shape.circle;
									if(_this9.zip_worldCOM) {
										if(_this9.body != null) {
											_this9.zip_worldCOM = false;
											if(_this9.zip_localCOM) {
												_this9.zip_localCOM = false;
												if(_this9.type == 1) {
													var _this10 = _this9.polygon;
													if(_this10.lverts.next.next == null) {
														_this10.localCOMx = _this10.lverts.next.x;
														_this10.localCOMy = _this10.lverts.next.y;
													} else if(_this10.lverts.next.next.next == null) {
														_this10.localCOMx = _this10.lverts.next.x;
														_this10.localCOMy = _this10.lverts.next.y;
														var t = 1.0;
														_this10.localCOMx += _this10.lverts.next.next.x * t;
														_this10.localCOMy += _this10.lverts.next.next.y * t;
														var t1 = 0.5;
														_this10.localCOMx *= t1;
														_this10.localCOMy *= t1;
													} else {
														_this10.localCOMx = 0;
														_this10.localCOMy = 0;
														var area = 0.0;
														var cx_ite = _this10.lverts.next;
														var u = cx_ite;
														cx_ite = cx_ite.next;
														var v = cx_ite;
														cx_ite = cx_ite.next;
														while(cx_ite != null) {
															var w = cx_ite;
															area += v.x * (w.y - u.y);
															var cf = w.y * v.x - w.x * v.y;
															_this10.localCOMx += (v.x + w.x) * cf;
															_this10.localCOMy += (v.y + w.y) * cf;
															u = v;
															v = w;
															cx_ite = cx_ite.next;
														}
														cx_ite = _this10.lverts.next;
														var w1 = cx_ite;
														area += v.x * (w1.y - u.y);
														var cf1 = w1.y * v.x - w1.x * v.y;
														_this10.localCOMx += (v.x + w1.x) * cf1;
														_this10.localCOMy += (v.y + w1.y) * cf1;
														u = v;
														v = w1;
														cx_ite = cx_ite.next;
														var w2 = cx_ite;
														area += v.x * (w2.y - u.y);
														var cf2 = w2.y * v.x - w2.x * v.y;
														_this10.localCOMx += (v.x + w2.x) * cf2;
														_this10.localCOMy += (v.y + w2.y) * cf2;
														area = 1 / (3 * area);
														var t2 = area;
														_this10.localCOMx *= t2;
														_this10.localCOMy *= t2;
													}
												}
												if(_this9.wrap_localCOM != null) {
													_this9.wrap_localCOM.zpp_inner.x = _this9.localCOMx;
													_this9.wrap_localCOM.zpp_inner.y = _this9.localCOMy;
												}
											}
											var _this11 = _this9.body;
											if(_this11.zip_axis) {
												_this11.zip_axis = false;
												_this11.axisx = Math.sin(_this11.rot);
												_this11.axisy = Math.cos(_this11.rot);
											}
											_this9.worldCOMx = _this9.body.posx + (_this9.body.axisy * _this9.localCOMx - _this9.body.axisx * _this9.localCOMy);
											_this9.worldCOMy = _this9.body.posy + (_this9.localCOMx * _this9.body.axisx + _this9.localCOMy * _this9.body.axisy);
										}
									}
									var rx = _this9.radius;
									var ry = _this9.radius;
									_this9.aabb.minx = _this9.worldCOMx - rx;
									_this9.aabb.miny = _this9.worldCOMy - ry;
									_this9.aabb.maxx = _this9.worldCOMx + rx;
									_this9.aabb.maxy = _this9.worldCOMy + ry;
								} else {
									var _this12 = shape.polygon;
									if(_this12.zip_gverts) {
										if(_this12.body != null) {
											_this12.zip_gverts = false;
											_this12.validate_lverts();
											var _this13 = _this12.body;
											if(_this13.zip_axis) {
												_this13.zip_axis = false;
												_this13.axisx = Math.sin(_this13.rot);
												_this13.axisy = Math.cos(_this13.rot);
											}
											var li = _this12.lverts.next;
											var cx_ite1 = _this12.gverts.next;
											while(cx_ite1 != null) {
												var g2 = cx_ite1;
												var l = li;
												li = li.next;
												g2.x = _this12.body.posx + (_this12.body.axisy * l.x - _this12.body.axisx * l.y);
												g2.y = _this12.body.posy + (l.x * _this12.body.axisx + l.y * _this12.body.axisy);
												cx_ite1 = cx_ite1.next;
											}
										}
									}
									var p0 = _this12.gverts.next;
									_this12.aabb.minx = p0.x;
									_this12.aabb.miny = p0.y;
									_this12.aabb.maxx = p0.x;
									_this12.aabb.maxy = p0.y;
									var cx_ite2 = _this12.gverts.next.next;
									while(cx_ite2 != null) {
										var p = cx_ite2;
										if(p.x < _this12.aabb.minx) {
											_this12.aabb.minx = p.x;
										}
										if(p.x > _this12.aabb.maxx) {
											_this12.aabb.maxx = p.x;
										}
										if(p.y < _this12.aabb.miny) {
											_this12.aabb.miny = p.y;
										}
										if(p.y > _this12.aabb.maxy) {
											_this12.aabb.maxy = p.y;
										}
										cx_ite2 = cx_ite2.next;
									}
								}
							}
						}
					}
					var a9 = shape.aabb;
					aabb.minx = a9.minx - 3.0;
					aabb.miny = a9.miny - 3.0;
					aabb.maxx = a9.maxx + 3.0;
					aabb.maxy = a9.maxy + 3.0;
					var tree1 = (node.dyn = shape.body.type == 1 ? false : !shape.body.component.sleeping) ? this.dtree : this.stree;
					if(tree1.root == null) {
						tree1.root = node;
						tree1.root.parent = null;
					} else {
						var leafaabb = node.aabb;
						var node2 = tree1.root;
						while(node2.child1 != null) {
							var child11 = node2.child1;
							var child21 = node2.child2;
							var _this14 = node2.aabb;
							var area1 = (_this14.maxx - _this14.minx + (_this14.maxy - _this14.miny)) * 2;
							var _this15 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var a10 = node2.aabb;
							_this15.minx = a10.minx < leafaabb.minx ? a10.minx : leafaabb.minx;
							_this15.miny = a10.miny < leafaabb.miny ? a10.miny : leafaabb.miny;
							_this15.maxx = a10.maxx > leafaabb.maxx ? a10.maxx : leafaabb.maxx;
							_this15.maxy = a10.maxy > leafaabb.maxy ? a10.maxy : leafaabb.maxy;
							var _this16 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var carea = (_this16.maxx - _this16.minx + (_this16.maxy - _this16.miny)) * 2;
							var cost = 2 * carea;
							var icost = 2 * (carea - area1);
							var _this17 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var b10 = child11.aabb;
							_this17.minx = leafaabb.minx < b10.minx ? leafaabb.minx : b10.minx;
							_this17.miny = leafaabb.miny < b10.miny ? leafaabb.miny : b10.miny;
							_this17.maxx = leafaabb.maxx > b10.maxx ? leafaabb.maxx : b10.maxx;
							_this17.maxy = leafaabb.maxy > b10.maxy ? leafaabb.maxy : b10.maxy;
							var cost1;
							if(child11.child1 == null) {
								var _this18 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								cost1 = (_this18.maxx - _this18.minx + (_this18.maxy - _this18.miny)) * 2 + icost;
							} else {
								var _this19 = child11.aabb;
								var oarea = (_this19.maxx - _this19.minx + (_this19.maxy - _this19.miny)) * 2;
								var _this20 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								var narea = (_this20.maxx - _this20.minx + (_this20.maxy - _this20.miny)) * 2;
								cost1 = narea - oarea + icost;
							}
							var _this21 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var b11 = child21.aabb;
							_this21.minx = leafaabb.minx < b11.minx ? leafaabb.minx : b11.minx;
							_this21.miny = leafaabb.miny < b11.miny ? leafaabb.miny : b11.miny;
							_this21.maxx = leafaabb.maxx > b11.maxx ? leafaabb.maxx : b11.maxx;
							_this21.maxy = leafaabb.maxy > b11.maxy ? leafaabb.maxy : b11.maxy;
							var cost2;
							if(child21.child1 == null) {
								var _this22 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								cost2 = (_this22.maxx - _this22.minx + (_this22.maxy - _this22.miny)) * 2 + icost;
							} else {
								var _this23 = child21.aabb;
								var oarea1 = (_this23.maxx - _this23.minx + (_this23.maxy - _this23.miny)) * 2;
								var _this24 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								var narea1 = (_this24.maxx - _this24.minx + (_this24.maxy - _this24.miny)) * 2;
								cost2 = narea1 - oarea1 + icost;
							}
							if(cost < cost1 && cost < cost2) {
								break;
							} else {
								node2 = cost1 < cost2 ? child11 : child21;
							}
						}
						var sibling1 = node2;
						var oparent = sibling1.parent;
						var nparent;
						if(zpp_$nape_space_ZPP_$AABBNode.zpp_pool == null) {
							nparent = new zpp_$nape_space_ZPP_$AABBNode();
						} else {
							nparent = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
							zpp_$nape_space_ZPP_$AABBNode.zpp_pool = nparent.next;
							nparent.next = null;
						}
						if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
							nparent.aabb = new zpp_$nape_geom_ZPP_$AABB();
						} else {
							nparent.aabb = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
							zpp_$nape_geom_ZPP_$AABB.zpp_pool = nparent.aabb.next;
							nparent.aabb.next = null;
						}
						nparent.moved = false;
						nparent.synced = false;
						nparent.first_sync = false;
						nparent.parent = oparent;
						var _this25 = nparent.aabb;
						var b12 = sibling1.aabb;
						_this25.minx = leafaabb.minx < b12.minx ? leafaabb.minx : b12.minx;
						_this25.miny = leafaabb.miny < b12.miny ? leafaabb.miny : b12.miny;
						_this25.maxx = leafaabb.maxx > b12.maxx ? leafaabb.maxx : b12.maxx;
						_this25.maxy = leafaabb.maxy > b12.maxy ? leafaabb.maxy : b12.maxy;
						nparent.height = sibling1.height + 1;
						if(oparent != null) {
							if(oparent.child1 == sibling1) {
								oparent.child1 = nparent;
							} else {
								oparent.child2 = nparent;
							}
							nparent.child1 = sibling1;
							nparent.child2 = node;
							sibling1.parent = nparent;
							node.parent = nparent;
						} else {
							nparent.child1 = sibling1;
							nparent.child2 = node;
							sibling1.parent = nparent;
							node.parent = nparent;
							tree1.root = nparent;
						}
						node2 = node.parent;
						while(node2 != null) {
							if(!(node2.child1 == null || node2.height < 2)) {
								var b13 = node2.child1;
								var c1 = node2.child2;
								var balance1 = c1.height - b13.height;
								if(balance1 > 1) {
									var f2 = c1.child1;
									var g3 = c1.child2;
									c1.child1 = node2;
									c1.parent = node2.parent;
									node2.parent = c1;
									if(c1.parent != null) {
										if(c1.parent.child1 == node2) {
											c1.parent.child1 = c1;
										} else {
											c1.parent.child2 = c1;
										}
									} else {
										tree1.root = c1;
									}
									if(f2.height > g3.height) {
										c1.child2 = f2;
										node2.child2 = g3;
										g3.parent = node2;
										var _this26 = node2.aabb;
										var a11 = b13.aabb;
										var b14 = g3.aabb;
										_this26.minx = a11.minx < b14.minx ? a11.minx : b14.minx;
										_this26.miny = a11.miny < b14.miny ? a11.miny : b14.miny;
										_this26.maxx = a11.maxx > b14.maxx ? a11.maxx : b14.maxx;
										_this26.maxy = a11.maxy > b14.maxy ? a11.maxy : b14.maxy;
										var _this27 = c1.aabb;
										var a12 = node2.aabb;
										var b15 = f2.aabb;
										_this27.minx = a12.minx < b15.minx ? a12.minx : b15.minx;
										_this27.miny = a12.miny < b15.miny ? a12.miny : b15.miny;
										_this27.maxx = a12.maxx > b15.maxx ? a12.maxx : b15.maxx;
										_this27.maxy = a12.maxy > b15.maxy ? a12.maxy : b15.maxy;
										var x9 = b13.height;
										var y9 = g3.height;
										node2.height = 1 + (x9 > y9 ? x9 : y9);
										var x10 = node2.height;
										var y10 = f2.height;
										c1.height = 1 + (x10 > y10 ? x10 : y10);
									} else {
										c1.child2 = g3;
										node2.child2 = f2;
										f2.parent = node2;
										var _this28 = node2.aabb;
										var a13 = b13.aabb;
										var b16 = f2.aabb;
										_this28.minx = a13.minx < b16.minx ? a13.minx : b16.minx;
										_this28.miny = a13.miny < b16.miny ? a13.miny : b16.miny;
										_this28.maxx = a13.maxx > b16.maxx ? a13.maxx : b16.maxx;
										_this28.maxy = a13.maxy > b16.maxy ? a13.maxy : b16.maxy;
										var _this29 = c1.aabb;
										var a14 = node2.aabb;
										var b17 = g3.aabb;
										_this29.minx = a14.minx < b17.minx ? a14.minx : b17.minx;
										_this29.miny = a14.miny < b17.miny ? a14.miny : b17.miny;
										_this29.maxx = a14.maxx > b17.maxx ? a14.maxx : b17.maxx;
										_this29.maxy = a14.maxy > b17.maxy ? a14.maxy : b17.maxy;
										var x11 = b13.height;
										var y11 = f2.height;
										node2.height = 1 + (x11 > y11 ? x11 : y11);
										var x12 = node2.height;
										var y12 = g3.height;
										c1.height = 1 + (x12 > y12 ? x12 : y12);
									}
									node2 = c1;
								} else if(balance1 < -1) {
									var f3 = b13.child1;
									var g4 = b13.child2;
									b13.child1 = node2;
									b13.parent = node2.parent;
									node2.parent = b13;
									if(b13.parent != null) {
										if(b13.parent.child1 == node2) {
											b13.parent.child1 = b13;
										} else {
											b13.parent.child2 = b13;
										}
									} else {
										tree1.root = b13;
									}
									if(f3.height > g4.height) {
										b13.child2 = f3;
										node2.child1 = g4;
										g4.parent = node2;
										var _this30 = node2.aabb;
										var a15 = c1.aabb;
										var b18 = g4.aabb;
										_this30.minx = a15.minx < b18.minx ? a15.minx : b18.minx;
										_this30.miny = a15.miny < b18.miny ? a15.miny : b18.miny;
										_this30.maxx = a15.maxx > b18.maxx ? a15.maxx : b18.maxx;
										_this30.maxy = a15.maxy > b18.maxy ? a15.maxy : b18.maxy;
										var _this31 = b13.aabb;
										var a16 = node2.aabb;
										var b19 = f3.aabb;
										_this31.minx = a16.minx < b19.minx ? a16.minx : b19.minx;
										_this31.miny = a16.miny < b19.miny ? a16.miny : b19.miny;
										_this31.maxx = a16.maxx > b19.maxx ? a16.maxx : b19.maxx;
										_this31.maxy = a16.maxy > b19.maxy ? a16.maxy : b19.maxy;
										var x13 = c1.height;
										var y13 = g4.height;
										node2.height = 1 + (x13 > y13 ? x13 : y13);
										var x14 = node2.height;
										var y14 = f3.height;
										b13.height = 1 + (x14 > y14 ? x14 : y14);
									} else {
										b13.child2 = g4;
										node2.child1 = f3;
										f3.parent = node2;
										var _this32 = node2.aabb;
										var a17 = c1.aabb;
										var b20 = f3.aabb;
										_this32.minx = a17.minx < b20.minx ? a17.minx : b20.minx;
										_this32.miny = a17.miny < b20.miny ? a17.miny : b20.miny;
										_this32.maxx = a17.maxx > b20.maxx ? a17.maxx : b20.maxx;
										_this32.maxy = a17.maxy > b20.maxy ? a17.maxy : b20.maxy;
										var _this33 = b13.aabb;
										var a18 = node2.aabb;
										var b21 = g4.aabb;
										_this33.minx = a18.minx < b21.minx ? a18.minx : b21.minx;
										_this33.miny = a18.miny < b21.miny ? a18.miny : b21.miny;
										_this33.maxx = a18.maxx > b21.maxx ? a18.maxx : b21.maxx;
										_this33.maxy = a18.maxy > b21.maxy ? a18.maxy : b21.maxy;
										var x15 = c1.height;
										var y15 = f3.height;
										node2.height = 1 + (x15 > y15 ? x15 : y15);
										var x16 = node2.height;
										var y16 = g4.height;
										b13.height = 1 + (x16 > y16 ? x16 : y16);
									}
									node2 = b13;
								}
							}
							var child12 = node2.child1;
							var child22 = node2.child2;
							var x17 = child12.height;
							var y17 = child22.height;
							node2.height = 1 + (x17 > y17 ? x17 : y17);
							var _this34 = node2.aabb;
							var a19 = child12.aabb;
							var b22 = child22.aabb;
							_this34.minx = a19.minx < b22.minx ? a19.minx : b22.minx;
							_this34.miny = a19.miny < b22.miny ? a19.miny : b22.miny;
							_this34.maxx = a19.maxx > b22.maxx ? a19.maxx : b22.maxx;
							_this34.maxy = a19.maxy > b22.maxy ? a19.maxy : b22.maxy;
							node2 = node2.parent;
						}
					}
					node.synced = false;
					node.moved = true;
					node.mnext = node.snext;
					node.snext = null;
					node = node.mnext;
				}
				var t = this.syncs;
				this.syncs = this.moves;
				this.moves = t;
			} else {
				while(this.syncs != null) {
					var ret = this.syncs;
					this.syncs = ret.snext;
					ret.snext = null;
					var node = ret;
					var shape = node.shape;
					if(!node.first_sync) {
						var tree = node.dyn ? this.dtree : this.stree;
						if(node == tree.root) {
							tree.root = null;
						} else {
							var parent = node.parent;
							var gparent = parent.parent;
							var sibling = parent.child1 == node ? parent.child2 : parent.child1;
							if(gparent != null) {
								if(gparent.child1 == parent) {
									gparent.child1 = sibling;
								} else {
									gparent.child2 = sibling;
								}
								sibling.parent = gparent;
								var o = parent;
								o.height = -1;
								var o1 = o.aabb;
								if(o1.outer != null) {
									o1.outer.zpp_inner = null;
									o1.outer = null;
								}
								o1.wrap_min = o1.wrap_max = null;
								o1._invalidate = null;
								o1._validate = null;
								o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
								zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
								o.child1 = o.child2 = o.parent = null;
								o.next = null;
								o.snext = null;
								o.mnext = null;
								o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
								zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
								var node1 = gparent;
								while(node1 != null) {
									if(!(node1.child1 == null || node1.height < 2)) {
										var b = node1.child1;
										var c = node1.child2;
										var balance = c.height - b.height;
										if(balance > 1) {
											var f = c.child1;
											var g = c.child2;
											c.child1 = node1;
											c.parent = node1.parent;
											node1.parent = c;
											if(c.parent != null) {
												if(c.parent.child1 == node1) {
													c.parent.child1 = c;
												} else {
													c.parent.child2 = c;
												}
											} else {
												tree.root = c;
											}
											if(f.height > g.height) {
												c.child2 = f;
												node1.child2 = g;
												g.parent = node1;
												var _this = node1.aabb;
												var a = b.aabb;
												var b1 = g.aabb;
												_this.minx = a.minx < b1.minx ? a.minx : b1.minx;
												_this.miny = a.miny < b1.miny ? a.miny : b1.miny;
												_this.maxx = a.maxx > b1.maxx ? a.maxx : b1.maxx;
												_this.maxy = a.maxy > b1.maxy ? a.maxy : b1.maxy;
												var _this1 = c.aabb;
												var a1 = node1.aabb;
												var b2 = f.aabb;
												_this1.minx = a1.minx < b2.minx ? a1.minx : b2.minx;
												_this1.miny = a1.miny < b2.miny ? a1.miny : b2.miny;
												_this1.maxx = a1.maxx > b2.maxx ? a1.maxx : b2.maxx;
												_this1.maxy = a1.maxy > b2.maxy ? a1.maxy : b2.maxy;
												var x = b.height;
												var y = g.height;
												node1.height = 1 + (x > y ? x : y);
												var x1 = node1.height;
												var y1 = f.height;
												c.height = 1 + (x1 > y1 ? x1 : y1);
											} else {
												c.child2 = g;
												node1.child2 = f;
												f.parent = node1;
												var _this2 = node1.aabb;
												var a2 = b.aabb;
												var b3 = f.aabb;
												_this2.minx = a2.minx < b3.minx ? a2.minx : b3.minx;
												_this2.miny = a2.miny < b3.miny ? a2.miny : b3.miny;
												_this2.maxx = a2.maxx > b3.maxx ? a2.maxx : b3.maxx;
												_this2.maxy = a2.maxy > b3.maxy ? a2.maxy : b3.maxy;
												var _this3 = c.aabb;
												var a3 = node1.aabb;
												var b4 = g.aabb;
												_this3.minx = a3.minx < b4.minx ? a3.minx : b4.minx;
												_this3.miny = a3.miny < b4.miny ? a3.miny : b4.miny;
												_this3.maxx = a3.maxx > b4.maxx ? a3.maxx : b4.maxx;
												_this3.maxy = a3.maxy > b4.maxy ? a3.maxy : b4.maxy;
												var x2 = b.height;
												var y2 = f.height;
												node1.height = 1 + (x2 > y2 ? x2 : y2);
												var x3 = node1.height;
												var y3 = g.height;
												c.height = 1 + (x3 > y3 ? x3 : y3);
											}
											node1 = c;
										} else if(balance < -1) {
											var f1 = b.child1;
											var g1 = b.child2;
											b.child1 = node1;
											b.parent = node1.parent;
											node1.parent = b;
											if(b.parent != null) {
												if(b.parent.child1 == node1) {
													b.parent.child1 = b;
												} else {
													b.parent.child2 = b;
												}
											} else {
												tree.root = b;
											}
											if(f1.height > g1.height) {
												b.child2 = f1;
												node1.child1 = g1;
												g1.parent = node1;
												var _this4 = node1.aabb;
												var a4 = c.aabb;
												var b5 = g1.aabb;
												_this4.minx = a4.minx < b5.minx ? a4.minx : b5.minx;
												_this4.miny = a4.miny < b5.miny ? a4.miny : b5.miny;
												_this4.maxx = a4.maxx > b5.maxx ? a4.maxx : b5.maxx;
												_this4.maxy = a4.maxy > b5.maxy ? a4.maxy : b5.maxy;
												var _this5 = b.aabb;
												var a5 = node1.aabb;
												var b6 = f1.aabb;
												_this5.minx = a5.minx < b6.minx ? a5.minx : b6.minx;
												_this5.miny = a5.miny < b6.miny ? a5.miny : b6.miny;
												_this5.maxx = a5.maxx > b6.maxx ? a5.maxx : b6.maxx;
												_this5.maxy = a5.maxy > b6.maxy ? a5.maxy : b6.maxy;
												var x4 = c.height;
												var y4 = g1.height;
												node1.height = 1 + (x4 > y4 ? x4 : y4);
												var x5 = node1.height;
												var y5 = f1.height;
												b.height = 1 + (x5 > y5 ? x5 : y5);
											} else {
												b.child2 = g1;
												node1.child1 = f1;
												f1.parent = node1;
												var _this6 = node1.aabb;
												var a6 = c.aabb;
												var b7 = f1.aabb;
												_this6.minx = a6.minx < b7.minx ? a6.minx : b7.minx;
												_this6.miny = a6.miny < b7.miny ? a6.miny : b7.miny;
												_this6.maxx = a6.maxx > b7.maxx ? a6.maxx : b7.maxx;
												_this6.maxy = a6.maxy > b7.maxy ? a6.maxy : b7.maxy;
												var _this7 = b.aabb;
												var a7 = node1.aabb;
												var b8 = g1.aabb;
												_this7.minx = a7.minx < b8.minx ? a7.minx : b8.minx;
												_this7.miny = a7.miny < b8.miny ? a7.miny : b8.miny;
												_this7.maxx = a7.maxx > b8.maxx ? a7.maxx : b8.maxx;
												_this7.maxy = a7.maxy > b8.maxy ? a7.maxy : b8.maxy;
												var x6 = c.height;
												var y6 = f1.height;
												node1.height = 1 + (x6 > y6 ? x6 : y6);
												var x7 = node1.height;
												var y7 = g1.height;
												b.height = 1 + (x7 > y7 ? x7 : y7);
											}
											node1 = b;
										}
									}
									var child1 = node1.child1;
									var child2 = node1.child2;
									var _this8 = node1.aabb;
									var a8 = child1.aabb;
									var b9 = child2.aabb;
									_this8.minx = a8.minx < b9.minx ? a8.minx : b9.minx;
									_this8.miny = a8.miny < b9.miny ? a8.miny : b9.miny;
									_this8.maxx = a8.maxx > b9.maxx ? a8.maxx : b9.maxx;
									_this8.maxy = a8.maxy > b9.maxy ? a8.maxy : b9.maxy;
									var x8 = child1.height;
									var y8 = child2.height;
									node1.height = 1 + (x8 > y8 ? x8 : y8);
									node1 = node1.parent;
								}
							} else {
								tree.root = sibling;
								sibling.parent = null;
								var o2 = parent;
								o2.height = -1;
								var o3 = o2.aabb;
								if(o3.outer != null) {
									o3.outer.zpp_inner = null;
									o3.outer = null;
								}
								o3.wrap_min = o3.wrap_max = null;
								o3._invalidate = null;
								o3._validate = null;
								o3.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
								zpp_$nape_geom_ZPP_$AABB.zpp_pool = o3;
								o2.child1 = o2.child2 = o2.parent = null;
								o2.next = null;
								o2.snext = null;
								o2.mnext = null;
								o2.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
								zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o2;
							}
						}
					} else {
						node.first_sync = false;
					}
					var aabb = node.aabb;
					if(!this.space.continuous) {
						if(shape.zip_aabb) {
							if(shape.body != null) {
								shape.zip_aabb = false;
								if(shape.type == 0) {
									var _this9 = shape.circle;
									if(_this9.zip_worldCOM) {
										if(_this9.body != null) {
											_this9.zip_worldCOM = false;
											if(_this9.zip_localCOM) {
												_this9.zip_localCOM = false;
												if(_this9.type == 1) {
													var _this10 = _this9.polygon;
													if(_this10.lverts.next.next == null) {
														_this10.localCOMx = _this10.lverts.next.x;
														_this10.localCOMy = _this10.lverts.next.y;
													} else if(_this10.lverts.next.next.next == null) {
														_this10.localCOMx = _this10.lverts.next.x;
														_this10.localCOMy = _this10.lverts.next.y;
														var t = 1.0;
														_this10.localCOMx += _this10.lverts.next.next.x * t;
														_this10.localCOMy += _this10.lverts.next.next.y * t;
														var t1 = 0.5;
														_this10.localCOMx *= t1;
														_this10.localCOMy *= t1;
													} else {
														_this10.localCOMx = 0;
														_this10.localCOMy = 0;
														var area = 0.0;
														var cx_ite = _this10.lverts.next;
														var u = cx_ite;
														cx_ite = cx_ite.next;
														var v = cx_ite;
														cx_ite = cx_ite.next;
														while(cx_ite != null) {
															var w = cx_ite;
															area += v.x * (w.y - u.y);
															var cf = w.y * v.x - w.x * v.y;
															_this10.localCOMx += (v.x + w.x) * cf;
															_this10.localCOMy += (v.y + w.y) * cf;
															u = v;
															v = w;
															cx_ite = cx_ite.next;
														}
														cx_ite = _this10.lverts.next;
														var w1 = cx_ite;
														area += v.x * (w1.y - u.y);
														var cf1 = w1.y * v.x - w1.x * v.y;
														_this10.localCOMx += (v.x + w1.x) * cf1;
														_this10.localCOMy += (v.y + w1.y) * cf1;
														u = v;
														v = w1;
														cx_ite = cx_ite.next;
														var w2 = cx_ite;
														area += v.x * (w2.y - u.y);
														var cf2 = w2.y * v.x - w2.x * v.y;
														_this10.localCOMx += (v.x + w2.x) * cf2;
														_this10.localCOMy += (v.y + w2.y) * cf2;
														area = 1 / (3 * area);
														var t2 = area;
														_this10.localCOMx *= t2;
														_this10.localCOMy *= t2;
													}
												}
												if(_this9.wrap_localCOM != null) {
													_this9.wrap_localCOM.zpp_inner.x = _this9.localCOMx;
													_this9.wrap_localCOM.zpp_inner.y = _this9.localCOMy;
												}
											}
											var _this11 = _this9.body;
											if(_this11.zip_axis) {
												_this11.zip_axis = false;
												_this11.axisx = Math.sin(_this11.rot);
												_this11.axisy = Math.cos(_this11.rot);
											}
											_this9.worldCOMx = _this9.body.posx + (_this9.body.axisy * _this9.localCOMx - _this9.body.axisx * _this9.localCOMy);
											_this9.worldCOMy = _this9.body.posy + (_this9.localCOMx * _this9.body.axisx + _this9.localCOMy * _this9.body.axisy);
										}
									}
									var rx = _this9.radius;
									var ry = _this9.radius;
									_this9.aabb.minx = _this9.worldCOMx - rx;
									_this9.aabb.miny = _this9.worldCOMy - ry;
									_this9.aabb.maxx = _this9.worldCOMx + rx;
									_this9.aabb.maxy = _this9.worldCOMy + ry;
								} else {
									var _this12 = shape.polygon;
									if(_this12.zip_gverts) {
										if(_this12.body != null) {
											_this12.zip_gverts = false;
											_this12.validate_lverts();
											var _this13 = _this12.body;
											if(_this13.zip_axis) {
												_this13.zip_axis = false;
												_this13.axisx = Math.sin(_this13.rot);
												_this13.axisy = Math.cos(_this13.rot);
											}
											var li = _this12.lverts.next;
											var cx_ite1 = _this12.gverts.next;
											while(cx_ite1 != null) {
												var g2 = cx_ite1;
												var l = li;
												li = li.next;
												g2.x = _this12.body.posx + (_this12.body.axisy * l.x - _this12.body.axisx * l.y);
												g2.y = _this12.body.posy + (l.x * _this12.body.axisx + l.y * _this12.body.axisy);
												cx_ite1 = cx_ite1.next;
											}
										}
									}
									var p0 = _this12.gverts.next;
									_this12.aabb.minx = p0.x;
									_this12.aabb.miny = p0.y;
									_this12.aabb.maxx = p0.x;
									_this12.aabb.maxy = p0.y;
									var cx_ite2 = _this12.gverts.next.next;
									while(cx_ite2 != null) {
										var p = cx_ite2;
										if(p.x < _this12.aabb.minx) {
											_this12.aabb.minx = p.x;
										}
										if(p.x > _this12.aabb.maxx) {
											_this12.aabb.maxx = p.x;
										}
										if(p.y < _this12.aabb.miny) {
											_this12.aabb.miny = p.y;
										}
										if(p.y > _this12.aabb.maxy) {
											_this12.aabb.maxy = p.y;
										}
										cx_ite2 = cx_ite2.next;
									}
								}
							}
						}
					}
					var a9 = shape.aabb;
					aabb.minx = a9.minx - 3.0;
					aabb.miny = a9.miny - 3.0;
					aabb.maxx = a9.maxx + 3.0;
					aabb.maxy = a9.maxy + 3.0;
					var tree1 = (node.dyn = shape.body.type == 1 ? false : !shape.body.component.sleeping) ? this.dtree : this.stree;
					if(tree1.root == null) {
						tree1.root = node;
						tree1.root.parent = null;
					} else {
						var leafaabb = node.aabb;
						var node2 = tree1.root;
						while(node2.child1 != null) {
							var child11 = node2.child1;
							var child21 = node2.child2;
							var _this14 = node2.aabb;
							var area1 = (_this14.maxx - _this14.minx + (_this14.maxy - _this14.miny)) * 2;
							var _this15 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var a10 = node2.aabb;
							_this15.minx = a10.minx < leafaabb.minx ? a10.minx : leafaabb.minx;
							_this15.miny = a10.miny < leafaabb.miny ? a10.miny : leafaabb.miny;
							_this15.maxx = a10.maxx > leafaabb.maxx ? a10.maxx : leafaabb.maxx;
							_this15.maxy = a10.maxy > leafaabb.maxy ? a10.maxy : leafaabb.maxy;
							var _this16 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var carea = (_this16.maxx - _this16.minx + (_this16.maxy - _this16.miny)) * 2;
							var cost = 2 * carea;
							var icost = 2 * (carea - area1);
							var _this17 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var b10 = child11.aabb;
							_this17.minx = leafaabb.minx < b10.minx ? leafaabb.minx : b10.minx;
							_this17.miny = leafaabb.miny < b10.miny ? leafaabb.miny : b10.miny;
							_this17.maxx = leafaabb.maxx > b10.maxx ? leafaabb.maxx : b10.maxx;
							_this17.maxy = leafaabb.maxy > b10.maxy ? leafaabb.maxy : b10.maxy;
							var cost1;
							if(child11.child1 == null) {
								var _this18 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								cost1 = (_this18.maxx - _this18.minx + (_this18.maxy - _this18.miny)) * 2 + icost;
							} else {
								var _this19 = child11.aabb;
								var oarea = (_this19.maxx - _this19.minx + (_this19.maxy - _this19.miny)) * 2;
								var _this20 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								var narea = (_this20.maxx - _this20.minx + (_this20.maxy - _this20.miny)) * 2;
								cost1 = narea - oarea + icost;
							}
							var _this21 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
							var b11 = child21.aabb;
							_this21.minx = leafaabb.minx < b11.minx ? leafaabb.minx : b11.minx;
							_this21.miny = leafaabb.miny < b11.miny ? leafaabb.miny : b11.miny;
							_this21.maxx = leafaabb.maxx > b11.maxx ? leafaabb.maxx : b11.maxx;
							_this21.maxy = leafaabb.maxy > b11.maxy ? leafaabb.maxy : b11.maxy;
							var cost2;
							if(child21.child1 == null) {
								var _this22 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								cost2 = (_this22.maxx - _this22.minx + (_this22.maxy - _this22.miny)) * 2 + icost;
							} else {
								var _this23 = child21.aabb;
								var oarea1 = (_this23.maxx - _this23.minx + (_this23.maxy - _this23.miny)) * 2;
								var _this24 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
								var narea1 = (_this24.maxx - _this24.minx + (_this24.maxy - _this24.miny)) * 2;
								cost2 = narea1 - oarea1 + icost;
							}
							if(cost < cost1 && cost < cost2) {
								break;
							} else {
								node2 = cost1 < cost2 ? child11 : child21;
							}
						}
						var sibling1 = node2;
						var oparent = sibling1.parent;
						var nparent;
						if(zpp_$nape_space_ZPP_$AABBNode.zpp_pool == null) {
							nparent = new zpp_$nape_space_ZPP_$AABBNode();
						} else {
							nparent = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
							zpp_$nape_space_ZPP_$AABBNode.zpp_pool = nparent.next;
							nparent.next = null;
						}
						if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
							nparent.aabb = new zpp_$nape_geom_ZPP_$AABB();
						} else {
							nparent.aabb = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
							zpp_$nape_geom_ZPP_$AABB.zpp_pool = nparent.aabb.next;
							nparent.aabb.next = null;
						}
						nparent.moved = false;
						nparent.synced = false;
						nparent.first_sync = false;
						nparent.parent = oparent;
						var _this25 = nparent.aabb;
						var b12 = sibling1.aabb;
						_this25.minx = leafaabb.minx < b12.minx ? leafaabb.minx : b12.minx;
						_this25.miny = leafaabb.miny < b12.miny ? leafaabb.miny : b12.miny;
						_this25.maxx = leafaabb.maxx > b12.maxx ? leafaabb.maxx : b12.maxx;
						_this25.maxy = leafaabb.maxy > b12.maxy ? leafaabb.maxy : b12.maxy;
						nparent.height = sibling1.height + 1;
						if(oparent != null) {
							if(oparent.child1 == sibling1) {
								oparent.child1 = nparent;
							} else {
								oparent.child2 = nparent;
							}
							nparent.child1 = sibling1;
							nparent.child2 = node;
							sibling1.parent = nparent;
							node.parent = nparent;
						} else {
							nparent.child1 = sibling1;
							nparent.child2 = node;
							sibling1.parent = nparent;
							node.parent = nparent;
							tree1.root = nparent;
						}
						node2 = node.parent;
						while(node2 != null) {
							if(!(node2.child1 == null || node2.height < 2)) {
								var b13 = node2.child1;
								var c1 = node2.child2;
								var balance1 = c1.height - b13.height;
								if(balance1 > 1) {
									var f2 = c1.child1;
									var g3 = c1.child2;
									c1.child1 = node2;
									c1.parent = node2.parent;
									node2.parent = c1;
									if(c1.parent != null) {
										if(c1.parent.child1 == node2) {
											c1.parent.child1 = c1;
										} else {
											c1.parent.child2 = c1;
										}
									} else {
										tree1.root = c1;
									}
									if(f2.height > g3.height) {
										c1.child2 = f2;
										node2.child2 = g3;
										g3.parent = node2;
										var _this26 = node2.aabb;
										var a11 = b13.aabb;
										var b14 = g3.aabb;
										_this26.minx = a11.minx < b14.minx ? a11.minx : b14.minx;
										_this26.miny = a11.miny < b14.miny ? a11.miny : b14.miny;
										_this26.maxx = a11.maxx > b14.maxx ? a11.maxx : b14.maxx;
										_this26.maxy = a11.maxy > b14.maxy ? a11.maxy : b14.maxy;
										var _this27 = c1.aabb;
										var a12 = node2.aabb;
										var b15 = f2.aabb;
										_this27.minx = a12.minx < b15.minx ? a12.minx : b15.minx;
										_this27.miny = a12.miny < b15.miny ? a12.miny : b15.miny;
										_this27.maxx = a12.maxx > b15.maxx ? a12.maxx : b15.maxx;
										_this27.maxy = a12.maxy > b15.maxy ? a12.maxy : b15.maxy;
										var x9 = b13.height;
										var y9 = g3.height;
										node2.height = 1 + (x9 > y9 ? x9 : y9);
										var x10 = node2.height;
										var y10 = f2.height;
										c1.height = 1 + (x10 > y10 ? x10 : y10);
									} else {
										c1.child2 = g3;
										node2.child2 = f2;
										f2.parent = node2;
										var _this28 = node2.aabb;
										var a13 = b13.aabb;
										var b16 = f2.aabb;
										_this28.minx = a13.minx < b16.minx ? a13.minx : b16.minx;
										_this28.miny = a13.miny < b16.miny ? a13.miny : b16.miny;
										_this28.maxx = a13.maxx > b16.maxx ? a13.maxx : b16.maxx;
										_this28.maxy = a13.maxy > b16.maxy ? a13.maxy : b16.maxy;
										var _this29 = c1.aabb;
										var a14 = node2.aabb;
										var b17 = g3.aabb;
										_this29.minx = a14.minx < b17.minx ? a14.minx : b17.minx;
										_this29.miny = a14.miny < b17.miny ? a14.miny : b17.miny;
										_this29.maxx = a14.maxx > b17.maxx ? a14.maxx : b17.maxx;
										_this29.maxy = a14.maxy > b17.maxy ? a14.maxy : b17.maxy;
										var x11 = b13.height;
										var y11 = f2.height;
										node2.height = 1 + (x11 > y11 ? x11 : y11);
										var x12 = node2.height;
										var y12 = g3.height;
										c1.height = 1 + (x12 > y12 ? x12 : y12);
									}
									node2 = c1;
								} else if(balance1 < -1) {
									var f3 = b13.child1;
									var g4 = b13.child2;
									b13.child1 = node2;
									b13.parent = node2.parent;
									node2.parent = b13;
									if(b13.parent != null) {
										if(b13.parent.child1 == node2) {
											b13.parent.child1 = b13;
										} else {
											b13.parent.child2 = b13;
										}
									} else {
										tree1.root = b13;
									}
									if(f3.height > g4.height) {
										b13.child2 = f3;
										node2.child1 = g4;
										g4.parent = node2;
										var _this30 = node2.aabb;
										var a15 = c1.aabb;
										var b18 = g4.aabb;
										_this30.minx = a15.minx < b18.minx ? a15.minx : b18.minx;
										_this30.miny = a15.miny < b18.miny ? a15.miny : b18.miny;
										_this30.maxx = a15.maxx > b18.maxx ? a15.maxx : b18.maxx;
										_this30.maxy = a15.maxy > b18.maxy ? a15.maxy : b18.maxy;
										var _this31 = b13.aabb;
										var a16 = node2.aabb;
										var b19 = f3.aabb;
										_this31.minx = a16.minx < b19.minx ? a16.minx : b19.minx;
										_this31.miny = a16.miny < b19.miny ? a16.miny : b19.miny;
										_this31.maxx = a16.maxx > b19.maxx ? a16.maxx : b19.maxx;
										_this31.maxy = a16.maxy > b19.maxy ? a16.maxy : b19.maxy;
										var x13 = c1.height;
										var y13 = g4.height;
										node2.height = 1 + (x13 > y13 ? x13 : y13);
										var x14 = node2.height;
										var y14 = f3.height;
										b13.height = 1 + (x14 > y14 ? x14 : y14);
									} else {
										b13.child2 = g4;
										node2.child1 = f3;
										f3.parent = node2;
										var _this32 = node2.aabb;
										var a17 = c1.aabb;
										var b20 = f3.aabb;
										_this32.minx = a17.minx < b20.minx ? a17.minx : b20.minx;
										_this32.miny = a17.miny < b20.miny ? a17.miny : b20.miny;
										_this32.maxx = a17.maxx > b20.maxx ? a17.maxx : b20.maxx;
										_this32.maxy = a17.maxy > b20.maxy ? a17.maxy : b20.maxy;
										var _this33 = b13.aabb;
										var a18 = node2.aabb;
										var b21 = g4.aabb;
										_this33.minx = a18.minx < b21.minx ? a18.minx : b21.minx;
										_this33.miny = a18.miny < b21.miny ? a18.miny : b21.miny;
										_this33.maxx = a18.maxx > b21.maxx ? a18.maxx : b21.maxx;
										_this33.maxy = a18.maxy > b21.maxy ? a18.maxy : b21.maxy;
										var x15 = c1.height;
										var y15 = f3.height;
										node2.height = 1 + (x15 > y15 ? x15 : y15);
										var x16 = node2.height;
										var y16 = g4.height;
										b13.height = 1 + (x16 > y16 ? x16 : y16);
									}
									node2 = b13;
								}
							}
							var child12 = node2.child1;
							var child22 = node2.child2;
							var x17 = child12.height;
							var y17 = child22.height;
							node2.height = 1 + (x17 > y17 ? x17 : y17);
							var _this34 = node2.aabb;
							var a19 = child12.aabb;
							var b22 = child22.aabb;
							_this34.minx = a19.minx < b22.minx ? a19.minx : b22.minx;
							_this34.miny = a19.miny < b22.miny ? a19.miny : b22.miny;
							_this34.maxx = a19.maxx > b22.maxx ? a19.maxx : b22.maxx;
							_this34.maxy = a19.maxy > b22.maxy ? a19.maxy : b22.maxy;
							node2 = node2.parent;
						}
					}
					node.synced = false;
					if(!node.moved) {
						node.moved = true;
						node.mnext = this.moves;
						this.moves = node;
					}
				}
			}
		}
	}
	,broadphase: function(space,discrete) {
		var node = this.syncs;
		while(node != null) {
			var shape = node.shape;
			if(!node.first_sync) {
				var tree = node.dyn ? this.dtree : this.stree;
				if(node == tree.root) {
					tree.root = null;
				} else {
					var parent = node.parent;
					var gparent = parent.parent;
					var sibling = parent.child1 == node ? parent.child2 : parent.child1;
					if(gparent != null) {
						if(gparent.child1 == parent) {
							gparent.child1 = sibling;
						} else {
							gparent.child2 = sibling;
						}
						sibling.parent = gparent;
						var o = parent;
						o.height = -1;
						var o1 = o.aabb;
						if(o1.outer != null) {
							o1.outer.zpp_inner = null;
							o1.outer = null;
						}
						o1.wrap_min = o1.wrap_max = null;
						o1._invalidate = null;
						o1._validate = null;
						o1.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
						zpp_$nape_geom_ZPP_$AABB.zpp_pool = o1;
						o.child1 = o.child2 = o.parent = null;
						o.next = null;
						o.snext = null;
						o.mnext = null;
						o.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
						zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o;
						var node1 = gparent;
						while(node1 != null) {
							if(!(node1.child1 == null || node1.height < 2)) {
								var b = node1.child1;
								var c = node1.child2;
								var balance = c.height - b.height;
								if(balance > 1) {
									var f = c.child1;
									var g = c.child2;
									c.child1 = node1;
									c.parent = node1.parent;
									node1.parent = c;
									if(c.parent != null) {
										if(c.parent.child1 == node1) {
											c.parent.child1 = c;
										} else {
											c.parent.child2 = c;
										}
									} else {
										tree.root = c;
									}
									if(f.height > g.height) {
										c.child2 = f;
										node1.child2 = g;
										g.parent = node1;
										var _this = node1.aabb;
										var a = b.aabb;
										var b1 = g.aabb;
										_this.minx = a.minx < b1.minx ? a.minx : b1.minx;
										_this.miny = a.miny < b1.miny ? a.miny : b1.miny;
										_this.maxx = a.maxx > b1.maxx ? a.maxx : b1.maxx;
										_this.maxy = a.maxy > b1.maxy ? a.maxy : b1.maxy;
										var _this1 = c.aabb;
										var a1 = node1.aabb;
										var b2 = f.aabb;
										_this1.minx = a1.minx < b2.minx ? a1.minx : b2.minx;
										_this1.miny = a1.miny < b2.miny ? a1.miny : b2.miny;
										_this1.maxx = a1.maxx > b2.maxx ? a1.maxx : b2.maxx;
										_this1.maxy = a1.maxy > b2.maxy ? a1.maxy : b2.maxy;
										var x = b.height;
										var y = g.height;
										node1.height = 1 + (x > y ? x : y);
										var x1 = node1.height;
										var y1 = f.height;
										c.height = 1 + (x1 > y1 ? x1 : y1);
									} else {
										c.child2 = g;
										node1.child2 = f;
										f.parent = node1;
										var _this2 = node1.aabb;
										var a2 = b.aabb;
										var b3 = f.aabb;
										_this2.minx = a2.minx < b3.minx ? a2.minx : b3.minx;
										_this2.miny = a2.miny < b3.miny ? a2.miny : b3.miny;
										_this2.maxx = a2.maxx > b3.maxx ? a2.maxx : b3.maxx;
										_this2.maxy = a2.maxy > b3.maxy ? a2.maxy : b3.maxy;
										var _this3 = c.aabb;
										var a3 = node1.aabb;
										var b4 = g.aabb;
										_this3.minx = a3.minx < b4.minx ? a3.minx : b4.minx;
										_this3.miny = a3.miny < b4.miny ? a3.miny : b4.miny;
										_this3.maxx = a3.maxx > b4.maxx ? a3.maxx : b4.maxx;
										_this3.maxy = a3.maxy > b4.maxy ? a3.maxy : b4.maxy;
										var x2 = b.height;
										var y2 = f.height;
										node1.height = 1 + (x2 > y2 ? x2 : y2);
										var x3 = node1.height;
										var y3 = g.height;
										c.height = 1 + (x3 > y3 ? x3 : y3);
									}
									node1 = c;
								} else if(balance < -1) {
									var f1 = b.child1;
									var g1 = b.child2;
									b.child1 = node1;
									b.parent = node1.parent;
									node1.parent = b;
									if(b.parent != null) {
										if(b.parent.child1 == node1) {
											b.parent.child1 = b;
										} else {
											b.parent.child2 = b;
										}
									} else {
										tree.root = b;
									}
									if(f1.height > g1.height) {
										b.child2 = f1;
										node1.child1 = g1;
										g1.parent = node1;
										var _this4 = node1.aabb;
										var a4 = c.aabb;
										var b5 = g1.aabb;
										_this4.minx = a4.minx < b5.minx ? a4.minx : b5.minx;
										_this4.miny = a4.miny < b5.miny ? a4.miny : b5.miny;
										_this4.maxx = a4.maxx > b5.maxx ? a4.maxx : b5.maxx;
										_this4.maxy = a4.maxy > b5.maxy ? a4.maxy : b5.maxy;
										var _this5 = b.aabb;
										var a5 = node1.aabb;
										var b6 = f1.aabb;
										_this5.minx = a5.minx < b6.minx ? a5.minx : b6.minx;
										_this5.miny = a5.miny < b6.miny ? a5.miny : b6.miny;
										_this5.maxx = a5.maxx > b6.maxx ? a5.maxx : b6.maxx;
										_this5.maxy = a5.maxy > b6.maxy ? a5.maxy : b6.maxy;
										var x4 = c.height;
										var y4 = g1.height;
										node1.height = 1 + (x4 > y4 ? x4 : y4);
										var x5 = node1.height;
										var y5 = f1.height;
										b.height = 1 + (x5 > y5 ? x5 : y5);
									} else {
										b.child2 = g1;
										node1.child1 = f1;
										f1.parent = node1;
										var _this6 = node1.aabb;
										var a6 = c.aabb;
										var b7 = f1.aabb;
										_this6.minx = a6.minx < b7.minx ? a6.minx : b7.minx;
										_this6.miny = a6.miny < b7.miny ? a6.miny : b7.miny;
										_this6.maxx = a6.maxx > b7.maxx ? a6.maxx : b7.maxx;
										_this6.maxy = a6.maxy > b7.maxy ? a6.maxy : b7.maxy;
										var _this7 = b.aabb;
										var a7 = node1.aabb;
										var b8 = g1.aabb;
										_this7.minx = a7.minx < b8.minx ? a7.minx : b8.minx;
										_this7.miny = a7.miny < b8.miny ? a7.miny : b8.miny;
										_this7.maxx = a7.maxx > b8.maxx ? a7.maxx : b8.maxx;
										_this7.maxy = a7.maxy > b8.maxy ? a7.maxy : b8.maxy;
										var x6 = c.height;
										var y6 = f1.height;
										node1.height = 1 + (x6 > y6 ? x6 : y6);
										var x7 = node1.height;
										var y7 = g1.height;
										b.height = 1 + (x7 > y7 ? x7 : y7);
									}
									node1 = b;
								}
							}
							var child1 = node1.child1;
							var child2 = node1.child2;
							var _this8 = node1.aabb;
							var a8 = child1.aabb;
							var b9 = child2.aabb;
							_this8.minx = a8.minx < b9.minx ? a8.minx : b9.minx;
							_this8.miny = a8.miny < b9.miny ? a8.miny : b9.miny;
							_this8.maxx = a8.maxx > b9.maxx ? a8.maxx : b9.maxx;
							_this8.maxy = a8.maxy > b9.maxy ? a8.maxy : b9.maxy;
							var x8 = child1.height;
							var y8 = child2.height;
							node1.height = 1 + (x8 > y8 ? x8 : y8);
							node1 = node1.parent;
						}
					} else {
						tree.root = sibling;
						sibling.parent = null;
						var o2 = parent;
						o2.height = -1;
						var o3 = o2.aabb;
						if(o3.outer != null) {
							o3.outer.zpp_inner = null;
							o3.outer = null;
						}
						o3.wrap_min = o3.wrap_max = null;
						o3._invalidate = null;
						o3._validate = null;
						o3.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
						zpp_$nape_geom_ZPP_$AABB.zpp_pool = o3;
						o2.child1 = o2.child2 = o2.parent = null;
						o2.next = null;
						o2.snext = null;
						o2.mnext = null;
						o2.next = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
						zpp_$nape_space_ZPP_$AABBNode.zpp_pool = o2;
					}
				}
			} else {
				node.first_sync = false;
			}
			var aabb = node.aabb;
			if(!space.continuous) {
				if(shape.zip_aabb) {
					if(shape.body != null) {
						shape.zip_aabb = false;
						if(shape.type == 0) {
							var _this9 = shape.circle;
							if(_this9.zip_worldCOM) {
								if(_this9.body != null) {
									_this9.zip_worldCOM = false;
									if(_this9.zip_localCOM) {
										_this9.zip_localCOM = false;
										if(_this9.type == 1) {
											var _this10 = _this9.polygon;
											if(_this10.lverts.next.next == null) {
												_this10.localCOMx = _this10.lverts.next.x;
												_this10.localCOMy = _this10.lverts.next.y;
											} else if(_this10.lverts.next.next.next == null) {
												_this10.localCOMx = _this10.lverts.next.x;
												_this10.localCOMy = _this10.lverts.next.y;
												var t = 1.0;
												_this10.localCOMx += _this10.lverts.next.next.x * t;
												_this10.localCOMy += _this10.lverts.next.next.y * t;
												var t1 = 0.5;
												_this10.localCOMx *= t1;
												_this10.localCOMy *= t1;
											} else {
												_this10.localCOMx = 0;
												_this10.localCOMy = 0;
												var area = 0.0;
												var cx_ite = _this10.lverts.next;
												var u = cx_ite;
												cx_ite = cx_ite.next;
												var v = cx_ite;
												cx_ite = cx_ite.next;
												while(cx_ite != null) {
													var w = cx_ite;
													area += v.x * (w.y - u.y);
													var cf = w.y * v.x - w.x * v.y;
													_this10.localCOMx += (v.x + w.x) * cf;
													_this10.localCOMy += (v.y + w.y) * cf;
													u = v;
													v = w;
													cx_ite = cx_ite.next;
												}
												cx_ite = _this10.lverts.next;
												var w1 = cx_ite;
												area += v.x * (w1.y - u.y);
												var cf1 = w1.y * v.x - w1.x * v.y;
												_this10.localCOMx += (v.x + w1.x) * cf1;
												_this10.localCOMy += (v.y + w1.y) * cf1;
												u = v;
												v = w1;
												cx_ite = cx_ite.next;
												var w2 = cx_ite;
												area += v.x * (w2.y - u.y);
												var cf2 = w2.y * v.x - w2.x * v.y;
												_this10.localCOMx += (v.x + w2.x) * cf2;
												_this10.localCOMy += (v.y + w2.y) * cf2;
												area = 1 / (3 * area);
												var t2 = area;
												_this10.localCOMx *= t2;
												_this10.localCOMy *= t2;
											}
										}
										if(_this9.wrap_localCOM != null) {
											_this9.wrap_localCOM.zpp_inner.x = _this9.localCOMx;
											_this9.wrap_localCOM.zpp_inner.y = _this9.localCOMy;
										}
									}
									var _this11 = _this9.body;
									if(_this11.zip_axis) {
										_this11.zip_axis = false;
										_this11.axisx = Math.sin(_this11.rot);
										_this11.axisy = Math.cos(_this11.rot);
									}
									_this9.worldCOMx = _this9.body.posx + (_this9.body.axisy * _this9.localCOMx - _this9.body.axisx * _this9.localCOMy);
									_this9.worldCOMy = _this9.body.posy + (_this9.localCOMx * _this9.body.axisx + _this9.localCOMy * _this9.body.axisy);
								}
							}
							var rx = _this9.radius;
							var ry = _this9.radius;
							_this9.aabb.minx = _this9.worldCOMx - rx;
							_this9.aabb.miny = _this9.worldCOMy - ry;
							_this9.aabb.maxx = _this9.worldCOMx + rx;
							_this9.aabb.maxy = _this9.worldCOMy + ry;
						} else {
							var _this12 = shape.polygon;
							if(_this12.zip_gverts) {
								if(_this12.body != null) {
									_this12.zip_gverts = false;
									_this12.validate_lverts();
									var _this13 = _this12.body;
									if(_this13.zip_axis) {
										_this13.zip_axis = false;
										_this13.axisx = Math.sin(_this13.rot);
										_this13.axisy = Math.cos(_this13.rot);
									}
									var li = _this12.lverts.next;
									var cx_ite1 = _this12.gverts.next;
									while(cx_ite1 != null) {
										var g2 = cx_ite1;
										var l = li;
										li = li.next;
										g2.x = _this12.body.posx + (_this12.body.axisy * l.x - _this12.body.axisx * l.y);
										g2.y = _this12.body.posy + (l.x * _this12.body.axisx + l.y * _this12.body.axisy);
										cx_ite1 = cx_ite1.next;
									}
								}
							}
							var p0 = _this12.gverts.next;
							_this12.aabb.minx = p0.x;
							_this12.aabb.miny = p0.y;
							_this12.aabb.maxx = p0.x;
							_this12.aabb.maxy = p0.y;
							var cx_ite2 = _this12.gverts.next.next;
							while(cx_ite2 != null) {
								var p = cx_ite2;
								if(p.x < _this12.aabb.minx) {
									_this12.aabb.minx = p.x;
								}
								if(p.x > _this12.aabb.maxx) {
									_this12.aabb.maxx = p.x;
								}
								if(p.y < _this12.aabb.miny) {
									_this12.aabb.miny = p.y;
								}
								if(p.y > _this12.aabb.maxy) {
									_this12.aabb.maxy = p.y;
								}
								cx_ite2 = cx_ite2.next;
							}
						}
					}
				}
			}
			var a9 = shape.aabb;
			aabb.minx = a9.minx - 3.0;
			aabb.miny = a9.miny - 3.0;
			aabb.maxx = a9.maxx + 3.0;
			aabb.maxy = a9.maxy + 3.0;
			var tree1 = (node.dyn = shape.body.type == 1 ? false : !shape.body.component.sleeping) ? this.dtree : this.stree;
			if(tree1.root == null) {
				tree1.root = node;
				tree1.root.parent = null;
			} else {
				var leafaabb = node.aabb;
				var node2 = tree1.root;
				while(node2.child1 != null) {
					var child11 = node2.child1;
					var child21 = node2.child2;
					var _this14 = node2.aabb;
					var area1 = (_this14.maxx - _this14.minx + (_this14.maxy - _this14.miny)) * 2;
					var _this15 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
					var a10 = node2.aabb;
					_this15.minx = a10.minx < leafaabb.minx ? a10.minx : leafaabb.minx;
					_this15.miny = a10.miny < leafaabb.miny ? a10.miny : leafaabb.miny;
					_this15.maxx = a10.maxx > leafaabb.maxx ? a10.maxx : leafaabb.maxx;
					_this15.maxy = a10.maxy > leafaabb.maxy ? a10.maxy : leafaabb.maxy;
					var _this16 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
					var carea = (_this16.maxx - _this16.minx + (_this16.maxy - _this16.miny)) * 2;
					var cost = 2 * carea;
					var icost = 2 * (carea - area1);
					var _this17 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
					var b10 = child11.aabb;
					_this17.minx = leafaabb.minx < b10.minx ? leafaabb.minx : b10.minx;
					_this17.miny = leafaabb.miny < b10.miny ? leafaabb.miny : b10.miny;
					_this17.maxx = leafaabb.maxx > b10.maxx ? leafaabb.maxx : b10.maxx;
					_this17.maxy = leafaabb.maxy > b10.maxy ? leafaabb.maxy : b10.maxy;
					var cost1;
					if(child11.child1 == null) {
						var _this18 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
						cost1 = (_this18.maxx - _this18.minx + (_this18.maxy - _this18.miny)) * 2 + icost;
					} else {
						var _this19 = child11.aabb;
						var oarea = (_this19.maxx - _this19.minx + (_this19.maxy - _this19.miny)) * 2;
						var _this20 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
						var narea = (_this20.maxx - _this20.minx + (_this20.maxy - _this20.miny)) * 2;
						cost1 = narea - oarea + icost;
					}
					var _this21 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
					var b11 = child21.aabb;
					_this21.minx = leafaabb.minx < b11.minx ? leafaabb.minx : b11.minx;
					_this21.miny = leafaabb.miny < b11.miny ? leafaabb.miny : b11.miny;
					_this21.maxx = leafaabb.maxx > b11.maxx ? leafaabb.maxx : b11.maxx;
					_this21.maxy = leafaabb.maxy > b11.maxy ? leafaabb.maxy : b11.maxy;
					var cost2;
					if(child21.child1 == null) {
						var _this22 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
						cost2 = (_this22.maxx - _this22.minx + (_this22.maxy - _this22.miny)) * 2 + icost;
					} else {
						var _this23 = child21.aabb;
						var oarea1 = (_this23.maxx - _this23.minx + (_this23.maxy - _this23.miny)) * 2;
						var _this24 = zpp_$nape_space_ZPP_$AABBTree.tmpaabb;
						var narea1 = (_this24.maxx - _this24.minx + (_this24.maxy - _this24.miny)) * 2;
						cost2 = narea1 - oarea1 + icost;
					}
					if(cost < cost1 && cost < cost2) {
						break;
					} else {
						node2 = cost1 < cost2 ? child11 : child21;
					}
				}
				var sibling1 = node2;
				var oparent = sibling1.parent;
				var nparent;
				if(zpp_$nape_space_ZPP_$AABBNode.zpp_pool == null) {
					nparent = new zpp_$nape_space_ZPP_$AABBNode();
				} else {
					nparent = zpp_$nape_space_ZPP_$AABBNode.zpp_pool;
					zpp_$nape_space_ZPP_$AABBNode.zpp_pool = nparent.next;
					nparent.next = null;
				}
				if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
					nparent.aabb = new zpp_$nape_geom_ZPP_$AABB();
				} else {
					nparent.aabb = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
					zpp_$nape_geom_ZPP_$AABB.zpp_pool = nparent.aabb.next;
					nparent.aabb.next = null;
				}
				nparent.moved = false;
				nparent.synced = false;
				nparent.first_sync = false;
				nparent.parent = oparent;
				var _this25 = nparent.aabb;
				var b12 = sibling1.aabb;
				_this25.minx = leafaabb.minx < b12.minx ? leafaabb.minx : b12.minx;
				_this25.miny = leafaabb.miny < b12.miny ? leafaabb.miny : b12.miny;
				_this25.maxx = leafaabb.maxx > b12.maxx ? leafaabb.maxx : b12.maxx;
				_this25.maxy = leafaabb.maxy > b12.maxy ? leafaabb.maxy : b12.maxy;
				nparent.height = sibling1.height + 1;
				if(oparent != null) {
					if(oparent.child1 == sibling1) {
						oparent.child1 = nparent;
					} else {
						oparent.child2 = nparent;
					}
					nparent.child1 = sibling1;
					nparent.child2 = node;
					sibling1.parent = nparent;
					node.parent = nparent;
				} else {
					nparent.child1 = sibling1;
					nparent.child2 = node;
					sibling1.parent = nparent;
					node.parent = nparent;
					tree1.root = nparent;
				}
				node2 = node.parent;
				while(node2 != null) {
					if(!(node2.child1 == null || node2.height < 2)) {
						var b13 = node2.child1;
						var c1 = node2.child2;
						var balance1 = c1.height - b13.height;
						if(balance1 > 1) {
							var f2 = c1.child1;
							var g3 = c1.child2;
							c1.child1 = node2;
							c1.parent = node2.parent;
							node2.parent = c1;
							if(c1.parent != null) {
								if(c1.parent.child1 == node2) {
									c1.parent.child1 = c1;
								} else {
									c1.parent.child2 = c1;
								}
							} else {
								tree1.root = c1;
							}
							if(f2.height > g3.height) {
								c1.child2 = f2;
								node2.child2 = g3;
								g3.parent = node2;
								var _this26 = node2.aabb;
								var a11 = b13.aabb;
								var b14 = g3.aabb;
								_this26.minx = a11.minx < b14.minx ? a11.minx : b14.minx;
								_this26.miny = a11.miny < b14.miny ? a11.miny : b14.miny;
								_this26.maxx = a11.maxx > b14.maxx ? a11.maxx : b14.maxx;
								_this26.maxy = a11.maxy > b14.maxy ? a11.maxy : b14.maxy;
								var _this27 = c1.aabb;
								var a12 = node2.aabb;
								var b15 = f2.aabb;
								_this27.minx = a12.minx < b15.minx ? a12.minx : b15.minx;
								_this27.miny = a12.miny < b15.miny ? a12.miny : b15.miny;
								_this27.maxx = a12.maxx > b15.maxx ? a12.maxx : b15.maxx;
								_this27.maxy = a12.maxy > b15.maxy ? a12.maxy : b15.maxy;
								var x9 = b13.height;
								var y9 = g3.height;
								node2.height = 1 + (x9 > y9 ? x9 : y9);
								var x10 = node2.height;
								var y10 = f2.height;
								c1.height = 1 + (x10 > y10 ? x10 : y10);
							} else {
								c1.child2 = g3;
								node2.child2 = f2;
								f2.parent = node2;
								var _this28 = node2.aabb;
								var a13 = b13.aabb;
								var b16 = f2.aabb;
								_this28.minx = a13.minx < b16.minx ? a13.minx : b16.minx;
								_this28.miny = a13.miny < b16.miny ? a13.miny : b16.miny;
								_this28.maxx = a13.maxx > b16.maxx ? a13.maxx : b16.maxx;
								_this28.maxy = a13.maxy > b16.maxy ? a13.maxy : b16.maxy;
								var _this29 = c1.aabb;
								var a14 = node2.aabb;
								var b17 = g3.aabb;
								_this29.minx = a14.minx < b17.minx ? a14.minx : b17.minx;
								_this29.miny = a14.miny < b17.miny ? a14.miny : b17.miny;
								_this29.maxx = a14.maxx > b17.maxx ? a14.maxx : b17.maxx;
								_this29.maxy = a14.maxy > b17.maxy ? a14.maxy : b17.maxy;
								var x11 = b13.height;
								var y11 = f2.height;
								node2.height = 1 + (x11 > y11 ? x11 : y11);
								var x12 = node2.height;
								var y12 = g3.height;
								c1.height = 1 + (x12 > y12 ? x12 : y12);
							}
							node2 = c1;
						} else if(balance1 < -1) {
							var f3 = b13.child1;
							var g4 = b13.child2;
							b13.child1 = node2;
							b13.parent = node2.parent;
							node2.parent = b13;
							if(b13.parent != null) {
								if(b13.parent.child1 == node2) {
									b13.parent.child1 = b13;
								} else {
									b13.parent.child2 = b13;
								}
							} else {
								tree1.root = b13;
							}
							if(f3.height > g4.height) {
								b13.child2 = f3;
								node2.child1 = g4;
								g4.parent = node2;
								var _this30 = node2.aabb;
								var a15 = c1.aabb;
								var b18 = g4.aabb;
								_this30.minx = a15.minx < b18.minx ? a15.minx : b18.minx;
								_this30.miny = a15.miny < b18.miny ? a15.miny : b18.miny;
								_this30.maxx = a15.maxx > b18.maxx ? a15.maxx : b18.maxx;
								_this30.maxy = a15.maxy > b18.maxy ? a15.maxy : b18.maxy;
								var _this31 = b13.aabb;
								var a16 = node2.aabb;
								var b19 = f3.aabb;
								_this31.minx = a16.minx < b19.minx ? a16.minx : b19.minx;
								_this31.miny = a16.miny < b19.miny ? a16.miny : b19.miny;
								_this31.maxx = a16.maxx > b19.maxx ? a16.maxx : b19.maxx;
								_this31.maxy = a16.maxy > b19.maxy ? a16.maxy : b19.maxy;
								var x13 = c1.height;
								var y13 = g4.height;
								node2.height = 1 + (x13 > y13 ? x13 : y13);
								var x14 = node2.height;
								var y14 = f3.height;
								b13.height = 1 + (x14 > y14 ? x14 : y14);
							} else {
								b13.child2 = g4;
								node2.child1 = f3;
								f3.parent = node2;
								var _this32 = node2.aabb;
								var a17 = c1.aabb;
								var b20 = f3.aabb;
								_this32.minx = a17.minx < b20.minx ? a17.minx : b20.minx;
								_this32.miny = a17.miny < b20.miny ? a17.miny : b20.miny;
								_this32.maxx = a17.maxx > b20.maxx ? a17.maxx : b20.maxx;
								_this32.maxy = a17.maxy > b20.maxy ? a17.maxy : b20.maxy;
								var _this33 = b13.aabb;
								var a18 = node2.aabb;
								var b21 = g4.aabb;
								_this33.minx = a18.minx < b21.minx ? a18.minx : b21.minx;
								_this33.miny = a18.miny < b21.miny ? a18.miny : b21.miny;
								_this33.maxx = a18.maxx > b21.maxx ? a18.maxx : b21.maxx;
								_this33.maxy = a18.maxy > b21.maxy ? a18.maxy : b21.maxy;
								var x15 = c1.height;
								var y15 = f3.height;
								node2.height = 1 + (x15 > y15 ? x15 : y15);
								var x16 = node2.height;
								var y16 = g4.height;
								b13.height = 1 + (x16 > y16 ? x16 : y16);
							}
							node2 = b13;
						}
					}
					var child12 = node2.child1;
					var child22 = node2.child2;
					var x17 = child12.height;
					var y17 = child22.height;
					node2.height = 1 + (x17 > y17 ? x17 : y17);
					var _this34 = node2.aabb;
					var a19 = child12.aabb;
					var b22 = child22.aabb;
					_this34.minx = a19.minx < b22.minx ? a19.minx : b22.minx;
					_this34.miny = a19.miny < b22.miny ? a19.miny : b22.miny;
					_this34.maxx = a19.maxx > b22.maxx ? a19.maxx : b22.maxx;
					_this34.maxy = a19.maxy > b22.maxy ? a19.maxy : b22.maxy;
					node2 = node2.parent;
				}
			}
			node.synced = false;
			node = node.snext;
		}
		while(this.syncs != null) {
			var ret = this.syncs;
			this.syncs = ret.snext;
			ret.snext = null;
			var leaf = ret;
			if(leaf.moved) {
				continue;
			}
			leaf.moved = false;
			var lshape = leaf.shape;
			var lbody = lshape.body;
			if(lbody.component.sleeping) {
				continue;
			}
			var ab = leaf.aabb;
			var stack = null;
			if(this.dtree.root != null) {
				this.dtree.root.next = stack;
				stack = this.dtree.root;
			}
			while(stack != null) {
				var ret1 = stack;
				stack = ret1.next;
				ret1.next = null;
				var node = ret1;
				if(node == leaf) {
					continue;
				}
				if(node.child1 == null) {
					var shape = node.shape;
					if(shape.body != lshape.body && !(shape.body.type == 1 && lshape.body.type == 1)) {
						var x = node.aabb;
						if(x.miny <= ab.maxy && ab.miny <= x.maxy && x.minx <= ab.maxx && ab.minx <= x.maxx) {
							var id;
							var di;
							if(lshape.id < shape.id) {
								id = lshape.id;
								di = shape.id;
							} else {
								id = shape.id;
								di = lshape.id;
							}
							var s = lshape.pairs.length < shape.pairs.length ? lshape : shape;
							var p = null;
							var cx_ite = s.pairs.head;
							while(cx_ite != null) {
								var px = cx_ite.elt;
								if(px.id == id && px.di == di) {
									p = px;
									break;
								}
								cx_ite = cx_ite.next;
							}
							if(p != null) {
								if(p.sleeping) {
									p.sleeping = false;
									p.next = this.pairs;
									this.pairs = p;
									p.first = true;
								}
								continue;
							}
							if(zpp_$nape_space_ZPP_$AABBPair.zpp_pool == null) {
								p = new zpp_$nape_space_ZPP_$AABBPair();
							} else {
								p = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
								zpp_$nape_space_ZPP_$AABBPair.zpp_pool = p.next;
								p.next = null;
							}
							p.n1 = leaf;
							p.n2 = node;
							p.id = id;
							p.di = di;
							p.next = this.pairs;
							this.pairs = p;
							p.first = true;
							var _this = lshape.pairs;
							var ret2;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret2 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret2.next;
								ret2.next = null;
							}
							ret2.elt = p;
							var temp = ret2;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							var _this1 = shape.pairs;
							var ret3;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret3 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret3.next;
								ret3.next = null;
							}
							ret3.elt = p;
							var temp1 = ret3;
							temp1.next = _this1.head;
							_this1.head = temp1;
							_this1.modified = true;
							_this1.length++;
						}
					}
				} else {
					var x1 = node.aabb;
					if(x1.miny <= ab.maxy && ab.miny <= x1.maxy && x1.minx <= ab.maxx && ab.minx <= x1.maxx) {
						if(node.child1 != null) {
							node.child1.next = stack;
							stack = node.child1;
						}
						if(node.child2 != null) {
							node.child2.next = stack;
							stack = node.child2;
						}
					}
				}
			}
			if(this.stree.root != null) {
				this.stree.root.next = stack;
				stack = this.stree.root;
			}
			while(stack != null) {
				var ret4 = stack;
				stack = ret4.next;
				ret4.next = null;
				var node1 = ret4;
				if(node1 == leaf) {
					continue;
				}
				if(node1.child1 == null) {
					var shape1 = node1.shape;
					if(shape1.body != lshape.body && !(shape1.body.type == 1 && lshape.body.type == 1)) {
						var x2 = node1.aabb;
						if(x2.miny <= ab.maxy && ab.miny <= x2.maxy && x2.minx <= ab.maxx && ab.minx <= x2.maxx) {
							var id1;
							var di1;
							if(lshape.id < shape1.id) {
								id1 = lshape.id;
								di1 = shape1.id;
							} else {
								id1 = shape1.id;
								di1 = lshape.id;
							}
							var s1 = lshape.pairs.length < shape1.pairs.length ? lshape : shape1;
							var p1 = null;
							var cx_ite1 = s1.pairs.head;
							while(cx_ite1 != null) {
								var px1 = cx_ite1.elt;
								if(px1.id == id1 && px1.di == di1) {
									p1 = px1;
									break;
								}
								cx_ite1 = cx_ite1.next;
							}
							if(p1 != null) {
								if(p1.sleeping) {
									p1.sleeping = false;
									p1.next = this.pairs;
									this.pairs = p1;
									p1.first = true;
								}
								continue;
							}
							if(zpp_$nape_space_ZPP_$AABBPair.zpp_pool == null) {
								p1 = new zpp_$nape_space_ZPP_$AABBPair();
							} else {
								p1 = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
								zpp_$nape_space_ZPP_$AABBPair.zpp_pool = p1.next;
								p1.next = null;
							}
							p1.n1 = leaf;
							p1.n2 = node1;
							p1.id = id1;
							p1.di = di1;
							p1.next = this.pairs;
							this.pairs = p1;
							p1.first = true;
							var _this2 = lshape.pairs;
							var ret5;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret5 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret5 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret5.next;
								ret5.next = null;
							}
							ret5.elt = p1;
							var temp2 = ret5;
							temp2.next = _this2.head;
							_this2.head = temp2;
							_this2.modified = true;
							_this2.length++;
							var _this3 = shape1.pairs;
							var ret6;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret6 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret6 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret6.next;
								ret6.next = null;
							}
							ret6.elt = p1;
							var temp3 = ret6;
							temp3.next = _this3.head;
							_this3.head = temp3;
							_this3.modified = true;
							_this3.length++;
						}
					}
				} else {
					var x3 = node1.aabb;
					if(x3.miny <= ab.maxy && ab.miny <= x3.maxy && x3.minx <= ab.maxx && ab.minx <= x3.maxx) {
						if(node1.child1 != null) {
							node1.child1.next = stack;
							stack = node1.child1;
						}
						if(node1.child2 != null) {
							node1.child2.next = stack;
							stack = node1.child2;
						}
					}
				}
			}
		}
		while(this.moves != null) {
			var ret = this.moves;
			this.moves = ret.mnext;
			ret.mnext = null;
			var leaf = ret;
			leaf.moved = false;
			var lshape = leaf.shape;
			var lbody = lshape.body;
			if(lbody.component.sleeping) {
				continue;
			}
			var ab = leaf.aabb;
			var stack = null;
			if(this.dtree.root != null) {
				this.dtree.root.next = stack;
				stack = this.dtree.root;
			}
			while(stack != null) {
				var ret1 = stack;
				stack = ret1.next;
				ret1.next = null;
				var node = ret1;
				if(node == leaf) {
					continue;
				}
				if(node.child1 == null) {
					var shape = node.shape;
					if(shape.body != lshape.body && !(shape.body.type == 1 && lshape.body.type == 1)) {
						var x = node.aabb;
						if(x.miny <= ab.maxy && ab.miny <= x.maxy && x.minx <= ab.maxx && ab.minx <= x.maxx) {
							var id;
							var di;
							if(lshape.id < shape.id) {
								id = lshape.id;
								di = shape.id;
							} else {
								id = shape.id;
								di = lshape.id;
							}
							var s = lshape.pairs.length < shape.pairs.length ? lshape : shape;
							var p = null;
							var cx_ite = s.pairs.head;
							while(cx_ite != null) {
								var px = cx_ite.elt;
								if(px.id == id && px.di == di) {
									p = px;
									break;
								}
								cx_ite = cx_ite.next;
							}
							if(p != null) {
								if(p.sleeping) {
									p.sleeping = false;
									p.next = this.pairs;
									this.pairs = p;
									p.first = true;
								}
								continue;
							}
							if(zpp_$nape_space_ZPP_$AABBPair.zpp_pool == null) {
								p = new zpp_$nape_space_ZPP_$AABBPair();
							} else {
								p = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
								zpp_$nape_space_ZPP_$AABBPair.zpp_pool = p.next;
								p.next = null;
							}
							p.n1 = leaf;
							p.n2 = node;
							p.id = id;
							p.di = di;
							p.next = this.pairs;
							this.pairs = p;
							p.first = true;
							var _this = lshape.pairs;
							var ret2;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret2 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret2.next;
								ret2.next = null;
							}
							ret2.elt = p;
							var temp = ret2;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							var _this1 = shape.pairs;
							var ret3;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret3 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret3.next;
								ret3.next = null;
							}
							ret3.elt = p;
							var temp1 = ret3;
							temp1.next = _this1.head;
							_this1.head = temp1;
							_this1.modified = true;
							_this1.length++;
						}
					}
				} else {
					var x1 = node.aabb;
					if(x1.miny <= ab.maxy && ab.miny <= x1.maxy && x1.minx <= ab.maxx && ab.minx <= x1.maxx) {
						if(node.child1 != null) {
							node.child1.next = stack;
							stack = node.child1;
						}
						if(node.child2 != null) {
							node.child2.next = stack;
							stack = node.child2;
						}
					}
				}
			}
			if(this.stree.root != null) {
				this.stree.root.next = stack;
				stack = this.stree.root;
			}
			while(stack != null) {
				var ret4 = stack;
				stack = ret4.next;
				ret4.next = null;
				var node1 = ret4;
				if(node1 == leaf) {
					continue;
				}
				if(node1.child1 == null) {
					var shape1 = node1.shape;
					if(shape1.body != lshape.body && !(shape1.body.type == 1 && lshape.body.type == 1)) {
						var x2 = node1.aabb;
						if(x2.miny <= ab.maxy && ab.miny <= x2.maxy && x2.minx <= ab.maxx && ab.minx <= x2.maxx) {
							var id1;
							var di1;
							if(lshape.id < shape1.id) {
								id1 = lshape.id;
								di1 = shape1.id;
							} else {
								id1 = shape1.id;
								di1 = lshape.id;
							}
							var s1 = lshape.pairs.length < shape1.pairs.length ? lshape : shape1;
							var p1 = null;
							var cx_ite1 = s1.pairs.head;
							while(cx_ite1 != null) {
								var px1 = cx_ite1.elt;
								if(px1.id == id1 && px1.di == di1) {
									p1 = px1;
									break;
								}
								cx_ite1 = cx_ite1.next;
							}
							if(p1 != null) {
								if(p1.sleeping) {
									p1.sleeping = false;
									p1.next = this.pairs;
									this.pairs = p1;
									p1.first = true;
								}
								continue;
							}
							if(zpp_$nape_space_ZPP_$AABBPair.zpp_pool == null) {
								p1 = new zpp_$nape_space_ZPP_$AABBPair();
							} else {
								p1 = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
								zpp_$nape_space_ZPP_$AABBPair.zpp_pool = p1.next;
								p1.next = null;
							}
							p1.n1 = leaf;
							p1.n2 = node1;
							p1.id = id1;
							p1.di = di1;
							p1.next = this.pairs;
							this.pairs = p1;
							p1.first = true;
							var _this2 = lshape.pairs;
							var ret5;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret5 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret5 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret5.next;
								ret5.next = null;
							}
							ret5.elt = p1;
							var temp2 = ret5;
							temp2.next = _this2.head;
							_this2.head = temp2;
							_this2.modified = true;
							_this2.length++;
							var _this3 = shape1.pairs;
							var ret6;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool == null) {
								ret6 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBPair();
							} else {
								ret6 = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = ret6.next;
								ret6.next = null;
							}
							ret6.elt = p1;
							var temp3 = ret6;
							temp3.next = _this3.head;
							_this3.head = temp3;
							_this3.modified = true;
							_this3.length++;
						}
					}
				} else {
					var x3 = node1.aabb;
					if(x3.miny <= ab.maxy && ab.miny <= x3.maxy && x3.minx <= ab.maxx && ab.minx <= x3.maxx) {
						if(node1.child1 != null) {
							node1.child1.next = stack;
							stack = node1.child1;
						}
						if(node1.child2 != null) {
							node1.child2.next = stack;
							stack = node1.child2;
						}
					}
				}
			}
		}
		var pre = null;
		var cur = this.pairs;
		while(cur != null) {
			var tmp;
			if(!cur.first) {
				var _this = cur.n1.aabb;
				var x = cur.n2.aabb;
				tmp = !(x.miny <= _this.maxy && _this.miny <= x.maxy && x.minx <= _this.maxx && _this.minx <= x.maxx);
			} else {
				tmp = false;
			}
			if(tmp) {
				if(pre == null) {
					this.pairs = cur.next;
				} else {
					pre.next = cur.next;
				}
				var _this1 = cur.n1.shape.pairs;
				var pre1 = null;
				var cur1 = _this1.head;
				var ret = false;
				while(cur1 != null) {
					if(cur1.elt == cur) {
						var old;
						var ret1;
						if(pre1 == null) {
							old = _this1.head;
							ret1 = old.next;
							_this1.head = ret1;
							if(_this1.head == null) {
								_this1.pushmod = true;
							}
						} else {
							old = pre1.next;
							ret1 = old.next;
							pre1.next = ret1;
							if(ret1 == null) {
								_this1.pushmod = true;
							}
						}
						var o = old;
						o.elt = null;
						o.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = o;
						_this1.modified = true;
						_this1.length--;
						_this1.pushmod = true;
						ret = true;
						break;
					}
					pre1 = cur1;
					cur1 = cur1.next;
				}
				var _this2 = cur.n2.shape.pairs;
				var pre2 = null;
				var cur2 = _this2.head;
				var ret2 = false;
				while(cur2 != null) {
					if(cur2.elt == cur) {
						var old1;
						var ret3;
						if(pre2 == null) {
							old1 = _this2.head;
							ret3 = old1.next;
							_this2.head = ret3;
							if(_this2.head == null) {
								_this2.pushmod = true;
							}
						} else {
							old1 = pre2.next;
							ret3 = old1.next;
							pre2.next = ret3;
							if(ret3 == null) {
								_this2.pushmod = true;
							}
						}
						var o1 = old1;
						o1.elt = null;
						o1.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = o1;
						_this2.modified = true;
						_this2.length--;
						_this2.pushmod = true;
						ret2 = true;
						break;
					}
					pre2 = cur2;
					cur2 = cur2.next;
				}
				var nxt = cur.next;
				if(cur.arb != null) {
					cur.arb.pair = null;
				}
				cur.arb = null;
				var o2 = cur;
				o2.n1 = o2.n2 = null;
				o2.sleeping = false;
				o2.next = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
				zpp_$nape_space_ZPP_$AABBPair.zpp_pool = o2;
				cur = nxt;
				continue;
			}
			var s1 = cur.n1.shape;
			var b1 = s1.body;
			var s2 = cur.n2.shape;
			var b2 = s2.body;
			if(!cur.first) {
				if((b1.component.sleeping || b1.type == 1) && (b2.component.sleeping || b2.type == 1)) {
					cur.sleeping = true;
					if(pre == null) {
						this.pairs = cur.next;
					} else {
						pre.next = cur.next;
					}
					cur = cur.next;
					continue;
				}
			}
			cur.first = false;
			var _this3 = s1.aabb;
			var x1 = s2.aabb;
			if(x1.miny <= _this3.maxy && _this3.miny <= x1.maxy && x1.minx <= _this3.maxx && _this3.minx <= x1.maxx) {
				var oarb = cur.arb;
				if(discrete) {
					cur.arb = space.narrowPhase(s1,s2,b1.type != 2 || b2.type != 2,cur.arb,false);
				} else {
					cur.arb = space.continuousEvent(s1,s2,b1.type != 2 || b2.type != 2,cur.arb,false);
				}
				if(cur.arb == null) {
					if(oarb != null) {
						oarb.pair = null;
					}
				} else {
					cur.arb.pair = cur;
				}
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,clear: function() {
		while(this.syncs != null) {
			var next = this.syncs.snext;
			this.syncs.snext = null;
			if(this.syncs.first_sync) {
				this.syncs.shape.node = null;
				this.syncs.shape.removedFromSpace();
				this.syncs.shape = null;
			}
			this.syncs = next;
		}
		while(this.moves != null) {
			var next = this.moves.mnext;
			this.moves.mnext = null;
			if(this.moves.first_sync) {
				this.moves.shape.node = null;
				this.moves.shape.removedFromSpace();
				this.moves.shape = null;
			}
			this.moves = next;
		}
		while(this.pairs != null) {
			var nxt = this.pairs.next;
			if(this.pairs.arb != null) {
				this.pairs.arb.pair = null;
			}
			this.pairs.arb = null;
			var _this = this.pairs.n1.shape.pairs;
			var obj = this.pairs;
			var pre = null;
			var cur = _this.head;
			var ret = false;
			while(cur != null) {
				if(cur.elt == obj) {
					var old;
					var ret1;
					if(pre == null) {
						old = _this.head;
						ret1 = old.next;
						_this.head = ret1;
						if(_this.head == null) {
							_this.pushmod = true;
						}
					} else {
						old = pre.next;
						ret1 = old.next;
						pre.next = ret1;
						if(ret1 == null) {
							_this.pushmod = true;
						}
					}
					var o = old;
					o.elt = null;
					o.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = o;
					_this.modified = true;
					_this.length--;
					_this.pushmod = true;
					ret = true;
					break;
				}
				pre = cur;
				cur = cur.next;
			}
			var _this1 = this.pairs.n2.shape.pairs;
			var obj1 = this.pairs;
			var pre1 = null;
			var cur1 = _this1.head;
			var ret2 = false;
			while(cur1 != null) {
				if(cur1.elt == obj1) {
					var old1;
					var ret3;
					if(pre1 == null) {
						old1 = _this1.head;
						ret3 = old1.next;
						_this1.head = ret3;
						if(_this1.head == null) {
							_this1.pushmod = true;
						}
					} else {
						old1 = pre1.next;
						ret3 = old1.next;
						pre1.next = ret3;
						if(ret3 == null) {
							_this1.pushmod = true;
						}
					}
					var o1 = old1;
					o1.elt = null;
					o1.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = o1;
					_this1.modified = true;
					_this1.length--;
					_this1.pushmod = true;
					ret2 = true;
					break;
				}
				pre1 = cur1;
				cur1 = cur1.next;
			}
			var o2 = this.pairs;
			o2.n1 = o2.n2 = null;
			o2.sleeping = false;
			o2.next = zpp_$nape_space_ZPP_$AABBPair.zpp_pool;
			zpp_$nape_space_ZPP_$AABBPair.zpp_pool = o2;
			this.pairs = nxt;
		}
		this.dtree.clear();
		this.stree.clear();
	}
	,shapesUnderPoint: function(x,y,filter,output) {
		this.sync_broadphase();
		var ret;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.weak = false;
		ret._immutable = false;
		ret.x = x;
		ret.y = y;
		var v = ret;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(v.x >= _this.minx && v.x <= _this.maxx && v.y >= _this.miny && v.y <= _this.maxy) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(node.shape.type == 0) {
								if(zpp_$nape_geom_ZPP_$Collide.circleContains(node.shape.circle,v)) {
									ret.push(node.shape.outer);
								}
							} else if(zpp_$nape_geom_ZPP_$Collide.polyContains(node.shape.polygon,v)) {
								ret.push(node.shape.outer);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(v.x >= _this.minx && v.x <= _this.maxx && v.y >= _this.miny && v.y <= _this.maxy) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(node.shape.type == 0) {
								if(zpp_$nape_geom_ZPP_$Collide.circleContains(node.shape.circle,v)) {
									ret.push(node.shape.outer);
								}
							} else if(zpp_$nape_geom_ZPP_$Collide.polyContains(node.shape.polygon,v)) {
								ret.push(node.shape.outer);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		var o = v;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return ret;
	}
	,bodiesUnderPoint: function(x,y,filter,output) {
		this.sync_broadphase();
		var ret;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.weak = false;
		ret._immutable = false;
		ret.x = x;
		ret.y = y;
		var v = ret;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(v.x >= _this.minx && v.x <= _this.maxx && v.y >= _this.miny && v.y <= _this.maxy) {
					if(node.child1 == null) {
						var body = node.shape.body.outer;
						if(!ret.has(body)) {
							var tmp;
							if(filter != null) {
								var _this1 = node.shape.filter;
								tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
							} else {
								tmp = true;
							}
							if(tmp) {
								if(node.shape.type == 0) {
									if(zpp_$nape_geom_ZPP_$Collide.circleContains(node.shape.circle,v)) {
										ret.push(body);
									}
								} else if(zpp_$nape_geom_ZPP_$Collide.polyContains(node.shape.polygon,v)) {
									ret.push(body);
								}
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(v.x >= _this.minx && v.x <= _this.maxx && v.y >= _this.miny && v.y <= _this.maxy) {
					if(node.child1 == null) {
						var body = node.shape.body.outer;
						if(!ret.has(body)) {
							var tmp;
							if(filter != null) {
								var _this1 = node.shape.filter;
								tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
							} else {
								tmp = true;
							}
							if(tmp) {
								if(node.shape.type == 0) {
									if(zpp_$nape_geom_ZPP_$Collide.circleContains(node.shape.circle,v)) {
										ret.push(body);
									}
								} else if(zpp_$nape_geom_ZPP_$Collide.polyContains(node.shape.polygon,v)) {
									ret.push(body);
								}
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		var o = v;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return ret;
	}
	,shapesInAABB: function(aabb,strict,containment,filter,output) {
		this.sync_broadphase();
		this.updateAABBShape(aabb);
		var ab = this.aabbShape.zpp_inner.aabb;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var x = node.aabb;
				if(x.minx >= ab.minx && x.miny >= ab.miny && x.maxx <= ab.maxx && x.maxy <= ab.maxy) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this = node.shape.filter;
							tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							ret.push(node.shape.outer);
						}
					} else {
						if(this.treeStack2 == null) {
							this.treeStack2 = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
						}
						this.treeStack2.add(node);
						while(this.treeStack2.head != null) {
							var node1 = this.treeStack2.pop_unsafe();
							if(node1.child1 == null) {
								var tmp1;
								if(filter != null) {
									var _this1 = node1.shape.filter;
									tmp1 = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
								} else {
									tmp1 = true;
								}
								if(tmp1) {
									ret.push(node1.shape.outer);
								}
							} else {
								if(node1.child1 != null) {
									this.treeStack2.add(node1.child1);
								}
								if(node1.child2 != null) {
									this.treeStack2.add(node1.child2);
								}
							}
						}
					}
				} else {
					var _this2 = node.aabb;
					if(ab.miny <= _this2.maxy && _this2.miny <= ab.maxy && ab.minx <= _this2.maxx && _this2.minx <= ab.maxx) {
						if(node.child1 == null) {
							var tmp2;
							if(filter != null) {
								var _this3 = node.shape.filter;
								tmp2 = (_this3.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this3.collisionGroup) != 0;
							} else {
								tmp2 = true;
							}
							if(tmp2) {
								if(strict) {
									if(containment) {
										if(zpp_$nape_geom_ZPP_$Collide.containTest(this.aabbShape.zpp_inner,node.shape)) {
											ret.push(node.shape.outer);
										}
									} else {
										var x1 = node.shape.aabb;
										if(x1.minx >= ab.minx && x1.miny >= ab.miny && x1.maxx <= ab.maxx && x1.maxy <= ab.maxy) {
											ret.push(node.shape.outer);
										} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.aabbShape.zpp_inner)) {
											ret.push(node.shape.outer);
										}
									}
								} else {
									var tmp3;
									if(containment) {
										var x2 = node.shape.aabb;
										tmp3 = x2.minx >= ab.minx && x2.miny >= ab.miny && x2.maxx <= ab.maxx && x2.maxy <= ab.maxy;
									} else {
										tmp3 = true;
									}
									if(tmp3) {
										ret.push(node.shape.outer);
									}
								}
							}
						} else {
							if(node.child1 != null) {
								this.treeStack.add(node.child1);
							}
							if(node.child2 != null) {
								this.treeStack.add(node.child2);
							}
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var x = node.aabb;
				if(x.minx >= ab.minx && x.miny >= ab.miny && x.maxx <= ab.maxx && x.maxy <= ab.maxy) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this = node.shape.filter;
							tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							ret.push(node.shape.outer);
						}
					} else {
						if(this.treeStack2 == null) {
							this.treeStack2 = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
						}
						this.treeStack2.add(node);
						while(this.treeStack2.head != null) {
							var node1 = this.treeStack2.pop_unsafe();
							if(node1.child1 == null) {
								var tmp1;
								if(filter != null) {
									var _this1 = node1.shape.filter;
									tmp1 = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
								} else {
									tmp1 = true;
								}
								if(tmp1) {
									ret.push(node1.shape.outer);
								}
							} else {
								if(node1.child1 != null) {
									this.treeStack2.add(node1.child1);
								}
								if(node1.child2 != null) {
									this.treeStack2.add(node1.child2);
								}
							}
						}
					}
				} else {
					var _this2 = node.aabb;
					if(ab.miny <= _this2.maxy && _this2.miny <= ab.maxy && ab.minx <= _this2.maxx && _this2.minx <= ab.maxx) {
						if(node.child1 == null) {
							var tmp2;
							if(filter != null) {
								var _this3 = node.shape.filter;
								tmp2 = (_this3.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this3.collisionGroup) != 0;
							} else {
								tmp2 = true;
							}
							if(tmp2) {
								if(strict) {
									if(containment) {
										if(zpp_$nape_geom_ZPP_$Collide.containTest(this.aabbShape.zpp_inner,node.shape)) {
											ret.push(node.shape.outer);
										}
									} else {
										var x1 = node.shape.aabb;
										if(x1.minx >= ab.minx && x1.miny >= ab.miny && x1.maxx <= ab.maxx && x1.maxy <= ab.maxy) {
											ret.push(node.shape.outer);
										} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.aabbShape.zpp_inner)) {
											ret.push(node.shape.outer);
										}
									}
								} else {
									var tmp3;
									if(containment) {
										var x2 = node.shape.aabb;
										tmp3 = x2.minx >= ab.minx && x2.miny >= ab.miny && x2.maxx <= ab.maxx && x2.maxy <= ab.maxy;
									} else {
										tmp3 = true;
									}
									if(tmp3) {
										ret.push(node.shape.outer);
									}
								}
							}
						} else {
							if(node.child1 != null) {
								this.treeStack.add(node.child1);
							}
							if(node.child2 != null) {
								this.treeStack.add(node.child2);
							}
						}
					}
				}
			}
		}
		return ret;
	}
	,bodiesInAABB: function(aabb,strict,containment,filter,output) {
		this.sync_broadphase();
		this.updateAABBShape(aabb);
		var ab = this.aabbShape.zpp_inner.aabb;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.failed == null) {
			this.failed = new nape_phys_BodyList();
		}
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var x = node.aabb;
				if(x.minx >= ab.minx && x.miny >= ab.miny && x.maxx <= ab.maxx && x.maxy <= ab.maxy) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this = node.shape.filter;
							tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							var body = node.shape.body.outer;
							if(!ret.has(body)) {
								ret.push(body);
							}
						}
					} else {
						if(this.treeStack2 == null) {
							this.treeStack2 = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
						}
						this.treeStack2.add(node);
						while(this.treeStack2.head != null) {
							var node1 = this.treeStack2.pop_unsafe();
							if(node1.child1 == null) {
								var tmp1;
								if(filter != null) {
									var _this1 = node1.shape.filter;
									tmp1 = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
								} else {
									tmp1 = true;
								}
								if(tmp1) {
									var body1 = node1.shape.body.outer;
									if(!ret.has(body1)) {
										ret.push(body1);
									}
								}
							} else {
								if(node1.child1 != null) {
									this.treeStack2.add(node1.child1);
								}
								if(node1.child2 != null) {
									this.treeStack2.add(node1.child2);
								}
							}
						}
					}
				} else {
					var _this2 = node.aabb;
					if(ab.miny <= _this2.maxy && _this2.miny <= ab.maxy && ab.minx <= _this2.maxx && _this2.minx <= ab.maxx) {
						if(node.child1 == null) {
							var body2 = node.shape.body.outer;
							var tmp2;
							if(filter != null) {
								var _this3 = node.shape.filter;
								tmp2 = (_this3.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this3.collisionGroup) != 0;
							} else {
								tmp2 = true;
							}
							if(tmp2) {
								if(strict) {
									if(containment) {
										if(!this.failed.has(body2)) {
											var col = zpp_$nape_geom_ZPP_$Collide.containTest(this.aabbShape.zpp_inner,node.shape);
											if(!ret.has(body2) && col) {
												ret.push(body2);
											} else if(!col) {
												ret.remove(body2);
												this.failed.push(body2);
											}
										}
									} else if(!ret.has(body2) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.aabbShape.zpp_inner)) {
										ret.push(body2);
									}
								} else if(containment) {
									if(!this.failed.has(body2)) {
										var x1 = node.shape.aabb;
										var col1 = x1.minx >= ab.minx && x1.miny >= ab.miny && x1.maxx <= ab.maxx && x1.maxy <= ab.maxy;
										if(!ret.has(body2) && col1) {
											ret.push(body2);
										} else if(!col1) {
											ret.remove(body2);
											this.failed.push(body2);
										}
									}
								} else {
									var tmp3;
									if(!ret.has(body2)) {
										var x2 = node.shape.aabb;
										tmp3 = x2.minx >= ab.minx && x2.miny >= ab.miny && x2.maxx <= ab.maxx && x2.maxy <= ab.maxy;
									} else {
										tmp3 = false;
									}
									if(tmp3) {
										ret.push(body2);
									}
								}
							}
						} else {
							if(node.child1 != null) {
								this.treeStack.add(node.child1);
							}
							if(node.child2 != null) {
								this.treeStack.add(node.child2);
							}
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var x = node.aabb;
				if(x.minx >= ab.minx && x.miny >= ab.miny && x.maxx <= ab.maxx && x.maxy <= ab.maxy) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this = node.shape.filter;
							tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							var body = node.shape.body.outer;
							if(!ret.has(body)) {
								ret.push(body);
							}
						}
					} else {
						if(this.treeStack2 == null) {
							this.treeStack2 = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
						}
						this.treeStack2.add(node);
						while(this.treeStack2.head != null) {
							var node1 = this.treeStack2.pop_unsafe();
							if(node1.child1 == null) {
								var tmp1;
								if(filter != null) {
									var _this1 = node1.shape.filter;
									tmp1 = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
								} else {
									tmp1 = true;
								}
								if(tmp1) {
									var body1 = node1.shape.body.outer;
									if(!ret.has(body1)) {
										ret.push(body1);
									}
								}
							} else {
								if(node1.child1 != null) {
									this.treeStack2.add(node1.child1);
								}
								if(node1.child2 != null) {
									this.treeStack2.add(node1.child2);
								}
							}
						}
					}
				} else {
					var _this2 = node.aabb;
					if(ab.miny <= _this2.maxy && _this2.miny <= ab.maxy && ab.minx <= _this2.maxx && _this2.minx <= ab.maxx) {
						if(node.child1 == null) {
							var body2 = node.shape.body.outer;
							var tmp2;
							if(filter != null) {
								var _this3 = node.shape.filter;
								tmp2 = (_this3.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this3.collisionGroup) != 0;
							} else {
								tmp2 = true;
							}
							if(tmp2) {
								if(strict) {
									if(containment) {
										if(!this.failed.has(body2)) {
											var col = zpp_$nape_geom_ZPP_$Collide.containTest(this.aabbShape.zpp_inner,node.shape);
											if(!ret.has(body2) && col) {
												ret.push(body2);
											} else if(!col) {
												ret.remove(body2);
												this.failed.push(body2);
											}
										}
									} else if(!ret.has(body2) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.aabbShape.zpp_inner)) {
										ret.push(body2);
									}
								} else if(containment) {
									if(!this.failed.has(body2)) {
										var x1 = node.shape.aabb;
										var col1 = x1.minx >= ab.minx && x1.miny >= ab.miny && x1.maxx <= ab.maxx && x1.maxy <= ab.maxy;
										if(!ret.has(body2) && col1) {
											ret.push(body2);
										} else if(!col1) {
											ret.remove(body2);
											this.failed.push(body2);
										}
									}
								} else {
									var tmp3;
									if(!ret.has(body2)) {
										var x2 = node.shape.aabb;
										tmp3 = x2.minx >= ab.minx && x2.miny >= ab.miny && x2.maxx <= ab.maxx && x2.maxy <= ab.maxy;
									} else {
										tmp3 = false;
									}
									if(tmp3) {
										ret.push(body2);
									}
								}
							}
						} else {
							if(node.child1 != null) {
								this.treeStack.add(node.child1);
							}
							if(node.child2 != null) {
								this.treeStack.add(node.child2);
							}
						}
					}
				}
			}
		}
		this.failed.clear();
		return ret;
	}
	,shapesInCircle: function(x,y,r,containment,filter,output) {
		this.sync_broadphase();
		this.updateCircShape(x,y,r);
		var ab = this.circShape.zpp_inner.aabb;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(zpp_$nape_geom_ZPP_$Collide.containTest(this.circShape.zpp_inner,node.shape)) {
									ret.push(node.shape.outer);
								}
							} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.circShape.zpp_inner)) {
								ret.push(node.shape.outer);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(zpp_$nape_geom_ZPP_$Collide.containTest(this.circShape.zpp_inner,node.shape)) {
									ret.push(node.shape.outer);
								}
							} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.circShape.zpp_inner)) {
								ret.push(node.shape.outer);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		return ret;
	}
	,bodiesInCircle: function(x,y,r,containment,filter,output) {
		this.sync_broadphase();
		this.updateCircShape(x,y,r);
		var ab = this.circShape.zpp_inner.aabb;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.failed == null) {
			this.failed = new nape_phys_BodyList();
		}
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var body = node.shape.body.outer;
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(!this.failed.has(body)) {
									var col = zpp_$nape_geom_ZPP_$Collide.containTest(this.circShape.zpp_inner,node.shape);
									if(!ret.has(body) && col) {
										ret.push(body);
									} else if(!col) {
										ret.remove(body);
										this.failed.push(body);
									}
								}
							} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.circShape.zpp_inner)) {
								ret.push(body);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var body = node.shape.body.outer;
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(!this.failed.has(body)) {
									var col = zpp_$nape_geom_ZPP_$Collide.containTest(this.circShape.zpp_inner,node.shape);
									if(!ret.has(body) && col) {
										ret.push(body);
									} else if(!col) {
										ret.remove(body);
										this.failed.push(body);
									}
								}
							} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,this.circShape.zpp_inner)) {
								ret.push(body);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		this.failed.clear();
		return ret;
	}
	,shapesInShape: function(shp,containment,filter,output) {
		this.sync_broadphase();
		this.validateShape(shp);
		var ab = shp.aabb;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(zpp_$nape_geom_ZPP_$Collide.containTest(shp,node.shape)) {
									ret.push(node.shape.outer);
								}
							} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,shp)) {
								ret.push(node.shape.outer);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(zpp_$nape_geom_ZPP_$Collide.containTest(shp,node.shape)) {
									ret.push(node.shape.outer);
								}
							} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,shp)) {
								ret.push(node.shape.outer);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		return ret;
	}
	,bodiesInShape: function(shp,containment,filter,output) {
		this.sync_broadphase();
		this.validateShape(shp);
		var ab = shp.aabb;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.failed == null) {
			this.failed = new nape_phys_BodyList();
		}
		if(this.stree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.stree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var body = node.shape.body.outer;
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(!this.failed.has(body)) {
									var col = zpp_$nape_geom_ZPP_$Collide.containTest(shp,node.shape);
									if(!ret.has(body) && col) {
										ret.push(body);
									} else if(!col) {
										ret.remove(body);
										this.failed.push(body);
									}
								}
							} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,shp)) {
								ret.push(body);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		if(this.dtree.root != null) {
			if(this.treeStack == null) {
				this.treeStack = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
			}
			this.treeStack.add(this.dtree.root);
			while(this.treeStack.head != null) {
				var node = this.treeStack.pop_unsafe();
				var _this = node.aabb;
				if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
					if(node.child1 == null) {
						var body = node.shape.body.outer;
						var tmp;
						if(filter != null) {
							var _this1 = node.shape.filter;
							tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
						} else {
							tmp = true;
						}
						if(tmp) {
							if(containment) {
								if(!this.failed.has(body)) {
									var col = zpp_$nape_geom_ZPP_$Collide.containTest(shp,node.shape);
									if(!ret.has(body) && col) {
										ret.push(body);
									} else if(!col) {
										ret.remove(body);
										this.failed.push(body);
									}
								}
							} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(node.shape,shp)) {
								ret.push(body);
							}
						}
					} else {
						if(node.child1 != null) {
							this.treeStack.add(node.child1);
						}
						if(node.child2 != null) {
							this.treeStack.add(node.child2);
						}
					}
				}
			}
		}
		this.failed.clear();
		return ret;
	}
	,rayCast: function(ray,inner,filter) {
		if(this.openlist == null) {
			this.openlist = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
		}
		this.sync_broadphase();
		ray.validate_dir();
		var mint = ray.maxdist;
		if(this.dtree.root != null) {
			if(ray.aabbtest(this.dtree.root.aabb)) {
				var t = ray.aabbsect(this.dtree.root.aabb);
				if(t >= 0 && t < mint) {
					this.dtree.root.rayt = t;
					var pre = null;
					var cx_ite = this.openlist.head;
					while(cx_ite != null) {
						var j = cx_ite.elt;
						if(this.dtree.root.rayt < j.rayt) {
							break;
						}
						pre = cx_ite;
						cx_ite = cx_ite.next;
					}
					var _this = this.openlist;
					var o = this.dtree.root;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$AABBNode();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = o;
					var temp = ret;
					if(pre == null) {
						temp.next = _this.head;
						_this.head = temp;
					} else {
						temp.next = pre.next;
						pre.next = temp;
					}
					_this.pushmod = _this.modified = true;
					_this.length++;
				}
			}
		}
		if(this.stree.root != null) {
			if(ray.aabbtest(this.stree.root.aabb)) {
				var t = ray.aabbsect(this.stree.root.aabb);
				if(t >= 0 && t < mint) {
					this.stree.root.rayt = t;
					var pre = null;
					var cx_ite = this.openlist.head;
					while(cx_ite != null) {
						var j = cx_ite.elt;
						if(this.stree.root.rayt < j.rayt) {
							break;
						}
						pre = cx_ite;
						cx_ite = cx_ite.next;
					}
					var _this = this.openlist;
					var o = this.stree.root;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$AABBNode();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = o;
					var temp = ret;
					if(pre == null) {
						temp.next = _this.head;
						_this.head = temp;
					} else {
						temp.next = pre.next;
						pre.next = temp;
					}
					_this.pushmod = _this.modified = true;
					_this.length++;
				}
			}
		}
		var minres = null;
		while(this.openlist.head != null) {
			var cnode = this.openlist.pop_unsafe();
			if(cnode.rayt >= mint) {
				break;
			}
			if(cnode.child1 == null) {
				var shape = cnode.shape;
				var tmp;
				if(filter != null) {
					var _this = shape.filter;
					tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					var result = shape.type == 0 ? ray.circlesect(shape.circle,inner,mint) : ray.aabbtest(shape.aabb) ? ray.polysect(shape.polygon,inner,mint) : null;
					if(result != null) {
						mint = result.zpp_inner.toiDistance;
						if(minres != null) {
							minres.zpp_inner.free();
						}
						minres = result;
					}
				}
			} else {
				if(cnode.child1 != null) {
					if(ray.aabbtest(cnode.child1.aabb)) {
						var t = ray.aabbsect(cnode.child1.aabb);
						if(t >= 0 && t < mint) {
							cnode.child1.rayt = t;
							var pre = null;
							var cx_ite = this.openlist.head;
							while(cx_ite != null) {
								var j = cx_ite.elt;
								if(cnode.child1.rayt < j.rayt) {
									break;
								}
								pre = cx_ite;
								cx_ite = cx_ite.next;
							}
							var _this1 = this.openlist;
							var o = cnode.child1;
							var ret;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool == null) {
								ret = new zpp_$nape_util_ZNPNode_$ZPP_$AABBNode();
							} else {
								ret = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.elt = o;
							var temp = ret;
							if(pre == null) {
								temp.next = _this1.head;
								_this1.head = temp;
							} else {
								temp.next = pre.next;
								pre.next = temp;
							}
							_this1.pushmod = _this1.modified = true;
							_this1.length++;
						}
					}
				}
				if(cnode.child2 != null) {
					if(ray.aabbtest(cnode.child2.aabb)) {
						var t1 = ray.aabbsect(cnode.child2.aabb);
						if(t1 >= 0 && t1 < mint) {
							cnode.child2.rayt = t1;
							var pre1 = null;
							var cx_ite1 = this.openlist.head;
							while(cx_ite1 != null) {
								var j1 = cx_ite1.elt;
								if(cnode.child2.rayt < j1.rayt) {
									break;
								}
								pre1 = cx_ite1;
								cx_ite1 = cx_ite1.next;
							}
							var _this2 = this.openlist;
							var o1 = cnode.child2;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$AABBNode();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = o1;
							var temp1 = ret1;
							if(pre1 == null) {
								temp1.next = _this2.head;
								_this2.head = temp1;
							} else {
								temp1.next = pre1.next;
								pre1.next = temp1;
							}
							_this2.pushmod = _this2.modified = true;
							_this2.length++;
						}
					}
				}
			}
		}
		this.openlist.clear();
		return minres;
	}
	,rayMultiCast: function(ray,inner,filter,output) {
		if(this.openlist == null) {
			this.openlist = new zpp_$nape_util_ZNPList_$ZPP_$AABBNode();
		}
		this.sync_broadphase();
		ray.validate_dir();
		var inf = ray.maxdist >= Infinity;
		var ret = output == null ? new nape_geom_RayResultList() : output;
		if(this.dtree.root != null) {
			if(ray.aabbtest(this.dtree.root.aabb)) {
				if(inf) {
					this.openlist.add(this.dtree.root);
				} else {
					var t = ray.aabbsect(this.dtree.root.aabb);
					if(t >= 0 && t < ray.maxdist) {
						this.openlist.add(this.dtree.root);
					}
				}
			}
		}
		if(this.stree.root != null) {
			if(ray.aabbtest(this.stree.root.aabb)) {
				if(inf) {
					this.openlist.add(this.stree.root);
				} else {
					var t = ray.aabbsect(this.stree.root.aabb);
					if(t >= 0 && t < ray.maxdist) {
						this.openlist.add(this.stree.root);
					}
				}
			}
		}
		while(this.openlist.head != null) {
			var cnode = this.openlist.pop_unsafe();
			if(cnode.child1 == null) {
				var shape = cnode.shape;
				var tmp;
				if(filter != null) {
					var _this = shape.filter;
					tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(shape.type == 0) {
						ray.circlesect2(shape.circle,inner,ret);
					} else if(ray.aabbtest(shape.aabb)) {
						ray.polysect2(shape.polygon,inner,ret);
					}
				}
			} else {
				if(cnode.child1 != null) {
					if(ray.aabbtest(cnode.child1.aabb)) {
						if(inf) {
							this.openlist.add(cnode.child1);
						} else {
							var t = ray.aabbsect(cnode.child1.aabb);
							if(t >= 0 && t < ray.maxdist) {
								this.openlist.add(cnode.child1);
							}
						}
					}
				}
				if(cnode.child2 != null) {
					if(ray.aabbtest(cnode.child2.aabb)) {
						if(inf) {
							this.openlist.add(cnode.child2);
						} else {
							var t1 = ray.aabbsect(cnode.child2.aabb);
							if(t1 >= 0 && t1 < ray.maxdist) {
								this.openlist.add(cnode.child2);
							}
						}
					}
				}
			}
		}
		this.openlist.clear();
		return ret;
	}
});
var zpp_$nape_space_ZPP_$Island = function() {
	this.waket = 0;
	this.sleep = false;
	this.comps = null;
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this._inuse = false;
	this.next = null;
	this.comps = new zpp_$nape_util_ZNPList_$ZPP_$Component();
};
zpp_$nape_space_ZPP_$Island.__name__ = true;
zpp_$nape_space_ZPP_$Island.prototype = {
	pop: function() {
		var ret = this.next;
		this.next = ret.next;
		ret._inuse = false;
		if(this.next == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
};
var zpp_$nape_space_ZPP_$Component = function() {
	this.woken = false;
	this.waket = 0;
	this.sleeping = false;
	this.island = null;
	this.constraint = null;
	this.body = null;
	this.isBody = false;
	this.rank = 0;
	this.parent = null;
	this.next = null;
	this.sleeping = false;
	this.island = null;
	this.parent = this;
	this.rank = 0;
	this.woken = false;
};
zpp_$nape_space_ZPP_$Component.__name__ = true;
var zpp_$nape_space_ZPP_$CallbackSet = function() {
	this.lazydel = false;
	this.freed = false;
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this._inuse = false;
	this.next = null;
	this.int2 = null;
	this.int1 = null;
	this.di = 0;
	this.id = 0;
	this.arbiters = new zpp_$nape_util_ZNPList_$ZPP_$Arbiter();
};
zpp_$nape_space_ZPP_$CallbackSet.__name__ = true;
zpp_$nape_space_ZPP_$CallbackSet.get = function(i1,i2) {
	var ret;
	if(zpp_$nape_space_ZPP_$CallbackSet.zpp_pool == null) {
		ret = new zpp_$nape_space_ZPP_$CallbackSet();
	} else {
		ret = zpp_$nape_space_ZPP_$CallbackSet.zpp_pool;
		zpp_$nape_space_ZPP_$CallbackSet.zpp_pool = ret.next;
		ret.next = null;
	}
	ret.freed = false;
	ret.lazydel = false;
	ret.COLLISIONstate = 1;
	ret.COLLISIONstamp = 0;
	ret.SENSORstate = 1;
	ret.SENSORstamp = 0;
	ret.FLUIDstate = 1;
	ret.FLUIDstamp = 0;
	if(i1.id < i2.id) {
		ret.int1 = i1;
		ret.int2 = i2;
	} else {
		ret.int1 = i2;
		ret.int2 = i1;
	}
	ret.id = ret.int1.id;
	ret.di = ret.int2.id;
	return ret;
};
zpp_$nape_space_ZPP_$CallbackSet.prototype = {
	pop: function() {
		var ret = this.next;
		this.next = ret.next;
		ret._inuse = false;
		if(this.next == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.next;
		this.pop();
		return ret;
	}
	,remove_arb: function(x) {
		var _this = this.arbiters;
		var pre = null;
		var cur = _this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == x) {
				var old;
				var ret1;
				if(pre == null) {
					old = _this.head;
					ret1 = old.next;
					_this.head = ret1;
					if(_this.head == null) {
						_this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						_this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
				_this.modified = true;
				_this.length--;
				_this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,empty_arb: function(type) {
		var retvar;
		retvar = true;
		var cx_ite = this.arbiters.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			if((x.type & type) == 0) {
				cx_ite = cx_ite.next;
				continue;
			} else {
				retvar = false;
				break;
			}
		}
		return retvar;
	}
};
var zpp_$nape_space_ZPP_$CbSetManager = function(space) {
	this.space = null;
	this.cbsets = null;
	if(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool == null) {
		this.cbsets = new zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet();
	} else {
		this.cbsets = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool = this.cbsets.next;
		this.cbsets.next = null;
	}
	this.cbsets.lt = zpp_$nape_callbacks_ZPP_$CbSet.setlt;
	this.space = space;
};
zpp_$nape_space_ZPP_$CbSetManager.__name__ = true;
zpp_$nape_space_ZPP_$CbSetManager.prototype = {
	get: function(cbTypes) {
		if(cbTypes.head == null) {
			return null;
		}
		var fake;
		if(zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool == null) {
			fake = new zpp_$nape_callbacks_ZPP_$CbSet();
		} else {
			fake = zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool;
			zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool = fake.next;
			fake.next = null;
		}
		var faketypes = fake.cbTypes;
		fake.cbTypes = cbTypes;
		var res = this.cbsets.find_weak(fake);
		var ret;
		if(res != null) {
			ret = res.data;
		} else {
			var set = zpp_$nape_callbacks_ZPP_$CbSet.get(cbTypes);
			this.cbsets.insert(set);
			set.manager = this;
			ret = set;
		}
		fake.cbTypes = faketypes;
		var o = fake;
		o.listeners.clear();
		o.zip_listeners = true;
		o.bodylisteners.clear();
		o.zip_bodylisteners = true;
		o.conlisteners.clear();
		o.zip_conlisteners = true;
		while(o.cbTypes.head != null) {
			var cb = o.cbTypes.pop_unsafe();
			cb.cbsets.remove(o);
		}
		o.next = zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool;
		zpp_$nape_callbacks_ZPP_$CbSet.zpp_pool = o;
		return ret;
	}
	,remove: function(set) {
		this.cbsets.remove(set);
		while(set.cbpairs.head != null) {
			var pair = set.cbpairs.pop_unsafe();
			if(pair.a != pair.b) {
				if(set == pair.a) {
					pair.b.cbpairs.remove(pair);
				} else {
					pair.a.cbpairs.remove(pair);
				}
			}
			var o = pair;
			o.a = o.b = null;
			o.listeners.clear();
			o.next = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
			zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = o;
		}
		set.manager = null;
	}
	,clear: function() {
	}
};
var zpp_$nape_space_ZPP_$Space = function(gravity,broadphase) {
	this.prelisteners = null;
	this.precb = null;
	this.continuous = false;
	this.toiEvents = null;
	this.pre_dt = 0.0;
	this.convexShapeList = null;
	this.cbsets = null;
	this.callbackset_list = null;
	this.callbacks = null;
	this.wrap_listeners = null;
	this.listeners = null;
	this.islands = null;
	this.staticsleep = null;
	this.wrap_livecon = null;
	this.live_constraints = null;
	this.wrap_live = null;
	this.live = null;
	this.wrap_arbiters = null;
	this.s_arbiters = null;
	this.f_arbiters = null;
	this.c_arbiters_false = null;
	this.c_arbiters_true = null;
	this.sortcontacts = false;
	this.time = 0.0;
	this.midstep = false;
	this.stamp = 0;
	this.global_ang_drag = 0.0;
	this.global_lin_drag = 0.0;
	this.__static = null;
	this.bphase = null;
	this.kinematics = null;
	this.wrap_constraints = null;
	this.constraints = null;
	this.wrap_compounds = null;
	this.compounds = null;
	this.wrap_bodies = null;
	this.bodies = null;
	this.wrap_gravity = null;
	this.gravityy = 0.0;
	this.gravityx = 0.0;
	this.userData = null;
	this.outer = null;
	this.toiEvents = new zpp_$nape_util_ZNPList_$ZPP_$ToiEvent();
	this.global_lin_drag = 0.015;
	this.global_ang_drag = 0.015;
	this.precb = new nape_callbacks_PreCallback();
	this.precb.zpp_inner = new zpp_$nape_callbacks_ZPP_$Callback();
	this.sortcontacts = true;
	this.pre_dt = 0.0;
	var tmp;
	if(broadphase != null) {
		if(zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE = new nape_space_Broadphase();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		tmp = broadphase == zpp_$nape_util_ZPP_$Flags.Broadphase_DYNAMIC_AABB_TREE;
	} else {
		tmp = true;
	}
	if(tmp) {
		this.bphase = new zpp_$nape_space_ZPP_$DynAABBPhase(this);
	} else {
		if(zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE == null) {
			zpp_$nape_util_ZPP_$Flags.internal = true;
			zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE = new nape_space_Broadphase();
			zpp_$nape_util_ZPP_$Flags.internal = false;
		}
		if(broadphase == zpp_$nape_util_ZPP_$Flags.Broadphase_SWEEP_AND_PRUNE) {
			this.bphase = new zpp_$nape_space_ZPP_$SweepPhase(this);
		}
	}
	this.time = 0.0;
	var me = this;
	if(gravity != null) {
		this.gravityx = gravity.x;
		this.gravityy = gravity.y;
	} else {
		this.gravityx = 0;
		this.gravityy = 0;
	}
	this.bodies = new zpp_$nape_util_ZNPList_$ZPP_$Body();
	this.wrap_bodies = zpp_$nape_util_ZPP_$BodyList.get(this.bodies);
	this.wrap_bodies.zpp_inner.adder = $bind(this,this.bodies_adder);
	this.wrap_bodies.zpp_inner.subber = $bind(this,this.bodies_subber);
	this.compounds = new zpp_$nape_util_ZNPList_$ZPP_$Compound();
	this.wrap_compounds = zpp_$nape_util_ZPP_$CompoundList.get(this.compounds);
	this.wrap_compounds.zpp_inner.adder = $bind(this,this.compounds_adder);
	this.wrap_compounds.zpp_inner.subber = $bind(this,this.compounds_subber);
	this.kinematics = new zpp_$nape_util_ZNPList_$ZPP_$Body();
	this.c_arbiters_true = new zpp_$nape_util_ZNPList_$ZPP_$ColArbiter();
	this.c_arbiters_false = new zpp_$nape_util_ZNPList_$ZPP_$ColArbiter();
	this.f_arbiters = new zpp_$nape_util_ZNPList_$ZPP_$FluidArbiter();
	this.s_arbiters = new zpp_$nape_util_ZNPList_$ZPP_$SensorArbiter();
	this.islands = new zpp_$nape_space_ZPP_$Island();
	this.live = new zpp_$nape_util_ZNPList_$ZPP_$Body();
	this.wrap_live = zpp_$nape_util_ZPP_$BodyList.get(this.live,true);
	this.staticsleep = new zpp_$nape_util_ZNPList_$ZPP_$Body();
	this.constraints = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this.wrap_constraints = zpp_$nape_util_ZPP_$ConstraintList.get(this.constraints);
	this.wrap_constraints.zpp_inner.adder = $bind(this,this.constraints_adder);
	this.wrap_constraints.zpp_inner.subber = $bind(this,this.constraints_subber);
	this.live_constraints = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this.wrap_livecon = zpp_$nape_util_ZPP_$ConstraintList.get(this.live_constraints,true);
	this.__static = zpp_$nape_phys_ZPP_$Body.__static();
	this.__static.zpp_inner.space = this;
	this.callbacks = new zpp_$nape_callbacks_ZPP_$Callback();
	this.midstep = false;
	this.listeners = new zpp_$nape_util_ZNPList_$ZPP_$Listener();
	this.wrap_listeners = zpp_$nape_util_ZPP_$ListenerList.get(this.listeners);
	this.wrap_listeners.zpp_inner.adder = $bind(this,this.listeners_adder);
	this.wrap_listeners.zpp_inner.subber = $bind(this,this.listeners_subber);
	this.callbackset_list = new zpp_$nape_space_ZPP_$CallbackSet();
	this.mrca1 = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
	this.mrca2 = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
	this.prelisteners = new zpp_$nape_util_ZNPList_$ZPP_$InteractionListener();
	this.cbsets = new zpp_$nape_space_ZPP_$CbSetManager(this);
};
zpp_$nape_space_ZPP_$Space.__name__ = true;
zpp_$nape_space_ZPP_$Space.prototype = {
	getgravity: function() {
		var x = this.gravityx;
		var y = this.gravityy;
		if(y == null) {
			y = 0;
		}
		if(x == null) {
			x = 0;
		}
		var ret;
		if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
			ret = new nape_geom_Vec2();
		} else {
			ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
			zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
			ret.zpp_pool = null;
		}
		if(ret.zpp_inner == null) {
			var ret1;
			if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
				ret1 = new zpp_$nape_geom_ZPP_$Vec2();
			} else {
				ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.weak = false;
			ret1._immutable = false;
			ret1.x = x;
			ret1.y = y;
			ret.zpp_inner = ret1;
			ret.zpp_inner.outer = ret;
		} else {
			var tmp;
			var _this = ret.zpp_inner;
			if(_this._validate != null) {
				_this._validate();
			}
			if(ret.zpp_inner.x == x) {
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				tmp = ret.zpp_inner.y == y;
			} else {
				tmp = false;
			}
			if(!tmp) {
				ret.zpp_inner.x = x;
				ret.zpp_inner.y = y;
				var _this = ret.zpp_inner;
				if(_this._invalidate != null) {
					_this._invalidate(_this);
				}
			}
		}
		ret.zpp_inner.weak = false;
		this.wrap_gravity = ret;
		this.wrap_gravity.zpp_inner._inuse = true;
		this.wrap_gravity.zpp_inner._invalidate = $bind(this,this.gravity_invalidate);
		this.wrap_gravity.zpp_inner._validate = $bind(this,this.gravity_validate);
	}
	,gravity_invalidate: function(x) {
		this.gravityx = x.x;
		this.gravityy = x.y;
		var stack = new zpp_$nape_util_ZNPList_$ZPP_$Compound();
		var cx_ite = this.bodies.head;
		while(cx_ite != null) {
			var x = cx_ite.elt;
			var o = x;
			if(!o.world) {
				o.component.waket = this.stamp + (this.midstep ? 0 : 1);
				if(o.type == 3) {
					o.kinematicDelaySleep = true;
				}
				if(o.component.sleeping) {
					this.really_wake(o,false);
				}
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.compounds.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			stack.add(i);
			cx_ite = cx_ite.next;
		}
		while(stack.head != null) {
			var s = stack.pop_unsafe();
			var cx_ite = s.bodies.head;
			while(cx_ite != null) {
				var x = cx_ite.elt;
				var o = x;
				if(!o.world) {
					o.component.waket = this.stamp + (this.midstep ? 0 : 1);
					if(o.type == 3) {
						o.kinematicDelaySleep = true;
					}
					if(o.component.sleeping) {
						this.really_wake(o,false);
					}
				}
				cx_ite = cx_ite.next;
			}
			var cx_ite1 = s.compounds.head;
			while(cx_ite1 != null) {
				var i = cx_ite1.elt;
				stack.add(i);
				cx_ite1 = cx_ite1.next;
			}
		}
	}
	,gravity_validate: function() {
		this.wrap_gravity.zpp_inner.x = this.gravityx;
		this.wrap_gravity.zpp_inner.y = this.gravityy;
	}
	,clear: function() {
		while(this.listeners.head != null) {
			var c = this.listeners.pop_unsafe();
			this.remListener(c);
		}
		while(this.callbackset_list.next != null) {
			var c = this.callbackset_list.pop_unsafe();
			c.arbiters.clear();
			var o = c;
			o.int1 = o.int2 = null;
			o.id = o.di = -1;
			o.freed = true;
			o.next = zpp_$nape_space_ZPP_$CallbackSet.zpp_pool;
			zpp_$nape_space_ZPP_$CallbackSet.zpp_pool = o;
		}
		while(this.c_arbiters_true.head != null) {
			var arb = this.c_arbiters_true.pop_unsafe();
			if(!arb.cleared) {
				var _this = arb.b1.arbiters;
				var pre = null;
				var cur = _this.head;
				var ret = false;
				while(cur != null) {
					if(cur.elt == arb) {
						var old;
						var ret1;
						if(pre == null) {
							old = _this.head;
							ret1 = old.next;
							_this.head = ret1;
							if(_this.head == null) {
								_this.pushmod = true;
							}
						} else {
							old = pre.next;
							ret1 = old.next;
							pre.next = ret1;
							if(ret1 == null) {
								_this.pushmod = true;
							}
						}
						var o = old;
						o.elt = null;
						o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
						_this.modified = true;
						_this.length--;
						_this.pushmod = true;
						ret = true;
						break;
					}
					pre = cur;
					cur = cur.next;
				}
				var _this1 = arb.b2.arbiters;
				var pre1 = null;
				var cur1 = _this1.head;
				var ret2 = false;
				while(cur1 != null) {
					if(cur1.elt == arb) {
						var old1;
						var ret3;
						if(pre1 == null) {
							old1 = _this1.head;
							ret3 = old1.next;
							_this1.head = ret3;
							if(_this1.head == null) {
								_this1.pushmod = true;
							}
						} else {
							old1 = pre1.next;
							ret3 = old1.next;
							pre1.next = ret3;
							if(ret3 == null) {
								_this1.pushmod = true;
							}
						}
						var o1 = old1;
						o1.elt = null;
						o1.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o1;
						_this1.modified = true;
						_this1.length--;
						_this1.pushmod = true;
						ret2 = true;
						break;
					}
					pre1 = cur1;
					cur1 = cur1.next;
				}
				if(arb.pair != null) {
					arb.pair.arb = null;
					arb.pair = null;
				}
			}
			arb.b1 = arb.b2 = null;
			arb.active = false;
			arb.intchange = false;
			while(arb.contacts.next != null) {
				var _this2 = arb.contacts;
				var ret4 = _this2.next;
				_this2.pop();
				var o2 = ret4;
				o2.sBias = -1.0;
				o2.arbiter = null;
				o2.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
				zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o2;
				var _this3 = arb.innards;
				var ret5 = _this3.next;
				_this3.next = ret5.next;
				ret5._inuse = false;
				if(_this3.next == null) {
					_this3.pushmod = true;
				}
				_this3.modified = true;
				_this3.length--;
			}
			var o3 = arb;
			o3.userdef_dyn_fric = false;
			o3.userdef_stat_fric = false;
			o3.userdef_restitution = false;
			o3.userdef_rfric = false;
			o3.__ref_edge1 = o3.__ref_edge2 = null;
			o3.next = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = o3;
			arb.pre_dt = -1.0;
		}
		while(this.c_arbiters_false.head != null) {
			var arb = this.c_arbiters_false.pop_unsafe();
			if(!arb.cleared) {
				var _this = arb.b1.arbiters;
				var pre = null;
				var cur = _this.head;
				var ret = false;
				while(cur != null) {
					if(cur.elt == arb) {
						var old;
						var ret1;
						if(pre == null) {
							old = _this.head;
							ret1 = old.next;
							_this.head = ret1;
							if(_this.head == null) {
								_this.pushmod = true;
							}
						} else {
							old = pre.next;
							ret1 = old.next;
							pre.next = ret1;
							if(ret1 == null) {
								_this.pushmod = true;
							}
						}
						var o = old;
						o.elt = null;
						o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
						_this.modified = true;
						_this.length--;
						_this.pushmod = true;
						ret = true;
						break;
					}
					pre = cur;
					cur = cur.next;
				}
				var _this1 = arb.b2.arbiters;
				var pre1 = null;
				var cur1 = _this1.head;
				var ret2 = false;
				while(cur1 != null) {
					if(cur1.elt == arb) {
						var old1;
						var ret3;
						if(pre1 == null) {
							old1 = _this1.head;
							ret3 = old1.next;
							_this1.head = ret3;
							if(_this1.head == null) {
								_this1.pushmod = true;
							}
						} else {
							old1 = pre1.next;
							ret3 = old1.next;
							pre1.next = ret3;
							if(ret3 == null) {
								_this1.pushmod = true;
							}
						}
						var o1 = old1;
						o1.elt = null;
						o1.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o1;
						_this1.modified = true;
						_this1.length--;
						_this1.pushmod = true;
						ret2 = true;
						break;
					}
					pre1 = cur1;
					cur1 = cur1.next;
				}
				if(arb.pair != null) {
					arb.pair.arb = null;
					arb.pair = null;
				}
			}
			arb.b1 = arb.b2 = null;
			arb.active = false;
			arb.intchange = false;
			while(arb.contacts.next != null) {
				var _this2 = arb.contacts;
				var ret4 = _this2.next;
				_this2.pop();
				var o2 = ret4;
				o2.sBias = -1.0;
				o2.arbiter = null;
				o2.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
				zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o2;
				var _this3 = arb.innards;
				var ret5 = _this3.next;
				_this3.next = ret5.next;
				ret5._inuse = false;
				if(_this3.next == null) {
					_this3.pushmod = true;
				}
				_this3.modified = true;
				_this3.length--;
			}
			var o3 = arb;
			o3.userdef_dyn_fric = false;
			o3.userdef_stat_fric = false;
			o3.userdef_restitution = false;
			o3.userdef_rfric = false;
			o3.__ref_edge1 = o3.__ref_edge2 = null;
			o3.next = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = o3;
			arb.pre_dt = -1.0;
		}
		while(this.s_arbiters.head != null) {
			var arb = this.s_arbiters.pop_unsafe();
			if(!arb.cleared) {
				var _this = arb.b1.arbiters;
				var pre = null;
				var cur = _this.head;
				var ret = false;
				while(cur != null) {
					if(cur.elt == arb) {
						var old;
						var ret1;
						if(pre == null) {
							old = _this.head;
							ret1 = old.next;
							_this.head = ret1;
							if(_this.head == null) {
								_this.pushmod = true;
							}
						} else {
							old = pre.next;
							ret1 = old.next;
							pre.next = ret1;
							if(ret1 == null) {
								_this.pushmod = true;
							}
						}
						var o = old;
						o.elt = null;
						o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
						_this.modified = true;
						_this.length--;
						_this.pushmod = true;
						ret = true;
						break;
					}
					pre = cur;
					cur = cur.next;
				}
				var _this1 = arb.b2.arbiters;
				var pre1 = null;
				var cur1 = _this1.head;
				var ret2 = false;
				while(cur1 != null) {
					if(cur1.elt == arb) {
						var old1;
						var ret3;
						if(pre1 == null) {
							old1 = _this1.head;
							ret3 = old1.next;
							_this1.head = ret3;
							if(_this1.head == null) {
								_this1.pushmod = true;
							}
						} else {
							old1 = pre1.next;
							ret3 = old1.next;
							pre1.next = ret3;
							if(ret3 == null) {
								_this1.pushmod = true;
							}
						}
						var o1 = old1;
						o1.elt = null;
						o1.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o1;
						_this1.modified = true;
						_this1.length--;
						_this1.pushmod = true;
						ret2 = true;
						break;
					}
					pre1 = cur1;
					cur1 = cur1.next;
				}
				if(arb.pair != null) {
					arb.pair.arb = null;
					arb.pair = null;
				}
			}
			arb.b1 = arb.b2 = null;
			arb.active = false;
			arb.intchange = false;
			var o2 = arb;
			o2.next = zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool = o2;
		}
		while(this.f_arbiters.head != null) {
			var arb = this.f_arbiters.pop_unsafe();
			if(!arb.cleared) {
				var _this = arb.b1.arbiters;
				var pre = null;
				var cur = _this.head;
				var ret = false;
				while(cur != null) {
					if(cur.elt == arb) {
						var old;
						var ret1;
						if(pre == null) {
							old = _this.head;
							ret1 = old.next;
							_this.head = ret1;
							if(_this.head == null) {
								_this.pushmod = true;
							}
						} else {
							old = pre.next;
							ret1 = old.next;
							pre.next = ret1;
							if(ret1 == null) {
								_this.pushmod = true;
							}
						}
						var o = old;
						o.elt = null;
						o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
						_this.modified = true;
						_this.length--;
						_this.pushmod = true;
						ret = true;
						break;
					}
					pre = cur;
					cur = cur.next;
				}
				var _this1 = arb.b2.arbiters;
				var pre1 = null;
				var cur1 = _this1.head;
				var ret2 = false;
				while(cur1 != null) {
					if(cur1.elt == arb) {
						var old1;
						var ret3;
						if(pre1 == null) {
							old1 = _this1.head;
							ret3 = old1.next;
							_this1.head = ret3;
							if(_this1.head == null) {
								_this1.pushmod = true;
							}
						} else {
							old1 = pre1.next;
							ret3 = old1.next;
							pre1.next = ret3;
							if(ret3 == null) {
								_this1.pushmod = true;
							}
						}
						var o1 = old1;
						o1.elt = null;
						o1.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o1;
						_this1.modified = true;
						_this1.length--;
						_this1.pushmod = true;
						ret2 = true;
						break;
					}
					pre1 = cur1;
					cur1 = cur1.next;
				}
				if(arb.pair != null) {
					arb.pair.arb = null;
					arb.pair = null;
				}
			}
			arb.b1 = arb.b2 = null;
			arb.active = false;
			arb.intchange = false;
			var o2 = arb;
			o2.next = zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool;
			zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool = o2;
			arb.pre_dt = -1.0;
		}
		this.bphase.clear();
		while(this.bodies.head != null) {
			var b = this.bodies.pop_unsafe();
			if(b.component != null) {
				var i = b.component.island;
				if(i != null) {
					while(i.comps.head != null) {
						var c = i.comps.pop_unsafe();
						c.sleeping = false;
						c.island = null;
						c.parent = c;
						c.rank = 0;
					}
					var o = i;
					o.next = zpp_$nape_space_ZPP_$Island.zpp_pool;
					zpp_$nape_space_ZPP_$Island.zpp_pool = o;
				}
			}
			b.removedFromSpace();
			b.space = null;
		}
		while(this.constraints.head != null) {
			var c = this.constraints.pop_unsafe();
			if(c.component != null) {
				var i = c.component.island;
				if(i != null) {
					while(i.comps.head != null) {
						var c1 = i.comps.pop_unsafe();
						c1.sleeping = false;
						c1.island = null;
						c1.parent = c1;
						c1.rank = 0;
					}
					var o = i;
					o.next = zpp_$nape_space_ZPP_$Island.zpp_pool;
					zpp_$nape_space_ZPP_$Island.zpp_pool = o;
				}
			}
			c.removedFromSpace();
			c.space = null;
		}
		this.kinematics.clear();
		var stack = new zpp_$nape_util_ZNPList_$ZPP_$Compound();
		while(this.compounds.head != null) {
			var c = this.compounds.pop_unsafe();
			stack.add(c);
		}
		while(stack.head != null) {
			var comp = stack.pop_unsafe();
			comp.removedFromSpace();
			comp.space = null;
			var cx_ite = comp.bodies.head;
			while(cx_ite != null) {
				var b = cx_ite.elt;
				if(b.component != null) {
					var i = b.component.island;
					if(i != null) {
						while(i.comps.head != null) {
							var c = i.comps.pop_unsafe();
							c.sleeping = false;
							c.island = null;
							c.parent = c;
							c.rank = 0;
						}
						var o = i;
						o.next = zpp_$nape_space_ZPP_$Island.zpp_pool;
						zpp_$nape_space_ZPP_$Island.zpp_pool = o;
					}
				}
				b.removedFromSpace();
				b.space = null;
				cx_ite = cx_ite.next;
			}
			var cx_ite1 = comp.constraints.head;
			while(cx_ite1 != null) {
				var c1 = cx_ite1.elt;
				if(c1.component != null) {
					var i1 = c1.component.island;
					if(i1 != null) {
						while(i1.comps.head != null) {
							var c2 = i1.comps.pop_unsafe();
							c2.sleeping = false;
							c2.island = null;
							c2.parent = c2;
							c2.rank = 0;
						}
						var o1 = i1;
						o1.next = zpp_$nape_space_ZPP_$Island.zpp_pool;
						zpp_$nape_space_ZPP_$Island.zpp_pool = o1;
					}
				}
				c1.removedFromSpace();
				c1.space = null;
				cx_ite1 = cx_ite1.next;
			}
			var cx_ite2 = comp.compounds.head;
			while(cx_ite2 != null) {
				var i2 = cx_ite2.elt;
				stack.add(i2);
				cx_ite2 = cx_ite2.next;
			}
		}
		this.staticsleep.clear();
		this.live.clear();
		this.live_constraints.clear();
		this.stamp = 0;
		this.time = 0.0;
		this.mrca1.clear();
		this.mrca2.clear();
		this.prelisteners.clear();
		this.cbsets.clear();
	}
	,bodies_adder: function(x) {
		if(x.zpp_inner.space != this) {
			if(x.zpp_inner.space != null) {
				x.zpp_inner.space.outer.zpp_inner.wrap_bodies.remove(x);
			}
			this.addBody(x.zpp_inner);
			return true;
		} else {
			return false;
		}
	}
	,bodies_subber: function(x) {
		this.remBody(x.zpp_inner);
	}
	,compounds_adder: function(x) {
		if(x.zpp_inner.space != this) {
			if(x.zpp_inner.space != null) {
				x.zpp_inner.space.wrap_compounds.remove(x);
			}
			this.addCompound(x.zpp_inner);
			return true;
		} else {
			return false;
		}
	}
	,compounds_subber: function(x) {
		this.remCompound(x.zpp_inner);
	}
	,constraints_adder: function(x) {
		if(x.zpp_inner.space != this) {
			if(x.zpp_inner.space != null) {
				x.zpp_inner.space.outer.zpp_inner.wrap_constraints.remove(x);
			}
			this.addConstraint(x.zpp_inner);
			return true;
		} else {
			return false;
		}
	}
	,constraints_subber: function(x) {
		this.remConstraint(x.zpp_inner);
	}
	,listeners_adder: function(x) {
		if(x.zpp_inner.space != this) {
			if(x.zpp_inner.space != null) {
				x.zpp_inner.space.outer.zpp_inner.wrap_listeners.remove(x);
			}
			this.addListener(x.zpp_inner);
			return true;
		} else {
			return false;
		}
	}
	,listeners_subber: function(x) {
		this.remListener(x.zpp_inner);
	}
	,addListener: function(x) {
		x.space = this;
		x.addedToSpace();
		var tmp = x.interaction != null;
	}
	,remListener: function(x) {
		var tmp = x.interaction != null;
		x.removedFromSpace();
		x.space = null;
	}
	,add_callbackset: function(cb) {
		var _this = cb.int1.cbsets;
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = cb;
		var temp = ret;
		temp.next = _this.head;
		_this.head = temp;
		_this.modified = true;
		_this.length++;
		var _this = cb.int2.cbsets;
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = cb;
		var temp = ret;
		temp.next = _this.head;
		_this.head = temp;
		_this.modified = true;
		_this.length++;
		var _this = this.callbackset_list;
		cb._inuse = true;
		var temp = cb;
		temp.next = _this.next;
		_this.next = temp;
		_this.modified = true;
		_this.length++;
	}
	,remove_callbackset: function(cb) {
		cb.lazydel = true;
		var _this = cb.int1.cbsets;
		var pre = null;
		var cur = _this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == cb) {
				var old;
				var ret1;
				if(pre == null) {
					old = _this.head;
					ret1 = old.next;
					_this.head = ret1;
					if(_this.head == null) {
						_this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						_this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool = o;
				_this.modified = true;
				_this.length--;
				_this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
		var _this = cb.int2.cbsets;
		var pre = null;
		var cur = _this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == cb) {
				var old;
				var ret1;
				if(pre == null) {
					old = _this.head;
					ret1 = old.next;
					_this.head = ret1;
					if(_this.head == null) {
						_this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						_this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.zpp_pool = o;
				_this.modified = true;
				_this.length--;
				_this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,transmitType: function(p,new_type) {
		var o = p;
		if(!o.world) {
			o.component.waket = this.stamp + (this.midstep ? 0 : 1);
			if(o.type == 3) {
				o.kinematicDelaySleep = true;
			}
			if(o.component.sleeping) {
				this.really_wake(o,false);
			}
		}
		if(p.type == 2) {
			this.live.remove(p);
		} else if(p.type == 3) {
			this.kinematics.remove(p);
			this.staticsleep.remove(p);
		} else if(p.type == 1) {
			this.staticsleep.remove(p);
		}
		p.type = new_type;
		if(p.type == 3) {
			this.kinematics.add(p);
		}
		if(p.type == 1) {
			this.static_validation(p);
		}
		p.component.sleeping = true;
		var o = p;
		if(!o.world) {
			o.component.waket = this.stamp + (this.midstep ? 0 : 1);
			if(o.type == 3) {
				o.kinematicDelaySleep = true;
			}
			if(o.component.sleeping) {
				this.really_wake(o,true);
			}
		}
	}
	,removed_shape: function(s,deleting) {
		if(deleting == null) {
			deleting = false;
		}
		var _gthis = this;
		var body = s.body;
		if(!deleting) {
			body.wake();
		}
		var pre = null;
		var cx_ite = body.arbiters.head;
		while(cx_ite != null) {
			var xarb = cx_ite.elt;
			var rem = xarb.ws1 == s || xarb.ws2 == s;
			if(rem) {
				if(xarb.present != 0) {
					this.MRCA_chains(xarb.ws1,xarb.ws2);
					var cx_ite1 = this.mrca1.head;
					while(cx_ite1 != null) {
						var i1 = cx_ite1.elt;
						var cx_ite2 = this.mrca2.head;
						while(cx_ite2 != null) {
							var i2 = cx_ite2.elt;
							var cb1 = i1.cbSet;
							var cb2 = i2.cbSet;
							cb1.validate();
							cb2.validate();
							var _this = cb1.manager;
							var ret = null;
							var pairs = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
							var cx_ite3 = pairs.head;
							while(cx_ite3 != null) {
								var p = cx_ite3.elt;
								if(p.a == cb1 && p.b == cb2 || p.a == cb2 && p.b == cb1) {
									ret = p;
									break;
								}
								cx_ite3 = cx_ite3.next;
							}
							if(ret == null) {
								var ret1;
								if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
									ret1 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
								} else {
									ret1 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
									zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.zip_listeners = true;
								if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
									ret1.a = cb1;
									ret1.b = cb2;
								} else {
									ret1.a = cb2;
									ret1.b = cb1;
								}
								ret = ret1;
								cb1.cbpairs.add(ret);
								if(cb2 != cb1) {
									cb2.cbpairs.add(ret);
								}
							}
							if(ret.zip_listeners) {
								ret.zip_listeners = false;
								ret.__validate();
							}
							if(ret.listeners.head == null) {
								cx_ite2 = cx_ite2.next;
								continue;
							}
							var callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
							callbackset.remove_arb(xarb);
							xarb.present--;
							var _this1 = cb1.manager;
							var ret2 = null;
							var pairs1 = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
							var cx_ite4 = pairs1.head;
							while(cx_ite4 != null) {
								var p1 = cx_ite4.elt;
								if(p1.a == cb1 && p1.b == cb2 || p1.a == cb2 && p1.b == cb1) {
									ret2 = p1;
									break;
								}
								cx_ite4 = cx_ite4.next;
							}
							if(ret2 == null) {
								var ret3;
								if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
									ret3 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
								} else {
									ret3 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
									zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret3.next;
									ret3.next = null;
								}
								ret3.zip_listeners = true;
								if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
									ret3.a = cb1;
									ret3.b = cb2;
								} else {
									ret3.a = cb2;
									ret3.b = cb1;
								}
								ret2 = ret3;
								cb1.cbpairs.add(ret2);
								if(cb2 != cb1) {
									cb2.cbpairs.add(ret2);
								}
							}
							if(ret2.zip_listeners) {
								ret2.zip_listeners = false;
								ret2.__validate();
							}
							var cx_ite5 = ret2.listeners.head;
							while(cx_ite5 != null) {
								var x = cx_ite5.elt;
								if(x.event == 1) {
									if((x.itype & xarb.type) != 0 && callbackset.empty_arb(x.itype)) {
										var cb = _gthis.push_callback(x);
										cb.event = 1;
										var o1 = callbackset.int1;
										var o2 = callbackset.int2;
										var tmp;
										var _this2 = x.options1;
										var xs = o1.cbTypes;
										if(_this2.nonemptyintersection(xs,_this2.includes) && !_this2.nonemptyintersection(xs,_this2.excludes)) {
											var _this3 = x.options2;
											var xs1 = o2.cbTypes;
											tmp = _this3.nonemptyintersection(xs1,_this3.includes) && !_this3.nonemptyintersection(xs1,_this3.excludes);
										} else {
											tmp = false;
										}
										if(tmp) {
											cb.int1 = o1;
											cb.int2 = o2;
										} else {
											cb.int1 = o2;
											cb.int2 = o1;
										}
										cb.set = callbackset;
									}
								}
								cx_ite5 = cx_ite5.next;
							}
							if(callbackset.arbiters.head == null) {
								this.remove_callbackset(callbackset);
							}
							cx_ite2 = cx_ite2.next;
						}
						cx_ite1 = cx_ite1.next;
					}
				}
				if(xarb.b1 != body && xarb.b1.type == 2) {
					var o = xarb.b1;
					if(!o.world) {
						o.component.waket = this.stamp + (this.midstep ? 0 : 1);
						if(o.type == 3) {
							o.kinematicDelaySleep = true;
						}
						if(o.component.sleeping) {
							this.really_wake(o,false);
						}
					}
				}
				if(xarb.b2 != body && xarb.b2.type == 2) {
					var o3 = xarb.b2;
					if(!o3.world) {
						o3.component.waket = this.stamp + (this.midstep ? 0 : 1);
						if(o3.type == 3) {
							o3.kinematicDelaySleep = true;
						}
						if(o3.component.sleeping) {
							this.really_wake(o3,false);
						}
					}
				}
				xarb.cleared = true;
				if(body == null || xarb.b2 == body) {
					var _this4 = xarb.b1.arbiters;
					var pre1 = null;
					var cur = _this4.head;
					var ret4 = false;
					while(cur != null) {
						if(cur.elt == xarb) {
							var old;
							var ret5;
							if(pre1 == null) {
								old = _this4.head;
								ret5 = old.next;
								_this4.head = ret5;
								if(_this4.head == null) {
									_this4.pushmod = true;
								}
							} else {
								old = pre1.next;
								ret5 = old.next;
								pre1.next = ret5;
								if(ret5 == null) {
									_this4.pushmod = true;
								}
							}
							var o4 = old;
							o4.elt = null;
							o4.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o4;
							_this4.modified = true;
							_this4.length--;
							_this4.pushmod = true;
							ret4 = true;
							break;
						}
						pre1 = cur;
						cur = cur.next;
					}
				}
				if(body == null || xarb.b1 == body) {
					var _this5 = xarb.b2.arbiters;
					var pre2 = null;
					var cur1 = _this5.head;
					var ret6 = false;
					while(cur1 != null) {
						if(cur1.elt == xarb) {
							var old1;
							var ret7;
							if(pre2 == null) {
								old1 = _this5.head;
								ret7 = old1.next;
								_this5.head = ret7;
								if(_this5.head == null) {
									_this5.pushmod = true;
								}
							} else {
								old1 = pre2.next;
								ret7 = old1.next;
								pre2.next = ret7;
								if(ret7 == null) {
									_this5.pushmod = true;
								}
							}
							var o5 = old1;
							o5.elt = null;
							o5.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o5;
							_this5.modified = true;
							_this5.length--;
							_this5.pushmod = true;
							ret6 = true;
							break;
						}
						pre2 = cur1;
						cur1 = cur1.next;
					}
				}
				if(xarb.pair != null) {
					xarb.pair.arb = null;
					xarb.pair = null;
				}
				xarb.active = false;
				this.f_arbiters.modified = true;
				cx_ite = body.arbiters.erase(pre);
				continue;
			}
			pre = cx_ite;
			cx_ite = cx_ite.next;
		}
		this.bphase.remove(s);
		s.removedFromSpace();
	}
	,addConstraint: function(con) {
		con.space = this;
		con.addedToSpace();
		if(con.active) {
			con.component.sleeping = true;
			this.wake_constraint(con,true);
		}
	}
	,remConstraint: function(con) {
		if(con.active) {
			this.wake_constraint(con,true);
			this.live_constraints.remove(con);
		}
		con.removedFromSpace();
		con.space = null;
	}
	,addCompound: function(x) {
		x.space = this;
		x.addedToSpace();
		var cx_ite = x.bodies.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.addBody(i);
			cx_ite = cx_ite.next;
		}
		var cx_ite = x.constraints.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.addConstraint(i);
			cx_ite = cx_ite.next;
		}
		var cx_ite = x.compounds.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.addCompound(i);
			cx_ite = cx_ite.next;
		}
	}
	,remCompound: function(x) {
		var cx_ite = x.bodies.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.remBody(i);
			cx_ite = cx_ite.next;
		}
		var cx_ite = x.constraints.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.remConstraint(i);
			cx_ite = cx_ite.next;
		}
		var cx_ite = x.compounds.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.remCompound(i);
			cx_ite = cx_ite.next;
		}
		x.removedFromSpace();
		x.space = null;
	}
	,addBody: function(body,flag) {
		if(flag == null) {
			flag = -1;
		}
		body.space = this;
		body.addedToSpace();
		body.component.sleeping = true;
		var o = body;
		if(!o.world) {
			o.component.waket = this.stamp + (this.midstep ? 0 : 1);
			if(o.type == 3) {
				o.kinematicDelaySleep = true;
			}
			if(o.component.sleeping) {
				this.really_wake(o,true);
			}
		}
		var cx_ite = body.shapes.head;
		while(cx_ite != null) {
			var shape = cx_ite.elt;
			var dontwake = true;
			if(dontwake == null) {
				dontwake = false;
			}
			if(!dontwake) {
				var o = shape.body;
				if(!o.world) {
					o.component.waket = this.stamp + (this.midstep ? 0 : 1);
					if(o.type == 3) {
						o.kinematicDelaySleep = true;
					}
					if(o.component.sleeping) {
						this.really_wake(o,false);
					}
				}
			}
			this.bphase.insert(shape);
			shape.addedToSpace();
			cx_ite = cx_ite.next;
		}
		if(body.type == 1) {
			this.static_validation(body);
		} else if(body.type != 2) {
			if(flag != 3) {
				this.kinematics.add(body);
			}
		}
	}
	,remBody: function(body,flag) {
		if(flag == null) {
			flag = -1;
		}
		if(body.type == 1) {
			var o = body;
			if(!o.world) {
				o.component.waket = this.stamp + (this.midstep ? 0 : 1);
				if(o.type == 3) {
					o.kinematicDelaySleep = true;
				}
				if(o.component.sleeping) {
					this.really_wake(o,true);
				}
			}
			this.staticsleep.remove(body);
		} else if(body.type == 2) {
			var o = body;
			if(!o.world) {
				o.component.waket = this.stamp + (this.midstep ? 0 : 1);
				if(o.type == 3) {
					o.kinematicDelaySleep = true;
				}
				if(o.component.sleeping) {
					this.really_wake(o,true);
				}
			}
			this.live.remove(body);
		} else {
			if(flag != 3) {
				this.kinematics.remove(body);
			}
			var o = body;
			if(!o.world) {
				o.component.waket = this.stamp + (this.midstep ? 0 : 1);
				if(o.type == 3) {
					o.kinematicDelaySleep = true;
				}
				if(o.component.sleeping) {
					this.really_wake(o,true);
				}
			}
			this.staticsleep.remove(body);
		}
		var cx_ite = body.shapes.head;
		while(cx_ite != null) {
			var shape = cx_ite.elt;
			this.removed_shape(shape,true);
			cx_ite = cx_ite.next;
		}
		body.removedFromSpace();
		body.space = null;
	}
	,shapesUnderPoint: function(x,y,filter,output) {
		return this.bphase.shapesUnderPoint(x,y,filter,output);
	}
	,bodiesUnderPoint: function(x,y,filter,output) {
		return this.bphase.bodiesUnderPoint(x,y,filter,output);
	}
	,shapesInAABB: function(aabb,strict,cont,filter,output) {
		return this.bphase.shapesInAABB(aabb.zpp_inner,strict,cont,filter,output);
	}
	,bodiesInAABB: function(aabb,strict,cont,filter,output) {
		return this.bphase.bodiesInAABB(aabb.zpp_inner,strict,cont,filter,output);
	}
	,shapesInCircle: function(pos,rad,cont,filter,output) {
		var tmp = this.bphase;
		var _this = pos.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = pos.zpp_inner.x;
		var _this = pos.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return tmp.shapesInCircle(tmp1,pos.zpp_inner.y,rad,cont,filter,output);
	}
	,bodiesInCircle: function(pos,rad,cont,filter,output) {
		var tmp = this.bphase;
		var _this = pos.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		var tmp1 = pos.zpp_inner.x;
		var _this = pos.zpp_inner;
		if(_this._validate != null) {
			_this._validate();
		}
		return tmp.bodiesInCircle(tmp1,pos.zpp_inner.y,rad,cont,filter,output);
	}
	,shapesInShape: function(shape,cont,filter,output) {
		return this.bphase.shapesInShape(shape,cont,filter,output);
	}
	,bodiesInShape: function(shape,cont,filter,output) {
		return this.bphase.bodiesInShape(shape,cont,filter,output);
	}
	,rayCast: function(ray,inner,filter) {
		return this.bphase.rayCast(ray.zpp_inner,inner,filter == null ? null : filter.zpp_inner);
	}
	,rayMultiCast: function(ray,inner,filter,output) {
		return this.bphase.rayMultiCast(ray.zpp_inner,inner,filter == null ? null : filter.zpp_inner,output);
	}
	,convexCast: function(shape,deltaTime,filter,dynamics) {
		var toi;
		if(zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool == null) {
			toi = new zpp_$nape_geom_ZPP_$ToiEvent();
		} else {
			toi = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
			zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = toi.next;
			toi.next = null;
		}
		toi.failed = false;
		toi.s1 = toi.s2 = null;
		toi.arbiter = null;
		if(shape.type == 0) {
			var _this = shape.circle;
			if(_this.zip_worldCOM) {
				if(_this.body != null) {
					_this.zip_worldCOM = false;
					if(_this.zip_localCOM) {
						_this.zip_localCOM = false;
						if(_this.type == 1) {
							var _this1 = _this.polygon;
							if(_this1.lverts.next.next == null) {
								_this1.localCOMx = _this1.lverts.next.x;
								_this1.localCOMy = _this1.lverts.next.y;
							} else if(_this1.lverts.next.next.next == null) {
								_this1.localCOMx = _this1.lverts.next.x;
								_this1.localCOMy = _this1.lverts.next.y;
								var t = 1.0;
								_this1.localCOMx += _this1.lverts.next.next.x * t;
								_this1.localCOMy += _this1.lverts.next.next.y * t;
								var t = 0.5;
								_this1.localCOMx *= t;
								_this1.localCOMy *= t;
							} else {
								_this1.localCOMx = 0;
								_this1.localCOMy = 0;
								var area = 0.0;
								var cx_ite = _this1.lverts.next;
								var u = cx_ite;
								cx_ite = cx_ite.next;
								var v = cx_ite;
								cx_ite = cx_ite.next;
								while(cx_ite != null) {
									var w = cx_ite;
									area += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									_this1.localCOMx += (v.x + w.x) * cf;
									_this1.localCOMy += (v.y + w.y) * cf;
									u = v;
									v = w;
									cx_ite = cx_ite.next;
								}
								cx_ite = _this1.lverts.next;
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this1.localCOMx += (v.x + w.x) * cf;
								_this1.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite = cx_ite.next;
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this1.localCOMx += (v.x + w.x) * cf;
								_this1.localCOMy += (v.y + w.y) * cf;
								area = 1 / (3 * area);
								var t = area;
								_this1.localCOMx *= t;
								_this1.localCOMy *= t;
							}
						}
						if(_this.wrap_localCOM != null) {
							_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
							_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
						}
					}
					var _this1 = _this.body;
					if(_this1.zip_axis) {
						_this1.zip_axis = false;
						_this1.axisx = Math.sin(_this1.rot);
						_this1.axisy = Math.cos(_this1.rot);
					}
					_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
					_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
				}
			}
		} else {
			var _this = shape.polygon;
			if(_this.zip_gaxi) {
				if(_this.body != null) {
					_this.zip_gaxi = false;
					_this.validate_laxi();
					var _this1 = _this.body;
					if(_this1.zip_axis) {
						_this1.zip_axis = false;
						_this1.axisx = Math.sin(_this1.rot);
						_this1.axisy = Math.cos(_this1.rot);
					}
					if(_this.zip_gverts) {
						if(_this.body != null) {
							_this.zip_gverts = false;
							_this.validate_lverts();
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							var li = _this.lverts.next;
							var cx_ite = _this.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
								g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var ite = _this.edges.head;
					var cx_ite = _this.gverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var v = cx_ite;
						var e = ite.elt;
						ite = ite.next;
						e.gp0 = u;
						e.gp1 = v;
						e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
						e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
						e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
						if(e.wrap_gnorm != null) {
							e.wrap_gnorm.zpp_inner.x = e.gnormx;
							e.wrap_gnorm.zpp_inner.y = e.gnormy;
						}
						e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
						e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
						u = v;
						cx_ite = cx_ite.next;
					}
					var v = _this.gverts.next;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
				}
			}
		}
		var body = shape.body;
		var prex = body.posx;
		var prey = body.posy;
		body.sweepTime = 0;
		body.sweep_angvel = body.angvel;
		var delta = deltaTime - body.sweepTime;
		if(delta != 0) {
			body.sweepTime = deltaTime;
			var t = delta;
			body.posx += body.velx * t;
			body.posy += body.vely * t;
			if(body.angvel != 0) {
				var dr = body.sweep_angvel * delta;
				body.rot += dr;
				if(dr * dr > 0.0001) {
					body.axisx = Math.sin(body.rot);
					body.axisy = Math.cos(body.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * body.axisx + dr * body.axisy) * m;
					body.axisy = (p * body.axisy - dr * body.axisx) * m;
					body.axisx = nx;
				}
			}
		}
		var postx = body.posx;
		var posty = body.posy;
		shape.validate_sweepRadius();
		var rad = shape.sweepRadius;
		var aabb;
		if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
			aabb = new zpp_$nape_geom_ZPP_$AABB();
		} else {
			aabb = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = aabb.next;
			aabb.next = null;
		}
		var x = prex;
		var y = postx;
		aabb.minx = (x < y ? x : y) - rad;
		var x = prex;
		var y = postx;
		aabb.maxx = (x > y ? x : y) + rad;
		var x = prey;
		var y = posty;
		aabb.miny = (x < y ? x : y) - rad;
		var x = prey;
		var y = posty;
		aabb.maxy = (x > y ? x : y) + rad;
		var list = this.convexShapeList = this.bphase.shapesInAABB(aabb,false,false,filter == null ? null : filter.zpp_inner,this.convexShapeList);
		var o = aabb;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o.wrap_min = o.wrap_max = null;
		o._invalidate = null;
		o._validate = null;
		o.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = o;
		var minAxisx = 0.0;
		var minAxisy = 0.0;
		minAxisx = 0;
		minAxisy = 0;
		var minPosx = 0.0;
		var minPosy = 0.0;
		minPosx = 0;
		minPosy = 0;
		var mins = null;
		var mint = deltaTime + 1;
		list.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(list);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var s = _g.zpp_inner.at(_g.zpp_i++);
			if(s != shape.outer && (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null) != body.outer) {
				toi.s1 = shape;
				toi.s2 = s.zpp_inner;
				if(dynamics) {
					s.zpp_inner.validate_sweepRadius();
					(s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner.sweep_angvel = (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner.angvel;
					(s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner.sweepTime = 0;
					zpp_$nape_geom_ZPP_$SweepDistance.dynamicSweep(toi,deltaTime,0,0,true);
					var _this1 = (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner;
					var delta = 0 - _this1.sweepTime;
					if(delta != 0) {
						_this1.sweepTime = 0;
						var t = delta;
						_this1.posx += _this1.velx * t;
						_this1.posy += _this1.vely * t;
						if(_this1.angvel != 0) {
							var dr = _this1.sweep_angvel * delta;
							_this1.rot += dr;
							if(dr * dr > 0.0001) {
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							} else {
								var d2 = dr * dr;
								var p = 1 - 0.5 * d2;
								var m = 1 - d2 * d2 / 8;
								var nx = (p * _this1.axisx + dr * _this1.axisy) * m;
								_this1.axisy = (p * _this1.axisy - dr * _this1.axisx) * m;
								_this1.axisx = nx;
							}
						}
					}
					var _this2 = (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner;
					var s1 = s.zpp_inner;
					if(s1.type == 0) {
						s1.worldCOMx = _this2.posx + (_this2.axisy * s1.localCOMx - _this2.axisx * s1.localCOMy);
						s1.worldCOMy = _this2.posy + (s1.localCOMx * _this2.axisx + s1.localCOMy * _this2.axisy);
					} else {
						var p1 = s1.polygon;
						var li = p1.lverts.next;
						var cx_ite = p1.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this2.posx + (_this2.axisy * l.x - _this2.axisx * l.y);
							g.y = _this2.posy + (l.x * _this2.axisx + l.y * _this2.axisy);
							cx_ite = cx_ite.next;
						}
						var ite = p1.edges.head;
						var cx_ite1 = p1.gverts.next;
						var u = cx_ite1;
						cx_ite1 = cx_ite1.next;
						while(cx_ite1 != null) {
							var v = cx_ite1;
							var e = ite.elt;
							ite = ite.next;
							e.gnormx = _this2.axisy * e.lnormx - _this2.axisx * e.lnormy;
							e.gnormy = e.lnormx * _this2.axisx + e.lnormy * _this2.axisy;
							e.gprojection = _this2.posx * e.gnormx + _this2.posy * e.gnormy + e.lprojection;
							e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
							e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
							u = v;
							cx_ite1 = cx_ite1.next;
						}
						var v1 = p1.gverts.next;
						var e1 = ite.elt;
						ite = ite.next;
						e1.gnormx = _this2.axisy * e1.lnormx - _this2.axisx * e1.lnormy;
						e1.gnormy = e1.lnormx * _this2.axisx + e1.lnormy * _this2.axisy;
						e1.gprojection = _this2.posx * e1.gnormx + _this2.posy * e1.gnormy + e1.lprojection;
						e1.tp0 = u.y * e1.gnormx - u.x * e1.gnormy;
						e1.tp1 = v1.y * e1.gnormx - v1.x * e1.gnormy;
					}
				} else {
					zpp_$nape_geom_ZPP_$SweepDistance.staticSweep(toi,deltaTime,0,0);
				}
				toi.toi *= deltaTime;
				if(toi.toi > 0 && toi.toi < mint) {
					mint = toi.toi;
					minAxisx = toi.axis.x;
					minAxisy = toi.axis.y;
					minPosx = toi.c2.x;
					minPosy = toi.c2.y;
					mins = s;
				}
			}
		}
		list.clear();
		var o = toi;
		o.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o;
		var delta = 0 - body.sweepTime;
		if(delta != 0) {
			body.sweepTime = 0;
			var t = delta;
			body.posx += body.velx * t;
			body.posy += body.vely * t;
			if(body.angvel != 0) {
				var dr = body.sweep_angvel * delta;
				body.rot += dr;
				if(dr * dr > 0.0001) {
					body.axisx = Math.sin(body.rot);
					body.axisy = Math.cos(body.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * body.axisx + dr * body.axisy) * m;
					body.axisy = (p * body.axisy - dr * body.axisx) * m;
					body.axisx = nx;
				}
			}
		}
		if(shape.type == 0) {
			shape.worldCOMx = body.posx + (body.axisy * shape.localCOMx - body.axisx * shape.localCOMy);
			shape.worldCOMy = body.posy + (shape.localCOMx * body.axisx + shape.localCOMy * body.axisy);
		} else {
			var p = shape.polygon;
			var li = p.lverts.next;
			var cx_ite = p.gverts.next;
			while(cx_ite != null) {
				var g = cx_ite;
				var l = li;
				li = li.next;
				g.x = body.posx + (body.axisy * l.x - body.axisx * l.y);
				g.y = body.posy + (l.x * body.axisx + l.y * body.axisy);
				cx_ite = cx_ite.next;
			}
			var ite = p.edges.head;
			var cx_ite = p.gverts.next;
			var u = cx_ite;
			cx_ite = cx_ite.next;
			while(cx_ite != null) {
				var v = cx_ite;
				var e = ite.elt;
				ite = ite.next;
				e.gnormx = body.axisy * e.lnormx - body.axisx * e.lnormy;
				e.gnormy = e.lnormx * body.axisx + e.lnormy * body.axisy;
				e.gprojection = body.posx * e.gnormx + body.posy * e.gnormy + e.lprojection;
				e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
				e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
				u = v;
				cx_ite = cx_ite.next;
			}
			var v = p.gverts.next;
			var e = ite.elt;
			ite = ite.next;
			e.gnormx = body.axisy * e.lnormx - body.axisx * e.lnormy;
			e.gnormy = e.lnormx * body.axisx + e.lnormy * body.axisy;
			e.gprojection = body.posx * e.gnormx + body.posy * e.gnormy + e.lprojection;
			e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
			e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
		}
		if(mint <= deltaTime) {
			var x = -minAxisx;
			var y = -minAxisy;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret = new nape_geom_Vec2();
			} else {
				ret = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret.zpp_pool;
				ret.zpp_pool = null;
			}
			if(ret.zpp_inner == null) {
				var ret1;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret1 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret1 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret1.next;
					ret1.next = null;
				}
				ret1.weak = false;
				ret1._immutable = false;
				ret1.x = x;
				ret1.y = y;
				ret.zpp_inner = ret1;
				ret.zpp_inner.outer = ret;
			} else {
				var tmp;
				var _this = ret.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret.zpp_inner.x == x) {
					var _this = ret.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret.zpp_inner.x = x;
					ret.zpp_inner.y = y;
					var _this = ret.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret.zpp_inner.weak = false;
			var x = minPosx;
			var y = minPosy;
			if(y == null) {
				y = 0;
			}
			if(x == null) {
				x = 0;
			}
			var ret1;
			if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
				ret1 = new nape_geom_Vec2();
			} else {
				ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
				zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
				ret1.zpp_pool = null;
			}
			if(ret1.zpp_inner == null) {
				var ret2;
				if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
					ret2 = new zpp_$nape_geom_ZPP_$Vec2();
				} else {
					ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
					zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
					ret2.next = null;
				}
				ret2.weak = false;
				ret2._immutable = false;
				ret2.x = x;
				ret2.y = y;
				ret1.zpp_inner = ret2;
				ret1.zpp_inner.outer = ret1;
			} else {
				var tmp;
				var _this = ret1.zpp_inner;
				if(_this._validate != null) {
					_this._validate();
				}
				if(ret1.zpp_inner.x == x) {
					var _this = ret1.zpp_inner;
					if(_this._validate != null) {
						_this._validate();
					}
					tmp = ret1.zpp_inner.y == y;
				} else {
					tmp = false;
				}
				if(!tmp) {
					ret1.zpp_inner.x = x;
					ret1.zpp_inner.y = y;
					var _this = ret1.zpp_inner;
					if(_this._invalidate != null) {
						_this._invalidate(_this);
					}
				}
			}
			ret1.zpp_inner.weak = false;
			return zpp_$nape_geom_ZPP_$ConvexRayResult.getConvex(ret,ret1,mint,mins);
		} else {
			return null;
		}
	}
	,convexMultiCast: function(shape,deltaTime,filter,dynamics,output) {
		var toi;
		if(zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool == null) {
			toi = new zpp_$nape_geom_ZPP_$ToiEvent();
		} else {
			toi = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
			zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = toi.next;
			toi.next = null;
		}
		toi.failed = false;
		toi.s1 = toi.s2 = null;
		toi.arbiter = null;
		if(shape.type == 0) {
			var _this = shape.circle;
			if(_this.zip_worldCOM) {
				if(_this.body != null) {
					_this.zip_worldCOM = false;
					if(_this.zip_localCOM) {
						_this.zip_localCOM = false;
						if(_this.type == 1) {
							var _this1 = _this.polygon;
							if(_this1.lverts.next.next == null) {
								_this1.localCOMx = _this1.lverts.next.x;
								_this1.localCOMy = _this1.lverts.next.y;
							} else if(_this1.lverts.next.next.next == null) {
								_this1.localCOMx = _this1.lverts.next.x;
								_this1.localCOMy = _this1.lverts.next.y;
								var t = 1.0;
								_this1.localCOMx += _this1.lverts.next.next.x * t;
								_this1.localCOMy += _this1.lverts.next.next.y * t;
								var t = 0.5;
								_this1.localCOMx *= t;
								_this1.localCOMy *= t;
							} else {
								_this1.localCOMx = 0;
								_this1.localCOMy = 0;
								var area = 0.0;
								var cx_ite = _this1.lverts.next;
								var u = cx_ite;
								cx_ite = cx_ite.next;
								var v = cx_ite;
								cx_ite = cx_ite.next;
								while(cx_ite != null) {
									var w = cx_ite;
									area += v.x * (w.y - u.y);
									var cf = w.y * v.x - w.x * v.y;
									_this1.localCOMx += (v.x + w.x) * cf;
									_this1.localCOMy += (v.y + w.y) * cf;
									u = v;
									v = w;
									cx_ite = cx_ite.next;
								}
								cx_ite = _this1.lverts.next;
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this1.localCOMx += (v.x + w.x) * cf;
								_this1.localCOMy += (v.y + w.y) * cf;
								u = v;
								v = w;
								cx_ite = cx_ite.next;
								var w = cx_ite;
								area += v.x * (w.y - u.y);
								var cf = w.y * v.x - w.x * v.y;
								_this1.localCOMx += (v.x + w.x) * cf;
								_this1.localCOMy += (v.y + w.y) * cf;
								area = 1 / (3 * area);
								var t = area;
								_this1.localCOMx *= t;
								_this1.localCOMy *= t;
							}
						}
						if(_this.wrap_localCOM != null) {
							_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
							_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
						}
					}
					var _this1 = _this.body;
					if(_this1.zip_axis) {
						_this1.zip_axis = false;
						_this1.axisx = Math.sin(_this1.rot);
						_this1.axisy = Math.cos(_this1.rot);
					}
					_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
					_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
				}
			}
		} else {
			var _this = shape.polygon;
			if(_this.zip_gaxi) {
				if(_this.body != null) {
					_this.zip_gaxi = false;
					_this.validate_laxi();
					var _this1 = _this.body;
					if(_this1.zip_axis) {
						_this1.zip_axis = false;
						_this1.axisx = Math.sin(_this1.rot);
						_this1.axisy = Math.cos(_this1.rot);
					}
					if(_this.zip_gverts) {
						if(_this.body != null) {
							_this.zip_gverts = false;
							_this.validate_lverts();
							var _this1 = _this.body;
							if(_this1.zip_axis) {
								_this1.zip_axis = false;
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							}
							var li = _this.lverts.next;
							var cx_ite = _this.gverts.next;
							while(cx_ite != null) {
								var g = cx_ite;
								var l = li;
								li = li.next;
								g.x = _this.body.posx + (_this.body.axisy * l.x - _this.body.axisx * l.y);
								g.y = _this.body.posy + (l.x * _this.body.axisx + l.y * _this.body.axisy);
								cx_ite = cx_ite.next;
							}
						}
					}
					var ite = _this.edges.head;
					var cx_ite = _this.gverts.next;
					var u = cx_ite;
					cx_ite = cx_ite.next;
					while(cx_ite != null) {
						var v = cx_ite;
						var e = ite.elt;
						ite = ite.next;
						e.gp0 = u;
						e.gp1 = v;
						e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
						e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
						e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
						if(e.wrap_gnorm != null) {
							e.wrap_gnorm.zpp_inner.x = e.gnormx;
							e.wrap_gnorm.zpp_inner.y = e.gnormy;
						}
						e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
						e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
						u = v;
						cx_ite = cx_ite.next;
					}
					var v = _this.gverts.next;
					var e = ite.elt;
					ite = ite.next;
					e.gp0 = u;
					e.gp1 = v;
					e.gnormx = _this.body.axisy * e.lnormx - _this.body.axisx * e.lnormy;
					e.gnormy = e.lnormx * _this.body.axisx + e.lnormy * _this.body.axisy;
					e.gprojection = _this.body.posx * e.gnormx + _this.body.posy * e.gnormy + e.lprojection;
					if(e.wrap_gnorm != null) {
						e.wrap_gnorm.zpp_inner.x = e.gnormx;
						e.wrap_gnorm.zpp_inner.y = e.gnormy;
					}
					e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
					e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
				}
			}
		}
		var body = shape.body;
		var prex = body.posx;
		var prey = body.posy;
		body.sweepTime = 0;
		body.sweep_angvel = body.angvel;
		var delta = deltaTime - body.sweepTime;
		if(delta != 0) {
			body.sweepTime = deltaTime;
			var t = delta;
			body.posx += body.velx * t;
			body.posy += body.vely * t;
			if(body.angvel != 0) {
				var dr = body.sweep_angvel * delta;
				body.rot += dr;
				if(dr * dr > 0.0001) {
					body.axisx = Math.sin(body.rot);
					body.axisy = Math.cos(body.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * body.axisx + dr * body.axisy) * m;
					body.axisy = (p * body.axisy - dr * body.axisx) * m;
					body.axisx = nx;
				}
			}
		}
		var postx = body.posx;
		var posty = body.posy;
		shape.validate_sweepRadius();
		var rad = shape.sweepRadius;
		var aabb;
		if(zpp_$nape_geom_ZPP_$AABB.zpp_pool == null) {
			aabb = new zpp_$nape_geom_ZPP_$AABB();
		} else {
			aabb = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
			zpp_$nape_geom_ZPP_$AABB.zpp_pool = aabb.next;
			aabb.next = null;
		}
		var x = prex;
		var y = postx;
		aabb.minx = (x < y ? x : y) - rad;
		var x = prex;
		var y = postx;
		aabb.maxx = (x > y ? x : y) + rad;
		var x = prey;
		var y = posty;
		aabb.miny = (x < y ? x : y) - rad;
		var x = prey;
		var y = posty;
		aabb.maxy = (x > y ? x : y) + rad;
		var list = this.convexShapeList = this.bphase.shapesInAABB(aabb,false,false,filter == null ? null : filter.zpp_inner,this.convexShapeList);
		var o = aabb;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o.wrap_min = o.wrap_max = null;
		o._invalidate = null;
		o._validate = null;
		o.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = o;
		var ret = output == null ? new nape_geom_ConvexResultList() : output;
		list.zpp_inner.valmod();
		var _g = nape_shape_ShapeIterator.get(list);
		while(true) {
			_g.zpp_inner.zpp_inner.valmod();
			var _this = _g.zpp_inner;
			_this.zpp_inner.valmod();
			if(_this.zpp_inner.zip_length) {
				_this.zpp_inner.zip_length = false;
				_this.zpp_inner.user_length = _this.zpp_inner.inner.length;
			}
			var length = _this.zpp_inner.user_length;
			_g.zpp_critical = true;
			var tmp;
			if(_g.zpp_i < length) {
				tmp = true;
			} else {
				_g.zpp_next = nape_shape_ShapeIterator.zpp_pool;
				nape_shape_ShapeIterator.zpp_pool = _g;
				_g.zpp_inner = null;
				tmp = false;
			}
			if(!tmp) {
				break;
			}
			_g.zpp_critical = false;
			var s = _g.zpp_inner.at(_g.zpp_i++);
			if(s != shape.outer && (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null) != body.outer) {
				toi.s1 = shape;
				toi.s2 = s.zpp_inner;
				if(dynamics) {
					s.zpp_inner.validate_sweepRadius();
					(s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner.sweep_angvel = (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner.angvel;
					(s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner.sweepTime = 0;
					zpp_$nape_geom_ZPP_$SweepDistance.dynamicSweep(toi,deltaTime,0,0,true);
					var _this1 = (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner;
					var delta = 0 - _this1.sweepTime;
					if(delta != 0) {
						_this1.sweepTime = 0;
						var t = delta;
						_this1.posx += _this1.velx * t;
						_this1.posy += _this1.vely * t;
						if(_this1.angvel != 0) {
							var dr = _this1.sweep_angvel * delta;
							_this1.rot += dr;
							if(dr * dr > 0.0001) {
								_this1.axisx = Math.sin(_this1.rot);
								_this1.axisy = Math.cos(_this1.rot);
							} else {
								var d2 = dr * dr;
								var p = 1 - 0.5 * d2;
								var m = 1 - d2 * d2 / 8;
								var nx = (p * _this1.axisx + dr * _this1.axisy) * m;
								_this1.axisy = (p * _this1.axisy - dr * _this1.axisx) * m;
								_this1.axisx = nx;
							}
						}
					}
					var _this2 = (s.zpp_inner.body != null ? s.zpp_inner.body.outer : null).zpp_inner;
					var s1 = s.zpp_inner;
					if(s1.type == 0) {
						s1.worldCOMx = _this2.posx + (_this2.axisy * s1.localCOMx - _this2.axisx * s1.localCOMy);
						s1.worldCOMy = _this2.posy + (s1.localCOMx * _this2.axisx + s1.localCOMy * _this2.axisy);
					} else {
						var p1 = s1.polygon;
						var li = p1.lverts.next;
						var cx_ite = p1.gverts.next;
						while(cx_ite != null) {
							var g = cx_ite;
							var l = li;
							li = li.next;
							g.x = _this2.posx + (_this2.axisy * l.x - _this2.axisx * l.y);
							g.y = _this2.posy + (l.x * _this2.axisx + l.y * _this2.axisy);
							cx_ite = cx_ite.next;
						}
						var ite = p1.edges.head;
						var cx_ite1 = p1.gverts.next;
						var u = cx_ite1;
						cx_ite1 = cx_ite1.next;
						while(cx_ite1 != null) {
							var v = cx_ite1;
							var e = ite.elt;
							ite = ite.next;
							e.gnormx = _this2.axisy * e.lnormx - _this2.axisx * e.lnormy;
							e.gnormy = e.lnormx * _this2.axisx + e.lnormy * _this2.axisy;
							e.gprojection = _this2.posx * e.gnormx + _this2.posy * e.gnormy + e.lprojection;
							e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
							e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
							u = v;
							cx_ite1 = cx_ite1.next;
						}
						var v1 = p1.gverts.next;
						var e1 = ite.elt;
						ite = ite.next;
						e1.gnormx = _this2.axisy * e1.lnormx - _this2.axisx * e1.lnormy;
						e1.gnormy = e1.lnormx * _this2.axisx + e1.lnormy * _this2.axisy;
						e1.gprojection = _this2.posx * e1.gnormx + _this2.posy * e1.gnormy + e1.lprojection;
						e1.tp0 = u.y * e1.gnormx - u.x * e1.gnormy;
						e1.tp1 = v1.y * e1.gnormx - v1.x * e1.gnormy;
					}
				} else {
					zpp_$nape_geom_ZPP_$SweepDistance.staticSweep(toi,deltaTime,0,0);
				}
				toi.toi *= deltaTime;
				if(toi.toi > 0) {
					var x = -toi.axis.x;
					var y = -toi.axis.y;
					if(y == null) {
						y = 0;
					}
					if(x == null) {
						x = 0;
					}
					var ret1;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret1 = new nape_geom_Vec2();
					} else {
						ret1 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret1.zpp_pool;
						ret1.zpp_pool = null;
					}
					if(ret1.zpp_inner == null) {
						var ret2;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret2 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret2 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret2.next;
							ret2.next = null;
						}
						ret2.weak = false;
						ret2._immutable = false;
						ret2.x = x;
						ret2.y = y;
						ret1.zpp_inner = ret2;
						ret1.zpp_inner.outer = ret1;
					} else {
						var res;
						var _this3 = ret1.zpp_inner;
						if(_this3._validate != null) {
							_this3._validate();
						}
						if(ret1.zpp_inner.x == x) {
							var _this4 = ret1.zpp_inner;
							if(_this4._validate != null) {
								_this4._validate();
							}
							res = ret1.zpp_inner.y == y;
						} else {
							res = false;
						}
						if(!res) {
							ret1.zpp_inner.x = x;
							ret1.zpp_inner.y = y;
							var _this5 = ret1.zpp_inner;
							if(_this5._invalidate != null) {
								_this5._invalidate(_this5);
							}
						}
					}
					ret1.zpp_inner.weak = false;
					var x1 = toi.c2.x;
					var y1 = toi.c2.y;
					if(y1 == null) {
						y1 = 0;
					}
					if(x1 == null) {
						x1 = 0;
					}
					var ret3;
					if(zpp_$nape_util_ZPP_$PubPool.poolVec2 == null) {
						ret3 = new nape_geom_Vec2();
					} else {
						ret3 = zpp_$nape_util_ZPP_$PubPool.poolVec2;
						zpp_$nape_util_ZPP_$PubPool.poolVec2 = ret3.zpp_pool;
						ret3.zpp_pool = null;
					}
					if(ret3.zpp_inner == null) {
						var ret4;
						if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
							ret4 = new zpp_$nape_geom_ZPP_$Vec2();
						} else {
							ret4 = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
							zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret4.next;
							ret4.next = null;
						}
						ret4.weak = false;
						ret4._immutable = false;
						ret4.x = x1;
						ret4.y = y1;
						ret3.zpp_inner = ret4;
						ret3.zpp_inner.outer = ret3;
					} else {
						var res1;
						var _this6 = ret3.zpp_inner;
						if(_this6._validate != null) {
							_this6._validate();
						}
						if(ret3.zpp_inner.x == x1) {
							var _this7 = ret3.zpp_inner;
							if(_this7._validate != null) {
								_this7._validate();
							}
							res1 = ret3.zpp_inner.y == y1;
						} else {
							res1 = false;
						}
						if(!res1) {
							ret3.zpp_inner.x = x1;
							ret3.zpp_inner.y = y1;
							var _this8 = ret3.zpp_inner;
							if(_this8._invalidate != null) {
								_this8._invalidate(_this8);
							}
						}
					}
					ret3.zpp_inner.weak = false;
					var res2 = zpp_$nape_geom_ZPP_$ConvexRayResult.getConvex(ret1,ret3,toi.toi,s);
					var pre = null;
					var cx_ite2 = ret.zpp_inner.inner.head;
					while(cx_ite2 != null) {
						var j = cx_ite2.elt;
						if(res2.zpp_inner.toiDistance < j.zpp_inner.toiDistance) {
							break;
						}
						pre = cx_ite2;
						cx_ite2 = cx_ite2.next;
					}
					var _this9 = ret.zpp_inner.inner;
					var ret5;
					if(zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool == null) {
						ret5 = new zpp_$nape_util_ZNPNode_$ConvexResult();
					} else {
						ret5 = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool;
						zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = ret5.next;
						ret5.next = null;
					}
					ret5.elt = res2;
					var temp = ret5;
					if(pre == null) {
						temp.next = _this9.head;
						_this9.head = temp;
					} else {
						temp.next = pre.next;
						pre.next = temp;
					}
					_this9.pushmod = _this9.modified = true;
					_this9.length++;
				}
			}
		}
		list.clear();
		var o = toi;
		o.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
		zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o;
		var delta = 0 - body.sweepTime;
		if(delta != 0) {
			body.sweepTime = 0;
			var t = delta;
			body.posx += body.velx * t;
			body.posy += body.vely * t;
			if(body.angvel != 0) {
				var dr = body.sweep_angvel * delta;
				body.rot += dr;
				if(dr * dr > 0.0001) {
					body.axisx = Math.sin(body.rot);
					body.axisy = Math.cos(body.rot);
				} else {
					var d2 = dr * dr;
					var p = 1 - 0.5 * d2;
					var m = 1 - d2 * d2 / 8;
					var nx = (p * body.axisx + dr * body.axisy) * m;
					body.axisy = (p * body.axisy - dr * body.axisx) * m;
					body.axisx = nx;
				}
			}
		}
		if(shape.type == 0) {
			shape.worldCOMx = body.posx + (body.axisy * shape.localCOMx - body.axisx * shape.localCOMy);
			shape.worldCOMy = body.posy + (shape.localCOMx * body.axisx + shape.localCOMy * body.axisy);
		} else {
			var p = shape.polygon;
			var li = p.lverts.next;
			var cx_ite = p.gverts.next;
			while(cx_ite != null) {
				var g = cx_ite;
				var l = li;
				li = li.next;
				g.x = body.posx + (body.axisy * l.x - body.axisx * l.y);
				g.y = body.posy + (l.x * body.axisx + l.y * body.axisy);
				cx_ite = cx_ite.next;
			}
			var ite = p.edges.head;
			var cx_ite = p.gverts.next;
			var u = cx_ite;
			cx_ite = cx_ite.next;
			while(cx_ite != null) {
				var v = cx_ite;
				var e = ite.elt;
				ite = ite.next;
				e.gnormx = body.axisy * e.lnormx - body.axisx * e.lnormy;
				e.gnormy = e.lnormx * body.axisx + e.lnormy * body.axisy;
				e.gprojection = body.posx * e.gnormx + body.posy * e.gnormy + e.lprojection;
				e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
				e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
				u = v;
				cx_ite = cx_ite.next;
			}
			var v = p.gverts.next;
			var e = ite.elt;
			ite = ite.next;
			e.gnormx = body.axisy * e.lnormx - body.axisx * e.lnormy;
			e.gnormy = e.lnormx * body.axisx + e.lnormy * body.axisy;
			e.gprojection = body.posx * e.gnormx + body.posy * e.gnormy + e.lprojection;
			e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
			e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
		}
		return ret;
	}
	,push_callback: function(i) {
		var cb;
		if(zpp_$nape_callbacks_ZPP_$Callback.zpp_pool == null) {
			cb = new zpp_$nape_callbacks_ZPP_$Callback();
		} else {
			cb = zpp_$nape_callbacks_ZPP_$Callback.zpp_pool;
			zpp_$nape_callbacks_ZPP_$Callback.zpp_pool = cb.next;
			cb.next = null;
		}
		this.callbacks.push(cb);
		cb.listener = i;
		return cb;
	}
	,step: function(deltaTime,velocityIterations,positionIterations) {
		var _gthis = this;
		this.time += deltaTime;
		this.pre_dt = deltaTime;
		this.midstep = true;
		this.stamp++;
		this.validation();
		this.bphase.broadphase(this,true);
		this.prestep(deltaTime);
		if(this.sortcontacts) {
			var xxlist = this.c_arbiters_false;
			if(xxlist.head != null && xxlist.head.next != null) {
				var head = xxlist.head;
				var tail = null;
				var left = null;
				var right = null;
				var nxt = null;
				var listSize = 1;
				var numMerges;
				var leftSize;
				var rightSize;
				do {
					numMerges = 0;
					left = head;
					head = null;
					tail = head;
					while(left != null) {
						++numMerges;
						right = left;
						leftSize = 0;
						rightSize = listSize;
						while(right != null && leftSize < listSize) {
							++leftSize;
							right = right.next;
						}
						while(leftSize > 0 || rightSize > 0 && right != null) {
							if(leftSize == 0) {
								nxt = right;
								right = right.next;
								--rightSize;
							} else if(rightSize == 0 || right == null) {
								nxt = left;
								left = left.next;
								--leftSize;
							} else if(left.elt.active && right.elt.active ? left.elt.oc1.dist < right.elt.oc1.dist : true) {
								nxt = left;
								left = left.next;
								--leftSize;
							} else {
								nxt = right;
								right = right.next;
								--rightSize;
							}
							if(tail != null) {
								tail.next = nxt;
							} else {
								head = nxt;
							}
							tail = nxt;
						}
						left = right;
					}
					tail.next = null;
					listSize <<= 1;
				} while(numMerges > 1);
				xxlist.head = head;
				xxlist.modified = true;
				xxlist.pushmod = true;
			}
		}
		var preIterations = velocityIterations >> 1;
		zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale = 1.0;
		this.iterateVel(preIterations);
		zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale = 0.0;
		this.updateVel(deltaTime);
		this.warmStart();
		this.iterateVel(velocityIterations - preIterations);
		zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale = 1.0;
		var cx_ite = this.kinematics.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			cur.pre_posx = cur.posx;
			cur.pre_posy = cur.posy;
			cur.pre_rot = cur.rot;
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.live.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			cur.pre_posx = cur.posx;
			cur.pre_posy = cur.posy;
			cur.pre_rot = cur.rot;
			cx_ite = cx_ite.next;
		}
		this.updatePos(deltaTime);
		this.continuous = true;
		this.continuousCollisions(deltaTime);
		this.continuous = false;
		this.iteratePos(positionIterations);
		var cx_ite = this.kinematics.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			var upos = !(cur.posx == cur.pre_posx && cur.posy == cur.pre_posy);
			var urot = cur.pre_rot != cur.rot;
			if(upos) {
				var cx_ite1 = cur.shapes.head;
				while(cx_ite1 != null) {
					var s = cx_ite1.elt;
					if(s.type == 1) {
						s.polygon.invalidate_gverts();
						s.polygon.invalidate_gaxi();
					}
					s.invalidate_worldCOM();
					cx_ite1 = cx_ite1.next;
				}
				cur.zip_worldCOM = true;
			}
			if(urot) {
				cur.zip_axis = true;
				var cx_ite2 = cur.shapes.head;
				while(cx_ite2 != null) {
					var s1 = cx_ite2.elt;
					if(s1.type == 1) {
						s1.polygon.invalidate_gverts();
						s1.polygon.invalidate_gaxi();
					}
					s1.invalidate_worldCOM();
					cx_ite2 = cx_ite2.next;
				}
				cur.zip_worldCOM = true;
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.live.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			var upos = !(cur.posx == cur.pre_posx && cur.posy == cur.pre_posy);
			var urot = cur.pre_rot != cur.rot;
			if(upos) {
				var cx_ite1 = cur.shapes.head;
				while(cx_ite1 != null) {
					var s = cx_ite1.elt;
					if(s.type == 1) {
						s.polygon.invalidate_gverts();
						s.polygon.invalidate_gaxi();
					}
					s.invalidate_worldCOM();
					cx_ite1 = cx_ite1.next;
				}
				cur.zip_worldCOM = true;
			}
			if(urot) {
				cur.zip_axis = true;
				var cx_ite2 = cur.shapes.head;
				while(cx_ite2 != null) {
					var s1 = cx_ite2.elt;
					if(s1.type == 1) {
						s1.polygon.invalidate_gverts();
						s1.polygon.invalidate_gaxi();
					}
					s1.invalidate_worldCOM();
					cx_ite2 = cx_ite2.next;
				}
				cur.zip_worldCOM = true;
			}
			cx_ite = cx_ite.next;
		}
		var pre = null;
		var cx_ite = this.staticsleep.head;
		while(cx_ite != null) {
			var b = cx_ite.elt;
			if(b.type != 3 || b.velx == 0 && b.vely == 0 && b.angvel == 0) {
				if(b.kinematicDelaySleep) {
					b.kinematicDelaySleep = false;
					cx_ite = cx_ite.next;
					continue;
				}
				b.component.sleeping = true;
				var _this = this.staticsleep;
				var old;
				var ret;
				if(pre == null) {
					old = _this.head;
					ret = old.next;
					_this.head = ret;
					if(_this.head == null) {
						_this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						_this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = o;
				_this.modified = true;
				_this.length--;
				_this.pushmod = true;
				cx_ite = ret;
				continue;
			}
			pre = cx_ite;
			cx_ite = cx_ite.next;
		}
		this.doForests(deltaTime);
		this.sleepArbiters();
		this.midstep = false;
		var pre = null;
		var cx_ite = this.callbackset_list.next;
		while(cx_ite != null) {
			var set = cx_ite;
			if(set.arbiters.head == null) {
				var _this = this.callbackset_list;
				var old;
				var ret;
				if(pre == null) {
					old = _this.next;
					ret = old.next;
					_this.next = ret;
					if(_this.next == null) {
						_this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						_this.pushmod = true;
					}
				}
				old._inuse = false;
				_this.modified = true;
				_this.length--;
				_this.pushmod = true;
				cx_ite = ret;
				var o = set;
				o.int1 = o.int2 = null;
				o.id = o.di = -1;
				o.freed = true;
				o.next = zpp_$nape_space_ZPP_$CallbackSet.zpp_pool;
				zpp_$nape_space_ZPP_$CallbackSet.zpp_pool = o;
				continue;
			}
			var ret1;
			ret1 = true;
			var cx_ite1 = set.arbiters.head;
			while(cx_ite1 != null) {
				var x = cx_ite1.elt;
				if(x.sleeping) {
					cx_ite1 = cx_ite1.next;
					continue;
				} else {
					ret1 = false;
					break;
				}
			}
			var sleeping = ret1;
			var a = set.int1.cbSet;
			var b = set.int2.cbSet;
			var _this1 = a.manager;
			var ret2 = null;
			var pairs = a.cbpairs.length < b.cbpairs.length ? a.cbpairs : b.cbpairs;
			var cx_ite2 = pairs.head;
			while(cx_ite2 != null) {
				var p = cx_ite2.elt;
				if(p.a == a && p.b == b || p.a == b && p.b == a) {
					ret2 = p;
					break;
				}
				cx_ite2 = cx_ite2.next;
			}
			if(ret2 == null) {
				var ret3;
				if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
					ret3 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
				} else {
					ret3 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
					zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret3.next;
					ret3.next = null;
				}
				ret3.zip_listeners = true;
				if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(a,b)) {
					ret3.a = a;
					ret3.b = b;
				} else {
					ret3.a = b;
					ret3.b = a;
				}
				ret2 = ret3;
				a.cbpairs.add(ret2);
				if(b != a) {
					b.cbpairs.add(ret2);
				}
			}
			if(ret2.zip_listeners) {
				ret2.zip_listeners = false;
				ret2.__validate();
			}
			var cx_ite3 = ret2.listeners.head;
			while(cx_ite3 != null) {
				var x1 = cx_ite3.elt;
				if(x1.event == 6) {
					if((!sleeping || x1.allowSleepingCallbacks) && !set.empty_arb(x1.itype)) {
						var cb = _gthis.push_callback(x1);
						cb.event = 6;
						var o1 = set.int1;
						var o2 = set.int2;
						var tmp;
						var _this2 = x1.options1;
						var xs = o1.cbTypes;
						if(_this2.nonemptyintersection(xs,_this2.includes) && !_this2.nonemptyintersection(xs,_this2.excludes)) {
							var _this3 = x1.options2;
							var xs1 = o2.cbTypes;
							tmp = _this3.nonemptyintersection(xs1,_this3.includes) && !_this3.nonemptyintersection(xs1,_this3.excludes);
						} else {
							tmp = false;
						}
						if(tmp) {
							cb.int1 = o1;
							cb.int2 = o2;
						} else {
							cb.int1 = o2;
							cb.int2 = o1;
						}
						cb.set = set;
					}
				}
				cx_ite3 = cx_ite3.next;
			}
			pre = cx_ite;
			cx_ite = cx_ite.next;
		}
		while(!this.callbacks.empty()) {
			var cb = this.callbacks.pop();
			if(cb.listener.type == 0) {
				var o = cb.listener.body;
				o.handler(cb.wrapper_body());
			} else if(cb.listener.type == 1) {
				var o1 = cb.listener.constraint;
				o1.handler(cb.wrapper_con());
			} else if(cb.listener.type == 2) {
				var o2 = cb.listener.interaction;
				o2.handleri(cb.wrapper_int());
			}
			var o3 = cb;
			o3.int1 = o3.int2 = null;
			o3.body = null;
			o3.constraint = null;
			o3.listener = null;
			if(o3.wrap_arbiters != null) {
				o3.wrap_arbiters.zpp_inner.inner = null;
			}
			o3.set = null;
			o3.next = zpp_$nape_callbacks_ZPP_$Callback.zpp_pool;
			zpp_$nape_callbacks_ZPP_$Callback.zpp_pool = o3;
		}
	}
	,continuousCollisions: function(deltaTime) {
		var MAX_VEL = 2 * Math.PI / deltaTime;
		this.bphase.broadphase(this,false);
		var curTimeAlpha = 0.0;
		while(curTimeAlpha < 1 && this.toiEvents.head != null) {
			var minTOI = null;
			var minTime = 2.0;
			var minKinematic = false;
			var preMin = null;
			var pre = null;
			var cx_ite = this.toiEvents.head;
			while(cx_ite != null) {
				var toi = cx_ite.elt;
				var b1 = toi.s1.body;
				var b2 = toi.s2.body;
				if(b1.sweepFrozen && b2.sweepFrozen) {
					if(toi.toi != 0 && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(toi.s1,toi.s2)) {
						toi.toi = 0;
					} else {
						cx_ite = this.toiEvents.erase(pre);
						var o = toi;
						o.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
						zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o;
						continue;
					}
				}
				if(toi.frozen1 != b1.sweepFrozen || toi.frozen2 != b2.sweepFrozen) {
					if(!toi.kinematic) {
						toi.frozen1 = b1.sweepFrozen;
						toi.frozen2 = b2.sweepFrozen;
						if(toi.frozen1) {
							var tmp = toi.s1;
							toi.s1 = toi.s2;
							toi.s2 = tmp;
							toi.frozen1 = false;
							toi.frozen2 = true;
						}
						zpp_$nape_geom_ZPP_$SweepDistance.staticSweep(toi,deltaTime,0,nape_Config.collisionSlopCCD);
						if(toi.toi < 0) {
							cx_ite = this.toiEvents.erase(pre);
							var o1 = toi;
							o1.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
							zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o1;
							continue;
						}
					} else {
						cx_ite = this.toiEvents.erase(pre);
						var o2 = toi;
						o2.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
						zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o2;
						continue;
					}
				}
				if(toi.toi >= 0 && (toi.toi < minTime || !minKinematic && toi.kinematic)) {
					minTOI = toi;
					minTime = toi.toi;
					minKinematic = toi.kinematic;
					preMin = pre;
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			if(minTOI == null) {
				break;
			}
			this.toiEvents.erase(preMin);
			curTimeAlpha = minTOI.toi;
			var b11 = minTOI.s1.body;
			var b21 = minTOI.s2.body;
			if(!b11.sweepFrozen) {
				var dt = curTimeAlpha * deltaTime;
				var delta = dt - b11.sweepTime;
				if(delta != 0) {
					b11.sweepTime = dt;
					var t = delta;
					b11.posx += b11.velx * t;
					b11.posy += b11.vely * t;
					if(b11.angvel != 0) {
						var dr = b11.sweep_angvel * delta;
						b11.rot += dr;
						if(dr * dr > 0.0001) {
							b11.axisx = Math.sin(b11.rot);
							b11.axisy = Math.cos(b11.rot);
						} else {
							var d2 = dr * dr;
							var p = 1 - 0.5 * d2;
							var m = 1 - d2 * d2 / 8;
							var nx = (p * b11.axisx + dr * b11.axisy) * m;
							b11.axisy = (p * b11.axisy - dr * b11.axisx) * m;
							b11.axisx = nx;
						}
					}
				}
				var s = minTOI.s1;
				if(s.type == 0) {
					s.worldCOMx = b11.posx + (b11.axisy * s.localCOMx - b11.axisx * s.localCOMy);
					s.worldCOMy = b11.posy + (s.localCOMx * b11.axisx + s.localCOMy * b11.axisy);
				} else {
					var p1 = s.polygon;
					var li = p1.lverts.next;
					var cx_ite1 = p1.gverts.next;
					while(cx_ite1 != null) {
						var g = cx_ite1;
						var l = li;
						li = li.next;
						g.x = b11.posx + (b11.axisy * l.x - b11.axisx * l.y);
						g.y = b11.posy + (l.x * b11.axisx + l.y * b11.axisy);
						cx_ite1 = cx_ite1.next;
					}
					var ite = p1.edges.head;
					var cx_ite2 = p1.gverts.next;
					var u = cx_ite2;
					cx_ite2 = cx_ite2.next;
					while(cx_ite2 != null) {
						var v = cx_ite2;
						var e = ite.elt;
						ite = ite.next;
						e.gnormx = b11.axisy * e.lnormx - b11.axisx * e.lnormy;
						e.gnormy = e.lnormx * b11.axisx + e.lnormy * b11.axisy;
						e.gprojection = b11.posx * e.gnormx + b11.posy * e.gnormy + e.lprojection;
						e.tp0 = u.y * e.gnormx - u.x * e.gnormy;
						e.tp1 = v.y * e.gnormx - v.x * e.gnormy;
						u = v;
						cx_ite2 = cx_ite2.next;
					}
					var v1 = p1.gverts.next;
					var e1 = ite.elt;
					ite = ite.next;
					e1.gnormx = b11.axisy * e1.lnormx - b11.axisx * e1.lnormy;
					e1.gnormy = e1.lnormx * b11.axisx + e1.lnormy * b11.axisy;
					e1.gprojection = b11.posx * e1.gnormx + b11.posy * e1.gnormy + e1.lprojection;
					e1.tp0 = u.y * e1.gnormx - u.x * e1.gnormy;
					e1.tp1 = v1.y * e1.gnormx - v1.x * e1.gnormy;
				}
			}
			if(!b21.sweepFrozen) {
				var dt1 = curTimeAlpha * deltaTime;
				var delta1 = dt1 - b21.sweepTime;
				if(delta1 != 0) {
					b21.sweepTime = dt1;
					var t1 = delta1;
					b21.posx += b21.velx * t1;
					b21.posy += b21.vely * t1;
					if(b21.angvel != 0) {
						var dr1 = b21.sweep_angvel * delta1;
						b21.rot += dr1;
						if(dr1 * dr1 > 0.0001) {
							b21.axisx = Math.sin(b21.rot);
							b21.axisy = Math.cos(b21.rot);
						} else {
							var d21 = dr1 * dr1;
							var p2 = 1 - 0.5 * d21;
							var m1 = 1 - d21 * d21 / 8;
							var nx1 = (p2 * b21.axisx + dr1 * b21.axisy) * m1;
							b21.axisy = (p2 * b21.axisy - dr1 * b21.axisx) * m1;
							b21.axisx = nx1;
						}
					}
				}
				var s1 = minTOI.s2;
				if(s1.type == 0) {
					s1.worldCOMx = b21.posx + (b21.axisy * s1.localCOMx - b21.axisx * s1.localCOMy);
					s1.worldCOMy = b21.posy + (s1.localCOMx * b21.axisx + s1.localCOMy * b21.axisy);
				} else {
					var p3 = s1.polygon;
					var li1 = p3.lverts.next;
					var cx_ite3 = p3.gverts.next;
					while(cx_ite3 != null) {
						var g1 = cx_ite3;
						var l1 = li1;
						li1 = li1.next;
						g1.x = b21.posx + (b21.axisy * l1.x - b21.axisx * l1.y);
						g1.y = b21.posy + (l1.x * b21.axisx + l1.y * b21.axisy);
						cx_ite3 = cx_ite3.next;
					}
					var ite1 = p3.edges.head;
					var cx_ite4 = p3.gverts.next;
					var u1 = cx_ite4;
					cx_ite4 = cx_ite4.next;
					while(cx_ite4 != null) {
						var v2 = cx_ite4;
						var e2 = ite1.elt;
						ite1 = ite1.next;
						e2.gnormx = b21.axisy * e2.lnormx - b21.axisx * e2.lnormy;
						e2.gnormy = e2.lnormx * b21.axisx + e2.lnormy * b21.axisy;
						e2.gprojection = b21.posx * e2.gnormx + b21.posy * e2.gnormy + e2.lprojection;
						e2.tp0 = u1.y * e2.gnormx - u1.x * e2.gnormy;
						e2.tp1 = v2.y * e2.gnormx - v2.x * e2.gnormy;
						u1 = v2;
						cx_ite4 = cx_ite4.next;
					}
					var v3 = p3.gverts.next;
					var e3 = ite1.elt;
					ite1 = ite1.next;
					e3.gnormx = b21.axisy * e3.lnormx - b21.axisx * e3.lnormy;
					e3.gnormy = e3.lnormx * b21.axisx + e3.lnormy * b21.axisy;
					e3.gprojection = b21.posx * e3.gnormx + b21.posy * e3.gnormy + e3.lprojection;
					e3.tp0 = u1.y * e3.gnormx - u1.x * e3.gnormy;
					e3.tp1 = v3.y * e3.gnormx - v3.x * e3.gnormy;
				}
			}
			var wasnull = minTOI.arbiter == null;
			var arb = this.narrowPhase(minTOI.s1,minTOI.s2,true,minTOI.arbiter,true);
			if(arb == null) {
				if(minTOI.arbiter != null && minTOI.arbiter.pair != null) {
					minTOI.arbiter.pair.arb = null;
					minTOI.arbiter.pair = null;
				}
			} else if(!this.presteparb(arb,deltaTime,true)) {
				if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL && (arb.active && (arb.immState & 1) != 0)) {
					var _this = arb.colarb;
					var jx = _this.nx * _this.c1.jnAcc - _this.ny * _this.c1.jtAcc;
					var jy = _this.ny * _this.c1.jnAcc + _this.nx * _this.c1.jtAcc;
					var t2 = _this.b1.imass;
					_this.b1.velx -= jx * t2;
					_this.b1.vely -= jy * t2;
					_this.b1.angvel -= _this.b1.iinertia * (jy * _this.c1.r1x - jx * _this.c1.r1y);
					var t3 = _this.b2.imass;
					_this.b2.velx += jx * t3;
					_this.b2.vely += jy * t3;
					_this.b2.angvel += _this.b2.iinertia * (jy * _this.c1.r2x - jx * _this.c1.r2y);
					if(_this.hc2) {
						var jx1 = _this.nx * _this.c2.jnAcc - _this.ny * _this.c2.jtAcc;
						var jy1 = _this.ny * _this.c2.jnAcc + _this.nx * _this.c2.jtAcc;
						var t4 = _this.b1.imass;
						_this.b1.velx -= jx1 * t4;
						_this.b1.vely -= jy1 * t4;
						_this.b1.angvel -= _this.b1.iinertia * (jy1 * _this.c2.r1x - jx1 * _this.c2.r1y);
						var t5 = _this.b2.imass;
						_this.b2.velx += jx1 * t5;
						_this.b2.vely += jy1 * t5;
						_this.b2.angvel += _this.b2.iinertia * (jy1 * _this.c2.r2x - jx1 * _this.c2.r2y);
					}
					_this.b2.angvel += _this.jrAcc * _this.b2.iinertia;
					_this.b1.angvel -= _this.jrAcc * _this.b1.iinertia;
					var _this1 = arb.colarb;
					var jx2;
					var jy2;
					var j;
					var jMax;
					var jOld;
					var cjAcc;
					var v1x = _this1.k1x + _this1.b2.velx - _this1.c1.r2y * _this1.b2.angvel - (_this1.b1.velx - _this1.c1.r1y * _this1.b1.angvel);
					var v1y = _this1.k1y + _this1.b2.vely + _this1.c1.r2x * _this1.b2.angvel - (_this1.b1.vely + _this1.c1.r1x * _this1.b1.angvel);
					if(_this1.hc2) {
						var v2x = _this1.k2x + _this1.b2.velx - _this1.c2.r2y * _this1.b2.angvel - (_this1.b1.velx - _this1.c2.r1y * _this1.b1.angvel);
						var v2y = _this1.k2y + _this1.b2.vely + _this1.c2.r2x * _this1.b2.angvel - (_this1.b1.vely + _this1.c2.r1x * _this1.b1.angvel);
						var ax = _this1.c1.jnAcc;
						var ay = _this1.c2.jnAcc;
						var jnx = v1x * _this1.nx + v1y * _this1.ny + _this1.surfacey + _this1.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this1.Ka * ax + _this1.Kb * ay);
						var jny = v2x * _this1.nx + v2y * _this1.ny + _this1.surfacey + _this1.c2.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this1.Kb * ax + _this1.Kc * ay);
						var xx = -(_this1.kMassa * jnx + _this1.kMassb * jny);
						var xy = -(_this1.kMassb * jnx + _this1.kMassc * jny);
						if(xx >= 0 && xy >= 0) {
							jnx = xx - ax;
							jny = xy - ay;
							_this1.c1.jnAcc = xx;
							_this1.c2.jnAcc = xy;
						} else {
							xx = -_this1.c1.nMass * jnx;
							if(xx >= 0 && _this1.Kb * xx + jny >= 0) {
								jnx = xx - ax;
								jny = -ay;
								_this1.c1.jnAcc = xx;
								_this1.c2.jnAcc = 0;
							} else {
								xy = -_this1.c2.nMass * jny;
								if(xy >= 0 && _this1.Kb * xy + jnx >= 0) {
									jnx = -ax;
									jny = xy - ay;
									_this1.c1.jnAcc = 0;
									_this1.c2.jnAcc = xy;
								} else if(jnx >= 0 && jny >= 0) {
									jnx = -ax;
									jny = -ay;
									_this1.c1.jnAcc = _this1.c2.jnAcc = 0;
								} else {
									jnx = 0;
									jny = 0;
								}
							}
						}
						j = jnx + jny;
						jx2 = _this1.nx * j;
						jy2 = _this1.ny * j;
						_this1.b2.velx += jx2 * _this1.b2.imass;
						_this1.b2.vely += jy2 * _this1.b2.imass;
						_this1.b1.velx -= jx2 * _this1.b1.imass;
						_this1.b1.vely -= jy2 * _this1.b1.imass;
						_this1.b2.angvel += (_this1.rn1b * jnx + _this1.rn2b * jny) * _this1.b2.iinertia;
						_this1.b1.angvel -= (_this1.rn1a * jnx + _this1.rn2a * jny) * _this1.b1.iinertia;
						v1x = _this1.k1x + _this1.b2.velx - _this1.c1.r2y * _this1.b2.angvel - (_this1.b1.velx - _this1.c1.r1y * _this1.b1.angvel);
						v1y = _this1.k1y + _this1.b2.vely + _this1.c1.r2x * _this1.b2.angvel - (_this1.b1.vely + _this1.c1.r1x * _this1.b1.angvel);
						j = (v1y * _this1.nx - v1x * _this1.ny + _this1.surfacex) * _this1.c1.tMass;
						jMax = _this1.c1.friction * _this1.c1.jnAcc;
						jOld = _this1.c1.jtAcc;
						cjAcc = jOld - j;
						if(cjAcc > jMax) {
							cjAcc = jMax;
						} else if(cjAcc < -jMax) {
							cjAcc = -jMax;
						}
						j = cjAcc - jOld;
						_this1.c1.jtAcc = cjAcc;
						jx2 = -_this1.ny * j;
						jy2 = _this1.nx * j;
						_this1.b2.velx += jx2 * _this1.b2.imass;
						_this1.b2.vely += jy2 * _this1.b2.imass;
						_this1.b1.velx -= jx2 * _this1.b1.imass;
						_this1.b1.vely -= jy2 * _this1.b1.imass;
						_this1.b2.angvel += _this1.rt1b * j * _this1.b2.iinertia;
						_this1.b1.angvel -= _this1.rt1a * j * _this1.b1.iinertia;
						v2x = _this1.k2x + _this1.b2.velx - _this1.c2.r2y * _this1.b2.angvel - (_this1.b1.velx - _this1.c2.r1y * _this1.b1.angvel);
						v2y = _this1.k2y + _this1.b2.vely + _this1.c2.r2x * _this1.b2.angvel - (_this1.b1.vely + _this1.c2.r1x * _this1.b1.angvel);
						j = (v2y * _this1.nx - v2x * _this1.ny + _this1.surfacex) * _this1.c2.tMass;
						jMax = _this1.c2.friction * _this1.c2.jnAcc;
						jOld = _this1.c2.jtAcc;
						cjAcc = jOld - j;
						if(cjAcc > jMax) {
							cjAcc = jMax;
						} else if(cjAcc < -jMax) {
							cjAcc = -jMax;
						}
						j = cjAcc - jOld;
						_this1.c2.jtAcc = cjAcc;
						jx2 = -_this1.ny * j;
						jy2 = _this1.nx * j;
						_this1.b2.velx += jx2 * _this1.b2.imass;
						_this1.b2.vely += jy2 * _this1.b2.imass;
						_this1.b1.velx -= jx2 * _this1.b1.imass;
						_this1.b1.vely -= jy2 * _this1.b1.imass;
						_this1.b2.angvel += _this1.rt2b * j * _this1.b2.iinertia;
						_this1.b1.angvel -= _this1.rt2a * j * _this1.b1.iinertia;
					} else {
						j = (_this1.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale + (_this1.nx * v1x + _this1.ny * v1y) + _this1.surfacey) * _this1.c1.nMass;
						jOld = _this1.c1.jnAcc;
						cjAcc = jOld - j;
						if(cjAcc < 0.0) {
							cjAcc = 0.0;
						}
						j = cjAcc - jOld;
						_this1.c1.jnAcc = cjAcc;
						jx2 = _this1.nx * j;
						jy2 = _this1.ny * j;
						_this1.b2.velx += jx2 * _this1.b2.imass;
						_this1.b2.vely += jy2 * _this1.b2.imass;
						_this1.b1.velx -= jx2 * _this1.b1.imass;
						_this1.b1.vely -= jy2 * _this1.b1.imass;
						_this1.b2.angvel += _this1.rn1b * j * _this1.b2.iinertia;
						_this1.b1.angvel -= _this1.rn1a * j * _this1.b1.iinertia;
						v1x = _this1.k1x + _this1.b2.velx - _this1.c1.r2y * _this1.b2.angvel - (_this1.b1.velx - _this1.c1.r1y * _this1.b1.angvel);
						v1y = _this1.k1y + _this1.b2.vely + _this1.c1.r2x * _this1.b2.angvel - (_this1.b1.vely + _this1.c1.r1x * _this1.b1.angvel);
						j = (v1y * _this1.nx - v1x * _this1.ny + _this1.surfacex) * _this1.c1.tMass;
						jMax = _this1.c1.friction * _this1.c1.jnAcc;
						jOld = _this1.c1.jtAcc;
						cjAcc = jOld - j;
						if(cjAcc > jMax) {
							cjAcc = jMax;
						} else if(cjAcc < -jMax) {
							cjAcc = -jMax;
						}
						j = cjAcc - jOld;
						_this1.c1.jtAcc = cjAcc;
						jx2 = -_this1.ny * j;
						jy2 = _this1.nx * j;
						_this1.b2.velx += jx2 * _this1.b2.imass;
						_this1.b2.vely += jy2 * _this1.b2.imass;
						_this1.b1.velx -= jx2 * _this1.b1.imass;
						_this1.b1.vely -= jy2 * _this1.b1.imass;
						_this1.b2.angvel += _this1.rt1b * j * _this1.b2.iinertia;
						_this1.b1.angvel -= _this1.rt1a * j * _this1.b1.iinertia;
						if(_this1.radius != 0.0) {
							var dw = _this1.b2.angvel - _this1.b1.angvel;
							j = dw * _this1.rMass;
							jMax = _this1.rfric * _this1.c1.jnAcc;
							jOld = _this1.jrAcc;
							_this1.jrAcc -= j;
							if(_this1.jrAcc > jMax) {
								_this1.jrAcc = jMax;
							} else if(_this1.jrAcc < -jMax) {
								_this1.jrAcc = -jMax;
							}
							j = _this1.jrAcc - jOld;
							_this1.b2.angvel += j * _this1.b2.iinertia;
							_this1.b1.angvel -= j * _this1.b1.iinertia;
						}
					}
					var _this2 = arb.colarb;
					var jx3;
					var jy3;
					var j1;
					var jMax1;
					var jOld1;
					var cjAcc1;
					var v1x1 = _this2.k1x + _this2.b2.velx - _this2.c1.r2y * _this2.b2.angvel - (_this2.b1.velx - _this2.c1.r1y * _this2.b1.angvel);
					var v1y1 = _this2.k1y + _this2.b2.vely + _this2.c1.r2x * _this2.b2.angvel - (_this2.b1.vely + _this2.c1.r1x * _this2.b1.angvel);
					if(_this2.hc2) {
						var v2x1 = _this2.k2x + _this2.b2.velx - _this2.c2.r2y * _this2.b2.angvel - (_this2.b1.velx - _this2.c2.r1y * _this2.b1.angvel);
						var v2y1 = _this2.k2y + _this2.b2.vely + _this2.c2.r2x * _this2.b2.angvel - (_this2.b1.vely + _this2.c2.r1x * _this2.b1.angvel);
						var ax1 = _this2.c1.jnAcc;
						var ay1 = _this2.c2.jnAcc;
						var jnx1 = v1x1 * _this2.nx + v1y1 * _this2.ny + _this2.surfacey + _this2.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this2.Ka * ax1 + _this2.Kb * ay1);
						var jny1 = v2x1 * _this2.nx + v2y1 * _this2.ny + _this2.surfacey + _this2.c2.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this2.Kb * ax1 + _this2.Kc * ay1);
						var xx1 = -(_this2.kMassa * jnx1 + _this2.kMassb * jny1);
						var xy1 = -(_this2.kMassb * jnx1 + _this2.kMassc * jny1);
						if(xx1 >= 0 && xy1 >= 0) {
							jnx1 = xx1 - ax1;
							jny1 = xy1 - ay1;
							_this2.c1.jnAcc = xx1;
							_this2.c2.jnAcc = xy1;
						} else {
							xx1 = -_this2.c1.nMass * jnx1;
							if(xx1 >= 0 && _this2.Kb * xx1 + jny1 >= 0) {
								jnx1 = xx1 - ax1;
								jny1 = -ay1;
								_this2.c1.jnAcc = xx1;
								_this2.c2.jnAcc = 0;
							} else {
								xy1 = -_this2.c2.nMass * jny1;
								if(xy1 >= 0 && _this2.Kb * xy1 + jnx1 >= 0) {
									jnx1 = -ax1;
									jny1 = xy1 - ay1;
									_this2.c1.jnAcc = 0;
									_this2.c2.jnAcc = xy1;
								} else if(jnx1 >= 0 && jny1 >= 0) {
									jnx1 = -ax1;
									jny1 = -ay1;
									_this2.c1.jnAcc = _this2.c2.jnAcc = 0;
								} else {
									jnx1 = 0;
									jny1 = 0;
								}
							}
						}
						j1 = jnx1 + jny1;
						jx3 = _this2.nx * j1;
						jy3 = _this2.ny * j1;
						_this2.b2.velx += jx3 * _this2.b2.imass;
						_this2.b2.vely += jy3 * _this2.b2.imass;
						_this2.b1.velx -= jx3 * _this2.b1.imass;
						_this2.b1.vely -= jy3 * _this2.b1.imass;
						_this2.b2.angvel += (_this2.rn1b * jnx1 + _this2.rn2b * jny1) * _this2.b2.iinertia;
						_this2.b1.angvel -= (_this2.rn1a * jnx1 + _this2.rn2a * jny1) * _this2.b1.iinertia;
						v1x1 = _this2.k1x + _this2.b2.velx - _this2.c1.r2y * _this2.b2.angvel - (_this2.b1.velx - _this2.c1.r1y * _this2.b1.angvel);
						v1y1 = _this2.k1y + _this2.b2.vely + _this2.c1.r2x * _this2.b2.angvel - (_this2.b1.vely + _this2.c1.r1x * _this2.b1.angvel);
						j1 = (v1y1 * _this2.nx - v1x1 * _this2.ny + _this2.surfacex) * _this2.c1.tMass;
						jMax1 = _this2.c1.friction * _this2.c1.jnAcc;
						jOld1 = _this2.c1.jtAcc;
						cjAcc1 = jOld1 - j1;
						if(cjAcc1 > jMax1) {
							cjAcc1 = jMax1;
						} else if(cjAcc1 < -jMax1) {
							cjAcc1 = -jMax1;
						}
						j1 = cjAcc1 - jOld1;
						_this2.c1.jtAcc = cjAcc1;
						jx3 = -_this2.ny * j1;
						jy3 = _this2.nx * j1;
						_this2.b2.velx += jx3 * _this2.b2.imass;
						_this2.b2.vely += jy3 * _this2.b2.imass;
						_this2.b1.velx -= jx3 * _this2.b1.imass;
						_this2.b1.vely -= jy3 * _this2.b1.imass;
						_this2.b2.angvel += _this2.rt1b * j1 * _this2.b2.iinertia;
						_this2.b1.angvel -= _this2.rt1a * j1 * _this2.b1.iinertia;
						v2x1 = _this2.k2x + _this2.b2.velx - _this2.c2.r2y * _this2.b2.angvel - (_this2.b1.velx - _this2.c2.r1y * _this2.b1.angvel);
						v2y1 = _this2.k2y + _this2.b2.vely + _this2.c2.r2x * _this2.b2.angvel - (_this2.b1.vely + _this2.c2.r1x * _this2.b1.angvel);
						j1 = (v2y1 * _this2.nx - v2x1 * _this2.ny + _this2.surfacex) * _this2.c2.tMass;
						jMax1 = _this2.c2.friction * _this2.c2.jnAcc;
						jOld1 = _this2.c2.jtAcc;
						cjAcc1 = jOld1 - j1;
						if(cjAcc1 > jMax1) {
							cjAcc1 = jMax1;
						} else if(cjAcc1 < -jMax1) {
							cjAcc1 = -jMax1;
						}
						j1 = cjAcc1 - jOld1;
						_this2.c2.jtAcc = cjAcc1;
						jx3 = -_this2.ny * j1;
						jy3 = _this2.nx * j1;
						_this2.b2.velx += jx3 * _this2.b2.imass;
						_this2.b2.vely += jy3 * _this2.b2.imass;
						_this2.b1.velx -= jx3 * _this2.b1.imass;
						_this2.b1.vely -= jy3 * _this2.b1.imass;
						_this2.b2.angvel += _this2.rt2b * j1 * _this2.b2.iinertia;
						_this2.b1.angvel -= _this2.rt2a * j1 * _this2.b1.iinertia;
					} else {
						j1 = (_this2.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale + (_this2.nx * v1x1 + _this2.ny * v1y1) + _this2.surfacey) * _this2.c1.nMass;
						jOld1 = _this2.c1.jnAcc;
						cjAcc1 = jOld1 - j1;
						if(cjAcc1 < 0.0) {
							cjAcc1 = 0.0;
						}
						j1 = cjAcc1 - jOld1;
						_this2.c1.jnAcc = cjAcc1;
						jx3 = _this2.nx * j1;
						jy3 = _this2.ny * j1;
						_this2.b2.velx += jx3 * _this2.b2.imass;
						_this2.b2.vely += jy3 * _this2.b2.imass;
						_this2.b1.velx -= jx3 * _this2.b1.imass;
						_this2.b1.vely -= jy3 * _this2.b1.imass;
						_this2.b2.angvel += _this2.rn1b * j1 * _this2.b2.iinertia;
						_this2.b1.angvel -= _this2.rn1a * j1 * _this2.b1.iinertia;
						v1x1 = _this2.k1x + _this2.b2.velx - _this2.c1.r2y * _this2.b2.angvel - (_this2.b1.velx - _this2.c1.r1y * _this2.b1.angvel);
						v1y1 = _this2.k1y + _this2.b2.vely + _this2.c1.r2x * _this2.b2.angvel - (_this2.b1.vely + _this2.c1.r1x * _this2.b1.angvel);
						j1 = (v1y1 * _this2.nx - v1x1 * _this2.ny + _this2.surfacex) * _this2.c1.tMass;
						jMax1 = _this2.c1.friction * _this2.c1.jnAcc;
						jOld1 = _this2.c1.jtAcc;
						cjAcc1 = jOld1 - j1;
						if(cjAcc1 > jMax1) {
							cjAcc1 = jMax1;
						} else if(cjAcc1 < -jMax1) {
							cjAcc1 = -jMax1;
						}
						j1 = cjAcc1 - jOld1;
						_this2.c1.jtAcc = cjAcc1;
						jx3 = -_this2.ny * j1;
						jy3 = _this2.nx * j1;
						_this2.b2.velx += jx3 * _this2.b2.imass;
						_this2.b2.vely += jy3 * _this2.b2.imass;
						_this2.b1.velx -= jx3 * _this2.b1.imass;
						_this2.b1.vely -= jy3 * _this2.b1.imass;
						_this2.b2.angvel += _this2.rt1b * j1 * _this2.b2.iinertia;
						_this2.b1.angvel -= _this2.rt1a * j1 * _this2.b1.iinertia;
						if(_this2.radius != 0.0) {
							var dw1 = _this2.b2.angvel - _this2.b1.angvel;
							j1 = dw1 * _this2.rMass;
							jMax1 = _this2.rfric * _this2.c1.jnAcc;
							jOld1 = _this2.jrAcc;
							_this2.jrAcc -= j1;
							if(_this2.jrAcc > jMax1) {
								_this2.jrAcc = jMax1;
							} else if(_this2.jrAcc < -jMax1) {
								_this2.jrAcc = -jMax1;
							}
							j1 = _this2.jrAcc - jOld1;
							_this2.b2.angvel += j1 * _this2.b2.iinertia;
							_this2.b1.angvel -= j1 * _this2.b1.iinertia;
						}
					}
					var _this3 = arb.colarb;
					var jx4;
					var jy4;
					var j2;
					var jMax2;
					var jOld2;
					var cjAcc2;
					var v1x2 = _this3.k1x + _this3.b2.velx - _this3.c1.r2y * _this3.b2.angvel - (_this3.b1.velx - _this3.c1.r1y * _this3.b1.angvel);
					var v1y2 = _this3.k1y + _this3.b2.vely + _this3.c1.r2x * _this3.b2.angvel - (_this3.b1.vely + _this3.c1.r1x * _this3.b1.angvel);
					if(_this3.hc2) {
						var v2x2 = _this3.k2x + _this3.b2.velx - _this3.c2.r2y * _this3.b2.angvel - (_this3.b1.velx - _this3.c2.r1y * _this3.b1.angvel);
						var v2y2 = _this3.k2y + _this3.b2.vely + _this3.c2.r2x * _this3.b2.angvel - (_this3.b1.vely + _this3.c2.r1x * _this3.b1.angvel);
						var ax2 = _this3.c1.jnAcc;
						var ay2 = _this3.c2.jnAcc;
						var jnx2 = v1x2 * _this3.nx + v1y2 * _this3.ny + _this3.surfacey + _this3.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this3.Ka * ax2 + _this3.Kb * ay2);
						var jny2 = v2x2 * _this3.nx + v2y2 * _this3.ny + _this3.surfacey + _this3.c2.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this3.Kb * ax2 + _this3.Kc * ay2);
						var xx2 = -(_this3.kMassa * jnx2 + _this3.kMassb * jny2);
						var xy2 = -(_this3.kMassb * jnx2 + _this3.kMassc * jny2);
						if(xx2 >= 0 && xy2 >= 0) {
							jnx2 = xx2 - ax2;
							jny2 = xy2 - ay2;
							_this3.c1.jnAcc = xx2;
							_this3.c2.jnAcc = xy2;
						} else {
							xx2 = -_this3.c1.nMass * jnx2;
							if(xx2 >= 0 && _this3.Kb * xx2 + jny2 >= 0) {
								jnx2 = xx2 - ax2;
								jny2 = -ay2;
								_this3.c1.jnAcc = xx2;
								_this3.c2.jnAcc = 0;
							} else {
								xy2 = -_this3.c2.nMass * jny2;
								if(xy2 >= 0 && _this3.Kb * xy2 + jnx2 >= 0) {
									jnx2 = -ax2;
									jny2 = xy2 - ay2;
									_this3.c1.jnAcc = 0;
									_this3.c2.jnAcc = xy2;
								} else if(jnx2 >= 0 && jny2 >= 0) {
									jnx2 = -ax2;
									jny2 = -ay2;
									_this3.c1.jnAcc = _this3.c2.jnAcc = 0;
								} else {
									jnx2 = 0;
									jny2 = 0;
								}
							}
						}
						j2 = jnx2 + jny2;
						jx4 = _this3.nx * j2;
						jy4 = _this3.ny * j2;
						_this3.b2.velx += jx4 * _this3.b2.imass;
						_this3.b2.vely += jy4 * _this3.b2.imass;
						_this3.b1.velx -= jx4 * _this3.b1.imass;
						_this3.b1.vely -= jy4 * _this3.b1.imass;
						_this3.b2.angvel += (_this3.rn1b * jnx2 + _this3.rn2b * jny2) * _this3.b2.iinertia;
						_this3.b1.angvel -= (_this3.rn1a * jnx2 + _this3.rn2a * jny2) * _this3.b1.iinertia;
						v1x2 = _this3.k1x + _this3.b2.velx - _this3.c1.r2y * _this3.b2.angvel - (_this3.b1.velx - _this3.c1.r1y * _this3.b1.angvel);
						v1y2 = _this3.k1y + _this3.b2.vely + _this3.c1.r2x * _this3.b2.angvel - (_this3.b1.vely + _this3.c1.r1x * _this3.b1.angvel);
						j2 = (v1y2 * _this3.nx - v1x2 * _this3.ny + _this3.surfacex) * _this3.c1.tMass;
						jMax2 = _this3.c1.friction * _this3.c1.jnAcc;
						jOld2 = _this3.c1.jtAcc;
						cjAcc2 = jOld2 - j2;
						if(cjAcc2 > jMax2) {
							cjAcc2 = jMax2;
						} else if(cjAcc2 < -jMax2) {
							cjAcc2 = -jMax2;
						}
						j2 = cjAcc2 - jOld2;
						_this3.c1.jtAcc = cjAcc2;
						jx4 = -_this3.ny * j2;
						jy4 = _this3.nx * j2;
						_this3.b2.velx += jx4 * _this3.b2.imass;
						_this3.b2.vely += jy4 * _this3.b2.imass;
						_this3.b1.velx -= jx4 * _this3.b1.imass;
						_this3.b1.vely -= jy4 * _this3.b1.imass;
						_this3.b2.angvel += _this3.rt1b * j2 * _this3.b2.iinertia;
						_this3.b1.angvel -= _this3.rt1a * j2 * _this3.b1.iinertia;
						v2x2 = _this3.k2x + _this3.b2.velx - _this3.c2.r2y * _this3.b2.angvel - (_this3.b1.velx - _this3.c2.r1y * _this3.b1.angvel);
						v2y2 = _this3.k2y + _this3.b2.vely + _this3.c2.r2x * _this3.b2.angvel - (_this3.b1.vely + _this3.c2.r1x * _this3.b1.angvel);
						j2 = (v2y2 * _this3.nx - v2x2 * _this3.ny + _this3.surfacex) * _this3.c2.tMass;
						jMax2 = _this3.c2.friction * _this3.c2.jnAcc;
						jOld2 = _this3.c2.jtAcc;
						cjAcc2 = jOld2 - j2;
						if(cjAcc2 > jMax2) {
							cjAcc2 = jMax2;
						} else if(cjAcc2 < -jMax2) {
							cjAcc2 = -jMax2;
						}
						j2 = cjAcc2 - jOld2;
						_this3.c2.jtAcc = cjAcc2;
						jx4 = -_this3.ny * j2;
						jy4 = _this3.nx * j2;
						_this3.b2.velx += jx4 * _this3.b2.imass;
						_this3.b2.vely += jy4 * _this3.b2.imass;
						_this3.b1.velx -= jx4 * _this3.b1.imass;
						_this3.b1.vely -= jy4 * _this3.b1.imass;
						_this3.b2.angvel += _this3.rt2b * j2 * _this3.b2.iinertia;
						_this3.b1.angvel -= _this3.rt2a * j2 * _this3.b1.iinertia;
					} else {
						j2 = (_this3.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale + (_this3.nx * v1x2 + _this3.ny * v1y2) + _this3.surfacey) * _this3.c1.nMass;
						jOld2 = _this3.c1.jnAcc;
						cjAcc2 = jOld2 - j2;
						if(cjAcc2 < 0.0) {
							cjAcc2 = 0.0;
						}
						j2 = cjAcc2 - jOld2;
						_this3.c1.jnAcc = cjAcc2;
						jx4 = _this3.nx * j2;
						jy4 = _this3.ny * j2;
						_this3.b2.velx += jx4 * _this3.b2.imass;
						_this3.b2.vely += jy4 * _this3.b2.imass;
						_this3.b1.velx -= jx4 * _this3.b1.imass;
						_this3.b1.vely -= jy4 * _this3.b1.imass;
						_this3.b2.angvel += _this3.rn1b * j2 * _this3.b2.iinertia;
						_this3.b1.angvel -= _this3.rn1a * j2 * _this3.b1.iinertia;
						v1x2 = _this3.k1x + _this3.b2.velx - _this3.c1.r2y * _this3.b2.angvel - (_this3.b1.velx - _this3.c1.r1y * _this3.b1.angvel);
						v1y2 = _this3.k1y + _this3.b2.vely + _this3.c1.r2x * _this3.b2.angvel - (_this3.b1.vely + _this3.c1.r1x * _this3.b1.angvel);
						j2 = (v1y2 * _this3.nx - v1x2 * _this3.ny + _this3.surfacex) * _this3.c1.tMass;
						jMax2 = _this3.c1.friction * _this3.c1.jnAcc;
						jOld2 = _this3.c1.jtAcc;
						cjAcc2 = jOld2 - j2;
						if(cjAcc2 > jMax2) {
							cjAcc2 = jMax2;
						} else if(cjAcc2 < -jMax2) {
							cjAcc2 = -jMax2;
						}
						j2 = cjAcc2 - jOld2;
						_this3.c1.jtAcc = cjAcc2;
						jx4 = -_this3.ny * j2;
						jy4 = _this3.nx * j2;
						_this3.b2.velx += jx4 * _this3.b2.imass;
						_this3.b2.vely += jy4 * _this3.b2.imass;
						_this3.b1.velx -= jx4 * _this3.b1.imass;
						_this3.b1.vely -= jy4 * _this3.b1.imass;
						_this3.b2.angvel += _this3.rt1b * j2 * _this3.b2.iinertia;
						_this3.b1.angvel -= _this3.rt1a * j2 * _this3.b1.iinertia;
						if(_this3.radius != 0.0) {
							var dw2 = _this3.b2.angvel - _this3.b1.angvel;
							j2 = dw2 * _this3.rMass;
							jMax2 = _this3.rfric * _this3.c1.jnAcc;
							jOld2 = _this3.jrAcc;
							_this3.jrAcc -= j2;
							if(_this3.jrAcc > jMax2) {
								_this3.jrAcc = jMax2;
							} else if(_this3.jrAcc < -jMax2) {
								_this3.jrAcc = -jMax2;
							}
							j2 = _this3.jrAcc - jOld2;
							_this3.b2.angvel += j2 * _this3.b2.iinertia;
							_this3.b1.angvel -= j2 * _this3.b1.iinertia;
						}
					}
					var _this4 = arb.colarb;
					var jx5;
					var jy5;
					var j3;
					var jMax3;
					var jOld3;
					var cjAcc3;
					var v1x3 = _this4.k1x + _this4.b2.velx - _this4.c1.r2y * _this4.b2.angvel - (_this4.b1.velx - _this4.c1.r1y * _this4.b1.angvel);
					var v1y3 = _this4.k1y + _this4.b2.vely + _this4.c1.r2x * _this4.b2.angvel - (_this4.b1.vely + _this4.c1.r1x * _this4.b1.angvel);
					if(_this4.hc2) {
						var v2x3 = _this4.k2x + _this4.b2.velx - _this4.c2.r2y * _this4.b2.angvel - (_this4.b1.velx - _this4.c2.r1y * _this4.b1.angvel);
						var v2y3 = _this4.k2y + _this4.b2.vely + _this4.c2.r2x * _this4.b2.angvel - (_this4.b1.vely + _this4.c2.r1x * _this4.b1.angvel);
						var ax3 = _this4.c1.jnAcc;
						var ay3 = _this4.c2.jnAcc;
						var jnx3 = v1x3 * _this4.nx + v1y3 * _this4.ny + _this4.surfacey + _this4.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this4.Ka * ax3 + _this4.Kb * ay3);
						var jny3 = v2x3 * _this4.nx + v2y3 * _this4.ny + _this4.surfacey + _this4.c2.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (_this4.Kb * ax3 + _this4.Kc * ay3);
						var xx3 = -(_this4.kMassa * jnx3 + _this4.kMassb * jny3);
						var xy3 = -(_this4.kMassb * jnx3 + _this4.kMassc * jny3);
						if(xx3 >= 0 && xy3 >= 0) {
							jnx3 = xx3 - ax3;
							jny3 = xy3 - ay3;
							_this4.c1.jnAcc = xx3;
							_this4.c2.jnAcc = xy3;
						} else {
							xx3 = -_this4.c1.nMass * jnx3;
							if(xx3 >= 0 && _this4.Kb * xx3 + jny3 >= 0) {
								jnx3 = xx3 - ax3;
								jny3 = -ay3;
								_this4.c1.jnAcc = xx3;
								_this4.c2.jnAcc = 0;
							} else {
								xy3 = -_this4.c2.nMass * jny3;
								if(xy3 >= 0 && _this4.Kb * xy3 + jnx3 >= 0) {
									jnx3 = -ax3;
									jny3 = xy3 - ay3;
									_this4.c1.jnAcc = 0;
									_this4.c2.jnAcc = xy3;
								} else if(jnx3 >= 0 && jny3 >= 0) {
									jnx3 = -ax3;
									jny3 = -ay3;
									_this4.c1.jnAcc = _this4.c2.jnAcc = 0;
								} else {
									jnx3 = 0;
									jny3 = 0;
								}
							}
						}
						j3 = jnx3 + jny3;
						jx5 = _this4.nx * j3;
						jy5 = _this4.ny * j3;
						_this4.b2.velx += jx5 * _this4.b2.imass;
						_this4.b2.vely += jy5 * _this4.b2.imass;
						_this4.b1.velx -= jx5 * _this4.b1.imass;
						_this4.b1.vely -= jy5 * _this4.b1.imass;
						_this4.b2.angvel += (_this4.rn1b * jnx3 + _this4.rn2b * jny3) * _this4.b2.iinertia;
						_this4.b1.angvel -= (_this4.rn1a * jnx3 + _this4.rn2a * jny3) * _this4.b1.iinertia;
						v1x3 = _this4.k1x + _this4.b2.velx - _this4.c1.r2y * _this4.b2.angvel - (_this4.b1.velx - _this4.c1.r1y * _this4.b1.angvel);
						v1y3 = _this4.k1y + _this4.b2.vely + _this4.c1.r2x * _this4.b2.angvel - (_this4.b1.vely + _this4.c1.r1x * _this4.b1.angvel);
						j3 = (v1y3 * _this4.nx - v1x3 * _this4.ny + _this4.surfacex) * _this4.c1.tMass;
						jMax3 = _this4.c1.friction * _this4.c1.jnAcc;
						jOld3 = _this4.c1.jtAcc;
						cjAcc3 = jOld3 - j3;
						if(cjAcc3 > jMax3) {
							cjAcc3 = jMax3;
						} else if(cjAcc3 < -jMax3) {
							cjAcc3 = -jMax3;
						}
						j3 = cjAcc3 - jOld3;
						_this4.c1.jtAcc = cjAcc3;
						jx5 = -_this4.ny * j3;
						jy5 = _this4.nx * j3;
						_this4.b2.velx += jx5 * _this4.b2.imass;
						_this4.b2.vely += jy5 * _this4.b2.imass;
						_this4.b1.velx -= jx5 * _this4.b1.imass;
						_this4.b1.vely -= jy5 * _this4.b1.imass;
						_this4.b2.angvel += _this4.rt1b * j3 * _this4.b2.iinertia;
						_this4.b1.angvel -= _this4.rt1a * j3 * _this4.b1.iinertia;
						v2x3 = _this4.k2x + _this4.b2.velx - _this4.c2.r2y * _this4.b2.angvel - (_this4.b1.velx - _this4.c2.r1y * _this4.b1.angvel);
						v2y3 = _this4.k2y + _this4.b2.vely + _this4.c2.r2x * _this4.b2.angvel - (_this4.b1.vely + _this4.c2.r1x * _this4.b1.angvel);
						j3 = (v2y3 * _this4.nx - v2x3 * _this4.ny + _this4.surfacex) * _this4.c2.tMass;
						jMax3 = _this4.c2.friction * _this4.c2.jnAcc;
						jOld3 = _this4.c2.jtAcc;
						cjAcc3 = jOld3 - j3;
						if(cjAcc3 > jMax3) {
							cjAcc3 = jMax3;
						} else if(cjAcc3 < -jMax3) {
							cjAcc3 = -jMax3;
						}
						j3 = cjAcc3 - jOld3;
						_this4.c2.jtAcc = cjAcc3;
						jx5 = -_this4.ny * j3;
						jy5 = _this4.nx * j3;
						_this4.b2.velx += jx5 * _this4.b2.imass;
						_this4.b2.vely += jy5 * _this4.b2.imass;
						_this4.b1.velx -= jx5 * _this4.b1.imass;
						_this4.b1.vely -= jy5 * _this4.b1.imass;
						_this4.b2.angvel += _this4.rt2b * j3 * _this4.b2.iinertia;
						_this4.b1.angvel -= _this4.rt2a * j3 * _this4.b1.iinertia;
					} else {
						j3 = (_this4.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale + (_this4.nx * v1x3 + _this4.ny * v1y3) + _this4.surfacey) * _this4.c1.nMass;
						jOld3 = _this4.c1.jnAcc;
						cjAcc3 = jOld3 - j3;
						if(cjAcc3 < 0.0) {
							cjAcc3 = 0.0;
						}
						j3 = cjAcc3 - jOld3;
						_this4.c1.jnAcc = cjAcc3;
						jx5 = _this4.nx * j3;
						jy5 = _this4.ny * j3;
						_this4.b2.velx += jx5 * _this4.b2.imass;
						_this4.b2.vely += jy5 * _this4.b2.imass;
						_this4.b1.velx -= jx5 * _this4.b1.imass;
						_this4.b1.vely -= jy5 * _this4.b1.imass;
						_this4.b2.angvel += _this4.rn1b * j3 * _this4.b2.iinertia;
						_this4.b1.angvel -= _this4.rn1a * j3 * _this4.b1.iinertia;
						v1x3 = _this4.k1x + _this4.b2.velx - _this4.c1.r2y * _this4.b2.angvel - (_this4.b1.velx - _this4.c1.r1y * _this4.b1.angvel);
						v1y3 = _this4.k1y + _this4.b2.vely + _this4.c1.r2x * _this4.b2.angvel - (_this4.b1.vely + _this4.c1.r1x * _this4.b1.angvel);
						j3 = (v1y3 * _this4.nx - v1x3 * _this4.ny + _this4.surfacex) * _this4.c1.tMass;
						jMax3 = _this4.c1.friction * _this4.c1.jnAcc;
						jOld3 = _this4.c1.jtAcc;
						cjAcc3 = jOld3 - j3;
						if(cjAcc3 > jMax3) {
							cjAcc3 = jMax3;
						} else if(cjAcc3 < -jMax3) {
							cjAcc3 = -jMax3;
						}
						j3 = cjAcc3 - jOld3;
						_this4.c1.jtAcc = cjAcc3;
						jx5 = -_this4.ny * j3;
						jy5 = _this4.nx * j3;
						_this4.b2.velx += jx5 * _this4.b2.imass;
						_this4.b2.vely += jy5 * _this4.b2.imass;
						_this4.b1.velx -= jx5 * _this4.b1.imass;
						_this4.b1.vely -= jy5 * _this4.b1.imass;
						_this4.b2.angvel += _this4.rt1b * j3 * _this4.b2.iinertia;
						_this4.b1.angvel -= _this4.rt1a * j3 * _this4.b1.iinertia;
						if(_this4.radius != 0.0) {
							var dw3 = _this4.b2.angvel - _this4.b1.angvel;
							j3 = dw3 * _this4.rMass;
							jMax3 = _this4.rfric * _this4.c1.jnAcc;
							jOld3 = _this4.jrAcc;
							_this4.jrAcc -= j3;
							if(_this4.jrAcc > jMax3) {
								_this4.jrAcc = jMax3;
							} else if(_this4.jrAcc < -jMax3) {
								_this4.jrAcc = -jMax3;
							}
							j3 = _this4.jrAcc - jOld3;
							_this4.b2.angvel += j3 * _this4.b2.iinertia;
							_this4.b1.angvel -= j3 * _this4.b1.iinertia;
						}
					}
					b11.sweep_angvel = b11.angvel % MAX_VEL;
					b21.sweep_angvel = b21.angvel % MAX_VEL;
				}
			}
			if(arb != null && (arb.active && (arb.immState & 1) != 0) && arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
				if(!b11.sweepFrozen && b11.type != 3) {
					b11.sweepFrozen = true;
					if(minTOI.failed) {
						b11.angvel = b11.sweep_angvel = 0;
					} else if(minTOI.slipped) {
						var b12 = b11;
						b12.sweep_angvel *= nape_Config.angularCCDSlipScale;
						b11.angvel = b12.sweep_angvel;
					} else {
						b11.angvel = b11.sweep_angvel;
					}
				}
				if(!b21.sweepFrozen && b21.type != 3) {
					b21.sweepFrozen = true;
					if(minTOI.failed) {
						b21.angvel = b21.sweep_angvel = 0;
					} else if(minTOI.slipped) {
						var b22 = b21;
						b22.sweep_angvel *= nape_Config.angularCCDSlipScale;
						b21.angvel = b22.sweep_angvel;
					} else {
						b21.angvel = b21.sweep_angvel;
					}
				}
			}
			var o3 = minTOI;
			o3.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
			zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o3;
		}
		while(this.toiEvents.head != null) {
			var toi = this.toiEvents.pop_unsafe();
			var o = toi;
			o.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
			zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o;
		}
		var cx_ite = this.kinematics.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			var delta = deltaTime - cur.sweepTime;
			if(delta != 0) {
				cur.sweepTime = deltaTime;
				var t = delta;
				cur.posx += cur.velx * t;
				cur.posy += cur.vely * t;
				if(cur.angvel != 0) {
					var dr = cur.sweep_angvel * delta;
					cur.rot += dr;
					if(dr * dr > 0.0001) {
						cur.axisx = Math.sin(cur.rot);
						cur.axisy = Math.cos(cur.rot);
					} else {
						var d2 = dr * dr;
						var p = 1 - 0.5 * d2;
						var m = 1 - d2 * d2 / 8;
						var nx = (p * cur.axisx + dr * cur.axisy) * m;
						cur.axisy = (p * cur.axisy - dr * cur.axisx) * m;
						cur.axisx = nx;
					}
				}
			}
			cur.sweepTime = 0;
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.live.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			if(!cur.sweepFrozen) {
				var delta = deltaTime - cur.sweepTime;
				if(delta != 0) {
					cur.sweepTime = deltaTime;
					var t = delta;
					cur.posx += cur.velx * t;
					cur.posy += cur.vely * t;
					if(cur.angvel != 0) {
						var dr = cur.sweep_angvel * delta;
						cur.rot += dr;
						if(dr * dr > 0.0001) {
							cur.axisx = Math.sin(cur.rot);
							cur.axisy = Math.cos(cur.rot);
						} else {
							var d2 = dr * dr;
							var p = 1 - 0.5 * d2;
							var m = 1 - d2 * d2 / 8;
							var nx = (p * cur.axisx + dr * cur.axisy) * m;
							cur.axisy = (p * cur.axisy - dr * cur.axisx) * m;
							cur.axisx = nx;
						}
					}
				}
			}
			cur.sweepTime = 0;
			cx_ite = cx_ite.next;
		}
	}
	,continuousEvent: function(s1,s2,stat,in_arb,_) {
		if(s1.body.sweepFrozen && s2.body.sweepFrozen) {
			return in_arb;
		}
		if(s1.body.disableCCD || s2.body.disableCCD) {
			return in_arb;
		}
		var tmp;
		if(!(in_arb != null && in_arb.colarb == null)) {
			var b1 = s1.body;
			var b2 = s2.body;
			var con_ignore;
			con_ignore = false;
			var cx_ite = b1.constraints.head;
			while(cx_ite != null) {
				var con = cx_ite.elt;
				if(con.ignore && con.pair_exists(b1.id,b2.id)) {
					con_ignore = true;
					break;
				}
				cx_ite = cx_ite.next;
			}
			var tmp1;
			var tmp2;
			if(!con_ignore) {
				var cur = s1;
				while(cur != null && cur.group == null) if(cur.ishape != null) {
					cur = cur.ishape.body;
				} else if(cur.icompound != null) {
					cur = cur.icompound.compound;
				} else {
					cur = cur.ibody.compound;
				}
				var g1 = cur == null ? null : cur.group;
				var tmp3;
				if(g1 == null) {
					tmp3 = false;
				} else {
					var cur = s2;
					while(cur != null && cur.group == null) if(cur.ishape != null) {
						cur = cur.ishape.body;
					} else if(cur.icompound != null) {
						cur = cur.icompound.compound;
					} else {
						cur = cur.ibody.compound;
					}
					var g2 = cur == null ? null : cur.group;
					if(g2 == null) {
						tmp3 = false;
					} else {
						var ret = false;
						while(g1 != null && g2 != null) {
							if(g1 == g2) {
								ret = g1.ignore;
								break;
							}
							if(g1.depth < g2.depth) {
								g2 = g2.group;
							} else {
								g1 = g1.group;
							}
						}
						tmp3 = ret;
					}
				}
				tmp2 = !tmp3;
			} else {
				tmp2 = false;
			}
			if(tmp2) {
				var tmp2;
				if(s1.sensorEnabled || s2.sensorEnabled) {
					var _this = s1.filter;
					var x = s2.filter;
					tmp2 = (_this.sensorMask & x.sensorGroup) != 0 && (x.sensorMask & _this.sensorGroup) != 0;
				} else {
					tmp2 = false;
				}
				if(tmp2) {
					tmp1 = 2;
				} else {
					var tmp2;
					if(s1.fluidEnabled || s2.fluidEnabled) {
						var _this = s1.filter;
						var x = s2.filter;
						tmp2 = (_this.fluidMask & x.fluidGroup) != 0 && (x.fluidMask & _this.fluidGroup) != 0;
					} else {
						tmp2 = false;
					}
					if(tmp2 && !(b1.imass == 0 && b2.imass == 0 && b1.iinertia == 0 && b2.iinertia == 0)) {
						tmp1 = 0;
					} else {
						var _this = s1.filter;
						var x = s2.filter;
						tmp1 = (_this.collisionMask & x.collisionGroup) != 0 && (x.collisionMask & _this.collisionGroup) != 0 && !(b1.imass == 0 && b2.imass == 0 && b1.iinertia == 0 && b2.iinertia == 0) ? 1 : -1;
					}
				}
			} else {
				tmp1 = -1;
			}
			tmp = tmp1 <= 0;
		} else {
			tmp = true;
		}
		if(tmp) {
			return in_arb;
		}
		var b1 = s1.body;
		var b2 = s2.body;
		if(stat || b1.bullet || b2.bullet) {
			var toi;
			if(zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool == null) {
				toi = new zpp_$nape_geom_ZPP_$ToiEvent();
			} else {
				toi = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
				zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = toi.next;
				toi.next = null;
			}
			toi.failed = false;
			toi.s1 = toi.s2 = null;
			toi.arbiter = null;
			var kin = b1.type == 3 || b2.type == 3;
			if(stat && !kin) {
				if(s1.body.type != 2) {
					toi.s2 = s1;
					toi.s1 = s2;
				} else {
					toi.s1 = s1;
					toi.s2 = s2;
				}
				toi.kinematic = false;
				zpp_$nape_geom_ZPP_$SweepDistance.staticSweep(toi,this.pre_dt,0,nape_Config.collisionSlopCCD);
			} else {
				toi.s1 = s1;
				toi.s2 = s2;
				toi.kinematic = kin;
				if(toi.s1.body.sweepFrozen || toi.s2.body.sweepFrozen) {
					if(toi.s1.body.sweepFrozen) {
						var tmp = toi.s1;
						toi.s1 = toi.s2;
						toi.s2 = tmp;
						toi.frozen1 = false;
						toi.frozen2 = true;
					}
					zpp_$nape_geom_ZPP_$SweepDistance.staticSweep(toi,this.pre_dt,0,nape_Config.collisionSlopCCD);
				} else {
					zpp_$nape_geom_ZPP_$SweepDistance.dynamicSweep(toi,this.pre_dt,0,nape_Config.collisionSlopCCD);
				}
			}
			if(stat && toi.toi < 0 || toi.failed) {
				var o = toi;
				o.next = zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool;
				zpp_$nape_geom_ZPP_$ToiEvent.zpp_pool = o;
			} else {
				this.toiEvents.add(toi);
				toi.frozen1 = toi.s1.body.sweepFrozen;
				toi.frozen2 = toi.s2.body.sweepFrozen;
				toi.arbiter = in_arb != null ? in_arb.colarb : null;
			}
		}
		return in_arb;
	}
	,bodyCbWake: function(b) {
		if(b.type == 2 && b.cbSet != null) {
			if(this.midstep) {
				var cx_ite = b.cbSet.bodylisteners.head;
				while(cx_ite != null) {
					var i = cx_ite.elt;
					if(i.event != 2) {
						cx_ite = cx_ite.next;
						continue;
					}
					var cb = this.push_callback(i);
					cb.event = 2;
					cb.body = b;
					cx_ite = cx_ite.next;
				}
			} else {
				b.component.woken = true;
			}
		}
	}
	,bodyCbSleep: function(b) {
		if(b.type == 2 && b.cbSet != null) {
			var cx_ite = b.cbSet.bodylisteners.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.event != 3) {
					cx_ite = cx_ite.next;
					continue;
				}
				var cb = this.push_callback(i);
				cb.event = 3;
				cb.body = b;
				cx_ite = cx_ite.next;
			}
		}
	}
	,constraintCbWake: function(con) {
		if(con.cbSet != null) {
			if(this.midstep) {
				var cx_ite = con.cbSet.conlisteners.head;
				while(cx_ite != null) {
					var i = cx_ite.elt;
					if(i.event != 2) {
						cx_ite = cx_ite.next;
						continue;
					}
					var cb = this.push_callback(i);
					cb.event = 2;
					cb.constraint = con;
					cx_ite = cx_ite.next;
				}
			} else {
				con.component.woken = true;
			}
		}
	}
	,constraintCbSleep: function(con) {
		if(con.cbSet != null) {
			var cx_ite = con.cbSet.conlisteners.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.event != 3) {
					cx_ite = cx_ite.next;
					continue;
				}
				var cb = this.push_callback(i);
				cb.event = 3;
				cb.constraint = con;
				cx_ite = cx_ite.next;
			}
		}
	}
	,constraintCbBreak: function(con) {
		if(con.cbSet != null) {
			var cx_ite = con.cbSet.conlisteners.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				if(i.event != 4) {
					cx_ite = cx_ite.next;
					continue;
				}
				var cb = this.push_callback(i);
				cb.event = 4;
				cb.constraint = con;
				cx_ite = cx_ite.next;
			}
		}
	}
	,nullListenerType: function(cb1,cb2) {
		var stack = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
		var cx_ite = cb1.interactors.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			stack.add(i);
			cx_ite = cx_ite.next;
		}
		if(cb1 != cb2) {
			var cx_ite = cb2.interactors.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				stack.add(i);
				cx_ite = cx_ite.next;
			}
		}
		while(stack.head != null) {
			var intx = stack.pop_unsafe();
			if(intx.icompound != null) {
				var comp = intx.icompound;
				var cx_ite = comp.bodies.head;
				while(cx_ite != null) {
					var i = cx_ite.elt;
					stack.add(i);
					cx_ite = cx_ite.next;
				}
				var cx_ite1 = comp.compounds.head;
				while(cx_ite1 != null) {
					var i1 = cx_ite1.elt;
					stack.add(i1);
					cx_ite1 = cx_ite1.next;
				}
			} else {
				var xbody = intx.ibody != null ? intx.ibody : intx.ishape.body;
				var xshp = intx.ishape != null ? intx.ishape : null;
				var cx_ite2 = xbody.arbiters.head;
				while(cx_ite2 != null) {
					var xarb = cx_ite2.elt;
					if(xarb.present == 0) {
						cx_ite2 = cx_ite2.next;
						continue;
					}
					if(xshp != null && !(xarb.ws1 == xshp || xarb.ws2 == xshp)) {
						cx_ite2 = cx_ite2.next;
						continue;
					}
					this.MRCA_chains(xarb.ws1,xarb.ws2);
					var cx_ite3 = this.mrca1.head;
					while(cx_ite3 != null) {
						var i11 = cx_ite3.elt;
						if(i11.cbSet != cb1 && i11.cbSet != cb2) {
							cx_ite3 = cx_ite3.next;
							continue;
						}
						var cx_ite4 = this.mrca2.head;
						while(cx_ite4 != null) {
							var i2 = cx_ite4.elt;
							if(i11.cbSet == cb1 && i2.cbSet != cb2 || i11.cbSet == cb2 && i2.cbSet != cb1) {
								cx_ite4 = cx_ite4.next;
								continue;
							}
							var callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i11,i2);
							if(callbackset != null) {
								while(callbackset.arbiters.head != null) {
									var arb = callbackset.arbiters.pop_unsafe();
									arb.present--;
								}
								this.remove_callbackset(callbackset);
							}
							cx_ite4 = cx_ite4.next;
						}
						cx_ite3 = cx_ite3.next;
					}
					cx_ite2 = cx_ite2.next;
				}
			}
		}
	}
	,nullInteractorType: function(intx,me) {
		if(me == null) {
			me = intx;
		}
		if(intx.icompound != null) {
			var comp = intx.icompound;
			var cx_ite = comp.bodies.head;
			while(cx_ite != null) {
				var body = cx_ite.elt;
				this.nullInteractorType(body,me);
				cx_ite = cx_ite.next;
			}
			var cx_ite = comp.compounds.head;
			while(cx_ite != null) {
				var comp = cx_ite.elt;
				this.nullInteractorType(comp,me);
				cx_ite = cx_ite.next;
			}
		} else {
			var xbody = intx.ibody != null ? intx.ibody : intx.ishape.body;
			var xshp = intx.ishape != null ? intx.ishape : null;
			var cx_ite = xbody.arbiters.head;
			while(cx_ite != null) {
				var xarb = cx_ite.elt;
				if(xarb.present == 0) {
					cx_ite = cx_ite.next;
					continue;
				}
				if(xshp != null && !(xarb.ws1 == xshp || xarb.ws2 == xshp)) {
					cx_ite = cx_ite.next;
					continue;
				}
				this.MRCA_chains(xarb.ws1,xarb.ws2);
				var cx_ite1 = this.mrca1.head;
				while(cx_ite1 != null) {
					var i1 = cx_ite1.elt;
					var cx_ite2 = this.mrca2.head;
					while(cx_ite2 != null) {
						var i2 = cx_ite2.elt;
						if(i1 != me && i2 != me) {
							cx_ite2 = cx_ite2.next;
							continue;
						}
						var callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
						if(callbackset != null) {
							xarb.present--;
							callbackset.remove_arb(xarb);
							if(callbackset.arbiters.head == null) {
								this.remove_callbackset(callbackset);
							}
						}
						cx_ite2 = cx_ite2.next;
					}
					cx_ite1 = cx_ite1.next;
				}
				cx_ite = cx_ite.next;
			}
		}
	}
	,freshListenerType: function(cb1,cb2) {
		var stack = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
		var cx_ite = cb1.interactors.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			stack.add(i);
			cx_ite = cx_ite.next;
		}
		if(cb1 != cb2) {
			var cx_ite = cb2.interactors.head;
			while(cx_ite != null) {
				var i = cx_ite.elt;
				stack.add(i);
				cx_ite = cx_ite.next;
			}
		}
		while(stack.head != null) {
			var intx = stack.pop_unsafe();
			if(intx.icompound != null) {
				var comp = intx.icompound;
				var cx_ite = comp.bodies.head;
				while(cx_ite != null) {
					var i = cx_ite.elt;
					stack.add(i);
					cx_ite = cx_ite.next;
				}
				var cx_ite1 = comp.compounds.head;
				while(cx_ite1 != null) {
					var i1 = cx_ite1.elt;
					stack.add(i1);
					cx_ite1 = cx_ite1.next;
				}
			} else {
				var xbody = intx.ibody != null ? intx.ibody : intx.ishape.body;
				var xshp = intx.ishape != null ? intx.ishape : null;
				var cx_ite2 = xbody.arbiters.head;
				while(cx_ite2 != null) {
					var xarb = cx_ite2.elt;
					if(!xarb.presentable) {
						cx_ite2 = cx_ite2.next;
						continue;
					}
					if(xshp != null && !(xarb.ws1 == xshp || xarb.ws2 == xshp)) {
						cx_ite2 = cx_ite2.next;
						continue;
					}
					this.MRCA_chains(xarb.ws1,xarb.ws2);
					var cx_ite3 = this.mrca1.head;
					while(cx_ite3 != null) {
						var i11 = cx_ite3.elt;
						if(i11.cbSet != cb1 && i11.cbSet != cb2) {
							cx_ite3 = cx_ite3.next;
							continue;
						}
						var cx_ite4 = this.mrca2.head;
						while(cx_ite4 != null) {
							var i2 = cx_ite4.elt;
							if(i11.cbSet == cb1 && i2.cbSet != cb2 || i11.cbSet == cb2 && i2.cbSet != cb1) {
								cx_ite4 = cx_ite4.next;
								continue;
							}
							var callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i11,i2);
							if(callbackset == null) {
								callbackset = zpp_$nape_space_ZPP_$CallbackSet.get(i11,i2);
								this.add_callbackset(callbackset);
							}
							var tmp;
							var ret;
							ret = false;
							var cx_ite5 = callbackset.arbiters.head;
							while(cx_ite5 != null) {
								var npite = cx_ite5.elt;
								if(npite == xarb) {
									ret = true;
									break;
								}
								cx_ite5 = cx_ite5.next;
							}
							if(!ret) {
								var _this = callbackset.arbiters;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = xarb;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
								tmp = true;
							} else {
								tmp = false;
							}
							if(tmp) {
								xarb.present++;
							}
							cx_ite4 = cx_ite4.next;
						}
						cx_ite3 = cx_ite3.next;
					}
					cx_ite2 = cx_ite2.next;
				}
			}
		}
	}
	,freshInteractorType: function(intx,me) {
		if(me == null) {
			me = intx;
		}
		if(intx.icompound != null) {
			var comp = intx.icompound;
			var cx_ite = comp.bodies.head;
			while(cx_ite != null) {
				var body = cx_ite.elt;
				this.freshInteractorType(body,me);
				cx_ite = cx_ite.next;
			}
			var cx_ite = comp.compounds.head;
			while(cx_ite != null) {
				var comp = cx_ite.elt;
				this.freshInteractorType(comp,me);
				cx_ite = cx_ite.next;
			}
		} else {
			var xbody = intx.ibody != null ? intx.ibody : intx.ishape.body;
			var xshp = intx.ishape != null ? intx.ishape : null;
			var cx_ite = xbody.arbiters.head;
			while(cx_ite != null) {
				var xarb = cx_ite.elt;
				if(!xarb.presentable) {
					cx_ite = cx_ite.next;
					continue;
				}
				if(xshp != null && !(xarb.ws1 == xshp || xarb.ws2 == xshp)) {
					cx_ite = cx_ite.next;
					continue;
				}
				this.MRCA_chains(xarb.ws1,xarb.ws2);
				var cx_ite1 = this.mrca1.head;
				while(cx_ite1 != null) {
					var i1 = cx_ite1.elt;
					var cx_ite2 = this.mrca2.head;
					while(cx_ite2 != null) {
						var i2 = cx_ite2.elt;
						if(i1 != me && i2 != me) {
							cx_ite2 = cx_ite2.next;
							continue;
						}
						var cb1 = i1.cbSet;
						var cb2 = i2.cbSet;
						cb1.validate();
						cb2.validate();
						var _this = cb1.manager;
						var ret = null;
						var pairs = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
						var cx_ite3 = pairs.head;
						while(cx_ite3 != null) {
							var p = cx_ite3.elt;
							if(p.a == cb1 && p.b == cb2 || p.a == cb2 && p.b == cb1) {
								ret = p;
								break;
							}
							cx_ite3 = cx_ite3.next;
						}
						if(ret == null) {
							var ret1;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret1 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret1 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
								ret1.a = cb1;
								ret1.b = cb2;
							} else {
								ret1.a = cb2;
								ret1.b = cb1;
							}
							ret = ret1;
							cb1.cbpairs.add(ret);
							if(cb2 != cb1) {
								cb2.cbpairs.add(ret);
							}
						}
						if(ret.zip_listeners) {
							ret.zip_listeners = false;
							ret.__validate();
						}
						if(ret.listeners.head != null) {
							var callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
							if(callbackset == null) {
								callbackset = zpp_$nape_space_ZPP_$CallbackSet.get(i1,i2);
								this.add_callbackset(callbackset);
							}
							var tmp;
							var ret2;
							ret2 = false;
							var cx_ite4 = callbackset.arbiters.head;
							while(cx_ite4 != null) {
								var npite = cx_ite4.elt;
								if(npite == xarb) {
									ret2 = true;
									break;
								}
								cx_ite4 = cx_ite4.next;
							}
							if(!ret2) {
								var _this1 = callbackset.arbiters;
								var ret3;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
									ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
								} else {
									ret3 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret3.next;
									ret3.next = null;
								}
								ret3.elt = xarb;
								var temp = ret3;
								temp.next = _this1.head;
								_this1.head = temp;
								_this1.modified = true;
								_this1.length++;
								tmp = true;
							} else {
								tmp = false;
							}
							if(tmp) {
								xarb.present++;
							}
						}
						cx_ite2 = cx_ite2.next;
					}
					cx_ite1 = cx_ite1.next;
				}
				cx_ite = cx_ite.next;
			}
		}
	}
	,wakeCompound: function(x) {
		var cx_ite = x.bodies.head;
		while(cx_ite != null) {
			var y = cx_ite.elt;
			var o = y;
			if(!o.world) {
				o.component.waket = this.stamp + (this.midstep ? 0 : 1);
				if(o.type == 3) {
					o.kinematicDelaySleep = true;
				}
				if(o.component.sleeping) {
					this.really_wake(o,false);
				}
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = x.constraints.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.wake_constraint(i);
			cx_ite = cx_ite.next;
		}
		var cx_ite = x.compounds.head;
		while(cx_ite != null) {
			var i = cx_ite.elt;
			this.wakeCompound(i);
			cx_ite = cx_ite.next;
		}
	}
	,wakeIsland: function(i) {
		while(i.comps.head != null) {
			var c = i.comps.pop_unsafe();
			c.waket = this.stamp + (this.midstep ? 0 : 1);
			if(c.isBody) {
				var b = c.body;
				this.live.add(b);
				var cx_ite = b.arbiters.head;
				while(cx_ite != null) {
					var arb = cx_ite.elt;
					if(arb.sleeping) {
						arb.sleeping = false;
						arb.up_stamp += this.stamp - arb.sleep_stamp;
						if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
							var carb = arb.colarb;
							if(carb.stat) {
								var _this = this.c_arbiters_true;
								var ret;
								if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
									ret = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
								} else {
									ret = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret.next;
									ret.next = null;
								}
								ret.elt = carb;
								var temp = ret;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							} else {
								var _this1 = this.c_arbiters_false;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = carb;
								var temp1 = ret1;
								temp1.next = _this1.head;
								_this1.head = temp1;
								_this1.modified = true;
								_this1.length++;
							}
						} else if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
							var _this2 = this.f_arbiters;
							var o = arb.fluidarb;
							var ret2;
							if(zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool == null) {
								ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter();
							} else {
								ret2 = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = ret2.next;
								ret2.next = null;
							}
							ret2.elt = o;
							var temp2 = ret2;
							temp2.next = _this2.head;
							_this2.head = temp2;
							_this2.modified = true;
							_this2.length++;
						} else {
							var _this3 = this.s_arbiters;
							var o1 = arb.sensorarb;
							var ret3;
							if(zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool == null) {
								ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter();
							} else {
								ret3 = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = ret3.next;
								ret3.next = null;
							}
							ret3.elt = o1;
							var temp3 = ret3;
							temp3.next = _this3.head;
							_this3.head = temp3;
							_this3.modified = true;
							_this3.length++;
						}
					}
					cx_ite = cx_ite.next;
				}
				this.bodyCbWake(b);
				c.sleeping = false;
				c.island = null;
				c.parent = c;
				c.rank = 0;
				if(b.type != 1) {
					var cx_ite1 = b.shapes.head;
					while(cx_ite1 != null) {
						var shape = cx_ite1.elt;
						if(shape.node != null) {
							this.bphase.sync(shape);
						}
						cx_ite1 = cx_ite1.next;
					}
				}
			} else {
				var con = c.constraint;
				var _this4 = this.live_constraints;
				var ret4;
				if(zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool == null) {
					ret4 = new zpp_$nape_util_ZNPNode_$ZPP_$Constraint();
				} else {
					ret4 = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = ret4.next;
					ret4.next = null;
				}
				ret4.elt = con;
				var temp4 = ret4;
				temp4.next = _this4.head;
				_this4.head = temp4;
				_this4.modified = true;
				_this4.length++;
				this.constraintCbWake(con);
				c.sleeping = false;
				c.island = null;
				c.parent = c;
				c.rank = 0;
			}
		}
		var o = i;
		o.next = zpp_$nape_space_ZPP_$Island.zpp_pool;
		zpp_$nape_space_ZPP_$Island.zpp_pool = o;
	}
	,non_inlined_wake: function(o,fst) {
		if(fst == null) {
			fst = false;
		}
		var o1 = o;
		if(!o1.world) {
			o1.component.waket = this.stamp + (this.midstep ? 0 : 1);
			if(o1.type == 3) {
				o1.kinematicDelaySleep = true;
			}
			if(o1.component.sleeping) {
				this.really_wake(o1,fst);
			}
		}
	}
	,really_wake: function(o,fst) {
		if(fst == null) {
			fst = false;
		}
		if(o.component.island == null) {
			o.component.sleeping = false;
			if(o.type == 3 || o.type == 1) {
				var _this = this.staticsleep;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$Body();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = o;
				var temp = ret;
				temp.next = _this.head;
				_this.head = temp;
				_this.modified = true;
				_this.length++;
			} else {
				var _this = this.live;
				var ret;
				if(zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool == null) {
					ret = new zpp_$nape_util_ZNPNode_$ZPP_$Body();
				} else {
					ret = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = ret.next;
					ret.next = null;
				}
				ret.elt = o;
				var temp = ret;
				temp.next = _this.head;
				_this.head = temp;
				_this.modified = true;
				_this.length++;
			}
			var cx_ite = o.constraints.head;
			while(cx_ite != null) {
				var con = cx_ite.elt;
				if(con.space == this) {
					this.wake_constraint(con);
				}
				cx_ite = cx_ite.next;
			}
			var cx_ite = o.arbiters.head;
			while(cx_ite != null) {
				var arb = cx_ite.elt;
				if(arb.sleeping) {
					arb.sleeping = false;
					arb.up_stamp += this.stamp + (this.midstep ? 0 : 1) - arb.sleep_stamp;
					if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL) {
						var carb = arb.colarb;
						if(carb.stat) {
							var _this = this.c_arbiters_true;
							var ret;
							if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
								ret = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
							} else {
								ret = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.elt = carb;
							var temp = ret;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
						} else {
							var _this1 = this.c_arbiters_false;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = carb;
							var temp1 = ret1;
							temp1.next = _this1.head;
							_this1.head = temp1;
							_this1.modified = true;
							_this1.length++;
						}
					} else if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
						var _this2 = this.f_arbiters;
						var o1 = arb.fluidarb;
						var ret2;
						if(zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool == null) {
							ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter();
						} else {
							ret2 = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = ret2.next;
							ret2.next = null;
						}
						ret2.elt = o1;
						var temp2 = ret2;
						temp2.next = _this2.head;
						_this2.head = temp2;
						_this2.modified = true;
						_this2.length++;
					} else {
						var _this3 = this.s_arbiters;
						var o2 = arb.sensorarb;
						var ret3;
						if(zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool == null) {
							ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter();
						} else {
							ret3 = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = ret3.next;
							ret3.next = null;
						}
						ret3.elt = o2;
						var temp3 = ret3;
						temp3.next = _this3.head;
						_this3.head = temp3;
						_this3.modified = true;
						_this3.length++;
					}
				}
				if(arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR && !arb.cleared && arb.up_stamp >= this.stamp && (arb.immState & 1) != 0) {
					if(arb.b1.type == 2 && arb.b1.component.sleeping) {
						var o3 = arb.b1;
						if(!o3.world) {
							o3.component.waket = this.stamp + (this.midstep ? 0 : 1);
							if(o3.type == 3) {
								o3.kinematicDelaySleep = true;
							}
							if(o3.component.sleeping) {
								this.really_wake(o3,false);
							}
						}
					}
					if(arb.b2.type == 2 && arb.b2.component.sleeping) {
						var o4 = arb.b2;
						if(!o4.world) {
							o4.component.waket = this.stamp + (this.midstep ? 0 : 1);
							if(o4.type == 3) {
								o4.kinematicDelaySleep = true;
							}
							if(o4.component.sleeping) {
								this.really_wake(o4,false);
							}
						}
					}
				}
				cx_ite = cx_ite.next;
			}
			if(!fst && o.type == 2) {
				this.bodyCbWake(o);
			}
			if(!fst && !this.bphase.is_sweep && o.type != 1) {
				var cx_ite = o.shapes.head;
				while(cx_ite != null) {
					var shape = cx_ite.elt;
					if(shape.node != null) {
						this.bphase.sync(shape);
					}
					cx_ite = cx_ite.next;
				}
			}
		} else {
			this.wakeIsland(o.component.island);
		}
	}
	,wake_constraint: function(con,fst) {
		if(fst == null) {
			fst = false;
		}
		if(con.active) {
			con.component.waket = this.stamp + (this.midstep ? 0 : 1);
			if(con.component.sleeping) {
				if(con.component.island == null) {
					con.component.sleeping = false;
					var _this = this.live_constraints;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$Constraint();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = con;
					var temp = ret;
					temp.next = _this.head;
					_this.head = temp;
					_this.modified = true;
					_this.length++;
					con.wake_connected();
					if(!fst) {
						this.constraintCbWake(con);
					}
				} else {
					this.wakeIsland(con.component.island);
				}
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
	,doForests: function(dt) {
		var cx_ite = this.c_arbiters_false.head;
		while(cx_ite != null) {
			var arb = cx_ite.elt;
			if(!arb.cleared && arb.up_stamp == this.stamp && (arb.immState & 1) != 0) {
				if(arb.b1.type == 2 && arb.b2.type == 2) {
					var xr;
					if(arb.b1.component == arb.b1.component.parent) {
						xr = arb.b1.component;
					} else {
						var obj = arb.b1.component;
						var stack = null;
						while(obj != obj.parent) {
							var nxt = obj.parent;
							obj.parent = stack;
							stack = obj;
							obj = nxt;
						}
						while(stack != null) {
							var nxt1 = stack.parent;
							stack.parent = obj;
							stack = nxt1;
						}
						xr = obj;
					}
					var yr;
					if(arb.b2.component == arb.b2.component.parent) {
						yr = arb.b2.component;
					} else {
						var obj1 = arb.b2.component;
						var stack1 = null;
						while(obj1 != obj1.parent) {
							var nxt2 = obj1.parent;
							obj1.parent = stack1;
							stack1 = obj1;
							obj1 = nxt2;
						}
						while(stack1 != null) {
							var nxt3 = stack1.parent;
							stack1.parent = obj1;
							stack1 = nxt3;
						}
						yr = obj1;
					}
					if(xr != yr) {
						if(xr.rank < yr.rank) {
							xr.parent = yr;
						} else if(xr.rank > yr.rank) {
							yr.parent = xr;
						} else {
							yr.parent = xr;
							xr.rank++;
						}
					}
				}
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.f_arbiters.head;
		while(cx_ite != null) {
			var arb = cx_ite.elt;
			if(!arb.cleared && arb.up_stamp == this.stamp && (arb.immState & 1) != 0) {
				if(arb.b1.type == 2 && arb.b2.type == 2) {
					var xr;
					if(arb.b1.component == arb.b1.component.parent) {
						xr = arb.b1.component;
					} else {
						var obj = arb.b1.component;
						var stack = null;
						while(obj != obj.parent) {
							var nxt = obj.parent;
							obj.parent = stack;
							stack = obj;
							obj = nxt;
						}
						while(stack != null) {
							var nxt1 = stack.parent;
							stack.parent = obj;
							stack = nxt1;
						}
						xr = obj;
					}
					var yr;
					if(arb.b2.component == arb.b2.component.parent) {
						yr = arb.b2.component;
					} else {
						var obj1 = arb.b2.component;
						var stack1 = null;
						while(obj1 != obj1.parent) {
							var nxt2 = obj1.parent;
							obj1.parent = stack1;
							stack1 = obj1;
							obj1 = nxt2;
						}
						while(stack1 != null) {
							var nxt3 = stack1.parent;
							stack1.parent = obj1;
							stack1 = nxt3;
						}
						yr = obj1;
					}
					if(xr != yr) {
						if(xr.rank < yr.rank) {
							xr.parent = yr;
						} else if(xr.rank > yr.rank) {
							yr.parent = xr;
						} else {
							yr.parent = xr;
							xr.rank++;
						}
					}
				}
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.live_constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			con.forest();
			cx_ite = cx_ite.next;
		}
		while(this.live.head != null) {
			var _this = this.live;
			var ret = _this.head.elt;
			_this.pop();
			var o = ret;
			var oc = o.component;
			var root;
			if(oc == oc.parent) {
				root = oc;
			} else {
				var obj = oc;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt1 = stack.parent;
					stack.parent = obj;
					stack = nxt1;
				}
				root = obj;
			}
			if(root.island == null) {
				if(zpp_$nape_space_ZPP_$Island.zpp_pool == null) {
					root.island = new zpp_$nape_space_ZPP_$Island();
				} else {
					root.island = zpp_$nape_space_ZPP_$Island.zpp_pool;
					zpp_$nape_space_ZPP_$Island.zpp_pool = root.island.next;
					root.island.next = null;
				}
				root.island.waket = 0;
				var _this1 = this.islands;
				var o1 = root.island;
				o1._inuse = true;
				var temp = o1;
				temp.next = _this1.next;
				_this1.next = temp;
				_this1.modified = true;
				_this1.length++;
				root.island.sleep = true;
			}
			oc.island = root.island;
			var _this2 = oc.island.comps;
			var ret1;
			if(zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool == null) {
				ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Component();
			} else {
				ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.elt = oc;
			var temp1 = ret1;
			temp1.next = _this2.head;
			_this2.head = temp1;
			_this2.modified = true;
			_this2.length++;
			var rest = o.atRest(dt);
			oc.island.sleep = oc.island.sleep && rest;
			if(oc.waket > oc.island.waket) {
				oc.island.waket = oc.waket;
			}
		}
		while(this.live_constraints.head != null) {
			var _this = this.live_constraints;
			var ret = _this.head.elt;
			_this.pop();
			var o = ret;
			var oc = o.component;
			var root;
			if(oc == oc.parent) {
				root = oc;
			} else {
				var obj = oc;
				var stack = null;
				while(obj != obj.parent) {
					var nxt = obj.parent;
					obj.parent = stack;
					stack = obj;
					obj = nxt;
				}
				while(stack != null) {
					var nxt1 = stack.parent;
					stack.parent = obj;
					stack = nxt1;
				}
				root = obj;
			}
			oc.island = root.island;
			var _this1 = oc.island.comps;
			var ret1;
			if(zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool == null) {
				ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Component();
			} else {
				ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool = ret1.next;
				ret1.next = null;
			}
			ret1.elt = oc;
			var temp = ret1;
			temp.next = _this1.head;
			_this1.head = temp;
			_this1.modified = true;
			_this1.length++;
			if(oc.waket > oc.island.waket) {
				oc.island.waket = oc.waket;
			}
		}
		while(this.islands.next != null) {
			var _this = this.islands;
			var ret = _this.next;
			_this.pop();
			var i = ret;
			if(i.sleep) {
				var cx_ite = i.comps.head;
				while(cx_ite != null) {
					var c = cx_ite.elt;
					if(c.isBody) {
						var b = c.body;
						b.velx = 0;
						b.vely = 0;
						b.angvel = 0;
						c.sleeping = true;
						var cx_ite1 = b.shapes.head;
						while(cx_ite1 != null) {
							var shape = cx_ite1.elt;
							this.bphase.sync(shape);
							cx_ite1 = cx_ite1.next;
						}
						this.bodyCbSleep(b);
					} else {
						var con = c.constraint;
						this.constraintCbSleep(con);
						c.sleeping = true;
					}
					cx_ite = cx_ite.next;
				}
			} else {
				while(i.comps.head != null) {
					var _this1 = i.comps;
					var ret1 = _this1.head.elt;
					_this1.pop();
					var c1 = ret1;
					c1.waket = i.waket;
					if(c1.isBody) {
						var _this2 = this.live;
						var o = c1.body;
						var ret2;
						if(zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool == null) {
							ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$Body();
						} else {
							ret2 = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = ret2.next;
							ret2.next = null;
						}
						ret2.elt = o;
						var temp = ret2;
						temp.next = _this2.head;
						_this2.head = temp;
						_this2.modified = true;
						_this2.length++;
					} else {
						var _this3 = this.live_constraints;
						var o1 = c1.constraint;
						var ret3;
						if(zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool == null) {
							ret3 = new zpp_$nape_util_ZNPNode_$ZPP_$Constraint();
						} else {
							ret3 = zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Constraint.zpp_pool = ret3.next;
							ret3.next = null;
						}
						ret3.elt = o1;
						var temp1 = ret3;
						temp1.next = _this3.head;
						_this3.head = temp1;
						_this3.modified = true;
						_this3.length++;
					}
					c1.sleeping = false;
					c1.island = null;
					c1.parent = c1;
					c1.rank = 0;
				}
				var o2 = i;
				o2.next = zpp_$nape_space_ZPP_$Island.zpp_pool;
				zpp_$nape_space_ZPP_$Island.zpp_pool = o2;
			}
		}
	}
	,sleepArbiters: function() {
		var pre = null;
		var arbs = this.c_arbiters_true;
		var arbite = arbs.head;
		var fst = this.c_arbiters_false != null;
		if(fst && arbite == null) {
			fst = false;
			arbite = this.c_arbiters_false.head;
			arbs = this.c_arbiters_false;
			pre = null;
		}
		while(arbite != null) {
			var arb = arbite.elt;
			if(arb.b1.component.sleeping && arb.b2.component.sleeping) {
				arb.sleep_stamp = this.stamp;
				arb.sleeping = true;
				var old;
				var ret;
				if(pre == null) {
					old = arbs.head;
					ret = old.next;
					arbs.head = ret;
					if(arbs.head == null) {
						arbs.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						arbs.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = o;
				arbs.modified = true;
				arbs.length--;
				arbs.pushmod = true;
				arbite = ret;
				if(fst && arbite == null) {
					fst = false;
					arbite = this.c_arbiters_false.head;
					arbs = this.c_arbiters_false;
					pre = null;
				}
				continue;
			}
			pre = arbite;
			arbite = arbite.next;
			if(fst && arbite == null) {
				fst = false;
				arbite = this.c_arbiters_false.head;
				arbs = this.c_arbiters_false;
				pre = null;
			}
		}
		var pre = null;
		var arbs = this.f_arbiters;
		var arbite = arbs.head;
		var fst = false;
		if(fst && arbite == null) {
			fst = false;
			arbite = null.begin();
			arbs = null;
			pre = null;
		}
		while(arbite != null) {
			var arb = arbite.elt;
			if(arb.b1.component.sleeping && arb.b2.component.sleeping) {
				arb.sleep_stamp = this.stamp;
				arb.sleeping = true;
				var old;
				var ret;
				if(pre == null) {
					old = arbs.head;
					ret = old.next;
					arbs.head = ret;
					if(arbs.head == null) {
						arbs.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						arbs.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = o;
				arbs.modified = true;
				arbs.length--;
				arbs.pushmod = true;
				arbite = ret;
				if(fst && arbite == null) {
					fst = false;
					arbite = null.begin();
					arbs = null;
					pre = null;
				}
				continue;
			}
			pre = arbite;
			arbite = arbite.next;
			if(fst && arbite == null) {
				fst = false;
				arbite = null.begin();
				arbs = null;
				pre = null;
			}
		}
		var pre = null;
		var arbs = this.s_arbiters;
		var arbite = arbs.head;
		var fst = false;
		if(fst && arbite == null) {
			fst = false;
			arbite = null.begin();
			arbs = null;
			pre = null;
		}
		while(arbite != null) {
			var arb = arbite.elt;
			if(arb.b1.component.sleeping && arb.b2.component.sleeping) {
				arb.sleep_stamp = this.stamp;
				arb.sleeping = true;
				var old;
				var ret;
				if(pre == null) {
					old = arbs.head;
					ret = old.next;
					arbs.head = ret;
					if(arbs.head == null) {
						arbs.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						arbs.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = o;
				arbs.modified = true;
				arbs.length--;
				arbs.pushmod = true;
				arbite = ret;
				if(fst && arbite == null) {
					fst = false;
					arbite = null.begin();
					arbs = null;
					pre = null;
				}
				continue;
			}
			pre = arbite;
			arbite = arbite.next;
			if(fst && arbite == null) {
				fst = false;
				arbite = null.begin();
				arbs = null;
				pre = null;
			}
		}
	}
	,static_validation: function(body) {
		if(body.shapes.head != null) {
			if(body.zip_aabb) {
				body.zip_aabb = false;
				body.aabb.minx = Infinity;
				body.aabb.miny = Infinity;
				body.aabb.maxx = -Infinity;
				body.aabb.maxy = -Infinity;
				var cx_ite = body.shapes.head;
				while(cx_ite != null) {
					var s = cx_ite.elt;
					if(s.zip_aabb) {
						if(s.body != null) {
							s.zip_aabb = false;
							if(s.type == 0) {
								var _this = s.circle;
								if(_this.zip_worldCOM) {
									if(_this.body != null) {
										_this.zip_worldCOM = false;
										if(_this.zip_localCOM) {
											_this.zip_localCOM = false;
											if(_this.type == 1) {
												var _this1 = _this.polygon;
												if(_this1.lverts.next.next == null) {
													_this1.localCOMx = _this1.lverts.next.x;
													_this1.localCOMy = _this1.lverts.next.y;
												} else if(_this1.lverts.next.next.next == null) {
													_this1.localCOMx = _this1.lverts.next.x;
													_this1.localCOMy = _this1.lverts.next.y;
													var t = 1.0;
													_this1.localCOMx += _this1.lverts.next.next.x * t;
													_this1.localCOMy += _this1.lverts.next.next.y * t;
													var t1 = 0.5;
													_this1.localCOMx *= t1;
													_this1.localCOMy *= t1;
												} else {
													_this1.localCOMx = 0;
													_this1.localCOMy = 0;
													var area = 0.0;
													var cx_ite1 = _this1.lverts.next;
													var u = cx_ite1;
													cx_ite1 = cx_ite1.next;
													var v = cx_ite1;
													cx_ite1 = cx_ite1.next;
													while(cx_ite1 != null) {
														var w = cx_ite1;
														area += v.x * (w.y - u.y);
														var cf = w.y * v.x - w.x * v.y;
														_this1.localCOMx += (v.x + w.x) * cf;
														_this1.localCOMy += (v.y + w.y) * cf;
														u = v;
														v = w;
														cx_ite1 = cx_ite1.next;
													}
													cx_ite1 = _this1.lverts.next;
													var w1 = cx_ite1;
													area += v.x * (w1.y - u.y);
													var cf1 = w1.y * v.x - w1.x * v.y;
													_this1.localCOMx += (v.x + w1.x) * cf1;
													_this1.localCOMy += (v.y + w1.y) * cf1;
													u = v;
													v = w1;
													cx_ite1 = cx_ite1.next;
													var w2 = cx_ite1;
													area += v.x * (w2.y - u.y);
													var cf2 = w2.y * v.x - w2.x * v.y;
													_this1.localCOMx += (v.x + w2.x) * cf2;
													_this1.localCOMy += (v.y + w2.y) * cf2;
													area = 1 / (3 * area);
													var t2 = area;
													_this1.localCOMx *= t2;
													_this1.localCOMy *= t2;
												}
											}
											if(_this.wrap_localCOM != null) {
												_this.wrap_localCOM.zpp_inner.x = _this.localCOMx;
												_this.wrap_localCOM.zpp_inner.y = _this.localCOMy;
											}
										}
										var _this2 = _this.body;
										if(_this2.zip_axis) {
											_this2.zip_axis = false;
											_this2.axisx = Math.sin(_this2.rot);
											_this2.axisy = Math.cos(_this2.rot);
										}
										_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
										_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
									}
								}
								var rx = _this.radius;
								var ry = _this.radius;
								_this.aabb.minx = _this.worldCOMx - rx;
								_this.aabb.miny = _this.worldCOMy - ry;
								_this.aabb.maxx = _this.worldCOMx + rx;
								_this.aabb.maxy = _this.worldCOMy + ry;
							} else {
								var _this3 = s.polygon;
								if(_this3.zip_gverts) {
									if(_this3.body != null) {
										_this3.zip_gverts = false;
										_this3.validate_lverts();
										var _this4 = _this3.body;
										if(_this4.zip_axis) {
											_this4.zip_axis = false;
											_this4.axisx = Math.sin(_this4.rot);
											_this4.axisy = Math.cos(_this4.rot);
										}
										var li = _this3.lverts.next;
										var cx_ite2 = _this3.gverts.next;
										while(cx_ite2 != null) {
											var g = cx_ite2;
											var l = li;
											li = li.next;
											g.x = _this3.body.posx + (_this3.body.axisy * l.x - _this3.body.axisx * l.y);
											g.y = _this3.body.posy + (l.x * _this3.body.axisx + l.y * _this3.body.axisy);
											cx_ite2 = cx_ite2.next;
										}
									}
								}
								var p0 = _this3.gverts.next;
								_this3.aabb.minx = p0.x;
								_this3.aabb.miny = p0.y;
								_this3.aabb.maxx = p0.x;
								_this3.aabb.maxy = p0.y;
								var cx_ite3 = _this3.gverts.next.next;
								while(cx_ite3 != null) {
									var p = cx_ite3;
									if(p.x < _this3.aabb.minx) {
										_this3.aabb.minx = p.x;
									}
									if(p.x > _this3.aabb.maxx) {
										_this3.aabb.maxx = p.x;
									}
									if(p.y < _this3.aabb.miny) {
										_this3.aabb.miny = p.y;
									}
									if(p.y > _this3.aabb.maxy) {
										_this3.aabb.maxy = p.y;
									}
									cx_ite3 = cx_ite3.next;
								}
							}
						}
					}
					var _this5 = body.aabb;
					var x = s.aabb;
					if(x.minx < _this5.minx) {
						_this5.minx = x.minx;
					}
					if(x.maxx > _this5.maxx) {
						_this5.maxx = x.maxx;
					}
					if(x.miny < _this5.miny) {
						_this5.miny = x.miny;
					}
					if(x.maxy > _this5.maxy) {
						_this5.maxy = x.maxy;
					}
					cx_ite = cx_ite.next;
				}
			}
		}
		body.validate_mass();
		body.validate_inertia();
		var cx_ite = body.shapes.head;
		while(cx_ite != null) {
			var s = cx_ite.elt;
			if(s.type == 1) {
				var _this = s.polygon;
				if(_this.zip_sanitation) {
					_this.zip_sanitation = false;
					_this.splice_collinear_real();
				}
				var _this1 = s.polygon;
				if(_this1.zip_gaxi) {
					if(_this1.body != null) {
						_this1.zip_gaxi = false;
						_this1.validate_laxi();
						var _this2 = _this1.body;
						if(_this2.zip_axis) {
							_this2.zip_axis = false;
							_this2.axisx = Math.sin(_this2.rot);
							_this2.axisy = Math.cos(_this2.rot);
						}
						if(_this1.zip_gverts) {
							if(_this1.body != null) {
								_this1.zip_gverts = false;
								_this1.validate_lverts();
								var _this3 = _this1.body;
								if(_this3.zip_axis) {
									_this3.zip_axis = false;
									_this3.axisx = Math.sin(_this3.rot);
									_this3.axisy = Math.cos(_this3.rot);
								}
								var li = _this1.lverts.next;
								var cx_ite1 = _this1.gverts.next;
								while(cx_ite1 != null) {
									var g = cx_ite1;
									var l = li;
									li = li.next;
									g.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
									g.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
									cx_ite1 = cx_ite1.next;
								}
							}
						}
						var ite = _this1.edges.head;
						var cx_ite2 = _this1.gverts.next;
						var u = cx_ite2;
						cx_ite2 = cx_ite2.next;
						while(cx_ite2 != null) {
							var v = cx_ite2;
							var e = ite.elt;
							ite = ite.next;
							e.gp0 = u;
							e.gp1 = v;
							e.gnormx = _this1.body.axisy * e.lnormx - _this1.body.axisx * e.lnormy;
							e.gnormy = e.lnormx * _this1.body.axisx + e.lnormy * _this1.body.axisy;
							e.gprojection = _this1.body.posx * e.gnormx + _this1.body.posy * e.gnormy + e.lprojection;
							if(e.wrap_gnorm != null) {
								e.wrap_gnorm.zpp_inner.x = e.gnormx;
								e.wrap_gnorm.zpp_inner.y = e.gnormy;
							}
							e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
							e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
							u = v;
							cx_ite2 = cx_ite2.next;
						}
						var v1 = _this1.gverts.next;
						var e1 = ite.elt;
						ite = ite.next;
						e1.gp0 = u;
						e1.gp1 = v1;
						e1.gnormx = _this1.body.axisy * e1.lnormx - _this1.body.axisx * e1.lnormy;
						e1.gnormy = e1.lnormx * _this1.body.axisx + e1.lnormy * _this1.body.axisy;
						e1.gprojection = _this1.body.posx * e1.gnormx + _this1.body.posy * e1.gnormy + e1.lprojection;
						if(e1.wrap_gnorm != null) {
							e1.wrap_gnorm.zpp_inner.x = e1.gnormx;
							e1.wrap_gnorm.zpp_inner.y = e1.gnormy;
						}
						e1.tp0 = e1.gp0.y * e1.gnormx - e1.gp0.x * e1.gnormy;
						e1.tp1 = e1.gp1.y * e1.gnormx - e1.gp1.x * e1.gnormy;
					}
				}
			}
			cx_ite = cx_ite.next;
		}
		body.sweepFrozen = true;
	}
	,validation: function() {
		var _this = this.cbsets;
		if(!_this.cbsets.empty()) {
			var set_ite = _this.cbsets.parent;
			while(set_ite.prev != null) set_ite = set_ite.prev;
			while(set_ite != null) {
				var cb = set_ite.data;
				cb.validate();
				if(set_ite.next != null) {
					set_ite = set_ite.next;
					while(set_ite.prev != null) set_ite = set_ite.prev;
				} else {
					while(set_ite.parent != null && set_ite == set_ite.parent.next) set_ite = set_ite.parent;
					set_ite = set_ite.parent;
				}
			}
		}
		var cx_ite = this.live.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			cur.sweepRadius = 0;
			var cx_ite1 = cur.shapes.head;
			while(cx_ite1 != null) {
				var s = cx_ite1.elt;
				if(s.type == 1) {
					var _this = s.polygon;
					if(_this.zip_sanitation) {
						_this.zip_sanitation = false;
						_this.splice_collinear_real();
					}
					var _this1 = s.polygon;
					if(_this1.zip_gaxi) {
						if(_this1.body != null) {
							_this1.zip_gaxi = false;
							_this1.validate_laxi();
							var _this2 = _this1.body;
							if(_this2.zip_axis) {
								_this2.zip_axis = false;
								_this2.axisx = Math.sin(_this2.rot);
								_this2.axisy = Math.cos(_this2.rot);
							}
							if(_this1.zip_gverts) {
								if(_this1.body != null) {
									_this1.zip_gverts = false;
									_this1.validate_lverts();
									var _this3 = _this1.body;
									if(_this3.zip_axis) {
										_this3.zip_axis = false;
										_this3.axisx = Math.sin(_this3.rot);
										_this3.axisy = Math.cos(_this3.rot);
									}
									var li = _this1.lverts.next;
									var cx_ite2 = _this1.gverts.next;
									while(cx_ite2 != null) {
										var g = cx_ite2;
										var l = li;
										li = li.next;
										g.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
										g.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
										cx_ite2 = cx_ite2.next;
									}
								}
							}
							var ite = _this1.edges.head;
							var cx_ite3 = _this1.gverts.next;
							var u = cx_ite3;
							cx_ite3 = cx_ite3.next;
							while(cx_ite3 != null) {
								var v = cx_ite3;
								var e = ite.elt;
								ite = ite.next;
								e.gp0 = u;
								e.gp1 = v;
								e.gnormx = _this1.body.axisy * e.lnormx - _this1.body.axisx * e.lnormy;
								e.gnormy = e.lnormx * _this1.body.axisx + e.lnormy * _this1.body.axisy;
								e.gprojection = _this1.body.posx * e.gnormx + _this1.body.posy * e.gnormy + e.lprojection;
								if(e.wrap_gnorm != null) {
									e.wrap_gnorm.zpp_inner.x = e.gnormx;
									e.wrap_gnorm.zpp_inner.y = e.gnormy;
								}
								e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
								e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
								u = v;
								cx_ite3 = cx_ite3.next;
							}
							var v1 = _this1.gverts.next;
							var e1 = ite.elt;
							ite = ite.next;
							e1.gp0 = u;
							e1.gp1 = v1;
							e1.gnormx = _this1.body.axisy * e1.lnormx - _this1.body.axisx * e1.lnormy;
							e1.gnormy = e1.lnormx * _this1.body.axisx + e1.lnormy * _this1.body.axisy;
							e1.gprojection = _this1.body.posx * e1.gnormx + _this1.body.posy * e1.gnormy + e1.lprojection;
							if(e1.wrap_gnorm != null) {
								e1.wrap_gnorm.zpp_inner.x = e1.gnormx;
								e1.wrap_gnorm.zpp_inner.y = e1.gnormy;
							}
							e1.tp0 = e1.gp0.y * e1.gnormx - e1.gp0.x * e1.gnormy;
							e1.tp1 = e1.gp1.y * e1.gnormx - e1.gp1.x * e1.gnormy;
						}
					}
				}
				s.validate_sweepRadius();
				if(s.sweepRadius > cur.sweepRadius) {
					cur.sweepRadius = s.sweepRadius;
				}
				cx_ite1 = cx_ite1.next;
			}
			cur.validate_mass();
			cur.validate_inertia();
			if(cur.shapes.head != null) {
				if(cur.zip_aabb) {
					cur.zip_aabb = false;
					cur.aabb.minx = Infinity;
					cur.aabb.miny = Infinity;
					cur.aabb.maxx = -Infinity;
					cur.aabb.maxy = -Infinity;
					var cx_ite4 = cur.shapes.head;
					while(cx_ite4 != null) {
						var s1 = cx_ite4.elt;
						if(s1.zip_aabb) {
							if(s1.body != null) {
								s1.zip_aabb = false;
								if(s1.type == 0) {
									var _this4 = s1.circle;
									if(_this4.zip_worldCOM) {
										if(_this4.body != null) {
											_this4.zip_worldCOM = false;
											if(_this4.zip_localCOM) {
												_this4.zip_localCOM = false;
												if(_this4.type == 1) {
													var _this5 = _this4.polygon;
													if(_this5.lverts.next.next == null) {
														_this5.localCOMx = _this5.lverts.next.x;
														_this5.localCOMy = _this5.lverts.next.y;
													} else if(_this5.lverts.next.next.next == null) {
														_this5.localCOMx = _this5.lverts.next.x;
														_this5.localCOMy = _this5.lverts.next.y;
														var t = 1.0;
														_this5.localCOMx += _this5.lverts.next.next.x * t;
														_this5.localCOMy += _this5.lverts.next.next.y * t;
														var t1 = 0.5;
														_this5.localCOMx *= t1;
														_this5.localCOMy *= t1;
													} else {
														_this5.localCOMx = 0;
														_this5.localCOMy = 0;
														var area = 0.0;
														var cx_ite5 = _this5.lverts.next;
														var u1 = cx_ite5;
														cx_ite5 = cx_ite5.next;
														var v2 = cx_ite5;
														cx_ite5 = cx_ite5.next;
														while(cx_ite5 != null) {
															var w = cx_ite5;
															area += v2.x * (w.y - u1.y);
															var cf = w.y * v2.x - w.x * v2.y;
															_this5.localCOMx += (v2.x + w.x) * cf;
															_this5.localCOMy += (v2.y + w.y) * cf;
															u1 = v2;
															v2 = w;
															cx_ite5 = cx_ite5.next;
														}
														cx_ite5 = _this5.lverts.next;
														var w1 = cx_ite5;
														area += v2.x * (w1.y - u1.y);
														var cf1 = w1.y * v2.x - w1.x * v2.y;
														_this5.localCOMx += (v2.x + w1.x) * cf1;
														_this5.localCOMy += (v2.y + w1.y) * cf1;
														u1 = v2;
														v2 = w1;
														cx_ite5 = cx_ite5.next;
														var w2 = cx_ite5;
														area += v2.x * (w2.y - u1.y);
														var cf2 = w2.y * v2.x - w2.x * v2.y;
														_this5.localCOMx += (v2.x + w2.x) * cf2;
														_this5.localCOMy += (v2.y + w2.y) * cf2;
														area = 1 / (3 * area);
														var t2 = area;
														_this5.localCOMx *= t2;
														_this5.localCOMy *= t2;
													}
												}
												if(_this4.wrap_localCOM != null) {
													_this4.wrap_localCOM.zpp_inner.x = _this4.localCOMx;
													_this4.wrap_localCOM.zpp_inner.y = _this4.localCOMy;
												}
											}
											var _this6 = _this4.body;
											if(_this6.zip_axis) {
												_this6.zip_axis = false;
												_this6.axisx = Math.sin(_this6.rot);
												_this6.axisy = Math.cos(_this6.rot);
											}
											_this4.worldCOMx = _this4.body.posx + (_this4.body.axisy * _this4.localCOMx - _this4.body.axisx * _this4.localCOMy);
											_this4.worldCOMy = _this4.body.posy + (_this4.localCOMx * _this4.body.axisx + _this4.localCOMy * _this4.body.axisy);
										}
									}
									var rx = _this4.radius;
									var ry = _this4.radius;
									_this4.aabb.minx = _this4.worldCOMx - rx;
									_this4.aabb.miny = _this4.worldCOMy - ry;
									_this4.aabb.maxx = _this4.worldCOMx + rx;
									_this4.aabb.maxy = _this4.worldCOMy + ry;
								} else {
									var _this7 = s1.polygon;
									if(_this7.zip_gverts) {
										if(_this7.body != null) {
											_this7.zip_gverts = false;
											_this7.validate_lverts();
											var _this8 = _this7.body;
											if(_this8.zip_axis) {
												_this8.zip_axis = false;
												_this8.axisx = Math.sin(_this8.rot);
												_this8.axisy = Math.cos(_this8.rot);
											}
											var li1 = _this7.lverts.next;
											var cx_ite6 = _this7.gverts.next;
											while(cx_ite6 != null) {
												var g1 = cx_ite6;
												var l1 = li1;
												li1 = li1.next;
												g1.x = _this7.body.posx + (_this7.body.axisy * l1.x - _this7.body.axisx * l1.y);
												g1.y = _this7.body.posy + (l1.x * _this7.body.axisx + l1.y * _this7.body.axisy);
												cx_ite6 = cx_ite6.next;
											}
										}
									}
									var p0 = _this7.gverts.next;
									_this7.aabb.minx = p0.x;
									_this7.aabb.miny = p0.y;
									_this7.aabb.maxx = p0.x;
									_this7.aabb.maxy = p0.y;
									var cx_ite7 = _this7.gverts.next.next;
									while(cx_ite7 != null) {
										var p = cx_ite7;
										if(p.x < _this7.aabb.minx) {
											_this7.aabb.minx = p.x;
										}
										if(p.x > _this7.aabb.maxx) {
											_this7.aabb.maxx = p.x;
										}
										if(p.y < _this7.aabb.miny) {
											_this7.aabb.miny = p.y;
										}
										if(p.y > _this7.aabb.maxy) {
											_this7.aabb.maxy = p.y;
										}
										cx_ite7 = cx_ite7.next;
									}
								}
							}
						}
						var _this9 = cur.aabb;
						var x = s1.aabb;
						if(x.minx < _this9.minx) {
							_this9.minx = x.minx;
						}
						if(x.maxx > _this9.maxx) {
							_this9.maxx = x.maxx;
						}
						if(x.miny < _this9.miny) {
							_this9.miny = x.miny;
						}
						if(x.maxy > _this9.maxy) {
							_this9.maxy = x.maxy;
						}
						cx_ite4 = cx_ite4.next;
					}
				}
				cur.validate_worldCOM();
			}
			cur.validate_gravMass();
			if(cur.zip_axis) {
				cur.zip_axis = false;
				cur.axisx = Math.sin(cur.rot);
				cur.axisy = Math.cos(cur.rot);
			}
			if(cur.component.woken && cur.cbSet != null) {
				var cx_ite8 = cur.cbSet.bodylisteners.head;
				while(cx_ite8 != null) {
					var i = cx_ite8.elt;
					if(i.event != 2) {
						cx_ite8 = cx_ite8.next;
						continue;
					}
					var cb = this.push_callback(i);
					cb.event = 2;
					cb.body = cur;
					cx_ite8 = cx_ite8.next;
				}
			}
			cur.component.woken = false;
			var cx_ite9 = cur.shapes.head;
			while(cx_ite9 != null) {
				var shape = cx_ite9.elt;
				this.bphase.sync(shape);
				cx_ite9 = cx_ite9.next;
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.kinematics.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			cur.sweepRadius = 0;
			var cx_ite1 = cur.shapes.head;
			while(cx_ite1 != null) {
				var s = cx_ite1.elt;
				if(s.type == 1) {
					var _this = s.polygon;
					if(_this.zip_sanitation) {
						_this.zip_sanitation = false;
						_this.splice_collinear_real();
					}
					var _this1 = s.polygon;
					if(_this1.zip_gaxi) {
						if(_this1.body != null) {
							_this1.zip_gaxi = false;
							_this1.validate_laxi();
							var _this2 = _this1.body;
							if(_this2.zip_axis) {
								_this2.zip_axis = false;
								_this2.axisx = Math.sin(_this2.rot);
								_this2.axisy = Math.cos(_this2.rot);
							}
							if(_this1.zip_gverts) {
								if(_this1.body != null) {
									_this1.zip_gverts = false;
									_this1.validate_lverts();
									var _this3 = _this1.body;
									if(_this3.zip_axis) {
										_this3.zip_axis = false;
										_this3.axisx = Math.sin(_this3.rot);
										_this3.axisy = Math.cos(_this3.rot);
									}
									var li = _this1.lverts.next;
									var cx_ite2 = _this1.gverts.next;
									while(cx_ite2 != null) {
										var g = cx_ite2;
										var l = li;
										li = li.next;
										g.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
										g.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
										cx_ite2 = cx_ite2.next;
									}
								}
							}
							var ite = _this1.edges.head;
							var cx_ite3 = _this1.gverts.next;
							var u = cx_ite3;
							cx_ite3 = cx_ite3.next;
							while(cx_ite3 != null) {
								var v = cx_ite3;
								var e = ite.elt;
								ite = ite.next;
								e.gp0 = u;
								e.gp1 = v;
								e.gnormx = _this1.body.axisy * e.lnormx - _this1.body.axisx * e.lnormy;
								e.gnormy = e.lnormx * _this1.body.axisx + e.lnormy * _this1.body.axisy;
								e.gprojection = _this1.body.posx * e.gnormx + _this1.body.posy * e.gnormy + e.lprojection;
								if(e.wrap_gnorm != null) {
									e.wrap_gnorm.zpp_inner.x = e.gnormx;
									e.wrap_gnorm.zpp_inner.y = e.gnormy;
								}
								e.tp0 = e.gp0.y * e.gnormx - e.gp0.x * e.gnormy;
								e.tp1 = e.gp1.y * e.gnormx - e.gp1.x * e.gnormy;
								u = v;
								cx_ite3 = cx_ite3.next;
							}
							var v1 = _this1.gverts.next;
							var e1 = ite.elt;
							ite = ite.next;
							e1.gp0 = u;
							e1.gp1 = v1;
							e1.gnormx = _this1.body.axisy * e1.lnormx - _this1.body.axisx * e1.lnormy;
							e1.gnormy = e1.lnormx * _this1.body.axisx + e1.lnormy * _this1.body.axisy;
							e1.gprojection = _this1.body.posx * e1.gnormx + _this1.body.posy * e1.gnormy + e1.lprojection;
							if(e1.wrap_gnorm != null) {
								e1.wrap_gnorm.zpp_inner.x = e1.gnormx;
								e1.wrap_gnorm.zpp_inner.y = e1.gnormy;
							}
							e1.tp0 = e1.gp0.y * e1.gnormx - e1.gp0.x * e1.gnormy;
							e1.tp1 = e1.gp1.y * e1.gnormx - e1.gp1.x * e1.gnormy;
						}
					}
				}
				s.validate_sweepRadius();
				if(s.sweepRadius > cur.sweepRadius) {
					cur.sweepRadius = s.sweepRadius;
				}
				cx_ite1 = cx_ite1.next;
			}
			cur.validate_mass();
			cur.validate_inertia();
			if(cur.shapes.head != null) {
				if(cur.zip_aabb) {
					cur.zip_aabb = false;
					cur.aabb.minx = Infinity;
					cur.aabb.miny = Infinity;
					cur.aabb.maxx = -Infinity;
					cur.aabb.maxy = -Infinity;
					var cx_ite4 = cur.shapes.head;
					while(cx_ite4 != null) {
						var s1 = cx_ite4.elt;
						if(s1.zip_aabb) {
							if(s1.body != null) {
								s1.zip_aabb = false;
								if(s1.type == 0) {
									var _this4 = s1.circle;
									if(_this4.zip_worldCOM) {
										if(_this4.body != null) {
											_this4.zip_worldCOM = false;
											if(_this4.zip_localCOM) {
												_this4.zip_localCOM = false;
												if(_this4.type == 1) {
													var _this5 = _this4.polygon;
													if(_this5.lverts.next.next == null) {
														_this5.localCOMx = _this5.lverts.next.x;
														_this5.localCOMy = _this5.lverts.next.y;
													} else if(_this5.lverts.next.next.next == null) {
														_this5.localCOMx = _this5.lverts.next.x;
														_this5.localCOMy = _this5.lverts.next.y;
														var t = 1.0;
														_this5.localCOMx += _this5.lverts.next.next.x * t;
														_this5.localCOMy += _this5.lverts.next.next.y * t;
														var t1 = 0.5;
														_this5.localCOMx *= t1;
														_this5.localCOMy *= t1;
													} else {
														_this5.localCOMx = 0;
														_this5.localCOMy = 0;
														var area = 0.0;
														var cx_ite5 = _this5.lverts.next;
														var u1 = cx_ite5;
														cx_ite5 = cx_ite5.next;
														var v2 = cx_ite5;
														cx_ite5 = cx_ite5.next;
														while(cx_ite5 != null) {
															var w = cx_ite5;
															area += v2.x * (w.y - u1.y);
															var cf = w.y * v2.x - w.x * v2.y;
															_this5.localCOMx += (v2.x + w.x) * cf;
															_this5.localCOMy += (v2.y + w.y) * cf;
															u1 = v2;
															v2 = w;
															cx_ite5 = cx_ite5.next;
														}
														cx_ite5 = _this5.lverts.next;
														var w1 = cx_ite5;
														area += v2.x * (w1.y - u1.y);
														var cf1 = w1.y * v2.x - w1.x * v2.y;
														_this5.localCOMx += (v2.x + w1.x) * cf1;
														_this5.localCOMy += (v2.y + w1.y) * cf1;
														u1 = v2;
														v2 = w1;
														cx_ite5 = cx_ite5.next;
														var w2 = cx_ite5;
														area += v2.x * (w2.y - u1.y);
														var cf2 = w2.y * v2.x - w2.x * v2.y;
														_this5.localCOMx += (v2.x + w2.x) * cf2;
														_this5.localCOMy += (v2.y + w2.y) * cf2;
														area = 1 / (3 * area);
														var t2 = area;
														_this5.localCOMx *= t2;
														_this5.localCOMy *= t2;
													}
												}
												if(_this4.wrap_localCOM != null) {
													_this4.wrap_localCOM.zpp_inner.x = _this4.localCOMx;
													_this4.wrap_localCOM.zpp_inner.y = _this4.localCOMy;
												}
											}
											var _this6 = _this4.body;
											if(_this6.zip_axis) {
												_this6.zip_axis = false;
												_this6.axisx = Math.sin(_this6.rot);
												_this6.axisy = Math.cos(_this6.rot);
											}
											_this4.worldCOMx = _this4.body.posx + (_this4.body.axisy * _this4.localCOMx - _this4.body.axisx * _this4.localCOMy);
											_this4.worldCOMy = _this4.body.posy + (_this4.localCOMx * _this4.body.axisx + _this4.localCOMy * _this4.body.axisy);
										}
									}
									var rx = _this4.radius;
									var ry = _this4.radius;
									_this4.aabb.minx = _this4.worldCOMx - rx;
									_this4.aabb.miny = _this4.worldCOMy - ry;
									_this4.aabb.maxx = _this4.worldCOMx + rx;
									_this4.aabb.maxy = _this4.worldCOMy + ry;
								} else {
									var _this7 = s1.polygon;
									if(_this7.zip_gverts) {
										if(_this7.body != null) {
											_this7.zip_gverts = false;
											_this7.validate_lverts();
											var _this8 = _this7.body;
											if(_this8.zip_axis) {
												_this8.zip_axis = false;
												_this8.axisx = Math.sin(_this8.rot);
												_this8.axisy = Math.cos(_this8.rot);
											}
											var li1 = _this7.lverts.next;
											var cx_ite6 = _this7.gverts.next;
											while(cx_ite6 != null) {
												var g1 = cx_ite6;
												var l1 = li1;
												li1 = li1.next;
												g1.x = _this7.body.posx + (_this7.body.axisy * l1.x - _this7.body.axisx * l1.y);
												g1.y = _this7.body.posy + (l1.x * _this7.body.axisx + l1.y * _this7.body.axisy);
												cx_ite6 = cx_ite6.next;
											}
										}
									}
									var p0 = _this7.gverts.next;
									_this7.aabb.minx = p0.x;
									_this7.aabb.miny = p0.y;
									_this7.aabb.maxx = p0.x;
									_this7.aabb.maxy = p0.y;
									var cx_ite7 = _this7.gverts.next.next;
									while(cx_ite7 != null) {
										var p = cx_ite7;
										if(p.x < _this7.aabb.minx) {
											_this7.aabb.minx = p.x;
										}
										if(p.x > _this7.aabb.maxx) {
											_this7.aabb.maxx = p.x;
										}
										if(p.y < _this7.aabb.miny) {
											_this7.aabb.miny = p.y;
										}
										if(p.y > _this7.aabb.maxy) {
											_this7.aabb.maxy = p.y;
										}
										cx_ite7 = cx_ite7.next;
									}
								}
							}
						}
						var _this9 = cur.aabb;
						var x = s1.aabb;
						if(x.minx < _this9.minx) {
							_this9.minx = x.minx;
						}
						if(x.maxx > _this9.maxx) {
							_this9.maxx = x.maxx;
						}
						if(x.miny < _this9.miny) {
							_this9.miny = x.miny;
						}
						if(x.maxy > _this9.maxy) {
							_this9.maxy = x.maxy;
						}
						cx_ite4 = cx_ite4.next;
					}
				}
				cur.validate_worldCOM();
			}
			cur.validate_gravMass();
			if(cur.zip_axis) {
				cur.zip_axis = false;
				cur.axisx = Math.sin(cur.rot);
				cur.axisy = Math.cos(cur.rot);
			}
			var cx_ite8 = cur.shapes.head;
			while(cx_ite8 != null) {
				var shape = cx_ite8.elt;
				this.bphase.sync(shape);
				cx_ite8 = cx_ite8.next;
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.live_constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			if(con.active) {
				if(con.component.woken && con.cbSet != null) {
					var cx_ite1 = con.cbSet.conlisteners.head;
					while(cx_ite1 != null) {
						var i = cx_ite1.elt;
						if(i.event != 2) {
							cx_ite1 = cx_ite1.next;
							continue;
						}
						var cb = this.push_callback(i);
						cb.event = 2;
						cb.constraint = con;
						cx_ite1 = cx_ite1.next;
					}
				}
				con.component.woken = false;
			}
			cx_ite = cx_ite.next;
		}
	}
	,updateVel: function(dt) {
		var pre = null;
		var linDrag = 1 - dt * this.global_lin_drag;
		var angDrag = 1 - dt * this.global_ang_drag;
		var cx_ite = this.live.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			if(cur.smass != 0.0) {
				var time = dt * cur.imass;
				cur.velx = linDrag * cur.velx + (cur.forcex + this.gravityx * cur.gravMass) * time;
				cur.vely = linDrag * cur.vely + (cur.forcey + this.gravityy * cur.gravMass) * time;
			}
			if(cur.sinertia != 0.0) {
				var dpx = 0.0;
				var dpy = 0.0;
				dpx = cur.worldCOMx - cur.posx;
				dpy = cur.worldCOMy - cur.posy;
				var torque = cur.torque + (this.gravityy * dpx - this.gravityx * dpy) * cur.gravMass;
				cur.angvel = angDrag * cur.angvel + torque * dt * cur.iinertia;
			}
			pre = cx_ite;
			cx_ite = cx_ite.next;
		}
	}
	,updatePos: function(dt) {
		var MAX_VEL = 2 * Math.PI / dt;
		var cx_ite = this.live.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			cur.pre_posx = cur.posx;
			cur.pre_posy = cur.posy;
			cur.pre_rot = cur.rot;
			cur.sweepTime = 0;
			cur.sweep_angvel = cur.angvel % MAX_VEL;
			var delta = dt - cur.sweepTime;
			if(delta != 0) {
				cur.sweepTime = dt;
				var t = delta;
				cur.posx += cur.velx * t;
				cur.posy += cur.vely * t;
				if(cur.angvel != 0) {
					var dr = cur.sweep_angvel * delta;
					cur.rot += dr;
					if(dr * dr > 0.0001) {
						cur.axisx = Math.sin(cur.rot);
						cur.axisy = Math.cos(cur.rot);
					} else {
						var d2 = dr * dr;
						var p = 1 - 0.5 * d2;
						var m = 1 - d2 * d2 / 8;
						var nx = (p * cur.axisx + dr * cur.axisy) * m;
						cur.axisy = (p * cur.axisy - dr * cur.axisx) * m;
						cur.axisx = nx;
					}
				}
			}
			if(!cur.disableCCD) {
				var linThreshold = nape_Config.staticCCDLinearThreshold * cur.sweepRadius;
				var angThreshold = nape_Config.staticCCDAngularThreshold;
				if((cur.velx * cur.velx + cur.vely * cur.vely) * dt * dt > linThreshold * linThreshold || cur.angvel * cur.angvel * dt * dt > angThreshold * angThreshold || cur.type == 3) {
					var angvel = cur.sweep_angvel;
					if(angvel < 0) {
						angvel = -angvel;
					}
					var iangvel = 1 / angvel;
					var cx_ite1 = cur.shapes.head;
					while(cx_ite1 != null) {
						var s = cx_ite1.elt;
						var aabb = s.aabb;
						var minx = aabb.minx;
						var miny = aabb.miny;
						var maxx = aabb.maxx;
						var maxy = aabb.maxy;
						var count = angvel * dt * s.sweepCoef * 0.00833333333333333322 | 0;
						if(count > 8) {
							count = 8;
						}
						var anginc = angvel * dt / count;
						var delta1 = dt - cur.sweepTime;
						if(delta1 != 0) {
							cur.sweepTime = dt;
							var t1 = delta1;
							cur.posx += cur.velx * t1;
							cur.posy += cur.vely * t1;
							if(cur.angvel != 0) {
								var dr1 = cur.sweep_angvel * delta1;
								cur.rot += dr1;
								if(dr1 * dr1 > 0.0001) {
									cur.axisx = Math.sin(cur.rot);
									cur.axisy = Math.cos(cur.rot);
								} else {
									var d21 = dr1 * dr1;
									var p1 = 1 - 0.5 * d21;
									var m1 = 1 - d21 * d21 / 8;
									var nx1 = (p1 * cur.axisx + dr1 * cur.axisy) * m1;
									cur.axisy = (p1 * cur.axisy - dr1 * cur.axisx) * m1;
									cur.axisx = nx1;
								}
							}
						}
						if(s.type == 0) {
							var _this = s.circle;
							_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
							_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
							_this.aabb.minx = _this.worldCOMx - _this.radius;
							_this.aabb.miny = _this.worldCOMy - _this.radius;
							_this.aabb.maxx = _this.worldCOMx + _this.radius;
							_this.aabb.maxy = _this.worldCOMy + _this.radius;
						} else {
							var _this1 = s.polygon;
							var li = _this1.lverts.next;
							var p0 = _this1.gverts.next;
							var l = li;
							li = li.next;
							p0.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
							p0.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
							_this1.aabb.minx = p0.x;
							_this1.aabb.miny = p0.y;
							_this1.aabb.maxx = p0.x;
							_this1.aabb.maxy = p0.y;
							var cx_ite2 = _this1.gverts.next.next;
							while(cx_ite2 != null) {
								var p2 = cx_ite2;
								var l1 = li;
								li = li.next;
								p2.x = _this1.body.posx + (_this1.body.axisy * l1.x - _this1.body.axisx * l1.y);
								p2.y = _this1.body.posy + (l1.x * _this1.body.axisx + l1.y * _this1.body.axisy);
								if(p2.x < _this1.aabb.minx) {
									_this1.aabb.minx = p2.x;
								}
								if(p2.x > _this1.aabb.maxx) {
									_this1.aabb.maxx = p2.x;
								}
								if(p2.y < _this1.aabb.miny) {
									_this1.aabb.miny = p2.y;
								}
								if(p2.y > _this1.aabb.maxy) {
									_this1.aabb.maxy = p2.y;
								}
								cx_ite2 = cx_ite2.next;
							}
						}
						if(minx < aabb.minx) {
							aabb.minx = minx;
						} else {
							minx = aabb.minx;
						}
						if(miny < aabb.miny) {
							aabb.miny = miny;
						} else {
							miny = aabb.miny;
						}
						if(maxx > aabb.maxx) {
							aabb.maxx = maxx;
						} else {
							maxx = aabb.maxx;
						}
						if(maxy > aabb.maxy) {
							aabb.maxy = maxy;
						} else {
							maxy = aabb.maxy;
						}
						var _g = 1;
						var _g1 = count;
						while(_g < _g1) {
							var i = _g++;
							var dt1 = anginc * i * iangvel;
							var delta2 = dt1 - cur.sweepTime;
							if(delta2 != 0) {
								cur.sweepTime = dt1;
								var t2 = delta2;
								cur.posx += cur.velx * t2;
								cur.posy += cur.vely * t2;
								if(cur.angvel != 0) {
									var dr2 = cur.sweep_angvel * delta2;
									cur.rot += dr2;
									if(dr2 * dr2 > 0.0001) {
										cur.axisx = Math.sin(cur.rot);
										cur.axisy = Math.cos(cur.rot);
									} else {
										var d22 = dr2 * dr2;
										var p3 = 1 - 0.5 * d22;
										var m2 = 1 - d22 * d22 / 8;
										var nx2 = (p3 * cur.axisx + dr2 * cur.axisy) * m2;
										cur.axisy = (p3 * cur.axisy - dr2 * cur.axisx) * m2;
										cur.axisx = nx2;
									}
								}
							}
							if(s.type == 0) {
								var _this2 = s.circle;
								_this2.worldCOMx = _this2.body.posx + (_this2.body.axisy * _this2.localCOMx - _this2.body.axisx * _this2.localCOMy);
								_this2.worldCOMy = _this2.body.posy + (_this2.localCOMx * _this2.body.axisx + _this2.localCOMy * _this2.body.axisy);
								_this2.aabb.minx = _this2.worldCOMx - _this2.radius;
								_this2.aabb.miny = _this2.worldCOMy - _this2.radius;
								_this2.aabb.maxx = _this2.worldCOMx + _this2.radius;
								_this2.aabb.maxy = _this2.worldCOMy + _this2.radius;
							} else {
								var _this3 = s.polygon;
								var li1 = _this3.lverts.next;
								var p01 = _this3.gverts.next;
								var l2 = li1;
								li1 = li1.next;
								p01.x = _this3.body.posx + (_this3.body.axisy * l2.x - _this3.body.axisx * l2.y);
								p01.y = _this3.body.posy + (l2.x * _this3.body.axisx + l2.y * _this3.body.axisy);
								_this3.aabb.minx = p01.x;
								_this3.aabb.miny = p01.y;
								_this3.aabb.maxx = p01.x;
								_this3.aabb.maxy = p01.y;
								var cx_ite3 = _this3.gverts.next.next;
								while(cx_ite3 != null) {
									var p4 = cx_ite3;
									var l3 = li1;
									li1 = li1.next;
									p4.x = _this3.body.posx + (_this3.body.axisy * l3.x - _this3.body.axisx * l3.y);
									p4.y = _this3.body.posy + (l3.x * _this3.body.axisx + l3.y * _this3.body.axisy);
									if(p4.x < _this3.aabb.minx) {
										_this3.aabb.minx = p4.x;
									}
									if(p4.x > _this3.aabb.maxx) {
										_this3.aabb.maxx = p4.x;
									}
									if(p4.y < _this3.aabb.miny) {
										_this3.aabb.miny = p4.y;
									}
									if(p4.y > _this3.aabb.maxy) {
										_this3.aabb.maxy = p4.y;
									}
									cx_ite3 = cx_ite3.next;
								}
							}
							if(minx < aabb.minx) {
								aabb.minx = minx;
							} else {
								minx = aabb.minx;
							}
							if(miny < aabb.miny) {
								aabb.miny = miny;
							} else {
								miny = aabb.miny;
							}
							if(maxx > aabb.maxx) {
								aabb.maxx = maxx;
							} else {
								maxx = aabb.maxx;
							}
							if(maxy > aabb.maxy) {
								aabb.maxy = maxy;
							} else {
								maxy = aabb.maxy;
							}
						}
						this.bphase.sync(s);
						cx_ite1 = cx_ite1.next;
					}
					cur.sweepFrozen = false;
					if(cur.type == 2 && cur.bulletEnabled) {
						var linThreshold2 = nape_Config.bulletCCDLinearThreshold * cur.sweepRadius;
						var angThreshold2 = nape_Config.bulletCCDAngularThreshold;
						if((cur.velx * cur.velx + cur.vely * cur.vely) * dt * dt > linThreshold2 * linThreshold2 || cur.angvel * cur.angvel * dt * dt > angThreshold2 * angThreshold2) {
							cur.bullet = true;
						}
					}
				} else {
					cur.sweepFrozen = true;
					cur.bullet = false;
				}
			} else {
				cur.sweepFrozen = true;
				cur.bullet = false;
			}
			cx_ite = cx_ite.next;
		}
		var cx_ite = this.kinematics.head;
		while(cx_ite != null) {
			var cur = cx_ite.elt;
			cur.pre_posx = cur.posx;
			cur.pre_posy = cur.posy;
			cur.pre_rot = cur.rot;
			cur.sweepTime = 0;
			cur.sweep_angvel = cur.angvel % MAX_VEL;
			var delta = dt - cur.sweepTime;
			if(delta != 0) {
				cur.sweepTime = dt;
				var t = delta;
				cur.posx += cur.velx * t;
				cur.posy += cur.vely * t;
				if(cur.angvel != 0) {
					var dr = cur.sweep_angvel * delta;
					cur.rot += dr;
					if(dr * dr > 0.0001) {
						cur.axisx = Math.sin(cur.rot);
						cur.axisy = Math.cos(cur.rot);
					} else {
						var d2 = dr * dr;
						var p = 1 - 0.5 * d2;
						var m = 1 - d2 * d2 / 8;
						var nx = (p * cur.axisx + dr * cur.axisy) * m;
						cur.axisy = (p * cur.axisy - dr * cur.axisx) * m;
						cur.axisx = nx;
					}
				}
			}
			if(!cur.disableCCD) {
				var linThreshold = nape_Config.staticCCDLinearThreshold * cur.sweepRadius;
				var angThreshold = nape_Config.staticCCDAngularThreshold;
				if((cur.velx * cur.velx + cur.vely * cur.vely) * dt * dt > linThreshold * linThreshold || cur.angvel * cur.angvel * dt * dt > angThreshold * angThreshold || cur.type == 3) {
					var angvel = cur.sweep_angvel;
					if(angvel < 0) {
						angvel = -angvel;
					}
					var iangvel = 1 / angvel;
					var cx_ite1 = cur.shapes.head;
					while(cx_ite1 != null) {
						var s = cx_ite1.elt;
						var aabb = s.aabb;
						var minx = aabb.minx;
						var miny = aabb.miny;
						var maxx = aabb.maxx;
						var maxy = aabb.maxy;
						var count = angvel * dt * s.sweepCoef * 0.00833333333333333322 | 0;
						if(count > 8) {
							count = 8;
						}
						var anginc = angvel * dt / count;
						var delta1 = dt - cur.sweepTime;
						if(delta1 != 0) {
							cur.sweepTime = dt;
							var t1 = delta1;
							cur.posx += cur.velx * t1;
							cur.posy += cur.vely * t1;
							if(cur.angvel != 0) {
								var dr1 = cur.sweep_angvel * delta1;
								cur.rot += dr1;
								if(dr1 * dr1 > 0.0001) {
									cur.axisx = Math.sin(cur.rot);
									cur.axisy = Math.cos(cur.rot);
								} else {
									var d21 = dr1 * dr1;
									var p1 = 1 - 0.5 * d21;
									var m1 = 1 - d21 * d21 / 8;
									var nx1 = (p1 * cur.axisx + dr1 * cur.axisy) * m1;
									cur.axisy = (p1 * cur.axisy - dr1 * cur.axisx) * m1;
									cur.axisx = nx1;
								}
							}
						}
						if(s.type == 0) {
							var _this = s.circle;
							_this.worldCOMx = _this.body.posx + (_this.body.axisy * _this.localCOMx - _this.body.axisx * _this.localCOMy);
							_this.worldCOMy = _this.body.posy + (_this.localCOMx * _this.body.axisx + _this.localCOMy * _this.body.axisy);
							_this.aabb.minx = _this.worldCOMx - _this.radius;
							_this.aabb.miny = _this.worldCOMy - _this.radius;
							_this.aabb.maxx = _this.worldCOMx + _this.radius;
							_this.aabb.maxy = _this.worldCOMy + _this.radius;
						} else {
							var _this1 = s.polygon;
							var li = _this1.lverts.next;
							var p0 = _this1.gverts.next;
							var l = li;
							li = li.next;
							p0.x = _this1.body.posx + (_this1.body.axisy * l.x - _this1.body.axisx * l.y);
							p0.y = _this1.body.posy + (l.x * _this1.body.axisx + l.y * _this1.body.axisy);
							_this1.aabb.minx = p0.x;
							_this1.aabb.miny = p0.y;
							_this1.aabb.maxx = p0.x;
							_this1.aabb.maxy = p0.y;
							var cx_ite2 = _this1.gverts.next.next;
							while(cx_ite2 != null) {
								var p2 = cx_ite2;
								var l1 = li;
								li = li.next;
								p2.x = _this1.body.posx + (_this1.body.axisy * l1.x - _this1.body.axisx * l1.y);
								p2.y = _this1.body.posy + (l1.x * _this1.body.axisx + l1.y * _this1.body.axisy);
								if(p2.x < _this1.aabb.minx) {
									_this1.aabb.minx = p2.x;
								}
								if(p2.x > _this1.aabb.maxx) {
									_this1.aabb.maxx = p2.x;
								}
								if(p2.y < _this1.aabb.miny) {
									_this1.aabb.miny = p2.y;
								}
								if(p2.y > _this1.aabb.maxy) {
									_this1.aabb.maxy = p2.y;
								}
								cx_ite2 = cx_ite2.next;
							}
						}
						if(minx < aabb.minx) {
							aabb.minx = minx;
						} else {
							minx = aabb.minx;
						}
						if(miny < aabb.miny) {
							aabb.miny = miny;
						} else {
							miny = aabb.miny;
						}
						if(maxx > aabb.maxx) {
							aabb.maxx = maxx;
						} else {
							maxx = aabb.maxx;
						}
						if(maxy > aabb.maxy) {
							aabb.maxy = maxy;
						} else {
							maxy = aabb.maxy;
						}
						var _g = 1;
						var _g1 = count;
						while(_g < _g1) {
							var i = _g++;
							var dt1 = anginc * i * iangvel;
							var delta2 = dt1 - cur.sweepTime;
							if(delta2 != 0) {
								cur.sweepTime = dt1;
								var t2 = delta2;
								cur.posx += cur.velx * t2;
								cur.posy += cur.vely * t2;
								if(cur.angvel != 0) {
									var dr2 = cur.sweep_angvel * delta2;
									cur.rot += dr2;
									if(dr2 * dr2 > 0.0001) {
										cur.axisx = Math.sin(cur.rot);
										cur.axisy = Math.cos(cur.rot);
									} else {
										var d22 = dr2 * dr2;
										var p3 = 1 - 0.5 * d22;
										var m2 = 1 - d22 * d22 / 8;
										var nx2 = (p3 * cur.axisx + dr2 * cur.axisy) * m2;
										cur.axisy = (p3 * cur.axisy - dr2 * cur.axisx) * m2;
										cur.axisx = nx2;
									}
								}
							}
							if(s.type == 0) {
								var _this2 = s.circle;
								_this2.worldCOMx = _this2.body.posx + (_this2.body.axisy * _this2.localCOMx - _this2.body.axisx * _this2.localCOMy);
								_this2.worldCOMy = _this2.body.posy + (_this2.localCOMx * _this2.body.axisx + _this2.localCOMy * _this2.body.axisy);
								_this2.aabb.minx = _this2.worldCOMx - _this2.radius;
								_this2.aabb.miny = _this2.worldCOMy - _this2.radius;
								_this2.aabb.maxx = _this2.worldCOMx + _this2.radius;
								_this2.aabb.maxy = _this2.worldCOMy + _this2.radius;
							} else {
								var _this3 = s.polygon;
								var li1 = _this3.lverts.next;
								var p01 = _this3.gverts.next;
								var l2 = li1;
								li1 = li1.next;
								p01.x = _this3.body.posx + (_this3.body.axisy * l2.x - _this3.body.axisx * l2.y);
								p01.y = _this3.body.posy + (l2.x * _this3.body.axisx + l2.y * _this3.body.axisy);
								_this3.aabb.minx = p01.x;
								_this3.aabb.miny = p01.y;
								_this3.aabb.maxx = p01.x;
								_this3.aabb.maxy = p01.y;
								var cx_ite3 = _this3.gverts.next.next;
								while(cx_ite3 != null) {
									var p4 = cx_ite3;
									var l3 = li1;
									li1 = li1.next;
									p4.x = _this3.body.posx + (_this3.body.axisy * l3.x - _this3.body.axisx * l3.y);
									p4.y = _this3.body.posy + (l3.x * _this3.body.axisx + l3.y * _this3.body.axisy);
									if(p4.x < _this3.aabb.minx) {
										_this3.aabb.minx = p4.x;
									}
									if(p4.x > _this3.aabb.maxx) {
										_this3.aabb.maxx = p4.x;
									}
									if(p4.y < _this3.aabb.miny) {
										_this3.aabb.miny = p4.y;
									}
									if(p4.y > _this3.aabb.maxy) {
										_this3.aabb.maxy = p4.y;
									}
									cx_ite3 = cx_ite3.next;
								}
							}
							if(minx < aabb.minx) {
								aabb.minx = minx;
							} else {
								minx = aabb.minx;
							}
							if(miny < aabb.miny) {
								aabb.miny = miny;
							} else {
								miny = aabb.miny;
							}
							if(maxx > aabb.maxx) {
								aabb.maxx = maxx;
							} else {
								maxx = aabb.maxx;
							}
							if(maxy > aabb.maxy) {
								aabb.maxy = maxy;
							} else {
								maxy = aabb.maxy;
							}
						}
						this.bphase.sync(s);
						cx_ite1 = cx_ite1.next;
					}
					cur.sweepFrozen = false;
					if(cur.type == 2 && cur.bulletEnabled) {
						var linThreshold2 = nape_Config.bulletCCDLinearThreshold * cur.sweepRadius;
						var angThreshold2 = nape_Config.bulletCCDAngularThreshold;
						if((cur.velx * cur.velx + cur.vely * cur.vely) * dt * dt > linThreshold2 * linThreshold2 || cur.angvel * cur.angvel * dt * dt > angThreshold2 * angThreshold2) {
							cur.bullet = true;
						}
					}
				} else {
					cur.sweepFrozen = true;
					cur.bullet = false;
				}
			} else {
				cur.sweepFrozen = true;
				cur.bullet = false;
			}
			cx_ite = cx_ite.next;
		}
	}
	,presteparb: function(arb,dt,cont) {
		if(cont == null) {
			cont = false;
		}
		var _gthis = this;
		if(!arb.cleared && (arb.b1.component.sleeping && arb.b2.component.sleeping)) {
			arb.sleep_stamp = this.stamp;
			arb.sleeping = true;
			return true;
		}
		if(!arb.cleared || arb.present != 0 || arb.intchange) {
			var endcb = !cont && arb.up_stamp == this.stamp - 1 && !arb.cleared && !arb.intchange;
			var begcb = arb.fresh && !arb.cleared && !arb.intchange;
			if(endcb) {
				arb.endGenerated = this.stamp;
			}
			if(begcb || endcb || arb.cleared || arb.intchange) {
				var s1 = arb.ws1;
				var s2 = arb.ws2;
				var _this = this.mrca1;
				while(_this.head != null) {
					var ret = _this.head;
					_this.head = ret.next;
					var o = ret;
					o.elt = null;
					o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
					if(_this.head == null) {
						_this.pushmod = true;
					}
					_this.modified = true;
					_this.length--;
				}
				_this.pushmod = true;
				var _this = this.mrca2;
				while(_this.head != null) {
					var ret = _this.head;
					_this.head = ret.next;
					var o = ret;
					o.elt = null;
					o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
					zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
					if(_this.head == null) {
						_this.pushmod = true;
					}
					_this.modified = true;
					_this.length--;
				}
				_this.pushmod = true;
				if(s1.cbSet != null) {
					var _this = this.mrca1;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = s1;
					var temp = ret;
					temp.next = _this.head;
					_this.head = temp;
					_this.modified = true;
					_this.length++;
				}
				if(s1.body.cbSet != null) {
					var _this = this.mrca1;
					var o = s1.body;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = o;
					var temp = ret;
					temp.next = _this.head;
					_this.head = temp;
					_this.modified = true;
					_this.length++;
				}
				if(s2.cbSet != null) {
					var _this = this.mrca2;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = s2;
					var temp = ret;
					temp.next = _this.head;
					_this.head = temp;
					_this.modified = true;
					_this.length++;
				}
				if(s2.body.cbSet != null) {
					var _this = this.mrca2;
					var o = s2.body;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = o;
					var temp = ret;
					temp.next = _this.head;
					_this.head = temp;
					_this.modified = true;
					_this.length++;
				}
				var c1 = s1.body.compound;
				var c2 = s2.body.compound;
				while(c1 != c2) {
					var d1 = c1 == null ? 0 : c1.depth;
					var d2 = c2 == null ? 0 : c2.depth;
					if(d1 < d2) {
						if(c2.cbSet != null) {
							var _this = this.mrca2;
							var ret;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
								ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
							} else {
								ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
								ret.next = null;
							}
							ret.elt = c2;
							var temp = ret;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
						}
						c2 = c2.compound;
					} else {
						if(c1.cbSet != null) {
							var _this1 = this.mrca1;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = c1;
							var temp1 = ret1;
							temp1.next = _this1.head;
							_this1.head = temp1;
							_this1.modified = true;
							_this1.length++;
						}
						c1 = c1.compound;
					}
				}
				var cx_ite = this.mrca1.head;
				while(cx_ite != null) {
					var i1 = cx_ite.elt;
					var cx_ite1 = this.mrca2.head;
					while(cx_ite1 != null) {
						var i2 = cx_ite1.elt;
						var cb1 = i1.cbSet;
						var cb2 = i2.cbSet;
						var _this = cb1.manager;
						var ret = null;
						var pairs = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
						var cx_ite2 = pairs.head;
						while(cx_ite2 != null) {
							var p = cx_ite2.elt;
							if(p.a == cb1 && p.b == cb2 || p.a == cb2 && p.b == cb1) {
								ret = p;
								break;
							}
							cx_ite2 = cx_ite2.next;
						}
						if(ret == null) {
							var ret1;
							if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
								ret1 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
							} else {
								ret1 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
								zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.zip_listeners = true;
							if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
								ret1.a = cb1;
								ret1.b = cb2;
							} else {
								ret1.a = cb2;
								ret1.b = cb1;
							}
							ret = ret1;
							cb1.cbpairs.add(ret);
							if(cb2 != cb1) {
								cb2.cbpairs.add(ret);
							}
						}
						if(ret.zip_listeners) {
							ret.zip_listeners = false;
							ret.__validate();
						}
						if(ret.listeners.head == null) {
							cx_ite1 = cx_ite1.next;
							continue;
						}
						var callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
						if(begcb || arb.intchange) {
							if(callbackset == null) {
								callbackset = zpp_$nape_space_ZPP_$CallbackSet.get(i1,i2);
								this.add_callbackset(callbackset);
							}
							var _this1 = cb1.manager;
							var ret2 = null;
							var pairs1 = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
							var cx_ite3 = pairs1.head;
							while(cx_ite3 != null) {
								var p1 = cx_ite3.elt;
								if(p1.a == cb1 && p1.b == cb2 || p1.a == cb2 && p1.b == cb1) {
									ret2 = p1;
									break;
								}
								cx_ite3 = cx_ite3.next;
							}
							if(ret2 == null) {
								var ret3;
								if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
									ret3 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
								} else {
									ret3 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
									zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret3.next;
									ret3.next = null;
								}
								ret3.zip_listeners = true;
								if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
									ret3.a = cb1;
									ret3.b = cb2;
								} else {
									ret3.a = cb2;
									ret3.b = cb1;
								}
								ret2 = ret3;
								cb1.cbpairs.add(ret2);
								if(cb2 != cb1) {
									cb2.cbpairs.add(ret2);
								}
							}
							if(ret2.zip_listeners) {
								ret2.zip_listeners = false;
								ret2.__validate();
							}
							var cx_ite4 = ret2.listeners.head;
							while(cx_ite4 != null) {
								var x = cx_ite4.elt;
								if(x.event == 0) {
									if((x.itype & arb.type) != 0 && callbackset.empty_arb(x.itype)) {
										var cb = _gthis.push_callback(x);
										cb.event = 0;
										var o1 = callbackset.int1;
										var o2 = callbackset.int2;
										var tmp;
										var _this2 = x.options1;
										var xs = o1.cbTypes;
										if(_this2.nonemptyintersection(xs,_this2.includes) && !_this2.nonemptyintersection(xs,_this2.excludes)) {
											var _this3 = x.options2;
											var xs1 = o2.cbTypes;
											tmp = _this3.nonemptyintersection(xs1,_this3.includes) && !_this3.nonemptyintersection(xs1,_this3.excludes);
										} else {
											tmp = false;
										}
										if(tmp) {
											cb.int1 = o1;
											cb.int2 = o2;
										} else {
											cb.int1 = o2;
											cb.int2 = o1;
										}
										cb.set = callbackset;
									}
								}
								cx_ite4 = cx_ite4.next;
							}
							var tmp1;
							var ret4;
							ret4 = false;
							var cx_ite5 = callbackset.arbiters.head;
							while(cx_ite5 != null) {
								var npite = cx_ite5.elt;
								if(npite == arb) {
									ret4 = true;
									break;
								}
								cx_ite5 = cx_ite5.next;
							}
							if(!ret4) {
								var _this4 = callbackset.arbiters;
								var ret5;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
									ret5 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
								} else {
									ret5 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret5.next;
									ret5.next = null;
								}
								ret5.elt = arb;
								var temp = ret5;
								temp.next = _this4.head;
								_this4.head = temp;
								_this4.modified = true;
								_this4.length++;
								tmp1 = true;
							} else {
								tmp1 = false;
							}
							if(tmp1) {
								arb.present++;
							}
						} else {
							arb.present--;
							callbackset.remove_arb(arb);
							var _this5 = cb1.manager;
							var ret6 = null;
							var pairs2 = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
							var cx_ite6 = pairs2.head;
							while(cx_ite6 != null) {
								var p2 = cx_ite6.elt;
								if(p2.a == cb1 && p2.b == cb2 || p2.a == cb2 && p2.b == cb1) {
									ret6 = p2;
									break;
								}
								cx_ite6 = cx_ite6.next;
							}
							if(ret6 == null) {
								var ret7;
								if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
									ret7 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
								} else {
									ret7 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
									zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret7.next;
									ret7.next = null;
								}
								ret7.zip_listeners = true;
								if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
									ret7.a = cb1;
									ret7.b = cb2;
								} else {
									ret7.a = cb2;
									ret7.b = cb1;
								}
								ret6 = ret7;
								cb1.cbpairs.add(ret6);
								if(cb2 != cb1) {
									cb2.cbpairs.add(ret6);
								}
							}
							if(ret6.zip_listeners) {
								ret6.zip_listeners = false;
								ret6.__validate();
							}
							var cx_ite7 = ret6.listeners.head;
							while(cx_ite7 != null) {
								var x1 = cx_ite7.elt;
								if(x1.event == 1) {
									if((x1.itype & arb.type) != 0 && callbackset.empty_arb(x1.itype)) {
										var cb3 = _gthis.push_callback(x1);
										cb3.event = 1;
										var o11 = callbackset.int1;
										var o21 = callbackset.int2;
										var tmp2;
										var _this6 = x1.options1;
										var xs2 = o11.cbTypes;
										if(_this6.nonemptyintersection(xs2,_this6.includes) && !_this6.nonemptyintersection(xs2,_this6.excludes)) {
											var _this7 = x1.options2;
											var xs3 = o21.cbTypes;
											tmp2 = _this7.nonemptyintersection(xs3,_this7.includes) && !_this7.nonemptyintersection(xs3,_this7.excludes);
										} else {
											tmp2 = false;
										}
										if(tmp2) {
											cb3.int1 = o11;
											cb3.int2 = o21;
										} else {
											cb3.int1 = o21;
											cb3.int2 = o11;
										}
										cb3.set = callbackset;
									}
								}
								cx_ite7 = cx_ite7.next;
							}
							if(callbackset.arbiters.head == null) {
								this.remove_callbackset(callbackset);
							}
						}
						cx_ite1 = cx_ite1.next;
					}
					cx_ite = cx_ite.next;
				}
			}
			arb.fresh = false;
			arb.intchange = false;
		}
		if(arb.cleared || arb.up_stamp + (arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.COL ? nape_Config.arbiterExpirationDelay : 0) < this.stamp) {
			if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR) {
				var _this = arb.sensorarb;
				if(!_this.cleared) {
					var _this1 = _this.b1.arbiters;
					var pre = null;
					var cur = _this1.head;
					var ret = false;
					while(cur != null) {
						if(cur.elt == _this) {
							var old;
							var ret1;
							if(pre == null) {
								old = _this1.head;
								ret1 = old.next;
								_this1.head = ret1;
								if(_this1.head == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret1 = old.next;
								pre.next = ret1;
								if(ret1 == null) {
									_this1.pushmod = true;
								}
							}
							var o = old;
							o.elt = null;
							o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							ret = true;
							break;
						}
						pre = cur;
						cur = cur.next;
					}
					var _this1 = _this.b2.arbiters;
					var pre = null;
					var cur = _this1.head;
					var ret = false;
					while(cur != null) {
						if(cur.elt == _this) {
							var old;
							var ret1;
							if(pre == null) {
								old = _this1.head;
								ret1 = old.next;
								_this1.head = ret1;
								if(_this1.head == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret1 = old.next;
								pre.next = ret1;
								if(ret1 == null) {
									_this1.pushmod = true;
								}
							}
							var o = old;
							o.elt = null;
							o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							ret = true;
							break;
						}
						pre = cur;
						cur = cur.next;
					}
					if(_this.pair != null) {
						_this.pair.arb = null;
						_this.pair = null;
					}
				}
				_this.b1 = _this.b2 = null;
				_this.active = false;
				_this.intchange = false;
				var o = _this;
				o.next = zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool;
				zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool = o;
			} else if(arb.type == zpp_$nape_dynamics_ZPP_$Arbiter.FLUID) {
				var _this = arb.fluidarb;
				if(!_this.cleared) {
					var _this1 = _this.b1.arbiters;
					var pre = null;
					var cur = _this1.head;
					var ret = false;
					while(cur != null) {
						if(cur.elt == _this) {
							var old;
							var ret1;
							if(pre == null) {
								old = _this1.head;
								ret1 = old.next;
								_this1.head = ret1;
								if(_this1.head == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret1 = old.next;
								pre.next = ret1;
								if(ret1 == null) {
									_this1.pushmod = true;
								}
							}
							var o = old;
							o.elt = null;
							o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							ret = true;
							break;
						}
						pre = cur;
						cur = cur.next;
					}
					var _this1 = _this.b2.arbiters;
					var pre = null;
					var cur = _this1.head;
					var ret = false;
					while(cur != null) {
						if(cur.elt == _this) {
							var old;
							var ret1;
							if(pre == null) {
								old = _this1.head;
								ret1 = old.next;
								_this1.head = ret1;
								if(_this1.head == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret1 = old.next;
								pre.next = ret1;
								if(ret1 == null) {
									_this1.pushmod = true;
								}
							}
							var o = old;
							o.elt = null;
							o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							ret = true;
							break;
						}
						pre = cur;
						cur = cur.next;
					}
					if(_this.pair != null) {
						_this.pair.arb = null;
						_this.pair = null;
					}
				}
				_this.b1 = _this.b2 = null;
				_this.active = false;
				_this.intchange = false;
				var o = _this;
				o.next = zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool;
				zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool = o;
				_this.pre_dt = -1.0;
			} else {
				var _this = arb.colarb;
				if(!_this.cleared) {
					var _this1 = _this.b1.arbiters;
					var pre = null;
					var cur = _this1.head;
					var ret = false;
					while(cur != null) {
						if(cur.elt == _this) {
							var old;
							var ret1;
							if(pre == null) {
								old = _this1.head;
								ret1 = old.next;
								_this1.head = ret1;
								if(_this1.head == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret1 = old.next;
								pre.next = ret1;
								if(ret1 == null) {
									_this1.pushmod = true;
								}
							}
							var o = old;
							o.elt = null;
							o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							ret = true;
							break;
						}
						pre = cur;
						cur = cur.next;
					}
					var _this1 = _this.b2.arbiters;
					var pre = null;
					var cur = _this1.head;
					var ret = false;
					while(cur != null) {
						if(cur.elt == _this) {
							var old;
							var ret1;
							if(pre == null) {
								old = _this1.head;
								ret1 = old.next;
								_this1.head = ret1;
								if(_this1.head == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret1 = old.next;
								pre.next = ret1;
								if(ret1 == null) {
									_this1.pushmod = true;
								}
							}
							var o = old;
							o.elt = null;
							o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
							zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							ret = true;
							break;
						}
						pre = cur;
						cur = cur.next;
					}
					if(_this.pair != null) {
						_this.pair.arb = null;
						_this.pair = null;
					}
				}
				_this.b1 = _this.b2 = null;
				_this.active = false;
				_this.intchange = false;
				while(_this.contacts.next != null) {
					var _this1 = _this.contacts;
					var ret = _this1.next;
					_this1.pop();
					var o = ret;
					o.sBias = -1.0;
					o.arbiter = null;
					o.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
					zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o;
					var _this2 = _this.innards;
					var ret1 = _this2.next;
					_this2.next = ret1.next;
					ret1._inuse = false;
					if(_this2.next == null) {
						_this2.pushmod = true;
					}
					_this2.modified = true;
					_this2.length--;
				}
				var o = _this;
				o.userdef_dyn_fric = false;
				o.userdef_stat_fric = false;
				o.userdef_restitution = false;
				o.userdef_rfric = false;
				o.__ref_edge1 = o.__ref_edge2 = null;
				o.next = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool;
				zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = o;
				_this.pre_dt = -1.0;
			}
			return true;
		}
		var pact = arb.active;
		arb.active = arb.presentable = arb.up_stamp == this.stamp;
		if((arb.immState & 1) != 0) {
			if(arb.active && arb.type != zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR) {
				if(arb.colarb != null) {
					var _this = arb.colarb;
					if(_this.invalidated) {
						_this.invalidated = false;
						if(!_this.userdef_restitution) {
							if(_this.s1.material.elasticity <= -Infinity || _this.s2.material.elasticity <= -Infinity) {
								_this.restitution = 0;
							} else if(_this.s1.material.elasticity >= Infinity || _this.s2.material.elasticity >= Infinity) {
								_this.restitution = 1;
							} else {
								_this.restitution = (_this.s1.material.elasticity + _this.s2.material.elasticity) / 2;
							}
							if(_this.restitution < 0) {
								_this.restitution = 0;
							}
							if(_this.restitution > 1) {
								_this.restitution = 1;
							}
						}
						if(!_this.userdef_dyn_fric) {
							var x = _this.s1.material.dynamicFriction * _this.s2.material.dynamicFriction;
							var tmp;
							if(x == 0.0) {
								tmp = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
							}
							_this.dyn_fric = tmp;
						}
						if(!_this.userdef_stat_fric) {
							var x = _this.s1.material.staticFriction * _this.s2.material.staticFriction;
							var tmp;
							if(x == 0.0) {
								tmp = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
							}
							_this.stat_fric = tmp;
						}
						if(!_this.userdef_rfric) {
							var x = _this.s1.material.rollingFriction * _this.s2.material.rollingFriction;
							var tmp;
							if(x == 0.0) {
								tmp = 0.0;
							} else {
								zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
								zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
								var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
								tmp = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
							}
							_this.rfric = tmp;
						}
					}
					if(_this.pre_dt == -1.0) {
						_this.pre_dt = dt;
					}
					var dtratio = dt / _this.pre_dt;
					_this.pre_dt = dt;
					var mass_sum = _this.b1.smass + _this.b2.smass;
					_this.hc2 = false;
					var fst = true;
					var statType = _this.b1.type != 2 || _this.b2.type != 2;
					var bias = statType ? _this.continuous ? nape_Config.contactContinuousStaticBiasCoef : nape_Config.contactStaticBiasCoef : _this.continuous ? nape_Config.contactContinuousBiasCoef : nape_Config.contactBiasCoef;
					_this.biasCoef = bias;
					_this.continuous = false;
					var pre = null;
					var prei = null;
					var cx_itei = _this.innards.next;
					var cx_ite = _this.contacts.next;
					while(cx_ite != null) {
						var c = cx_ite;
						if(c.stamp + nape_Config.arbiterExpirationDelay < _this.stamp) {
							var _this1 = _this.contacts;
							var old;
							var ret;
							if(pre == null) {
								old = _this1.next;
								ret = old.next;
								_this1.next = ret;
								if(_this1.next == null) {
									_this1.pushmod = true;
								}
							} else {
								old = pre.next;
								ret = old.next;
								pre.next = ret;
								if(ret == null) {
									_this1.pushmod = true;
								}
							}
							old._inuse = false;
							_this1.modified = true;
							_this1.length--;
							_this1.pushmod = true;
							cx_ite = ret;
							var _this2 = _this.innards;
							var old1;
							var ret1;
							if(prei == null) {
								old1 = _this2.next;
								ret1 = old1.next;
								_this2.next = ret1;
								if(_this2.next == null) {
									_this2.pushmod = true;
								}
							} else {
								old1 = prei.next;
								ret1 = old1.next;
								prei.next = ret1;
								if(ret1 == null) {
									_this2.pushmod = true;
								}
							}
							old1._inuse = false;
							_this2.modified = true;
							_this2.length--;
							_this2.pushmod = true;
							cx_itei = ret1;
							var o = c;
							o.sBias = -1.0;
							o.arbiter = null;
							o.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
							zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o;
							continue;
						}
						var ci = c.inner;
						var pact1 = c.active;
						c.active = c.stamp == _this.stamp;
						if(c.active) {
							if(fst) {
								fst = false;
								_this.c1 = ci;
								_this.oc1 = c;
							} else {
								_this.hc2 = true;
								_this.c2 = ci;
								_this.oc2 = c;
							}
							ci.r2x = c.px - _this.b2.posx;
							ci.r2y = c.py - _this.b2.posy;
							ci.r1x = c.px - _this.b1.posx;
							ci.r1y = c.py - _this.b1.posy;
							var x = ci.r2x * _this.nx + ci.r2y * _this.ny;
							var kt = mass_sum + _this.b2.sinertia * (x * x);
							var x1 = ci.r1x * _this.nx + ci.r1y * _this.ny;
							kt += _this.b1.sinertia * (x1 * x1);
							ci.tMass = kt < nape_Config.epsilon * nape_Config.epsilon ? 0 : 1.0 / kt;
							var x2 = _this.ny * ci.r2x - _this.nx * ci.r2y;
							var nt = mass_sum + _this.b2.sinertia * (x2 * x2);
							var x3 = _this.ny * ci.r1x - _this.nx * ci.r1y;
							nt += _this.b1.sinertia * (x3 * x3);
							ci.nMass = nt < nape_Config.epsilon * nape_Config.epsilon ? 0 : 1.0 / nt;
							var vrx = 0.0;
							var vry = 0.0;
							var ang = _this.b2.angvel + _this.b2.kinangvel;
							vrx = _this.b2.velx + _this.b2.kinvelx - ci.r2y * ang;
							vry = _this.b2.vely + _this.b2.kinvely + ci.r2x * ang;
							ang = _this.b1.angvel + _this.b1.kinangvel;
							vrx -= _this.b1.velx + _this.b1.kinvelx - ci.r1y * ang;
							vry -= _this.b1.vely + _this.b1.kinvely + ci.r1x * ang;
							var vdot = _this.nx * vrx + _this.ny * vry;
							var sb = 0.1;
							var sf = 1 - 0.9 * vdot * vdot;
							if(sf < 0) {
								sf = 0;
							}
							sf -= c.dist * 0.01;
							if(sf < 0) {
								sf = 0;
							}
							if(sf > 1) {
								sf = 1;
							}
							sb += 0.700000000000000067 * sf;
							if(sb > 1) {
								sb = 1;
							}
							if(c.sBias == -1) {
								c.sBias = sb;
							} else {
								c.sBias = 0.85 * c.sBias + 0.150000000000000022 * sb;
							}
							ci.biasCoef = c.sBias;
							if(statType) {
								ci.biasCoef *= 2;
								if(ci.biasCoef > 1) {
									ci.biasCoef = 1;
								}
							}
							c.elasticity = _this.restitution;
							ci.bounce = vdot * c.elasticity;
							if(ci.bounce > -nape_Config.elasticThreshold) {
								ci.bounce = 0;
							}
							vdot = vry * _this.nx - vrx * _this.ny;
							var thr = nape_Config.staticFrictionThreshold;
							if(vdot * vdot > thr * thr) {
								ci.friction = _this.dyn_fric;
							} else {
								ci.friction = _this.stat_fric;
							}
							ci.jnAcc *= dtratio;
							ci.jtAcc *= dtratio;
						}
						if(pact1 != c.active) {
							_this.contacts.modified = true;
						}
						pre = cx_ite;
						prei = cx_itei;
						cx_itei = cx_itei.next;
						cx_ite = cx_ite.next;
					}
					if(_this.hc2) {
						_this.hpc2 = true;
						if(_this.oc1.posOnly) {
							var tmp = _this.c1;
							_this.c1 = _this.c2;
							_this.c2 = tmp;
							var tmp2 = _this.oc1;
							_this.oc1 = _this.oc2;
							_this.oc2 = tmp2;
							_this.hc2 = false;
						} else if(_this.oc2.posOnly) {
							_this.hc2 = false;
						}
						if(_this.oc1.posOnly) {
							fst = true;
						}
					} else {
						_this.hpc2 = false;
					}
					_this.jrAcc *= dtratio;
					if(!fst) {
						_this.rn1a = _this.ny * _this.c1.r1x - _this.nx * _this.c1.r1y;
						_this.rt1a = _this.c1.r1x * _this.nx + _this.c1.r1y * _this.ny;
						_this.rn1b = _this.ny * _this.c1.r2x - _this.nx * _this.c1.r2y;
						_this.rt1b = _this.c1.r2x * _this.nx + _this.c1.r2y * _this.ny;
						_this.k1x = _this.b2.kinvelx - _this.c1.r2y * _this.b2.kinangvel - (_this.b1.kinvelx - _this.c1.r1y * _this.b1.kinangvel);
						_this.k1y = _this.b2.kinvely + _this.c1.r2x * _this.b2.kinangvel - (_this.b1.kinvely + _this.c1.r1x * _this.b1.kinangvel);
					}
					if(_this.hc2) {
						_this.rn2a = _this.ny * _this.c2.r1x - _this.nx * _this.c2.r1y;
						_this.rt2a = _this.c2.r1x * _this.nx + _this.c2.r1y * _this.ny;
						_this.rn2b = _this.ny * _this.c2.r2x - _this.nx * _this.c2.r2y;
						_this.rt2b = _this.c2.r2x * _this.nx + _this.c2.r2y * _this.ny;
						_this.k2x = _this.b2.kinvelx - _this.c2.r2y * _this.b2.kinangvel - (_this.b1.kinvelx - _this.c2.r1y * _this.b1.kinangvel);
						_this.k2y = _this.b2.kinvely + _this.c2.r2x * _this.b2.kinangvel - (_this.b1.kinvely + _this.c2.r1x * _this.b1.kinangvel);
						_this.kMassa = mass_sum + _this.b1.sinertia * _this.rn1a * _this.rn1a + _this.b2.sinertia * _this.rn1b * _this.rn1b;
						_this.kMassb = mass_sum + _this.b1.sinertia * _this.rn1a * _this.rn2a + _this.b2.sinertia * _this.rn1b * _this.rn2b;
						_this.kMassc = mass_sum + _this.b1.sinertia * _this.rn2a * _this.rn2a + _this.b2.sinertia * _this.rn2b * _this.rn2b;
						var norm = _this.kMassa * _this.kMassa + 2 * _this.kMassb * _this.kMassb + _this.kMassc * _this.kMassc;
						if(norm < nape_Config.illConditionedThreshold * (_this.kMassa * _this.kMassc - _this.kMassb * _this.kMassb)) {
							_this.Ka = _this.kMassa;
							_this.Kb = _this.kMassb;
							_this.Kc = _this.kMassc;
							var det = _this.kMassa * _this.kMassc - _this.kMassb * _this.kMassb;
							if(det != det) {
								_this.kMassa = _this.kMassb = _this.kMassc = 0;
							} else if(det == 0) {
								var flag = 0;
								if(_this.kMassa != 0) {
									_this.kMassa = 1 / _this.kMassa;
								} else {
									_this.kMassa = 0;
									flag |= 1;
								}
								if(_this.kMassc != 0) {
									_this.kMassc = 1 / _this.kMassc;
								} else {
									_this.kMassc = 0;
									flag |= 2;
								}
								_this.kMassb = 0;
							} else {
								det = 1 / det;
								var t = _this.kMassc * det;
								_this.kMassc = _this.kMassa * det;
								_this.kMassa = t;
								_this.kMassb *= -det;
							}
						} else {
							_this.hc2 = false;
							if(_this.oc2.dist < _this.oc1.dist) {
								var t = _this.c1;
								_this.c1 = _this.c2;
								_this.c2 = t;
							}
							_this.oc2.active = false;
							_this.contacts.modified = true;
						}
					}
					_this.surfacex = _this.b2.svelx;
					_this.surfacey = _this.b2.svely;
					var t = 1.0;
					_this.surfacex += _this.b1.svelx * t;
					_this.surfacey += _this.b1.svely * t;
					_this.surfacex = -_this.surfacex;
					_this.surfacey = -_this.surfacey;
					_this.rMass = _this.b1.sinertia + _this.b2.sinertia;
					if(_this.rMass != 0) {
						_this.rMass = 1 / _this.rMass;
					}
					if(fst) {
						arb.active = false;
					}
				} else {
					var _this = arb.fluidarb;
					if(_this.pre_dt == -1.0) {
						_this.pre_dt = dt;
					}
					var dtratio = dt / _this.pre_dt;
					_this.pre_dt = dt;
					_this.r1x = _this.centroidx - _this.b1.posx;
					_this.r1y = _this.centroidy - _this.b1.posy;
					_this.r2x = _this.centroidx - _this.b2.posx;
					_this.r2y = _this.centroidy - _this.b2.posy;
					var g1x = 0.0;
					var g1y = 0.0;
					if(_this.ws1.fluidEnabled && _this.ws1.fluidProperties.wrap_gravity != null) {
						g1x = _this.ws1.fluidProperties.gravityx;
						g1y = _this.ws1.fluidProperties.gravityy;
					} else {
						g1x = this.gravityx;
						g1y = this.gravityy;
					}
					var g2x = 0.0;
					var g2y = 0.0;
					if(_this.ws2.fluidEnabled && _this.ws2.fluidProperties.wrap_gravity != null) {
						g2x = _this.ws2.fluidProperties.gravityx;
						g2y = _this.ws2.fluidProperties.gravityy;
					} else {
						g2x = this.gravityx;
						g2y = this.gravityy;
					}
					var buoyx = 0;
					var buoyy = 0;
					if(_this.ws1.fluidEnabled && _this.ws2.fluidEnabled) {
						var mass1 = _this.overlap * _this.ws1.fluidProperties.density;
						var mass2 = _this.overlap * _this.ws2.fluidProperties.density;
						if(mass1 > mass2) {
							var t = mass1 + mass2;
							buoyx -= g1x * t;
							buoyy -= g1y * t;
						} else if(mass1 < mass2) {
							var t = mass1 + mass2;
							buoyx += g2x * t;
							buoyy += g2y * t;
						} else {
							var gx = 0.0;
							var gy = 0.0;
							gx = g1x + g2x;
							gy = g1y + g2y;
							var t = 0.5;
							gx *= t;
							gy *= t;
							if(_this.ws1.worldCOMx * gx + _this.ws1.worldCOMy * gy > _this.ws2.worldCOMx * gx + _this.ws2.worldCOMy * gy) {
								var t = mass1 + mass2;
								buoyx -= gx * t;
								buoyy -= gy * t;
							} else {
								var t = mass1 + mass2;
								buoyx += gx * t;
								buoyy += gy * t;
							}
						}
					} else if(_this.ws1.fluidEnabled) {
						var mass = _this.overlap * _this.ws1.fluidProperties.density;
						var t = mass;
						buoyx -= g1x * t;
						buoyy -= g1y * t;
					} else if(_this.ws2.fluidEnabled) {
						var mass = _this.overlap * _this.ws2.fluidProperties.density;
						var t = mass;
						buoyx += g2x * t;
						buoyy += g2y * t;
					}
					var t = dt;
					buoyx *= t;
					buoyy *= t;
					_this.buoyx = buoyx;
					_this.buoyy = buoyy;
					if(_this.b1.type == 2) {
						var t = _this.b1.imass;
						_this.b1.velx -= buoyx * t;
						_this.b1.vely -= buoyy * t;
						_this.b1.angvel -= (buoyy * _this.r1x - buoyx * _this.r1y) * _this.b1.iinertia;
					}
					if(_this.b2.type == 2) {
						var t = _this.b2.imass;
						_this.b2.velx += buoyx * t;
						_this.b2.vely += buoyy * t;
						_this.b2.angvel += (buoyy * _this.r2x - buoyx * _this.r2y) * _this.b2.iinertia;
					}
					if((!_this.ws1.fluidEnabled || _this.ws1.fluidProperties.viscosity == 0) && (!_this.ws2.fluidEnabled || _this.ws2.fluidProperties.viscosity == 0)) {
						_this.nodrag = true;
						_this.dampx = 0;
						_this.dampy = 0;
						_this.adamp = 0;
					} else {
						_this.nodrag = false;
						var tViscosity = 0.0;
						if(_this.ws1.fluidEnabled) {
							_this.ws2.validate_angDrag();
							tViscosity += _this.ws1.fluidProperties.viscosity * _this.ws2.angDrag * _this.overlap / _this.ws2.area;
						}
						if(_this.ws2.fluidEnabled) {
							_this.ws1.validate_angDrag();
							tViscosity += _this.ws2.fluidProperties.viscosity * _this.ws1.angDrag * _this.overlap / _this.ws1.area;
						}
						if(tViscosity != 0) {
							var iSum = _this.b1.sinertia + _this.b2.sinertia;
							if(iSum != 0) {
								_this.wMass = 1 / iSum;
							} else {
								_this.wMass = 0.0;
							}
							tViscosity *= 0.0004;
							var omega = 2 * Math.PI * tViscosity;
							_this.agamma = 1 / (dt * omega * (2 + omega * dt));
							var ig = 1 / (1 + _this.agamma);
							var biasCoef = dt * omega * omega * _this.agamma;
							_this.agamma *= ig;
							_this.wMass *= ig;
						} else {
							_this.wMass = 0.0;
							_this.agamma = 0.0;
						}
						var vrnx = _this.b2.velx + _this.b2.kinvelx - _this.r2y * (_this.b2.angvel + _this.b2.kinangvel) - (_this.b1.velx + _this.b1.kinvelx - _this.r1y * (_this.b2.angvel + _this.b2.kinangvel));
						var vrny = _this.b2.vely + _this.b2.kinvely + _this.r2x * (_this.b2.angvel + _this.b2.kinangvel) - (_this.b1.vely + _this.b1.kinvely + _this.r1x * (_this.b1.angvel + _this.b1.kinangvel));
						if(!(vrnx * vrnx + vrny * vrny < nape_Config.epsilon * nape_Config.epsilon)) {
							var d = vrnx * vrnx + vrny * vrny;
							zpp_$nape_util_ZPP_$Math.fbuf[0] = d;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							var imag = x2 * (1.5 - 0.5 * d * x2 * x2);
							var t = imag;
							vrnx *= t;
							vrny *= t;
							_this.nx = vrnx;
							_this.ny = vrny;
						}
						var tViscosity = 0.0;
						if(_this.ws1.fluidEnabled) {
							var f = -_this.ws1.fluidProperties.viscosity * _this.overlap / _this.ws2.area;
							if(_this.ws2.type == 0) {
								tViscosity -= f * _this.ws2.circle.radius * nape_Config.fluidLinearDrag / (2 * _this.ws2.circle.radius * Math.PI);
							} else {
								var poly = _this.ws2.polygon;
								var bord = 0.0;
								var acc = 0.0;
								var cx_ite = poly.edges.head;
								while(cx_ite != null) {
									var ex = cx_ite.elt;
									bord += ex.length;
									var fact = f * ex.length * (ex.gnormx * _this.nx + ex.gnormy * _this.ny);
									if(fact > 0) {
										fact *= -nape_Config.fluidVacuumDrag;
									}
									acc -= fact * 0.5 * nape_Config.fluidLinearDrag;
									cx_ite = cx_ite.next;
								}
								tViscosity += acc / bord;
							}
						}
						if(_this.ws2.fluidEnabled) {
							var f = -_this.ws2.fluidProperties.viscosity * _this.overlap / _this.ws1.area;
							if(_this.ws1.type == 0) {
								tViscosity -= f * _this.ws1.circle.radius * nape_Config.fluidLinearDrag / (2 * _this.ws1.circle.radius * Math.PI);
							} else {
								var poly = _this.ws1.polygon;
								var bord = 0.0;
								var acc = 0.0;
								var cx_ite = poly.edges.head;
								while(cx_ite != null) {
									var ex = cx_ite.elt;
									bord += ex.length;
									var fact = f * ex.length * (ex.gnormx * _this.nx + ex.gnormy * _this.ny);
									if(fact > 0) {
										fact *= -nape_Config.fluidVacuumDrag;
									}
									acc -= fact * 0.5 * nape_Config.fluidLinearDrag;
									cx_ite = cx_ite.next;
								}
								tViscosity += acc / bord;
							}
						}
						if(tViscosity != 0) {
							var m = _this.b1.smass + _this.b2.smass;
							var Ka = 0.0;
							var Kb = 0.0;
							var Kc = 0.0;
							Ka = m;
							Kb = 0;
							Kc = m;
							if(_this.b1.sinertia != 0) {
								var X = _this.r1x * _this.b1.sinertia;
								var Y = _this.r1y * _this.b1.sinertia;
								Ka += Y * _this.r1y;
								Kb += -Y * _this.r1x;
								Kc += X * _this.r1x;
							}
							if(_this.b2.sinertia != 0) {
								var X = _this.r2x * _this.b2.sinertia;
								var Y = _this.r2y * _this.b2.sinertia;
								Ka += Y * _this.r2y;
								Kb += -Y * _this.r2x;
								Kc += X * _this.r2x;
							}
							var det = Ka * Kc - Kb * Kb;
							if(det != det) {
								Kc = 0;
								Kb = Kc;
								Ka = Kb;
							} else if(det == 0) {
								var flag = 0;
								if(Ka != 0) {
									Ka = 1 / Ka;
								} else {
									Ka = 0;
									flag |= 1;
								}
								if(Kc != 0) {
									Kc = 1 / Kc;
								} else {
									Kc = 0;
									flag |= 2;
								}
								Kb = 0;
							} else {
								det = 1 / det;
								var t = Kc * det;
								Kc = Ka * det;
								Ka = t;
								Kb *= -det;
							}
							_this.vMassa = Ka;
							_this.vMassb = Kb;
							_this.vMassc = Kc;
							var biasCoef;
							var omega = 2 * Math.PI * tViscosity;
							_this.lgamma = 1 / (dt * omega * (2 + omega * dt));
							var ig = 1 / (1 + _this.lgamma);
							biasCoef = dt * omega * omega * _this.lgamma;
							_this.lgamma *= ig;
							var X = ig;
							_this.vMassa *= X;
							_this.vMassb *= X;
							_this.vMassc *= X;
						} else {
							_this.vMassa = 0;
							_this.vMassb = 0;
							_this.vMassc = 0;
							_this.lgamma = 0.0;
						}
					}
					var t = dtratio;
					_this.dampx *= t;
					_this.dampy *= t;
					_this.adamp *= dtratio;
				}
			}
		} else if(arb.colarb != null) {
			var _this = arb.colarb;
			var fst = true;
			var pre = null;
			var prei = null;
			var cx_itei = _this.innards.next;
			_this.hc2 = false;
			var cx_ite = _this.contacts.next;
			while(cx_ite != null) {
				var c = cx_ite;
				if(c.stamp + nape_Config.arbiterExpirationDelay < _this.stamp) {
					var _this1 = _this.contacts;
					var old;
					var ret;
					if(pre == null) {
						old = _this1.next;
						ret = old.next;
						_this1.next = ret;
						if(_this1.next == null) {
							_this1.pushmod = true;
						}
					} else {
						old = pre.next;
						ret = old.next;
						pre.next = ret;
						if(ret == null) {
							_this1.pushmod = true;
						}
					}
					old._inuse = false;
					_this1.modified = true;
					_this1.length--;
					_this1.pushmod = true;
					cx_ite = ret;
					var _this2 = _this.innards;
					var old1;
					var ret1;
					if(prei == null) {
						old1 = _this2.next;
						ret1 = old1.next;
						_this2.next = ret1;
						if(_this2.next == null) {
							_this2.pushmod = true;
						}
					} else {
						old1 = prei.next;
						ret1 = old1.next;
						prei.next = ret1;
						if(ret1 == null) {
							_this2.pushmod = true;
						}
					}
					old1._inuse = false;
					_this2.modified = true;
					_this2.length--;
					_this2.pushmod = true;
					cx_itei = ret1;
					var o = c;
					o.sBias = -1.0;
					o.arbiter = null;
					o.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
					zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o;
					continue;
				}
				var ci = c.inner;
				var pact1 = c.active;
				c.active = c.stamp == _this.stamp;
				if(c.active) {
					if(fst) {
						fst = false;
						_this.c1 = ci;
						_this.oc1 = c;
					} else {
						_this.hc2 = true;
						_this.c2 = ci;
						_this.oc2 = c;
					}
				}
				if(pact1 != c.active) {
					_this.contacts.modified = true;
				}
				pre = cx_ite;
				prei = cx_itei;
				cx_itei = cx_itei.next;
				cx_ite = cx_ite.next;
			}
			if(_this.hc2) {
				_this.hpc2 = true;
				if(_this.oc1.posOnly) {
					var tmp = _this.c1;
					_this.c1 = _this.c2;
					_this.c2 = tmp;
					var tmp2 = _this.oc1;
					_this.oc1 = _this.oc2;
					_this.oc2 = tmp2;
					_this.hc2 = false;
				} else if(_this.oc2.posOnly) {
					_this.hc2 = false;
				}
				if(_this.oc1.posOnly) {
					fst = true;
				}
			} else {
				_this.hpc2 = false;
			}
			if(fst) {
				arb.active = false;
			}
		}
		if(pact != arb.active) {
			arb.b1.arbiters.modified = true;
			arb.b2.arbiters.modified = true;
			this.c_arbiters_true.modified = this.c_arbiters_false.modified = true;
			this.s_arbiters.modified = this.f_arbiters.modified = true;
		}
		return false;
	}
	,prestep: function(dt) {
		var pre = null;
		var cx_ite = this.live_constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			if(con.preStep(dt)) {
				cx_ite = this.live_constraints.erase(pre);
				con.broken();
				this.constraintCbBreak(con);
				if(con.removeOnBreak) {
					con.component.sleeping = true;
					this.midstep = false;
					if(con.compound != null) {
						con.compound.wrap_constraints.remove(con.outer);
					} else {
						this.wrap_constraints.remove(con.outer);
					}
					this.midstep = true;
				} else {
					con.active = false;
				}
				con.clearcache();
				continue;
			}
			pre = cx_ite;
			cx_ite = cx_ite.next;
		}
		var pre = null;
		var arbs = this.c_arbiters_true;
		var arbite = arbs.head;
		var fst = this.c_arbiters_false != null;
		if(fst && arbite == null) {
			fst = false;
			arbite = this.c_arbiters_false.head;
			arbs = this.c_arbiters_false;
			pre = null;
		}
		while(arbite != null) {
			var arb = arbite.elt;
			if(this.presteparb(arb,dt)) {
				var old;
				var ret;
				if(pre == null) {
					old = arbs.head;
					ret = old.next;
					arbs.head = ret;
					if(arbs.head == null) {
						arbs.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						arbs.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = o;
				arbs.modified = true;
				arbs.length--;
				arbs.pushmod = true;
				arbite = ret;
				if(fst && arbite == null) {
					fst = false;
					arbite = this.c_arbiters_false.head;
					arbs = this.c_arbiters_false;
					pre = null;
				}
				continue;
			}
			pre = arbite;
			arbite = arbite.next;
			if(fst && arbite == null) {
				fst = false;
				arbite = this.c_arbiters_false.head;
				arbs = this.c_arbiters_false;
				pre = null;
			}
		}
		var pre = null;
		var arbs = this.f_arbiters;
		var arbite = arbs.head;
		var fst = false;
		if(fst && arbite == null) {
			fst = false;
			arbite = null.begin();
			arbs = null;
			pre = null;
		}
		while(arbite != null) {
			var arb = arbite.elt;
			if(this.presteparb(arb,dt)) {
				var old;
				var ret;
				if(pre == null) {
					old = arbs.head;
					ret = old.next;
					arbs.head = ret;
					if(arbs.head == null) {
						arbs.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						arbs.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = o;
				arbs.modified = true;
				arbs.length--;
				arbs.pushmod = true;
				arbite = ret;
				if(fst && arbite == null) {
					fst = false;
					arbite = null.begin();
					arbs = null;
					pre = null;
				}
				continue;
			}
			pre = arbite;
			arbite = arbite.next;
			if(fst && arbite == null) {
				fst = false;
				arbite = null.begin();
				arbs = null;
				pre = null;
			}
		}
		var pre = null;
		var arbs = this.s_arbiters;
		var arbite = arbs.head;
		var fst = false;
		if(fst && arbite == null) {
			fst = false;
			arbite = null.begin();
			arbs = null;
			pre = null;
		}
		while(arbite != null) {
			var arb = arbite.elt;
			if(this.presteparb(arb,dt)) {
				var old;
				var ret;
				if(pre == null) {
					old = arbs.head;
					ret = old.next;
					arbs.head = ret;
					if(arbs.head == null) {
						arbs.pushmod = true;
					}
				} else {
					old = pre.next;
					ret = old.next;
					pre.next = ret;
					if(ret == null) {
						arbs.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = o;
				arbs.modified = true;
				arbs.length--;
				arbs.pushmod = true;
				arbite = ret;
				if(fst && arbite == null) {
					fst = false;
					arbite = null.begin();
					arbs = null;
					pre = null;
				}
				continue;
			}
			pre = arbite;
			arbite = arbite.next;
			if(fst && arbite == null) {
				fst = false;
				arbite = null.begin();
				arbs = null;
				pre = null;
			}
		}
	}
	,warmStart: function() {
		var cx_ite = this.f_arbiters.head;
		while(cx_ite != null) {
			var arb = cx_ite.elt;
			if(arb.active && (arb.immState & 1) != 0) {
				var t = arb.b1.imass;
				arb.b1.velx -= arb.dampx * t;
				arb.b1.vely -= arb.dampy * t;
				var t1 = arb.b2.imass;
				arb.b2.velx += arb.dampx * t1;
				arb.b2.vely += arb.dampy * t1;
				arb.b1.angvel -= arb.b1.iinertia * (arb.dampy * arb.r1x - arb.dampx * arb.r1y);
				arb.b2.angvel += arb.b2.iinertia * (arb.dampy * arb.r2x - arb.dampx * arb.r2y);
				arb.b1.angvel -= arb.adamp * arb.b1.iinertia;
				arb.b2.angvel += arb.adamp * arb.b2.iinertia;
			}
			cx_ite = cx_ite.next;
		}
		var arbi = this.c_arbiters_false.head;
		var fst = true;
		if(arbi == null) {
			arbi = this.c_arbiters_true.head;
			fst = false;
		}
		while(arbi != null) {
			var arb = arbi.elt;
			if(arb.active && (arb.immState & 1) != 0) {
				var jx = arb.nx * arb.c1.jnAcc - arb.ny * arb.c1.jtAcc;
				var jy = arb.ny * arb.c1.jnAcc + arb.nx * arb.c1.jtAcc;
				var t = arb.b1.imass;
				arb.b1.velx -= jx * t;
				arb.b1.vely -= jy * t;
				arb.b1.angvel -= arb.b1.iinertia * (jy * arb.c1.r1x - jx * arb.c1.r1y);
				var t1 = arb.b2.imass;
				arb.b2.velx += jx * t1;
				arb.b2.vely += jy * t1;
				arb.b2.angvel += arb.b2.iinertia * (jy * arb.c1.r2x - jx * arb.c1.r2y);
				if(arb.hc2) {
					var jx1 = arb.nx * arb.c2.jnAcc - arb.ny * arb.c2.jtAcc;
					var jy1 = arb.ny * arb.c2.jnAcc + arb.nx * arb.c2.jtAcc;
					var t2 = arb.b1.imass;
					arb.b1.velx -= jx1 * t2;
					arb.b1.vely -= jy1 * t2;
					arb.b1.angvel -= arb.b1.iinertia * (jy1 * arb.c2.r1x - jx1 * arb.c2.r1y);
					var t3 = arb.b2.imass;
					arb.b2.velx += jx1 * t3;
					arb.b2.vely += jy1 * t3;
					arb.b2.angvel += arb.b2.iinertia * (jy1 * arb.c2.r2x - jx1 * arb.c2.r2y);
				}
				arb.b2.angvel += arb.jrAcc * arb.b2.iinertia;
				arb.b1.angvel -= arb.jrAcc * arb.b1.iinertia;
			}
			arbi = arbi.next;
			if(fst && arbi == null) {
				arbi = this.c_arbiters_true.head;
				fst = false;
			}
		}
		var cx_ite = this.live_constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			con.warmStart();
			cx_ite = cx_ite.next;
		}
	}
	,iterateVel: function(times) {
		var _g = 0;
		var _g1 = times;
		while(_g < _g1) {
			var i = _g++;
			var cx_ite = this.f_arbiters.head;
			while(cx_ite != null) {
				var arb = cx_ite.elt;
				if(arb.active && (arb.immState & 1) != 0) {
					if(!arb.nodrag) {
						var w1 = arb.b1.angvel + arb.b1.kinangvel;
						var w2 = arb.b2.angvel + arb.b2.kinangvel;
						var jx = arb.b1.velx + arb.b1.kinvelx - arb.r1y * w1 - (arb.b2.velx + arb.b2.kinvelx - arb.r2y * w2);
						var jy = arb.b1.vely + arb.b1.kinvely + arb.r1x * w1 - (arb.b2.vely + arb.b2.kinvely + arb.r2x * w2);
						var t = arb.vMassa * jx + arb.vMassb * jy;
						jy = arb.vMassb * jx + arb.vMassc * jy;
						jx = t;
						var t1 = arb.lgamma;
						jx -= arb.dampx * t1;
						jy -= arb.dampy * t1;
						var t2 = 1.0;
						arb.dampx += jx * t2;
						arb.dampy += jy * t2;
						var t3 = arb.b1.imass;
						arb.b1.velx -= jx * t3;
						arb.b1.vely -= jy * t3;
						var t4 = arb.b2.imass;
						arb.b2.velx += jx * t4;
						arb.b2.vely += jy * t4;
						arb.b1.angvel -= arb.b1.iinertia * (jy * arb.r1x - jx * arb.r1y);
						arb.b2.angvel += arb.b2.iinertia * (jy * arb.r2x - jx * arb.r2y);
						var j_damp = (w1 - w2) * arb.wMass - arb.adamp * arb.agamma;
						arb.adamp += j_damp;
						arb.b1.angvel -= j_damp * arb.b1.iinertia;
						arb.b2.angvel += j_damp * arb.b2.iinertia;
					}
				}
				cx_ite = cx_ite.next;
			}
			var pre = null;
			var cx_ite1 = this.live_constraints.head;
			while(cx_ite1 != null) {
				var con = cx_ite1.elt;
				if(con.applyImpulseVel()) {
					cx_ite1 = this.live_constraints.erase(pre);
					con.broken();
					this.constraintCbBreak(con);
					if(con.removeOnBreak) {
						con.component.sleeping = true;
						this.midstep = false;
						if(con.compound != null) {
							con.compound.wrap_constraints.remove(con.outer);
						} else {
							this.wrap_constraints.remove(con.outer);
						}
						this.midstep = true;
					} else {
						con.active = false;
					}
					con.clearcache();
					continue;
				}
				pre = cx_ite1;
				cx_ite1 = cx_ite1.next;
			}
			var arbi = this.c_arbiters_false.head;
			var fst = true;
			if(arbi == null) {
				arbi = this.c_arbiters_true.head;
				fst = false;
			}
			while(arbi != null) {
				var arb1 = arbi.elt;
				if(arb1.active && (arb1.immState & 1) != 0) {
					var jx1;
					var jy1;
					var j;
					var jMax;
					var jOld;
					var cjAcc;
					var v1x = arb1.k1x + arb1.b2.velx - arb1.c1.r2y * arb1.b2.angvel - (arb1.b1.velx - arb1.c1.r1y * arb1.b1.angvel);
					var v1y = arb1.k1y + arb1.b2.vely + arb1.c1.r2x * arb1.b2.angvel - (arb1.b1.vely + arb1.c1.r1x * arb1.b1.angvel);
					if(arb1.hc2) {
						var v2x = arb1.k2x + arb1.b2.velx - arb1.c2.r2y * arb1.b2.angvel - (arb1.b1.velx - arb1.c2.r1y * arb1.b1.angvel);
						var v2y = arb1.k2y + arb1.b2.vely + arb1.c2.r2x * arb1.b2.angvel - (arb1.b1.vely + arb1.c2.r1x * arb1.b1.angvel);
						var ax = arb1.c1.jnAcc;
						var ay = arb1.c2.jnAcc;
						var jnx = v1x * arb1.nx + v1y * arb1.ny + arb1.surfacey + arb1.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (arb1.Ka * ax + arb1.Kb * ay);
						var jny = v2x * arb1.nx + v2y * arb1.ny + arb1.surfacey + arb1.c2.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale - (arb1.Kb * ax + arb1.Kc * ay);
						var xx = -(arb1.kMassa * jnx + arb1.kMassb * jny);
						var xy = -(arb1.kMassb * jnx + arb1.kMassc * jny);
						if(xx >= 0 && xy >= 0) {
							jnx = xx - ax;
							jny = xy - ay;
							arb1.c1.jnAcc = xx;
							arb1.c2.jnAcc = xy;
						} else {
							xx = -arb1.c1.nMass * jnx;
							if(xx >= 0 && arb1.Kb * xx + jny >= 0) {
								jnx = xx - ax;
								jny = -ay;
								arb1.c1.jnAcc = xx;
								arb1.c2.jnAcc = 0;
							} else {
								xy = -arb1.c2.nMass * jny;
								if(xy >= 0 && arb1.Kb * xy + jnx >= 0) {
									jnx = -ax;
									jny = xy - ay;
									arb1.c1.jnAcc = 0;
									arb1.c2.jnAcc = xy;
								} else if(jnx >= 0 && jny >= 0) {
									jnx = -ax;
									jny = -ay;
									arb1.c1.jnAcc = arb1.c2.jnAcc = 0;
								} else {
									jnx = 0;
									jny = 0;
								}
							}
						}
						j = jnx + jny;
						jx1 = arb1.nx * j;
						jy1 = arb1.ny * j;
						arb1.b2.velx += jx1 * arb1.b2.imass;
						arb1.b2.vely += jy1 * arb1.b2.imass;
						arb1.b1.velx -= jx1 * arb1.b1.imass;
						arb1.b1.vely -= jy1 * arb1.b1.imass;
						arb1.b2.angvel += (arb1.rn1b * jnx + arb1.rn2b * jny) * arb1.b2.iinertia;
						arb1.b1.angvel -= (arb1.rn1a * jnx + arb1.rn2a * jny) * arb1.b1.iinertia;
						v1x = arb1.k1x + arb1.b2.velx - arb1.c1.r2y * arb1.b2.angvel - (arb1.b1.velx - arb1.c1.r1y * arb1.b1.angvel);
						v1y = arb1.k1y + arb1.b2.vely + arb1.c1.r2x * arb1.b2.angvel - (arb1.b1.vely + arb1.c1.r1x * arb1.b1.angvel);
						j = (v1y * arb1.nx - v1x * arb1.ny + arb1.surfacex) * arb1.c1.tMass;
						jMax = arb1.c1.friction * arb1.c1.jnAcc;
						jOld = arb1.c1.jtAcc;
						cjAcc = jOld - j;
						if(cjAcc > jMax) {
							cjAcc = jMax;
						} else if(cjAcc < -jMax) {
							cjAcc = -jMax;
						}
						j = cjAcc - jOld;
						arb1.c1.jtAcc = cjAcc;
						jx1 = -arb1.ny * j;
						jy1 = arb1.nx * j;
						arb1.b2.velx += jx1 * arb1.b2.imass;
						arb1.b2.vely += jy1 * arb1.b2.imass;
						arb1.b1.velx -= jx1 * arb1.b1.imass;
						arb1.b1.vely -= jy1 * arb1.b1.imass;
						arb1.b2.angvel += arb1.rt1b * j * arb1.b2.iinertia;
						arb1.b1.angvel -= arb1.rt1a * j * arb1.b1.iinertia;
						v2x = arb1.k2x + arb1.b2.velx - arb1.c2.r2y * arb1.b2.angvel - (arb1.b1.velx - arb1.c2.r1y * arb1.b1.angvel);
						v2y = arb1.k2y + arb1.b2.vely + arb1.c2.r2x * arb1.b2.angvel - (arb1.b1.vely + arb1.c2.r1x * arb1.b1.angvel);
						j = (v2y * arb1.nx - v2x * arb1.ny + arb1.surfacex) * arb1.c2.tMass;
						jMax = arb1.c2.friction * arb1.c2.jnAcc;
						jOld = arb1.c2.jtAcc;
						cjAcc = jOld - j;
						if(cjAcc > jMax) {
							cjAcc = jMax;
						} else if(cjAcc < -jMax) {
							cjAcc = -jMax;
						}
						j = cjAcc - jOld;
						arb1.c2.jtAcc = cjAcc;
						jx1 = -arb1.ny * j;
						jy1 = arb1.nx * j;
						arb1.b2.velx += jx1 * arb1.b2.imass;
						arb1.b2.vely += jy1 * arb1.b2.imass;
						arb1.b1.velx -= jx1 * arb1.b1.imass;
						arb1.b1.vely -= jy1 * arb1.b1.imass;
						arb1.b2.angvel += arb1.rt2b * j * arb1.b2.iinertia;
						arb1.b1.angvel -= arb1.rt2a * j * arb1.b1.iinertia;
					} else {
						j = (arb1.c1.bounce * zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale + (arb1.nx * v1x + arb1.ny * v1y) + arb1.surfacey) * arb1.c1.nMass;
						jOld = arb1.c1.jnAcc;
						cjAcc = jOld - j;
						if(cjAcc < 0.0) {
							cjAcc = 0.0;
						}
						j = cjAcc - jOld;
						arb1.c1.jnAcc = cjAcc;
						jx1 = arb1.nx * j;
						jy1 = arb1.ny * j;
						arb1.b2.velx += jx1 * arb1.b2.imass;
						arb1.b2.vely += jy1 * arb1.b2.imass;
						arb1.b1.velx -= jx1 * arb1.b1.imass;
						arb1.b1.vely -= jy1 * arb1.b1.imass;
						arb1.b2.angvel += arb1.rn1b * j * arb1.b2.iinertia;
						arb1.b1.angvel -= arb1.rn1a * j * arb1.b1.iinertia;
						v1x = arb1.k1x + arb1.b2.velx - arb1.c1.r2y * arb1.b2.angvel - (arb1.b1.velx - arb1.c1.r1y * arb1.b1.angvel);
						v1y = arb1.k1y + arb1.b2.vely + arb1.c1.r2x * arb1.b2.angvel - (arb1.b1.vely + arb1.c1.r1x * arb1.b1.angvel);
						j = (v1y * arb1.nx - v1x * arb1.ny + arb1.surfacex) * arb1.c1.tMass;
						jMax = arb1.c1.friction * arb1.c1.jnAcc;
						jOld = arb1.c1.jtAcc;
						cjAcc = jOld - j;
						if(cjAcc > jMax) {
							cjAcc = jMax;
						} else if(cjAcc < -jMax) {
							cjAcc = -jMax;
						}
						j = cjAcc - jOld;
						arb1.c1.jtAcc = cjAcc;
						jx1 = -arb1.ny * j;
						jy1 = arb1.nx * j;
						arb1.b2.velx += jx1 * arb1.b2.imass;
						arb1.b2.vely += jy1 * arb1.b2.imass;
						arb1.b1.velx -= jx1 * arb1.b1.imass;
						arb1.b1.vely -= jy1 * arb1.b1.imass;
						arb1.b2.angvel += arb1.rt1b * j * arb1.b2.iinertia;
						arb1.b1.angvel -= arb1.rt1a * j * arb1.b1.iinertia;
						if(arb1.radius != 0.0) {
							var dw = arb1.b2.angvel - arb1.b1.angvel;
							j = dw * arb1.rMass;
							jMax = arb1.rfric * arb1.c1.jnAcc;
							jOld = arb1.jrAcc;
							arb1.jrAcc -= j;
							if(arb1.jrAcc > jMax) {
								arb1.jrAcc = jMax;
							} else if(arb1.jrAcc < -jMax) {
								arb1.jrAcc = -jMax;
							}
							j = arb1.jrAcc - jOld;
							arb1.b2.angvel += j * arb1.b2.iinertia;
							arb1.b1.angvel -= j * arb1.b1.iinertia;
						}
					}
				}
				arbi = arbi.next;
				if(fst && arbi == null) {
					arbi = this.c_arbiters_true.head;
					fst = false;
				}
			}
		}
	}
	,iteratePos: function(times) {
		var _g = 0;
		var _g1 = times;
		while(_g < _g1) {
			var i = _g++;
			var pre = null;
			var cx_ite = this.live_constraints.head;
			while(cx_ite != null) {
				var con = cx_ite.elt;
				if(!con.__velocity && con.stiff) {
					if(con.applyImpulsePos()) {
						cx_ite = this.live_constraints.erase(pre);
						con.broken();
						this.constraintCbBreak(con);
						if(con.removeOnBreak) {
							con.component.sleeping = true;
							this.midstep = false;
							if(con.compound != null) {
								con.compound.wrap_constraints.remove(con.outer);
							} else {
								this.wrap_constraints.remove(con.outer);
							}
							this.midstep = true;
						} else {
							con.active = false;
						}
						con.clearcache();
						continue;
					}
				}
				pre = cx_ite;
				cx_ite = cx_ite.next;
			}
			var arbi = this.c_arbiters_false.head;
			var fst = true;
			if(arbi == null) {
				arbi = this.c_arbiters_true.head;
				fst = false;
			}
			while(arbi != null) {
				var arb = arbi.elt;
				if(arb.active && (arb.immState & 1) != 0) {
					if(arb.ptype == 2) {
						var c = arb.c1;
						var r2x = 0.0;
						var r2y = 0.0;
						r2x = arb.b2.axisy * c.lr2x - arb.b2.axisx * c.lr2y;
						r2y = c.lr2x * arb.b2.axisx + c.lr2y * arb.b2.axisy;
						var t = 1.0;
						r2x += arb.b2.posx * t;
						r2y += arb.b2.posy * t;
						var r1x = 0.0;
						var r1y = 0.0;
						r1x = arb.b1.axisy * c.lr1x - arb.b1.axisx * c.lr1y;
						r1y = c.lr1x * arb.b1.axisx + c.lr1y * arb.b1.axisy;
						var t1 = 1.0;
						r1x += arb.b1.posx * t1;
						r1y += arb.b1.posy * t1;
						var dx = 0.0;
						var dy = 0.0;
						dx = r2x - r1x;
						dy = r2y - r1y;
						var x = dx * dx + dy * dy;
						var dl;
						if(x == 0.0) {
							dl = 0.0;
						} else {
							zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
							zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
							var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
							dl = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
						}
						var r = arb.radius - nape_Config.collisionSlop;
						var err = dl - r;
						if(dx * arb.nx + dy * arb.ny < 0) {
							dx = -dx;
							dy = -dy;
							err -= arb.radius;
						}
						if(err < 0) {
							if(dl < nape_Config.epsilon) {
								if(arb.b1.smass != 0.0) {
									arb.b1.posx += nape_Config.epsilon * 10;
								} else {
									arb.b2.posx += nape_Config.epsilon * 10;
								}
							} else {
								var t2 = 1.0 / dl;
								dx *= t2;
								dy *= t2;
								var px = 0.5 * (r1x + r2x);
								var py = 0.5 * (r1y + r2y);
								var pen = dl - r;
								r1x = px - arb.b1.posx;
								r1y = py - arb.b1.posy;
								r2x = px - arb.b2.posx;
								r2y = py - arb.b2.posy;
								var rn1 = dy * r1x - dx * r1y;
								var rn2 = dy * r2x - dx * r2y;
								var K = arb.b2.smass + rn2 * rn2 * arb.b2.sinertia + arb.b1.smass + rn1 * rn1 * arb.b1.sinertia;
								if(K != 0) {
									var jn = -arb.c1.biasCoef * pen / K;
									var Jx = 0.0;
									var Jy = 0.0;
									var t3 = jn;
									Jx = dx * t3;
									Jy = dy * t3;
									var t4 = arb.b1.imass;
									arb.b1.posx -= Jx * t4;
									arb.b1.posy -= Jy * t4;
									var _this = arb.b1;
									var dr = -rn1 * arb.b1.iinertia * jn;
									_this.rot += dr;
									if(dr * dr > 0.0001) {
										_this.axisx = Math.sin(_this.rot);
										_this.axisy = Math.cos(_this.rot);
									} else {
										var d2 = dr * dr;
										var p = 1 - 0.5 * d2;
										var m = 1 - d2 * d2 / 8;
										var nx = (p * _this.axisx + dr * _this.axisy) * m;
										_this.axisy = (p * _this.axisy - dr * _this.axisx) * m;
										_this.axisx = nx;
									}
									var t5 = arb.b2.imass;
									arb.b2.posx += Jx * t5;
									arb.b2.posy += Jy * t5;
									var _this1 = arb.b2;
									var dr1 = rn2 * arb.b2.iinertia * jn;
									_this1.rot += dr1;
									if(dr1 * dr1 > 0.0001) {
										_this1.axisx = Math.sin(_this1.rot);
										_this1.axisy = Math.cos(_this1.rot);
									} else {
										var d21 = dr1 * dr1;
										var p1 = 1 - 0.5 * d21;
										var m1 = 1 - d21 * d21 / 8;
										var nx1 = (p1 * _this1.axisx + dr1 * _this1.axisy) * m1;
										_this1.axisy = (p1 * _this1.axisy - dr1 * _this1.axisx) * m1;
										_this1.axisx = nx1;
									}
								}
							}
						}
					} else {
						var gnormx = 0.0;
						var gnormy = 0.0;
						var gproj;
						var clip1x = 0.0;
						var clip1y = 0.0;
						var clip2x = 0;
						var clip2y = 0;
						if(arb.ptype == 0) {
							gnormx = arb.b1.axisy * arb.lnormx - arb.b1.axisx * arb.lnormy;
							gnormy = arb.lnormx * arb.b1.axisx + arb.lnormy * arb.b1.axisy;
							gproj = arb.lproj + (gnormx * arb.b1.posx + gnormy * arb.b1.posy);
							clip1x = arb.b2.axisy * arb.c1.lr1x - arb.b2.axisx * arb.c1.lr1y;
							clip1y = arb.c1.lr1x * arb.b2.axisx + arb.c1.lr1y * arb.b2.axisy;
							var t6 = 1.0;
							clip1x += arb.b2.posx * t6;
							clip1y += arb.b2.posy * t6;
							if(arb.hpc2) {
								clip2x = arb.b2.axisy * arb.c2.lr1x - arb.b2.axisx * arb.c2.lr1y;
								clip2y = arb.c2.lr1x * arb.b2.axisx + arb.c2.lr1y * arb.b2.axisy;
								var t7 = 1.0;
								clip2x += arb.b2.posx * t7;
								clip2y += arb.b2.posy * t7;
							}
						} else {
							gnormx = arb.b2.axisy * arb.lnormx - arb.b2.axisx * arb.lnormy;
							gnormy = arb.lnormx * arb.b2.axisx + arb.lnormy * arb.b2.axisy;
							gproj = arb.lproj + (gnormx * arb.b2.posx + gnormy * arb.b2.posy);
							clip1x = arb.b1.axisy * arb.c1.lr1x - arb.b1.axisx * arb.c1.lr1y;
							clip1y = arb.c1.lr1x * arb.b1.axisx + arb.c1.lr1y * arb.b1.axisy;
							var t8 = 1.0;
							clip1x += arb.b1.posx * t8;
							clip1y += arb.b1.posy * t8;
							if(arb.hpc2) {
								clip2x = arb.b1.axisy * arb.c2.lr1x - arb.b1.axisx * arb.c2.lr1y;
								clip2y = arb.c2.lr1x * arb.b1.axisx + arb.c2.lr1y * arb.b1.axisy;
								var t9 = 1.0;
								clip2x += arb.b1.posx * t9;
								clip2y += arb.b1.posy * t9;
							}
						}
						var err1 = clip1x * gnormx + clip1y * gnormy - gproj - arb.radius;
						err1 += nape_Config.collisionSlop;
						var err2 = 0.0;
						if(arb.hpc2) {
							err2 = clip2x * gnormx + clip2y * gnormy - gproj - arb.radius;
							err2 += nape_Config.collisionSlop;
						}
						if(err1 < 0 || err2 < 0) {
							if(arb.rev) {
								gnormx = -gnormx;
								gnormy = -gnormy;
							}
							var c1r1x = 0.0;
							var c1r1y = 0.0;
							c1r1x = clip1x - arb.b1.posx;
							c1r1y = clip1y - arb.b1.posy;
							var c1r2x = 0.0;
							var c1r2y = 0.0;
							c1r2x = clip1x - arb.b2.posx;
							c1r2y = clip1y - arb.b2.posy;
							var c2r1x = 0;
							var c2r1y = 0;
							var c2r2x = 0;
							var c2r2y = 0;
							if(arb.hpc2) {
								c2r1x = clip2x - arb.b1.posx;
								c2r1y = clip2y - arb.b1.posy;
								c2r2x = clip2x - arb.b2.posx;
								c2r2y = clip2y - arb.b2.posy;
								var rn1a = gnormy * c1r1x - gnormx * c1r1y;
								var rn1b = gnormy * c1r2x - gnormx * c1r2y;
								var rn2a = gnormy * c2r1x - gnormx * c2r1y;
								var rn2b = gnormy * c2r2x - gnormx * c2r2y;
								var mass_sum = arb.b1.smass + arb.b2.smass;
								arb.kMassa = mass_sum + arb.b1.sinertia * rn1a * rn1a + arb.b2.sinertia * rn1b * rn1b;
								arb.kMassb = mass_sum + arb.b1.sinertia * rn1a * rn2a + arb.b2.sinertia * rn1b * rn2b;
								arb.kMassc = mass_sum + arb.b1.sinertia * rn2a * rn2a + arb.b2.sinertia * rn2b * rn2b;
								var Ka = 0.0;
								var Kb = 0.0;
								var Kc = 0.0;
								Ka = arb.kMassa;
								Kb = arb.kMassb;
								Kc = arb.kMassc;
								var pbias = (arb.c1.biasCoef + arb.c2.biasCoef) * 0.5;
								var bx = err1 * pbias;
								var by = err2 * pbias;
								do {
									var xx = 0.0;
									var xy = 0.0;
									xx = bx;
									xy = by;
									xx = -xx;
									xy = -xy;
									var det = arb.kMassa * arb.kMassc - arb.kMassb * arb.kMassb;
									if(det != det) {
										xy = 0;
										xx = xy;
									} else if(det == 0) {
										if(arb.kMassa != 0) {
											xx /= arb.kMassa;
										} else {
											xx = 0;
										}
										if(arb.kMassc != 0) {
											xy /= arb.kMassc;
										} else {
											xy = 0;
										}
									} else {
										det = 1 / det;
										var t10 = det * (arb.kMassc * xx - arb.kMassb * xy);
										xy = det * (arb.kMassa * xy - arb.kMassb * xx);
										xx = t10;
									}
									if(xx >= 0 && xy >= 0) {
										var t11 = (xx + xy) * arb.b1.imass;
										arb.b1.posx -= gnormx * t11;
										arb.b1.posy -= gnormy * t11;
										var _this2 = arb.b1;
										var dr2 = -arb.b1.iinertia * (rn1a * xx + rn2a * xy);
										_this2.rot += dr2;
										if(dr2 * dr2 > 0.0001) {
											_this2.axisx = Math.sin(_this2.rot);
											_this2.axisy = Math.cos(_this2.rot);
										} else {
											var d22 = dr2 * dr2;
											var p2 = 1 - 0.5 * d22;
											var m2 = 1 - d22 * d22 / 8;
											var nx2 = (p2 * _this2.axisx + dr2 * _this2.axisy) * m2;
											_this2.axisy = (p2 * _this2.axisy - dr2 * _this2.axisx) * m2;
											_this2.axisx = nx2;
										}
										var t12 = (xx + xy) * arb.b2.imass;
										arb.b2.posx += gnormx * t12;
										arb.b2.posy += gnormy * t12;
										var _this3 = arb.b2;
										var dr3 = arb.b2.iinertia * (rn1b * xx + rn2b * xy);
										_this3.rot += dr3;
										if(dr3 * dr3 > 0.0001) {
											_this3.axisx = Math.sin(_this3.rot);
											_this3.axisy = Math.cos(_this3.rot);
										} else {
											var d23 = dr3 * dr3;
											var p3 = 1 - 0.5 * d23;
											var m3 = 1 - d23 * d23 / 8;
											var nx3 = (p3 * _this3.axisx + dr3 * _this3.axisy) * m3;
											_this3.axisy = (p3 * _this3.axisy - dr3 * _this3.axisx) * m3;
											_this3.axisx = nx3;
										}
										break;
									}
									xx = -bx / Ka;
									xy = 0;
									var vn2 = Kb * xx + by;
									if(xx >= 0 && vn2 >= 0) {
										var t13 = (xx + xy) * arb.b1.imass;
										arb.b1.posx -= gnormx * t13;
										arb.b1.posy -= gnormy * t13;
										var _this4 = arb.b1;
										var dr4 = -arb.b1.iinertia * (rn1a * xx + rn2a * xy);
										_this4.rot += dr4;
										if(dr4 * dr4 > 0.0001) {
											_this4.axisx = Math.sin(_this4.rot);
											_this4.axisy = Math.cos(_this4.rot);
										} else {
											var d24 = dr4 * dr4;
											var p4 = 1 - 0.5 * d24;
											var m4 = 1 - d24 * d24 / 8;
											var nx4 = (p4 * _this4.axisx + dr4 * _this4.axisy) * m4;
											_this4.axisy = (p4 * _this4.axisy - dr4 * _this4.axisx) * m4;
											_this4.axisx = nx4;
										}
										var t14 = (xx + xy) * arb.b2.imass;
										arb.b2.posx += gnormx * t14;
										arb.b2.posy += gnormy * t14;
										var _this5 = arb.b2;
										var dr5 = arb.b2.iinertia * (rn1b * xx + rn2b * xy);
										_this5.rot += dr5;
										if(dr5 * dr5 > 0.0001) {
											_this5.axisx = Math.sin(_this5.rot);
											_this5.axisy = Math.cos(_this5.rot);
										} else {
											var d25 = dr5 * dr5;
											var p5 = 1 - 0.5 * d25;
											var m5 = 1 - d25 * d25 / 8;
											var nx5 = (p5 * _this5.axisx + dr5 * _this5.axisy) * m5;
											_this5.axisy = (p5 * _this5.axisy - dr5 * _this5.axisx) * m5;
											_this5.axisx = nx5;
										}
										break;
									}
									xx = 0;
									xy = -by / Kc;
									var vn1 = Kb * xy + bx;
									if(xy >= 0 && vn1 >= 0) {
										var t15 = (xx + xy) * arb.b1.imass;
										arb.b1.posx -= gnormx * t15;
										arb.b1.posy -= gnormy * t15;
										var _this6 = arb.b1;
										var dr6 = -arb.b1.iinertia * (rn1a * xx + rn2a * xy);
										_this6.rot += dr6;
										if(dr6 * dr6 > 0.0001) {
											_this6.axisx = Math.sin(_this6.rot);
											_this6.axisy = Math.cos(_this6.rot);
										} else {
											var d26 = dr6 * dr6;
											var p6 = 1 - 0.5 * d26;
											var m6 = 1 - d26 * d26 / 8;
											var nx6 = (p6 * _this6.axisx + dr6 * _this6.axisy) * m6;
											_this6.axisy = (p6 * _this6.axisy - dr6 * _this6.axisx) * m6;
											_this6.axisx = nx6;
										}
										var t16 = (xx + xy) * arb.b2.imass;
										arb.b2.posx += gnormx * t16;
										arb.b2.posy += gnormy * t16;
										var _this7 = arb.b2;
										var dr7 = arb.b2.iinertia * (rn1b * xx + rn2b * xy);
										_this7.rot += dr7;
										if(dr7 * dr7 > 0.0001) {
											_this7.axisx = Math.sin(_this7.rot);
											_this7.axisy = Math.cos(_this7.rot);
										} else {
											var d27 = dr7 * dr7;
											var p7 = 1 - 0.5 * d27;
											var m7 = 1 - d27 * d27 / 8;
											var nx7 = (p7 * _this7.axisx + dr7 * _this7.axisy) * m7;
											_this7.axisy = (p7 * _this7.axisy - dr7 * _this7.axisx) * m7;
											_this7.axisx = nx7;
										}
										break;
									}
								} while(false);
							} else {
								var rn11 = gnormy * c1r1x - gnormx * c1r1y;
								var rn21 = gnormy * c1r2x - gnormx * c1r2y;
								var K1 = arb.b2.smass + rn21 * rn21 * arb.b2.sinertia + arb.b1.smass + rn11 * rn11 * arb.b1.sinertia;
								if(K1 != 0) {
									var jn1 = -arb.c1.biasCoef * err1 / K1;
									var Jx1 = 0.0;
									var Jy1 = 0.0;
									var t17 = jn1;
									Jx1 = gnormx * t17;
									Jy1 = gnormy * t17;
									var t18 = arb.b1.imass;
									arb.b1.posx -= Jx1 * t18;
									arb.b1.posy -= Jy1 * t18;
									var _this8 = arb.b1;
									var dr8 = -rn11 * arb.b1.iinertia * jn1;
									_this8.rot += dr8;
									if(dr8 * dr8 > 0.0001) {
										_this8.axisx = Math.sin(_this8.rot);
										_this8.axisy = Math.cos(_this8.rot);
									} else {
										var d28 = dr8 * dr8;
										var p8 = 1 - 0.5 * d28;
										var m8 = 1 - d28 * d28 / 8;
										var nx8 = (p8 * _this8.axisx + dr8 * _this8.axisy) * m8;
										_this8.axisy = (p8 * _this8.axisy - dr8 * _this8.axisx) * m8;
										_this8.axisx = nx8;
									}
									var t19 = arb.b2.imass;
									arb.b2.posx += Jx1 * t19;
									arb.b2.posy += Jy1 * t19;
									var _this9 = arb.b2;
									var dr9 = rn21 * arb.b2.iinertia * jn1;
									_this9.rot += dr9;
									if(dr9 * dr9 > 0.0001) {
										_this9.axisx = Math.sin(_this9.rot);
										_this9.axisy = Math.cos(_this9.rot);
									} else {
										var d29 = dr9 * dr9;
										var p9 = 1 - 0.5 * d29;
										var m9 = 1 - d29 * d29 / 8;
										var nx9 = (p9 * _this9.axisx + dr9 * _this9.axisy) * m9;
										_this9.axisy = (p9 * _this9.axisy - dr9 * _this9.axisx) * m9;
										_this9.axisx = nx9;
									}
								}
							}
						}
					}
				}
				arbi = arbi.next;
				if(fst && arbi == null) {
					arbi = this.c_arbiters_true.head;
					fst = false;
				}
			}
		}
	}
	,narrowPhase: function(s1,s2,stat,in_arb,continuous) {
		var _gthis = this;
		var ret = null;
		var b1 = s1.body;
		var b2 = s2.body;
		var con_ignore;
		con_ignore = false;
		var cx_ite = b1.constraints.head;
		while(cx_ite != null) {
			var con = cx_ite.elt;
			if(con.ignore && con.pair_exists(b1.id,b2.id)) {
				con_ignore = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		var itype;
		var itype1;
		if(!con_ignore) {
			var cur = s1;
			while(cur != null && cur.group == null) if(cur.ishape != null) {
				cur = cur.ishape.body;
			} else if(cur.icompound != null) {
				cur = cur.icompound.compound;
			} else {
				cur = cur.ibody.compound;
			}
			var g1 = cur == null ? null : cur.group;
			var itype2;
			if(g1 == null) {
				itype2 = false;
			} else {
				var cur = s2;
				while(cur != null && cur.group == null) if(cur.ishape != null) {
					cur = cur.ishape.body;
				} else if(cur.icompound != null) {
					cur = cur.icompound.compound;
				} else {
					cur = cur.ibody.compound;
				}
				var g2 = cur == null ? null : cur.group;
				if(g2 == null) {
					itype2 = false;
				} else {
					var ret1 = false;
					while(g1 != null && g2 != null) {
						if(g1 == g2) {
							ret1 = g1.ignore;
							break;
						}
						if(g1.depth < g2.depth) {
							g2 = g2.group;
						} else {
							g1 = g1.group;
						}
					}
					itype2 = ret1;
				}
			}
			itype1 = !itype2;
		} else {
			itype1 = false;
		}
		if(itype1) {
			var itype1;
			if(s1.sensorEnabled || s2.sensorEnabled) {
				var _this = s1.filter;
				var x = s2.filter;
				itype1 = (_this.sensorMask & x.sensorGroup) != 0 && (x.sensorMask & _this.sensorGroup) != 0;
			} else {
				itype1 = false;
			}
			if(itype1) {
				itype = 2;
			} else {
				var itype1;
				if(s1.fluidEnabled || s2.fluidEnabled) {
					var _this = s1.filter;
					var x = s2.filter;
					itype1 = (_this.fluidMask & x.fluidGroup) != 0 && (x.fluidMask & _this.fluidGroup) != 0;
				} else {
					itype1 = false;
				}
				if(itype1 && !(b1.imass == 0 && b2.imass == 0 && b1.iinertia == 0 && b2.iinertia == 0)) {
					itype = 0;
				} else {
					var _this = s1.filter;
					var x = s2.filter;
					itype = (_this.collisionMask & x.collisionGroup) != 0 && (x.collisionMask & _this.collisionGroup) != 0 && !(b1.imass == 0 && b2.imass == 0 && b1.iinertia == 0 && b2.iinertia == 0) ? 1 : -1;
				}
			}
		} else {
			itype = -1;
		}
		if(itype != -1) {
			var sa;
			var sb;
			if(s1.type > s2.type) {
				sa = s2;
				sb = s1;
			} else if(s1.type == s2.type) {
				if(s1.id < s2.id) {
					sa = s1;
					sb = s2;
				} else {
					sb = s1;
					sa = s2;
				}
			} else {
				sa = s1;
				sb = s2;
			}
			var reverse = sa == s2;
			if(itype == 0) {
				var xarb;
				if(in_arb == null) {
					var ret1 = null;
					var b = b1.arbiters.length < b2.arbiters.length ? b1 : b2;
					var cx_ite = b.arbiters.head;
					while(cx_ite != null) {
						var arb = cx_ite.elt;
						if(arb.id == sa.id && arb.di == sb.id) {
							ret1 = arb;
							break;
						}
						cx_ite = cx_ite.next;
					}
					xarb = ret1;
				} else {
					xarb = in_arb;
				}
				var first = xarb == null;
				var arb;
				var swapped = false;
				if(first) {
					if(zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool == null) {
						arb = new zpp_$nape_dynamics_ZPP_$FluidArbiter();
					} else {
						arb = zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool = arb.next;
						arb.next = null;
					}
				} else if(xarb.fluidarb == null) {
					var b = null;
					xarb.cleared = true;
					if(b == null || xarb.b2 == b) {
						var _this = xarb.b1.arbiters;
						var pre = null;
						var cur = _this.head;
						var ret1 = false;
						while(cur != null) {
							if(cur.elt == xarb) {
								var old;
								var ret2;
								if(pre == null) {
									old = _this.head;
									ret2 = old.next;
									_this.head = ret2;
									if(_this.head == null) {
										_this.pushmod = true;
									}
								} else {
									old = pre.next;
									ret2 = old.next;
									pre.next = ret2;
									if(ret2 == null) {
										_this.pushmod = true;
									}
								}
								var o = old;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
								_this.modified = true;
								_this.length--;
								_this.pushmod = true;
								ret1 = true;
								break;
							}
							pre = cur;
							cur = cur.next;
						}
					}
					if(b == null || xarb.b1 == b) {
						var _this = xarb.b2.arbiters;
						var pre = null;
						var cur = _this.head;
						var ret1 = false;
						while(cur != null) {
							if(cur.elt == xarb) {
								var old;
								var ret2;
								if(pre == null) {
									old = _this.head;
									ret2 = old.next;
									_this.head = ret2;
									if(_this.head == null) {
										_this.pushmod = true;
									}
								} else {
									old = pre.next;
									ret2 = old.next;
									pre.next = ret2;
									if(ret2 == null) {
										_this.pushmod = true;
									}
								}
								var o = old;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
								_this.modified = true;
								_this.length--;
								_this.pushmod = true;
								ret1 = true;
								break;
							}
							pre = cur;
							cur = cur.next;
						}
					}
					if(xarb.pair != null) {
						xarb.pair.arb = null;
						xarb.pair = null;
					}
					xarb.active = false;
					this.f_arbiters.modified = true;
					if(zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool == null) {
						arb = new zpp_$nape_dynamics_ZPP_$FluidArbiter();
					} else {
						arb = zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool = arb.next;
						arb.next = null;
					}
					arb.intchange = true;
					first = true;
					swapped = true;
				} else {
					arb = xarb.fluidarb;
				}
				var inttype = 4;
				if(first || arb.stamp != this.stamp || continuous) {
					arb.stamp = this.stamp;
					if(zpp_$nape_geom_ZPP_$Collide.flowCollide(sa,sb,arb)) {
						if(first) {
							var di = sb.id;
							arb.b1 = s1.body;
							arb.ws1 = s1;
							arb.b2 = s2.body;
							arb.ws2 = s2;
							arb.id = sa.id;
							arb.di = di;
							var _this = arb.b1.arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							var _this = arb.b2.arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							arb.active = true;
							arb.present = 0;
							arb.cleared = false;
							arb.sleeping = false;
							arb.fresh = false;
							arb.presentable = false;
							arb.nx = 0;
							arb.ny = 1;
							arb.dampx = 0;
							arb.dampy = 0;
							arb.adamp = 0.0;
							var _this = this.f_arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							arb.fresh = !swapped;
						} else {
							arb.fresh = arb.up_stamp < this.stamp - 1 || arb.endGenerated == this.stamp && continuous;
						}
						arb.up_stamp = arb.stamp;
						if(arb.fresh || (arb.immState & 4) == 0) {
							arb.immState = 1;
							var anyimpure = false;
							var arbs1 = arb.ws1.id > arb.ws2.id ? arb.ws2 : arb.ws1;
							var arbs2 = arb.ws1.id > arb.ws2.id ? arb.ws1 : arb.ws2;
							var _this = this.mrca1;
							while(_this.head != null) {
								var ret1 = _this.head;
								_this.head = ret1.next;
								var o = ret1;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
								if(_this.head == null) {
									_this.pushmod = true;
								}
								_this.modified = true;
								_this.length--;
							}
							_this.pushmod = true;
							var _this = this.mrca2;
							while(_this.head != null) {
								var ret1 = _this.head;
								_this.head = ret1.next;
								var o = ret1;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
								if(_this.head == null) {
									_this.pushmod = true;
								}
								_this.modified = true;
								_this.length--;
							}
							_this.pushmod = true;
							if(arbs1.cbSet != null) {
								var _this = this.mrca1;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = arbs1;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs1.body.cbSet != null) {
								var _this = this.mrca1;
								var o = arbs1.body;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = o;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs2.cbSet != null) {
								var _this = this.mrca2;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = arbs2;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs2.body.cbSet != null) {
								var _this = this.mrca2;
								var o = arbs2.body;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = o;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							var c1 = arbs1.body.compound;
							var c2 = arbs2.body.compound;
							while(c1 != c2) {
								var d1 = c1 == null ? 0 : c1.depth;
								var d2 = c2 == null ? 0 : c2.depth;
								if(d1 < d2) {
									if(c2.cbSet != null) {
										var _this = this.mrca2;
										var ret1;
										if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
											ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
										} else {
											ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
											zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
											ret1.next = null;
										}
										ret1.elt = c2;
										var temp = ret1;
										temp.next = _this.head;
										_this.head = temp;
										_this.modified = true;
										_this.length++;
									}
									c2 = c2.compound;
								} else {
									if(c1.cbSet != null) {
										var _this1 = this.mrca1;
										var ret2;
										if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
											ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
										} else {
											ret2 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
											zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.elt = c1;
										var temp1 = ret2;
										temp1.next = _this1.head;
										_this1.head = temp1;
										_this1.modified = true;
										_this1.length++;
									}
									c1 = c1.compound;
								}
							}
							var cx_ite = this.mrca1.head;
							while(cx_ite != null) {
								var i1 = cx_ite.elt;
								var cx_ite1 = this.mrca2.head;
								while(cx_ite1 != null) {
									var i2 = cx_ite1.elt;
									var cb1 = i1.cbSet;
									var cb2 = i2.cbSet;
									var _this = cb1.manager;
									var ret1 = null;
									var pairs = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
									var cx_ite2 = pairs.head;
									while(cx_ite2 != null) {
										var p = cx_ite2.elt;
										if(p.a == cb1 && p.b == cb2 || p.a == cb2 && p.b == cb1) {
											ret1 = p;
											break;
										}
										cx_ite2 = cx_ite2.next;
									}
									if(ret1 == null) {
										var ret2;
										if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
											ret2 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
										} else {
											ret2 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
											zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.zip_listeners = true;
										if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
											ret2.a = cb1;
											ret2.b = cb2;
										} else {
											ret2.a = cb2;
											ret2.b = cb1;
										}
										ret1 = ret2;
										cb1.cbpairs.add(ret1);
										if(cb2 != cb1) {
											cb2.cbpairs.add(ret1);
										}
									}
									if(ret1.zip_listeners) {
										ret1.zip_listeners = false;
										ret1.__validate();
									}
									if(ret1.listeners.head == null) {
										cx_ite1 = cx_ite1.next;
										continue;
									}
									var callbackset = null;
									var ncallbackset = null;
									var _this1 = this.prelisteners;
									while(_this1.head != null) {
										var ret3 = _this1.head;
										_this1.head = ret3.next;
										var o = ret3;
										o.elt = null;
										o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
										zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = o;
										if(_this1.head == null) {
											_this1.pushmod = true;
										}
										_this1.modified = true;
										_this1.length--;
									}
									_this1.pushmod = true;
									var lite = null;
									var _this2 = cb1.manager;
									var ret4 = null;
									var pairs1 = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
									var cx_ite3 = pairs1.head;
									while(cx_ite3 != null) {
										var p1 = cx_ite3.elt;
										if(p1.a == cb1 && p1.b == cb2 || p1.a == cb2 && p1.b == cb1) {
											ret4 = p1;
											break;
										}
										cx_ite3 = cx_ite3.next;
									}
									if(ret4 == null) {
										var ret5;
										if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
											ret5 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
										} else {
											ret5 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
											zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.zip_listeners = true;
										if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
											ret5.a = cb1;
											ret5.b = cb2;
										} else {
											ret5.a = cb2;
											ret5.b = cb1;
										}
										ret4 = ret5;
										cb1.cbpairs.add(ret4);
										if(cb2 != cb1) {
											cb2.cbpairs.add(ret4);
										}
									}
									if(ret4.zip_listeners) {
										ret4.zip_listeners = false;
										ret4.__validate();
									}
									var cx_ite4 = ret4.listeners.head;
									while(cx_ite4 != null) {
										var x = cx_ite4.elt;
										if(x.event == 5) {
											if((x.itype & inttype) != 0) {
												var _this3 = _gthis.prelisteners;
												var ret6;
												if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
													ret6 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
												} else {
													ret6 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
													zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret6.next;
													ret6.next = null;
												}
												ret6.elt = x;
												var temp = ret6;
												if(lite == null) {
													temp.next = _this3.head;
													_this3.head = temp;
												} else {
													temp.next = lite.next;
													lite.next = temp;
												}
												_this3.pushmod = _this3.modified = true;
												_this3.length++;
												lite = temp;
												anyimpure = anyimpure || !x.pure;
											}
										}
										cx_ite4 = cx_ite4.next;
									}
									if(this.prelisteners.head == null) {
										cx_ite1 = cx_ite1.next;
										continue;
									}
									callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
									if(callbackset == null) {
										ncallbackset = zpp_$nape_space_ZPP_$CallbackSet.get(i1,i2);
										this.add_callbackset(ncallbackset);
									}
									if(callbackset == null || (callbackset.FLUIDstamp != this.stamp || continuous) && (callbackset.FLUIDstate & 4) == 0) {
										if(ncallbackset != null) {
											callbackset = ncallbackset;
										}
										if(callbackset != null) {
											var cx_ite5 = this.prelisteners.head;
											while(cx_ite5 != null) {
												var listener = cx_ite5.elt;
												if(listener.itype == 7) {
													callbackset.COLLISIONstamp = this.stamp;
													callbackset.SENSORstamp = this.stamp;
													callbackset.FLUIDstamp = this.stamp;
												} else {
													callbackset.FLUIDstamp = this.stamp;
												}
												cx_ite5 = cx_ite5.next;
											}
										}
										var pact = arb.active;
										arb.active = true;
										var emptycontacts = false;
										this.precb.zpp_inner.pre_arbiter = arb;
										this.precb.zpp_inner.set = callbackset;
										var cx_ite6 = this.prelisteners.head;
										while(cx_ite6 != null) {
											var listener1 = cx_ite6.elt;
											this.precb.zpp_inner.listener = listener1;
											var cb = this.precb.zpp_inner;
											var o1 = callbackset.int1;
											var o2 = callbackset.int2;
											var ret7;
											var _this4 = listener1.options1;
											var xs = o1.cbTypes;
											if(_this4.nonemptyintersection(xs,_this4.includes) && !_this4.nonemptyintersection(xs,_this4.excludes)) {
												var _this5 = listener1.options2;
												var xs1 = o2.cbTypes;
												ret7 = _this5.nonemptyintersection(xs1,_this5.includes) && !_this5.nonemptyintersection(xs1,_this5.excludes);
											} else {
												ret7 = false;
											}
											if(ret7) {
												cb.int1 = o1;
												cb.int2 = o2;
											} else {
												cb.int1 = o2;
												cb.int2 = o1;
											}
											this.precb.zpp_inner.pre_swapped = i1 != this.precb.zpp_inner.int1;
											var ret8 = listener1.handlerp(this.precb);
											if(ret8 != null) {
												var ret9;
												if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
													zpp_$nape_util_ZPP_$Flags.internal = true;
													zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
													zpp_$nape_util_ZPP_$Flags.internal = false;
												}
												if(ret8 == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT) {
													ret9 = 5;
												} else {
													if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
														zpp_$nape_util_ZPP_$Flags.internal = true;
														zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
														zpp_$nape_util_ZPP_$Flags.internal = false;
													}
													if(ret8 == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE) {
														ret9 = 1;
													} else {
														if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
															zpp_$nape_util_ZPP_$Flags.internal = true;
															zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
															zpp_$nape_util_ZPP_$Flags.internal = false;
														}
														ret9 = ret8 == zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE ? 6 : 2;
													}
												}
												arb.immState = ret9;
											}
											cx_ite6 = cx_ite6.next;
										}
										arb.active = pact;
										if(callbackset != null) {
											var cx_ite7 = this.prelisteners.head;
											while(cx_ite7 != null) {
												var listener2 = cx_ite7.elt;
												if(listener2.itype == 7) {
													callbackset.COLLISIONstate = arb.immState;
													callbackset.SENSORstate = arb.immState;
													callbackset.FLUIDstate = arb.immState;
												} else {
													callbackset.FLUIDstate = arb.immState;
												}
												cx_ite7 = cx_ite7.next;
											}
										}
									} else if(callbackset == null) {
										if((arb.immState & 4) == 0) {
											arb.immState = 1;
										}
									} else {
										arb.immState = callbackset.FLUIDstate;
									}
									cx_ite1 = cx_ite1.next;
								}
								cx_ite = cx_ite.next;
							}
							if(anyimpure && (arb.immState & 4) == 0) {
								if(arb.b1.type == 2) {
									var o = arb.b1;
									if(!o.world) {
										o.component.waket = this.stamp + (this.midstep ? 0 : 1);
										if(o.type == 3) {
											o.kinematicDelaySleep = true;
										}
										if(o.component.sleeping) {
											this.really_wake(o,false);
										}
									}
								}
								if(arb.b1.type == 2) {
									var o = arb.b2;
									if(!o.world) {
										o.component.waket = this.stamp + (this.midstep ? 0 : 1);
										if(o.type == 3) {
											o.kinematicDelaySleep = true;
										}
										if(o.component.sleeping) {
											this.really_wake(o,false);
										}
									}
								}
							}
						}
						if((arb.immState & 1) != 0) {
							if(arb.b1.type == 2 && arb.b1.component.sleeping) {
								var o = arb.b1;
								if(!o.world) {
									o.component.waket = this.stamp + (this.midstep ? 0 : 1);
									if(o.type == 3) {
										o.kinematicDelaySleep = true;
									}
									if(o.component.sleeping) {
										this.really_wake(o,false);
									}
								}
							}
							if(arb.b2.type == 2 && arb.b2.component.sleeping) {
								var o = arb.b2;
								if(!o.world) {
									o.component.waket = this.stamp + (this.midstep ? 0 : 1);
									if(o.type == 3) {
										o.kinematicDelaySleep = true;
									}
									if(o.component.sleeping) {
										this.really_wake(o,false);
									}
								}
							}
						}
						if(arb.sleeping) {
							arb.sleeping = false;
							var _this = this.f_arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
						}
						ret = arb;
					} else if(first) {
						var o = arb;
						o.next = zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$FluidArbiter.zpp_pool = o;
						ret = null;
					} else {
						ret = arb;
					}
				} else {
					ret = arb;
				}
			} else if(itype == 1) {
				var carbs = stat ? this.c_arbiters_true : this.c_arbiters_false;
				var xarb;
				if(in_arb == null) {
					var ret1 = null;
					var b = b1.arbiters.length < b2.arbiters.length ? b1 : b2;
					var cx_ite = b.arbiters.head;
					while(cx_ite != null) {
						var arb = cx_ite.elt;
						if(arb.id == sa.id && arb.di == sb.id) {
							ret1 = arb;
							break;
						}
						cx_ite = cx_ite.next;
					}
					xarb = ret1;
				} else {
					xarb = in_arb;
				}
				var first = xarb == null;
				var arb;
				var swapped = false;
				if(first) {
					if(zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool == null) {
						arb = new zpp_$nape_dynamics_ZPP_$ColArbiter();
					} else {
						arb = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = arb.next;
						arb.next = null;
					}
					arb.stat = stat;
				} else if(xarb.colarb == null) {
					var b = null;
					xarb.cleared = true;
					if(b == null || xarb.b2 == b) {
						var _this = xarb.b1.arbiters;
						var pre = null;
						var cur = _this.head;
						var ret1 = false;
						while(cur != null) {
							if(cur.elt == xarb) {
								var old;
								var ret2;
								if(pre == null) {
									old = _this.head;
									ret2 = old.next;
									_this.head = ret2;
									if(_this.head == null) {
										_this.pushmod = true;
									}
								} else {
									old = pre.next;
									ret2 = old.next;
									pre.next = ret2;
									if(ret2 == null) {
										_this.pushmod = true;
									}
								}
								var o = old;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
								_this.modified = true;
								_this.length--;
								_this.pushmod = true;
								ret1 = true;
								break;
							}
							pre = cur;
							cur = cur.next;
						}
					}
					if(b == null || xarb.b1 == b) {
						var _this = xarb.b2.arbiters;
						var pre = null;
						var cur = _this.head;
						var ret1 = false;
						while(cur != null) {
							if(cur.elt == xarb) {
								var old;
								var ret2;
								if(pre == null) {
									old = _this.head;
									ret2 = old.next;
									_this.head = ret2;
									if(_this.head == null) {
										_this.pushmod = true;
									}
								} else {
									old = pre.next;
									ret2 = old.next;
									pre.next = ret2;
									if(ret2 == null) {
										_this.pushmod = true;
									}
								}
								var o = old;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
								_this.modified = true;
								_this.length--;
								_this.pushmod = true;
								ret1 = true;
								break;
							}
							pre = cur;
							cur = cur.next;
						}
					}
					if(xarb.pair != null) {
						xarb.pair.arb = null;
						xarb.pair = null;
					}
					xarb.active = false;
					this.f_arbiters.modified = true;
					if(zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool == null) {
						arb = new zpp_$nape_dynamics_ZPP_$ColArbiter();
					} else {
						arb = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = arb.next;
						arb.next = null;
					}
					arb.intchange = true;
					arb.stat = stat;
					first = true;
					swapped = true;
				} else {
					arb = xarb.colarb;
					reverse = sa != arb.s1;
					if(arb.stat != stat) {
						arb.stat = stat;
						if(!arb.sleeping) {
							(stat ? this.c_arbiters_false : this.c_arbiters_true).remove(arb);
							carbs.add(arb);
						}
					}
				}
				var inttype = 1;
				if(first || arb.stamp != this.stamp || continuous) {
					arb.stamp = this.stamp;
					if(zpp_$nape_geom_ZPP_$Collide.contactCollide(sa,sb,arb,reverse)) {
						if(first) {
							var di = sb.id;
							arb.b1 = s1.body;
							arb.ws1 = s1;
							arb.b2 = s2.body;
							arb.ws2 = s2;
							arb.id = sa.id;
							arb.di = di;
							var _this = arb.b1.arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							var _this = arb.b2.arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							arb.active = true;
							arb.present = 0;
							arb.cleared = false;
							arb.sleeping = false;
							arb.fresh = false;
							arb.presentable = false;
							arb.s1 = s1;
							arb.s2 = s2;
							if(!arb.userdef_restitution) {
								if(arb.s1.material.elasticity <= -Infinity || arb.s2.material.elasticity <= -Infinity) {
									arb.restitution = 0;
								} else if(arb.s1.material.elasticity >= Infinity || arb.s2.material.elasticity >= Infinity) {
									arb.restitution = 1;
								} else {
									arb.restitution = (arb.s1.material.elasticity + arb.s2.material.elasticity) / 2;
								}
								if(arb.restitution < 0) {
									arb.restitution = 0;
								}
								if(arb.restitution > 1) {
									arb.restitution = 1;
								}
							}
							if(!arb.userdef_dyn_fric) {
								var x = arb.s1.material.dynamicFriction * arb.s2.material.dynamicFriction;
								var ret1;
								if(x == 0.0) {
									ret1 = 0.0;
								} else {
									zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
									zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
									var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
									ret1 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
								}
								arb.dyn_fric = ret1;
							}
							if(!arb.userdef_stat_fric) {
								var x = arb.s1.material.staticFriction * arb.s2.material.staticFriction;
								var ret1;
								if(x == 0.0) {
									ret1 = 0.0;
								} else {
									zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
									zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
									var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
									ret1 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
								}
								arb.stat_fric = ret1;
							}
							if(!arb.userdef_rfric) {
								var x = arb.s1.material.rollingFriction * arb.s2.material.rollingFriction;
								var ret1;
								if(x == 0.0) {
									ret1 = 0.0;
								} else {
									zpp_$nape_util_ZPP_$Math.fbuf[0] = x;
									zpp_$nape_util_ZPP_$Math.ibuf[0] = 1597463007 - (zpp_$nape_util_ZPP_$Math.ibuf[0] >> 1);
									var x2 = zpp_$nape_util_ZPP_$Math.fbuf[0];
									ret1 = 1 / (x2 * (1.5 - 0.5 * x * x2 * x2));
								}
								arb.rfric = ret1;
							}
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = carbs.head;
							carbs.head = temp;
							carbs.modified = true;
							carbs.length++;
							arb.fresh = !swapped;
						} else {
							arb.fresh = arb.up_stamp < this.stamp - 1 || arb.endGenerated == this.stamp && continuous;
						}
						arb.up_stamp = arb.stamp;
						if(arb.fresh || (arb.immState & 4) == 0) {
							arb.immState = 1;
							var anyimpure = false;
							var arbs1 = arb.ws1.id > arb.ws2.id ? arb.ws2 : arb.ws1;
							var arbs2 = arb.ws1.id > arb.ws2.id ? arb.ws1 : arb.ws2;
							var _this = this.mrca1;
							while(_this.head != null) {
								var ret1 = _this.head;
								_this.head = ret1.next;
								var o = ret1;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
								if(_this.head == null) {
									_this.pushmod = true;
								}
								_this.modified = true;
								_this.length--;
							}
							_this.pushmod = true;
							var _this = this.mrca2;
							while(_this.head != null) {
								var ret1 = _this.head;
								_this.head = ret1.next;
								var o = ret1;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
								if(_this.head == null) {
									_this.pushmod = true;
								}
								_this.modified = true;
								_this.length--;
							}
							_this.pushmod = true;
							if(arbs1.cbSet != null) {
								var _this = this.mrca1;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = arbs1;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs1.body.cbSet != null) {
								var _this = this.mrca1;
								var o = arbs1.body;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = o;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs2.cbSet != null) {
								var _this = this.mrca2;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = arbs2;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs2.body.cbSet != null) {
								var _this = this.mrca2;
								var o = arbs2.body;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = o;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							var c1 = arbs1.body.compound;
							var c2 = arbs2.body.compound;
							while(c1 != c2) {
								var d1 = c1 == null ? 0 : c1.depth;
								var d2 = c2 == null ? 0 : c2.depth;
								if(d1 < d2) {
									if(c2.cbSet != null) {
										var _this = this.mrca2;
										var ret1;
										if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
											ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
										} else {
											ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
											zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
											ret1.next = null;
										}
										ret1.elt = c2;
										var temp = ret1;
										temp.next = _this.head;
										_this.head = temp;
										_this.modified = true;
										_this.length++;
									}
									c2 = c2.compound;
								} else {
									if(c1.cbSet != null) {
										var _this1 = this.mrca1;
										var ret2;
										if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
											ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
										} else {
											ret2 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
											zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.elt = c1;
										var temp1 = ret2;
										temp1.next = _this1.head;
										_this1.head = temp1;
										_this1.modified = true;
										_this1.length++;
									}
									c1 = c1.compound;
								}
							}
							var cx_ite = this.mrca1.head;
							while(cx_ite != null) {
								var i1 = cx_ite.elt;
								var cx_ite1 = this.mrca2.head;
								while(cx_ite1 != null) {
									var i2 = cx_ite1.elt;
									var cb1 = i1.cbSet;
									var cb2 = i2.cbSet;
									var _this = cb1.manager;
									var ret1 = null;
									var pairs = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
									var cx_ite2 = pairs.head;
									while(cx_ite2 != null) {
										var p = cx_ite2.elt;
										if(p.a == cb1 && p.b == cb2 || p.a == cb2 && p.b == cb1) {
											ret1 = p;
											break;
										}
										cx_ite2 = cx_ite2.next;
									}
									if(ret1 == null) {
										var ret2;
										if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
											ret2 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
										} else {
											ret2 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
											zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.zip_listeners = true;
										if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
											ret2.a = cb1;
											ret2.b = cb2;
										} else {
											ret2.a = cb2;
											ret2.b = cb1;
										}
										ret1 = ret2;
										cb1.cbpairs.add(ret1);
										if(cb2 != cb1) {
											cb2.cbpairs.add(ret1);
										}
									}
									if(ret1.zip_listeners) {
										ret1.zip_listeners = false;
										ret1.__validate();
									}
									if(ret1.listeners.head == null) {
										cx_ite1 = cx_ite1.next;
										continue;
									}
									var callbackset = null;
									var ncallbackset = null;
									var _this1 = this.prelisteners;
									while(_this1.head != null) {
										var ret3 = _this1.head;
										_this1.head = ret3.next;
										var o = ret3;
										o.elt = null;
										o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
										zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = o;
										if(_this1.head == null) {
											_this1.pushmod = true;
										}
										_this1.modified = true;
										_this1.length--;
									}
									_this1.pushmod = true;
									var lite = null;
									var _this2 = cb1.manager;
									var ret4 = null;
									var pairs1 = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
									var cx_ite3 = pairs1.head;
									while(cx_ite3 != null) {
										var p1 = cx_ite3.elt;
										if(p1.a == cb1 && p1.b == cb2 || p1.a == cb2 && p1.b == cb1) {
											ret4 = p1;
											break;
										}
										cx_ite3 = cx_ite3.next;
									}
									if(ret4 == null) {
										var ret5;
										if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
											ret5 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
										} else {
											ret5 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
											zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.zip_listeners = true;
										if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
											ret5.a = cb1;
											ret5.b = cb2;
										} else {
											ret5.a = cb2;
											ret5.b = cb1;
										}
										ret4 = ret5;
										cb1.cbpairs.add(ret4);
										if(cb2 != cb1) {
											cb2.cbpairs.add(ret4);
										}
									}
									if(ret4.zip_listeners) {
										ret4.zip_listeners = false;
										ret4.__validate();
									}
									var cx_ite4 = ret4.listeners.head;
									while(cx_ite4 != null) {
										var x = cx_ite4.elt;
										if(x.event == 5) {
											if((x.itype & inttype) != 0) {
												var _this3 = _gthis.prelisteners;
												var ret6;
												if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
													ret6 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
												} else {
													ret6 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
													zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret6.next;
													ret6.next = null;
												}
												ret6.elt = x;
												var temp = ret6;
												if(lite == null) {
													temp.next = _this3.head;
													_this3.head = temp;
												} else {
													temp.next = lite.next;
													lite.next = temp;
												}
												_this3.pushmod = _this3.modified = true;
												_this3.length++;
												lite = temp;
												anyimpure = anyimpure || !x.pure;
											}
										}
										cx_ite4 = cx_ite4.next;
									}
									if(this.prelisteners.head == null) {
										cx_ite1 = cx_ite1.next;
										continue;
									}
									callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
									if(callbackset == null) {
										ncallbackset = zpp_$nape_space_ZPP_$CallbackSet.get(i1,i2);
										this.add_callbackset(ncallbackset);
									}
									if(callbackset == null || (callbackset.COLLISIONstamp != this.stamp || continuous) && (callbackset.COLLISIONstate & 4) == 0) {
										if(ncallbackset != null) {
											callbackset = ncallbackset;
										}
										if(callbackset != null) {
											var cx_ite5 = this.prelisteners.head;
											while(cx_ite5 != null) {
												var listener = cx_ite5.elt;
												if(listener.itype == 7) {
													callbackset.COLLISIONstamp = this.stamp;
													callbackset.SENSORstamp = this.stamp;
													callbackset.FLUIDstamp = this.stamp;
												} else {
													callbackset.COLLISIONstamp = this.stamp;
												}
												cx_ite5 = cx_ite5.next;
											}
										}
										var pact = arb.active;
										arb.active = true;
										var emptycontacts = false;
										var fst = true;
										var pre = null;
										var prei = null;
										var cx_itei = arb.innards.next;
										arb.hc2 = false;
										var cx_ite6 = arb.contacts.next;
										while(cx_ite6 != null) {
											var c = cx_ite6;
											if(c.stamp + nape_Config.arbiterExpirationDelay < arb.stamp) {
												var _this4 = arb.contacts;
												var old;
												var ret7;
												if(pre == null) {
													old = _this4.next;
													ret7 = old.next;
													_this4.next = ret7;
													if(_this4.next == null) {
														_this4.pushmod = true;
													}
												} else {
													old = pre.next;
													ret7 = old.next;
													pre.next = ret7;
													if(ret7 == null) {
														_this4.pushmod = true;
													}
												}
												old._inuse = false;
												_this4.modified = true;
												_this4.length--;
												_this4.pushmod = true;
												cx_ite6 = ret7;
												var _this5 = arb.innards;
												var old1;
												var ret8;
												if(prei == null) {
													old1 = _this5.next;
													ret8 = old1.next;
													_this5.next = ret8;
													if(_this5.next == null) {
														_this5.pushmod = true;
													}
												} else {
													old1 = prei.next;
													ret8 = old1.next;
													prei.next = ret8;
													if(ret8 == null) {
														_this5.pushmod = true;
													}
												}
												old1._inuse = false;
												_this5.modified = true;
												_this5.length--;
												_this5.pushmod = true;
												cx_itei = ret8;
												var o1 = c;
												o1.sBias = -1.0;
												o1.arbiter = null;
												o1.next = zpp_$nape_dynamics_ZPP_$Contact.zpp_pool;
												zpp_$nape_dynamics_ZPP_$Contact.zpp_pool = o1;
												continue;
											}
											var ci = c.inner;
											var pact1 = c.active;
											c.active = c.stamp == arb.stamp;
											if(c.active) {
												if(fst) {
													fst = false;
													arb.c1 = ci;
													arb.oc1 = c;
												} else {
													arb.hc2 = true;
													arb.c2 = ci;
													arb.oc2 = c;
												}
											}
											if(pact1 != c.active) {
												arb.contacts.modified = true;
											}
											pre = cx_ite6;
											prei = cx_itei;
											cx_itei = cx_itei.next;
											cx_ite6 = cx_ite6.next;
										}
										if(arb.hc2) {
											arb.hpc2 = true;
											if(arb.oc1.posOnly) {
												var tmp = arb.c1;
												arb.c1 = arb.c2;
												arb.c2 = tmp;
												var tmp2 = arb.oc1;
												arb.oc1 = arb.oc2;
												arb.oc2 = tmp2;
												arb.hc2 = false;
											} else if(arb.oc2.posOnly) {
												arb.hc2 = false;
											}
											if(arb.oc1.posOnly) {
												fst = true;
											}
										} else {
											arb.hpc2 = false;
										}
										this.precb.zpp_inner.pre_arbiter = arb;
										this.precb.zpp_inner.set = callbackset;
										var cx_ite7 = this.prelisteners.head;
										while(cx_ite7 != null) {
											var listener1 = cx_ite7.elt;
											this.precb.zpp_inner.listener = listener1;
											var cb = this.precb.zpp_inner;
											var o11 = callbackset.int1;
											var o2 = callbackset.int2;
											var ret9;
											var _this6 = listener1.options1;
											var xs = o11.cbTypes;
											if(_this6.nonemptyintersection(xs,_this6.includes) && !_this6.nonemptyintersection(xs,_this6.excludes)) {
												var _this7 = listener1.options2;
												var xs1 = o2.cbTypes;
												ret9 = _this7.nonemptyintersection(xs1,_this7.includes) && !_this7.nonemptyintersection(xs1,_this7.excludes);
											} else {
												ret9 = false;
											}
											if(ret9) {
												cb.int1 = o11;
												cb.int2 = o2;
											} else {
												cb.int1 = o2;
												cb.int2 = o11;
											}
											this.precb.zpp_inner.pre_swapped = i1 != this.precb.zpp_inner.int1;
											var ret10 = listener1.handlerp(this.precb);
											if(ret10 != null) {
												var ret11;
												if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
													zpp_$nape_util_ZPP_$Flags.internal = true;
													zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
													zpp_$nape_util_ZPP_$Flags.internal = false;
												}
												if(ret10 == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT) {
													ret11 = 5;
												} else {
													if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
														zpp_$nape_util_ZPP_$Flags.internal = true;
														zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
														zpp_$nape_util_ZPP_$Flags.internal = false;
													}
													if(ret10 == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE) {
														ret11 = 1;
													} else {
														if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
															zpp_$nape_util_ZPP_$Flags.internal = true;
															zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
															zpp_$nape_util_ZPP_$Flags.internal = false;
														}
														ret11 = ret10 == zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE ? 6 : 2;
													}
												}
												arb.immState = ret11;
											}
											cx_ite7 = cx_ite7.next;
										}
										arb.active = pact;
										if(callbackset != null) {
											var cx_ite8 = this.prelisteners.head;
											while(cx_ite8 != null) {
												var listener2 = cx_ite8.elt;
												if(listener2.itype == 7) {
													callbackset.COLLISIONstate = arb.immState;
													callbackset.SENSORstate = arb.immState;
													callbackset.FLUIDstate = arb.immState;
												} else {
													callbackset.COLLISIONstate = arb.immState;
												}
												cx_ite8 = cx_ite8.next;
											}
										}
									} else if(callbackset == null) {
										if((arb.immState & 4) == 0) {
											arb.immState = 1;
										}
									} else {
										arb.immState = callbackset.COLLISIONstate;
									}
									cx_ite1 = cx_ite1.next;
								}
								cx_ite = cx_ite.next;
							}
							if(anyimpure && (arb.immState & 4) == 0) {
								if(arb.b1.type == 2) {
									var o = arb.b1;
									if(!o.world) {
										o.component.waket = this.stamp + (this.midstep ? 0 : 1);
										if(o.type == 3) {
											o.kinematicDelaySleep = true;
										}
										if(o.component.sleeping) {
											this.really_wake(o,false);
										}
									}
								}
								if(arb.b1.type == 2) {
									var o = arb.b2;
									if(!o.world) {
										o.component.waket = this.stamp + (this.midstep ? 0 : 1);
										if(o.type == 3) {
											o.kinematicDelaySleep = true;
										}
										if(o.component.sleeping) {
											this.really_wake(o,false);
										}
									}
								}
							}
						}
						if((arb.immState & 1) != 0) {
							if(arb.b1.type == 2 && arb.b1.component.sleeping) {
								var o = arb.b1;
								if(!o.world) {
									o.component.waket = this.stamp + (this.midstep ? 0 : 1);
									if(o.type == 3) {
										o.kinematicDelaySleep = true;
									}
									if(o.component.sleeping) {
										this.really_wake(o,false);
									}
								}
							}
							if(arb.b2.type == 2 && arb.b2.component.sleeping) {
								var o = arb.b2;
								if(!o.world) {
									o.component.waket = this.stamp + (this.midstep ? 0 : 1);
									if(o.type == 3) {
										o.kinematicDelaySleep = true;
									}
									if(o.component.sleeping) {
										this.really_wake(o,false);
									}
								}
							}
						}
						if(arb.sleeping) {
							arb.sleeping = false;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = carbs.head;
							carbs.head = temp;
							carbs.modified = true;
							carbs.length++;
						}
						ret = arb;
					} else if(first) {
						var o = arb;
						o.userdef_dyn_fric = false;
						o.userdef_stat_fric = false;
						o.userdef_restitution = false;
						o.userdef_rfric = false;
						o.__ref_edge1 = o.__ref_edge2 = null;
						o.next = zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$ColArbiter.zpp_pool = o;
						ret = null;
					} else {
						ret = arb;
					}
				} else {
					ret = arb;
				}
			} else {
				var xarb;
				if(in_arb == null) {
					var ret1 = null;
					var b = b1.arbiters.length < b2.arbiters.length ? b1 : b2;
					var cx_ite = b.arbiters.head;
					while(cx_ite != null) {
						var arb = cx_ite.elt;
						if(arb.id == sa.id && arb.di == sb.id) {
							ret1 = arb;
							break;
						}
						cx_ite = cx_ite.next;
					}
					xarb = ret1;
				} else {
					xarb = in_arb;
				}
				var first = xarb == null;
				var arb;
				var swapped = false;
				if(first) {
					if(zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool == null) {
						arb = new zpp_$nape_dynamics_ZPP_$SensorArbiter();
					} else {
						arb = zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool = arb.next;
						arb.next = null;
					}
				} else if(xarb.sensorarb == null) {
					var b = null;
					xarb.cleared = true;
					if(b == null || xarb.b2 == b) {
						var _this = xarb.b1.arbiters;
						var pre = null;
						var cur = _this.head;
						var ret1 = false;
						while(cur != null) {
							if(cur.elt == xarb) {
								var old;
								var ret2;
								if(pre == null) {
									old = _this.head;
									ret2 = old.next;
									_this.head = ret2;
									if(_this.head == null) {
										_this.pushmod = true;
									}
								} else {
									old = pre.next;
									ret2 = old.next;
									pre.next = ret2;
									if(ret2 == null) {
										_this.pushmod = true;
									}
								}
								var o = old;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
								_this.modified = true;
								_this.length--;
								_this.pushmod = true;
								ret1 = true;
								break;
							}
							pre = cur;
							cur = cur.next;
						}
					}
					if(b == null || xarb.b1 == b) {
						var _this = xarb.b2.arbiters;
						var pre = null;
						var cur = _this.head;
						var ret1 = false;
						while(cur != null) {
							if(cur.elt == xarb) {
								var old;
								var ret2;
								if(pre == null) {
									old = _this.head;
									ret2 = old.next;
									_this.head = ret2;
									if(_this.head == null) {
										_this.pushmod = true;
									}
								} else {
									old = pre.next;
									ret2 = old.next;
									pre.next = ret2;
									if(ret2 == null) {
										_this.pushmod = true;
									}
								}
								var o = old;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
								_this.modified = true;
								_this.length--;
								_this.pushmod = true;
								ret1 = true;
								break;
							}
							pre = cur;
							cur = cur.next;
						}
					}
					if(xarb.pair != null) {
						xarb.pair.arb = null;
						xarb.pair = null;
					}
					xarb.active = false;
					this.f_arbiters.modified = true;
					if(zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool == null) {
						arb = new zpp_$nape_dynamics_ZPP_$SensorArbiter();
					} else {
						arb = zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool = arb.next;
						arb.next = null;
					}
					arb.intchange = true;
					first = true;
					swapped = true;
				} else {
					arb = xarb.sensorarb;
				}
				var inttype = 2;
				if(first || arb.stamp != this.stamp || continuous) {
					arb.stamp = this.stamp;
					if(zpp_$nape_geom_ZPP_$Collide.testCollide(sa,sb)) {
						if(first) {
							var di = sb.id;
							arb.b1 = s1.body;
							arb.ws1 = s1;
							arb.b2 = s2.body;
							arb.ws2 = s2;
							arb.id = sa.id;
							arb.di = di;
							var _this = arb.b1.arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							var _this = arb.b2.arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							arb.active = true;
							arb.present = 0;
							arb.cleared = false;
							arb.sleeping = false;
							arb.fresh = false;
							arb.presentable = false;
							var _this = this.s_arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
							arb.fresh = !swapped;
						} else {
							arb.fresh = arb.up_stamp < this.stamp - 1 || arb.endGenerated == this.stamp && continuous;
						}
						arb.up_stamp = arb.stamp;
						if(arb.fresh || (arb.immState & 4) == 0) {
							arb.immState = 1;
							var anyimpure = false;
							var arbs1 = arb.ws1.id > arb.ws2.id ? arb.ws2 : arb.ws1;
							var arbs2 = arb.ws1.id > arb.ws2.id ? arb.ws1 : arb.ws2;
							var _this = this.mrca1;
							while(_this.head != null) {
								var ret1 = _this.head;
								_this.head = ret1.next;
								var o = ret1;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
								if(_this.head == null) {
									_this.pushmod = true;
								}
								_this.modified = true;
								_this.length--;
							}
							_this.pushmod = true;
							var _this = this.mrca2;
							while(_this.head != null) {
								var ret1 = _this.head;
								_this.head = ret1.next;
								var o = ret1;
								o.elt = null;
								o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
								if(_this.head == null) {
									_this.pushmod = true;
								}
								_this.modified = true;
								_this.length--;
							}
							_this.pushmod = true;
							if(arbs1.cbSet != null) {
								var _this = this.mrca1;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = arbs1;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs1.body.cbSet != null) {
								var _this = this.mrca1;
								var o = arbs1.body;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = o;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs2.cbSet != null) {
								var _this = this.mrca2;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = arbs2;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							if(arbs2.body.cbSet != null) {
								var _this = this.mrca2;
								var o = arbs2.body;
								var ret1;
								if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
									ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
								} else {
									ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
									zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
									ret1.next = null;
								}
								ret1.elt = o;
								var temp = ret1;
								temp.next = _this.head;
								_this.head = temp;
								_this.modified = true;
								_this.length++;
							}
							var c1 = arbs1.body.compound;
							var c2 = arbs2.body.compound;
							while(c1 != c2) {
								var d1 = c1 == null ? 0 : c1.depth;
								var d2 = c2 == null ? 0 : c2.depth;
								if(d1 < d2) {
									if(c2.cbSet != null) {
										var _this = this.mrca2;
										var ret1;
										if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
											ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
										} else {
											ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
											zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
											ret1.next = null;
										}
										ret1.elt = c2;
										var temp = ret1;
										temp.next = _this.head;
										_this.head = temp;
										_this.modified = true;
										_this.length++;
									}
									c2 = c2.compound;
								} else {
									if(c1.cbSet != null) {
										var _this1 = this.mrca1;
										var ret2;
										if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
											ret2 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
										} else {
											ret2 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
											zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.elt = c1;
										var temp1 = ret2;
										temp1.next = _this1.head;
										_this1.head = temp1;
										_this1.modified = true;
										_this1.length++;
									}
									c1 = c1.compound;
								}
							}
							var cx_ite = this.mrca1.head;
							while(cx_ite != null) {
								var i1 = cx_ite.elt;
								var cx_ite1 = this.mrca2.head;
								while(cx_ite1 != null) {
									var i2 = cx_ite1.elt;
									var cb1 = i1.cbSet;
									var cb2 = i2.cbSet;
									var _this = cb1.manager;
									var ret1 = null;
									var pairs = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
									var cx_ite2 = pairs.head;
									while(cx_ite2 != null) {
										var p = cx_ite2.elt;
										if(p.a == cb1 && p.b == cb2 || p.a == cb2 && p.b == cb1) {
											ret1 = p;
											break;
										}
										cx_ite2 = cx_ite2.next;
									}
									if(ret1 == null) {
										var ret2;
										if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
											ret2 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
										} else {
											ret2 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
											zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret2.next;
											ret2.next = null;
										}
										ret2.zip_listeners = true;
										if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
											ret2.a = cb1;
											ret2.b = cb2;
										} else {
											ret2.a = cb2;
											ret2.b = cb1;
										}
										ret1 = ret2;
										cb1.cbpairs.add(ret1);
										if(cb2 != cb1) {
											cb2.cbpairs.add(ret1);
										}
									}
									if(ret1.zip_listeners) {
										ret1.zip_listeners = false;
										ret1.__validate();
									}
									if(ret1.listeners.head == null) {
										cx_ite1 = cx_ite1.next;
										continue;
									}
									var callbackset = null;
									var ncallbackset = null;
									var _this1 = this.prelisteners;
									while(_this1.head != null) {
										var ret3 = _this1.head;
										_this1.head = ret3.next;
										var o = ret3;
										o.elt = null;
										o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
										zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = o;
										if(_this1.head == null) {
											_this1.pushmod = true;
										}
										_this1.modified = true;
										_this1.length--;
									}
									_this1.pushmod = true;
									var lite = null;
									var _this2 = cb1.manager;
									var ret4 = null;
									var pairs1 = cb1.cbpairs.length < cb2.cbpairs.length ? cb1.cbpairs : cb2.cbpairs;
									var cx_ite3 = pairs1.head;
									while(cx_ite3 != null) {
										var p1 = cx_ite3.elt;
										if(p1.a == cb1 && p1.b == cb2 || p1.a == cb2 && p1.b == cb1) {
											ret4 = p1;
											break;
										}
										cx_ite3 = cx_ite3.next;
									}
									if(ret4 == null) {
										var ret5;
										if(zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool == null) {
											ret5 = new zpp_$nape_callbacks_ZPP_$CbSetPair();
										} else {
											ret5 = zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool;
											zpp_$nape_callbacks_ZPP_$CbSetPair.zpp_pool = ret5.next;
											ret5.next = null;
										}
										ret5.zip_listeners = true;
										if(zpp_$nape_callbacks_ZPP_$CbSet.setlt(cb1,cb2)) {
											ret5.a = cb1;
											ret5.b = cb2;
										} else {
											ret5.a = cb2;
											ret5.b = cb1;
										}
										ret4 = ret5;
										cb1.cbpairs.add(ret4);
										if(cb2 != cb1) {
											cb2.cbpairs.add(ret4);
										}
									}
									if(ret4.zip_listeners) {
										ret4.zip_listeners = false;
										ret4.__validate();
									}
									var cx_ite4 = ret4.listeners.head;
									while(cx_ite4 != null) {
										var x = cx_ite4.elt;
										if(x.event == 5) {
											if((x.itype & inttype) != 0) {
												var _this3 = _gthis.prelisteners;
												var ret6;
												if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool == null) {
													ret6 = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener();
												} else {
													ret6 = zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool;
													zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.zpp_pool = ret6.next;
													ret6.next = null;
												}
												ret6.elt = x;
												var temp = ret6;
												if(lite == null) {
													temp.next = _this3.head;
													_this3.head = temp;
												} else {
													temp.next = lite.next;
													lite.next = temp;
												}
												_this3.pushmod = _this3.modified = true;
												_this3.length++;
												lite = temp;
												anyimpure = anyimpure || !x.pure;
											}
										}
										cx_ite4 = cx_ite4.next;
									}
									if(this.prelisteners.head == null) {
										cx_ite1 = cx_ite1.next;
										continue;
									}
									callbackset = zpp_$nape_phys_ZPP_$Interactor.get(i1,i2);
									if(callbackset == null) {
										ncallbackset = zpp_$nape_space_ZPP_$CallbackSet.get(i1,i2);
										this.add_callbackset(ncallbackset);
									}
									if(callbackset == null || (callbackset.SENSORstamp != this.stamp || continuous) && (callbackset.SENSORstate & 4) == 0) {
										if(ncallbackset != null) {
											callbackset = ncallbackset;
										}
										if(callbackset != null) {
											var cx_ite5 = this.prelisteners.head;
											while(cx_ite5 != null) {
												var listener = cx_ite5.elt;
												if(listener.itype == 7) {
													callbackset.COLLISIONstamp = this.stamp;
													callbackset.SENSORstamp = this.stamp;
													callbackset.FLUIDstamp = this.stamp;
												} else {
													callbackset.SENSORstamp = this.stamp;
												}
												cx_ite5 = cx_ite5.next;
											}
										}
										var pact = arb.active;
										arb.active = true;
										var emptycontacts = false;
										this.precb.zpp_inner.pre_arbiter = arb;
										this.precb.zpp_inner.set = callbackset;
										var cx_ite6 = this.prelisteners.head;
										while(cx_ite6 != null) {
											var listener1 = cx_ite6.elt;
											this.precb.zpp_inner.listener = listener1;
											var cb = this.precb.zpp_inner;
											var o1 = callbackset.int1;
											var o2 = callbackset.int2;
											var ret7;
											var _this4 = listener1.options1;
											var xs = o1.cbTypes;
											if(_this4.nonemptyintersection(xs,_this4.includes) && !_this4.nonemptyintersection(xs,_this4.excludes)) {
												var _this5 = listener1.options2;
												var xs1 = o2.cbTypes;
												ret7 = _this5.nonemptyintersection(xs1,_this5.includes) && !_this5.nonemptyintersection(xs1,_this5.excludes);
											} else {
												ret7 = false;
											}
											if(ret7) {
												cb.int1 = o1;
												cb.int2 = o2;
											} else {
												cb.int1 = o2;
												cb.int2 = o1;
											}
											this.precb.zpp_inner.pre_swapped = i1 != this.precb.zpp_inner.int1;
											var ret8 = listener1.handlerp(this.precb);
											if(ret8 != null) {
												var ret9;
												if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT == null) {
													zpp_$nape_util_ZPP_$Flags.internal = true;
													zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT = new nape_callbacks_PreFlag();
													zpp_$nape_util_ZPP_$Flags.internal = false;
												}
												if(ret8 == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT) {
													ret9 = 5;
												} else {
													if(zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE == null) {
														zpp_$nape_util_ZPP_$Flags.internal = true;
														zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE = new nape_callbacks_PreFlag();
														zpp_$nape_util_ZPP_$Flags.internal = false;
													}
													if(ret8 == zpp_$nape_util_ZPP_$Flags.PreFlag_ACCEPT_ONCE) {
														ret9 = 1;
													} else {
														if(zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE == null) {
															zpp_$nape_util_ZPP_$Flags.internal = true;
															zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE = new nape_callbacks_PreFlag();
															zpp_$nape_util_ZPP_$Flags.internal = false;
														}
														ret9 = ret8 == zpp_$nape_util_ZPP_$Flags.PreFlag_IGNORE ? 6 : 2;
													}
												}
												arb.immState = ret9;
											}
											cx_ite6 = cx_ite6.next;
										}
										arb.active = pact;
										if(callbackset != null) {
											var cx_ite7 = this.prelisteners.head;
											while(cx_ite7 != null) {
												var listener2 = cx_ite7.elt;
												if(listener2.itype == 7) {
													callbackset.COLLISIONstate = arb.immState;
													callbackset.SENSORstate = arb.immState;
													callbackset.FLUIDstate = arb.immState;
												} else {
													callbackset.SENSORstate = arb.immState;
												}
												cx_ite7 = cx_ite7.next;
											}
										}
									} else if(callbackset == null) {
										if((arb.immState & 4) == 0) {
											arb.immState = 1;
										}
									} else {
										arb.immState = callbackset.SENSORstate;
									}
									cx_ite1 = cx_ite1.next;
								}
								cx_ite = cx_ite.next;
							}
							if(anyimpure && (arb.immState & 4) == 0) {
								if(arb.b1.type != 1) {
									var o = arb.b1;
									if(!o.world) {
										o.component.waket = this.stamp + (this.midstep ? 0 : 1);
										if(o.type == 3) {
											o.kinematicDelaySleep = true;
										}
										if(o.component.sleeping) {
											this.really_wake(o,false);
										}
									}
								}
								if(arb.b2.type != 1) {
									var o = arb.b2;
									if(!o.world) {
										o.component.waket = this.stamp + (this.midstep ? 0 : 1);
										if(o.type == 3) {
											o.kinematicDelaySleep = true;
										}
										if(o.component.sleeping) {
											this.really_wake(o,false);
										}
									}
								}
							}
						}
						if(arb.sleeping) {
							arb.sleeping = false;
							var _this = this.s_arbiters;
							var ret1;
							if(zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool == null) {
								ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter();
							} else {
								ret1 = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
								zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = ret1.next;
								ret1.next = null;
							}
							ret1.elt = arb;
							var temp = ret1;
							temp.next = _this.head;
							_this.head = temp;
							_this.modified = true;
							_this.length++;
						}
						ret = arb;
					} else if(first) {
						var o = arb;
						o.next = zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool;
						zpp_$nape_dynamics_ZPP_$SensorArbiter.zpp_pool = o;
						ret = null;
					} else {
						ret = arb;
					}
				} else {
					ret = arb;
				}
			}
		}
		return ret;
	}
	,MRCA_chains: function(s1,s2) {
		var _this = this.mrca1;
		while(_this.head != null) {
			var ret = _this.head;
			_this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
			if(_this.head == null) {
				_this.pushmod = true;
			}
			_this.modified = true;
			_this.length--;
		}
		_this.pushmod = true;
		var _this = this.mrca2;
		while(_this.head != null) {
			var ret = _this.head;
			_this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = o;
			if(_this.head == null) {
				_this.pushmod = true;
			}
			_this.modified = true;
			_this.length--;
		}
		_this.pushmod = true;
		if(s1.cbSet != null) {
			var _this = this.mrca1;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = s1;
			var temp = ret;
			temp.next = _this.head;
			_this.head = temp;
			_this.modified = true;
			_this.length++;
		}
		if(s1.body.cbSet != null) {
			var _this = this.mrca1;
			var o = s1.body;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = o;
			var temp = ret;
			temp.next = _this.head;
			_this.head = temp;
			_this.modified = true;
			_this.length++;
		}
		if(s2.cbSet != null) {
			var _this = this.mrca2;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = s2;
			var temp = ret;
			temp.next = _this.head;
			_this.head = temp;
			_this.modified = true;
			_this.length++;
		}
		if(s2.body.cbSet != null) {
			var _this = this.mrca2;
			var o = s2.body;
			var ret;
			if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
				ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
			} else {
				ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
				ret.next = null;
			}
			ret.elt = o;
			var temp = ret;
			temp.next = _this.head;
			_this.head = temp;
			_this.modified = true;
			_this.length++;
		}
		var c1 = s1.body.compound;
		var c2 = s2.body.compound;
		while(c1 != c2) {
			var d1 = c1 == null ? 0 : c1.depth;
			var d2 = c2 == null ? 0 : c2.depth;
			if(d1 < d2) {
				if(c2.cbSet != null) {
					var _this = this.mrca2;
					var ret;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
						ret = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
					} else {
						ret = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret.next;
						ret.next = null;
					}
					ret.elt = c2;
					var temp = ret;
					temp.next = _this.head;
					_this.head = temp;
					_this.modified = true;
					_this.length++;
				}
				c2 = c2.compound;
			} else {
				if(c1.cbSet != null) {
					var _this1 = this.mrca1;
					var ret1;
					if(zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool == null) {
						ret1 = new zpp_$nape_util_ZNPNode_$ZPP_$Interactor();
					} else {
						ret1 = zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool;
						zpp_$nape_util_ZNPNode_$ZPP_$Interactor.zpp_pool = ret1.next;
						ret1.next = null;
					}
					ret1.elt = c1;
					var temp1 = ret1;
					temp1.next = _this1.head;
					_this1.head = temp1;
					_this1.modified = true;
					_this1.length++;
				}
				c1 = c1.compound;
			}
		}
	}
};
var zpp_$nape_space_ZPP_$SweepData = function() {
	this.aabb = null;
	this.shape = null;
	this.prev = null;
	this.next = null;
};
zpp_$nape_space_ZPP_$SweepData.__name__ = true;
var zpp_$nape_space_ZPP_$SweepPhase = function(space) {
	this.failed = null;
	this.list = null;
	zpp_$nape_space_ZPP_$Broadphase.call(this);
	this.space = space;
	this.is_sweep = true;
	this.sweep = this;
};
zpp_$nape_space_ZPP_$SweepPhase.__name__ = true;
zpp_$nape_space_ZPP_$SweepPhase.__super__ = zpp_$nape_space_ZPP_$Broadphase;
zpp_$nape_space_ZPP_$SweepPhase.prototype = $extend(zpp_$nape_space_ZPP_$Broadphase.prototype,{
	__insert: function(shape) {
		var dat;
		if(zpp_$nape_space_ZPP_$SweepData.zpp_pool == null) {
			dat = new zpp_$nape_space_ZPP_$SweepData();
		} else {
			dat = zpp_$nape_space_ZPP_$SweepData.zpp_pool;
			zpp_$nape_space_ZPP_$SweepData.zpp_pool = dat.next;
			dat.next = null;
		}
		shape.sweep = dat;
		dat.shape = shape;
		dat.aabb = shape.aabb;
		dat.next = this.list;
		if(this.list != null) {
			this.list.prev = dat;
		}
		this.list = dat;
	}
	,__remove: function(shape) {
		var dat = shape.sweep;
		if(dat.prev == null) {
			this.list = dat.next;
		} else {
			dat.prev.next = dat.next;
		}
		if(dat.next != null) {
			dat.next.prev = dat.prev;
		}
		shape.sweep = null;
		var o = dat;
		o.prev = null;
		o.shape = null;
		o.aabb = null;
		o.next = zpp_$nape_space_ZPP_$SweepData.zpp_pool;
		zpp_$nape_space_ZPP_$SweepData.zpp_pool = o;
	}
	,sync_broadphase: function() {
		this.space.validation();
		if(this.list != null) {
			var a = this.list.next;
			while(a != null) {
				var n = a.next;
				var b = a.prev;
				if(a.aabb.minx > b.aabb.minx) {
					a = n;
					continue;
				}
				while(b.prev != null && b.prev.aabb.minx > a.aabb.minx) b = b.prev;
				var prev = a.prev;
				prev.next = a.next;
				if(a.next != null) {
					a.next.prev = prev;
				}
				if(b.prev == null) {
					a.prev = null;
					this.list = a;
					a.next = b;
					b.prev = a;
				} else {
					a.prev = b.prev;
					b.prev = a;
					a.prev.next = a;
					a.next = b;
				}
				a = n;
			}
		}
	}
	,broadphase: function(space,discrete) {
		if(this.list != null) {
			var a = this.list.next;
			while(a != null) {
				var n = a.next;
				var b = a.prev;
				if(a.aabb.minx > b.aabb.minx) {
					a = n;
					continue;
				}
				while(b.prev != null && b.prev.aabb.minx > a.aabb.minx) b = b.prev;
				var prev = a.prev;
				prev.next = a.next;
				if(a.next != null) {
					a.next.prev = prev;
				}
				if(b.prev == null) {
					a.prev = null;
					this.list = a;
					a.next = b;
					b.prev = a;
				} else {
					a.prev = b.prev;
					b.prev = a;
					a.prev.next = a;
					a.next = b;
				}
				a = n;
			}
			var d1 = this.list;
			while(d1 != null) {
				var d2 = d1.next;
				var s1 = d1.shape;
				var b1 = s1.body;
				var bottom = d1.aabb.maxx;
				while(d2 != null) {
					if(d2.aabb.minx > bottom) {
						break;
					}
					var s2 = d2.shape;
					var b2 = s2.body;
					if(b2 == b1) {
						d2 = d2.next;
						continue;
					}
					if(b1.type == 1 && b2.type == 1) {
						d2 = d2.next;
						continue;
					}
					if(b1.component.sleeping && b2.component.sleeping) {
						d2 = d2.next;
						continue;
					}
					var _this = s1.aabb;
					var x = s2.aabb;
					if(!(x.miny > _this.maxy || _this.miny > x.maxy)) {
						if(discrete) {
							space.narrowPhase(s1,s2,b1.type != 2 || b2.type != 2,null,false);
						} else {
							space.continuousEvent(s1,s2,b1.type != 2 || b2.type != 2,null,false);
						}
					}
					d2 = d2.next;
				}
				d1 = d1.next;
			}
		}
	}
	,clear: function() {
		while(this.list != null) {
			this.list.shape.removedFromSpace();
			this.__remove(this.list.shape);
		}
	}
	,shapesUnderPoint: function(x,y,filter,output) {
		this.sync_broadphase();
		var ret;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.weak = false;
		ret._immutable = false;
		ret.x = x;
		ret.y = y;
		var v = ret;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		var a = this.list;
		while(a != null && a.aabb.minx > x) a = a.next;
		while(a != null && a.aabb.minx <= x) {
			if(a.aabb.maxx >= x && a.aabb.miny <= y && a.aabb.maxy >= y) {
				var shape = a.shape;
				var tmp;
				if(filter != null) {
					var _this = shape.filter;
					tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(shape.type == 0) {
						if(zpp_$nape_geom_ZPP_$Collide.circleContains(shape.circle,v)) {
							ret.push(shape.outer);
						}
					} else if(zpp_$nape_geom_ZPP_$Collide.polyContains(shape.polygon,v)) {
						ret.push(shape.outer);
					}
				}
			}
			a = a.next;
		}
		var o = v;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return ret;
	}
	,bodiesUnderPoint: function(x,y,filter,output) {
		this.sync_broadphase();
		var ret;
		if(zpp_$nape_geom_ZPP_$Vec2.zpp_pool == null) {
			ret = new zpp_$nape_geom_ZPP_$Vec2();
		} else {
			ret = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.weak = false;
		ret._immutable = false;
		ret.x = x;
		ret.y = y;
		var v = ret;
		var ret = output == null ? new nape_phys_BodyList() : output;
		var a = this.list;
		while(a != null && a.aabb.minx > x) a = a.next;
		while(a != null && a.aabb.minx <= x) {
			if(a.aabb.maxx >= x && a.aabb.miny <= y && a.aabb.maxy >= y) {
				var shape = a.shape;
				var body = shape.body.outer;
				if(!ret.has(body)) {
					var tmp;
					if(filter != null) {
						var _this = shape.filter;
						tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
					} else {
						tmp = true;
					}
					if(tmp) {
						if(shape.type == 0) {
							if(zpp_$nape_geom_ZPP_$Collide.circleContains(shape.circle,v)) {
								ret.push(body);
							}
						} else if(zpp_$nape_geom_ZPP_$Collide.polyContains(shape.polygon,v)) {
							ret.push(body);
						}
					}
				}
			}
			a = a.next;
		}
		var o = v;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o._isimmutable = null;
		o._validate = null;
		o._invalidate = null;
		o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
		zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
		return ret;
	}
	,shapesInAABB: function(aabb,strict,containment,filter,output) {
		this.sync_broadphase();
		this.updateAABBShape(aabb);
		var ab = this.aabbShape.zpp_inner.aabb;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		var a = this.list;
		while(a != null && a.aabb.maxx < ab.minx) a = a.next;
		while(a != null && a.aabb.minx <= ab.maxx) {
			var shape = a.shape;
			var tmp;
			if(filter != null) {
				var _this = shape.filter;
				tmp = (_this.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this.collisionGroup) != 0;
			} else {
				tmp = true;
			}
			if(tmp) {
				if(strict) {
					if(containment) {
						if(zpp_$nape_geom_ZPP_$Collide.containTest(this.aabbShape.zpp_inner,shape)) {
							ret.push(shape.outer);
						}
					} else {
						var x = a.aabb;
						if(x.minx >= ab.minx && x.miny >= ab.miny && x.maxx <= ab.maxx && x.maxy <= ab.maxy) {
							ret.push(shape.outer);
						} else {
							var _this1 = a.aabb;
							if(ab.miny <= _this1.maxy && _this1.miny <= ab.maxy && ab.minx <= _this1.maxx && _this1.minx <= ab.maxx) {
								if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape,this.aabbShape.zpp_inner)) {
									ret.push(shape.outer);
								}
							}
						}
					}
				} else {
					var tmp1;
					if(containment) {
						var x1 = a.aabb;
						tmp1 = x1.minx >= ab.minx && x1.miny >= ab.miny && x1.maxx <= ab.maxx && x1.maxy <= ab.maxy;
					} else {
						var _this2 = a.aabb;
						tmp1 = ab.miny <= _this2.maxy && _this2.miny <= ab.maxy && ab.minx <= _this2.maxx && _this2.minx <= ab.maxx;
					}
					if(tmp1) {
						ret.push(shape.outer);
					}
				}
			}
			a = a.next;
		}
		return ret;
	}
	,bodiesInAABB: function(aabb,strict,containment,filter,output) {
		this.sync_broadphase();
		this.updateAABBShape(aabb);
		var ab = this.aabbShape.zpp_inner.aabb;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.failed == null) {
			this.failed = new nape_phys_BodyList();
		}
		var a = this.list;
		while(a != null && a.aabb.maxx < ab.minx) a = a.next;
		while(a != null && a.aabb.minx <= ab.maxx) {
			var shape = a.shape;
			var body = shape.body.outer;
			var _this = a.aabb;
			if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
				var tmp;
				if(filter != null) {
					var _this1 = shape.filter;
					tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(strict) {
						if(containment) {
							if(!this.failed.has(body)) {
								var col = zpp_$nape_geom_ZPP_$Collide.containTest(this.aabbShape.zpp_inner,shape);
								if(!ret.has(body) && col) {
									ret.push(body);
								} else if(!col) {
									ret.remove(body);
									this.failed.push(body);
								}
							}
						} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape,this.aabbShape.zpp_inner)) {
							ret.push(body);
						}
					} else if(containment) {
						if(!this.failed.has(body)) {
							var x = shape.aabb;
							var col1 = x.minx >= ab.minx && x.miny >= ab.miny && x.maxx <= ab.maxx && x.maxy <= ab.maxy;
							if(!ret.has(body) && col1) {
								ret.push(body);
							} else if(!col1) {
								ret.remove(body);
								this.failed.push(body);
							}
						}
					} else {
						var tmp1;
						if(!ret.has(body)) {
							var x1 = shape.aabb;
							tmp1 = x1.minx >= ab.minx && x1.miny >= ab.miny && x1.maxx <= ab.maxx && x1.maxy <= ab.maxy;
						} else {
							tmp1 = false;
						}
						if(tmp1) {
							ret.push(body);
						}
					}
				}
			}
			a = a.next;
		}
		this.failed.clear();
		return ret;
	}
	,shapesInCircle: function(x,y,r,containment,filter,output) {
		this.sync_broadphase();
		this.updateCircShape(x,y,r);
		var ab = this.circShape.zpp_inner.aabb;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		var a = this.list;
		while(a != null && a.aabb.maxx < ab.minx) a = a.next;
		while(a != null && a.aabb.minx <= ab.maxx) {
			var _this = a.aabb;
			if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
				var shape = a.shape;
				var tmp;
				if(filter != null) {
					var _this1 = shape.filter;
					tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(containment) {
						if(zpp_$nape_geom_ZPP_$Collide.containTest(this.circShape.zpp_inner,shape)) {
							ret.push(shape.outer);
						}
					} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape,this.circShape.zpp_inner)) {
						ret.push(shape.outer);
					}
				}
			}
			a = a.next;
		}
		return ret;
	}
	,bodiesInCircle: function(x,y,r,containment,filter,output) {
		this.sync_broadphase();
		this.updateCircShape(x,y,r);
		var ab = this.circShape.zpp_inner.aabb;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.failed == null) {
			this.failed = new nape_phys_BodyList();
		}
		var a = this.list;
		while(a != null && a.aabb.maxx < ab.minx) a = a.next;
		while(a != null && a.aabb.minx <= ab.maxx) {
			var _this = a.aabb;
			if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
				var shape = a.shape;
				var body = shape.body.outer;
				var tmp;
				if(filter != null) {
					var _this1 = shape.filter;
					tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(containment) {
						if(!this.failed.has(body)) {
							var col = zpp_$nape_geom_ZPP_$Collide.containTest(this.circShape.zpp_inner,shape);
							if(!ret.has(body) && col) {
								ret.push(body);
							} else if(!col) {
								ret.remove(body);
								this.failed.push(body);
							}
						}
					} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape,this.circShape.zpp_inner)) {
						ret.push(body);
					}
				}
			}
			a = a.next;
		}
		this.failed.clear();
		return ret;
	}
	,shapesInShape: function(shape,containment,filter,output) {
		this.sync_broadphase();
		this.validateShape(shape);
		var ab = shape.aabb;
		var ret = output == null ? new nape_shape_ShapeList() : output;
		var a = this.list;
		while(a != null && a.aabb.maxx < ab.minx) a = a.next;
		while(a != null && a.aabb.minx <= ab.maxx) {
			var _this = a.aabb;
			if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
				var shape2 = a.shape;
				var tmp;
				if(filter != null) {
					var _this1 = shape2.filter;
					tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(containment) {
						if(zpp_$nape_geom_ZPP_$Collide.containTest(shape,shape2)) {
							ret.push(shape2.outer);
						}
					} else if(zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape2,shape)) {
						ret.push(shape2.outer);
					}
				}
			}
			a = a.next;
		}
		return ret;
	}
	,bodiesInShape: function(shape,containment,filter,output) {
		this.sync_broadphase();
		this.validateShape(shape);
		var ab = shape.aabb;
		var ret = output == null ? new nape_phys_BodyList() : output;
		if(this.failed == null) {
			this.failed = new nape_phys_BodyList();
		}
		var a = this.list;
		while(a != null && a.aabb.maxx < ab.minx) a = a.next;
		while(a != null && a.aabb.minx <= ab.maxx) {
			var _this = a.aabb;
			if(ab.miny <= _this.maxy && _this.miny <= ab.maxy && ab.minx <= _this.maxx && _this.minx <= ab.maxx) {
				var shape2 = a.shape;
				var body = shape2.body.outer;
				var tmp;
				if(filter != null) {
					var _this1 = shape2.filter;
					tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
				} else {
					tmp = true;
				}
				if(tmp) {
					if(containment) {
						if(!this.failed.has(body)) {
							var col = zpp_$nape_geom_ZPP_$Collide.containTest(shape,shape2);
							if(!ret.has(body) && col) {
								ret.push(body);
							} else if(!col) {
								ret.remove(body);
								this.failed.push(body);
							}
						}
					} else if(!ret.has(body) && zpp_$nape_geom_ZPP_$Collide.testCollide_safe(shape,shape2)) {
						ret.push(body);
					}
				}
			}
			a = a.next;
		}
		this.failed.clear();
		return ret;
	}
	,rayCast: function(ray,inner,filter) {
		this.sync_broadphase();
		ray.validate_dir();
		var rayab = ray.rayAABB();
		var mint = ray.maxdist;
		var minres = null;
		if(ray.dirx == 0) {
			var a = this.list;
			while(a != null && a.aabb.minx <= rayab.minx) {
				var tmp;
				var _this = a.aabb;
				if(rayab.miny <= _this.maxy && _this.miny <= rayab.maxy && rayab.minx <= _this.maxx && _this.minx <= rayab.maxx) {
					if(filter != null) {
						var _this1 = a.shape.filter;
						tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
					} else {
						tmp = true;
					}
				} else {
					tmp = false;
				}
				if(tmp) {
					var t = ray.aabbsect(a.aabb);
					if(t >= 0 && t < mint) {
						var result = a.shape.type == 0 ? ray.circlesect(a.shape.circle,inner,mint) : ray.polysect(a.shape.polygon,inner,mint);
						if(result != null) {
							mint = result.zpp_inner.toiDistance;
							if(minres != null) {
								minres.zpp_inner.free();
							}
							minres = result;
						}
					}
				}
				a = a.next;
			}
		} else if(ray.dirx < 0) {
			var a = this.list;
			var b = null;
			while(a != null && a.aabb.minx <= rayab.maxx) {
				b = a;
				a = a.next;
			}
			a = b;
			while(a != null) {
				var tmp;
				var _this = a.aabb;
				if(rayab.miny <= _this.maxy && _this.miny <= rayab.maxy && rayab.minx <= _this.maxx && _this.minx <= rayab.maxx) {
					if(filter != null) {
						var _this1 = a.shape.filter;
						tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
					} else {
						tmp = true;
					}
				} else {
					tmp = false;
				}
				if(tmp) {
					var t = ray.aabbsect(a.aabb);
					if(t >= 0 && t < mint) {
						var result = a.shape.type == 0 ? ray.circlesect(a.shape.circle,inner,mint) : ray.polysect(a.shape.polygon,inner,mint);
						if(result != null) {
							mint = result.zpp_inner.toiDistance;
							if(minres != null) {
								minres.zpp_inner.free();
							}
							minres = result;
						}
					}
				}
				a = a.prev;
			}
		} else {
			var a = this.list;
			while(a != null && a.aabb.minx <= rayab.maxx && a.aabb.minx < ray.originx + ray.dirx * mint) {
				var tmp;
				var _this = a.aabb;
				if(rayab.miny <= _this.maxy && _this.miny <= rayab.maxy && rayab.minx <= _this.maxx && _this.minx <= rayab.maxx) {
					if(filter != null) {
						var _this1 = a.shape.filter;
						tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
					} else {
						tmp = true;
					}
				} else {
					tmp = false;
				}
				if(tmp) {
					var t = ray.aabbsect(a.aabb);
					if(t >= 0 && t < mint) {
						var result = a.shape.type == 0 ? ray.circlesect(a.shape.circle,inner,mint) : ray.polysect(a.shape.polygon,inner,mint);
						if(result != null) {
							mint = result.zpp_inner.toiDistance;
							if(minres != null) {
								minres.zpp_inner.free();
							}
							minres = result;
						}
					}
				}
				a = a.next;
			}
		}
		var o = rayab;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o.wrap_min = o.wrap_max = null;
		o._invalidate = null;
		o._validate = null;
		o.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = o;
		return minres;
	}
	,rayMultiCast: function(ray,inner,filter,output) {
		this.sync_broadphase();
		ray.validate_dir();
		var rayab = ray.rayAABB();
		var ret = output == null ? new nape_geom_RayResultList() : output;
		if(ray.dirx == 0) {
			var a = this.list;
			while(a != null && a.aabb.minx <= rayab.minx) {
				var tmp;
				var _this = a.aabb;
				if(rayab.miny <= _this.maxy && _this.miny <= rayab.maxy && rayab.minx <= _this.maxx && _this.minx <= rayab.maxx) {
					if(filter != null) {
						var _this1 = a.shape.filter;
						tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
					} else {
						tmp = true;
					}
				} else {
					tmp = false;
				}
				if(tmp) {
					var t = ray.aabbsect(a.aabb);
					if(t >= 0) {
						if(a.shape.type == 0) {
							ray.circlesect2(a.shape.circle,inner,ret);
						} else {
							ray.polysect2(a.shape.polygon,inner,ret);
						}
					}
				}
				a = a.next;
			}
		} else if(ray.dirx < 0) {
			var a = this.list;
			var b = null;
			while(a != null && a.aabb.minx <= rayab.maxx) {
				b = a;
				a = a.next;
			}
			a = b;
			while(a != null) {
				var tmp;
				var _this = a.aabb;
				if(rayab.miny <= _this.maxy && _this.miny <= rayab.maxy && rayab.minx <= _this.maxx && _this.minx <= rayab.maxx) {
					if(filter != null) {
						var _this1 = a.shape.filter;
						tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
					} else {
						tmp = true;
					}
				} else {
					tmp = false;
				}
				if(tmp) {
					var t = ray.aabbsect(a.aabb);
					if(t >= 0) {
						if(a.shape.type == 0) {
							ray.circlesect2(a.shape.circle,inner,ret);
						} else {
							ray.polysect2(a.shape.polygon,inner,ret);
						}
					}
				}
				a = a.prev;
			}
		} else {
			var a = this.list;
			while(a != null && a.aabb.minx <= rayab.maxx) {
				var tmp;
				var _this = a.aabb;
				if(rayab.miny <= _this.maxy && _this.miny <= rayab.maxy && rayab.minx <= _this.maxx && _this.minx <= rayab.maxx) {
					if(filter != null) {
						var _this1 = a.shape.filter;
						tmp = (_this1.collisionMask & filter.collisionGroup) != 0 && (filter.collisionMask & _this1.collisionGroup) != 0;
					} else {
						tmp = true;
					}
				} else {
					tmp = false;
				}
				if(tmp) {
					var t = ray.aabbsect(a.aabb);
					if(t >= 0) {
						if(a.shape.type == 0) {
							ray.circlesect2(a.shape.circle,inner,ret);
						} else {
							ray.polysect2(a.shape.polygon,inner,ret);
						}
					}
				}
				a = a.next;
			}
		}
		var o = rayab;
		if(o.outer != null) {
			o.outer.zpp_inner = null;
			o.outer = null;
		}
		o.wrap_min = o.wrap_max = null;
		o._invalidate = null;
		o._validate = null;
		o.next = zpp_$nape_geom_ZPP_$AABB.zpp_pool;
		zpp_$nape_geom_ZPP_$AABB.zpp_pool = o;
		return ret;
	}
});
var zpp_$nape_util_ZNPArray2_$Float = function(width,height) {
	this.width = 0;
	this.list = null;
	this.width = width;
	this.list = [];
};
zpp_$nape_util_ZNPArray2_$Float.__name__ = true;
zpp_$nape_util_ZNPArray2_$Float.prototype = {
	resize: function(width,height,def) {
		this.width = width;
		var _g = 0;
		var _g1 = width * height;
		while(_g < _g1) {
			var i = _g++;
			this.list[i] = def;
		}
	}
};
var zpp_$nape_util_ZNPArray2_$ZPP_$GeomVert = function(width,height) {
	this.width = 0;
	this.list = null;
	this.width = width;
	this.list = [];
};
zpp_$nape_util_ZNPArray2_$ZPP_$GeomVert.__name__ = true;
zpp_$nape_util_ZNPArray2_$ZPP_$GeomVert.prototype = {
	resize: function(width,height,def) {
		this.width = width;
		var _g = 0;
		var _g1 = width * height;
		while(_g < _g1) {
			var i = _g++;
			this.list[i] = def;
		}
	}
};
var zpp_$nape_util_ZNPArray2_$ZPP_$MarchPair = function(width,height) {
	this.width = 0;
	this.list = null;
	this.width = width;
	this.list = [];
};
zpp_$nape_util_ZNPArray2_$ZPP_$MarchPair.__name__ = true;
zpp_$nape_util_ZNPArray2_$ZPP_$MarchPair.prototype = {
	resize: function(width,height,def) {
		this.width = width;
		var _g = 0;
		var _g1 = width * height;
		while(_g < _g1) {
			var i = _g++;
			this.list[i] = def;
		}
	}
};
var zpp_$nape_util_Hashable2_$Boolfalse = function() {
	this.di = 0;
	this.id = 0;
	this.hnext = null;
	this.next = null;
	this.value = false;
};
zpp_$nape_util_Hashable2_$Boolfalse.__name__ = true;
var zpp_$nape_util_FastHash2_$Hashable2_$Boolfalse = function() {
	this.cnt = 0;
	this.table = null;
	this.cnt = 0;
	this.table = [];
	var _g = 0;
	var _g1 = 1048576;
	while(_g < _g1) {
		var i = _g++;
		this.table.push(null);
	}
};
zpp_$nape_util_FastHash2_$Hashable2_$Boolfalse.__name__ = true;
zpp_$nape_util_FastHash2_$Hashable2_$Boolfalse.prototype = {
	has: function(id,di) {
		var n = this.table[id * 106039 + di & 1048575];
		if(n == null) {
			return false;
		} else if(n.id == id && n.di == di) {
			return true;
		} else {
			do n = n.hnext; while(n != null && (n.id != id || n.di != di));
			return n != null;
		}
	}
	,add: function(arb) {
		var h = arb.id * 106039 + arb.di & 1048575;
		var n = this.table[h];
		if(n == null) {
			this.table[h] = arb;
			arb.hnext = null;
		} else {
			arb.hnext = n.hnext;
			n.hnext = arb;
		}
		this.cnt++;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Compound = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Compound.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Compound.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Compound();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Compound();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Compound.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$AABBNode = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$AABBNode.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$AABBNode.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$AABBNode();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Edge = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Edge.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Edge.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Edge();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Edge();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Edge.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,reverse: function() {
		var cur = this.head;
		var pre = null;
		while(cur != null) {
			var nx = cur.next;
			cur.next = pre;
			this.head = cur;
			pre = cur;
			cur = nx;
		}
		this.modified = true;
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$AABBPair = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$AABBPair.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$AABBPair.prototype = {
	pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Shape = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Shape.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Shape.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Shape();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Shape();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Shape.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Arbiter = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Arbiter.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Arbiter.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Arbiter();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Body = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Body.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Body.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Body();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Body();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,clear: function() {
		while(this.head != null) {
			var ret = this.head;
			this.head = ret.next;
			var o = ret;
			o.elt = null;
			o.next = zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Body.zpp_pool = o;
			if(this.head == null) {
				this.pushmod = true;
			}
			this.modified = true;
			this.length--;
		}
		this.pushmod = true;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$CallbackSet = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$CallbackSet.__name__ = true;
var zpp_$nape_util_ZNPList_$ZPP_$Component = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Component.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Component.prototype = {
	pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Component.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$FluidArbiter = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$FluidArbiter.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$FluidArbiter.prototype = {
	pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$CutInt = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$CutInt.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$CutInt.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CutInt();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$CutInt.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$SensorArbiter = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$SensorArbiter.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$SensorArbiter.prototype = {
	pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$CutVert = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$CutVert.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$CutVert.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CutVert();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$CutVert.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$Listener = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$Listener.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$Listener.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Listener();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$Listener();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$Listener.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$ColArbiter = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$ColArbiter.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$ColArbiter.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$ToiEvent = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$ToiEvent.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$ToiEvent.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$PartitionVertex.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,reverse: function() {
		var cur = this.head;
		var pre = null;
		while(cur != null) {
			var nx = cur.next;
			cur.next = pre;
			this.head = cur;
			pre = cur;
			cur = nx;
		}
		this.modified = true;
		this.pushmod = true;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$PartitionedPoly = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$PartitionedPoly.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$PartitionedPoly.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$SimplifyP = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$SimplifyP.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$SimplifyP.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$GeomVert = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$GeomVert.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$GeomVert.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$GeomVert();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$SimpleVert = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$SimpleVert.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$SimpleVert.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$SimpleEvent = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$SimpleEvent.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$SimpleEvent.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$InteractionGroup = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$InteractionGroup.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$InteractionGroup.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$CbSetPair = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$CbSetPair.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$CbSetPair.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,pop_unsafe: function() {
		var ret = this.head.elt;
		this.pop();
		return ret;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
};
var zpp_$nape_util_ZNPList_$ConvexResult = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ConvexResult.__name__ = true;
zpp_$nape_util_ZNPList_$ConvexResult.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ConvexResult();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool;
			zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ConvexResult();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool;
			zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool;
		zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool;
				zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool;
		zpp_$nape_util_ZNPNode_$ConvexResult.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$ZPP_$GeomPoly = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$ZPP_$GeomPoly.__name__ = true;
zpp_$nape_util_ZNPList_$ZPP_$GeomPoly.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly();
		} else {
			ret = zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool;
			zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool;
				zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool;
		zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPList_$RayResult = function() {
	this.length = 0;
	this.pushmod = false;
	this.modified = false;
	this.head = null;
};
zpp_$nape_util_ZNPList_$RayResult.__name__ = true;
zpp_$nape_util_ZNPList_$RayResult.prototype = {
	add: function(o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$RayResult();
		} else {
			ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
			zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		temp.next = this.head;
		this.head = temp;
		this.modified = true;
		this.length++;
		return o;
	}
	,insert: function(cur,o) {
		var ret;
		if(zpp_$nape_util_ZNPNode_$RayResult.zpp_pool == null) {
			ret = new zpp_$nape_util_ZNPNode_$RayResult();
		} else {
			ret = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
			zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = ret.next;
			ret.next = null;
		}
		ret.elt = o;
		var temp = ret;
		if(cur == null) {
			temp.next = this.head;
			this.head = temp;
		} else {
			temp.next = cur.next;
			cur.next = temp;
		}
		this.pushmod = this.modified = true;
		this.length++;
		return temp;
	}
	,pop: function() {
		var ret = this.head;
		this.head = ret.next;
		var o = ret;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
		zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = o;
		if(this.head == null) {
			this.pushmod = true;
		}
		this.modified = true;
		this.length--;
	}
	,remove: function(obj) {
		var pre = null;
		var cur = this.head;
		var ret = false;
		while(cur != null) {
			if(cur.elt == obj) {
				var old;
				var ret1;
				if(pre == null) {
					old = this.head;
					ret1 = old.next;
					this.head = ret1;
					if(this.head == null) {
						this.pushmod = true;
					}
				} else {
					old = pre.next;
					ret1 = old.next;
					pre.next = ret1;
					if(ret1 == null) {
						this.pushmod = true;
					}
				}
				var o = old;
				o.elt = null;
				o.next = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
				zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = o;
				this.modified = true;
				this.length--;
				this.pushmod = true;
				ret = true;
				break;
			}
			pre = cur;
			cur = cur.next;
		}
	}
	,erase: function(pre) {
		var old;
		var ret;
		if(pre == null) {
			old = this.head;
			ret = old.next;
			this.head = ret;
			if(this.head == null) {
				this.pushmod = true;
			}
		} else {
			old = pre.next;
			ret = old.next;
			pre.next = ret;
			if(ret == null) {
				this.pushmod = true;
			}
		}
		var o = old;
		o.elt = null;
		o.next = zpp_$nape_util_ZNPNode_$RayResult.zpp_pool;
		zpp_$nape_util_ZNPNode_$RayResult.zpp_pool = o;
		this.modified = true;
		this.length--;
		this.pushmod = true;
		return ret;
	}
	,has: function(obj) {
		var ret;
		ret = false;
		var cx_ite = this.head;
		while(cx_ite != null) {
			var npite = cx_ite.elt;
			if(npite == obj) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		return ret;
	}
	,iterator_at: function(ind) {
		var ret = this.head;
		while(ind-- > 0 && ret != null) ret = ret.next;
		return ret;
	}
};
var zpp_$nape_util_ZNPNode_$ZPP_$Compound = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Compound.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$AABBNode = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$AABBNode.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Edge = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Edge.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$AABBPair = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$AABBPair.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Shape = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Shape.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Arbiter = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Arbiter.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Constraint = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Constraint.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Body = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Body.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$CallbackSet.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$CbType = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$CbType.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Component = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Component.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Vec2 = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Vec2.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$FluidArbiter.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$CutInt = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$CutInt.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$SensorArbiter.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$CutVert = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$CutVert.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Listener = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Listener.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$ColArbiter.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$ToiEvent.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$Interactor = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$Interactor.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$InteractionListener.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$PartitionVertex.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$PartitionedPoly.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$SimplifyP.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$GeomVert = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$GeomVert.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$SimpleVert.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$SimpleEvent.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$InteractionGroup.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$CbSet = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$CbSet.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$BodyListener = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$BodyListener.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$ConstraintListener.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$CbSetPair.__name__ = true;
var zpp_$nape_util_ZNPNode_$ConvexResult = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ConvexResult.__name__ = true;
var zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$ZPP_$GeomPoly.__name__ = true;
var zpp_$nape_util_ZNPNode_$RayResult = function() {
	this.elt = null;
	this.next = null;
};
zpp_$nape_util_ZNPNode_$RayResult.__name__ = true;
var zpp_$nape_util_ZPP_$MixVec2List = function() {
	this.at_index = 0;
	this.at_ite = null;
	this.zip_length = false;
	this._length = 0;
	this.inner = null;
	nape_geom_Vec2List.call(this);
	this.at_ite = null;
	this.at_index = 0;
	this.zip_length = true;
	this._length = 0;
};
zpp_$nape_util_ZPP_$MixVec2List.__name__ = true;
zpp_$nape_util_ZPP_$MixVec2List.get = function(list,immutable) {
	if(immutable == null) {
		immutable = false;
	}
	var ret = new zpp_$nape_util_ZPP_$MixVec2List();
	ret.inner = list;
	ret.zpp_inner.immutable = immutable;
	return ret;
};
zpp_$nape_util_ZPP_$MixVec2List.__super__ = nape_geom_Vec2List;
zpp_$nape_util_ZPP_$MixVec2List.prototype = $extend(nape_geom_Vec2List.prototype,{
	zpp_gl: function() {
		this.zpp_vm();
		if(this.zip_length) {
			this._length = 0;
			var cx_ite = this.inner.next;
			while(cx_ite != null) {
				var i = cx_ite;
				this._length++;
				cx_ite = cx_ite.next;
			}
			this.zip_length = false;
		}
		return this._length;
	}
	,zpp_vm: function() {
		this.zpp_inner.validate();
		if(this.inner.modified) {
			this.zip_length = true;
			this._length = 0;
			this.at_ite = null;
		}
	}
	,at: function(index) {
		this.zpp_vm();
		if(this.zpp_inner.reverse_flag) {
			index = this.zpp_gl() - 1 - index;
		}
		if(index < this.at_index || this.at_ite == null) {
			this.at_index = 0;
			this.at_ite = this.inner.next;
			do {
				var x = this.at_ite;
			} while(false);
		}
		while(this.at_index != index) {
			this.at_index++;
			this.at_ite = this.at_ite.next;
			do {
				var x = this.at_ite;
			} while(false);
		}
		var _this = this.at_ite;
		if(_this.outer == null) {
			_this.outer = new nape_geom_Vec2();
			var o = _this.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			_this.outer.zpp_inner = _this;
		}
		return _this.outer;
	}
	,push: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				this.inner.add(obj.zpp_inner);
			} else {
				var ite = this.inner.iterator_at(this.zpp_gl() - 1);
				this.inner.insert(ite,obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,unshift: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var cont = this.zpp_inner.adder != null ? this.zpp_inner.adder(obj) : true;
		if(cont) {
			if(this.zpp_inner.reverse_flag) {
				var ite = this.inner.iterator_at(this.zpp_gl() - 1);
				this.inner.insert(ite,obj.zpp_inner);
			} else {
				this.inner.add(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
			if(this.zpp_inner.post_adder != null) {
				this.zpp_inner.post_adder(obj);
			}
		}
		return cont;
	}
	,pop: function() {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			ret = this.inner.next;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.inner.pop();
			}
		} else {
			if(this.at_ite != null && this.at_ite.next == null) {
				this.at_ite = null;
			}
			var ite = this.zpp_gl() == 1 ? null : this.inner.iterator_at(this.zpp_gl() - 2);
			ret = ite == null ? this.inner.next : ite.next;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.inner.erase(ite);
			}
		}
		this.zpp_inner.invalidate();
		if(ret.outer == null) {
			ret.outer = new nape_geom_Vec2();
			var o = ret.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			ret.outer.zpp_inner = ret;
		}
		var retx = ret.outer;
		return retx;
	}
	,shift: function() {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret = null;
		if(this.zpp_inner.reverse_flag) {
			if(this.at_ite != null && this.at_ite.next == null) {
				this.at_ite = null;
			}
			var ite = this.zpp_gl() == 1 ? null : this.inner.iterator_at(this.zpp_gl() - 2);
			ret = ite == null ? this.inner.next : ite.next;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.inner.erase(ite);
			}
		} else {
			ret = this.inner.next;
			if(ret.outer == null) {
				ret.outer = new nape_geom_Vec2();
				var o = ret.outer.zpp_inner;
				if(o.outer != null) {
					o.outer.zpp_inner = null;
					o.outer = null;
				}
				o._isimmutable = null;
				o._validate = null;
				o._invalidate = null;
				o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
				zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
				ret.outer.zpp_inner = ret;
			}
			var retx = ret.outer;
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(retx);
			}
			if(!this.zpp_inner.dontremove) {
				this.inner.pop();
			}
		}
		this.zpp_inner.invalidate();
		if(ret.outer == null) {
			ret.outer = new nape_geom_Vec2();
			var o = ret.outer.zpp_inner;
			if(o.outer != null) {
				o.outer.zpp_inner = null;
				o.outer = null;
			}
			o._isimmutable = null;
			o._validate = null;
			o._invalidate = null;
			o.next = zpp_$nape_geom_ZPP_$Vec2.zpp_pool;
			zpp_$nape_geom_ZPP_$Vec2.zpp_pool = o;
			ret.outer.zpp_inner = ret;
		}
		var retx = ret.outer;
		return retx;
	}
	,remove: function(obj) {
		this.zpp_inner.modify_test();
		this.zpp_vm();
		var ret;
		ret = false;
		var cx_ite = this.inner.next;
		while(cx_ite != null) {
			var x = cx_ite;
			if(obj.zpp_inner == x) {
				ret = true;
				break;
			}
			cx_ite = cx_ite.next;
		}
		if(ret) {
			if(this.zpp_inner.subber != null) {
				this.zpp_inner.subber(obj);
			}
			if(!this.zpp_inner.dontremove) {
				this.inner.remove(obj.zpp_inner);
			}
			this.zpp_inner.invalidate();
		}
		return ret;
	}
	,clear: function() {
		if(this.zpp_inner.reverse_flag) {
			while(!this.empty()) this.pop();
		} else {
			while(!this.empty()) this.shift();
		}
	}
});
var zpp_$nape_util_ZPP_$EdgeList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Edge();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$EdgeList.__name__ = true;
zpp_$nape_util_ZPP_$EdgeList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_shape_EdgeList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$EdgeList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$ShapeList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Shape();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$ShapeList.__name__ = true;
zpp_$nape_util_ZPP_$ShapeList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_shape_ShapeList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$ShapeList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$BodyList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Body();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$BodyList.__name__ = true;
zpp_$nape_util_ZPP_$BodyList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_phys_BodyList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$BodyList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$CompoundList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Compound();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$CompoundList.__name__ = true;
zpp_$nape_util_ZPP_$CompoundList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_phys_CompoundList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$CompoundList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$InteractorList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Interactor();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$InteractorList.__name__ = true;
zpp_$nape_util_ZPP_$InteractorList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_phys_InteractorList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$InteractorList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$ConvexResultList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ConvexResult();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$ConvexResultList.__name__ = true;
zpp_$nape_util_ZPP_$ConvexResultList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$GeomPolyList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$GeomPoly();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$GeomPolyList.__name__ = true;
zpp_$nape_util_ZPP_$GeomPolyList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$RayResultList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$RayResult();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$RayResultList.__name__ = true;
zpp_$nape_util_ZPP_$RayResultList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$Vec2List = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Vec2();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$Vec2List.__name__ = true;
zpp_$nape_util_ZPP_$Vec2List.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$ArbiterList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Arbiter();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$ArbiterList.__name__ = true;
zpp_$nape_util_ZPP_$ArbiterList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_dynamics_ArbiterList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$ArbiterList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$ContactList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_dynamics_ZPP_$Contact();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$ContactList.__name__ = true;
zpp_$nape_util_ZPP_$ContactList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_dynamics_ContactList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$ContactList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$InteractionGroupList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$InteractionGroup();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$InteractionGroupList.__name__ = true;
zpp_$nape_util_ZPP_$InteractionGroupList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_dynamics_InteractionGroupList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$InteractionGroupList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$ConstraintList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Constraint();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$ConstraintList.__name__ = true;
zpp_$nape_util_ZPP_$ConstraintList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_constraint_ConstraintList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$ConstraintList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$CbTypeList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$CbTypeList.__name__ = true;
zpp_$nape_util_ZPP_$CbTypeList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_callbacks_CbTypeList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$CbTypeList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$ListenerList = function() {
	this.user_length = 0;
	this.zip_length = false;
	this.push_ite = null;
	this.at_ite = null;
	this.at_index = 0;
	this.reverse_flag = false;
	this.dontremove = false;
	this.subber = null;
	this.post_adder = null;
	this.adder = null;
	this._validate = null;
	this._invalidate = null;
	this._invalidated = false;
	this.immutable = false;
	this.inner = null;
	this.outer = null;
	this.inner = new zpp_$nape_util_ZNPList_$ZPP_$Listener();
	this._invalidated = true;
};
zpp_$nape_util_ZPP_$ListenerList.__name__ = true;
zpp_$nape_util_ZPP_$ListenerList.get = function(list,imm) {
	if(imm == null) {
		imm = false;
	}
	var ret = new nape_callbacks_ListenerList();
	ret.zpp_inner.inner = list;
	if(imm) {
		ret.zpp_inner.immutable = true;
	}
	ret.zpp_inner.zip_length = true;
	return ret;
};
zpp_$nape_util_ZPP_$ListenerList.prototype = {
	valmod: function() {
		this.validate();
		if(this.inner.modified) {
			if(this.inner.pushmod) {
				this.push_ite = null;
			}
			this.at_ite = null;
			this.inner.modified = false;
			this.inner.pushmod = false;
			this.zip_length = true;
		}
	}
	,modify_test: function() {
	}
	,validate: function() {
		if(this._invalidated) {
			this._invalidated = false;
			if(this._validate != null) {
				this._validate();
			}
		}
	}
	,invalidate: function() {
		this._invalidated = true;
		if(this._invalidate != null) {
			this._invalidate(this);
		}
	}
};
var zpp_$nape_util_ZPP_$Math = function() { };
zpp_$nape_util_ZPP_$Math.__name__ = true;
var zpp_$nape_util_ZPP_$PubPool = function() { };
zpp_$nape_util_ZPP_$PubPool.__name__ = true;
var zpp_$nape_util_ZPP_$Set_$ZPP_$Body = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$Body.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$Body.prototype = {
	__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,try_insert_bool: function(obj) {
		var x = null;
		var cur = null;
		if(this.parent == null) {
			if(zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool == null) {
				x = new zpp_$nape_util_ZPP_$Set_$ZPP_$Body();
			} else {
				x = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = x.next;
				x.next = null;
			}
			x.data = obj;
			this.parent = x;
		} else {
			cur = this.parent;
			while(true) if(this.lt(obj,cur.data)) {
				if(cur.prev == null) {
					if(zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool == null) {
						x = new zpp_$nape_util_ZPP_$Set_$ZPP_$Body();
					} else {
						x = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool;
						zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = x.next;
						x.next = null;
					}
					x.data = obj;
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(this.lt(cur.data,obj)) {
				if(cur.next == null) {
					if(zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool == null) {
						x = new zpp_$nape_util_ZPP_$Set_$ZPP_$Body();
					} else {
						x = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool;
						zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = x.next;
						x.next = null;
					}
					x.data = obj;
					cur.next = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.next;
				}
			} else {
				break;
			}
		}
		if(x == null) {
			return false;
		} else {
			if(x.parent == null) {
				x.colour = 1;
			} else {
				x.colour = 0;
				if(x.parent.colour == 0) {
					this.__fix_dbl_red(x);
				}
			}
			return true;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$Body();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$Body.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.prototype = {
	empty: function() {
		return this.parent == null;
	}
	,find: function(obj) {
		var cur = this.parent;
		while(cur != null && cur.data != obj) if(this.lt(obj,cur.data)) {
			cur = cur.prev;
		} else {
			cur = cur.next;
		}
		return cur;
	}
	,find_weak: function(obj) {
		var cur = this.parent;
		while(cur != null) if(this.lt(obj,cur.data)) {
			cur = cur.prev;
		} else if(this.lt(cur.data,obj)) {
			cur = cur.next;
		} else {
			break;
		}
		return cur;
	}
	,remove: function(obj) {
		var node = this.find(obj);
		this.remove_node(node);
	}
	,remove_node: function(cur) {
		if(cur.next != null && cur.prev != null) {
			var sm = cur.next;
			while(sm.prev != null) sm = sm.prev;
			var t = cur.data;
			cur.data = sm.data;
			sm.data = t;
			if(this.swapped != null) {
				this.swapped(cur.data,sm.data);
			}
			cur = sm;
		}
		var child = cur.prev == null ? cur.next : cur.prev;
		if(cur.colour == 1) {
			if(cur.prev != null || cur.next != null) {
				child.colour = 1;
			} else if(cur.parent != null) {
				var parent = cur.parent;
				while(true) {
					parent.colour++;
					parent.prev.colour--;
					parent.next.colour--;
					var child1 = parent.prev;
					if(child1.colour == -1) {
						this.__fix_neg_red(child1);
						break;
					} else if(child1.colour == 0) {
						if(child1.prev != null && child1.prev.colour == 0) {
							this.__fix_dbl_red(child1.prev);
							break;
						}
						if(child1.next != null && child1.next.colour == 0) {
							this.__fix_dbl_red(child1.next);
							break;
						}
					}
					var child2 = parent.next;
					if(child2.colour == -1) {
						this.__fix_neg_red(child2);
						break;
					} else if(child2.colour == 0) {
						if(child2.prev != null && child2.prev.colour == 0) {
							this.__fix_dbl_red(child2.prev);
							break;
						}
						if(child2.next != null && child2.next.colour == 0) {
							this.__fix_dbl_red(child2.next);
							break;
						}
					}
					if(parent.colour == 2) {
						if(parent.parent == null) {
							parent.colour = 1;
						} else {
							parent = parent.parent;
							continue;
						}
					}
					break;
				}
			}
		}
		var par = cur.parent;
		if(par == null) {
			this.parent = child;
		} else if(par.prev == cur) {
			par.prev = child;
		} else {
			par.next = child;
		}
		if(child != null) {
			child.parent = par;
		}
		cur.parent = cur.prev = cur.next = null;
		var o = cur;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool = o;
	}
	,__fix_neg_red: function(negred) {
		var parent = negred.parent;
		var child;
		if(parent.prev == negred) {
			var nl = negred.prev;
			var nr = negred.next;
			var trl = nr.prev;
			var trr = nr.next;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.next = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.prev = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.next = parent.next;
			if(parent.next != null) {
				parent.next.parent = nr;
			}
			parent.next = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		} else {
			var nl = negred.next;
			var nr = negred.prev;
			var trl = nr.next;
			var trr = nr.prev;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.prev = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.next = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.prev = parent.prev;
			if(parent.prev != null) {
				parent.prev.parent = nr;
			}
			parent.prev = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		}
		if(child.prev != null && child.prev.colour == 0) {
			this.__fix_dbl_red(child.prev);
		} else if(child.next != null && child.next.colour == 0) {
			this.__fix_dbl_red(child.next);
		}
	}
	,__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$CbSet.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.prototype = {
	empty: function() {
		return this.parent == null;
	}
	,remove_node: function(cur) {
		if(cur.next != null && cur.prev != null) {
			var sm = cur.next;
			while(sm.prev != null) sm = sm.prev;
			var t = cur.data;
			cur.data = sm.data;
			sm.data = t;
			if(this.swapped != null) {
				this.swapped(cur.data,sm.data);
			}
			cur = sm;
		}
		var child = cur.prev == null ? cur.next : cur.prev;
		if(cur.colour == 1) {
			if(cur.prev != null || cur.next != null) {
				child.colour = 1;
			} else if(cur.parent != null) {
				var parent = cur.parent;
				while(true) {
					parent.colour++;
					parent.prev.colour--;
					parent.next.colour--;
					var child1 = parent.prev;
					if(child1.colour == -1) {
						this.__fix_neg_red(child1);
						break;
					} else if(child1.colour == 0) {
						if(child1.prev != null && child1.prev.colour == 0) {
							this.__fix_dbl_red(child1.prev);
							break;
						}
						if(child1.next != null && child1.next.colour == 0) {
							this.__fix_dbl_red(child1.next);
							break;
						}
					}
					var child2 = parent.next;
					if(child2.colour == -1) {
						this.__fix_neg_red(child2);
						break;
					} else if(child2.colour == 0) {
						if(child2.prev != null && child2.prev.colour == 0) {
							this.__fix_dbl_red(child2.prev);
							break;
						}
						if(child2.next != null && child2.next.colour == 0) {
							this.__fix_dbl_red(child2.next);
							break;
						}
					}
					if(parent.colour == 2) {
						if(parent.parent == null) {
							parent.colour = 1;
						} else {
							parent = parent.parent;
							continue;
						}
					}
					break;
				}
			}
		}
		var par = cur.parent;
		if(par == null) {
			this.parent = child;
		} else if(par.prev == cur) {
			par.prev = child;
		} else {
			par.next = child;
		}
		if(child != null) {
			child.parent = par;
		}
		cur.parent = cur.prev = cur.next = null;
		var o = cur;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool = o;
	}
	,__fix_neg_red: function(negred) {
		var parent = negred.parent;
		var child;
		if(parent.prev == negred) {
			var nl = negred.prev;
			var nr = negred.next;
			var trl = nr.prev;
			var trr = nr.next;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.next = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.prev = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.next = parent.next;
			if(parent.next != null) {
				parent.next.parent = nr;
			}
			parent.next = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		} else {
			var nl = negred.next;
			var nr = negred.prev;
			var trl = nr.next;
			var trr = nr.prev;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.prev = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.next = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.prev = parent.prev;
			if(parent.prev != null) {
				parent.prev.parent = nr;
			}
			parent.prev = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		}
		if(child.prev != null && child.prev.colour == 0) {
			this.__fix_dbl_red(child.prev);
		} else if(child.next != null && child.next.colour == 0) {
			this.__fix_dbl_red(child.next);
		}
	}
	,__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionVertex.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.prototype = {
	empty: function() {
		return this.parent == null;
	}
	,singular: function() {
		if(this.parent != null && this.parent.prev == null) {
			return this.parent.next == null;
		} else {
			return false;
		}
	}
	,find: function(obj) {
		var cur = this.parent;
		while(cur != null && cur.data != obj) if(this.lt(obj,cur.data)) {
			cur = cur.prev;
		} else {
			cur = cur.next;
		}
		return cur;
	}
	,first: function() {
		var cur = this.parent;
		while(cur.prev != null) cur = cur.prev;
		return cur.data;
	}
	,remove: function(obj) {
		var node = this.find(obj);
		this.remove_node(node);
	}
	,successor_node: function(cur) {
		if(cur.next != null) {
			cur = cur.next;
			while(cur.prev != null) cur = cur.prev;
		} else {
			var pre = cur;
			cur = cur.parent;
			while(cur != null && cur.prev != pre) {
				pre = cur;
				cur = cur.parent;
			}
		}
		return cur;
	}
	,predecessor_node: function(cur) {
		if(cur.prev != null) {
			cur = cur.prev;
			while(cur.next != null) cur = cur.next;
		} else {
			var pre = cur;
			cur = cur.parent;
			while(cur != null && cur.next != pre) {
				pre = cur;
				cur = cur.parent;
			}
		}
		return cur;
	}
	,remove_node: function(cur) {
		if(cur.next != null && cur.prev != null) {
			var sm = cur.next;
			while(sm.prev != null) sm = sm.prev;
			var t = cur.data;
			cur.data = sm.data;
			sm.data = t;
			if(this.swapped != null) {
				this.swapped(cur.data,sm.data);
			}
			cur = sm;
		}
		var child = cur.prev == null ? cur.next : cur.prev;
		if(cur.colour == 1) {
			if(cur.prev != null || cur.next != null) {
				child.colour = 1;
			} else if(cur.parent != null) {
				var parent = cur.parent;
				while(true) {
					parent.colour++;
					parent.prev.colour--;
					parent.next.colour--;
					var child1 = parent.prev;
					if(child1.colour == -1) {
						this.__fix_neg_red(child1);
						break;
					} else if(child1.colour == 0) {
						if(child1.prev != null && child1.prev.colour == 0) {
							this.__fix_dbl_red(child1.prev);
							break;
						}
						if(child1.next != null && child1.next.colour == 0) {
							this.__fix_dbl_red(child1.next);
							break;
						}
					}
					var child2 = parent.next;
					if(child2.colour == -1) {
						this.__fix_neg_red(child2);
						break;
					} else if(child2.colour == 0) {
						if(child2.prev != null && child2.prev.colour == 0) {
							this.__fix_dbl_red(child2.prev);
							break;
						}
						if(child2.next != null && child2.next.colour == 0) {
							this.__fix_dbl_red(child2.next);
							break;
						}
					}
					if(parent.colour == 2) {
						if(parent.parent == null) {
							parent.colour = 1;
						} else {
							parent = parent.parent;
							continue;
						}
					}
					break;
				}
			}
		}
		var par = cur.parent;
		if(par == null) {
			this.parent = child;
		} else if(par.prev == cur) {
			par.prev = child;
		} else {
			par.next = child;
		}
		if(child != null) {
			child.parent = par;
		}
		cur.parent = cur.prev = cur.next = null;
		var o = cur;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = o;
	}
	,clear: function() {
		if(this.parent != null) {
			var cur = this.parent;
			while(cur != null) if(cur.prev != null) {
				cur = cur.prev;
			} else if(cur.next != null) {
				cur = cur.next;
			} else {
				var ret = cur.parent;
				if(ret != null) {
					if(cur == ret.prev) {
						ret.prev = null;
					} else {
						ret.next = null;
					}
					cur.parent = null;
				}
				var o = cur;
				o.data = null;
				o.lt = null;
				o.swapped = null;
				o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = o;
				cur = ret;
			}
			this.parent = null;
		}
	}
	,__fix_neg_red: function(negred) {
		var parent = negred.parent;
		var child;
		if(parent.prev == negred) {
			var nl = negred.prev;
			var nr = negred.next;
			var trl = nr.prev;
			var trr = nr.next;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.next = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.prev = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.next = parent.next;
			if(parent.next != null) {
				parent.next.parent = nr;
			}
			parent.next = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		} else {
			var nl = negred.next;
			var nr = negred.prev;
			var trl = nr.next;
			var trr = nr.prev;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.prev = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.next = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.prev = parent.prev;
			if(parent.prev != null) {
				parent.prev.parent = nr;
			}
			parent.prev = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		}
		if(child.prev != null && child.prev.colour == 0) {
			this.__fix_dbl_red(child.prev);
		} else if(child.next != null && child.next.colour == 0) {
			this.__fix_dbl_red(child.next);
		}
	}
	,__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleVert.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.prototype = {
	successor_node: function(cur) {
		if(cur.next != null) {
			cur = cur.next;
			while(cur.prev != null) cur = cur.prev;
		} else {
			var pre = cur;
			cur = cur.parent;
			while(cur != null && cur.prev != pre) {
				pre = cur;
				cur = cur.parent;
			}
		}
		return cur;
	}
	,predecessor_node: function(cur) {
		if(cur.prev != null) {
			cur = cur.prev;
			while(cur.next != null) cur = cur.next;
		} else {
			var pre = cur;
			cur = cur.parent;
			while(cur != null && cur.next != pre) {
				pre = cur;
				cur = cur.parent;
			}
		}
		return cur;
	}
	,remove_node: function(cur) {
		if(cur.next != null && cur.prev != null) {
			var sm = cur.next;
			while(sm.prev != null) sm = sm.prev;
			var t = cur.data;
			cur.data = sm.data;
			sm.data = t;
			if(this.swapped != null) {
				this.swapped(cur.data,sm.data);
			}
			cur = sm;
		}
		var child = cur.prev == null ? cur.next : cur.prev;
		if(cur.colour == 1) {
			if(cur.prev != null || cur.next != null) {
				child.colour = 1;
			} else if(cur.parent != null) {
				var parent = cur.parent;
				while(true) {
					parent.colour++;
					parent.prev.colour--;
					parent.next.colour--;
					var child1 = parent.prev;
					if(child1.colour == -1) {
						this.__fix_neg_red(child1);
						break;
					} else if(child1.colour == 0) {
						if(child1.prev != null && child1.prev.colour == 0) {
							this.__fix_dbl_red(child1.prev);
							break;
						}
						if(child1.next != null && child1.next.colour == 0) {
							this.__fix_dbl_red(child1.next);
							break;
						}
					}
					var child2 = parent.next;
					if(child2.colour == -1) {
						this.__fix_neg_red(child2);
						break;
					} else if(child2.colour == 0) {
						if(child2.prev != null && child2.prev.colour == 0) {
							this.__fix_dbl_red(child2.prev);
							break;
						}
						if(child2.next != null && child2.next.colour == 0) {
							this.__fix_dbl_red(child2.next);
							break;
						}
					}
					if(parent.colour == 2) {
						if(parent.parent == null) {
							parent.colour = 1;
						} else {
							parent = parent.parent;
							continue;
						}
					}
					break;
				}
			}
		}
		var par = cur.parent;
		if(par == null) {
			this.parent = child;
		} else if(par.prev == cur) {
			par.prev = child;
		} else {
			par.next = child;
		}
		if(child != null) {
			child.parent = par;
		}
		cur.parent = cur.prev = cur.next = null;
		var o = cur;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool = o;
	}
	,clear: function() {
		if(this.parent != null) {
			var cur = this.parent;
			while(cur != null) if(cur.prev != null) {
				cur = cur.prev;
			} else if(cur.next != null) {
				cur = cur.next;
			} else {
				var ret = cur.parent;
				if(ret != null) {
					if(cur == ret.prev) {
						ret.prev = null;
					} else {
						ret.next = null;
					}
					cur.parent = null;
				}
				var o = cur;
				o.data = null;
				o.lt = null;
				o.swapped = null;
				o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool = o;
				cur = ret;
			}
			this.parent = null;
		}
	}
	,__fix_neg_red: function(negred) {
		var parent = negred.parent;
		var child;
		if(parent.prev == negred) {
			var nl = negred.prev;
			var nr = negred.next;
			var trl = nr.prev;
			var trr = nr.next;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.next = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.prev = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.next = parent.next;
			if(parent.next != null) {
				parent.next.parent = nr;
			}
			parent.next = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		} else {
			var nl = negred.next;
			var nr = negred.prev;
			var trl = nr.next;
			var trr = nr.prev;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.prev = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.next = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.prev = parent.prev;
			if(parent.prev != null) {
				parent.prev.parent = nr;
			}
			parent.prev = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		}
		if(child.prev != null && child.prev.colour == 0) {
			this.__fix_dbl_red(child.prev);
		} else if(child.next != null && child.next.colour == 0) {
			this.__fix_dbl_red(child.next);
		}
	}
	,__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleSeg.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.prototype = {
	empty: function() {
		return this.parent == null;
	}
	,find: function(obj) {
		var cur = this.parent;
		while(cur != null && cur.data != obj) if(this.lt(obj,cur.data)) {
			cur = cur.prev;
		} else {
			cur = cur.next;
		}
		return cur;
	}
	,pop_front: function() {
		var cur = this.parent;
		while(cur.prev != null) cur = cur.prev;
		var ret = cur.data;
		this.remove_node(cur);
		return ret;
	}
	,remove: function(obj) {
		var node = this.find(obj);
		this.remove_node(node);
	}
	,remove_node: function(cur) {
		if(cur.next != null && cur.prev != null) {
			var sm = cur.next;
			while(sm.prev != null) sm = sm.prev;
			var t = cur.data;
			cur.data = sm.data;
			sm.data = t;
			if(this.swapped != null) {
				this.swapped(cur.data,sm.data);
			}
			cur = sm;
		}
		var child = cur.prev == null ? cur.next : cur.prev;
		if(cur.colour == 1) {
			if(cur.prev != null || cur.next != null) {
				child.colour = 1;
			} else if(cur.parent != null) {
				var parent = cur.parent;
				while(true) {
					parent.colour++;
					parent.prev.colour--;
					parent.next.colour--;
					var child1 = parent.prev;
					if(child1.colour == -1) {
						this.__fix_neg_red(child1);
						break;
					} else if(child1.colour == 0) {
						if(child1.prev != null && child1.prev.colour == 0) {
							this.__fix_dbl_red(child1.prev);
							break;
						}
						if(child1.next != null && child1.next.colour == 0) {
							this.__fix_dbl_red(child1.next);
							break;
						}
					}
					var child2 = parent.next;
					if(child2.colour == -1) {
						this.__fix_neg_red(child2);
						break;
					} else if(child2.colour == 0) {
						if(child2.prev != null && child2.prev.colour == 0) {
							this.__fix_dbl_red(child2.prev);
							break;
						}
						if(child2.next != null && child2.next.colour == 0) {
							this.__fix_dbl_red(child2.next);
							break;
						}
					}
					if(parent.colour == 2) {
						if(parent.parent == null) {
							parent.colour = 1;
						} else {
							parent = parent.parent;
							continue;
						}
					}
					break;
				}
			}
		}
		var par = cur.parent;
		if(par == null) {
			this.parent = child;
		} else if(par.prev == cur) {
			par.prev = child;
		} else {
			par.next = child;
		}
		if(child != null) {
			child.parent = par;
		}
		cur.parent = cur.prev = cur.next = null;
		var o = cur;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool = o;
	}
	,__fix_neg_red: function(negred) {
		var parent = negred.parent;
		var child;
		if(parent.prev == negred) {
			var nl = negred.prev;
			var nr = negred.next;
			var trl = nr.prev;
			var trr = nr.next;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.next = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.prev = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.next = parent.next;
			if(parent.next != null) {
				parent.next.parent = nr;
			}
			parent.next = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		} else {
			var nl = negred.next;
			var nr = negred.prev;
			var trl = nr.next;
			var trr = nr.prev;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.prev = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.next = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.prev = parent.prev;
			if(parent.prev != null) {
				parent.prev.parent = nr;
			}
			parent.prev = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		}
		if(child.prev != null && child.prev.colour == 0) {
			this.__fix_dbl_red(child.prev);
		} else if(child.next != null && child.next.colour == 0) {
			this.__fix_dbl_red(child.next);
		}
	}
	,__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$SimpleEvent.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.prototype = {
	remove_node: function(cur) {
		if(cur.next != null && cur.prev != null) {
			var sm = cur.next;
			while(sm.prev != null) sm = sm.prev;
			var t = cur.data;
			cur.data = sm.data;
			sm.data = t;
			if(this.swapped != null) {
				this.swapped(cur.data,sm.data);
			}
			cur = sm;
		}
		var child = cur.prev == null ? cur.next : cur.prev;
		if(cur.colour == 1) {
			if(cur.prev != null || cur.next != null) {
				child.colour = 1;
			} else if(cur.parent != null) {
				var parent = cur.parent;
				while(true) {
					parent.colour++;
					parent.prev.colour--;
					parent.next.colour--;
					var child1 = parent.prev;
					if(child1.colour == -1) {
						this.__fix_neg_red(child1);
						break;
					} else if(child1.colour == 0) {
						if(child1.prev != null && child1.prev.colour == 0) {
							this.__fix_dbl_red(child1.prev);
							break;
						}
						if(child1.next != null && child1.next.colour == 0) {
							this.__fix_dbl_red(child1.next);
							break;
						}
					}
					var child2 = parent.next;
					if(child2.colour == -1) {
						this.__fix_neg_red(child2);
						break;
					} else if(child2.colour == 0) {
						if(child2.prev != null && child2.prev.colour == 0) {
							this.__fix_dbl_red(child2.prev);
							break;
						}
						if(child2.next != null && child2.next.colour == 0) {
							this.__fix_dbl_red(child2.next);
							break;
						}
					}
					if(parent.colour == 2) {
						if(parent.parent == null) {
							parent.colour = 1;
						} else {
							parent = parent.parent;
							continue;
						}
					}
					break;
				}
			}
		}
		var par = cur.parent;
		if(par == null) {
			this.parent = child;
		} else if(par.prev == cur) {
			par.prev = child;
		} else {
			par.next = child;
		}
		if(child != null) {
			child.parent = par;
		}
		cur.parent = cur.prev = cur.next = null;
		var o = cur;
		o.data = null;
		o.lt = null;
		o.swapped = null;
		o.next = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool;
		zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool = o;
	}
	,__fix_neg_red: function(negred) {
		var parent = negred.parent;
		var child;
		if(parent.prev == negred) {
			var nl = negred.prev;
			var nr = negred.next;
			var trl = nr.prev;
			var trr = nr.next;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.next = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.prev = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.next = parent.next;
			if(parent.next != null) {
				parent.next.parent = nr;
			}
			parent.next = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		} else {
			var nl = negred.next;
			var nr = negred.prev;
			var trl = nr.next;
			var trr = nr.prev;
			nl.colour = 0;
			negred.colour = parent.colour = 1;
			negred.prev = trl;
			if(trl != null) {
				trl.parent = negred;
			}
			var t = parent.data;
			parent.data = nr.data;
			nr.data = t;
			if(this.swapped != null) {
				this.swapped(parent.data,nr.data);
			}
			nr.next = trr;
			if(trr != null) {
				trr.parent = nr;
			}
			nr.prev = parent.prev;
			if(parent.prev != null) {
				parent.prev.parent = nr;
			}
			parent.prev = nr;
			if(nr != null) {
				nr.parent = parent;
			}
			child = nl;
		}
		if(child.prev != null && child.prev.colour == 0) {
			this.__fix_dbl_red(child.prev);
		} else if(child.next != null && child.next.colour == 0) {
			this.__fix_dbl_red(child.next);
		}
	}
	,__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,insert: function(obj) {
		var x;
		if(zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool == null) {
			x = new zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair();
		} else {
			x = zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool;
			zpp_$nape_util_ZPP_$Set_$ZPP_$PartitionPair.zpp_pool = x.next;
			x.next = null;
		}
		x.data = obj;
		if(this.parent == null) {
			this.parent = x;
		} else {
			var cur = this.parent;
			while(true) if(this.lt(x.data,cur.data)) {
				if(cur.prev == null) {
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(cur.next == null) {
				cur.next = x;
				x.parent = cur;
				break;
			} else {
				cur = cur.next;
			}
		}
		if(x.parent == null) {
			x.colour = 1;
		} else {
			x.colour = 0;
			if(x.parent.colour == 0) {
				this.__fix_dbl_red(x);
			}
		}
		return x;
	}
};
var zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair = function() {
	this.colour = 0;
	this.parent = null;
	this.next = null;
	this.prev = null;
	this.data = null;
	this.swapped = null;
	this.lt = null;
};
zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.__name__ = true;
zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.prototype = {
	__fix_dbl_red: function(x) {
		while(true) {
			var par = x.parent;
			var g = par.parent;
			if(g == null) {
				par.colour = 1;
				break;
			}
			var n1;
			var n2;
			var n3;
			var t1;
			var t2;
			var t3;
			var t4;
			if(par == g.prev) {
				n3 = g;
				t4 = g.next;
				if(x == par.prev) {
					n1 = x;
					n2 = par;
					t1 = x.prev;
					t2 = x.next;
					t3 = par.next;
				} else {
					n1 = par;
					n2 = x;
					t1 = par.prev;
					t2 = x.prev;
					t3 = x.next;
				}
			} else {
				n1 = g;
				t1 = g.prev;
				if(x == par.prev) {
					n2 = x;
					n3 = par;
					t2 = x.prev;
					t3 = x.next;
					t4 = par.next;
				} else {
					n2 = par;
					n3 = x;
					t2 = par.prev;
					t3 = x.prev;
					t4 = x.next;
				}
			}
			var par1 = g.parent;
			if(par1 == null) {
				this.parent = n2;
			} else if(par1.prev == g) {
				par1.prev = n2;
			} else {
				par1.next = n2;
			}
			if(n2 != null) {
				n2.parent = par1;
			}
			n1.prev = t1;
			if(t1 != null) {
				t1.parent = n1;
			}
			n1.next = t2;
			if(t2 != null) {
				t2.parent = n1;
			}
			n2.prev = n1;
			if(n1 != null) {
				n1.parent = n2;
			}
			n2.next = n3;
			if(n3 != null) {
				n3.parent = n2;
			}
			n3.prev = t3;
			if(t3 != null) {
				t3.parent = n3;
			}
			n3.next = t4;
			if(t4 != null) {
				t4.parent = n3;
			}
			n2.colour = g.colour - 1;
			n1.colour = 1;
			n3.colour = 1;
			if(n2 == this.parent) {
				this.parent.colour = 1;
			} else if(n2.colour == 0 && n2.parent.colour == 0) {
				x = n2;
				continue;
			}
			break;
		}
	}
	,try_insert: function(obj) {
		var x = null;
		var cur = null;
		if(this.parent == null) {
			if(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool == null) {
				x = new zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair();
			} else {
				x = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool;
				zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = x.next;
				x.next = null;
			}
			x.data = obj;
			this.parent = x;
		} else {
			cur = this.parent;
			while(true) if(this.lt(obj,cur.data)) {
				if(cur.prev == null) {
					if(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool == null) {
						x = new zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair();
					} else {
						x = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool;
						zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = x.next;
						x.next = null;
					}
					x.data = obj;
					cur.prev = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.prev;
				}
			} else if(this.lt(cur.data,obj)) {
				if(cur.next == null) {
					if(zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool == null) {
						x = new zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair();
					} else {
						x = zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool;
						zpp_$nape_util_ZPP_$Set_$ZPP_$CbSetPair.zpp_pool = x.next;
						x.next = null;
					}
					x.data = obj;
					cur.next = x;
					x.parent = cur;
					break;
				} else {
					cur = cur.next;
				}
			} else {
				break;
			}
		}
		if(x == null) {
			return cur;
		} else {
			if(x.parent == null) {
				x.colour = 1;
			} else {
				x.colour = 0;
				if(x.parent.colour == 0) {
					this.__fix_dbl_red(x);
				}
			}
			return x;
		}
	}
};
var $_;
function $bind(o,m) { if( m == null ) return null; if( m.__id__ == null ) m.__id__ = $global.$haxeUID++; var f; if( o.hx__closures__ == null ) o.hx__closures__ = {}; else f = o.hx__closures__[m.__id__]; if( f == null ) { f = m.bind(o); o.hx__closures__[m.__id__] = f; } return f; }
$global.$haxeUID |= 0;
String.__name__ = true;
Array.__name__ = true;
js_Boot.__toStr = ({ }).toString;
nape_Config.epsilon = 1e-8;
nape_Config.fluidAngularDragFriction = 2.5;
nape_Config.fluidAngularDrag = 100;
nape_Config.fluidVacuumDrag = 0.5;
nape_Config.fluidLinearDrag = 0.5;
nape_Config.collisionSlop = 0.2;
nape_Config.collisionSlopCCD = 0.5;
nape_Config.distanceThresholdCCD = 0.05;
nape_Config.staticCCDLinearThreshold = 0.05;
nape_Config.staticCCDAngularThreshold = 0.005;
nape_Config.bulletCCDLinearThreshold = 0.125;
nape_Config.bulletCCDAngularThreshold = 0.0125;
nape_Config.dynamicSweepLinearThreshold = 17;
nape_Config.dynamicSweepAngularThreshold = 0.6;
nape_Config.angularCCDSlipScale = 0.75;
nape_Config.arbiterExpirationDelay = 6;
nape_Config.staticFrictionThreshold = 2;
nape_Config.elasticThreshold = 20;
nape_Config.sleepDelay = 60;
nape_Config.linearSleepThreshold = 0.2;
nape_Config.angularSleepThreshold = 0.4;
nape_Config.contactBiasCoef = 0.3;
nape_Config.contactStaticBiasCoef = 0.6;
nape_Config.contactContinuousBiasCoef = 0.4;
nape_Config.contactContinuousStaticBiasCoef = 0.5;
nape_Config.constraintLinearSlop = 0.1;
nape_Config.constraintAngularSlop = 1e-3;
nape_Config.illConditionedThreshold = 2e+8;
zpp_$nape_ZPP_$ID._Interactor = 0;
zpp_$nape_ZPP_$ID._ZPP_SimpleVert = 0;
zpp_$nape_ZPP_$ID._ZPP_SimpleSeg = 0;
zpp_$nape_ZPP_$ID._Constraint = 0;
zpp_$nape_ZPP_$ID._CbType = 0;
zpp_$nape_ZPP_$ID._CbSet = 0;
zpp_$nape_ZPP_$ID._Listener = 0;
zpp_$nape_callbacks_ZPP_$CbType.ANY_SHAPE = new nape_callbacks_CbType();
zpp_$nape_callbacks_ZPP_$CbType.ANY_BODY = new nape_callbacks_CbType();
zpp_$nape_callbacks_ZPP_$CbType.ANY_COMPOUND = new nape_callbacks_CbType();
zpp_$nape_callbacks_ZPP_$CbType.ANY_CONSTRAINT = new nape_callbacks_CbType();
zpp_$nape_util_ZPP_$Flags.internal = false;
zpp_$nape_callbacks_ZPP_$Listener.types = (function($this) {
	var $r;
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_BODY == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_BODY = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp = zpp_$nape_util_ZPP_$Flags.ListenerType_BODY;
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp1 = zpp_$nape_util_ZPP_$Flags.ListenerType_CONSTRAINT;
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp2 = zpp_$nape_util_ZPP_$Flags.ListenerType_INTERACTION;
	if(zpp_$nape_util_ZPP_$Flags.ListenerType_PRE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ListenerType_PRE = new nape_callbacks_ListenerType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	$r = [tmp,tmp1,tmp2,zpp_$nape_util_ZPP_$Flags.ListenerType_PRE];
	return $r;
}(this));
zpp_$nape_callbacks_ZPP_$Listener.events = (function($this) {
	var $r;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp = zpp_$nape_util_ZPP_$Flags.CbEvent_BEGIN;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_END == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_END = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp1 = zpp_$nape_util_ZPP_$Flags.CbEvent_END;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp2 = zpp_$nape_util_ZPP_$Flags.CbEvent_WAKE;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp3 = zpp_$nape_util_ZPP_$Flags.CbEvent_SLEEP;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp4 = zpp_$nape_util_ZPP_$Flags.CbEvent_BREAK;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_PRE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_PRE = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp5 = zpp_$nape_util_ZPP_$Flags.CbEvent_PRE;
	if(zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING = new nape_callbacks_CbEvent();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	$r = [tmp,tmp1,tmp2,tmp3,tmp4,tmp5,zpp_$nape_util_ZPP_$Flags.CbEvent_ONGOING];
	return $r;
}(this));
zpp_$nape_callbacks_ZPP_$InteractionListener.UCbSet = new zpp_$nape_util_ZNPList_$ZPP_$CbSet();
zpp_$nape_callbacks_ZPP_$InteractionListener.VCbSet = new zpp_$nape_util_ZNPList_$ZPP_$CbSet();
zpp_$nape_callbacks_ZPP_$InteractionListener.WCbSet = new zpp_$nape_util_ZNPList_$ZPP_$CbSet();
zpp_$nape_callbacks_ZPP_$InteractionListener.UCbType = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
zpp_$nape_callbacks_ZPP_$InteractionListener.VCbType = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
zpp_$nape_callbacks_ZPP_$InteractionListener.WCbType = new zpp_$nape_util_ZNPList_$ZPP_$CbType();
zpp_$nape_dynamics_ZPP_$Arbiter.internal = false;
zpp_$nape_dynamics_ZPP_$Arbiter.COL = 1;
zpp_$nape_dynamics_ZPP_$Arbiter.FLUID = 4;
zpp_$nape_dynamics_ZPP_$Arbiter.SENSOR = 2;
zpp_$nape_dynamics_ZPP_$Arbiter.types = (function($this) {
	var $r;
	if(zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION = new nape_dynamics_ArbiterType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp = zpp_$nape_util_ZPP_$Flags.ArbiterType_COLLISION;
	if(zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR = new nape_dynamics_ArbiterType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp1 = zpp_$nape_util_ZPP_$Flags.ArbiterType_SENSOR;
	if(zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID = new nape_dynamics_ArbiterType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	$r = [null,tmp,tmp1,null,zpp_$nape_util_ZPP_$Flags.ArbiterType_FLUID];
	return $r;
}(this));
zpp_$nape_dynamics_ZPP_$ColArbiter.bounceScale = 1.0;
zpp_$nape_dynamics_ZPP_$Contact.internal = false;
zpp_$nape_geom_ZPP_$Collide.flowpoly = new zpp_$nape_util_ZNPList_$ZPP_$Vec2();
zpp_$nape_geom_ZPP_$Collide.flowsegs = new zpp_$nape_util_ZNPList_$ZPP_$Vec2();
zpp_$nape_geom_ZPP_$ConvexRayResult.internal = false;
zpp_$nape_geom_ZPP_$MarchingSquares.me = new zpp_$nape_geom_ZPP_$MarchingSquares();
zpp_$nape_geom_ZPP_$MarchingSquares.look_march = [-1,224,56,216,14,-1,54,214,131,99,-1,91,141,109,181,85];
zpp_$nape_geom_ZPP_$PartitionVertex.nextId = 0;
zpp_$nape_phys_ZPP_$Body.types = (function($this) {
	var $r;
	if(zpp_$nape_util_ZPP_$Flags.BodyType_STATIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_STATIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp = zpp_$nape_util_ZPP_$Flags.BodyType_STATIC;
	if(zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp1 = zpp_$nape_util_ZPP_$Flags.BodyType_DYNAMIC;
	if(zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC = new nape_phys_BodyType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	$r = [null,tmp,tmp1,zpp_$nape_util_ZPP_$Flags.BodyType_KINEMATIC];
	return $r;
}(this));
zpp_$nape_phys_ZPP_$Body.cur_graph_depth = 0;
zpp_$nape_phys_ZPP_$Material.WAKE = 1;
zpp_$nape_phys_ZPP_$Material.PROPS = 2;
zpp_$nape_phys_ZPP_$Material.ANGDRAG = 4;
zpp_$nape_phys_ZPP_$Material.ARBITERS = 8;
zpp_$nape_shape_ZPP_$Shape.types = (function($this) {
	var $r;
	if(zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE = new nape_shape_ShapeType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	var tmp = zpp_$nape_util_ZPP_$Flags.ShapeType_CIRCLE;
	if(zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON == null) {
		zpp_$nape_util_ZPP_$Flags.internal = true;
		zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON = new nape_shape_ShapeType();
		zpp_$nape_util_ZPP_$Flags.internal = false;
	}
	$r = [tmp,zpp_$nape_util_ZPP_$Flags.ShapeType_POLYGON];
	return $r;
}(this));
zpp_$nape_shape_ZPP_$Edge.internal = false;
zpp_$nape_space_ZPP_$AABBTree.tmpaabb = new zpp_$nape_geom_ZPP_$AABB();
zpp_$nape_util_ZPP_$EdgeList.internal = false;
zpp_$nape_util_ZPP_$ShapeList.internal = false;
zpp_$nape_util_ZPP_$BodyList.internal = false;
zpp_$nape_util_ZPP_$CompoundList.internal = false;
zpp_$nape_util_ZPP_$InteractorList.internal = false;
zpp_$nape_util_ZPP_$ConvexResultList.internal = false;
zpp_$nape_util_ZPP_$GeomPolyList.internal = false;
zpp_$nape_util_ZPP_$RayResultList.internal = false;
zpp_$nape_util_ZPP_$Vec2List.internal = false;
zpp_$nape_util_ZPP_$ArbiterList.internal = false;
zpp_$nape_util_ZPP_$ContactList.internal = false;
zpp_$nape_util_ZPP_$InteractionGroupList.internal = false;
zpp_$nape_util_ZPP_$ConstraintList.internal = false;
zpp_$nape_util_ZPP_$CbTypeList.internal = false;
zpp_$nape_util_ZPP_$ListenerList.internal = false;
zpp_$nape_util_ZPP_$Math.fbuf = new Float32Array(1);
zpp_$nape_util_ZPP_$Math.ibuf = new Int32Array(zpp_$nape_util_ZPP_$Math.fbuf.buffer);
NapeMain.main();
})(typeof exports != "undefined" ? exports : typeof window != "undefined" ? window : typeof self != "undefined" ? self : this, typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this);
